var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x22) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x22, {
  get: (a7, b25) => (typeof require !== "undefined" ? require : a7)[b25]
}) : x22)(function(x22) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x22 + '" is not supported');
});
var __esm = (fn2, res) => function __init() {
  return fn2 && (res = (0, fn2[__getOwnPropNames(fn2)[0]])(fn2 = 0)), res;
};
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js
function T1(n23) {
  let t6 = 0;
  return n23.includes("i") && (t6 |= y.CASE_INSENSITIVE), n23.includes("m") && (t6 |= y.MULTILINE), n23.includes("s") && (t6 |= y.DOTALL), t6;
}
function N1(n23) {
  return y.translateRegExp(n23);
}
function b1(n23, t6 = "") {
  return new B(n23, t6);
}
var g, u, a, b, w, O, R1, I, F, X, P, _, m, v, U, z, V, L, $, j, N, E, W, Y, M, c, q, D, K, Z, d, n1, r1, a1, o1, l1, h1, u1, c1, p1, f1, g1, A1, w1, E1, d1, O1, C1, m1, S1, x, H, Q, J, t1, e1, s1, y, B, i1;
var init_chunk_YNYSPYQ5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js"() {
    g = class n {
      static FOLD_CASE = 1;
      static LITERAL = 2;
      static CLASS_NL = 4;
      static DOT_NL = 8;
      static ONE_LINE = 16;
      static NON_GREEDY = 32;
      static PERL_X = 64;
      static UNICODE_GROUPS = 128;
      static WAS_DOLLAR = 256;
      static MATCH_NL = n.CLASS_NL | n.DOT_NL;
      static PERL = n.CLASS_NL | n.ONE_LINE | n.PERL_X | n.UNICODE_GROUPS;
      static POSIX = 0;
      static UNANCHORED = 0;
      static ANCHOR_START = 1;
      static ANCHOR_BOTH = 2;
    };
    u = class {
      static CODES = /* @__PURE__ */ new Map([["\x07", 7], ["\b", 8], ["	", 9], [`
`, 10], ["\v", 11], ["\f", 12], ["\r", 13], [" ", 32], ['"', 34], ["$", 36], ["&", 38], ["(", 40], [")", 41], ["*", 42], ["+", 43], ["-", 45], [".", 46], ["0", 48], ["1", 49], ["2", 50], ["3", 51], ["4", 52], ["5", 53], ["6", 54], ["7", 55], ["8", 56], ["9", 57], [":", 58], ["<", 60], [">", 62], ["?", 63], ["A", 65], ["B", 66], ["C", 67], ["F", 70], ["P", 80], ["Q", 81], ["U", 85], ["Z", 90], ["[", 91], ["\\", 92], ["]", 93], ["^", 94], ["_", 95], ["a", 97], ["b", 98], ["f", 102], ["i", 105], ["m", 109], ["n", 110], ["r", 114], ["s", 115], ["t", 116], ["v", 118], ["x", 120], ["z", 122], ["{", 123], ["|", 124], ["}", 125]]);
      static toUpperCase(t6) {
        let e5 = String.fromCodePoint(t6).toUpperCase();
        if (e5.length > 1) return t6;
        let s9 = String.fromCodePoint(e5.codePointAt(0)).toLowerCase();
        return s9.length > 1 || s9.codePointAt(0) !== t6 ? t6 : e5.codePointAt(0);
      }
      static toLowerCase(t6) {
        let e5 = String.fromCodePoint(t6).toLowerCase();
        if (e5.length > 1) return t6;
        let s9 = String.fromCodePoint(e5.codePointAt(0)).toUpperCase();
        return s9.length > 1 || s9.codePointAt(0) !== t6 ? t6 : e5.codePointAt(0);
      }
    };
    a = class {
      SIZE = 3;
      constructor(t6) {
        this.data = t6;
      }
      getLo(t6) {
        return this.data[t6 * this.SIZE];
      }
      getHi(t6) {
        return this.data[t6 * this.SIZE + 1];
      }
      getStride(t6) {
        return this.data[t6 * this.SIZE + 2];
      }
      get(t6) {
        let e5 = t6 * this.SIZE;
        return [this.data[e5], this.data[e5 + 1], this.data[e5 + 2]];
      }
      get length() {
        return this.data.length / this.SIZE;
      }
    };
    b = class n2 {
      static CASE_ORBIT = /* @__PURE__ */ new Map([[75, 107], [107, 8490], [8490, 75], [83, 115], [115, 383], [383, 83], [181, 924], [924, 956], [956, 181], [197, 229], [229, 8491], [8491, 197], [452, 453], [453, 454], [454, 452], [455, 456], [456, 457], [457, 455], [458, 459], [459, 460], [460, 458], [497, 498], [498, 499], [499, 497], [837, 921], [921, 953], [953, 8126], [8126, 837], [914, 946], [946, 976], [976, 914], [917, 949], [949, 1013], [1013, 917], [920, 952], [952, 977], [977, 1012], [1012, 920], [922, 954], [954, 1008], [1008, 922], [928, 960], [960, 982], [982, 928], [929, 961], [961, 1009], [1009, 929], [931, 962], [962, 963], [963, 931], [934, 966], [966, 981], [981, 934], [937, 969], [969, 8486], [8486, 937], [1042, 1074], [1074, 7296], [7296, 1042], [1044, 1076], [1076, 7297], [7297, 1044], [1054, 1086], [1086, 7298], [7298, 1054], [1057, 1089], [1089, 7299], [7299, 1057], [1058, 1090], [1090, 7300], [7300, 7301], [7301, 1058], [1066, 1098], [1098, 7302], [7302, 1066], [1122, 1123], [1123, 7303], [7303, 1122], [7304, 42570], [42570, 42571], [42571, 7304], [7776, 7777], [7777, 7835], [7835, 7776], [223, 7838], [7838, 223], [8064, 8072], [8072, 8064], [8065, 8073], [8073, 8065], [8066, 8074], [8074, 8066], [8067, 8075], [8075, 8067], [8068, 8076], [8076, 8068], [8069, 8077], [8077, 8069], [8070, 8078], [8078, 8070], [8071, 8079], [8079, 8071], [8080, 8088], [8088, 8080], [8081, 8089], [8089, 8081], [8082, 8090], [8090, 8082], [8083, 8091], [8091, 8083], [8084, 8092], [8092, 8084], [8085, 8093], [8093, 8085], [8086, 8094], [8094, 8086], [8087, 8095], [8095, 8087], [8096, 8104], [8104, 8096], [8097, 8105], [8105, 8097], [8098, 8106], [8106, 8098], [8099, 8107], [8107, 8099], [8100, 8108], [8108, 8100], [8101, 8109], [8109, 8101], [8102, 8110], [8110, 8102], [8103, 8111], [8111, 8103], [8115, 8124], [8124, 8115], [8131, 8140], [8140, 8131], [912, 8147], [8147, 912], [944, 8163], [8163, 944], [8179, 8188], [8188, 8179], [64261, 64262], [64262, 64261], [66560, 66600], [66600, 66560], [66561, 66601], [66601, 66561], [66562, 66602], [66602, 66562], [66563, 66603], [66603, 66563], [66564, 66604], [66604, 66564], [66565, 66605], [66605, 66565], [66566, 66606], [66606, 66566], [66567, 66607], [66607, 66567], [66568, 66608], [66608, 66568], [66569, 66609], [66609, 66569], [66570, 66610], [66610, 66570], [66571, 66611], [66611, 66571], [66572, 66612], [66612, 66572], [66573, 66613], [66613, 66573], [66574, 66614], [66614, 66574], [66575, 66615], [66615, 66575], [66576, 66616], [66616, 66576], [66577, 66617], [66617, 66577], [66578, 66618], [66618, 66578], [66579, 66619], [66619, 66579], [66580, 66620], [66620, 66580], [66581, 66621], [66621, 66581], [66582, 66622], [66622, 66582], [66583, 66623], [66623, 66583], [66584, 66624], [66624, 66584], [66585, 66625], [66625, 66585], [66586, 66626], [66626, 66586], [66587, 66627], [66627, 66587], [66588, 66628], [66628, 66588], [66589, 66629], [66629, 66589], [66590, 66630], [66630, 66590], [66591, 66631], [66631, 66591], [66592, 66632], [66632, 66592], [66593, 66633], [66633, 66593], [66594, 66634], [66634, 66594], [66595, 66635], [66635, 66595], [66596, 66636], [66636, 66596], [66597, 66637], [66637, 66597], [66598, 66638], [66638, 66598], [66599, 66639], [66639, 66599], [66736, 66776], [66776, 66736], [66737, 66777], [66777, 66737], [66738, 66778], [66778, 66738], [66739, 66779], [66779, 66739], [66740, 66780], [66780, 66740], [66741, 66781], [66781, 66741], [66742, 66782], [66782, 66742], [66743, 66783], [66783, 66743], [66744, 66784], [66784, 66744], [66745, 66785], [66785, 66745], [66746, 66786], [66786, 66746], [66747, 66787], [66787, 66747], [66748, 66788], [66788, 66748], [66749, 66789], [66789, 66749], [66750, 66790], [66790, 66750], [66751, 66791], [66791, 66751], [66752, 66792], [66792, 66752], [66753, 66793], [66793, 66753], [66754, 66794], [66794, 66754], [66755, 66795], [66795, 66755], [66756, 66796], [66796, 66756], [66757, 66797], [66797, 66757], [66758, 66798], [66798, 66758], [66759, 66799], [66799, 66759], [66760, 66800], [66800, 66760], [66761, 66801], [66801, 66761], [66762, 66802], [66802, 66762], [66763, 66803], [66803, 66763], [66764, 66804], [66804, 66764], [66765, 66805], [66805, 66765], [66766, 66806], [66806, 66766], [66767, 66807], [66807, 66767], [66768, 66808], [66808, 66768], [66769, 66809], [66809, 66769], [66770, 66810], [66810, 66770], [66771, 66811], [66811, 66771], [66928, 66967], [66967, 66928], [66929, 66968], [66968, 66929], [66930, 66969], [66969, 66930], [66931, 66970], [66970, 66931], [66932, 66971], [66971, 66932], [66933, 66972], [66972, 66933], [66934, 66973], [66973, 66934], [66935, 66974], [66974, 66935], [66936, 66975], [66975, 66936], [66937, 66976], [66976, 66937], [66938, 66977], [66977, 66938], [66940, 66979], [66979, 66940], [66941, 66980], [66980, 66941], [66942, 66981], [66981, 66942], [66943, 66982], [66982, 66943], [66944, 66983], [66983, 66944], [66945, 66984], [66984, 66945], [66946, 66985], [66985, 66946], [66947, 66986], [66986, 66947], [66948, 66987], [66987, 66948], [66949, 66988], [66988, 66949], [66950, 66989], [66989, 66950], [66951, 66990], [66990, 66951], [66952, 66991], [66991, 66952], [66953, 66992], [66992, 66953], [66954, 66993], [66993, 66954], [66956, 66995], [66995, 66956], [66957, 66996], [66996, 66957], [66958, 66997], [66997, 66958], [66959, 66998], [66998, 66959], [66960, 66999], [66999, 66960], [66961, 67e3], [67e3, 66961], [66962, 67001], [67001, 66962], [66964, 67003], [67003, 66964], [66965, 67004], [67004, 66965], [68736, 68800], [68800, 68736], [68737, 68801], [68801, 68737], [68738, 68802], [68802, 68738], [68739, 68803], [68803, 68739], [68740, 68804], [68804, 68740], [68741, 68805], [68805, 68741], [68742, 68806], [68806, 68742], [68743, 68807], [68807, 68743], [68744, 68808], [68808, 68744], [68745, 68809], [68809, 68745], [68746, 68810], [68810, 68746], [68747, 68811], [68811, 68747], [68748, 68812], [68812, 68748], [68749, 68813], [68813, 68749], [68750, 68814], [68814, 68750], [68751, 68815], [68815, 68751], [68752, 68816], [68816, 68752], [68753, 68817], [68817, 68753], [68754, 68818], [68818, 68754], [68755, 68819], [68819, 68755], [68756, 68820], [68820, 68756], [68757, 68821], [68821, 68757], [68758, 68822], [68822, 68758], [68759, 68823], [68823, 68759], [68760, 68824], [68824, 68760], [68761, 68825], [68825, 68761], [68762, 68826], [68826, 68762], [68763, 68827], [68827, 68763], [68764, 68828], [68828, 68764], [68765, 68829], [68829, 68765], [68766, 68830], [68830, 68766], [68767, 68831], [68831, 68767], [68768, 68832], [68832, 68768], [68769, 68833], [68833, 68769], [68770, 68834], [68834, 68770], [68771, 68835], [68835, 68771], [68772, 68836], [68836, 68772], [68773, 68837], [68837, 68773], [68774, 68838], [68838, 68774], [68775, 68839], [68839, 68775], [68776, 68840], [68840, 68776], [68777, 68841], [68841, 68777], [68778, 68842], [68842, 68778], [68779, 68843], [68843, 68779], [68780, 68844], [68844, 68780], [68781, 68845], [68845, 68781], [68782, 68846], [68846, 68782], [68783, 68847], [68847, 68783], [68784, 68848], [68848, 68784], [68785, 68849], [68849, 68785], [68786, 68850], [68850, 68786], [68944, 68976], [68976, 68944], [68945, 68977], [68977, 68945], [68946, 68978], [68978, 68946], [68947, 68979], [68979, 68947], [68948, 68980], [68980, 68948], [68949, 68981], [68981, 68949], [68950, 68982], [68982, 68950], [68951, 68983], [68983, 68951], [68952, 68984], [68984, 68952], [68953, 68985], [68985, 68953], [68954, 68986], [68986, 68954], [68955, 68987], [68987, 68955], [68956, 68988], [68988, 68956], [68957, 68989], [68989, 68957], [68958, 68990], [68990, 68958], [68959, 68991], [68991, 68959], [68960, 68992], [68992, 68960], [68961, 68993], [68993, 68961], [68962, 68994], [68994, 68962], [68963, 68995], [68995, 68963], [68964, 68996], [68996, 68964], [68965, 68997], [68997, 68965], [71840, 71872], [71872, 71840], [71841, 71873], [71873, 71841], [71842, 71874], [71874, 71842], [71843, 71875], [71875, 71843], [71844, 71876], [71876, 71844], [71845, 71877], [71877, 71845], [71846, 71878], [71878, 71846], [71847, 71879], [71879, 71847], [71848, 71880], [71880, 71848], [71849, 71881], [71881, 71849], [71850, 71882], [71882, 71850], [71851, 71883], [71883, 71851], [71852, 71884], [71884, 71852], [71853, 71885], [71885, 71853], [71854, 71886], [71886, 71854], [71855, 71887], [71887, 71855], [71856, 71888], [71888, 71856], [71857, 71889], [71889, 71857], [71858, 71890], [71890, 71858], [71859, 71891], [71891, 71859], [71860, 71892], [71892, 71860], [71861, 71893], [71893, 71861], [71862, 71894], [71894, 71862], [71863, 71895], [71895, 71863], [71864, 71896], [71896, 71864], [71865, 71897], [71897, 71865], [71866, 71898], [71898, 71866], [71867, 71899], [71899, 71867], [71868, 71900], [71900, 71868], [71869, 71901], [71901, 71869], [71870, 71902], [71902, 71870], [71871, 71903], [71903, 71871], [93760, 93792], [93792, 93760], [93761, 93793], [93793, 93761], [93762, 93794], [93794, 93762], [93763, 93795], [93795, 93763], [93764, 93796], [93796, 93764], [93765, 93797], [93797, 93765], [93766, 93798], [93798, 93766], [93767, 93799], [93799, 93767], [93768, 93800], [93800, 93768], [93769, 93801], [93801, 93769], [93770, 93802], [93802, 93770], [93771, 93803], [93803, 93771], [93772, 93804], [93804, 93772], [93773, 93805], [93805, 93773], [93774, 93806], [93806, 93774], [93775, 93807], [93807, 93775], [93776, 93808], [93808, 93776], [93777, 93809], [93809, 93777], [93778, 93810], [93810, 93778], [93779, 93811], [93811, 93779], [93780, 93812], [93812, 93780], [93781, 93813], [93813, 93781], [93782, 93814], [93814, 93782], [93783, 93815], [93815, 93783], [93784, 93816], [93816, 93784], [93785, 93817], [93817, 93785], [93786, 93818], [93818, 93786], [93787, 93819], [93819, 93787], [93788, 93820], [93820, 93788], [93789, 93821], [93821, 93789], [93790, 93822], [93822, 93790], [93791, 93823], [93823, 93791], [125184, 125218], [125218, 125184], [125185, 125219], [125219, 125185], [125186, 125220], [125220, 125186], [125187, 125221], [125221, 125187], [125188, 125222], [125222, 125188], [125189, 125223], [125223, 125189], [125190, 125224], [125224, 125190], [125191, 125225], [125225, 125191], [125192, 125226], [125226, 125192], [125193, 125227], [125227, 125193], [125194, 125228], [125228, 125194], [125195, 125229], [125229, 125195], [125196, 125230], [125230, 125196], [125197, 125231], [125231, 125197], [125198, 125232], [125232, 125198], [125199, 125233], [125233, 125199], [125200, 125234], [125234, 125200], [125201, 125235], [125235, 125201], [125202, 125236], [125236, 125202], [125203, 125237], [125237, 125203], [125204, 125238], [125238, 125204], [125205, 125239], [125239, 125205], [125206, 125240], [125240, 125206], [125207, 125241], [125241, 125207], [125208, 125242], [125242, 125208], [125209, 125243], [125243, 125209], [125210, 125244], [125244, 125210], [125211, 125245], [125245, 125211], [125212, 125246], [125246, 125212], [125213, 125247], [125247, 125213], [125214, 125248], [125248, 125214], [125215, 125249], [125249, 125215], [125216, 125250], [125250, 125216], [125217, 125251], [125251, 125217]]);
      static C = new a(new Uint32Array([0, 31, 1, 127, 159, 1, 173, 888, 715, 889, 896, 7, 897, 899, 1, 907, 909, 2, 930, 1328, 398, 1367, 1368, 1, 1419, 1420, 1, 1424, 1480, 56, 1481, 1487, 1, 1515, 1518, 1, 1525, 1541, 1, 1564, 1757, 193, 1806, 1807, 1, 1867, 1868, 1, 1970, 1983, 1, 2043, 2044, 1, 2094, 2095, 1, 2111, 2140, 29, 2141, 2143, 2, 2155, 2159, 1, 2191, 2198, 1, 2274, 2436, 162, 2445, 2446, 1, 2449, 2450, 1, 2473, 2481, 8, 2483, 2485, 1, 2490, 2491, 1, 2501, 2502, 1, 2505, 2506, 1, 2511, 2518, 1, 2520, 2523, 1, 2526, 2532, 6, 2533, 2559, 26, 2560, 2564, 4, 2571, 2574, 1, 2577, 2578, 1, 2601, 2609, 8, 2612, 2618, 3, 2619, 2621, 2, 2627, 2630, 1, 2633, 2634, 1, 2638, 2640, 1, 2642, 2648, 1, 2653, 2655, 2, 2656, 2661, 1, 2679, 2688, 1, 2692, 2702, 10, 2706, 2729, 23, 2737, 2740, 3, 2746, 2747, 1, 2758, 2766, 4, 2767, 2769, 2, 2770, 2783, 1, 2788, 2789, 1, 2802, 2808, 1, 2816, 2820, 4, 2829, 2830, 1, 2833, 2834, 1, 2857, 2865, 8, 2868, 2874, 6, 2875, 2885, 10, 2886, 2889, 3, 2890, 2894, 4, 2895, 2900, 1, 2904, 2907, 1, 2910, 2916, 6, 2917, 2936, 19, 2937, 2945, 1, 2948, 2955, 7, 2956, 2957, 1, 2961, 2966, 5, 2967, 2968, 1, 2971, 2973, 2, 2976, 2978, 1, 2981, 2983, 1, 2987, 2989, 1, 3002, 3005, 1, 3011, 3013, 1, 3017, 3022, 5, 3023, 3025, 2, 3026, 3030, 1, 3032, 3045, 1, 3067, 3071, 1, 3085, 3089, 4, 3113, 3130, 17, 3131, 3141, 10, 3145, 3150, 5, 3151, 3156, 1, 3159, 3163, 4, 3164, 3166, 2, 3167, 3172, 5, 3173, 3184, 11, 3185, 3190, 1, 3213, 3217, 4, 3241, 3252, 11, 3258, 3259, 1, 3269, 3273, 4, 3278, 3284, 1, 3287, 3292, 1, 3295, 3300, 5, 3301, 3312, 11, 3316, 3327, 1, 3341, 3345, 4, 3397, 3401, 4, 3408, 3411, 1, 3428, 3429, 1, 3456, 3460, 4, 3479, 3481, 1, 3506, 3516, 10, 3518, 3519, 1, 3527, 3529, 1, 3531, 3534, 1, 3541, 3543, 2, 3552, 3557, 1, 3568, 3569, 1, 3573, 3584, 1, 3643, 3646, 1, 3676, 3712, 1, 3715, 3717, 2, 3723, 3748, 25, 3750, 3774, 24, 3775, 3781, 6, 3783, 3791, 8, 3802, 3803, 1, 3808, 3839, 1, 3912, 3949, 37, 3950, 3952, 1, 3992, 4029, 37, 4045, 4059, 14, 4060, 4095, 1, 4294, 4296, 2, 4297, 4300, 1, 4302, 4303, 1, 4681, 4686, 5, 4687, 4695, 8, 4697, 4702, 5, 4703, 4745, 42, 4750, 4751, 1, 4785, 4790, 5, 4791, 4799, 8, 4801, 4806, 5, 4807, 4823, 16, 4881, 4886, 5, 4887, 4955, 68, 4956, 4989, 33, 4990, 4991, 1, 5018, 5023, 1, 5110, 5111, 1, 5118, 5119, 1, 5789, 5791, 1, 5881, 5887, 1, 5910, 5918, 1, 5943, 5951, 1, 5972, 5983, 1, 5997, 6001, 4, 6004, 6015, 1, 6110, 6111, 1, 6122, 6127, 1, 6138, 6143, 1, 6158, 6170, 12, 6171, 6175, 1, 6265, 6271, 1, 6315, 6319, 1, 6390, 6399, 1, 6431, 6444, 13, 6445, 6447, 1, 6460, 6463, 1, 6465, 6467, 1, 6510, 6511, 1, 6517, 6527, 1, 6572, 6575, 1, 6602, 6607, 1, 6619, 6621, 1, 6684, 6685, 1, 6751, 6781, 30, 6782, 6794, 12, 6795, 6799, 1, 6810, 6815, 1, 6830, 6831, 1, 6863, 6911, 1, 6989, 7156, 167, 7157, 7163, 1, 7224, 7226, 1, 7242, 7244, 1, 7307, 7311, 1, 7355, 7356, 1, 7368, 7375, 1, 7419, 7423, 1, 7958, 7959, 1, 7966, 7967, 1, 8006, 8007, 1, 8014, 8015, 1, 8024, 8030, 2, 8062, 8063, 1, 8117, 8133, 16, 8148, 8149, 1, 8156, 8176, 20, 8177, 8181, 4, 8191, 8203, 12, 8204, 8207, 1, 8234, 8238, 1, 8288, 8303, 1, 8306, 8307, 1, 8335, 8349, 14, 8350, 8351, 1, 8385, 8399, 1, 8433, 8447, 1, 8588, 8591, 1, 9258, 9279, 1, 9291, 9311, 1, 11124, 11125, 1, 11158, 11508, 350, 11509, 11512, 1, 11558, 11560, 2, 11561, 11564, 1, 11566, 11567, 1, 11624, 11630, 1, 11633, 11646, 1, 11671, 11679, 1, 11687, 11743, 8, 11870, 11903, 1, 11930, 12020, 90, 12021, 12031, 1, 12246, 12271, 1, 12352, 12439, 87, 12440, 12544, 104, 12545, 12548, 1, 12592, 12687, 95, 12774, 12782, 1, 12831, 42125, 29294, 42126, 42127, 1, 42183, 42191, 1, 42540, 42559, 1, 42744, 42751, 1, 42958, 42959, 1, 42962, 42964, 2, 42973, 42993, 1, 43053, 43055, 1, 43066, 43071, 1, 43128, 43135, 1, 43206, 43213, 1, 43226, 43231, 1, 43348, 43358, 1, 43389, 43391, 1, 43470, 43482, 12, 43483, 43485, 1, 43519, 43575, 56, 43576, 43583, 1, 43598, 43599, 1, 43610, 43611, 1, 43715, 43738, 1, 43767, 43776, 1, 43783, 43784, 1, 43791, 43792, 1, 43799, 43807, 1, 43815, 43823, 8, 43884, 43887, 1, 44014, 44015, 1, 44026, 44031, 1, 55204, 55215, 1, 55239, 55242, 1, 55292, 63743, 1, 64110, 64111, 1, 64218, 64255, 1, 64263, 64274, 1, 64280, 64284, 1, 64311, 64317, 6, 64319, 64325, 3, 64451, 64466, 1, 64912, 64913, 1, 64968, 64974, 1, 64976, 65007, 1, 65050, 65055, 1, 65107, 65127, 20, 65132, 65135, 1, 65141, 65277, 136, 65278, 65280, 1, 65471, 65473, 1, 65480, 65481, 1, 65488, 65489, 1, 65496, 65497, 1, 65501, 65503, 1, 65511, 65519, 8, 65520, 65531, 1, 65534, 65535, 1, 65548, 65575, 27, 65595, 65598, 3, 65614, 65615, 1, 65630, 65663, 1, 65787, 65791, 1, 65795, 65798, 1, 65844, 65846, 1, 65935, 65949, 14, 65950, 65951, 1, 65953, 65999, 1, 66046, 66175, 1, 66205, 66207, 1, 66257, 66271, 1, 66300, 66303, 1, 66340, 66348, 1, 66379, 66383, 1, 66427, 66431, 1, 66462, 66500, 38, 66501, 66503, 1, 66518, 66559, 1, 66718, 66719, 1, 66730, 66735, 1, 66772, 66775, 1, 66812, 66815, 1, 66856, 66863, 1, 66916, 66926, 1, 66939, 66955, 16, 66963, 66966, 3, 66978, 66994, 16, 67002, 67005, 3, 67006, 67007, 1, 67060, 67071, 1, 67383, 67391, 1, 67414, 67423, 1, 67432, 67455, 1, 67462, 67505, 43, 67515, 67583, 1, 67590, 67591, 1, 67593, 67638, 45, 67641, 67643, 1, 67645, 67646, 1, 67670, 67743, 73, 67744, 67750, 1, 67760, 67807, 1, 67827, 67830, 3, 67831, 67834, 1, 67868, 67870, 1, 67898, 67902, 1, 67904, 67967, 1, 68024, 68027, 1, 68048, 68049, 1, 68100, 68103, 3, 68104, 68107, 1, 68116, 68120, 4, 68150, 68151, 1, 68155, 68158, 1, 68169, 68175, 1, 68185, 68191, 1, 68256, 68287, 1, 68327, 68330, 1, 68343, 68351, 1, 68406, 68408, 1, 68438, 68439, 1, 68467, 68471, 1, 68498, 68504, 1, 68509, 68520, 1, 68528, 68607, 1, 68681, 68735, 1, 68787, 68799, 1, 68851, 68857, 1, 68904, 68911, 1, 68922, 68927, 1, 68966, 68968, 1, 68998, 69005, 1, 69008, 69215, 1, 69247, 69290, 43, 69294, 69295, 1, 69298, 69313, 1, 69317, 69371, 1, 69416, 69423, 1, 69466, 69487, 1, 69514, 69551, 1, 69580, 69599, 1, 69623, 69631, 1, 69710, 69713, 1, 69750, 69758, 1, 69821, 69827, 6, 69828, 69839, 1, 69865, 69871, 1, 69882, 69887, 1, 69941, 69960, 19, 69961, 69967, 1, 70007, 70015, 1, 70112, 70133, 21, 70134, 70143, 1, 70162, 70210, 48, 70211, 70271, 1, 70279, 70281, 2, 70286, 70302, 16, 70314, 70319, 1, 70379, 70383, 1, 70394, 70399, 1, 70404, 70413, 9, 70414, 70417, 3, 70418, 70441, 23, 70449, 70452, 3, 70458, 70469, 11, 70470, 70473, 3, 70474, 70478, 4, 70479, 70481, 2, 70482, 70486, 1, 70488, 70492, 1, 70500, 70501, 1, 70509, 70511, 1, 70517, 70527, 1, 70538, 70540, 2, 70541, 70543, 2, 70582, 70593, 11, 70595, 70596, 1, 70598, 70603, 5, 70614, 70617, 3, 70618, 70624, 1, 70627, 70655, 1, 70748, 70754, 6, 70755, 70783, 1, 70856, 70863, 1, 70874, 71039, 1, 71094, 71095, 1, 71134, 71167, 1, 71237, 71247, 1, 71258, 71263, 1, 71277, 71295, 1, 71354, 71359, 1, 71370, 71375, 1, 71396, 71423, 1, 71451, 71452, 1, 71468, 71471, 1, 71495, 71679, 1, 71740, 71839, 1, 71923, 71934, 1, 71943, 71944, 1, 71946, 71947, 1, 71956, 71959, 3, 71990, 71993, 3, 71994, 72007, 13, 72008, 72015, 1, 72026, 72095, 1, 72104, 72105, 1, 72152, 72153, 1, 72165, 72191, 1, 72264, 72271, 1, 72355, 72367, 1, 72441, 72447, 1, 72458, 72639, 1, 72674, 72687, 1, 72698, 72703, 1, 72713, 72759, 46, 72774, 72783, 1, 72813, 72815, 1, 72848, 72849, 1, 72872, 72887, 15, 72888, 72959, 1, 72967, 72970, 3, 73015, 73017, 1, 73019, 73022, 3, 73032, 73039, 1, 73050, 73055, 1, 73062, 73065, 3, 73103, 73106, 3, 73113, 73119, 1, 73130, 73439, 1, 73465, 73471, 1, 73489, 73531, 42, 73532, 73533, 1, 73563, 73647, 1, 73649, 73663, 1, 73714, 73726, 1, 74650, 74751, 1, 74863, 74869, 6, 74870, 74879, 1, 75076, 77711, 1, 77811, 77823, 1, 78896, 78911, 1, 78934, 78943, 1, 82939, 82943, 1, 83527, 90367, 1, 90426, 92159, 1, 92729, 92735, 1, 92767, 92778, 11, 92779, 92781, 1, 92863, 92874, 11, 92875, 92879, 1, 92910, 92911, 1, 92918, 92927, 1, 92998, 93007, 1, 93018, 93026, 8, 93048, 93052, 1, 93072, 93503, 1, 93562, 93759, 1, 93851, 93951, 1, 94027, 94030, 1, 94088, 94094, 1, 94112, 94175, 1, 94181, 94191, 1, 94194, 94207, 1, 100344, 100351, 1, 101590, 101630, 1, 101641, 110575, 1, 110580, 110588, 8, 110591, 110883, 292, 110884, 110897, 1, 110899, 110927, 1, 110931, 110932, 1, 110934, 110947, 1, 110952, 110959, 1, 111356, 113663, 1, 113771, 113775, 1, 113789, 113791, 1, 113801, 113807, 1, 113818, 113819, 1, 113824, 117759, 1, 118010, 118015, 1, 118452, 118527, 1, 118574, 118575, 1, 118599, 118607, 1, 118724, 118783, 1, 119030, 119039, 1, 119079, 119080, 1, 119155, 119162, 1, 119275, 119295, 1, 119366, 119487, 1, 119508, 119519, 1, 119540, 119551, 1, 119639, 119647, 1, 119673, 119807, 1, 119893, 119965, 72, 119968, 119969, 1, 119971, 119972, 1, 119975, 119976, 1, 119981, 119994, 13, 119996, 120004, 8, 120070, 120075, 5, 120076, 120085, 9, 120093, 120122, 29, 120127, 120133, 6, 120135, 120137, 1, 120145, 120486, 341, 120487, 120780, 293, 120781, 121484, 703, 121485, 121498, 1, 121504, 121520, 16, 121521, 122623, 1, 122655, 122660, 1, 122667, 122879, 1, 122887, 122905, 18, 122906, 122914, 8, 122917, 122923, 6, 122924, 122927, 1, 122990, 123022, 1, 123024, 123135, 1, 123181, 123183, 1, 123198, 123199, 1, 123210, 123213, 1, 123216, 123535, 1, 123567, 123583, 1, 123642, 123646, 1, 123648, 124111, 1, 124154, 124367, 1, 124411, 124414, 1, 124416, 124895, 1, 124903, 124908, 5, 124911, 124927, 16, 125125, 125126, 1, 125143, 125183, 1, 125260, 125263, 1, 125274, 125277, 1, 125280, 126064, 1, 126133, 126208, 1, 126270, 126463, 1, 126468, 126496, 28, 126499, 126501, 2, 126502, 126504, 2, 126515, 126520, 5, 126522, 126524, 2, 126525, 126529, 1, 126531, 126534, 1, 126536, 126540, 2, 126544, 126547, 3, 126549, 126550, 1, 126552, 126560, 2, 126563, 126565, 2, 126566, 126571, 5, 126579, 126589, 5, 126591, 126602, 11, 126620, 126624, 1, 126628, 126634, 6, 126652, 126703, 1, 126706, 126975, 1, 127020, 127023, 1, 127124, 127135, 1, 127151, 127152, 1, 127168, 127184, 16, 127222, 127231, 1, 127406, 127461, 1, 127491, 127503, 1, 127548, 127551, 1, 127561, 127567, 1, 127570, 127583, 1, 127590, 127743, 1, 128728, 128731, 1, 128749, 128751, 1, 128765, 128767, 1, 128887, 128890, 1, 128986, 128991, 1, 129004, 129007, 1, 129009, 129023, 1, 129036, 129039, 1, 129096, 129103, 1, 129114, 129119, 1, 129160, 129167, 1, 129198, 129199, 1, 129212, 129215, 1, 129218, 129279, 1, 129620, 129631, 1, 129646, 129647, 1, 129661, 129663, 1, 129674, 129678, 1, 129735, 129741, 1, 129757, 129758, 1, 129770, 129775, 1, 129785, 129791, 1, 129939, 130042, 103, 130043, 131071, 1, 173792, 173823, 1, 177978, 177983, 1, 178206, 178207, 1, 183970, 183983, 1, 191457, 191471, 1, 192094, 194559, 1, 195102, 196607, 1, 201547, 201551, 1, 205744, 917759, 1, 918e3, 1114111, 1]));
      static Cc = new a(new Uint32Array([0, 31, 1, 127, 159, 1]));
      static Cf = new a(new Uint32Array([173, 1536, 1363, 1537, 1541, 1, 1564, 1757, 193, 1807, 2192, 385, 2193, 2274, 81, 6158, 8203, 2045, 8204, 8207, 1, 8234, 8238, 1, 8288, 8292, 1, 8294, 8303, 1, 65279, 65529, 250, 65530, 65531, 1, 69821, 69837, 16, 78896, 78911, 1, 113824, 113827, 1, 119155, 119162, 1, 917505, 917536, 31, 917537, 917631, 1]));
      static Co = new a(new Uint32Array([57344, 63743, 1, 983040, 1048573, 1, 1048576, 1114109, 1]));
      static Cs = new a(new Uint32Array([55296, 57343, 1]));
      static L = new a(new Uint32Array([65, 90, 1, 97, 122, 1, 170, 181, 11, 186, 192, 6, 193, 214, 1, 216, 246, 1, 248, 705, 1, 710, 721, 1, 736, 740, 1, 748, 750, 2, 880, 884, 1, 886, 887, 1, 890, 893, 1, 895, 902, 7, 904, 906, 1, 908, 910, 2, 911, 929, 1, 931, 1013, 1, 1015, 1153, 1, 1162, 1327, 1, 1329, 1366, 1, 1369, 1376, 7, 1377, 1416, 1, 1488, 1514, 1, 1519, 1522, 1, 1568, 1610, 1, 1646, 1647, 1, 1649, 1747, 1, 1749, 1765, 16, 1766, 1774, 8, 1775, 1786, 11, 1787, 1788, 1, 1791, 1808, 17, 1810, 1839, 1, 1869, 1957, 1, 1969, 1994, 25, 1995, 2026, 1, 2036, 2037, 1, 2042, 2048, 6, 2049, 2069, 1, 2074, 2084, 10, 2088, 2112, 24, 2113, 2136, 1, 2144, 2154, 1, 2160, 2183, 1, 2185, 2190, 1, 2208, 2249, 1, 2308, 2361, 1, 2365, 2384, 19, 2392, 2401, 1, 2417, 2432, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2493, 2510, 17, 2524, 2525, 1, 2527, 2529, 1, 2544, 2545, 1, 2556, 2565, 9, 2566, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2649, 2652, 1, 2654, 2674, 20, 2675, 2676, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2749, 2768, 19, 2784, 2785, 1, 2809, 2821, 12, 2822, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2877, 2908, 31, 2909, 2911, 2, 2912, 2913, 1, 2929, 2947, 18, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3024, 3077, 53, 3078, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3133, 3160, 27, 3161, 3162, 1, 3165, 3168, 3, 3169, 3200, 31, 3205, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3261, 3293, 32, 3294, 3296, 2, 3297, 3313, 16, 3314, 3332, 18, 3333, 3340, 1, 3342, 3344, 1, 3346, 3386, 1, 3389, 3406, 17, 3412, 3414, 1, 3423, 3425, 1, 3450, 3455, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3585, 3632, 1, 3634, 3635, 1, 3648, 3654, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3760, 1, 3762, 3763, 1, 3773, 3776, 3, 3777, 3780, 1, 3782, 3804, 22, 3805, 3807, 1, 3840, 3904, 64, 3905, 3911, 1, 3913, 3948, 1, 3976, 3980, 1, 4096, 4138, 1, 4159, 4176, 17, 4177, 4181, 1, 4186, 4189, 1, 4193, 4197, 4, 4198, 4206, 8, 4207, 4208, 1, 4213, 4225, 1, 4238, 4256, 18, 4257, 4293, 1, 4295, 4301, 6, 4304, 4346, 1, 4348, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4992, 5007, 1, 5024, 5109, 1, 5112, 5117, 1, 5121, 5740, 1, 5743, 5759, 1, 5761, 5786, 1, 5792, 5866, 1, 5873, 5880, 1, 5888, 5905, 1, 5919, 5937, 1, 5952, 5969, 1, 5984, 5996, 1, 5998, 6e3, 1, 6016, 6067, 1, 6103, 6108, 5, 6176, 6264, 1, 6272, 6276, 1, 6279, 6312, 1, 6314, 6320, 6, 6321, 6389, 1, 6400, 6430, 1, 6480, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6656, 6678, 1, 6688, 6740, 1, 6823, 6917, 94, 6918, 6963, 1, 6981, 6988, 1, 7043, 7072, 1, 7086, 7087, 1, 7098, 7141, 1, 7168, 7203, 1, 7245, 7247, 1, 7258, 7293, 1, 7296, 7306, 1, 7312, 7354, 1, 7357, 7359, 1, 7401, 7404, 1, 7406, 7411, 1, 7413, 7414, 1, 7418, 7424, 6, 7425, 7615, 1, 7680, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8124, 1, 8126, 8130, 4, 8131, 8132, 1, 8134, 8140, 1, 8144, 8147, 1, 8150, 8155, 1, 8160, 8172, 1, 8178, 8180, 1, 8182, 8188, 1, 8305, 8319, 14, 8336, 8348, 1, 8450, 8455, 5, 8458, 8467, 1, 8469, 8473, 4, 8474, 8477, 1, 8484, 8490, 2, 8491, 8493, 1, 8495, 8505, 1, 8508, 8511, 1, 8517, 8521, 1, 8526, 8579, 53, 8580, 11264, 2684, 11265, 11492, 1, 11499, 11502, 1, 11506, 11507, 1, 11520, 11557, 1, 11559, 11565, 6, 11568, 11623, 1, 11631, 11648, 17, 11649, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 11823, 12293, 470, 12294, 12337, 43, 12338, 12341, 1, 12347, 12348, 1, 12353, 12438, 1, 12445, 12447, 1, 12449, 12538, 1, 12540, 12543, 1, 12549, 12591, 1, 12593, 12686, 1, 12704, 12735, 1, 12784, 12799, 1, 13312, 19903, 1, 19968, 42124, 1, 42192, 42237, 1, 42240, 42508, 1, 42512, 42527, 1, 42538, 42539, 1, 42560, 42606, 1, 42623, 42653, 1, 42656, 42725, 1, 42775, 42783, 1, 42786, 42888, 1, 42891, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43009, 1, 43011, 43013, 1, 43015, 43018, 1, 43020, 43042, 1, 43072, 43123, 1, 43138, 43187, 1, 43250, 43255, 1, 43259, 43261, 2, 43262, 43274, 12, 43275, 43301, 1, 43312, 43334, 1, 43360, 43388, 1, 43396, 43442, 1, 43471, 43488, 17, 43489, 43492, 1, 43494, 43503, 1, 43514, 43518, 1, 43520, 43560, 1, 43584, 43586, 1, 43588, 43595, 1, 43616, 43638, 1, 43642, 43646, 4, 43647, 43695, 1, 43697, 43701, 4, 43702, 43705, 3, 43706, 43709, 1, 43712, 43714, 2, 43739, 43741, 1, 43744, 43754, 1, 43762, 43764, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43824, 43866, 1, 43868, 43881, 1, 43888, 44002, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64256, 64262, 1, 64275, 64279, 1, 64285, 64287, 2, 64288, 64296, 1, 64298, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64433, 1, 64467, 64829, 1, 64848, 64911, 1, 64914, 64967, 1, 65008, 65019, 1, 65136, 65140, 1, 65142, 65276, 1, 65313, 65338, 1, 65345, 65370, 1, 65382, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 66176, 66204, 1, 66208, 66256, 1, 66304, 66335, 1, 66349, 66368, 1, 66370, 66377, 1, 66384, 66421, 1, 66432, 66461, 1, 66464, 66499, 1, 66504, 66511, 1, 66560, 66717, 1, 66736, 66771, 1, 66776, 66811, 1, 66816, 66855, 1, 66864, 66915, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67680, 67702, 1, 67712, 67742, 1, 67808, 67826, 1, 67828, 67829, 1, 67840, 67861, 1, 67872, 67897, 1, 67968, 68023, 1, 68030, 68031, 1, 68096, 68112, 16, 68113, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68192, 68220, 1, 68224, 68252, 1, 68288, 68295, 1, 68297, 68324, 1, 68352, 68405, 1, 68416, 68437, 1, 68448, 68466, 1, 68480, 68497, 1, 68608, 68680, 1, 68736, 68786, 1, 68800, 68850, 1, 68864, 68899, 1, 68938, 68965, 1, 68975, 68997, 1, 69248, 69289, 1, 69296, 69297, 1, 69314, 69316, 1, 69376, 69404, 1, 69415, 69424, 9, 69425, 69445, 1, 69488, 69505, 1, 69552, 69572, 1, 69600, 69622, 1, 69635, 69687, 1, 69745, 69746, 1, 69749, 69763, 14, 69764, 69807, 1, 69840, 69864, 1, 69891, 69926, 1, 69956, 69959, 3, 69968, 70002, 1, 70006, 70019, 13, 70020, 70066, 1, 70081, 70084, 1, 70106, 70108, 2, 70144, 70161, 1, 70163, 70187, 1, 70207, 70208, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70312, 1, 70320, 70366, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70461, 70480, 19, 70493, 70497, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70609, 26, 70611, 70656, 45, 70657, 70708, 1, 70727, 70730, 1, 70751, 70753, 1, 70784, 70831, 1, 70852, 70853, 1, 70855, 71040, 185, 71041, 71086, 1, 71128, 71131, 1, 71168, 71215, 1, 71236, 71296, 60, 71297, 71338, 1, 71352, 71424, 72, 71425, 71450, 1, 71488, 71494, 1, 71680, 71723, 1, 71840, 71903, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71983, 1, 71999, 72001, 2, 72096, 72103, 1, 72106, 72144, 1, 72161, 72163, 2, 72192, 72203, 11, 72204, 72242, 1, 72250, 72272, 22, 72284, 72329, 1, 72349, 72368, 19, 72369, 72440, 1, 72640, 72672, 1, 72704, 72712, 1, 72714, 72750, 1, 72768, 72818, 50, 72819, 72847, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73008, 1, 73030, 73056, 26, 73057, 73061, 1, 73063, 73064, 1, 73066, 73097, 1, 73112, 73440, 328, 73441, 73458, 1, 73474, 73476, 2, 73477, 73488, 1, 73490, 73523, 1, 73648, 73728, 80, 73729, 74649, 1, 74880, 75075, 1, 77712, 77808, 1, 77824, 78895, 1, 78913, 78918, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90397, 1, 92160, 92728, 1, 92736, 92766, 1, 92784, 92862, 1, 92880, 92909, 1, 92928, 92975, 1, 92992, 92995, 1, 93027, 93047, 1, 93053, 93071, 1, 93504, 93548, 1, 93760, 93823, 1, 93952, 94026, 1, 94032, 94099, 67, 94100, 94111, 1, 94176, 94177, 1, 94179, 94208, 29, 94209, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120512, 1, 120514, 120538, 1, 120540, 120570, 1, 120572, 120596, 1, 120598, 120628, 1, 120630, 120654, 1, 120656, 120686, 1, 120688, 120712, 1, 120714, 120744, 1, 120746, 120770, 1, 120772, 120779, 1, 122624, 122654, 1, 122661, 122666, 1, 122928, 122989, 1, 123136, 123180, 1, 123191, 123197, 1, 123214, 123536, 322, 123537, 123565, 1, 123584, 123627, 1, 124112, 124139, 1, 124368, 124397, 1, 124400, 124896, 496, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 125184, 125251, 1, 125259, 126464, 1205, 126465, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static foldL = new a(new Uint32Array([837, 837, 1]));
      static Ll = new a(new Uint32Array([97, 122, 1, 181, 223, 42, 224, 246, 1, 248, 255, 1, 257, 311, 2, 312, 328, 2, 329, 375, 2, 378, 382, 2, 383, 384, 1, 387, 389, 2, 392, 396, 4, 397, 402, 5, 405, 409, 4, 410, 411, 1, 414, 417, 3, 419, 421, 2, 424, 426, 2, 427, 429, 2, 432, 436, 4, 438, 441, 3, 442, 445, 3, 446, 447, 1, 454, 460, 3, 462, 476, 2, 477, 495, 2, 496, 499, 3, 501, 505, 4, 507, 563, 2, 564, 569, 1, 572, 575, 3, 576, 578, 2, 583, 591, 2, 592, 659, 1, 661, 687, 1, 881, 883, 2, 887, 891, 4, 892, 893, 1, 912, 940, 28, 941, 974, 1, 976, 977, 1, 981, 983, 1, 985, 1007, 2, 1008, 1011, 1, 1013, 1019, 3, 1020, 1072, 52, 1073, 1119, 1, 1121, 1153, 2, 1163, 1215, 2, 1218, 1230, 2, 1231, 1327, 2, 1376, 1416, 1, 4304, 4346, 1, 4349, 4351, 1, 5112, 5117, 1, 7296, 7304, 1, 7306, 7424, 118, 7425, 7467, 1, 7531, 7543, 1, 7545, 7578, 1, 7681, 7829, 2, 7830, 7837, 1, 7839, 7935, 2, 7936, 7943, 1, 7952, 7957, 1, 7968, 7975, 1, 7984, 7991, 1, 8e3, 8005, 1, 8016, 8023, 1, 8032, 8039, 1, 8048, 8061, 1, 8064, 8071, 1, 8080, 8087, 1, 8096, 8103, 1, 8112, 8116, 1, 8118, 8119, 1, 8126, 8130, 4, 8131, 8132, 1, 8134, 8135, 1, 8144, 8147, 1, 8150, 8151, 1, 8160, 8167, 1, 8178, 8180, 1, 8182, 8183, 1, 8458, 8462, 4, 8463, 8467, 4, 8495, 8505, 5, 8508, 8509, 1, 8518, 8521, 1, 8526, 8580, 54, 11312, 11359, 1, 11361, 11365, 4, 11366, 11372, 2, 11377, 11379, 2, 11380, 11382, 2, 11383, 11387, 1, 11393, 11491, 2, 11492, 11500, 8, 11502, 11507, 5, 11520, 11557, 1, 11559, 11565, 6, 42561, 42605, 2, 42625, 42651, 2, 42787, 42799, 2, 42800, 42801, 1, 42803, 42865, 2, 42866, 42872, 1, 42874, 42876, 2, 42879, 42887, 2, 42892, 42894, 2, 42897, 42899, 2, 42900, 42901, 1, 42903, 42921, 2, 42927, 42933, 6, 42935, 42947, 2, 42952, 42954, 2, 42957, 42961, 4, 42963, 42971, 2, 42998, 43002, 4, 43824, 43866, 1, 43872, 43880, 1, 43888, 43967, 1, 64256, 64262, 1, 64275, 64279, 1, 65345, 65370, 1, 66600, 66639, 1, 66776, 66811, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 68800, 68850, 1, 68976, 68997, 1, 71872, 71903, 1, 93792, 93823, 1, 119834, 119859, 1, 119886, 119892, 1, 119894, 119911, 1, 119938, 119963, 1, 119990, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120015, 1, 120042, 120067, 1, 120094, 120119, 1, 120146, 120171, 1, 120198, 120223, 1, 120250, 120275, 1, 120302, 120327, 1, 120354, 120379, 1, 120406, 120431, 1, 120458, 120485, 1, 120514, 120538, 1, 120540, 120545, 1, 120572, 120596, 1, 120598, 120603, 1, 120630, 120654, 1, 120656, 120661, 1, 120688, 120712, 1, 120714, 120719, 1, 120746, 120770, 1, 120772, 120777, 1, 120779, 122624, 1845, 122625, 122633, 1, 122635, 122654, 1, 122661, 122666, 1, 125218, 125251, 1]));
      static foldLl = new a(new Uint32Array([65, 90, 1, 192, 214, 1, 216, 222, 1, 256, 302, 2, 306, 310, 2, 313, 327, 2, 330, 376, 2, 377, 381, 2, 385, 386, 1, 388, 390, 2, 391, 393, 2, 394, 395, 1, 398, 401, 1, 403, 404, 1, 406, 408, 1, 412, 413, 1, 415, 416, 1, 418, 422, 2, 423, 425, 2, 428, 430, 2, 431, 433, 2, 434, 435, 1, 437, 439, 2, 440, 444, 4, 452, 453, 1, 455, 456, 1, 458, 459, 1, 461, 475, 2, 478, 494, 2, 497, 498, 1, 500, 502, 2, 503, 504, 1, 506, 562, 2, 570, 571, 1, 573, 574, 1, 577, 579, 2, 580, 582, 1, 584, 590, 2, 837, 880, 43, 882, 886, 4, 895, 902, 7, 904, 906, 1, 908, 910, 2, 911, 913, 2, 914, 929, 1, 931, 939, 1, 975, 984, 9, 986, 1006, 2, 1012, 1015, 3, 1017, 1018, 1, 1021, 1071, 1, 1120, 1152, 2, 1162, 1216, 2, 1217, 1229, 2, 1232, 1326, 2, 1329, 1366, 1, 4256, 4293, 1, 4295, 4301, 6, 5024, 5109, 1, 7305, 7312, 7, 7313, 7354, 1, 7357, 7359, 1, 7680, 7828, 2, 7838, 7934, 2, 7944, 7951, 1, 7960, 7965, 1, 7976, 7983, 1, 7992, 7999, 1, 8008, 8013, 1, 8025, 8031, 2, 8040, 8047, 1, 8072, 8079, 1, 8088, 8095, 1, 8104, 8111, 1, 8120, 8124, 1, 8136, 8140, 1, 8152, 8155, 1, 8168, 8172, 1, 8184, 8188, 1, 8486, 8490, 4, 8491, 8498, 7, 8579, 11264, 2685, 11265, 11311, 1, 11360, 11362, 2, 11363, 11364, 1, 11367, 11373, 2, 11374, 11376, 1, 11378, 11381, 3, 11390, 11392, 1, 11394, 11490, 2, 11499, 11501, 2, 11506, 42560, 31054, 42562, 42604, 2, 42624, 42650, 2, 42786, 42798, 2, 42802, 42862, 2, 42873, 42877, 2, 42878, 42886, 2, 42891, 42893, 2, 42896, 42898, 2, 42902, 42922, 2, 42923, 42926, 1, 42928, 42932, 1, 42934, 42948, 2, 42949, 42951, 1, 42953, 42955, 2, 42956, 42960, 4, 42966, 42972, 2, 42997, 65313, 22316, 65314, 65338, 1, 66560, 66599, 1, 66736, 66771, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 68736, 68786, 1, 68944, 68965, 1, 71840, 71871, 1, 93760, 93791, 1, 125184, 125217, 1]));
      static Lm = new a(new Uint32Array([688, 705, 1, 710, 721, 1, 736, 740, 1, 748, 750, 2, 884, 890, 6, 1369, 1600, 231, 1765, 1766, 1, 2036, 2037, 1, 2042, 2074, 32, 2084, 2088, 4, 2249, 2417, 168, 3654, 3782, 128, 4348, 6103, 1755, 6211, 6823, 612, 7288, 7293, 1, 7468, 7530, 1, 7544, 7579, 35, 7580, 7615, 1, 8305, 8319, 14, 8336, 8348, 1, 11388, 11389, 1, 11631, 11823, 192, 12293, 12337, 44, 12338, 12341, 1, 12347, 12445, 98, 12446, 12540, 94, 12541, 12542, 1, 40981, 42232, 1251, 42233, 42237, 1, 42508, 42623, 115, 42652, 42653, 1, 42775, 42783, 1, 42864, 42888, 24, 42994, 42996, 1, 43e3, 43001, 1, 43471, 43494, 23, 43632, 43741, 109, 43763, 43764, 1, 43868, 43871, 1, 43881, 65392, 21511, 65438, 65439, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 68942, 68975, 33, 92992, 92995, 1, 93504, 93506, 1, 93547, 93548, 1, 94099, 94111, 1, 94176, 94177, 1, 94179, 110576, 16397, 110577, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 122928, 122989, 1, 123191, 123197, 1, 124139, 125259, 1120]));
      static Lo = new a(new Uint32Array([170, 186, 16, 443, 448, 5, 449, 451, 1, 660, 1488, 828, 1489, 1514, 1, 1519, 1522, 1, 1568, 1599, 1, 1601, 1610, 1, 1646, 1647, 1, 1649, 1747, 1, 1749, 1774, 25, 1775, 1786, 11, 1787, 1788, 1, 1791, 1808, 17, 1810, 1839, 1, 1869, 1957, 1, 1969, 1994, 25, 1995, 2026, 1, 2048, 2069, 1, 2112, 2136, 1, 2144, 2154, 1, 2160, 2183, 1, 2185, 2190, 1, 2208, 2248, 1, 2308, 2361, 1, 2365, 2384, 19, 2392, 2401, 1, 2418, 2432, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2493, 2510, 17, 2524, 2525, 1, 2527, 2529, 1, 2544, 2545, 1, 2556, 2565, 9, 2566, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2649, 2652, 1, 2654, 2674, 20, 2675, 2676, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2749, 2768, 19, 2784, 2785, 1, 2809, 2821, 12, 2822, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2877, 2908, 31, 2909, 2911, 2, 2912, 2913, 1, 2929, 2947, 18, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3024, 3077, 53, 3078, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3133, 3160, 27, 3161, 3162, 1, 3165, 3168, 3, 3169, 3200, 31, 3205, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3261, 3293, 32, 3294, 3296, 2, 3297, 3313, 16, 3314, 3332, 18, 3333, 3340, 1, 3342, 3344, 1, 3346, 3386, 1, 3389, 3406, 17, 3412, 3414, 1, 3423, 3425, 1, 3450, 3455, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3585, 3632, 1, 3634, 3635, 1, 3648, 3653, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3760, 1, 3762, 3763, 1, 3773, 3776, 3, 3777, 3780, 1, 3804, 3807, 1, 3840, 3904, 64, 3905, 3911, 1, 3913, 3948, 1, 3976, 3980, 1, 4096, 4138, 1, 4159, 4176, 17, 4177, 4181, 1, 4186, 4189, 1, 4193, 4197, 4, 4198, 4206, 8, 4207, 4208, 1, 4213, 4225, 1, 4238, 4352, 114, 4353, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4992, 5007, 1, 5121, 5740, 1, 5743, 5759, 1, 5761, 5786, 1, 5792, 5866, 1, 5873, 5880, 1, 5888, 5905, 1, 5919, 5937, 1, 5952, 5969, 1, 5984, 5996, 1, 5998, 6e3, 1, 6016, 6067, 1, 6108, 6176, 68, 6177, 6210, 1, 6212, 6264, 1, 6272, 6276, 1, 6279, 6312, 1, 6314, 6320, 6, 6321, 6389, 1, 6400, 6430, 1, 6480, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6656, 6678, 1, 6688, 6740, 1, 6917, 6963, 1, 6981, 6988, 1, 7043, 7072, 1, 7086, 7087, 1, 7098, 7141, 1, 7168, 7203, 1, 7245, 7247, 1, 7258, 7287, 1, 7401, 7404, 1, 7406, 7411, 1, 7413, 7414, 1, 7418, 8501, 1083, 8502, 8504, 1, 11568, 11623, 1, 11648, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 12294, 12348, 54, 12353, 12438, 1, 12447, 12449, 2, 12450, 12538, 1, 12543, 12549, 6, 12550, 12591, 1, 12593, 12686, 1, 12704, 12735, 1, 12784, 12799, 1, 13312, 19903, 1, 19968, 40980, 1, 40982, 42124, 1, 42192, 42231, 1, 42240, 42507, 1, 42512, 42527, 1, 42538, 42539, 1, 42606, 42656, 50, 42657, 42725, 1, 42895, 42999, 104, 43003, 43009, 1, 43011, 43013, 1, 43015, 43018, 1, 43020, 43042, 1, 43072, 43123, 1, 43138, 43187, 1, 43250, 43255, 1, 43259, 43261, 2, 43262, 43274, 12, 43275, 43301, 1, 43312, 43334, 1, 43360, 43388, 1, 43396, 43442, 1, 43488, 43492, 1, 43495, 43503, 1, 43514, 43518, 1, 43520, 43560, 1, 43584, 43586, 1, 43588, 43595, 1, 43616, 43631, 1, 43633, 43638, 1, 43642, 43646, 4, 43647, 43695, 1, 43697, 43701, 4, 43702, 43705, 3, 43706, 43709, 1, 43712, 43714, 2, 43739, 43740, 1, 43744, 43754, 1, 43762, 43777, 15, 43778, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43968, 44002, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64285, 64287, 2, 64288, 64296, 1, 64298, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64433, 1, 64467, 64829, 1, 64848, 64911, 1, 64914, 64967, 1, 65008, 65019, 1, 65136, 65140, 1, 65142, 65276, 1, 65382, 65391, 1, 65393, 65437, 1, 65440, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 66176, 66204, 1, 66208, 66256, 1, 66304, 66335, 1, 66349, 66368, 1, 66370, 66377, 1, 66384, 66421, 1, 66432, 66461, 1, 66464, 66499, 1, 66504, 66511, 1, 66640, 66717, 1, 66816, 66855, 1, 66864, 66915, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67680, 67702, 1, 67712, 67742, 1, 67808, 67826, 1, 67828, 67829, 1, 67840, 67861, 1, 67872, 67897, 1, 67968, 68023, 1, 68030, 68031, 1, 68096, 68112, 16, 68113, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68192, 68220, 1, 68224, 68252, 1, 68288, 68295, 1, 68297, 68324, 1, 68352, 68405, 1, 68416, 68437, 1, 68448, 68466, 1, 68480, 68497, 1, 68608, 68680, 1, 68864, 68899, 1, 68938, 68941, 1, 68943, 69248, 305, 69249, 69289, 1, 69296, 69297, 1, 69314, 69316, 1, 69376, 69404, 1, 69415, 69424, 9, 69425, 69445, 1, 69488, 69505, 1, 69552, 69572, 1, 69600, 69622, 1, 69635, 69687, 1, 69745, 69746, 1, 69749, 69763, 14, 69764, 69807, 1, 69840, 69864, 1, 69891, 69926, 1, 69956, 69959, 3, 69968, 70002, 1, 70006, 70019, 13, 70020, 70066, 1, 70081, 70084, 1, 70106, 70108, 2, 70144, 70161, 1, 70163, 70187, 1, 70207, 70208, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70312, 1, 70320, 70366, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70461, 70480, 19, 70493, 70497, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70609, 26, 70611, 70656, 45, 70657, 70708, 1, 70727, 70730, 1, 70751, 70753, 1, 70784, 70831, 1, 70852, 70853, 1, 70855, 71040, 185, 71041, 71086, 1, 71128, 71131, 1, 71168, 71215, 1, 71236, 71296, 60, 71297, 71338, 1, 71352, 71424, 72, 71425, 71450, 1, 71488, 71494, 1, 71680, 71723, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71983, 1, 71999, 72001, 2, 72096, 72103, 1, 72106, 72144, 1, 72161, 72163, 2, 72192, 72203, 11, 72204, 72242, 1, 72250, 72272, 22, 72284, 72329, 1, 72349, 72368, 19, 72369, 72440, 1, 72640, 72672, 1, 72704, 72712, 1, 72714, 72750, 1, 72768, 72818, 50, 72819, 72847, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73008, 1, 73030, 73056, 26, 73057, 73061, 1, 73063, 73064, 1, 73066, 73097, 1, 73112, 73440, 328, 73441, 73458, 1, 73474, 73476, 2, 73477, 73488, 1, 73490, 73523, 1, 73648, 73728, 80, 73729, 74649, 1, 74880, 75075, 1, 77712, 77808, 1, 77824, 78895, 1, 78913, 78918, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90397, 1, 92160, 92728, 1, 92736, 92766, 1, 92784, 92862, 1, 92880, 92909, 1, 92928, 92975, 1, 93027, 93047, 1, 93053, 93071, 1, 93507, 93546, 1, 93952, 94026, 1, 94032, 94208, 176, 94209, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 122634, 123136, 502, 123137, 123180, 1, 123214, 123536, 322, 123537, 123565, 1, 123584, 123627, 1, 124112, 124138, 1, 124368, 124397, 1, 124400, 124896, 496, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static Lt = new a(new Uint32Array([453, 459, 3, 498, 8072, 7574, 8073, 8079, 1, 8088, 8095, 1, 8104, 8111, 1, 8124, 8140, 16, 8188, 8188, 1]));
      static foldLt = new a(new Uint32Array([452, 454, 2, 455, 457, 2, 458, 460, 2, 497, 499, 2, 8064, 8071, 1, 8080, 8087, 1, 8096, 8103, 1, 8115, 8131, 16, 8179, 8179, 1]));
      static Lu = new a(new Uint32Array([65, 90, 1, 192, 214, 1, 216, 222, 1, 256, 310, 2, 313, 327, 2, 330, 376, 2, 377, 381, 2, 385, 386, 1, 388, 390, 2, 391, 393, 2, 394, 395, 1, 398, 401, 1, 403, 404, 1, 406, 408, 1, 412, 413, 1, 415, 416, 1, 418, 422, 2, 423, 425, 2, 428, 430, 2, 431, 433, 2, 434, 435, 1, 437, 439, 2, 440, 444, 4, 452, 461, 3, 463, 475, 2, 478, 494, 2, 497, 500, 3, 502, 504, 1, 506, 562, 2, 570, 571, 1, 573, 574, 1, 577, 579, 2, 580, 582, 1, 584, 590, 2, 880, 882, 2, 886, 895, 9, 902, 904, 2, 905, 906, 1, 908, 910, 2, 911, 913, 2, 914, 929, 1, 931, 939, 1, 975, 978, 3, 979, 980, 1, 984, 1006, 2, 1012, 1015, 3, 1017, 1018, 1, 1021, 1071, 1, 1120, 1152, 2, 1162, 1216, 2, 1217, 1229, 2, 1232, 1326, 2, 1329, 1366, 1, 4256, 4293, 1, 4295, 4301, 6, 5024, 5109, 1, 7305, 7312, 7, 7313, 7354, 1, 7357, 7359, 1, 7680, 7828, 2, 7838, 7934, 2, 7944, 7951, 1, 7960, 7965, 1, 7976, 7983, 1, 7992, 7999, 1, 8008, 8013, 1, 8025, 8031, 2, 8040, 8047, 1, 8120, 8123, 1, 8136, 8139, 1, 8152, 8155, 1, 8168, 8172, 1, 8184, 8187, 1, 8450, 8455, 5, 8459, 8461, 1, 8464, 8466, 1, 8469, 8473, 4, 8474, 8477, 1, 8484, 8490, 2, 8491, 8493, 1, 8496, 8499, 1, 8510, 8511, 1, 8517, 8579, 62, 11264, 11311, 1, 11360, 11362, 2, 11363, 11364, 1, 11367, 11373, 2, 11374, 11376, 1, 11378, 11381, 3, 11390, 11392, 1, 11394, 11490, 2, 11499, 11501, 2, 11506, 42560, 31054, 42562, 42604, 2, 42624, 42650, 2, 42786, 42798, 2, 42802, 42862, 2, 42873, 42877, 2, 42878, 42886, 2, 42891, 42893, 2, 42896, 42898, 2, 42902, 42922, 2, 42923, 42926, 1, 42928, 42932, 1, 42934, 42948, 2, 42949, 42951, 1, 42953, 42955, 2, 42956, 42960, 4, 42966, 42972, 2, 42997, 65313, 22316, 65314, 65338, 1, 66560, 66599, 1, 66736, 66771, 1, 66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 68736, 68786, 1, 68944, 68965, 1, 71840, 71871, 1, 93760, 93791, 1, 119808, 119833, 1, 119860, 119885, 1, 119912, 119937, 1, 119964, 119966, 2, 119967, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119989, 1, 120016, 120041, 1, 120068, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120120, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120172, 120197, 1, 120224, 120249, 1, 120276, 120301, 1, 120328, 120353, 1, 120380, 120405, 1, 120432, 120457, 1, 120488, 120512, 1, 120546, 120570, 1, 120604, 120628, 1, 120662, 120686, 1, 120720, 120744, 1, 120778, 125184, 4406, 125185, 125217, 1]));
      static Upper = this.Lu;
      static foldLu = new a(new Uint32Array([97, 122, 1, 181, 223, 42, 224, 246, 1, 248, 255, 1, 257, 303, 2, 307, 311, 2, 314, 328, 2, 331, 375, 2, 378, 382, 2, 383, 384, 1, 387, 389, 2, 392, 396, 4, 402, 405, 3, 409, 411, 1, 414, 417, 3, 419, 421, 2, 424, 429, 5, 432, 436, 4, 438, 441, 3, 445, 447, 2, 453, 454, 1, 456, 457, 1, 459, 460, 1, 462, 476, 2, 477, 495, 2, 498, 499, 1, 501, 505, 4, 507, 543, 2, 547, 563, 2, 572, 575, 3, 576, 578, 2, 583, 591, 2, 592, 596, 1, 598, 599, 1, 601, 603, 2, 604, 608, 4, 609, 611, 2, 612, 614, 1, 616, 620, 1, 623, 625, 2, 626, 629, 3, 637, 640, 3, 642, 643, 1, 647, 652, 1, 658, 669, 11, 670, 837, 167, 881, 883, 2, 887, 891, 4, 892, 893, 1, 940, 943, 1, 945, 974, 1, 976, 977, 1, 981, 983, 1, 985, 1007, 2, 1008, 1011, 1, 1013, 1019, 3, 1072, 1119, 1, 1121, 1153, 2, 1163, 1215, 2, 1218, 1230, 2, 1231, 1327, 2, 1377, 1414, 1, 4304, 4346, 1, 4349, 4351, 1, 5112, 5117, 1, 7296, 7304, 1, 7306, 7545, 239, 7549, 7566, 17, 7681, 7829, 2, 7835, 7841, 6, 7843, 7935, 2, 7936, 7943, 1, 7952, 7957, 1, 7968, 7975, 1, 7984, 7991, 1, 8e3, 8005, 1, 8017, 8023, 2, 8032, 8039, 1, 8048, 8061, 1, 8112, 8113, 1, 8126, 8144, 18, 8145, 8160, 15, 8161, 8165, 4, 8526, 8580, 54, 11312, 11359, 1, 11361, 11365, 4, 11366, 11372, 2, 11379, 11382, 3, 11393, 11491, 2, 11500, 11502, 2, 11507, 11520, 13, 11521, 11557, 1, 11559, 11565, 6, 42561, 42605, 2, 42625, 42651, 2, 42787, 42799, 2, 42803, 42863, 2, 42874, 42876, 2, 42879, 42887, 2, 42892, 42897, 5, 42899, 42900, 1, 42903, 42921, 2, 42933, 42947, 2, 42952, 42954, 2, 42957, 42961, 4, 42967, 42971, 2, 42998, 43859, 861, 43888, 43967, 1, 65345, 65370, 1, 66600, 66639, 1, 66776, 66811, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 68800, 68850, 1, 68976, 68997, 1, 71872, 71903, 1, 93792, 93823, 1, 125218, 125251, 1]));
      static M = new a(new Uint32Array([768, 879, 1, 1155, 1161, 1, 1425, 1469, 1, 1471, 1473, 2, 1474, 1476, 2, 1477, 1479, 2, 1552, 1562, 1, 1611, 1631, 1, 1648, 1750, 102, 1751, 1756, 1, 1759, 1764, 1, 1767, 1768, 1, 1770, 1773, 1, 1809, 1840, 31, 1841, 1866, 1, 1958, 1968, 1, 2027, 2035, 1, 2045, 2070, 25, 2071, 2073, 1, 2075, 2083, 1, 2085, 2087, 1, 2089, 2093, 1, 2137, 2139, 1, 2199, 2207, 1, 2250, 2273, 1, 2275, 2307, 1, 2362, 2364, 1, 2366, 2383, 1, 2385, 2391, 1, 2402, 2403, 1, 2433, 2435, 1, 2492, 2494, 2, 2495, 2500, 1, 2503, 2504, 1, 2507, 2509, 1, 2519, 2530, 11, 2531, 2558, 27, 2561, 2563, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2672, 31, 2673, 2677, 4, 2689, 2691, 1, 2748, 2750, 2, 2751, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2786, 2787, 1, 2810, 2815, 1, 2817, 2819, 1, 2876, 2878, 2, 2879, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2914, 2915, 1, 2946, 3006, 60, 3007, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3031, 3072, 41, 3073, 3076, 1, 3132, 3134, 2, 3135, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3170, 3171, 1, 3201, 3203, 1, 3260, 3262, 2, 3263, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3298, 3299, 1, 3315, 3328, 13, 3329, 3331, 1, 3387, 3388, 1, 3390, 3396, 1, 3398, 3400, 1, 3402, 3405, 1, 3415, 3426, 11, 3427, 3457, 30, 3458, 3459, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3570, 3571, 1, 3633, 3636, 3, 3637, 3642, 1, 3655, 3662, 1, 3761, 3764, 3, 3765, 3772, 1, 3784, 3790, 1, 3864, 3865, 1, 3893, 3897, 2, 3902, 3903, 1, 3953, 3972, 1, 3974, 3975, 1, 3981, 3991, 1, 3993, 4028, 1, 4038, 4139, 101, 4140, 4158, 1, 4182, 4185, 1, 4190, 4192, 1, 4194, 4196, 1, 4199, 4205, 1, 4209, 4212, 1, 4226, 4237, 1, 4239, 4250, 11, 4251, 4253, 1, 4957, 4959, 1, 5906, 5909, 1, 5938, 5940, 1, 5970, 5971, 1, 6002, 6003, 1, 6068, 6099, 1, 6109, 6155, 46, 6156, 6157, 1, 6159, 6277, 118, 6278, 6313, 35, 6432, 6443, 1, 6448, 6459, 1, 6679, 6683, 1, 6741, 6750, 1, 6752, 6780, 1, 6783, 6832, 49, 6833, 6862, 1, 6912, 6916, 1, 6964, 6980, 1, 7019, 7027, 1, 7040, 7042, 1, 7073, 7085, 1, 7142, 7155, 1, 7204, 7223, 1, 7376, 7378, 1, 7380, 7400, 1, 7405, 7412, 7, 7415, 7417, 1, 7616, 7679, 1, 8400, 8432, 1, 11503, 11505, 1, 11647, 11744, 97, 11745, 11775, 1, 12330, 12335, 1, 12441, 12442, 1, 42607, 42610, 1, 42612, 42621, 1, 42654, 42655, 1, 42736, 42737, 1, 43010, 43014, 4, 43019, 43043, 24, 43044, 43047, 1, 43052, 43136, 84, 43137, 43188, 51, 43189, 43205, 1, 43232, 43249, 1, 43263, 43302, 39, 43303, 43309, 1, 43335, 43347, 1, 43392, 43395, 1, 43443, 43456, 1, 43493, 43561, 68, 43562, 43574, 1, 43587, 43596, 9, 43597, 43643, 46, 43644, 43645, 1, 43696, 43698, 2, 43699, 43700, 1, 43703, 43704, 1, 43710, 43711, 1, 43713, 43755, 42, 43756, 43759, 1, 43765, 43766, 1, 44003, 44010, 1, 44012, 44013, 1, 64286, 65024, 738, 65025, 65039, 1, 65056, 65071, 1, 66045, 66272, 227, 66422, 66426, 1, 68097, 68099, 1, 68101, 68102, 1, 68108, 68111, 1, 68152, 68154, 1, 68159, 68325, 166, 68326, 68900, 574, 68901, 68903, 1, 68969, 68973, 1, 69291, 69292, 1, 69372, 69375, 1, 69446, 69456, 1, 69506, 69509, 1, 69632, 69634, 1, 69688, 69702, 1, 69744, 69747, 3, 69748, 69759, 11, 69760, 69762, 1, 69808, 69818, 1, 69826, 69888, 62, 69889, 69890, 1, 69927, 69940, 1, 69957, 69958, 1, 70003, 70016, 13, 70017, 70018, 1, 70067, 70080, 1, 70089, 70092, 1, 70094, 70095, 1, 70188, 70199, 1, 70206, 70209, 3, 70367, 70378, 1, 70400, 70403, 1, 70459, 70460, 1, 70462, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70487, 70498, 11, 70499, 70502, 3, 70503, 70508, 1, 70512, 70516, 1, 70584, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70608, 1, 70610, 70625, 15, 70626, 70709, 83, 70710, 70726, 1, 70750, 70832, 82, 70833, 70851, 1, 71087, 71093, 1, 71096, 71104, 1, 71132, 71133, 1, 71216, 71232, 1, 71339, 71351, 1, 71453, 71467, 1, 71724, 71738, 1, 71984, 71989, 1, 71991, 71992, 1, 71995, 71998, 1, 72e3, 72002, 2, 72003, 72145, 142, 72146, 72151, 1, 72154, 72160, 1, 72164, 72193, 29, 72194, 72202, 1, 72243, 72249, 1, 72251, 72254, 1, 72263, 72273, 10, 72274, 72283, 1, 72330, 72345, 1, 72751, 72758, 1, 72760, 72767, 1, 72850, 72871, 1, 72873, 72886, 1, 73009, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73029, 1, 73031, 73098, 67, 73099, 73102, 1, 73104, 73105, 1, 73107, 73111, 1, 73459, 73462, 1, 73472, 73473, 1, 73475, 73524, 49, 73525, 73530, 1, 73534, 73538, 1, 73562, 78912, 5350, 78919, 78933, 1, 90398, 90415, 1, 92912, 92916, 1, 92976, 92982, 1, 94031, 94033, 2, 94034, 94087, 1, 94095, 94098, 1, 94180, 94192, 12, 94193, 113821, 19628, 113822, 118528, 4706, 118529, 118573, 1, 118576, 118598, 1, 119141, 119145, 1, 119149, 119154, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 119362, 119364, 1, 121344, 121398, 1, 121403, 121452, 1, 121461, 121476, 15, 121499, 121503, 1, 121505, 121519, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 123023, 123184, 161, 123185, 123190, 1, 123566, 123628, 62, 123629, 123631, 1, 124140, 124143, 1, 124398, 124399, 1, 125136, 125142, 1, 125252, 125258, 1, 917760, 917999, 1]));
      static foldM = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static Mc = new a(new Uint32Array([2307, 2363, 56, 2366, 2368, 1, 2377, 2380, 1, 2382, 2383, 1, 2434, 2435, 1, 2494, 2496, 1, 2503, 2504, 1, 2507, 2508, 1, 2519, 2563, 44, 2622, 2624, 1, 2691, 2750, 59, 2751, 2752, 1, 2761, 2763, 2, 2764, 2818, 54, 2819, 2878, 59, 2880, 2887, 7, 2888, 2891, 3, 2892, 2903, 11, 3006, 3007, 1, 3009, 3010, 1, 3014, 3016, 1, 3018, 3020, 1, 3031, 3073, 42, 3074, 3075, 1, 3137, 3140, 1, 3202, 3203, 1, 3262, 3264, 2, 3265, 3268, 1, 3271, 3272, 1, 3274, 3275, 1, 3285, 3286, 1, 3315, 3330, 15, 3331, 3390, 59, 3391, 3392, 1, 3398, 3400, 1, 3402, 3404, 1, 3415, 3458, 43, 3459, 3535, 76, 3536, 3537, 1, 3544, 3551, 1, 3570, 3571, 1, 3902, 3903, 1, 3967, 4139, 172, 4140, 4145, 5, 4152, 4155, 3, 4156, 4182, 26, 4183, 4194, 11, 4195, 4196, 1, 4199, 4205, 1, 4227, 4228, 1, 4231, 4236, 1, 4239, 4250, 11, 4251, 4252, 1, 5909, 5940, 31, 6070, 6078, 8, 6079, 6085, 1, 6087, 6088, 1, 6435, 6438, 1, 6441, 6443, 1, 6448, 6449, 1, 6451, 6456, 1, 6681, 6682, 1, 6741, 6743, 2, 6753, 6755, 2, 6756, 6765, 9, 6766, 6770, 1, 6916, 6965, 49, 6971, 6973, 2, 6974, 6977, 1, 6979, 6980, 1, 7042, 7073, 31, 7078, 7079, 1, 7082, 7143, 61, 7146, 7148, 1, 7150, 7154, 4, 7155, 7204, 49, 7205, 7211, 1, 7220, 7221, 1, 7393, 7415, 22, 12334, 12335, 1, 43043, 43044, 1, 43047, 43136, 89, 43137, 43188, 51, 43189, 43203, 1, 43346, 43347, 1, 43395, 43444, 49, 43445, 43450, 5, 43451, 43454, 3, 43455, 43456, 1, 43567, 43568, 1, 43571, 43572, 1, 43597, 43643, 46, 43645, 43755, 110, 43758, 43759, 1, 43765, 44003, 238, 44004, 44006, 2, 44007, 44009, 2, 44010, 44012, 2, 69632, 69634, 2, 69762, 69808, 46, 69809, 69810, 1, 69815, 69816, 1, 69932, 69957, 25, 69958, 70018, 60, 70067, 70069, 1, 70079, 70080, 1, 70094, 70188, 94, 70189, 70190, 1, 70194, 70195, 1, 70197, 70368, 171, 70369, 70370, 1, 70402, 70403, 1, 70462, 70463, 1, 70465, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70487, 70498, 11, 70499, 70584, 85, 70585, 70586, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70605, 1, 70607, 70709, 102, 70710, 70711, 1, 70720, 70721, 1, 70725, 70832, 107, 70833, 70834, 1, 70841, 70843, 2, 70844, 70846, 1, 70849, 71087, 238, 71088, 71089, 1, 71096, 71099, 1, 71102, 71216, 114, 71217, 71218, 1, 71227, 71228, 1, 71230, 71340, 110, 71342, 71343, 1, 71350, 71454, 104, 71456, 71457, 1, 71462, 71724, 262, 71725, 71726, 1, 71736, 71984, 248, 71985, 71989, 1, 71991, 71992, 1, 71997, 72e3, 3, 72002, 72145, 143, 72146, 72147, 1, 72156, 72159, 1, 72164, 72249, 85, 72279, 72280, 1, 72343, 72751, 408, 72766, 72873, 107, 72881, 72884, 3, 73098, 73102, 1, 73107, 73108, 1, 73110, 73461, 351, 73462, 73475, 13, 73524, 73525, 1, 73534, 73535, 1, 73537, 90410, 16873, 90411, 90412, 1, 94033, 94087, 1, 94192, 94193, 1, 119141, 119142, 1, 119149, 119154, 1]));
      static Me = new a(new Uint32Array([1160, 1161, 1, 6846, 8413, 1567, 8414, 8416, 1, 8418, 8420, 1, 42608, 42610, 1]));
      static Mn = new a(new Uint32Array([768, 879, 1, 1155, 1159, 1, 1425, 1469, 1, 1471, 1473, 2, 1474, 1476, 2, 1477, 1479, 2, 1552, 1562, 1, 1611, 1631, 1, 1648, 1750, 102, 1751, 1756, 1, 1759, 1764, 1, 1767, 1768, 1, 1770, 1773, 1, 1809, 1840, 31, 1841, 1866, 1, 1958, 1968, 1, 2027, 2035, 1, 2045, 2070, 25, 2071, 2073, 1, 2075, 2083, 1, 2085, 2087, 1, 2089, 2093, 1, 2137, 2139, 1, 2199, 2207, 1, 2250, 2273, 1, 2275, 2306, 1, 2362, 2364, 2, 2369, 2376, 1, 2381, 2385, 4, 2386, 2391, 1, 2402, 2403, 1, 2433, 2492, 59, 2497, 2500, 1, 2509, 2530, 21, 2531, 2558, 27, 2561, 2562, 1, 2620, 2625, 5, 2626, 2631, 5, 2632, 2635, 3, 2636, 2637, 1, 2641, 2672, 31, 2673, 2677, 4, 2689, 2690, 1, 2748, 2753, 5, 2754, 2757, 1, 2759, 2760, 1, 2765, 2786, 21, 2787, 2810, 23, 2811, 2815, 1, 2817, 2876, 59, 2879, 2881, 2, 2882, 2884, 1, 2893, 2901, 8, 2902, 2914, 12, 2915, 2946, 31, 3008, 3021, 13, 3072, 3076, 4, 3132, 3134, 2, 3135, 3136, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3170, 3171, 1, 3201, 3260, 59, 3263, 3270, 7, 3276, 3277, 1, 3298, 3299, 1, 3328, 3329, 1, 3387, 3388, 1, 3393, 3396, 1, 3405, 3426, 21, 3427, 3457, 30, 3530, 3538, 8, 3539, 3540, 1, 3542, 3633, 91, 3636, 3642, 1, 3655, 3662, 1, 3761, 3764, 3, 3765, 3772, 1, 3784, 3790, 1, 3864, 3865, 1, 3893, 3897, 2, 3953, 3966, 1, 3968, 3972, 1, 3974, 3975, 1, 3981, 3991, 1, 3993, 4028, 1, 4038, 4141, 103, 4142, 4144, 1, 4146, 4151, 1, 4153, 4154, 1, 4157, 4158, 1, 4184, 4185, 1, 4190, 4192, 1, 4209, 4212, 1, 4226, 4229, 3, 4230, 4237, 7, 4253, 4957, 704, 4958, 4959, 1, 5906, 5908, 1, 5938, 5939, 1, 5970, 5971, 1, 6002, 6003, 1, 6068, 6069, 1, 6071, 6077, 1, 6086, 6089, 3, 6090, 6099, 1, 6109, 6155, 46, 6156, 6157, 1, 6159, 6277, 118, 6278, 6313, 35, 6432, 6434, 1, 6439, 6440, 1, 6450, 6457, 7, 6458, 6459, 1, 6679, 6680, 1, 6683, 6742, 59, 6744, 6750, 1, 6752, 6754, 2, 6757, 6764, 1, 6771, 6780, 1, 6783, 6832, 49, 6833, 6845, 1, 6847, 6862, 1, 6912, 6915, 1, 6964, 6966, 2, 6967, 6970, 1, 6972, 6978, 6, 7019, 7027, 1, 7040, 7041, 1, 7074, 7077, 1, 7080, 7081, 1, 7083, 7085, 1, 7142, 7144, 2, 7145, 7149, 4, 7151, 7153, 1, 7212, 7219, 1, 7222, 7223, 1, 7376, 7378, 1, 7380, 7392, 1, 7394, 7400, 1, 7405, 7412, 7, 7416, 7417, 1, 7616, 7679, 1, 8400, 8412, 1, 8417, 8421, 4, 8422, 8432, 1, 11503, 11505, 1, 11647, 11744, 97, 11745, 11775, 1, 12330, 12333, 1, 12441, 12442, 1, 42607, 42612, 5, 42613, 42621, 1, 42654, 42655, 1, 42736, 42737, 1, 43010, 43014, 4, 43019, 43045, 26, 43046, 43052, 6, 43204, 43205, 1, 43232, 43249, 1, 43263, 43302, 39, 43303, 43309, 1, 43335, 43345, 1, 43392, 43394, 1, 43443, 43446, 3, 43447, 43449, 1, 43452, 43453, 1, 43493, 43561, 68, 43562, 43566, 1, 43569, 43570, 1, 43573, 43574, 1, 43587, 43596, 9, 43644, 43696, 52, 43698, 43700, 1, 43703, 43704, 1, 43710, 43711, 1, 43713, 43756, 43, 43757, 43766, 9, 44005, 44008, 3, 44013, 64286, 20273, 65024, 65039, 1, 65056, 65071, 1, 66045, 66272, 227, 66422, 66426, 1, 68097, 68099, 1, 68101, 68102, 1, 68108, 68111, 1, 68152, 68154, 1, 68159, 68325, 166, 68326, 68900, 574, 68901, 68903, 1, 68969, 68973, 1, 69291, 69292, 1, 69372, 69375, 1, 69446, 69456, 1, 69506, 69509, 1, 69633, 69688, 55, 69689, 69702, 1, 69744, 69747, 3, 69748, 69759, 11, 69760, 69761, 1, 69811, 69814, 1, 69817, 69818, 1, 69826, 69888, 62, 69889, 69890, 1, 69927, 69931, 1, 69933, 69940, 1, 70003, 70016, 13, 70017, 70070, 53, 70071, 70078, 1, 70089, 70092, 1, 70095, 70191, 96, 70192, 70193, 1, 70196, 70198, 2, 70199, 70206, 7, 70209, 70367, 158, 70371, 70378, 1, 70400, 70401, 1, 70459, 70460, 1, 70464, 70502, 38, 70503, 70508, 1, 70512, 70516, 1, 70587, 70592, 1, 70606, 70610, 2, 70625, 70626, 1, 70712, 70719, 1, 70722, 70724, 1, 70726, 70750, 24, 70835, 70840, 1, 70842, 70847, 5, 70848, 70850, 2, 70851, 71090, 239, 71091, 71093, 1, 71100, 71101, 1, 71103, 71104, 1, 71132, 71133, 1, 71219, 71226, 1, 71229, 71231, 2, 71232, 71339, 107, 71341, 71344, 3, 71345, 71349, 1, 71351, 71453, 102, 71455, 71458, 3, 71459, 71461, 1, 71463, 71467, 1, 71727, 71735, 1, 71737, 71738, 1, 71995, 71996, 1, 71998, 72003, 5, 72148, 72151, 1, 72154, 72155, 1, 72160, 72193, 33, 72194, 72202, 1, 72243, 72248, 1, 72251, 72254, 1, 72263, 72273, 10, 72274, 72278, 1, 72281, 72283, 1, 72330, 72342, 1, 72344, 72345, 1, 72752, 72758, 1, 72760, 72765, 1, 72767, 72850, 83, 72851, 72871, 1, 72874, 72880, 1, 72882, 72883, 1, 72885, 72886, 1, 73009, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73029, 1, 73031, 73104, 73, 73105, 73109, 4, 73111, 73459, 348, 73460, 73472, 12, 73473, 73526, 53, 73527, 73530, 1, 73536, 73538, 2, 73562, 78912, 5350, 78919, 78933, 1, 90398, 90409, 1, 90413, 90415, 1, 92912, 92916, 1, 92976, 92982, 1, 94031, 94095, 64, 94096, 94098, 1, 94180, 113821, 19641, 113822, 118528, 4706, 118529, 118573, 1, 118576, 118598, 1, 119143, 119145, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 119362, 119364, 1, 121344, 121398, 1, 121403, 121452, 1, 121461, 121476, 15, 121499, 121503, 1, 121505, 121519, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 123023, 123184, 161, 123185, 123190, 1, 123566, 123628, 62, 123629, 123631, 1, 124140, 124143, 1, 124398, 124399, 1, 125136, 125142, 1, 125252, 125258, 1, 917760, 917999, 1]));
      static foldMn = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static N = new a(new Uint32Array([48, 57, 1, 178, 179, 1, 185, 188, 3, 189, 190, 1, 1632, 1641, 1, 1776, 1785, 1, 1984, 1993, 1, 2406, 2415, 1, 2534, 2543, 1, 2548, 2553, 1, 2662, 2671, 1, 2790, 2799, 1, 2918, 2927, 1, 2930, 2935, 1, 3046, 3058, 1, 3174, 3183, 1, 3192, 3198, 1, 3302, 3311, 1, 3416, 3422, 1, 3430, 3448, 1, 3558, 3567, 1, 3664, 3673, 1, 3792, 3801, 1, 3872, 3891, 1, 4160, 4169, 1, 4240, 4249, 1, 4969, 4988, 1, 5870, 5872, 1, 6112, 6121, 1, 6128, 6137, 1, 6160, 6169, 1, 6470, 6479, 1, 6608, 6618, 1, 6784, 6793, 1, 6800, 6809, 1, 6992, 7001, 1, 7088, 7097, 1, 7232, 7241, 1, 7248, 7257, 1, 8304, 8308, 4, 8309, 8313, 1, 8320, 8329, 1, 8528, 8578, 1, 8581, 8585, 1, 9312, 9371, 1, 9450, 9471, 1, 10102, 10131, 1, 11517, 12295, 778, 12321, 12329, 1, 12344, 12346, 1, 12690, 12693, 1, 12832, 12841, 1, 12872, 12879, 1, 12881, 12895, 1, 12928, 12937, 1, 12977, 12991, 1, 42528, 42537, 1, 42726, 42735, 1, 43056, 43061, 1, 43216, 43225, 1, 43264, 43273, 1, 43472, 43481, 1, 43504, 43513, 1, 43600, 43609, 1, 44016, 44025, 1, 65296, 65305, 1, 65799, 65843, 1, 65856, 65912, 1, 65930, 65931, 1, 66273, 66299, 1, 66336, 66339, 1, 66369, 66378, 9, 66513, 66517, 1, 66720, 66729, 1, 67672, 67679, 1, 67705, 67711, 1, 67751, 67759, 1, 67835, 67839, 1, 67862, 67867, 1, 68028, 68029, 1, 68032, 68047, 1, 68050, 68095, 1, 68160, 68168, 1, 68221, 68222, 1, 68253, 68255, 1, 68331, 68335, 1, 68440, 68447, 1, 68472, 68479, 1, 68521, 68527, 1, 68858, 68863, 1, 68912, 68921, 1, 68928, 68937, 1, 69216, 69246, 1, 69405, 69414, 1, 69457, 69460, 1, 69573, 69579, 1, 69714, 69743, 1, 69872, 69881, 1, 69942, 69951, 1, 70096, 70105, 1, 70113, 70132, 1, 70384, 70393, 1, 70736, 70745, 1, 70864, 70873, 1, 71248, 71257, 1, 71360, 71369, 1, 71376, 71395, 1, 71472, 71483, 1, 71904, 71922, 1, 72016, 72025, 1, 72688, 72697, 1, 72784, 72812, 1, 73040, 73049, 1, 73120, 73129, 1, 73552, 73561, 1, 73664, 73684, 1, 74752, 74862, 1, 90416, 90425, 1, 92768, 92777, 1, 92864, 92873, 1, 93008, 93017, 1, 93019, 93025, 1, 93552, 93561, 1, 93824, 93846, 1, 118e3, 118009, 1, 119488, 119507, 1, 119520, 119539, 1, 119648, 119672, 1, 120782, 120831, 1, 123200, 123209, 1, 123632, 123641, 1, 124144, 124153, 1, 124401, 124410, 1, 125127, 125135, 1, 125264, 125273, 1, 126065, 126123, 1, 126125, 126127, 1, 126129, 126132, 1, 126209, 126253, 1, 126255, 126269, 1, 127232, 127244, 1, 130032, 130041, 1]));
      static Nd = new a(new Uint32Array([48, 57, 1, 1632, 1641, 1, 1776, 1785, 1, 1984, 1993, 1, 2406, 2415, 1, 2534, 2543, 1, 2662, 2671, 1, 2790, 2799, 1, 2918, 2927, 1, 3046, 3055, 1, 3174, 3183, 1, 3302, 3311, 1, 3430, 3439, 1, 3558, 3567, 1, 3664, 3673, 1, 3792, 3801, 1, 3872, 3881, 1, 4160, 4169, 1, 4240, 4249, 1, 6112, 6121, 1, 6160, 6169, 1, 6470, 6479, 1, 6608, 6617, 1, 6784, 6793, 1, 6800, 6809, 1, 6992, 7001, 1, 7088, 7097, 1, 7232, 7241, 1, 7248, 7257, 1, 42528, 42537, 1, 43216, 43225, 1, 43264, 43273, 1, 43472, 43481, 1, 43504, 43513, 1, 43600, 43609, 1, 44016, 44025, 1, 65296, 65305, 1, 66720, 66729, 1, 68912, 68921, 1, 68928, 68937, 1, 69734, 69743, 1, 69872, 69881, 1, 69942, 69951, 1, 70096, 70105, 1, 70384, 70393, 1, 70736, 70745, 1, 70864, 70873, 1, 71248, 71257, 1, 71360, 71369, 1, 71376, 71395, 1, 71472, 71481, 1, 71904, 71913, 1, 72016, 72025, 1, 72688, 72697, 1, 72784, 72793, 1, 73040, 73049, 1, 73120, 73129, 1, 73552, 73561, 1, 90416, 90425, 1, 92768, 92777, 1, 92864, 92873, 1, 93008, 93017, 1, 93552, 93561, 1, 118e3, 118009, 1, 120782, 120831, 1, 123200, 123209, 1, 123632, 123641, 1, 124144, 124153, 1, 124401, 124410, 1, 125264, 125273, 1, 130032, 130041, 1]));
      static Nl = new a(new Uint32Array([5870, 5872, 1, 8544, 8578, 1, 8581, 8584, 1, 12295, 12321, 26, 12322, 12329, 1, 12344, 12346, 1, 42726, 42735, 1, 65856, 65908, 1, 66369, 66378, 9, 66513, 66517, 1, 74752, 74862, 1]));
      static No = new a(new Uint32Array([178, 179, 1, 185, 188, 3, 189, 190, 1, 2548, 2553, 1, 2930, 2935, 1, 3056, 3058, 1, 3192, 3198, 1, 3416, 3422, 1, 3440, 3448, 1, 3882, 3891, 1, 4969, 4988, 1, 6128, 6137, 1, 6618, 8304, 1686, 8308, 8313, 1, 8320, 8329, 1, 8528, 8543, 1, 8585, 9312, 727, 9313, 9371, 1, 9450, 9471, 1, 10102, 10131, 1, 11517, 12690, 1173, 12691, 12693, 1, 12832, 12841, 1, 12872, 12879, 1, 12881, 12895, 1, 12928, 12937, 1, 12977, 12991, 1, 43056, 43061, 1, 65799, 65843, 1, 65909, 65912, 1, 65930, 65931, 1, 66273, 66299, 1, 66336, 66339, 1, 67672, 67679, 1, 67705, 67711, 1, 67751, 67759, 1, 67835, 67839, 1, 67862, 67867, 1, 68028, 68029, 1, 68032, 68047, 1, 68050, 68095, 1, 68160, 68168, 1, 68221, 68222, 1, 68253, 68255, 1, 68331, 68335, 1, 68440, 68447, 1, 68472, 68479, 1, 68521, 68527, 1, 68858, 68863, 1, 69216, 69246, 1, 69405, 69414, 1, 69457, 69460, 1, 69573, 69579, 1, 69714, 69733, 1, 70113, 70132, 1, 71482, 71483, 1, 71914, 71922, 1, 72794, 72812, 1, 73664, 73684, 1, 93019, 93025, 1, 93824, 93846, 1, 119488, 119507, 1, 119520, 119539, 1, 119648, 119672, 1, 125127, 125135, 1, 126065, 126123, 1, 126125, 126127, 1, 126129, 126132, 1, 126209, 126253, 1, 126255, 126269, 1, 127232, 127244, 1]));
      static P = new a(new Uint32Array([33, 35, 1, 37, 42, 1, 44, 47, 1, 58, 59, 1, 63, 64, 1, 91, 93, 1, 95, 123, 28, 125, 161, 36, 167, 171, 4, 182, 183, 1, 187, 191, 4, 894, 903, 9, 1370, 1375, 1, 1417, 1418, 1, 1470, 1472, 2, 1475, 1478, 3, 1523, 1524, 1, 1545, 1546, 1, 1548, 1549, 1, 1563, 1565, 2, 1566, 1567, 1, 1642, 1645, 1, 1748, 1792, 44, 1793, 1805, 1, 2039, 2041, 1, 2096, 2110, 1, 2142, 2404, 262, 2405, 2416, 11, 2557, 2678, 121, 2800, 3191, 391, 3204, 3572, 368, 3663, 3674, 11, 3675, 3844, 169, 3845, 3858, 1, 3860, 3898, 38, 3899, 3901, 1, 3973, 4048, 75, 4049, 4052, 1, 4057, 4058, 1, 4170, 4175, 1, 4347, 4960, 613, 4961, 4968, 1, 5120, 5742, 622, 5787, 5788, 1, 5867, 5869, 1, 5941, 5942, 1, 6100, 6102, 1, 6104, 6106, 1, 6144, 6154, 1, 6468, 6469, 1, 6686, 6687, 1, 6816, 6822, 1, 6824, 6829, 1, 6990, 6991, 1, 7002, 7008, 1, 7037, 7039, 1, 7164, 7167, 1, 7227, 7231, 1, 7294, 7295, 1, 7360, 7367, 1, 7379, 8208, 829, 8209, 8231, 1, 8240, 8259, 1, 8261, 8273, 1, 8275, 8286, 1, 8317, 8318, 1, 8333, 8334, 1, 8968, 8971, 1, 9001, 9002, 1, 10088, 10101, 1, 10181, 10182, 1, 10214, 10223, 1, 10627, 10648, 1, 10712, 10715, 1, 10748, 10749, 1, 11513, 11516, 1, 11518, 11519, 1, 11632, 11776, 144, 11777, 11822, 1, 11824, 11855, 1, 11858, 11869, 1, 12289, 12291, 1, 12296, 12305, 1, 12308, 12319, 1, 12336, 12349, 13, 12448, 12539, 91, 42238, 42239, 1, 42509, 42511, 1, 42611, 42622, 11, 42738, 42743, 1, 43124, 43127, 1, 43214, 43215, 1, 43256, 43258, 1, 43260, 43310, 50, 43311, 43359, 48, 43457, 43469, 1, 43486, 43487, 1, 43612, 43615, 1, 43742, 43743, 1, 43760, 43761, 1, 44011, 64830, 20819, 64831, 65040, 209, 65041, 65049, 1, 65072, 65106, 1, 65108, 65121, 1, 65123, 65128, 5, 65130, 65131, 1, 65281, 65283, 1, 65285, 65290, 1, 65292, 65295, 1, 65306, 65307, 1, 65311, 65312, 1, 65339, 65341, 1, 65343, 65371, 28, 65373, 65375, 2, 65376, 65381, 1, 65792, 65794, 1, 66463, 66512, 49, 66927, 67671, 744, 67871, 67903, 32, 68176, 68184, 1, 68223, 68336, 113, 68337, 68342, 1, 68409, 68415, 1, 68505, 68508, 1, 68974, 69293, 319, 69461, 69465, 1, 69510, 69513, 1, 69703, 69709, 1, 69819, 69820, 1, 69822, 69825, 1, 69952, 69955, 1, 70004, 70005, 1, 70085, 70088, 1, 70093, 70107, 14, 70109, 70111, 1, 70200, 70205, 1, 70313, 70612, 299, 70613, 70615, 2, 70616, 70731, 115, 70732, 70735, 1, 70746, 70747, 1, 70749, 70854, 105, 71105, 71127, 1, 71233, 71235, 1, 71264, 71276, 1, 71353, 71484, 131, 71485, 71486, 1, 71739, 72004, 265, 72005, 72006, 1, 72162, 72255, 93, 72256, 72262, 1, 72346, 72348, 1, 72350, 72354, 1, 72448, 72457, 1, 72673, 72769, 96, 72770, 72773, 1, 72816, 72817, 1, 73463, 73464, 1, 73539, 73551, 1, 73727, 74864, 1137, 74865, 74868, 1, 77809, 77810, 1, 92782, 92783, 1, 92917, 92983, 66, 92984, 92987, 1, 92996, 93549, 553, 93550, 93551, 1, 93847, 93850, 1, 94178, 113823, 19645, 121479, 121483, 1, 124415, 125278, 863, 125279, 125279, 1]));
      static Pc = new a(new Uint32Array([95, 8255, 8160, 8256, 8276, 20, 65075, 65076, 1, 65101, 65103, 1, 65343, 65343, 1]));
      static Pd = new a(new Uint32Array([45, 1418, 1373, 1470, 5120, 3650, 6150, 8208, 2058, 8209, 8213, 1, 11799, 11802, 3, 11834, 11835, 1, 11840, 11869, 29, 12316, 12336, 20, 12448, 65073, 52625, 65074, 65112, 38, 65123, 65293, 170, 68974, 69293, 319]));
      static Pe = new a(new Uint32Array([41, 93, 52, 125, 3899, 3774, 3901, 5788, 1887, 8262, 8318, 56, 8334, 8969, 635, 8971, 9002, 31, 10089, 10101, 2, 10182, 10215, 33, 10217, 10223, 2, 10628, 10648, 2, 10713, 10715, 2, 10749, 11811, 1062, 11813, 11817, 2, 11862, 11868, 2, 12297, 12305, 2, 12309, 12315, 2, 12318, 12319, 1, 64830, 65048, 218, 65078, 65092, 2, 65096, 65114, 18, 65116, 65118, 2, 65289, 65341, 52, 65373, 65379, 3]));
      static Pf = new a(new Uint32Array([187, 8217, 8030, 8221, 8250, 29, 11779, 11781, 2, 11786, 11789, 3, 11805, 11809, 4]));
      static Pi = new a(new Uint32Array([171, 8216, 8045, 8219, 8220, 1, 8223, 8249, 26, 11778, 11780, 2, 11785, 11788, 3, 11804, 11808, 4]));
      static Po = new a(new Uint32Array([33, 35, 1, 37, 39, 1, 42, 46, 2, 47, 58, 11, 59, 63, 4, 64, 92, 28, 161, 167, 6, 182, 183, 1, 191, 894, 703, 903, 1370, 467, 1371, 1375, 1, 1417, 1472, 55, 1475, 1478, 3, 1523, 1524, 1, 1545, 1546, 1, 1548, 1549, 1, 1563, 1565, 2, 1566, 1567, 1, 1642, 1645, 1, 1748, 1792, 44, 1793, 1805, 1, 2039, 2041, 1, 2096, 2110, 1, 2142, 2404, 262, 2405, 2416, 11, 2557, 2678, 121, 2800, 3191, 391, 3204, 3572, 368, 3663, 3674, 11, 3675, 3844, 169, 3845, 3858, 1, 3860, 3973, 113, 4048, 4052, 1, 4057, 4058, 1, 4170, 4175, 1, 4347, 4960, 613, 4961, 4968, 1, 5742, 5867, 125, 5868, 5869, 1, 5941, 5942, 1, 6100, 6102, 1, 6104, 6106, 1, 6144, 6149, 1, 6151, 6154, 1, 6468, 6469, 1, 6686, 6687, 1, 6816, 6822, 1, 6824, 6829, 1, 6990, 6991, 1, 7002, 7008, 1, 7037, 7039, 1, 7164, 7167, 1, 7227, 7231, 1, 7294, 7295, 1, 7360, 7367, 1, 7379, 8214, 835, 8215, 8224, 9, 8225, 8231, 1, 8240, 8248, 1, 8251, 8254, 1, 8257, 8259, 1, 8263, 8273, 1, 8275, 8277, 2, 8278, 8286, 1, 11513, 11516, 1, 11518, 11519, 1, 11632, 11776, 144, 11777, 11782, 5, 11783, 11784, 1, 11787, 11790, 3, 11791, 11798, 1, 11800, 11801, 1, 11803, 11806, 3, 11807, 11818, 11, 11819, 11822, 1, 11824, 11833, 1, 11836, 11839, 1, 11841, 11843, 2, 11844, 11855, 1, 11858, 11860, 1, 12289, 12291, 1, 12349, 12539, 190, 42238, 42239, 1, 42509, 42511, 1, 42611, 42622, 11, 42738, 42743, 1, 43124, 43127, 1, 43214, 43215, 1, 43256, 43258, 1, 43260, 43310, 50, 43311, 43359, 48, 43457, 43469, 1, 43486, 43487, 1, 43612, 43615, 1, 43742, 43743, 1, 43760, 43761, 1, 44011, 65040, 21029, 65041, 65046, 1, 65049, 65072, 23, 65093, 65094, 1, 65097, 65100, 1, 65104, 65106, 1, 65108, 65111, 1, 65119, 65121, 1, 65128, 65130, 2, 65131, 65281, 150, 65282, 65283, 1, 65285, 65287, 1, 65290, 65294, 2, 65295, 65306, 11, 65307, 65311, 4, 65312, 65340, 28, 65377, 65380, 3, 65381, 65792, 411, 65793, 65794, 1, 66463, 66512, 49, 66927, 67671, 744, 67871, 67903, 32, 68176, 68184, 1, 68223, 68336, 113, 68337, 68342, 1, 68409, 68415, 1, 68505, 68508, 1, 69461, 69465, 1, 69510, 69513, 1, 69703, 69709, 1, 69819, 69820, 1, 69822, 69825, 1, 69952, 69955, 1, 70004, 70005, 1, 70085, 70088, 1, 70093, 70107, 14, 70109, 70111, 1, 70200, 70205, 1, 70313, 70612, 299, 70613, 70615, 2, 70616, 70731, 115, 70732, 70735, 1, 70746, 70747, 1, 70749, 70854, 105, 71105, 71127, 1, 71233, 71235, 1, 71264, 71276, 1, 71353, 71484, 131, 71485, 71486, 1, 71739, 72004, 265, 72005, 72006, 1, 72162, 72255, 93, 72256, 72262, 1, 72346, 72348, 1, 72350, 72354, 1, 72448, 72457, 1, 72673, 72769, 96, 72770, 72773, 1, 72816, 72817, 1, 73463, 73464, 1, 73539, 73551, 1, 73727, 74864, 1137, 74865, 74868, 1, 77809, 77810, 1, 92782, 92783, 1, 92917, 92983, 66, 92984, 92987, 1, 92996, 93549, 553, 93550, 93551, 1, 93847, 93850, 1, 94178, 113823, 19645, 121479, 121483, 1, 124415, 125278, 863, 125279, 125279, 1]));
      static Ps = new a(new Uint32Array([40, 91, 51, 123, 3898, 3775, 3900, 5787, 1887, 8218, 8222, 4, 8261, 8317, 56, 8333, 8968, 635, 8970, 9001, 31, 10088, 10100, 2, 10181, 10214, 33, 10216, 10222, 2, 10627, 10647, 2, 10712, 10714, 2, 10748, 11810, 1062, 11812, 11816, 2, 11842, 11861, 19, 11863, 11867, 2, 12296, 12304, 2, 12308, 12314, 2, 12317, 64831, 52514, 65047, 65077, 30, 65079, 65091, 2, 65095, 65113, 18, 65115, 65117, 2, 65288, 65339, 51, 65371, 65375, 4, 65378, 65378, 1]));
      static S = new a(new Uint32Array([36, 43, 7, 60, 62, 1, 94, 96, 2, 124, 126, 2, 162, 166, 1, 168, 169, 1, 172, 174, 2, 175, 177, 1, 180, 184, 4, 215, 247, 32, 706, 709, 1, 722, 735, 1, 741, 747, 1, 749, 751, 2, 752, 767, 1, 885, 900, 15, 901, 1014, 113, 1154, 1421, 267, 1422, 1423, 1, 1542, 1544, 1, 1547, 1550, 3, 1551, 1758, 207, 1769, 1789, 20, 1790, 2038, 248, 2046, 2047, 1, 2184, 2546, 362, 2547, 2554, 7, 2555, 2801, 246, 2928, 3059, 131, 3060, 3066, 1, 3199, 3407, 208, 3449, 3647, 198, 3841, 3843, 1, 3859, 3861, 2, 3862, 3863, 1, 3866, 3871, 1, 3892, 3896, 2, 4030, 4037, 1, 4039, 4044, 1, 4046, 4047, 1, 4053, 4056, 1, 4254, 4255, 1, 5008, 5017, 1, 5741, 6107, 366, 6464, 6622, 158, 6623, 6655, 1, 7009, 7018, 1, 7028, 7036, 1, 8125, 8127, 2, 8128, 8129, 1, 8141, 8143, 1, 8157, 8159, 1, 8173, 8175, 1, 8189, 8190, 1, 8260, 8274, 14, 8314, 8316, 1, 8330, 8332, 1, 8352, 8384, 1, 8448, 8449, 1, 8451, 8454, 1, 8456, 8457, 1, 8468, 8470, 2, 8471, 8472, 1, 8478, 8483, 1, 8485, 8489, 2, 8494, 8506, 12, 8507, 8512, 5, 8513, 8516, 1, 8522, 8525, 1, 8527, 8586, 59, 8587, 8592, 5, 8593, 8967, 1, 8972, 9e3, 1, 9003, 9257, 1, 9280, 9290, 1, 9372, 9449, 1, 9472, 10087, 1, 10132, 10180, 1, 10183, 10213, 1, 10224, 10626, 1, 10649, 10711, 1, 10716, 10747, 1, 10750, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11493, 11498, 1, 11856, 11857, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12292, 12306, 14, 12307, 12320, 13, 12342, 12343, 1, 12350, 12351, 1, 12443, 12444, 1, 12688, 12689, 1, 12694, 12703, 1, 12736, 12773, 1, 12783, 12800, 17, 12801, 12830, 1, 12842, 12871, 1, 12880, 12896, 16, 12897, 12927, 1, 12938, 12976, 1, 12992, 13311, 1, 19904, 19967, 1, 42128, 42182, 1, 42752, 42774, 1, 42784, 42785, 1, 42889, 42890, 1, 43048, 43051, 1, 43062, 43065, 1, 43639, 43641, 1, 43867, 43882, 15, 43883, 64297, 20414, 64434, 64450, 1, 64832, 64847, 1, 64975, 65020, 45, 65021, 65023, 1, 65122, 65124, 2, 65125, 65126, 1, 65129, 65284, 155, 65291, 65308, 17, 65309, 65310, 1, 65342, 65344, 2, 65372, 65374, 2, 65504, 65510, 1, 65512, 65518, 1, 65532, 65533, 1, 65847, 65855, 1, 65913, 65929, 1, 65932, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66044, 1, 67703, 67704, 1, 68296, 69006, 710, 69007, 71487, 2480, 73685, 73713, 1, 92988, 92991, 1, 92997, 113820, 20823, 117760, 117999, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119140, 1, 119146, 119148, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119296, 119361, 1, 119365, 119552, 187, 119553, 119638, 1, 120513, 120539, 26, 120571, 120597, 26, 120629, 120655, 26, 120687, 120713, 26, 120745, 120771, 26, 120832, 121343, 1, 121399, 121402, 1, 121453, 121460, 1, 121462, 121475, 1, 121477, 121478, 1, 123215, 123647, 432, 126124, 126128, 4, 126254, 126704, 450, 126705, 126976, 271, 126977, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127245, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130031, 1]));
      static Sc = new a(new Uint32Array([36, 162, 126, 163, 165, 1, 1423, 1547, 124, 2046, 2047, 1, 2546, 2547, 1, 2555, 2801, 246, 3065, 3647, 582, 6107, 8352, 2245, 8353, 8384, 1, 43064, 65020, 21956, 65129, 65284, 155, 65504, 65505, 1, 65509, 65510, 1, 73693, 73696, 1, 123647, 126128, 2481]));
      static Sk = new a(new Uint32Array([94, 96, 2, 168, 175, 7, 180, 184, 4, 706, 709, 1, 722, 735, 1, 741, 747, 1, 749, 751, 2, 752, 767, 1, 885, 900, 15, 901, 2184, 1283, 8125, 8127, 2, 8128, 8129, 1, 8141, 8143, 1, 8157, 8159, 1, 8173, 8175, 1, 8189, 8190, 1, 12443, 12444, 1, 42752, 42774, 1, 42784, 42785, 1, 42889, 42890, 1, 43867, 43882, 15, 43883, 64434, 20551, 64435, 64450, 1, 65342, 65344, 2, 65507, 127995, 62488, 127996, 127999, 1]));
      static Sm = new a(new Uint32Array([43, 60, 17, 61, 62, 1, 124, 126, 2, 172, 177, 5, 215, 247, 32, 1014, 1542, 528, 1543, 1544, 1, 8260, 8274, 14, 8314, 8316, 1, 8330, 8332, 1, 8472, 8512, 40, 8513, 8516, 1, 8523, 8592, 69, 8593, 8596, 1, 8602, 8603, 1, 8608, 8614, 3, 8622, 8654, 32, 8655, 8658, 3, 8660, 8692, 32, 8693, 8959, 1, 8992, 8993, 1, 9084, 9115, 31, 9116, 9139, 1, 9180, 9185, 1, 9655, 9665, 10, 9720, 9727, 1, 9839, 10176, 337, 10177, 10180, 1, 10183, 10213, 1, 10224, 10239, 1, 10496, 10626, 1, 10649, 10711, 1, 10716, 10747, 1, 10750, 11007, 1, 11056, 11076, 1, 11079, 11084, 1, 64297, 65122, 825, 65124, 65126, 1, 65291, 65308, 17, 65309, 65310, 1, 65372, 65374, 2, 65506, 65513, 7, 65514, 65516, 1, 69006, 69007, 1, 120513, 120539, 26, 120571, 120597, 26, 120629, 120655, 26, 120687, 120713, 26, 120745, 120771, 26, 126704, 126705, 1]));
      static So = new a(new Uint32Array([166, 169, 3, 174, 176, 2, 1154, 1421, 267, 1422, 1550, 128, 1551, 1758, 207, 1769, 1789, 20, 1790, 2038, 248, 2554, 2928, 374, 3059, 3064, 1, 3066, 3199, 133, 3407, 3449, 42, 3841, 3843, 1, 3859, 3861, 2, 3862, 3863, 1, 3866, 3871, 1, 3892, 3896, 2, 4030, 4037, 1, 4039, 4044, 1, 4046, 4047, 1, 4053, 4056, 1, 4254, 4255, 1, 5008, 5017, 1, 5741, 6464, 723, 6622, 6655, 1, 7009, 7018, 1, 7028, 7036, 1, 8448, 8449, 1, 8451, 8454, 1, 8456, 8457, 1, 8468, 8470, 2, 8471, 8478, 7, 8479, 8483, 1, 8485, 8489, 2, 8494, 8506, 12, 8507, 8522, 15, 8524, 8525, 1, 8527, 8586, 59, 8587, 8597, 10, 8598, 8601, 1, 8604, 8607, 1, 8609, 8610, 1, 8612, 8613, 1, 8615, 8621, 1, 8623, 8653, 1, 8656, 8657, 1, 8659, 8661, 2, 8662, 8691, 1, 8960, 8967, 1, 8972, 8991, 1, 8994, 9e3, 1, 9003, 9083, 1, 9085, 9114, 1, 9140, 9179, 1, 9186, 9257, 1, 9280, 9290, 1, 9372, 9449, 1, 9472, 9654, 1, 9656, 9664, 1, 9666, 9719, 1, 9728, 9838, 1, 9840, 10087, 1, 10132, 10175, 1, 10240, 10495, 1, 11008, 11055, 1, 11077, 11078, 1, 11085, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11493, 11498, 1, 11856, 11857, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12292, 12306, 14, 12307, 12320, 13, 12342, 12343, 1, 12350, 12351, 1, 12688, 12689, 1, 12694, 12703, 1, 12736, 12773, 1, 12783, 12800, 17, 12801, 12830, 1, 12842, 12871, 1, 12880, 12896, 16, 12897, 12927, 1, 12938, 12976, 1, 12992, 13311, 1, 19904, 19967, 1, 42128, 42182, 1, 43048, 43051, 1, 43062, 43063, 1, 43065, 43639, 574, 43640, 43641, 1, 64832, 64847, 1, 64975, 65021, 46, 65022, 65023, 1, 65508, 65512, 4, 65517, 65518, 1, 65532, 65533, 1, 65847, 65855, 1, 65913, 65929, 1, 65932, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66044, 1, 67703, 67704, 1, 68296, 71487, 3191, 73685, 73692, 1, 73697, 73713, 1, 92988, 92991, 1, 92997, 113820, 20823, 117760, 117999, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119140, 1, 119146, 119148, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119296, 119361, 1, 119365, 119552, 187, 119553, 119638, 1, 120832, 121343, 1, 121399, 121402, 1, 121453, 121460, 1, 121462, 121475, 1, 121477, 121478, 1, 123215, 126124, 2909, 126254, 126976, 722, 126977, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127245, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 127994, 1, 128e3, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130031, 1]));
      static Z = new a(new Uint32Array([32, 160, 128, 5760, 8192, 2432, 8193, 8202, 1, 8232, 8233, 1, 8239, 8287, 48, 12288, 12288, 1]));
      static Zl = new a(new Uint32Array([8232, 8232, 1]));
      static Zp = new a(new Uint32Array([8233, 8233, 1]));
      static Zs = new a(new Uint32Array([32, 160, 128, 5760, 8192, 2432, 8193, 8202, 1, 8239, 8287, 48, 12288, 12288, 1]));
      static Adlam = new a(new Uint32Array([125184, 125259, 1, 125264, 125273, 1, 125278, 125279, 1]));
      static Ahom = new a(new Uint32Array([71424, 71450, 1, 71453, 71467, 1, 71472, 71494, 1]));
      static Anatolian_Hieroglyphs = new a(new Uint32Array([82944, 83526, 1]));
      static Arabic = new a(new Uint32Array([1536, 1540, 1, 1542, 1547, 1, 1549, 1562, 1, 1564, 1566, 1, 1568, 1599, 1, 1601, 1610, 1, 1622, 1647, 1, 1649, 1756, 1, 1758, 1791, 1, 1872, 1919, 1, 2160, 2190, 1, 2192, 2193, 1, 2199, 2273, 1, 2275, 2303, 1, 64336, 64450, 1, 64467, 64829, 1, 64832, 64911, 1, 64914, 64967, 1, 64975, 65008, 33, 65009, 65023, 1, 65136, 65140, 1, 65142, 65276, 1, 69216, 69246, 1, 69314, 69316, 1, 69372, 69375, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 126704, 126705, 1]));
      static Armenian = new a(new Uint32Array([1329, 1366, 1, 1369, 1418, 1, 1421, 1423, 1, 64275, 64279, 1]));
      static Avestan = new a(new Uint32Array([68352, 68405, 1, 68409, 68415, 1]));
      static Balinese = new a(new Uint32Array([6912, 6988, 1, 6990, 7039, 1]));
      static Bamum = new a(new Uint32Array([42656, 42743, 1, 92160, 92728, 1]));
      static Bassa_Vah = new a(new Uint32Array([92880, 92909, 1, 92912, 92917, 1]));
      static Batak = new a(new Uint32Array([7104, 7155, 1, 7164, 7167, 1]));
      static Bengali = new a(new Uint32Array([2432, 2435, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2492, 2500, 1, 2503, 2504, 1, 2507, 2510, 1, 2519, 2524, 5, 2525, 2527, 2, 2528, 2531, 1, 2534, 2558, 1]));
      static Bhaiksuki = new a(new Uint32Array([72704, 72712, 1, 72714, 72758, 1, 72760, 72773, 1, 72784, 72812, 1]));
      static Bopomofo = new a(new Uint32Array([746, 747, 1, 12549, 12591, 1, 12704, 12735, 1]));
      static Brahmi = new a(new Uint32Array([69632, 69709, 1, 69714, 69749, 1, 69759, 69759, 1]));
      static Braille = new a(new Uint32Array([10240, 10495, 1]));
      static Buginese = new a(new Uint32Array([6656, 6683, 1, 6686, 6687, 1]));
      static Buhid = new a(new Uint32Array([5952, 5971, 1]));
      static Canadian_Aboriginal = new a(new Uint32Array([5120, 5759, 1, 6320, 6389, 1, 72368, 72383, 1]));
      static Carian = new a(new Uint32Array([66208, 66256, 1]));
      static Caucasian_Albanian = new a(new Uint32Array([66864, 66915, 1, 66927, 66927, 1]));
      static Chakma = new a(new Uint32Array([69888, 69940, 1, 69942, 69959, 1]));
      static Cham = new a(new Uint32Array([43520, 43574, 1, 43584, 43597, 1, 43600, 43609, 1, 43612, 43615, 1]));
      static Cherokee = new a(new Uint32Array([5024, 5109, 1, 5112, 5117, 1, 43888, 43967, 1]));
      static Chorasmian = new a(new Uint32Array([69552, 69579, 1]));
      static Common = new a(new Uint32Array([0, 64, 1, 91, 96, 1, 123, 169, 1, 171, 185, 1, 187, 191, 1, 215, 247, 32, 697, 735, 1, 741, 745, 1, 748, 767, 1, 884, 894, 10, 901, 903, 2, 1541, 1548, 7, 1563, 1567, 4, 1600, 1757, 157, 2274, 2404, 130, 2405, 3647, 1242, 4053, 4056, 1, 4347, 5867, 1520, 5868, 5869, 1, 5941, 5942, 1, 6146, 6147, 1, 6149, 7379, 1230, 7393, 7401, 8, 7402, 7404, 1, 7406, 7411, 1, 7413, 7415, 1, 7418, 8192, 774, 8193, 8203, 1, 8206, 8292, 1, 8294, 8304, 1, 8308, 8318, 1, 8320, 8334, 1, 8352, 8384, 1, 8448, 8485, 1, 8487, 8489, 1, 8492, 8497, 1, 8499, 8525, 1, 8527, 8543, 1, 8585, 8587, 1, 8592, 9257, 1, 9280, 9290, 1, 9312, 10239, 1, 10496, 11123, 1, 11126, 11157, 1, 11159, 11263, 1, 11776, 11869, 1, 12272, 12292, 1, 12294, 12296, 2, 12297, 12320, 1, 12336, 12343, 1, 12348, 12351, 1, 12443, 12444, 1, 12448, 12539, 91, 12540, 12688, 148, 12689, 12703, 1, 12736, 12773, 1, 12783, 12832, 49, 12833, 12895, 1, 12927, 13007, 1, 13055, 13144, 89, 13145, 13311, 1, 19904, 19967, 1, 42752, 42785, 1, 42888, 42890, 1, 43056, 43065, 1, 43310, 43471, 161, 43867, 43882, 15, 43883, 64830, 20947, 64831, 65040, 209, 65041, 65049, 1, 65072, 65106, 1, 65108, 65126, 1, 65128, 65131, 1, 65279, 65281, 2, 65282, 65312, 1, 65339, 65344, 1, 65371, 65381, 1, 65392, 65438, 46, 65439, 65504, 65, 65505, 65510, 1, 65512, 65518, 1, 65529, 65533, 1, 65792, 65794, 1, 65799, 65843, 1, 65847, 65855, 1, 65936, 65948, 1, 66e3, 66044, 1, 66273, 66299, 1, 113824, 113827, 1, 117760, 118009, 1, 118016, 118451, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119142, 1, 119146, 119162, 1, 119171, 119172, 1, 119180, 119209, 1, 119214, 119274, 1, 119488, 119507, 1, 119520, 119539, 1, 119552, 119638, 1, 119648, 119672, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120779, 1, 120782, 120831, 1, 126065, 126132, 1, 126209, 126269, 1, 126976, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127232, 127405, 1, 127462, 127487, 1, 127489, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130041, 1, 917505, 917536, 31, 917537, 917631, 1]));
      static foldCommon = new a(new Uint32Array([924, 956, 32]));
      static Coptic = new a(new Uint32Array([994, 1007, 1, 11392, 11507, 1, 11513, 11519, 1]));
      static Cuneiform = new a(new Uint32Array([73728, 74649, 1, 74752, 74862, 1, 74864, 74868, 1, 74880, 75075, 1]));
      static Cypriot = new a(new Uint32Array([67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3]));
      static Cypro_Minoan = new a(new Uint32Array([77712, 77810, 1]));
      static Cyrillic = new a(new Uint32Array([1024, 1156, 1, 1159, 1327, 1, 7296, 7306, 1, 7467, 7544, 77, 11744, 11775, 1, 42560, 42655, 1, 65070, 65071, 1, 122928, 122989, 1, 123023, 123023, 1]));
      static Deseret = new a(new Uint32Array([66560, 66639, 1]));
      static Devanagari = new a(new Uint32Array([2304, 2384, 1, 2389, 2403, 1, 2406, 2431, 1, 43232, 43263, 1, 72448, 72457, 1]));
      static Dives_Akuru = new a(new Uint32Array([71936, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71989, 1, 71991, 71992, 1, 71995, 72006, 1, 72016, 72025, 1]));
      static Dogra = new a(new Uint32Array([71680, 71739, 1]));
      static Duployan = new a(new Uint32Array([113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 113820, 113823, 1]));
      static Egyptian_Hieroglyphs = new a(new Uint32Array([77824, 78933, 1, 78944, 82938, 1]));
      static Elbasan = new a(new Uint32Array([66816, 66855, 1]));
      static Elymaic = new a(new Uint32Array([69600, 69622, 1]));
      static Ethiopic = new a(new Uint32Array([4608, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4957, 4988, 1, 4992, 5017, 1, 11648, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 124896, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1]));
      static Garay = new a(new Uint32Array([68928, 68965, 1, 68969, 68997, 1, 69006, 69007, 1]));
      static Georgian = new a(new Uint32Array([4256, 4293, 1, 4295, 4301, 6, 4304, 4346, 1, 4348, 4351, 1, 7312, 7354, 1, 7357, 7359, 1, 11520, 11557, 1, 11559, 11565, 6]));
      static Glagolitic = new a(new Uint32Array([11264, 11359, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1]));
      static Gothic = new a(new Uint32Array([66352, 66378, 1]));
      static Grantha = new a(new Uint32Array([70400, 70403, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70460, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70480, 70487, 7, 70493, 70499, 1, 70502, 70508, 1, 70512, 70516, 1]));
      static Greek = new a(new Uint32Array([880, 883, 1, 885, 887, 1, 890, 893, 1, 895, 900, 5, 902, 904, 2, 905, 906, 1, 908, 910, 2, 911, 929, 1, 931, 993, 1, 1008, 1023, 1, 7462, 7466, 1, 7517, 7521, 1, 7526, 7530, 1, 7615, 7936, 321, 7937, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8132, 1, 8134, 8147, 1, 8150, 8155, 1, 8157, 8175, 1, 8178, 8180, 1, 8182, 8190, 1, 8486, 43877, 35391, 65856, 65934, 1, 65952, 119296, 53344, 119297, 119365, 1]));
      static foldGreek = new a(new Uint32Array([181, 837, 656]));
      static Gujarati = new a(new Uint32Array([2689, 2691, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2748, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2768, 2784, 16, 2785, 2787, 1, 2790, 2801, 1, 2809, 2815, 1]));
      static Gunjala_Gondi = new a(new Uint32Array([73056, 73061, 1, 73063, 73064, 1, 73066, 73102, 1, 73104, 73105, 1, 73107, 73112, 1, 73120, 73129, 1]));
      static Gurmukhi = new a(new Uint32Array([2561, 2563, 1, 2565, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2649, 8, 2650, 2652, 1, 2654, 2662, 8, 2663, 2678, 1]));
      static Gurung_Khema = new a(new Uint32Array([90368, 90425, 1]));
      static Han = new a(new Uint32Array([11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12293, 12295, 2, 12321, 12329, 1, 12344, 12347, 1, 13312, 19903, 1, 19968, 40959, 1, 63744, 64109, 1, 64112, 64217, 1, 94178, 94179, 1, 94192, 94193, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1]));
      static Hangul = new a(new Uint32Array([4352, 4607, 1, 12334, 12335, 1, 12593, 12686, 1, 12800, 12830, 1, 12896, 12926, 1, 43360, 43388, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 65440, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1]));
      static Hanifi_Rohingya = new a(new Uint32Array([68864, 68903, 1, 68912, 68921, 1]));
      static Hanunoo = new a(new Uint32Array([5920, 5940, 1]));
      static Hatran = new a(new Uint32Array([67808, 67826, 1, 67828, 67829, 1, 67835, 67839, 1]));
      static Hebrew = new a(new Uint32Array([1425, 1479, 1, 1488, 1514, 1, 1519, 1524, 1, 64285, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64335, 1]));
      static Hiragana = new a(new Uint32Array([12353, 12438, 1, 12445, 12447, 1, 110593, 110879, 1, 110898, 110928, 30, 110929, 110930, 1, 127488, 127488, 1]));
      static Imperial_Aramaic = new a(new Uint32Array([67648, 67669, 1, 67671, 67679, 1]));
      static Inherited = new a(new Uint32Array([768, 879, 1, 1157, 1158, 1, 1611, 1621, 1, 1648, 2385, 737, 2386, 2388, 1, 6832, 6862, 1, 7376, 7378, 1, 7380, 7392, 1, 7394, 7400, 1, 7405, 7412, 7, 7416, 7417, 1, 7616, 7679, 1, 8204, 8205, 1, 8400, 8432, 1, 12330, 12333, 1, 12441, 12442, 1, 65024, 65039, 1, 65056, 65069, 1, 66045, 66272, 227, 70459, 118528, 48069, 118529, 118573, 1, 118576, 118598, 1, 119143, 119145, 1, 119163, 119170, 1, 119173, 119179, 1, 119210, 119213, 1, 917760, 917999, 1]));
      static foldInherited = new a(new Uint32Array([921, 953, 32, 8126, 8126, 1]));
      static Inscriptional_Pahlavi = new a(new Uint32Array([68448, 68466, 1, 68472, 68479, 1]));
      static Inscriptional_Parthian = new a(new Uint32Array([68416, 68437, 1, 68440, 68447, 1]));
      static Javanese = new a(new Uint32Array([43392, 43469, 1, 43472, 43481, 1, 43486, 43487, 1]));
      static Kaithi = new a(new Uint32Array([69760, 69826, 1, 69837, 69837, 1]));
      static Kannada = new a(new Uint32Array([3200, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3260, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3293, 3294, 1, 3296, 3299, 1, 3302, 3311, 1, 3313, 3315, 1]));
      static Katakana = new a(new Uint32Array([12449, 12538, 1, 12541, 12543, 1, 12784, 12799, 1, 13008, 13054, 1, 13056, 13143, 1, 65382, 65391, 1, 65393, 65437, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110880, 288, 110881, 110882, 1, 110933, 110948, 15, 110949, 110951, 1]));
      static Kawi = new a(new Uint32Array([73472, 73488, 1, 73490, 73530, 1, 73534, 73562, 1]));
      static Kayah_Li = new a(new Uint32Array([43264, 43309, 1, 43311, 43311, 1]));
      static Kharoshthi = new a(new Uint32Array([68096, 68099, 1, 68101, 68102, 1, 68108, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68152, 68154, 1, 68159, 68168, 1, 68176, 68184, 1]));
      static Khitan_Small_Script = new a(new Uint32Array([94180, 101120, 6940, 101121, 101589, 1, 101631, 101631, 1]));
      static Khmer = new a(new Uint32Array([6016, 6109, 1, 6112, 6121, 1, 6128, 6137, 1, 6624, 6655, 1]));
      static Khojki = new a(new Uint32Array([70144, 70161, 1, 70163, 70209, 1]));
      static Khudawadi = new a(new Uint32Array([70320, 70378, 1, 70384, 70393, 1]));
      static Kirat_Rai = new a(new Uint32Array([93504, 93561, 1]));
      static Lao = new a(new Uint32Array([3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3773, 1, 3776, 3780, 1, 3782, 3784, 2, 3785, 3790, 1, 3792, 3801, 1, 3804, 3807, 1]));
      static Latin = new a(new Uint32Array([65, 90, 1, 97, 122, 1, 170, 186, 16, 192, 214, 1, 216, 246, 1, 248, 696, 1, 736, 740, 1, 7424, 7461, 1, 7468, 7516, 1, 7522, 7525, 1, 7531, 7543, 1, 7545, 7614, 1, 7680, 7935, 1, 8305, 8319, 14, 8336, 8348, 1, 8490, 8491, 1, 8498, 8526, 28, 8544, 8584, 1, 11360, 11391, 1, 42786, 42887, 1, 42891, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43007, 1, 43824, 43866, 1, 43868, 43876, 1, 43878, 43881, 1, 64256, 64262, 1, 65313, 65338, 1, 65345, 65370, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 122624, 122654, 1, 122661, 122666, 1]));
      static Lepcha = new a(new Uint32Array([7168, 7223, 1, 7227, 7241, 1, 7245, 7247, 1]));
      static Limbu = new a(new Uint32Array([6400, 6430, 1, 6432, 6443, 1, 6448, 6459, 1, 6464, 6468, 4, 6469, 6479, 1]));
      static Linear_A = new a(new Uint32Array([67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1]));
      static Linear_B = new a(new Uint32Array([65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1]));
      static Lisu = new a(new Uint32Array([42192, 42239, 1, 73648, 73648, 1]));
      static Lycian = new a(new Uint32Array([66176, 66204, 1]));
      static Lydian = new a(new Uint32Array([67872, 67897, 1, 67903, 67903, 1]));
      static Mahajani = new a(new Uint32Array([69968, 70006, 1]));
      static Makasar = new a(new Uint32Array([73440, 73464, 1]));
      static Malayalam = new a(new Uint32Array([3328, 3340, 1, 3342, 3344, 1, 3346, 3396, 1, 3398, 3400, 1, 3402, 3407, 1, 3412, 3427, 1, 3430, 3455, 1]));
      static Mandaic = new a(new Uint32Array([2112, 2139, 1, 2142, 2142, 1]));
      static Manichaean = new a(new Uint32Array([68288, 68326, 1, 68331, 68342, 1]));
      static Marchen = new a(new Uint32Array([72816, 72847, 1, 72850, 72871, 1, 72873, 72886, 1]));
      static Masaram_Gondi = new a(new Uint32Array([72960, 72966, 1, 72968, 72969, 1, 72971, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73031, 1, 73040, 73049, 1]));
      static Medefaidrin = new a(new Uint32Array([93760, 93850, 1]));
      static Meetei_Mayek = new a(new Uint32Array([43744, 43766, 1, 43968, 44013, 1, 44016, 44025, 1]));
      static Mende_Kikakui = new a(new Uint32Array([124928, 125124, 1, 125127, 125142, 1]));
      static Meroitic_Cursive = new a(new Uint32Array([68e3, 68023, 1, 68028, 68047, 1, 68050, 68095, 1]));
      static Meroitic_Hieroglyphs = new a(new Uint32Array([67968, 67999, 1]));
      static Miao = new a(new Uint32Array([93952, 94026, 1, 94031, 94087, 1, 94095, 94111, 1]));
      static Modi = new a(new Uint32Array([71168, 71236, 1, 71248, 71257, 1]));
      static Mongolian = new a(new Uint32Array([6144, 6145, 1, 6148, 6150, 2, 6151, 6169, 1, 6176, 6264, 1, 6272, 6314, 1, 71264, 71276, 1]));
      static Mro = new a(new Uint32Array([92736, 92766, 1, 92768, 92777, 1, 92782, 92783, 1]));
      static Multani = new a(new Uint32Array([70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70313, 1]));
      static Myanmar = new a(new Uint32Array([4096, 4255, 1, 43488, 43518, 1, 43616, 43647, 1, 71376, 71395, 1]));
      static Nabataean = new a(new Uint32Array([67712, 67742, 1, 67751, 67759, 1]));
      static Nag_Mundari = new a(new Uint32Array([124112, 124153, 1]));
      static Nandinagari = new a(new Uint32Array([72096, 72103, 1, 72106, 72151, 1, 72154, 72164, 1]));
      static New_Tai_Lue = new a(new Uint32Array([6528, 6571, 1, 6576, 6601, 1, 6608, 6618, 1, 6622, 6623, 1]));
      static Newa = new a(new Uint32Array([70656, 70747, 1, 70749, 70753, 1]));
      static Nko = new a(new Uint32Array([1984, 2042, 1, 2045, 2047, 1]));
      static Nushu = new a(new Uint32Array([94177, 110960, 16783, 110961, 111355, 1]));
      static Nyiakeng_Puachue_Hmong = new a(new Uint32Array([123136, 123180, 1, 123184, 123197, 1, 123200, 123209, 1, 123214, 123215, 1]));
      static Ogham = new a(new Uint32Array([5760, 5788, 1]));
      static Ol_Chiki = new a(new Uint32Array([7248, 7295, 1]));
      static Ol_Onal = new a(new Uint32Array([124368, 124410, 1, 124415, 124415, 1]));
      static Old_Hungarian = new a(new Uint32Array([68736, 68786, 1, 68800, 68850, 1, 68858, 68863, 1]));
      static Old_Italic = new a(new Uint32Array([66304, 66339, 1, 66349, 66351, 1]));
      static Old_North_Arabian = new a(new Uint32Array([68224, 68255, 1]));
      static Old_Permic = new a(new Uint32Array([66384, 66426, 1]));
      static Old_Persian = new a(new Uint32Array([66464, 66499, 1, 66504, 66517, 1]));
      static Old_Sogdian = new a(new Uint32Array([69376, 69415, 1]));
      static Old_South_Arabian = new a(new Uint32Array([68192, 68223, 1]));
      static Old_Turkic = new a(new Uint32Array([68608, 68680, 1]));
      static Old_Uyghur = new a(new Uint32Array([69488, 69513, 1]));
      static Oriya = new a(new Uint32Array([2817, 2819, 1, 2821, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2876, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2908, 2909, 1, 2911, 2915, 1, 2918, 2935, 1]));
      static Osage = new a(new Uint32Array([66736, 66771, 1, 66776, 66811, 1]));
      static Osmanya = new a(new Uint32Array([66688, 66717, 1, 66720, 66729, 1]));
      static Pahawh_Hmong = new a(new Uint32Array([92928, 92997, 1, 93008, 93017, 1, 93019, 93025, 1, 93027, 93047, 1, 93053, 93071, 1]));
      static Palmyrene = new a(new Uint32Array([67680, 67711, 1]));
      static Pau_Cin_Hau = new a(new Uint32Array([72384, 72440, 1]));
      static Phags_Pa = new a(new Uint32Array([43072, 43127, 1]));
      static Phoenician = new a(new Uint32Array([67840, 67867, 1, 67871, 67871, 1]));
      static Psalter_Pahlavi = new a(new Uint32Array([68480, 68497, 1, 68505, 68508, 1, 68521, 68527, 1]));
      static Rejang = new a(new Uint32Array([43312, 43347, 1, 43359, 43359, 1]));
      static Runic = new a(new Uint32Array([5792, 5866, 1, 5870, 5880, 1]));
      static Samaritan = new a(new Uint32Array([2048, 2093, 1, 2096, 2110, 1]));
      static Saurashtra = new a(new Uint32Array([43136, 43205, 1, 43214, 43225, 1]));
      static Sharada = new a(new Uint32Array([70016, 70111, 1]));
      static Shavian = new a(new Uint32Array([66640, 66687, 1]));
      static Siddham = new a(new Uint32Array([71040, 71093, 1, 71096, 71133, 1]));
      static SignWriting = new a(new Uint32Array([120832, 121483, 1, 121499, 121503, 1, 121505, 121519, 1]));
      static Sinhala = new a(new Uint32Array([3457, 3459, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3558, 3567, 1, 3570, 3572, 1, 70113, 70132, 1]));
      static Sogdian = new a(new Uint32Array([69424, 69465, 1]));
      static Sora_Sompeng = new a(new Uint32Array([69840, 69864, 1, 69872, 69881, 1]));
      static Soyombo = new a(new Uint32Array([72272, 72354, 1]));
      static Sundanese = new a(new Uint32Array([7040, 7103, 1, 7360, 7367, 1]));
      static Sunuwar = new a(new Uint32Array([72640, 72673, 1, 72688, 72697, 1]));
      static Syloti_Nagri = new a(new Uint32Array([43008, 43052, 1]));
      static Syriac = new a(new Uint32Array([1792, 1805, 1, 1807, 1866, 1, 1869, 1871, 1, 2144, 2154, 1]));
      static Tagalog = new a(new Uint32Array([5888, 5909, 1, 5919, 5919, 1]));
      static Tagbanwa = new a(new Uint32Array([5984, 5996, 1, 5998, 6e3, 1, 6002, 6003, 1]));
      static Tai_Le = new a(new Uint32Array([6480, 6509, 1, 6512, 6516, 1]));
      static Tai_Tham = new a(new Uint32Array([6688, 6750, 1, 6752, 6780, 1, 6783, 6793, 1, 6800, 6809, 1, 6816, 6829, 1]));
      static Tai_Viet = new a(new Uint32Array([43648, 43714, 1, 43739, 43743, 1]));
      static Takri = new a(new Uint32Array([71296, 71353, 1, 71360, 71369, 1]));
      static Tamil = new a(new Uint32Array([2946, 2947, 1, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3006, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3024, 3031, 7, 3046, 3066, 1, 73664, 73713, 1, 73727, 73727, 1]));
      static Tangsa = new a(new Uint32Array([92784, 92862, 1, 92864, 92873, 1]));
      static Tangut = new a(new Uint32Array([94176, 94208, 32, 94209, 100343, 1, 100352, 101119, 1, 101632, 101640, 1]));
      static Telugu = new a(new Uint32Array([3072, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3132, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3160, 3162, 1, 3165, 3168, 3, 3169, 3171, 1, 3174, 3183, 1, 3191, 3199, 1]));
      static Thaana = new a(new Uint32Array([1920, 1969, 1]));
      static Thai = new a(new Uint32Array([3585, 3642, 1, 3648, 3675, 1]));
      static Tibetan = new a(new Uint32Array([3840, 3911, 1, 3913, 3948, 1, 3953, 3991, 1, 3993, 4028, 1, 4030, 4044, 1, 4046, 4052, 1, 4057, 4058, 1]));
      static Tifinagh = new a(new Uint32Array([11568, 11623, 1, 11631, 11632, 1, 11647, 11647, 1]));
      static Tirhuta = new a(new Uint32Array([70784, 70855, 1, 70864, 70873, 1]));
      static Todhri = new a(new Uint32Array([67008, 67059, 1]));
      static Toto = new a(new Uint32Array([123536, 123566, 1]));
      static Tulu_Tigalari = new a(new Uint32Array([70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70613, 1, 70615, 70616, 1, 70625, 70626, 1]));
      static Ugaritic = new a(new Uint32Array([66432, 66461, 1, 66463, 66463, 1]));
      static Vai = new a(new Uint32Array([42240, 42539, 1]));
      static Vithkuqi = new a(new Uint32Array([66928, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1]));
      static Wancho = new a(new Uint32Array([123584, 123641, 1, 123647, 123647, 1]));
      static Warang_Citi = new a(new Uint32Array([71840, 71922, 1, 71935, 71935, 1]));
      static Yezidi = new a(new Uint32Array([69248, 69289, 1, 69291, 69293, 1, 69296, 69297, 1]));
      static Yi = new a(new Uint32Array([40960, 42124, 1, 42128, 42182, 1]));
      static Zanabazar_Square = new a(new Uint32Array([72192, 72263, 1]));
      static CATEGORIES = /* @__PURE__ */ new Map([["C", n2.C], ["Cc", n2.Cc], ["Cf", n2.Cf], ["Co", n2.Co], ["Cs", n2.Cs], ["L", n2.L], ["Ll", n2.Ll], ["Lm", n2.Lm], ["Lo", n2.Lo], ["Lt", n2.Lt], ["Lu", n2.Lu], ["M", n2.M], ["Mc", n2.Mc], ["Me", n2.Me], ["Mn", n2.Mn], ["N", n2.N], ["Nd", n2.Nd], ["Nl", n2.Nl], ["No", n2.No], ["P", n2.P], ["Pc", n2.Pc], ["Pd", n2.Pd], ["Pe", n2.Pe], ["Pf", n2.Pf], ["Pi", n2.Pi], ["Po", n2.Po], ["Ps", n2.Ps], ["S", n2.S], ["Sc", n2.Sc], ["Sk", n2.Sk], ["Sm", n2.Sm], ["So", n2.So], ["Z", n2.Z], ["Zl", n2.Zl], ["Zp", n2.Zp], ["Zs", n2.Zs]]);
      static SCRIPTS = /* @__PURE__ */ new Map([["Adlam", n2.Adlam], ["Ahom", n2.Ahom], ["Anatolian_Hieroglyphs", n2.Anatolian_Hieroglyphs], ["Arabic", n2.Arabic], ["Armenian", n2.Armenian], ["Avestan", n2.Avestan], ["Balinese", n2.Balinese], ["Bamum", n2.Bamum], ["Bassa_Vah", n2.Bassa_Vah], ["Batak", n2.Batak], ["Bengali", n2.Bengali], ["Bhaiksuki", n2.Bhaiksuki], ["Bopomofo", n2.Bopomofo], ["Brahmi", n2.Brahmi], ["Braille", n2.Braille], ["Buginese", n2.Buginese], ["Buhid", n2.Buhid], ["Canadian_Aboriginal", n2.Canadian_Aboriginal], ["Carian", n2.Carian], ["Caucasian_Albanian", n2.Caucasian_Albanian], ["Chakma", n2.Chakma], ["Cham", n2.Cham], ["Cherokee", n2.Cherokee], ["Chorasmian", n2.Chorasmian], ["Common", n2.Common], ["Coptic", n2.Coptic], ["Cuneiform", n2.Cuneiform], ["Cypriot", n2.Cypriot], ["Cypro_Minoan", n2.Cypro_Minoan], ["Cyrillic", n2.Cyrillic], ["Deseret", n2.Deseret], ["Devanagari", n2.Devanagari], ["Dives_Akuru", n2.Dives_Akuru], ["Dogra", n2.Dogra], ["Duployan", n2.Duployan], ["Egyptian_Hieroglyphs", n2.Egyptian_Hieroglyphs], ["Elbasan", n2.Elbasan], ["Elymaic", n2.Elymaic], ["Ethiopic", n2.Ethiopic], ["Garay", n2.Garay], ["Georgian", n2.Georgian], ["Glagolitic", n2.Glagolitic], ["Gothic", n2.Gothic], ["Grantha", n2.Grantha], ["Greek", n2.Greek], ["Gujarati", n2.Gujarati], ["Gunjala_Gondi", n2.Gunjala_Gondi], ["Gurmukhi", n2.Gurmukhi], ["Gurung_Khema", n2.Gurung_Khema], ["Han", n2.Han], ["Hangul", n2.Hangul], ["Hanifi_Rohingya", n2.Hanifi_Rohingya], ["Hanunoo", n2.Hanunoo], ["Hatran", n2.Hatran], ["Hebrew", n2.Hebrew], ["Hiragana", n2.Hiragana], ["Imperial_Aramaic", n2.Imperial_Aramaic], ["Inherited", n2.Inherited], ["Inscriptional_Pahlavi", n2.Inscriptional_Pahlavi], ["Inscriptional_Parthian", n2.Inscriptional_Parthian], ["Javanese", n2.Javanese], ["Kaithi", n2.Kaithi], ["Kannada", n2.Kannada], ["Katakana", n2.Katakana], ["Kawi", n2.Kawi], ["Kayah_Li", n2.Kayah_Li], ["Kharoshthi", n2.Kharoshthi], ["Khitan_Small_Script", n2.Khitan_Small_Script], ["Khmer", n2.Khmer], ["Khojki", n2.Khojki], ["Khudawadi", n2.Khudawadi], ["Kirat_Rai", n2.Kirat_Rai], ["Lao", n2.Lao], ["Latin", n2.Latin], ["Lepcha", n2.Lepcha], ["Limbu", n2.Limbu], ["Linear_A", n2.Linear_A], ["Linear_B", n2.Linear_B], ["Lisu", n2.Lisu], ["Lycian", n2.Lycian], ["Lydian", n2.Lydian], ["Mahajani", n2.Mahajani], ["Makasar", n2.Makasar], ["Malayalam", n2.Malayalam], ["Mandaic", n2.Mandaic], ["Manichaean", n2.Manichaean], ["Marchen", n2.Marchen], ["Masaram_Gondi", n2.Masaram_Gondi], ["Medefaidrin", n2.Medefaidrin], ["Meetei_Mayek", n2.Meetei_Mayek], ["Mende_Kikakui", n2.Mende_Kikakui], ["Meroitic_Cursive", n2.Meroitic_Cursive], ["Meroitic_Hieroglyphs", n2.Meroitic_Hieroglyphs], ["Miao", n2.Miao], ["Modi", n2.Modi], ["Mongolian", n2.Mongolian], ["Mro", n2.Mro], ["Multani", n2.Multani], ["Myanmar", n2.Myanmar], ["Nabataean", n2.Nabataean], ["Nag_Mundari", n2.Nag_Mundari], ["Nandinagari", n2.Nandinagari], ["New_Tai_Lue", n2.New_Tai_Lue], ["Newa", n2.Newa], ["Nko", n2.Nko], ["Nushu", n2.Nushu], ["Nyiakeng_Puachue_Hmong", n2.Nyiakeng_Puachue_Hmong], ["Ogham", n2.Ogham], ["Ol_Chiki", n2.Ol_Chiki], ["Ol_Onal", n2.Ol_Onal], ["Old_Hungarian", n2.Old_Hungarian], ["Old_Italic", n2.Old_Italic], ["Old_North_Arabian", n2.Old_North_Arabian], ["Old_Permic", n2.Old_Permic], ["Old_Persian", n2.Old_Persian], ["Old_Sogdian", n2.Old_Sogdian], ["Old_South_Arabian", n2.Old_South_Arabian], ["Old_Turkic", n2.Old_Turkic], ["Old_Uyghur", n2.Old_Uyghur], ["Oriya", n2.Oriya], ["Osage", n2.Osage], ["Osmanya", n2.Osmanya], ["Pahawh_Hmong", n2.Pahawh_Hmong], ["Palmyrene", n2.Palmyrene], ["Pau_Cin_Hau", n2.Pau_Cin_Hau], ["Phags_Pa", n2.Phags_Pa], ["Phoenician", n2.Phoenician], ["Psalter_Pahlavi", n2.Psalter_Pahlavi], ["Rejang", n2.Rejang], ["Runic", n2.Runic], ["Samaritan", n2.Samaritan], ["Saurashtra", n2.Saurashtra], ["Sharada", n2.Sharada], ["Shavian", n2.Shavian], ["Siddham", n2.Siddham], ["SignWriting", n2.SignWriting], ["Sinhala", n2.Sinhala], ["Sogdian", n2.Sogdian], ["Sora_Sompeng", n2.Sora_Sompeng], ["Soyombo", n2.Soyombo], ["Sundanese", n2.Sundanese], ["Sunuwar", n2.Sunuwar], ["Syloti_Nagri", n2.Syloti_Nagri], ["Syriac", n2.Syriac], ["Tagalog", n2.Tagalog], ["Tagbanwa", n2.Tagbanwa], ["Tai_Le", n2.Tai_Le], ["Tai_Tham", n2.Tai_Tham], ["Tai_Viet", n2.Tai_Viet], ["Takri", n2.Takri], ["Tamil", n2.Tamil], ["Tangsa", n2.Tangsa], ["Tangut", n2.Tangut], ["Telugu", n2.Telugu], ["Thaana", n2.Thaana], ["Thai", n2.Thai], ["Tibetan", n2.Tibetan], ["Tifinagh", n2.Tifinagh], ["Tirhuta", n2.Tirhuta], ["Todhri", n2.Todhri], ["Toto", n2.Toto], ["Tulu_Tigalari", n2.Tulu_Tigalari], ["Ugaritic", n2.Ugaritic], ["Vai", n2.Vai], ["Vithkuqi", n2.Vithkuqi], ["Wancho", n2.Wancho], ["Warang_Citi", n2.Warang_Citi], ["Yezidi", n2.Yezidi], ["Yi", n2.Yi], ["Zanabazar_Square", n2.Zanabazar_Square]]);
      static FOLD_CATEGORIES = /* @__PURE__ */ new Map([["L", n2.foldL], ["Ll", n2.foldLl], ["Lt", n2.foldLt], ["Lu", n2.foldLu], ["M", n2.foldM], ["Mn", n2.foldMn]]);
      static FOLD_SCRIPT = /* @__PURE__ */ new Map([["Common", n2.foldCommon], ["Greek", n2.foldGreek], ["Inherited", n2.foldInherited]]);
      static Print = new a(new Uint32Array([33, 126, 1, 161, 172, 1, 174, 887, 1, 890, 895, 1, 900, 906, 1, 908, 910, 2, 911, 929, 1, 931, 1327, 1, 1329, 1366, 1, 1369, 1418, 1, 1421, 1423, 1, 1425, 1479, 1, 1488, 1514, 1, 1519, 1524, 1, 1542, 1563, 1, 1565, 1756, 1, 1758, 1805, 1, 1808, 1866, 1, 1869, 1969, 1, 1984, 2042, 1, 2045, 2093, 1, 2096, 2110, 1, 2112, 2139, 1, 2142, 2144, 2, 2145, 2154, 1, 2160, 2190, 1, 2199, 2273, 1, 2275, 2435, 1, 2437, 2444, 1, 2447, 2448, 1, 2451, 2472, 1, 2474, 2480, 1, 2482, 2486, 4, 2487, 2489, 1, 2492, 2500, 1, 2503, 2504, 1, 2507, 2510, 1, 2519, 2524, 5, 2525, 2527, 2, 2528, 2531, 1, 2534, 2558, 1, 2561, 2563, 1, 2565, 2570, 1, 2575, 2576, 1, 2579, 2600, 1, 2602, 2608, 1, 2610, 2611, 1, 2613, 2614, 1, 2616, 2617, 1, 2620, 2622, 2, 2623, 2626, 1, 2631, 2632, 1, 2635, 2637, 1, 2641, 2649, 8, 2650, 2652, 1, 2654, 2662, 8, 2663, 2678, 1, 2689, 2691, 1, 2693, 2701, 1, 2703, 2705, 1, 2707, 2728, 1, 2730, 2736, 1, 2738, 2739, 1, 2741, 2745, 1, 2748, 2757, 1, 2759, 2761, 1, 2763, 2765, 1, 2768, 2784, 16, 2785, 2787, 1, 2790, 2801, 1, 2809, 2815, 1, 2817, 2819, 1, 2821, 2828, 1, 2831, 2832, 1, 2835, 2856, 1, 2858, 2864, 1, 2866, 2867, 1, 2869, 2873, 1, 2876, 2884, 1, 2887, 2888, 1, 2891, 2893, 1, 2901, 2903, 1, 2908, 2909, 1, 2911, 2915, 1, 2918, 2935, 1, 2946, 2947, 1, 2949, 2954, 1, 2958, 2960, 1, 2962, 2965, 1, 2969, 2970, 1, 2972, 2974, 2, 2975, 2979, 4, 2980, 2984, 4, 2985, 2986, 1, 2990, 3001, 1, 3006, 3010, 1, 3014, 3016, 1, 3018, 3021, 1, 3024, 3031, 7, 3046, 3066, 1, 3072, 3084, 1, 3086, 3088, 1, 3090, 3112, 1, 3114, 3129, 1, 3132, 3140, 1, 3142, 3144, 1, 3146, 3149, 1, 3157, 3158, 1, 3160, 3162, 1, 3165, 3168, 3, 3169, 3171, 1, 3174, 3183, 1, 3191, 3212, 1, 3214, 3216, 1, 3218, 3240, 1, 3242, 3251, 1, 3253, 3257, 1, 3260, 3268, 1, 3270, 3272, 1, 3274, 3277, 1, 3285, 3286, 1, 3293, 3294, 1, 3296, 3299, 1, 3302, 3311, 1, 3313, 3315, 1, 3328, 3340, 1, 3342, 3344, 1, 3346, 3396, 1, 3398, 3400, 1, 3402, 3407, 1, 3412, 3427, 1, 3430, 3455, 1, 3457, 3459, 1, 3461, 3478, 1, 3482, 3505, 1, 3507, 3515, 1, 3517, 3520, 3, 3521, 3526, 1, 3530, 3535, 5, 3536, 3540, 1, 3542, 3544, 2, 3545, 3551, 1, 3558, 3567, 1, 3570, 3572, 1, 3585, 3642, 1, 3647, 3675, 1, 3713, 3714, 1, 3716, 3718, 2, 3719, 3722, 1, 3724, 3747, 1, 3749, 3751, 2, 3752, 3773, 1, 3776, 3780, 1, 3782, 3784, 2, 3785, 3790, 1, 3792, 3801, 1, 3804, 3807, 1, 3840, 3911, 1, 3913, 3948, 1, 3953, 3991, 1, 3993, 4028, 1, 4030, 4044, 1, 4046, 4058, 1, 4096, 4293, 1, 4295, 4301, 6, 4304, 4680, 1, 4682, 4685, 1, 4688, 4694, 1, 4696, 4698, 2, 4699, 4701, 1, 4704, 4744, 1, 4746, 4749, 1, 4752, 4784, 1, 4786, 4789, 1, 4792, 4798, 1, 4800, 4802, 2, 4803, 4805, 1, 4808, 4822, 1, 4824, 4880, 1, 4882, 4885, 1, 4888, 4954, 1, 4957, 4988, 1, 4992, 5017, 1, 5024, 5109, 1, 5112, 5117, 1, 5120, 5759, 1, 5761, 5788, 1, 5792, 5880, 1, 5888, 5909, 1, 5919, 5942, 1, 5952, 5971, 1, 5984, 5996, 1, 5998, 6e3, 1, 6002, 6003, 1, 6016, 6109, 1, 6112, 6121, 1, 6128, 6137, 1, 6144, 6157, 1, 6159, 6169, 1, 6176, 6264, 1, 6272, 6314, 1, 6320, 6389, 1, 6400, 6430, 1, 6432, 6443, 1, 6448, 6459, 1, 6464, 6468, 4, 6469, 6509, 1, 6512, 6516, 1, 6528, 6571, 1, 6576, 6601, 1, 6608, 6618, 1, 6622, 6683, 1, 6686, 6750, 1, 6752, 6780, 1, 6783, 6793, 1, 6800, 6809, 1, 6816, 6829, 1, 6832, 6862, 1, 6912, 6988, 1, 6990, 7155, 1, 7164, 7223, 1, 7227, 7241, 1, 7245, 7306, 1, 7312, 7354, 1, 7357, 7367, 1, 7376, 7418, 1, 7424, 7957, 1, 7960, 7965, 1, 7968, 8005, 1, 8008, 8013, 1, 8016, 8023, 1, 8025, 8031, 2, 8032, 8061, 1, 8064, 8116, 1, 8118, 8132, 1, 8134, 8147, 1, 8150, 8155, 1, 8157, 8175, 1, 8178, 8180, 1, 8182, 8190, 1, 8208, 8231, 1, 8240, 8286, 1, 8304, 8305, 1, 8308, 8334, 1, 8336, 8348, 1, 8352, 8384, 1, 8400, 8432, 1, 8448, 8587, 1, 8592, 9257, 1, 9280, 9290, 1, 9312, 11123, 1, 11126, 11157, 1, 11159, 11507, 1, 11513, 11557, 1, 11559, 11565, 6, 11568, 11623, 1, 11631, 11632, 1, 11647, 11670, 1, 11680, 11686, 1, 11688, 11694, 1, 11696, 11702, 1, 11704, 11710, 1, 11712, 11718, 1, 11720, 11726, 1, 11728, 11734, 1, 11736, 11742, 1, 11744, 11869, 1, 11904, 11929, 1, 11931, 12019, 1, 12032, 12245, 1, 12272, 12287, 1, 12289, 12351, 1, 12353, 12438, 1, 12441, 12543, 1, 12549, 12591, 1, 12593, 12686, 1, 12688, 12773, 1, 12783, 12830, 1, 12832, 42124, 1, 42128, 42182, 1, 42192, 42539, 1, 42560, 42743, 1, 42752, 42957, 1, 42960, 42961, 1, 42963, 42965, 2, 42966, 42972, 1, 42994, 43052, 1, 43056, 43065, 1, 43072, 43127, 1, 43136, 43205, 1, 43214, 43225, 1, 43232, 43347, 1, 43359, 43388, 1, 43392, 43469, 1, 43471, 43481, 1, 43486, 43518, 1, 43520, 43574, 1, 43584, 43597, 1, 43600, 43609, 1, 43612, 43714, 1, 43739, 43766, 1, 43777, 43782, 1, 43785, 43790, 1, 43793, 43798, 1, 43808, 43814, 1, 43816, 43822, 1, 43824, 43883, 1, 43888, 44013, 1, 44016, 44025, 1, 44032, 55203, 1, 55216, 55238, 1, 55243, 55291, 1, 63744, 64109, 1, 64112, 64217, 1, 64256, 64262, 1, 64275, 64279, 1, 64285, 64310, 1, 64312, 64316, 1, 64318, 64320, 2, 64321, 64323, 2, 64324, 64326, 2, 64327, 64450, 1, 64467, 64911, 1, 64914, 64967, 1, 64975, 65008, 33, 65009, 65049, 1, 65056, 65106, 1, 65108, 65126, 1, 65128, 65131, 1, 65136, 65140, 1, 65142, 65276, 1, 65281, 65470, 1, 65474, 65479, 1, 65482, 65487, 1, 65490, 65495, 1, 65498, 65500, 1, 65504, 65510, 1, 65512, 65518, 1, 65532, 65533, 1, 65536, 65547, 1, 65549, 65574, 1, 65576, 65594, 1, 65596, 65597, 1, 65599, 65613, 1, 65616, 65629, 1, 65664, 65786, 1, 65792, 65794, 1, 65799, 65843, 1, 65847, 65934, 1, 65936, 65948, 1, 65952, 66e3, 48, 66001, 66045, 1, 66176, 66204, 1, 66208, 66256, 1, 66272, 66299, 1, 66304, 66339, 1, 66349, 66378, 1, 66384, 66426, 1, 66432, 66461, 1, 66463, 66499, 1, 66504, 66517, 1, 66560, 66717, 1, 66720, 66729, 1, 66736, 66771, 1, 66776, 66811, 1, 66816, 66855, 1, 66864, 66915, 1, 66927, 66938, 1, 66940, 66954, 1, 66956, 66962, 1, 66964, 66965, 1, 66967, 66977, 1, 66979, 66993, 1, 66995, 67001, 1, 67003, 67004, 1, 67008, 67059, 1, 67072, 67382, 1, 67392, 67413, 1, 67424, 67431, 1, 67456, 67461, 1, 67463, 67504, 1, 67506, 67514, 1, 67584, 67589, 1, 67592, 67594, 2, 67595, 67637, 1, 67639, 67640, 1, 67644, 67647, 3, 67648, 67669, 1, 67671, 67742, 1, 67751, 67759, 1, 67808, 67826, 1, 67828, 67829, 1, 67835, 67867, 1, 67871, 67897, 1, 67903, 67968, 65, 67969, 68023, 1, 68028, 68047, 1, 68050, 68099, 1, 68101, 68102, 1, 68108, 68115, 1, 68117, 68119, 1, 68121, 68149, 1, 68152, 68154, 1, 68159, 68168, 1, 68176, 68184, 1, 68192, 68255, 1, 68288, 68326, 1, 68331, 68342, 1, 68352, 68405, 1, 68409, 68437, 1, 68440, 68466, 1, 68472, 68497, 1, 68505, 68508, 1, 68521, 68527, 1, 68608, 68680, 1, 68736, 68786, 1, 68800, 68850, 1, 68858, 68903, 1, 68912, 68921, 1, 68928, 68965, 1, 68969, 68997, 1, 69006, 69007, 1, 69216, 69246, 1, 69248, 69289, 1, 69291, 69293, 1, 69296, 69297, 1, 69314, 69316, 1, 69372, 69415, 1, 69424, 69465, 1, 69488, 69513, 1, 69552, 69579, 1, 69600, 69622, 1, 69632, 69709, 1, 69714, 69749, 1, 69759, 69820, 1, 69822, 69826, 1, 69840, 69864, 1, 69872, 69881, 1, 69888, 69940, 1, 69942, 69959, 1, 69968, 70006, 1, 70016, 70111, 1, 70113, 70132, 1, 70144, 70161, 1, 70163, 70209, 1, 70272, 70278, 1, 70280, 70282, 2, 70283, 70285, 1, 70287, 70301, 1, 70303, 70313, 1, 70320, 70378, 1, 70384, 70393, 1, 70400, 70403, 1, 70405, 70412, 1, 70415, 70416, 1, 70419, 70440, 1, 70442, 70448, 1, 70450, 70451, 1, 70453, 70457, 1, 70459, 70468, 1, 70471, 70472, 1, 70475, 70477, 1, 70480, 70487, 7, 70493, 70499, 1, 70502, 70508, 1, 70512, 70516, 1, 70528, 70537, 1, 70539, 70542, 3, 70544, 70581, 1, 70583, 70592, 1, 70594, 70597, 3, 70599, 70602, 1, 70604, 70613, 1, 70615, 70616, 1, 70625, 70626, 1, 70656, 70747, 1, 70749, 70753, 1, 70784, 70855, 1, 70864, 70873, 1, 71040, 71093, 1, 71096, 71133, 1, 71168, 71236, 1, 71248, 71257, 1, 71264, 71276, 1, 71296, 71353, 1, 71360, 71369, 1, 71376, 71395, 1, 71424, 71450, 1, 71453, 71467, 1, 71472, 71494, 1, 71680, 71739, 1, 71840, 71922, 1, 71935, 71942, 1, 71945, 71948, 3, 71949, 71955, 1, 71957, 71958, 1, 71960, 71989, 1, 71991, 71992, 1, 71995, 72006, 1, 72016, 72025, 1, 72096, 72103, 1, 72106, 72151, 1, 72154, 72164, 1, 72192, 72263, 1, 72272, 72354, 1, 72368, 72440, 1, 72448, 72457, 1, 72640, 72673, 1, 72688, 72697, 1, 72704, 72712, 1, 72714, 72758, 1, 72760, 72773, 1, 72784, 72812, 1, 72816, 72847, 1, 72850, 72871, 1, 72873, 72886, 1, 72960, 72966, 1, 72968, 72969, 1, 72971, 73014, 1, 73018, 73020, 2, 73021, 73023, 2, 73024, 73031, 1, 73040, 73049, 1, 73056, 73061, 1, 73063, 73064, 1, 73066, 73102, 1, 73104, 73105, 1, 73107, 73112, 1, 73120, 73129, 1, 73440, 73464, 1, 73472, 73488, 1, 73490, 73530, 1, 73534, 73562, 1, 73648, 73664, 16, 73665, 73713, 1, 73727, 74649, 1, 74752, 74862, 1, 74864, 74868, 1, 74880, 75075, 1, 77712, 77810, 1, 77824, 78895, 1, 78912, 78933, 1, 78944, 82938, 1, 82944, 83526, 1, 90368, 90425, 1, 92160, 92728, 1, 92736, 92766, 1, 92768, 92777, 1, 92782, 92862, 1, 92864, 92873, 1, 92880, 92909, 1, 92912, 92917, 1, 92928, 92997, 1, 93008, 93017, 1, 93019, 93025, 1, 93027, 93047, 1, 93053, 93071, 1, 93504, 93561, 1, 93760, 93850, 1, 93952, 94026, 1, 94031, 94087, 1, 94095, 94111, 1, 94176, 94180, 1, 94192, 94193, 1, 94208, 100343, 1, 100352, 101589, 1, 101631, 101640, 1, 110576, 110579, 1, 110581, 110587, 1, 110589, 110590, 1, 110592, 110882, 1, 110898, 110928, 30, 110929, 110930, 1, 110933, 110948, 15, 110949, 110951, 1, 110960, 111355, 1, 113664, 113770, 1, 113776, 113788, 1, 113792, 113800, 1, 113808, 113817, 1, 113820, 113823, 1, 117760, 118009, 1, 118016, 118451, 1, 118528, 118573, 1, 118576, 118598, 1, 118608, 118723, 1, 118784, 119029, 1, 119040, 119078, 1, 119081, 119154, 1, 119163, 119274, 1, 119296, 119365, 1, 119488, 119507, 1, 119520, 119539, 1, 119552, 119638, 1, 119648, 119672, 1, 119808, 119892, 1, 119894, 119964, 1, 119966, 119967, 1, 119970, 119973, 3, 119974, 119977, 3, 119978, 119980, 1, 119982, 119993, 1, 119995, 119997, 2, 119998, 120003, 1, 120005, 120069, 1, 120071, 120074, 1, 120077, 120084, 1, 120086, 120092, 1, 120094, 120121, 1, 120123, 120126, 1, 120128, 120132, 1, 120134, 120138, 4, 120139, 120144, 1, 120146, 120485, 1, 120488, 120779, 1, 120782, 121483, 1, 121499, 121503, 1, 121505, 121519, 1, 122624, 122654, 1, 122661, 122666, 1, 122880, 122886, 1, 122888, 122904, 1, 122907, 122913, 1, 122915, 122916, 1, 122918, 122922, 1, 122928, 122989, 1, 123023, 123136, 113, 123137, 123180, 1, 123184, 123197, 1, 123200, 123209, 1, 123214, 123215, 1, 123536, 123566, 1, 123584, 123641, 1, 123647, 124112, 465, 124113, 124153, 1, 124368, 124410, 1, 124415, 124896, 481, 124897, 124902, 1, 124904, 124907, 1, 124909, 124910, 1, 124912, 124926, 1, 124928, 125124, 1, 125127, 125142, 1, 125184, 125259, 1, 125264, 125273, 1, 125278, 125279, 1, 126065, 126132, 1, 126209, 126269, 1, 126464, 126467, 1, 126469, 126495, 1, 126497, 126498, 1, 126500, 126503, 3, 126505, 126514, 1, 126516, 126519, 1, 126521, 126523, 2, 126530, 126535, 5, 126537, 126541, 2, 126542, 126543, 1, 126545, 126546, 1, 126548, 126551, 3, 126553, 126561, 2, 126562, 126564, 2, 126567, 126570, 1, 126572, 126578, 1, 126580, 126583, 1, 126585, 126588, 1, 126590, 126592, 2, 126593, 126601, 1, 126603, 126619, 1, 126625, 126627, 1, 126629, 126633, 1, 126635, 126651, 1, 126704, 126705, 1, 126976, 127019, 1, 127024, 127123, 1, 127136, 127150, 1, 127153, 127167, 1, 127169, 127183, 1, 127185, 127221, 1, 127232, 127405, 1, 127462, 127490, 1, 127504, 127547, 1, 127552, 127560, 1, 127568, 127569, 1, 127584, 127589, 1, 127744, 128727, 1, 128732, 128748, 1, 128752, 128764, 1, 128768, 128886, 1, 128891, 128985, 1, 128992, 129003, 1, 129008, 129024, 16, 129025, 129035, 1, 129040, 129095, 1, 129104, 129113, 1, 129120, 129159, 1, 129168, 129197, 1, 129200, 129211, 1, 129216, 129217, 1, 129280, 129619, 1, 129632, 129645, 1, 129648, 129660, 1, 129664, 129673, 1, 129679, 129734, 1, 129742, 129756, 1, 129759, 129769, 1, 129776, 129784, 1, 129792, 129938, 1, 129940, 130041, 1, 131072, 173791, 1, 173824, 177977, 1, 177984, 178205, 1, 178208, 183969, 1, 183984, 191456, 1, 191472, 192093, 1, 194560, 195101, 1, 196608, 201546, 1, 201552, 205743, 1, 917760, 917999, 1]));
    };
    w = class {
      static MAX_RUNE = 1114111;
      static MAX_ASCII = 127;
      static MAX_LATIN1 = 255;
      static MAX_BMP = 65535;
      static MIN_FOLD = 65;
      static MAX_FOLD = 125251;
      static is32(t6, e5) {
        let s9 = 0, i10 = t6.length;
        for (; s9 < i10; ) {
          let r8 = s9 + Math.floor((i10 - s9) / 2), o9 = t6.getLo(r8), l8 = t6.getHi(r8);
          if (o9 <= e5 && e5 <= l8) {
            let h16 = t6.getStride(r8);
            return (e5 - o9) % h16 === 0;
          }
          e5 < o9 ? i10 = r8 : s9 = r8 + 1;
        }
        return false;
      }
      static is(t6, e5) {
        if (e5 <= this.MAX_LATIN1) {
          for (let s9 = 0; s9 < t6.length; s9++) {
            let i10 = t6.getHi(s9);
            if (e5 > i10) continue;
            let r8 = t6.getLo(s9);
            if (e5 < r8) return false;
            let o9 = t6.getStride(s9);
            return (e5 - r8) % o9 === 0;
          }
          return false;
        }
        return t6.length > 0 && e5 >= t6.getLo(0) && this.is32(t6, e5);
      }
      static isUpper(t6) {
        if (t6 <= this.MAX_LATIN1) {
          let e5 = String.fromCodePoint(t6);
          return e5.toUpperCase() === e5 && e5.toLowerCase() !== e5;
        }
        return this.is(b.Upper, t6);
      }
      static isPrint(t6) {
        return t6 <= this.MAX_LATIN1 ? t6 >= 32 && t6 < this.MAX_ASCII || t6 >= 161 && t6 !== 173 : this.is(b.Print, t6);
      }
      static simpleFold(t6) {
        if (b.CASE_ORBIT.has(t6)) return b.CASE_ORBIT.get(t6);
        let e5 = u.toLowerCase(t6);
        return e5 !== t6 ? e5 : u.toUpperCase(t6);
      }
      static equalsIgnoreCase(t6, e5) {
        if (t6 < 0 || e5 < 0 || t6 === e5) return true;
        if (t6 <= this.MAX_ASCII && e5 <= this.MAX_ASCII) return u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z") && (t6 |= 32), u.CODES.get("A") <= e5 && e5 <= u.CODES.get("Z") && (e5 |= 32), t6 === e5;
        for (let s9 = this.simpleFold(t6); s9 !== t6; s9 = this.simpleFold(s9)) if (s9 === e5) return true;
        return false;
      }
    };
    O = class {
      static METACHARACTERS = "\\.+*?()|[]{}^$";
      static EMPTY_BEGIN_LINE = 1;
      static EMPTY_END_LINE = 2;
      static EMPTY_BEGIN_TEXT = 4;
      static EMPTY_END_TEXT = 8;
      static EMPTY_WORD_BOUNDARY = 16;
      static EMPTY_NO_WORD_BOUNDARY = 32;
      static EMPTY_ALL = -1;
      static emptyInts() {
        return [];
      }
      static isalnum(t6) {
        return u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") || u.CODES.get("a") <= t6 && t6 <= u.CODES.get("z") || u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z");
      }
      static unhex(t6) {
        return u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") ? t6 - u.CODES.get("0") : u.CODES.get("a") <= t6 && t6 <= u.CODES.get("f") ? t6 - u.CODES.get("a") + 10 : u.CODES.get("A") <= t6 && t6 <= u.CODES.get("F") ? t6 - u.CODES.get("A") + 10 : -1;
      }
      static escapeRune(t6) {
        let e5 = "";
        if (w.isPrint(t6)) this.METACHARACTERS.indexOf(String.fromCodePoint(t6)) >= 0 && (e5 += "\\"), e5 += String.fromCodePoint(t6);
        else switch (t6) {
          case u.CODES.get('"'):
            e5 += '\\"';
            break;
          case u.CODES.get("\\"):
            e5 += "\\\\";
            break;
          case u.CODES.get("	"):
            e5 += "\\t";
            break;
          case u.CODES.get(`
`):
            e5 += "\\n";
            break;
          case u.CODES.get("\r"):
            e5 += "\\r";
            break;
          case u.CODES.get("\b"):
            e5 += "\\b";
            break;
          case u.CODES.get("\f"):
            e5 += "\\f";
            break;
          default: {
            let s9 = t6.toString(16);
            t6 < 256 ? (e5 += "\\x", s9.length === 1 && (e5 += "0"), e5 += s9) : e5 += `\\x{${s9}}`;
            break;
          }
        }
        return e5;
      }
      static stringToRunes(t6) {
        return String(t6).split("").map((e5) => e5.codePointAt(0));
      }
      static runeToString(t6) {
        return String.fromCodePoint(t6);
      }
      static isWordRune(t6) {
        return u.CODES.get("a") <= t6 && t6 <= u.CODES.get("z") || u.CODES.get("A") <= t6 && t6 <= u.CODES.get("Z") || u.CODES.get("0") <= t6 && t6 <= u.CODES.get("9") || t6 === u.CODES.get("_");
      }
      static emptyOpContext(t6, e5) {
        let s9 = 0;
        return t6 < 0 && (s9 |= this.EMPTY_BEGIN_TEXT | this.EMPTY_BEGIN_LINE), t6 === u.CODES.get(`
`) && (s9 |= this.EMPTY_BEGIN_LINE), e5 < 0 && (s9 |= this.EMPTY_END_TEXT | this.EMPTY_END_LINE), e5 === u.CODES.get(`
`) && (s9 |= this.EMPTY_END_LINE), this.isWordRune(t6) !== this.isWordRune(e5) ? s9 |= this.EMPTY_WORD_BOUNDARY : s9 |= this.EMPTY_NO_WORD_BOUNDARY, s9;
      }
      static quoteMeta(t6) {
        return t6.split("").map((e5) => this.METACHARACTERS.indexOf(e5) >= 0 ? `\\${e5}` : e5).join("");
      }
      static charCount(t6) {
        return t6 > w.MAX_BMP ? 2 : 1;
      }
      static stringToUtf8ByteArray(t6) {
        if (globalThis.TextEncoder) return Array.from(new TextEncoder().encode(t6));
        {
          let e5 = [], s9 = 0;
          for (let i10 = 0; i10 < t6.length; i10++) {
            let r8 = t6.charCodeAt(i10);
            r8 < 128 ? e5[s9++] = r8 : r8 < 2048 ? (e5[s9++] = r8 >> 6 | 192, e5[s9++] = r8 & 63 | 128) : (r8 & 64512) === 55296 && i10 + 1 < t6.length && (t6.charCodeAt(i10 + 1) & 64512) === 56320 ? (r8 = 65536 + ((r8 & 1023) << 10) + (t6.charCodeAt(++i10) & 1023), e5[s9++] = r8 >> 18 | 240, e5[s9++] = r8 >> 12 & 63 | 128, e5[s9++] = r8 >> 6 & 63 | 128, e5[s9++] = r8 & 63 | 128) : (e5[s9++] = r8 >> 12 | 224, e5[s9++] = r8 >> 6 & 63 | 128, e5[s9++] = r8 & 63 | 128);
          }
          return e5;
        }
      }
      static utf8ByteArrayToString(t6) {
        if (globalThis.TextDecoder) return new TextDecoder("utf-8").decode(new Uint8Array(t6));
        {
          let e5 = [], s9 = 0, i10 = 0;
          for (; s9 < t6.length; ) {
            let r8 = t6[s9++];
            if (r8 < 128) e5[i10++] = String.fromCharCode(r8);
            else if (r8 > 191 && r8 < 224) {
              let o9 = t6[s9++];
              e5[i10++] = String.fromCharCode((r8 & 31) << 6 | o9 & 63);
            } else if (r8 > 239 && r8 < 365) {
              let o9 = t6[s9++], l8 = t6[s9++], h16 = t6[s9++], p17 = ((r8 & 7) << 18 | (o9 & 63) << 12 | (l8 & 63) << 6 | h16 & 63) - 65536;
              e5[i10++] = String.fromCharCode(55296 + (p17 >> 10)), e5[i10++] = String.fromCharCode(56320 + (p17 & 1023));
            } else {
              let o9 = t6[s9++], l8 = t6[s9++];
              e5[i10++] = String.fromCharCode((r8 & 15) << 12 | (o9 & 63) << 6 | l8 & 63);
            }
          }
          return e5.join("");
        }
      }
    };
    R1 = (n23 = [], t6 = 0) => {
      let e5 = {};
      for (let s9 = 0; s9 < n23.length; s9++) {
        let i10 = n23[s9], r8 = t6 + s9;
        e5[i10] = r8, e5[r8] = i10;
      }
      return Object.freeze(e5);
    };
    I = class n3 {
      static Encoding = R1(["UTF_16", "UTF_8"]);
      getEncoding() {
        throw Error("not implemented");
      }
      isUTF8Encoding() {
        return this.getEncoding() === n3.Encoding.UTF_8;
      }
      isUTF16Encoding() {
        return this.getEncoding() === n3.Encoding.UTF_16;
      }
    };
    F = class extends I {
      constructor(t6 = null) {
        super(), this.bytes = t6;
      }
      getEncoding() {
        return I.Encoding.UTF_8;
      }
      asCharSequence() {
        return O.utf8ByteArrayToString(this.bytes);
      }
      asBytes() {
        return this.bytes;
      }
      length() {
        return this.bytes.length;
      }
    };
    X = class extends I {
      constructor(t6 = null) {
        super(), this.charSequence = t6;
      }
      getEncoding() {
        return I.Encoding.UTF_16;
      }
      asCharSequence() {
        return this.charSequence;
      }
      asBytes() {
        return this.charSequence.toString().split("").map((t6) => t6.codePointAt(0));
      }
      length() {
        return this.charSequence.length;
      }
    };
    P = class {
      static utf16(t6) {
        return new X(t6);
      }
      static utf8(t6) {
        return Array.isArray(t6) ? new F(t6) : new F(O.stringToUtf8ByteArray(t6));
      }
    };
    _ = class extends Error {
      constructor(t6) {
        super(t6), this.name = "RE2JSException";
      }
    };
    m = class extends _ {
      constructor(t6, e5 = null) {
        let s9 = `error parsing regexp: ${t6}`;
        e5 && (s9 += `: \`${e5}\``), super(s9), this.name = "RE2JSSyntaxException", this.message = s9, this.error = t6, this.input = e5;
      }
      getDescription() {
        return this.error;
      }
      getPattern() {
        return this.input;
      }
    };
    v = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSCompileException";
      }
    };
    U = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSGroupException";
      }
    };
    z = class extends _ {
      constructor(t6) {
        super(t6), this.name = "RE2JSFlagsException";
      }
    };
    V = class {
      static quoteReplacement(t6) {
        return t6.indexOf("\\") < 0 && t6.indexOf("$") < 0 ? t6 : t6.split("").map((e5) => {
          let s9 = e5.codePointAt(0);
          return s9 === u.CODES["\\"] || s9 === u.CODES.$ ? `\\${e5}` : e5;
        }).join("");
      }
      constructor(t6, e5) {
        if (t6 === null) throw new Error("pattern is null");
        this.patternInput = t6;
        let s9 = this.patternInput.re2();
        this.patternGroupCount = s9.numberOfCapturingGroups(), this.groups = [], this.namedGroups = s9.namedGroups, this.numberOfInstructions = s9.numberOfInstructions(), e5 instanceof I ? this.resetMatcherInput(e5) : Array.isArray(e5) ? this.resetMatcherInput(P.utf8(e5)) : this.resetMatcherInput(P.utf16(e5));
      }
      pattern() {
        return this.patternInput;
      }
      reset() {
        return this.matcherInputLength = this.matcherInput.length(), this.appendPos = 0, this.hasMatch = false, this.hasGroups = false, this.anchorFlag = 0, this;
      }
      resetMatcherInput(t6) {
        if (t6 === null) throw new Error("input is null");
        return this.matcherInput = t6, this.reset(), this;
      }
      start(t6 = 0) {
        if (typeof t6 == "string") {
          let e5 = this.namedGroups[t6];
          if (!Number.isFinite(e5)) throw new U(`group '${t6}' not found`);
          t6 = e5;
        }
        return this.loadGroup(t6), this.groups[2 * t6];
      }
      end(t6 = 0) {
        if (typeof t6 == "string") {
          let e5 = this.namedGroups[t6];
          if (!Number.isFinite(e5)) throw new U(`group '${t6}' not found`);
          t6 = e5;
        }
        return this.loadGroup(t6), this.groups[2 * t6 + 1];
      }
      programSize() {
        return this.numberOfInstructions;
      }
      group(t6 = 0) {
        if (typeof t6 == "string") {
          let i10 = this.namedGroups[t6];
          if (!Number.isFinite(i10)) throw new U(`group '${t6}' not found`);
          t6 = i10;
        }
        let e5 = this.start(t6), s9 = this.end(t6);
        return e5 < 0 && s9 < 0 ? null : this.substring(e5, s9);
      }
      groupCount() {
        return this.patternGroupCount;
      }
      loadGroup(t6) {
        if (t6 < 0 || t6 > this.patternGroupCount) throw new U(`Group index out of bounds: ${t6}`);
        if (!this.hasMatch) throw new U("perhaps no match attempted");
        if (t6 === 0 || this.hasGroups) return;
        let e5 = this.groups[1] + 1;
        e5 > this.matcherInputLength && (e5 = this.matcherInputLength);
        let s9 = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], e5, this.anchorFlag, 1 + this.patternGroupCount);
        if (!s9[0]) throw new U("inconsistency in matching group data");
        this.groups = s9[1], this.hasGroups = true;
      }
      matches() {
        return this.genMatch(0, g.ANCHOR_BOTH);
      }
      lookingAt() {
        return this.genMatch(0, g.ANCHOR_START);
      }
      find(t6 = null) {
        if (t6 !== null) {
          if (t6 < 0 || t6 > this.matcherInputLength) throw new U(`start index out of bounds: ${t6}`);
          return this.reset(), this.genMatch(t6, 0);
        }
        return t6 = 0, this.hasMatch && (t6 = this.groups[1], this.groups[0] === this.groups[1] && t6++), this.genMatch(t6, g.UNANCHORED);
      }
      genMatch(t6, e5) {
        let s9 = this.patternInput.re2().matchMachineInput(this.matcherInput, t6, this.matcherInputLength, e5, 1);
        return s9[0] ? (this.groups = s9[1], this.hasMatch = true, this.hasGroups = false, this.anchorFlag = e5, true) : false;
      }
      substring(t6, e5) {
        return this.matcherInput.isUTF8Encoding() ? O.utf8ByteArrayToString(this.matcherInput.asBytes().slice(t6, e5)) : this.matcherInput.asCharSequence().substring(t6, e5).toString();
      }
      inputLength() {
        return this.matcherInputLength;
      }
      appendReplacement(t6, e5 = false) {
        let s9 = "", i10 = this.start(), r8 = this.end();
        return this.appendPos < i10 && (s9 += this.substring(this.appendPos, i10)), this.appendPos = r8, s9 += e5 ? this.appendReplacementInternalPerl(t6) : this.appendReplacementInternal(t6), s9;
      }
      appendReplacementInternal(t6) {
        let e5 = "", s9 = 0, i10 = t6.length;
        for (let r8 = 0; r8 < i10 - 1; r8++) {
          if (t6.codePointAt(r8) === u.CODES.get("\\")) {
            s9 < r8 && (e5 += t6.substring(s9, r8)), r8++, s9 = r8;
            continue;
          }
          if (t6.codePointAt(r8) === u.CODES.get("$")) {
            let o9 = t6.codePointAt(r8 + 1);
            if (u.CODES.get("0") <= o9 && o9 <= u.CODES.get("9")) {
              let l8 = o9 - u.CODES.get("0");
              for (s9 < r8 && (e5 += t6.substring(s9, r8)), r8 += 2; r8 < i10 && (o9 = t6.codePointAt(r8), !(o9 < u.CODES.get("0") || o9 > u.CODES.get("9") || l8 * 10 + o9 - u.CODES.get("0") > this.patternGroupCount)); r8++) l8 = l8 * 10 + o9 - u.CODES.get("0");
              if (l8 > this.patternGroupCount) throw new U(`n > number of groups: ${l8}`);
              let h16 = this.group(l8);
              h16 !== null && (e5 += h16), s9 = r8, r8--;
              continue;
            } else if (o9 === u.CODES.get("{")) {
              s9 < r8 && (e5 += t6.substring(s9, r8)), r8++;
              let l8 = r8 + 1;
              for (; l8 < t6.length && t6.codePointAt(l8) !== u.CODES.get("}") && t6.codePointAt(l8) !== u.CODES.get(" "); ) l8++;
              if (l8 === t6.length || t6.codePointAt(l8) !== u.CODES.get("}")) throw new U("named capture group is missing trailing '}'");
              let h16 = t6.substring(r8 + 1, l8);
              e5 += this.group(h16), s9 = l8 + 1;
            }
          }
        }
        return s9 < i10 && (e5 += t6.substring(s9, i10)), e5;
      }
      appendReplacementInternalPerl(t6) {
        let e5 = "", s9 = 0, i10 = t6.length;
        for (let r8 = 0; r8 < i10 - 1; r8++) if (t6.codePointAt(r8) === u.CODES.get("$")) {
          let o9 = t6.codePointAt(r8 + 1);
          if (u.CODES.get("$") === o9) {
            s9 < r8 && (e5 += t6.substring(s9, r8)), e5 += "$", r8++, s9 = r8 + 1;
            continue;
          } else if (u.CODES.get("&") === o9) {
            s9 < r8 && (e5 += t6.substring(s9, r8));
            let l8 = this.group(0);
            l8 !== null ? e5 += l8 : e5 += "$&", r8++, s9 = r8 + 1;
            continue;
          } else if (u.CODES.get("1") <= o9 && o9 <= u.CODES.get("9")) {
            let l8 = o9 - u.CODES.get("0");
            for (s9 < r8 && (e5 += t6.substring(s9, r8)), r8 += 2; r8 < i10 && (o9 = t6.codePointAt(r8), !(o9 < u.CODES.get("0") || o9 > u.CODES.get("9") || l8 * 10 + o9 - u.CODES.get("0") > this.patternGroupCount)); r8++) l8 = l8 * 10 + o9 - u.CODES.get("0");
            if (l8 > this.patternGroupCount) {
              e5 += `$${l8}`, s9 = r8, r8--;
              continue;
            }
            let h16 = this.group(l8);
            h16 !== null && (e5 += h16), s9 = r8, r8--;
            continue;
          } else if (o9 === u.CODES.get("<")) {
            s9 < r8 && (e5 += t6.substring(s9, r8)), r8++;
            let l8 = r8 + 1;
            for (; l8 < t6.length && t6.codePointAt(l8) !== u.CODES.get(">") && t6.codePointAt(l8) !== u.CODES.get(" "); ) l8++;
            if (l8 === t6.length || t6.codePointAt(l8) !== u.CODES.get(">")) {
              e5 += t6.substring(r8 - 1, l8 + 1), s9 = l8 + 1;
              continue;
            }
            let h16 = t6.substring(r8 + 1, l8);
            Object.prototype.hasOwnProperty.call(this.namedGroups, h16) ? e5 += this.group(h16) : e5 += `$<${h16}>`, s9 = l8 + 1;
          }
        }
        return s9 < i10 && (e5 += t6.substring(s9, i10)), e5;
      }
      appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
      }
      replaceAll(t6, e5 = false) {
        return this.replace(t6, true, e5);
      }
      replaceFirst(t6, e5 = false) {
        return this.replace(t6, false, e5);
      }
      replace(t6, e5 = true, s9 = false) {
        let i10 = "";
        for (this.reset(); this.find() && (i10 += this.appendReplacement(t6, s9), !!e5); ) ;
        return i10 += this.appendTail(), i10;
      }
    };
    L = class {
      static EOF() {
        return -8;
      }
      canCheckPrefix() {
        return true;
      }
      endPos() {
        return this.end;
      }
    };
    $ = class extends L {
      constructor(t6, e5 = 0, s9 = t6.length) {
        super(), this.bytes = t6, this.start = e5, this.end = s9;
      }
      step(t6) {
        if (t6 += this.start, t6 >= this.end) return L.EOF();
        let e5 = this.bytes[t6++] & 255;
        return (e5 & 128) === 0 ? e5 << 3 | 1 : (e5 & 224) === 192 ? (e5 = e5 & 31, t6 >= this.end ? L.EOF() : (e5 = e5 << 6 | this.bytes[t6++] & 63, e5 << 3 | 2)) : (e5 & 240) === 224 ? (e5 = e5 & 15, t6 + 1 >= this.end ? L.EOF() : (e5 = e5 << 6 | this.bytes[t6++] & 63, e5 = e5 << 6 | this.bytes[t6++] & 63, e5 << 3 | 3)) : (e5 = e5 & 7, t6 + 2 >= this.end ? L.EOF() : (e5 = e5 << 6 | this.bytes[t6++] & 63, e5 = e5 << 6 | this.bytes[t6++] & 63, e5 = e5 << 6 | this.bytes[t6++] & 63, e5 << 3 | 4));
      }
      index(t6, e5) {
        e5 += this.start;
        let s9 = this.indexOf(this.bytes, t6.prefixUTF8, e5);
        return s9 < 0 ? s9 : s9 - e5;
      }
      context(t6) {
        t6 += this.start;
        let e5 = -1;
        if (t6 > this.start && t6 <= this.end) {
          let i10 = t6 - 1;
          if (e5 = this.bytes[i10--], e5 >= 128) {
            let r8 = t6 - 4;
            for (r8 < this.start && (r8 = this.start); i10 >= r8 && (this.bytes[i10] & 192) === 128; ) i10--;
            i10 < this.start && (i10 = this.start), e5 = this.step(i10) >> 3;
          }
        }
        let s9 = t6 < this.end ? this.step(t6) >> 3 : -1;
        return O.emptyOpContext(e5, s9);
      }
      indexOf(t6, e5, s9 = 0) {
        let i10 = e5.length;
        if (i10 === 0) return -1;
        let r8 = t6.length;
        for (let o9 = s9; o9 <= r8 - i10; o9++) for (let l8 = 0; l8 < i10 && t6[o9 + l8] === e5[l8]; l8++) if (l8 === i10 - 1) return o9;
        return -1;
      }
    };
    j = class extends L {
      constructor(t6, e5 = 0, s9 = t6.length) {
        super(), this.charSequence = t6, this.start = e5, this.end = s9;
      }
      step(t6) {
        if (t6 += this.start, t6 < this.end) {
          let e5 = this.charSequence.codePointAt(t6);
          return e5 << 3 | O.charCount(e5);
        } else return L.EOF();
      }
      index(t6, e5) {
        e5 += this.start;
        let s9 = this.charSequence.indexOf(t6.prefix, e5);
        return s9 < 0 ? s9 : s9 - e5;
      }
      context(t6) {
        t6 += this.start;
        let e5 = t6 > 0 && t6 <= this.charSequence.length ? this.charSequence.codePointAt(t6 - 1) : -1, s9 = t6 < this.charSequence.length ? this.charSequence.codePointAt(t6) : -1;
        return O.emptyOpContext(e5, s9);
      }
    };
    N = class {
      static fromUTF8(t6, e5 = 0, s9 = t6.length) {
        return new $(t6, e5, s9);
      }
      static fromUTF16(t6, e5 = 0, s9 = t6.length) {
        return new j(t6, e5, s9);
      }
    };
    E = class n4 {
      static ALT = 1;
      static ALT_MATCH = 2;
      static CAPTURE = 3;
      static EMPTY_WIDTH = 4;
      static FAIL = 5;
      static MATCH = 6;
      static NOP = 7;
      static RUNE = 8;
      static RUNE1 = 9;
      static RUNE_ANY = 10;
      static RUNE_ANY_NOT_NL = 11;
      static isRuneOp(t6) {
        return n4.RUNE <= t6 && t6 <= n4.RUNE_ANY_NOT_NL;
      }
      static escapeRunes(t6) {
        let e5 = '"';
        for (let s9 of t6) e5 += O.escapeRune(s9);
        return e5 += '"', e5;
      }
      constructor(t6) {
        this.op = t6, this.out = 0, this.arg = 0, this.runes = [];
      }
      matchRune(t6) {
        if (this.runes.length === 1) {
          let i10 = this.runes[0];
          return (this.arg & g.FOLD_CASE) !== 0 ? w.equalsIgnoreCase(i10, t6) : t6 === i10;
        }
        for (let i10 = 0; i10 < this.runes.length && i10 <= 8; i10 += 2) {
          if (t6 < this.runes[i10]) return false;
          if (t6 <= this.runes[i10 + 1]) return true;
        }
        let e5 = 0, s9 = this.runes.length / 2 | 0;
        for (; e5 < s9; ) {
          let i10 = e5 + ((s9 - e5) / 2 | 0);
          if (this.runes[2 * i10] <= t6) {
            if (t6 <= this.runes[2 * i10 + 1]) return true;
            e5 = i10 + 1;
          } else s9 = i10;
        }
        return false;
      }
      toString() {
        switch (this.op) {
          case n4.ALT:
            return `alt -> ${this.out}, ${this.arg}`;
          case n4.ALT_MATCH:
            return `altmatch -> ${this.out}, ${this.arg}`;
          case n4.CAPTURE:
            return `cap ${this.arg} -> ${this.out}`;
          case n4.EMPTY_WIDTH:
            return `empty ${this.arg} -> ${this.out}`;
          case n4.MATCH:
            return "match";
          case n4.FAIL:
            return "fail";
          case n4.NOP:
            return `nop -> ${this.out}`;
          case n4.RUNE:
            return this.runes === null ? "rune <null>" : ["rune ", n4.escapeRunes(this.runes), (this.arg & g.FOLD_CASE) !== 0 ? "/i" : "", " -> ", this.out].join("");
          case n4.RUNE1:
            return `rune1 ${n4.escapeRunes(this.runes)} -> ${this.out}`;
          case n4.RUNE_ANY:
            return `any -> ${this.out}`;
          case n4.RUNE_ANY_NOT_NL:
            return `anynotnl -> ${this.out}`;
          default:
            throw new Error("unhandled case in Inst.toString");
        }
      }
    };
    W = class {
      constructor() {
        this.inst = null, this.cap = [];
      }
    };
    Y = class {
      constructor() {
        this.sparse = [], this.densePcs = [], this.denseThreads = [], this.size = 0;
      }
      contains(t6) {
        let e5 = this.sparse[t6];
        return e5 < this.size && this.densePcs[e5] === t6;
      }
      isEmpty() {
        return this.size === 0;
      }
      add(t6) {
        let e5 = this.size++;
        return this.sparse[t6] = e5, this.denseThreads[e5] = null, this.densePcs[e5] = t6, e5;
      }
      clear() {
        this.sparse = [], this.densePcs = [], this.denseThreads = [], this.size = 0;
      }
      toString() {
        let t6 = "{";
        for (let e5 = 0; e5 < this.size; e5++) e5 !== 0 && (t6 += ", "), t6 += this.densePcs[e5];
        return t6 += "}", t6;
      }
    };
    M = class n5 {
      static fromRE2(t6) {
        let e5 = new n5();
        return e5.prog = t6.prog, e5.re2 = t6, e5.q0 = new Y(e5.prog.numInst()), e5.q1 = new Y(e5.prog.numInst()), e5.pool = [], e5.poolSize = 0, e5.matched = false, e5.matchcap = Array(e5.prog.numCap < 2 ? 2 : e5.prog.numCap).fill(0), e5.ncap = 0, e5;
      }
      static fromMachine(t6) {
        let e5 = new n5();
        return e5.re2 = t6.re2, e5.prog = t6.prog, e5.q0 = t6.q0, e5.q1 = t6.q1, e5.pool = t6.pool, e5.poolSize = t6.poolSize, e5.matched = t6.matched, e5.matchcap = t6.matchcap, e5.ncap = t6.ncap, e5;
      }
      init(t6) {
        this.ncap = t6, t6 > this.matchcap.length ? this.initNewCap(t6) : this.resetCap(t6);
      }
      resetCap(t6) {
        for (let e5 = 0; e5 < this.poolSize; e5++) {
          let s9 = this.pool[e5];
          s9.cap = Array(t6).fill(0);
        }
      }
      initNewCap(t6) {
        for (let e5 = 0; e5 < this.poolSize; e5++) {
          let s9 = this.pool[e5];
          s9.cap = Array(t6).fill(0);
        }
        this.matchcap = Array(t6).fill(0);
      }
      submatches() {
        return this.ncap === 0 ? O.emptyInts() : this.matchcap.slice(0, this.ncap);
      }
      alloc(t6) {
        let e5;
        return this.poolSize > 0 ? (this.poolSize--, e5 = this.pool[this.poolSize]) : e5 = new W(), e5.inst = t6, e5;
      }
      freeQueue(t6, e5 = 0) {
        let s9 = t6.size - e5, i10 = this.poolSize + s9;
        this.pool.length < i10 && (this.pool = this.pool.slice(0, Math.max(this.pool.length * 2, i10)));
        for (let r8 = e5; r8 < t6.size; r8++) {
          let o9 = t6.denseThreads[r8];
          o9 !== null && (this.pool[this.poolSize] = o9, this.poolSize++);
        }
        t6.clear();
      }
      freeThread(t6) {
        this.pool.length <= this.poolSize && (this.pool = this.pool.slice(0, this.pool.length * 2)), this.pool[this.poolSize] = t6, this.poolSize++;
      }
      match(t6, e5, s9) {
        let i10 = this.re2.cond;
        if (i10 === O.EMPTY_ALL || (s9 === g.ANCHOR_START || s9 === g.ANCHOR_BOTH) && e5 !== 0) return false;
        this.matched = false, this.matchcap = Array(this.prog.numCap).fill(-1);
        let r8 = this.q0, o9 = this.q1, l8 = t6.step(e5), h16 = l8 >> 3, p17 = l8 & 7, f11 = -1, A13 = 0;
        l8 !== L.EOF() && (l8 = t6.step(e5 + p17), f11 = l8 >> 3, A13 = l8 & 7);
        let T10;
        for (e5 === 0 ? T10 = O.emptyOpContext(-1, h16) : T10 = t6.context(e5); ; ) {
          if (r8.isEmpty()) {
            if ((i10 & O.EMPTY_BEGIN_TEXT) !== 0 && e5 !== 0 || this.matched) break;
            if (this.re2.prefix.length !== 0 && f11 !== this.re2.prefixRune && t6.canCheckPrefix()) {
              let R13 = t6.index(this.re2, e5);
              if (R13 < 0) break;
              e5 += R13, l8 = t6.step(e5), h16 = l8 >> 3, p17 = l8 & 7, l8 = t6.step(e5 + p17), f11 = l8 >> 3, A13 = l8 & 7;
            }
          }
          !this.matched && (e5 === 0 || s9 === g.UNANCHORED) && (this.ncap > 0 && (this.matchcap[0] = e5), this.add(r8, this.prog.start, e5, this.matchcap, T10, null));
          let C19 = e5 + p17;
          if (T10 = t6.context(C19), this.step(r8, o9, e5, C19, h16, T10, s9, e5 === t6.endPos()), p17 === 0 || this.ncap === 0 && this.matched) break;
          e5 += p17, h16 = f11, p17 = A13, h16 !== -1 && (l8 = t6.step(e5 + p17), f11 = l8 >> 3, A13 = l8 & 7);
          let S16 = r8;
          r8 = o9, o9 = S16;
        }
        return this.freeQueue(o9), this.matched;
      }
      step(t6, e5, s9, i10, r8, o9, l8, h16) {
        let p17 = this.re2.longest;
        for (let f11 = 0; f11 < t6.size; f11++) {
          let A13 = t6.denseThreads[f11];
          if (A13 === null) continue;
          if (p17 && this.matched && this.ncap > 0 && this.matchcap[0] < A13.cap[0]) {
            this.freeThread(A13);
            continue;
          }
          let T10 = A13.inst, C19 = false;
          switch (T10.op) {
            case E.MATCH:
              if (l8 === g.ANCHOR_BOTH && !h16) break;
              this.ncap > 0 && (!p17 || !this.matched || this.matchcap[1] < s9) && (A13.cap[1] = s9, this.matchcap = A13.cap.slice(0, this.ncap)), p17 || this.freeQueue(t6, f11 + 1), this.matched = true;
              break;
            case E.RUNE:
              C19 = T10.matchRune(r8);
              break;
            case E.RUNE1:
              C19 = r8 === T10.runes[0];
              break;
            case E.RUNE_ANY:
              C19 = true;
              break;
            case E.RUNE_ANY_NOT_NL:
              C19 = r8 !== u.CODES.get(`
`);
              break;
            default:
              throw new Error("bad inst");
          }
          C19 && (A13 = this.add(e5, T10.out, i10, A13.cap, o9, A13)), A13 !== null && (this.freeThread(A13), t6.denseThreads[f11] = null);
        }
        t6.clear();
      }
      add(t6, e5, s9, i10, r8, o9) {
        if (e5 === 0 || t6.contains(e5)) return o9;
        let l8 = t6.add(e5), h16 = this.prog.inst[e5];
        switch (h16.op) {
          case E.FAIL:
            break;
          case E.ALT:
          case E.ALT_MATCH:
            o9 = this.add(t6, h16.out, s9, i10, r8, o9), o9 = this.add(t6, h16.arg, s9, i10, r8, o9);
            break;
          case E.EMPTY_WIDTH:
            (h16.arg & ~r8) === 0 && (o9 = this.add(t6, h16.out, s9, i10, r8, o9));
            break;
          case E.NOP:
            o9 = this.add(t6, h16.out, s9, i10, r8, o9);
            break;
          case E.CAPTURE:
            if (h16.arg < this.ncap) {
              let p17 = i10[h16.arg];
              i10[h16.arg] = s9, this.add(t6, h16.out, s9, i10, r8, null), i10[h16.arg] = p17;
            } else o9 = this.add(t6, h16.out, s9, i10, r8, o9);
            break;
          case E.MATCH:
          case E.RUNE:
          case E.RUNE1:
          case E.RUNE_ANY:
          case E.RUNE_ANY_NOT_NL:
            o9 === null ? o9 = this.alloc(h16) : o9.inst = h16, this.ncap > 0 && o9.cap !== i10 && (o9.cap = i10.slice(0, this.ncap)), t6.denseThreads[l8] = o9, o9 = null;
            break;
          default:
            throw new Error("unhandled");
        }
        return o9;
      }
    };
    c = class n6 {
      static Op = R1(["NO_MATCH", "EMPTY_MATCH", "LITERAL", "CHAR_CLASS", "ANY_CHAR_NOT_NL", "ANY_CHAR", "BEGIN_LINE", "END_LINE", "BEGIN_TEXT", "END_TEXT", "WORD_BOUNDARY", "NO_WORD_BOUNDARY", "CAPTURE", "STAR", "PLUS", "QUEST", "REPEAT", "CONCAT", "ALTERNATE", "LEFT_PAREN", "VERTICAL_BAR"]);
      static isPseudoOp(t6) {
        return t6 >= n6.Op.LEFT_PAREN;
      }
      static emptySubs() {
        return [];
      }
      static quoteIfHyphen(t6) {
        return t6 === u.CODES.get("-") ? "\\" : "";
      }
      static fromRegexp(t6) {
        let e5 = new n6(t6.op);
        return e5.flags = t6.flags, e5.subs = t6.subs, e5.runes = t6.runes, e5.cap = t6.cap, e5.min = t6.min, e5.max = t6.max, e5.name = t6.name, e5.namedGroups = t6.namedGroups, e5;
      }
      constructor(t6) {
        this.op = t6, this.flags = 0, this.subs = n6.emptySubs(), this.runes = [], this.min = 0, this.max = 0, this.cap = 0, this.name = null, this.namedGroups = {};
      }
      reinit() {
        this.flags = 0, this.subs = n6.emptySubs(), this.runes = [], this.cap = 0, this.min = 0, this.max = 0, this.name = null, this.namedGroups = {};
      }
      toString() {
        return this.appendTo();
      }
      appendTo() {
        let t6 = "";
        switch (this.op) {
          case n6.Op.NO_MATCH:
            t6 += "[^\\x00-\\x{10FFFF}]";
            break;
          case n6.Op.EMPTY_MATCH:
            t6 += "(?:)";
            break;
          case n6.Op.STAR:
          case n6.Op.PLUS:
          case n6.Op.QUEST:
          case n6.Op.REPEAT: {
            let e5 = this.subs[0];
            switch (e5.op > n6.Op.CAPTURE || e5.op === n6.Op.LITERAL && e5.runes.length > 1 ? t6 += `(?:${e5.appendTo()})` : t6 += e5.appendTo(), this.op) {
              case n6.Op.STAR:
                t6 += "*";
                break;
              case n6.Op.PLUS:
                t6 += "+";
                break;
              case n6.Op.QUEST:
                t6 += "?";
                break;
              case n6.Op.REPEAT:
                t6 += `{${this.min}`, this.min !== this.max && (t6 += ",", this.max >= 0 && (t6 += this.max)), t6 += "}";
                break;
            }
            (this.flags & g.NON_GREEDY) !== 0 && (t6 += "?");
            break;
          }
          case n6.Op.CONCAT: {
            for (let e5 of this.subs) e5.op === n6.Op.ALTERNATE ? t6 += `(?:${e5.appendTo()})` : t6 += e5.appendTo();
            break;
          }
          case n6.Op.ALTERNATE: {
            let e5 = "";
            for (let s9 of this.subs) t6 += e5, e5 = "|", t6 += s9.appendTo();
            break;
          }
          case n6.Op.LITERAL:
            (this.flags & g.FOLD_CASE) !== 0 && (t6 += "(?i:");
            for (let e5 of this.runes) t6 += O.escapeRune(e5);
            (this.flags & g.FOLD_CASE) !== 0 && (t6 += ")");
            break;
          case n6.Op.ANY_CHAR_NOT_NL:
            t6 += "(?-s:.)";
            break;
          case n6.Op.ANY_CHAR:
            t6 += "(?s:.)";
            break;
          case n6.Op.CAPTURE:
            this.name === null || this.name.length === 0 ? t6 += "(" : t6 += `(?P<${this.name}>`, this.subs[0].op !== n6.Op.EMPTY_MATCH && (t6 += this.subs[0].appendTo()), t6 += ")";
            break;
          case n6.Op.BEGIN_TEXT:
            t6 += "\\A";
            break;
          case n6.Op.END_TEXT:
            (this.flags & g.WAS_DOLLAR) !== 0 ? t6 += "(?-m:$)" : t6 += "\\z";
            break;
          case n6.Op.BEGIN_LINE:
            t6 += "^";
            break;
          case n6.Op.END_LINE:
            t6 += "$";
            break;
          case n6.Op.WORD_BOUNDARY:
            t6 += "\\b";
            break;
          case n6.Op.NO_WORD_BOUNDARY:
            t6 += "\\B";
            break;
          case n6.Op.CHAR_CLASS:
            if (this.runes.length % 2 !== 0) {
              t6 += "[invalid char class]";
              break;
            }
            if (t6 += "[", this.runes.length === 0) t6 += "^\\x00-\\x{10FFFF}";
            else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === w.MAX_RUNE) {
              t6 += "^";
              for (let e5 = 1; e5 < this.runes.length - 1; e5 += 2) {
                let s9 = this.runes[e5] + 1, i10 = this.runes[e5 + 1] - 1;
                t6 += n6.quoteIfHyphen(s9), t6 += O.escapeRune(s9), s9 !== i10 && (t6 += "-", t6 += n6.quoteIfHyphen(i10), t6 += O.escapeRune(i10));
              }
            } else for (let e5 = 0; e5 < this.runes.length; e5 += 2) {
              let s9 = this.runes[e5], i10 = this.runes[e5 + 1];
              t6 += n6.quoteIfHyphen(s9), t6 += O.escapeRune(s9), s9 !== i10 && (t6 += "-", t6 += n6.quoteIfHyphen(i10), t6 += O.escapeRune(i10));
            }
            t6 += "]";
            break;
          default:
            t6 += this.op;
            break;
        }
        return t6;
      }
      maxCap() {
        let t6 = 0;
        if (this.op === n6.Op.CAPTURE && (t6 = this.cap), this.subs !== null) for (let e5 of this.subs) {
          let s9 = e5.maxCap();
          t6 < s9 && (t6 = s9);
        }
        return t6;
      }
      equals(t6) {
        if (!(t6 !== null && t6 instanceof n6) || this.op !== t6.op) return false;
        switch (this.op) {
          case n6.Op.END_TEXT: {
            if ((this.flags & g.WAS_DOLLAR) !== (t6.flags & g.WAS_DOLLAR)) return false;
            break;
          }
          case n6.Op.LITERAL:
          case n6.Op.CHAR_CLASS: {
            if (this.runes === null && t6.runes === null) break;
            if (this.runes === null || t6.runes === null || this.runes.length !== t6.runes.length) return false;
            for (let e5 = 0; e5 < this.runes.length; e5++) if (this.runes[e5] !== t6.runes[e5]) return false;
            break;
          }
          case n6.Op.ALTERNATE:
          case n6.Op.CONCAT: {
            if (this.subs.length !== t6.subs.length) return false;
            for (let e5 = 0; e5 < this.subs.length; ++e5) if (!this.subs[e5].equals(t6.subs[e5])) return false;
            break;
          }
          case n6.Op.STAR:
          case n6.Op.PLUS:
          case n6.Op.QUEST: {
            if ((this.flags & g.NON_GREEDY) !== (t6.flags & g.NON_GREEDY) || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
          case n6.Op.REPEAT: {
            if ((this.flags & g.NON_GREEDY) !== (t6.flags & g.NON_GREEDY) || this.min !== t6.min || this.max !== t6.max || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
          case n6.Op.CAPTURE: {
            if (this.cap !== t6.cap || (this.name === null ? t6.name !== null : this.name !== t6.name) || !this.subs[0].equals(t6.subs[0])) return false;
            break;
          }
        }
        return true;
      }
    };
    q = class {
      constructor() {
        this.inst = [], this.start = 0, this.numCap = 2;
      }
      getInst(t6) {
        return this.inst[t6];
      }
      numInst() {
        return this.inst.length;
      }
      addInst(t6) {
        this.inst.push(new E(t6));
      }
      skipNop(t6) {
        let e5 = this.inst[t6];
        for (; e5.op === E.NOP || e5.op === E.CAPTURE; ) e5 = this.inst[t6], t6 = e5.out;
        return e5;
      }
      prefix() {
        let t6 = "", e5 = this.skipNop(this.start);
        if (!E.isRuneOp(e5.op) || e5.runes.length !== 1) return [e5.op === E.MATCH, t6];
        for (; E.isRuneOp(e5.op) && e5.runes.length === 1 && (e5.arg & g.FOLD_CASE) === 0; ) t6 += String.fromCodePoint(e5.runes[0]), e5 = this.skipNop(e5.out);
        return [e5.op === E.MATCH, t6];
      }
      startCond() {
        let t6 = 0, e5 = this.start;
        t: for (; ; ) {
          let s9 = this.inst[e5];
          switch (s9.op) {
            case E.EMPTY_WIDTH:
              t6 |= s9.arg;
              break;
            case E.FAIL:
              return -1;
            case E.CAPTURE:
            case E.NOP:
              break;
            default:
              break t;
          }
          e5 = s9.out;
        }
        return t6;
      }
      next(t6) {
        let e5 = this.inst[t6 >> 1];
        return (t6 & 1) === 0 ? e5.out : e5.arg;
      }
      patch(t6, e5) {
        for (; t6 !== 0; ) {
          let s9 = this.inst[t6 >> 1];
          (t6 & 1) === 0 ? (t6 = s9.out, s9.out = e5) : (t6 = s9.arg, s9.arg = e5);
        }
      }
      append(t6, e5) {
        if (t6 === 0) return e5;
        if (e5 === 0) return t6;
        let s9 = t6;
        for (; ; ) {
          let r8 = this.next(s9);
          if (r8 === 0) break;
          s9 = r8;
        }
        let i10 = this.inst[s9 >> 1];
        return (s9 & 1) === 0 ? i10.out = e5 : i10.arg = e5, t6;
      }
      toString() {
        let t6 = "";
        for (let e5 = 0; e5 < this.inst.length; e5++) {
          let s9 = t6.length;
          t6 += e5, e5 === this.start && (t6 += "*"), t6 += "        ".substring(t6.length - s9), t6 += this.inst[e5], t6 += `
`;
        }
        return t6;
      }
    };
    D = class {
      constructor(t6 = 0, e5 = 0, s9 = false) {
        this.i = t6, this.out = e5, this.nullable = s9;
      }
    };
    K = class n7 {
      static ANY_RUNE_NOT_NL() {
        return [0, u.CODES.get(`
`) - 1, u.CODES.get(`
`) + 1, w.MAX_RUNE];
      }
      static ANY_RUNE() {
        return [0, w.MAX_RUNE];
      }
      static compileRegexp(t6) {
        let e5 = new n7(), s9 = e5.compile(t6);
        return e5.prog.patch(s9.out, e5.newInst(E.MATCH).i), e5.prog.start = s9.i, e5.prog;
      }
      constructor() {
        this.prog = new q(), this.newInst(E.FAIL);
      }
      newInst(t6) {
        return this.prog.addInst(t6), new D(this.prog.numInst() - 1, 0, true);
      }
      nop() {
        let t6 = this.newInst(E.NOP);
        return t6.out = t6.i << 1, t6;
      }
      fail() {
        return new D();
      }
      cap(t6) {
        let e5 = this.newInst(E.CAPTURE);
        return e5.out = e5.i << 1, this.prog.getInst(e5.i).arg = t6, this.prog.numCap < t6 + 1 && (this.prog.numCap = t6 + 1), e5;
      }
      cat(t6, e5) {
        return t6.i === 0 || e5.i === 0 ? this.fail() : (this.prog.patch(t6.out, e5.i), new D(t6.i, e5.out, t6.nullable && e5.nullable));
      }
      alt(t6, e5) {
        if (t6.i === 0) return e5;
        if (e5.i === 0) return t6;
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return i10.out = t6.i, i10.arg = e5.i, s9.out = this.prog.append(t6.out, e5.out), s9.nullable = t6.nullable || e5.nullable, s9;
      }
      loop(t6, e5) {
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return e5 ? (i10.arg = t6.i, s9.out = s9.i << 1) : (i10.out = t6.i, s9.out = s9.i << 1 | 1), this.prog.patch(t6.out, s9.i), s9;
      }
      quest(t6, e5) {
        let s9 = this.newInst(E.ALT), i10 = this.prog.getInst(s9.i);
        return e5 ? (i10.arg = t6.i, s9.out = s9.i << 1) : (i10.out = t6.i, s9.out = s9.i << 1 | 1), s9.out = this.prog.append(s9.out, t6.out), s9;
      }
      star(t6, e5) {
        return t6.nullable ? this.quest(this.plus(t6, e5), e5) : this.loop(t6, e5);
      }
      plus(t6, e5) {
        return new D(t6.i, this.loop(t6, e5).out, t6.nullable);
      }
      empty(t6) {
        let e5 = this.newInst(E.EMPTY_WIDTH);
        return this.prog.getInst(e5.i).arg = t6, e5.out = e5.i << 1, e5;
      }
      rune(t6, e5) {
        let s9 = this.newInst(E.RUNE);
        s9.nullable = false;
        let i10 = this.prog.getInst(s9.i);
        return i10.runes = t6, e5 &= g.FOLD_CASE, (t6.length !== 1 || w.simpleFold(t6[0]) === t6[0]) && (e5 &= -2), i10.arg = e5, s9.out = s9.i << 1, (e5 & g.FOLD_CASE) === 0 && t6.length === 1 || t6.length === 2 && t6[0] === t6[1] ? i10.op = E.RUNE1 : t6.length === 2 && t6[0] === 0 && t6[1] === w.MAX_RUNE ? i10.op = E.RUNE_ANY : t6.length === 4 && t6[0] === 0 && t6[1] === u.CODES.get(`
`) - 1 && t6[2] === u.CODES.get(`
`) + 1 && t6[3] === w.MAX_RUNE && (i10.op = E.RUNE_ANY_NOT_NL), s9;
      }
      compile(t6) {
        switch (t6.op) {
          case c.Op.NO_MATCH:
            return this.fail();
          case c.Op.EMPTY_MATCH:
            return this.nop();
          case c.Op.LITERAL:
            if (t6.runes.length === 0) return this.nop();
            {
              let e5 = null;
              for (let s9 of t6.runes) {
                let i10 = this.rune([s9], t6.flags);
                e5 = e5 === null ? i10 : this.cat(e5, i10);
              }
              return e5;
            }
          case c.Op.CHAR_CLASS:
            return this.rune(t6.runes, t6.flags);
          case c.Op.ANY_CHAR_NOT_NL:
            return this.rune(n7.ANY_RUNE_NOT_NL(), 0);
          case c.Op.ANY_CHAR:
            return this.rune(n7.ANY_RUNE(), 0);
          case c.Op.BEGIN_LINE:
            return this.empty(O.EMPTY_BEGIN_LINE);
          case c.Op.END_LINE:
            return this.empty(O.EMPTY_END_LINE);
          case c.Op.BEGIN_TEXT:
            return this.empty(O.EMPTY_BEGIN_TEXT);
          case c.Op.END_TEXT:
            return this.empty(O.EMPTY_END_TEXT);
          case c.Op.WORD_BOUNDARY:
            return this.empty(O.EMPTY_WORD_BOUNDARY);
          case c.Op.NO_WORD_BOUNDARY:
            return this.empty(O.EMPTY_NO_WORD_BOUNDARY);
          case c.Op.CAPTURE: {
            let e5 = this.cap(t6.cap << 1), s9 = this.compile(t6.subs[0]), i10 = this.cap(t6.cap << 1 | 1);
            return this.cat(this.cat(e5, s9), i10);
          }
          case c.Op.STAR:
            return this.star(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.PLUS:
            return this.plus(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.QUEST:
            return this.quest(this.compile(t6.subs[0]), (t6.flags & g.NON_GREEDY) !== 0);
          case c.Op.CONCAT: {
            if (t6.subs.length === 0) return this.nop();
            {
              let e5 = null;
              for (let s9 of t6.subs) {
                let i10 = this.compile(s9);
                e5 = e5 === null ? i10 : this.cat(e5, i10);
              }
              return e5;
            }
          }
          case c.Op.ALTERNATE: {
            if (t6.subs.length === 0) return this.nop();
            {
              let e5 = null;
              for (let s9 of t6.subs) {
                let i10 = this.compile(s9);
                e5 = e5 === null ? i10 : this.alt(e5, i10);
              }
              return e5;
            }
          }
          default:
            throw new v("regexp: unhandled case in compile");
        }
      }
    };
    Z = class n8 {
      static simplify(t6) {
        if (t6 === null) return null;
        switch (t6.op) {
          case c.Op.CAPTURE:
          case c.Op.CONCAT:
          case c.Op.ALTERNATE: {
            let e5 = t6;
            for (let s9 = 0; s9 < t6.subs.length; s9++) {
              let i10 = t6.subs[s9], r8 = n8.simplify(i10);
              e5 === t6 && r8 !== i10 && (e5 = c.fromRegexp(t6), e5.runes = [], e5.subs = t6.subs.slice(0, t6.subs.length)), e5 !== t6 && (e5.subs[s9] = r8);
            }
            return e5;
          }
          case c.Op.STAR:
          case c.Op.PLUS:
          case c.Op.QUEST: {
            let e5 = n8.simplify(t6.subs[0]);
            return n8.simplify1(t6.op, t6.flags, e5, t6);
          }
          case c.Op.REPEAT: {
            if (t6.min === 0 && t6.max === 0) return new c(c.Op.EMPTY_MATCH);
            let e5 = n8.simplify(t6.subs[0]);
            if (t6.max === -1) {
              if (t6.min === 0) return n8.simplify1(c.Op.STAR, t6.flags, e5, null);
              if (t6.min === 1) return n8.simplify1(c.Op.PLUS, t6.flags, e5, null);
              let i10 = new c(c.Op.CONCAT), r8 = [];
              for (let o9 = 0; o9 < t6.min - 1; o9++) r8.push(e5);
              return r8.push(n8.simplify1(c.Op.PLUS, t6.flags, e5, null)), i10.subs = r8.slice(0), i10;
            }
            if (t6.min === 1 && t6.max === 1) return e5;
            let s9 = null;
            if (t6.min > 0) {
              s9 = [];
              for (let i10 = 0; i10 < t6.min; i10++) s9.push(e5);
            }
            if (t6.max > t6.min) {
              let i10 = n8.simplify1(c.Op.QUEST, t6.flags, e5, null);
              for (let r8 = t6.min + 1; r8 < t6.max; r8++) {
                let o9 = new c(c.Op.CONCAT);
                o9.subs = [e5, i10], i10 = n8.simplify1(c.Op.QUEST, t6.flags, o9, null);
              }
              if (s9 === null) return i10;
              s9.push(i10);
            }
            if (s9 !== null) {
              let i10 = new c(c.Op.CONCAT);
              return i10.subs = s9.slice(0), i10;
            }
            return new c(c.Op.NO_MATCH);
          }
        }
        return t6;
      }
      static simplify1(t6, e5, s9, i10) {
        return s9.op === c.Op.EMPTY_MATCH || t6 === s9.op && (e5 & g.NON_GREEDY) === (s9.flags & g.NON_GREEDY) ? s9 : (i10 !== null && i10.op === t6 && (i10.flags & g.NON_GREEDY) === (e5 & g.NON_GREEDY) && s9 === i10.subs[0] || (i10 = new c(t6), i10.flags = e5, i10.subs = [s9]), i10);
      }
    };
    d = class {
      constructor(t6, e5) {
        this.sign = t6, this.cls = e5;
      }
    };
    n1 = [48, 57];
    r1 = [9, 10, 12, 13, 32, 32];
    a1 = [48, 57, 65, 90, 95, 95, 97, 122];
    o1 = /* @__PURE__ */ new Map([["\\d", new d(1, n1)], ["\\D", new d(-1, n1)], ["\\s", new d(1, r1)], ["\\S", new d(-1, r1)], ["\\w", new d(1, a1)], ["\\W", new d(-1, a1)]]);
    l1 = [48, 57, 65, 90, 97, 122];
    h1 = [65, 90, 97, 122];
    u1 = [0, 127];
    c1 = [9, 9, 32, 32];
    p1 = [0, 31, 127, 127];
    f1 = [48, 57];
    g1 = [33, 126];
    A1 = [97, 122];
    w1 = [32, 126];
    E1 = [33, 47, 58, 64, 91, 96, 123, 126];
    d1 = [9, 13, 32, 32];
    O1 = [65, 90];
    C1 = [48, 57, 65, 90, 95, 95, 97, 122];
    m1 = [48, 57, 65, 70, 97, 102];
    S1 = /* @__PURE__ */ new Map([["[:alnum:]", new d(1, l1)], ["[:^alnum:]", new d(-1, l1)], ["[:alpha:]", new d(1, h1)], ["[:^alpha:]", new d(-1, h1)], ["[:ascii:]", new d(1, u1)], ["[:^ascii:]", new d(-1, u1)], ["[:blank:]", new d(1, c1)], ["[:^blank:]", new d(-1, c1)], ["[:cntrl:]", new d(1, p1)], ["[:^cntrl:]", new d(-1, p1)], ["[:digit:]", new d(1, f1)], ["[:^digit:]", new d(-1, f1)], ["[:graph:]", new d(1, g1)], ["[:^graph:]", new d(-1, g1)], ["[:lower:]", new d(1, A1)], ["[:^lower:]", new d(-1, A1)], ["[:print:]", new d(1, w1)], ["[:^print:]", new d(-1, w1)], ["[:punct:]", new d(1, E1)], ["[:^punct:]", new d(-1, E1)], ["[:space:]", new d(1, d1)], ["[:^space:]", new d(-1, d1)], ["[:upper:]", new d(1, O1)], ["[:^upper:]", new d(-1, O1)], ["[:word:]", new d(1, C1)], ["[:^word:]", new d(-1, C1)], ["[:xdigit:]", new d(1, m1)], ["[:^xdigit:]", new d(-1, m1)]]);
    x = class n9 {
      static charClassToString(t6, e5) {
        let s9 = "[";
        for (let i10 = 0; i10 < e5; i10 += 2) {
          i10 > 0 && (s9 += " ");
          let r8 = t6[i10], o9 = t6[i10 + 1];
          r8 === o9 ? s9 += `0x${r8.toString(16)}` : s9 += `0x${r8.toString(16)}-0x${o9.toString(16)}`;
        }
        return s9 += "]", s9;
      }
      static cmp(t6, e5, s9, i10) {
        let r8 = t6[e5] - s9;
        return r8 !== 0 ? r8 : i10 - t6[e5 + 1];
      }
      static qsortIntPair(t6, e5, s9) {
        let i10 = ((e5 + s9) / 2 | 0) & -2, r8 = t6[i10], o9 = t6[i10 + 1], l8 = e5, h16 = s9;
        for (; l8 <= h16; ) {
          for (; l8 < s9 && n9.cmp(t6, l8, r8, o9) < 0; ) l8 += 2;
          for (; h16 > e5 && n9.cmp(t6, h16, r8, o9) > 0; ) h16 -= 2;
          if (l8 <= h16) {
            if (l8 !== h16) {
              let p17 = t6[l8];
              t6[l8] = t6[h16], t6[h16] = p17, p17 = t6[l8 + 1], t6[l8 + 1] = t6[h16 + 1], t6[h16 + 1] = p17;
            }
            l8 += 2, h16 -= 2;
          }
        }
        e5 < h16 && n9.qsortIntPair(t6, e5, h16), l8 < s9 && n9.qsortIntPair(t6, l8, s9);
      }
      constructor(t6 = O.emptyInts()) {
        this.r = t6, this.len = t6.length;
      }
      toArray() {
        return this.len === this.r.length ? this.r : this.r.slice(0, this.len);
      }
      cleanClass() {
        if (this.len < 4) return this;
        n9.qsortIntPair(this.r, 0, this.len - 2);
        let t6 = 2;
        for (let e5 = 2; e5 < this.len; e5 += 2) {
          let s9 = this.r[e5], i10 = this.r[e5 + 1];
          if (s9 <= this.r[t6 - 1] + 1) {
            i10 > this.r[t6 - 1] && (this.r[t6 - 1] = i10);
            continue;
          }
          this.r[t6] = s9, this.r[t6 + 1] = i10, t6 += 2;
        }
        return this.len = t6, this;
      }
      appendLiteral(t6, e5) {
        return (e5 & g.FOLD_CASE) !== 0 ? this.appendFoldedRange(t6, t6) : this.appendRange(t6, t6);
      }
      appendRange(t6, e5) {
        if (this.len > 0) {
          for (let s9 = 2; s9 <= 4; s9 += 2) if (this.len >= s9) {
            let i10 = this.r[this.len - s9], r8 = this.r[this.len - s9 + 1];
            if (t6 <= r8 + 1 && i10 <= e5 + 1) return t6 < i10 && (this.r[this.len - s9] = t6), e5 > r8 && (this.r[this.len - s9 + 1] = e5), this;
          }
        }
        return this.r[this.len++] = t6, this.r[this.len++] = e5, this;
      }
      appendFoldedRange(t6, e5) {
        if (t6 <= w.MIN_FOLD && e5 >= w.MAX_FOLD) return this.appendRange(t6, e5);
        if (e5 < w.MIN_FOLD || t6 > w.MAX_FOLD) return this.appendRange(t6, e5);
        t6 < w.MIN_FOLD && (this.appendRange(t6, w.MIN_FOLD - 1), t6 = w.MIN_FOLD), e5 > w.MAX_FOLD && (this.appendRange(w.MAX_FOLD + 1, e5), e5 = w.MAX_FOLD);
        for (let s9 = t6; s9 <= e5; s9++) {
          this.appendRange(s9, s9);
          for (let i10 = w.simpleFold(s9); i10 !== s9; i10 = w.simpleFold(i10)) this.appendRange(i10, i10);
        }
        return this;
      }
      appendClass(t6) {
        for (let e5 = 0; e5 < t6.length; e5 += 2) this.appendRange(t6[e5], t6[e5 + 1]);
        return this;
      }
      appendFoldedClass(t6) {
        for (let e5 = 0; e5 < t6.length; e5 += 2) this.appendFoldedRange(t6[e5], t6[e5 + 1]);
        return this;
      }
      appendNegatedClass(t6) {
        let e5 = 0;
        for (let s9 = 0; s9 < t6.length; s9 += 2) {
          let i10 = t6[s9], r8 = t6[s9 + 1];
          e5 <= i10 - 1 && this.appendRange(e5, i10 - 1), e5 = r8 + 1;
        }
        return e5 <= w.MAX_RUNE && this.appendRange(e5, w.MAX_RUNE), this;
      }
      appendTable(t6) {
        for (let e5 = 0; e5 < t6.length; ++e5) {
          let s9 = t6.getLo(e5), i10 = t6.getHi(e5), r8 = t6.getStride(e5);
          if (r8 === 1) {
            this.appendRange(s9, i10);
            continue;
          }
          for (let o9 = s9; o9 <= i10; o9 += r8) this.appendRange(o9, o9);
        }
        return this;
      }
      appendNegatedTable(t6) {
        let e5 = 0;
        for (let s9 = 0; s9 < t6.length; ++s9) {
          let i10 = t6.getLo(s9), r8 = t6.getHi(s9), o9 = t6.getStride(s9);
          if (o9 === 1) {
            e5 <= i10 - 1 && this.appendRange(e5, i10 - 1), e5 = r8 + 1;
            continue;
          }
          for (let l8 = i10; l8 <= r8; l8 += o9) e5 <= l8 - 1 && this.appendRange(e5, l8 - 1), e5 = l8 + 1;
        }
        return e5 <= w.MAX_RUNE && this.appendRange(e5, w.MAX_RUNE), this;
      }
      appendTableWithSign(t6, e5) {
        return e5 < 0 ? this.appendNegatedTable(t6) : this.appendTable(t6);
      }
      negateClass() {
        let t6 = 0, e5 = 0;
        for (let s9 = 0; s9 < this.len; s9 += 2) {
          let i10 = this.r[s9], r8 = this.r[s9 + 1];
          t6 <= i10 - 1 && (this.r[e5] = t6, this.r[e5 + 1] = i10 - 1, e5 += 2), t6 = r8 + 1;
        }
        return this.len = e5, t6 <= w.MAX_RUNE && (this.r[this.len++] = t6, this.r[this.len++] = w.MAX_RUNE), this;
      }
      appendClassWithSign(t6, e5) {
        return e5 < 0 ? this.appendNegatedClass(t6) : this.appendClass(t6);
      }
      appendGroup(t6, e5) {
        let s9 = t6.cls;
        return e5 && (s9 = new n9().appendFoldedClass(s9).cleanClass().toArray()), this.appendClassWithSign(s9, t6.sign);
      }
      toString() {
        return n9.charClassToString(this.r, this.len);
      }
    };
    H = class n10 {
      static of(t6, e5) {
        return new n10(t6, e5);
      }
      constructor(t6, e5) {
        this.first = t6, this.second = e5;
      }
    };
    Q = class {
      constructor(t6) {
        this.str = t6, this.position = 0;
      }
      pos() {
        return this.position;
      }
      rewindTo(t6) {
        this.position = t6;
      }
      more() {
        return this.position < this.str.length;
      }
      peek() {
        return this.str.codePointAt(this.position);
      }
      skip(t6) {
        this.position += t6;
      }
      skipString(t6) {
        this.position += t6.length;
      }
      pop() {
        let t6 = this.str.codePointAt(this.position);
        return this.position += O.charCount(t6), t6;
      }
      lookingAt(t6) {
        return this.rest().startsWith(t6);
      }
      rest() {
        return this.str.substring(this.position);
      }
      from(t6) {
        return this.str.substring(t6, this.position);
      }
      toString() {
        return this.rest();
      }
    };
    J = class n11 {
      static ERR_INTERNAL_ERROR = "regexp/syntax: internal error";
      static ERR_INVALID_CHAR_RANGE = "invalid character class range";
      static ERR_INVALID_ESCAPE = "invalid escape sequence";
      static ERR_INVALID_NAMED_CAPTURE = "invalid named capture";
      static ERR_INVALID_PERL_OP = "invalid or unsupported Perl syntax";
      static ERR_INVALID_REPEAT_OP = "invalid nested repetition operator";
      static ERR_INVALID_REPEAT_SIZE = "invalid repeat count";
      static ERR_MISSING_BRACKET = "missing closing ]";
      static ERR_MISSING_PAREN = "missing closing )";
      static ERR_MISSING_REPEAT_ARGUMENT = "missing argument to repetition operator";
      static ERR_TRAILING_BACKSLASH = "trailing backslash at end of expression";
      static ERR_DUPLICATE_NAMED_CAPTURE = "duplicate capture group name";
      static ERR_UNEXPECTED_PAREN = "unexpected )";
      static ERR_NESTING_DEPTH = "expression nests too deeply";
      static ERR_LARGE = "expression too large";
      static MAX_HEIGHT = 1e3;
      static MAX_SIZE = 3355443;
      static MAX_RUNES = 33554432;
      static ANY_TABLE = new a(new Uint32Array([0, w.MAX_RUNE, 1]));
      static unicodeTable(t6) {
        return t6 === "Any" ? H.of(n11.ANY_TABLE, n11.ANY_TABLE) : b.CATEGORIES.has(t6) ? H.of(b.CATEGORIES.get(t6), b.FOLD_CATEGORIES.get(t6)) : b.SCRIPTS.has(t6) ? H.of(b.SCRIPTS.get(t6), b.FOLD_SCRIPT.get(t6)) : null;
      }
      static minFoldRune(t6) {
        if (t6 < w.MIN_FOLD || t6 > w.MAX_FOLD) return t6;
        let e5 = t6, s9 = t6;
        for (t6 = w.simpleFold(t6); t6 !== s9; t6 = w.simpleFold(t6)) e5 > t6 && (e5 = t6);
        return e5;
      }
      static leadingRegexp(t6) {
        if (t6.op === c.Op.EMPTY_MATCH) return null;
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          let e5 = t6.subs[0];
          return e5.op === c.Op.EMPTY_MATCH ? null : e5;
        }
        return t6;
      }
      static literalRegexp(t6, e5) {
        let s9 = new c(c.Op.LITERAL);
        return s9.flags = e5, s9.runes = O.stringToRunes(t6), s9;
      }
      static parse(t6, e5) {
        return new n11(t6, e5).parseInternal();
      }
      static parseRepeat(t6) {
        let e5 = t6.pos();
        if (!t6.more() || !t6.lookingAt("{")) return -1;
        t6.skip(1);
        let s9 = n11.parseInt(t6);
        if (s9 === -1 || !t6.more()) return -1;
        let i10;
        if (!t6.lookingAt(",")) i10 = s9;
        else {
          if (t6.skip(1), !t6.more()) return -1;
          if (t6.lookingAt("}")) i10 = -1;
          else if ((i10 = n11.parseInt(t6)) === -1) return -1;
        }
        if (!t6.more() || !t6.lookingAt("}")) return -1;
        if (t6.skip(1), s9 < 0 || s9 > 1e3 || i10 === -2 || i10 > 1e3 || i10 >= 0 && s9 > i10) throw new m(n11.ERR_INVALID_REPEAT_SIZE, t6.from(e5));
        return s9 << 16 | i10 & w.MAX_BMP;
      }
      static isValidCaptureName(t6) {
        if (t6.length === 0) return false;
        for (let e5 = 0; e5 < t6.length; e5++) {
          let s9 = t6.codePointAt(e5);
          if (s9 !== u.CODES.get("_") && !O.isalnum(s9)) return false;
        }
        return true;
      }
      static parseInt(t6) {
        let e5 = t6.pos();
        for (; t6.more() && t6.peek() >= u.CODES.get("0") && t6.peek() <= u.CODES.get("9"); ) t6.skip(1);
        let s9 = t6.from(e5);
        return s9.length === 0 || s9.length > 1 && s9.codePointAt(0) === u.CODES.get("0") ? -1 : s9.length > 8 ? -2 : parseFloat(s9, 10);
      }
      static isCharClass(t6) {
        return t6.op === c.Op.LITERAL && t6.runes.length === 1 || t6.op === c.Op.CHAR_CLASS || t6.op === c.Op.ANY_CHAR_NOT_NL || t6.op === c.Op.ANY_CHAR;
      }
      static matchRune(t6, e5) {
        switch (t6.op) {
          case c.Op.LITERAL:
            return t6.runes.length === 1 && t6.runes[0] === e5;
          case c.Op.CHAR_CLASS:
            for (let s9 = 0; s9 < t6.runes.length; s9 += 2) if (t6.runes[s9] <= e5 && e5 <= t6.runes[s9 + 1]) return true;
            return false;
          case c.Op.ANY_CHAR_NOT_NL:
            return e5 !== u.CODES.get(`
`);
          case c.Op.ANY_CHAR:
            return true;
        }
        return false;
      }
      static mergeCharClass(t6, e5) {
        switch (t6.op) {
          case c.Op.ANY_CHAR:
            break;
          case c.Op.ANY_CHAR_NOT_NL:
            n11.matchRune(e5, u.CODES.get(`
`)) && (t6.op = c.Op.ANY_CHAR);
            break;
          case c.Op.CHAR_CLASS:
            e5.op === c.Op.LITERAL ? t6.runes = new x(t6.runes).appendLiteral(e5.runes[0], e5.flags).toArray() : t6.runes = new x(t6.runes).appendClass(e5.runes).toArray();
            break;
          case c.Op.LITERAL:
            if (e5.runes[0] === t6.runes[0] && e5.flags === t6.flags) break;
            t6.op = c.Op.CHAR_CLASS, t6.runes = new x().appendLiteral(t6.runes[0], t6.flags).appendLiteral(e5.runes[0], e5.flags).toArray();
            break;
        }
      }
      static parseEscape(t6) {
        let e5 = t6.pos();
        if (t6.skip(1), !t6.more()) throw new m(n11.ERR_TRAILING_BACKSLASH);
        let s9 = t6.pop();
        t: switch (s9) {
          case u.CODES.get("1"):
          case u.CODES.get("2"):
          case u.CODES.get("3"):
          case u.CODES.get("4"):
          case u.CODES.get("5"):
          case u.CODES.get("6"):
          case u.CODES.get("7"):
            if (!t6.more() || t6.peek() < u.CODES.get("0") || t6.peek() > u.CODES.get("7")) break;
          case u.CODES.get("0"): {
            let i10 = s9 - u.CODES.get("0");
            for (let r8 = 1; r8 < 3 && !(!t6.more() || t6.peek() < u.CODES.get("0") || t6.peek() > u.CODES.get("7")); r8++) i10 = i10 * 8 + t6.peek() - u.CODES.get("0"), t6.skip(1);
            return i10;
          }
          case u.CODES.get("x"): {
            if (!t6.more()) break;
            if (s9 = t6.pop(), s9 === u.CODES.get("{")) {
              let o9 = 0, l8 = 0;
              for (; ; ) {
                if (!t6.more()) break t;
                if (s9 = t6.pop(), s9 === u.CODES.get("}")) break;
                let h16 = O.unhex(s9);
                if (h16 < 0 || (l8 = l8 * 16 + h16, l8 > w.MAX_RUNE)) break t;
                o9++;
              }
              if (o9 === 0) break t;
              return l8;
            }
            let i10 = O.unhex(s9);
            if (!t6.more()) break;
            s9 = t6.pop();
            let r8 = O.unhex(s9);
            if (i10 < 0 || r8 < 0) break;
            return i10 * 16 + r8;
          }
          case u.CODES.get("a"):
            return u.CODES.get("\x07");
          case u.CODES.get("f"):
            return u.CODES.get("\f");
          case u.CODES.get("n"):
            return u.CODES.get(`
`);
          case u.CODES.get("r"):
            return u.CODES.get("\r");
          case u.CODES.get("t"):
            return u.CODES.get("	");
          case u.CODES.get("v"):
            return u.CODES.get("\v");
          default:
            if (s9 <= w.MAX_ASCII && !O.isalnum(s9)) return s9;
            break;
        }
        throw new m(n11.ERR_INVALID_ESCAPE, t6.from(e5));
      }
      static parseClassChar(t6, e5) {
        if (!t6.more()) throw new m(n11.ERR_MISSING_BRACKET, t6.from(e5));
        return t6.lookingAt("\\") ? n11.parseEscape(t6) : t6.pop();
      }
      static concatRunes(t6, e5) {
        return [...t6, ...e5];
      }
      constructor(t6, e5 = 0) {
        this.wholeRegexp = t6, this.flags = e5, this.numCap = 0, this.namedGroups = {}, this.stack = [], this.free = null, this.numRegexp = 0, this.numRunes = 0, this.repeats = 0, this.height = null, this.size = null;
      }
      newRegexp(t6) {
        let e5 = this.free;
        return e5 !== null && e5.subs !== null && e5.subs.length > 0 ? (this.free = e5.subs[0], e5.reinit(), e5.op = t6) : (e5 = new c(t6), this.numRegexp += 1), e5;
      }
      reuse(t6) {
        this.height !== null && Object.prototype.hasOwnProperty.call(this.height, t6) && delete this.height[t6], t6.subs !== null && t6.subs.length > 0 && (t6.subs[0] = this.free), this.free = t6;
      }
      checkLimits(t6) {
        if (this.numRunes > n11.MAX_RUNES) throw new m(n11.ERR_LARGE);
        this.checkSize(t6), this.checkHeight(t6);
      }
      checkSize(t6) {
        if (this.size === null) {
          if (this.repeats === 0 && (this.repeats = 1), t6.op === c.Op.REPEAT) {
            let e5 = t6.max;
            e5 === -1 && (e5 = t6.min), e5 <= 0 && (e5 = 1), e5 > n11.MAX_SIZE / this.repeats ? this.repeats = n11.MAX_SIZE : this.repeats *= e5;
          }
          if (this.numRegexp < n11.MAX_SIZE / this.repeats) return;
          this.size = {};
          for (let e5 of this.stack) this.checkSize(e5);
        }
        if (this.calcSize(t6, true) > n11.MAX_SIZE) throw new m(n11.ERR_LARGE);
      }
      calcSize(t6, e5 = false) {
        if (!e5 && Object.prototype.hasOwnProperty.call(this.size, t6)) return this.size[t6];
        let s9 = 0;
        switch (t6.op) {
          case c.Op.LITERAL: {
            s9 = t6.runes.length;
            break;
          }
          case c.Op.CAPTURE:
          case c.Op.STAR: {
            s9 = 2 + this.calcSize(t6.subs[0]);
            break;
          }
          case c.Op.PLUS:
          case c.Op.QUEST: {
            s9 = 1 + this.calcSize(t6.subs[0]);
            break;
          }
          case c.Op.CONCAT: {
            for (let i10 of t6.subs) s9 = s9 + this.calcSize(i10);
            break;
          }
          case c.Op.ALTERNATE: {
            for (let i10 of t6.subs) s9 = s9 + this.calcSize(i10);
            t6.subs.length > 1 && (s9 = s9 + t6.subs.length - 1);
            break;
          }
          case c.Op.REPEAT: {
            let i10 = this.calcSize(t6.subs[0]);
            if (t6.max === -1) {
              t6.min === 0 ? s9 = 2 + i10 : s9 = 1 + t6.min * i10;
              break;
            }
            s9 = t6.max * i10 + (t6.max - t6.min);
            break;
          }
        }
        return s9 = Math.max(1, s9), this.size[t6] = s9, s9;
      }
      checkHeight(t6) {
        if (!(this.numRegexp < n11.MAX_HEIGHT)) {
          if (this.height === null) {
            this.height = {};
            for (let e5 of this.stack) this.checkHeight(e5);
          }
          if (this.calcHeight(t6, true) > n11.MAX_HEIGHT) throw new m(n11.ERR_NESTING_DEPTH);
        }
      }
      calcHeight(t6, e5 = false) {
        if (!e5 && Object.prototype.hasOwnProperty.call(this.height, t6)) return this.height[t6];
        let s9 = 1;
        for (let i10 of t6.subs) {
          let r8 = this.calcHeight(i10);
          s9 < 1 + r8 && (s9 = 1 + r8);
        }
        return this.height[t6] = s9, s9;
      }
      pop() {
        return this.stack.pop();
      }
      popToPseudo() {
        let t6 = this.stack.length, e5 = t6;
        for (; e5 > 0 && !c.isPseudoOp(this.stack[e5 - 1].op); ) e5--;
        let s9 = this.stack.slice(e5, t6);
        return this.stack = this.stack.slice(0, e5), s9;
      }
      push(t6) {
        if (this.numRunes += t6.runes.length, t6.op === c.Op.CHAR_CLASS && t6.runes.length === 2 && t6.runes[0] === t6.runes[1]) {
          if (this.maybeConcat(t6.runes[0], this.flags & -2)) return null;
          t6.op = c.Op.LITERAL, t6.runes = [t6.runes[0]], t6.flags = this.flags & -2;
        } else if (t6.op === c.Op.CHAR_CLASS && t6.runes.length === 4 && t6.runes[0] === t6.runes[1] && t6.runes[2] === t6.runes[3] && w.simpleFold(t6.runes[0]) === t6.runes[2] && w.simpleFold(t6.runes[2]) === t6.runes[0] || t6.op === c.Op.CHAR_CLASS && t6.runes.length === 2 && t6.runes[0] + 1 === t6.runes[1] && w.simpleFold(t6.runes[0]) === t6.runes[1] && w.simpleFold(t6.runes[1]) === t6.runes[0]) {
          if (this.maybeConcat(t6.runes[0], this.flags | g.FOLD_CASE)) return null;
          t6.op = c.Op.LITERAL, t6.runes = [t6.runes[0]], t6.flags = this.flags | g.FOLD_CASE;
        } else this.maybeConcat(-1, 0);
        return this.stack.push(t6), this.checkLimits(t6), t6;
      }
      maybeConcat(t6, e5) {
        let s9 = this.stack.length;
        if (s9 < 2) return false;
        let i10 = this.stack[s9 - 1], r8 = this.stack[s9 - 2];
        return i10.op !== c.Op.LITERAL || r8.op !== c.Op.LITERAL || (i10.flags & g.FOLD_CASE) !== (r8.flags & g.FOLD_CASE) ? false : (r8.runes = n11.concatRunes(r8.runes, i10.runes), t6 >= 0 ? (i10.runes = [t6], i10.flags = e5, true) : (this.pop(), this.reuse(i10), false));
      }
      newLiteral(t6, e5) {
        let s9 = this.newRegexp(c.Op.LITERAL);
        return s9.flags = e5, (e5 & g.FOLD_CASE) !== 0 && (t6 = n11.minFoldRune(t6)), s9.runes = [t6], s9;
      }
      literal(t6) {
        this.push(this.newLiteral(t6, this.flags));
      }
      op(t6) {
        let e5 = this.newRegexp(t6);
        return e5.flags = this.flags, this.push(e5);
      }
      repeat(t6, e5, s9, i10, r8, o9) {
        let l8 = this.flags;
        if ((l8 & g.PERL_X) !== 0 && (r8.more() && r8.lookingAt("?") && (r8.skip(1), l8 ^= g.NON_GREEDY), o9 !== -1)) throw new m(n11.ERR_INVALID_REPEAT_OP, r8.from(o9));
        let h16 = this.stack.length;
        if (h16 === 0) throw new m(n11.ERR_MISSING_REPEAT_ARGUMENT, r8.from(i10));
        let p17 = this.stack[h16 - 1];
        if (c.isPseudoOp(p17.op)) throw new m(n11.ERR_MISSING_REPEAT_ARGUMENT, r8.from(i10));
        let f11 = this.newRegexp(t6);
        if (f11.min = e5, f11.max = s9, f11.flags = l8, f11.subs = [p17], this.stack[h16 - 1] = f11, this.checkLimits(f11), t6 === c.Op.REPEAT && (e5 >= 2 || s9 >= 2) && !this.repeatIsValid(f11, 1e3)) throw new m(n11.ERR_INVALID_REPEAT_SIZE, r8.from(i10));
      }
      repeatIsValid(t6, e5) {
        if (t6.op === c.Op.REPEAT) {
          let s9 = t6.max;
          if (s9 === 0) return true;
          if (s9 < 0 && (s9 = t6.min), s9 > e5) return false;
          s9 > 0 && (e5 = Math.trunc(e5 / s9));
        }
        for (let s9 of t6.subs) if (!this.repeatIsValid(s9, e5)) return false;
        return true;
      }
      concat() {
        this.maybeConcat(-1, 0);
        let t6 = this.popToPseudo();
        return t6.length === 0 ? this.push(this.newRegexp(c.Op.EMPTY_MATCH)) : this.push(this.collapse(t6, c.Op.CONCAT));
      }
      alternate() {
        let t6 = this.popToPseudo();
        return t6.length > 0 && this.cleanAlt(t6[t6.length - 1]), t6.length === 0 ? this.push(this.newRegexp(c.Op.NO_MATCH)) : this.push(this.collapse(t6, c.Op.ALTERNATE));
      }
      cleanAlt(t6) {
        t6.op === c.Op.CHAR_CLASS && (t6.runes = new x(t6.runes).cleanClass().toArray(), t6.runes.length === 2 && t6.runes[0] === 0 && t6.runes[1] === w.MAX_RUNE ? (t6.runes = [], t6.op = c.Op.ANY_CHAR) : t6.runes.length === 4 && t6.runes[0] === 0 && t6.runes[1] === u.CODES.get(`
`) - 1 && t6.runes[2] === u.CODES.get(`
`) + 1 && t6.runes[3] === w.MAX_RUNE && (t6.runes = [], t6.op = c.Op.ANY_CHAR_NOT_NL));
      }
      collapse(t6, e5) {
        if (t6.length === 1) return t6[0];
        let s9 = 0;
        for (let l8 of t6) s9 += l8.op === e5 ? l8.subs.length : 1;
        let i10 = new Array(s9).fill(null), r8 = 0;
        for (let l8 of t6) l8.op === e5 ? (i10.splice(r8, l8.subs.length, ...l8.subs), r8 += l8.subs.length, this.reuse(l8)) : i10[r8++] = l8;
        let o9 = this.newRegexp(e5);
        if (o9.subs = i10, e5 === c.Op.ALTERNATE && (o9.subs = this.factor(o9.subs), o9.subs.length === 1)) {
          let l8 = o9;
          o9 = o9.subs[0], this.reuse(l8);
        }
        return o9;
      }
      factor(t6) {
        if (t6.length < 2) return t6;
        let e5 = 0, s9 = t6.length, i10 = 0, r8 = null, o9 = 0, l8 = 0, h16 = 0;
        for (let f11 = 0; f11 <= s9; f11++) {
          let A13 = null, T10 = 0, C19 = 0;
          if (f11 < s9) {
            let S16 = t6[e5 + f11];
            if (S16.op === c.Op.CONCAT && S16.subs.length > 0 && (S16 = S16.subs[0]), S16.op === c.Op.LITERAL && (A13 = S16.runes, T10 = S16.runes.length, C19 = S16.flags & g.FOLD_CASE), C19 === l8) {
              let R13 = 0;
              for (; R13 < o9 && R13 < T10 && r8[R13] === A13[R13]; ) R13++;
              if (R13 > 0) {
                o9 = R13;
                continue;
              }
            }
          }
          if (f11 !== h16) if (f11 === h16 + 1) t6[i10++] = t6[e5 + h16];
          else {
            let S16 = this.newRegexp(c.Op.LITERAL);
            S16.flags = l8, S16.runes = r8.slice(0, o9);
            for (let k15 = h16; k15 < f11; k15++) t6[e5 + k15] = this.removeLeadingString(t6[e5 + k15], o9), this.checkLimits(t6[e5 + k15]);
            let R13 = this.collapse(t6.slice(e5 + h16, e5 + f11), c.Op.ALTERNATE), G8 = this.newRegexp(c.Op.CONCAT);
            G8.subs = [S16, R13], t6[i10++] = G8;
          }
          h16 = f11, r8 = A13, o9 = T10, l8 = C19;
        }
        s9 = i10, e5 = 0, h16 = 0, i10 = 0;
        let p17 = null;
        for (let f11 = 0; f11 <= s9; f11++) {
          let A13 = null;
          if (!(f11 < s9 && (A13 = n11.leadingRegexp(t6[e5 + f11]), p17 !== null && p17.equals(A13) && (n11.isCharClass(p17) || p17.op === c.Op.REPEAT && p17.min === p17.max && n11.isCharClass(p17.subs[0]))))) {
            if (f11 !== h16) if (f11 === h16 + 1) t6[i10++] = t6[e5 + h16];
            else {
              let T10 = p17;
              for (let R13 = h16; R13 < f11; R13++) {
                let G8 = R13 !== h16;
                t6[e5 + R13] = this.removeLeadingRegexp(t6[e5 + R13], G8), this.checkLimits(t6[e5 + R13]);
              }
              let C19 = this.collapse(t6.slice(e5 + h16, e5 + f11), c.Op.ALTERNATE), S16 = this.newRegexp(c.Op.CONCAT);
              S16.subs = [T10, C19], t6[i10++] = S16;
            }
            h16 = f11, p17 = A13;
          }
        }
        s9 = i10, e5 = 0, h16 = 0, i10 = 0;
        for (let f11 = 0; f11 <= s9; f11++) if (!(f11 < s9 && n11.isCharClass(t6[e5 + f11]))) {
          if (f11 !== h16) if (f11 === h16 + 1) t6[i10++] = t6[e5 + h16];
          else {
            let A13 = h16;
            for (let C19 = h16 + 1; C19 < f11; C19++) {
              let S16 = t6[e5 + A13], R13 = t6[e5 + C19];
              (S16.op < R13.op || S16.op === R13.op && (S16.runes !== null ? S16.runes.length : 0) < (R13.runes !== null ? R13.runes.length : 0)) && (A13 = C19);
            }
            let T10 = t6[e5 + h16];
            t6[e5 + h16] = t6[e5 + A13], t6[e5 + A13] = T10;
            for (let C19 = h16 + 1; C19 < f11; C19++) n11.mergeCharClass(t6[e5 + h16], t6[e5 + C19]), this.reuse(t6[e5 + C19]);
            this.cleanAlt(t6[e5 + h16]), t6[i10++] = t6[e5 + h16];
          }
          f11 < s9 && (t6[i10++] = t6[e5 + f11]), h16 = f11 + 1;
        }
        s9 = i10, e5 = 0, h16 = 0, i10 = 0;
        for (let f11 = 0; f11 < s9; ++f11) f11 + 1 < s9 && t6[e5 + f11].op === c.Op.EMPTY_MATCH && t6[e5 + f11 + 1].op === c.Op.EMPTY_MATCH || (t6[i10++] = t6[e5 + f11]);
        return s9 = i10, e5 = 0, t6.slice(e5, s9);
      }
      removeLeadingString(t6, e5) {
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          let s9 = this.removeLeadingString(t6.subs[0], e5);
          if (t6.subs[0] = s9, s9.op === c.Op.EMPTY_MATCH) switch (this.reuse(s9), t6.subs.length) {
            case 0:
            case 1:
              t6.op = c.Op.EMPTY_MATCH, t6.subs = null;
              break;
            case 2: {
              let i10 = t6;
              t6 = t6.subs[1], this.reuse(i10);
              break;
            }
            default:
              t6.subs = t6.subs.slice(1, t6.subs.length);
              break;
          }
          return t6;
        }
        return t6.op === c.Op.LITERAL && (t6.runes = t6.runes.slice(e5, t6.runes.length), t6.runes.length === 0 && (t6.op = c.Op.EMPTY_MATCH)), t6;
      }
      removeLeadingRegexp(t6, e5) {
        if (t6.op === c.Op.CONCAT && t6.subs.length > 0) {
          switch (e5 && this.reuse(t6.subs[0]), t6.subs = t6.subs.slice(1, t6.subs.length), t6.subs.length) {
            case 0: {
              t6.op = c.Op.EMPTY_MATCH, t6.subs = c.emptySubs();
              break;
            }
            case 1: {
              let s9 = t6;
              t6 = t6.subs[0], this.reuse(s9);
              break;
            }
          }
          return t6;
        }
        return e5 && this.reuse(t6), this.newRegexp(c.Op.EMPTY_MATCH);
      }
      parseInternal() {
        if ((this.flags & g.LITERAL) !== 0) return n11.literalRegexp(this.wholeRegexp, this.flags);
        let t6 = -1, e5 = -1, s9 = -1, i10 = new Q(this.wholeRegexp);
        for (; i10.more(); ) {
          let o9 = -1;
          t: switch (i10.peek()) {
            case u.CODES.get("("):
              if ((this.flags & g.PERL_X) !== 0 && i10.lookingAt("(?")) {
                this.parsePerlFlags(i10);
                break;
              }
              this.op(c.Op.LEFT_PAREN).cap = ++this.numCap, i10.skip(1);
              break;
            case u.CODES.get("|"):
              this.parseVerticalBar(), i10.skip(1);
              break;
            case u.CODES.get(")"):
              this.parseRightParen(), i10.skip(1);
              break;
            case u.CODES.get("^"):
              (this.flags & g.ONE_LINE) !== 0 ? this.op(c.Op.BEGIN_TEXT) : this.op(c.Op.BEGIN_LINE), i10.skip(1);
              break;
            case u.CODES.get("$"):
              (this.flags & g.ONE_LINE) !== 0 ? this.op(c.Op.END_TEXT).flags |= g.WAS_DOLLAR : this.op(c.Op.END_LINE), i10.skip(1);
              break;
            case u.CODES.get("."):
              (this.flags & g.DOT_NL) !== 0 ? this.op(c.Op.ANY_CHAR) : this.op(c.Op.ANY_CHAR_NOT_NL), i10.skip(1);
              break;
            case u.CODES.get("["):
              this.parseClass(i10);
              break;
            case u.CODES.get("*"):
            case u.CODES.get("+"):
            case u.CODES.get("?"): {
              o9 = i10.pos();
              let l8 = null;
              switch (i10.pop()) {
                case u.CODES.get("*"):
                  l8 = c.Op.STAR;
                  break;
                case u.CODES.get("+"):
                  l8 = c.Op.PLUS;
                  break;
                case u.CODES.get("?"):
                  l8 = c.Op.QUEST;
                  break;
              }
              this.repeat(l8, e5, s9, o9, i10, t6);
              break;
            }
            case u.CODES.get("{"): {
              o9 = i10.pos();
              let l8 = n11.parseRepeat(i10);
              if (l8 < 0) {
                i10.rewindTo(o9), this.literal(i10.pop());
                break;
              }
              e5 = l8 >> 16, s9 = (l8 & w.MAX_BMP) << 16 >> 16, this.repeat(c.Op.REPEAT, e5, s9, o9, i10, t6);
              break;
            }
            case u.CODES.get("\\"): {
              let l8 = i10.pos();
              if (i10.skip(1), (this.flags & g.PERL_X) !== 0 && i10.more()) switch (i10.pop()) {
                case u.CODES.get("A"):
                  this.op(c.Op.BEGIN_TEXT);
                  break t;
                case u.CODES.get("b"):
                  this.op(c.Op.WORD_BOUNDARY);
                  break t;
                case u.CODES.get("B"):
                  this.op(c.Op.NO_WORD_BOUNDARY);
                  break t;
                case u.CODES.get("C"):
                  throw new m(n11.ERR_INVALID_ESCAPE, "\\C");
                case u.CODES.get("Q"): {
                  let A13 = i10.rest(), T10 = A13.indexOf("\\E");
                  T10 >= 0 && (A13 = A13.substring(0, T10)), i10.skipString(A13), i10.skipString("\\E");
                  let C19 = 0;
                  for (; C19 < A13.length; ) {
                    let S16 = A13.codePointAt(C19);
                    this.literal(S16), C19 += O.charCount(S16);
                  }
                  break t;
                }
                case u.CODES.get("z"):
                  this.op(c.Op.END_TEXT);
                  break t;
                default:
                  i10.rewindTo(l8);
                  break;
              }
              let h16 = this.newRegexp(c.Op.CHAR_CLASS);
              if (h16.flags = this.flags, i10.lookingAt("\\p") || i10.lookingAt("\\P")) {
                let f11 = new x();
                if (this.parseUnicodeClass(i10, f11)) {
                  h16.runes = f11.toArray(), this.push(h16);
                  break t;
                }
              }
              let p17 = new x();
              if (this.parsePerlClassEscape(i10, p17)) {
                h16.runes = p17.toArray(), this.push(h16);
                break t;
              }
              i10.rewindTo(l8), this.reuse(h16), this.literal(n11.parseEscape(i10));
              break;
            }
            default:
              this.literal(i10.pop());
              break;
          }
          t6 = o9;
        }
        if (this.concat(), this.swapVerticalBar() && this.pop(), this.alternate(), this.stack.length !== 1) throw new m(n11.ERR_MISSING_PAREN, this.wholeRegexp);
        return this.stack[0].namedGroups = this.namedGroups, this.stack[0];
      }
      parsePerlFlags(t6) {
        let e5 = t6.pos(), s9 = t6.rest();
        if (s9.startsWith("(?P<") || s9.startsWith("(?<")) {
          let l8 = s9.charAt(2) === "P" ? 4 : 3, h16 = s9.indexOf(">");
          if (h16 < 0) throw new m(n11.ERR_INVALID_NAMED_CAPTURE, s9);
          let p17 = s9.substring(l8, h16);
          if (t6.skipString(p17), t6.skip(l8 + 1), !n11.isValidCaptureName(p17)) throw new m(n11.ERR_INVALID_NAMED_CAPTURE, s9.substring(0, h16 + 1));
          let f11 = this.op(c.Op.LEFT_PAREN);
          if (f11.cap = ++this.numCap, this.namedGroups[p17]) throw new m(n11.ERR_DUPLICATE_NAMED_CAPTURE, p17);
          this.namedGroups[p17] = this.numCap, f11.name = p17;
          return;
        }
        t6.skip(2);
        let i10 = this.flags, r8 = 1, o9 = false;
        t: for (; t6.more(); ) {
          let l8 = t6.pop();
          switch (l8) {
            case u.CODES.get("i"):
              i10 |= g.FOLD_CASE, o9 = true;
              break;
            case u.CODES.get("m"):
              i10 &= -17, o9 = true;
              break;
            case u.CODES.get("s"):
              i10 |= g.DOT_NL, o9 = true;
              break;
            case u.CODES.get("U"):
              i10 |= g.NON_GREEDY, o9 = true;
              break;
            case u.CODES.get("-"):
              if (r8 < 0) break t;
              r8 = -1, i10 = ~i10, o9 = false;
              break;
            case u.CODES.get(":"):
            case u.CODES.get(")"):
              if (r8 < 0) {
                if (!o9) break t;
                i10 = ~i10;
              }
              l8 === u.CODES.get(":") && this.op(c.Op.LEFT_PAREN), this.flags = i10;
              return;
            default:
              break t;
          }
        }
        throw new m(n11.ERR_INVALID_PERL_OP, t6.from(e5));
      }
      parseVerticalBar() {
        this.concat(), this.swapVerticalBar() || this.op(c.Op.VERTICAL_BAR);
      }
      swapVerticalBar() {
        let t6 = this.stack.length;
        if (t6 >= 3 && this.stack[t6 - 2].op === c.Op.VERTICAL_BAR && n11.isCharClass(this.stack[t6 - 1]) && n11.isCharClass(this.stack[t6 - 3])) {
          let e5 = this.stack[t6 - 1], s9 = this.stack[t6 - 3];
          if (e5.op > s9.op) {
            let i10 = s9;
            s9 = e5, e5 = i10, this.stack[t6 - 3] = s9;
          }
          return n11.mergeCharClass(s9, e5), this.reuse(e5), this.pop(), true;
        }
        if (t6 >= 2) {
          let e5 = this.stack[t6 - 1], s9 = this.stack[t6 - 2];
          if (s9.op === c.Op.VERTICAL_BAR) return t6 >= 3 && this.cleanAlt(this.stack[t6 - 3]), this.stack[t6 - 2] = e5, this.stack[t6 - 1] = s9, true;
        }
        return false;
      }
      parseRightParen() {
        if (this.concat(), this.swapVerticalBar() && this.pop(), this.alternate(), this.stack.length < 2) throw new m(n11.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        let e5 = this.pop(), s9 = this.pop();
        if (s9.op !== c.Op.LEFT_PAREN) throw new m(n11.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        this.flags = s9.flags, s9.cap === 0 ? this.push(e5) : (s9.op = c.Op.CAPTURE, s9.subs = [e5], this.push(s9));
      }
      parsePerlClassEscape(t6, e5) {
        let s9 = t6.pos();
        if ((this.flags & g.PERL_X) === 0 || !t6.more() || t6.pop() !== u.CODES.get("\\") || !t6.more()) return false;
        t6.pop();
        let i10 = t6.from(s9), r8 = o1.has(i10) ? o1.get(i10) : null;
        return r8 === null ? false : (e5.appendGroup(r8, (this.flags & g.FOLD_CASE) !== 0), true);
      }
      parseNamedClass(t6, e5) {
        let s9 = t6.rest(), i10 = s9.indexOf(":]");
        if (i10 < 0) return false;
        let r8 = s9.substring(0, i10 + 2);
        t6.skipString(r8);
        let o9 = S1.has(r8) ? S1.get(r8) : null;
        if (o9 === null) throw new m(n11.ERR_INVALID_CHAR_RANGE, r8);
        return e5.appendGroup(o9, (this.flags & g.FOLD_CASE) !== 0), true;
      }
      parseUnicodeClass(t6, e5) {
        let s9 = t6.pos();
        if ((this.flags & g.UNICODE_GROUPS) === 0 || !t6.lookingAt("\\p") && !t6.lookingAt("\\P")) return false;
        t6.skip(1);
        let i10 = 1, r8 = t6.pop();
        if (r8 === u.CODES.get("P") && (i10 = -1), !t6.more()) throw t6.rewindTo(s9), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
        r8 = t6.pop();
        let o9;
        if (r8 !== u.CODES.get("{")) o9 = O.runeToString(r8);
        else {
          let f11 = t6.rest(), A13 = f11.indexOf("}");
          if (A13 < 0) throw t6.rewindTo(s9), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
          o9 = f11.substring(0, A13), t6.skipString(o9), t6.skip(1);
        }
        o9.length !== 0 && o9.codePointAt(0) === u.CODES.get("^") && (i10 = 0 - i10, o9 = o9.substring(1));
        let l8 = n11.unicodeTable(o9);
        if (l8 === null) throw new m(n11.ERR_INVALID_CHAR_RANGE, t6.from(s9));
        let h16 = l8.first, p17 = l8.second;
        if ((this.flags & g.FOLD_CASE) === 0 || p17 === null) e5.appendTableWithSign(h16, i10);
        else {
          let f11 = new x().appendTable(h16).appendTable(p17).cleanClass().toArray();
          e5.appendClassWithSign(f11, i10);
        }
        return true;
      }
      parseClass(t6) {
        let e5 = t6.pos();
        t6.skip(1);
        let s9 = this.newRegexp(c.Op.CHAR_CLASS);
        s9.flags = this.flags;
        let i10 = new x(), r8 = 1;
        t6.more() && t6.lookingAt("^") && (r8 = -1, t6.skip(1), (this.flags & g.CLASS_NL) === 0 && i10.appendRange(u.CODES.get(`
`), u.CODES.get(`
`)));
        let o9 = true;
        for (; !t6.more() || t6.peek() !== u.CODES.get("]") || o9; ) {
          if (t6.more() && t6.lookingAt("-") && (this.flags & g.PERL_X) === 0 && !o9) {
            let f11 = t6.rest();
            if (f11 === "-" || !f11.startsWith("-]")) throw t6.rewindTo(e5), new m(n11.ERR_INVALID_CHAR_RANGE, t6.rest());
          }
          o9 = false;
          let l8 = t6.pos();
          if (t6.lookingAt("[:")) {
            if (this.parseNamedClass(t6, i10)) continue;
            t6.rewindTo(l8);
          }
          if (this.parseUnicodeClass(t6, i10) || this.parsePerlClassEscape(t6, i10)) continue;
          t6.rewindTo(l8);
          let h16 = n11.parseClassChar(t6, e5), p17 = h16;
          if (t6.more() && t6.lookingAt("-")) {
            if (t6.skip(1), t6.more() && t6.lookingAt("]")) t6.skip(-1);
            else if (p17 = n11.parseClassChar(t6, e5), p17 < h16) throw new m(n11.ERR_INVALID_CHAR_RANGE, t6.from(l8));
          }
          (this.flags & g.FOLD_CASE) === 0 ? i10.appendRange(h16, p17) : i10.appendFoldedRange(h16, p17);
        }
        t6.skip(1), i10.cleanClass(), r8 < 0 && i10.negateClass(), s9.runes = i10.toArray(), this.push(s9);
      }
    };
    t1 = class {
      constructor(t6) {
        this.value = t6;
      }
      get() {
        return this.value;
      }
      set(t6) {
        this.value = t6;
      }
      compareAndSet(t6, e5) {
        return this.value === t6 ? (this.value = e5, true) : false;
      }
    };
    e1 = class n12 {
      static initTest(t6) {
        let e5 = n12.compile(t6), s9 = new n12(e5.expr, e5.prog, e5.numSubexp, e5.longest);
        return s9.cond = e5.cond, s9.prefix = e5.prefix, s9.prefixUTF8 = e5.prefixUTF8, s9.prefixComplete = e5.prefixComplete, s9.prefixRune = e5.prefixRune, s9;
      }
      static compile(t6) {
        return n12.compileImpl(t6, g.PERL, false);
      }
      static compilePOSIX(t6) {
        return n12.compileImpl(t6, g.POSIX, true);
      }
      static compileImpl(t6, e5, s9) {
        let i10 = J.parse(t6, e5), r8 = i10.maxCap();
        i10 = Z.simplify(i10);
        let o9 = K.compileRegexp(i10), l8 = new n12(t6, o9, r8, s9), [h16, p17] = o9.prefix();
        return l8.prefixComplete = h16, l8.prefix = p17, l8.prefixUTF8 = O.stringToUtf8ByteArray(l8.prefix), l8.prefix.length > 0 && (l8.prefixRune = l8.prefix.codePointAt(0)), l8.namedGroups = i10.namedGroups, l8;
      }
      static match(t6, e5) {
        return n12.compile(t6).match(e5);
      }
      constructor(t6, e5, s9 = 0, i10 = 0) {
        this.expr = t6, this.prog = e5, this.numSubexp = s9, this.longest = i10, this.cond = e5.startCond(), this.prefix = null, this.prefixUTF8 = null, this.prefixComplete = false, this.prefixRune = 0, this.pooled = new t1();
      }
      numberOfCapturingGroups() {
        return this.numSubexp;
      }
      numberOfInstructions() {
        return this.prog.numInst();
      }
      get() {
        let t6;
        do
          t6 = this.pooled.get();
        while (t6 && !this.pooled.compareAndSet(t6, t6.next));
        return t6;
      }
      reset() {
        this.pooled.set(null);
      }
      put(t6, e5) {
        let s9 = this.pooled.get();
        do
          s9 = this.pooled.get(), !e5 && s9 && (t6 = M.fromMachine(t6), e5 = true), t6.next !== s9 && (t6.next = s9);
        while (!this.pooled.compareAndSet(s9, t6));
      }
      toString() {
        return this.expr;
      }
      doExecute(t6, e5, s9, i10) {
        let r8 = this.get(), o9 = false;
        r8 ? r8.next !== null && (r8 = M.fromMachine(r8), o9 = true) : (r8 = M.fromRE2(this), o9 = true), r8.init(i10);
        let l8 = r8.match(t6, e5, s9) ? r8.submatches() : null;
        return this.put(r8, o9), l8;
      }
      match(t6) {
        return this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 0) !== null;
      }
      matchWithGroup(t6, e5, s9, i10, r8) {
        return t6 instanceof I || (t6 = P.utf16(t6)), this.matchMachineInput(t6, e5, s9, i10, r8);
      }
      matchMachineInput(t6, e5, s9, i10, r8) {
        if (e5 > s9) return [false, null];
        let o9 = t6.isUTF16Encoding() ? N.fromUTF16(t6.asCharSequence(), 0, s9) : N.fromUTF8(t6.asBytes(), 0, s9), l8 = this.doExecute(o9, e5, i10, 2 * r8);
        return l8 === null ? [false, null] : [true, l8];
      }
      matchUTF8(t6) {
        return this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 0) !== null;
      }
      replaceAll(t6, e5) {
        return this.replaceAllFunc(t6, () => e5, 2 * t6.length + 1);
      }
      replaceFirst(t6, e5) {
        return this.replaceAllFunc(t6, () => e5, 1);
      }
      replaceAllFunc(t6, e5, s9) {
        let i10 = 0, r8 = 0, o9 = "", l8 = N.fromUTF16(t6), h16 = 0;
        for (; r8 <= t6.length; ) {
          let p17 = this.doExecute(l8, r8, g.UNANCHORED, 2);
          if (p17 === null || p17.length === 0) break;
          o9 += t6.substring(i10, p17[0]), (p17[1] > i10 || p17[0] === 0) && (o9 += e5(t6.substring(p17[0], p17[1])), h16++), i10 = p17[1];
          let f11 = l8.step(r8) & 7;
          if (r8 + f11 > p17[1] ? r8 += f11 : r8 + 1 > p17[1] ? r8++ : r8 = p17[1], h16 >= s9) break;
        }
        return o9 += t6.substring(i10), o9;
      }
      pad(t6) {
        if (t6 === null) return null;
        let e5 = (1 + this.numSubexp) * 2;
        if (t6.length < e5) {
          let s9 = new Array(e5).fill(-1);
          for (let i10 = 0; i10 < t6.length; i10++) s9[i10] = t6[i10];
          t6 = s9;
        }
        return t6;
      }
      allMatches(t6, e5, s9 = (i10) => i10) {
        let i10 = [], r8 = t6.endPos();
        e5 < 0 && (e5 = r8 + 1);
        let o9 = 0, l8 = 0, h16 = -1;
        for (; l8 < e5 && o9 <= r8; ) {
          let p17 = this.doExecute(t6, o9, g.UNANCHORED, this.prog.numCap);
          if (p17 === null || p17.length === 0) break;
          let f11 = true;
          if (p17[1] === o9) {
            p17[0] === h16 && (f11 = false);
            let A13 = t6.step(o9);
            A13 < 0 ? o9 = r8 + 1 : o9 += A13 & 7;
          } else o9 = p17[1];
          h16 = p17[1], f11 && (i10.push(s9(this.pad(p17))), l8++);
        }
        return i10;
      }
      findUTF8(t6) {
        let e5 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 2);
        return e5 === null ? null : t6.slice(e5[0], e5[1]);
      }
      findUTF8Index(t6) {
        let e5 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, 2);
        return e5 === null ? null : e5.slice(0, 2);
      }
      find(t6) {
        let e5 = this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 2);
        return e5 === null ? "" : t6.substring(e5[0], e5[1]);
      }
      findIndex(t6) {
        return this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, 2);
      }
      findUTF8Submatch(t6) {
        let e5 = this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, this.prog.numCap);
        if (e5 === null) return null;
        let s9 = new Array(1 + this.numSubexp).fill(null);
        for (let i10 = 0; i10 < s9.length; i10++) 2 * i10 < e5.length && e5[2 * i10] >= 0 && (s9[i10] = t6.slice(e5[2 * i10], e5[2 * i10 + 1]));
        return s9;
      }
      findUTF8SubmatchIndex(t6) {
        return this.pad(this.doExecute(N.fromUTF8(t6), 0, g.UNANCHORED, this.prog.numCap));
      }
      findSubmatch(t6) {
        let e5 = this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, this.prog.numCap);
        if (e5 === null) return null;
        let s9 = new Array(1 + this.numSubexp).fill(null);
        for (let i10 = 0; i10 < s9.length; i10++) 2 * i10 < e5.length && e5[2 * i10] >= 0 && (s9[i10] = t6.substring(e5[2 * i10], e5[2 * i10 + 1]));
        return s9;
      }
      findSubmatchIndex(t6) {
        return this.pad(this.doExecute(N.fromUTF16(t6), 0, g.UNANCHORED, this.prog.numCap));
      }
      findAllUTF8(t6, e5) {
        let s9 = this.allMatches(N.fromUTF8(t6), e5, (i10) => t6.slice(i10[0], i10[1]));
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8Index(t6, e5) {
        let s9 = this.allMatches(N.fromUTF8(t6), e5, (i10) => i10.slice(0, 2));
        return s9.length === 0 ? null : s9;
      }
      findAll(t6, e5) {
        let s9 = this.allMatches(N.fromUTF16(t6), e5, (i10) => t6.substring(i10[0], i10[1]));
        return s9.length === 0 ? null : s9;
      }
      findAllIndex(t6, e5) {
        let s9 = this.allMatches(N.fromUTF16(t6), e5, (i10) => i10.slice(0, 2));
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8Submatch(t6, e5) {
        let s9 = this.allMatches(N.fromUTF8(t6), e5, (i10) => {
          let r8 = new Array(i10.length / 2 | 0).fill(null);
          for (let o9 = 0; o9 < r8.length; o9++) i10[2 * o9] >= 0 && (r8[o9] = t6.slice(i10[2 * o9], i10[2 * o9 + 1]));
          return r8;
        });
        return s9.length === 0 ? null : s9;
      }
      findAllUTF8SubmatchIndex(t6, e5) {
        let s9 = this.allMatches(N.fromUTF8(t6), e5);
        return s9.length === 0 ? null : s9;
      }
      findAllSubmatch(t6, e5) {
        let s9 = this.allMatches(N.fromUTF16(t6), e5, (i10) => {
          let r8 = new Array(i10.length / 2 | 0).fill(null);
          for (let o9 = 0; o9 < r8.length; o9++) i10[2 * o9] >= 0 && (r8[o9] = t6.substring(i10[2 * o9], i10[2 * o9 + 1]));
          return r8;
        });
        return s9.length === 0 ? null : s9;
      }
      findAllSubmatchIndex(t6, e5) {
        let s9 = this.allMatches(N.fromUTF16(t6), e5);
        return s9.length === 0 ? null : s9;
      }
    };
    s1 = class n13 {
      static isUpperCaseAlpha(t6) {
        return "A" <= t6 && t6 <= "Z";
      }
      static isHexadecimal(t6) {
        return "0" <= t6 && t6 <= "9" || "A" <= t6 && t6 <= "F" || "a" <= t6 && t6 <= "f";
      }
      static getUtf8CharSize(t6) {
        let e5 = t6.charCodeAt(0);
        return e5 < 128 ? 1 : e5 < 2048 ? 2 : e5 < 65536 ? 3 : 4;
      }
      static translate(t6) {
        if (typeof t6 != "string") return t6;
        let e5 = "", s9 = false, i10 = t6.length;
        i10 === 0 && (e5 = "(?:)", s9 = true);
        let r8 = 0;
        for (; r8 < i10; ) {
          let o9 = t6[r8];
          if (o9 === "\\") {
            if (r8 + 1 < i10) switch (o9 = t6[r8 + 1], o9) {
              case "\\": {
                e5 += "\\\\", r8 += 2;
                continue;
              }
              case "c": {
                if (r8 + 2 < i10) {
                  let h16 = t6[r8 + 2];
                  if (n13.isUpperCaseAlpha(h16)) {
                    e5 += "\\x", e5 += (h16.charCodeAt(0) - 64 >> 4).toString(16).toUpperCase(), e5 += (h16.charCodeAt(0) - 64 & 15).toString(16).toUpperCase(), r8 += 3, s9 = true;
                    continue;
                  }
                }
                e5 += "\\c", r8 += 2;
                continue;
              }
              case "u": {
                if (r8 + 2 < i10) {
                  let h16 = t6[r8 + 2];
                  if (n13.isHexadecimal(h16)) {
                    e5 += "\\x{" + h16, r8 += 3;
                    for (let p17 = 0; p17 < 3 && r8 < i10 && (h16 = t6[r8], !!n13.isHexadecimal(h16)); ++r8, ++p17) e5 += h16;
                    e5 += "}", s9 = true;
                    continue;
                  } else if (h16 === "{") {
                    e5 += "\\x", r8 += 2, s9 = true;
                    continue;
                  }
                }
                e5 += "\\u", r8 += 2;
                continue;
              }
              default: {
                e5 += "\\";
                let h16 = n13.getUtf8CharSize(o9);
                e5 += t6.substring(r8 + 1, r8 + 1 + h16), r8 += h16 + 1;
                continue;
              }
            }
          } else if (o9 === "/") {
            e5 += "\\/", r8 += 1, s9 = true;
            continue;
          } else if (o9 === "(" && r8 + 2 < i10 && t6[r8 + 1] === "?" && t6[r8 + 2] === "<" && (r8 + 3 >= i10 || t6[r8 + 3] !== "=" && t6[r8 + 3] !== "!")) {
            e5 += "(?P<", r8 += 3, s9 = true;
            continue;
          }
          let l8 = n13.getUtf8CharSize(o9);
          e5 += t6.substring(r8, r8 + l8), r8 += l8;
        }
        return s9 ? e5 : t6;
      }
    };
    y = class n14 {
      static CASE_INSENSITIVE = 1;
      static DOTALL = 2;
      static MULTILINE = 4;
      static DISABLE_UNICODE_GROUPS = 8;
      static LONGEST_MATCH = 16;
      static quote(t6) {
        return O.quoteMeta(t6);
      }
      static translateRegExp(t6) {
        return s1.translate(t6);
      }
      static compile(t6, e5 = 0) {
        let s9 = t6;
        if ((e5 & n14.CASE_INSENSITIVE) !== 0 && (s9 = `(?i)${s9}`), (e5 & n14.DOTALL) !== 0 && (s9 = `(?s)${s9}`), (e5 & n14.MULTILINE) !== 0 && (s9 = `(?m)${s9}`), (e5 & ~(n14.MULTILINE | n14.DOTALL | n14.CASE_INSENSITIVE | n14.DISABLE_UNICODE_GROUPS | n14.LONGEST_MATCH)) !== 0) throw new z("Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH");
        let i10 = g.PERL;
        (e5 & n14.DISABLE_UNICODE_GROUPS) !== 0 && (i10 &= -129);
        let r8 = new n14(t6, e5);
        return r8.re2Input = e1.compileImpl(s9, i10, (e5 & n14.LONGEST_MATCH) !== 0), r8;
      }
      static matches(t6, e5) {
        return n14.compile(t6).matcher(e5).matches();
      }
      static initTest(t6, e5, s9) {
        if (t6 == null) throw new Error("pattern is null");
        if (s9 == null) throw new Error("re2 is null");
        let i10 = new n14(t6, e5);
        return i10.re2Input = s9, i10;
      }
      constructor(t6, e5) {
        this.patternInput = t6, this.flagsInput = e5;
      }
      reset() {
        this.re2Input.reset();
      }
      flags() {
        return this.flagsInput;
      }
      pattern() {
        return this.patternInput;
      }
      re2() {
        return this.re2Input;
      }
      matches(t6) {
        return this.matcher(t6).matches();
      }
      matcher(t6) {
        return Array.isArray(t6) && (t6 = P.utf8(t6)), new V(this, t6);
      }
      split(t6, e5 = 0) {
        let s9 = this.matcher(t6), i10 = [], r8 = 0, o9 = 0;
        for (; s9.find(); ) {
          if (o9 === 0 && s9.end() === 0) {
            o9 = s9.end();
            continue;
          }
          if (e5 > 0 && i10.length === e5 - 1) break;
          if (o9 === s9.start()) {
            if (e5 === 0) {
              r8 += 1, o9 = s9.end();
              continue;
            }
          } else for (; r8 > 0; ) i10.push(""), r8 -= 1;
          i10.push(s9.substring(o9, s9.start())), o9 = s9.end();
        }
        if (e5 === 0 && o9 !== s9.inputLength()) {
          for (; r8 > 0; ) i10.push(""), r8 -= 1;
          i10.push(s9.substring(o9, s9.inputLength()));
        }
        return (e5 !== 0 || i10.length === 0) && i10.push(s9.substring(o9, s9.inputLength())), i10;
      }
      toString() {
        return this.patternInput;
      }
      programSize() {
        return this.re2Input.numberOfInstructions();
      }
      groupCount() {
        return this.re2Input.numberOfCapturingGroups();
      }
      namedGroups() {
        return this.re2Input.namedGroups;
      }
      equals(t6) {
        return this === t6 ? true : t6 === null || this.constructor !== t6.constructor ? false : this.flagsInput === t6.flagsInput && this.patternInput === t6.patternInput;
      }
    };
    B = class {
      _re2;
      _pattern;
      _flags;
      _global;
      _ignoreCase;
      _multiline;
      _lastIndex = 0;
      _nativeRegex = null;
      constructor(t6, e5 = "") {
        this._pattern = t6, this._flags = e5, this._global = e5.includes("g"), this._ignoreCase = e5.includes("i"), this._multiline = e5.includes("m");
        try {
          let s9 = N1(t6), i10 = T1(e5);
          this._re2 = y.compile(s9, i10);
        } catch (s9) {
          if (s9 instanceof m) {
            let i10 = s9.message || "", r8 = "";
            throw i10.includes("(?=") || i10.includes("(?!") || i10.includes("(?<") || i10.includes("(?<!") || t6.includes("(?=") || t6.includes("(?!") || t6.includes("(?<=") || t6.includes("(?<!") ? r8 = " Lookahead (?=, ?!) and lookbehind (?<=, ?<!) assertions are not supported in this environment because the regex engine uses RE2 for ReDoS protection. RE2 guarantees linear-time matching but cannot support these features." : (i10.includes("backreference") || /\\[1-9]/.test(t6)) && (r8 = " Backreferences (\\1, \\2, etc.) are not supported in this environment because the regex engine uses RE2 for ReDoS protection. RE2 guarantees linear-time matching but cannot support backreferences."), new SyntaxError(`Invalid regular expression: /${t6}/: ${i10}${r8}`);
          }
          throw s9;
        }
      }
      test(t6) {
        return this._global && (this._lastIndex = 0), this._re2.matcher(t6).find();
      }
      exec(t6) {
        let e5 = this._re2.matcher(t6), s9 = this._global ? this._lastIndex : 0;
        if (!e5.find(s9)) return this._global && (this._lastIndex = 0), null;
        let i10 = this._re2.groupCount(), r8 = [];
        r8.push(e5.group(0) ?? "");
        for (let h16 = 1; h16 <= i10; h16++) {
          let p17 = e5.group(h16);
          r8.push(p17);
        }
        let o9 = r8;
        o9.index = e5.start(0), o9.input = t6;
        let l8 = this._re2.namedGroups();
        if (l8 && Object.keys(l8).length > 0) {
          let h16 = /* @__PURE__ */ Object.create(null);
          for (let [p17, f11] of Object.entries(l8)) {
            let A13 = e5.group(f11);
            A13 !== null && (h16[p17] = A13);
          }
          o9.groups = h16;
        }
        return this._global && (this._lastIndex = e5.end(0), e5.start(0) === e5.end(0) && this._lastIndex++), o9;
      }
      match(t6) {
        if (this._global && (this._lastIndex = 0), !this._global) return this.exec(t6);
        let e5 = [], s9 = this._re2.matcher(t6), i10 = 0;
        for (; s9.find(i10); ) {
          let r8 = s9.group(0) ?? "";
          if (e5.push(r8), i10 = s9.end(0), s9.start(0) === s9.end(0) && i10++, i10 > t6.length) break;
        }
        return e5.length > 0 ? e5 : null;
      }
      replace(t6, e5) {
        if (this._global && (this._lastIndex = 0), typeof e5 == "string") {
          let p17 = this._re2.matcher(t6);
          return this._global ? p17.replaceAll(e5, true) : p17.replaceFirst(e5, true);
        }
        let s9 = [], i10 = this._re2.matcher(t6), r8 = 0, o9 = 0, l8 = this._re2.groupCount(), h16 = this._re2.namedGroups();
        for (; i10.find(o9); ) {
          s9.push(t6.slice(r8, i10.start(0)));
          let p17 = [], f11 = i10.group(0) ?? "";
          for (let A13 = 1; A13 <= l8; A13++) p17.push(i10.group(A13));
          if (p17.push(i10.start(0)), p17.push(t6), h16 && Object.keys(h16).length > 0) {
            let A13 = /* @__PURE__ */ Object.create(null);
            for (let [T10, C19] of Object.entries(h16)) A13[T10] = i10.group(C19) ?? "";
            p17.push(A13);
          }
          if (s9.push(e5(f11, ...p17)), r8 = i10.end(0), o9 = r8, i10.start(0) === i10.end(0) && o9++, !this._global || o9 > t6.length) break;
        }
        return s9.push(t6.slice(r8)), s9.join("");
      }
      split(t6, e5) {
        return e5 === void 0 || e5 < 0 ? this._re2.split(t6, -1) : e5 === 0 ? [] : this._re2.split(t6, -1).slice(0, e5);
      }
      search(t6) {
        let e5 = this._re2.matcher(t6);
        return e5.find() ? e5.start(0) : -1;
      }
      *matchAll(t6) {
        if (!this._global) throw new Error("matchAll requires global flag");
        this._lastIndex = 0;
        let e5 = this._re2.matcher(t6), s9 = this._re2.groupCount(), i10 = this._re2.namedGroups(), r8 = 0;
        for (; e5.find(r8); ) {
          let o9 = [];
          o9.push(e5.group(0) ?? "");
          for (let h16 = 1; h16 <= s9; h16++) o9.push(e5.group(h16));
          let l8 = o9;
          if (l8.index = e5.start(0), l8.input = t6, i10 && Object.keys(i10).length > 0) {
            let h16 = /* @__PURE__ */ Object.create(null);
            for (let [p17, f11] of Object.entries(i10)) {
              let A13 = e5.group(f11);
              A13 !== null && (h16[p17] = A13);
            }
            l8.groups = h16;
          }
          if (yield l8, r8 = e5.end(0), e5.start(0) === e5.end(0) && r8++, r8 > t6.length) break;
        }
      }
      get native() {
        if (!this._nativeRegex) try {
          this._nativeRegex = new RegExp(this._pattern, this._flags);
        } catch {
          this._nativeRegex = new RegExp("", this._flags), Object.defineProperty(this._nativeRegex, "source", { value: this._pattern, writable: false });
        }
        return this._nativeRegex;
      }
      get source() {
        return this._pattern;
      }
      get flags() {
        return this._flags;
      }
      get global() {
        return this._global;
      }
      get ignoreCase() {
        return this._ignoreCase;
      }
      get multiline() {
        return this._multiline;
      }
      get lastIndex() {
        return this._lastIndex;
      }
      set lastIndex(t6) {
        this._lastIndex = t6;
      }
    };
    i1 = class {
      _regex;
      constructor(t6) {
        this._regex = t6;
      }
      test(t6) {
        return this._regex.global && (this._regex.lastIndex = 0), this._regex.test(t6);
      }
      exec(t6) {
        return this._regex.exec(t6);
      }
      match(t6) {
        return this._regex.global && (this._regex.lastIndex = 0), t6.match(this._regex);
      }
      replace(t6, e5) {
        return this._regex.global && (this._regex.lastIndex = 0), t6.replace(this._regex, e5);
      }
      split(t6, e5) {
        return t6.split(this._regex, e5);
      }
      search(t6) {
        return t6.search(this._regex);
      }
      *matchAll(t6) {
        if (!this._regex.global) throw new Error("matchAll requires global flag");
        this._regex.lastIndex = 0;
        let e5 = this._regex.exec(t6);
        for (; e5 !== null; ) yield e5, e5[0].length === 0 && this._regex.lastIndex++, e5 = this._regex.exec(t6);
      }
      get native() {
        return this._regex;
      }
      get source() {
        return this._regex.source;
      }
      get flags() {
        return this._regex.flags;
      }
      get global() {
        return this._regex.global;
      }
      get ignoreCase() {
        return this._regex.ignoreCase;
      }
      get multiline() {
        return this._regex.multiline;
      }
      get lastIndex() {
        return this._regex.lastIndex;
      }
      set lastIndex(t6) {
        this._regex.lastIndex = t6;
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PSW6BMXW.js
var n15, p, b2;
var init_chunk_PSW6BMXW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PSW6BMXW.js"() {
    n15 = class extends Error {
      stdout;
      stderr;
      constructor(t6, s9 = "", e5 = "") {
        super(t6), this.stdout = s9, this.stderr = e5;
      }
      prependOutput(t6, s9) {
        this.stdout = t6 + this.stdout, this.stderr = s9 + this.stderr;
      }
    };
    p = class extends n15 {
      name = "ArithmeticError";
      fatal;
      constructor(t6, s9 = "", e5 = "", o9 = false) {
        super(t6, s9, e5), this.stderr = e5 || `bash: ${t6}
`, this.fatal = o9;
      }
    };
    b2 = class extends n15 {
      limitType;
      name = "ExecutionLimitError";
      static EXIT_CODE = 126;
      constructor(t6, s9, e5 = "", o9 = "") {
        super(t6, e5, o9), this.limitType = s9, this.stderr = o9 || `bash: ${t6}
`;
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-V4CDPGZH.js
function $2(e5, t6) {
  for (; t6 < e5.length; ) {
    if (e5[t6] === "\\" && e5[t6 + 1] === `
`) {
      t6 += 2;
      continue;
    }
    if (/\s/.test(e5[t6])) {
      t6++;
      continue;
    }
    break;
  }
  return t6;
}
function ge(e5) {
  if (e5.includes("#")) {
    let [r8, s9] = e5.split("#"), n23 = Number.parseInt(r8, 10);
    if (n23 < 2 || n23 > 64) return Number.NaN;
    if (n23 <= 36) {
      let i10 = Number.parseInt(s9, n23);
      return i10 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : i10;
    }
    let a7 = 0;
    for (let i10 of s9) {
      let l8;
      if (/[0-9]/.test(i10)) l8 = i10.charCodeAt(0) - 48;
      else if (/[a-z]/.test(i10)) l8 = i10.charCodeAt(0) - 97 + 10;
      else if (/[A-Z]/.test(i10)) l8 = i10.charCodeAt(0) - 65 + 36;
      else if (i10 === "@") l8 = 62;
      else if (i10 === "_") l8 = 63;
      else return Number.NaN;
      if (l8 >= n23) return Number.NaN;
      if (a7 = a7 * n23 + l8, a7 > Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
    }
    return a7;
  }
  if (e5.startsWith("0x") || e5.startsWith("0X")) {
    let r8 = Number.parseInt(e5.slice(2), 16);
    return r8 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : r8;
  }
  if (e5.startsWith("0") && e5.length > 1 && /^[0-9]+$/.test(e5)) {
    if (/[89]/.test(e5)) return Number.NaN;
    let r8 = Number.parseInt(e5, 8);
    return r8 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : r8;
  }
  let t6 = Number.parseInt(e5, 10);
  return t6 > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t6;
}
function It(e5, t6, r8, s9) {
  if (r8.slice(s9, s9 + 3) !== "$((") return null;
  let n23 = s9 + 3, a7 = 1, i10 = n23;
  for (; n23 < r8.length - 1 && a7 > 0; ) r8[n23] === "(" && r8[n23 + 1] === "(" ? (a7++, n23 += 2) : r8[n23] === ")" && r8[n23 + 1] === ")" ? (a7--, a7 > 0 && (n23 += 2)) : n23++;
  let l8 = r8.slice(i10, n23), { expr: o9 } = e5(t6, l8, 0);
  return n23 += 2, { expr: { type: "ArithNested", expression: o9 }, pos: n23 };
}
function vt(e5, t6) {
  if (e5.slice(t6, t6 + 2) !== "$'") return null;
  let r8 = t6 + 2, s9 = "";
  for (; r8 < e5.length && e5[r8] !== "'"; ) if (e5[r8] === "\\" && r8 + 1 < e5.length) {
    let a7 = e5[r8 + 1];
    switch (a7) {
      case "n":
        s9 += `
`;
        break;
      case "t":
        s9 += "	";
        break;
      case "r":
        s9 += "\r";
        break;
      case "\\":
        s9 += "\\";
        break;
      case "'":
        s9 += "'";
        break;
      default:
        s9 += a7;
    }
    r8 += 2;
  } else s9 += e5[r8], r8++;
  e5[r8] === "'" && r8++;
  let n23 = Number.parseInt(s9, 10);
  return { expr: { type: "ArithNumber", value: Number.isNaN(n23) ? 0 : n23 }, pos: r8 };
}
function Dt(e5, t6) {
  if (e5.slice(t6, t6 + 2) !== '$"') return null;
  let r8 = t6 + 2, s9 = "";
  for (; r8 < e5.length && e5[r8] !== '"'; ) e5[r8] === "\\" && r8 + 1 < e5.length ? (s9 += e5[r8 + 1], r8 += 2) : (s9 += e5[r8], r8++);
  e5[r8] === '"' && r8++;
  let n23 = Number.parseInt(s9, 10);
  return { expr: { type: "ArithNumber", value: Number.isNaN(n23) ? 0 : n23 }, pos: r8 };
}
function wr(e5) {
  let t6 = "", r8 = 0;
  for (; r8 < e5.length; ) if (e5[r8] === '"') {
    for (r8++; r8 < e5.length && e5[r8] !== '"'; ) e5[r8] === "\\" && r8 + 1 < e5.length ? (t6 += e5[r8 + 1], r8 += 2) : (t6 += e5[r8], r8++);
    r8 < e5.length && r8++;
  } else t6 += e5[r8], r8++;
  return t6;
}
function M2(e5, t6) {
  let r8 = wr(t6), { expr: s9, pos: n23 } = Z2(e5, r8, 0), a7 = $2(r8, n23);
  if (a7 < r8.length) {
    let i10 = t6.slice(a7).trim();
    if (i10) return { type: "ArithmeticExpression", originalText: t6, expression: { type: "ArithSyntaxError", errorToken: i10, message: `${i10}: syntax error: invalid arithmetic operator (error token is "${i10}")` } };
  }
  return { type: "ArithmeticExpression", expression: s9, originalText: t6 };
}
function F2(e5, t6) {
  return { expr: { type: "ArithSyntaxError", errorToken: e5, message: `syntax error: operand expected (error token is "${e5}")` }, pos: t6 };
}
function z2(e5, t6) {
  return $2(e5, t6) >= e5.length;
}
function Z2(e5, t6, r8) {
  return Nr(e5, t6, r8);
}
function Nr(e5, t6, r8) {
  let { expr: s9, pos: n23 } = ye(e5, t6, r8);
  for (n23 = $2(t6, n23); t6[n23] === ","; ) {
    if (n23++, z2(t6, n23)) return F2(",", n23);
    let { expr: i10, pos: l8 } = ye(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: ",", left: s9, right: i10 }, n23 = $2(t6, l8);
  }
  return { expr: s9, pos: n23 };
}
function ye(e5, t6, r8) {
  let { expr: s9, pos: n23 } = kr(e5, t6, r8);
  if (n23 = $2(t6, n23), t6[n23] === "?") {
    n23++;
    let { expr: a7, pos: i10 } = Z2(e5, t6, n23);
    if (n23 = $2(t6, i10), t6[n23] === ":") {
      n23++;
      let { expr: l8, pos: o9 } = Z2(e5, t6, n23);
      return { expr: { type: "ArithTernary", condition: s9, consequent: a7, alternate: l8 }, pos: o9 };
    }
  }
  return { expr: s9, pos: n23 };
}
function kr(e5, t6, r8) {
  let { expr: s9, pos: n23 } = xt(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6.slice(n23, n23 + 2) === "||"; ) {
    if (n23 += 2, z2(t6, n23)) return F2("||", n23);
    let { expr: i10, pos: l8 } = xt(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "||", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function xt(e5, t6, r8) {
  let { expr: s9, pos: n23 } = _t(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6.slice(n23, n23 + 2) === "&&"; ) {
    if (n23 += 2, z2(t6, n23)) return F2("&&", n23);
    let { expr: i10, pos: l8 } = _t(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "&&", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function _t(e5, t6, r8) {
  let { expr: s9, pos: n23 } = $t(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6[n23] === "|" && t6[n23 + 1] !== "|"; ) {
    if (n23++, z2(t6, n23)) return F2("|", n23);
    let { expr: i10, pos: l8 } = $t(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "|", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function $t(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Ct(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6[n23] === "^"; ) {
    if (n23++, z2(t6, n23)) return F2("^", n23);
    let { expr: i10, pos: l8 } = Ct(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "^", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Ct(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Ot(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6[n23] === "&" && t6[n23 + 1] !== "&"; ) {
    if (n23++, z2(t6, n23)) return F2("&", n23);
    let { expr: i10, pos: l8 } = Ot(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "&", left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Ot(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Lt(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6.slice(n23, n23 + 2) === "==" || t6.slice(n23, n23 + 2) === "!="; ) {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Lt(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Lt(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Fe(e5, t6, r8);
  for (; ; ) if (n23 = $2(t6, n23), t6.slice(n23, n23 + 2) === "<=" || t6.slice(n23, n23 + 2) === ">=") {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Fe(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else if (t6[n23] === "<" || t6[n23] === ">") {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Fe(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else break;
  return { expr: s9, pos: n23 };
}
function Fe(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Wt(e5, t6, r8);
  for (; n23 = $2(t6, n23), t6.slice(n23, n23 + 2) === "<<" || t6.slice(n23, n23 + 2) === ">>"; ) {
    let a7 = t6.slice(n23, n23 + 2);
    if (n23 += 2, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Wt(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Wt(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Tt(e5, t6, r8);
  for (; n23 = $2(t6, n23), (t6[n23] === "+" || t6[n23] === "-") && t6[n23 + 1] !== t6[n23]; ) {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Tt(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  }
  return { expr: s9, pos: n23 };
}
function Tt(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Re(e5, t6, r8);
  for (; ; ) if (n23 = $2(t6, n23), t6[n23] === "*" && t6[n23 + 1] !== "*") {
    if (n23++, z2(t6, n23)) return F2("*", n23);
    let { expr: i10, pos: l8 } = Re(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: "*", left: s9, right: i10 }, n23 = l8;
  } else if (t6[n23] === "/" || t6[n23] === "%") {
    let a7 = t6[n23];
    if (n23++, z2(t6, n23)) return F2(a7, n23);
    let { expr: i10, pos: l8 } = Re(e5, t6, n23);
    s9 = { type: "ArithBinary", operator: a7, left: s9, right: i10 }, n23 = l8;
  } else break;
  return { expr: s9, pos: n23 };
}
function Re(e5, t6, r8) {
  let { expr: s9, pos: n23 } = ze(e5, t6, r8), a7 = $2(t6, n23);
  if (t6.slice(a7, a7 + 2) === "**") {
    if (a7 += 2, z2(t6, a7)) return F2("**", a7);
    let { expr: l8, pos: o9 } = Re(e5, t6, a7);
    return { expr: { type: "ArithBinary", operator: "**", left: s9, right: l8 }, pos: o9 };
  }
  return { expr: s9, pos: n23 };
}
function ze(e5, t6, r8) {
  let s9 = $2(t6, r8);
  if (t6.slice(s9, s9 + 2) === "++" || t6.slice(s9, s9 + 2) === "--") {
    let n23 = t6.slice(s9, s9 + 2);
    s9 += 2;
    let { expr: a7, pos: i10 } = ze(e5, t6, s9);
    return { expr: { type: "ArithUnary", operator: n23, operand: a7, prefix: true }, pos: i10 };
  }
  if (t6[s9] === "+" || t6[s9] === "-" || t6[s9] === "!" || t6[s9] === "~") {
    let n23 = t6[s9];
    s9++;
    let { expr: a7, pos: i10 } = ze(e5, t6, s9);
    return { expr: { type: "ArithUnary", operator: n23, operand: a7, prefix: true }, pos: i10 };
  }
  return Rr(e5, t6, s9);
}
function Pr(e5, t6) {
  let r8 = e5[t6];
  return r8 === "$" || r8 === "`";
}
function Rr(e5, t6, r8) {
  let { expr: s9, pos: n23 } = Mt(e5, t6, r8, false), a7 = [s9];
  for (; Pr(t6, n23); ) {
    let { expr: l8, pos: o9 } = Mt(e5, t6, n23, true);
    a7.push(l8), n23 = o9;
  }
  a7.length > 1 && (s9 = { type: "ArithConcat", parts: a7 });
  let i10;
  if (t6[n23] === "[" && s9.type === "ArithConcat") {
    n23++;
    let { expr: l8, pos: o9 } = Z2(e5, t6, n23);
    i10 = l8, n23 = o9, t6[n23] === "]" && n23++;
  }
  if (i10 && s9.type === "ArithConcat" && (s9 = { type: "ArithDynamicElement", nameExpr: s9, subscript: i10 }, i10 = void 0), n23 = $2(t6, n23), s9.type === "ArithConcat" || s9.type === "ArithVariable" || s9.type === "ArithDynamicElement") {
    for (let l8 of Pe) if (t6.slice(n23, n23 + l8.length) === l8 && t6.slice(n23, n23 + l8.length + 1) !== "==") {
      n23 += l8.length;
      let { expr: o9, pos: c14 } = ye(e5, t6, n23);
      return s9.type === "ArithDynamicElement" ? { expr: { type: "ArithDynamicAssignment", operator: l8, target: s9.nameExpr, subscript: s9.subscript, value: o9 }, pos: c14 } : s9.type === "ArithConcat" ? { expr: { type: "ArithDynamicAssignment", operator: l8, target: s9, value: o9 }, pos: c14 } : { expr: { type: "ArithAssignment", operator: l8, variable: s9.name, value: o9 }, pos: c14 };
    }
  }
  if (t6.slice(n23, n23 + 2) === "++" || t6.slice(n23, n23 + 2) === "--") {
    let l8 = t6.slice(n23, n23 + 2);
    return n23 += 2, { expr: { type: "ArithUnary", operator: l8, operand: s9, prefix: false }, pos: n23 };
  }
  return { expr: s9, pos: n23 };
}
function Mt(e5, t6, r8, s9 = false) {
  let n23 = $2(t6, r8), a7 = It(Z2, e5, t6, n23);
  if (a7) return a7;
  let i10 = vt(t6, n23);
  if (i10) return i10;
  let l8 = Dt(t6, n23);
  if (l8) return l8;
  if (t6.slice(n23, n23 + 2) === "$(" && t6[n23 + 2] !== "(") {
    n23 += 2;
    let c14 = 1, u10 = n23;
    for (; n23 < t6.length && c14 > 0; ) t6[n23] === "(" ? c14++ : t6[n23] === ")" && c14--, c14 > 0 && n23++;
    let f11 = t6.slice(u10, n23);
    return n23++, { expr: { type: "ArithCommandSubst", command: f11 }, pos: n23 };
  }
  if (t6[n23] === "`") {
    n23++;
    let c14 = n23;
    for (; n23 < t6.length && t6[n23] !== "`"; ) n23++;
    let u10 = t6.slice(c14, n23);
    return t6[n23] === "`" && n23++, { expr: { type: "ArithCommandSubst", command: u10 }, pos: n23 };
  }
  if (t6[n23] === "(") {
    n23++;
    let { expr: c14, pos: u10 } = Z2(e5, t6, n23);
    return n23 = $2(t6, u10), t6[n23] === ")" && n23++, { expr: { type: "ArithGroup", expression: c14 }, pos: n23 };
  }
  if (t6[n23] === "'") {
    n23++;
    let c14 = "";
    for (; n23 < t6.length && t6[n23] !== "'"; ) c14 += t6[n23], n23++;
    t6[n23] === "'" && n23++;
    let u10 = Number.parseInt(c14, 10);
    return { expr: { type: "ArithSingleQuote", content: c14, value: Number.isNaN(u10) ? 0 : u10 }, pos: n23 };
  }
  if (t6[n23] === '"') {
    n23++;
    let c14 = "";
    for (; n23 < t6.length && t6[n23] !== '"'; ) t6[n23] === "\\" && n23 + 1 < t6.length ? (c14 += t6[n23 + 1], n23 += 2) : (c14 += t6[n23], n23++);
    t6[n23] === '"' && n23++;
    let u10 = c14.trim();
    if (!u10) return { expr: { type: "ArithNumber", value: 0 }, pos: n23 };
    let { expr: f11 } = Z2(e5, u10, 0);
    return { expr: f11, pos: n23 };
  }
  if (/[0-9]/.test(t6[n23])) {
    let c14 = "", u10 = false, f11 = false;
    for (; n23 < t6.length; ) {
      let d16 = t6[n23];
      if (u10) if (/[0-9a-zA-Z@_]/.test(d16)) c14 += d16, n23++;
      else break;
      else if (d16 === "#") u10 = true, c14 += d16, n23++;
      else if (c14 === "0" && (d16 === "x" || d16 === "X") && n23 + 1 < t6.length && /[0-9a-fA-F]/.test(t6[n23 + 1])) f11 = true, c14 += d16, n23++;
      else if (f11 && /[0-9a-fA-F]/.test(d16)) c14 += d16, n23++;
      else if (!f11 && /[0-9]/.test(d16)) c14 += d16, n23++;
      else break;
    }
    if (n23 < t6.length && /[a-zA-Z_]/.test(t6[n23])) {
      let d16 = c14;
      for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) d16 += t6[n23], n23++;
      return { expr: { type: "ArithSyntaxError", errorToken: d16, message: `${d16}: value too great for base (error token is "${d16}")` }, pos: n23 };
    }
    if (t6[n23] === "." && /[0-9]/.test(t6[n23 + 1])) throw new p(`${c14}.${t6[n23 + 1]}...: syntax error: invalid arithmetic operator`);
    if (t6[n23] === "[") {
      let d16 = t6.slice(n23).trim();
      return { expr: { type: "ArithNumberSubscript", number: c14, errorToken: d16 }, pos: t6.length };
    }
    return { expr: { type: "ArithNumber", value: ge(c14) }, pos: n23 };
  }
  if (t6[n23] === "$" && t6[n23 + 1] === "{") {
    let c14 = n23 + 2, u10 = 1, f11 = c14;
    for (; f11 < t6.length && u10 > 0; ) t6[f11] === "{" ? u10++ : t6[f11] === "}" && u10--, u10 > 0 && f11++;
    let h16 = t6.slice(c14, f11), d16 = f11 + 1;
    if (t6[d16] === "#") {
      let m24 = d16 + 1;
      for (; m24 < t6.length && /[0-9a-zA-Z@_]/.test(t6[m24]); ) m24++;
      let g18 = t6.slice(d16 + 1, m24);
      return { expr: { type: "ArithDynamicBase", baseExpr: h16, value: g18 }, pos: m24 };
    }
    if (/[0-9]/.test(t6[d16]) || t6[d16] === "x" || t6[d16] === "X") {
      let m24 = d16;
      if (t6[d16] === "x" || t6[d16] === "X") for (m24++; m24 < t6.length && /[0-9a-fA-F]/.test(t6[m24]); ) m24++;
      else for (; m24 < t6.length && /[0-9]/.test(t6[m24]); ) m24++;
      let g18 = t6.slice(d16, m24);
      return { expr: { type: "ArithDynamicNumber", prefix: h16, suffix: g18 }, pos: m24 };
    }
    return n23 = d16, { expr: { type: "ArithBracedExpansion", content: h16 }, pos: n23 };
  }
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[0-9]/.test(t6[n23 + 1])) {
    n23++;
    let c14 = "";
    for (; n23 < t6.length && /[0-9]/.test(t6[n23]); ) c14 += t6[n23], n23++;
    return { expr: { type: "ArithVariable", name: c14, hasDollarPrefix: true }, pos: n23 };
  }
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[*@#?\-!$]/.test(t6[n23 + 1])) {
    let c14 = t6[n23 + 1];
    return n23 += 2, { expr: { type: "ArithSpecialVar", name: c14 }, pos: n23 };
  }
  let o9 = false;
  if (t6[n23] === "$" && n23 + 1 < t6.length && /[a-zA-Z_]/.test(t6[n23 + 1]) && (o9 = true, n23++), n23 < t6.length && /[a-zA-Z_]/.test(t6[n23])) {
    let c14 = "";
    for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) c14 += t6[n23], n23++;
    if (t6[n23] === "[" && !s9) {
      n23++;
      let u10;
      if (t6[n23] === "'" || t6[n23] === '"') {
        let h16 = t6[n23];
        for (n23++, u10 = ""; n23 < t6.length && t6[n23] !== h16; ) u10 += t6[n23], n23++;
        t6[n23] === h16 && n23++, n23 = $2(t6, n23), t6[n23] === "]" && n23++;
      }
      let f11;
      if (u10 === void 0) {
        let { expr: h16, pos: d16 } = Z2(e5, t6, n23);
        f11 = h16, n23 = d16, t6[n23] === "]" && n23++;
      }
      if (n23 = $2(t6, n23), t6[n23] === "[" && f11) return { expr: { type: "ArithDoubleSubscript", array: c14, index: f11 }, pos: n23 };
      if (!s9) {
        for (let h16 of Pe) if (t6.slice(n23, n23 + h16.length) === h16 && t6.slice(n23, n23 + h16.length + 1) !== "==") {
          n23 += h16.length;
          let { expr: d16, pos: m24 } = ye(e5, t6, n23);
          return { expr: { type: "ArithAssignment", operator: h16, variable: c14, subscript: f11, stringKey: u10, value: d16 }, pos: m24 };
        }
      }
      return { expr: { type: "ArithArrayElement", array: c14, index: f11, stringKey: u10 }, pos: n23 };
    }
    if (n23 = $2(t6, n23), !s9) {
      for (let u10 of Pe) if (t6.slice(n23, n23 + u10.length) === u10 && t6.slice(n23, n23 + u10.length + 1) !== "==") {
        n23 += u10.length;
        let { expr: f11, pos: h16 } = ye(e5, t6, n23);
        return { expr: { type: "ArithAssignment", operator: u10, variable: c14, value: f11 }, pos: h16 };
      }
    }
    return { expr: { type: "ArithVariable", name: c14, hasDollarPrefix: o9 }, pos: n23 };
  }
  if (t6[n23] === "#") {
    let c14 = n23 + 1;
    for (; c14 < t6.length && t6[c14] !== `
`; ) c14++;
    let u10 = t6.slice(n23, c14).trim() || "#";
    return { expr: { type: "ArithSyntaxError", errorToken: u10, message: `${u10}: syntax error: invalid arithmetic operator (error token is "${u10}")` }, pos: t6.length };
  }
  return { expr: { type: "ArithNumber", value: 0 }, pos: n23 };
}
function Bt(e5) {
  let t6 = e5.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
  if (!t6) return false;
  let r8 = e5.slice(t6[0].length);
  if (r8 === "" || r8 === "+") return true;
  if (r8[0] === "[") {
    let s9 = 0, n23 = 0;
    for (; n23 < r8.length; n23++) if (r8[n23] === "[") s9++;
    else if (r8[n23] === "]" && (s9--, s9 === 0)) break;
    if (s9 !== 0 || n23 >= r8.length) return false;
    let a7 = r8.slice(n23 + 1);
    return a7 === "" || a7 === "+";
  }
  return false;
}
function Ft(e5) {
  let t6 = 0;
  for (let r8 = 0; r8 < e5.length; r8++) {
    let s9 = e5[r8];
    if (s9 === "[") t6++;
    else if (s9 === "]") t6--;
    else {
      if (t6 === 0 && s9 === "=") return r8;
      if (t6 === 0 && s9 === "+" && e5[r8 + 1] === "=") return r8 + 1;
    }
  }
  return -1;
}
function xr(e5) {
  return /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(e5);
}
function zt(e5) {
  return e5 === " " || e5 === "	" || e5 === `
` || e5 === ";" || e5 === "&" || e5 === "|" || e5 === "(" || e5 === ")" || e5 === "<" || e5 === ">";
}
function _r(e5) {
  let t6 = "", r8 = 0;
  for (; r8 < e5.length; ) {
    let s9 = e5[r8];
    if (s9 < 128) {
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 224) === 192) {
      if (r8 + 1 < e5.length && (e5[r8 + 1] & 192) === 128 && s9 >= 194) {
        let n23 = (s9 & 31) << 6 | e5[r8 + 1] & 63;
        t6 += String.fromCharCode(n23), r8 += 2;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 240) === 224) {
      if (r8 + 2 < e5.length && (e5[r8 + 1] & 192) === 128 && (e5[r8 + 2] & 192) === 128) {
        if (s9 === 224 && e5[r8 + 1] < 160) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        let n23 = (s9 & 15) << 12 | (e5[r8 + 1] & 63) << 6 | e5[r8 + 2] & 63;
        if (n23 >= 55296 && n23 <= 57343) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        t6 += String.fromCharCode(n23), r8 += 3;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    if ((s9 & 248) === 240 && s9 <= 244) {
      if (r8 + 3 < e5.length && (e5[r8 + 1] & 192) === 128 && (e5[r8 + 2] & 192) === 128 && (e5[r8 + 3] & 192) === 128) {
        if (s9 === 240 && e5[r8 + 1] < 144) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        let n23 = (s9 & 7) << 18 | (e5[r8 + 1] & 63) << 12 | (e5[r8 + 2] & 63) << 6 | e5[r8 + 3] & 63;
        if (n23 > 1114111) {
          t6 += String.fromCharCode(s9), r8++;
          continue;
        }
        t6 += String.fromCodePoint(n23), r8 += 4;
        continue;
      }
      t6 += String.fromCharCode(s9), r8++;
      continue;
    }
    t6 += String.fromCharCode(s9), r8++;
  }
  return t6;
}
function jt(e5, t6, r8) {
  let s9 = r8 + 1;
  for (; s9 < t6.length && /[a-zA-Z0-9_-]/.test(t6[s9]); ) s9++;
  return s9;
}
function Ue(e5, t6, r8, s9, n23) {
  let a7 = 1, i10 = r8 + 1;
  for (; i10 < t6.length && a7 > 0; ) t6[i10] === s9 ? a7++ : t6[i10] === n23 && a7--, a7 > 0 && i10++;
  return a7 === 0 ? i10 : -1;
}
function fe(e5, t6, r8) {
  let s9 = r8, n23 = 1;
  for (; s9 < t6.length && n23 > 0; ) {
    let a7 = t6[s9];
    if (a7 === "\\" && s9 + 1 < t6.length) {
      s9 += 2;
      continue;
    }
    if (a7 === "'") {
      let i10 = t6.indexOf("'", s9 + 1);
      if (i10 !== -1) {
        s9 = i10 + 1;
        continue;
      }
    }
    if (a7 === '"') {
      for (s9++; s9 < t6.length && t6[s9] !== '"'; ) t6[s9] === "\\" && s9 + 1 < t6.length ? s9 += 2 : s9++;
      s9 < t6.length && s9++;
      continue;
    }
    a7 === "{" ? n23++ : a7 === "}" && n23--, n23 > 0 && s9++;
  }
  return s9;
}
function Kt(e5, t6, r8) {
  let s9 = r8, n23 = false;
  for (; s9 < t6.length; ) {
    let a7 = t6[s9];
    if (a7 === "/" && n23 || a7 === "}") break;
    if (a7 === "'") {
      let i10 = t6.indexOf("'", s9 + 1);
      if (i10 !== -1) {
        s9 = i10 + 1, n23 = true;
        continue;
      }
    }
    if (a7 === '"') {
      for (s9++; s9 < t6.length && t6[s9] !== '"'; ) t6[s9] === "\\" && s9 + 1 < t6.length ? s9 += 2 : s9++;
      s9 < t6.length && s9++, n23 = true;
      continue;
    }
    a7 === "\\" ? (s9 += 2, n23 = true) : (s9++, n23 = true);
  }
  return s9;
}
function Xt(e5, t6, r8) {
  let s9 = r8, n23 = "";
  for (; s9 < t6.length; ) {
    let a7 = t6[s9];
    if (a7 === "*" || a7 === "?") n23 += a7, s9++;
    else if (a7 === "[") {
      let i10 = $r(t6, s9);
      i10 === -1 ? (n23 += a7, s9++) : (n23 += t6.slice(s9, i10 + 1), s9 = i10 + 1);
    } else break;
  }
  return { pattern: n23, endIndex: s9 };
}
function $r(e5, t6) {
  let r8 = t6 + 1;
  for (r8 < e5.length && e5[r8] === "^" && r8++, r8 < e5.length && e5[r8] === "]" && r8++; r8 < e5.length; ) {
    let s9 = e5[r8];
    if (s9 === "\\" && r8 + 1 < e5.length) {
      let n23 = e5[r8 + 1];
      if (n23 === '"' || n23 === "'") return -1;
      r8 += 2;
      continue;
    }
    if (s9 === "]") return r8;
    if (s9 === '"' || s9 === "$" || s9 === "`") return -1;
    if (s9 === "'") {
      let n23 = e5.indexOf("'", r8 + 1);
      if (n23 !== -1) {
        r8 = n23 + 1;
        continue;
      }
    }
    if (s9 === "[" && r8 + 1 < e5.length && e5[r8 + 1] === ":") {
      let n23 = e5.indexOf(":]", r8 + 2);
      if (n23 !== -1) {
        r8 = n23 + 2;
        continue;
      }
    }
    if (s9 === "[" && r8 + 1 < e5.length && (e5[r8 + 1] === "." || e5[r8 + 1] === "=")) {
      let a7 = `${e5[r8 + 1]}]`, i10 = e5.indexOf(a7, r8 + 2);
      if (i10 !== -1) {
        r8 = i10 + 2;
        continue;
      }
    }
    r8++;
  }
  return -1;
}
function Jt(e5, t6, r8) {
  let s9 = "", n23 = r8;
  for (; n23 < t6.length && t6[n23] !== "'"; ) {
    let a7 = t6[n23];
    if (a7 === "\\" && n23 + 1 < t6.length) switch (t6[n23 + 1]) {
      case "n":
        s9 += `
`, n23 += 2;
        break;
      case "t":
        s9 += "	", n23 += 2;
        break;
      case "r":
        s9 += "\r", n23 += 2;
        break;
      case "\\":
        s9 += "\\", n23 += 2;
        break;
      case "'":
        s9 += "'", n23 += 2;
        break;
      case '"':
        s9 += '"', n23 += 2;
        break;
      case "a":
        s9 += "\x07", n23 += 2;
        break;
      case "b":
        s9 += "\b", n23 += 2;
        break;
      case "e":
      case "E":
        s9 += "\x1B", n23 += 2;
        break;
      case "f":
        s9 += "\f", n23 += 2;
        break;
      case "v":
        s9 += "\v", n23 += 2;
        break;
      case "x": {
        let l8 = [], o9 = n23;
        for (; o9 + 1 < t6.length && t6[o9] === "\\" && t6[o9 + 1] === "x"; ) {
          let c14 = t6.slice(o9 + 2, o9 + 4), u10 = parseInt(c14, 16);
          if (!Number.isNaN(u10) && c14.length > 0) l8.push(u10), o9 += 2 + c14.length;
          else break;
        }
        l8.length > 0 ? (s9 += _r(l8), n23 = o9) : (s9 += "\\x", n23 += 2);
        break;
      }
      case "u": {
        let l8 = t6.slice(n23 + 2, n23 + 6), o9 = parseInt(l8, 16);
        Number.isNaN(o9) ? (s9 += "\\u", n23 += 2) : (s9 += String.fromCharCode(o9), n23 += 6);
        break;
      }
      case "c": {
        if (n23 + 2 < t6.length) {
          let o9 = t6[n23 + 2].charCodeAt(0) & 31;
          s9 += String.fromCharCode(o9), n23 += 3;
        } else s9 += "\\c", n23 += 2;
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7": {
        let l8 = "", o9 = n23 + 1;
        for (; o9 < t6.length && o9 < n23 + 4 && /[0-7]/.test(t6[o9]); ) l8 += t6[o9], o9++;
        let c14 = parseInt(l8, 8);
        s9 += String.fromCharCode(c14), n23 = o9;
        break;
      }
      default:
        s9 += a7, n23++;
    }
    else s9 += a7, n23++;
  }
  return n23 < t6.length && t6[n23] === "'" && n23++, { part: w2.literal(s9), endIndex: n23 };
}
function He(e5, t6) {
  let r8 = t6.trim();
  return r8 === "" ? { type: "ArithmeticExpression", expression: { type: "ArithNumber", value: 0 } } : M2(e5, r8);
}
function Ht(e5) {
  let t6 = [], r8 = "", s9 = 0;
  for (let n23 = 0; n23 < e5.length; n23++) {
    let a7 = e5[n23];
    a7 === "{" ? (s9++, r8 += a7) : a7 === "}" ? (s9--, r8 += a7) : a7 === "," && s9 === 0 ? (t6.push(r8), r8 = "") : r8 += a7;
  }
  return t6.push(r8), t6;
}
function Yt(e5, t6, r8, s9) {
  let n23 = Ue(e5, t6, r8, "{", "}");
  if (n23 === -1) return null;
  let a7 = t6.slice(r8 + 1, n23), i10 = a7.match(/^(-?\d+)\.\.(-?\d+)(?:\.\.(-?\d+))?$/);
  if (i10) return { part: { type: "BraceExpansion", items: [{ type: "Range", start: Number.parseInt(i10[1], 10), end: Number.parseInt(i10[2], 10), step: i10[3] ? Number.parseInt(i10[3], 10) : void 0, startStr: i10[1], endStr: i10[2] }] }, endIndex: n23 + 1 };
  let l8 = a7.match(/^([a-zA-Z])\.\.([a-zA-Z])(?:\.\.(-?\d+))?$/);
  return l8 ? { part: { type: "BraceExpansion", items: [{ type: "Range", start: l8[1], end: l8[2], step: l8[3] ? Number.parseInt(l8[3], 10) : void 0 }] }, endIndex: n23 + 1 } : a7.includes(",") && s9 ? { part: { type: "BraceExpansion", items: Ht(a7).map((u10) => ({ type: "Word", word: w2.word(s9(e5, u10, false, false, false)) })) }, endIndex: n23 + 1 } : a7.includes(",") ? { part: { type: "BraceExpansion", items: Ht(a7).map((u10) => ({ type: "Word", word: w2.word([w2.literal(u10)]) })) }, endIndex: n23 + 1 } : null;
}
function je(e5, t6) {
  let r8 = "";
  for (let s9 of t6.parts) switch (s9.type) {
    case "Literal":
      r8 += s9.value;
      break;
    case "SingleQuoted":
      r8 += `'${s9.value}'`;
      break;
    case "Escaped":
      r8 += s9.value;
      break;
    case "DoubleQuoted":
      r8 += '"';
      for (let n23 of s9.parts) n23.type === "Literal" || n23.type === "Escaped" ? r8 += n23.value : n23.type === "ParameterExpansion" && (r8 += `\${${n23.parameter}}`);
      r8 += '"';
      break;
    case "ParameterExpansion":
      r8 += `\${${s9.parameter}}`;
      break;
    case "Glob":
      r8 += s9.pattern;
      break;
    case "TildeExpansion":
      r8 += "~", s9.user && (r8 += s9.user);
      break;
    case "BraceExpansion": {
      r8 += "{";
      let n23 = [];
      for (let a7 of s9.items) if (a7.type === "Range") {
        let i10 = a7.startStr ?? String(a7.start), l8 = a7.endStr ?? String(a7.end);
        a7.step !== void 0 ? n23.push(`${i10}..${l8}..${a7.step}`) : n23.push(`${i10}..${l8}`);
      } else n23.push(je(e5, a7.word));
      n23.length === 1 && s9.items[0].type === "Range" ? r8 += n23[0] : r8 += n23.join(","), r8 += "}";
      break;
    }
    default:
      r8 += s9.type;
  }
  return r8;
}
function en(e5, t6) {
  return { [p2.LESS]: "<", [p2.GREAT]: ">", [p2.DGREAT]: ">>", [p2.LESSAND]: "<&", [p2.GREATAND]: ">&", [p2.LESSGREAT]: "<>", [p2.CLOBBER]: ">|", [p2.TLESS]: "<<<", [p2.AND_GREAT]: "&>", [p2.AND_DGREAT]: "&>>", [p2.DLESS]: "<", [p2.DLESSDASH]: "<" }[t6] || ">";
}
function ve(e5) {
  let t6 = e5.current(), r8 = t6.type;
  if (r8 === p2.NUMBER) {
    let s9 = e5.peek(1);
    return t6.end !== s9.start ? false : Zt.has(s9.type);
  }
  if (r8 === p2.FD_VARIABLE) {
    let s9 = e5.peek(1);
    return Ut.has(s9.type);
  }
  return Gt.has(r8);
}
function De(e5) {
  let t6 = null, r8;
  e5.check(p2.NUMBER) ? t6 = Number.parseInt(e5.advance().value, 10) : e5.check(p2.FD_VARIABLE) && (r8 = e5.advance().value);
  let s9 = e5.advance(), n23 = en(e5, s9.type);
  if (s9.type === p2.DLESS || s9.type === p2.DLESSDASH) return Cr(e5, n23, t6, s9.type === p2.DLESSDASH);
  e5.isWord() || e5.error("Expected redirection target");
  let a7 = e5.parseWord();
  return w2.redirection(n23, a7, t6, r8);
}
function Cr(e5, t6, r8, s9) {
  e5.isWord() || e5.error("Expected here-document delimiter");
  let n23 = e5.advance(), a7 = n23.value, i10 = n23.quoted || false;
  (a7.startsWith("'") && a7.endsWith("'") || a7.startsWith('"') && a7.endsWith('"')) && (a7 = a7.slice(1, -1));
  let l8 = w2.redirection(s9 ? "<<-" : "<<", w2.hereDoc(a7, w2.word([]), s9, i10), r8);
  return e5.addPendingHeredoc(l8, a7, s9, i10), l8;
}
function nn(e5) {
  let t6 = e5.current().line, r8 = [], s9 = null, n23 = [], a7 = [];
  for (; e5.check(p2.ASSIGNMENT_WORD) || ve(e5); ) e5.checkIterationLimit(), e5.check(p2.ASSIGNMENT_WORD) ? r8.push(Or(e5)) : a7.push(De(e5));
  if (e5.isWord()) s9 = e5.parseWord();
  else if (r8.length > 0 && (e5.check(p2.DBRACK_START) || e5.check(p2.DPAREN_START))) {
    let l8 = e5.advance();
    s9 = w2.word([w2.literal(l8.value)]);
  }
  for (; (!e5.isStatementEnd() || e5.check(p2.RBRACE)) && !e5.check(p2.PIPE, p2.PIPE_AMP); ) if (e5.checkIterationLimit(), ve(e5)) a7.push(De(e5));
  else if (e5.check(p2.RBRACE)) {
    let l8 = e5.advance();
    n23.push(e5.parseWordFromString(l8.value, false, false));
  } else if (e5.check(p2.LBRACE)) {
    let l8 = e5.advance();
    n23.push(e5.parseWordFromString(l8.value, false, false));
  } else if (e5.check(p2.DBRACK_END)) {
    let l8 = e5.advance();
    n23.push(e5.parseWordFromString(l8.value, false, false));
  } else if (e5.isWord()) n23.push(e5.parseWord());
  else if (e5.check(p2.ASSIGNMENT_WORD)) {
    let l8 = e5.advance(), o9 = l8.value, c14 = o9.endsWith("="), u10 = o9.endsWith("=(");
    if ((c14 || u10) && (u10 || e5.check(p2.LPAREN))) {
      let f11 = u10 ? o9.slice(0, -2) : o9.slice(0, -1);
      u10 || e5.expect(p2.LPAREN);
      let h16 = Ke(e5);
      e5.expect(p2.RPAREN);
      let d16 = h16.map((g18) => je(e5, g18)), m24 = `${f11}=(${d16.join(" ")})`;
      n23.push(e5.parseWordFromString(m24, false, false));
    } else n23.push(e5.parseWordFromString(o9, l8.quoted, l8.singleQuoted));
  } else if (e5.check(p2.LPAREN)) e5.error("syntax error near unexpected token `('");
  else break;
  let i10 = w2.simpleCommand(s9, n23, r8, a7);
  return i10.line = t6, i10;
}
function Or(e5) {
  let t6 = e5.expect(p2.ASSIGNMENT_WORD), r8 = t6.value, s9 = r8.match(/^[a-zA-Z_][a-zA-Z0-9_]*/);
  s9 || e5.error(`Invalid assignment: ${r8}`);
  let n23 = s9[0], a7, i10 = n23.length;
  if (r8[i10] === "[") {
    let f11 = 0, h16 = i10 + 1;
    for (; i10 < r8.length; i10++) if (r8[i10] === "[") f11++;
    else if (r8[i10] === "]" && (f11--, f11 === 0)) break;
    f11 !== 0 && e5.error(`Invalid assignment: ${r8}`), a7 = r8.slice(h16, i10), i10++;
  }
  let l8 = r8[i10] === "+";
  l8 && i10++, r8[i10] !== "=" && e5.error(`Invalid assignment: ${r8}`), i10++;
  let o9 = r8.slice(i10);
  if (o9 === "(") {
    let f11 = Ke(e5);
    e5.expect(p2.RPAREN);
    let h16 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
    return w2.assignment(h16, null, l8, f11);
  }
  if (o9 === "" && e5.check(p2.LPAREN)) {
    let f11 = e5.current();
    if (t6.end === f11.start) {
      e5.advance();
      let h16 = Ke(e5);
      e5.expect(p2.RPAREN);
      let d16 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
      return w2.assignment(d16, null, l8, h16);
    }
  }
  let c14 = o9 ? e5.parseWordFromString(o9, t6.quoted, t6.singleQuoted, true) : null, u10 = a7 !== void 0 ? `${n23}[${a7}]` : n23;
  return w2.assignment(u10, c14, l8, null);
}
function Ke(e5) {
  let t6 = [];
  for (e5.skipNewlines(); !e5.check(p2.RPAREN, p2.EOF); ) e5.checkIterationLimit(), e5.isWord() ? t6.push(e5.parseWord()) : Lr.has(e5.current().type) ? e5.error(`syntax error near unexpected token \`${e5.current().value}'`) : e5.advance(), e5.skipNewlines();
  return t6;
}
function Xe(e5, t6) {
  e5.expect(p2.IF);
  let r8 = [], s9 = e5.parseCompoundList();
  e5.expect(p2.THEN);
  let n23 = e5.parseCompoundList();
  if (n23.length === 0) {
    let l8 = e5.check(p2.FI) ? "fi" : e5.check(p2.ELSE) ? "else" : e5.check(p2.ELIF) ? "elif" : "fi";
    e5.error(`syntax error near unexpected token \`${l8}'`);
  }
  for (r8.push({ condition: s9, body: n23 }); e5.check(p2.ELIF); ) {
    e5.advance();
    let l8 = e5.parseCompoundList();
    e5.expect(p2.THEN);
    let o9 = e5.parseCompoundList();
    if (o9.length === 0) {
      let c14 = e5.check(p2.FI) ? "fi" : e5.check(p2.ELSE) ? "else" : e5.check(p2.ELIF) ? "elif" : "fi";
      e5.error(`syntax error near unexpected token \`${c14}'`);
    }
    r8.push({ condition: l8, body: o9 });
  }
  let a7 = null;
  e5.check(p2.ELSE) && (e5.advance(), a7 = e5.parseCompoundList(), a7.length === 0 && e5.error("syntax error near unexpected token `fi'")), e5.expect(p2.FI);
  let i10 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.ifNode(r8, a7, i10);
}
function Je(e5, t6) {
  let r8 = e5.expect(p2.FOR);
  if (e5.check(p2.DPAREN_START)) return Tr(e5, t6, r8.line);
  e5.isWord() || e5.error("Expected variable name in for loop");
  let n23 = e5.advance().value, a7 = null;
  if (e5.skipNewlines(), e5.check(p2.IN)) for (e5.advance(), a7 = []; !e5.check(p2.SEMICOLON, p2.NEWLINE, p2.DO, p2.EOF) && e5.isWord(); ) a7.push(e5.parseWord());
  e5.check(p2.SEMICOLON) && e5.advance(), e5.skipNewlines(), e5.expect(p2.DO);
  let i10 = e5.parseCompoundList();
  e5.expect(p2.DONE);
  let l8 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.forNode(n23, a7, i10, l8);
}
function Tr(e5, t6, r8) {
  e5.expect(p2.DPAREN_START);
  let s9 = null, n23 = null, a7 = null, i10 = ["", "", ""], l8 = 0, o9 = 0;
  for (; !e5.check(p2.DPAREN_END, p2.EOF); ) {
    let f11 = e5.advance();
    if (f11.type === p2.SEMICOLON && o9 === 0) {
      if (l8++, l8 > 2) break;
    } else f11.value === "(" && o9++, f11.value === ")" && o9--, i10[l8] += f11.value;
  }
  e5.expect(p2.DPAREN_END), i10[0].trim() && (s9 = M2(e5, i10[0].trim())), i10[1].trim() && (n23 = M2(e5, i10[1].trim())), i10[2].trim() && (a7 = M2(e5, i10[2].trim())), e5.skipNewlines(), e5.check(p2.SEMICOLON) && e5.advance(), e5.skipNewlines();
  let c14;
  e5.check(p2.LBRACE) ? (e5.advance(), c14 = e5.parseCompoundList(), e5.expect(p2.RBRACE)) : (e5.expect(p2.DO), c14 = e5.parseCompoundList(), e5.expect(p2.DONE));
  let u10 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return { type: "CStyleFor", init: s9, condition: n23, update: a7, body: c14, redirections: u10, line: r8 };
}
function Ye(e5, t6) {
  e5.expect(p2.WHILE);
  let r8 = e5.parseCompoundList();
  e5.expect(p2.DO);
  let s9 = e5.parseCompoundList();
  s9.length === 0 && e5.error("syntax error near unexpected token `done'"), e5.expect(p2.DONE);
  let n23 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.whileNode(r8, s9, n23);
}
function et(e5, t6) {
  e5.expect(p2.UNTIL);
  let r8 = e5.parseCompoundList();
  e5.expect(p2.DO);
  let s9 = e5.parseCompoundList();
  s9.length === 0 && e5.error("syntax error near unexpected token `done'"), e5.expect(p2.DONE);
  let n23 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.untilNode(r8, s9, n23);
}
function tt(e5, t6) {
  e5.expect(p2.CASE), e5.isWord() || e5.error("Expected word after 'case'");
  let r8 = e5.parseWord();
  e5.skipNewlines(), e5.expect(p2.IN), e5.skipNewlines();
  let s9 = [];
  for (; !e5.check(p2.ESAC, p2.EOF); ) {
    e5.checkIterationLimit();
    let a7 = e5.getPos(), i10 = Mr(e5);
    if (i10 && s9.push(i10), e5.skipNewlines(), e5.getPos() === a7 && !i10) break;
  }
  e5.expect(p2.ESAC);
  let n23 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.caseNode(r8, s9, n23);
}
function Mr(e5) {
  e5.check(p2.LPAREN) && e5.advance();
  let t6 = [];
  for (; e5.isWord() && (t6.push(e5.parseWord()), e5.check(p2.PIPE)); ) e5.advance();
  if (t6.length === 0) return null;
  e5.expect(p2.RPAREN), e5.skipNewlines();
  let r8 = [];
  for (; !e5.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND, p2.ESAC, p2.EOF); ) {
    e5.checkIterationLimit(), e5.isWord() && e5.peek(1).type === p2.RPAREN && e5.error("syntax error near unexpected token `)'"), e5.check(p2.LPAREN) && e5.peek(1).type === p2.WORD && e5.error(`syntax error near unexpected token \`${e5.peek(1).value}'`);
    let n23 = e5.getPos(), a7 = e5.parseStatement();
    if (a7 && r8.push(a7), e5.skipSeparators(false), e5.getPos() === n23 && !a7) break;
  }
  let s9 = ";;";
  return e5.check(p2.DSEMI) ? (e5.advance(), s9 = ";;") : e5.check(p2.SEMI_AND) ? (e5.advance(), s9 = ";&") : e5.check(p2.SEMI_SEMI_AND) && (e5.advance(), s9 = ";;&"), w2.caseItem(t6, r8, s9);
}
function nt(e5, t6) {
  e5.expect(p2.LPAREN);
  let r8 = e5.parseCompoundList();
  e5.expect(p2.RPAREN);
  let s9 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.subshell(r8, s9);
}
function rt(e5, t6) {
  e5.expect(p2.LBRACE);
  let r8 = e5.parseCompoundList();
  e5.expect(p2.RBRACE);
  let s9 = t6?.skipRedirections ? [] : e5.parseOptionalRedirections();
  return w2.group(r8, s9);
}
function rn(e5) {
  return e5.isWord() || e5.check(p2.LBRACE) || e5.check(p2.RBRACE) || e5.check(p2.ASSIGNMENT_WORD);
}
function sn(e5) {
  if (e5.check(p2.BANG) && e5.peek(1).type === p2.LPAREN) {
    e5.advance(), e5.advance();
    let t6 = 1, r8 = "!(";
    for (; t6 > 0 && !e5.check(p2.EOF); ) if (e5.check(p2.LPAREN)) t6++, r8 += "(", e5.advance();
    else if (e5.check(p2.RPAREN)) t6--, t6 > 0 && (r8 += ")"), e5.advance();
    else if (e5.isWord()) r8 += e5.advance().value;
    else if (e5.check(p2.PIPE)) r8 += "|", e5.advance();
    else break;
    return r8 += ")", e5.parseWordFromString(r8, false, false, false, false, true);
  }
  return e5.parseWordNoBraceExpansion();
}
function it(e5) {
  return e5.skipNewlines(), Fr(e5);
}
function Fr(e5) {
  let t6 = an(e5);
  for (e5.skipNewlines(); e5.check(p2.OR_OR); ) {
    e5.advance(), e5.skipNewlines();
    let r8 = an(e5);
    t6 = { type: "CondOr", left: t6, right: r8 }, e5.skipNewlines();
  }
  return t6;
}
function an(e5) {
  let t6 = st(e5);
  for (e5.skipNewlines(); e5.check(p2.AND_AND); ) {
    e5.advance(), e5.skipNewlines();
    let r8 = st(e5);
    t6 = { type: "CondAnd", left: t6, right: r8 }, e5.skipNewlines();
  }
  return t6;
}
function st(e5) {
  return e5.skipNewlines(), e5.check(p2.BANG) ? (e5.advance(), e5.skipNewlines(), { type: "CondNot", operand: st(e5) }) : zr(e5);
}
function zr(e5) {
  if (e5.check(p2.LPAREN)) {
    e5.advance();
    let t6 = it(e5);
    return e5.expect(p2.RPAREN), { type: "CondGroup", expression: t6 };
  }
  if (rn(e5)) {
    let t6 = e5.current(), r8 = t6.value;
    if (qr.includes(r8) && !t6.quoted) {
      if (e5.advance(), e5.check(p2.DBRACK_END) && e5.error(`Expected operand after ${r8}`), rn(e5)) {
        let a7 = e5.parseWordNoBraceExpansion();
        return { type: "CondUnary", operator: r8, operand: a7 };
      }
      let n23 = e5.current();
      e5.error(`unexpected argument \`${n23.value}' to conditional unary operator`);
    }
    let s9 = e5.parseWordNoBraceExpansion();
    if (e5.isWord() && Br.includes(e5.current().value)) {
      let n23 = e5.advance().value, a7;
      return n23 === "=~" ? a7 = Qr(e5) : n23 === "==" || n23 === "!=" ? a7 = sn(e5) : a7 = e5.parseWordNoBraceExpansion(), { type: "CondBinary", operator: n23, left: s9, right: a7 };
    }
    if (e5.check(p2.LESS)) {
      e5.advance();
      let n23 = e5.parseWordNoBraceExpansion();
      return { type: "CondBinary", operator: "<", left: s9, right: n23 };
    }
    if (e5.check(p2.GREAT)) {
      e5.advance();
      let n23 = e5.parseWordNoBraceExpansion();
      return { type: "CondBinary", operator: ">", left: s9, right: n23 };
    }
    if (e5.isWord() && e5.current().value === "=") {
      e5.advance();
      let n23 = sn(e5);
      return { type: "CondBinary", operator: "==", left: s9, right: n23 };
    }
    return { type: "CondWord", word: s9 };
  }
  e5.error("Expected conditional expression");
}
function Qr(e5) {
  let t6 = [], r8 = 0, s9 = -1, n23 = e5.getInput(), a7 = () => e5.check(p2.DBRACK_END) || e5.check(p2.AND_AND) || e5.check(p2.OR_OR) || e5.check(p2.NEWLINE) || e5.check(p2.EOF);
  for (; !a7(); ) {
    let i10 = e5.current(), l8 = s9 >= 0 && i10.start > s9;
    if (r8 === 0 && l8) break;
    if (r8 > 0 && l8) {
      let o9 = n23.slice(s9, i10.start);
      t6.push({ type: "Literal", value: o9 });
    }
    if (e5.isWord() || e5.check(p2.ASSIGNMENT_WORD)) {
      let o9 = e5.parseWordForRegex();
      t6.push(...o9.parts), s9 = e5.peek(-1).end;
    } else if (e5.check(p2.LPAREN)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "(" }), r8++, s9 = o9.end;
    } else if (e5.check(p2.DPAREN_START)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "((" }), r8 += 2, s9 = o9.end;
    } else if (e5.check(p2.DPAREN_END)) if (r8 >= 2) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "))" }), r8 -= 2, s9 = o9.end;
    } else {
      if (r8 === 1) break;
      break;
    }
    else if (e5.check(p2.RPAREN)) if (r8 > 0) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ")" }), r8--, s9 = o9.end;
    } else break;
    else if (e5.check(p2.PIPE)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "|" }), s9 = o9.end;
    } else if (e5.check(p2.SEMICOLON)) if (r8 > 0) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ";" }), s9 = o9.end;
    } else break;
    else if (r8 > 0 && e5.check(p2.LESS)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "<" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.GREAT)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ">" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.DGREAT)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ">>" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.DLESS)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "<<" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.LESSAND)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "<&" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.GREATAND)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ">&" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.LESSGREAT)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "<>" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.CLOBBER)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: ">|" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.TLESS)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "<<<" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.AMP)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "&" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.LBRACE)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "{" }), s9 = o9.end;
    } else if (r8 > 0 && e5.check(p2.RBRACE)) {
      let o9 = e5.advance();
      t6.push({ type: "Literal", value: "}" }), s9 = o9.end;
    } else break;
  }
  return t6.length === 0 && e5.error("Expected regex pattern after =~"), { type: "Word", parts: t6 };
}
function Zr(e5, t6) {
  let r8 = 1, s9 = t6 + 1;
  for (; s9 < e5.length && r8 > 0; ) {
    let n23 = e5[s9];
    if (n23 === "\\") {
      s9 += 2;
      continue;
    }
    if ("@*+?!".includes(n23) && s9 + 1 < e5.length && e5[s9 + 1] === "(") {
      s9++, r8++, s9++;
      continue;
    }
    if (n23 === "(") r8++;
    else if (n23 === ")" && (r8--, r8 === 0)) return s9;
    s9++;
  }
  return -1;
}
function Ur(e5, t6, r8) {
  let s9 = r8 + 1, n23 = t6[s9];
  if ("@*#?$!-0123456789".includes(n23)) return { part: w2.parameterExpansion(n23), endIndex: s9 + 1 };
  let a7 = "";
  for (; s9 < t6.length && /[a-zA-Z0-9_]/.test(t6[s9]); ) a7 += t6[s9], s9++;
  return { part: w2.parameterExpansion(a7), endIndex: s9 };
}
function Hr(e5, t6, r8, s9 = false) {
  let n23 = r8 + 2, a7 = false;
  t6[n23] === "!" && (a7 = true, n23++);
  let i10 = false;
  t6[n23] === "#" && !/[}:#%/^,]/.test(t6[n23 + 1] || "}") && (i10 = true, n23++);
  let l8 = "", o9 = t6[n23];
  if (/[@*#?$!-]/.test(o9) && !/[a-zA-Z0-9_]/.test(t6[n23 + 1] || "")) l8 = o9, n23++;
  else for (; n23 < t6.length && /[a-zA-Z0-9_]/.test(t6[n23]); ) l8 += t6[n23], n23++;
  if (t6[n23] === "[") {
    let u10 = Ue(e5, t6, n23, "[", "]");
    if (l8 += t6.slice(n23, u10 + 1), n23 = u10 + 1, t6[n23] === "[") {
      let f11 = 1, h16 = n23;
      for (; h16 < t6.length && f11 > 0; ) t6[h16] === "{" ? f11++ : t6[h16] === "}" && f11--, f11 > 0 && h16++;
      let d16 = t6.slice(r8 + 2, h16);
      return { part: w2.parameterExpansion("", { type: "BadSubstitution", text: d16 }), endIndex: h16 + 1 };
    }
  }
  if (l8 === "" && !a7 && !i10 && t6[n23] !== "}") {
    let u10 = 1, f11 = n23;
    for (; f11 < t6.length && u10 > 0; ) t6[f11] === "{" ? u10++ : t6[f11] === "}" && u10--, u10 > 0 && f11++;
    if (u10 > 0) throw new Q2("unexpected EOF while looking for matching '}'", 0, 0);
    let h16 = t6.slice(r8 + 2, f11);
    return { part: w2.parameterExpansion("", { type: "BadSubstitution", text: h16 }), endIndex: f11 + 1 };
  }
  let c14 = null;
  if (a7) {
    let u10 = l8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[([@*])\]$/);
    if (u10) if (n23 < t6.length && t6[n23] !== "}" && /[:=\-+?#%/^,@]/.test(t6[n23])) {
      let f11 = at(e5, t6, n23, l8, s9);
      f11.operation ? (c14 = { type: "Indirection", innerOp: f11.operation }, n23 = f11.endIndex) : (c14 = { type: "ArrayKeys", array: u10[1], star: u10[2] === "*" }, l8 = "");
    } else c14 = { type: "ArrayKeys", array: u10[1], star: u10[2] === "*" }, l8 = "";
    else if (t6[n23] === "*" || t6[n23] === "@" && !/[QPaAEKkuUL]/.test(t6[n23 + 1] || "")) {
      let f11 = t6[n23];
      n23++, c14 = { type: "VarNamePrefix", prefix: l8, star: f11 === "*" }, l8 = "";
    } else if (n23 < t6.length && t6[n23] !== "}" && /[:=\-+?#%/^,@]/.test(t6[n23])) {
      let f11 = at(e5, t6, n23, l8, s9);
      f11.operation ? (c14 = { type: "Indirection", innerOp: f11.operation }, n23 = f11.endIndex) : c14 = { type: "Indirection" };
    } else c14 = { type: "Indirection" };
  } else if (i10) if (t6[n23] === ":") for (c14 = { type: "LengthSliceError" }; n23 < t6.length && t6[n23] !== "}"; ) n23++;
  else t6[n23] !== "}" && /[-+=?]/.test(t6[n23]) ? e5.error(`\${#${l8}${t6.slice(n23, t6.indexOf("}", n23))}}: bad substitution`) : t6[n23] === "/" ? e5.error(`\${#${l8}${t6.slice(n23, t6.indexOf("}", n23))}}: bad substitution`) : c14 = { type: "Length" };
  if (!c14 && n23 < t6.length && t6[n23] !== "}") {
    let u10 = at(e5, t6, n23, l8, s9);
    c14 = u10.operation, n23 = u10.endIndex;
  }
  if (n23 < t6.length && t6[n23] !== "}") {
    let u10 = t6[n23];
    if (!/[:\-+=?#%/^,@[]/.test(u10)) {
      let f11 = n23;
      for (; f11 < t6.length && t6[f11] !== "}"; ) f11++;
      let h16 = t6.slice(r8, f11 + 1);
      e5.error(`\${${h16.slice(2, -1)}}: bad substitution`);
    }
  }
  for (; n23 < t6.length && t6[n23] !== "}"; ) n23++;
  if (n23 >= t6.length) throw new Q2("unexpected EOF while looking for matching '}'", 0, 0);
  return { part: w2.parameterExpansion(l8, c14), endIndex: n23 + 1 };
}
function at(e5, t6, r8, s9, n23 = false) {
  let a7 = r8, i10 = t6[a7], l8 = t6[a7 + 1] || "";
  if (i10 === ":") {
    let o9 = l8;
    if ("-=?+".includes(o9)) {
      a7 += 2;
      let A13 = fe(e5, t6, a7), S16 = t6.slice(a7, A13), y18 = ae(e5, S16, false, false, true, false, n23, false, false, true), b25 = w2.word(y18.length > 0 ? y18 : [w2.literal("")]);
      if (o9 === "-") return { operation: { type: "DefaultValue", word: b25, checkEmpty: true }, endIndex: A13 };
      if (o9 === "=") return { operation: { type: "AssignDefault", word: b25, checkEmpty: true }, endIndex: A13 };
      if (o9 === "?") return { operation: { type: "ErrorIfUnset", word: b25, checkEmpty: true }, endIndex: A13 };
      if (o9 === "+") return { operation: { type: "UseAlternative", word: b25, checkEmpty: true }, endIndex: A13 };
    }
    a7++;
    let c14 = fe(e5, t6, a7), u10 = t6.slice(a7, c14), f11 = -1, h16 = 0, d16 = 0;
    for (let E12 = 0; E12 < u10.length; E12++) {
      let A13 = u10[E12];
      if (A13 === "(" || A13 === "[") h16++;
      else if (A13 === ")" || A13 === "]") h16--;
      else if (A13 === "?" && h16 === 0) d16++;
      else if (A13 === ":" && h16 === 0) if (d16 > 0) d16--;
      else {
        f11 = E12;
        break;
      }
    }
    let m24 = f11 >= 0 ? u10.slice(0, f11) : u10, g18 = f11 >= 0 ? u10.slice(f11 + 1) : null;
    return { operation: { type: "Substring", offset: He(e5, m24), length: g18 !== null ? He(e5, g18) : null }, endIndex: c14 };
  }
  if ("-=?+".includes(i10)) {
    a7++;
    let o9 = fe(e5, t6, a7), c14 = t6.slice(a7, o9), u10 = ae(e5, c14, false, false, true, false, n23, false, false, true), f11 = w2.word(u10.length > 0 ? u10 : [w2.literal("")]);
    if (i10 === "-") return { operation: { type: "DefaultValue", word: f11, checkEmpty: false }, endIndex: o9 };
    if (i10 === "=") return { operation: { type: "AssignDefault", word: f11, checkEmpty: false }, endIndex: o9 };
    if (i10 === "?") return { operation: { type: "ErrorIfUnset", word: c14 ? f11 : null, checkEmpty: false }, endIndex: o9 };
    if (i10 === "+") return { operation: { type: "UseAlternative", word: f11, checkEmpty: false }, endIndex: o9 };
  }
  if (i10 === "#" || i10 === "%") {
    let o9 = l8 === i10, c14 = i10 === "#" ? "prefix" : "suffix";
    a7 += o9 ? 2 : 1;
    let u10 = fe(e5, t6, a7), f11 = t6.slice(a7, u10), h16 = ae(e5, f11, false, false, false);
    return { operation: { type: "PatternRemoval", pattern: w2.word(h16.length > 0 ? h16 : [w2.literal("")]), side: c14, greedy: o9 }, endIndex: u10 };
  }
  if (i10 === "/") {
    let o9 = l8 === "/";
    a7 += o9 ? 2 : 1;
    let c14 = null;
    t6[a7] === "#" ? (c14 = "start", a7++) : t6[a7] === "%" && (c14 = "end", a7++);
    let u10;
    c14 !== null && (t6[a7] === "/" || t6[a7] === "}") ? u10 = a7 : u10 = Kt(e5, t6, a7);
    let f11 = t6.slice(a7, u10), h16 = ae(e5, f11, false, false, false), d16 = w2.word(h16.length > 0 ? h16 : [w2.literal("")]), m24 = null, g18 = u10;
    if (t6[u10] === "/") {
      let E12 = u10 + 1, A13 = fe(e5, t6, E12), S16 = t6.slice(E12, A13), y18 = ae(e5, S16, false, false, false);
      m24 = w2.word(y18.length > 0 ? y18 : [w2.literal("")]), g18 = A13;
    }
    return { operation: { type: "PatternReplacement", pattern: d16, replacement: m24, all: o9, anchor: c14 }, endIndex: g18 };
  }
  if (i10 === "^" || i10 === ",") {
    let o9 = l8 === i10, c14 = i10 === "^" ? "upper" : "lower";
    a7 += o9 ? 2 : 1;
    let u10 = fe(e5, t6, a7), f11 = t6.slice(a7, u10), h16 = f11 ? w2.word([w2.literal(f11)]) : null;
    return { operation: { type: "CaseModification", direction: c14, all: o9, pattern: h16 }, endIndex: u10 };
  }
  return i10 === "@" && /[QPaAEKkuUL]/.test(l8) ? { operation: { type: "Transform", operator: l8 }, endIndex: a7 + 2 } : { operation: null, endIndex: a7 };
}
function ot(e5, t6, r8, s9 = false) {
  let n23 = r8 + 1;
  if (n23 >= t6.length) return { part: w2.literal("$"), endIndex: n23 };
  let a7 = t6[n23];
  if (a7 === "(" && t6[n23 + 1] === "(") return e5.isDollarDparenSubshell(t6, r8) ? e5.parseCommandSubstitution(t6, r8) : e5.parseArithmeticExpansion(t6, r8);
  if (a7 === "[") {
    let i10 = 1, l8 = n23 + 1;
    for (; l8 < t6.length && i10 > 0; ) t6[l8] === "[" ? i10++ : t6[l8] === "]" && i10--, i10 > 0 && l8++;
    if (i10 === 0) {
      let o9 = t6.slice(n23 + 1, l8), c14 = M2(e5, o9);
      return { part: w2.arithmeticExpansion(c14), endIndex: l8 + 1 };
    }
  }
  return a7 === "(" ? e5.parseCommandSubstitution(t6, r8) : a7 === "{" ? Hr(e5, t6, r8, s9) : /[a-zA-Z_0-9@*#?$!-]/.test(a7) ? Ur(e5, t6, r8) : { part: w2.literal("$"), endIndex: n23 };
}
function on(e5, t6) {
  let r8 = [], s9 = 0, n23 = "", a7 = () => {
    n23 && (r8.push(w2.literal(n23)), n23 = "");
  };
  for (; s9 < t6.length; ) {
    let i10 = t6[s9];
    if (i10 === "\\" && s9 + 1 < t6.length) {
      let l8 = t6[s9 + 1];
      if (l8 === "$" || l8 === "`" || l8 === '"' || l8 === "\\") {
        n23 += l8, s9 += 2;
        continue;
      }
      n23 += i10, s9++;
      continue;
    }
    if (i10 === "$") {
      a7();
      let { part: l8, endIndex: o9 } = ot(e5, t6, s9, true);
      l8 && r8.push(l8), s9 = o9;
      continue;
    }
    if (i10 === "`") {
      a7();
      let { part: l8, endIndex: o9 } = e5.parseBacktickSubstitution(t6, s9, true);
      r8.push(l8), s9 = o9;
      continue;
    }
    n23 += i10, s9++;
  }
  return a7(), r8;
}
function jr(e5, t6, r8) {
  let s9 = [], n23 = r8, a7 = "", i10 = () => {
    a7 && (s9.push(w2.literal(a7)), a7 = "");
  };
  for (; n23 < t6.length && t6[n23] !== '"'; ) {
    let l8 = t6[n23];
    if (l8 === "\\" && n23 + 1 < t6.length) {
      let o9 = t6[n23 + 1];
      if ('"\\$`\n'.includes(o9)) {
        a7 += o9, n23 += 2;
        continue;
      }
      a7 += l8, n23++;
      continue;
    }
    if (l8 === "$") {
      i10();
      let { part: o9, endIndex: c14 } = ot(e5, t6, n23, true);
      o9 && s9.push(o9), n23 = c14;
      continue;
    }
    if (l8 === "`") {
      i10();
      let { part: o9, endIndex: c14 } = e5.parseBacktickSubstitution(t6, n23, true);
      s9.push(o9), n23 = c14;
      continue;
    }
    a7 += l8, n23++;
  }
  return i10(), { part: w2.doubleQuoted(s9), endIndex: n23 };
}
function ae(e5, t6, r8 = false, s9 = false, n23 = false, a7 = false, i10 = false, l8 = false, o9 = false, c14 = false) {
  if (s9) return [w2.singleQuoted(t6)];
  if (r8) {
    let m24 = on(e5, t6);
    return [w2.doubleQuoted(m24)];
  }
  if (t6.length >= 2 && t6[0] === '"' && t6[t6.length - 1] === '"') {
    let m24 = t6.slice(1, -1), g18 = false;
    for (let E12 = 0; E12 < m24.length; E12++) {
      if (m24[E12] === '"') {
        g18 = true;
        break;
      }
      m24[E12] === "\\" && E12 + 1 < m24.length && E12++;
    }
    if (!g18) {
      let E12 = on(e5, m24);
      return [w2.doubleQuoted(E12)];
    }
  }
  let u10 = [], f11 = 0, h16 = "", d16 = () => {
    h16 && (u10.push(w2.literal(h16)), h16 = "");
  };
  for (; f11 < t6.length; ) {
    let m24 = t6[f11];
    if (m24 === "\\" && f11 + 1 < t6.length) {
      let g18 = t6[f11 + 1];
      if (o9) {
        d16(), u10.push(w2.escaped(g18)), f11 += 2;
        continue;
      }
      let E12 = a7 ? g18 === "$" || g18 === "`" || g18 === `
` : g18 === "$" || g18 === "`" || g18 === '"' || g18 === "'" || g18 === `
` || c14 && g18 === "}", A13 = i10 ? "*?[]\\".includes(g18) : "*?[]\\(){}.^+".includes(g18);
      E12 ? h16 += g18 : A13 ? (d16(), u10.push(w2.escaped(g18))) : h16 += `\\${g18}`, f11 += 2;
      continue;
    }
    if (m24 === "'" && !i10 && !a7) {
      d16();
      let g18 = t6.indexOf("'", f11 + 1);
      if (g18 === -1) {
        h16 += t6.slice(f11);
        break;
      }
      u10.push(w2.singleQuoted(t6.slice(f11 + 1, g18))), f11 = g18 + 1;
      continue;
    }
    if (m24 === '"' && !a7) {
      d16();
      let { part: g18, endIndex: E12 } = jr(e5, t6, f11 + 1);
      u10.push(g18), f11 = E12 + 1;
      continue;
    }
    if (m24 === "$" && t6[f11 + 1] === "'") {
      d16();
      let { part: g18, endIndex: E12 } = Jt(e5, t6, f11 + 2);
      u10.push(g18), f11 = E12;
      continue;
    }
    if (m24 === "$") {
      d16();
      let { part: g18, endIndex: E12 } = ot(e5, t6, f11);
      g18 && u10.push(g18), f11 = E12;
      continue;
    }
    if (m24 === "`") {
      d16();
      let { part: g18, endIndex: E12 } = e5.parseBacktickSubstitution(t6, f11);
      u10.push(g18), f11 = E12;
      continue;
    }
    if (m24 === "~") {
      let g18 = f11 > 0 ? t6[f11 - 1] : "";
      if (f11 === 0 || g18 === "=" || n23 && g18 === ":") {
        let A13 = jt(e5, t6, f11), S16 = t6[A13];
        if (S16 === void 0 || S16 === "/" || S16 === ":") {
          d16();
          let y18 = t6.slice(f11 + 1, A13) || null;
          u10.push({ type: "TildeExpansion", user: y18 }), f11 = A13;
          continue;
        }
      }
    }
    if ("@*+?!".includes(m24) && f11 + 1 < t6.length && t6[f11 + 1] === "(") {
      let g18 = Zr(t6, f11 + 1);
      if (g18 !== -1) {
        d16();
        let E12 = t6.slice(f11, g18 + 1);
        u10.push({ type: "Glob", pattern: E12 }), f11 = g18 + 1;
        continue;
      }
    }
    if (m24 === "*" || m24 === "?" || m24 === "[") {
      d16();
      let { pattern: g18, endIndex: E12 } = Xt(e5, t6, f11);
      u10.push({ type: "Glob", pattern: g18 }), f11 = E12;
      continue;
    }
    if (m24 === "{" && !n23 && !l8) {
      let g18 = Yt(e5, t6, f11, ae);
      if (g18) {
        d16(), u10.push(g18.part), f11 = g18.endIndex;
        continue;
      }
    }
    h16 += m24, f11++;
  }
  return d16(), u10;
}
function ln(e5, t6) {
  let r8 = e5.length, s9 = t6 + 3, n23 = 2, a7 = false, i10 = false;
  for (; s9 < r8 && n23 > 0; ) {
    let l8 = e5[s9];
    if (a7) {
      l8 === "'" && (a7 = false), s9++;
      continue;
    }
    if (i10) {
      if (l8 === "\\") {
        s9 += 2;
        continue;
      }
      l8 === '"' && (i10 = false), s9++;
      continue;
    }
    if (l8 === "'") {
      a7 = true, s9++;
      continue;
    }
    if (l8 === '"') {
      i10 = true, s9++;
      continue;
    }
    if (l8 === "\\") {
      s9 += 2;
      continue;
    }
    if (l8 === "(") {
      n23++, s9++;
      continue;
    }
    if (l8 === ")") {
      if (n23--, n23 === 1) {
        let o9 = s9 + 1;
        return !(o9 < r8 && e5[o9] === ")");
      }
      if (n23 === 0) return false;
      s9++;
      continue;
    }
    if (n23 === 1 && (l8 === "|" && s9 + 1 < r8 && e5[s9 + 1] === "|" || l8 === "&" && s9 + 1 < r8 && e5[s9 + 1] === "&" || l8 === "|" && s9 + 1 < r8 && e5[s9 + 1] !== "|")) return true;
    s9++;
  }
  return false;
}
function un(e5, t6, r8, s9) {
  let n23 = t6 + 2, a7 = 1, i10 = n23, l8 = false, o9 = false, c14 = 0, u10 = false, f11 = "";
  for (; i10 < e5.length && a7 > 0; ) {
    let g18 = e5[i10];
    l8 ? g18 === "'" && (l8 = false) : o9 ? g18 === "\\" && i10 + 1 < e5.length ? i10++ : g18 === '"' && (o9 = false) : g18 === "'" ? (l8 = true, f11 = "") : g18 === '"' ? (o9 = true, f11 = "") : g18 === "\\" && i10 + 1 < e5.length ? (i10++, f11 = "") : /[a-zA-Z_]/.test(g18) ? f11 += g18 : (f11 === "case" ? (c14++, u10 = false) : f11 === "in" && c14 > 0 ? u10 = true : f11 === "esac" && c14 > 0 && (c14--, u10 = false), f11 = "", g18 === "(" ? i10 > 0 && e5[i10 - 1] === "$" ? a7++ : u10 || a7++ : g18 === ")" ? u10 ? u10 = false : a7-- : g18 === ";" && c14 > 0 && i10 + 1 < e5.length && e5[i10 + 1] === ";" && (u10 = true)), a7 > 0 && i10++;
  }
  a7 > 0 && s9("unexpected EOF while looking for matching `)'");
  let h16 = e5.slice(n23, i10), m24 = r8().parse(h16);
  return { part: w2.commandSubstitution(m24, false), endIndex: i10 + 1 };
}
function cn(e5, t6, r8, s9, n23) {
  let i10 = t6 + 1, l8 = "";
  for (; i10 < e5.length && e5[i10] !== "`"; ) if (e5[i10] === "\\") {
    let u10 = e5[i10 + 1];
    u10 === "$" || u10 === "`" || u10 === "\\" || u10 === `
` || r8 && u10 === '"' ? (u10 !== `
` && (l8 += u10), i10 += 2) : (l8 += e5[i10], i10++);
  } else l8 += e5[i10], i10++;
  i10 >= e5.length && n23("unexpected EOF while looking for matching ``'");
  let c14 = s9().parse(l8);
  return { part: w2.commandSubstitution(c14, true), endIndex: i10 + 1 };
}
function hi(e5, t6) {
  return new V2().parse(e5, t6);
}
var Pe, w2, p2, pe, qt, Ir, vr, Dr, Ie, Qe, Ge, Qt, Ze, Gt, Zt, Ut, Q2, Lr, qr, Br, V2;
var init_chunk_V4CDPGZH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-V4CDPGZH.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    Pe = ["=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", "&=", "|=", "^="];
    w2 = { script(e5) {
      return { type: "Script", statements: e5 };
    }, statement(e5, t6 = [], r8 = false, s9, n23) {
      let a7 = { type: "Statement", pipelines: e5, operators: t6, background: r8 };
      return s9 && (a7.deferredError = s9), n23 !== void 0 && (a7.sourceText = n23), a7;
    }, pipeline(e5, t6 = false, r8 = false, s9 = false, n23) {
      return { type: "Pipeline", commands: e5, negated: t6, timed: r8, timePosix: s9, pipeStderr: n23 };
    }, simpleCommand(e5, t6 = [], r8 = [], s9 = []) {
      return { type: "SimpleCommand", name: e5, args: t6, assignments: r8, redirections: s9 };
    }, word(e5) {
      return { type: "Word", parts: e5 };
    }, literal(e5) {
      return { type: "Literal", value: e5 };
    }, singleQuoted(e5) {
      return { type: "SingleQuoted", value: e5 };
    }, doubleQuoted(e5) {
      return { type: "DoubleQuoted", parts: e5 };
    }, escaped(e5) {
      return { type: "Escaped", value: e5 };
    }, parameterExpansion(e5, t6 = null) {
      return { type: "ParameterExpansion", parameter: e5, operation: t6 };
    }, commandSubstitution(e5, t6 = false) {
      return { type: "CommandSubstitution", body: e5, legacy: t6 };
    }, arithmeticExpansion(e5) {
      return { type: "ArithmeticExpansion", expression: e5 };
    }, assignment(e5, t6, r8 = false, s9 = null) {
      return { type: "Assignment", name: e5, value: t6, append: r8, array: s9 };
    }, redirection(e5, t6, r8 = null, s9) {
      let n23 = { type: "Redirection", fd: r8, operator: e5, target: t6 };
      return s9 && (n23.fdVariable = s9), n23;
    }, hereDoc(e5, t6, r8 = false, s9 = false) {
      return { type: "HereDoc", delimiter: e5, content: t6, stripTabs: r8, quoted: s9 };
    }, ifNode(e5, t6 = null, r8 = []) {
      return { type: "If", clauses: e5, elseBody: t6, redirections: r8 };
    }, forNode(e5, t6, r8, s9 = []) {
      return { type: "For", variable: e5, words: t6, body: r8, redirections: s9 };
    }, whileNode(e5, t6, r8 = []) {
      return { type: "While", condition: e5, body: t6, redirections: r8 };
    }, untilNode(e5, t6, r8 = []) {
      return { type: "Until", condition: e5, body: t6, redirections: r8 };
    }, caseNode(e5, t6, r8 = []) {
      return { type: "Case", word: e5, items: t6, redirections: r8 };
    }, caseItem(e5, t6, r8 = ";;") {
      return { type: "CaseItem", patterns: e5, body: t6, terminator: r8 };
    }, subshell(e5, t6 = []) {
      return { type: "Subshell", body: e5, redirections: t6 };
    }, group(e5, t6 = []) {
      return { type: "Group", body: e5, redirections: t6 };
    }, functionDef(e5, t6, r8 = [], s9) {
      return { type: "FunctionDef", name: e5, body: t6, redirections: r8, sourceFile: s9 };
    }, conditionalCommand(e5, t6 = [], r8) {
      return { type: "ConditionalCommand", expression: e5, redirections: t6, line: r8 };
    }, arithmeticCommand(e5, t6 = [], r8) {
      return { type: "ArithmeticCommand", expression: e5, redirections: t6, line: r8 };
    } };
    (function(e5) {
      e5.EOF = "EOF", e5.NEWLINE = "NEWLINE", e5.SEMICOLON = "SEMICOLON", e5.AMP = "AMP", e5.PIPE = "PIPE", e5.PIPE_AMP = "PIPE_AMP", e5.AND_AND = "AND_AND", e5.OR_OR = "OR_OR", e5.BANG = "BANG", e5.LESS = "LESS", e5.GREAT = "GREAT", e5.DLESS = "DLESS", e5.DGREAT = "DGREAT", e5.LESSAND = "LESSAND", e5.GREATAND = "GREATAND", e5.LESSGREAT = "LESSGREAT", e5.DLESSDASH = "DLESSDASH", e5.CLOBBER = "CLOBBER", e5.TLESS = "TLESS", e5.AND_GREAT = "AND_GREAT", e5.AND_DGREAT = "AND_DGREAT", e5.LPAREN = "LPAREN", e5.RPAREN = "RPAREN", e5.LBRACE = "LBRACE", e5.RBRACE = "RBRACE", e5.DSEMI = "DSEMI", e5.SEMI_AND = "SEMI_AND", e5.SEMI_SEMI_AND = "SEMI_SEMI_AND", e5.DBRACK_START = "DBRACK_START", e5.DBRACK_END = "DBRACK_END", e5.DPAREN_START = "DPAREN_START", e5.DPAREN_END = "DPAREN_END", e5.IF = "IF", e5.THEN = "THEN", e5.ELSE = "ELSE", e5.ELIF = "ELIF", e5.FI = "FI", e5.FOR = "FOR", e5.WHILE = "WHILE", e5.UNTIL = "UNTIL", e5.DO = "DO", e5.DONE = "DONE", e5.CASE = "CASE", e5.ESAC = "ESAC", e5.IN = "IN", e5.FUNCTION = "FUNCTION", e5.SELECT = "SELECT", e5.TIME = "TIME", e5.COPROC = "COPROC", e5.WORD = "WORD", e5.NAME = "NAME", e5.NUMBER = "NUMBER", e5.ASSIGNMENT_WORD = "ASSIGNMENT_WORD", e5.FD_VARIABLE = "FD_VARIABLE", e5.COMMENT = "COMMENT", e5.HEREDOC_CONTENT = "HEREDOC_CONTENT";
    })(p2 || (p2 = {}));
    pe = class extends Error {
      line;
      column;
      constructor(t6, r8, s9) {
        super(`line ${r8}: ${t6}`), this.line = r8, this.column = s9, this.name = "LexerError";
      }
    };
    qt = /* @__PURE__ */ new Map([["if", p2.IF], ["then", p2.THEN], ["else", p2.ELSE], ["elif", p2.ELIF], ["fi", p2.FI], ["for", p2.FOR], ["while", p2.WHILE], ["until", p2.UNTIL], ["do", p2.DO], ["done", p2.DONE], ["case", p2.CASE], ["esac", p2.ESAC], ["in", p2.IN], ["function", p2.FUNCTION], ["select", p2.SELECT], ["time", p2.TIME], ["coproc", p2.COPROC]]);
    Ir = [[";", ";", "&", p2.SEMI_SEMI_AND], ["<", "<", "<", p2.TLESS], ["&", ">", ">", p2.AND_DGREAT]];
    vr = [["[", "[", p2.DBRACK_START], ["]", "]", p2.DBRACK_END], ["(", "(", p2.DPAREN_START], [")", ")", p2.DPAREN_END], ["&", "&", p2.AND_AND], ["|", "|", p2.OR_OR], [";", ";", p2.DSEMI], [";", "&", p2.SEMI_AND], ["|", "&", p2.PIPE_AMP], [">", ">", p2.DGREAT], ["<", "&", p2.LESSAND], [">", "&", p2.GREATAND], ["<", ">", p2.LESSGREAT], [">", "|", p2.CLOBBER], ["&", ">", p2.AND_GREAT]];
    Dr = /* @__PURE__ */ new Map([["|", p2.PIPE], ["&", p2.AMP], [";", p2.SEMICOLON], ["(", p2.LPAREN], [")", p2.RPAREN], ["<", p2.LESS], [">", p2.GREAT]]);
    Ie = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      tokens = [];
      pendingHeredocs = [];
      dparenDepth = 0;
      maxHeredocSize;
      constructor(t6, r8) {
        this.input = t6, this.maxHeredocSize = r8?.maxHeredocSize ?? 10485760;
      }
      tokenize() {
        let r8 = this.input.length, s9 = this.tokens, n23 = this.pendingHeredocs;
        for (; this.pos < r8; ) {
          if (n23.length > 0 && s9.length > 0 && s9[s9.length - 1].type === p2.NEWLINE) {
            this.readHeredocContent();
            continue;
          }
          if (this.skipWhitespace(), this.pos >= r8) break;
          let a7 = this.nextToken();
          a7 && s9.push(a7);
        }
        return s9.push({ type: p2.EOF, value: "", start: this.pos, end: this.pos, line: this.line, column: this.column }), s9;
      }
      skipWhitespace() {
        let t6 = this.input, r8 = t6.length, s9 = this.pos, n23 = this.column, a7 = this.line;
        for (; s9 < r8; ) {
          let i10 = t6[s9];
          if (i10 === " " || i10 === "	") s9++, n23++;
          else if (i10 === "\\" && t6[s9 + 1] === `
`) s9 += 2, a7++, n23 = 1;
          else break;
        }
        this.pos = s9, this.column = n23, this.line = a7;
      }
      nextToken() {
        let t6 = this.input, r8 = this.pos, s9 = this.line, n23 = this.column, a7 = t6[r8], i10 = t6[r8 + 1], l8 = t6[r8 + 2];
        if (a7 === "#" && this.dparenDepth === 0) return this.readComment(r8, s9, n23);
        if (a7 === `
`) return this.pos = r8 + 1, this.line++, this.column = 1, { type: p2.NEWLINE, value: `
`, start: r8, end: r8 + 1, line: s9, column: n23 };
        if (a7 === "<" && i10 === "<" && l8 === "-") return this.pos = r8 + 3, this.column = n23 + 3, this.registerHeredocFromLookahead(true), this.makeToken(p2.DLESSDASH, "<<-", r8, s9, n23);
        for (let [c14, u10, f11, h16] of Ir) if (a7 === c14 && i10 === u10 && l8 === f11) return this.pos = r8 + 3, this.column = n23 + 3, this.makeToken(h16, c14 + u10 + f11, r8, s9, n23);
        if (a7 === "<" && i10 === "<") return this.pos = r8 + 2, this.column = n23 + 2, this.registerHeredocFromLookahead(false), this.makeToken(p2.DLESS, "<<", r8, s9, n23);
        if (a7 === "(" && i10 === "(") return this.dparenDepth > 0 ? (this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth++, this.makeToken(p2.LPAREN, "(", r8, s9, n23)) : this.looksLikeNestedSubshells(r8 + 2) || this.dparenClosesWithSpacedParens(r8 + 2) ? (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.LPAREN, "(", r8, s9, n23)) : (this.pos = r8 + 2, this.column = n23 + 2, this.dparenDepth = 1, this.makeToken(p2.DPAREN_START, "((", r8, s9, n23));
        if (a7 === ")" && i10 === ")") return this.dparenDepth === 1 ? (this.pos = r8 + 2, this.column = n23 + 2, this.dparenDepth = 0, this.makeToken(p2.DPAREN_END, "))", r8, s9, n23)) : this.dparenDepth > 1 ? (this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth--, this.makeToken(p2.RPAREN, ")", r8, s9, n23)) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.RPAREN, ")", r8, s9, n23));
        for (let [c14, u10, f11] of vr) if (!(c14 === "(" && u10 === "(" || c14 === ")" && u10 === ")") && !(this.dparenDepth > 0 && c14 === ";" && (f11 === p2.DSEMI || f11 === p2.SEMI_AND || f11 === p2.SEMI_SEMI_AND)) && a7 === c14 && i10 === u10) {
          if (f11 === p2.DBRACK_START || f11 === p2.DBRACK_END) {
            let h16 = t6[r8 + 2];
            if (h16 !== void 0 && h16 !== " " && h16 !== "	" && h16 !== `
` && h16 !== ";" && h16 !== "&" && h16 !== "|" && h16 !== "(" && h16 !== ")" && h16 !== "<" && h16 !== ">") break;
          }
          return this.pos = r8 + 2, this.column = n23 + 2, this.makeToken(f11, c14 + u10, r8, s9, n23);
        }
        if (a7 === "(" && this.dparenDepth > 0) return this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth++, this.makeToken(p2.LPAREN, "(", r8, s9, n23);
        if (a7 === ")" && this.dparenDepth > 1) return this.pos = r8 + 1, this.column = n23 + 1, this.dparenDepth--, this.makeToken(p2.RPAREN, ")", r8, s9, n23);
        let o9 = Dr.get(a7);
        if (o9 !== void 0) return this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(o9, a7, r8, s9, n23);
        if (a7 === "{") {
          let c14 = this.scanFdVariable(r8);
          return c14 !== null ? (this.pos = c14.end, this.column = n23 + (c14.end - r8), { type: p2.FD_VARIABLE, value: c14.varname, start: r8, end: c14.end, line: s9, column: n23 }) : i10 === "}" ? (this.pos = r8 + 2, this.column = n23 + 2, { type: p2.WORD, value: "{}", start: r8, end: r8 + 2, line: s9, column: n23, quoted: false, singleQuoted: false }) : this.scanBraceExpansion(r8) !== null ? this.readWordWithBraceExpansion(r8, s9, n23) : this.scanLiteralBraceWord(r8) !== null ? this.readWordWithBraceExpansion(r8, s9, n23) : i10 !== void 0 && i10 !== " " && i10 !== "	" && i10 !== `
` ? this.readWord(r8, s9, n23) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.LBRACE, "{", r8, s9, n23));
        }
        return a7 === "}" ? this.isWordCharFollowing(r8 + 1) ? this.readWord(r8, s9, n23) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.RBRACE, "}", r8, s9, n23)) : a7 === "!" ? i10 === "=" ? (this.pos = r8 + 2, this.column = n23 + 2, this.makeToken(p2.WORD, "!=", r8, s9, n23)) : (this.pos = r8 + 1, this.column = n23 + 1, this.makeToken(p2.BANG, "!", r8, s9, n23)) : this.readWord(r8, s9, n23);
      }
      looksLikeNestedSubshells(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6;
        for (; n23 < s9 && (r8[n23] === " " || r8[n23] === "	"); ) n23++;
        if (n23 >= s9) return false;
        let a7 = r8[n23];
        if (a7 === "(") return this.looksLikeNestedSubshells(n23 + 1);
        let i10 = /[a-zA-Z_]/.test(a7), l8 = a7 === "!" || a7 === "[";
        if (!i10 && !l8) return false;
        let o9 = n23;
        for (; o9 < s9 && /[a-zA-Z0-9_\-.]/.test(r8[o9]); ) o9++;
        if (o9 === n23) return l8;
        let c14 = o9;
        for (; c14 < s9 && (r8[c14] === " " || r8[c14] === "	"); ) c14++;
        if (c14 >= s9) return false;
        let u10 = r8[c14];
        if (u10 === "=" && r8[c14 + 1] !== "=" || u10 === `
` || o9 === c14 && /[+\-*/%<>&|^!~?:]/.test(u10) && u10 !== "-" || u10 === ")" && r8[c14 + 1] === ")") return false;
        if (c14 > o9 && (u10 === "-" || u10 === '"' || u10 === "'" || u10 === "$" || /[a-zA-Z_/.]/.test(u10))) {
          let f11 = c14;
          for (; f11 < s9 && r8[f11] !== `
`; ) {
            if (r8[f11] === ")") return true;
            f11++;
          }
          return false;
        }
        if (u10 === ")") {
          let f11 = c14 + 1;
          for (; f11 < s9 && (r8[f11] === " " || r8[f11] === "	"); ) f11++;
          if (r8[f11] === "|" && r8[f11 + 1] === "|" || r8[f11] === "&" && r8[f11 + 1] === "&" || r8[f11] === ";" || r8[f11] === "|" && r8[f11 + 1] !== "|") return true;
        }
        return false;
      }
      makeToken(t6, r8, s9, n23, a7) {
        return { type: t6, value: r8, start: s9, end: this.pos, line: n23, column: a7 };
      }
      readComment(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = this.pos;
        for (; i10 < a7 && n23[i10] !== `
`; ) i10++;
        let l8 = n23.slice(t6, i10);
        return this.pos = i10, this.column = s9 + (i10 - t6), { type: p2.COMMENT, value: l8, start: t6, end: i10, line: r8, column: s9 };
      }
      readWord(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = this.pos, l8 = i10;
        for (; i10 < a7; ) {
          let y18 = n23[i10];
          if (y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">" || y18 === "'" || y18 === '"' || y18 === "\\" || y18 === "$" || y18 === "`" || y18 === "{" || y18 === "}" || y18 === "~" || y18 === "*" || y18 === "?" || y18 === "[") break;
          i10++;
        }
        if (i10 > l8) {
          let y18 = n23[i10];
          if (!(y18 === "(" && i10 > l8 && "@*+?!".includes(n23[i10 - 1]))) {
            if (i10 >= a7 || y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">") {
              let b25 = n23.slice(l8, i10);
              this.pos = i10, this.column = s9 + (i10 - l8);
              let D15 = qt.get(b25);
              if (D15 !== void 0) return { type: D15, value: b25, start: t6, end: i10, line: r8, column: s9 };
              let G8 = Ft(b25);
              return G8 > 0 && Bt(b25.slice(0, G8)) ? { type: p2.ASSIGNMENT_WORD, value: b25, start: t6, end: i10, line: r8, column: s9 } : /^[0-9]+$/.test(b25) ? { type: p2.NUMBER, value: b25, start: t6, end: i10, line: r8, column: s9 } : /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(b25) ? { type: p2.NAME, value: b25, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false } : { type: p2.WORD, value: b25, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false };
            }
          }
        }
        i10 = this.pos;
        let o9 = this.column, c14 = this.line, u10 = "", f11 = false, h16 = false, d16 = false, m24 = false, g18 = n23[i10] === '"' || n23[i10] === "'", E12 = false, A13 = 0;
        for (; i10 < a7; ) {
          let y18 = n23[i10];
          if (!d16 && !m24) {
            if (y18 === "(" && u10.length > 0 && "@*+?!".includes(u10[u10.length - 1])) {
              let b25 = this.scanExtglobPattern(i10);
              if (b25 !== null) {
                u10 += b25.content, i10 = b25.end, o9 += b25.content.length;
                continue;
              }
            }
            if (y18 === "[" && A13 === 0) {
              if (/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(u10)) {
                let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
                if (b25 === "^" || b25 === "!") {
                  u10 += y18, i10++, o9++;
                  continue;
                }
                A13 = 1, u10 += y18, i10++, o9++;
                continue;
              }
            } else if (y18 === "[" && A13 > 0) {
              u10.length > 0 && u10[u10.length - 1] !== "\\" && A13++, u10 += y18, i10++, o9++;
              continue;
            } else if (y18 === "]" && A13 > 0) {
              u10.length > 0 && u10[u10.length - 1] !== "\\" && A13--, u10 += y18, i10++, o9++;
              continue;
            }
            if (A13 > 0) {
              if (y18 === `
`) break;
              u10 += y18, i10++, o9++;
              continue;
            }
            if (y18 === " " || y18 === "	" || y18 === `
` || y18 === ";" || y18 === "&" || y18 === "|" || y18 === "(" || y18 === ")" || y18 === "<" || y18 === ">") break;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "'" && !d16 && !m24) {
            for (u10 += "$'", i10 += 2, o9 += 2; i10 < a7 && n23[i10] !== "'"; ) n23[i10] === "\\" && i10 + 1 < a7 ? (u10 += n23[i10] + n23[i10 + 1], i10 += 2, o9 += 2) : (u10 += n23[i10], i10++, o9++);
            i10 < a7 && (u10 += "'", i10++, o9++);
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === '"' && !d16 && !m24) {
            i10++, o9++, m24 = true, f11 = true, u10 === "" && (g18 = true), i10++, o9++;
            continue;
          }
          if (y18 === "'" && !m24) {
            if (d16) if (d16 = false, !g18 || E12) u10 += y18;
            else {
              let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
              b25 && !zt(b25) && b25 !== "'" && (b25 === '"' ? (E12 = true, u10 += y18, h16 = false, f11 = false) : (E12 = true, u10 += y18));
            }
            else d16 = true, g18 && !E12 ? (h16 = true, f11 = true) : u10 += y18;
            i10++, o9++;
            continue;
          }
          if (y18 === '"' && !d16) {
            if (m24) if (m24 = false, !g18 || E12) u10 += y18;
            else {
              let b25 = i10 + 1 < a7 ? n23[i10 + 1] : "";
              b25 && !zt(b25) && b25 !== '"' && (b25 === "'" ? (E12 = true, u10 += y18, h16 = false, f11 = false) : (E12 = true, u10 += y18));
            }
            else m24 = true, g18 && !E12 ? f11 = true : u10 += y18;
            i10++, o9++;
            continue;
          }
          if (y18 === "\\" && !d16 && i10 + 1 < a7) {
            let b25 = n23[i10 + 1];
            if (b25 === `
`) {
              i10 += 2, c14++, o9 = 1;
              continue;
            }
            if (m24) {
              if (b25 === '"' || b25 === "\\" || b25 === "$" || b25 === "`" || b25 === `
`) {
                if (b25 === `
`) {
                  i10 += 2, o9 = 1, c14++;
                  continue;
                }
                u10 += y18 + b25, i10 += 2, o9 += 2;
                continue;
              }
            } else {
              b25 === "\\" || b25 === '"' || b25 === "'" || b25 === "`" || b25 === "*" || b25 === "?" || b25 === "[" || b25 === "]" || b25 === "(" || b25 === ")" || b25 === "$" || b25 === "-" || b25 === "." || b25 === "^" || b25 === "+" || b25 === "{" || b25 === "}" ? u10 += y18 + b25 : u10 += b25, i10 += 2, o9 += 2;
              continue;
            }
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "(" && !d16) {
            u10 += y18, i10++, o9++, u10 += n23[i10], i10++, o9++;
            let b25 = 1, D15 = false, G8 = false, ie7 = 0, H16 = false, B12 = "", we6 = n23[i10] === "(" && !this.dollarDparenIsSubshell(i10);
            for (; b25 > 0 && i10 < a7; ) {
              let _14 = n23[i10];
              if (u10 += _14, D15) _14 === "'" && (D15 = false);
              else if (G8) _14 === "\\" && i10 + 1 < a7 ? (u10 += n23[i10 + 1], i10++, o9++) : _14 === '"' && (G8 = false);
              else if (_14 === "'") D15 = true, B12 = "";
              else if (_14 === '"') G8 = true, B12 = "";
              else if (_14 === "\\" && i10 + 1 < a7) u10 += n23[i10 + 1], i10++, o9++, B12 = "";
              else if (_14 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{") {
                i10++, o9++, u10 += n23[i10], i10++, o9++;
                let qe5 = 1, Ne6 = false, Be5 = false;
                for (; qe5 > 0 && i10 < a7; ) {
                  let Y10 = n23[i10];
                  if (Y10 === "\\" && i10 + 1 < a7 && !Ne6) {
                    u10 += Y10, i10++, o9++, u10 += n23[i10], i10++, o9++;
                    continue;
                  }
                  u10 += Y10, Ne6 ? Y10 === "'" && (Ne6 = false) : Be5 ? Y10 === '"' && (Be5 = false) : Y10 === "'" ? Ne6 = true : Y10 === '"' ? Be5 = true : Y10 === "{" ? qe5++ : Y10 === "}" && qe5--, Y10 === `
` ? (c14++, o9 = 0) : o9++, i10++;
                }
                B12 = "";
                continue;
              } else if (_14 === "#" && !we6 && (B12 === "" || /\s/.test(n23[i10 - 1] || ""))) {
                for (; i10 + 1 < a7 && n23[i10 + 1] !== `
`; ) i10++, o9++, u10 += n23[i10];
                B12 = "";
              } else /[a-zA-Z_]/.test(_14) ? B12 += _14 : (B12 === "case" ? (ie7++, H16 = false) : B12 === "in" && ie7 > 0 ? H16 = true : B12 === "esac" && ie7 > 0 && (ie7--, H16 = false), B12 = "", _14 === "(" ? i10 > 0 && n23[i10 - 1] === "$" ? b25++ : H16 || b25++ : _14 === ")" ? H16 ? H16 = false : b25-- : _14 === ";" && ie7 > 0 && (i10 + 1 < a7 && n23[i10 + 1] === ";" || i10 + 1 < a7 && n23[i10 + 1] === "&") && (H16 = true));
              _14 === `
` && (c14++, o9 = 0, B12 = ""), i10++, o9++;
            }
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "[" && !d16) {
            u10 += y18, i10++, o9++, u10 += n23[i10], i10++, o9++;
            let b25 = 1;
            for (; b25 > 0 && i10 < a7; ) {
              let D15 = n23[i10];
              u10 += D15, D15 === "[" ? b25++ : D15 === "]" ? b25-- : D15 === `
` && (c14++, o9 = 0), i10++, o9++;
            }
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{" && !d16) {
            u10 += y18, i10++, o9++, u10 += n23[i10], i10++, o9++;
            let b25 = 1, D15 = false, G8 = false, ie7 = c14, H16 = o9, B12 = c14, we6 = o9;
            for (; b25 > 0 && i10 < a7; ) {
              let _14 = n23[i10];
              if (_14 === "\\" && i10 + 1 < a7 && n23[i10 + 1] === `
`) {
                i10 += 2, c14++, o9 = 1;
                continue;
              }
              if (_14 === "\\" && i10 + 1 < a7 && !D15) {
                u10 += _14, i10++, o9++, u10 += n23[i10], i10++, o9++;
                continue;
              }
              u10 += _14, D15 ? _14 === "'" && (D15 = false) : G8 ? _14 === '"' && (G8 = false) : _14 === "'" ? (D15 = true, ie7 = c14, H16 = o9) : _14 === '"' ? (G8 = true, B12 = c14, we6 = o9) : _14 === "{" ? b25++ : _14 === "}" && b25--, _14 === `
` && (c14++, o9 = 0), i10++, o9++;
            }
            if (D15) throw new pe("unexpected EOF while looking for matching `''", ie7, H16);
            if (G8) throw new pe("unexpected EOF while looking for matching `\"'", B12, we6);
            continue;
          }
          if (y18 === "$" && i10 + 1 < a7 && !d16) {
            let b25 = n23[i10 + 1];
            if (b25 === "#" || b25 === "?" || b25 === "$" || b25 === "!" || b25 === "@" || b25 === "*" || b25 === "-" || b25 >= "0" && b25 <= "9") {
              u10 += y18 + b25, i10 += 2, o9 += 2;
              continue;
            }
          }
          if (y18 === "`" && !d16) {
            for (u10 += y18, i10++, o9++; i10 < a7 && n23[i10] !== "`"; ) {
              let b25 = n23[i10];
              u10 += b25, b25 === "\\" && i10 + 1 < a7 && (u10 += n23[i10 + 1], i10++, o9++), b25 === `
` && (c14++, o9 = 0), i10++, o9++;
            }
            i10 < a7 && (u10 += n23[i10], i10++, o9++);
            continue;
          }
          u10 += y18, i10++, y18 === `
` ? (c14++, o9 = 1) : o9++;
        }
        if (this.pos = i10, this.column = o9, this.line = c14, E12 && g18 && (u10 = n23[t6] + u10, f11 = false, h16 = false), d16 || m24) {
          let y18 = d16 ? "'" : '"';
          throw new pe(`unexpected EOF while looking for matching \`${y18}'`, r8, s9);
        }
        if (!g18 && u10.length >= 2) {
          if (u10[0] === "'" && u10[u10.length - 1] === "'") {
            let y18 = u10.slice(1, -1);
            !y18.includes("'") && !y18.includes('"') && (u10 = y18, f11 = true, h16 = true);
          } else if (u10[0] === '"' && u10[u10.length - 1] === '"') {
            let y18 = u10.slice(1, -1), b25 = false;
            for (let D15 = 0; D15 < y18.length; D15++) {
              if (y18[D15] === '"') {
                b25 = true;
                break;
              }
              y18[D15] === "\\" && D15 + 1 < y18.length && D15++;
            }
            b25 || (u10 = y18, f11 = true, h16 = false);
          }
        }
        if (u10 === "") return { type: p2.WORD, value: "", start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h16 };
        let S16 = qt.get(u10);
        if (!f11 && S16 !== void 0) return { type: S16, value: u10, start: t6, end: i10, line: r8, column: s9 };
        if (!g18) {
          let y18 = Ft(u10);
          if (y18 > 0 && Bt(u10.slice(0, y18))) return { type: p2.ASSIGNMENT_WORD, value: u10, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h16 };
        }
        return /^[0-9]+$/.test(u10) ? { type: p2.NUMBER, value: u10, start: t6, end: i10, line: r8, column: s9 } : xr(u10) ? { type: p2.NAME, value: u10, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h16 } : { type: p2.WORD, value: u10, start: t6, end: i10, line: r8, column: s9, quoted: f11, singleQuoted: h16 };
      }
      readHeredocContent() {
        for (; this.pendingHeredocs.length > 0; ) {
          let t6 = this.pendingHeredocs.shift();
          if (!t6) break;
          let r8 = this.pos, s9 = this.line, n23 = this.column, a7 = "";
          for (; this.pos < this.input.length; ) {
            let i10 = this.pos, l8 = "";
            for (; this.pos < this.input.length && this.input[this.pos] !== `
`; ) l8 += this.input[this.pos], this.pos++, this.column++;
            if ((t6.stripTabs ? l8.replace(/^\t+/, "") : l8) === t6.delimiter) {
              this.pos < this.input.length && this.input[this.pos] === `
` && (this.pos++, this.line++, this.column = 1);
              break;
            }
            if (a7 += l8, a7.length > this.maxHeredocSize) throw new pe(`Heredoc size limit exceeded (${this.maxHeredocSize} bytes)`, s9, n23);
            this.pos < this.input.length && this.input[this.pos] === `
` && (a7 += `
`, this.pos++, this.line++, this.column = 1);
          }
          this.tokens.push({ type: p2.HEREDOC_CONTENT, value: a7, start: r8, end: this.pos, line: s9, column: n23 });
        }
      }
      addPendingHeredoc(t6, r8, s9) {
        this.pendingHeredocs.push({ delimiter: t6, stripTabs: r8, quoted: s9 });
      }
      registerHeredocFromLookahead(t6) {
        let r8 = this.pos, s9 = this.column;
        for (; this.pos < this.input.length && (this.input[this.pos] === " " || this.input[this.pos] === "	"); ) this.pos++, this.column++;
        let n23 = "", a7 = false;
        for (; this.pos < this.input.length; ) {
          let i10 = this.input[this.pos];
          if (/[\s;<>&|()]/.test(i10)) break;
          if (i10 === "'" || i10 === '"') {
            a7 = true;
            let l8 = i10;
            for (this.pos++, this.column++; this.pos < this.input.length && this.input[this.pos] !== l8; ) n23 += this.input[this.pos], this.pos++, this.column++;
            this.pos < this.input.length && this.input[this.pos] === l8 && (this.pos++, this.column++);
          } else i10 === "\\" ? (a7 = true, this.pos++, this.column++, this.pos < this.input.length && (n23 += this.input[this.pos], this.pos++, this.column++)) : (n23 += i10, this.pos++, this.column++);
        }
        this.pos = r8, this.column = s9, n23 && this.pendingHeredocs.push({ delimiter: n23, stripTabs: t6, quoted: a7 });
      }
      isWordCharFollowing(t6) {
        if (t6 >= this.input.length) return false;
        let r8 = this.input[t6];
        return !(r8 === " " || r8 === "	" || r8 === `
` || r8 === ";" || r8 === "&" || r8 === "|" || r8 === "(" || r8 === ")" || r8 === "<" || r8 === ">");
      }
      readWordWithBraceExpansion(t6, r8, s9) {
        let n23 = this.input, a7 = n23.length, i10 = t6, l8 = s9;
        for (; i10 < a7; ) {
          let c14 = n23[i10];
          if (c14 === " " || c14 === "	" || c14 === `
` || c14 === ";" || c14 === "&" || c14 === "|" || c14 === "(" || c14 === ")" || c14 === "<" || c14 === ">") break;
          if (c14 === "{") {
            if (this.scanBraceExpansion(i10) !== null) {
              let f11 = 1;
              for (i10++, l8++; i10 < a7 && f11 > 0; ) n23[i10] === "{" ? f11++ : n23[i10] === "}" && f11--, i10++, l8++;
              continue;
            }
            i10++, l8++;
            continue;
          }
          if (c14 === "}") {
            i10++, l8++;
            continue;
          }
          if (c14 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "(") {
            i10++, l8++, i10++, l8++;
            let u10 = 1;
            for (; u10 > 0 && i10 < a7; ) n23[i10] === "(" ? u10++ : n23[i10] === ")" && u10--, i10++, l8++;
            continue;
          }
          if (c14 === "$" && i10 + 1 < a7 && n23[i10 + 1] === "{") {
            i10++, l8++, i10++, l8++;
            let u10 = 1;
            for (; u10 > 0 && i10 < a7; ) n23[i10] === "{" ? u10++ : n23[i10] === "}" && u10--, i10++, l8++;
            continue;
          }
          if (c14 === "`") {
            for (i10++, l8++; i10 < a7 && n23[i10] !== "`"; ) n23[i10] === "\\" && i10 + 1 < a7 ? (i10 += 2, l8 += 2) : (i10++, l8++);
            i10 < a7 && (i10++, l8++);
            continue;
          }
          i10++, l8++;
        }
        let o9 = n23.slice(t6, i10);
        return this.pos = i10, this.column = l8, { type: p2.WORD, value: o9, start: t6, end: i10, line: r8, column: s9, quoted: false, singleQuoted: false };
      }
      scanBraceExpansion(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1, i10 = false, l8 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let o9 = r8[n23];
          if (o9 === "{") a7++, n23++;
          else if (o9 === "}") a7--, n23++;
          else if (o9 === "," && a7 === 1) i10 = true, n23++;
          else if (o9 === "." && n23 + 1 < s9 && r8[n23 + 1] === ".") l8 = true, n23 += 2;
          else {
            if (o9 === " " || o9 === "	" || o9 === `
` || o9 === ";" || o9 === "&" || o9 === "|") return null;
            n23++;
          }
        }
        return a7 === 0 && (i10 || l8) ? r8.slice(t6, n23) : null;
      }
      scanLiteralBraceWord(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1;
        for (; n23 < s9 && a7 > 0; ) {
          let i10 = r8[n23];
          if (i10 === "{") a7++, n23++;
          else if (i10 === "}") {
            if (a7--, a7 === 0) return r8.slice(t6, n23 + 1);
            n23++;
          } else {
            if (i10 === " " || i10 === "	" || i10 === `
` || i10 === ";" || i10 === "&" || i10 === "|") return null;
            n23++;
          }
        }
        return null;
      }
      scanExtglobPattern(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 1;
        for (; n23 < s9 && a7 > 0; ) {
          let i10 = r8[n23];
          if (i10 === "\\" && n23 + 1 < s9) {
            n23 += 2;
            continue;
          }
          if ("@*+?!".includes(i10) && n23 + 1 < s9 && r8[n23 + 1] === "(") {
            n23++, a7++, n23++;
            continue;
          }
          if (i10 === "(") a7++, n23++;
          else if (i10 === ")") a7--, n23++;
          else {
            if (i10 === `
`) return null;
            n23++;
          }
        }
        return a7 === 0 ? { content: r8.slice(t6, n23), end: n23 } : null;
      }
      scanFdVariable(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = n23;
        for (; n23 < s9; ) {
          let u10 = r8[n23];
          if (n23 === a7) {
            if (!(u10 >= "a" && u10 <= "z" || u10 >= "A" && u10 <= "Z" || u10 === "_")) return null;
          } else if (!(u10 >= "a" && u10 <= "z" || u10 >= "A" && u10 <= "Z" || u10 >= "0" && u10 <= "9" || u10 === "_")) break;
          n23++;
        }
        if (n23 === a7) return null;
        let i10 = r8.slice(a7, n23);
        if (n23 >= s9 || r8[n23] !== "}" || (n23++, n23 >= s9)) return null;
        let l8 = r8[n23], o9 = n23 + 1 < s9 ? r8[n23 + 1] : "";
        return l8 === ">" || l8 === "<" || l8 === "&" && (o9 === ">" || o9 === "<") ? { varname: i10, end: n23 } : null;
      }
      dollarDparenIsSubshell(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6 + 1, a7 = 2, i10 = false, l8 = false, o9 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let c14 = r8[n23];
          if (i10) {
            c14 === "'" && (i10 = false), c14 === `
` && (o9 = true), n23++;
            continue;
          }
          if (l8) {
            if (c14 === "\\") {
              n23 += 2;
              continue;
            }
            c14 === '"' && (l8 = false), c14 === `
` && (o9 = true), n23++;
            continue;
          }
          if (c14 === "'") {
            i10 = true, n23++;
            continue;
          }
          if (c14 === '"') {
            l8 = true, n23++;
            continue;
          }
          if (c14 === "\\") {
            n23 += 2;
            continue;
          }
          if (c14 === `
` && (o9 = true), c14 === "(") {
            a7++, n23++;
            continue;
          }
          if (c14 === ")") {
            if (a7--, a7 === 1) {
              let u10 = n23 + 1;
              if (u10 < s9 && r8[u10] === ")") return false;
              let f11 = u10, h16 = false;
              for (; f11 < s9 && (r8[f11] === " " || r8[f11] === "	" || r8[f11] === `
`); ) h16 = true, f11++;
              if (h16 && f11 < s9 && r8[f11] === ")" || o9) return true;
            }
            if (a7 === 0) return false;
            n23++;
            continue;
          }
          n23++;
        }
        return false;
      }
      dparenClosesWithSpacedParens(t6) {
        let r8 = this.input, s9 = r8.length, n23 = t6, a7 = 2, i10 = false, l8 = false;
        for (; n23 < s9 && a7 > 0; ) {
          let o9 = r8[n23];
          if (i10) {
            o9 === "'" && (i10 = false), n23++;
            continue;
          }
          if (l8) {
            if (o9 === "\\") {
              n23 += 2;
              continue;
            }
            o9 === '"' && (l8 = false), n23++;
            continue;
          }
          if (o9 === "'") {
            i10 = true, n23++;
            continue;
          }
          if (o9 === '"') {
            l8 = true, n23++;
            continue;
          }
          if (o9 === "\\") {
            n23 += 2;
            continue;
          }
          if (o9 === "(") {
            a7++, n23++;
            continue;
          }
          if (o9 === ")") {
            if (a7--, a7 === 1) {
              let c14 = n23 + 1;
              if (c14 < s9 && r8[c14] === ")") return false;
              let u10 = c14, f11 = false;
              for (; u10 < s9 && (r8[u10] === " " || r8[u10] === "	" || r8[u10] === `
`); ) f11 = true, u10++;
              if (f11 && u10 < s9 && r8[u10] === ")") return true;
            }
            if (a7 === 0) return false;
            n23++;
            continue;
          }
          if (a7 === 1 && (o9 === "|" && n23 + 1 < s9 && r8[n23 + 1] === "|" || o9 === "&" && n23 + 1 < s9 && r8[n23 + 1] === "&" || o9 === "|" && n23 + 1 < s9 && r8[n23 + 1] !== "|")) return true;
          n23++;
        }
        return false;
      }
    };
    Qe = 1e6;
    Ge = 1e5;
    Qt = 1e6;
    Ze = 200;
    Gt = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS, p2.AND_GREAT, p2.AND_DGREAT]);
    Zt = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS]);
    Ut = /* @__PURE__ */ new Set([p2.LESS, p2.GREAT, p2.DLESS, p2.DGREAT, p2.LESSAND, p2.GREATAND, p2.LESSGREAT, p2.DLESSDASH, p2.CLOBBER, p2.TLESS, p2.AND_GREAT, p2.AND_DGREAT]);
    Q2 = class extends Error {
      line;
      column;
      token;
      constructor(t6, r8, s9, n23 = void 0) {
        super(`Parse error at ${r8}:${s9}: ${t6}`), this.line = r8, this.column = s9, this.token = n23, this.name = "ParseException";
      }
    };
    Lr = /* @__PURE__ */ new Set([p2.AMP, p2.PIPE, p2.PIPE_AMP, p2.SEMICOLON, p2.AND_AND, p2.OR_OR, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND]);
    qr = ["-a", "-b", "-c", "-d", "-e", "-f", "-g", "-h", "-k", "-p", "-r", "-s", "-t", "-u", "-w", "-x", "-G", "-L", "-N", "-O", "-S", "-z", "-n", "-o", "-v", "-R"];
    Br = ["==", "!=", "=~", "<", ">", "-eq", "-ne", "-lt", "-le", "-gt", "-ge", "-nt", "-ot", "-ef"];
    V2 = class e {
      tokens = [];
      pos = 0;
      pendingHeredocs = [];
      parseIterations = 0;
      parseDepth = 0;
      _input = "";
      getInput() {
        return this._input;
      }
      checkIterationLimit() {
        if (this.parseIterations++, this.parseIterations > Qt) throw new Q2("Maximum parse iterations exceeded (possible infinite loop)", this.current().line, this.current().column);
      }
      enterDepth() {
        if (this.parseDepth++, this.parseDepth > Ze) throw new Q2(`Maximum parser nesting depth exceeded (${Ze})`, this.current().line, this.current().column);
        return () => {
          this.parseDepth--;
        };
      }
      parse(t6, r8) {
        if (t6.length > Qe) throw new Q2(`Input too large: ${t6.length} bytes exceeds limit of ${Qe}`, 1, 1);
        this._input = t6;
        let s9 = new Ie(t6, r8);
        if (this.tokens = s9.tokenize(), this.tokens.length > Ge) throw new Q2(`Too many tokens: ${this.tokens.length} exceeds limit of ${Ge}`, 1, 1);
        return this.pos = 0, this.pendingHeredocs = [], this.parseIterations = 0, this.parseDepth = 0, this.parseScript();
      }
      parseTokens(t6) {
        return this.tokens = t6, this.pos = 0, this.pendingHeredocs = [], this.parseIterations = 0, this.parseDepth = 0, this.parseScript();
      }
      current() {
        return this.tokens[this.pos] || this.tokens[this.tokens.length - 1];
      }
      peek(t6 = 0) {
        return this.tokens[this.pos + t6] || this.tokens[this.tokens.length - 1];
      }
      advance() {
        let t6 = this.current();
        return this.pos < this.tokens.length - 1 && this.pos++, t6;
      }
      getPos() {
        return this.pos;
      }
      check(t6, r8, s9, n23, ...a7) {
        let i10 = this.tokens[this.pos]?.type;
        return i10 === t6 || r8 !== void 0 && i10 === r8 || s9 !== void 0 && i10 === s9 || n23 !== void 0 && i10 === n23 ? true : a7.length > 0 ? a7.includes(i10) : false;
      }
      expect(t6, r8) {
        if (this.check(t6)) return this.advance();
        let s9 = this.current();
        throw new Q2(r8 || `Expected ${t6}, got ${s9.type}`, s9.line, s9.column, s9);
      }
      error(t6) {
        let r8 = this.current();
        throw new Q2(t6, r8.line, r8.column, r8);
      }
      skipNewlines() {
        for (; this.check(p2.NEWLINE, p2.COMMENT); ) this.check(p2.NEWLINE) ? (this.advance(), this.processHeredocs()) : this.advance();
      }
      skipSeparators(t6 = true) {
        for (; ; ) {
          if (this.check(p2.NEWLINE)) {
            this.advance(), this.processHeredocs();
            continue;
          }
          if (this.check(p2.SEMICOLON, p2.COMMENT)) {
            this.advance();
            continue;
          }
          if (t6 && this.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND)) {
            this.advance();
            continue;
          }
          break;
        }
      }
      addPendingHeredoc(t6, r8, s9, n23) {
        this.pendingHeredocs.push({ redirect: t6, delimiter: r8, stripTabs: s9, quoted: n23 });
      }
      processHeredocs() {
        for (let t6 of this.pendingHeredocs) if (this.check(p2.HEREDOC_CONTENT)) {
          let r8 = this.advance(), s9;
          t6.quoted ? s9 = w2.word([w2.literal(r8.value)]) : s9 = this.parseWordFromString(r8.value, false, false, false, true), t6.redirect.target = w2.hereDoc(t6.delimiter, s9, t6.stripTabs, t6.quoted);
        }
        this.pendingHeredocs = [];
      }
      isStatementEnd() {
        return this.check(p2.EOF, p2.NEWLINE, p2.SEMICOLON, p2.AMP, p2.AND_AND, p2.OR_OR, p2.RPAREN, p2.RBRACE, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND);
      }
      isCommandStart() {
        let t6 = this.current().type;
        return t6 === p2.WORD || t6 === p2.NAME || t6 === p2.NUMBER || t6 === p2.ASSIGNMENT_WORD || t6 === p2.IF || t6 === p2.FOR || t6 === p2.WHILE || t6 === p2.UNTIL || t6 === p2.CASE || t6 === p2.LPAREN || t6 === p2.LBRACE || t6 === p2.DPAREN_START || t6 === p2.DBRACK_START || t6 === p2.FUNCTION || t6 === p2.BANG || t6 === p2.TIME || t6 === p2.IN || t6 === p2.LESS || t6 === p2.GREAT || t6 === p2.DLESS || t6 === p2.DGREAT || t6 === p2.LESSAND || t6 === p2.GREATAND || t6 === p2.LESSGREAT || t6 === p2.DLESSDASH || t6 === p2.CLOBBER || t6 === p2.TLESS || t6 === p2.AND_GREAT || t6 === p2.AND_DGREAT;
      }
      parseScript() {
        let t6 = [], s9 = 0;
        for (this.skipNewlines(); !this.check(p2.EOF); ) {
          s9++, s9 > 1e4 && this.error("Parser stuck: too many iterations (>10000)");
          let n23 = this.checkUnexpectedToken();
          if (n23) {
            t6.push(n23), this.skipSeparators(false);
            continue;
          }
          let a7 = this.pos, i10 = this.parseStatement();
          i10 && t6.push(i10), this.skipSeparators(false), this.check(p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND) && this.error(`syntax error near unexpected token \`${this.current().value}'`), this.pos === a7 && !this.check(p2.EOF) && this.advance();
        }
        return w2.script(t6);
      }
      checkUnexpectedToken() {
        let t6 = this.current().type, r8 = this.current().value;
        if ((t6 === p2.DO || t6 === p2.DONE || t6 === p2.THEN || t6 === p2.ELSE || t6 === p2.ELIF || t6 === p2.FI || t6 === p2.ESAC) && this.error(`syntax error near unexpected token \`${r8}'`), t6 === p2.RBRACE || t6 === p2.RPAREN) {
          let s9 = `syntax error near unexpected token \`${r8}'`;
          return this.advance(), w2.statement([w2.pipeline([w2.simpleCommand(null, [], [], [])])], [], false, { message: s9, token: r8 });
        }
        return (t6 === p2.DSEMI || t6 === p2.SEMI_AND || t6 === p2.SEMI_SEMI_AND) && this.error(`syntax error near unexpected token \`${r8}'`), t6 === p2.SEMICOLON && this.error(`syntax error near unexpected token \`${r8}'`), (t6 === p2.PIPE || t6 === p2.PIPE_AMP) && this.error(`syntax error near unexpected token \`${r8}'`), null;
      }
      parseStatement() {
        if (this.skipNewlines(), !this.isCommandStart()) return null;
        let t6 = this.current().start, r8 = [], s9 = [], n23 = false, a7 = this.parsePipeline();
        for (r8.push(a7); this.check(p2.AND_AND, p2.OR_OR); ) {
          let o9 = this.advance();
          s9.push(o9.type === p2.AND_AND ? "&&" : "||"), this.skipNewlines();
          let c14 = this.parsePipeline();
          r8.push(c14);
        }
        this.check(p2.AMP) && (this.advance(), n23 = true);
        let i10 = this.pos > 0 ? this.tokens[this.pos - 1].end : t6, l8 = this._input.slice(t6, i10);
        return w2.statement(r8, s9, n23, void 0, l8);
      }
      parsePipeline() {
        let t6 = false, r8 = false;
        this.check(p2.TIME) && (this.advance(), t6 = true, this.check(p2.WORD, p2.NAME) && this.current().value === "-p" && (this.advance(), r8 = true));
        let s9 = 0;
        for (; this.check(p2.BANG); ) this.advance(), s9++;
        let n23 = s9 % 2 === 1, a7 = [], i10 = [], l8 = this.parseCommand();
        for (a7.push(l8); this.check(p2.PIPE, p2.PIPE_AMP); ) {
          let o9 = this.advance();
          this.skipNewlines(), i10.push(o9.type === p2.PIPE_AMP);
          let c14 = this.parseCommand();
          a7.push(c14);
        }
        return w2.pipeline(a7, n23, t6, r8, i10.length > 0 ? i10 : void 0);
      }
      parseCommand() {
        return this.check(p2.IF) ? Xe(this) : this.check(p2.FOR) ? Je(this) : this.check(p2.WHILE) ? Ye(this) : this.check(p2.UNTIL) ? et(this) : this.check(p2.CASE) ? tt(this) : this.check(p2.LPAREN) ? nt(this) : this.check(p2.LBRACE) ? rt(this) : this.check(p2.DPAREN_START) ? this.dparenClosesWithSpacedParens() ? this.parseNestedSubshellsFromDparen() : this.parseArithmeticCommand() : this.check(p2.DBRACK_START) ? this.parseConditionalCommand() : this.check(p2.FUNCTION) ? this.parseFunctionDef() : this.check(p2.NAME, p2.WORD) && this.peek(1).type === p2.LPAREN && this.peek(2).type === p2.RPAREN ? this.parseFunctionDef() : nn(this);
      }
      dparenClosesWithSpacedParens() {
        let t6 = 1, r8 = 1;
        for (; r8 < this.tokens.length - this.pos; ) {
          let s9 = this.peek(r8);
          if (s9.type === p2.EOF) return false;
          if (s9.type === p2.DPAREN_START || s9.type === p2.LPAREN) t6++;
          else if (s9.type === p2.DPAREN_END) {
            if (t6 -= 2, t6 <= 0) return false;
          } else if (s9.type === p2.RPAREN && (t6--, t6 === 0 && this.peek(r8 + 1).type === p2.RPAREN)) return true;
          r8++;
        }
        return false;
      }
      parseNestedSubshellsFromDparen() {
        this.advance();
        let t6 = this.parseCompoundList();
        this.expect(p2.RPAREN), this.expect(p2.RPAREN);
        let r8 = this.parseOptionalRedirections(), s9 = w2.subshell(t6, []);
        return w2.subshell([w2.statement([w2.pipeline([s9], false, false, false)])], r8);
      }
      isWord() {
        let t6 = this.current().type;
        return t6 === p2.WORD || t6 === p2.NAME || t6 === p2.NUMBER || t6 === p2.IF || t6 === p2.FOR || t6 === p2.WHILE || t6 === p2.UNTIL || t6 === p2.CASE || t6 === p2.FUNCTION || t6 === p2.ELSE || t6 === p2.ELIF || t6 === p2.FI || t6 === p2.THEN || t6 === p2.DO || t6 === p2.DONE || t6 === p2.ESAC || t6 === p2.IN || t6 === p2.SELECT || t6 === p2.TIME || t6 === p2.COPROC || t6 === p2.BANG;
      }
      parseWord() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted);
      }
      parseWordNoBraceExpansion() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted, false, false, true);
      }
      parseWordForRegex() {
        let t6 = this.advance();
        return this.parseWordFromString(t6.value, t6.quoted, t6.singleQuoted, false, false, true, true);
      }
      parseWordFromString(t6, r8 = false, s9 = false, n23 = false, a7 = false, i10 = false, l8 = false) {
        let o9 = ae(this, t6, r8, s9, n23, a7, false, i10, l8);
        return w2.word(o9);
      }
      parseCommandSubstitution(t6, r8) {
        return un(t6, r8, () => new e(), (s9) => this.error(s9));
      }
      parseBacktickSubstitution(t6, r8, s9 = false) {
        return cn(t6, r8, s9, () => new e(), (n23) => this.error(n23));
      }
      isDollarDparenSubshell(t6, r8) {
        return ln(t6, r8);
      }
      parseArithmeticExpansion(t6, r8) {
        let s9 = r8 + 3, n23 = 1, a7 = 0, i10 = s9;
        for (; i10 < t6.length - 1 && n23 > 0; ) t6[i10] === "$" && t6[i10 + 1] === "(" ? t6[i10 + 2] === "(" ? (n23++, i10 += 3) : (a7++, i10 += 2) : t6[i10] === "(" && t6[i10 + 1] === "(" ? (n23++, i10 += 2) : t6[i10] === ")" && t6[i10 + 1] === ")" ? a7 > 0 ? (a7--, i10++) : (n23--, n23 > 0 && (i10 += 2)) : t6[i10] === "(" ? (a7++, i10++) : (t6[i10] === ")" && a7 > 0 && a7--, i10++);
        let l8 = t6.slice(s9, i10), o9 = this.parseArithmeticExpression(l8);
        return { part: w2.arithmeticExpansion(o9), endIndex: i10 + 2 };
      }
      parseArithmeticCommand() {
        let t6 = this.expect(p2.DPAREN_START), r8 = "", s9 = 1, n23 = 0, a7 = false, i10 = false;
        for (; s9 > 0 && !this.check(p2.EOF); ) {
          if (a7) {
            if (a7 = false, n23 > 0) {
              n23--, r8 += ")";
              continue;
            }
            if (this.check(p2.RPAREN)) {
              s9--, i10 = true, this.advance();
              continue;
            }
            if (this.check(p2.DPAREN_END)) {
              s9--, i10 = true;
              continue;
            }
            r8 += ")";
            continue;
          }
          if (this.check(p2.DPAREN_START)) s9++, r8 += "((", this.advance();
          else if (this.check(p2.DPAREN_END)) n23 >= 2 ? (n23 -= 2, r8 += "))", this.advance()) : n23 === 1 ? (n23--, r8 += ")", a7 = true, this.advance()) : (s9--, i10 = true, s9 > 0 && (r8 += "))"), this.advance());
          else if (this.check(p2.LPAREN)) n23++, r8 += "(", this.advance();
          else if (this.check(p2.RPAREN)) n23 > 0 && n23--, r8 += ")", this.advance();
          else {
            let c14 = this.current().value, u10 = r8.length > 0 ? r8[r8.length - 1] : "";
            r8.length > 0 && !r8.endsWith(" ") && !(c14 === "=" && /[|&^+\-*/%<>]$/.test(r8)) && !(c14 === "<" && u10 === "<") && !(c14 === ">" && u10 === ">") && (r8 += " "), r8 += c14, this.advance();
          }
        }
        i10 || this.expect(p2.DPAREN_END);
        let l8 = this.parseArithmeticExpression(r8.trim()), o9 = this.parseOptionalRedirections();
        return w2.arithmeticCommand(l8, o9, t6.line);
      }
      parseConditionalCommand() {
        let t6 = this.expect(p2.DBRACK_START), r8 = it(this);
        this.expect(p2.DBRACK_END);
        let s9 = this.parseOptionalRedirections();
        return w2.conditionalCommand(r8, s9, t6.line);
      }
      parseFunctionDef() {
        let t6;
        if (this.check(p2.FUNCTION)) {
          if (this.advance(), this.check(p2.NAME) || this.check(p2.WORD)) t6 = this.advance().value;
          else {
            let n23 = this.current();
            throw new Q2("Expected function name", n23.line, n23.column, n23);
          }
          this.check(p2.LPAREN) && (this.advance(), this.expect(p2.RPAREN));
        } else t6 = this.advance().value, t6.includes("$") && this.error(`\`${t6}': not a valid identifier`), this.expect(p2.LPAREN), this.expect(p2.RPAREN);
        this.skipNewlines();
        let r8 = this.parseCompoundCommandBody({ forFunctionBody: true }), s9 = this.parseOptionalRedirections();
        return w2.functionDef(t6, r8, s9);
      }
      parseCompoundCommandBody(t6) {
        let r8 = t6?.forFunctionBody;
        if (this.check(p2.LBRACE)) return rt(this, { skipRedirections: r8 });
        if (this.check(p2.LPAREN)) return nt(this, { skipRedirections: r8 });
        if (this.check(p2.IF)) return Xe(this, { skipRedirections: r8 });
        if (this.check(p2.FOR)) return Je(this, { skipRedirections: r8 });
        if (this.check(p2.WHILE)) return Ye(this, { skipRedirections: r8 });
        if (this.check(p2.UNTIL)) return et(this, { skipRedirections: r8 });
        if (this.check(p2.CASE)) return tt(this, { skipRedirections: r8 });
        this.error("Expected compound command for function body");
      }
      parseCompoundList() {
        let t6 = this.enterDepth(), r8 = [];
        for (this.skipNewlines(); !this.check(p2.EOF, p2.FI, p2.ELSE, p2.ELIF, p2.THEN, p2.DO, p2.DONE, p2.ESAC, p2.RPAREN, p2.RBRACE, p2.DSEMI, p2.SEMI_AND, p2.SEMI_SEMI_AND) && this.isCommandStart(); ) {
          this.checkIterationLimit();
          let s9 = this.pos, n23 = this.parseStatement();
          if (n23 && r8.push(n23), this.skipSeparators(), this.pos === s9 && !n23) break;
        }
        return t6(), r8;
      }
      parseOptionalRedirections() {
        let t6 = [];
        for (; ve(this); ) {
          this.checkIterationLimit();
          let r8 = this.pos;
          if (t6.push(De(this)), this.pos === r8) break;
        }
        return t6;
      }
      parseArithmeticExpression(t6) {
        return M2(this, t6);
      }
    };
  }
});

// stub-node:node:fs
var existsSync;
var init_node_fs = __esm({
  "stub-node:node:fs"() {
    existsSync = () => false;
  }
});

// stub-node:node:path
var join, dirname;
var init_node_path = __esm({
  "stub-node:node:path"() {
    join = (...a7) => a7.join("/");
    dirname = (p17) => p17;
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YYAPW4OA.js
function d3(t6) {
  if (!t6) return t6;
  let e5 = t6.replace(/\n\s+at\s.*/g, "");
  return e5 = e5.replace(/(?:\/(?:Users|home|private|var|opt|Library|System|usr|etc|tmp|nix|snap))\b[^\s'",)}\]:]*/g, "<path>"), e5 = e5.replace(/[A-Z]:\\[^\s'",)}\]:]+/g, "<path>"), e5;
}
var init_chunk_YYAPW4OA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YYAPW4OA.js"() {
    init_node_fs();
    init_node_path();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OJDRYQWQ.js
function r(e5) {
  return Object.assign(/* @__PURE__ */ Object.create(null), Object.fromEntries(e5));
}
function c2(...e5) {
  return Object.assign(/* @__PURE__ */ Object.create(null), ...e5);
}
var init_chunk_OJDRYQWQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OJDRYQWQ.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-44UOCSGV.js
function n16(e5) {
  return e5 instanceof Error ? e5.message : String(e5);
}
var init_chunk_44UOCSGV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-44UOCSGV.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DXB73IDG.js
var h2, e2, i, j2, k, l2, m3, n17, o, p3, g2, q2, r2;
var init_chunk_DXB73IDG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DXB73IDG.js"() {
    h2 = Object.create;
    e2 = Object.defineProperty;
    i = Object.getOwnPropertyDescriptor;
    j2 = Object.getOwnPropertyNames;
    k = Object.getPrototypeOf;
    l2 = Object.prototype.hasOwnProperty;
    m3 = ((a7) => typeof __require < "u" ? __require : typeof Proxy < "u" ? new Proxy(a7, { get: (b25, c14) => (typeof __require < "u" ? __require : b25)[c14] }) : a7)(function(a7) {
      if (typeof __require < "u") return __require.apply(this, arguments);
      throw Error('Dynamic require of "' + a7 + '" is not supported');
    });
    n17 = (a7, b25) => () => (a7 && (b25 = a7(a7 = 0)), b25);
    o = (a7, b25) => () => (b25 || a7((b25 = { exports: {} }).exports, b25), b25.exports);
    p3 = (a7, b25) => {
      for (var c14 in b25) e2(a7, c14, { get: b25[c14], enumerable: true });
    };
    g2 = (a7, b25, c14, f11) => {
      if (b25 && typeof b25 == "object" || typeof b25 == "function") for (let d16 of j2(b25)) !l2.call(a7, d16) && d16 !== c14 && e2(a7, d16, { get: () => b25[d16], enumerable: !(f11 = i(b25, d16)) || f11.enumerable });
      return a7;
    };
    q2 = (a7, b25, c14) => (c14 = a7 != null ? h2(k(a7)) : {}, g2(b25 || !a7 || !a7.__esModule ? e2(c14, "default", { value: a7, enumerable: true }) : c14, a7));
    r2 = (a7) => g2(e2({}, "__esModule", { value: true }), a7);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GCTKCWKD.js
function n18(r8) {
  let s9 = "", e5 = 0;
  for (; e5 < r8.length; ) if (r8[e5] === "\\") {
    if (e5 + 1 >= r8.length) {
      s9 += "\\";
      break;
    }
    let o9 = r8[e5 + 1];
    switch (o9) {
      case "\\":
        s9 += "\\", e5 += 2;
        break;
      case "n":
        s9 += `
`, e5 += 2;
        break;
      case "t":
        s9 += "	", e5 += 2;
        break;
      case "r":
        s9 += "\r", e5 += 2;
        break;
      case "a":
        s9 += "\x07", e5 += 2;
        break;
      case "b":
        s9 += "\b", e5 += 2;
        break;
      case "f":
        s9 += "\f", e5 += 2;
        break;
      case "v":
        s9 += "\v", e5 += 2;
        break;
      case "e":
      case "E":
        s9 += "\x1B", e5 += 2;
        break;
      case "c":
        return { output: s9, stop: true };
      case "0": {
        let a7 = "", t6 = e5 + 2;
        for (; t6 < r8.length && t6 < e5 + 5 && /[0-7]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\0";
        else {
          let l8 = parseInt(a7, 8) % 256;
          s9 += String.fromCharCode(l8);
        }
        e5 = t6;
        break;
      }
      case "x": {
        let a7 = "", t6 = e5 + 2;
        for (; t6 < r8.length && t6 < e5 + 4 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\x", e5 += 2;
        else {
          let l8 = parseInt(a7, 16);
          s9 += String.fromCharCode(l8), e5 = t6;
        }
        break;
      }
      case "u": {
        let a7 = "", t6 = e5 + 2;
        for (; t6 < r8.length && t6 < e5 + 6 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\u", e5 += 2;
        else {
          let l8 = parseInt(a7, 16);
          s9 += String.fromCodePoint(l8), e5 = t6;
        }
        break;
      }
      case "U": {
        let a7 = "", t6 = e5 + 2;
        for (; t6 < r8.length && t6 < e5 + 10 && /[0-9a-fA-F]/.test(r8[t6]); ) a7 += r8[t6], t6++;
        if (a7.length === 0) s9 += "\\U", e5 += 2;
        else {
          let l8 = parseInt(a7, 16);
          try {
            s9 += String.fromCodePoint(l8);
          } catch {
            s9 += `\\U${a7}`;
          }
          e5 = t6;
        }
        break;
      }
      default:
        s9 += `\\${o9}`, e5 += 2;
    }
  } else s9 += r8[e5], e5++;
  return { output: s9, stop: false };
}
var c3, f;
var init_chunk_GCTKCWKD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GCTKCWKD.js"() {
    c3 = { name: "echo", async execute(r8, s9) {
      let e5 = false, o9 = s9.xpgEcho ?? false, a7 = 0;
      for (; a7 < r8.length; ) {
        let l8 = r8[a7];
        if (l8 === "-n") e5 = true, a7++;
        else if (l8 === "-e") o9 = true, a7++;
        else if (l8 === "-E") o9 = false, a7++;
        else if (l8 === "-ne" || l8 === "-en") e5 = true, o9 = true, a7++;
        else break;
      }
      let t6 = r8.slice(a7).join(" ");
      if (o9) {
        let l8 = n18(t6);
        if (t6 = l8.output, l8.stop) return { stdout: t6, stderr: "", exitCode: 0 };
      }
      return e5 || (t6 += `
`), { stdout: t6, stderr: "", exitCode: 0 };
    } };
    f = { name: "echo", flags: [{ flag: "-n", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-E", type: "boolean" }], stdinType: "none", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/echo-O45JWWI2.js
var echo_O45JWWI2_exports = {};
__export(echo_O45JWWI2_exports, {
  echoCommand: () => c3,
  flagsForFuzzing: () => f
});
var init_echo_O45JWWI2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/echo-O45JWWI2.js"() {
    init_chunk_GCTKCWKD();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7L36YK2X.js
async function y2(t6, n23, s9) {
  let { cmdName: r8, allowStdinMarker: f11 = true, stopOnError: a7 = false, batchSize: u10 = 100 } = s9;
  if (n23.length === 0) return { files: [{ filename: "", content: t6.stdin }], stderr: "", exitCode: 0 };
  let i10 = [], c14 = "", l8 = 0;
  for (let o9 = 0; o9 < n23.length; o9 += u10) {
    let d16 = n23.slice(o9, o9 + u10), m24 = await Promise.all(d16.map(async (e5) => {
      if (f11 && e5 === "-") return { filename: "-", content: t6.stdin, error: null };
      try {
        let h16 = t6.fs.resolvePath(t6.cwd, e5), p17 = await t6.fs.readFile(h16, "binary");
        return { filename: e5, content: p17, error: null };
      } catch {
        return { filename: e5, content: "", error: `${r8}: ${e5}: No such file or directory
` };
      }
    }));
    for (let e5 of m24) if (e5.error) {
      if (c14 += e5.error, l8 = 1, a7) return { files: i10, stderr: c14, exitCode: l8 };
    } else i10.push({ filename: e5.filename, content: e5.content });
  }
  return { files: i10, stderr: c14, exitCode: l8 };
}
async function b3(t6, n23, s9) {
  let r8 = await y2(t6, n23, { ...s9, stopOnError: true });
  return r8.exitCode !== 0 ? { ok: false, error: { stdout: "", stderr: r8.stderr, exitCode: r8.exitCode } } : { ok: true, content: r8.files.map((a7) => a7.content).join("") };
}
var init_chunk_7L36YK2X = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7L36YK2X.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-74CEPOFO.js
function s(t6) {
  let e5 = `${t6.name} - ${t6.summary}

`;
  if (e5 += `Usage: ${t6.usage}
`, t6.description) {
    if (e5 += `
Description:
`, typeof t6.description == "string") for (let n23 of t6.description.split(`
`)) e5 += n23 ? `  ${n23}
` : `
`;
    else if (t6.description.length > 0) for (let n23 of t6.description) e5 += n23 ? `  ${n23}
` : `
`;
  }
  if (t6.options && t6.options.length > 0) {
    e5 += `
Options:
`;
    for (let n23 of t6.options) e5 += `  ${n23}
`;
  }
  if (t6.examples && t6.examples.length > 0) {
    e5 += `
Examples:
`;
    for (let n23 of t6.examples) e5 += `  ${n23}
`;
  }
  if (t6.notes && t6.notes.length > 0) {
    e5 += `
Notes:
`;
    for (let n23 of t6.notes) e5 += `  ${n23}
`;
  }
  return { stdout: e5, stderr: "", exitCode: 0 };
}
function o2(t6) {
  return t6.includes("--help");
}
function r3(t6, e5) {
  return { stdout: "", stderr: e5.startsWith("--") ? `${t6}: unrecognized option '${e5}'
` : `${t6}: invalid option -- '${e5.replace(/^-/, "")}'
`, exitCode: 1 };
}
var init_chunk_74CEPOFO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-74CEPOFO.js"() {
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HWKDQ44K.js
function x3(a7, i10, d16) {
  let g18 = /* @__PURE__ */ new Map(), h16 = /* @__PURE__ */ new Map();
  for (let [t6, e5] of Object.entries(d16)) {
    let n23 = { name: t6, type: e5.type };
    e5.short && g18.set(e5.short, n23), e5.long && h16.set(e5.long, n23);
  }
  let s9 = /* @__PURE__ */ Object.create(null);
  for (let [t6, e5] of Object.entries(d16)) e5.default !== void 0 ? s9[t6] = e5.default : e5.type === "boolean" && (s9[t6] = false);
  let b25 = [], k15 = false;
  for (let t6 = 0; t6 < i10.length; t6++) {
    let e5 = i10[t6];
    if (k15 || !e5.startsWith("-") || e5 === "-") {
      b25.push(e5);
      continue;
    }
    if (e5 === "--") {
      k15 = true;
      continue;
    }
    if (e5.startsWith("--")) {
      let n23 = e5.indexOf("="), o9, r8;
      n23 !== -1 ? (o9 = e5.slice(2, n23), r8 = e5.slice(n23 + 1)) : o9 = e5.slice(2);
      let l8 = h16.get(o9);
      if (!l8) return { ok: false, error: r3(a7, e5) };
      let { name: f11, type: u10 } = l8;
      if (u10 === "boolean") s9[f11] = true;
      else {
        if (r8 === void 0) {
          if (t6 + 1 >= i10.length) return { ok: false, error: { stdout: "", stderr: `${a7}: option '--${o9}' requires an argument
`, exitCode: 1 } };
          r8 = i10[++t6];
        }
        s9[f11] = u10 === "number" ? parseInt(r8, 10) : r8;
      }
    } else {
      let n23 = e5.slice(1);
      for (let o9 = 0; o9 < n23.length; o9++) {
        let r8 = n23[o9], l8 = g18.get(r8);
        if (!l8) return { ok: false, error: r3(a7, `-${r8}`) };
        let { name: f11, type: u10 } = l8;
        if (u10 === "boolean") s9[f11] = true;
        else {
          let c14;
          if (o9 + 1 < n23.length) c14 = n23.slice(o9 + 1);
          else if (t6 + 1 < i10.length) c14 = i10[++t6];
          else return { ok: false, error: { stdout: "", stderr: `${a7}: option requires an argument -- '${r8}'
`, exitCode: 1 } };
          s9[f11] = u10 === "number" ? parseInt(c14, 10) : c14;
          break;
        }
      }
    }
  }
  return { ok: true, result: { flags: s9, positional: b25 } };
}
var init_chunk_HWKDQ44K = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HWKDQ44K.js"() {
    init_chunk_74CEPOFO();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7DBA735O.js
function g3(t6, o9) {
  let e5 = t6.split(`
`), r8 = t6.endsWith(`
`), a7 = r8 ? e5.slice(0, -1) : e5;
  return { content: a7.map((n23, l8) => `${String(o9 + l8).padStart(6, " ")}	${n23}`).join(`
`) + (r8 ? `
` : ""), nextLineNumber: o9 + a7.length };
}
var f2, b4, N2, F3;
var init_chunk_7DBA735O = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7DBA735O.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    f2 = { name: "cat", summary: "concatenate files and print on the standard output", usage: "cat [OPTION]... [FILE]...", options: ["-n, --number           number all output lines", "    --help             display this help and exit"] };
    b4 = { number: { short: "n", long: "number", type: "boolean" } };
    N2 = { name: "cat", async execute(t6, o9) {
      if (o2(t6)) return s(f2);
      let e5 = x3("cat", t6, b4);
      if (!e5.ok) return e5.error;
      let r8 = e5.result.flags.number, a7 = e5.result.positional, s9 = await y2(o9, a7, { cmdName: "cat", allowStdinMarker: true, stopOnError: false }), n23 = "", l8 = 1;
      for (let { content: i10 } of s9.files) if (r8) {
        let u10 = g3(i10, l8);
        n23 += u10.content, l8 = u10.nextLineNumber;
      } else n23 += i10;
      return { stdout: n23, stderr: s9.stderr, exitCode: s9.exitCode };
    } };
    F3 = { name: "cat", flags: [{ flag: "-n", type: "boolean" }, { flag: "-A", type: "boolean" }, { flag: "-b", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-t", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cat-C2OBLGHA.js
var cat_C2OBLGHA_exports = {};
__export(cat_C2OBLGHA_exports, {
  catCommand: () => N2,
  flagsForFuzzing: () => F3
});
var init_cat_C2OBLGHA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cat-C2OBLGHA.js"() {
    init_chunk_7DBA735O();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-EEXR5ZDP.js
function i2(t6, l8, e5) {
  let c14 = t6;
  e5 >= 0 && c14.length > e5 && (c14 = c14.slice(0, e5));
  let n23 = Math.abs(l8);
  return n23 > c14.length && (l8 < 0 ? c14 = c14.padEnd(n23, " ") : c14 = c14.padStart(n23, " ")), c14;
}
function h3(t6, l8) {
  let e5 = l8, c14 = 0, n23 = -1, a7 = false;
  for (e5 < t6.length && t6[e5] === "-" && (a7 = true, e5++); e5 < t6.length && /\d/.test(t6[e5]); ) c14 = c14 * 10 + parseInt(t6[e5], 10), e5++;
  if (e5 < t6.length && t6[e5] === ".") for (e5++, n23 = 0; e5 < t6.length && /\d/.test(t6[e5]); ) n23 = n23 * 10 + parseInt(t6[e5], 10), e5++;
  return a7 && c14 > 0 && (c14 = -c14), [c14, n23, e5 - l8];
}
function r4(t6) {
  let l8 = "", e5 = 0;
  for (; e5 < t6.length; ) if (t6[e5] === "\\" && e5 + 1 < t6.length) switch (t6[e5 + 1]) {
    case "n":
      l8 += `
`, e5 += 2;
      break;
    case "t":
      l8 += "	", e5 += 2;
      break;
    case "r":
      l8 += "\r", e5 += 2;
      break;
    case "\\":
      l8 += "\\", e5 += 2;
      break;
    case "a":
      l8 += "\x07", e5 += 2;
      break;
    case "b":
      l8 += "\b", e5 += 2;
      break;
    case "f":
      l8 += "\f", e5 += 2;
      break;
    case "v":
      l8 += "\v", e5 += 2;
      break;
    case "e":
    case "E":
      l8 += "\x1B", e5 += 2;
      break;
    case "0":
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "7": {
      let n23 = "", a7 = e5 + 1;
      for (; a7 < t6.length && a7 < e5 + 4 && /[0-7]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      l8 += String.fromCharCode(parseInt(n23, 8)), e5 = a7;
      break;
    }
    case "x": {
      let n23 = [], a7 = e5;
      for (; a7 + 3 < t6.length && t6[a7] === "\\" && t6[a7 + 1] === "x" && /[0-9a-fA-F]{2}/.test(t6.slice(a7 + 2, a7 + 4)); ) n23.push(parseInt(t6.slice(a7 + 2, a7 + 4), 16)), a7 += 4;
      if (n23.length > 0) {
        try {
          let s9 = new TextDecoder("utf-8", { fatal: true });
          l8 += s9.decode(new Uint8Array(n23));
        } catch {
          for (let s9 of n23) l8 += String.fromCharCode(s9);
        }
        e5 = a7;
      } else l8 += t6[e5], e5++;
      break;
    }
    case "u": {
      let n23 = "", a7 = e5 + 2;
      for (; a7 < t6.length && a7 < e5 + 6 && /[0-9a-fA-F]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      n23 ? (l8 += String.fromCodePoint(parseInt(n23, 16)), e5 = a7) : (l8 += "\\u", e5 += 2);
      break;
    }
    case "U": {
      let n23 = "", a7 = e5 + 2;
      for (; a7 < t6.length && a7 < e5 + 10 && /[0-9a-fA-F]/.test(t6[a7]); ) n23 += t6[a7], a7++;
      n23 ? (l8 += String.fromCodePoint(parseInt(n23, 16)), e5 = a7) : (l8 += "\\U", e5 += 2);
      break;
    }
    default:
      l8 += t6[e5], e5++;
  }
  else l8 += t6[e5], e5++;
  return l8;
}
var init_chunk_EEXR5ZDP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-EEXR5ZDP.js"() {
  }
});

// ../../node_modules/sprintf-js/src/sprintf.js
var require_sprintf = __commonJS({
  "../../node_modules/sprintf-js/src/sprintf.js"(exports) {
    !function() {
      "use strict";
      var re5 = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
      };
      function sprintf(key) {
        return sprintf_format(sprintf_parse(key), arguments);
      }
      function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []));
      }
      function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i10, k15, ph, pad, pad_character, pad_length, is_positive, sign;
        for (i10 = 0; i10 < tree_length; i10++) {
          if (typeof parse_tree[i10] === "string") {
            output += parse_tree[i10];
          } else if (typeof parse_tree[i10] === "object") {
            ph = parse_tree[i10];
            if (ph.keys) {
              arg = argv[cursor];
              for (k15 = 0; k15 < ph.keys.length; k15++) {
                if (arg == void 0) {
                  throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k15], ph.keys[k15 - 1]));
                }
                arg = arg[ph.keys[k15]];
              }
            } else if (ph.param_no) {
              arg = argv[ph.param_no];
            } else {
              arg = argv[cursor++];
            }
            if (re5.not_type.test(ph.type) && re5.not_primitive.test(ph.type) && arg instanceof Function) {
              arg = arg();
            }
            if (re5.numeric_arg.test(ph.type) && (typeof arg !== "number" && isNaN(arg))) {
              throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
            }
            if (re5.number.test(ph.type)) {
              is_positive = arg >= 0;
            }
            switch (ph.type) {
              case "b":
                arg = parseInt(arg, 10).toString(2);
                break;
              case "c":
                arg = String.fromCharCode(parseInt(arg, 10));
                break;
              case "d":
              case "i":
                arg = parseInt(arg, 10);
                break;
              case "j":
                arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                break;
              case "e":
                arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                break;
              case "f":
                arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                break;
              case "g":
                arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                break;
              case "o":
                arg = (parseInt(arg, 10) >>> 0).toString(8);
                break;
              case "s":
                arg = String(arg);
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "t":
                arg = String(!!arg);
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "T":
                arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "u":
                arg = parseInt(arg, 10) >>> 0;
                break;
              case "v":
                arg = arg.valueOf();
                arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                break;
              case "x":
                arg = (parseInt(arg, 10) >>> 0).toString(16);
                break;
              case "X":
                arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                break;
            }
            if (re5.json.test(ph.type)) {
              output += arg;
            } else {
              if (re5.number.test(ph.type) && (!is_positive || ph.sign)) {
                sign = is_positive ? "+" : "-";
                arg = arg.toString().replace(re5.sign, "");
              } else {
                sign = "";
              }
              pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
              pad_length = ph.width - (sign + arg).length;
              pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
              output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
            }
          }
        }
        return output;
      }
      var sprintf_cache = /* @__PURE__ */ Object.create(null);
      function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
          return sprintf_cache[fmt];
        }
        var _fmt = fmt, match2, parse_tree = [], arg_names = 0;
        while (_fmt) {
          if ((match2 = re5.text.exec(_fmt)) !== null) {
            parse_tree.push(match2[0]);
          } else if ((match2 = re5.modulo.exec(_fmt)) !== null) {
            parse_tree.push("%");
          } else if ((match2 = re5.placeholder.exec(_fmt)) !== null) {
            if (match2[2]) {
              arg_names |= 1;
              var field_list = [], replacement_field = match2[2], field_match = [];
              if ((field_match = re5.key.exec(replacement_field)) !== null) {
                field_list.push(field_match[1]);
                while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                  if ((field_match = re5.key_access.exec(replacement_field)) !== null) {
                    field_list.push(field_match[1]);
                  } else if ((field_match = re5.index_access.exec(replacement_field)) !== null) {
                    field_list.push(field_match[1]);
                  } else {
                    throw new SyntaxError("[sprintf] failed to parse named argument key");
                  }
                }
              } else {
                throw new SyntaxError("[sprintf] failed to parse named argument key");
              }
              match2[2] = field_list;
            } else {
              arg_names |= 2;
            }
            if (arg_names === 3) {
              throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
            }
            parse_tree.push(
              {
                placeholder: match2[0],
                param_no: match2[1],
                keys: match2[2],
                sign: match2[3],
                pad_char: match2[4],
                align: match2[5],
                width: match2[6],
                precision: match2[7],
                type: match2[8]
              }
            );
          } else {
            throw new SyntaxError("[sprintf] unexpected placeholder");
          }
          _fmt = _fmt.substring(match2[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
      }
      if (typeof exports !== "undefined") {
        exports["sprintf"] = sprintf;
        exports["vsprintf"] = vsprintf;
      }
      if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) {
          define(function() {
            return {
              "sprintf": sprintf,
              "vsprintf": vsprintf
            };
          });
        }
      }
    }();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-L4KW73FJ.js
function z3(t6, s9, r8) {
  let e5 = new Date(s9 * 1e3), a7 = "", n23 = 0;
  for (; n23 < t6.length; ) if (t6[n23] === "%" && n23 + 1 < t6.length) {
    let o9 = t6[n23 + 1], i10 = H2(e5, o9, r8);
    i10 !== null ? (a7 += i10, n23 += 2) : (a7 += t6[n23], n23++);
  } else a7 += t6[n23], n23++;
  return a7;
}
function _2(t6, s9) {
  let r8 = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", weekday: "short", hour12: false, timeZone: s9 };
  try {
    let a7 = new Intl.DateTimeFormat("en-US", r8).formatToParts(t6), n23 = (u10) => a7.find((c14) => c14.type === u10)?.value ?? "", o9 = /* @__PURE__ */ new Map([["Sun", 0], ["Mon", 1], ["Tue", 2], ["Wed", 3], ["Thu", 4], ["Fri", 5], ["Sat", 6]]), i10 = n23("weekday");
    return { year: Number.parseInt(n23("year"), 10) || t6.getFullYear(), month: Number.parseInt(n23("month"), 10) || t6.getMonth() + 1, day: Number.parseInt(n23("day"), 10) || t6.getDate(), hour: Number.parseInt(n23("hour"), 10) || t6.getHours(), minute: Number.parseInt(n23("minute"), 10) || t6.getMinutes(), second: Number.parseInt(n23("second"), 10) || t6.getSeconds(), weekday: o9.get(i10) ?? t6.getDay() };
  } catch {
    return { year: t6.getFullYear(), month: t6.getMonth() + 1, day: t6.getDate(), hour: t6.getHours(), minute: t6.getMinutes(), second: t6.getSeconds(), weekday: t6.getDay() };
  }
}
function H2(t6, s9, r8) {
  let e5 = _2(t6, r8), a7 = (u10, c14 = 2) => String(u10).padStart(c14, "0"), n23 = O2(e5.year, e5.month, e5.day), o9 = W2(e5.year, e5.month, e5.day, e5.weekday, 0), i10 = W2(e5.year, e5.month, e5.day, e5.weekday, 1);
  switch (s9) {
    case "a":
      return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][e5.weekday];
    case "A":
      return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][e5.weekday];
    case "b":
    case "h":
      return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e5.month - 1];
    case "B":
      return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][e5.month - 1];
    case "c":
      return `${["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][e5.weekday]} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e5.month - 1]} ${String(e5.day).padStart(2, " ")} ${a7(e5.hour)}:${a7(e5.minute)}:${a7(e5.second)} ${e5.year}`;
    case "C":
      return a7(Math.floor(e5.year / 100));
    case "d":
      return a7(e5.day);
    case "D":
      return `${a7(e5.month)}/${a7(e5.day)}/${a7(e5.year % 100)}`;
    case "e":
      return String(e5.day).padStart(2, " ");
    case "F":
      return `${e5.year}-${a7(e5.month)}-${a7(e5.day)}`;
    case "g":
      return a7(P2(e5.year, e5.month, e5.day) % 100);
    case "G":
      return String(P2(e5.year, e5.month, e5.day));
    case "H":
      return a7(e5.hour);
    case "I":
      return a7(e5.hour % 12 || 12);
    case "j":
      return String(n23).padStart(3, "0");
    case "k":
      return String(e5.hour).padStart(2, " ");
    case "l":
      return String(e5.hour % 12 || 12).padStart(2, " ");
    case "m":
      return a7(e5.month);
    case "M":
      return a7(e5.minute);
    case "n":
      return `
`;
    case "N":
      return "000000000";
    case "p":
      return e5.hour < 12 ? "AM" : "PM";
    case "P":
      return e5.hour < 12 ? "am" : "pm";
    case "r":
      return `${a7(e5.hour % 12 || 12)}:${a7(e5.minute)}:${a7(e5.second)} ${e5.hour < 12 ? "AM" : "PM"}`;
    case "R":
      return `${a7(e5.hour)}:${a7(e5.minute)}`;
    case "s":
      return String(Math.floor(t6.getTime() / 1e3));
    case "S":
      return a7(e5.second);
    case "t":
      return "	";
    case "T":
      return `${a7(e5.hour)}:${a7(e5.minute)}:${a7(e5.second)}`;
    case "u":
      return String(e5.weekday === 0 ? 7 : e5.weekday);
    case "U":
      return a7(o9);
    case "V":
      return a7(R(e5.year, e5.month, e5.day));
    case "w":
      return String(e5.weekday);
    case "W":
      return a7(i10);
    case "x":
      return `${a7(e5.month)}/${a7(e5.day)}/${a7(e5.year % 100)}`;
    case "X":
      return `${a7(e5.hour)}:${a7(e5.minute)}:${a7(e5.second)}`;
    case "y":
      return a7(e5.year % 100);
    case "Y":
      return String(e5.year);
    case "z":
      return G(t6, r8);
    case "Z":
      return L2(t6, r8);
    case "%":
      return "%";
    default:
      return null;
  }
}
function G(t6, s9) {
  if (!s9) {
    let o9 = -t6.getTimezoneOffset(), i10 = o9 >= 0 ? "+" : "-", u10 = Math.floor(Math.abs(o9) / 60), c14 = Math.abs(o9) % 60;
    return `${i10}${String(u10).padStart(2, "0")}${String(c14).padStart(2, "0")}`;
  }
  try {
    let u10 = new Intl.DateTimeFormat("en-US", { timeZone: s9, timeZoneName: "longOffset" }).formatToParts(t6).find((c14) => c14.type === "timeZoneName");
    if (u10) {
      let c14 = u10.value.match(/GMT([+-])(\d{2}):(\d{2})/);
      if (c14) return `${c14[1]}${c14[2]}${c14[3]}`;
      if (u10.value === "GMT" || u10.value === "UTC") return "+0000";
    }
  } catch {
  }
  let r8 = -t6.getTimezoneOffset(), e5 = r8 >= 0 ? "+" : "-", a7 = Math.floor(Math.abs(r8) / 60), n23 = Math.abs(r8) % 60;
  return `${e5}${String(a7).padStart(2, "0")}${String(n23).padStart(2, "0")}`;
}
function L2(t6, s9) {
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: s9, timeZoneName: "short" }).formatToParts(t6).find((n23) => n23.type === "timeZoneName")?.value ?? "UTC";
  } catch {
    return "UTC";
  }
}
function O2(t6, s9, r8) {
  let e5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  (t6 % 4 === 0 && t6 % 100 !== 0 || t6 % 400 === 0) && (e5[1] = 29);
  let n23 = r8;
  for (let o9 = 0; o9 < s9 - 1; o9++) n23 += e5[o9];
  return n23;
}
function W2(t6, s9, r8, e5, a7) {
  let n23 = O2(t6, s9, r8), u10 = (new Date(t6, 0, 1).getDay() - a7 + 7) % 7, c14 = (e5 - a7 + 7) % 7, l8 = n23 - 1 + u10;
  return Math.floor((l8 - c14 + 7) / 7);
}
function R(t6, s9, r8) {
  let e5 = new Date(t6, s9 - 1, r8, 12, 0, 0);
  e5.setDate(e5.getDate() + 3 - (e5.getDay() + 6) % 7);
  let a7 = new Date(e5.getFullYear(), 0, 4);
  a7.setDate(a7.getDate() + 3 - (a7.getDay() + 6) % 7);
  let n23 = e5.getTime() - a7.getTime();
  return 1 + Math.round(n23 / (10080 * 60 * 1e3));
}
function P2(t6, s9, r8) {
  let e5 = new Date(t6, s9 - 1, r8, 12, 0, 0);
  return e5.setDate(e5.getDate() + 3 - (e5.getDay() + 6) % 7), e5.getFullYear();
}
function V3(t6) {
  let s9 = "", r8 = 0;
  for (; r8 < t6.length; ) {
    let e5 = t6[r8];
    if (e5 < 128) {
      s9 += String.fromCharCode(e5), r8++;
      continue;
    }
    if ((e5 & 224) === 192) {
      if (r8 + 1 < t6.length && (t6[r8 + 1] & 192) === 128 && e5 >= 194) {
        let a7 = (e5 & 31) << 6 | t6[r8 + 1] & 63;
        s9 += String.fromCharCode(a7), r8 += 2;
        continue;
      }
      s9 += String.fromCharCode(e5), r8++;
      continue;
    }
    if ((e5 & 240) === 224) {
      if (r8 + 2 < t6.length && (t6[r8 + 1] & 192) === 128 && (t6[r8 + 2] & 192) === 128) {
        if (e5 === 224 && t6[r8 + 1] < 160) {
          s9 += String.fromCharCode(e5), r8++;
          continue;
        }
        let a7 = (e5 & 15) << 12 | (t6[r8 + 1] & 63) << 6 | t6[r8 + 2] & 63;
        if (a7 >= 55296 && a7 <= 57343) {
          s9 += String.fromCharCode(e5), r8++;
          continue;
        }
        s9 += String.fromCharCode(a7), r8 += 3;
        continue;
      }
      s9 += String.fromCharCode(e5), r8++;
      continue;
    }
    if ((e5 & 248) === 240 && e5 <= 244) {
      if (r8 + 3 < t6.length && (t6[r8 + 1] & 192) === 128 && (t6[r8 + 2] & 192) === 128 && (t6[r8 + 3] & 192) === 128) {
        if (e5 === 240 && t6[r8 + 1] < 144) {
          s9 += String.fromCharCode(e5), r8++;
          continue;
        }
        let a7 = (e5 & 7) << 18 | (t6[r8 + 1] & 63) << 12 | (t6[r8 + 2] & 63) << 6 | t6[r8 + 3] & 63;
        if (a7 > 1114111) {
          s9 += String.fromCharCode(e5), r8++;
          continue;
        }
        s9 += String.fromCodePoint(a7), r8 += 4;
        continue;
      }
      s9 += String.fromCharCode(e5), r8++;
      continue;
    }
    s9 += String.fromCharCode(e5), r8++;
  }
  return s9;
}
function q3(t6, s9, r8, e5) {
  let a7 = "", n23 = 0, o9 = 0, i10 = false, u10 = "";
  for (; n23 < t6.length; ) if (t6[n23] === "%" && n23 + 1 < t6.length) {
    let c14 = n23;
    if (n23++, t6[n23] === "%") {
      a7 += "%", n23++;
      continue;
    }
    let l8 = t6.slice(c14).match(/^%(-?\d*)(?:\.(\d+))?\(([^)]*)\)T/);
    if (l8) {
      let g18 = l8[1] ? parseInt(l8[1], 10) : 0, b25 = l8[2] ? parseInt(l8[2], 10) : -1, J13 = l8[3], Y10 = l8[0], M14 = s9[r8 + o9] || "";
      o9++;
      let C19;
      M14 === "" || M14 === "-1" || M14 === "-2" ? C19 = Math.floor(Date.now() / 1e3) : C19 = parseInt(M14, 10) || 0;
      let h16 = z3(J13, C19, e5);
      if (b25 >= 0 && h16.length > b25 && (h16 = h16.slice(0, b25)), g18 !== 0) {
        let k15 = Math.abs(g18);
        h16.length < k15 && (g18 < 0 ? h16 = h16.padEnd(k15, " ") : h16 = h16.padStart(k15, " "));
      }
      a7 += h16, n23 = c14 + Y10.length;
      continue;
    }
    for (; n23 < t6.length && "+-0 #'".includes(t6[n23]); ) n23++;
    let y18 = false;
    if (t6[n23] === "*") y18 = true, n23++;
    else for (; n23 < t6.length && /\d/.test(t6[n23]); ) n23++;
    let p17 = false;
    if (t6[n23] === ".") if (n23++, t6[n23] === "*") p17 = true, n23++;
    else for (; n23 < t6.length && /\d/.test(t6[n23]); ) n23++;
    n23 < t6.length && "hlL".includes(t6[n23]) && n23++;
    let m24 = t6[n23] || "";
    n23++;
    let f11 = t6.slice(c14, n23);
    if (y18) {
      let g18 = parseInt(s9[r8 + o9] || "0", 10);
      o9++, f11 = f11.replace("*", String(g18));
    }
    if (p17) {
      let g18 = parseInt(s9[r8 + o9] || "0", 10);
      o9++, f11 = f11.replace(".*", `.${g18}`);
    }
    let x22 = s9[r8 + o9] || "";
    o9++;
    let { value: $17, parseError: j11, parseErrMsg: I17, stopped: U13 } = Q3(f11, m24, x22);
    if (a7 += $17, j11 && (i10 = true, I17 && (u10 = I17)), U13) return { result: a7, argsConsumed: o9, error: i10, errMsg: u10, stopped: true };
  } else a7 += t6[n23], n23++;
  return { result: a7, argsConsumed: o9, error: i10, errMsg: u10, stopped: false };
}
function Q3(t6, s9, r8) {
  let e5 = false, a7 = "";
  switch (s9) {
    case "d":
    case "i": {
      let n23 = v2(r8);
      return e5 = d4, e5 && (a7 = `printf: ${r8}: invalid number
`), { value: Z3(t6, n23), parseError: e5, parseErrMsg: a7 };
    }
    case "o": {
      let n23 = v2(r8);
      return e5 = d4, e5 && (a7 = `printf: ${r8}: invalid number
`), { value: B2(t6, n23), parseError: e5, parseErrMsg: a7 };
    }
    case "u": {
      let n23 = v2(r8);
      e5 = d4, e5 && (a7 = `printf: ${r8}: invalid number
`);
      let o9 = n23 < 0 ? n23 >>> 0 : n23;
      return { value: Z3(t6.replace("u", "d"), o9), parseError: e5, parseErrMsg: a7 };
    }
    case "x":
    case "X": {
      let n23 = v2(r8);
      return e5 = d4, e5 && (a7 = `printf: ${r8}: invalid number
`), { value: K2(t6, n23), parseError: e5, parseErrMsg: a7 };
    }
    case "e":
    case "E":
    case "f":
    case "F":
    case "g":
    case "G": {
      let n23 = parseFloat(r8) || 0;
      return { value: ne(t6, s9, n23), parseError: false, parseErrMsg: "" };
    }
    case "c": {
      if (r8 === "") return { value: "", parseError: false, parseErrMsg: "" };
      let i10 = new TextEncoder().encode(r8)[0];
      return { value: String.fromCharCode(i10), parseError: false, parseErrMsg: "" };
    }
    case "s":
      return { value: te(t6, r8), parseError: false, parseErrMsg: "" };
    case "q":
      return { value: re(t6, r8), parseError: false, parseErrMsg: "" };
    case "b": {
      let n23 = ae2(r8);
      return { value: n23.value, parseError: false, parseErrMsg: "", stopped: n23.stopped };
    }
    default:
      try {
        return { value: (0, import_sprintf_js.sprintf)(t6, r8), parseError: false, parseErrMsg: "" };
      } catch {
        return { value: "", parseError: true, parseErrMsg: `printf: [sprintf] unexpected placeholder
` };
      }
  }
}
function v2(t6) {
  d4 = false;
  let s9 = t6.trimStart(), r8 = s9 !== s9.trimEnd();
  if (t6 = s9.trimEnd(), t6.startsWith("'") && t6.length >= 2 || t6.startsWith('"') && t6.length >= 2) return t6.charCodeAt(1);
  if (t6.startsWith("\\'") && t6.length >= 3 || t6.startsWith('\\"') && t6.length >= 3) return t6.charCodeAt(2);
  if (t6.startsWith("+") && (t6 = t6.slice(1)), t6.startsWith("0x") || t6.startsWith("0X")) {
    let e5 = parseInt(t6, 16);
    return Number.isNaN(e5) ? (d4 = true, 0) : (r8 && (d4 = true), e5);
  }
  if (t6.startsWith("0") && t6.length > 1 && /^-?0[0-7]+$/.test(t6)) return r8 && (d4 = true), parseInt(t6, 8) || 0;
  if (/^\d+#/.test(t6)) {
    d4 = true;
    let e5 = t6.match(/^(\d+)#/);
    return e5 ? parseInt(e5[1], 10) : 0;
  }
  if (t6 !== "" && !/^-?\d+$/.test(t6)) {
    d4 = true;
    let e5 = parseInt(t6, 10);
    return Number.isNaN(e5) ? 0 : e5;
  }
  return r8 && (d4 = true), parseInt(t6, 10) || 0;
}
function Z3(t6, s9) {
  let r8 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[diu]$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6.replace(/\.\d*/, ""), s9);
  let e5 = r8[1] || "", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = s9 < 0, i10 = Math.abs(s9), u10 = String(i10);
  n23 >= 0 && (u10 = u10.padStart(n23, "0"));
  let c14 = "";
  o9 ? c14 = "-" : e5.includes("+") ? c14 = "+" : e5.includes(" ") && (c14 = " ");
  let l8 = c14 + u10;
  return a7 > l8.length && (e5.includes("-") ? l8 = l8.padEnd(a7, " ") : e5.includes("0") && n23 < 0 ? l8 = c14 + u10.padStart(a7 - c14.length, "0") : l8 = l8.padStart(a7, " ")), l8;
}
function B2(t6, s9) {
  let r8 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?o$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6, s9);
  let e5 = r8[1] || "", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = Math.abs(s9).toString(8);
  n23 >= 0 && (o9 = o9.padStart(n23, "0")), e5.includes("#") && !o9.startsWith("0") && (o9 = `0${o9}`);
  let i10 = o9;
  return a7 > i10.length && (e5.includes("-") ? i10 = i10.padEnd(a7, " ") : e5.includes("0") && n23 < 0 ? i10 = i10.padStart(a7, "0") : i10 = i10.padStart(a7, " ")), i10;
}
function K2(t6, s9) {
  let r8 = t6.includes("X"), e5 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[xX]$/);
  if (!e5) return (0, import_sprintf_js.sprintf)(t6, s9);
  let a7 = e5[1] || "", n23 = e5[2] ? parseInt(e5[2], 10) : 0, o9 = e5[3] !== void 0 ? e5[4] ? parseInt(e5[4], 10) : 0 : -1, i10 = Math.abs(s9).toString(16);
  r8 && (i10 = i10.toUpperCase()), o9 >= 0 && (i10 = i10.padStart(o9, "0"));
  let u10 = "";
  a7.includes("#") && s9 !== 0 && (u10 = r8 ? "0X" : "0x");
  let c14 = u10 + i10;
  return n23 > c14.length && (a7.includes("-") ? c14 = c14.padEnd(n23, " ") : a7.includes("0") && o9 < 0 ? c14 = u10 + i10.padStart(n23 - u10.length, "0") : c14 = c14.padStart(n23, " ")), c14;
}
function ee(t6) {
  if (t6 === "") return "''";
  if (/^[a-zA-Z0-9_./-]+$/.test(t6)) return t6;
  if (/[\x00-\x1f\x7f-\xff]/.test(t6)) {
    let e5 = "$'";
    for (let a7 of t6) {
      let n23 = a7.charCodeAt(0);
      a7 === "'" ? e5 += "\\'" : a7 === "\\" ? e5 += "\\\\" : a7 === `
` ? e5 += "\\n" : a7 === "	" ? e5 += "\\t" : a7 === "\r" ? e5 += "\\r" : a7 === "\x07" ? e5 += "\\a" : a7 === "\b" ? e5 += "\\b" : a7 === "\f" ? e5 += "\\f" : a7 === "\v" ? e5 += "\\v" : a7 === "\x1B" ? e5 += "\\E" : n23 < 32 || n23 >= 127 && n23 <= 255 ? e5 += `\\${n23.toString(8).padStart(3, "0")}` : a7 === '"' ? e5 += '\\"' : e5 += a7;
    }
    return e5 += "'", e5;
  }
  let r8 = "";
  for (let e5 of t6) " 	|&;<>()$`\\\"'*?[#~=%!{}".includes(e5) ? r8 += `\\${e5}` : r8 += e5;
  return r8;
}
function te(t6, s9) {
  let r8 = t6.match(/^%(-?)(\d*)(\.(\d*))?s$/);
  if (!r8) return (0, import_sprintf_js.sprintf)(t6.replace(/0+(?=\d)/, ""), s9);
  let e5 = r8[1] === "-", a7 = r8[2] ? parseInt(r8[2], 10) : 0, n23 = r8[3] !== void 0 ? r8[4] ? parseInt(r8[4], 10) : 0 : -1, o9 = e5 ? -a7 : a7;
  return i2(s9, o9, n23);
}
function re(t6, s9) {
  let r8 = ee(s9), e5 = t6.match(/^%(-?)(\d*)q$/);
  if (!e5) return r8;
  let a7 = e5[1] === "-", n23 = e5[2] ? parseInt(e5[2], 10) : 0, o9 = r8;
  return n23 > o9.length && (a7 ? o9 = o9.padEnd(n23, " ") : o9 = o9.padStart(n23, " ")), o9;
}
function ne(t6, s9, r8) {
  let e5 = t6.match(/^%([- +#0']*)(\d*)(\.(\d*))?[eEfFgG]$/);
  if (!e5) return (0, import_sprintf_js.sprintf)(t6, r8);
  let a7 = e5[1] || "", n23 = e5[2] ? parseInt(e5[2], 10) : 0, o9 = e5[3] !== void 0 ? e5[4] ? parseInt(e5[4], 10) : 0 : 6, i10, u10 = s9.toLowerCase();
  if (u10 === "e" ? (i10 = r8.toExponential(o9), i10 = i10.replace(/e([+-])(\d)$/, "e$10$2"), s9 === "E" && (i10 = i10.toUpperCase())) : u10 === "f" ? (i10 = r8.toFixed(o9), a7.includes("#") && o9 === 0 && !i10.includes(".") && (i10 += ".")) : u10 === "g" ? (i10 = r8.toPrecision(o9 || 1), a7.includes("#") || (i10 = i10.replace(/\.?0+$/, ""), i10 = i10.replace(/\.?0+e/, "e")), i10 = i10.replace(/e([+-])(\d)$/, "e$10$2"), s9 === "G" && (i10 = i10.toUpperCase())) : i10 = r8.toString(), r8 >= 0 && (a7.includes("+") ? i10 = `+${i10}` : a7.includes(" ") && (i10 = ` ${i10}`)), n23 > i10.length) if (a7.includes("-")) i10 = i10.padEnd(n23, " ");
  else if (a7.includes("0")) {
    let c14 = i10.match(/^[+ -]/)?.[0] || "", l8 = c14 ? i10.slice(1) : i10;
    i10 = c14 + l8.padStart(n23 - c14.length, "0");
  } else i10 = i10.padStart(n23, " ");
  return i10;
}
function ae2(t6) {
  let s9 = "", r8 = 0;
  for (; r8 < t6.length; ) if (t6[r8] === "\\" && r8 + 1 < t6.length) switch (t6[r8 + 1]) {
    case "n":
      s9 += `
`, r8 += 2;
      break;
    case "t":
      s9 += "	", r8 += 2;
      break;
    case "r":
      s9 += "\r", r8 += 2;
      break;
    case "\\":
      s9 += "\\", r8 += 2;
      break;
    case "a":
      s9 += "\x07", r8 += 2;
      break;
    case "b":
      s9 += "\b", r8 += 2;
      break;
    case "f":
      s9 += "\f", r8 += 2;
      break;
    case "v":
      s9 += "\v", r8 += 2;
      break;
    case "c":
      return { value: s9, stopped: true };
    case "x": {
      let a7 = [], n23 = r8;
      for (; n23 + 1 < t6.length && t6[n23] === "\\" && t6[n23 + 1] === "x"; ) {
        let o9 = "", i10 = n23 + 2;
        for (; i10 < t6.length && i10 < n23 + 4 && /[0-9a-fA-F]/.test(t6[i10]); ) o9 += t6[i10], i10++;
        if (o9) a7.push(parseInt(o9, 16)), n23 = i10;
        else break;
      }
      a7.length > 0 ? (s9 += V3(a7), r8 = n23) : (s9 += "\\x", r8 += 2);
      break;
    }
    case "u": {
      let a7 = "", n23 = r8 + 2;
      for (; n23 < t6.length && n23 < r8 + 6 && /[0-9a-fA-F]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      a7 ? (s9 += String.fromCodePoint(parseInt(a7, 16)), r8 = n23) : (s9 += "\\u", r8 += 2);
      break;
    }
    case "0": {
      let a7 = "", n23 = r8 + 2;
      for (; n23 < t6.length && n23 < r8 + 5 && /[0-7]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      a7 ? s9 += String.fromCharCode(parseInt(a7, 8)) : s9 += "\0", r8 = n23;
      break;
    }
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "7": {
      let a7 = "", n23 = r8 + 1;
      for (; n23 < t6.length && n23 < r8 + 4 && /[0-7]/.test(t6[n23]); ) a7 += t6[n23], n23++;
      s9 += String.fromCharCode(parseInt(a7, 8)), r8 = n23;
      break;
    }
    default:
      s9 += t6[r8], r8++;
  }
  else s9 += t6[r8], r8++;
  return { value: s9, stopped: false };
}
var import_sprintf_js, X2, de, d4, he;
var init_chunk_L4KW73FJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-L4KW73FJ.js"() {
    init_chunk_EEXR5ZDP();
    init_chunk_PSW6BMXW();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    import_sprintf_js = __toESM(require_sprintf(), 1);
    X2 = { name: "printf", summary: "format and print data", usage: "printf [-v var] FORMAT [ARGUMENT...]", options: ["    -v var     assign the output to shell variable VAR rather than display it", "    --help     display this help and exit"], notes: ["FORMAT controls the output like in C printf.", "Escape sequences: \\n (newline), \\t (tab), \\\\ (backslash)", "Format specifiers: %s (string), %d (integer), %f (float), %x (hex), %o (octal), %% (literal %)", "Width and precision: %10s (width 10), %.2f (2 decimal places), %010d (zero-padded)", "Flags: %- (left-justify), %+ (show sign), %0 (zero-pad)"] };
    de = { name: "printf", async execute(t6, s9) {
      if (o2(t6)) return s(X2);
      if (t6.length === 0) return { stdout: "", stderr: `printf: usage: printf format [arguments]
`, exitCode: 2 };
      let r8 = null, e5 = 0;
      for (; e5 < t6.length; ) {
        let o9 = t6[e5];
        if (o9 === "--") {
          e5++;
          break;
        }
        if (o9 === "-v") {
          if (e5 + 1 >= t6.length) return { stdout: "", stderr: `printf: -v: option requires an argument
`, exitCode: 1 };
          if (r8 = t6[e5 + 1], !/^[a-zA-Z_][a-zA-Z0-9_]*(\[[^\]]+\])?$/.test(r8)) return { stdout: "", stderr: `printf: \`${r8}': not a valid identifier
`, exitCode: 2 };
          e5 += 2;
        } else {
          if (o9.startsWith("-") && o9 !== "-") break;
          break;
        }
      }
      if (e5 >= t6.length) return { stdout: "", stderr: `printf: usage: printf format [arguments]
`, exitCode: 1 };
      let a7 = t6[e5], n23 = t6.slice(e5 + 1);
      try {
        let o9 = r4(a7), i10 = "", u10 = 0, c14 = false, l8 = "", y18 = s9.env.get("TZ"), p17 = s9.limits?.maxStringLength;
        do {
          let { result: m24, argsConsumed: w19, error: f11, errMsg: x22, stopped: $17 } = q3(o9, n23, u10, y18);
          if (i10 += m24, p17 !== void 0 && p17 > 0 && i10.length > p17) throw new b2(`printf: output size limit exceeded (${p17} bytes)`, "string_length");
          if (u10 += w19, f11 && (c14 = true, x22 && (l8 = x22)), $17) break;
        } while (u10 < n23.length && u10 > 0);
        if (u10 === 0 && n23.length > 0, r8) {
          let m24 = r8.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\[(['"]?)(.+?)\2\]$/);
          if (m24) {
            let w19 = m24[1], f11 = m24[3];
            f11 = f11.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)/g, (x22, $17) => s9.env.get($17) ?? ""), s9.env.set(`${w19}_${f11}`, i10);
          } else s9.env.set(r8, i10);
          return { stdout: "", stderr: l8, exitCode: c14 ? 1 : 0 };
        }
        return { stdout: i10, stderr: l8, exitCode: c14 ? 1 : 0 };
      } catch (o9) {
        if (o9 instanceof b2) throw o9;
        return { stdout: "", stderr: `printf: ${n16(o9)}
`, exitCode: 1 };
      }
    } };
    d4 = false;
    he = { name: "printf", flags: [{ flag: "-v", type: "value", valueHint: "string" }], stdinType: "none", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/printf-KGN6BDCY.js
var printf_KGN6BDCY_exports = {};
__export(printf_KGN6BDCY_exports, {
  flagsForFuzzing: () => he,
  printfCommand: () => de
});
var init_printf_KGN6BDCY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/printf-KGN6BDCY.js"() {
    init_chunk_L4KW73FJ();
    init_chunk_EEXR5ZDP();
    init_chunk_PSW6BMXW();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/node_modules/balanced-match/dist/esm/index.js
var balanced, maybeMatch, range;
var init_esm = __esm({
  "../../node_modules/just-bash/node_modules/balanced-match/dist/esm/index.js"() {
    balanced = (a7, b25, str) => {
      const ma = a7 instanceof RegExp ? maybeMatch(a7, str) : a7;
      const mb = b25 instanceof RegExp ? maybeMatch(b25, str) : b25;
      const r8 = ma !== null && mb != null && range(ma, mb, str);
      return r8 && {
        start: r8[0],
        end: r8[1],
        pre: str.slice(0, r8[0]),
        body: str.slice(r8[0] + ma.length, r8[1]),
        post: str.slice(r8[1] + mb.length)
      };
    };
    maybeMatch = (reg, str) => {
      const m24 = str.match(reg);
      return m24 ? m24[0] : null;
    };
    range = (a7, b25, str) => {
      let begs, beg, left, right = void 0, result;
      let ai = str.indexOf(a7);
      let bi = str.indexOf(b25, ai + 1);
      let i10 = ai;
      if (ai >= 0 && bi > 0) {
        if (a7 === b25) {
          return [ai, bi];
        }
        begs = [];
        left = str.length;
        while (i10 >= 0 && !result) {
          if (i10 === ai) {
            begs.push(i10);
            ai = str.indexOf(a7, i10 + 1);
          } else if (begs.length === 1) {
            const r8 = begs.pop();
            if (r8 !== void 0)
              result = [r8, bi];
          } else {
            beg = begs.pop();
            if (beg !== void 0 && beg < left) {
              left = beg;
              right = bi;
            }
            bi = str.indexOf(b25, i10 + 1);
          }
          i10 = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length && right !== void 0) {
          result = [left, right];
        }
      }
      return result;
    };
  }
});

// ../../node_modules/just-bash/node_modules/brace-expansion/dist/esm/index.js
function numeric(str) {
  return !isNaN(str) ? parseInt(str, 10) : str.charCodeAt(0);
}
function escapeBraces(str) {
  return str.replace(slashPattern, escSlash).replace(openPattern, escOpen).replace(closePattern, escClose).replace(commaPattern, escComma).replace(periodPattern, escPeriod);
}
function unescapeBraces(str) {
  return str.replace(escSlashPattern, "\\").replace(escOpenPattern, "{").replace(escClosePattern, "}").replace(escCommaPattern, ",").replace(escPeriodPattern, ".");
}
function parseCommaParts(str) {
  if (!str) {
    return [""];
  }
  const parts = [];
  const m24 = balanced("{", "}", str);
  if (!m24) {
    return str.split(",");
  }
  const { pre, body, post } = m24;
  const p17 = pre.split(",");
  p17[p17.length - 1] += "{" + body + "}";
  const postParts = parseCommaParts(post);
  if (post.length) {
    ;
    p17[p17.length - 1] += postParts.shift();
    p17.push.apply(p17, postParts);
  }
  parts.push.apply(parts, p17);
  return parts;
}
function expand(str, options = {}) {
  if (!str) {
    return [];
  }
  const { max = EXPANSION_MAX } = options;
  if (str.slice(0, 2) === "{}") {
    str = "\\{\\}" + str.slice(2);
  }
  return expand_(escapeBraces(str), max, true).map(unescapeBraces);
}
function embrace(str) {
  return "{" + str + "}";
}
function isPadded(el2) {
  return /^-?0\d/.test(el2);
}
function lte(i10, y18) {
  return i10 <= y18;
}
function gte(i10, y18) {
  return i10 >= y18;
}
function expand_(str, max, isTop) {
  const expansions = [];
  const m24 = balanced("{", "}", str);
  if (!m24)
    return [str];
  const pre = m24.pre;
  const post = m24.post.length ? expand_(m24.post, max, false) : [""];
  if (/\$$/.test(m24.pre)) {
    for (let k15 = 0; k15 < post.length && k15 < max; k15++) {
      const expansion = pre + "{" + m24.body + "}" + post[k15];
      expansions.push(expansion);
    }
  } else {
    const isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m24.body);
    const isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m24.body);
    const isSequence = isNumericSequence || isAlphaSequence;
    const isOptions = m24.body.indexOf(",") >= 0;
    if (!isSequence && !isOptions) {
      if (m24.post.match(/,(?!,).*\}/)) {
        str = m24.pre + "{" + m24.body + escClose + m24.post;
        return expand_(str, max, true);
      }
      return [str];
    }
    let n23;
    if (isSequence) {
      n23 = m24.body.split(/\.\./);
    } else {
      n23 = parseCommaParts(m24.body);
      if (n23.length === 1 && n23[0] !== void 0) {
        n23 = expand_(n23[0], max, false).map(embrace);
        if (n23.length === 1) {
          return post.map((p17) => m24.pre + n23[0] + p17);
        }
      }
    }
    let N14;
    if (isSequence && n23[0] !== void 0 && n23[1] !== void 0) {
      const x22 = numeric(n23[0]);
      const y18 = numeric(n23[1]);
      const width = Math.max(n23[0].length, n23[1].length);
      let incr = n23.length === 3 && n23[2] !== void 0 ? Math.max(Math.abs(numeric(n23[2])), 1) : 1;
      let test = lte;
      const reverse = y18 < x22;
      if (reverse) {
        incr *= -1;
        test = gte;
      }
      const pad = n23.some(isPadded);
      N14 = [];
      for (let i10 = x22; test(i10, y18); i10 += incr) {
        let c14;
        if (isAlphaSequence) {
          c14 = String.fromCharCode(i10);
          if (c14 === "\\") {
            c14 = "";
          }
        } else {
          c14 = String(i10);
          if (pad) {
            const need = width - c14.length;
            if (need > 0) {
              const z10 = new Array(need + 1).join("0");
              if (i10 < 0) {
                c14 = "-" + z10 + c14.slice(1);
              } else {
                c14 = z10 + c14;
              }
            }
          }
        }
        N14.push(c14);
      }
    } else {
      N14 = [];
      for (let j11 = 0; j11 < n23.length; j11++) {
        N14.push.apply(N14, expand_(n23[j11], max, false));
      }
    }
    for (let j11 = 0; j11 < N14.length; j11++) {
      for (let k15 = 0; k15 < post.length && expansions.length < max; k15++) {
        const expansion = pre + N14[j11] + post[k15];
        if (!isTop || isSequence || expansion) {
          expansions.push(expansion);
        }
      }
    }
  }
  return expansions;
}
var escSlash, escOpen, escClose, escComma, escPeriod, escSlashPattern, escOpenPattern, escClosePattern, escCommaPattern, escPeriodPattern, slashPattern, openPattern, closePattern, commaPattern, periodPattern, EXPANSION_MAX;
var init_esm2 = __esm({
  "../../node_modules/just-bash/node_modules/brace-expansion/dist/esm/index.js"() {
    init_esm();
    escSlash = "\0SLASH" + Math.random() + "\0";
    escOpen = "\0OPEN" + Math.random() + "\0";
    escClose = "\0CLOSE" + Math.random() + "\0";
    escComma = "\0COMMA" + Math.random() + "\0";
    escPeriod = "\0PERIOD" + Math.random() + "\0";
    escSlashPattern = new RegExp(escSlash, "g");
    escOpenPattern = new RegExp(escOpen, "g");
    escClosePattern = new RegExp(escClose, "g");
    escCommaPattern = new RegExp(escComma, "g");
    escPeriodPattern = new RegExp(escPeriod, "g");
    slashPattern = /\\\\/g;
    openPattern = /\\{/g;
    closePattern = /\\}/g;
    commaPattern = /\\,/g;
    periodPattern = /\\\./g;
    EXPANSION_MAX = 1e5;
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/assert-valid-pattern.js
var MAX_PATTERN_LENGTH, assertValidPattern;
var init_assert_valid_pattern = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/assert-valid-pattern.js"() {
    MAX_PATTERN_LENGTH = 1024 * 64;
    assertValidPattern = (pattern) => {
      if (typeof pattern !== "string") {
        throw new TypeError("invalid pattern");
      }
      if (pattern.length > MAX_PATTERN_LENGTH) {
        throw new TypeError("pattern is too long");
      }
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/brace-expressions.js
var posixClasses, braceEscape, regexpEscape, rangesToString, parseClass;
var init_brace_expressions = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/brace-expressions.js"() {
    posixClasses = {
      "[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", true],
      "[:alpha:]": ["\\p{L}\\p{Nl}", true],
      "[:ascii:]": ["\\x00-\\x7f", false],
      "[:blank:]": ["\\p{Zs}\\t", true],
      "[:cntrl:]": ["\\p{Cc}", true],
      "[:digit:]": ["\\p{Nd}", true],
      "[:graph:]": ["\\p{Z}\\p{C}", true, true],
      "[:lower:]": ["\\p{Ll}", true],
      "[:print:]": ["\\p{C}", true],
      "[:punct:]": ["\\p{P}", true],
      "[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", true],
      "[:upper:]": ["\\p{Lu}", true],
      "[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", true],
      "[:xdigit:]": ["A-Fa-f0-9", false]
    };
    braceEscape = (s9) => s9.replace(/[[\]\\-]/g, "\\$&");
    regexpEscape = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    rangesToString = (ranges) => ranges.join("");
    parseClass = (glob, position) => {
      const pos = position;
      if (glob.charAt(pos) !== "[") {
        throw new Error("not in a brace expression");
      }
      const ranges = [];
      const negs = [];
      let i10 = pos + 1;
      let sawStart = false;
      let uflag = false;
      let escaping = false;
      let negate = false;
      let endPos = pos;
      let rangeStart = "";
      WHILE: while (i10 < glob.length) {
        const c14 = glob.charAt(i10);
        if ((c14 === "!" || c14 === "^") && i10 === pos + 1) {
          negate = true;
          i10++;
          continue;
        }
        if (c14 === "]" && sawStart && !escaping) {
          endPos = i10 + 1;
          break;
        }
        sawStart = true;
        if (c14 === "\\") {
          if (!escaping) {
            escaping = true;
            i10++;
            continue;
          }
        }
        if (c14 === "[" && !escaping) {
          for (const [cls, [unip, u10, neg]] of Object.entries(posixClasses)) {
            if (glob.startsWith(cls, i10)) {
              if (rangeStart) {
                return ["$.", false, glob.length - pos, true];
              }
              i10 += cls.length;
              if (neg)
                negs.push(unip);
              else
                ranges.push(unip);
              uflag = uflag || u10;
              continue WHILE;
            }
          }
        }
        escaping = false;
        if (rangeStart) {
          if (c14 > rangeStart) {
            ranges.push(braceEscape(rangeStart) + "-" + braceEscape(c14));
          } else if (c14 === rangeStart) {
            ranges.push(braceEscape(c14));
          }
          rangeStart = "";
          i10++;
          continue;
        }
        if (glob.startsWith("-]", i10 + 1)) {
          ranges.push(braceEscape(c14 + "-"));
          i10 += 2;
          continue;
        }
        if (glob.startsWith("-", i10 + 1)) {
          rangeStart = c14;
          i10 += 2;
          continue;
        }
        ranges.push(braceEscape(c14));
        i10++;
      }
      if (endPos < i10) {
        return ["", false, 0, false];
      }
      if (!ranges.length && !negs.length) {
        return ["$.", false, glob.length - pos, true];
      }
      if (negs.length === 0 && ranges.length === 1 && /^\\?.$/.test(ranges[0]) && !negate) {
        const r8 = ranges[0].length === 2 ? ranges[0].slice(-1) : ranges[0];
        return [regexpEscape(r8), false, endPos - pos, false];
      }
      const sranges = "[" + (negate ? "^" : "") + rangesToString(ranges) + "]";
      const snegs = "[" + (negate ? "" : "^") + rangesToString(negs) + "]";
      const comb = ranges.length && negs.length ? "(" + sranges + "|" + snegs + ")" : ranges.length ? sranges : snegs;
      return [comb, uflag, endPos - pos, true];
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/unescape.js
var unescape;
var init_unescape = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/unescape.js"() {
    unescape = (s9, { windowsPathsNoEscape = false, magicalBraces = true } = {}) => {
      if (magicalBraces) {
        return windowsPathsNoEscape ? s9.replace(/\[([^\/\\])\]/g, "$1") : s9.replace(/((?!\\).|^)\[([^\/\\])\]/g, "$1$2").replace(/\\([^\/])/g, "$1");
      }
      return windowsPathsNoEscape ? s9.replace(/\[([^\/\\{}])\]/g, "$1") : s9.replace(/((?!\\).|^)\[([^\/\\{}])\]/g, "$1$2").replace(/\\([^\/{}])/g, "$1");
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/ast.js
var _a, types, isExtglobType, isExtglobAST, adoptionMap, adoptionWithSpaceMap, adoptionAnyMap, usurpMap, startNoTraversal, startNoDot, addPatternStart, justDots, reSpecials, regExpEscape, qmark, star, starNoEmpty, ID, AST;
var init_ast = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/ast.js"() {
    init_brace_expressions();
    init_unescape();
    types = /* @__PURE__ */ new Set(["!", "?", "+", "*", "@"]);
    isExtglobType = (c14) => types.has(c14);
    isExtglobAST = (c14) => isExtglobType(c14.type);
    adoptionMap = /* @__PURE__ */ new Map([
      ["!", ["@"]],
      ["?", ["?", "@"]],
      ["@", ["@"]],
      ["*", ["*", "+", "?", "@"]],
      ["+", ["+", "@"]]
    ]);
    adoptionWithSpaceMap = /* @__PURE__ */ new Map([
      ["!", ["?"]],
      ["@", ["?"]],
      ["+", ["?", "*"]]
    ]);
    adoptionAnyMap = /* @__PURE__ */ new Map([
      ["!", ["?", "@"]],
      ["?", ["?", "@"]],
      ["@", ["?", "@"]],
      ["*", ["*", "+", "?", "@"]],
      ["+", ["+", "@", "?", "*"]]
    ]);
    usurpMap = /* @__PURE__ */ new Map([
      ["!", /* @__PURE__ */ new Map([["!", "@"]])],
      [
        "?",
        /* @__PURE__ */ new Map([
          ["*", "*"],
          ["+", "*"]
        ])
      ],
      [
        "@",
        /* @__PURE__ */ new Map([
          ["!", "!"],
          ["?", "?"],
          ["@", "@"],
          ["*", "*"],
          ["+", "+"]
        ])
      ],
      [
        "+",
        /* @__PURE__ */ new Map([
          ["?", "*"],
          ["*", "*"]
        ])
      ]
    ]);
    startNoTraversal = "(?!(?:^|/)\\.\\.?(?:$|/))";
    startNoDot = "(?!\\.)";
    addPatternStart = /* @__PURE__ */ new Set(["[", "."]);
    justDots = /* @__PURE__ */ new Set(["..", "."]);
    reSpecials = new Set("().*{}+?[]^$\\!");
    regExpEscape = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    qmark = "[^/]";
    star = qmark + "*?";
    starNoEmpty = qmark + "+?";
    ID = 0;
    AST = class {
      type;
      #root;
      #hasMagic;
      #uflag = false;
      #parts = [];
      #parent;
      #parentIndex;
      #negs;
      #filledNegs = false;
      #options;
      #toString;
      // set to true if it's an extglob with no children
      // (which really means one child of '')
      #emptyExt = false;
      id = ++ID;
      get depth() {
        return (this.#parent?.depth ?? -1) + 1;
      }
      [Symbol.for("nodejs.util.inspect.custom")]() {
        return {
          "@@type": "AST",
          id: this.id,
          type: this.type,
          root: this.#root.id,
          parent: this.#parent?.id,
          depth: this.depth,
          partsLength: this.#parts.length,
          parts: this.#parts
        };
      }
      constructor(type, parent, options = {}) {
        this.type = type;
        if (type)
          this.#hasMagic = true;
        this.#parent = parent;
        this.#root = this.#parent ? this.#parent.#root : this;
        this.#options = this.#root === this ? options : this.#root.#options;
        this.#negs = this.#root === this ? [] : this.#root.#negs;
        if (type === "!" && !this.#root.#filledNegs)
          this.#negs.push(this);
        this.#parentIndex = this.#parent ? this.#parent.#parts.length : 0;
      }
      get hasMagic() {
        if (this.#hasMagic !== void 0)
          return this.#hasMagic;
        for (const p17 of this.#parts) {
          if (typeof p17 === "string")
            continue;
          if (p17.type || p17.hasMagic)
            return this.#hasMagic = true;
        }
        return this.#hasMagic;
      }
      // reconstructs the pattern
      toString() {
        if (this.#toString !== void 0)
          return this.#toString;
        if (!this.type) {
          return this.#toString = this.#parts.map((p17) => String(p17)).join("");
        } else {
          return this.#toString = this.type + "(" + this.#parts.map((p17) => String(p17)).join("|") + ")";
        }
      }
      #fillNegs() {
        if (this !== this.#root)
          throw new Error("should only call on root");
        if (this.#filledNegs)
          return this;
        this.toString();
        this.#filledNegs = true;
        let n23;
        while (n23 = this.#negs.pop()) {
          if (n23.type !== "!")
            continue;
          let p17 = n23;
          let pp = p17.#parent;
          while (pp) {
            for (let i10 = p17.#parentIndex + 1; !pp.type && i10 < pp.#parts.length; i10++) {
              for (const part of n23.#parts) {
                if (typeof part === "string") {
                  throw new Error("string part in extglob AST??");
                }
                part.copyIn(pp.#parts[i10]);
              }
            }
            p17 = pp;
            pp = p17.#parent;
          }
        }
        return this;
      }
      push(...parts) {
        for (const p17 of parts) {
          if (p17 === "")
            continue;
          if (typeof p17 !== "string" && !(p17 instanceof _a && p17.#parent === this)) {
            throw new Error("invalid part: " + p17);
          }
          this.#parts.push(p17);
        }
      }
      toJSON() {
        const ret = this.type === null ? this.#parts.slice().map((p17) => typeof p17 === "string" ? p17 : p17.toJSON()) : [this.type, ...this.#parts.map((p17) => p17.toJSON())];
        if (this.isStart() && !this.type)
          ret.unshift([]);
        if (this.isEnd() && (this === this.#root || this.#root.#filledNegs && this.#parent?.type === "!")) {
          ret.push({});
        }
        return ret;
      }
      isStart() {
        if (this.#root === this)
          return true;
        if (!this.#parent?.isStart())
          return false;
        if (this.#parentIndex === 0)
          return true;
        const p17 = this.#parent;
        for (let i10 = 0; i10 < this.#parentIndex; i10++) {
          const pp = p17.#parts[i10];
          if (!(pp instanceof _a && pp.type === "!")) {
            return false;
          }
        }
        return true;
      }
      isEnd() {
        if (this.#root === this)
          return true;
        if (this.#parent?.type === "!")
          return true;
        if (!this.#parent?.isEnd())
          return false;
        if (!this.type)
          return this.#parent?.isEnd();
        const pl2 = this.#parent ? this.#parent.#parts.length : 0;
        return this.#parentIndex === pl2 - 1;
      }
      copyIn(part) {
        if (typeof part === "string")
          this.push(part);
        else
          this.push(part.clone(this));
      }
      clone(parent) {
        const c14 = new _a(this.type, parent);
        for (const p17 of this.#parts) {
          c14.copyIn(p17);
        }
        return c14;
      }
      static #parseAST(str, ast, pos, opt, extDepth) {
        const maxDepth = opt.maxExtglobRecursion ?? 2;
        let escaping = false;
        let inBrace = false;
        let braceStart = -1;
        let braceNeg = false;
        if (ast.type === null) {
          let i11 = pos;
          let acc2 = "";
          while (i11 < str.length) {
            const c14 = str.charAt(i11++);
            if (escaping || c14 === "\\") {
              escaping = !escaping;
              acc2 += c14;
              continue;
            }
            if (inBrace) {
              if (i11 === braceStart + 1) {
                if (c14 === "^" || c14 === "!") {
                  braceNeg = true;
                }
              } else if (c14 === "]" && !(i11 === braceStart + 2 && braceNeg)) {
                inBrace = false;
              }
              acc2 += c14;
              continue;
            } else if (c14 === "[") {
              inBrace = true;
              braceStart = i11;
              braceNeg = false;
              acc2 += c14;
              continue;
            }
            const doRecurse = !opt.noext && isExtglobType(c14) && str.charAt(i11) === "(" && extDepth <= maxDepth;
            if (doRecurse) {
              ast.push(acc2);
              acc2 = "";
              const ext2 = new _a(c14, ast);
              i11 = _a.#parseAST(str, ext2, i11, opt, extDepth + 1);
              ast.push(ext2);
              continue;
            }
            acc2 += c14;
          }
          ast.push(acc2);
          return i11;
        }
        let i10 = pos + 1;
        let part = new _a(null, ast);
        const parts = [];
        let acc = "";
        while (i10 < str.length) {
          const c14 = str.charAt(i10++);
          if (escaping || c14 === "\\") {
            escaping = !escaping;
            acc += c14;
            continue;
          }
          if (inBrace) {
            if (i10 === braceStart + 1) {
              if (c14 === "^" || c14 === "!") {
                braceNeg = true;
              }
            } else if (c14 === "]" && !(i10 === braceStart + 2 && braceNeg)) {
              inBrace = false;
            }
            acc += c14;
            continue;
          } else if (c14 === "[") {
            inBrace = true;
            braceStart = i10;
            braceNeg = false;
            acc += c14;
            continue;
          }
          const doRecurse = !opt.noext && isExtglobType(c14) && str.charAt(i10) === "(" && /* c8 ignore start - the maxDepth is sufficient here */
          (extDepth <= maxDepth || ast && ast.#canAdoptType(c14));
          if (doRecurse) {
            const depthAdd = ast && ast.#canAdoptType(c14) ? 0 : 1;
            part.push(acc);
            acc = "";
            const ext2 = new _a(c14, part);
            part.push(ext2);
            i10 = _a.#parseAST(str, ext2, i10, opt, extDepth + depthAdd);
            continue;
          }
          if (c14 === "|") {
            part.push(acc);
            acc = "";
            parts.push(part);
            part = new _a(null, ast);
            continue;
          }
          if (c14 === ")") {
            if (acc === "" && ast.#parts.length === 0) {
              ast.#emptyExt = true;
            }
            part.push(acc);
            acc = "";
            ast.push(...parts, part);
            return i10;
          }
          acc += c14;
        }
        ast.type = null;
        ast.#hasMagic = void 0;
        ast.#parts = [str.substring(pos - 1)];
        return i10;
      }
      #canAdoptWithSpace(child) {
        return this.#canAdopt(child, adoptionWithSpaceMap);
      }
      #canAdopt(child, map = adoptionMap) {
        if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null) {
          return false;
        }
        const gc = child.#parts[0];
        if (!gc || typeof gc !== "object" || gc.type === null) {
          return false;
        }
        return this.#canAdoptType(gc.type, map);
      }
      #canAdoptType(c14, map = adoptionAnyMap) {
        return !!map.get(this.type)?.includes(c14);
      }
      #adoptWithSpace(child, index) {
        const gc = child.#parts[0];
        const blank = new _a(null, gc, this.options);
        blank.#parts.push("");
        gc.push(blank);
        this.#adopt(child, index);
      }
      #adopt(child, index) {
        const gc = child.#parts[0];
        this.#parts.splice(index, 1, ...gc.#parts);
        for (const p17 of gc.#parts) {
          if (typeof p17 === "object")
            p17.#parent = this;
        }
        this.#toString = void 0;
      }
      #canUsurpType(c14) {
        const m24 = usurpMap.get(this.type);
        return !!m24?.has(c14);
      }
      #canUsurp(child) {
        if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null || this.#parts.length !== 1) {
          return false;
        }
        const gc = child.#parts[0];
        if (!gc || typeof gc !== "object" || gc.type === null) {
          return false;
        }
        return this.#canUsurpType(gc.type);
      }
      #usurp(child) {
        const m24 = usurpMap.get(this.type);
        const gc = child.#parts[0];
        const nt7 = m24?.get(gc.type);
        if (!nt7)
          return false;
        this.#parts = gc.#parts;
        for (const p17 of this.#parts) {
          if (typeof p17 === "object") {
            p17.#parent = this;
          }
        }
        this.type = nt7;
        this.#toString = void 0;
        this.#emptyExt = false;
      }
      static fromGlob(pattern, options = {}) {
        const ast = new _a(null, void 0, options);
        _a.#parseAST(pattern, ast, 0, options, 0);
        return ast;
      }
      // returns the regular expression if there's magic, or the unescaped
      // string if not.
      toMMPattern() {
        if (this !== this.#root)
          return this.#root.toMMPattern();
        const glob = this.toString();
        const [re5, body, hasMagic, uflag] = this.toRegExpSource();
        const anyMagic = hasMagic || this.#hasMagic || this.#options.nocase && !this.#options.nocaseMagicOnly && glob.toUpperCase() !== glob.toLowerCase();
        if (!anyMagic) {
          return body;
        }
        const flags = (this.#options.nocase ? "i" : "") + (uflag ? "u" : "");
        return Object.assign(new RegExp(`^${re5}$`, flags), {
          _src: re5,
          _glob: glob
        });
      }
      get options() {
        return this.#options;
      }
      // returns the string match, the regexp source, whether there's magic
      // in the regexp (so a regular expression is required) and whether or
      // not the uflag is needed for the regular expression (for posix classes)
      // TODO: instead of injecting the start/end at this point, just return
      // the BODY of the regexp, along with the start/end portions suitable
      // for binding the start/end in either a joined full-path makeRe context
      // (where we bind to (^|/), or a standalone matchPart context (where
      // we bind to ^, and not /).  Otherwise slashes get duped!
      //
      // In part-matching mode, the start is:
      // - if not isStart: nothing
      // - if traversal possible, but not allowed: ^(?!\.\.?$)
      // - if dots allowed or not possible: ^
      // - if dots possible and not allowed: ^(?!\.)
      // end is:
      // - if not isEnd(): nothing
      // - else: $
      //
      // In full-path matching mode, we put the slash at the START of the
      // pattern, so start is:
      // - if first pattern: same as part-matching mode
      // - if not isStart(): nothing
      // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
      // - if dots allowed or not possible: /
      // - if dots possible and not allowed: /(?!\.)
      // end is:
      // - if last pattern, same as part-matching mode
      // - else nothing
      //
      // Always put the (?:$|/) on negated tails, though, because that has to be
      // there to bind the end of the negated pattern portion, and it's easier to
      // just stick it in now rather than try to inject it later in the middle of
      // the pattern.
      //
      // We can just always return the same end, and leave it up to the caller
      // to know whether it's going to be used joined or in parts.
      // And, if the start is adjusted slightly, can do the same there:
      // - if not isStart: nothing
      // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
      // - if dots allowed or not possible: (?:/|^)
      // - if dots possible and not allowed: (?:/|^)(?!\.)
      //
      // But it's better to have a simpler binding without a conditional, for
      // performance, so probably better to return both start options.
      //
      // Then the caller just ignores the end if it's not the first pattern,
      // and the start always gets applied.
      //
      // But that's always going to be $ if it's the ending pattern, or nothing,
      // so the caller can just attach $ at the end of the pattern when building.
      //
      // So the todo is:
      // - better detect what kind of start is needed
      // - return both flavors of starting pattern
      // - attach $ at the end of the pattern when creating the actual RegExp
      //
      // Ah, but wait, no, that all only applies to the root when the first pattern
      // is not an extglob. If the first pattern IS an extglob, then we need all
      // that dot prevention biz to live in the extglob portions, because eg
      // +(*|.x*) can match .xy but not .yx.
      //
      // So, return the two flavors if it's #root and the first child is not an
      // AST, otherwise leave it to the child AST to handle it, and there,
      // use the (?:^|/) style of start binding.
      //
      // Even simplified further:
      // - Since the start for a join is eg /(?!\.) and the start for a part
      // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
      // or start or whatever) and prepend ^ or / at the Regexp construction.
      toRegExpSource(allowDot) {
        const dot = allowDot ?? !!this.#options.dot;
        if (this.#root === this) {
          this.#flatten();
          this.#fillNegs();
        }
        if (!isExtglobAST(this)) {
          const noEmpty = this.isStart() && this.isEnd() && !this.#parts.some((s9) => typeof s9 !== "string");
          const src = this.#parts.map((p17) => {
            const [re5, _14, hasMagic, uflag] = typeof p17 === "string" ? _a.#parseGlob(p17, this.#hasMagic, noEmpty) : p17.toRegExpSource(allowDot);
            this.#hasMagic = this.#hasMagic || hasMagic;
            this.#uflag = this.#uflag || uflag;
            return re5;
          }).join("");
          let start2 = "";
          if (this.isStart()) {
            if (typeof this.#parts[0] === "string") {
              const dotTravAllowed = this.#parts.length === 1 && justDots.has(this.#parts[0]);
              if (!dotTravAllowed) {
                const aps = addPatternStart;
                const needNoTrav = (
                  // dots are allowed, and the pattern starts with [ or .
                  dot && aps.has(src.charAt(0)) || // the pattern starts with \., and then [ or .
                  src.startsWith("\\.") && aps.has(src.charAt(2)) || // the pattern starts with \.\., and then [ or .
                  src.startsWith("\\.\\.") && aps.has(src.charAt(4))
                );
                const needNoDot = !dot && !allowDot && aps.has(src.charAt(0));
                start2 = needNoTrav ? startNoTraversal : needNoDot ? startNoDot : "";
              }
            }
          }
          let end = "";
          if (this.isEnd() && this.#root.#filledNegs && this.#parent?.type === "!") {
            end = "(?:$|\\/)";
          }
          const final2 = start2 + src + end;
          return [
            final2,
            unescape(src),
            this.#hasMagic = !!this.#hasMagic,
            this.#uflag
          ];
        }
        const repeated = this.type === "*" || this.type === "+";
        const start = this.type === "!" ? "(?:(?!(?:" : "(?:";
        let body = this.#partsToRegExp(dot);
        if (this.isStart() && this.isEnd() && !body && this.type !== "!") {
          const s9 = this.toString();
          const me5 = this;
          me5.#parts = [s9];
          me5.type = null;
          me5.#hasMagic = void 0;
          return [s9, unescape(this.toString()), false, false];
        }
        let bodyDotAllowed = !repeated || allowDot || dot || !startNoDot ? "" : this.#partsToRegExp(true);
        if (bodyDotAllowed === body) {
          bodyDotAllowed = "";
        }
        if (bodyDotAllowed) {
          body = `(?:${body})(?:${bodyDotAllowed})*?`;
        }
        let final = "";
        if (this.type === "!" && this.#emptyExt) {
          final = (this.isStart() && !dot ? startNoDot : "") + starNoEmpty;
        } else {
          const close = this.type === "!" ? (
            // !() must match something,but !(x) can match ''
            "))" + (this.isStart() && !dot && !allowDot ? startNoDot : "") + star + ")"
          ) : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && bodyDotAllowed ? ")" : this.type === "*" && bodyDotAllowed ? `)?` : `)${this.type}`;
          final = start + body + close;
        }
        return [
          final,
          unescape(body),
          this.#hasMagic = !!this.#hasMagic,
          this.#uflag
        ];
      }
      #flatten() {
        if (!isExtglobAST(this)) {
          for (const p17 of this.#parts) {
            if (typeof p17 === "object") {
              p17.#flatten();
            }
          }
        } else {
          let iterations = 0;
          let done = false;
          do {
            done = true;
            for (let i10 = 0; i10 < this.#parts.length; i10++) {
              const c14 = this.#parts[i10];
              if (typeof c14 === "object") {
                c14.#flatten();
                if (this.#canAdopt(c14)) {
                  done = false;
                  this.#adopt(c14, i10);
                } else if (this.#canAdoptWithSpace(c14)) {
                  done = false;
                  this.#adoptWithSpace(c14, i10);
                } else if (this.#canUsurp(c14)) {
                  done = false;
                  this.#usurp(c14);
                }
              }
            }
          } while (!done && ++iterations < 10);
        }
        this.#toString = void 0;
      }
      #partsToRegExp(dot) {
        return this.#parts.map((p17) => {
          if (typeof p17 === "string") {
            throw new Error("string type in extglob ast??");
          }
          const [re5, _14, _hasMagic, uflag] = p17.toRegExpSource(dot);
          this.#uflag = this.#uflag || uflag;
          return re5;
        }).filter((p17) => !(this.isStart() && this.isEnd()) || !!p17).join("|");
      }
      static #parseGlob(glob, hasMagic, noEmpty = false) {
        let escaping = false;
        let re5 = "";
        let uflag = false;
        let inStar = false;
        for (let i10 = 0; i10 < glob.length; i10++) {
          const c14 = glob.charAt(i10);
          if (escaping) {
            escaping = false;
            re5 += (reSpecials.has(c14) ? "\\" : "") + c14;
            continue;
          }
          if (c14 === "*") {
            if (inStar)
              continue;
            inStar = true;
            re5 += noEmpty && /^[*]+$/.test(glob) ? starNoEmpty : star;
            hasMagic = true;
            continue;
          } else {
            inStar = false;
          }
          if (c14 === "\\") {
            if (i10 === glob.length - 1) {
              re5 += "\\\\";
            } else {
              escaping = true;
            }
            continue;
          }
          if (c14 === "[") {
            const [src, needUflag, consumed, magic] = parseClass(glob, i10);
            if (consumed) {
              re5 += src;
              uflag = uflag || needUflag;
              i10 += consumed - 1;
              hasMagic = hasMagic || magic;
              continue;
            }
          }
          if (c14 === "?") {
            re5 += qmark;
            hasMagic = true;
            continue;
          }
          re5 += regExpEscape(c14);
        }
        return [re5, unescape(glob), !!hasMagic, uflag];
      }
    };
    _a = AST;
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/escape.js
var escape;
var init_escape = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/escape.js"() {
    escape = (s9, { windowsPathsNoEscape = false, magicalBraces = false } = {}) => {
      if (magicalBraces) {
        return windowsPathsNoEscape ? s9.replace(/[?*()[\]{}]/g, "[$&]") : s9.replace(/[?*()[\]\\{}]/g, "\\$&");
      }
      return windowsPathsNoEscape ? s9.replace(/[?*()[\]]/g, "[$&]") : s9.replace(/[?*()[\]\\]/g, "\\$&");
    };
  }
});

// ../../node_modules/just-bash/node_modules/minimatch/dist/esm/index.js
var minimatch, starDotExtRE, starDotExtTest, starDotExtTestDot, starDotExtTestNocase, starDotExtTestNocaseDot, starDotStarRE, starDotStarTest, starDotStarTestDot, dotStarRE, dotStarTest, starRE, starTest, starTestDot, qmarksRE, qmarksTestNocase, qmarksTestNocaseDot, qmarksTestDot, qmarksTest, qmarksTestNoExt, qmarksTestNoExtDot, defaultPlatform, path, sep, GLOBSTAR, qmark2, star2, twoStarDot, twoStarNoDot, filter, ext, defaults, braceExpand, makeRe, match, globMagic, regExpEscape2, Minimatch;
var init_esm3 = __esm({
  "../../node_modules/just-bash/node_modules/minimatch/dist/esm/index.js"() {
    init_esm2();
    init_assert_valid_pattern();
    init_ast();
    init_escape();
    init_unescape();
    init_ast();
    init_escape();
    init_unescape();
    minimatch = (p17, pattern, options = {}) => {
      assertValidPattern(pattern);
      if (!options.nocomment && pattern.charAt(0) === "#") {
        return false;
      }
      return new Minimatch(pattern, options).match(p17);
    };
    starDotExtRE = /^\*+([^+@!?\*\[\(]*)$/;
    starDotExtTest = (ext2) => (f11) => !f11.startsWith(".") && f11.endsWith(ext2);
    starDotExtTestDot = (ext2) => (f11) => f11.endsWith(ext2);
    starDotExtTestNocase = (ext2) => {
      ext2 = ext2.toLowerCase();
      return (f11) => !f11.startsWith(".") && f11.toLowerCase().endsWith(ext2);
    };
    starDotExtTestNocaseDot = (ext2) => {
      ext2 = ext2.toLowerCase();
      return (f11) => f11.toLowerCase().endsWith(ext2);
    };
    starDotStarRE = /^\*+\.\*+$/;
    starDotStarTest = (f11) => !f11.startsWith(".") && f11.includes(".");
    starDotStarTestDot = (f11) => f11 !== "." && f11 !== ".." && f11.includes(".");
    dotStarRE = /^\.\*+$/;
    dotStarTest = (f11) => f11 !== "." && f11 !== ".." && f11.startsWith(".");
    starRE = /^\*+$/;
    starTest = (f11) => f11.length !== 0 && !f11.startsWith(".");
    starTestDot = (f11) => f11.length !== 0 && f11 !== "." && f11 !== "..";
    qmarksRE = /^\?+([^+@!?\*\[\(]*)?$/;
    qmarksTestNocase = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExt([$0]);
      if (!ext2)
        return noext;
      ext2 = ext2.toLowerCase();
      return (f11) => noext(f11) && f11.toLowerCase().endsWith(ext2);
    };
    qmarksTestNocaseDot = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExtDot([$0]);
      if (!ext2)
        return noext;
      ext2 = ext2.toLowerCase();
      return (f11) => noext(f11) && f11.toLowerCase().endsWith(ext2);
    };
    qmarksTestDot = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExtDot([$0]);
      return !ext2 ? noext : (f11) => noext(f11) && f11.endsWith(ext2);
    };
    qmarksTest = ([$0, ext2 = ""]) => {
      const noext = qmarksTestNoExt([$0]);
      return !ext2 ? noext : (f11) => noext(f11) && f11.endsWith(ext2);
    };
    qmarksTestNoExt = ([$0]) => {
      const len = $0.length;
      return (f11) => f11.length === len && !f11.startsWith(".");
    };
    qmarksTestNoExtDot = ([$0]) => {
      const len = $0.length;
      return (f11) => f11.length === len && f11 !== "." && f11 !== "..";
    };
    defaultPlatform = typeof process === "object" && process ? typeof process.env === "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix";
    path = {
      win32: { sep: "\\" },
      posix: { sep: "/" }
    };
    sep = defaultPlatform === "win32" ? path.win32.sep : path.posix.sep;
    minimatch.sep = sep;
    GLOBSTAR = Symbol("globstar **");
    minimatch.GLOBSTAR = GLOBSTAR;
    qmark2 = "[^/]";
    star2 = qmark2 + "*?";
    twoStarDot = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?";
    twoStarNoDot = "(?:(?!(?:\\/|^)\\.).)*?";
    filter = (pattern, options = {}) => (p17) => minimatch(p17, pattern, options);
    minimatch.filter = filter;
    ext = (a7, b25 = {}) => Object.assign({}, a7, b25);
    defaults = (def) => {
      if (!def || typeof def !== "object" || !Object.keys(def).length) {
        return minimatch;
      }
      const orig = minimatch;
      const m24 = (p17, pattern, options = {}) => orig(p17, pattern, ext(def, options));
      return Object.assign(m24, {
        Minimatch: class Minimatch extends orig.Minimatch {
          constructor(pattern, options = {}) {
            super(pattern, ext(def, options));
          }
          static defaults(options) {
            return orig.defaults(ext(def, options)).Minimatch;
          }
        },
        AST: class AST extends orig.AST {
          /* c8 ignore start */
          constructor(type, parent, options = {}) {
            super(type, parent, ext(def, options));
          }
          /* c8 ignore stop */
          static fromGlob(pattern, options = {}) {
            return orig.AST.fromGlob(pattern, ext(def, options));
          }
        },
        unescape: (s9, options = {}) => orig.unescape(s9, ext(def, options)),
        escape: (s9, options = {}) => orig.escape(s9, ext(def, options)),
        filter: (pattern, options = {}) => orig.filter(pattern, ext(def, options)),
        defaults: (options) => orig.defaults(ext(def, options)),
        makeRe: (pattern, options = {}) => orig.makeRe(pattern, ext(def, options)),
        braceExpand: (pattern, options = {}) => orig.braceExpand(pattern, ext(def, options)),
        match: (list, pattern, options = {}) => orig.match(list, pattern, ext(def, options)),
        sep: orig.sep,
        GLOBSTAR
      });
    };
    minimatch.defaults = defaults;
    braceExpand = (pattern, options = {}) => {
      assertValidPattern(pattern);
      if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) {
        return [pattern];
      }
      return expand(pattern, { max: options.braceExpandMax });
    };
    minimatch.braceExpand = braceExpand;
    makeRe = (pattern, options = {}) => new Minimatch(pattern, options).makeRe();
    minimatch.makeRe = makeRe;
    match = (list, pattern, options = {}) => {
      const mm = new Minimatch(pattern, options);
      list = list.filter((f11) => mm.match(f11));
      if (mm.options.nonull && !list.length) {
        list.push(pattern);
      }
      return list;
    };
    minimatch.match = match;
    globMagic = /[?*]|[+@!]\(.*?\)|\[|\]/;
    regExpEscape2 = (s9) => s9.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    Minimatch = class {
      options;
      set;
      pattern;
      windowsPathsNoEscape;
      nonegate;
      negate;
      comment;
      empty;
      preserveMultipleSlashes;
      partial;
      globSet;
      globParts;
      nocase;
      isWindows;
      platform;
      windowsNoMagicRoot;
      maxGlobstarRecursion;
      regexp;
      constructor(pattern, options = {}) {
        assertValidPattern(pattern);
        options = options || {};
        this.options = options;
        this.maxGlobstarRecursion = options.maxGlobstarRecursion ?? 200;
        this.pattern = pattern;
        this.platform = options.platform || defaultPlatform;
        this.isWindows = this.platform === "win32";
        const awe = "allowWindowsEscape";
        this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options[awe] === false;
        if (this.windowsPathsNoEscape) {
          this.pattern = this.pattern.replace(/\\/g, "/");
        }
        this.preserveMultipleSlashes = !!options.preserveMultipleSlashes;
        this.regexp = null;
        this.negate = false;
        this.nonegate = !!options.nonegate;
        this.comment = false;
        this.empty = false;
        this.partial = !!options.partial;
        this.nocase = !!this.options.nocase;
        this.windowsNoMagicRoot = options.windowsNoMagicRoot !== void 0 ? options.windowsNoMagicRoot : !!(this.isWindows && this.nocase);
        this.globSet = [];
        this.globParts = [];
        this.set = [];
        this.make();
      }
      hasMagic() {
        if (this.options.magicalBraces && this.set.length > 1) {
          return true;
        }
        for (const pattern of this.set) {
          for (const part of pattern) {
            if (typeof part !== "string")
              return true;
          }
        }
        return false;
      }
      debug(..._14) {
      }
      make() {
        const pattern = this.pattern;
        const options = this.options;
        if (!options.nocomment && pattern.charAt(0) === "#") {
          this.comment = true;
          return;
        }
        if (!pattern) {
          this.empty = true;
          return;
        }
        this.parseNegate();
        this.globSet = [...new Set(this.braceExpand())];
        if (options.debug) {
          this.debug = (...args) => console.error(...args);
        }
        this.debug(this.pattern, this.globSet);
        const rawGlobParts = this.globSet.map((s9) => this.slashSplit(s9));
        this.globParts = this.preprocess(rawGlobParts);
        this.debug(this.pattern, this.globParts);
        let set = this.globParts.map((s9, _14, __) => {
          if (this.isWindows && this.windowsNoMagicRoot) {
            const isUNC = s9[0] === "" && s9[1] === "" && (s9[2] === "?" || !globMagic.test(s9[2])) && !globMagic.test(s9[3]);
            const isDrive = /^[a-z]:/i.test(s9[0]);
            if (isUNC) {
              return [
                ...s9.slice(0, 4),
                ...s9.slice(4).map((ss) => this.parse(ss))
              ];
            } else if (isDrive) {
              return [s9[0], ...s9.slice(1).map((ss) => this.parse(ss))];
            }
          }
          return s9.map((ss) => this.parse(ss));
        });
        this.debug(this.pattern, set);
        this.set = set.filter((s9) => s9.indexOf(false) === -1);
        if (this.isWindows) {
          for (let i10 = 0; i10 < this.set.length; i10++) {
            const p17 = this.set[i10];
            if (p17[0] === "" && p17[1] === "" && this.globParts[i10][2] === "?" && typeof p17[3] === "string" && /^[a-z]:$/i.test(p17[3])) {
              p17[2] = "?";
            }
          }
        }
        this.debug(this.pattern, this.set);
      }
      // various transforms to equivalent pattern sets that are
      // faster to process in a filesystem walk.  The goal is to
      // eliminate what we can, and push all ** patterns as far
      // to the right as possible, even if it increases the number
      // of patterns that we have to process.
      preprocess(globParts) {
        if (this.options.noglobstar) {
          for (let i10 = 0; i10 < globParts.length; i10++) {
            for (let j11 = 0; j11 < globParts[i10].length; j11++) {
              if (globParts[i10][j11] === "**") {
                globParts[i10][j11] = "*";
              }
            }
          }
        }
        const { optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) {
          globParts = this.firstPhasePreProcess(globParts);
          globParts = this.secondPhasePreProcess(globParts);
        } else if (optimizationLevel >= 1) {
          globParts = this.levelOneOptimize(globParts);
        } else {
          globParts = this.adjascentGlobstarOptimize(globParts);
        }
        return globParts;
      }
      // just get rid of adjascent ** portions
      adjascentGlobstarOptimize(globParts) {
        return globParts.map((parts) => {
          let gs = -1;
          while (-1 !== (gs = parts.indexOf("**", gs + 1))) {
            let i10 = gs;
            while (parts[i10 + 1] === "**") {
              i10++;
            }
            if (i10 !== gs) {
              parts.splice(gs, i10 - gs);
            }
          }
          return parts;
        });
      }
      // get rid of adjascent ** and resolve .. portions
      levelOneOptimize(globParts) {
        return globParts.map((parts) => {
          parts = parts.reduce((set, part) => {
            const prev = set[set.length - 1];
            if (part === "**" && prev === "**") {
              return set;
            }
            if (part === "..") {
              if (prev && prev !== ".." && prev !== "." && prev !== "**") {
                set.pop();
                return set;
              }
            }
            set.push(part);
            return set;
          }, []);
          return parts.length === 0 ? [""] : parts;
        });
      }
      levelTwoFileOptimize(parts) {
        if (!Array.isArray(parts)) {
          parts = this.slashSplit(parts);
        }
        let didSomething = false;
        do {
          didSomething = false;
          if (!this.preserveMultipleSlashes) {
            for (let i10 = 1; i10 < parts.length - 1; i10++) {
              const p17 = parts[i10];
              if (i10 === 1 && p17 === "" && parts[0] === "")
                continue;
              if (p17 === "." || p17 === "") {
                didSomething = true;
                parts.splice(i10, 1);
                i10--;
              }
            }
            if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
              didSomething = true;
              parts.pop();
            }
          }
          let dd = 0;
          while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
            const p17 = parts[dd - 1];
            if (p17 && p17 !== "." && p17 !== ".." && p17 !== "**") {
              didSomething = true;
              parts.splice(dd - 1, 2);
              dd -= 2;
            }
          }
        } while (didSomething);
        return parts.length === 0 ? [""] : parts;
      }
      // First phase: single-pattern processing
      // <pre> is 1 or more portions
      // <rest> is 1 or more portions
      // <p> is any portion other than ., .., '', or **
      // <e> is . or ''
      //
      // **/.. is *brutal* for filesystem walking performance, because
      // it effectively resets the recursive walk each time it occurs,
      // and ** cannot be reduced out by a .. pattern part like a regexp
      // or most strings (other than .., ., and '') can be.
      //
      // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
      // <pre>/<e>/<rest> -> <pre>/<rest>
      // <pre>/<p>/../<rest> -> <pre>/<rest>
      // **/**/<rest> -> **/<rest>
      //
      // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
      // this WOULD be allowed if ** did follow symlinks, or * didn't
      firstPhasePreProcess(globParts) {
        let didSomething = false;
        do {
          didSomething = false;
          for (let parts of globParts) {
            let gs = -1;
            while (-1 !== (gs = parts.indexOf("**", gs + 1))) {
              let gss = gs;
              while (parts[gss + 1] === "**") {
                gss++;
              }
              if (gss > gs) {
                parts.splice(gs + 1, gss - gs);
              }
              let next2 = parts[gs + 1];
              const p17 = parts[gs + 2];
              const p22 = parts[gs + 3];
              if (next2 !== "..")
                continue;
              if (!p17 || p17 === "." || p17 === ".." || !p22 || p22 === "." || p22 === "..") {
                continue;
              }
              didSomething = true;
              parts.splice(gs, 1);
              const other = parts.slice(0);
              other[gs] = "**";
              globParts.push(other);
              gs--;
            }
            if (!this.preserveMultipleSlashes) {
              for (let i10 = 1; i10 < parts.length - 1; i10++) {
                const p17 = parts[i10];
                if (i10 === 1 && p17 === "" && parts[0] === "")
                  continue;
                if (p17 === "." || p17 === "") {
                  didSomething = true;
                  parts.splice(i10, 1);
                  i10--;
                }
              }
              if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
                didSomething = true;
                parts.pop();
              }
            }
            let dd = 0;
            while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
              const p17 = parts[dd - 1];
              if (p17 && p17 !== "." && p17 !== ".." && p17 !== "**") {
                didSomething = true;
                const needDot = dd === 1 && parts[dd + 1] === "**";
                const splin = needDot ? ["."] : [];
                parts.splice(dd - 1, 2, ...splin);
                if (parts.length === 0)
                  parts.push("");
                dd -= 2;
              }
            }
          }
        } while (didSomething);
        return globParts;
      }
      // second phase: multi-pattern dedupes
      // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
      // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
      // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
      //
      // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
      // ^-- not valid because ** doens't follow symlinks
      secondPhasePreProcess(globParts) {
        for (let i10 = 0; i10 < globParts.length - 1; i10++) {
          for (let j11 = i10 + 1; j11 < globParts.length; j11++) {
            const matched = this.partsMatch(globParts[i10], globParts[j11], !this.preserveMultipleSlashes);
            if (matched) {
              globParts[i10] = [];
              globParts[j11] = matched;
              break;
            }
          }
        }
        return globParts.filter((gs) => gs.length);
      }
      partsMatch(a7, b25, emptyGSMatch = false) {
        let ai = 0;
        let bi = 0;
        let result = [];
        let which = "";
        while (ai < a7.length && bi < b25.length) {
          if (a7[ai] === b25[bi]) {
            result.push(which === "b" ? b25[bi] : a7[ai]);
            ai++;
            bi++;
          } else if (emptyGSMatch && a7[ai] === "**" && b25[bi] === a7[ai + 1]) {
            result.push(a7[ai]);
            ai++;
          } else if (emptyGSMatch && b25[bi] === "**" && a7[ai] === b25[bi + 1]) {
            result.push(b25[bi]);
            bi++;
          } else if (a7[ai] === "*" && b25[bi] && (this.options.dot || !b25[bi].startsWith(".")) && b25[bi] !== "**") {
            if (which === "b")
              return false;
            which = "a";
            result.push(a7[ai]);
            ai++;
            bi++;
          } else if (b25[bi] === "*" && a7[ai] && (this.options.dot || !a7[ai].startsWith(".")) && a7[ai] !== "**") {
            if (which === "a")
              return false;
            which = "b";
            result.push(b25[bi]);
            ai++;
            bi++;
          } else {
            return false;
          }
        }
        return a7.length === b25.length && result;
      }
      parseNegate() {
        if (this.nonegate)
          return;
        const pattern = this.pattern;
        let negate = false;
        let negateOffset = 0;
        for (let i10 = 0; i10 < pattern.length && pattern.charAt(i10) === "!"; i10++) {
          negate = !negate;
          negateOffset++;
        }
        if (negateOffset)
          this.pattern = pattern.slice(negateOffset);
        this.negate = negate;
      }
      // set partial to true to test if, for example,
      // "/a/b" matches the start of "/*/b/*/d"
      // Partial means, if you run out of file before you run
      // out of pattern, then that's fine, as long as all
      // the parts match.
      matchOne(file, pattern, partial = false) {
        let fileStartIndex = 0;
        let patternStartIndex = 0;
        if (this.isWindows) {
          const fileDrive = typeof file[0] === "string" && /^[a-z]:$/i.test(file[0]);
          const fileUNC = !fileDrive && file[0] === "" && file[1] === "" && file[2] === "?" && /^[a-z]:$/i.test(file[3]);
          const patternDrive = typeof pattern[0] === "string" && /^[a-z]:$/i.test(pattern[0]);
          const patternUNC = !patternDrive && pattern[0] === "" && pattern[1] === "" && pattern[2] === "?" && typeof pattern[3] === "string" && /^[a-z]:$/i.test(pattern[3]);
          const fdi = fileUNC ? 3 : fileDrive ? 0 : void 0;
          const pdi = patternUNC ? 3 : patternDrive ? 0 : void 0;
          if (typeof fdi === "number" && typeof pdi === "number") {
            const [fd, pd] = [
              file[fdi],
              pattern[pdi]
            ];
            if (fd.toLowerCase() === pd.toLowerCase()) {
              pattern[pdi] = fd;
              patternStartIndex = pdi;
              fileStartIndex = fdi;
            }
          }
        }
        const { optimizationLevel = 1 } = this.options;
        if (optimizationLevel >= 2) {
          file = this.levelTwoFileOptimize(file);
        }
        if (pattern.includes(GLOBSTAR)) {
          return this.#matchGlobstar(file, pattern, partial, fileStartIndex, patternStartIndex);
        }
        return this.#matchOne(file, pattern, partial, fileStartIndex, patternStartIndex);
      }
      #matchGlobstar(file, pattern, partial, fileIndex, patternIndex) {
        const firstgs = pattern.indexOf(GLOBSTAR, patternIndex);
        const lastgs = pattern.lastIndexOf(GLOBSTAR);
        const [head, body, tail] = partial ? [
          pattern.slice(patternIndex, firstgs),
          pattern.slice(firstgs + 1),
          []
        ] : [
          pattern.slice(patternIndex, firstgs),
          pattern.slice(firstgs + 1, lastgs),
          pattern.slice(lastgs + 1)
        ];
        if (head.length) {
          const fileHead = file.slice(fileIndex, fileIndex + head.length);
          if (!this.#matchOne(fileHead, head, partial, 0, 0)) {
            return false;
          }
          fileIndex += head.length;
          patternIndex += head.length;
        }
        let fileTailMatch = 0;
        if (tail.length) {
          if (tail.length + fileIndex > file.length)
            return false;
          let tailStart = file.length - tail.length;
          if (this.#matchOne(file, tail, partial, tailStart, 0)) {
            fileTailMatch = tail.length;
          } else {
            if (file[file.length - 1] !== "" || fileIndex + tail.length === file.length) {
              return false;
            }
            tailStart--;
            if (!this.#matchOne(file, tail, partial, tailStart, 0)) {
              return false;
            }
            fileTailMatch = tail.length + 1;
          }
        }
        if (!body.length) {
          let sawSome = !!fileTailMatch;
          for (let i11 = fileIndex; i11 < file.length - fileTailMatch; i11++) {
            const f11 = String(file[i11]);
            sawSome = true;
            if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
              return false;
            }
          }
          return partial || sawSome;
        }
        const bodySegments = [[[], 0]];
        let currentBody = bodySegments[0];
        let nonGsParts = 0;
        const nonGsPartsSums = [0];
        for (const b25 of body) {
          if (b25 === GLOBSTAR) {
            nonGsPartsSums.push(nonGsParts);
            currentBody = [[], 0];
            bodySegments.push(currentBody);
          } else {
            currentBody[0].push(b25);
            nonGsParts++;
          }
        }
        let i10 = bodySegments.length - 1;
        const fileLength = file.length - fileTailMatch;
        for (const b25 of bodySegments) {
          b25[1] = fileLength - (nonGsPartsSums[i10--] + b25[0].length);
        }
        return !!this.#matchGlobStarBodySections(file, bodySegments, fileIndex, 0, partial, 0, !!fileTailMatch);
      }
      // return false for "nope, not matching"
      // return null for "not matching, cannot keep trying"
      #matchGlobStarBodySections(file, bodySegments, fileIndex, bodyIndex, partial, globStarDepth, sawTail) {
        const bs = bodySegments[bodyIndex];
        if (!bs) {
          for (let i10 = fileIndex; i10 < file.length; i10++) {
            sawTail = true;
            const f11 = file[i10];
            if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
              return false;
            }
          }
          return sawTail;
        }
        const [body, after] = bs;
        while (fileIndex <= after) {
          const m24 = this.#matchOne(file.slice(0, fileIndex + body.length), body, partial, fileIndex, 0);
          if (m24 && globStarDepth < this.maxGlobstarRecursion) {
            const sub = this.#matchGlobStarBodySections(file, bodySegments, fileIndex + body.length, bodyIndex + 1, partial, globStarDepth + 1, sawTail);
            if (sub !== false) {
              return sub;
            }
          }
          const f11 = file[fileIndex];
          if (f11 === "." || f11 === ".." || !this.options.dot && f11.startsWith(".")) {
            return false;
          }
          fileIndex++;
        }
        return partial || null;
      }
      #matchOne(file, pattern, partial, fileIndex, patternIndex) {
        let fi;
        let pi;
        let pl2;
        let fl2;
        for (fi = fileIndex, pi = patternIndex, fl2 = file.length, pl2 = pattern.length; fi < fl2 && pi < pl2; fi++, pi++) {
          this.debug("matchOne loop");
          let p17 = pattern[pi];
          let f11 = file[fi];
          this.debug(pattern, p17, f11);
          if (p17 === false || p17 === GLOBSTAR) {
            return false;
          }
          let hit;
          if (typeof p17 === "string") {
            hit = f11 === p17;
            this.debug("string match", p17, f11, hit);
          } else {
            hit = p17.test(f11);
            this.debug("pattern match", p17, f11, hit);
          }
          if (!hit)
            return false;
        }
        if (fi === fl2 && pi === pl2) {
          return true;
        } else if (fi === fl2) {
          return partial;
        } else if (pi === pl2) {
          return fi === fl2 - 1 && file[fi] === "";
        } else {
          throw new Error("wtf?");
        }
      }
      braceExpand() {
        return braceExpand(this.pattern, this.options);
      }
      parse(pattern) {
        assertValidPattern(pattern);
        const options = this.options;
        if (pattern === "**")
          return GLOBSTAR;
        if (pattern === "")
          return "";
        let m24;
        let fastTest = null;
        if (m24 = pattern.match(starRE)) {
          fastTest = options.dot ? starTestDot : starTest;
        } else if (m24 = pattern.match(starDotExtRE)) {
          fastTest = (options.nocase ? options.dot ? starDotExtTestNocaseDot : starDotExtTestNocase : options.dot ? starDotExtTestDot : starDotExtTest)(m24[1]);
        } else if (m24 = pattern.match(qmarksRE)) {
          fastTest = (options.nocase ? options.dot ? qmarksTestNocaseDot : qmarksTestNocase : options.dot ? qmarksTestDot : qmarksTest)(m24);
        } else if (m24 = pattern.match(starDotStarRE)) {
          fastTest = options.dot ? starDotStarTestDot : starDotStarTest;
        } else if (m24 = pattern.match(dotStarRE)) {
          fastTest = dotStarTest;
        }
        const re5 = AST.fromGlob(pattern, this.options).toMMPattern();
        if (fastTest && typeof re5 === "object") {
          Reflect.defineProperty(re5, "test", { value: fastTest });
        }
        return re5;
      }
      makeRe() {
        if (this.regexp || this.regexp === false)
          return this.regexp;
        const set = this.set;
        if (!set.length) {
          this.regexp = false;
          return this.regexp;
        }
        const options = this.options;
        const twoStar = options.noglobstar ? star2 : options.dot ? twoStarDot : twoStarNoDot;
        const flags = new Set(options.nocase ? ["i"] : []);
        let re5 = set.map((pattern) => {
          const pp = pattern.map((p17) => {
            if (p17 instanceof RegExp) {
              for (const f11 of p17.flags.split(""))
                flags.add(f11);
            }
            return typeof p17 === "string" ? regExpEscape2(p17) : p17 === GLOBSTAR ? GLOBSTAR : p17._src;
          });
          pp.forEach((p17, i10) => {
            const next2 = pp[i10 + 1];
            const prev = pp[i10 - 1];
            if (p17 !== GLOBSTAR || prev === GLOBSTAR) {
              return;
            }
            if (prev === void 0) {
              if (next2 !== void 0 && next2 !== GLOBSTAR) {
                pp[i10 + 1] = "(?:\\/|" + twoStar + "\\/)?" + next2;
              } else {
                pp[i10] = twoStar;
              }
            } else if (next2 === void 0) {
              pp[i10 - 1] = prev + "(?:\\/|\\/" + twoStar + ")?";
            } else if (next2 !== GLOBSTAR) {
              pp[i10 - 1] = prev + "(?:\\/|\\/" + twoStar + "\\/)" + next2;
              pp[i10 + 1] = GLOBSTAR;
            }
          });
          const filtered = pp.filter((p17) => p17 !== GLOBSTAR);
          if (this.partial && filtered.length >= 1) {
            const prefixes = [];
            for (let i10 = 1; i10 <= filtered.length; i10++) {
              prefixes.push(filtered.slice(0, i10).join("/"));
            }
            return "(?:" + prefixes.join("|") + ")";
          }
          return filtered.join("/");
        }).join("|");
        const [open2, close] = set.length > 1 ? ["(?:", ")"] : ["", ""];
        re5 = "^" + open2 + re5 + close + "$";
        if (this.partial) {
          re5 = "^(?:\\/|" + open2 + re5.slice(1, -1) + close + ")$";
        }
        if (this.negate)
          re5 = "^(?!" + re5 + ").+$";
        try {
          this.regexp = new RegExp(re5, [...flags].join(""));
        } catch (ex) {
          this.regexp = false;
        }
        return this.regexp;
      }
      slashSplit(p17) {
        if (this.preserveMultipleSlashes) {
          return p17.split("/");
        } else if (this.isWindows && /^\/\/[^\/]+/.test(p17)) {
          return ["", ...p17.split(/\/+/)];
        } else {
          return p17.split(/\/+/);
        }
      }
      match(f11, partial = this.partial) {
        this.debug("match", f11, this.pattern);
        if (this.comment) {
          return false;
        }
        if (this.empty) {
          return f11 === "";
        }
        if (f11 === "/" && partial) {
          return true;
        }
        const options = this.options;
        if (this.isWindows) {
          f11 = f11.split("\\").join("/");
        }
        const ff = this.slashSplit(f11);
        this.debug(this.pattern, "split", ff);
        const set = this.set;
        this.debug(this.pattern, "set", set);
        let filename = ff[ff.length - 1];
        if (!filename) {
          for (let i10 = ff.length - 2; !filename && i10 >= 0; i10--) {
            filename = ff[i10];
          }
        }
        for (let i10 = 0; i10 < set.length; i10++) {
          const pattern = set[i10];
          let file = ff;
          if (options.matchBase && pattern.length === 1) {
            file = [filename];
          }
          const hit = this.matchOne(file, pattern, partial);
          if (hit) {
            if (options.flipNegate) {
              return true;
            }
            return !this.negate;
          }
        }
        if (options.flipNegate) {
          return false;
        }
        return this.negate;
      }
      static defaults(def) {
        return minimatch.defaults(def).Minimatch;
      }
    };
    minimatch.AST = AST;
    minimatch.Minimatch = Minimatch;
    minimatch.escape = escape;
    minimatch.unescape = unescape;
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KY5VPZXG.js
function A(a7) {
  if (a7 < 1024) return String(a7);
  if (a7 < 1024 * 1024) {
    let n23 = a7 / 1024;
    return n23 < 10 ? `${n23.toFixed(1)}K` : `${Math.round(n23)}K`;
  }
  if (a7 < 1024 * 1024 * 1024) {
    let n23 = a7 / 1048576;
    return n23 < 10 ? `${n23.toFixed(1)}M` : `${Math.round(n23)}M`;
  }
  let r8 = a7 / (1024 * 1024 * 1024);
  return r8 < 10 ? `${r8.toFixed(1)}G` : `${Math.round(r8)}G`;
}
function F4(a7) {
  let n23 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][a7.getMonth()], g18 = String(a7.getDate()).padStart(2, " "), $17 = /* @__PURE__ */ new Date(), y18 = new Date($17.getTime() - 4320 * 60 * 60 * 1e3);
  if (a7 > y18) {
    let w19 = String(a7.getHours()).padStart(2, "0"), S16 = String(a7.getMinutes()).padStart(2, "0");
    return `${n23} ${g18} ${w19}:${S16}`;
  }
  let b25 = a7.getFullYear();
  return `${n23} ${g18}  ${b25}`;
}
async function _3(a7, r8, n23, g18, $17, y18 = false, b25 = false, w19 = false) {
  let S16 = n23 || g18, z10 = r8.fs.getAllPaths(), C19 = r8.fs.resolvePath(r8.cwd, "."), m24 = [];
  for (let o9 of z10) {
    let i10 = o9.startsWith(C19) && o9.slice(C19.length + 1) || o9;
    if (minimatch(i10, a7) || minimatch(o9, a7)) {
      let c14 = i10.split("/").pop() || i10;
      if (!S16 && c14.startsWith(".")) continue;
      m24.push(i10 || o9);
    }
  }
  if (m24.length === 0) return { stdout: "", stderr: `ls: ${a7}: No such file or directory
`, exitCode: 2 };
  if (w19) {
    let o9 = [];
    for (let i10 of m24) {
      let c14 = r8.fs.resolvePath(r8.cwd, i10);
      try {
        let u10 = await r8.fs.stat(c14);
        o9.push({ path: i10, size: u10.size ?? 0 });
      } catch {
        o9.push({ path: i10, size: 0 });
      }
    }
    o9.sort((i10, c14) => c14.size - i10.size), m24.length = 0, m24.push(...o9.map((i10) => i10.path));
  } else m24.sort();
  if (y18 && m24.reverse(), $17) {
    let o9 = [];
    for (let i10 of m24) {
      let c14 = r8.fs.resolvePath(r8.cwd, i10);
      try {
        let u10 = await r8.fs.stat(c14), f11 = u10.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", e5 = u10.isDirectory ? "/" : "", l8 = u10.size ?? 0, s9 = b25 ? A(l8).padStart(5) : String(l8).padStart(5), t6 = u10.mtime ?? /* @__PURE__ */ new Date(0), d16 = F4(t6);
        o9.push(`${f11} 1 user user ${s9} ${d16} ${i10}${e5}`);
      } catch {
        o9.push(`-rw-r--r-- 1 user user     0 Jan  1 00:00 ${i10}`);
      }
    }
    return { stdout: `${o9.join(`
`)}
`, stderr: "", exitCode: 0 };
  }
  return { stdout: `${m24.join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function E2(a7, r8, n23, g18, $17, y18, b25, w19 = false, S16 = false, z10 = false, C19 = false) {
  let m24 = n23 || g18, o9 = r8.fs.resolvePath(r8.cwd, a7);
  try {
    let i10 = await r8.fs.stat(o9);
    if (!i10.isDirectory) {
      if ($17) {
        let f11 = i10.size ?? 0, e5 = S16 ? A(f11).padStart(5) : String(f11).padStart(5), l8 = i10.mtime ?? /* @__PURE__ */ new Date(0), s9 = F4(l8);
        return { stdout: `-rw-r--r-- 1 user user ${e5} ${s9} ${a7}
`, stderr: "", exitCode: 0 };
      }
      return { stdout: `${a7}
`, stderr: "", exitCode: 0 };
    }
    let c14 = await r8.fs.readdir(o9);
    if (m24 || (c14 = c14.filter((f11) => !f11.startsWith("."))), z10) {
      let f11 = [];
      for (let e5 of c14) {
        let l8 = o9 === "/" ? `/${e5}` : `${o9}/${e5}`;
        try {
          let s9 = await r8.fs.stat(l8);
          f11.push({ name: e5, size: s9.size ?? 0 });
        } catch {
          f11.push({ name: e5, size: 0 });
        }
      }
      f11.sort((e5, l8) => l8.size - e5.size), c14 = f11.map((e5) => e5.name);
    } else c14.sort();
    n23 && (c14 = [".", "..", ...c14]), w19 && c14.reverse();
    let u10 = "";
    if ((y18 || b25) && (u10 += `${a7}:
`), $17) {
      u10 += `total ${c14.length}
`;
      let f11 = c14.filter((t6) => t6 === "." || t6 === ".."), e5 = c14.filter((t6) => t6 !== "." && t6 !== "..");
      for (let t6 of f11) u10 += `drwxr-xr-x 1 user user     0 Jan  1 00:00 ${t6}
`;
      let l8 = [];
      for (let t6 = 0; t6 < e5.length; t6 += 100) {
        let d16 = e5.slice(t6, t6 + 100), h16 = await Promise.all(d16.map(async (p17) => {
          let D15 = o9 === "/" ? `/${p17}` : `${o9}/${p17}`;
          try {
            let P19 = await r8.fs.stat(D15), O16 = P19.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", R13 = P19.isDirectory ? "/" : "", x22 = P19.size ?? 0, B12 = S16 ? A(x22).padStart(5) : String(x22).padStart(5), J13 = P19.mtime ?? /* @__PURE__ */ new Date(0), N14 = F4(J13);
            return { name: p17, line: `${O16} 1 user user ${B12} ${N14} ${p17}${R13}
` };
          } catch {
            return { name: p17, line: `-rw-r--r-- 1 user user     0 Jan  1 00:00 ${p17}
` };
          }
        }));
        l8.push(...h16);
      }
      let s9 = new Map(e5.map((t6, d16) => [t6, d16]));
      l8.sort((t6, d16) => (s9.get(t6.name) ?? 0) - (s9.get(d16.name) ?? 0));
      for (let { line: t6 } of l8) u10 += t6;
    } else u10 += c14.join(`
`) + (c14.length ? `
` : "");
    if (y18) {
      let f11 = c14.filter((s9) => s9 !== "." && s9 !== ".."), e5 = [];
      if (r8.fs.readdirWithFileTypes) e5 = (await r8.fs.readdirWithFileTypes(o9)).filter((t6) => t6.isDirectory && f11.includes(t6.name)).map((t6) => ({ name: t6.name, isDirectory: true }));
      else for (let s9 = 0; s9 < f11.length; s9 += 100) {
        let t6 = f11.slice(s9, s9 + 100), d16 = await Promise.all(t6.map(async (h16) => {
          let p17 = o9 === "/" ? `/${h16}` : `${o9}/${h16}`;
          try {
            let D15 = await r8.fs.stat(p17);
            return { name: h16, isDirectory: D15.isDirectory };
          } catch {
            return { name: h16, isDirectory: false };
          }
        }));
        e5.push(...d16.filter((h16) => h16.isDirectory));
      }
      e5.sort((s9, t6) => s9.name.localeCompare(t6.name)), w19 && e5.reverse();
      let l8 = [];
      for (let s9 = 0; s9 < e5.length; s9 += 100) {
        let t6 = e5.slice(s9, s9 + 100), d16 = await Promise.all(t6.map(async (h16) => {
          let p17 = a7 === "." ? `./${h16.name}` : `${a7}/${h16.name}`, D15 = await E2(p17, r8, n23, g18, $17, y18, false, w19, S16, z10, true);
          return { name: h16.name, result: D15 };
        }));
        l8.push(...d16);
      }
      l8.sort((s9, t6) => s9.name.localeCompare(t6.name)), w19 && l8.reverse();
      for (let { result: s9 } of l8) u10 += `
`, u10 += s9.stdout;
    }
    return { stdout: u10, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: "", stderr: `ls: ${a7}: No such file or directory
`, exitCode: 2 };
  }
}
var G2, L3, U2, Y2;
var init_chunk_KY5VPZXG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KY5VPZXG.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_esm3();
    G2 = { name: "ls", summary: "list directory contents", usage: "ls [OPTION]... [FILE]...", options: ["-a, --all            do not ignore entries starting with .", "-A, --almost-all     do not list . and ..", "-d, --directory      list directories themselves, not their contents", "-h, --human-readable with -l, print sizes like 1K 234M 2G etc.", "-l                   use a long listing format", "-r, --reverse        reverse order while sorting", "-R, --recursive      list subdirectories recursively", "-S                   sort by file size, largest first", "-t                   sort by time, newest first", "-1                   list one file per line", "    --help           display this help and exit"] };
    L3 = { showAll: { short: "a", long: "all", type: "boolean" }, showAlmostAll: { short: "A", long: "almost-all", type: "boolean" }, longFormat: { short: "l", type: "boolean" }, humanReadable: { short: "h", long: "human-readable", type: "boolean" }, recursive: { short: "R", long: "recursive", type: "boolean" }, reverse: { short: "r", long: "reverse", type: "boolean" }, sortBySize: { short: "S", type: "boolean" }, directoryOnly: { short: "d", long: "directory", type: "boolean" }, sortByTime: { short: "t", type: "boolean" }, onePerLine: { short: "1", type: "boolean" } };
    U2 = { name: "ls", async execute(a7, r8) {
      if (o2(a7)) return s(G2);
      let n23 = x3("ls", a7, L3);
      if (!n23.ok) return n23.error;
      let g18 = n23.result.flags.showAll, $17 = n23.result.flags.showAlmostAll, y18 = n23.result.flags.longFormat, b25 = n23.result.flags.humanReadable, w19 = n23.result.flags.recursive, S16 = n23.result.flags.reverse, z10 = n23.result.flags.sortBySize, C19 = n23.result.flags.directoryOnly, m24 = n23.result.flags.sortByTime;
      n23.result.flags.onePerLine;
      let o9 = n23.result.positional;
      o9.length === 0 && o9.push(".");
      let i10 = "", c14 = "", u10 = 0;
      for (let f11 = 0; f11 < o9.length; f11++) {
        let e5 = o9[f11];
        if (f11 > 0 && i10 && !i10.endsWith(`

`) && (i10 += `
`), C19) {
          let l8 = r8.fs.resolvePath(r8.cwd, e5);
          try {
            let s9 = await r8.fs.stat(l8);
            if (y18) {
              let t6 = s9.isDirectory ? "drwxr-xr-x" : "-rw-r--r--", d16 = s9.isDirectory ? "/" : "", h16 = s9.size ?? 0, p17 = b25 ? A(h16).padStart(5) : String(h16).padStart(5), D15 = s9.mtime ?? /* @__PURE__ */ new Date(0), P19 = F4(D15);
              i10 += `${t6} 1 user user ${p17} ${P19} ${e5}${d16}
`;
            } else i10 += `${e5}
`;
          } catch {
            c14 += `ls: cannot access '${e5}': No such file or directory
`, u10 = 2;
          }
          continue;
        }
        if (e5.includes("*") || e5.includes("?") || e5.includes("[")) {
          let l8 = await _3(e5, r8, g18, $17, y18, S16, b25, z10);
          i10 += l8.stdout, c14 += l8.stderr, l8.exitCode !== 0 && (u10 = l8.exitCode);
        } else {
          let l8 = await E2(e5, r8, g18, $17, y18, w19, o9.length > 1, S16, b25, z10);
          i10 += l8.stdout, c14 += l8.stderr, l8.exitCode !== 0 && (u10 = l8.exitCode);
        }
      }
      return { stdout: i10, stderr: c14, exitCode: u10 };
    } };
    Y2 = { name: "ls", flags: [{ flag: "-a", type: "boolean" }, { flag: "-A", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-1", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/ls-OTONBH2E.js
var ls_OTONBH2E_exports = {};
__export(ls_OTONBH2E_exports, {
  flagsForFuzzing: () => Y2,
  lsCommand: () => U2
});
var init_ls_OTONBH2E = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/ls-OTONBH2E.js"() {
    init_chunk_KY5VPZXG();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XZ3MZS57.js
var g4, k2, v3;
var init_chunk_XZ3MZS57 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XZ3MZS57.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    g4 = { recursive: { short: "p", long: "parents", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    k2 = { name: "mkdir", async execute(f11, o9) {
      let e5 = x3("mkdir", f11, g4);
      if (!e5.ok) return e5.error;
      let u10 = e5.result.flags.recursive, m24 = e5.result.flags.verbose, i10 = e5.result.positional;
      if (i10.length === 0) return { stdout: "", stderr: `mkdir: missing operand
`, exitCode: 1 };
      let a7 = "", t6 = "", c14 = 0;
      for (let r8 of i10) try {
        let n23 = o9.fs.resolvePath(o9.cwd, r8);
        await o9.fs.mkdir(n23, { recursive: u10 }), m24 && (a7 += `mkdir: created directory '${r8}'
`);
      } catch (n23) {
        let s9 = n16(n23);
        s9.includes("ENOENT") || s9.includes("no such file") ? t6 += `mkdir: cannot create directory '${r8}': No such file or directory
` : s9.includes("EEXIST") || s9.includes("already exists") ? t6 += `mkdir: cannot create directory '${r8}': File exists
` : t6 += `mkdir: cannot create directory '${r8}': ${s9}
`, c14 = 1;
      }
      return { stdout: a7, stderr: t6, exitCode: c14 };
    } };
    v3 = { name: "mkdir", flags: [{ flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/mkdir-QWGXDWUS.js
var mkdir_QWGXDWUS_exports = {};
__export(mkdir_QWGXDWUS_exports, {
  flagsForFuzzing: () => v3,
  mkdirCommand: () => k2
});
var init_mkdir_QWGXDWUS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/mkdir-QWGXDWUS.js"() {
    init_chunk_XZ3MZS57();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OCS6LSEM.js
async function b5(t6, r8, e5, a7) {
  let o9 = "", s9 = "", n23 = t6.fs.resolvePath(t6.cwd, r8), i10 = await v4(t6, n23, r8, a7);
  if (o9 += i10.stdout, s9 += i10.stderr, i10.exitCode !== 0) return { stdout: o9, stderr: s9, exitCode: i10.exitCode };
  if (e5) {
    let u10 = n23, d16 = r8;
    for (; ; ) {
      let l8 = C(u10), f11 = C(d16);
      if (l8 === u10 || l8 === "/" || l8 === "." || f11 === "." || f11 === "") break;
      let m24 = await v4(t6, l8, f11, a7);
      if (o9 += m24.stdout, m24.exitCode !== 0) break;
      u10 = l8, d16 = f11;
    }
  }
  return { stdout: o9, stderr: s9, exitCode: 0 };
}
async function v4(t6, r8, e5, a7) {
  try {
    if (!await t6.fs.exists(r8)) return { stdout: "", stderr: `rmdir: failed to remove '${e5}': No such file or directory
`, exitCode: 1 };
    if (!(await t6.fs.stat(r8)).isDirectory) return { stdout: "", stderr: `rmdir: failed to remove '${e5}': Not a directory
`, exitCode: 1 };
    if ((await t6.fs.readdir(r8)).length > 0) return { stdout: "", stderr: `rmdir: failed to remove '${e5}': Directory not empty
`, exitCode: 1 };
    await t6.fs.rm(r8, { recursive: false, force: false });
    let n23 = "";
    return a7 && (n23 = `rmdir: removing directory, '${e5}'
`), { stdout: n23, stderr: "", exitCode: 0 };
  } catch (o9) {
    let s9 = n16(o9);
    return { stdout: "", stderr: `rmdir: failed to remove '${e5}': ${s9}
`, exitCode: 1 };
  }
}
function C(t6) {
  let r8 = t6.replace(/\/+$/, ""), e5 = r8.lastIndexOf("/");
  return e5 === -1 ? "." : e5 === 0 ? "/" : r8.substring(0, e5);
}
var x4, y3, D2, $3;
var init_chunk_OCS6LSEM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OCS6LSEM.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    x4 = `Usage: rmdir [-pv] DIRECTORY...
Remove empty directories.

Options:
  -p, --parents   Remove DIRECTORY and its ancestors
  -v, --verbose   Output a diagnostic for every directory processed`;
    y3 = { parents: { short: "p", long: "parents", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" }, help: { long: "help", type: "boolean" } };
    D2 = { name: "rmdir", async execute(t6, r8) {
      let e5 = x3("rmdir", t6, y3);
      if (!e5.ok) return e5.error;
      if (e5.result.flags.help) return { stdout: `${x4}
`, stderr: "", exitCode: 0 };
      let a7 = e5.result.flags.parents, o9 = e5.result.flags.verbose, s9 = e5.result.positional;
      if (s9.length === 0) return { stdout: "", stderr: `rmdir: missing operand
`, exitCode: 1 };
      let c14 = "", n23 = "", i10 = 0;
      for (let u10 of s9) {
        let d16 = await b5(r8, u10, a7, o9);
        c14 += d16.stdout, n23 += d16.stderr, d16.exitCode !== 0 && (i10 = d16.exitCode);
      }
      return { stdout: c14, stderr: n23, exitCode: i10 };
    } };
    $3 = { name: "rmdir", flags: [{ flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rmdir-XTQXT7RK.js
var rmdir_XTQXT7RK_exports = {};
__export(rmdir_XTQXT7RK_exports, {
  flagsForFuzzing: () => $3,
  rmdirCommand: () => D2
});
var init_rmdir_XTQXT7RK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rmdir-XTQXT7RK.js"() {
    init_chunk_OCS6LSEM();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OCLXQMOG.js
function h4(s9) {
  let a7 = s9.replace(/\//g, "-"), r8 = new Date(a7);
  if (!Number.isNaN(r8.getTime())) return r8;
  let i10 = a7.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (i10) {
    let [, o9, l8, f11] = i10;
    if (r8 = new Date(Number.parseInt(o9, 10), Number.parseInt(l8, 10) - 1, Number.parseInt(f11, 10)), !Number.isNaN(r8.getTime())) return r8;
  }
  let u10 = a7.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/);
  if (u10) {
    let [, o9, l8, f11, t6, e5, d16] = u10;
    if (r8 = new Date(Number.parseInt(o9, 10), Number.parseInt(l8, 10) - 1, Number.parseInt(f11, 10), Number.parseInt(t6, 10), Number.parseInt(e5, 10), Number.parseInt(d16, 10)), !Number.isNaN(r8.getTime())) return r8;
  }
  return null;
}
var N3, b6;
var init_chunk_OCLXQMOG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OCLXQMOG.js"() {
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    N3 = { name: "touch", async execute(s9, a7) {
      let r8 = [], i10 = null, u10 = false;
      for (let t6 = 0; t6 < s9.length; t6++) {
        let e5 = s9[t6];
        if (e5 === "--") {
          r8.push(...s9.slice(t6 + 1));
          break;
        } else if (e5 === "-d" || e5 === "--date") {
          if (t6 + 1 >= s9.length) return { stdout: "", stderr: `touch: option requires an argument -- 'd'
`, exitCode: 1 };
          i10 = s9[++t6];
        } else if (e5.startsWith("--date=")) i10 = e5.slice(7);
        else if (e5 === "-c" || e5 === "--no-create") u10 = true;
        else if (e5 === "-a" || e5 === "-m" || e5 === "-r" || e5 === "-t") (e5 === "-r" || e5 === "-t") && t6++;
        else {
          if (e5.startsWith("--")) return r3("touch", e5);
          if (e5.startsWith("-") && e5.length > 1) {
            let d16 = false;
            for (let n23 of e5.slice(1)) if (n23 === "c") u10 = true;
            else if (!(n23 === "a" || n23 === "m")) if (n23 === "d") {
              if (t6 + 1 >= s9.length) return { stdout: "", stderr: `touch: option requires an argument -- 'd'
`, exitCode: 1 };
              i10 = s9[++t6], d16 = true;
              break;
            } else if (n23 === "r" || n23 === "t") {
              t6++, d16 = true;
              break;
            } else return r3("touch", `-${n23}`);
            if (d16) continue;
          } else r8.push(e5);
        }
      }
      if (r8.length === 0) return { stdout: "", stderr: `touch: missing file operand
`, exitCode: 1 };
      let o9 = null;
      if (i10 !== null && (o9 = h4(i10), o9 === null)) return { stdout: "", stderr: `touch: invalid date format '${i10}'
`, exitCode: 1 };
      let l8 = "", f11 = 0;
      for (let t6 of r8) try {
        let e5 = a7.fs.resolvePath(a7.cwd, t6);
        if (!await a7.fs.exists(e5)) {
          if (u10) continue;
          await a7.fs.writeFile(e5, "");
        }
        let n23 = o9 ?? /* @__PURE__ */ new Date();
        await a7.fs.utimes(e5, n23, n23);
      } catch (e5) {
        l8 += `touch: cannot touch '${t6}': ${n16(e5)}
`, f11 = 1;
      }
      return { stdout: "", stderr: l8, exitCode: f11 };
    } };
    b6 = { name: "touch", flags: [{ flag: "-c", type: "boolean" }, { flag: "-a", type: "boolean" }, { flag: "-m", type: "boolean" }, { flag: "-d", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/touch-DX2IJOQ4.js
var touch_DX2IJOQ4_exports = {};
__export(touch_DX2IJOQ4_exports, {
  flagsForFuzzing: () => b6,
  touchCommand: () => N3
});
var init_touch_DX2IJOQ4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/touch-DX2IJOQ4.js"() {
    init_chunk_OCLXQMOG();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-27LMNKBP.js
var d5, b7, h5;
var init_chunk_27LMNKBP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-27LMNKBP.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    d5 = { recursive: { short: "r", long: "recursive", type: "boolean" }, recursiveUpper: { short: "R", type: "boolean" }, force: { short: "f", long: "force", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    b7 = { name: "rm", async execute(p17, s9) {
      let e5 = x3("rm", p17, d5);
      if (!e5.ok) return e5.error;
      let c14 = e5.result.flags.recursive || e5.result.flags.recursiveUpper, a7 = e5.result.flags.force, g18 = e5.result.flags.verbose, i10 = e5.result.positional;
      if (i10.length === 0) return a7 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: "", stderr: `rm: missing operand
`, exitCode: 1 };
      let f11 = "", t6 = "", l8 = 0;
      for (let r8 of i10) try {
        let n23 = s9.fs.resolvePath(s9.cwd, r8);
        if ((await s9.fs.stat(n23)).isDirectory && !c14) {
          t6 += `rm: cannot remove '${r8}': Is a directory
`, l8 = 1;
          continue;
        }
        await s9.fs.rm(n23, { recursive: c14, force: a7 }), g18 && (f11 += `removed '${r8}'
`);
      } catch (n23) {
        if (!a7) {
          let o9 = n16(n23);
          o9.includes("ENOENT") || o9.includes("no such file") ? t6 += `rm: cannot remove '${r8}': No such file or directory
` : o9.includes("ENOTEMPTY") || o9.includes("not empty") ? t6 += `rm: cannot remove '${r8}': Directory not empty
` : t6 += `rm: cannot remove '${r8}': ${o9}
`, l8 = 1;
        }
      }
      return { stdout: f11, stderr: t6, exitCode: l8 };
    } };
    h5 = { name: "rm", flags: [{ flag: "-r", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rm-KPTLPKPH.js
var rm_KPTLPKPH_exports = {};
__export(rm_KPTLPKPH_exports, {
  flagsForFuzzing: () => h5,
  rmCommand: () => b7
});
var init_rm_KPTLPKPH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rm-KPTLPKPH.js"() {
    init_chunk_27LMNKBP();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NUYSJFDK.js
var D3, E3, A2, F5;
var init_chunk_NUYSJFDK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NUYSJFDK.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    D3 = { name: "cp", summary: "copy files and directories", usage: "cp [OPTION]... SOURCE... DEST", options: ["-r, -R, --recursive  copy directories recursively", "-n, --no-clobber     do not overwrite an existing file", "-p, --preserve       preserve file attributes", "-v, --verbose        explain what is being done", "    --help           display this help and exit"] };
    E3 = { recursive: { short: "r", long: "recursive", type: "boolean" }, recursiveUpper: { short: "R", type: "boolean" }, noClobber: { short: "n", long: "no-clobber", type: "boolean" }, preserve: { short: "p", long: "preserve", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    A2 = { name: "cp", async execute(f11, e5) {
      if (o2(f11)) return s(D3);
      let t6 = x3("cp", f11, E3);
      if (!t6.ok) return t6.error;
      let u10 = t6.result.flags.recursive || t6.result.flags.recursiveUpper, w19 = t6.result.flags.noClobber, C19 = t6.result.flags.preserve, P19 = t6.result.flags.verbose, c14 = t6.result.positional;
      if (c14.length < 2) return { stdout: "", stderr: `cp: missing destination file operand
`, exitCode: 1 };
      let g18 = c14.pop() ?? "", d16 = c14, o9 = e5.fs.resolvePath(e5.cwd, g18), b25 = "", n23 = "", l8 = 0, p17 = false;
      try {
        p17 = (await e5.fs.stat(o9)).isDirectory;
      } catch {
      }
      if (d16.length > 1 && !p17) return { stdout: "", stderr: `cp: target '${g18}' is not a directory
`, exitCode: 1 };
      for (let r8 of d16) try {
        let a7 = e5.fs.resolvePath(e5.cwd, r8), s9 = await e5.fs.stat(a7), i10 = o9;
        if (p17) {
          let v20 = r8.split("/").pop() || r8;
          i10 = o9 === "/" ? `/${v20}` : `${o9}/${v20}`;
        }
        if (s9.isDirectory && !u10) {
          n23 += `cp: -r not specified; omitting directory '${r8}'
`, l8 = 1;
          continue;
        }
        if (w19) try {
          await e5.fs.stat(i10);
          continue;
        } catch {
        }
        await e5.fs.cp(a7, i10, { recursive: u10 }), P19 && (b25 += `'${r8}' -> '${i10}'
`);
      } catch (a7) {
        let s9 = n16(a7);
        s9.includes("ENOENT") || s9.includes("no such file") ? n23 += `cp: cannot stat '${r8}': No such file or directory
` : n23 += `cp: cannot copy '${r8}': ${s9}
`, l8 = 1;
      }
      return { stdout: b25, stderr: n23, exitCode: l8 };
    } };
    F5 = { name: "cp", flags: [{ flag: "-r", type: "boolean" }, { flag: "-R", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-p", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cp-XOYR4ABJ.js
var cp_XOYR4ABJ_exports = {};
__export(cp_XOYR4ABJ_exports, {
  cpCommand: () => A2,
  flagsForFuzzing: () => F5
});
var init_cp_XOYR4ABJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cp-XOYR4ABJ.js"() {
    init_chunk_NUYSJFDK();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A4JSPFCI.js
var C2, P3, O3, x5;
var init_chunk_A4JSPFCI = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A4JSPFCI.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    C2 = { name: "mv", summary: "move (rename) files", usage: "mv [OPTION]... SOURCE... DEST", options: ["-f, --force       do not prompt before overwriting", "-n, --no-clobber  do not overwrite an existing file", "-v, --verbose     explain what is being done", "    --help        display this help and exit"] };
    P3 = { force: { short: "f", long: "force", type: "boolean" }, noClobber: { short: "n", long: "no-clobber", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" } };
    O3 = { name: "mv", async execute(m24, t6) {
      if (o2(m24)) return s(C2);
      let s9 = x3("mv", m24, P3);
      if (!s9.ok) return s9.error;
      let p17 = s9.result.flags.force, d16 = s9.result.flags.noClobber, w19 = s9.result.flags.verbose, i10 = s9.result.positional;
      if (d16 && (p17 = false), i10.length < 2) return { stdout: "", stderr: `mv: missing destination file operand
`, exitCode: 1 };
      let r8 = i10.pop() ?? "", g18 = i10, n23 = t6.fs.resolvePath(t6.cwd, r8), v20 = "", f11 = "", b25 = 0, a7 = false;
      try {
        a7 = (await t6.fs.stat(n23)).isDirectory;
      } catch {
      }
      if (g18.length > 1 && !a7) return { stdout: "", stderr: `mv: target '${r8}' is not a directory
`, exitCode: 1 };
      for (let e5 of g18) try {
        let c14 = t6.fs.resolvePath(t6.cwd, e5), o9 = n23;
        if (a7) {
          let l8 = e5.split("/").pop() || e5;
          o9 = n23 === "/" ? `/${l8}` : `${n23}/${l8}`;
        }
        if (d16) try {
          await t6.fs.stat(o9);
          continue;
        } catch {
        }
        if (await t6.fs.mv(c14, o9), w19) {
          let l8 = a7 ? `${r8}/${e5.split("/").pop() || e5}` : r8;
          v20 += `renamed '${e5}' -> '${l8}'
`;
        }
      } catch (c14) {
        let o9 = n16(c14);
        o9.includes("ENOENT") || o9.includes("no such file") ? f11 += `mv: cannot stat '${e5}': No such file or directory
` : f11 += `mv: cannot move '${e5}': ${o9}
`, b25 = 1;
      }
      return { stdout: v20, stderr: f11, exitCode: b25 };
    } };
    x5 = { name: "mv", flags: [{ flag: "-f", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/mv-Z6MORUFL.js
var mv_Z6MORUFL_exports = {};
__export(mv_Z6MORUFL_exports, {
  flagsForFuzzing: () => x5,
  mvCommand: () => O3
});
var init_mv_Z6MORUFL = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/mv-Z6MORUFL.js"() {
    init_chunk_A4JSPFCI();
    init_chunk_HWKDQ44K();
    init_chunk_44UOCSGV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SL4FN3A5.js
var g5, p4, b8;
var init_chunk_SL4FN3A5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SL4FN3A5.js"() {
    init_chunk_74CEPOFO();
    g5 = { name: "ln", summary: "make links between files", usage: "ln [OPTIONS] TARGET LINK_NAME", options: ["-s      create a symbolic link instead of a hard link", "-f      remove existing destination files", "-n      treat LINK_NAME as a normal file if it is a symbolic link to a directory", "-v      print name of each linked file", "    --help display this help and exit"] };
    p4 = { name: "ln", async execute(n23, s9) {
      if (o2(n23)) return s(g5);
      let l8 = false, a7 = false, f11 = false, t6 = 0;
      for (; t6 < n23.length && n23[t6].startsWith("-"); ) {
        let e5 = n23[t6];
        if (e5 === "-s" || e5 === "--symbolic") l8 = true, t6++;
        else if (e5 === "-f" || e5 === "--force") a7 = true, t6++;
        else if (e5 === "-v" || e5 === "--verbose") f11 = true, t6++;
        else if (e5 === "-n" || e5 === "--no-dereference") t6++;
        else if (/^-[sfvn]+$/.test(e5)) e5.includes("s") && (l8 = true), e5.includes("f") && (a7 = true), e5.includes("v") && (f11 = true), t6++;
        else if (e5 === "--") {
          t6++;
          break;
        } else return { stdout: "", stderr: `ln: invalid option -- '${e5.slice(1)}'
`, exitCode: 1 };
      }
      let d16 = n23.slice(t6);
      if (d16.length < 2) return { stdout: "", stderr: `ln: missing file operand
`, exitCode: 1 };
      let i10 = d16[0], r8 = d16[1], o9 = s9.fs.resolvePath(s9.cwd, r8);
      if (await s9.fs.exists(o9)) if (a7) try {
        await s9.fs.rm(o9, { force: true });
      } catch {
        return { stdout: "", stderr: `ln: cannot remove '${r8}': Permission denied
`, exitCode: 1 };
      }
      else return { stdout: "", stderr: `ln: failed to create ${l8 ? "symbolic " : ""}link '${r8}': File exists
`, exitCode: 1 };
      try {
        if (l8) await s9.fs.symlink(i10, o9);
        else {
          let e5 = s9.fs.resolvePath(s9.cwd, i10);
          if (!await s9.fs.exists(e5)) return { stdout: "", stderr: `ln: failed to access '${i10}': No such file or directory
`, exitCode: 1 };
          await s9.fs.link(e5, o9);
        }
      } catch (e5) {
        let u10 = e5;
        return u10.message.includes("EPERM") ? { stdout: "", stderr: `ln: '${i10}': hard link not allowed for directory
`, exitCode: 1 } : { stdout: "", stderr: `ln: ${u10.message}
`, exitCode: 1 };
      }
      let c14 = "";
      return f11 && (c14 = `'${r8}' -> '${i10}'
`), { stdout: c14, stderr: "", exitCode: 0 };
    } };
    b8 = { name: "ln", flags: [{ flag: "-s", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/ln-YAIFIHCT.js
var ln_YAIFIHCT_exports = {};
__export(ln_YAIFIHCT_exports, {
  flagsForFuzzing: () => b8,
  lnCommand: () => p4
});
var init_ln_YAIFIHCT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/ln-YAIFIHCT.js"() {
    init_chunk_SL4FN3A5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GZ2N3SXD.js
async function $4(s9, a7, e5, c14, o9) {
  let n23 = "", l8 = await s9.fs.readdir(a7);
  for (let r8 of l8) {
    let i10 = a7 === "/" ? `/${r8}` : `${a7}/${r8}`, f11;
    if (e5 !== void 0) f11 = e5;
    else if (c14 !== void 0) {
      let u10 = await s9.fs.stat(i10);
      f11 = p5(c14, u10.mode);
    } else f11 = 420;
    await s9.fs.chmod(i10, f11), o9 && (n23 += `mode of '${i10}' changed to ${f11.toString(8).padStart(4, "0")}
`), (await s9.fs.stat(i10)).isDirectory && (n23 += await $4(s9, i10, e5, c14, o9));
  }
  return n23;
}
function p5(s9, a7 = 420) {
  if (/^[0-7]+$/.test(s9)) return parseInt(s9, 8);
  let e5 = a7 & 4095, c14 = s9.split(",");
  for (let o9 of c14) {
    let n23 = o9.match(/^([ugoa]*)([+\-=])([rwxXst]*)$/);
    if (!n23) throw new Error(`Invalid mode: ${s9}`);
    let l8 = n23[1] || "a", r8 = n23[2], i10 = n23[3];
    (l8 === "a" || l8 === "") && (l8 = "ugo");
    let f11 = 0;
    i10.includes("r") && (f11 |= 4), i10.includes("w") && (f11 |= 2), (i10.includes("x") || i10.includes("X")) && (f11 |= 1);
    let d16 = 0;
    i10.includes("s") && (l8.includes("u") && (d16 |= 2048), l8.includes("g") && (d16 |= 1024)), i10.includes("t") && (d16 |= 512);
    for (let u10 of l8) {
      let t6 = 0;
      u10 === "u" ? t6 = 6 : u10 === "g" ? t6 = 3 : u10 === "o" && (t6 = 0);
      let h16 = f11 << t6;
      r8 === "+" ? e5 |= h16 : r8 === "-" ? e5 &= ~h16 : r8 === "=" && (e5 &= ~(7 << t6), e5 |= h16);
    }
    r8 === "+" ? e5 |= d16 : r8 === "-" ? e5 &= ~d16 : r8 === "=" && (i10.includes("s") && (l8.includes("u") && (e5 &= -2049, e5 |= d16 & 2048), l8.includes("g") && (e5 &= -1025, e5 |= d16 & 1024)), i10.includes("t") && (e5 &= -513, e5 |= d16 & 512));
  }
  return e5;
}
var C3, R2, b9;
var init_chunk_GZ2N3SXD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GZ2N3SXD.js"() {
    init_chunk_74CEPOFO();
    C3 = { name: "chmod", summary: "change file mode bits", usage: "chmod [OPTIONS] MODE FILE...", options: ["-R      change files recursively", "-v      output a diagnostic for every file processed", "    --help display this help and exit"] };
    R2 = { name: "chmod", async execute(s9, a7) {
      if (o2(s9)) return s(C3);
      if (s9.length < 2) return { stdout: "", stderr: `chmod: missing operand
`, exitCode: 1 };
      let e5 = false, c14 = false, o9 = 0;
      for (; o9 < s9.length && s9[o9].startsWith("-"); ) {
        let t6 = s9[o9];
        if (t6 === "-R" || t6 === "--recursive") e5 = true, o9++;
        else if (t6 === "-v" || t6 === "--verbose") c14 = true, o9++;
        else if (t6 === "--") {
          o9++;
          break;
        } else {
          if (/^[+-]?[rwxugo]+/.test(t6) || /^\d+$/.test(t6)) break;
          if (/^-[Rv]+$/.test(t6)) {
            t6.includes("R") && (e5 = true), t6.includes("v") && (c14 = true), o9++;
            continue;
          }
          return { stdout: "", stderr: `chmod: invalid option -- '${t6.slice(1)}'
`, exitCode: 1 };
        }
      }
      if (s9.length - o9 < 2) return { stdout: "", stderr: `chmod: missing operand
`, exitCode: 1 };
      let n23 = s9[o9], l8 = s9.slice(o9 + 1), r8 = /^[0-7]+$/.test(n23), i10;
      if (r8) i10 = parseInt(n23, 8);
      else try {
        p5(n23, 420);
      } catch {
        return { stdout: "", stderr: `chmod: invalid mode: '${n23}'
`, exitCode: 1 };
      }
      let f11 = "", d16 = "", u10 = false;
      for (let t6 of l8) {
        let h16 = a7.fs.resolvePath(a7.cwd, t6);
        try {
          let m24;
          if (r8 && i10 !== void 0) m24 = i10;
          else {
            let g18 = await a7.fs.stat(h16);
            m24 = p5(n23, g18.mode);
          }
          if (await a7.fs.chmod(h16, m24), c14 && (f11 += `mode of '${t6}' changed to ${m24.toString(8).padStart(4, "0")}
`), e5 && (await a7.fs.stat(h16)).isDirectory) {
            let y18 = await $4(a7, h16, r8 ? i10 : void 0, r8 ? void 0 : n23, c14);
            f11 += y18;
          }
        } catch {
          d16 += `chmod: cannot access '${t6}': No such file or directory
`, u10 = true;
        }
      }
      return { stdout: f11, stderr: d16, exitCode: u10 ? 1 : 0 };
    } };
    b9 = { name: "chmod", flags: [{ flag: "-R", type: "boolean" }, { flag: "-v", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chmod-MIKE3OIT.js
var chmod_MIKE3OIT_exports = {};
__export(chmod_MIKE3OIT_exports, {
  chmodCommand: () => R2,
  flagsForFuzzing: () => b9
});
var init_chmod_MIKE3OIT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chmod-MIKE3OIT.js"() {
    init_chunk_GZ2N3SXD();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A4HU7SVR.js
var o3, f3;
var init_chunk_A4HU7SVR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A4HU7SVR.js"() {
    o3 = { name: "pwd", async execute(l8, a7) {
      let t6 = false;
      for (let e5 of l8) if (e5 === "-P") t6 = true;
      else if (e5 === "-L") t6 = false;
      else {
        if (e5 === "--") break;
        e5.startsWith("-");
      }
      let s9 = a7.cwd;
      if (t6) try {
        s9 = await a7.fs.realpath(a7.cwd);
      } catch {
      }
      return { stdout: `${s9}
`, stderr: "", exitCode: 0 };
    } };
    f3 = { name: "pwd", flags: [{ flag: "-P", type: "boolean" }, { flag: "-L", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/pwd-D4OZ7N27.js
var pwd_D4OZ7N27_exports = {};
__export(pwd_D4OZ7N27_exports, {
  flagsForFuzzing: () => f3,
  pwdCommand: () => o3
});
var init_pwd_D4OZ7N27 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/pwd-D4OZ7N27.js"() {
    init_chunk_A4HU7SVR();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IKZ5LEGB.js
var k3, g6, y4;
var init_chunk_IKZ5LEGB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IKZ5LEGB.js"() {
    init_chunk_74CEPOFO();
    k3 = { name: "readlink", summary: "print resolved symbolic links or canonical file names", usage: "readlink [OPTIONS] FILE...", options: ["-f      canonicalize by following every symlink in every component of the given name recursively", "    --help display this help and exit"] };
    g6 = { name: "readlink", async execute(i10, a7) {
      if (o2(i10)) return s(k3);
      let r8 = false, n23 = 0;
      for (; n23 < i10.length && i10[n23].startsWith("-"); ) {
        let t6 = i10[n23];
        if (t6 === "-f" || t6 === "--canonicalize") r8 = true, n23++;
        else if (t6 === "--") {
          n23++;
          break;
        } else return { stdout: "", stderr: `readlink: invalid option -- '${t6.slice(1)}'
`, exitCode: 1 };
      }
      let d16 = i10.slice(n23);
      if (d16.length === 0) return { stdout: "", stderr: `readlink: missing operand
`, exitCode: 1 };
      let l8 = "", f11 = false;
      for (let t6 of d16) {
        let s9 = a7.fs.resolvePath(a7.cwd, t6);
        try {
          if (r8) {
            let e5 = s9, c14 = /* @__PURE__ */ new Set();
            for (; !c14.has(e5); ) {
              c14.add(e5);
              try {
                let o9 = await a7.fs.readlink(e5);
                if (o9.startsWith("/")) e5 = o9;
                else {
                  let p17 = e5.substring(0, e5.lastIndexOf("/")) || "/";
                  e5 = a7.fs.resolvePath(p17, o9);
                }
              } catch {
                break;
              }
            }
            l8 += `${e5}
`;
          } else {
            let e5 = await a7.fs.readlink(s9);
            l8 += `${e5}
`;
          }
        } catch {
          r8 ? l8 += `${s9}
` : f11 = true;
        }
      }
      return { stdout: l8, stderr: "", exitCode: f11 ? 1 : 0 };
    } };
    y4 = { name: "readlink", flags: [{ flag: "-f", type: "boolean" }, { flag: "-e", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/readlink-IEQO24KU.js
var readlink_IEQO24KU_exports = {};
__export(readlink_IEQO24KU_exports, {
  flagsForFuzzing: () => y4,
  readlinkCommand: () => g6
});
var init_readlink_IEQO24KU = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/readlink-IEQO24KU.js"() {
    init_chunk_IKZ5LEGB();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HDQ56CKY.js
function I2(t6, r8) {
  let i10 = 10, s9 = null, o9 = false, l8 = false, n23 = false, u10 = [];
  for (let f11 = 0; f11 < t6.length; f11++) {
    let e5 = t6[f11];
    if (e5 === "-n" && f11 + 1 < t6.length) {
      let a7 = t6[++f11];
      r8 === "tail" && a7.startsWith("+") ? (n23 = true, i10 = parseInt(a7.slice(1), 10)) : i10 = parseInt(a7, 10);
    } else if (r8 === "tail" && e5.startsWith("-n+")) n23 = true, i10 = parseInt(e5.slice(3), 10);
    else if (e5.startsWith("-n")) i10 = parseInt(e5.slice(2), 10);
    else if (e5 === "-c" && f11 + 1 < t6.length) s9 = parseInt(t6[++f11], 10);
    else if (e5.startsWith("-c")) s9 = parseInt(e5.slice(2), 10);
    else if (e5.startsWith("--bytes=")) s9 = parseInt(e5.slice(8), 10);
    else if (e5.startsWith("--lines=")) i10 = parseInt(e5.slice(8), 10);
    else if (e5 === "-q" || e5 === "--quiet" || e5 === "--silent") o9 = true;
    else if (e5 === "-v" || e5 === "--verbose") l8 = true;
    else if (e5.match(/^-\d+$/)) i10 = parseInt(e5.slice(1), 10);
    else {
      if (e5.startsWith("--")) return { ok: false, error: r3(r8, e5) };
      if (e5.startsWith("-") && e5 !== "-") return { ok: false, error: r3(r8, e5) };
      u10.push(e5);
    }
  }
  return s9 !== null && (Number.isNaN(s9) || s9 < 0) ? { ok: false, error: { stdout: "", stderr: `${r8}: invalid number of bytes
`, exitCode: 1 } } : Number.isNaN(i10) || i10 < 0 ? { ok: false, error: { stdout: "", stderr: `${r8}: invalid number of lines
`, exitCode: 1 } } : { ok: true, options: { lines: i10, bytes: s9, quiet: o9, verbose: l8, files: u10, fromLine: n23 } };
}
async function W3(t6, r8, i10, s9) {
  let { quiet: o9, verbose: l8, files: n23 } = r8;
  if (n23.length === 0) return { stdout: s9(t6.stdin), stderr: "", exitCode: 0 };
  let u10 = "", f11 = "", e5 = 0, a7 = l8 || !o9 && n23.length > 1, h16 = 0;
  for (let d16 = 0; d16 < n23.length; d16++) {
    let p17 = n23[d16];
    try {
      let b25 = t6.fs.resolvePath(t6.cwd, p17), x22 = await t6.fs.readFile(b25);
      a7 && (h16 > 0 && (u10 += `
`), u10 += `==> ${p17} <==
`), u10 += s9(x22), h16++;
    } catch {
      f11 += `${i10}: ${p17}: No such file or directory
`, e5 = 1;
    }
  }
  return { stdout: u10, stderr: f11, exitCode: e5 };
}
function $5(t6, r8, i10) {
  if (i10 !== null) return t6.slice(0, i10);
  if (r8 === 0) return "";
  let s9 = 0, o9 = 0, l8 = t6.length;
  for (; s9 < l8 && o9 < r8; ) {
    let n23 = t6.indexOf(`
`, s9);
    if (n23 === -1) return `${t6}
`;
    o9++, s9 = n23 + 1;
  }
  return s9 > 0 ? t6.slice(0, s9) : "";
}
function g7(t6, r8, i10, s9) {
  if (i10 !== null) return t6.slice(-i10);
  let o9 = t6.length;
  if (o9 === 0) return "";
  if (s9) {
    let f11 = 0, e5 = 1;
    for (; f11 < o9 && e5 < r8; ) {
      let h16 = t6.indexOf(`
`, f11);
      if (h16 === -1) break;
      e5++, f11 = h16 + 1;
    }
    let a7 = t6.slice(f11);
    return a7.endsWith(`
`) ? a7 : `${a7}
`;
  }
  if (r8 === 0) return "";
  let l8 = o9 - 1;
  t6[l8] === `
` && l8--;
  let n23 = 0;
  for (; l8 >= 0 && n23 < r8; ) {
    if (t6[l8] === `
` && (n23++, n23 === r8)) {
      l8++;
      break;
    }
    l8--;
  }
  l8 < 0 && (l8 = 0);
  let u10 = t6.slice(l8);
  return t6[o9 - 1] === `
` ? u10 : `${u10}
`;
}
var init_chunk_HDQ56CKY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HDQ56CKY.js"() {
    init_chunk_74CEPOFO();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-64BAICW3.js
var f4, m4, g8;
var init_chunk_64BAICW3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-64BAICW3.js"() {
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    f4 = { name: "head", summary: "output the first part of files", usage: "head [OPTION]... [FILE]...", options: ["-c, --bytes=NUM    print the first NUM bytes", "-n, --lines=NUM    print the first NUM lines (default 10)", "-q, --quiet        never print headers giving file names", "-v, --verbose      always print headers giving file names", "    --help         display this help and exit"] };
    m4 = { name: "head", async execute(t6, l8) {
      if (o2(t6)) return s(f4);
      let e5 = I2(t6, "head");
      if (!e5.ok) return e5.error;
      let { lines: o9, bytes: p17 } = e5.options;
      return W3(l8, e5.options, "head", (d16) => $5(d16, o9, p17));
    } };
    g8 = { name: "head", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/head-HT2B6D2J.js
var head_HT2B6D2J_exports = {};
__export(head_HT2B6D2J_exports, {
  flagsForFuzzing: () => g8,
  headCommand: () => m4
});
var init_head_HT2B6D2J = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/head-HT2B6D2J.js"() {
    init_chunk_64BAICW3();
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DCAAORBQ.js
var m5, d6, c4;
var init_chunk_DCAAORBQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DCAAORBQ.js"() {
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    m5 = { name: "tail", summary: "output the last part of files", usage: "tail [OPTION]... [FILE]...", options: ["-c, --bytes=NUM    print the last NUM bytes", "-n, --lines=NUM    print the last NUM lines (default 10)", "-n +NUM            print starting from line NUM", "-q, --quiet        never print headers giving file names", "-v, --verbose      always print headers giving file names", "    --help         display this help and exit"] };
    d6 = { name: "tail", async execute(t6, r8) {
      if (o2(t6)) return s(m5);
      let e5 = I2(t6, "tail");
      if (!e5.ok) return e5.error;
      let { lines: o9, bytes: p17, fromLine: f11 } = e5.options;
      return W3(r8, e5.options, "tail", (u10) => g7(u10, o9, p17, f11 ?? false));
    } };
    c4 = { name: "tail", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tail-S5ULNTJU.js
var tail_S5ULNTJU_exports = {};
__export(tail_S5ULNTJU_exports, {
  flagsForFuzzing: () => c4,
  tailCommand: () => d6
});
var init_tail_S5ULNTJU = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tail-S5ULNTJU.js"() {
    init_chunk_DCAAORBQ();
    init_chunk_HDQ56CKY();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-GXVXFKBA.js
function C4(a7) {
  let c14 = a7.length, n23 = 0, o9 = 0, e5 = false;
  for (let s9 = 0; s9 < c14; s9++) {
    let t6 = a7[s9];
    t6 === `
` ? (n23++, e5 && (o9++, e5 = false)) : t6 === " " || t6 === "	" || t6 === "\r" ? e5 && (o9++, e5 = false) : e5 = true;
  }
  return e5 && o9++, { lines: n23, words: o9, chars: c14 };
}
function w3(a7, c14, n23, o9, e5, s9) {
  let t6 = [];
  c14 && t6.push(String(a7.lines).padStart(s9)), n23 && t6.push(String(a7.words).padStart(s9)), o9 && t6.push(String(a7.chars).padStart(s9));
  let i10 = t6.join(" ");
  return e5 && (i10 += ` ${e5}`), i10;
}
var $6, H3, E4, I3;
var init_chunk_GXVXFKBA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-GXVXFKBA.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    $6 = { name: "wc", summary: "print newline, word, and byte counts for each file", usage: "wc [OPTION]... [FILE]...", options: ["-c, --bytes      print the byte counts", "-m, --chars      print the character counts", "-l, --lines      print the newline counts", "-w, --words      print the word counts", "    --help       display this help and exit"] };
    H3 = { lines: { short: "l", long: "lines", type: "boolean" }, words: { short: "w", long: "words", type: "boolean" }, bytes: { short: "c", long: "bytes", type: "boolean" }, chars: { short: "m", long: "chars", type: "boolean" } };
    E4 = { name: "wc", async execute(a7, c14) {
      if (o2(a7)) return s($6);
      let n23 = x3("wc", a7, H3);
      if (!n23.ok) return n23.error;
      let { lines: o9, words: e5 } = n23.result.flags, s9 = n23.result.flags.bytes || n23.result.flags.chars, t6 = n23.result.positional;
      !o9 && !e5 && !s9 && (o9 = e5 = s9 = true);
      let i10 = await y2(c14, t6, { cmdName: "wc", stopOnError: false });
      if (t6.length === 0) {
        let r8 = C4(i10.files[0].content);
        return { stdout: `${w3(r8, o9, e5, s9, "", 0)}
`, stderr: "", exitCode: 0 };
      }
      let h16 = [], p17 = 0, d16 = 0, u10 = 0;
      for (let { filename: r8, content: m24 } of i10.files) {
        let f11 = C4(m24);
        p17 += f11.lines, d16 += f11.words, u10 += f11.chars, h16.push({ filename: r8, stats: f11 });
      }
      let F20 = t6.length > 1 ? p17 : Math.max(...h16.map((r8) => r8.stats.lines)), M14 = t6.length > 1 ? d16 : Math.max(...h16.map((r8) => r8.stats.words)), L18 = t6.length > 1 ? u10 : Math.max(...h16.map((r8) => r8.stats.chars)), l8 = t6.length > 1 ? 3 : 0;
      o9 && (l8 = Math.max(l8, String(F20).length)), e5 && (l8 = Math.max(l8, String(M14).length)), s9 && (l8 = Math.max(l8, String(L18).length));
      let g18 = "";
      for (let { filename: r8, stats: m24 } of h16) g18 += `${w3(m24, o9, e5, s9, r8, l8)}
`;
      return t6.length > 1 && (g18 += `${w3({ lines: p17, words: d16, chars: u10 }, o9, e5, s9, "total", l8)}
`), { stdout: g18, stderr: i10.stderr, exitCode: i10.exitCode };
    } };
    I3 = { name: "wc", flags: [{ flag: "-l", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-m", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/wc-TQB3VNOX.js
var wc_TQB3VNOX_exports = {};
__export(wc_TQB3VNOX_exports, {
  flagsForFuzzing: () => I3,
  wcCommand: () => E4
});
var init_wc_TQB3VNOX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/wc-TQB3VNOX.js"() {
    init_chunk_GXVXFKBA();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OFJTSXN6.js
function m6(e5, a7) {
  let s9 = a7 ? "d" : "-", l8 = [e5 & 256 ? "r" : "-", e5 & 128 ? "w" : "-", e5 & 64 ? "x" : "-", e5 & 32 ? "r" : "-", e5 & 16 ? "w" : "-", e5 & 8 ? "x" : "-", e5 & 4 ? "r" : "-", e5 & 2 ? "w" : "-", e5 & 1 ? "x" : "-"];
  return s9 + l8.join("");
}
var S2, $7, O4, w4;
var init_chunk_OFJTSXN6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OFJTSXN6.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    S2 = { name: "stat", summary: "display file or file system status", usage: "stat [OPTION]... FILE...", options: ["-c FORMAT   use the specified FORMAT instead of the default", "    --help  display this help and exit"] };
    $7 = { format: { short: "c", type: "string" } };
    O4 = { name: "stat", async execute(e5, a7) {
      if (o2(e5)) return s(S2);
      let s9 = x3("stat", e5, $7);
      if (!s9.ok) return s9.error;
      let l8 = s9.result.flags.format ?? null, c14 = s9.result.positional;
      if (c14.length === 0) return { stdout: "", stderr: `stat: missing operand
`, exitCode: 1 };
      let o9 = "", p17 = "", f11 = false;
      for (let n23 of c14) {
        let h16 = a7.fs.resolvePath(a7.cwd, n23);
        try {
          let r8 = await a7.fs.stat(h16);
          if (l8) {
            let t6 = l8, i10 = r8.mode.toString(8), y18 = m6(r8.mode, r8.isDirectory);
            t6 = t6.replace(/%n/g, n23), t6 = t6.replace(/%N/g, `'${n23}'`), t6 = t6.replace(/%s/g, String(r8.size)), t6 = t6.replace(/%F/g, r8.isDirectory ? "directory" : "regular file"), t6 = t6.replace(/%a/g, i10), t6 = t6.replace(/%A/g, y18), t6 = t6.replace(/%u/g, "1000"), t6 = t6.replace(/%U/g, "user"), t6 = t6.replace(/%g/g, "1000"), t6 = t6.replace(/%G/g, "group"), o9 += `${t6}
`;
          } else {
            let t6 = r8.mode.toString(8).padStart(4, "0"), i10 = m6(r8.mode, r8.isDirectory);
            o9 += `  File: ${n23}
`, o9 += `  Size: ${r8.size}		Blocks: ${Math.ceil(r8.size / 512)}
`, o9 += `Access: (${t6}/${i10})
`, o9 += `Modify: ${r8.mtime.toISOString()}
`;
          }
        } catch {
          p17 += `stat: cannot stat '${n23}': No such file or directory
`, f11 = true;
        }
      }
      return { stdout: o9, stderr: p17, exitCode: f11 ? 1 : 0 };
    } };
    w4 = { name: "stat", flags: [{ flag: "-c", type: "value", valueHint: "format" }, { flag: "-L", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/stat-74KBZFAX.js
var stat_74KBZFAX_exports = {};
__export(stat_74KBZFAX_exports, {
  flagsForFuzzing: () => w4,
  statCommand: () => O4
});
var init_stat_74KBZFAX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/stat-74KBZFAX.js"() {
    init_chunk_OFJTSXN6();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IJXFPKNC.js
function h6(l8, c14, t6) {
  let s9 = typeof t6 == "boolean" ? { ignoreCase: t6 } : t6 ?? {}, e5 = c14;
  s9.stripQuotes && (e5.startsWith('"') && e5.endsWith('"') || e5.startsWith("'") && e5.endsWith("'")) && (e5 = e5.slice(1, -1));
  let i10 = s9.ignoreCase ? `i:${e5}` : e5, o9 = r5.get(i10);
  return o9 || (o9 = f5(e5, s9.ignoreCase), r5.set(i10, o9)), o9.test(l8);
}
function f5(l8, c14) {
  let t6 = "^";
  for (let s9 = 0; s9 < l8.length; s9++) {
    let e5 = l8[s9];
    if (e5 === "*") t6 += ".*";
    else if (e5 === "?") t6 += ".";
    else if (e5 === "[") {
      let i10 = s9 + 1;
      for (; i10 < l8.length && l8[i10] !== "]"; ) i10++;
      t6 += l8.slice(s9, i10 + 1), s9 = i10;
    } else e5 === "." || e5 === "+" || e5 === "^" || e5 === "$" || e5 === "{" || e5 === "}" || e5 === "(" || e5 === ")" || e5 === "|" || e5 === "\\" ? t6 += `\\${e5}` : t6 += e5;
  }
  return t6 += "$", b1(t6, c14 ? "i" : "");
}
var r5;
var init_chunk_IJXFPKNC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IJXFPKNC.js"() {
    init_chunk_YNYSPYQ5();
    r5 = /* @__PURE__ */ new Map();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VLGZJRPG.js
function B3(n23, t6) {
  return n23.replace(/\$(&|\d+|<([^>]+)>)/g, (e5, i10, s9) => {
    if (i10 === "&") return t6[0];
    if (s9 !== void 0) return t6.groups?.[s9] ?? "";
    let h16 = parseInt(i10, 10);
    return t6[h16] ?? "";
  });
}
function D4(n23, t6, e5 = {}) {
  let { invertMatch: i10 = false, showLineNumbers: s9 = false, countOnly: h16 = false, countMatches: d16 = false, filename: a7 = "", onlyMatching: m24 = false, beforeContext: I17 = 0, afterContext: R13 = 0, maxCount: S16 = 0, contextSeparator: F20 = "--", showColumn: O16 = false, vimgrep: G8 = false, showByteOffset: P19 = false, replace: k15 = null, passthru: y18 = false, multiline: j11 = false, kResetGroup: A13 } = e5;
  if (j11) return Q4(n23, t6, { invertMatch: i10, showLineNumbers: s9, countOnly: h16, countMatches: d16, filename: a7, onlyMatching: m24, beforeContext: I17, afterContext: R13, maxCount: S16, contextSeparator: F20, showColumn: O16, showByteOffset: P19, replace: k15, kResetGroup: A13 });
  let x22 = n23.split(`
`), Z12 = x22.length, v20 = Z12 > 0 && x22[Z12 - 1] === "" ? Z12 - 1 : Z12;
  if (h16 || d16) {
    let f11 = 0, r8 = (d16 || m24) && !i10;
    for (let l8 = 0; l8 < v20; l8++) if (t6.lastIndex = 0, r8) for (let u10 = t6.exec(x22[l8]); u10 !== null; u10 = t6.exec(x22[l8])) f11++, u10[0].length === 0 && t6.lastIndex++;
    else t6.test(x22[l8]) !== i10 && f11++;
    return { output: `${a7 ? `${a7}:${f11}` : String(f11)}
`, matched: f11 > 0, matchCount: f11 };
  }
  if (I17 === 0 && R13 === 0 && !y18) {
    let f11 = [], r8 = false, o9 = 0, l8 = 0;
    for (let u10 = 0; u10 < v20 && !(S16 > 0 && o9 >= S16); u10++) {
      let L18 = x22[u10];
      if (t6.lastIndex = 0, t6.test(L18) !== i10) if (r8 = true, o9++, m24) {
        t6.lastIndex = 0;
        for (let $17 = t6.exec(L18); $17 !== null; $17 = t6.exec(L18)) {
          let b25 = A13 !== void 0 ? $17[A13] ?? "" : $17[0], T10 = k15 !== null ? B3(k15, $17) : b25, z10 = a7 ? `${a7}:` : "";
          P19 && (z10 += `${l8 + $17.index}:`), s9 && (z10 += `${u10 + 1}:`), O16 && (z10 += `${$17.index + 1}:`), f11.push(z10 + T10), $17[0].length === 0 && t6.lastIndex++;
        }
      } else if (G8) {
        t6.lastIndex = 0;
        for (let $17 = t6.exec(L18); $17 !== null; $17 = t6.exec(L18)) {
          let b25 = a7 ? `${a7}:` : "";
          P19 && (b25 += `${l8 + $17.index}:`), s9 && (b25 += `${u10 + 1}:`), O16 && (b25 += `${$17.index + 1}:`), f11.push(b25 + L18), $17[0].length === 0 && t6.lastIndex++;
        }
      } else {
        t6.lastIndex = 0;
        let $17 = t6.exec(L18), b25 = $17 ? $17.index + 1 : 1, T10 = L18;
        k15 !== null && (t6.lastIndex = 0, T10 = t6.replace(L18, (...M14) => {
          if (M14[0].length === 0) return "";
          let U13 = M14, _14 = M14[M14.length - 1];
          return typeof _14 == "object" && _14 !== null ? (U13.groups = _14, U13.input = M14[M14.length - 2], U13.index = M14[M14.length - 3]) : (U13.input = M14[M14.length - 1], U13.index = M14[M14.length - 2]), B3(k15, U13);
        }));
        let z10 = a7 ? `${a7}:` : "";
        P19 && (z10 += `${l8 + ($17 ? $17.index : 0)}:`), s9 && (z10 += `${u10 + 1}:`), O16 && (z10 += `${b25}:`), f11.push(z10 + T10);
      }
      l8 += L18.length + 1;
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: r8, matchCount: o9 };
  }
  if (y18) {
    let f11 = [], r8 = false, o9 = 0;
    for (let l8 = 0; l8 < v20; l8++) {
      let u10 = x22[l8];
      t6.lastIndex = 0;
      let E12 = t6.test(u10) !== i10;
      E12 && (r8 = true, o9++);
      let $17 = E12 ? ":" : "-", b25 = a7 ? `${a7}${$17}` : "";
      s9 && (b25 += `${l8 + 1}${$17}`), f11.push(b25 + u10);
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: r8, matchCount: o9 };
  }
  let g18 = [], w19 = 0, p17 = /* @__PURE__ */ new Set(), C19 = -1, c14 = [];
  for (let f11 = 0; f11 < v20 && !(S16 > 0 && w19 >= S16); f11++) t6.lastIndex = 0, t6.test(x22[f11]) !== i10 && (c14.push(f11), w19++);
  for (let f11 of c14) {
    let r8 = Math.max(0, f11 - I17);
    C19 >= 0 && r8 > C19 + 1 && g18.push(F20);
    for (let l8 = r8; l8 < f11; l8++) if (!p17.has(l8)) {
      p17.add(l8), C19 = l8;
      let u10 = x22[l8];
      s9 && (u10 = `${l8 + 1}-${u10}`), a7 && (u10 = `${a7}-${u10}`), g18.push(u10);
    }
    if (!p17.has(f11)) {
      p17.add(f11), C19 = f11;
      let l8 = x22[f11];
      if (m24) {
        t6.lastIndex = 0;
        for (let u10 = t6.exec(l8); u10 !== null; u10 = t6.exec(l8)) {
          let L18 = A13 !== void 0 ? u10[A13] ?? "" : u10[0], E12 = k15 !== null ? k15 : L18, $17 = a7 ? `${a7}:` : "";
          s9 && ($17 += `${f11 + 1}:`), O16 && ($17 += `${u10.index + 1}:`), g18.push($17 + E12), u10[0].length === 0 && t6.lastIndex++;
        }
      } else {
        let u10 = l8;
        s9 && (u10 = `${f11 + 1}:${u10}`), a7 && (u10 = `${a7}:${u10}`), g18.push(u10);
      }
    }
    let o9 = Math.min(v20 - 1, f11 + R13);
    for (let l8 = f11 + 1; l8 <= o9; l8++) if (!p17.has(l8)) {
      p17.add(l8), C19 = l8;
      let u10 = x22[l8];
      s9 && (u10 = `${l8 + 1}-${u10}`), a7 && (u10 = `${a7}-${u10}`), g18.push(u10);
    }
  }
  return { output: g18.length > 0 ? `${g18.join(`
`)}
` : "", matched: w19 > 0, matchCount: w19 };
}
function Q4(n23, t6, e5) {
  let { invertMatch: i10, showLineNumbers: s9, countOnly: h16, countMatches: d16, filename: a7, onlyMatching: m24, beforeContext: I17, afterContext: R13, maxCount: S16, contextSeparator: F20, showColumn: O16, showByteOffset: G8, replace: P19, kResetGroup: k15 } = e5, y18 = n23.split(`
`), j11 = y18.length, A13 = j11 > 0 && y18[j11 - 1] === "" ? j11 - 1 : j11, x22 = [0];
  for (let c14 = 0; c14 < n23.length; c14++) n23[c14] === `
` && x22.push(c14 + 1);
  let Z12 = (c14) => {
    let f11 = 0;
    for (let r8 = 0; r8 < x22.length && !(x22[r8] > c14); r8++) f11 = r8;
    return f11;
  }, v20 = (c14) => {
    let f11 = Z12(c14);
    return c14 - x22[f11] + 1;
  }, g18 = [];
  t6.lastIndex = 0;
  for (let c14 = t6.exec(n23); c14 !== null && !(S16 > 0 && g18.length >= S16); c14 = t6.exec(n23)) {
    let f11 = Z12(c14.index), r8 = Z12(c14.index + Math.max(0, c14[0].length - 1)), o9 = k15 !== void 0 ? c14[k15] ?? "" : c14[0];
    g18.push({ startLine: f11, endLine: r8, byteOffset: c14.index, column: v20(c14.index), matchText: o9 }), c14[0].length === 0 && t6.lastIndex++;
  }
  if (h16 || d16) {
    let c14;
    if (d16) c14 = i10 ? 0 : g18.length;
    else {
      let r8 = /* @__PURE__ */ new Set();
      for (let o9 of g18) for (let l8 = o9.startLine; l8 <= o9.endLine; l8++) r8.add(l8);
      c14 = i10 ? A13 - r8.size : r8.size;
    }
    return { output: `${a7 ? `${a7}:${c14}` : String(c14)}
`, matched: c14 > 0, matchCount: c14 };
  }
  if (i10) {
    let c14 = /* @__PURE__ */ new Set();
    for (let r8 of g18) for (let o9 = r8.startLine; o9 <= r8.endLine; o9++) c14.add(o9);
    let f11 = [];
    for (let r8 = 0; r8 < A13; r8++) if (!c14.has(r8)) {
      let o9 = y18[r8];
      s9 && (o9 = `${r8 + 1}:${o9}`), a7 && (o9 = `${a7}:${o9}`), f11.push(o9);
    }
    return { output: f11.length > 0 ? `${f11.join(`
`)}
` : "", matched: f11.length > 0, matchCount: f11.length };
  }
  if (g18.length === 0) return { output: "", matched: false, matchCount: 0 };
  let w19 = /* @__PURE__ */ new Set(), p17 = -1, C19 = [];
  for (let c14 of g18) {
    let f11 = Math.max(0, c14.startLine - I17), r8 = Math.min(A13 - 1, c14.endLine + R13);
    p17 >= 0 && f11 > p17 + 1 && C19.push(F20);
    for (let o9 = f11; o9 < c14.startLine; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      s9 && (l8 = `${o9 + 1}-${l8}`), a7 && (l8 = `${a7}-${l8}`), C19.push(l8);
    }
    if (m24) {
      let o9 = P19 !== null ? P19 : c14.matchText, l8 = a7 ? `${a7}:` : "";
      G8 && (l8 += `${c14.byteOffset}:`), s9 && (l8 += `${c14.startLine + 1}:`), O16 && (l8 += `${c14.column}:`), C19.push(l8 + o9);
      for (let u10 = c14.startLine; u10 <= c14.endLine; u10++) w19.add(u10), p17 = u10;
    } else for (let o9 = c14.startLine; o9 <= c14.endLine && o9 < A13; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      P19 !== null && o9 === c14.startLine && (t6.lastIndex = 0, l8 = t6.replace(l8, P19));
      let u10 = a7 ? `${a7}:` : "";
      G8 && o9 === c14.startLine && (u10 += `${c14.byteOffset}:`), s9 && (u10 += `${o9 + 1}:`), O16 && o9 === c14.startLine && (u10 += `${c14.column}:`), C19.push(u10 + l8);
    }
    for (let o9 = c14.endLine + 1; o9 <= r8; o9++) if (!w19.has(o9)) {
      w19.add(o9), p17 = o9;
      let l8 = y18[o9];
      s9 && (l8 = `${o9 + 1}-${l8}`), a7 && (l8 = `${a7}-${l8}`), C19.push(l8);
    }
  }
  return { output: C19.length > 0 ? `${C19.join(`
`)}
` : "", matched: true, matchCount: g18.length };
}
function K3(n23) {
  let t6 = "", e5 = 0;
  for (; e5 < n23.length; ) {
    if (n23.slice(e5, e5 + 7) === "[[:<:]]") {
      t6 += "\\b", e5 += 7;
      continue;
    }
    if (n23.slice(e5, e5 + 7) === "[[:>:]]") {
      t6 += "\\b", e5 += 7;
      continue;
    }
    if (n23[e5] === "[") {
      let i10 = "[";
      for (e5++, e5 < n23.length && (n23[e5] === "^" || n23[e5] === "!") && (i10 += "^", e5++), e5 < n23.length && n23[e5] === "]" && (i10 += "\\]", e5++); e5 < n23.length && n23[e5] !== "]"; ) {
        if (n23[e5] === "[" && e5 + 1 < n23.length && n23[e5 + 1] === ":") {
          let s9 = n23.indexOf(":]", e5 + 2);
          if (s9 !== -1) {
            let h16 = n23.slice(e5 + 2, s9), d16 = q4.get(h16);
            if (d16) {
              i10 += d16, e5 = s9 + 2;
              continue;
            }
          }
        }
        if (n23[e5] === "\\" && e5 + 1 < n23.length) {
          i10 += n23[e5] + n23[e5 + 1], e5 += 2;
          continue;
        }
        i10 += n23[e5], e5++;
      }
      e5 < n23.length && n23[e5] === "]" && (i10 += "]", e5++), t6 += i10;
      continue;
    }
    if (n23[e5] === "\\" && e5 + 1 < n23.length) {
      t6 += n23[e5] + n23[e5 + 1], e5 += 2;
      continue;
    }
    t6 += n23[e5], e5++;
  }
  return t6;
}
function W4(n23, t6) {
  let e5, i10;
  switch (t6.mode) {
    case "fixed":
      e5 = n23.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      break;
    case "extended":
    case "perl": {
      if (e5 = K3(n23), e5 = e5.replace(/\(\?P<([^>]+)>/g, "(?<$1>"), t6.mode === "perl") {
        e5 = X3(e5), e5 = H4(e5), e5 = J2(e5);
        let d16 = ne2(e5);
        e5 = d16.pattern, i10 = d16.kResetGroup;
      }
      break;
    }
    default:
      e5 = K3(n23), e5 = se(e5);
      break;
  }
  t6.wholeWord && (e5 = `\\b(?:${e5})\\b`), t6.lineRegexp && (e5 = `^${e5}$`);
  let s9 = /\\u\{[0-9A-Fa-f]+\}/.test(e5), h16 = "g" + (t6.ignoreCase ? "i" : "") + (t6.multiline ? "m" : "") + (t6.multilineDotall ? "s" : "") + (s9 ? "u" : "");
  return { regex: b1(e5, h16), kResetGroup: i10 };
}
function X3(n23) {
  let t6 = "", e5 = 0;
  for (; e5 < n23.length; ) if (n23[e5] === "\\" && e5 + 1 < n23.length && n23[e5 + 1] === "Q") {
    e5 += 2;
    let i10 = "";
    for (; e5 < n23.length; ) {
      if (n23[e5] === "\\" && e5 + 1 < n23.length && n23[e5 + 1] === "E") {
        e5 += 2;
        break;
      }
      i10 += n23[e5], e5++;
    }
    t6 += i10.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  } else t6 += n23[e5], e5++;
  return t6;
}
function H4(n23) {
  return n23.replace(/\\x\{([0-9A-Fa-f]+)\}/g, "\\u{$1}");
}
function J2(n23) {
  let t6 = "", e5 = 0;
  for (; e5 < n23.length; ) {
    if (n23[e5] === "(" && e5 + 1 < n23.length && n23[e5 + 1] === "?") {
      let i10 = n23.slice(e5).match(/^\(\?([imsx]*)(-[imsx]*)?(:|$|\))/);
      if (i10) {
        let s9 = i10[1] || "", h16 = i10[2] || "", d16 = i10[3];
        if (d16 === ":") {
          let a7 = e5 + i10[0].length - 1, m24 = V4(n23, e5);
          if (m24 !== -1) {
            let I17 = n23.slice(a7 + 1, m24), R13 = Y3(I17, s9, h16);
            t6 += `(?:${R13})`, e5 = m24 + 1;
            continue;
          }
        } else if (d16 === ")" || d16 === "") {
          e5 += i10[0].length;
          continue;
        }
      }
    }
    t6 += n23[e5], e5++;
  }
  return t6;
}
function V4(n23, t6) {
  let e5 = 0, i10 = t6;
  for (; i10 < n23.length; ) {
    if (n23[i10] === "\\") {
      i10 += 2;
      continue;
    }
    if (n23[i10] === "[") {
      for (i10++; i10 < n23.length && n23[i10] !== "]"; ) n23[i10] === "\\" && i10++, i10++;
      i10++;
      continue;
    }
    if (n23[i10] === "(") e5++;
    else if (n23[i10] === ")" && (e5--, e5 === 0)) return i10;
    i10++;
  }
  return -1;
}
function Y3(n23, t6, e5) {
  let i10 = n23;
  return t6.includes("i") && (i10 = ee2(i10)), i10;
}
function ee2(n23) {
  let t6 = "", e5 = 0;
  for (; e5 < n23.length; ) {
    let i10 = n23[e5];
    if (i10 === "\\") {
      e5 + 1 < n23.length ? (t6 += i10 + n23[e5 + 1], e5 += 2) : (t6 += i10, e5++);
      continue;
    }
    if (i10 === "[") {
      t6 += i10, e5++, e5 < n23.length && n23[e5] === "^" && (t6 += n23[e5], e5++);
      let s9 = [];
      for (; e5 < n23.length && n23[e5] !== "]"; ) if (n23[e5] === "\\") s9.push(n23[e5]), e5++, e5 < n23.length && (s9.push(n23[e5]), e5++);
      else if (n23[e5] === "-" && s9.length > 0 && e5 + 1 < n23.length && n23[e5 + 1] !== "]") {
        let h16 = s9[s9.length - 1], d16 = n23[e5 + 1];
        s9.push("-"), s9.push(d16), /[a-z]/.test(h16) && /[a-z]/.test(d16) ? (s9.push(h16.toUpperCase()), s9.push("-"), s9.push(d16.toUpperCase())) : /[A-Z]/.test(h16) && /[A-Z]/.test(d16) && (s9.push(h16.toLowerCase()), s9.push("-"), s9.push(d16.toLowerCase())), e5 += 2;
      } else {
        let h16 = n23[e5];
        if (s9.push(h16), /[a-zA-Z]/.test(h16)) {
          let d16 = h16 === h16.toLowerCase() ? h16.toUpperCase() : h16.toLowerCase();
          s9.includes(d16) || s9.push(d16);
        }
        e5++;
      }
      t6 += s9.join(""), e5 < n23.length && (t6 += n23[e5], e5++);
      continue;
    }
    if (/[a-zA-Z]/.test(i10)) {
      let s9 = i10.toLowerCase(), h16 = i10.toUpperCase();
      t6 += `[${h16}${s9}]`;
    } else t6 += i10;
    e5++;
  }
  return t6;
}
function ne2(n23) {
  let t6 = te2(n23);
  if (t6 === -1) return { pattern: n23 };
  let e5 = n23.slice(0, t6), i10 = n23.slice(t6 + 2), s9 = ie(e5);
  return { pattern: `(?:${e5})(${i10})`, kResetGroup: s9 + 1 };
}
function te2(n23) {
  let t6 = 0;
  for (; t6 < n23.length - 1; ) if (n23[t6] === "\\") {
    if (n23[t6 + 1] === "K") {
      let e5 = 0, i10 = t6 - 1;
      for (; i10 >= 0 && n23[i10] === "\\"; ) e5++, i10--;
      if (e5 % 2 === 0) return t6;
    }
    t6 += 2;
  } else t6++;
  return -1;
}
function ie(n23) {
  let t6 = 0, e5 = 0;
  for (; e5 < n23.length; ) {
    if (n23[e5] === "\\") {
      e5 += 2;
      continue;
    }
    if (n23[e5] === "[") {
      for (e5++; e5 < n23.length && n23[e5] !== "]"; ) n23[e5] === "\\" && e5++, e5++;
      e5++;
      continue;
    }
    if (n23[e5] === "(") if (e5 + 1 < n23.length && n23[e5 + 1] === "?") {
      if (e5 + 2 < n23.length) {
        let i10 = n23[e5 + 2];
        if (i10 === ":" || i10 === "=" || i10 === "!") {
          e5++;
          continue;
        }
        if (i10 === "<" && e5 + 3 < n23.length) {
          let s9 = n23[e5 + 3];
          if (s9 === "=" || s9 === "!") {
            e5++;
            continue;
          }
          t6++, e5++;
          continue;
        }
      }
    } else t6++;
    e5++;
  }
  return t6;
}
function le(n23) {
  let t6 = n23.replace(/\$\{0\}|\$0(?![0-9])/g, "$$&");
  return t6 = t6.replace(/\$\{([^0-9}][^}]*)\}/g, "$$<$1>"), t6 = t6.replace(/\$([a-zA-Z_][a-zA-Z0-9_]*)(?![>0-9])/g, "$$<$1>"), t6;
}
function se(n23) {
  let t6 = "", e5 = 0, i10 = true, s9 = 0;
  for (; e5 < n23.length; ) {
    let h16 = n23[e5];
    if (h16 === "[") {
      for (t6 += h16, e5++, e5 < n23.length && (n23[e5] === "^" || n23[e5] === "!") && (t6 += n23[e5], e5++), e5 < n23.length && n23[e5] === "]" && (t6 += n23[e5], e5++); e5 < n23.length && n23[e5] !== "]"; ) n23[e5] === "\\" && e5 + 1 < n23.length ? (t6 += n23[e5] + n23[e5 + 1], e5 += 2) : (t6 += n23[e5], e5++);
      e5 < n23.length && n23[e5] === "]" && (t6 += n23[e5], e5++), i10 = false;
      continue;
    }
    if (h16 === "\\" && e5 + 1 < n23.length) {
      let d16 = n23[e5 + 1];
      if (d16 === "|") {
        t6 += "|", e5 += 2, i10 = true;
        continue;
      }
      if (d16 === "(") {
        t6 += "(", e5 += 2, s9++, i10 = true;
        continue;
      }
      if (d16 === ")") {
        t6 += ")", e5 += 2, s9 = Math.max(0, s9 - 1), i10 = false;
        continue;
      }
      if (d16 === "{") {
        let m24 = n23.slice(e5).match(/^\\{(\d+)(,(\d*)?)?\\}/);
        if (m24) {
          let I17 = m24[1], R13 = m24[2] !== void 0, S16 = m24[3] || "";
          R13 ? t6 += `{${I17},${S16}}` : t6 += `{${I17}}`, e5 += m24[0].length, i10 = false;
          continue;
        }
        t6 += "\\{", e5 += 2, i10 = false;
        continue;
      }
      if (d16 === "}") {
        t6 += "\\}", e5 += 2, i10 = false;
        continue;
      }
      t6 += h16 + d16, e5 += 2, i10 = false;
      continue;
    }
    if (h16 === "*" && i10) {
      t6 += "\\*", e5++;
      continue;
    }
    if (h16 === "^") {
      if (i10) {
        t6 += "^", e5++;
        continue;
      }
      t6 += "\\^", e5++;
      continue;
    }
    if (h16 === "$") {
      let d16 = e5 === n23.length - 1, a7 = e5 + 2 < n23.length && n23[e5 + 1] === "\\" && n23[e5 + 2] === ")";
      d16 || a7 ? t6 += "$" : t6 += "\\$", e5++, i10 = false;
      continue;
    }
    h16 === "+" || h16 === "?" || h16 === "|" || h16 === "(" || h16 === ")" || h16 === "{" || h16 === "}" ? t6 += `\\${h16}` : t6 += h16, e5++, i10 = false;
  }
  return t6;
}
var q4;
var init_chunk_VLGZJRPG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VLGZJRPG.js"() {
    init_chunk_YNYSPYQ5();
    q4 = /* @__PURE__ */ new Map([["alpha", "a-zA-Z"], ["digit", "0-9"], ["alnum", "a-zA-Z0-9"], ["lower", "a-z"], ["upper", "A-Z"], ["xdigit", "0-9A-Fa-f"], ["space", " \\t\\n\\r\\f\\v"], ["blank", " \\t"], ["punct", "!-/:-@\\[-`{-~"], ["graph", "!-~"], ["print", " -~"], ["cntrl", "\\x00-\\x1F\\x7F"], ["ascii", "\\x00-\\x7F"], ["word", "a-zA-Z0-9_"]]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-S6BBC45K.js
async function K4(t6, s9, o9, f11) {
  let c14 = o9.fs.resolvePath(o9.cwd, t6);
  try {
    if (!(await o9.fs.stat(c14)).isDirectory) {
      let l8 = t6.split("/").pop() || "";
      if (s9) {
        let n23 = s9.replace(/^\//, "");
        h6(l8, n23, { stripQuotes: true }) && f11.push(t6);
      }
      return;
    }
    let g18 = await o9.fs.readdir(c14);
    for (let l8 of g18) {
      let n23 = t6 === "." ? l8 : `${t6}/${l8}`, d16 = o9.fs.resolvePath(o9.cwd, n23);
      if ((await o9.fs.stat(d16)).isDirectory) await K4(n23, s9, o9, f11);
      else if (s9) {
        let u10 = s9.replace(/^\//, "");
        h6(l8, u10, { stripQuotes: true }) && f11.push(n23);
      }
    }
  } catch {
  }
}
async function se2(t6, s9) {
  let o9 = [], f11 = t6.lastIndexOf("/"), c14, h16;
  if (f11 === -1 ? (c14 = s9.cwd, h16 = t6) : (c14 = t6.slice(0, f11) || "/", h16 = t6.slice(f11 + 1)), t6.includes("**")) {
    let l8 = [], n23 = t6.split("**"), d16 = n23[0].replace(/\/$/, "") || ".", x22 = n23[1] || "";
    return await K4(d16, x22, s9, l8), l8.map((u10) => ({ path: u10 }));
  }
  let g18 = s9.fs.resolvePath(s9.cwd, c14);
  try {
    if (s9.fs.readdirWithFileTypes) {
      let l8 = await s9.fs.readdirWithFileTypes(g18);
      for (let n23 of l8) if (h6(n23.name, h16, { stripQuotes: true })) {
        let d16 = f11 === -1 ? n23.name : `${c14}/${n23.name}`;
        o9.push({ path: d16, isFile: n23.isFile });
      }
    } else {
      let l8 = await s9.fs.readdir(g18);
      for (let n23 of l8) if (h6(n23, h16, { stripQuotes: true })) {
        let d16 = f11 === -1 ? n23 : `${c14}/${n23}`;
        o9.push({ path: d16 });
      }
    }
  } catch {
  }
  return o9.sort((l8, n23) => l8.path.localeCompare(n23.path));
}
async function I4(t6, s9, o9 = [], f11 = [], c14 = [], h16) {
  let g18 = s9.fs.resolvePath(s9.cwd, t6), l8 = [];
  try {
    let n23, d16;
    if (h16 !== void 0) n23 = h16, d16 = !h16;
    else {
      let u10 = await s9.fs.stat(g18);
      n23 = u10.isFile, d16 = u10.isDirectory;
    }
    if (n23) {
      let u10 = t6.split("/").pop() || t6;
      return f11.length > 0 && f11.some((p17) => h6(u10, p17, { stripQuotes: true })) ? [] : o9.length > 0 && !o9.some((p17) => h6(u10, p17, { stripQuotes: true })) ? [] : [{ path: t6, isFile: true }];
    }
    if (!d16) return [];
    let x22 = t6.split("/").pop() || t6;
    if (c14.length > 0 && c14.some((u10) => h6(x22, u10, { stripQuotes: true }))) return [];
    if (s9.fs.readdirWithFileTypes) {
      let u10 = await s9.fs.readdirWithFileTypes(g18);
      for (let p17 of u10) {
        if (p17.name.startsWith(".")) continue;
        let b25 = t6 === "." ? p17.name : `${t6}/${p17.name}`, w19 = await I4(b25, s9, o9, f11, c14, p17.isFile);
        l8.push(...w19);
      }
    } else {
      let u10 = await s9.fs.readdir(g18);
      for (let p17 of u10) {
        if (p17.startsWith(".")) continue;
        let b25 = t6 === "." ? p17 : `${t6}/${p17}`, w19 = await I4(b25, s9, o9, f11, c14);
        l8.push(...w19);
      }
    }
  } catch {
  }
  return l8;
}
var te3, J3, oe, ae3, fe2, ue, ce;
var init_chunk_S6BBC45K = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-S6BBC45K.js"() {
    init_chunk_IJXFPKNC();
    init_chunk_VLGZJRPG();
    init_chunk_74CEPOFO();
    te3 = { name: "grep", summary: "print lines that match patterns", usage: "grep [OPTION]... PATTERN [FILE]...", options: ["-E, --extended-regexp    PATTERN is an extended regular expression", "-P, --perl-regexp        PATTERN is a Perl regular expression", "-F, --fixed-strings      PATTERN is a set of newline-separated strings", "-i, --ignore-case        ignore case distinctions", "-v, --invert-match       select non-matching lines", "-w, --word-regexp        match only whole words", "-x, --line-regexp        match only whole lines", "-c, --count              print only a count of matching lines", "-l, --files-with-matches print only names of files with matches", "-L, --files-without-match print names of files with no matches", "-m NUM, --max-count=NUM  stop after NUM matches", "-n, --line-number        print line number with output lines", "-h, --no-filename        suppress the file name prefix on output", "-o, --only-matching      show only nonempty parts of lines that match", "-q, --quiet, --silent    suppress all normal output", "-r, -R, --recursive      search directories recursively", "-A NUM                   print NUM lines of trailing context", "-B NUM                   print NUM lines of leading context", "-C NUM                   print NUM lines of context", "-e PATTERN               use PATTERN for matching", "    --include=GLOB       search only files matching GLOB", "    --exclude=GLOB       skip files matching GLOB", "    --exclude-dir=DIR    skip directories matching DIR", "    --help               display this help and exit"] };
    J3 = { name: "grep", async execute(t6, s9) {
      if (o2(t6)) return s(te3);
      let o9 = false, f11 = false, c14 = false, h16 = false, g18 = false, l8 = false, n23 = false, d16 = false, x22 = false, u10 = false, p17 = false, b25 = false, w19 = false, z10 = false, E12 = false, $17 = 0, P19 = 0, T10 = 0, M14 = [], W14 = [], H16 = [], C19 = null, B12 = [];
      for (let r8 = 0; r8 < t6.length; r8++) {
        let i10 = t6[r8];
        if (i10.startsWith("-") && i10 !== "-") {
          if (i10 === "-e" && r8 + 1 < t6.length) {
            C19 = t6[++r8];
            continue;
          }
          if (i10.startsWith("--include=")) {
            M14.push(i10.slice(10));
            continue;
          }
          if (i10.startsWith("--exclude=")) {
            W14.push(i10.slice(10));
            continue;
          }
          if (i10.startsWith("--exclude-dir=")) {
            H16.push(i10.slice(14));
            continue;
          }
          if (i10.startsWith("--max-count=")) {
            $17 = parseInt(i10.slice(12), 10);
            continue;
          }
          let F20 = i10.match(/^-m(\d+)$/);
          if (F20) {
            $17 = parseInt(F20[1], 10);
            continue;
          }
          if (i10 === "-m" && r8 + 1 < t6.length) {
            $17 = parseInt(t6[++r8], 10);
            continue;
          }
          let a7 = i10.match(/^-([ABC])(\d+)$/);
          if (a7) {
            let e5 = parseInt(a7[2], 10);
            a7[1] === "A" ? T10 = e5 : a7[1] === "B" ? P19 = e5 : a7[1] === "C" && (P19 = e5, T10 = e5);
            continue;
          }
          if ((i10 === "-A" || i10 === "-B" || i10 === "-C") && r8 + 1 < t6.length) {
            let e5 = parseInt(t6[++r8], 10);
            i10 === "-A" ? T10 = e5 : i10 === "-B" ? P19 = e5 : (P19 = e5, T10 = e5);
            continue;
          }
          let m24 = i10.startsWith("--") ? [i10] : i10.slice(1).split("");
          for (let e5 of m24) if (e5 === "i" || e5 === "--ignore-case") o9 = true;
          else if (e5 === "n" || e5 === "--line-number") f11 = true;
          else if (e5 === "v" || e5 === "--invert-match") c14 = true;
          else if (e5 === "c" || e5 === "--count") h16 = true;
          else if (e5 === "l" || e5 === "--files-with-matches") g18 = true;
          else if (e5 === "L" || e5 === "--files-without-match") l8 = true;
          else if (e5 === "r" || e5 === "R" || e5 === "--recursive") n23 = true;
          else if (e5 === "w" || e5 === "--word-regexp") d16 = true;
          else if (e5 === "x" || e5 === "--line-regexp") x22 = true;
          else if (e5 === "E" || e5 === "--extended-regexp") u10 = true;
          else if (e5 === "P" || e5 === "--perl-regexp") p17 = true;
          else if (e5 === "F" || e5 === "--fixed-strings") b25 = true;
          else if (e5 === "o" || e5 === "--only-matching") w19 = true;
          else if (e5 === "h" || e5 === "--no-filename") z10 = true;
          else if (e5 === "q" || e5 === "--quiet" || e5 === "--silent") E12 = true;
          else {
            if (e5.startsWith("--")) return r3("grep", e5);
            if (e5.length === 1) return r3("grep", `-${e5}`);
          }
        } else C19 === null ? C19 = i10 : B12.push(i10);
      }
      if (C19 === null) return { stdout: "", stderr: `grep: missing pattern
`, exitCode: 2 };
      let V13 = b25 ? "fixed" : u10 ? "extended" : p17 ? "perl" : "basic", L18, O16;
      try {
        let r8 = W4(C19, { mode: V13, ignoreCase: o9, wholeWord: d16, lineRegexp: x22 });
        L18 = r8.regex, O16 = r8.kResetGroup;
      } catch {
        return { stdout: "", stderr: `grep: invalid regular expression: ${C19}
`, exitCode: 2 };
      }
      if (B12.length === 0 && s9.stdin !== void 0) {
        let r8 = D4(s9.stdin, L18, { invertMatch: c14, showLineNumbers: f11, countOnly: h16, filename: "", onlyMatching: w19, beforeContext: P19, afterContext: T10, maxCount: $17, kResetGroup: O16 });
        return E12 ? { stdout: "", stderr: "", exitCode: r8.matched ? 0 : 1 } : { stdout: r8.output, stderr: "", exitCode: r8.matched ? 0 : 1 };
      }
      if (B12.length === 0) return { stdout: "", stderr: `grep: no input files
`, exitCode: 2 };
      let R13 = "", G8 = "", S16 = false, D15 = false, v20 = [];
      for (let r8 of B12) if (r8.includes("*") || r8.includes("?") || r8.includes("[")) {
        let i10 = await se2(r8, s9);
        if (n23) for (let F20 of i10) {
          let a7 = await I4(F20.path, s9, M14, W14, H16, F20.isFile);
          v20.push(...a7);
        }
        else v20.push(...i10);
      } else if (n23) {
        let i10 = await I4(r8, s9, M14, W14, H16);
        v20.push(...i10);
      } else v20.push({ path: r8 });
      let X10 = (v20.length > 1 || n23) && !z10, k15 = 50;
      for (let r8 = 0; r8 < v20.length; r8 += k15) {
        let i10 = v20.slice(r8, r8 + k15), F20 = await Promise.all(i10.map(async (a7) => {
          let m24 = a7.path, e5 = m24.split("/").pop() || m24;
          if (W14.length > 0 && !n23 && W14.some((N14) => h6(e5, N14, { stripQuotes: true })) || M14.length > 0 && !n23 && !M14.some((N14) => h6(e5, N14, { stripQuotes: true }))) return null;
          try {
            let N14 = s9.fs.resolvePath(s9.cwd, m24), Q13 = false;
            if (a7.isFile === void 0 ? Q13 = (await s9.fs.stat(N14)).isDirectory : Q13 = !a7.isFile, Q13) return n23 ? null : { error: `grep: ${m24}: Is a directory
` };
            let Y10 = await s9.fs.readFile(N14), ee7 = D4(Y10, L18, { invertMatch: c14, showLineNumbers: f11, countOnly: h16, filename: X10 ? m24 : "", onlyMatching: w19, beforeContext: P19, afterContext: T10, maxCount: $17, kResetGroup: O16 });
            return { file: m24, result: ee7 };
          } catch {
            return { error: `grep: ${m24}: No such file or directory
` };
          }
        }));
        for (let a7 of F20) {
          if (a7 === null) continue;
          if ("error" in a7 && a7.error) {
            G8 += a7.error, a7.error.includes("Is a directory") || (D15 = true);
            continue;
          }
          if (!("file" in a7) || !a7.result) continue;
          let { file: m24, result: e5 } = a7;
          if (e5.matched) {
            if (S16 = true, E12) return { stdout: "", stderr: "", exitCode: 0 };
            g18 ? R13 += `${m24}
` : l8 || (R13 += e5.output);
          } else l8 ? R13 += `${m24}
` : h16 && !g18 && (R13 += e5.output);
        }
      }
      let A13;
      return D15 ? A13 = 2 : l8 ? A13 = R13.length > 0 ? 0 : 1 : A13 = S16 ? 0 : 1, E12 ? { stdout: "", stderr: "", exitCode: A13 } : { stdout: R13, stderr: G8, exitCode: A13 };
    } };
    oe = { name: "fgrep", async execute(t6, s9) {
      return J3.execute(["-F", ...t6], s9);
    } };
    ae3 = { name: "egrep", async execute(t6, s9) {
      return J3.execute(["-E", ...t6], s9);
    } };
    fe2 = { name: "grep", flags: [{ flag: "-E", type: "boolean" }, { flag: "-F", type: "boolean" }, { flag: "-P", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-L", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-o", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-m", type: "value", valueHint: "number" }, { flag: "-A", type: "value", valueHint: "number" }, { flag: "-B", type: "value", valueHint: "number" }, { flag: "-C", type: "value", valueHint: "number" }, { flag: "-e", type: "value", valueHint: "pattern" }], stdinType: "text", needsArgs: true };
    ue = { name: "fgrep", flags: [], stdinType: "text", needsArgs: true };
    ce = { name: "egrep", flags: [], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/grep-BPEMMINR.js
var grep_BPEMMINR_exports = {};
__export(grep_BPEMMINR_exports, {
  egrepCommand: () => ae3,
  egrepFlagsForFuzzing: () => ce,
  fgrepCommand: () => oe,
  fgrepFlagsForFuzzing: () => ue,
  flagsForFuzzing: () => fe2,
  grepCommand: () => J3
});
var init_grep_BPEMMINR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/grep-BPEMMINR.js"() {
    init_chunk_S6BBC45K();
    init_chunk_IJXFPKNC();
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:zlib
var gunzipSync, gzipSync, constants;
var init_node_zlib = __esm({
  "stub-node:node:zlib"() {
    gunzipSync = () => {
    };
    gzipSync = () => {
    };
    constants = {};
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-QOENL5UZ.js
function U3() {
  let e5 = [];
  for (let [t6, n23] of Object.entries(G3).sort()) {
    let s9 = [];
    for (let r8 of n23.extensions) s9.push(`*${r8}`);
    for (let r8 of n23.globs) s9.push(r8);
    e5.push(`${t6}: ${s9.join(", ")}`);
  }
  return `${e5.join(`
`)}
`;
}
function q5() {
  return { ignoreCase: false, caseSensitive: false, smartCase: true, fixedStrings: false, wordRegexp: false, lineRegexp: false, invertMatch: false, multiline: false, multilineDotall: false, patterns: [], patternFiles: [], count: false, countMatches: false, files: false, filesWithMatches: false, filesWithoutMatch: false, stats: false, onlyMatching: false, maxCount: 0, lineNumber: true, noFilename: false, withFilename: false, nullSeparator: false, byteOffset: false, column: false, vimgrep: false, replace: null, afterContext: 0, beforeContext: 0, contextSeparator: "--", quiet: false, heading: false, passthru: false, includeZero: false, sort: "path", json: false, globs: [], iglobs: [], globCaseInsensitive: false, types: [], typesNot: [], typeAdd: [], typeClear: [], hidden: false, noIgnore: false, noIgnoreDot: false, noIgnoreVcs: false, ignoreFiles: [], maxDepth: 1 / 0, maxFilesize: 0, followSymlinks: false, searchZip: false, searchBinary: false, preprocessor: null, preprocessorGlobs: [] };
}
function Q5(e5) {
  let t6 = e5.match(/^(\d+)([KMG])?$/i);
  if (!t6) return 0;
  let n23 = parseInt(t6[1], 10);
  switch ((t6[2] || "").toUpperCase()) {
    case "K":
      return n23 * 1024;
    case "M":
      return n23 * 1024 * 1024;
    case "G":
      return n23 * 1024 * 1024 * 1024;
    default:
      return n23;
  }
}
function ee3(e5) {
  return /^\d+[KMG]?$/i.test(e5) ? null : { stdout: "", stderr: `rg: invalid --max-filesize value: ${e5}
`, exitCode: 1 };
}
function H5(e5) {
  return null;
}
function ne3(e5) {
  e5.hidden ? e5.searchBinary = true : e5.noIgnore ? e5.hidden = true : e5.noIgnore = true;
}
function re2(e5, t6, n23) {
  let s9 = e5[t6];
  for (let r8 of V5) {
    if (s9.startsWith(`--${r8.long}=`)) {
      let l8 = s9.slice(`--${r8.long}=`.length), i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6, error: i10 } : { newIndex: t6 };
    }
    if (r8.short && s9.startsWith(`-${r8.short}`) && s9.length > 2) {
      let l8 = s9.slice(2), i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6, error: i10 } : { newIndex: t6 };
    }
    if (r8.short && s9 === `-${r8.short}` || s9 === `--${r8.long}`) {
      if (t6 + 1 >= e5.length) return null;
      let l8 = e5[t6 + 1], i10 = O5(n23, r8, l8);
      return i10 ? { newIndex: t6 + 1, error: i10 } : { newIndex: t6 + 1 };
    }
  }
  return null;
}
function ie2(e5) {
  return V5.find((t6) => t6.short === e5);
}
function O5(e5, t6, n23) {
  if (t6.validate) {
    let r8 = t6.validate(n23);
    if (r8) return r8;
  }
  let s9 = t6.parse ? t6.parse(n23) : n23;
  t6.multi ? e5[t6.target].push(s9) : e5[t6.target] = s9;
}
function le2(e5, t6) {
  let n23 = e5[t6];
  if (n23 === "--sort" && t6 + 1 < e5.length) {
    let s9 = e5[t6 + 1];
    if (s9 === "path" || s9 === "none") return { value: s9, newIndex: t6 + 1 };
  }
  if (n23.startsWith("--sort=")) {
    let s9 = n23.slice(7);
    if (s9 === "path" || s9 === "none") return { value: s9, newIndex: t6 };
  }
  return null;
}
function oe2(e5, t6) {
  let n23 = e5[t6], s9 = n23.match(/^-([ABC])(\d+)$/);
  return s9 ? { flag: s9[1], value: parseInt(s9[2], 10), newIndex: t6 } : (n23 === "-A" || n23 === "-B" || n23 === "-C") && t6 + 1 < e5.length ? { flag: n23[1], value: parseInt(e5[t6 + 1], 10), newIndex: t6 + 1 } : null;
}
function ae4(e5) {
  let t6 = e5.match(/^-m(\d+)$/);
  return t6 ? parseInt(t6[1], 10) : null;
}
function Z4(e5) {
  let t6 = q5(), n23 = null, s9 = [], r8 = -1, l8 = -1, i10 = -1, o9 = false;
  for (let c14 = 0; c14 < e5.length; c14++) {
    let a7 = e5[c14];
    if (a7.startsWith("-") && a7 !== "-") {
      let u10 = oe2(e5, c14);
      if (u10) {
        let { flag: f11, value: x22, newIndex: b25 } = u10;
        f11 === "A" ? r8 = Math.max(r8, x22) : f11 === "B" ? l8 = Math.max(l8, x22) : i10 = x22, c14 = b25;
        continue;
      }
      let d16 = ae4(a7);
      if (d16 !== null) {
        t6.maxCount = d16;
        continue;
      }
      let p17 = re2(e5, c14, t6);
      if (p17) {
        if (p17.error) return { success: false, error: p17.error };
        c14 = p17.newIndex;
        continue;
      }
      let g18 = le2(e5, c14);
      if (g18) {
        t6.sort = g18.value, c14 = g18.newIndex;
        continue;
      }
      let w19 = a7.startsWith("--") ? [a7] : a7.slice(1).split(""), m24 = false;
      for (let f11 of w19) {
        if (se3.has(f11)) {
          t6.lineNumber = true, o9 = true;
          continue;
        }
        if (f11 === "u" || f11 === "--unrestricted") {
          ne3(t6);
          continue;
        }
        if (f11 === "P" || f11 === "--pcre2") return { success: false, error: { stdout: "", stderr: `rg: PCRE2 is not supported. Use standard regex syntax instead.
`, exitCode: 1 } };
        if (f11.length === 1) {
          let b25 = ie2(f11);
          if (b25) {
            if (c14 + 1 >= e5.length) return { success: false, error: r3("rg", `-${f11}`) };
            let h16 = O5(t6, b25, e5[c14 + 1]);
            if (h16) return { success: false, error: h16 };
            c14++, m24 = true;
            continue;
          }
        }
        let x22 = te4.get(f11);
        if (x22) {
          x22(t6);
          continue;
        }
        if (f11.startsWith("--")) return { success: false, error: r3("rg", f11) };
        if (f11.length === 1) return { success: false, error: r3("rg", `-${f11}`) };
      }
    } else n23 === null && t6.patterns.length === 0 && t6.patternFiles.length === 0 ? n23 = a7 : s9.push(a7);
  }
  return (r8 >= 0 || i10 >= 0) && (t6.afterContext = Math.max(r8 >= 0 ? r8 : 0, i10 >= 0 ? i10 : 0)), (l8 >= 0 || i10 >= 0) && (t6.beforeContext = Math.max(l8 >= 0 ? l8 : 0, i10 >= 0 ? i10 : 0)), n23 !== null && t6.patterns.push(n23), (t6.column || t6.vimgrep) && (o9 = true), { success: true, options: t6, paths: s9, explicitLineNumbers: o9 };
}
async function L4(e5, t6, n23 = false, s9 = false, r8 = []) {
  let l8 = new k4(e5, t6, n23, s9);
  await l8.load(t6);
  for (let i10 of r8) try {
    let o9 = e5.resolvePath(t6, i10), c14 = await e5.readFile(o9);
    l8.addPatternsFromContent(c14, t6);
  } catch {
  }
  return l8;
}
function fe3(e5) {
  return e5.length >= 2 && e5[0] === 31 && e5[1] === 139;
}
function ue2(e5) {
  let t6 = false;
  for (let n23 = 0; n23 < e5.length; n23++) {
    let s9 = e5[n23];
    s9 === "[" && !t6 ? t6 = true : s9 === "]" && t6 && (t6 = false);
  }
  return t6 ? `rg: glob '${e5}' has an unclosed character class` : null;
}
async function J4(e5) {
  let { ctx: t6, options: n23, paths: s9, explicitLineNumbers: r8 } = e5;
  for (let f11 of n23.globs) {
    let x22 = f11.startsWith("!") ? f11.slice(1) : f11, b25 = ue2(x22);
    if (b25) return { stdout: "", stderr: `${b25}
`, exitCode: 1 };
  }
  if (n23.files) {
    let f11 = [...n23.patterns, ...s9];
    return pe2(t6, f11, n23);
  }
  let l8 = [...n23.patterns];
  for (let f11 of n23.patternFiles) try {
    let x22;
    if (f11 === "-") x22 = t6.stdin;
    else {
      let h16 = t6.fs.resolvePath(t6.cwd, f11);
      x22 = await t6.fs.readFile(h16);
    }
    let b25 = x22.split(`
`).filter((h16) => h16.length > 0);
    l8.push(...b25);
  } catch {
    return { stdout: "", stderr: `rg: ${f11}: No such file or directory
`, exitCode: 2 };
  }
  if (l8.length === 0) return n23.patternFiles.length > 0 ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `rg: no pattern given
`, exitCode: 2 };
  let i10 = s9.length === 0 ? ["."] : s9, o9 = he2(n23, l8), c14, a7;
  try {
    let f11 = ge2(l8, n23, o9);
    c14 = f11.regex, a7 = f11.kResetGroup;
  } catch {
    return { stdout: "", stderr: `rg: invalid regex: ${l8.join(", ")}
`, exitCode: 2 };
  }
  let u10 = null;
  n23.noIgnore || (u10 = await L4(t6.fs, t6.cwd, n23.noIgnoreDot, n23.noIgnoreVcs, n23.ignoreFiles));
  let d16 = new M3();
  for (let f11 of n23.typeClear) d16.clearType(f11);
  for (let f11 of n23.typeAdd) d16.addType(f11);
  let { files: p17, singleExplicitFile: g18 } = await Y4(t6, i10, n23, u10, d16);
  if (p17.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
  let w19 = !n23.noFilename && (n23.withFilename || !g18 || p17.length > 1), m24 = n23.lineNumber;
  return r8 || (g18 && p17.length === 1 && (m24 = false), n23.onlyMatching && (m24 = false)), xe(t6, p17, c14, n23, w19, m24, a7);
}
function he2(e5, t6) {
  return e5.caseSensitive ? false : e5.ignoreCase ? true : e5.smartCase ? !t6.some((n23) => /[A-Z]/.test(n23)) : false;
}
function ge2(e5, t6, n23) {
  let s9;
  return e5.length === 1 ? s9 = e5[0] : s9 = e5.map((r8) => t6.fixedStrings ? r8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : `(?:${r8})`).join("|"), W4(s9, { mode: t6.fixedStrings && e5.length === 1 ? "fixed" : "perl", ignoreCase: n23, wholeWord: t6.wordRegexp, lineRegexp: t6.lineRegexp, multiline: t6.multiline, multilineDotall: t6.multilineDotall });
}
async function Y4(e5, t6, n23, s9, r8) {
  let l8 = [], i10 = 0, o9 = 0;
  for (let a7 of t6) {
    let u10 = e5.fs.resolvePath(e5.cwd, a7);
    try {
      let d16 = await e5.fs.stat(u10);
      if (d16.isFile) {
        if (i10++, n23.maxFilesize > 0 && d16.size > n23.maxFilesize) continue;
        X4(a7, n23, s9, u10, r8) && l8.push(a7);
      } else d16.isDirectory && (o9++, await K5(e5, a7, u10, 0, n23, s9, r8, l8));
    } catch {
    }
  }
  return { files: n23.sort === "path" ? l8.sort() : l8, singleExplicitFile: i10 === 1 && o9 === 0 };
}
async function K5(e5, t6, n23, s9, r8, l8, i10, o9) {
  if (!(s9 >= r8.maxDepth)) {
    l8 && await l8.loadForDirectory(n23);
    try {
      let c14 = e5.fs.readdirWithFileTypes ? await e5.fs.readdirWithFileTypes(n23) : (await e5.fs.readdir(n23)).map((a7) => ({ name: a7, isFile: void 0 }));
      for (let a7 of c14) {
        let u10 = a7.name;
        if (!r8.noIgnore && k4.isCommonIgnored(u10)) continue;
        let d16 = u10.startsWith("."), p17 = t6 === "." ? u10 : t6 === "./" ? `./${u10}` : t6.endsWith("/") ? `${t6}${u10}` : `${t6}/${u10}`, g18 = e5.fs.resolvePath(n23, u10), w19, m24, f11 = false;
        if (a7.isFile !== void 0 && "isDirectory" in a7) {
          let h16 = a7;
          if (f11 = h16.isSymbolicLink === true, f11 && !r8.followSymlinks) continue;
          if (f11 && r8.followSymlinks) try {
            let y18 = await e5.fs.stat(g18);
            w19 = y18.isFile, m24 = y18.isDirectory;
          } catch {
            continue;
          }
          else w19 = h16.isFile, m24 = h16.isDirectory;
        } else try {
          let h16 = e5.fs.lstat ? await e5.fs.lstat(g18) : await e5.fs.stat(g18);
          if (f11 = h16.isSymbolicLink === true, f11 && !r8.followSymlinks) continue;
          let y18 = f11 && r8.followSymlinks ? await e5.fs.stat(g18) : h16;
          w19 = y18.isFile, m24 = y18.isDirectory;
        } catch {
          continue;
        }
        if (!l8?.matches(g18, m24) && !(d16 && !r8.hidden && !l8?.isWhitelisted(g18, m24))) {
          if (m24) await K5(e5, p17, g18, s9 + 1, r8, l8, i10, o9);
          else if (w19) {
            if (r8.maxFilesize > 0) try {
              if ((await e5.fs.stat(g18)).size > r8.maxFilesize) continue;
            } catch {
              continue;
            }
            X4(p17, r8, l8, g18, i10) && o9.push(p17);
          }
        }
      }
    } catch {
    }
  }
}
function X4(e5, t6, n23, s9, r8) {
  let l8 = e5.split("/").pop() || e5;
  if (n23?.matches(s9, false) || t6.types.length > 0 && !r8.matchesType(l8, t6.types) || t6.typesNot.length > 0 && r8.matchesType(l8, t6.typesNot)) return false;
  if (t6.globs.length > 0) {
    let i10 = t6.globCaseInsensitive, o9 = t6.globs.filter((a7) => !a7.startsWith("!")), c14 = t6.globs.filter((a7) => a7.startsWith("!")).map((a7) => a7.slice(1));
    if (o9.length > 0) {
      let a7 = false;
      for (let u10 of o9) if (v5(l8, u10, i10) || v5(e5, u10, i10)) {
        a7 = true;
        break;
      }
      if (!a7) return false;
    }
    for (let a7 of c14) if (a7.startsWith("/")) {
      let u10 = a7.slice(1);
      if (v5(e5, u10, i10)) return false;
    } else if (v5(l8, a7, i10) || v5(e5, a7, i10)) return false;
  }
  if (t6.iglobs.length > 0) {
    let i10 = t6.iglobs.filter((c14) => !c14.startsWith("!")), o9 = t6.iglobs.filter((c14) => c14.startsWith("!")).map((c14) => c14.slice(1));
    if (i10.length > 0) {
      let c14 = false;
      for (let a7 of i10) if (v5(l8, a7, true) || v5(e5, a7, true)) {
        c14 = true;
        break;
      }
      if (!c14) return false;
    }
    for (let c14 of o9) if (c14.startsWith("/")) {
      let a7 = c14.slice(1);
      if (v5(e5, a7, true)) return false;
    } else if (v5(l8, c14, true) || v5(e5, c14, true)) return false;
  }
  return true;
}
function v5(e5, t6, n23 = false) {
  let s9 = "^";
  for (let r8 = 0; r8 < t6.length; r8++) {
    let l8 = t6[r8];
    if (l8 === "*") t6[r8 + 1] === "*" ? (s9 += ".*", r8++) : s9 += "[^/]*";
    else if (l8 === "?") s9 += "[^/]";
    else if (l8 === "[") {
      let i10 = r8 + 1;
      for (i10 < t6.length && t6[i10] === "!" && i10++, i10 < t6.length && t6[i10] === "]" && i10++; i10 < t6.length && t6[i10] !== "]"; ) i10++;
      if (i10 < t6.length) {
        let o9 = t6.slice(r8, i10 + 1);
        o9.startsWith("[!") && (o9 = `[^${o9.slice(2)}`), s9 += o9, r8 = i10;
      } else s9 += "\\[";
    } else s9 += l8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  return s9 += "$", b1(s9, n23 ? "i" : "").test(e5);
}
async function pe2(e5, t6, n23) {
  let s9 = null;
  n23.noIgnore || (s9 = await L4(e5.fs, e5.cwd, n23.noIgnoreDot, n23.noIgnoreVcs, n23.ignoreFiles));
  let r8 = new M3();
  for (let a7 of n23.typeClear) r8.clearType(a7);
  for (let a7 of n23.typeAdd) r8.addType(a7);
  let l8 = t6.length === 0 ? ["."] : t6, { files: i10 } = await Y4(e5, l8, n23, s9, r8);
  if (i10.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
  if (n23.quiet) return { stdout: "", stderr: "", exitCode: 0 };
  let o9 = n23.nullSeparator ? "\0" : `
`;
  return { stdout: i10.map((a7) => a7 + o9).join(""), stderr: "", exitCode: 0 };
}
function me(e5, t6) {
  if (t6.length === 0) return true;
  for (let n23 of t6) if (v5(e5, n23, false)) return true;
  return false;
}
async function de2(e5, t6, n23, s9) {
  try {
    if (s9.preprocessor && e5.exec) {
      let i10 = n23.split("/").pop() || n23;
      if (me(i10, s9.preprocessorGlobs)) {
        let o9 = await e5.exec(`${s9.preprocessor} "${t6}"`, { cwd: e5.cwd });
        if (o9.exitCode === 0 && o9.stdout) {
          let c14 = o9.stdout.slice(0, 8192);
          return { content: o9.stdout, isBinary: c14.includes("\0") };
        }
      }
    }
    if (s9.searchZip && n23.endsWith(".gz")) {
      let i10 = await e5.fs.readFileBuffer(t6);
      if (fe3(i10)) try {
        let o9 = gunzipSync(i10), c14 = new TextDecoder().decode(o9), a7 = c14.slice(0, 8192);
        return { content: c14, isBinary: a7.includes("\0") };
      } catch {
        return null;
      }
    }
    let r8 = await e5.fs.readFile(t6), l8 = r8.slice(0, 8192);
    return { content: r8, isBinary: l8.includes("\0") };
  } catch {
    return null;
  }
}
async function xe(e5, t6, n23, s9, r8, l8, i10) {
  let o9 = "", c14 = false, a7 = [], u10 = 0, d16 = 0, p17 = 0, g18 = 50;
  e: for (let f11 = 0; f11 < t6.length; f11 += g18) {
    let x22 = t6.slice(f11, f11 + g18), b25 = await Promise.all(x22.map(async (h16) => {
      let y18 = e5.fs.resolvePath(e5.cwd, h16), F20 = await de2(e5, y18, h16, s9);
      if (!F20) return null;
      let { content: C19, isBinary: N14 } = F20;
      if (p17 += C19.length, N14 && !s9.searchBinary) return null;
      let W14 = r8 && !s9.heading ? h16 : "", S16 = D4(C19, n23, { invertMatch: s9.invertMatch, showLineNumbers: l8, countOnly: s9.count, countMatches: s9.countMatches, filename: W14, onlyMatching: s9.onlyMatching, beforeContext: s9.beforeContext, afterContext: s9.afterContext, maxCount: s9.maxCount, contextSeparator: s9.contextSeparator, showColumn: s9.column, vimgrep: s9.vimgrep, showByteOffset: s9.byteOffset, replace: s9.replace !== null ? le(s9.replace) : null, passthru: s9.passthru, multiline: s9.multiline, kResetGroup: i10 });
      return s9.json && S16.matched ? { file: h16, result: S16, content: C19, isBinary: false } : { file: h16, result: S16 };
    }));
    for (let h16 of b25) {
      if (!h16) continue;
      let { file: y18, result: F20 } = h16;
      if (F20.matched) {
        if (c14 = true, d16++, u10 += F20.matchCount, s9.quiet && !s9.json) break e;
        if (s9.json && !s9.quiet) {
          let C19 = h16.content || "";
          a7.push(JSON.stringify({ type: "begin", data: { path: { text: y18 } } }));
          let N14 = C19.split(`
`);
          n23.lastIndex = 0;
          let W14 = 0;
          for (let S16 = 0; S16 < N14.length; S16++) {
            let j11 = N14[S16];
            n23.lastIndex = 0;
            let P19 = [];
            for (let I17 = n23.exec(j11); I17 !== null; I17 = n23.exec(j11)) {
              let R13 = { match: { text: I17[0] }, start: I17.index, end: I17.index + I17[0].length };
              s9.replace !== null && (R13.replacement = { text: s9.replace }), P19.push(R13), I17[0].length === 0 && n23.lastIndex++;
            }
            if (P19.length > 0) {
              let I17 = { type: "match", data: { path: { text: y18 }, lines: { text: `${j11}
` }, line_number: S16 + 1, absolute_offset: W14, submatches: P19 } };
              a7.push(JSON.stringify(I17));
            }
            W14 += j11.length + 1;
          }
          a7.push(JSON.stringify({ type: "end", data: { path: { text: y18 }, binary_offset: null, stats: { elapsed: { secs: 0, nanos: 0, human: "0s" }, searches: 1, searches_with_match: 1, bytes_searched: C19.length, bytes_printed: 0, matched_lines: F20.matchCount, matches: F20.matchCount } } }));
        } else if (s9.filesWithMatches) {
          let C19 = s9.nullSeparator ? "\0" : `
`;
          o9 += `${y18}${C19}`;
        } else s9.filesWithoutMatch || (s9.heading && !s9.noFilename && (o9 += `${y18}
`), o9 += F20.output);
      } else if (s9.filesWithoutMatch) {
        let C19 = s9.nullSeparator ? "\0" : `
`;
        o9 += `${y18}${C19}`;
      } else s9.includeZero && (s9.count || s9.countMatches) && (o9 += F20.output);
    }
  }
  s9.json && (a7.push(JSON.stringify({ type: "summary", data: { elapsed_total: { secs: 0, nanos: 0, human: "0s" }, stats: { elapsed: { secs: 0, nanos: 0, human: "0s" }, searches: t6.length, searches_with_match: d16, bytes_searched: p17, bytes_printed: 0, matched_lines: u10, matches: u10 } } })), o9 = `${a7.join(`
`)}
`);
  let w19 = s9.quiet && !s9.json ? "" : o9;
  if (s9.stats && !s9.json) {
    let f11 = ["", `${u10} matches`, `${u10} matched lines`, `${d16} files contained matches`, `${t6.length} files searched`, `${p17} bytes searched`].join(`
`);
    w19 += `${f11}
`;
  }
  let m24;
  return s9.filesWithoutMatch ? m24 = o9.length > 0 ? 0 : 1 : m24 = c14 ? 0 : 1, { stdout: w19, stderr: "", exitCode: m24 };
}
var G3, M3, V5, te4, se3, T, k4, ye2, Re2, Ae;
var init_chunk_QOENL5UZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-QOENL5UZ.js"() {
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_node_zlib();
    G3 = { js: { extensions: [".js", ".mjs", ".cjs", ".jsx"], globs: [] }, ts: { extensions: [".ts", ".tsx", ".mts", ".cts"], globs: [] }, html: { extensions: [".html", ".htm", ".xhtml"], globs: [] }, css: { extensions: [".css", ".scss", ".sass", ".less"], globs: [] }, json: { extensions: [".json", ".jsonc", ".json5"], globs: [] }, xml: { extensions: [".xml", ".xsl", ".xslt"], globs: [] }, c: { extensions: [".c", ".h"], globs: [] }, cpp: { extensions: [".cpp", ".cc", ".cxx", ".hpp", ".hh", ".hxx", ".h"], globs: [] }, rust: { extensions: [".rs"], globs: [] }, go: { extensions: [".go"], globs: [] }, zig: { extensions: [".zig"], globs: [] }, java: { extensions: [".java"], globs: [] }, kotlin: { extensions: [".kt", ".kts"], globs: [] }, scala: { extensions: [".scala", ".sc"], globs: [] }, clojure: { extensions: [".clj", ".cljc", ".cljs", ".edn"], globs: [] }, py: { extensions: [".py", ".pyi", ".pyw"], globs: [] }, rb: { extensions: [".rb", ".rake", ".gemspec"], globs: ["Rakefile", "Gemfile"] }, php: { extensions: [".php", ".phtml", ".php3", ".php4", ".php5"], globs: [] }, perl: { extensions: [".pl", ".pm", ".pod", ".t"], globs: [] }, lua: { extensions: [".lua"], globs: [] }, sh: { extensions: [".sh", ".bash", ".zsh", ".fish"], globs: [".bashrc", ".zshrc", ".profile"] }, bat: { extensions: [".bat", ".cmd"], globs: [] }, ps: { extensions: [".ps1", ".psm1", ".psd1"], globs: [] }, yaml: { extensions: [".yaml", ".yml"], globs: [] }, toml: { extensions: [".toml"], globs: ["Cargo.toml", "pyproject.toml"] }, ini: { extensions: [".ini", ".cfg", ".conf"], globs: [] }, csv: { extensions: [".csv", ".tsv"], globs: [] }, md: { extensions: [".md", ".mdx", ".markdown", ".mdown", ".mkd"], globs: [] }, markdown: { extensions: [".md", ".mdx", ".markdown", ".mdown", ".mkd"], globs: [] }, rst: { extensions: [".rst"], globs: [] }, txt: { extensions: [".txt", ".text"], globs: [] }, tex: { extensions: [".tex", ".ltx", ".sty", ".cls"], globs: [] }, sql: { extensions: [".sql"], globs: [] }, graphql: { extensions: [".graphql", ".gql"], globs: [] }, proto: { extensions: [".proto"], globs: [] }, make: { extensions: [".mk", ".mak"], globs: ["Makefile", "GNUmakefile", "makefile"] }, docker: { extensions: [], globs: ["Dockerfile", "Dockerfile.*", "*.dockerfile"] }, tf: { extensions: [".tf", ".tfvars"], globs: [] } };
    M3 = class {
      types;
      constructor() {
        this.types = new Map(Object.entries(G3).map(([t6, n23]) => [t6, { extensions: [...n23.extensions], globs: [...n23.globs] }]));
      }
      addType(t6) {
        let n23 = t6.indexOf(":");
        if (n23 === -1) return;
        let s9 = t6.slice(0, n23), r8 = t6.slice(n23 + 1);
        if (r8.startsWith("include:")) {
          let l8 = r8.slice(8), i10 = this.types.get(l8);
          if (i10) {
            let o9 = this.types.get(s9) || { extensions: [], globs: [] };
            o9.extensions.push(...i10.extensions), o9.globs.push(...i10.globs), this.types.set(s9, o9);
          }
        } else {
          let l8 = this.types.get(s9) || { extensions: [], globs: [] };
          if (r8.startsWith("*.") && !r8.slice(2).includes("*")) {
            let i10 = r8.slice(1);
            l8.extensions.includes(i10) || l8.extensions.push(i10);
          } else l8.globs.includes(r8) || l8.globs.push(r8);
          this.types.set(s9, l8);
        }
      }
      clearType(t6) {
        let n23 = this.types.get(t6);
        n23 && (n23.extensions = [], n23.globs = []);
      }
      getType(t6) {
        return this.types.get(t6);
      }
      getAllTypes() {
        return this.types;
      }
      matchesType(t6, n23) {
        let s9 = t6.toLowerCase();
        for (let r8 of n23) {
          if (r8 === "all") {
            if (this.matchesAnyType(t6)) return true;
            continue;
          }
          let l8 = this.types.get(r8);
          if (l8) {
            for (let i10 of l8.extensions) if (s9.endsWith(i10)) return true;
            for (let i10 of l8.globs) if (i10.includes("*")) {
              let o9 = i10.replace(/\./g, "\\.").replace(/\*/g, ".*");
              if (b1(`^${o9}$`, "i").test(t6)) return true;
            } else if (s9 === i10.toLowerCase()) return true;
          }
        }
        return false;
      }
      matchesAnyType(t6) {
        let n23 = t6.toLowerCase();
        for (let s9 of this.types.values()) {
          for (let r8 of s9.extensions) if (n23.endsWith(r8)) return true;
          for (let r8 of s9.globs) if (r8.includes("*")) {
            let l8 = r8.replace(/\./g, "\\.").replace(/\*/g, ".*");
            if (b1(`^${l8}$`, "i").test(t6)) return true;
          } else if (n23 === r8.toLowerCase()) return true;
        }
        return false;
      }
    };
    V5 = [{ short: "g", long: "glob", target: "globs", multi: true }, { long: "iglob", target: "iglobs", multi: true }, { short: "t", long: "type", target: "types", multi: true, validate: H5 }, { short: "T", long: "type-not", target: "typesNot", multi: true, validate: H5 }, { long: "type-add", target: "typeAdd", multi: true }, { long: "type-clear", target: "typeClear", multi: true }, { short: "m", long: "max-count", target: "maxCount", parse: parseInt }, { short: "e", long: "regexp", target: "patterns", multi: true }, { short: "f", long: "file", target: "patternFiles", multi: true }, { short: "r", long: "replace", target: "replace" }, { short: "d", long: "max-depth", target: "maxDepth", parse: parseInt }, { long: "max-filesize", target: "maxFilesize", parse: Q5, validate: ee3 }, { long: "context-separator", target: "contextSeparator" }, { short: "j", long: "threads", target: "maxDepth", parse: () => 1 / 0 }, { long: "ignore-file", target: "ignoreFiles", multi: true }, { long: "pre", target: "preprocessor" }, { long: "pre-glob", target: "preprocessorGlobs", multi: true }];
    te4 = /* @__PURE__ */ new Map([["i", (e5) => {
      e5.ignoreCase = true, e5.caseSensitive = false, e5.smartCase = false;
    }], ["--ignore-case", (e5) => {
      e5.ignoreCase = true, e5.caseSensitive = false, e5.smartCase = false;
    }], ["s", (e5) => {
      e5.caseSensitive = true, e5.ignoreCase = false, e5.smartCase = false;
    }], ["--case-sensitive", (e5) => {
      e5.caseSensitive = true, e5.ignoreCase = false, e5.smartCase = false;
    }], ["S", (e5) => {
      e5.smartCase = true, e5.ignoreCase = false, e5.caseSensitive = false;
    }], ["--smart-case", (e5) => {
      e5.smartCase = true, e5.ignoreCase = false, e5.caseSensitive = false;
    }], ["F", (e5) => {
      e5.fixedStrings = true;
    }], ["--fixed-strings", (e5) => {
      e5.fixedStrings = true;
    }], ["w", (e5) => {
      e5.wordRegexp = true;
    }], ["--word-regexp", (e5) => {
      e5.wordRegexp = true;
    }], ["x", (e5) => {
      e5.lineRegexp = true;
    }], ["--line-regexp", (e5) => {
      e5.lineRegexp = true;
    }], ["v", (e5) => {
      e5.invertMatch = true;
    }], ["--invert-match", (e5) => {
      e5.invertMatch = true;
    }], ["U", (e5) => {
      e5.multiline = true;
    }], ["--multiline", (e5) => {
      e5.multiline = true;
    }], ["--multiline-dotall", (e5) => {
      e5.multilineDotall = true, e5.multiline = true;
    }], ["c", (e5) => {
      e5.count = true;
    }], ["--count", (e5) => {
      e5.count = true;
    }], ["--count-matches", (e5) => {
      e5.countMatches = true;
    }], ["l", (e5) => {
      e5.filesWithMatches = true;
    }], ["--files", (e5) => {
      e5.files = true;
    }], ["--files-with-matches", (e5) => {
      e5.filesWithMatches = true;
    }], ["--files-without-match", (e5) => {
      e5.filesWithoutMatch = true;
    }], ["--stats", (e5) => {
      e5.stats = true;
    }], ["o", (e5) => {
      e5.onlyMatching = true;
    }], ["--only-matching", (e5) => {
      e5.onlyMatching = true;
    }], ["q", (e5) => {
      e5.quiet = true;
    }], ["--quiet", (e5) => {
      e5.quiet = true;
    }], ["N", (e5) => {
      e5.lineNumber = false;
    }], ["--no-line-number", (e5) => {
      e5.lineNumber = false;
    }], ["H", (e5) => {
      e5.withFilename = true;
    }], ["--with-filename", (e5) => {
      e5.withFilename = true;
    }], ["I", (e5) => {
      e5.noFilename = true;
    }], ["--no-filename", (e5) => {
      e5.noFilename = true;
    }], ["0", (e5) => {
      e5.nullSeparator = true;
    }], ["--null", (e5) => {
      e5.nullSeparator = true;
    }], ["b", (e5) => {
      e5.byteOffset = true;
    }], ["--byte-offset", (e5) => {
      e5.byteOffset = true;
    }], ["--column", (e5) => {
      e5.column = true, e5.lineNumber = true;
    }], ["--no-column", (e5) => {
      e5.column = false;
    }], ["--vimgrep", (e5) => {
      e5.vimgrep = true, e5.column = true, e5.lineNumber = true;
    }], ["--json", (e5) => {
      e5.json = true;
    }], ["--hidden", (e5) => {
      e5.hidden = true;
    }], ["--no-ignore", (e5) => {
      e5.noIgnore = true;
    }], ["--no-ignore-dot", (e5) => {
      e5.noIgnoreDot = true;
    }], ["--no-ignore-vcs", (e5) => {
      e5.noIgnoreVcs = true;
    }], ["L", (e5) => {
      e5.followSymlinks = true;
    }], ["--follow", (e5) => {
      e5.followSymlinks = true;
    }], ["z", (e5) => {
      e5.searchZip = true;
    }], ["--search-zip", (e5) => {
      e5.searchZip = true;
    }], ["a", (e5) => {
      e5.searchBinary = true;
    }], ["--text", (e5) => {
      e5.searchBinary = true;
    }], ["--heading", (e5) => {
      e5.heading = true;
    }], ["--passthru", (e5) => {
      e5.passthru = true;
    }], ["--include-zero", (e5) => {
      e5.includeZero = true;
    }], ["--glob-case-insensitive", (e5) => {
      e5.globCaseInsensitive = true;
    }]]);
    se3 = /* @__PURE__ */ new Set(["n", "--line-number"]);
    T = class {
      patterns = [];
      basePath;
      constructor(t6 = "/") {
        this.basePath = t6;
      }
      parse(t6) {
        let n23 = t6.split(`
`);
        for (let s9 of n23) {
          let r8 = s9.replace(/\s+$/, "");
          if (!r8 || r8.startsWith("#")) continue;
          let l8 = false;
          r8.startsWith("!") && (l8 = true, r8 = r8.slice(1));
          let i10 = false;
          r8.endsWith("/") && (i10 = true, r8 = r8.slice(0, -1));
          let o9 = false;
          r8.startsWith("/") ? (o9 = true, r8 = r8.slice(1)) : r8.includes("/") && !r8.startsWith("**/") && (o9 = true);
          let c14 = this.patternToRegex(r8, o9);
          this.patterns.push({ pattern: s9, regex: c14, negated: l8, directoryOnly: i10, rooted: o9 });
        }
      }
      patternToRegex(t6, n23) {
        let s9 = "";
        n23 ? s9 = "^" : s9 = "(?:^|/)";
        let r8 = 0;
        for (; r8 < t6.length; ) {
          let l8 = t6[r8];
          if (l8 === "*") t6[r8 + 1] === "*" ? t6[r8 + 2] === "/" ? (s9 += "(?:.*/)?", r8 += 3) : (r8 + 2 >= t6.length, s9 += ".*", r8 += 2) : (s9 += "[^/]*", r8++);
          else if (l8 === "?") s9 += "[^/]", r8++;
          else if (l8 === "[") {
            let i10 = r8 + 1;
            for (i10 < t6.length && t6[i10] === "!" && i10++, i10 < t6.length && t6[i10] === "]" && i10++; i10 < t6.length && t6[i10] !== "]"; ) i10++;
            if (i10 < t6.length) {
              let o9 = t6.slice(r8, i10 + 1);
              o9.startsWith("[!") && (o9 = `[^${o9.slice(2)}`), s9 += o9, r8 = i10 + 1;
            } else s9 += "\\[", r8++;
          } else l8 === "/" ? (s9 += "/", r8++) : (s9 += l8.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), r8++);
        }
        return s9 += "(?:/.*)?$", b1(s9);
      }
      matches(t6, n23) {
        let s9 = t6.replace(/^\.\//, "");
        s9 = s9.replace(/^\//, "");
        let r8 = false;
        for (let l8 of this.patterns) l8.directoryOnly && !n23 || l8.regex.test(s9) && (r8 = !l8.negated);
        return r8;
      }
      isWhitelisted(t6, n23) {
        let s9 = t6.replace(/^\.\//, "");
        s9 = s9.replace(/^\//, "");
        for (let r8 of this.patterns) if (!(r8.directoryOnly && !n23) && r8.negated && r8.regex.test(s9)) return true;
        return false;
      }
      getBasePath() {
        return this.basePath;
      }
    };
    k4 = class {
      parsers = [];
      fs;
      skipDotIgnore;
      skipVcsIgnore;
      loadedDirs = /* @__PURE__ */ new Set();
      constructor(t6, n23, s9 = false, r8 = false) {
        this.fs = t6, this.skipDotIgnore = s9, this.skipVcsIgnore = r8;
      }
      async load(t6) {
        let n23 = [], s9 = t6;
        for (; ; ) {
          n23.unshift(s9);
          let l8 = this.fs.resolvePath(s9, "..");
          if (l8 === s9) break;
          s9 = l8;
        }
        let r8 = [];
        this.skipVcsIgnore || r8.push(".gitignore"), this.skipDotIgnore || r8.push(".rgignore", ".ignore");
        for (let l8 of n23) {
          this.loadedDirs.add(l8);
          for (let i10 of r8) {
            let o9 = this.fs.resolvePath(l8, i10);
            try {
              let c14 = await this.fs.readFile(o9), a7 = new T(l8);
              a7.parse(c14), this.parsers.push(a7);
            } catch {
            }
          }
        }
      }
      async loadForDirectory(t6) {
        if (this.loadedDirs.has(t6)) return;
        this.loadedDirs.add(t6);
        let n23 = [];
        this.skipVcsIgnore || n23.push(".gitignore"), this.skipDotIgnore || n23.push(".rgignore", ".ignore");
        for (let s9 of n23) {
          let r8 = this.fs.resolvePath(t6, s9);
          try {
            let l8 = await this.fs.readFile(r8), i10 = new T(t6);
            i10.parse(l8), this.parsers.push(i10);
          } catch {
          }
        }
      }
      addPatternsFromContent(t6, n23) {
        let s9 = new T(n23);
        s9.parse(t6), this.parsers.push(s9);
      }
      matches(t6, n23) {
        for (let s9 of this.parsers) {
          let r8 = s9.getBasePath();
          if (!t6.startsWith(r8)) continue;
          let l8 = t6.slice(r8.length).replace(/^\//, "");
          if (s9.matches(l8, n23)) return true;
        }
        return false;
      }
      isWhitelisted(t6, n23) {
        for (let s9 of this.parsers) {
          let r8 = s9.getBasePath();
          if (!t6.startsWith(r8)) continue;
          let l8 = t6.slice(r8.length).replace(/^\//, "");
          if (s9.isWhitelisted(l8, n23)) return true;
        }
        return false;
      }
      static isCommonIgnored(t6) {
        return (/* @__PURE__ */ new Set(["node_modules", ".git", ".svn", ".hg", "__pycache__", ".pytest_cache", ".mypy_cache", "venv", ".venv", ".next", ".nuxt", ".cargo"])).has(t6);
      }
    };
    ye2 = { name: "rg", summary: "recursively search for a pattern", usage: "rg [OPTIONS] PATTERN [PATH ...]", description: `rg (ripgrep) recursively searches directories for a regex pattern.
Unlike grep, rg is recursive by default and respects .gitignore files.

EXAMPLES:
  rg foo                    Search for 'foo' in current directory
  rg foo src/               Search in src/ directory
  rg -i foo                 Case-insensitive search
  rg -w foo                 Match whole words only
  rg -t js foo              Search only JavaScript files
  rg -g '*.ts' foo          Search files matching glob
  rg --hidden foo           Include hidden files
  rg -l foo                 List files with matches only`, options: ["-e, --regexp PATTERN    search for PATTERN (can be used multiple times)", "-f, --file FILE         read patterns from FILE, one per line", "-i, --ignore-case       case-insensitive search", "-s, --case-sensitive    case-sensitive search (overrides smart-case)", "-S, --smart-case        smart case (default: case-insensitive unless pattern has uppercase)", "-F, --fixed-strings     treat pattern as literal string", "-w, --word-regexp       match whole words only", "-x, --line-regexp       match whole lines only", "-v, --invert-match      select non-matching lines", "-r, --replace TEXT      replace matches with TEXT", "-c, --count             print count of matching lines per file", "    --count-matches     print count of individual matches per file", "-l, --files-with-matches print only file names with matches", "    --files-without-match print file names without matches", "    --files             list files that would be searched", "-o, --only-matching     print only matching parts", "-m, --max-count NUM     stop after NUM matches per file", "-q, --quiet             suppress output, exit 0 on match", "    --stats             print search statistics", "-n, --line-number       print line numbers (default: on)", "-N, --no-line-number    do not print line numbers", "-I, --no-filename       suppress the prefixing of file names", "-0, --null              use NUL as filename separator", "-b, --byte-offset       show byte offset of each match", "    --column            show column number of first match", "    --vimgrep           show results in vimgrep format", "    --json              show results in JSON Lines format", "-A NUM                  print NUM lines after each match", "-B NUM                  print NUM lines before each match", "-C NUM                  print NUM lines before and after each match", "    --context-separator SEP  separator for context groups (default: --)", "-U, --multiline         match patterns across lines", "-z, --search-zip        search in compressed files (gzip only)", "-g, --glob GLOB         include files matching GLOB", "-t, --type TYPE         only search files of TYPE (e.g., js, py, ts)", "-T, --type-not TYPE     exclude files of TYPE", "-L, --follow            follow symbolic links", "-u, --unrestricted      reduce filtering (-u: no ignore, -uu: +hidden, -uuu: +binary)", "-a, --text              search binary files as text", "    --hidden            search hidden files and directories", "    --no-ignore         don't respect .gitignore/.ignore files", "-d, --max-depth NUM     maximum search depth", "    --sort TYPE         sort files (path, none)", "    --heading           show file path above matches", "    --passthru          print all lines (non-matches use - separator)", "    --include-zero      include files with 0 matches in count output", "    --type-list         list all available file types", "    --help              display this help and exit"] };
    Re2 = { name: "rg", async execute(e5, t6) {
      if (o2(e5)) return s(ye2);
      if (e5.includes("--type-list")) return { stdout: U3(), stderr: "", exitCode: 0 };
      let n23 = Z4(e5);
      return n23.success ? J4({ ctx: t6, options: n23.options, paths: n23.paths, explicitLineNumbers: n23.explicitLineNumbers }) : n23.error;
    } };
    Ae = { name: "rg", flags: [{ flag: "-i", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "-F", type: "boolean" }, { flag: "-w", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-o", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-N", type: "boolean" }, { flag: "--hidden", type: "boolean" }, { flag: "--no-ignore", type: "boolean" }, { flag: "-m", type: "value", valueHint: "number" }, { flag: "-A", type: "value", valueHint: "number" }, { flag: "-B", type: "value", valueHint: "number" }, { flag: "-C", type: "value", valueHint: "number" }, { flag: "-g", type: "value", valueHint: "pattern" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-T", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rg-ORQK4GVH.js
var rg_ORQK4GVH_exports = {};
__export(rg_ORQK4GVH_exports, {
  flagsForFuzzing: () => Ae,
  rgCommand: () => Re2
});
var init_rg_ORQK4GVH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rg-ORQK4GVH.js"() {
    init_chunk_QOENL5UZ();
    init_chunk_VLGZJRPG();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-MZLOTDD7.js
function P4(i10) {
  let e5 = "", t6 = 0, n23 = false;
  for (; t6 < i10.length; ) {
    if (i10[t6] === "[" && !n23) {
      if (i10[t6 + 1] === "[" && i10[t6 + 2] === ":") {
        let s9 = i10.indexOf(":]]", t6 + 3);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 3, s9), a7 = B4.get(r8);
          if (a7) {
            e5 += `[${a7}]`, t6 = s9 + 3;
            continue;
          }
        }
      }
      if (i10[t6 + 1] === "^" && i10[t6 + 2] === "[" && i10[t6 + 3] === ":") {
        let s9 = i10.indexOf(":]]", t6 + 4);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 4, s9), a7 = B4.get(r8);
          if (a7) {
            e5 += `[^${a7}]`, t6 = s9 + 3;
            continue;
          }
        }
      }
      e5 += "[", t6++, n23 = true, t6 < i10.length && i10[t6] === "^" && (e5 += "^", t6++), t6 < i10.length && i10[t6] === "]" && (e5 += "\\]", t6++);
      continue;
    }
    if (n23) {
      if (i10[t6] === "]") {
        e5 += "]", t6++, n23 = false;
        continue;
      }
      if (i10[t6] === "[" && i10[t6 + 1] === ":") {
        let s9 = i10.indexOf(":]", t6 + 2);
        if (s9 !== -1) {
          let r8 = i10.slice(t6 + 2, s9), a7 = B4.get(r8);
          if (a7) {
            e5 += a7, t6 = s9 + 2;
            continue;
          }
        }
      }
      if (i10[t6] === "\\" && t6 + 1 < i10.length) {
        e5 += i10[t6] + i10[t6 + 1], t6 += 2;
        continue;
      }
      e5 += i10[t6], t6++;
      continue;
    }
    if (i10[t6] === "\\" && t6 + 1 < i10.length) {
      let s9 = i10[t6 + 1];
      if (s9 === "+" || s9 === "?" || s9 === "|") {
        e5 += s9, t6 += 2;
        continue;
      }
      if (s9 === "(" || s9 === ")") {
        e5 += s9, t6 += 2;
        continue;
      }
      if (s9 === "{" || s9 === "}") {
        e5 += s9, t6 += 2;
        continue;
      }
      if (s9 === "t") {
        e5 += "	", t6 += 2;
        continue;
      }
      if (s9 === "n") {
        e5 += `
`, t6 += 2;
        continue;
      }
      if (s9 === "r") {
        e5 += "\r", t6 += 2;
        continue;
      }
      e5 += i10[t6] + s9, t6 += 2;
      continue;
    }
    if (i10[t6] === "+" || i10[t6] === "?" || i10[t6] === "|" || i10[t6] === "(" || i10[t6] === ")") {
      e5 += `\\${i10[t6]}`, t6++;
      continue;
    }
    if (i10[t6] === "^" && !(e5 === "" || e5.endsWith("("))) {
      e5 += "\\^", t6++;
      continue;
    }
    if (i10[t6] === "$") {
      let s9 = t6 === i10.length - 1, r8 = t6 + 2 < i10.length && i10[t6 + 1] === "\\" && i10[t6 + 2] === ")";
      if (!s9 && !r8) {
        e5 += "\\$", t6++;
        continue;
      }
    }
    e5 += i10[t6], t6++;
  }
  return e5;
}
function D5(i10) {
  let e5 = "", t6 = false;
  for (let n23 = 0; n23 < i10.length; n23++) i10[n23] === "[" && !t6 ? (t6 = true, e5 += "[", n23++, n23 < i10.length && i10[n23] === "^" && (e5 += "^", n23++), n23 < i10.length && i10[n23] === "]" && (e5 += "]", n23++), n23--) : i10[n23] === "]" && t6 ? (t6 = false, e5 += "]") : !t6 && i10[n23] === "{" && i10[n23 + 1] === "," ? (e5 += "{0,", n23++) : e5 += i10[n23];
  return e5;
}
function Z5(i10) {
  let e5 = "";
  for (let t6 = 0; t6 < i10.length; t6++) {
    let n23 = i10[t6], s9 = n23.charCodeAt(0);
    n23 === "\\" ? e5 += "\\\\" : n23 === "	" ? e5 += "\\t" : n23 === `
` ? e5 += `$
` : n23 === "\r" ? e5 += "\\r" : n23 === "\x07" ? e5 += "\\a" : n23 === "\b" ? e5 += "\\b" : n23 === "\f" ? e5 += "\\f" : n23 === "\v" ? e5 += "\\v" : s9 < 32 || s9 >= 127 ? e5 += `\\${s9.toString(8).padStart(3, "0")}` : e5 += n23;
  }
  return `${e5}$`;
}
function K6(i10, e5, t6) {
  return { patternSpace: "", holdSpace: "", lineNumber: 0, totalLines: i10, deleted: false, printed: false, quit: false, quitSilent: false, exitCode: void 0, errorMessage: void 0, appendBuffer: [], substitutionMade: false, lineNumberOutput: [], nCommandOutput: [], restartCycle: false, inDRestartedCycle: false, currentFilename: e5, pendingFileReads: [], pendingFileWrites: [], pendingExecute: void 0, rangeStates: t6 || /* @__PURE__ */ new Map(), linesConsumedInCycle: 0 };
}
function ce2(i10) {
  return typeof i10 == "object" && "first" in i10 && "step" in i10;
}
function le3(i10) {
  return typeof i10 == "object" && "offset" in i10;
}
function O6(i10, e5, t6, n23, s9) {
  if (i10 === "$") return e5 === t6;
  if (typeof i10 == "number") return e5 === i10;
  if (ce2(i10)) {
    let { first: r8, step: a7 } = i10;
    return a7 === 0 ? e5 === r8 : (e5 - r8) % a7 === 0 && e5 >= r8;
  }
  if (typeof i10 == "object" && "pattern" in i10) try {
    let r8 = i10.pattern;
    r8 === "" && s9?.lastPattern ? r8 = s9.lastPattern : r8 !== "" && s9 && (s9.lastPattern = r8);
    let a7 = D5(P4(r8));
    return b1(a7).test(n23);
  } catch {
    return false;
  }
  return false;
}
function W5(i10) {
  let e5 = (t6) => t6 === void 0 ? "undefined" : t6 === "$" ? "$" : typeof t6 == "number" ? String(t6) : "pattern" in t6 ? `/${t6.pattern}/` : "first" in t6 ? `${t6.first}~${t6.step}` : "unknown";
  return `${e5(i10.start)},${e5(i10.end)}`;
}
function oe3(i10, e5, t6, n23, s9, r8) {
  if (!i10 || !i10.start && !i10.end) return true;
  let a7 = i10.start, c14 = i10.end;
  if (a7 !== void 0 && c14 === void 0) return O6(a7, e5, t6, n23, r8);
  if (a7 !== void 0 && c14 !== void 0) {
    let o9 = typeof a7 == "object" && "pattern" in a7, d16 = typeof c14 == "object" && "pattern" in c14, p17 = le3(c14);
    if (p17 && s9) {
      let m24 = W5(i10), f11 = s9.get(m24);
      if (f11 || (f11 = { active: false }, s9.set(m24, f11)), f11.active) {
        let u10 = f11.startLine || e5;
        return e5 >= u10 + c14.offset && (f11.active = false, s9.set(m24, f11)), true;
      } else return O6(a7, e5, t6, n23, r8) ? (f11.active = true, f11.startLine = e5, s9.set(m24, f11), c14.offset === 0 && (f11.active = false, s9.set(m24, f11)), true) : false;
    }
    if (!o9 && !d16 && !p17) {
      let m24 = typeof a7 == "number" ? a7 : a7 === "$" ? t6 : 1, f11 = typeof c14 == "number" ? c14 : t6;
      if (m24 <= f11) return e5 >= m24 && e5 <= f11;
      if (s9) {
        let u10 = W5(i10), h16 = s9.get(u10);
        return h16 || (h16 = { active: false }, s9.set(u10, h16)), !h16.completed && e5 >= m24 ? (h16.completed = true, s9.set(u10, h16), true) : false;
      }
      return false;
    }
    if (s9) {
      let m24 = W5(i10), f11 = s9.get(m24);
      if (f11 || (f11 = { active: false }, s9.set(m24, f11)), f11.active) return O6(c14, e5, t6, n23, r8) && (f11.active = false, typeof a7 == "number" && (f11.completed = true), s9.set(m24, f11)), true;
      {
        if (f11.completed) return false;
        let u10 = false;
        return typeof a7 == "number" ? u10 = e5 >= a7 : u10 = O6(a7, e5, t6, n23, r8), u10 ? (f11.active = true, f11.startLine = e5, s9.set(m24, f11), O6(c14, e5, t6, n23, r8) && (f11.active = false, typeof a7 == "number" && (f11.completed = true), s9.set(m24, f11)), true) : false;
      }
    }
    return O6(a7, e5, t6, n23, r8);
  }
  return true;
}
function I5(i10, e5, t6, n23, s9, r8) {
  let a7 = oe3(i10, e5, t6, n23, s9, r8);
  return i10?.negated ? !a7 : a7;
}
function ue3(i10, e5, t6, n23) {
  let s9 = "", r8 = 0, a7 = false;
  for (; r8 <= i10.length; ) {
    e5.lastIndex = r8;
    let c14 = e5.exec(i10);
    if (!c14) {
      s9 += i10.slice(r8);
      break;
    }
    if (c14.index !== r8) {
      s9 += i10.slice(r8, c14.index), r8 = c14.index, a7 = false;
      continue;
    }
    let o9 = c14[0], d16 = c14.slice(1);
    if (a7 && o9.length === 0) {
      if (r8 < i10.length) s9 += i10[r8], r8++;
      else break;
      a7 = false;
      continue;
    }
    if (s9 += n23(o9, d16), a7 = false, o9.length === 0) if (r8 < i10.length) s9 += i10[r8], r8++;
    else break;
    else r8 += o9.length, a7 = true;
  }
  return s9;
}
function q6(i10, e5, t6) {
  let n23 = "", s9 = 0;
  for (; s9 < i10.length; ) {
    if (i10[s9] === "\\" && s9 + 1 < i10.length) {
      let r8 = i10[s9 + 1];
      if (r8 === "&") {
        n23 += "&", s9 += 2;
        continue;
      }
      if (r8 === "n") {
        n23 += `
`, s9 += 2;
        continue;
      }
      if (r8 === "t") {
        n23 += "	", s9 += 2;
        continue;
      }
      if (r8 === "r") {
        n23 += "\r", s9 += 2;
        continue;
      }
      let a7 = parseInt(r8, 10);
      if (a7 === 0) {
        n23 += e5, s9 += 2;
        continue;
      }
      if (a7 >= 1 && a7 <= 9) {
        n23 += t6[a7 - 1] || "", s9 += 2;
        continue;
      }
      n23 += r8, s9 += 2;
      continue;
    }
    if (i10[s9] === "&") {
      n23 += e5, s9++;
      continue;
    }
    n23 += i10[s9], s9++;
  }
  return n23;
}
function he3(i10, e5) {
  let { lineNumber: t6, totalLines: n23, patternSpace: s9 } = e5;
  if (i10.type === "label") {
    e5.coverage?.hit(`sed:cmd:${i10.type}`);
    return;
  }
  if (I5(i10.address, t6, n23, s9, e5.rangeStates, e5)) switch (e5.coverage?.hit(`sed:cmd:${i10.type}`), i10.type) {
    case "substitute": {
      let r8 = i10, a7 = "";
      r8.global && (a7 += "g"), r8.ignoreCase && (a7 += "i");
      let c14 = r8.pattern;
      c14 === "" && e5.lastPattern ? c14 = e5.lastPattern : c14 !== "" && (e5.lastPattern = c14);
      let o9 = D5(r8.extendedRegex ? c14 : P4(c14));
      try {
        let d16 = b1(o9, a7), p17 = d16.test(e5.patternSpace);
        if (d16.lastIndex = 0, p17) {
          if (e5.substitutionMade = true, r8.nthOccurrence && r8.nthOccurrence > 0 && !r8.global) {
            let E12 = 0, m24 = r8.nthOccurrence, f11 = b1(o9, `g${r8.ignoreCase ? "i" : ""}`);
            e5.patternSpace = f11.replace(e5.patternSpace, (u10, ...h16) => {
              if (E12++, E12 === m24) {
                let b25 = h16.slice(0, -2);
                return q6(r8.replacement, u10, b25);
              }
              return u10;
            });
          } else if (r8.global) {
            let E12 = b1(o9, `g${r8.ignoreCase ? "i" : ""}`);
            e5.patternSpace = ue3(e5.patternSpace, E12, r8.replacement, (m24, f11) => q6(r8.replacement, m24, f11));
          } else e5.patternSpace = d16.replace(e5.patternSpace, (E12, ...m24) => {
            let f11 = m24.slice(0, -2);
            return q6(r8.replacement, E12, f11);
          });
          r8.printOnMatch && e5.lineNumberOutput.push(e5.patternSpace);
        }
      } catch {
      }
      break;
    }
    case "print":
      e5.lineNumberOutput.push(e5.patternSpace);
      break;
    case "printFirstLine": {
      let r8 = e5.patternSpace.indexOf(`
`);
      r8 !== -1 ? e5.lineNumberOutput.push(e5.patternSpace.slice(0, r8)) : e5.lineNumberOutput.push(e5.patternSpace);
      break;
    }
    case "delete":
      e5.deleted = true;
      break;
    case "deleteFirstLine": {
      let r8 = e5.patternSpace.indexOf(`
`);
      r8 !== -1 ? (e5.patternSpace = e5.patternSpace.slice(r8 + 1), e5.restartCycle = true, e5.inDRestartedCycle = true) : e5.deleted = true;
      break;
    }
    case "zap":
      e5.patternSpace = "";
      break;
    case "append":
      e5.appendBuffer.push(i10.text);
      break;
    case "insert":
      e5.appendBuffer.unshift(`__INSERT__${i10.text}`);
      break;
    case "change":
      e5.deleted = true, e5.changedText = i10.text;
      break;
    case "hold":
      e5.holdSpace = e5.patternSpace;
      break;
    case "holdAppend":
      e5.holdSpace ? e5.holdSpace += `
${e5.patternSpace}` : e5.holdSpace = e5.patternSpace;
      break;
    case "get":
      e5.patternSpace = e5.holdSpace;
      break;
    case "getAppend":
      e5.patternSpace += `
${e5.holdSpace}`;
      break;
    case "exchange": {
      let r8 = e5.patternSpace;
      e5.patternSpace = e5.holdSpace, e5.holdSpace = r8;
      break;
    }
    case "next":
      e5.printed = true;
      break;
    case "quit":
      e5.quit = true, i10.exitCode !== void 0 && (e5.exitCode = i10.exitCode);
      break;
    case "quitSilent":
      e5.quit = true, e5.quitSilent = true, i10.exitCode !== void 0 && (e5.exitCode = i10.exitCode);
      break;
    case "list": {
      let r8 = Z5(e5.patternSpace);
      e5.lineNumberOutput.push(r8);
      break;
    }
    case "printFilename":
      e5.currentFilename && e5.lineNumberOutput.push(e5.currentFilename);
      break;
    case "version": {
      let r8 = [4, 8, 0];
      if (i10.minVersion) {
        let a7 = i10.minVersion.split("."), c14 = [], o9 = false;
        for (let d16 of a7) {
          let p17 = parseInt(d16, 10);
          if (Number.isNaN(p17) || p17 < 0) {
            e5.quit = true, e5.exitCode = 1, e5.errorMessage = `sed: invalid version string: ${i10.minVersion}`, o9 = true;
            break;
          }
          c14.push(p17);
        }
        if (!o9) {
          for (; c14.length < 3; ) c14.push(0);
          for (let d16 = 0; d16 < 3; d16++) {
            if (c14[d16] > r8[d16]) {
              e5.quit = true, e5.exitCode = 1, e5.errorMessage = `sed: this is not GNU sed version ${i10.minVersion}`;
              break;
            }
            if (c14[d16] < r8[d16]) break;
          }
        }
      }
      break;
    }
    case "readFile":
      e5.pendingFileReads.push({ filename: i10.filename, wholeFile: true });
      break;
    case "readFileLine":
      e5.pendingFileReads.push({ filename: i10.filename, wholeFile: false });
      break;
    case "writeFile":
      e5.pendingFileWrites.push({ filename: i10.filename, content: `${e5.patternSpace}
` });
      break;
    case "writeFirstLine": {
      let r8 = e5.patternSpace.indexOf(`
`), a7 = r8 !== -1 ? e5.patternSpace.slice(0, r8) : e5.patternSpace;
      e5.pendingFileWrites.push({ filename: i10.filename, content: `${a7}
` });
      break;
    }
    case "execute":
      i10.command ? e5.pendingExecute = { command: i10.command, replacePattern: false } : e5.pendingExecute = { command: e5.patternSpace, replacePattern: true };
      break;
    case "transliterate":
      e5.patternSpace = de3(e5.patternSpace, i10);
      break;
    case "lineNumber":
      e5.lineNumberOutput.push(String(e5.lineNumber));
      break;
    case "branch":
      break;
    case "branchOnSubst":
      break;
    case "branchOnNoSubst":
      break;
    case "group":
      break;
  }
}
function de3(i10, e5) {
  let t6 = "";
  for (let n23 of i10) {
    let s9 = e5.source.indexOf(n23);
    s9 !== -1 ? t6 += e5.dest[s9] : t6 += n23;
  }
  return t6;
}
function U4(i10, e5, t6, n23) {
  let s9 = /* @__PURE__ */ new Map();
  for (let o9 = 0; o9 < i10.length; o9++) {
    let d16 = i10[o9];
    d16.type === "label" && s9.set(d16.name, o9);
  }
  let r8 = n23?.maxIterations ?? ae5, a7 = 0, c14 = 0;
  for (; c14 < i10.length; ) {
    if (a7++, a7 > r8) throw new b2(`sed: command execution exceeded maximum iterations (${r8})`, "iterations");
    if (e5.deleted || e5.quit || e5.quitSilent || e5.restartCycle) break;
    let o9 = i10[c14];
    if (o9.type === "next") {
      if (I5(o9.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5)) if (e5.coverage?.hit("sed:cmd:next"), e5.nCommandOutput.push(e5.patternSpace), t6 && t6.currentLineIndex + e5.linesConsumedInCycle + 1 < t6.lines.length) {
        e5.linesConsumedInCycle++;
        let d16 = t6.lines[t6.currentLineIndex + e5.linesConsumedInCycle];
        e5.patternSpace = d16, e5.lineNumber = t6.currentLineIndex + e5.linesConsumedInCycle + 1, e5.substitutionMade = false;
      } else {
        e5.quit = true, e5.deleted = true;
        break;
      }
      c14++;
      continue;
    }
    if (o9.type === "nextAppend") {
      if (I5(o9.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5)) if (e5.coverage?.hit("sed:cmd:nextAppend"), t6 && t6.currentLineIndex + e5.linesConsumedInCycle + 1 < t6.lines.length) {
        e5.linesConsumedInCycle++;
        let d16 = t6.lines[t6.currentLineIndex + e5.linesConsumedInCycle];
        e5.patternSpace += `
${d16}`, e5.lineNumber = t6.currentLineIndex + e5.linesConsumedInCycle + 1;
      } else {
        e5.quit = true;
        break;
      }
      c14++;
      continue;
    }
    if (o9.type === "branch") {
      let d16 = o9;
      if (I5(d16.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5)) {
        if (e5.coverage?.hit("sed:cmd:branch"), d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c14 = p17;
            continue;
          }
          e5.branchRequest = d16.label;
          break;
        }
        break;
      }
      c14++;
      continue;
    }
    if (o9.type === "branchOnSubst") {
      let d16 = o9;
      if (I5(d16.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5) && (e5.coverage?.hit("sed:cmd:branchOnSubst"), e5.substitutionMade)) {
        if (e5.substitutionMade = false, d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c14 = p17;
            continue;
          }
          e5.branchRequest = d16.label;
          break;
        }
        break;
      }
      c14++;
      continue;
    }
    if (o9.type === "branchOnNoSubst") {
      let d16 = o9;
      if (I5(d16.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5) && (e5.coverage?.hit("sed:cmd:branchOnNoSubst"), !e5.substitutionMade)) {
        if (d16.label) {
          let p17 = s9.get(d16.label);
          if (p17 !== void 0) {
            c14 = p17;
            continue;
          }
          e5.branchRequest = d16.label;
          break;
        }
        break;
      }
      c14++;
      continue;
    }
    if (o9.type === "group") {
      let d16 = o9;
      if (I5(d16.address, e5.lineNumber, e5.totalLines, e5.patternSpace, e5.rangeStates, e5) && (e5.coverage?.hit("sed:cmd:group"), U4(d16.commands, e5, t6, n23), e5.branchRequest)) {
        let p17 = s9.get(e5.branchRequest);
        if (p17 !== void 0) {
          e5.branchRequest = void 0, c14 = p17;
          continue;
        }
        break;
      }
      c14++;
      continue;
    }
    he3(o9, e5), c14++;
  }
  return e5.linesConsumedInCycle;
}
function Q6(i10, e5 = false) {
  let t6 = false, n23 = false, s9 = [];
  for (let o9 = 0; o9 < i10.length; o9++) {
    let d16 = i10[o9];
    if (s9.length === 0 && o9 === 0) {
      let p17 = d16.match(/^#([nr]+)\s*(?:\n|$)/i);
      if (p17) {
        let E12 = p17[1].toLowerCase();
        E12.includes("n") && (t6 = true), E12.includes("r") && (n23 = true), d16 = d16.slice(p17[0].length);
      }
    }
    if (s9.length > 0 && s9[s9.length - 1].endsWith("\\")) {
      let p17 = s9[s9.length - 1];
      s9[s9.length - 1] = `${p17}
${d16}`;
    } else s9.push(d16);
  }
  let r8 = s9.join(`
`), c14 = new H6([r8], e5 || n23).parse();
  if (!c14.error && c14.commands.length > 0) {
    let o9 = fe4(c14.commands);
    if (o9) return { commands: [], error: o9, silentMode: t6, extendedRegexMode: n23 };
  }
  return { ...c14, silentMode: t6, extendedRegexMode: n23 };
}
function fe4(i10) {
  let e5 = /* @__PURE__ */ new Set();
  J5(i10, e5);
  let t6 = Y5(i10, e5);
  if (t6) return `undefined label '${t6}'`;
}
function J5(i10, e5) {
  for (let t6 of i10) t6.type === "label" ? e5.add(t6.name) : t6.type === "group" && J5(t6.commands, e5);
}
function Y5(i10, e5) {
  for (let t6 of i10) {
    if ((t6.type === "branch" || t6.type === "branchOnSubst" || t6.type === "branchOnNoSubst") && t6.label && !e5.has(t6.label)) return t6.label;
    if (t6.type === "group") {
      let n23 = Y5(t6.commands, e5);
      if (n23) return n23;
    }
  }
}
async function z4(i10, e5, t6, n23 = {}) {
  let { limits: s9, filename: r8, fs: a7, cwd: c14, coverage: o9 } = n23, d16 = i10.endsWith(`
`), p17 = i10.split(`
`);
  p17.length > 0 && p17[p17.length - 1] === "" && p17.pop();
  let E12 = p17.length, m24 = "", f11, u10 = false, h16 = s9?.maxStringLength ?? 0, b25 = (R13) => {
    if (m24 += R13, h16 > 0 && m24.length > h16) throw new b2(`sed: output size limit exceeded (${h16} bytes)`, "string_length");
  }, C19 = "", y18, ee7 = /* @__PURE__ */ new Map(), F20 = /* @__PURE__ */ new Map(), $17 = /* @__PURE__ */ new Map(), M14 = /* @__PURE__ */ new Map(), te9 = s9 ? { maxIterations: s9.maxSedIterations } : void 0;
  for (let R13 = 0; R13 < p17.length; R13++) {
    let g18 = { ...K6(E12, r8, ee7), patternSpace: p17[R13], holdSpace: C19, lastPattern: y18, lineNumber: R13 + 1, totalLines: E12, substitutionMade: false, coverage: o9 }, ne8 = { lines: p17, currentLineIndex: R13 }, V13 = 0, ie7 = 1e4;
    g18.linesConsumedInCycle = 0;
    do {
      if (V13++, V13 > ie7) break;
      if (g18.restartCycle = false, g18.pendingFileReads = [], g18.pendingFileWrites = [], U4(e5, g18, ne8, te9), a7 && c14) {
        for (let v20 of g18.pendingFileReads) {
          let k15 = a7.resolvePath(c14, v20.filename);
          try {
            if (v20.wholeFile) {
              let S16 = await a7.readFile(k15);
              g18.appendBuffer.push(S16.replace(/\n$/, ""));
            } else {
              if (!F20.has(k15)) {
                let re5 = await a7.readFile(k15);
                F20.set(k15, re5.split(`
`)), $17.set(k15, 0);
              }
              let S16 = F20.get(k15), A13 = $17.get(k15);
              S16 && A13 !== void 0 && A13 < S16.length && (g18.appendBuffer.push(S16[A13]), $17.set(k15, A13 + 1));
            }
          } catch {
          }
        }
        for (let v20 of g18.pendingFileWrites) {
          let k15 = a7.resolvePath(c14, v20.filename), S16 = M14.get(k15) || "";
          M14.set(k15, S16 + v20.content);
        }
      }
    } while (g18.restartCycle && !g18.deleted && !g18.quit && !g18.quitSilent);
    if (R13 += g18.linesConsumedInCycle, C19 = g18.holdSpace, y18 = g18.lastPattern, !t6) for (let v20 of g18.nCommandOutput) b25(`${v20}
`);
    let se7 = g18.lineNumberOutput.length > 0;
    for (let v20 of g18.lineNumberOutput) b25(`${v20}
`);
    let X10 = [], _14 = [];
    for (let v20 of g18.appendBuffer) v20.startsWith("__INSERT__") ? X10.push(v20.slice(10)) : _14.push(v20);
    for (let v20 of X10) b25(`${v20}
`);
    let L18 = false;
    !g18.deleted && !g18.quitSilent ? t6 ? g18.printed && (b25(`${g18.patternSpace}
`), L18 = true) : (b25(`${g18.patternSpace}
`), L18 = true) : g18.changedText !== void 0 && (b25(`${g18.changedText}
`), L18 = true);
    for (let v20 of _14) b25(`${v20}
`);
    if (u10 = (se7 || L18) && _14.length === 0, g18.quit || g18.quitSilent) {
      if (g18.exitCode !== void 0 && (f11 = g18.exitCode), g18.errorMessage) return { output: "", exitCode: f11 || 1, errorMessage: g18.errorMessage };
      break;
    }
  }
  if (a7 && c14) for (let [R13, g18] of M14) try {
    await a7.writeFile(R13, g18);
  } catch {
  }
  return !d16 && u10 && m24.endsWith(`
`) && (m24 = m24.slice(0, -1)), { output: m24, exitCode: f11 };
}
var B4, ae5, l3, w5, H6, pe3, Ne, Le;
var init_chunk_MZLOTDD7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-MZLOTDD7.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    B4 = /* @__PURE__ */ new Map([["alnum", "a-zA-Z0-9"], ["alpha", "a-zA-Z"], ["ascii", "\\x00-\\x7F"], ["blank", " \\t"], ["cntrl", "\\x00-\\x1F\\x7F"], ["digit", "0-9"], ["graph", "!-~"], ["lower", "a-z"], ["print", " -~"], ["punct", "!-/:-@\\[-`{-~"], ["space", " \\t\\n\\r\\f\\v"], ["upper", "A-Z"], ["word", "a-zA-Z0-9_"], ["xdigit", "0-9A-Fa-f"]]);
    ae5 = 1e4;
    (function(i10) {
      i10.NUMBER = "NUMBER", i10.DOLLAR = "DOLLAR", i10.PATTERN = "PATTERN", i10.STEP = "STEP", i10.RELATIVE_OFFSET = "RELATIVE_OFFSET", i10.LBRACE = "LBRACE", i10.RBRACE = "RBRACE", i10.SEMICOLON = "SEMICOLON", i10.NEWLINE = "NEWLINE", i10.COMMA = "COMMA", i10.NEGATION = "NEGATION", i10.COMMAND = "COMMAND", i10.SUBSTITUTE = "SUBSTITUTE", i10.TRANSLITERATE = "TRANSLITERATE", i10.LABEL_DEF = "LABEL_DEF", i10.BRANCH = "BRANCH", i10.BRANCH_ON_SUBST = "BRANCH_ON_SUBST", i10.BRANCH_ON_NO_SUBST = "BRANCH_ON_NO_SUBST", i10.TEXT_CMD = "TEXT_CMD", i10.FILE_READ = "FILE_READ", i10.FILE_READ_LINE = "FILE_READ_LINE", i10.FILE_WRITE = "FILE_WRITE", i10.FILE_WRITE_LINE = "FILE_WRITE_LINE", i10.EXECUTE = "EXECUTE", i10.VERSION = "VERSION", i10.EOF = "EOF", i10.ERROR = "ERROR";
    })(l3 || (l3 = {}));
    w5 = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      constructor(e5) {
        this.input = e5;
      }
      tokenize() {
        let e5 = [];
        for (; this.pos < this.input.length; ) {
          let t6 = this.nextToken();
          t6 && e5.push(t6);
        }
        return e5.push(this.makeToken(l3.EOF, "")), e5;
      }
      makeToken(e5, t6, n23) {
        return { type: e5, value: t6, line: this.line, column: this.column, ...n23 };
      }
      peek(e5 = 0) {
        return this.input[this.pos + e5] || "";
      }
      advance() {
        let e5 = this.input[this.pos++] || "";
        return e5 === `
` ? (this.line++, this.column = 1) : this.column++, e5;
      }
      readEscapedString(e5) {
        let t6 = "";
        for (; this.pos < this.input.length && this.peek() !== e5; ) if (this.peek() === "\\") {
          this.advance();
          let n23 = this.advance();
          n23 === "n" ? t6 += `
` : n23 === "t" ? t6 += "	" : t6 += n23;
        } else {
          if (this.peek() === `
`) return null;
          t6 += this.advance();
        }
        return t6;
      }
      skipWhitespace() {
        for (; this.pos < this.input.length; ) {
          let e5 = this.peek();
          if (e5 === " " || e5 === "	" || e5 === "\r") this.advance();
          else if (e5 === "#") for (; this.pos < this.input.length && this.peek() !== `
`; ) this.advance();
          else break;
        }
      }
      nextToken() {
        if (this.skipWhitespace(), this.pos >= this.input.length) return null;
        let e5 = this.line, t6 = this.column, n23 = this.peek();
        return n23 === `
` ? (this.advance(), { type: l3.NEWLINE, value: `
`, line: e5, column: t6 }) : n23 === ";" ? (this.advance(), { type: l3.SEMICOLON, value: ";", line: e5, column: t6 }) : n23 === "{" ? (this.advance(), { type: l3.LBRACE, value: "{", line: e5, column: t6 }) : n23 === "}" ? (this.advance(), { type: l3.RBRACE, value: "}", line: e5, column: t6 }) : n23 === "," ? (this.advance(), { type: l3.COMMA, value: ",", line: e5, column: t6 }) : n23 === "!" ? (this.advance(), { type: l3.NEGATION, value: "!", line: e5, column: t6 }) : n23 === "$" ? (this.advance(), { type: l3.DOLLAR, value: "$", line: e5, column: t6 }) : this.isDigit(n23) ? this.readNumber() : n23 === "+" && this.isDigit(this.input[this.pos + 1] || "") ? this.readRelativeOffset() : n23 === "/" ? this.readPattern() : n23 === ":" ? this.readLabelDef() : this.readCommand();
      }
      readNumber() {
        let e5 = this.line, t6 = this.column, n23 = "";
        for (; this.isDigit(this.peek()); ) n23 += this.advance();
        if (this.peek() === "~") {
          this.advance();
          let s9 = "";
          for (; this.isDigit(this.peek()); ) s9 += this.advance();
          let r8 = parseInt(n23, 10), a7 = parseInt(s9, 10) || 0;
          return { type: l3.STEP, value: `${r8}~${a7}`, first: r8, step: a7, line: e5, column: t6 };
        }
        return { type: l3.NUMBER, value: parseInt(n23, 10), line: e5, column: t6 };
      }
      readRelativeOffset() {
        let e5 = this.line, t6 = this.column;
        this.advance();
        let n23 = "";
        for (; this.isDigit(this.peek()); ) n23 += this.advance();
        let s9 = parseInt(n23, 10) || 0;
        return { type: l3.RELATIVE_OFFSET, value: `+${s9}`, offset: s9, line: e5, column: t6 };
      }
      readPattern() {
        let e5 = this.line, t6 = this.column;
        this.advance();
        let n23 = "", s9 = false;
        for (; this.pos < this.input.length; ) {
          let r8 = this.peek();
          if (r8 === "/" && !s9) break;
          if (r8 === "\\") n23 += this.advance(), this.pos < this.input.length && this.peek() !== `
` && (n23 += this.advance());
          else {
            if (r8 === `
`) break;
            r8 === "[" && !s9 ? (s9 = true, n23 += this.advance(), this.peek() === "^" && (n23 += this.advance()), this.peek() === "]" && (n23 += this.advance())) : r8 === "]" && s9 ? (s9 = false, n23 += this.advance()) : n23 += this.advance();
          }
        }
        return this.peek() === "/" && this.advance(), { type: l3.PATTERN, value: n23, pattern: n23, line: e5, column: t6 };
      }
      readLabelDef() {
        let e5 = this.line, t6 = this.column;
        for (this.advance(); this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === " " || s9 === "	" || s9 === `
` || s9 === ";" || s9 === "}" || s9 === "{") break;
          n23 += this.advance();
        }
        return { type: l3.LABEL_DEF, value: n23, label: n23, line: e5, column: t6 };
      }
      readCommand() {
        let e5 = this.line, t6 = this.column, n23 = this.advance();
        switch (n23) {
          case "s":
            return this.readSubstitute(e5, t6);
          case "y":
            return this.readTransliterate(e5, t6);
          case "a":
          case "i":
          case "c":
            return this.readTextCommand(n23, e5, t6);
          case "b":
            return this.readBranch(l3.BRANCH, "b", e5, t6);
          case "t":
            return this.readBranch(l3.BRANCH_ON_SUBST, "t", e5, t6);
          case "T":
            return this.readBranch(l3.BRANCH_ON_NO_SUBST, "T", e5, t6);
          case "r":
            return this.readFileCommand(l3.FILE_READ, "r", e5, t6);
          case "R":
            return this.readFileCommand(l3.FILE_READ_LINE, "R", e5, t6);
          case "w":
            return this.readFileCommand(l3.FILE_WRITE, "w", e5, t6);
          case "W":
            return this.readFileCommand(l3.FILE_WRITE_LINE, "W", e5, t6);
          case "e":
            return this.readExecute(e5, t6);
          case "p":
          case "P":
          case "d":
          case "D":
          case "h":
          case "H":
          case "g":
          case "G":
          case "x":
          case "n":
          case "N":
          case "q":
          case "Q":
          case "z":
          case "=":
          case "l":
          case "F":
            return { type: l3.COMMAND, value: n23, line: e5, column: t6 };
          case "v":
            return this.readVersion(e5, t6);
          default:
            return { type: l3.ERROR, value: n23, line: e5, column: t6 };
        }
      }
      readSubstitute(e5, t6) {
        let n23 = this.advance();
        if (!n23 || n23 === `
`) return { type: l3.ERROR, value: "s", line: e5, column: t6 };
        let s9 = "", r8 = false;
        for (; this.pos < this.input.length; ) {
          let o9 = this.peek();
          if (o9 === n23 && !r8) break;
          if (o9 === "\\") this.advance(), this.pos < this.input.length && this.peek() !== `
` ? this.peek() === n23 && !r8 ? s9 += this.advance() : (s9 += "\\", s9 += this.advance()) : s9 += "\\";
          else {
            if (o9 === `
`) break;
            o9 === "[" && !r8 ? (r8 = true, s9 += this.advance(), this.peek() === "^" && (s9 += this.advance()), this.peek() === "]" && (s9 += this.advance())) : o9 === "]" && r8 ? (r8 = false, s9 += this.advance()) : s9 += this.advance();
          }
        }
        if (this.peek() !== n23) return { type: l3.ERROR, value: "unterminated substitution pattern", line: e5, column: t6 };
        this.advance();
        let a7 = "";
        for (; this.pos < this.input.length && this.peek() !== n23; ) if (this.peek() === "\\") if (this.advance(), this.pos < this.input.length) {
          let o9 = this.peek();
          o9 === "\\" ? (this.advance(), this.pos < this.input.length && this.peek() === `
` ? (a7 += `
`, this.advance()) : a7 += "\\") : o9 === `
` ? (a7 += `
`, this.advance()) : a7 += `\\${this.advance()}`;
        } else a7 += "\\";
        else {
          if (this.peek() === `
`) break;
          a7 += this.advance();
        }
        this.peek() === n23 && this.advance();
        let c14 = "";
        for (; this.pos < this.input.length; ) {
          let o9 = this.peek();
          if (o9 === "g" || o9 === "i" || o9 === "p" || o9 === "I" || this.isDigit(o9)) c14 += this.advance();
          else break;
        }
        return { type: l3.SUBSTITUTE, value: `s${n23}${s9}${n23}${a7}${n23}${c14}`, pattern: s9, replacement: a7, flags: c14, line: e5, column: t6 };
      }
      readTransliterate(e5, t6) {
        let n23 = this.advance();
        if (!n23 || n23 === `
`) return { type: l3.ERROR, value: "y", line: e5, column: t6 };
        let s9 = this.readEscapedString(n23);
        if (s9 === null || this.peek() !== n23) return { type: l3.ERROR, value: "unterminated transliteration source", line: e5, column: t6 };
        this.advance();
        let r8 = this.readEscapedString(n23);
        if (r8 === null || this.peek() !== n23) return { type: l3.ERROR, value: "unterminated transliteration dest", line: e5, column: t6 };
        this.advance();
        let a7 = this.peek();
        for (; a7 === " " || a7 === "	"; ) this.advance(), a7 = this.peek();
        return a7 !== "" && a7 !== ";" && a7 !== `
` && a7 !== "}" ? { type: l3.ERROR, value: "extra text at the end of a transform command", line: e5, column: t6 } : { type: l3.TRANSLITERATE, value: `y${n23}${s9}${n23}${r8}${n23}`, source: s9, dest: r8, line: e5, column: t6 };
      }
      readTextCommand(e5, t6, n23) {
        let s9 = false;
        this.peek() === "\\" && this.pos + 1 < this.input.length && (this.input[this.pos + 1] === `
` || this.input[this.pos + 1] === " " || this.input[this.pos + 1] === "	") && (s9 = true, this.advance()), (this.peek() === " " || this.peek() === "	") && this.advance(), this.peek() === "\\" && this.pos + 1 < this.input.length && (this.input[this.pos + 1] === " " || this.input[this.pos + 1] === "	") && this.advance(), s9 && this.peek() === `
` && this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === `
`) {
            if (r8.endsWith("\\")) {
              r8 = `${r8.slice(0, -1)}
`, this.advance();
              continue;
            }
            break;
          }
          if (a7 === "\\" && this.pos + 1 < this.input.length) {
            let c14 = this.input[this.pos + 1];
            if (c14 === "n") {
              r8 += `
`, this.advance(), this.advance();
              continue;
            }
            if (c14 === "t") {
              r8 += "	", this.advance(), this.advance();
              continue;
            }
            if (c14 === "r") {
              r8 += "\r", this.advance(), this.advance();
              continue;
            }
          }
          r8 += this.advance();
        }
        return { type: l3.TEXT_CMD, value: e5, text: r8, line: t6, column: n23 };
      }
      readBranch(e5, t6, n23, s9) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === " " || a7 === "	" || a7 === `
` || a7 === ";" || a7 === "}" || a7 === "{") break;
          r8 += this.advance();
        }
        return { type: e5, value: t6, label: r8 || void 0, line: n23, column: s9 };
      }
      readVersion(e5, t6) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === " " || s9 === "	" || s9 === `
` || s9 === ";" || s9 === "}" || s9 === "{") break;
          n23 += this.advance();
        }
        return { type: l3.VERSION, value: "v", label: n23 || void 0, line: e5, column: t6 };
      }
      readFileCommand(e5, t6, n23, s9) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let r8 = "";
        for (; this.pos < this.input.length; ) {
          let a7 = this.peek();
          if (a7 === `
` || a7 === ";") break;
          r8 += this.advance();
        }
        return { type: e5, value: t6, filename: r8.trim(), line: n23, column: s9 };
      }
      readExecute(e5, t6) {
        for (; this.peek() === " " || this.peek() === "	"; ) this.advance();
        let n23 = "";
        for (; this.pos < this.input.length; ) {
          let s9 = this.peek();
          if (s9 === `
` || s9 === ";") break;
          n23 += this.advance();
        }
        return { type: l3.EXECUTE, value: "e", command: n23.trim() || void 0, line: e5, column: t6 };
      }
      isDigit(e5) {
        return e5 >= "0" && e5 <= "9";
      }
    };
    H6 = class {
      scripts;
      tokens = [];
      pos = 0;
      extendedRegex = false;
      constructor(e5, t6 = false) {
        this.scripts = e5, this.extendedRegex = t6;
      }
      parse() {
        let e5 = [];
        for (let t6 of this.scripts) {
          let n23 = new w5(t6);
          for (this.tokens = n23.tokenize(), this.pos = 0; !this.isAtEnd(); ) {
            if (this.check(l3.NEWLINE) || this.check(l3.SEMICOLON)) {
              this.advance();
              continue;
            }
            let s9 = this.pos, r8 = this.parseCommand();
            if (r8.error) return { commands: [], error: r8.error };
            if (r8.command && e5.push(r8.command), this.pos === s9 && !this.isAtEnd()) return { commands: [], error: `unknown command: '${this.peek()?.value ?? this.peek()?.type}'` };
          }
        }
        return { commands: e5 };
      }
      parseCommand() {
        let e5 = this.parseAddressRange();
        if (e5?.error) return { command: null, error: e5.error };
        let t6 = e5?.address;
        for (this.check(l3.NEGATION) && (this.advance(), t6 && (t6.negated = true)); this.check(l3.NEWLINE) || this.check(l3.SEMICOLON); ) this.advance();
        if (this.isAtEnd()) return t6 && (t6.start !== void 0 || t6.end !== void 0) ? { command: null, error: "command expected" } : { command: null };
        let n23 = this.peek();
        switch (n23.type) {
          case l3.COMMAND:
            return this.parseSimpleCommand(n23, t6);
          case l3.SUBSTITUTE:
            return this.parseSubstituteFromToken(n23, t6);
          case l3.TRANSLITERATE:
            return this.parseTransliterateFromToken(n23, t6);
          case l3.LABEL_DEF:
            return this.advance(), { command: { type: "label", name: n23.label || "" } };
          case l3.BRANCH:
            return this.advance(), { command: { type: "branch", address: t6, label: n23.label } };
          case l3.BRANCH_ON_SUBST:
            return this.advance(), { command: { type: "branchOnSubst", address: t6, label: n23.label } };
          case l3.BRANCH_ON_NO_SUBST:
            return this.advance(), { command: { type: "branchOnNoSubst", address: t6, label: n23.label } };
          case l3.TEXT_CMD:
            return this.advance(), this.parseTextCommand(n23, t6);
          case l3.FILE_READ:
            return this.advance(), { command: { type: "readFile", address: t6, filename: n23.filename || "" } };
          case l3.FILE_READ_LINE:
            return this.advance(), { command: { type: "readFileLine", address: t6, filename: n23.filename || "" } };
          case l3.FILE_WRITE:
            return this.advance(), { command: { type: "writeFile", address: t6, filename: n23.filename || "" } };
          case l3.FILE_WRITE_LINE:
            return this.advance(), { command: { type: "writeFirstLine", address: t6, filename: n23.filename || "" } };
          case l3.EXECUTE:
            return this.advance(), { command: { type: "execute", address: t6, command: n23.command } };
          case l3.VERSION:
            return this.advance(), { command: { type: "version", address: t6, minVersion: n23.label } };
          case l3.LBRACE:
            return this.parseGroup(t6);
          case l3.RBRACE:
            return { command: null };
          case l3.ERROR:
            return { command: null, error: `invalid command: ${n23.value}` };
          default:
            return t6 && (t6.start !== void 0 || t6.end !== void 0) ? { command: null, error: "command expected" } : { command: null };
        }
      }
      parseSimpleCommand(e5, t6) {
        this.advance();
        let n23 = e5.value;
        switch (n23) {
          case "p":
            return { command: { type: "print", address: t6 } };
          case "P":
            return { command: { type: "printFirstLine", address: t6 } };
          case "d":
            return { command: { type: "delete", address: t6 } };
          case "D":
            return { command: { type: "deleteFirstLine", address: t6 } };
          case "h":
            return { command: { type: "hold", address: t6 } };
          case "H":
            return { command: { type: "holdAppend", address: t6 } };
          case "g":
            return { command: { type: "get", address: t6 } };
          case "G":
            return { command: { type: "getAppend", address: t6 } };
          case "x":
            return { command: { type: "exchange", address: t6 } };
          case "n":
            return { command: { type: "next", address: t6 } };
          case "N":
            return { command: { type: "nextAppend", address: t6 } };
          case "q":
            return { command: { type: "quit", address: t6 } };
          case "Q":
            return { command: { type: "quitSilent", address: t6 } };
          case "z":
            return { command: { type: "zap", address: t6 } };
          case "=":
            return { command: { type: "lineNumber", address: t6 } };
          case "l":
            return { command: { type: "list", address: t6 } };
          case "F":
            return { command: { type: "printFilename", address: t6 } };
          default:
            return { command: null, error: `unknown command: ${n23}` };
        }
      }
      parseSubstituteFromToken(e5, t6) {
        this.advance();
        let n23 = e5.flags || "", s9, r8 = n23.match(/(\d+)/);
        return r8 && (s9 = parseInt(r8[1], 10)), { command: { type: "substitute", address: t6, pattern: e5.pattern || "", replacement: e5.replacement || "", global: n23.includes("g"), ignoreCase: n23.includes("i") || n23.includes("I"), printOnMatch: n23.includes("p"), nthOccurrence: s9, extendedRegex: this.extendedRegex } };
      }
      parseTransliterateFromToken(e5, t6) {
        this.advance();
        let n23 = e5.source || "", s9 = e5.dest || "";
        return n23.length !== s9.length ? { command: null, error: "transliteration sets must have same length" } : { command: { type: "transliterate", address: t6, source: n23, dest: s9 } };
      }
      parseTextCommand(e5, t6) {
        let n23 = e5.value, s9 = e5.text || "";
        switch (n23) {
          case "a":
            return { command: { type: "append", address: t6, text: s9 } };
          case "i":
            return { command: { type: "insert", address: t6, text: s9 } };
          case "c":
            return { command: { type: "change", address: t6, text: s9 } };
          default:
            return { command: null, error: `unknown text command: ${n23}` };
        }
      }
      parseGroup(e5) {
        this.advance();
        let t6 = [];
        for (; !this.isAtEnd() && !this.check(l3.RBRACE); ) {
          if (this.check(l3.NEWLINE) || this.check(l3.SEMICOLON)) {
            this.advance();
            continue;
          }
          let n23 = this.pos, s9 = this.parseCommand();
          if (s9.error) return { command: null, error: s9.error };
          if (s9.command && t6.push(s9.command), this.pos === n23 && !this.isAtEnd()) return { command: null, error: `unknown command: '${this.peek()?.value ?? this.peek()?.type}'` };
        }
        return this.check(l3.RBRACE) ? (this.advance(), { command: { type: "group", address: e5, commands: t6 } }) : { command: null, error: "unmatched brace in grouped commands" };
      }
      parseAddressRange() {
        if (this.check(l3.COMMA)) return { error: "expected context address" };
        let e5 = this.parseAddress();
        if (e5 === void 0) return;
        let t6;
        if (this.check(l3.RELATIVE_OFFSET)) t6 = { offset: this.advance().offset || 0 };
        else if (this.check(l3.COMMA) && (this.advance(), t6 = this.parseAddress(), t6 === void 0)) return { error: "expected context address" };
        return { address: { start: e5, end: t6 } };
      }
      parseAddress() {
        let e5 = this.peek();
        switch (e5.type) {
          case l3.NUMBER:
            return this.advance(), e5.value;
          case l3.DOLLAR:
            return this.advance(), "$";
          case l3.PATTERN:
            return this.advance(), { pattern: e5.pattern || e5.value };
          case l3.STEP:
            return this.advance(), { first: e5.first || 0, step: e5.step || 0 };
          case l3.RELATIVE_OFFSET:
            return this.advance(), { offset: e5.offset || 0 };
          default:
            return;
        }
      }
      peek() {
        return this.tokens[this.pos] || { type: l3.EOF, value: "", line: 0, column: 0 };
      }
      advance() {
        return this.isAtEnd() || this.pos++, this.tokens[this.pos - 1];
      }
      check(e5) {
        return this.peek().type === e5;
      }
      isAtEnd() {
        return this.peek().type === l3.EOF;
      }
    };
    pe3 = { name: "sed", summary: "stream editor for filtering and transforming text", usage: "sed [OPTION]... {script} [input-file]...", options: ["-n, --quiet, --silent  suppress automatic printing of pattern space", "-e script              add the script to commands to be executed", "-f script-file         read script from file", "-i, --in-place         edit files in place", "-E, -r, --regexp-extended  use extended regular expressions", "    --help             display this help and exit"], description: `Commands:
  s/regexp/replacement/[flags]  substitute
  d                             delete pattern space
  p                             print pattern space
  a\\ text                       append text after line
  i\\ text                       insert text before line
  c\\ text                       change (replace) line with text
  h                             copy pattern space to hold space
  H                             append pattern space to hold space
  g                             copy hold space to pattern space
  G                             append hold space to pattern space
  x                             exchange pattern and hold spaces
  n                             read next line into pattern space
  N                             append next line to pattern space
  y/source/dest/                transliterate characters
  =                             print line number
  l                             list pattern space (escape special chars)
  b [label]                     branch to label
  t [label]                     branch on substitution
  T [label]                     branch if no substitution
  :label                        define label
  q                             quit
  Q                             quit without printing

Addresses:
  N                             line number
  $                             last line
  /regexp/                      lines matching regexp
  N,M                           range from line N to M
  first~step                    every step-th line starting at first` };
    Ne = { name: "sed", async execute(i10, e5) {
      if (o2(i10)) return s(pe3);
      let t6 = [], n23 = [], s9 = false, r8 = false, a7 = false, c14 = [];
      for (let u10 = 0; u10 < i10.length; u10++) {
        let h16 = i10[u10];
        if (h16 === "-n" || h16 === "--quiet" || h16 === "--silent") s9 = true;
        else if (h16 === "-i" || h16 === "--in-place") r8 = true;
        else if (h16.startsWith("-i")) r8 = true;
        else if (h16 === "-E" || h16 === "-r" || h16 === "--regexp-extended") a7 = true;
        else if (h16 === "-e") u10 + 1 < i10.length && t6.push(i10[++u10]);
        else if (h16 === "-f") u10 + 1 < i10.length && n23.push(i10[++u10]);
        else {
          if (h16.startsWith("--")) return r3("sed", h16);
          if (h16 === "-") c14.push(h16);
          else if (h16.startsWith("-") && h16.length > 1) {
            for (let b25 of h16.slice(1)) if (b25 !== "n" && b25 !== "e" && b25 !== "f" && b25 !== "i" && b25 !== "E" && b25 !== "r") return r3("sed", `-${b25}`);
            h16.includes("n") && (s9 = true), h16.includes("i") && (r8 = true), (h16.includes("E") || h16.includes("r")) && (a7 = true), h16.includes("e") && !h16.includes("n") && !h16.includes("i") && u10 + 1 < i10.length && t6.push(i10[++u10]), h16.includes("f") && !h16.includes("e") && u10 + 1 < i10.length && n23.push(i10[++u10]);
          } else !h16.startsWith("-") && t6.length === 0 && n23.length === 0 ? t6.push(h16) : h16.startsWith("-") || c14.push(h16);
        }
      }
      for (let u10 of n23) {
        let h16 = e5.fs.resolvePath(e5.cwd, u10);
        try {
          let b25 = await e5.fs.readFile(h16);
          for (let C19 of b25.split(`
`)) {
            let y18 = C19.trim();
            y18 && !y18.startsWith("#") && t6.push(y18);
          }
        } catch {
          return { stdout: "", stderr: `sed: couldn't open file ${u10}: No such file or directory
`, exitCode: 1 };
        }
      }
      if (t6.length === 0) return { stdout: "", stderr: `sed: no script specified
`, exitCode: 1 };
      let { commands: o9, error: d16, silentMode: p17 } = Q6(t6, a7);
      if (d16) return { stdout: "", stderr: `sed: ${d16}
`, exitCode: 1 };
      let E12 = !!(s9 || p17);
      if (r8) {
        if (c14.length === 0) return { stdout: "", stderr: `sed: -i requires at least one file argument
`, exitCode: 1 };
        for (let u10 of c14) {
          if (u10 === "-") continue;
          let h16 = e5.fs.resolvePath(e5.cwd, u10);
          try {
            let b25 = await e5.fs.readFile(h16), C19 = await z4(b25, o9, E12, { limits: e5.limits, filename: u10, fs: e5.fs, cwd: e5.cwd, coverage: e5.coverage });
            if (C19.errorMessage) return { stdout: "", stderr: `${C19.errorMessage}
`, exitCode: C19.exitCode ?? 1 };
            await e5.fs.writeFile(h16, C19.output);
          } catch (b25) {
            return b25 instanceof b2 ? { stdout: "", stderr: `sed: ${b25.message}
`, exitCode: b2.EXIT_CODE } : { stdout: "", stderr: `sed: ${u10}: No such file or directory
`, exitCode: 1 };
          }
        }
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      let m24 = "";
      if (c14.length === 0) {
        m24 = e5.stdin;
        try {
          let u10 = await z4(m24, o9, E12, { limits: e5.limits, fs: e5.fs, cwd: e5.cwd, coverage: e5.coverage });
          return { stdout: u10.output, stderr: u10.errorMessage ? `${u10.errorMessage}
` : "", exitCode: u10.exitCode ?? 0 };
        } catch (u10) {
          if (u10 instanceof b2) return { stdout: "", stderr: `sed: ${u10.message}
`, exitCode: b2.EXIT_CODE };
          throw u10;
        }
      }
      let f11 = false;
      for (let u10 of c14) {
        let h16;
        if (u10 === "-") f11 ? h16 = "" : (h16 = e5.stdin, f11 = true);
        else {
          let b25 = e5.fs.resolvePath(e5.cwd, u10);
          try {
            h16 = await e5.fs.readFile(b25);
          } catch (C19) {
            return C19 instanceof b2 ? { stdout: "", stderr: `sed: ${C19.message}
`, exitCode: b2.EXIT_CODE } : { stdout: "", stderr: `sed: ${u10}: No such file or directory
`, exitCode: 1 };
          }
        }
        m24.length > 0 && h16.length > 0 && !m24.endsWith(`
`) && (m24 += `
`), m24 += h16;
      }
      try {
        let u10 = await z4(m24, o9, E12, { limits: e5.limits, filename: c14.length === 1 ? c14[0] : void 0, fs: e5.fs, cwd: e5.cwd, coverage: e5.coverage });
        return { stdout: u10.output, stderr: u10.errorMessage ? `${u10.errorMessage}
` : "", exitCode: u10.exitCode ?? 0 };
      } catch (u10) {
        if (u10 instanceof b2) return { stdout: "", stderr: `sed: ${u10.message}
`, exitCode: b2.EXIT_CODE };
        throw u10;
      }
    } };
    Le = { name: "sed", flags: [{ flag: "-n", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-E", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-e", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sed-7HX4RAZG.js
var sed_7HX4RAZG_exports = {};
__export(sed_7HX4RAZG_exports, {
  flagsForFuzzing: () => Le,
  sedCommand: () => Ne
});
var init_sed_7HX4RAZG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sed-7HX4RAZG.js"() {
    init_chunk_MZLOTDD7();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-3KWUDRIP.js
function Q7(e5 = {}) {
  let { fieldSep: t6 = Pe2, maxIterations: n23 = Le2, maxRecursionDepth: i10 = Me, maxOutputSize: a7 = 0, fs: s9, cwd: o9, exec: c14, coverage: u10 } = e5;
  return { FS: " ", OFS: " ", ORS: `
`, OFMT: "%.6g", NR: 0, NF: 0, FNR: 0, FILENAME: "", RSTART: 0, RLENGTH: -1, SUBSEP: "", fields: [], line: "", vars: /* @__PURE__ */ Object.create(null), arrays: /* @__PURE__ */ Object.create(null), arrayAliases: /* @__PURE__ */ new Map(), ARGC: 0, ARGV: /* @__PURE__ */ Object.create(null), ENVIRON: /* @__PURE__ */ Object.create(null), functions: /* @__PURE__ */ new Map(), fieldSep: t6, maxIterations: n23, maxRecursionDepth: i10, maxOutputSize: a7, currentRecursionDepth: 0, exitCode: 0, shouldExit: false, shouldNext: false, shouldNextFile: false, loopBreak: false, loopContinue: false, hasReturn: false, inEndBlock: false, output: "", openedFiles: /* @__PURE__ */ new Set(), fs: s9, cwd: o9, exec: c14, coverage: u10 };
}
function le4(e5, t6, n23) {
  switch (n23) {
    case "+":
      return e5 + t6;
    case "-":
      return e5 - t6;
    case "*":
      return e5 * t6;
    case "/":
      return t6 !== 0 ? e5 / t6 : 0;
    case "%":
      return t6 !== 0 ? e5 % t6 : 0;
    case "^":
    case "**":
      return e5 ** t6;
    default:
      return 0;
  }
}
function C5(e5) {
  if (typeof e5 == "number") return e5;
  let t6 = parseFloat(e5);
  return Number.isNaN(t6) ? 0 : t6;
}
function I6(e5) {
  return typeof e5 == "string" ? e5 : (Number.isInteger(e5), String(e5));
}
async function U5(e5, t6) {
  if (e5.type === "regex") return e5.pattern;
  let n23 = I6(await t6.evalExpr(e5));
  return n23.startsWith("/") && n23.endsWith("/") && (n23 = n23.slice(1, -1)), n23;
}
async function ue4(e5, t6) {
  return e5 ? e5.type === "variable" ? e5.name : e5.type === "field" ? `$${Math.floor(C5(await t6.evalExpr(e5.index)))}` : "$0" : "$0";
}
function he4(e5, t6) {
  if (e5 === "$0") return t6.line;
  if (e5.startsWith("$")) {
    let n23 = parseInt(e5.slice(1), 10) - 1;
    return t6.fields[n23] || "";
  }
  return I6(t6.vars[e5] ?? "");
}
function pe4(e5, t6, n23) {
  if (e5 === "$0") n23.line = t6, n23.fields = n23.FS === " " ? t6.trim().split(/\s+/).filter(Boolean) : n23.fieldSep.split(t6), n23.NF = n23.fields.length;
  else if (e5.startsWith("$")) {
    let i10 = parseInt(e5.slice(1), 10) - 1;
    for (; n23.fields.length <= i10; ) n23.fields.push("");
    n23.fields[i10] = t6, n23.NF = n23.fields.length, n23.line = n23.fields.join(n23.OFS);
  } else n23.vars[e5] = t6;
}
async function Te(e5, t6, n23) {
  return e5.length === 0 ? t6.line.length : I6(await n23.evalExpr(e5[0])).length;
}
async function Fe2(e5, t6, n23) {
  if (e5.length < 2) return "";
  let i10 = I6(await n23.evalExpr(e5[0])), a7 = Math.floor(C5(await n23.evalExpr(e5[1]))) - 1;
  if (e5.length >= 3) {
    let s9 = Math.floor(C5(await n23.evalExpr(e5[2])));
    return i10.substr(Math.max(0, a7), s9);
  }
  return i10.substr(Math.max(0, a7));
}
async function _e(e5, t6, n23) {
  if (e5.length < 2) return 0;
  let i10 = I6(await n23.evalExpr(e5[0])), a7 = I6(await n23.evalExpr(e5[1])), s9 = i10.indexOf(a7);
  return s9 === -1 ? 0 : s9 + 1;
}
async function Ge2(e5, t6, n23) {
  if (e5.length < 2) return 0;
  let i10 = I6(await n23.evalExpr(e5[0])), a7 = e5[1];
  if (a7.type !== "variable") return 0;
  let s9 = a7.name, o9 = t6.FS;
  if (e5.length >= 3) {
    let u10 = e5[2];
    if (u10.type === "regex") o9 = b1(u10.pattern);
    else {
      let N14 = I6(await n23.evalExpr(u10));
      o9 = N14 === " " ? b1("\\s+") : N14;
    }
  } else t6.FS === " " && (o9 = b1("\\s+"));
  let c14 = typeof o9 == "string" ? i10.split(o9) : o9.split(i10);
  t6.arrays[s9] = /* @__PURE__ */ Object.create(null);
  for (let u10 = 0; u10 < c14.length; u10++) t6.arrays[s9][String(u10 + 1)] = c14[u10];
  return c14.length;
}
async function De2(e5, t6, n23) {
  if (e5.length < 2) return 0;
  let i10 = await U5(e5[0], n23), a7 = I6(await n23.evalExpr(e5[1])), s9 = await ue4(e5[2], n23), o9 = he4(s9, t6);
  try {
    let u10 = b1(i10).replace(o9, fe5(a7)), N14 = u10 !== o9 ? 1 : 0;
    return pe4(s9, u10, t6), N14;
  } catch {
    return 0;
  }
}
async function xe2(e5, t6, n23) {
  if (e5.length < 2) return 0;
  let i10 = await U5(e5[0], n23), a7 = I6(await n23.evalExpr(e5[1])), s9 = await ue4(e5[2], n23), o9 = he4(s9, t6);
  try {
    let c14 = b1(i10, "g"), u10 = c14.match(o9), N14 = u10 ? u10.length : 0, k15 = c14.replace(o9, fe5(a7));
    return pe4(s9, k15, t6), N14;
  } catch {
    return 0;
  }
}
function fe5(e5) {
  return (t6) => {
    let n23 = "", i10 = 0;
    for (; i10 < e5.length; ) if (e5[i10] === "\\" && i10 + 1 < e5.length) {
      let a7 = e5[i10 + 1];
      a7 === "&" ? (n23 += "&", i10 += 2) : a7 === "\\" ? (n23 += "\\", i10 += 2) : (n23 += e5[i10 + 1], i10 += 2);
    } else e5[i10] === "&" ? (n23 += t6, i10++) : (n23 += e5[i10], i10++);
    return n23;
  };
}
async function Ue2(e5, t6, n23) {
  if (e5.length < 2) return t6.RSTART = 0, t6.RLENGTH = -1, 0;
  let i10 = I6(await n23.evalExpr(e5[0])), a7 = await U5(e5[1], n23);
  try {
    let o9 = b1(a7).exec(i10);
    if (o9) return t6.RSTART = o9.index + 1, t6.RLENGTH = o9[0].length, t6.RSTART;
  } catch {
  }
  return t6.RSTART = 0, t6.RLENGTH = -1, 0;
}
async function Be(e5, t6, n23) {
  if (e5.length < 3) return "";
  let i10 = await U5(e5[0], n23), a7 = I6(await n23.evalExpr(e5[1])), s9 = I6(await n23.evalExpr(e5[2])), o9 = e5.length >= 4 ? I6(await n23.evalExpr(e5[3])) : t6.line;
  try {
    let c14 = s9.toLowerCase() === "g", u10 = c14 ? 0 : parseInt(s9, 10) || 1;
    if (c14) return b1(i10, "g").replace(o9, (k15, ...y18) => ce3(a7, k15, y18.slice(0, -2)));
    {
      let N14 = 0;
      return b1(i10, "g").replace(o9, (y18, ...w19) => (N14++, N14 === u10 ? ce3(a7, y18, w19.slice(0, -2)) : y18));
    }
  } catch {
    return o9;
  }
}
function ce3(e5, t6, n23) {
  let i10 = "", a7 = 0;
  for (; a7 < e5.length; ) if (e5[a7] === "\\" && a7 + 1 < e5.length) {
    let s9 = e5[a7 + 1];
    if (s9 === "&") i10 += "&", a7 += 2;
    else if (s9 === "0") i10 += t6, a7 += 2;
    else if (s9 >= "1" && s9 <= "9") {
      let o9 = parseInt(s9, 10) - 1;
      i10 += n23[o9] || "", a7 += 2;
    } else s9 === "n" ? (i10 += `
`, a7 += 2) : s9 === "t" ? (i10 += "	", a7 += 2) : (i10 += s9, a7 += 2);
  } else e5[a7] === "&" ? (i10 += t6, a7++) : (i10 += e5[a7], a7++);
  return i10;
}
async function He2(e5, t6, n23) {
  return e5.length === 0 ? "" : I6(await n23.evalExpr(e5[0])).toLowerCase();
}
async function $e(e5, t6, n23) {
  return e5.length === 0 ? "" : I6(await n23.evalExpr(e5[0])).toUpperCase();
}
async function We(e5, t6, n23) {
  if (e5.length === 0) return "";
  let i10 = I6(await n23.evalExpr(e5[0])), a7 = [];
  for (let s9 = 1; s9 < e5.length; s9++) a7.push(await n23.evalExpr(e5[s9]));
  return B5(i10, a7);
}
async function Ve(e5, t6, n23) {
  return e5.length === 0 ? 0 : Math.floor(C5(await n23.evalExpr(e5[0])));
}
async function Ke2(e5, t6, n23) {
  return e5.length === 0 ? 0 : Math.sqrt(C5(await n23.evalExpr(e5[0])));
}
async function Xe2(e5, t6, n23) {
  return e5.length === 0 ? 0 : Math.sin(C5(await n23.evalExpr(e5[0])));
}
async function je2(e5, t6, n23) {
  return e5.length === 0 ? 0 : Math.cos(C5(await n23.evalExpr(e5[0])));
}
async function ze2(e5, t6, n23) {
  let i10 = e5.length > 0 ? C5(await n23.evalExpr(e5[0])) : 0, a7 = e5.length > 1 ? C5(await n23.evalExpr(e5[1])) : 0;
  return Math.atan2(i10, a7);
}
async function Qe2(e5, t6, n23) {
  return e5.length === 0 ? 0 : Math.log(C5(await n23.evalExpr(e5[0])));
}
async function qe(e5, t6, n23) {
  return e5.length === 0 ? 1 : Math.exp(C5(await n23.evalExpr(e5[0])));
}
function Je2(e5, t6, n23) {
  return t6.random ? t6.random() : Math.random();
}
async function Ze2(e5, t6, n23) {
  let i10 = e5.length > 0 ? C5(await n23.evalExpr(e5[0])) : Date.now();
  return t6.vars._srand_seed = i10, i10;
}
function Ye2(e5, t6) {
  return () => {
    throw new Error(`${e5}() is not supported - ${t6}`);
  };
}
function q7(e5) {
  return () => {
    throw new Error(`function '${e5}()' is not implemented`);
  };
}
function B5(e5, t6) {
  let n23 = 0, i10 = "", a7 = 0;
  for (; a7 < e5.length; ) if (e5[a7] === "%" && a7 + 1 < e5.length) {
    let s9 = a7 + 1, o9 = "", c14 = "", u10 = "", N14, k15 = s9;
    for (; s9 < e5.length && /\d/.test(e5[s9]); ) s9++;
    s9 > k15 && e5[s9] === "$" ? (N14 = parseInt(e5.substring(k15, s9), 10) - 1, s9++) : s9 = k15;
    let y18 = () => {
      if (s9 < e5.length) {
        if (s9 + 1 < e5.length && (e5[s9] === "h" && e5[s9 + 1] === "h" || e5[s9] === "l" && e5[s9 + 1] === "l")) {
          s9 += 2;
          return;
        }
        /[lzjh]/.test(e5[s9]) && s9++;
      }
    };
    for (; s9 < e5.length && /[-+ #0]/.test(e5[s9]); ) o9 += e5[s9++];
    if (e5[s9] === "*") {
      let l8 = t6[n23++], p17 = l8 !== void 0 ? Math.floor(Number(l8)) : 0;
      p17 < 0 ? (o9 += "-", c14 = String(Math.min(-p17, L5))) : c14 = String(Math.min(p17, L5)), s9++;
    } else for (; s9 < e5.length && /\d/.test(e5[s9]); ) c14 += e5[s9++];
    if (c14 && parseInt(c14, 10) > L5 && (c14 = String(L5)), e5[s9] === ".") {
      if (s9++, e5[s9] === "*") {
        let l8 = t6[n23++];
        u10 = String(Math.min(l8 !== void 0 ? Math.floor(Number(l8)) : 0, L5)), s9++;
      } else for (; s9 < e5.length && /\d/.test(e5[s9]); ) u10 += e5[s9++];
      u10 && parseInt(u10, 10) > L5 && (u10 = String(L5));
    }
    y18();
    let w19 = e5[s9], g18 = t6[N14 !== void 0 ? N14 : n23];
    switch (w19) {
      case "s": {
        let l8 = g18 !== void 0 ? String(g18) : "";
        if (u10 && (l8 = l8.substring(0, parseInt(u10, 10))), c14) {
          let p17 = parseInt(c14, 10);
          o9.includes("-") ? l8 = l8.padEnd(p17) : l8 = l8.padStart(p17);
        }
        i10 += l8, N14 === void 0 && n23++;
        break;
      }
      case "d":
      case "i": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = l8 < 0, E12 = Math.abs(l8).toString();
        if (u10) {
          let b25 = parseInt(u10, 10);
          E12 = E12.padStart(b25, "0");
        }
        let d16 = "";
        p17 ? d16 = "-" : o9.includes("+") ? d16 = "+" : o9.includes(" ") && (d16 = " ");
        let R13 = d16 + E12;
        if (c14) {
          let b25 = parseInt(c14, 10);
          o9.includes("-") ? R13 = R13.padEnd(b25) : o9.includes("0") && !u10 ? R13 = d16 + E12.padStart(b25 - d16.length, "0") : R13 = R13.padStart(b25);
        }
        i10 += R13, N14 === void 0 && n23++;
        break;
      }
      case "f": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u10 ? parseInt(u10, 10) : 6, E12 = l8.toFixed(p17);
        if (c14) {
          let d16 = parseInt(c14, 10);
          o9.includes("-") ? E12 = E12.padEnd(d16) : E12 = E12.padStart(d16);
        }
        i10 += E12, N14 === void 0 && n23++;
        break;
      }
      case "e":
      case "E": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u10 ? parseInt(u10, 10) : 6, E12 = l8.toExponential(p17);
        if (w19 === "E" && (E12 = E12.toUpperCase()), c14) {
          let d16 = parseInt(c14, 10);
          o9.includes("-") ? E12 = E12.padEnd(d16) : E12 = E12.padStart(d16);
        }
        i10 += E12, N14 === void 0 && n23++;
        break;
      }
      case "g":
      case "G": {
        let l8 = g18 !== void 0 ? Number(g18) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = u10 ? parseInt(u10, 10) : 6, E12 = l8 !== 0 ? Math.floor(Math.log10(Math.abs(l8))) : 0, d16;
        if (l8 === 0 ? d16 = "0" : E12 < -4 || E12 >= p17 ? (d16 = l8.toExponential(p17 - 1), w19 === "G" && (d16 = d16.toUpperCase())) : d16 = l8.toPrecision(p17), d16.includes(".") && (d16 = d16.replace(/\.?0+$/, "").replace(/\.?0+e/, "e")), d16.includes("e") && (d16 = d16.replace(/\.?0+e/, "e")), c14) {
          let R13 = parseInt(c14, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : d16 = d16.padStart(R13);
        }
        i10 += d16, N14 === void 0 && n23++;
        break;
      }
      case "x":
      case "X": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = Math.abs(l8).toString(16);
        if (w19 === "X" && (p17 = p17.toUpperCase()), u10) {
          let R13 = parseInt(u10, 10);
          p17 = p17.padStart(R13, "0");
        }
        let E12 = l8 < 0 ? "-" : "", d16 = E12 + p17;
        if (c14) {
          let R13 = parseInt(c14, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : o9.includes("0") && !u10 ? d16 = E12 + p17.padStart(R13 - E12.length, "0") : d16 = d16.padStart(R13);
        }
        i10 += d16, N14 === void 0 && n23++;
        break;
      }
      case "o": {
        let l8 = g18 !== void 0 ? Math.floor(Number(g18)) : 0;
        Number.isNaN(l8) && (l8 = 0);
        let p17 = Math.abs(l8).toString(8);
        if (u10) {
          let R13 = parseInt(u10, 10);
          p17 = p17.padStart(R13, "0");
        }
        let E12 = l8 < 0 ? "-" : "", d16 = E12 + p17;
        if (c14) {
          let R13 = parseInt(c14, 10);
          o9.includes("-") ? d16 = d16.padEnd(R13) : o9.includes("0") && !u10 ? d16 = E12 + p17.padStart(R13 - E12.length, "0") : d16 = d16.padStart(R13);
        }
        i10 += d16, N14 === void 0 && n23++;
        break;
      }
      case "c": {
        typeof g18 == "number" ? i10 += String.fromCharCode(g18) : i10 += String(g18 ?? "").charAt(0) || "", N14 === void 0 && n23++;
        break;
      }
      case "%":
        i10 += "%";
        break;
      default:
        i10 += e5.substring(a7, s9 + 1);
    }
    a7 = s9 + 1;
  } else if (e5[a7] === "\\" && a7 + 1 < e5.length) {
    let s9 = e5[a7 + 1];
    switch (s9) {
      case "n":
        i10 += `
`;
        break;
      case "t":
        i10 += "	";
        break;
      case "r":
        i10 += "\r";
        break;
      case "\\":
        i10 += "\\";
        break;
      default:
        i10 += s9;
    }
    a7 += 2;
  } else i10 += e5[a7++];
  return i10;
}
function v6(e5) {
  return typeof e5 == "number" ? e5 !== 0 : !(e5 === "" || e5 === "0");
}
function m7(e5) {
  if (typeof e5 == "number") return e5;
  let t6 = parseFloat(e5);
  return Number.isNaN(t6) ? 0 : t6;
}
function S3(e5) {
  return typeof e5 == "string" ? e5 : (Number.isInteger(e5), String(e5));
}
function J6(e5) {
  if (typeof e5 == "number") return true;
  let t6 = String(e5).trim();
  return t6 === "" ? false : !Number.isNaN(Number(t6));
}
function G4(e5, t6) {
  try {
    return b1(e5).test(t6);
  } catch {
    return false;
  }
}
function Ee(e5, t6) {
  return t6 === "" ? [] : e5.FS === " " ? t6.trim().split(/\s+/).filter(Boolean) : e5.fieldSep.split(t6);
}
function H7(e5, t6) {
  return t6 === 0 ? e5.line : t6 < 0 || t6 > e5.fields.length ? "" : e5.fields[t6 - 1] ?? "";
}
function Z6(e5, t6, n23) {
  if (t6 === 0) e5.line = S3(n23), e5.fields = Ee(e5, e5.line), e5.NF = e5.fields.length;
  else if (t6 > 0) {
    for (; e5.fields.length < t6; ) e5.fields.push("");
    e5.fields[t6 - 1] = S3(n23), e5.NF = e5.fields.length, e5.line = e5.fields.join(e5.OFS);
  }
}
function T2(e5, t6) {
  e5.line = t6, e5.fields = Ee(e5, t6), e5.NF = e5.fields.length;
}
function Ne2(e5, t6) {
  if (e5.FS = t6, t6 === " ") e5.fieldSep = new i1(/\s+/);
  else try {
    e5.fieldSep = b1(t6);
  } catch {
    e5.fieldSep = b1(t6.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  }
}
function $8(e5, t6) {
  switch (t6) {
    case "FS":
      return e5.FS;
    case "OFS":
      return e5.OFS;
    case "ORS":
      return e5.ORS;
    case "OFMT":
      return e5.OFMT;
    case "NR":
      return e5.NR;
    case "NF":
      return e5.NF;
    case "FNR":
      return e5.FNR;
    case "FILENAME":
      return e5.FILENAME;
    case "RSTART":
      return e5.RSTART;
    case "RLENGTH":
      return e5.RLENGTH;
    case "SUBSEP":
      return e5.SUBSEP;
    case "ARGC":
      return e5.ARGC;
  }
  return e5.vars[t6] ?? "";
}
function F6(e5, t6, n23) {
  switch (t6) {
    case "FS":
      Ne2(e5, S3(n23));
      return;
    case "OFS":
      e5.OFS = S3(n23);
      return;
    case "ORS":
      e5.ORS = S3(n23);
      return;
    case "OFMT":
      e5.OFMT = S3(n23);
      return;
    case "NR":
      e5.NR = Math.floor(m7(n23));
      return;
    case "NF": {
      let i10 = Math.floor(m7(n23));
      if (i10 < e5.NF) e5.fields = e5.fields.slice(0, i10), e5.line = e5.fields.join(e5.OFS);
      else if (i10 > e5.NF) {
        for (; e5.fields.length < i10; ) e5.fields.push("");
        e5.line = e5.fields.join(e5.OFS);
      }
      e5.NF = i10;
      return;
    }
    case "FNR":
      e5.FNR = Math.floor(m7(n23));
      return;
    case "FILENAME":
      e5.FILENAME = S3(n23);
      return;
    case "RSTART":
      e5.RSTART = Math.floor(m7(n23));
      return;
    case "RLENGTH":
      e5.RLENGTH = Math.floor(m7(n23));
      return;
    case "SUBSEP":
      e5.SUBSEP = S3(n23);
      return;
  }
  e5.vars[t6] = n23;
}
function D6(e5, t6) {
  let n23 = t6, i10 = /* @__PURE__ */ new Set(), a7 = e5.arrayAliases.get(n23);
  for (; a7 !== void 0 && !i10.has(n23); ) i10.add(n23), n23 = a7, a7 = e5.arrayAliases.get(n23);
  return n23;
}
function W6(e5, t6, n23) {
  if (t6 === "ARGV") return e5.ARGV[n23] ?? "";
  if (t6 === "ENVIRON") return e5.ENVIRON[n23] ?? "";
  let i10 = D6(e5, t6);
  return e5.arrays[i10]?.[n23] ?? "";
}
function Y6(e5, t6, n23, i10) {
  let a7 = D6(e5, t6);
  e5.arrays[a7] || (e5.arrays[a7] = /* @__PURE__ */ Object.create(null)), e5.arrays[a7][n23] = i10;
}
function Se(e5, t6, n23) {
  if (t6 === "ARGV") return e5.ARGV[n23] !== void 0;
  if (t6 === "ENVIRON") return e5.ENVIRON[n23] !== void 0;
  let i10 = D6(e5, t6);
  return e5.arrays[i10]?.[n23] !== void 0;
}
function ye3(e5, t6, n23) {
  let i10 = D6(e5, t6);
  e5.arrays[i10] && delete e5.arrays[i10][n23];
}
function Re3(e5, t6) {
  let n23 = D6(e5, t6);
  delete e5.arrays[n23];
}
function me2(e5) {
  ee4 = e5;
}
async function f6(e5, t6) {
  switch (e5.coverage?.hit(`awk:expr:${t6.type}`), t6.type) {
    case "number":
      return t6.value;
    case "string":
      return t6.value;
    case "regex":
      return G4(t6.pattern, e5.line) ? 1 : 0;
    case "field":
      return et2(e5, t6);
    case "variable":
      return $8(e5, t6.name);
    case "array_access":
      return tt2(e5, t6);
    case "binary":
      return nt2(e5, t6);
    case "unary":
      return st2(e5, t6);
    case "ternary":
      return v6(await f6(e5, t6.condition)) ? await f6(e5, t6.consequent) : await f6(e5, t6.alternate);
    case "call":
      return at2(e5, t6.name, t6.args);
    case "assignment":
      return lt(e5, t6);
    case "pre_increment":
      return ct(e5, t6.operand);
    case "pre_decrement":
      return ut(e5, t6.operand);
    case "post_increment":
      return ht(e5, t6.operand);
    case "post_decrement":
      return pt(e5, t6.operand);
    case "in":
      return ft(e5, t6.key, t6.array);
    case "getline":
      return dt(e5, t6.variable, t6.file, t6.command);
    case "tuple":
      return St(e5, t6.elements);
    default:
      return "";
  }
}
async function et2(e5, t6) {
  let n23 = Math.floor(m7(await f6(e5, t6.index)));
  return H7(e5, n23);
}
async function tt2(e5, t6) {
  let n23 = S3(await f6(e5, t6.key));
  return W6(e5, t6.array, n23);
}
async function nt2(e5, t6) {
  let n23 = t6.operator;
  if (n23 === "||") return v6(await f6(e5, t6.left)) || v6(await f6(e5, t6.right)) ? 1 : 0;
  if (n23 === "&&") return v6(await f6(e5, t6.left)) && v6(await f6(e5, t6.right)) ? 1 : 0;
  if (n23 === "~") {
    let c14 = await f6(e5, t6.left);
    t6.right.type === "regex" && e5.coverage?.hit("awk:expr:regex");
    let u10 = t6.right.type === "regex" ? t6.right.pattern : S3(await f6(e5, t6.right));
    try {
      return b1(u10).test(S3(c14)) ? 1 : 0;
    } catch {
      return 0;
    }
  }
  if (n23 === "!~") {
    let c14 = await f6(e5, t6.left);
    t6.right.type === "regex" && e5.coverage?.hit("awk:expr:regex");
    let u10 = t6.right.type === "regex" ? t6.right.pattern : S3(await f6(e5, t6.right));
    try {
      return b1(u10).test(S3(c14)) ? 0 : 1;
    } catch {
      return 1;
    }
  }
  let i10 = await f6(e5, t6.left), a7 = await f6(e5, t6.right);
  if (n23 === " ") {
    let c14 = S3(i10) + S3(a7);
    if (e5.maxOutputSize > 0 && c14.length > e5.maxOutputSize) throw new b2(`awk: string concatenation size limit exceeded (${e5.maxOutputSize} bytes)`, "string_length", e5.output);
    return c14;
  }
  if (rt2(n23)) return it2(i10, a7, n23);
  let s9 = m7(i10), o9 = m7(a7);
  return le4(s9, o9, n23);
}
function rt2(e5) {
  return ["<", "<=", ">", ">=", "==", "!="].includes(e5);
}
function it2(e5, t6, n23) {
  let i10 = J6(e5), a7 = J6(t6);
  if (i10 && a7) {
    let c14 = m7(e5), u10 = m7(t6);
    switch (n23) {
      case "<":
        return c14 < u10 ? 1 : 0;
      case "<=":
        return c14 <= u10 ? 1 : 0;
      case ">":
        return c14 > u10 ? 1 : 0;
      case ">=":
        return c14 >= u10 ? 1 : 0;
      case "==":
        return c14 === u10 ? 1 : 0;
      case "!=":
        return c14 !== u10 ? 1 : 0;
    }
  }
  let s9 = S3(e5), o9 = S3(t6);
  switch (n23) {
    case "<":
      return s9 < o9 ? 1 : 0;
    case "<=":
      return s9 <= o9 ? 1 : 0;
    case ">":
      return s9 > o9 ? 1 : 0;
    case ">=":
      return s9 >= o9 ? 1 : 0;
    case "==":
      return s9 === o9 ? 1 : 0;
    case "!=":
      return s9 !== o9 ? 1 : 0;
  }
  return 0;
}
async function st2(e5, t6) {
  let n23 = await f6(e5, t6.operand);
  switch (t6.operator) {
    case "!":
      return v6(n23) ? 0 : 1;
    case "-":
      return -m7(n23);
    case "+":
      return +m7(n23);
    default:
      return n23;
  }
}
async function at2(e5, t6, n23) {
  let i10 = de4.get(t6);
  if (i10) return i10(n23, e5, { evalExpr: (s9) => f6(e5, s9) });
  let a7 = e5.functions.get(t6);
  return a7 ? ot2(e5, a7, n23) : "";
}
async function ot2(e5, t6, n23) {
  if (e5.currentRecursionDepth++, e5.currentRecursionDepth > e5.maxRecursionDepth) throw e5.currentRecursionDepth--, new b2(`awk: recursion depth exceeded maximum (${e5.maxRecursionDepth})`, "recursion", e5.output);
  let i10 = /* @__PURE__ */ Object.create(null);
  for (let o9 of t6.params) i10[o9] = e5.vars[o9];
  let a7 = [];
  for (let o9 = 0; o9 < t6.params.length; o9++) {
    let c14 = t6.params[o9];
    if (o9 < n23.length) {
      let u10 = n23[o9];
      u10.type === "variable" && (e5.arrayAliases.set(c14, u10.name), a7.push(c14));
      let N14 = await f6(e5, u10);
      e5.vars[c14] = N14;
    } else e5.vars[c14] = "";
  }
  e5.hasReturn = false, e5.returnValue = void 0, ee4 && await ee4(e5, t6.body.statements);
  let s9 = e5.returnValue ?? "";
  for (let o9 of t6.params) i10[o9] !== void 0 ? e5.vars[o9] = i10[o9] : delete e5.vars[o9];
  for (let o9 of a7) e5.arrayAliases.delete(o9);
  return e5.hasReturn = false, e5.returnValue = void 0, e5.currentRecursionDepth--, s9;
}
async function lt(e5, t6) {
  let n23 = await f6(e5, t6.value), i10 = t6.target, a7 = t6.operator, s9;
  if (a7 === "=") s9 = n23;
  else {
    let o9;
    if (i10.type === "field") {
      let N14 = Math.floor(m7(await f6(e5, i10.index)));
      o9 = H7(e5, N14);
    } else if (i10.type === "variable") o9 = $8(e5, i10.name);
    else {
      let N14 = S3(await f6(e5, i10.key));
      o9 = W6(e5, i10.array, N14);
    }
    let c14 = m7(o9), u10 = m7(n23);
    switch (a7) {
      case "+=":
        s9 = c14 + u10;
        break;
      case "-=":
        s9 = c14 - u10;
        break;
      case "*=":
        s9 = c14 * u10;
        break;
      case "/=":
        s9 = u10 !== 0 ? c14 / u10 : 0;
        break;
      case "%=":
        s9 = u10 !== 0 ? c14 % u10 : 0;
        break;
      case "^=":
        s9 = c14 ** u10;
        break;
      default:
        s9 = n23;
    }
  }
  if (i10.type === "field") {
    let o9 = Math.floor(m7(await f6(e5, i10.index)));
    Z6(e5, o9, s9);
  } else if (i10.type === "variable") F6(e5, i10.name, s9);
  else {
    let o9 = S3(await f6(e5, i10.key));
    Y6(e5, i10.array, o9, s9);
  }
  return s9;
}
async function V6(e5, t6, n23, i10) {
  let a7;
  if (t6.type === "field") {
    let s9 = Math.floor(m7(await f6(e5, t6.index)));
    a7 = m7(H7(e5, s9)), Z6(e5, s9, a7 + n23);
  } else if (t6.type === "variable") a7 = m7($8(e5, t6.name)), F6(e5, t6.name, a7 + n23);
  else {
    let s9 = S3(await f6(e5, t6.key));
    a7 = m7(W6(e5, t6.array, s9)), Y6(e5, t6.array, s9, a7 + n23);
  }
  return i10 ? a7 + n23 : a7;
}
async function ct(e5, t6) {
  return V6(e5, t6, 1, true);
}
async function ut(e5, t6) {
  return V6(e5, t6, -1, true);
}
async function ht(e5, t6) {
  return V6(e5, t6, 1, false);
}
async function pt(e5, t6) {
  return V6(e5, t6, -1, false);
}
async function ft(e5, t6, n23) {
  let i10;
  if (t6.type === "tuple") {
    e5.coverage?.hit("awk:expr:tuple");
    let a7 = [];
    for (let s9 of t6.elements) a7.push(S3(await f6(e5, s9)));
    i10 = a7.join(e5.SUBSEP);
  } else i10 = S3(await f6(e5, t6));
  return Se(e5, n23, i10) ? 1 : 0;
}
async function dt(e5, t6, n23, i10) {
  if (i10) return Et(e5, t6, i10);
  if (n23) return Nt(e5, t6, n23);
  if (!e5.lines || e5.lineIndex === void 0) return -1;
  let a7 = e5.lineIndex + 1;
  if (a7 >= e5.lines.length) return 0;
  let s9 = e5.lines[a7];
  return t6 ? F6(e5, t6, s9) : T2(e5, s9), e5.NR++, e5.lineIndex = a7, 1;
}
async function Et(e5, t6, n23) {
  if (!e5.exec) return -1;
  let i10 = S3(await f6(e5, n23)), a7 = `__cmd_${i10}`, s9 = `__cmdi_${i10}`, o9, c14;
  if (e5.vars[a7] === void 0) try {
    o9 = (await e5.exec(i10)).stdout.split(`
`), o9.length > 0 && o9[o9.length - 1] === "" && o9.pop(), e5.vars[a7] = JSON.stringify(o9), e5.vars[s9] = -1, c14 = -1;
  } catch {
    return -1;
  }
  else o9 = JSON.parse(e5.vars[a7]), c14 = e5.vars[s9];
  let u10 = c14 + 1;
  if (u10 >= o9.length) return 0;
  let N14 = o9[u10];
  return e5.vars[s9] = u10, t6 ? F6(e5, t6, N14) : T2(e5, N14), 1;
}
async function Nt(e5, t6, n23) {
  if (!e5.fs || !e5.cwd) return -1;
  let i10 = S3(await f6(e5, n23));
  if (i10 === "/dev/null") return 0;
  let a7 = e5.fs.resolvePath(e5.cwd, i10), s9 = `__fc_${a7}`, o9 = `__fi_${a7}`, c14, u10;
  if (e5.vars[s9] === void 0) try {
    c14 = (await e5.fs.readFile(a7)).split(`
`), c14.length > 0 && c14[c14.length - 1] === "" && c14.pop(), e5.vars[s9] = JSON.stringify(c14), e5.vars[o9] = -1, u10 = -1;
  } catch {
    return -1;
  }
  else c14 = JSON.parse(e5.vars[s9]), u10 = e5.vars[o9];
  let N14 = u10 + 1;
  if (N14 >= c14.length) return 0;
  let k15 = c14[N14];
  return e5.vars[o9] = N14, t6 ? F6(e5, t6, k15) : T2(e5, k15), 1;
}
async function St(e5, t6) {
  if (t6.length === 0) return "";
  for (let n23 = 0; n23 < t6.length - 1; n23++) await f6(e5, t6[n23]);
  return f6(e5, t6[t6.length - 1]);
}
function te5(e5) {
  if (e5.maxOutputSize > 0 && e5.output.length > e5.maxOutputSize) throw new b2(`awk: output size limit exceeded (${e5.maxOutputSize} bytes)`, "string_length", e5.output);
}
async function _4(e5, t6) {
  for (let n23 of t6) if (await M4(e5, n23), yt(e5)) break;
}
function yt(e5) {
  return e5.shouldExit || e5.shouldNext || e5.shouldNextFile || e5.loopBreak || e5.loopContinue || e5.hasReturn;
}
async function M4(e5, t6) {
  switch (e5.coverage?.hit(`awk:stmt:${t6.type}`), t6.type) {
    case "block":
      await _4(e5, t6.statements);
      break;
    case "expr_stmt":
      await f6(e5, t6.expression);
      break;
    case "print":
      await Rt(e5, t6.args, t6.output);
      break;
    case "printf":
      await mt(e5, t6.format, t6.args, t6.output);
      break;
    case "if":
      await At(e5, t6);
      break;
    case "while":
      await wt(e5, t6);
      break;
    case "do_while":
      await gt(e5, t6);
      break;
    case "for":
      await It2(e5, t6);
      break;
    case "for_in":
      await vt2(e5, t6);
      break;
    case "break":
      e5.loopBreak = true;
      break;
    case "continue":
      e5.loopContinue = true;
      break;
    case "next":
      e5.shouldNext = true;
      break;
    case "nextfile":
      e5.shouldNextFile = true;
      break;
    case "exit":
      e5.shouldExit = true, e5.exitCode = t6.code ? Math.floor(m7(await f6(e5, t6.code))) : 0;
      break;
    case "return":
      e5.hasReturn = true, e5.returnValue = t6.value ? await f6(e5, t6.value) : "";
      break;
    case "delete":
      await kt(e5, t6.target);
      break;
  }
}
async function Rt(e5, t6, n23) {
  let i10 = [];
  for (let s9 of t6) {
    let o9 = await f6(e5, s9);
    typeof o9 == "number" ? Number.isInteger(o9) && Math.abs(o9) < Number.MAX_SAFE_INTEGER ? i10.push(String(o9)) : i10.push(B5(e5.OFMT, [o9])) : i10.push(S3(o9));
  }
  let a7 = i10.join(e5.OFS) + e5.ORS;
  n23 ? await Ae2(e5, n23.redirect, n23.file, a7) : (e5.output += a7, te5(e5));
}
async function mt(e5, t6, n23, i10) {
  let a7 = S3(await f6(e5, t6)), s9 = [];
  for (let c14 of n23) s9.push(await f6(e5, c14));
  let o9 = B5(a7, s9);
  i10 ? await Ae2(e5, i10.redirect, i10.file, o9) : (e5.output += o9, te5(e5));
}
async function Ae2(e5, t6, n23, i10) {
  if (!e5.fs || !e5.cwd) {
    e5.output += i10, te5(e5);
    return;
  }
  let a7 = S3(await f6(e5, n23)), s9 = e5.fs.resolvePath(e5.cwd, a7);
  t6 === ">" ? e5.openedFiles.has(s9) ? await e5.fs.appendFile(s9, i10) : (await e5.fs.writeFile(s9, i10), e5.openedFiles.add(s9)) : (e5.openedFiles.has(s9) || e5.openedFiles.add(s9), await e5.fs.appendFile(s9, i10));
}
async function At(e5, t6) {
  v6(await f6(e5, t6.condition)) ? await M4(e5, t6.consequent) : t6.alternate && await M4(e5, t6.alternate);
}
async function wt(e5, t6) {
  let n23 = 0;
  for (; v6(await f6(e5, t6.condition)); ) {
    if (n23++, n23 > e5.maxIterations) throw new b2(`awk: while loop exceeded maximum iterations (${e5.maxIterations})`, "iterations", e5.output);
    if (e5.loopContinue = false, await M4(e5, t6.body), e5.loopBreak) {
      e5.loopBreak = false;
      break;
    }
    if (e5.shouldExit || e5.shouldNext || e5.hasReturn) break;
  }
}
async function gt(e5, t6) {
  let n23 = 0;
  do {
    if (n23++, n23 > e5.maxIterations) throw new b2(`awk: do-while loop exceeded maximum iterations (${e5.maxIterations})`, "iterations", e5.output);
    if (e5.loopContinue = false, await M4(e5, t6.body), e5.loopBreak) {
      e5.loopBreak = false;
      break;
    }
    if (e5.shouldExit || e5.shouldNext || e5.hasReturn) break;
  } while (v6(await f6(e5, t6.condition)));
}
async function It2(e5, t6) {
  t6.init && await f6(e5, t6.init);
  let n23 = 0;
  for (; !t6.condition || v6(await f6(e5, t6.condition)); ) {
    if (n23++, n23 > e5.maxIterations) throw new b2(`awk: for loop exceeded maximum iterations (${e5.maxIterations})`, "iterations", e5.output);
    if (e5.loopContinue = false, await M4(e5, t6.body), e5.loopBreak) {
      e5.loopBreak = false;
      break;
    }
    if (e5.shouldExit || e5.shouldNext || e5.hasReturn) break;
    t6.update && await f6(e5, t6.update);
  }
}
async function vt2(e5, t6) {
  let n23 = e5.arrays[t6.array];
  if (n23) for (let i10 of Object.keys(n23)) {
    if (e5.vars[t6.variable] = i10, e5.loopContinue = false, await M4(e5, t6.body), e5.loopBreak) {
      e5.loopBreak = false;
      break;
    }
    if (e5.shouldExit || e5.shouldNext || e5.hasReturn) break;
  }
}
async function kt(e5, t6) {
  if (t6.type === "array_access") {
    let n23 = S3(await f6(e5, t6.key));
    ye3(e5, t6.array, n23);
  } else t6.type === "variable" && Re3(e5, t6.name);
}
function Ot2(e5) {
  return e5.replace(/\[\[:space:\]\]/g, "[ \\t\\n\\r\\f\\v]").replace(/\[\[:blank:\]\]/g, "[ \\t]").replace(/\[\[:alpha:\]\]/g, "[a-zA-Z]").replace(/\[\[:digit:\]\]/g, "[0-9]").replace(/\[\[:alnum:\]\]/g, "[a-zA-Z0-9]").replace(/\[\[:upper:\]\]/g, "[A-Z]").replace(/\[\[:lower:\]\]/g, "[a-z]").replace(/\[\[:punct:\]\]/g, "[!\"#$%&'()*+,\\-./:;<=>?@\\[\\]\\\\^_`{|}~]").replace(/\[\[:xdigit:\]\]/g, "[0-9A-Fa-f]").replace(/\[\[:graph:\]\]/g, "[!-~]").replace(/\[\[:print:\]\]/g, "[ -~]").replace(/\[\[:cntrl:\]\]/g, "[\\x00-\\x1f\\x7f]");
}
function ke(e5) {
  e5.expect(h7.PRINT);
  let t6 = [];
  if (e5.check(h7.NEWLINE) || e5.check(h7.SEMICOLON) || e5.check(h7.RBRACE) || e5.check(h7.PIPE) || e5.check(h7.GT) || e5.check(h7.APPEND)) t6.push({ type: "field", index: { type: "number", value: 0 } });
  else for (t6.push(X5(e5)); e5.check(h7.COMMA); ) e5.advance(), t6.push(X5(e5));
  let n23;
  return e5.check(h7.GT) ? (e5.advance(), n23 = { redirect: ">", file: e5.parsePrimary() }) : e5.check(h7.APPEND) && (e5.advance(), n23 = { redirect: ">>", file: e5.parsePrimary() }), { type: "print", args: t6, output: n23 };
}
function X5(e5) {
  return bt(e5) ? ne4(e5, true) : ne4(e5, false);
}
function ne4(e5, t6) {
  let n23 = t6 ? e5.parseTernary() : Lt2(e5);
  if (e5.match(h7.ASSIGN, h7.PLUS_ASSIGN, h7.MINUS_ASSIGN, h7.STAR_ASSIGN, h7.SLASH_ASSIGN, h7.PERCENT_ASSIGN, h7.CARET_ASSIGN)) {
    let i10 = e5.advance(), a7 = ne4(e5, t6);
    if (n23.type !== "variable" && n23.type !== "field" && n23.type !== "array_access") throw new Error("Invalid assignment target");
    return { type: "assignment", operator: (/* @__PURE__ */ new Map([["=", "="], ["+=", "+="], ["-=", "-="], ["*=", "*="], ["/=", "/="], ["%=", "%="], ["^=", "^="]])).get(i10.value) ?? "=", target: n23, value: a7 };
  }
  return n23;
}
function bt(e5) {
  let t6 = 0, n23 = e5.pos;
  for (; n23 < e5.tokens.length; ) {
    let i10 = e5.tokens[n23];
    if (i10.type === h7.LPAREN && t6++, i10.type === h7.RPAREN && t6--, i10.type === h7.QUESTION && t6 === 0) return true;
    if (i10.type === h7.NEWLINE || i10.type === h7.SEMICOLON || i10.type === h7.RBRACE || i10.type === h7.COMMA || i10.type === h7.PIPE) return false;
    n23++;
  }
  return false;
}
function Lt2(e5) {
  let t6 = we(e5);
  for (; e5.check(h7.OR); ) {
    e5.advance();
    let n23 = we(e5);
    t6 = { type: "binary", operator: "||", left: t6, right: n23 };
  }
  return t6;
}
function we(e5) {
  let t6 = ge3(e5);
  for (; e5.check(h7.AND); ) {
    e5.advance();
    let n23 = ge3(e5);
    t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
  }
  return t6;
}
function ge3(e5) {
  let t6 = Mt2(e5);
  if (e5.check(h7.IN)) {
    e5.advance();
    let n23 = String(e5.expect(h7.IDENT).value);
    return { type: "in", key: t6, array: n23 };
  }
  return t6;
}
function Mt2(e5) {
  let t6 = Ie2(e5);
  for (; Pt(e5) && !Tt2(e5); ) {
    let n23 = Ie2(e5);
    t6 = { type: "binary", operator: " ", left: t6, right: n23 };
  }
  return t6;
}
function Ie2(e5) {
  let t6 = ve2(e5);
  for (; e5.match(h7.MATCH, h7.NOT_MATCH); ) {
    let n23 = e5.advance().type === h7.MATCH ? "~" : "!~", i10 = ve2(e5);
    t6 = { type: "binary", operator: n23, left: t6, right: i10 };
  }
  return t6;
}
function ve2(e5) {
  let t6 = e5.parseAddSub();
  for (; e5.match(h7.LT, h7.LE, h7.GE, h7.EQ, h7.NE); ) {
    let n23 = e5.advance(), i10 = e5.parseAddSub();
    t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["<", "<"], ["<=", "<="], [">=", ">="], ["==", "=="], ["!=", "!="]])).get(n23.value) ?? "==", left: t6, right: i10 };
  }
  return t6;
}
function Pt(e5) {
  return e5.match(h7.NUMBER, h7.STRING, h7.IDENT, h7.DOLLAR, h7.LPAREN, h7.NOT, h7.MINUS, h7.PLUS, h7.INCREMENT, h7.DECREMENT);
}
function Tt2(e5) {
  return e5.match(h7.AND, h7.OR, h7.QUESTION, h7.ASSIGN, h7.PLUS_ASSIGN, h7.MINUS_ASSIGN, h7.STAR_ASSIGN, h7.SLASH_ASSIGN, h7.PERCENT_ASSIGN, h7.CARET_ASSIGN, h7.COMMA, h7.SEMICOLON, h7.NEWLINE, h7.RBRACE, h7.RPAREN, h7.RBRACKET, h7.COLON, h7.PIPE, h7.APPEND, h7.GT, h7.IN);
}
function Ce(e5) {
  e5.expect(h7.PRINTF);
  let t6 = e5.check(h7.LPAREN);
  t6 && (e5.advance(), e5.skipNewlines());
  let n23 = t6 ? e5.parseExpression() : X5(e5), i10 = [];
  for (; e5.check(h7.COMMA); ) e5.advance(), t6 && e5.skipNewlines(), i10.push(t6 ? e5.parseExpression() : X5(e5));
  t6 && (e5.skipNewlines(), e5.expect(h7.RPAREN));
  let a7;
  return e5.check(h7.GT) ? (e5.advance(), a7 = { redirect: ">", file: e5.parsePrimary() }) : e5.check(h7.APPEND) && (e5.advance(), a7 = { redirect: ">>", file: e5.parsePrimary() }), { type: "printf", format: n23, args: i10, output: a7 };
}
function re3(e5) {
  return e5.replace(/\\t/g, "	").replace(/\\n/g, `
`).replace(/\\r/g, "\r").replace(/\\b/g, "\b").replace(/\\f/g, "\f").replace(/\\a/g, "\x07").replace(/\\v/g, "\v").replace(/\\\\/g, "\\");
}
function Oe(e5) {
  if (e5 === " ") return b1("\\s+");
  if (/[[\](){}.*+?^$|\\]/.test(e5)) try {
    return b1(e5);
  } catch {
    return b1(be(e5));
  }
  return b1(be(e5));
}
function be(e5) {
  return e5.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var Le2, Me, Pe2, L5, de4, ee4, x6, r6, Ct2, K7, h7, j3, Ft2, On, bn;
var init_chunk_3KWUDRIP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-3KWUDRIP.js"() {
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    Le2 = 1e4;
    Me = 100;
    Pe2 = new i1(/\s+/);
    L5 = 1e4;
    de4 = /* @__PURE__ */ new Map([["length", Te], ["substr", Fe2], ["index", _e], ["split", Ge2], ["sub", De2], ["gsub", xe2], ["match", Ue2], ["gensub", Be], ["tolower", He2], ["toupper", $e], ["sprintf", We], ["int", Ve], ["sqrt", Ke2], ["sin", Xe2], ["cos", je2], ["atan2", ze2], ["log", Qe2], ["exp", qe], ["rand", Je2], ["srand", Ze2], ["system", Ye2("system", "shell execution not allowed in sandboxed environment")], ["close", () => 0], ["fflush", () => 0], ["systime", q7("systime")], ["mktime", q7("mktime")], ["strftime", q7("strftime")]]);
    ee4 = null;
    me2(_4);
    x6 = class {
      ctx;
      program = null;
      rangeStates = [];
      constructor(t6) {
        this.ctx = t6;
      }
      execute(t6) {
        this.program = t6, this.ctx.output = "";
        for (let n23 of t6.functions) this.ctx.functions.set(n23.name, n23);
        this.rangeStates = t6.rules.map(() => false);
      }
      async executeBegin() {
        if (this.program) {
          for (let t6 of this.program.rules) if (t6.pattern?.type === "begin" && (await _4(this.ctx, t6.action.statements), this.ctx.shouldExit)) break;
        }
      }
      async executeLine(t6) {
        if (!(!this.program || this.ctx.shouldExit)) {
          T2(this.ctx, t6), this.ctx.NR++, this.ctx.FNR++, this.ctx.shouldNext = false;
          for (let n23 = 0; n23 < this.program.rules.length && !(this.ctx.shouldExit || this.ctx.shouldNext || this.ctx.shouldNextFile); n23++) {
            let i10 = this.program.rules[n23];
            i10.pattern?.type === "begin" || i10.pattern?.type === "end" || await this.matchesRule(i10, n23) && await _4(this.ctx, i10.action.statements);
          }
        }
      }
      async executeEnd() {
        if (this.program && !this.ctx.inEndBlock) {
          this.ctx.inEndBlock = true, this.ctx.shouldExit = false;
          for (let t6 of this.program.rules) if (t6.pattern?.type === "end" && (await _4(this.ctx, t6.action.statements), this.ctx.shouldExit)) break;
          this.ctx.inEndBlock = false;
        }
      }
      getOutput() {
        return this.ctx.output;
      }
      getExitCode() {
        return this.ctx.exitCode;
      }
      getContext() {
        return this.ctx;
      }
      async matchesRule(t6, n23) {
        let i10 = t6.pattern;
        if (!i10) return true;
        switch (i10.type) {
          case "begin":
          case "end":
            return false;
          case "regex_pattern":
            return G4(i10.pattern, this.ctx.line);
          case "expr_pattern":
            return v6(await f6(this.ctx, i10.expression));
          case "range": {
            let a7 = await this.matchPattern(i10.start), s9 = await this.matchPattern(i10.end);
            return this.rangeStates[n23] ? (s9 && (this.rangeStates[n23] = false), true) : a7 ? (this.rangeStates[n23] = true, s9 && (this.rangeStates[n23] = false), true) : false;
          }
          default:
            return false;
        }
      }
      async matchPattern(t6) {
        switch (t6.type) {
          case "regex_pattern":
            return G4(t6.pattern, this.ctx.line);
          case "expr_pattern":
            return v6(await f6(this.ctx, t6.expression));
          default:
            return false;
        }
      }
    };
    (function(e5) {
      e5.NUMBER = "NUMBER", e5.STRING = "STRING", e5.REGEX = "REGEX", e5.IDENT = "IDENT", e5.BEGIN = "BEGIN", e5.END = "END", e5.IF = "IF", e5.ELSE = "ELSE", e5.WHILE = "WHILE", e5.DO = "DO", e5.FOR = "FOR", e5.IN = "IN", e5.BREAK = "BREAK", e5.CONTINUE = "CONTINUE", e5.NEXT = "NEXT", e5.NEXTFILE = "NEXTFILE", e5.EXIT = "EXIT", e5.RETURN = "RETURN", e5.DELETE = "DELETE", e5.FUNCTION = "FUNCTION", e5.PRINT = "PRINT", e5.PRINTF = "PRINTF", e5.GETLINE = "GETLINE", e5.PLUS = "PLUS", e5.MINUS = "MINUS", e5.STAR = "STAR", e5.SLASH = "SLASH", e5.PERCENT = "PERCENT", e5.CARET = "CARET", e5.EQ = "EQ", e5.NE = "NE", e5.LT = "LT", e5.GT = "GT", e5.LE = "LE", e5.GE = "GE", e5.MATCH = "MATCH", e5.NOT_MATCH = "NOT_MATCH", e5.AND = "AND", e5.OR = "OR", e5.NOT = "NOT", e5.ASSIGN = "ASSIGN", e5.PLUS_ASSIGN = "PLUS_ASSIGN", e5.MINUS_ASSIGN = "MINUS_ASSIGN", e5.STAR_ASSIGN = "STAR_ASSIGN", e5.SLASH_ASSIGN = "SLASH_ASSIGN", e5.PERCENT_ASSIGN = "PERCENT_ASSIGN", e5.CARET_ASSIGN = "CARET_ASSIGN", e5.INCREMENT = "INCREMENT", e5.DECREMENT = "DECREMENT", e5.QUESTION = "QUESTION", e5.COLON = "COLON", e5.COMMA = "COMMA", e5.SEMICOLON = "SEMICOLON", e5.NEWLINE = "NEWLINE", e5.LPAREN = "LPAREN", e5.RPAREN = "RPAREN", e5.LBRACE = "LBRACE", e5.RBRACE = "RBRACE", e5.LBRACKET = "LBRACKET", e5.RBRACKET = "RBRACKET", e5.DOLLAR = "DOLLAR", e5.APPEND = "APPEND", e5.PIPE = "PIPE", e5.EOF = "EOF";
    })(r6 || (r6 = {}));
    Ct2 = /* @__PURE__ */ new Map([["BEGIN", r6.BEGIN], ["END", r6.END], ["if", r6.IF], ["else", r6.ELSE], ["while", r6.WHILE], ["do", r6.DO], ["for", r6.FOR], ["in", r6.IN], ["break", r6.BREAK], ["continue", r6.CONTINUE], ["next", r6.NEXT], ["nextfile", r6.NEXTFILE], ["exit", r6.EXIT], ["return", r6.RETURN], ["delete", r6.DELETE], ["function", r6.FUNCTION], ["print", r6.PRINT], ["printf", r6.PRINTF], ["getline", r6.GETLINE]]);
    K7 = class {
      input;
      pos = 0;
      line = 1;
      column = 1;
      lastTokenType = null;
      constructor(t6) {
        this.input = t6;
      }
      tokenize() {
        let t6 = [];
        for (; this.pos < this.input.length; ) {
          let n23 = this.nextToken();
          n23 && (t6.push(n23), this.lastTokenType = n23.type);
        }
        return t6.push(this.makeToken(r6.EOF, "")), t6;
      }
      makeToken(t6, n23) {
        return { type: t6, value: n23, line: this.line, column: this.column };
      }
      peek(t6 = 0) {
        return this.input[this.pos + t6] || "";
      }
      advance() {
        let t6 = this.input[this.pos++] || "";
        return t6 === `
` ? (this.line++, this.column = 1) : this.column++, t6;
      }
      skipWhitespace() {
        for (; this.pos < this.input.length; ) {
          let t6 = this.peek();
          if (t6 === " " || t6 === "	" || t6 === "\r") this.advance();
          else if (t6 === "\\") if (this.peek(1) === `
`) this.advance(), this.advance();
          else break;
          else if (t6 === "#") for (; this.pos < this.input.length && this.peek() !== `
`; ) this.advance();
          else break;
        }
      }
      nextToken() {
        if (this.skipWhitespace(), this.pos >= this.input.length) return null;
        let t6 = this.line, n23 = this.column, i10 = this.peek();
        return i10 === `
` ? (this.advance(), { type: r6.NEWLINE, value: `
`, line: t6, column: n23 }) : i10 === '"' ? this.readString() : i10 === "/" && this.canBeRegex() ? this.readRegex() : this.isDigit(i10) || i10 === "." && this.isDigit(this.peek(1)) ? this.readNumber() : this.isAlpha(i10) || i10 === "_" ? this.readIdentifier() : this.readOperator();
      }
      canBeRegex() {
        return (/* @__PURE__ */ new Set([null, r6.NEWLINE, r6.SEMICOLON, r6.LBRACE, r6.RBRACE, r6.LPAREN, r6.LBRACKET, r6.COMMA, r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN, r6.AND, r6.OR, r6.NOT, r6.MATCH, r6.NOT_MATCH, r6.QUESTION, r6.COLON, r6.LT, r6.GT, r6.LE, r6.GE, r6.EQ, r6.NE, r6.PLUS, r6.MINUS, r6.STAR, r6.PERCENT, r6.CARET, r6.PRINT, r6.PRINTF, r6.IF, r6.WHILE, r6.DO, r6.FOR, r6.RETURN])).has(this.lastTokenType);
      }
      readString() {
        let t6 = this.line, n23 = this.column;
        this.advance();
        let i10 = "";
        for (; this.pos < this.input.length && this.peek() !== '"'; ) if (this.peek() === "\\") {
          this.advance();
          let a7 = this.advance();
          switch (a7) {
            case "n":
              i10 += `
`;
              break;
            case "t":
              i10 += "	";
              break;
            case "r":
              i10 += "\r";
              break;
            case "f":
              i10 += "\f";
              break;
            case "b":
              i10 += "\b";
              break;
            case "v":
              i10 += "\v";
              break;
            case "a":
              i10 += "\x07";
              break;
            case "\\":
              i10 += "\\";
              break;
            case '"':
              i10 += '"';
              break;
            case "/":
              i10 += "/";
              break;
            case "x": {
              let s9 = "";
              for (; s9.length < 2 && /[0-9a-fA-F]/.test(this.peek()); ) s9 += this.advance();
              s9.length > 0 ? i10 += String.fromCharCode(parseInt(s9, 16)) : i10 += "x";
              break;
            }
            default:
              if (/[0-7]/.test(a7)) {
                let s9 = a7;
                for (; s9.length < 3 && /[0-7]/.test(this.peek()); ) s9 += this.advance();
                i10 += String.fromCharCode(parseInt(s9, 8));
              } else i10 += a7;
          }
        } else i10 += this.advance();
        return this.peek() === '"' && this.advance(), { type: r6.STRING, value: i10, line: t6, column: n23 };
      }
      readRegex() {
        let t6 = this.line, n23 = this.column;
        this.advance();
        let i10 = "";
        for (; this.pos < this.input.length && this.peek() !== "/"; ) if (this.peek() === "\\") i10 += this.advance(), this.pos < this.input.length && (i10 += this.advance());
        else {
          if (this.peek() === `
`) break;
          i10 += this.advance();
        }
        return this.peek() === "/" && this.advance(), i10 = Ot2(i10), { type: r6.REGEX, value: i10, line: t6, column: n23 };
      }
      readNumber() {
        let t6 = this.line, n23 = this.column, i10 = "";
        for (; this.isDigit(this.peek()); ) i10 += this.advance();
        if (this.peek() === "." && this.isDigit(this.peek(1))) for (i10 += this.advance(); this.isDigit(this.peek()); ) i10 += this.advance();
        if (this.peek() === "e" || this.peek() === "E") for (i10 += this.advance(), (this.peek() === "+" || this.peek() === "-") && (i10 += this.advance()); this.isDigit(this.peek()); ) i10 += this.advance();
        return { type: r6.NUMBER, value: parseFloat(i10), line: t6, column: n23 };
      }
      readIdentifier() {
        let t6 = this.line, n23 = this.column, i10 = "";
        for (; this.isAlphaNumeric(this.peek()) || this.peek() === "_"; ) i10 += this.advance();
        let a7 = Ct2.get(i10);
        return a7 !== void 0 ? { type: a7, value: i10, line: t6, column: n23 } : { type: r6.IDENT, value: i10, line: t6, column: n23 };
      }
      readOperator() {
        let t6 = this.line, n23 = this.column, i10 = this.advance(), a7 = this.peek();
        switch (i10) {
          case "+":
            return a7 === "+" ? (this.advance(), { type: r6.INCREMENT, value: "++", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.PLUS_ASSIGN, value: "+=", line: t6, column: n23 }) : { type: r6.PLUS, value: "+", line: t6, column: n23 };
          case "-":
            return a7 === "-" ? (this.advance(), { type: r6.DECREMENT, value: "--", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.MINUS_ASSIGN, value: "-=", line: t6, column: n23 }) : { type: r6.MINUS, value: "-", line: t6, column: n23 };
          case "*":
            return a7 === "*" ? (this.advance(), { type: r6.CARET, value: "**", line: t6, column: n23 }) : a7 === "=" ? (this.advance(), { type: r6.STAR_ASSIGN, value: "*=", line: t6, column: n23 }) : { type: r6.STAR, value: "*", line: t6, column: n23 };
          case "/":
            return a7 === "=" ? (this.advance(), { type: r6.SLASH_ASSIGN, value: "/=", line: t6, column: n23 }) : { type: r6.SLASH, value: "/", line: t6, column: n23 };
          case "%":
            return a7 === "=" ? (this.advance(), { type: r6.PERCENT_ASSIGN, value: "%=", line: t6, column: n23 }) : { type: r6.PERCENT, value: "%", line: t6, column: n23 };
          case "^":
            return a7 === "=" ? (this.advance(), { type: r6.CARET_ASSIGN, value: "^=", line: t6, column: n23 }) : { type: r6.CARET, value: "^", line: t6, column: n23 };
          case "=":
            return a7 === "=" ? (this.advance(), { type: r6.EQ, value: "==", line: t6, column: n23 }) : { type: r6.ASSIGN, value: "=", line: t6, column: n23 };
          case "!":
            return a7 === "=" ? (this.advance(), { type: r6.NE, value: "!=", line: t6, column: n23 }) : a7 === "~" ? (this.advance(), { type: r6.NOT_MATCH, value: "!~", line: t6, column: n23 }) : { type: r6.NOT, value: "!", line: t6, column: n23 };
          case "<":
            return a7 === "=" ? (this.advance(), { type: r6.LE, value: "<=", line: t6, column: n23 }) : { type: r6.LT, value: "<", line: t6, column: n23 };
          case ">":
            return a7 === "=" ? (this.advance(), { type: r6.GE, value: ">=", line: t6, column: n23 }) : a7 === ">" ? (this.advance(), { type: r6.APPEND, value: ">>", line: t6, column: n23 }) : { type: r6.GT, value: ">", line: t6, column: n23 };
          case "&":
            return a7 === "&" ? (this.advance(), { type: r6.AND, value: "&&", line: t6, column: n23 }) : { type: r6.IDENT, value: "&", line: t6, column: n23 };
          case "|":
            return a7 === "|" ? (this.advance(), { type: r6.OR, value: "||", line: t6, column: n23 }) : { type: r6.PIPE, value: "|", line: t6, column: n23 };
          case "~":
            return { type: r6.MATCH, value: "~", line: t6, column: n23 };
          case "?":
            return { type: r6.QUESTION, value: "?", line: t6, column: n23 };
          case ":":
            return { type: r6.COLON, value: ":", line: t6, column: n23 };
          case ",":
            return { type: r6.COMMA, value: ",", line: t6, column: n23 };
          case ";":
            return { type: r6.SEMICOLON, value: ";", line: t6, column: n23 };
          case "(":
            return { type: r6.LPAREN, value: "(", line: t6, column: n23 };
          case ")":
            return { type: r6.RPAREN, value: ")", line: t6, column: n23 };
          case "{":
            return { type: r6.LBRACE, value: "{", line: t6, column: n23 };
          case "}":
            return { type: r6.RBRACE, value: "}", line: t6, column: n23 };
          case "[":
            return { type: r6.LBRACKET, value: "[", line: t6, column: n23 };
          case "]":
            return { type: r6.RBRACKET, value: "]", line: t6, column: n23 };
          case "$":
            return { type: r6.DOLLAR, value: "$", line: t6, column: n23 };
          default:
            return { type: r6.IDENT, value: i10, line: t6, column: n23 };
        }
      }
      isDigit(t6) {
        return t6 >= "0" && t6 <= "9";
      }
      isAlpha(t6) {
        return t6 >= "a" && t6 <= "z" || t6 >= "A" && t6 <= "Z";
      }
      isAlphaNumeric(t6) {
        return this.isDigit(t6) || this.isAlpha(t6);
      }
    };
    h7 = { LPAREN: "LPAREN", RPAREN: "RPAREN", QUESTION: "QUESTION", NEWLINE: "NEWLINE", SEMICOLON: "SEMICOLON", RBRACE: "RBRACE", COMMA: "COMMA", PIPE: "PIPE", GT: "GT", APPEND: "APPEND", AND: "AND", OR: "OR", ASSIGN: "ASSIGN", PLUS_ASSIGN: "PLUS_ASSIGN", MINUS_ASSIGN: "MINUS_ASSIGN", STAR_ASSIGN: "STAR_ASSIGN", SLASH_ASSIGN: "SLASH_ASSIGN", PERCENT_ASSIGN: "PERCENT_ASSIGN", CARET_ASSIGN: "CARET_ASSIGN", RBRACKET: "RBRACKET", COLON: "COLON", IN: "IN", PRINT: "PRINT", PRINTF: "PRINTF", IDENT: "IDENT", LT: "LT", LE: "LE", GE: "GE", EQ: "EQ", NE: "NE", MATCH: "MATCH", NOT_MATCH: "NOT_MATCH", NUMBER: "NUMBER", STRING: "STRING", DOLLAR: "DOLLAR", NOT: "NOT", MINUS: "MINUS", PLUS: "PLUS", INCREMENT: "INCREMENT", DECREMENT: "DECREMENT" };
    j3 = class {
      tokens = [];
      pos = 0;
      parse(t6) {
        let n23 = new K7(t6);
        return this.tokens = n23.tokenize(), this.pos = 0, this.parseProgram();
      }
      setPos(t6) {
        this.pos = t6;
      }
      current() {
        return this.tokens[this.pos] || { type: r6.EOF, value: "", line: 0, column: 0 };
      }
      advance() {
        let t6 = this.current();
        return this.pos < this.tokens.length && this.pos++, t6;
      }
      match(...t6) {
        return t6.includes(this.current().type);
      }
      check(t6) {
        return this.current().type === t6;
      }
      expect(t6, n23) {
        if (!this.check(t6)) {
          let i10 = this.current();
          throw new Error(n23 || `Expected ${t6}, got ${i10.type} at line ${i10.line}:${i10.column}`);
        }
        return this.advance();
      }
      skipNewlines() {
        for (; this.check(r6.NEWLINE); ) this.advance();
      }
      skipTerminators() {
        for (; this.check(r6.NEWLINE) || this.check(r6.SEMICOLON); ) this.advance();
      }
      parseProgram() {
        let t6 = [], n23 = [];
        for (this.skipNewlines(); !this.check(r6.EOF) && (this.skipNewlines(), !this.check(r6.EOF)); ) this.check(r6.FUNCTION) ? t6.push(this.parseFunction()) : n23.push(this.parseRule()), this.skipTerminators();
        return { functions: t6, rules: n23 };
      }
      parseFunction() {
        this.expect(r6.FUNCTION);
        let t6 = this.expect(r6.IDENT).value;
        this.expect(r6.LPAREN);
        let n23 = [];
        if (!this.check(r6.RPAREN)) for (n23.push(this.expect(r6.IDENT).value); this.check(r6.COMMA); ) this.advance(), n23.push(this.expect(r6.IDENT).value);
        this.expect(r6.RPAREN), this.skipNewlines();
        let i10 = this.parseBlock();
        return { name: t6, params: n23, body: i10 };
      }
      parseRule() {
        let t6;
        if (this.check(r6.BEGIN)) this.advance(), t6 = { type: "begin" };
        else if (this.check(r6.END)) this.advance(), t6 = { type: "end" };
        else if (this.check(r6.LBRACE)) t6 = void 0;
        else if (this.check(r6.REGEX)) {
          let i10 = this.advance();
          if (this.check(r6.AND) || this.check(r6.OR)) {
            let a7 = { type: "binary", operator: "~", left: { type: "field", index: { type: "number", value: 0 } }, right: { type: "regex", pattern: i10.value } };
            t6 = { type: "expr_pattern", expression: this.parseLogicalOrRest(a7) };
          } else {
            let a7 = { type: "regex_pattern", pattern: i10.value };
            if (this.check(r6.COMMA)) {
              this.advance();
              let s9;
              this.check(r6.REGEX) ? s9 = { type: "regex_pattern", pattern: this.advance().value } : s9 = { type: "expr_pattern", expression: this.parseExpression() }, t6 = { type: "range", start: a7, end: s9 };
            } else t6 = a7;
          }
        } else {
          let a7 = { type: "expr_pattern", expression: this.parseExpression() };
          if (this.check(r6.COMMA)) {
            this.advance();
            let s9;
            this.check(r6.REGEX) ? s9 = { type: "regex_pattern", pattern: this.advance().value } : s9 = { type: "expr_pattern", expression: this.parseExpression() }, t6 = { type: "range", start: a7, end: s9 };
          } else t6 = a7;
        }
        this.skipNewlines();
        let n23;
        return this.check(r6.LBRACE) ? n23 = this.parseBlock() : n23 = { type: "block", statements: [{ type: "print", args: [{ type: "field", index: { type: "number", value: 0 } }] }] }, { pattern: t6, action: n23 };
      }
      parseBlock() {
        this.expect(r6.LBRACE), this.skipNewlines();
        let t6 = [];
        for (; !this.check(r6.RBRACE) && !this.check(r6.EOF); ) t6.push(this.parseStatement()), this.skipTerminators();
        return this.expect(r6.RBRACE), { type: "block", statements: t6 };
      }
      parseStatement() {
        if (this.check(r6.SEMICOLON) || this.check(r6.NEWLINE)) return this.advance(), { type: "block", statements: [] };
        if (this.check(r6.LBRACE)) return this.parseBlock();
        if (this.check(r6.IF)) return this.parseIf();
        if (this.check(r6.WHILE)) return this.parseWhile();
        if (this.check(r6.DO)) return this.parseDoWhile();
        if (this.check(r6.FOR)) return this.parseFor();
        if (this.check(r6.BREAK)) return this.advance(), { type: "break" };
        if (this.check(r6.CONTINUE)) return this.advance(), { type: "continue" };
        if (this.check(r6.NEXT)) return this.advance(), { type: "next" };
        if (this.check(r6.NEXTFILE)) return this.advance(), { type: "nextfile" };
        if (this.check(r6.EXIT)) {
          this.advance();
          let n23;
          return !this.check(r6.NEWLINE) && !this.check(r6.SEMICOLON) && !this.check(r6.RBRACE) && !this.check(r6.EOF) && (n23 = this.parseExpression()), { type: "exit", code: n23 };
        }
        if (this.check(r6.RETURN)) {
          this.advance();
          let n23;
          return !this.check(r6.NEWLINE) && !this.check(r6.SEMICOLON) && !this.check(r6.RBRACE) && !this.check(r6.EOF) && (n23 = this.parseExpression()), { type: "return", value: n23 };
        }
        if (this.check(r6.DELETE)) {
          this.advance();
          let n23 = this.parsePrimary();
          if (n23.type !== "array_access" && n23.type !== "variable") throw new Error("delete requires array element or array");
          return { type: "delete", target: n23 };
        }
        return this.check(r6.PRINT) ? ke(this) : this.check(r6.PRINTF) ? Ce(this) : { type: "expr_stmt", expression: this.parseExpression() };
      }
      parseIf() {
        this.expect(r6.IF), this.expect(r6.LPAREN);
        let t6 = this.parseExpression();
        this.expect(r6.RPAREN), this.skipNewlines();
        let n23 = this.parseStatement();
        this.skipTerminators();
        let i10;
        return this.check(r6.ELSE) && (this.advance(), this.skipNewlines(), i10 = this.parseStatement()), { type: "if", condition: t6, consequent: n23, alternate: i10 };
      }
      parseWhile() {
        this.expect(r6.WHILE), this.expect(r6.LPAREN);
        let t6 = this.parseExpression();
        this.expect(r6.RPAREN), this.skipNewlines();
        let n23 = this.parseStatement();
        return { type: "while", condition: t6, body: n23 };
      }
      parseDoWhile() {
        this.expect(r6.DO), this.skipNewlines();
        let t6 = this.parseStatement();
        this.skipNewlines(), this.expect(r6.WHILE), this.expect(r6.LPAREN);
        let n23 = this.parseExpression();
        return this.expect(r6.RPAREN), { type: "do_while", body: t6, condition: n23 };
      }
      parseFor() {
        if (this.expect(r6.FOR), this.expect(r6.LPAREN), this.check(r6.IDENT)) {
          let s9 = this.advance();
          if (this.check(r6.IN)) {
            this.advance();
            let o9 = this.expect(r6.IDENT).value;
            this.expect(r6.RPAREN), this.skipNewlines();
            let c14 = this.parseStatement();
            return { type: "for_in", variable: s9.value, array: o9, body: c14 };
          }
          this.pos--;
        }
        let t6;
        this.check(r6.SEMICOLON) || (t6 = this.parseExpression()), this.expect(r6.SEMICOLON);
        let n23;
        this.check(r6.SEMICOLON) || (n23 = this.parseExpression()), this.expect(r6.SEMICOLON);
        let i10;
        this.check(r6.RPAREN) || (i10 = this.parseExpression()), this.expect(r6.RPAREN), this.skipNewlines();
        let a7 = this.parseStatement();
        return { type: "for", init: t6, condition: n23, update: i10, body: a7 };
      }
      parseExpression() {
        return this.parseAssignment();
      }
      parseAssignment() {
        let t6 = this.parseTernary();
        if (this.match(r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN)) {
          let n23 = this.advance(), i10 = this.parseAssignment();
          if (t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid assignment target");
          return { type: "assignment", operator: { "=": "=", "+=": "+=", "-=": "-=", "*=": "*=", "/=": "/=", "%=": "%=", "^=": "^=" }[n23.value], target: t6, value: i10 };
        }
        return t6;
      }
      parseTernary() {
        let t6 = this.parsePipeGetline();
        if (this.check(r6.QUESTION)) {
          this.advance();
          let n23 = this.parseExpression();
          this.expect(r6.COLON);
          let i10 = this.parseExpression();
          t6 = { type: "ternary", condition: t6, consequent: n23, alternate: i10 };
        }
        return t6;
      }
      parsePipeGetline() {
        let t6 = this.parseOr();
        if (this.check(r6.PIPE)) {
          if (this.advance(), !this.check(r6.GETLINE)) throw new Error("Expected 'getline' after '|' in expression context");
          this.advance();
          let n23;
          return this.check(r6.IDENT) && (n23 = this.advance().value), { type: "getline", command: t6, variable: n23 };
        }
        return t6;
      }
      parseOr() {
        let t6 = this.parseAnd();
        for (; this.check(r6.OR); ) {
          this.advance();
          let n23 = this.parseAnd();
          t6 = { type: "binary", operator: "||", left: t6, right: n23 };
        }
        return t6;
      }
      parseLogicalOrRest(t6) {
        for (t6 = this.parseLogicalAndRest(t6); this.check(r6.OR); ) {
          this.advance();
          let n23 = this.parseAnd();
          t6 = { type: "binary", operator: "||", left: t6, right: n23 };
        }
        return t6;
      }
      parseLogicalAndRest(t6) {
        for (; this.check(r6.AND); ) {
          this.advance();
          let n23 = this.parseIn();
          t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
        }
        return t6;
      }
      parseAnd() {
        let t6 = this.parseIn();
        for (; this.check(r6.AND); ) {
          this.advance();
          let n23 = this.parseIn();
          t6 = { type: "binary", operator: "&&", left: t6, right: n23 };
        }
        return t6;
      }
      parseIn() {
        let t6 = this.parseConcatenation();
        if (this.check(r6.IN)) {
          this.advance();
          let n23 = this.expect(r6.IDENT).value;
          return { type: "in", key: t6, array: n23 };
        }
        return t6;
      }
      parseConcatenation() {
        let t6 = this.parseMatch();
        for (; this.canStartExpression() && !this.isConcatTerminator(); ) {
          let n23 = this.parseMatch();
          t6 = { type: "binary", operator: " ", left: t6, right: n23 };
        }
        return t6;
      }
      parseMatch() {
        let t6 = this.parseComparison();
        for (; this.match(r6.MATCH, r6.NOT_MATCH); ) {
          let n23 = this.advance().type === r6.MATCH ? "~" : "!~", i10 = this.parseComparison();
          t6 = { type: "binary", operator: n23, left: t6, right: i10 };
        }
        return t6;
      }
      parseComparison() {
        let t6 = this.parseAddSub();
        for (; this.match(r6.LT, r6.LE, r6.GT, r6.GE, r6.EQ, r6.NE); ) {
          let n23 = this.advance(), i10 = this.parseAddSub();
          t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["<", "<"], ["<=", "<="], [">", ">"], [">=", ">="], ["==", "=="], ["!=", "!="]])).get(n23.value) ?? "==", left: t6, right: i10 };
        }
        return t6;
      }
      canStartExpression() {
        return this.match(r6.NUMBER, r6.STRING, r6.IDENT, r6.DOLLAR, r6.LPAREN, r6.NOT, r6.MINUS, r6.PLUS, r6.INCREMENT, r6.DECREMENT);
      }
      isConcatTerminator() {
        return this.match(r6.AND, r6.OR, r6.QUESTION, r6.ASSIGN, r6.PLUS_ASSIGN, r6.MINUS_ASSIGN, r6.STAR_ASSIGN, r6.SLASH_ASSIGN, r6.PERCENT_ASSIGN, r6.CARET_ASSIGN, r6.COMMA, r6.SEMICOLON, r6.NEWLINE, r6.RBRACE, r6.RPAREN, r6.RBRACKET, r6.COLON, r6.PIPE, r6.APPEND, r6.IN);
      }
      parseAddSub() {
        let t6 = this.parseMulDiv();
        for (; this.match(r6.PLUS, r6.MINUS); ) {
          let n23 = this.advance().value, i10 = this.parseMulDiv();
          t6 = { type: "binary", operator: n23, left: t6, right: i10 };
        }
        return t6;
      }
      parseMulDiv() {
        let t6 = this.parseUnary();
        for (; this.match(r6.STAR, r6.SLASH, r6.PERCENT); ) {
          let n23 = this.advance(), i10 = this.parseUnary();
          t6 = { type: "binary", operator: (/* @__PURE__ */ new Map([["*", "*"], ["/", "/"], ["%", "%"]])).get(n23.value) ?? "*", left: t6, right: i10 };
        }
        return t6;
      }
      parseUnary() {
        if (this.check(r6.INCREMENT)) {
          this.advance();
          let t6 = this.parseUnary();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "+", operand: { type: "unary", operator: "+", operand: t6 } } : { type: "pre_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          this.advance();
          let t6 = this.parseUnary();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "-", operand: { type: "unary", operator: "-", operand: t6 } } : { type: "pre_decrement", operand: t6 };
        }
        if (this.match(r6.NOT, r6.MINUS, r6.PLUS)) {
          let t6 = this.advance().value, n23 = this.parseUnary();
          return { type: "unary", operator: t6, operand: n23 };
        }
        return this.parsePower();
      }
      parsePower() {
        let t6 = this.parsePostfix();
        if (this.check(r6.CARET)) {
          this.advance();
          let n23 = this.parsePower();
          t6 = { type: "binary", operator: "^", left: t6, right: n23 };
        }
        return t6;
      }
      parsePostfix() {
        let t6 = this.parsePrimary();
        if (this.check(r6.INCREMENT)) {
          if (this.advance(), t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid increment operand");
          return { type: "post_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          if (this.advance(), t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access") throw new Error("Invalid decrement operand");
          return { type: "post_decrement", operand: t6 };
        }
        return t6;
      }
      parseFieldIndex() {
        if (this.check(r6.INCREMENT)) {
          this.advance();
          let t6 = this.parseFieldIndex();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "+", operand: { type: "unary", operator: "+", operand: t6 } } : { type: "pre_increment", operand: t6 };
        }
        if (this.check(r6.DECREMENT)) {
          this.advance();
          let t6 = this.parseFieldIndex();
          return t6.type !== "variable" && t6.type !== "field" && t6.type !== "array_access" ? { type: "unary", operator: "-", operand: { type: "unary", operator: "-", operand: t6 } } : { type: "pre_decrement", operand: t6 };
        }
        if (this.match(r6.NOT, r6.MINUS, r6.PLUS)) {
          let t6 = this.advance().value, n23 = this.parseFieldIndex();
          return { type: "unary", operator: t6, operand: n23 };
        }
        return this.parseFieldIndexPower();
      }
      parseFieldIndexPower() {
        let t6 = this.parseFieldIndexPrimary();
        if (this.check(r6.CARET)) {
          this.advance();
          let n23 = this.parseFieldIndexPower();
          t6 = { type: "binary", operator: "^", left: t6, right: n23 };
        }
        return t6;
      }
      parseFieldIndexPrimary() {
        if (this.check(r6.NUMBER)) return { type: "number", value: this.advance().value };
        if (this.check(r6.STRING)) return { type: "string", value: this.advance().value };
        if (this.check(r6.DOLLAR)) return this.advance(), { type: "field", index: this.parseFieldIndex() };
        if (this.check(r6.LPAREN)) {
          this.advance();
          let t6 = this.parseExpression();
          return this.expect(r6.RPAREN), t6;
        }
        if (this.check(r6.IDENT)) {
          let t6 = this.advance().value;
          if (this.check(r6.LPAREN)) {
            this.advance();
            let n23 = [];
            if (!this.check(r6.RPAREN)) for (n23.push(this.parseExpression()); this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            return this.expect(r6.RPAREN), { type: "call", name: t6, args: n23 };
          }
          if (this.check(r6.LBRACKET)) {
            this.advance();
            let n23 = this.parseExpression();
            if (this.check(r6.COMMA)) {
              let i10 = [n23];
              for (; this.check(r6.COMMA); ) this.advance(), i10.push(this.parseExpression());
              this.expect(r6.RBRACKET);
              let a7 = i10.reduce((s9, o9) => ({ type: "binary", operator: " ", left: { type: "binary", operator: " ", left: s9, right: { type: "variable", name: "SUBSEP" } }, right: o9 }));
              return { type: "array_access", array: t6, key: a7 };
            }
            return this.expect(r6.RBRACKET), { type: "array_access", array: t6, key: n23 };
          }
          return { type: "variable", name: t6 };
        }
        throw new Error(`Unexpected token in field index: ${this.current().type} at line ${this.current().line}:${this.current().column}`);
      }
      parsePrimary() {
        if (this.check(r6.NUMBER)) return { type: "number", value: this.advance().value };
        if (this.check(r6.STRING)) return { type: "string", value: this.advance().value };
        if (this.check(r6.REGEX)) return { type: "regex", pattern: this.advance().value };
        if (this.check(r6.DOLLAR)) return this.advance(), { type: "field", index: this.parseFieldIndex() };
        if (this.check(r6.LPAREN)) {
          this.advance();
          let t6 = this.parseExpression();
          if (this.check(r6.COMMA)) {
            let n23 = [t6];
            for (; this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            return this.expect(r6.RPAREN), { type: "tuple", elements: n23 };
          }
          return this.expect(r6.RPAREN), t6;
        }
        if (this.check(r6.GETLINE)) {
          this.advance();
          let t6, n23;
          return this.check(r6.IDENT) && (t6 = this.advance().value), this.check(r6.LT) && (this.advance(), n23 = this.parsePrimary()), { type: "getline", variable: t6, file: n23 };
        }
        if (this.check(r6.IDENT)) {
          let t6 = this.advance().value;
          if (this.check(r6.LPAREN)) {
            this.advance();
            let n23 = [];
            if (this.skipNewlines(), !this.check(r6.RPAREN)) for (n23.push(this.parseExpression()); this.check(r6.COMMA); ) this.advance(), this.skipNewlines(), n23.push(this.parseExpression());
            return this.skipNewlines(), this.expect(r6.RPAREN), { type: "call", name: t6, args: n23 };
          }
          if (this.check(r6.LBRACKET)) {
            this.advance();
            let n23 = [this.parseExpression()];
            for (; this.check(r6.COMMA); ) this.advance(), n23.push(this.parseExpression());
            this.expect(r6.RBRACKET);
            let i10;
            if (n23.length === 1) i10 = n23[0];
            else {
              i10 = n23[0];
              for (let a7 = 1; a7 < n23.length; a7++) i10 = { type: "binary", operator: " ", left: { type: "binary", operator: " ", left: i10, right: { type: "variable", name: "SUBSEP" } }, right: n23[a7] };
            }
            return { type: "array_access", array: t6, key: i10 };
          }
          return { type: "variable", name: t6 };
        }
        throw new Error(`Unexpected token: ${this.current().type} at line ${this.current().line}:${this.current().column}`);
      }
    };
    Ft2 = { name: "awk", summary: "pattern scanning and text processing language", usage: "awk [OPTIONS] 'PROGRAM' [FILE...]", options: ["-F FS      use FS as field separator", "-v VAR=VAL assign VAL to variable VAR", "    --help display this help and exit"] };
    On = { name: "awk", async execute(e5, t6) {
      if (o2(e5)) return s(Ft2);
      let n23 = new i1(/\s+/), i10 = " ", a7 = /* @__PURE__ */ Object.create(null), s9 = 0;
      for (let l8 = 0; l8 < e5.length; l8++) {
        let p17 = e5[l8];
        if (p17 === "-F" && l8 + 1 < e5.length) i10 = re3(e5[++l8]), n23 = Oe(i10), s9 = l8 + 1;
        else if (p17.startsWith("-F")) i10 = re3(p17.slice(2)), n23 = Oe(i10), s9 = l8 + 1;
        else if (p17 === "-v" && l8 + 1 < e5.length) {
          let E12 = e5[++l8], d16 = E12.indexOf("=");
          if (d16 > 0) {
            let R13 = E12.slice(0, d16), b25 = re3(E12.slice(d16 + 1));
            a7[R13] = b25;
          }
          s9 = l8 + 1;
        } else {
          if (p17.startsWith("--")) return r3("awk", p17);
          if (p17.startsWith("-") && p17.length > 1) {
            let E12 = p17[1];
            if (E12 !== "F" && E12 !== "v") return r3("awk", `-${E12}`);
            s9 = l8 + 1;
          } else if (!p17.startsWith("-")) {
            s9 = l8;
            break;
          }
        }
      }
      if (s9 >= e5.length) return { stdout: "", stderr: `awk: missing program
`, exitCode: 1 };
      let o9 = e5[s9], c14 = e5.slice(s9 + 1), u10 = new j3(), N14;
      try {
        N14 = u10.parse(o9);
      } catch (l8) {
        return { stdout: "", stderr: `awk: ${l8 instanceof Error ? l8.message : String(l8)}
`, exitCode: 1 };
      }
      let k15 = { readFile: t6.fs.readFile.bind(t6.fs), writeFile: t6.fs.writeFile.bind(t6.fs), appendFile: async (l8, p17) => {
        try {
          let E12 = await t6.fs.readFile(l8);
          await t6.fs.writeFile(l8, E12 + p17);
        } catch {
          await t6.fs.writeFile(l8, p17);
        }
      }, resolvePath: t6.fs.resolvePath.bind(t6.fs) }, y18 = Q7({ fieldSep: n23, maxIterations: t6.limits?.maxAwkIterations, maxOutputSize: t6.limits?.maxStringLength, fs: k15, cwd: t6.cwd, exec: t6.exec ? (l8) => t6.exec(l8, { cwd: t6.cwd }) : void 0, coverage: t6.coverage });
      y18.FS = i10, y18.vars = Object.assign(/* @__PURE__ */ Object.create(null), a7), y18.ARGC = c14.length + 1, y18.ARGV = /* @__PURE__ */ Object.create(null), y18.ARGV[0] = "awk";
      for (let l8 = 0; l8 < c14.length; l8++) y18.ARGV[String(l8 + 1)] = c14[l8];
      y18.ENVIRON = r(t6.env);
      let w19 = new x6(y18);
      w19.execute(N14);
      let ie7 = N14.rules.some((l8) => l8.pattern?.type !== "begin" && l8.pattern?.type !== "end"), g18 = N14.rules.some((l8) => l8.pattern?.type === "end");
      try {
        if (await w19.executeBegin(), y18.shouldExit) return await w19.executeEnd(), { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
        if (!ie7 && !g18) return { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
        let l8 = [];
        if (c14.length > 0) for (let p17 of c14) try {
          let E12 = t6.fs.resolvePath(t6.cwd, p17), R13 = (await t6.fs.readFile(E12)).split(`
`);
          R13.length > 0 && R13[R13.length - 1] === "" && R13.pop(), l8.push({ filename: p17, lines: R13 });
        } catch {
          return { stdout: "", stderr: `awk: ${p17}: No such file or directory
`, exitCode: 1 };
        }
        else {
          let p17 = t6.stdin.split(`
`);
          p17.length > 0 && p17[p17.length - 1] === "" && p17.pop(), l8.push({ filename: "", lines: p17 });
        }
        for (let p17 of l8) {
          for (y18.FILENAME = p17.filename, y18.FNR = 0, y18.lines = p17.lines, y18.lineIndex = -1, y18.shouldNextFile = false; y18.lineIndex < p17.lines.length - 1 && (y18.lineIndex++, await w19.executeLine(p17.lines[y18.lineIndex]), !(y18.shouldExit || y18.shouldNextFile)); ) ;
          if (y18.shouldExit) break;
        }
        return await w19.executeEnd(), { stdout: w19.getOutput(), stderr: "", exitCode: w19.getExitCode() };
      } catch (l8) {
        let p17 = l8 instanceof Error ? l8.message : String(l8), E12 = l8 instanceof b2 ? b2.EXIT_CODE : 2;
        return { stdout: w19.getOutput(), stderr: `awk: ${p17}
`, exitCode: E12 };
      }
    } };
    bn = { name: "awk", flags: [{ flag: "-F", type: "value", valueHint: "delimiter" }, { flag: "-v", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/awk2-BDPR2JPZ.js
var awk2_BDPR2JPZ_exports = {};
__export(awk2_BDPR2JPZ_exports, {
  awkCommand2: () => On,
  flagsForFuzzing: () => bn
});
var init_awk2_BDPR2JPZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/awk2-BDPR2JPZ.js"() {
    init_chunk_3KWUDRIP();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KAEMRWOH.js
function O7(u10) {
  let r8 = u10.trim(), e5 = r8.match(/^([+-]?\d*\.?\d+)\s*([kmgtpeKMGTPE])?[iI]?[bB]?$/);
  if (!e5) {
    let n23 = parseFloat(r8);
    return Number.isNaN(n23) ? 0 : n23;
  }
  let l8 = parseFloat(e5[1]), s9 = (e5[2] || "").toLowerCase(), i10 = A3.get(s9) ?? 1;
  return l8 * i10;
}
function x7(u10) {
  let r8 = u10.trim().toLowerCase().slice(0, 3);
  return P5.get(r8) ?? 0;
}
function D7(u10, r8) {
  let e5 = u10.split(/(\d+)/), l8 = r8.split(/(\d+)/), s9 = Math.max(e5.length, l8.length);
  for (let i10 = 0; i10 < s9; i10++) {
    let n23 = e5[i10] || "", d16 = l8[i10] || "", o9 = /^\d+$/.test(n23) ? parseInt(n23, 10) : null, c14 = /^\d+$/.test(d16) ? parseInt(d16, 10) : null;
    if (o9 !== null && c14 !== null) {
      if (o9 !== c14) return o9 - c14;
    } else if (n23 !== d16) return n23.localeCompare(d16);
  }
  return 0;
}
function M5(u10) {
  return u10.replace(/[^a-zA-Z0-9\s]/g, "");
}
function v7(u10, r8, e5) {
  let l8 = e5 !== null ? e5 : /\s+/, s9 = u10.split(l8), i10 = r8.startField - 1;
  if (i10 >= s9.length) return "";
  if (r8.endField === void 0) {
    let o9 = s9[i10] || "";
    return r8.startChar !== void 0 && (o9 = o9.slice(r8.startChar - 1)), r8.ignoreLeading && (o9 = o9.trimStart()), o9;
  }
  let n23 = Math.min(r8.endField - 1, s9.length - 1), d16 = "";
  for (let o9 = i10; o9 <= n23 && o9 < s9.length; o9++) {
    let c14 = s9[o9] || "";
    if (o9 === i10 && r8.startChar !== void 0 && (c14 = c14.slice(r8.startChar - 1)), o9 === n23 && r8.endChar !== void 0) {
      let t6 = o9 === i10 && r8.startChar !== void 0 ? r8.endChar - r8.startChar + 1 : r8.endChar;
      c14 = c14.slice(0, t6);
    }
    o9 > i10 && (d16 += e5 || " "), d16 += c14;
  }
  return r8.ignoreLeading && (d16 = d16.trimStart()), d16;
}
function L6(u10, r8, e5) {
  let l8 = u10, s9 = r8;
  if (e5.dictionaryOrder && (l8 = M5(l8), s9 = M5(s9)), e5.ignoreCase && (l8 = l8.toLowerCase(), s9 = s9.toLowerCase()), e5.monthSort) {
    let i10 = x7(l8), n23 = x7(s9);
    return i10 - n23;
  }
  if (e5.humanNumeric) {
    let i10 = O7(l8), n23 = O7(s9);
    return i10 - n23;
  }
  if (e5.versionSort) return D7(l8, s9);
  if (e5.numeric) {
    let i10 = parseFloat(l8) || 0, n23 = parseFloat(s9) || 0;
    return i10 - n23;
  }
  return l8.localeCompare(s9);
}
function I7(u10) {
  let { keys: r8, fieldDelimiter: e5, numeric: l8, ignoreCase: s9, reverse: i10, humanNumeric: n23, versionSort: d16, dictionaryOrder: o9, monthSort: c14, ignoreLeadingBlanks: t6, stable: a7 } = u10;
  return (f11, C19) => {
    let g18 = f11, b25 = C19;
    if (t6 && (g18 = g18.trimStart(), b25 = b25.trimStart()), r8.length === 0) {
      let h16 = L6(g18, b25, { numeric: l8, ignoreCase: s9, humanNumeric: n23, versionSort: d16, dictionaryOrder: o9, monthSort: c14 });
      if (h16 !== 0) return i10 ? -h16 : h16;
      if (!a7) {
        let p17 = f11.localeCompare(C19);
        return i10 ? -p17 : p17;
      }
      return 0;
    }
    for (let m24 of r8) {
      let h16 = v7(g18, m24, e5), p17 = v7(b25, m24, e5);
      m24.ignoreLeading && (h16 = h16.trimStart(), p17 = p17.trimStart());
      let B12 = { numeric: m24.numeric ?? l8, ignoreCase: m24.ignoreCase ?? s9, humanNumeric: m24.humanNumeric ?? n23, versionSort: m24.versionSort ?? d16, dictionaryOrder: m24.dictionaryOrder ?? o9, monthSort: m24.monthSort ?? c14 }, V13 = m24.reverse ?? i10, S16 = L6(h16, p17, B12);
      if (S16 !== 0) return V13 ? -S16 : S16;
    }
    if (!a7) {
      let m24 = f11.localeCompare(C19);
      return i10 ? -m24 : m24;
    }
    return 0;
  };
}
function E5(u10, r8) {
  if (r8.keys.length === 0) {
    if (r8.ignoreCase) {
      let s9 = /* @__PURE__ */ new Set();
      return u10.filter((i10) => {
        let n23 = i10.toLowerCase();
        return s9.has(n23) ? false : (s9.add(n23), true);
      });
    }
    return [...new Set(u10)];
  }
  let e5 = r8.keys[0], l8 = /* @__PURE__ */ new Set();
  return u10.filter((s9) => {
    let i10 = v7(s9, e5, r8.fieldDelimiter);
    return (e5.ignoreCase ?? r8.ignoreCase) && (i10 = i10.toLowerCase()), l8.has(i10) ? false : (l8.add(i10), true);
  });
}
function y5(u10) {
  let r8 = { startField: 1 }, e5 = "", l8 = u10, s9 = l8.match(/([bdfhMnrV]+)$/);
  s9 && (e5 = s9[1], l8 = l8.slice(0, -e5.length)), e5.includes("n") && (r8.numeric = true), e5.includes("r") && (r8.reverse = true), e5.includes("f") && (r8.ignoreCase = true), e5.includes("b") && (r8.ignoreLeading = true), e5.includes("h") && (r8.humanNumeric = true), e5.includes("V") && (r8.versionSort = true), e5.includes("d") && (r8.dictionaryOrder = true), e5.includes("M") && (r8.monthSort = true);
  let i10 = l8.split(",");
  if (i10.length === 0 || i10[0] === "") return null;
  let n23 = i10[0].split("."), d16 = parseInt(n23[0], 10);
  if (Number.isNaN(d16) || d16 < 1) return null;
  if (r8.startField = d16, n23.length > 1 && n23[1]) {
    let o9 = parseInt(n23[1], 10);
    !Number.isNaN(o9) && o9 >= 1 && (r8.startChar = o9);
  }
  if (i10.length > 1 && i10[1]) {
    let o9 = i10[1], c14 = o9.match(/([bdfhMnrV]+)$/);
    if (c14) {
      let a7 = c14[1];
      a7.includes("n") && (r8.numeric = true), a7.includes("r") && (r8.reverse = true), a7.includes("f") && (r8.ignoreCase = true), a7.includes("b") && (r8.ignoreLeading = true), a7.includes("h") && (r8.humanNumeric = true), a7.includes("V") && (r8.versionSort = true), a7.includes("d") && (r8.dictionaryOrder = true), a7.includes("M") && (r8.monthSort = true), o9 = o9.slice(0, -a7.length);
    }
    let t6 = o9.split(".");
    if (t6[0]) {
      let a7 = parseInt(t6[0], 10);
      if (!Number.isNaN(a7) && a7 >= 1 && (r8.endField = a7), t6.length > 1 && t6[1]) {
        let f11 = parseInt(t6[1], 10);
        !Number.isNaN(f11) && f11 >= 1 && (r8.endChar = f11);
      }
    }
  }
  return r8;
}
var A3, P5, q8, j4, U6;
var init_chunk_KAEMRWOH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KAEMRWOH.js"() {
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    A3 = /* @__PURE__ */ new Map([["", 1], ["k", 1024], ["m", 1048576], ["g", 1073741824], ["t", 1099511627776], ["p", 1125899906842624], ["e", 1152921504606847e3]]);
    P5 = /* @__PURE__ */ new Map([["jan", 1], ["feb", 2], ["mar", 3], ["apr", 4], ["may", 5], ["jun", 6], ["jul", 7], ["aug", 8], ["sep", 9], ["oct", 10], ["nov", 11], ["dec", 12]]);
    q8 = { name: "sort", summary: "sort lines of text files", usage: "sort [OPTION]... [FILE]...", options: ["-b, --ignore-leading-blanks  ignore leading blanks", "-d, --dictionary-order  consider only blanks and alphanumeric characters", "-f, --ignore-case    fold lower case to upper case characters", "-h, --human-numeric-sort  compare human readable numbers (e.g., 2K 1G)", "-M, --month-sort     compare (unknown) < 'JAN' < ... < 'DEC'", "-n, --numeric-sort   compare according to string numerical value", "-r, --reverse        reverse the result of comparisons", "-V, --version-sort   natural sort of (version) numbers within text", "-c, --check          check for sorted input; do not sort", "-o, --output=FILE    write result to FILE instead of stdout", "-s, --stable         stabilize sort by disabling last-resort comparison", "-u, --unique         output only unique lines", "-k, --key=KEYDEF     sort via a key; KEYDEF gives location and type", "-t, --field-separator=SEP  use SEP as field separator", "    --help           display this help and exit"], description: `KEYDEF is F[.C][OPTS][,F[.C][OPTS]]
  F is a field number (1-indexed)
  C is a character position within the field (1-indexed)
  OPTS can be: b d f h M n r V (per-key modifiers)

Examples:
  -k1        sort by first field
  -k2,2      sort by second field only
  -k1.3      sort by first field starting at 3rd character
  -k1,2n     sort by fields 1-2 numerically
  -k2 -k1    sort by field 2, then by field 1` };
    j4 = { name: "sort", async execute(u10, r8) {
      if (o2(u10)) return s(q8);
      let e5 = { reverse: false, numeric: false, unique: false, ignoreCase: false, humanNumeric: false, versionSort: false, dictionaryOrder: false, monthSort: false, ignoreLeadingBlanks: false, stable: false, checkOnly: false, outputFile: null, keys: [], fieldDelimiter: null }, l8 = [];
      for (let c14 = 0; c14 < u10.length; c14++) {
        let t6 = u10[c14];
        if (t6 === "-r" || t6 === "--reverse") e5.reverse = true;
        else if (t6 === "-n" || t6 === "--numeric-sort") e5.numeric = true;
        else if (t6 === "-u" || t6 === "--unique") e5.unique = true;
        else if (t6 === "-f" || t6 === "--ignore-case") e5.ignoreCase = true;
        else if (t6 === "-h" || t6 === "--human-numeric-sort") e5.humanNumeric = true;
        else if (t6 === "-V" || t6 === "--version-sort") e5.versionSort = true;
        else if (t6 === "-d" || t6 === "--dictionary-order") e5.dictionaryOrder = true;
        else if (t6 === "-M" || t6 === "--month-sort") e5.monthSort = true;
        else if (t6 === "-b" || t6 === "--ignore-leading-blanks") e5.ignoreLeadingBlanks = true;
        else if (t6 === "-s" || t6 === "--stable") e5.stable = true;
        else if (t6 === "-c" || t6 === "--check") e5.checkOnly = true;
        else if (t6 === "-o" || t6 === "--output") e5.outputFile = u10[++c14] || null;
        else if (t6.startsWith("-o")) e5.outputFile = t6.slice(2) || null;
        else if (t6.startsWith("--output=")) e5.outputFile = t6.slice(9) || null;
        else if (t6 === "-t" || t6 === "--field-separator") e5.fieldDelimiter = u10[++c14] || null;
        else if (t6.startsWith("-t")) e5.fieldDelimiter = t6.slice(2) || null;
        else if (t6.startsWith("--field-separator=")) e5.fieldDelimiter = t6.slice(18) || null;
        else if (t6 === "-k" || t6 === "--key") {
          let a7 = u10[++c14];
          if (a7) {
            let f11 = y5(a7);
            f11 && e5.keys.push(f11);
          }
        } else if (t6.startsWith("-k")) {
          let a7 = y5(t6.slice(2));
          a7 && e5.keys.push(a7);
        } else if (t6.startsWith("--key=")) {
          let a7 = y5(t6.slice(6));
          a7 && e5.keys.push(a7);
        } else {
          if (t6.startsWith("--")) return r3("sort", t6);
          if (t6.startsWith("-") && !t6.startsWith("--")) {
            let a7 = false;
            for (let f11 of t6.slice(1)) if (f11 === "r") e5.reverse = true;
            else if (f11 === "n") e5.numeric = true;
            else if (f11 === "u") e5.unique = true;
            else if (f11 === "f") e5.ignoreCase = true;
            else if (f11 === "h") e5.humanNumeric = true;
            else if (f11 === "V") e5.versionSort = true;
            else if (f11 === "d") e5.dictionaryOrder = true;
            else if (f11 === "M") e5.monthSort = true;
            else if (f11 === "b") e5.ignoreLeadingBlanks = true;
            else if (f11 === "s") e5.stable = true;
            else if (f11 === "c") e5.checkOnly = true;
            else {
              a7 = true;
              break;
            }
            if (a7) return r3("sort", t6);
          } else l8.push(t6);
        }
      }
      let s9 = await b3(r8, l8, { cmdName: "sort" });
      if (!s9.ok) return s9.error;
      let n23 = s9.content.split(`
`);
      n23.length > 0 && n23[n23.length - 1] === "" && n23.pop();
      let d16 = I7(e5);
      if (e5.checkOnly) {
        let c14 = l8.length > 0 ? l8[0] : "-";
        for (let t6 = 1; t6 < n23.length; t6++) if (d16(n23[t6 - 1], n23[t6]) > 0) return { stdout: "", stderr: `sort: ${c14}:${t6 + 1}: disorder: ${n23[t6]}
`, exitCode: 1 };
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      n23.sort(d16), e5.unique && (n23 = E5(n23, e5));
      let o9 = n23.length > 0 ? `${n23.join(`
`)}
` : "";
      if (e5.outputFile) {
        let c14 = r8.fs.resolvePath(r8.cwd, e5.outputFile);
        return await r8.fs.writeFile(c14, o9), { stdout: "", stderr: "", exitCode: 0 };
      }
      return { stdout: o9, stderr: "", exitCode: 0 };
    } };
    U6 = { name: "sort", flags: [{ flag: "-r", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-u", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-V", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-M", type: "boolean" }, { flag: "-b", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-k", type: "value", valueHint: "string" }, { flag: "-t", type: "value", valueHint: "delimiter" }, { flag: "-o", type: "value", valueHint: "path" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sort-T7TNLWXL.js
var sort_T7TNLWXL_exports = {};
__export(sort_T7TNLWXL_exports, {
  flagsForFuzzing: () => U6,
  sortCommand: () => j4
});
var init_sort_T7TNLWXL = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sort-T7TNLWXL.js"() {
    init_chunk_KAEMRWOH();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7C6RBHP3.js
var O8, w6, N4, P6;
var init_chunk_7C6RBHP3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7C6RBHP3.js"() {
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    O8 = { name: "uniq", summary: "report or omit repeated lines", usage: "uniq [OPTION]... [INPUT [OUTPUT]]", options: ["-c, --count        prefix lines by the number of occurrences", "-d, --repeated     only print duplicate lines", "-i, --ignore-case  ignore case when comparing", "-u, --unique       only print unique lines", "    --help         display this help and exit"] };
    w6 = { count: { short: "c", long: "count", type: "boolean" }, duplicatesOnly: { short: "d", long: "repeated", type: "boolean" }, uniqueOnly: { short: "u", long: "unique", type: "boolean" }, ignoreCase: { short: "i", long: "ignore-case", type: "boolean" } };
    N4 = { name: "uniq", async execute(c14, m24) {
      if (o2(c14)) return s(O8);
      let o9 = x3("uniq", c14, w6);
      if (!o9.ok) return o9.error;
      let { count: y18, duplicatesOnly: h16, uniqueOnly: q15, ignoreCase: b25 } = o9.result.flags, C19 = o9.result.positional, s9 = await b3(m24, C19, { cmdName: "uniq" });
      if (!s9.ok) return s9.error;
      let n23 = s9.content.split(`
`);
      if (n23.length > 0 && n23[n23.length - 1] === "" && n23.pop(), n23.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
      let t6 = [], r8 = n23[0], i10 = 1, x22 = (e5, l8) => b25 ? e5.toLowerCase() === l8.toLowerCase() : e5 === l8;
      for (let e5 = 1; e5 < n23.length; e5++) x22(n23[e5], r8) ? i10++ : (t6.push({ line: r8, count: i10 }), r8 = n23[e5], i10 = 1);
      t6.push({ line: r8, count: i10 });
      let u10 = t6;
      h16 ? u10 = t6.filter((e5) => e5.count > 1) : q15 && (u10 = t6.filter((e5) => e5.count === 1));
      let a7 = "";
      for (let { line: e5, count: l8 } of u10) y18 ? a7 += `${String(l8).padStart(4)} ${e5}
` : a7 += `${e5}
`;
      return { stdout: a7, stderr: "", exitCode: 0 };
    } };
    P6 = { name: "uniq", flags: [{ flag: "-c", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-u", type: "boolean" }, { flag: "-i", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/uniq-ZXE4O5XB.js
var uniq_ZXE4O5XB_exports = {};
__export(uniq_ZXE4O5XB_exports, {
  flagsForFuzzing: () => P6,
  uniqCommand: () => N4
});
var init_uniq_ZXE4O5XB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/uniq-ZXE4O5XB.js"() {
    init_chunk_7C6RBHP3();
    init_chunk_7L36YK2X();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-Z7JVV2SM.js
var x8, C6, I8;
var init_chunk_Z7JVV2SM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-Z7JVV2SM.js"() {
    init_chunk_74CEPOFO();
    x8 = { name: "comm", summary: "compare two sorted files line by line", usage: "comm [OPTION]... FILE1 FILE2", options: ["-1             suppress column 1 (lines unique to FILE1)", "-2             suppress column 2 (lines unique to FILE2)", "-3             suppress column 3 (lines that appear in both files)", "    --help     display this help and exit"] };
    C6 = { name: "comm", async execute(p17, a7) {
      if (o2(p17)) return s(x8);
      let r8 = false, l8 = false, f11 = false, i10 = [];
      for (let e5 of p17) if (e5 === "-1") r8 = true;
      else if (e5 === "-2") l8 = true;
      else if (e5 === "-3") f11 = true;
      else if (e5 === "-12" || e5 === "-21") r8 = true, l8 = true;
      else if (e5 === "-13" || e5 === "-31") r8 = true, f11 = true;
      else if (e5 === "-23" || e5 === "-32") l8 = true, f11 = true;
      else if (e5 === "-123" || e5 === "-132" || e5 === "-213" || e5 === "-231" || e5 === "-312" || e5 === "-321") r8 = true, l8 = true, f11 = true;
      else {
        if (e5.startsWith("-") && e5 !== "-") return r3("comm", e5);
        i10.push(e5);
      }
      if (i10.length !== 2) return { stdout: "", stderr: `comm: missing operand
Try 'comm --help' for more information.
`, exitCode: 1 };
      let c14 = async (e5) => {
        if (e5 === "-") return a7.stdin;
        try {
          let w19 = a7.fs.resolvePath(a7.cwd, e5);
          return await a7.fs.readFile(w19);
        } catch {
          return null;
        }
      }, m24 = await c14(i10[0]);
      if (m24 === null) return { stdout: "", stderr: `comm: ${i10[0]}: No such file or directory
`, exitCode: 1 };
      let h16 = await c14(i10[1]);
      if (h16 === null) return { stdout: "", stderr: `comm: ${i10[1]}: No such file or directory
`, exitCode: 1 };
      let t6 = m24.split(`
`), s9 = h16.split(`
`);
      t6.length > 0 && t6[t6.length - 1] === "" && t6.pop(), s9.length > 0 && s9[s9.length - 1] === "" && s9.pop();
      let n23 = 0, o9 = 0, u10 = "", d16 = r8 ? "" : "	", F20 = (r8 ? "" : "	") + (l8 ? "" : "	");
      for (; n23 < t6.length || o9 < s9.length; ) n23 >= t6.length ? (l8 || (u10 += `${d16}${s9[o9]}
`), o9++) : o9 >= s9.length ? (r8 || (u10 += `${t6[n23]}
`), n23++) : t6[n23] < s9[o9] ? (r8 || (u10 += `${t6[n23]}
`), n23++) : t6[n23] > s9[o9] ? (l8 || (u10 += `${d16}${s9[o9]}
`), o9++) : (f11 || (u10 += `${F20}${t6[n23]}
`), n23++, o9++);
      return { stdout: u10, stderr: "", exitCode: 0 };
    } };
    I8 = { name: "comm", flags: [{ flag: "-1", type: "boolean" }, { flag: "-2", type: "boolean" }, { flag: "-3", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/comm-5SLSESQG.js
var comm_5SLSESQG_exports = {};
__export(comm_5SLSESQG_exports, {
  commCommand: () => C6,
  flagsForFuzzing: () => I8
});
var init_comm_5SLSESQG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/comm-5SLSESQG.js"() {
    init_chunk_Z7JVV2SM();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-6NY2AP72.js
function F7(t6) {
  let c14 = [], l8 = t6.split(",");
  for (let n23 of l8) if (n23.includes("-")) {
    let [s9, r8] = n23.split("-");
    c14.push({ start: s9 ? parseInt(s9, 10) : 1, end: r8 ? parseInt(r8, 10) : null });
  } else {
    let s9 = parseInt(n23, 10);
    c14.push({ start: s9, end: s9 });
  }
  return c14;
}
function L7(t6, c14) {
  let l8 = [];
  for (let n23 of c14) {
    let s9 = n23.start - 1, r8 = n23.end === null ? t6.length : n23.end;
    for (let o9 = s9; o9 < r8 && o9 < t6.length; o9++) o9 >= 0 && !l8.includes(t6[o9]) && l8.push(t6[o9]);
  }
  return l8;
}
var w7, C7, S4;
var init_chunk_6NY2AP72 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-6NY2AP72.js"() {
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    w7 = { name: "cut", summary: "remove sections from each line of files", usage: "cut [OPTION]... [FILE]...", options: ["-c LIST              select only these characters", "-d DELIM             use DELIM instead of TAB for field delimiter", "-f LIST              select only these fields", "-s, --only-delimited  do not print lines without delimiters", "    --help           display this help and exit"] };
    C7 = { name: "cut", async execute(t6, c14) {
      if (o2(t6)) return s(w7);
      let l8 = "	", n23 = null, s9 = null, r8 = false, o9 = [];
      for (let i10 = 0; i10 < t6.length; i10++) {
        let e5 = t6[i10];
        if (e5 === "-d") l8 = t6[++i10] || "	";
        else if (e5.startsWith("-d")) l8 = e5.slice(2);
        else if (e5 === "-f") n23 = t6[++i10];
        else if (e5.startsWith("-f")) n23 = e5.slice(2);
        else if (e5 === "-c") s9 = t6[++i10];
        else if (e5.startsWith("-c")) s9 = e5.slice(2);
        else if (e5 === "-s" || e5 === "--only-delimited") r8 = true;
        else {
          if (e5.startsWith("--")) return r3("cut", e5);
          if (e5.startsWith("-")) {
            let f11 = false;
            for (let a7 of e5.slice(1)) if (a7 === "s") r8 = true;
            else if (!"dfc".includes(a7)) {
              f11 = true;
              break;
            }
            if (f11) return r3("cut", e5);
          } else o9.push(e5);
        }
      }
      if (!n23 && !s9) return { stdout: "", stderr: `cut: you must specify a list of bytes, characters, or fields
`, exitCode: 1 };
      let p17 = await b3(c14, o9, { cmdName: "cut" });
      if (!p17.ok) return p17.error;
      let u10 = p17.content.split(`
`);
      u10.length > 0 && u10[u10.length - 1] === "" && u10.pop();
      let g18 = F7(n23 || s9 || "1"), h16 = "";
      for (let i10 of u10) if (s9) {
        let e5 = i10.split(""), f11 = [];
        for (let a7 of g18) {
          let v20 = a7.start - 1, H16 = a7.end === null ? e5.length : a7.end;
          for (let d16 = v20; d16 < H16 && d16 < e5.length; d16++) d16 >= 0 && f11.push(e5[d16]);
        }
        h16 += `${f11.join("")}
`;
      } else {
        if (r8 && !i10.includes(l8)) continue;
        let e5 = i10.split(l8), f11 = L7(e5, g18);
        h16 += `${f11.join(l8)}
`;
      }
      return { stdout: h16, stderr: "", exitCode: 0 };
    } };
    S4 = { name: "cut", flags: [{ flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-f", type: "value", valueHint: "string" }, { flag: "-c", type: "value", valueHint: "string" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/cut-LO6YYY5P.js
var cut_LO6YYY5P_exports = {};
__export(cut_LO6YYY5P_exports, {
  cutCommand: () => C7,
  flagsForFuzzing: () => S4
});
var init_cut_LO6YYY5P = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/cut-LO6YYY5P.js"() {
    init_chunk_6NY2AP72();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JVPRLUMK.js
function y6(s9, i10) {
  if (s9.length === 0) return "";
  if (s9.length === 1) return s9[0];
  let n23 = s9[0];
  for (let l8 = 1; l8 < s9.length; l8++) {
    let d16 = (l8 - 1) % i10.length;
    n23 += i10[d16] + s9[l8];
  }
  return n23;
}
var I9, F8, P7, T3;
var init_chunk_JVPRLUMK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JVPRLUMK.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    I9 = { name: "paste", summary: "merge lines of files", usage: "paste [OPTION]... [FILE]...", description: ["Write lines consisting of the sequentially corresponding lines from", "each FILE, separated by TABs, to standard output.", "", "With no FILE, or when FILE is -, read standard input."], options: ["-d, --delimiters=LIST   reuse characters from LIST instead of TABs", "-s, --serial            paste one file at a time instead of in parallel", "    --help              display this help and exit"], examples: ["paste file1 file2       Merge file1 and file2 side by side", "paste -d, file1 file2   Use comma as delimiter", "paste -s file1          Paste all lines of file1 on one line", "paste - - < file        Paste pairs of lines from file"] };
    F8 = { delimiter: { short: "d", long: "delimiters", type: "string", default: "	" }, serial: { short: "s", long: "serial", type: "boolean" } };
    P7 = { name: "paste", async execute(s9, i10) {
      if (o2(s9)) return s(I9);
      let n23 = x3("paste", s9, F8);
      if (!n23.ok) return n23.error;
      let l8 = n23.result.flags.delimiter, d16 = n23.result.flags.serial, p17 = n23.result.positional;
      if (p17.length === 0) return { stdout: "", stderr: `usage: paste [-s] [-d delimiters] file ...
`, exitCode: 1 };
      let a7 = i10.stdin ? i10.stdin.split(`
`) : [""];
      a7.length > 0 && a7[a7.length - 1] === "" && a7.pop();
      let x22 = p17.filter((e5) => e5 === "-").length, f11 = [], h16 = 0;
      for (let e5 of p17) if (e5 === "-") {
        let t6 = [];
        for (let o9 = h16; o9 < a7.length; o9 += x22) t6.push(a7[o9]);
        f11.push(t6), h16++;
      } else {
        let t6 = i10.fs.resolvePath(i10.cwd, e5);
        try {
          let r8 = (await i10.fs.readFile(t6)).split(`
`);
          r8.length > 0 && r8[r8.length - 1] === "" && r8.pop(), f11.push(r8);
        } catch {
          return { stdout: "", stderr: `paste: ${e5}: No such file or directory
`, exitCode: 1 };
        }
      }
      let u10 = "";
      if (d16) for (let e5 of f11) e5 && (u10 += `${y6(e5, l8)}
`);
      else {
        let e5 = Math.max(...f11.map((t6) => t6?.length ?? 0));
        for (let t6 = 0; t6 < e5; t6++) {
          let o9 = [];
          for (let r8 of f11) o9.push(r8?.[t6] ?? "");
          u10 += `${y6(o9, l8)}
`;
        }
      }
      return { stdout: u10, stderr: "", exitCode: 0 };
    } };
    T3 = { name: "paste", flags: [{ flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/paste-7N6AFSDS.js
var paste_7N6AFSDS_exports = {};
__export(paste_7N6AFSDS_exports, {
  flagsForFuzzing: () => T3,
  pasteCommand: () => P7
});
var init_paste_7N6AFSDS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/paste-7N6AFSDS.js"() {
    init_chunk_JVPRLUMK();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-X6JMGGW2.js
function S5(r8) {
  let n23 = "", e5 = 0;
  for (; e5 < r8.length; ) {
    if (r8[e5] === "[" && r8[e5 + 1] === ":") {
      let l8 = false;
      for (let [i10, a7] of x9) if (r8.slice(e5).startsWith(i10)) {
        n23 += a7, e5 += i10.length, l8 = true;
        break;
      }
      if (l8) continue;
    }
    if (r8[e5] === "\\" && e5 + 1 < r8.length) {
      let l8 = r8[e5 + 1];
      l8 === "n" ? n23 += `
` : l8 === "t" ? n23 += "	" : l8 === "r" ? n23 += "\r" : n23 += l8, e5 += 2;
      continue;
    }
    if (e5 + 2 < r8.length && r8[e5 + 1] === "-") {
      let l8 = r8.charCodeAt(e5), i10 = r8.charCodeAt(e5 + 2);
      for (let a7 = l8; a7 <= i10; a7++) n23 += String.fromCharCode(a7);
      e5 += 3;
      continue;
    }
    n23 += r8[e5], e5++;
  }
  return n23;
}
var y7, x9, b10, A4, q9;
var init_chunk_X6JMGGW2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-X6JMGGW2.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    y7 = { name: "tr", summary: "translate or delete characters", usage: "tr [OPTION]... SET1 [SET2]", options: ["-c, -C, --complement   use the complement of SET1", "-d, --delete           delete characters in SET1", "-s, --squeeze-repeats  squeeze repeated characters", "    --help             display this help and exit"], description: `SET syntax:
  a-z         character range
  [:alnum:]   all letters and digits
  [:alpha:]   all letters
  [:digit:]   all digits
  [:lower:]   all lowercase letters
  [:upper:]   all uppercase letters
  [:space:]   all whitespace
  [:blank:]   horizontal whitespace
  [:punct:]   all punctuation
  [:print:]   all printable characters
  [:graph:]   all printable characters except space
  [:cntrl:]   all control characters
  [:xdigit:]  all hexadecimal digits
  \\n, \\t, \\r  escape sequences` };
    x9 = /* @__PURE__ */ new Map([["[:alnum:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"], ["[:alpha:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"], ["[:blank:]", " 	"], ["[:cntrl:]", Array.from({ length: 32 }, (r8, n23) => String.fromCharCode(n23)).join("").concat("\x7F")], ["[:digit:]", "0123456789"], ["[:graph:]", Array.from({ length: 94 }, (r8, n23) => String.fromCharCode(33 + n23)).join("")], ["[:lower:]", "abcdefghijklmnopqrstuvwxyz"], ["[:print:]", Array.from({ length: 95 }, (r8, n23) => String.fromCharCode(32 + n23)).join("")], ["[:punct:]", "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~"], ["[:space:]", ` 	
\r\f\v`], ["[:upper:]", "ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["[:xdigit:]", "0123456789ABCDEFabcdef"]]);
    b10 = { complement: { short: "c", long: "complement", type: "boolean" }, complementUpper: { short: "C", type: "boolean" }, delete: { short: "d", long: "delete", type: "boolean" }, squeeze: { short: "s", long: "squeeze-repeats", type: "boolean" } };
    A4 = { name: "tr", async execute(r8, n23) {
      if (o2(r8)) return s(y7);
      let e5 = x3("tr", r8, b10);
      if (!e5.ok) return e5.error;
      let l8 = e5.result.flags.complement || e5.result.flags.complementUpper, i10 = e5.result.flags.delete, a7 = e5.result.flags.squeeze, p17 = e5.result.positional;
      if (p17.length < 1) return { stdout: "", stderr: `tr: missing operand
`, exitCode: 1 };
      if (!i10 && !a7 && p17.length < 2) return { stdout: "", stderr: `tr: missing operand after SET1
`, exitCode: 1 };
      let d16 = S5(p17[0]), s9 = p17.length > 1 ? S5(p17[1]) : "", h16 = n23.stdin, g18 = (o9) => {
        let t6 = d16.includes(o9);
        return l8 ? !t6 : t6;
      }, c14 = "";
      if (i10) for (let o9 of h16) g18(o9) || (c14 += o9);
      else if (a7 && p17.length === 1) {
        let o9 = "";
        for (let t6 of h16) g18(t6) && t6 === o9 || (c14 += t6, o9 = t6);
      } else {
        if (l8) {
          let o9 = s9.length > 0 ? s9[s9.length - 1] : "";
          for (let t6 of h16) d16.includes(t6) ? c14 += t6 : c14 += o9;
        } else {
          let o9 = /* @__PURE__ */ new Map();
          for (let t6 = 0; t6 < d16.length; t6++) {
            let f11 = t6 < s9.length ? s9[t6] : s9[s9.length - 1];
            o9.set(d16[t6], f11);
          }
          for (let t6 of h16) c14 += o9.get(t6) ?? t6;
        }
        if (a7) {
          let o9 = "", t6 = "";
          for (let f11 of c14) s9.includes(f11) && f11 === t6 || (o9 += f11, t6 = f11);
          c14 = o9;
        }
      }
      return { stdout: c14, stderr: "", exitCode: 0 };
    } };
    q9 = { name: "tr", flags: [{ flag: "-c", type: "boolean" }, { flag: "-C", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-s", type: "boolean" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tr-RYO2EDCA.js
var tr_RYO2EDCA_exports = {};
__export(tr_RYO2EDCA_exports, {
  flagsForFuzzing: () => q9,
  trCommand: () => A4
});
var init_tr_RYO2EDCA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tr-RYO2EDCA.js"() {
    init_chunk_X6JMGGW2();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-QCDB2VPH.js
function d7(t6) {
  return Array.from(t6).reverse().join("");
}
var u2, v8, m8;
var init_chunk_QCDB2VPH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-QCDB2VPH.js"() {
    init_chunk_74CEPOFO();
    u2 = { name: "rev", summary: "reverse lines characterwise", usage: "rev [file ...]", description: "Copies the specified files to standard output, reversing the order of characters in every line. If no files are specified, standard input is read.", examples: ["echo 'hello' | rev     # Output: olleh", "rev file.txt           # Reverse each line in file"] };
    v8 = { name: "rev", execute: async (t6, s9) => {
      if (o2(t6)) return s(u2);
      let o9 = [];
      for (let e5 of t6) if (e5 === "--") {
        let r8 = t6.indexOf(e5);
        o9.push(...t6.slice(r8 + 1));
        break;
      } else {
        if (e5.startsWith("-") && e5 !== "-") return r3("rev", e5);
        o9.push(e5);
      }
      let n23 = "", l8 = (e5) => {
        let r8 = e5.split(`
`), i10 = e5.endsWith(`
`) && r8[r8.length - 1] === "";
        return i10 && r8.pop(), r8.map(d7).join(`
`) + (i10 ? `
` : "");
      };
      if (o9.length === 0) {
        let e5 = s9.stdin ?? "";
        n23 = l8(e5);
      } else for (let e5 of o9) if (e5 === "-") {
        let r8 = s9.stdin ?? "";
        n23 += l8(r8);
      } else {
        let r8 = s9.fs.resolvePath(s9.cwd, e5), i10 = await s9.fs.readFile(r8);
        if (i10 === null) return { exitCode: 1, stdout: n23, stderr: `rev: ${e5}: No such file or directory
` };
        n23 += l8(i10);
      }
      return { exitCode: 0, stdout: n23, stderr: "" };
    } };
    m8 = { name: "rev", flags: [], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/rev-XOSYPP45.js
var rev_XOSYPP45_exports = {};
__export(rev_XOSYPP45_exports, {
  flagsForFuzzing: () => m8,
  rev: () => v8
});
var init_rev_XOSYPP45 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/rev-XOSYPP45.js"() {
    init_chunk_QCDB2VPH();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-F23WWYKW.js
function p6(r8, s9, i10) {
  let l8 = String(r8);
  switch (s9) {
    case "ln":
      return l8.padEnd(i10);
    case "rn":
      return l8.padStart(i10);
    case "rz":
      return l8.padStart(i10, "0");
    default:
      return s9;
  }
}
function N5(r8, s9) {
  switch (s9) {
    case "a":
      return true;
    case "t":
      return r8.trim().length > 0;
    case "n":
      return false;
    default:
      return s9;
  }
}
function b11(r8, s9, i10) {
  if (r8 === "") return { output: "", nextNumber: i10 };
  let l8 = r8.split(`
`), t6 = [], u10 = i10, a7 = r8.endsWith(`
`) && l8[l8.length - 1] === "";
  a7 && l8.pop();
  for (let n23 of l8) if (N5(n23, s9.bodyStyle)) {
    let e5 = p6(u10, s9.numberFormat, s9.width);
    t6.push(`${e5}${s9.separator}${n23}`), u10 += s9.increment;
  } else {
    let e5 = " ".repeat(s9.width);
    t6.push(`${e5}${s9.separator}${n23}`);
  }
  return { output: t6.join(`
`) + (a7 ? `
` : ""), nextNumber: u10 };
}
var h8, y8, x10;
var init_chunk_F23WWYKW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-F23WWYKW.js"() {
    init_chunk_74CEPOFO();
    h8 = { name: "nl", summary: "number lines of files", usage: "nl [OPTION]... [FILE]...", description: "Write each FILE to standard output, with line numbers added. If no FILE is specified, standard input is read.", options: ["-b STYLE     Body numbering style: a (all), t (non-empty), n (none)", "-n FORMAT    Number format: ln (left), rn (right), rz (right zeros)", "-w WIDTH     Number width (default: 6)", "-s SEP       Separator after number (default: TAB)", "-v START     Starting line number (default: 1)", "-i INCR      Line number increment (default: 1)"], examples: ["nl file.txt              # Number non-empty lines", "nl -ba file.txt          # Number all lines", "nl -n rz -w 3 file.txt   # Right-justified with zeros", "nl -s ': ' file.txt      # Use ': ' as separator"] };
    y8 = { name: "nl", execute: async (r8, s9) => {
      if (o2(r8)) return s(h8);
      let i10 = { bodyStyle: "t", numberFormat: "rn", width: 6, separator: "	", startNumber: 1, increment: 1 }, l8 = [], t6 = 0;
      for (; t6 < r8.length; ) {
        let n23 = r8[t6];
        if (n23 === "-b" && t6 + 1 < r8.length) {
          let e5 = r8[t6 + 1];
          if (e5 !== "a" && e5 !== "t" && e5 !== "n") return { exitCode: 1, stdout: "", stderr: `nl: invalid body numbering style: '${e5}'
` };
          i10.bodyStyle = e5, t6 += 2;
        } else if (n23.startsWith("-b")) {
          let e5 = n23.slice(2);
          if (e5 !== "a" && e5 !== "t" && e5 !== "n") return { exitCode: 1, stdout: "", stderr: `nl: invalid body numbering style: '${e5}'
` };
          i10.bodyStyle = e5, t6++;
        } else if (n23 === "-n" && t6 + 1 < r8.length) {
          let e5 = r8[t6 + 1];
          if (e5 !== "ln" && e5 !== "rn" && e5 !== "rz") return { exitCode: 1, stdout: "", stderr: `nl: invalid line numbering format: '${e5}'
` };
          i10.numberFormat = e5, t6 += 2;
        } else if (n23.startsWith("-n")) {
          let e5 = n23.slice(2);
          if (e5 !== "ln" && e5 !== "rn" && e5 !== "rz") return { exitCode: 1, stdout: "", stderr: `nl: invalid line numbering format: '${e5}'
` };
          i10.numberFormat = e5, t6++;
        } else if (n23 === "-w" && t6 + 1 < r8.length) {
          let e5 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e5) || e5 < 1) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number field width: '${r8[t6 + 1]}'
` };
          i10.width = e5, t6 += 2;
        } else if (n23.startsWith("-w")) {
          let e5 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e5) || e5 < 1) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number field width: '${n23.slice(2)}'
` };
          i10.width = e5, t6++;
        } else if (n23 === "-s" && t6 + 1 < r8.length) i10.separator = r8[t6 + 1], t6 += 2;
        else if (n23.startsWith("-s")) i10.separator = n23.slice(2), t6++;
        else if (n23 === "-v" && t6 + 1 < r8.length) {
          let e5 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e5)) return { exitCode: 1, stdout: "", stderr: `nl: invalid starting line number: '${r8[t6 + 1]}'
` };
          i10.startNumber = e5, t6 += 2;
        } else if (n23.startsWith("-v")) {
          let e5 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e5)) return { exitCode: 1, stdout: "", stderr: `nl: invalid starting line number: '${n23.slice(2)}'
` };
          i10.startNumber = e5, t6++;
        } else if (n23 === "-i" && t6 + 1 < r8.length) {
          let e5 = parseInt(r8[t6 + 1], 10);
          if (Number.isNaN(e5)) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number increment: '${r8[t6 + 1]}'
` };
          i10.increment = e5, t6 += 2;
        } else if (n23.startsWith("-i")) {
          let e5 = parseInt(n23.slice(2), 10);
          if (Number.isNaN(e5)) return { exitCode: 1, stdout: "", stderr: `nl: invalid line number increment: '${n23.slice(2)}'
` };
          i10.increment = e5, t6++;
        } else if (n23 === "--") {
          l8.push(...r8.slice(t6 + 1));
          break;
        } else {
          if (n23.startsWith("-") && n23 !== "-") return r3("nl", n23);
          l8.push(n23), t6++;
        }
      }
      let u10 = "", a7 = i10.startNumber;
      if (l8.length === 0) {
        let n23 = s9.stdin ?? "";
        u10 = b11(n23, i10, a7).output;
      } else for (let n23 of l8) {
        let e5 = s9.fs.resolvePath(s9.cwd, n23), o9 = await s9.fs.readFile(e5);
        if (o9 === null) return { exitCode: 1, stdout: u10, stderr: `nl: ${n23}: No such file or directory
` };
        let d16 = b11(o9, i10, a7);
        u10 += d16.output, a7 = d16.nextNumber;
      }
      return { exitCode: 0, stdout: u10, stderr: "" };
    } };
    x10 = { name: "nl", flags: [{ flag: "-b", type: "value", valueHint: "string" }, { flag: "-n", type: "value", valueHint: "string" }, { flag: "-w", type: "value", valueHint: "number" }, { flag: "-s", type: "value", valueHint: "string" }, { flag: "-v", type: "value", valueHint: "number" }, { flag: "-i", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/nl-U5YJDM32.js
var nl_U5YJDM32_exports = {};
__export(nl_U5YJDM32_exports, {
  flagsForFuzzing: () => x10,
  nl: () => y8
});
var init_nl_U5YJDM32 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/nl-U5YJDM32.js"() {
    init_chunk_F23WWYKW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-D4J545R4.js
function g9(s9, r8, n23) {
  return n23 ? new TextEncoder().encode(s9).length : s9 === "	" ? 8 - r8 % 8 : s9 === "\b" ? -1 : 1;
}
function y9(s9, r8) {
  if (s9.length === 0) return s9;
  let { width: n23, breakAtSpaces: u10, countBytes: i10 } = r8, l8 = [], e5 = "", t6 = 0, o9 = -1, f11 = 0;
  for (let c14 = 0; c14 < s9.length; c14++) {
    let a7 = s9[c14], d16 = g9(a7, t6, i10);
    t6 + d16 > n23 && e5.length > 0 ? u10 && o9 >= 0 ? (l8.push(e5.slice(0, o9 + 1)), e5 = e5.slice(o9 + 1) + a7, t6 = t6 - f11 - 1 + d16, o9 = -1, f11 = 0) : (l8.push(e5), e5 = a7, t6 = d16, o9 = -1, f11 = 0) : (e5 += a7, t6 += d16, (a7 === " " || a7 === "	") && (o9 = e5.length - 1, f11 = t6 - d16));
  }
  return e5.length > 0 && l8.push(e5), l8.join(`
`);
}
function b12(s9, r8) {
  if (s9 === "") return "";
  let n23 = s9.split(`
`), u10 = s9.endsWith(`
`) && n23[n23.length - 1] === "";
  return u10 && n23.pop(), n23.map((l8) => y9(l8, r8)).join(`
`) + (u10 ? `
` : "");
}
var m9, k5, x11;
var init_chunk_D4J545R4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-D4J545R4.js"() {
    init_chunk_74CEPOFO();
    m9 = { name: "fold", summary: "wrap each input line to fit in specified width", usage: "fold [OPTION]... [FILE]...", description: "Wrap input lines in each FILE, writing to standard output. If no FILE is specified, standard input is read.", options: ["-w WIDTH    Use WIDTH columns instead of 80", "-s          Break at spaces", "-b          Count bytes rather than columns"], examples: ["fold -w 40 file.txt           # Wrap at 40 columns", "fold -sw 40 file.txt          # Word wrap at 40 columns", "echo 'long line' | fold -w 5  # Force wrap at 5"] };
    k5 = { name: "fold", execute: async (s9, r8) => {
      if (o2(s9)) return s(m9);
      let n23 = { width: 80, breakAtSpaces: false, countBytes: false }, u10 = [], i10 = 0;
      for (; i10 < s9.length; ) {
        let e5 = s9[i10];
        if (e5 === "-w" && i10 + 1 < s9.length) {
          let t6 = parseInt(s9[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${s9[i10 + 1]}'
` };
          n23.width = t6, i10 += 2;
        } else if (e5.startsWith("-w") && e5.length > 2) {
          let t6 = parseInt(e5.slice(2), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${e5.slice(2)}'
` };
          n23.width = t6, i10++;
        } else if (e5 === "-s") n23.breakAtSpaces = true, i10++;
        else if (e5 === "-b") n23.countBytes = true, i10++;
        else if (e5 === "-bs" || e5 === "-sb") n23.breakAtSpaces = true, n23.countBytes = true, i10++;
        else if (e5.match(/^-[sb]+w\d+$/)) {
          e5.includes("s") && (n23.breakAtSpaces = true), e5.includes("b") && (n23.countBytes = true);
          let t6 = e5.replace(/^-[sb]+w/, ""), o9 = parseInt(t6, 10);
          if (Number.isNaN(o9) || o9 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${t6}'
` };
          n23.width = o9, i10++;
        } else if (e5.match(/^-[sb]+w$/) && i10 + 1 < s9.length) {
          e5.includes("s") && (n23.breakAtSpaces = true), e5.includes("b") && (n23.countBytes = true);
          let t6 = parseInt(s9[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `fold: invalid number of columns: '${s9[i10 + 1]}'
` };
          n23.width = t6, i10 += 2;
        } else if (e5 === "--") {
          u10.push(...s9.slice(i10 + 1));
          break;
        } else if (e5.startsWith("-") && e5 !== "-") {
          let t6 = e5.slice(1), o9 = false;
          for (let f11 of t6) if (f11 === "s") n23.breakAtSpaces = true;
          else if (f11 === "b") n23.countBytes = true;
          else {
            o9 = true;
            break;
          }
          if (o9) return r3("fold", e5);
          i10++;
        } else u10.push(e5), i10++;
      }
      let l8 = "";
      if (u10.length === 0) {
        let e5 = r8.stdin ?? "";
        l8 = b12(e5, n23);
      } else for (let e5 of u10) {
        let t6 = r8.fs.resolvePath(r8.cwd, e5), o9 = await r8.fs.readFile(t6);
        if (o9 === null) return { exitCode: 1, stdout: l8, stderr: `fold: ${e5}: No such file or directory
` };
        l8 += b12(o9, n23);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    x11 = { name: "fold", flags: [{ flag: "-w", type: "value", valueHint: "number" }, { flag: "-s", type: "boolean" }, { flag: "-b", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/fold-LDSORVYE.js
var fold_LDSORVYE_exports = {};
__export(fold_LDSORVYE_exports, {
  flagsForFuzzing: () => x11,
  fold: () => k5
});
var init_fold_LDSORVYE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/fold-LDSORVYE.js"() {
    init_chunk_D4J545R4();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VJFXDYWH.js
function p7(n23) {
  let i10 = n23.split(",").map((o9) => o9.trim()), t6 = [];
  for (let o9 of i10) {
    let e5 = parseInt(o9, 10);
    if (Number.isNaN(e5) || e5 < 1) return null;
    t6.push(e5);
  }
  for (let o9 = 1; o9 < t6.length; o9++) if (t6[o9] <= t6[o9 - 1]) return null;
  return t6;
}
function x12(n23, i10) {
  if (i10.length === 1) {
    let t6 = i10[0];
    return t6 - n23 % t6;
  }
  for (let t6 of i10) if (t6 > n23) return t6 - n23;
  if (i10.length >= 2) {
    let t6 = i10[i10.length - 1] - i10[i10.length - 2], o9 = i10[i10.length - 1], e5 = Math.floor((n23 - o9) / t6) + 1;
    return o9 + e5 * t6 - n23;
  }
  return 1;
}
function g10(n23, i10) {
  let { tabStops: t6, leadingOnly: o9 } = i10, e5 = "", l8 = 0, s9 = true;
  for (let a7 of n23) if (a7 === "	") if (o9 && !s9) e5 += a7, l8++;
  else {
    let r8 = x12(l8, t6);
    e5 += " ".repeat(r8), l8 += r8;
  }
  else a7 !== " " && a7 !== "	" && (s9 = false), e5 += a7, l8++;
  return e5;
}
function c5(n23, i10) {
  if (n23 === "") return "";
  let t6 = n23.split(`
`), o9 = n23.endsWith(`
`) && t6[t6.length - 1] === "";
  return o9 && t6.pop(), t6.map((l8) => g10(l8, i10)).join(`
`) + (o9 ? `
` : "");
}
var h9, m10, v9;
var init_chunk_VJFXDYWH = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VJFXDYWH.js"() {
    init_chunk_74CEPOFO();
    h9 = { name: "expand", summary: "convert tabs to spaces", usage: "expand [OPTION]... [FILE]...", description: "Convert TABs in each FILE to spaces, writing to standard output. If no FILE is specified, standard input is read.", options: ["-t N        Use N spaces per tab (default: 8)", "-t LIST     Use comma-separated list of tab stops", "-i          Only convert leading tabs on each line"], examples: ["expand file.txt             # Convert all tabs to 8 spaces", "expand -t 4 file.txt        # Use 4-space tabs", "expand -t 4,8,12 file.txt   # Custom tab stops"] };
    m10 = { name: "expand", execute: async (n23, i10) => {
      if (o2(n23)) return s(h9);
      let t6 = { tabStops: [8], leadingOnly: false }, o9 = [], e5 = 0;
      for (; e5 < n23.length; ) {
        let s9 = n23[e5];
        if (s9 === "-t" && e5 + 1 < n23.length) {
          let a7 = p7(n23[e5 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${n23[e5 + 1]}'
` };
          t6.tabStops = a7, e5 += 2;
        } else if (s9.startsWith("-t") && s9.length > 2) {
          let a7 = p7(s9.slice(2));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${s9.slice(2)}'
` };
          t6.tabStops = a7, e5++;
        } else if (s9 === "--tabs" && e5 + 1 < n23.length) {
          let a7 = p7(n23[e5 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${n23[e5 + 1]}'
` };
          t6.tabStops = a7, e5 += 2;
        } else if (s9.startsWith("--tabs=")) {
          let a7 = p7(s9.slice(7));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `expand: invalid tab size: '${s9.slice(7)}'
` };
          t6.tabStops = a7, e5++;
        } else if (s9 === "-i" || s9 === "--initial") t6.leadingOnly = true, e5++;
        else if (s9 === "--") {
          o9.push(...n23.slice(e5 + 1));
          break;
        } else {
          if (s9.startsWith("-") && s9 !== "-") return r3("expand", s9);
          o9.push(s9), e5++;
        }
      }
      let l8 = "";
      if (o9.length === 0) {
        let s9 = i10.stdin ?? "";
        l8 = c5(s9, t6);
      } else for (let s9 of o9) {
        let a7 = i10.fs.resolvePath(i10.cwd, s9), r8 = await i10.fs.readFile(a7);
        if (r8 === null) return { exitCode: 1, stdout: l8, stderr: `expand: ${s9}: No such file or directory
` };
        l8 += c5(r8, t6);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    v9 = { name: "expand", flags: [{ flag: "-t", type: "value", valueHint: "number" }, { flag: "-i", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/expand-DTNXU4LQ.js
var expand_DTNXU4LQ_exports = {};
__export(expand_DTNXU4LQ_exports, {
  expand: () => m10,
  flagsForFuzzing: () => v9
});
var init_expand_DTNXU4LQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/expand-DTNXU4LQ.js"() {
    init_chunk_VJFXDYWH();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PYSFUGCK.js
function f7(s9) {
  let i10 = s9.split(",").map((l8) => l8.trim()), e5 = [];
  for (let l8 of i10) {
    let n23 = parseInt(l8, 10);
    if (Number.isNaN(n23) || n23 < 1) return null;
    e5.push(n23);
  }
  for (let l8 = 1; l8 < e5.length; l8++) if (e5[l8] <= e5[l8 - 1]) return null;
  return e5;
}
function v10(s9, i10) {
  if (i10.length === 1) {
    let e5 = i10[0];
    return s9 + (e5 - s9 % e5);
  }
  for (let e5 of i10) if (e5 > s9) return e5;
  if (i10.length >= 2) {
    let e5 = i10[i10.length - 1] - i10[i10.length - 2], l8 = i10[i10.length - 1], n23 = Math.floor((s9 - l8) / e5) + 1;
    return l8 + n23 * e5;
  }
  return -1;
}
function L8(s9, i10) {
  let { tabStops: e5, allBlanks: l8 } = i10, n23 = "", o9 = 0, t6 = "", a7 = 0, u10 = true, d16 = () => {
    if (t6.length === 0) return;
    let r8 = a7 + t6.length;
    if (!l8 && !u10) {
      n23 += t6, t6 = "";
      return;
    }
    let p17 = a7, c14 = "";
    for (; p17 < r8; ) {
      let h16 = v10(p17, e5);
      if (h16 <= r8 && h16 > p17) c14 += "	", p17 = h16;
      else break;
    }
    let x22 = r8 - p17;
    x22 > 0 && (c14 += " ".repeat(x22)), n23 += c14, t6 = "";
  };
  for (let r8 of s9) r8 === " " ? (t6.length === 0 && (a7 = o9), t6 += r8, o9++) : r8 === "	" ? (d16(), n23 += r8, o9 = v10(o9, e5)) : (d16(), n23 += r8, o9++, u10 = false);
  return d16(), n23;
}
function C8(s9, i10) {
  if (s9 === "") return "";
  let e5 = s9.split(`
`), l8 = s9.endsWith(`
`) && e5[e5.length - 1] === "";
  return l8 && e5.pop(), e5.map((o9) => L8(o9, i10)).join(`
`) + (l8 ? `
` : "");
}
var k6, w8, F9;
var init_chunk_PYSFUGCK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PYSFUGCK.js"() {
    init_chunk_74CEPOFO();
    k6 = { name: "unexpand", summary: "convert spaces to tabs", usage: "unexpand [OPTION]... [FILE]...", description: "Convert blanks in each FILE to TABs, writing to standard output. If no FILE is specified, standard input is read.", options: ["-t N        Use N spaces per tab (default: 8)", "-t LIST     Use comma-separated list of tab stops", "-a          Convert all sequences of blanks (not just leading)"], examples: ["unexpand file.txt           # Convert leading spaces to tabs", "unexpand -a file.txt        # Convert all space sequences", "unexpand -t 4 file.txt      # Use 4-space tabs"] };
    w8 = { name: "unexpand", execute: async (s9, i10) => {
      if (o2(s9)) return s(k6);
      let e5 = { tabStops: [8], allBlanks: false }, l8 = [], n23 = 0;
      for (; n23 < s9.length; ) {
        let t6 = s9[n23];
        if (t6 === "-t" && n23 + 1 < s9.length) {
          let a7 = f7(s9[n23 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${s9[n23 + 1]}'
` };
          e5.tabStops = a7, n23 += 2;
        } else if (t6.startsWith("-t") && t6.length > 2) {
          let a7 = f7(t6.slice(2));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${t6.slice(2)}'
` };
          e5.tabStops = a7, n23++;
        } else if (t6 === "--tabs" && n23 + 1 < s9.length) {
          let a7 = f7(s9[n23 + 1]);
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${s9[n23 + 1]}'
` };
          e5.tabStops = a7, n23 += 2;
        } else if (t6.startsWith("--tabs=")) {
          let a7 = f7(t6.slice(7));
          if (!a7) return { exitCode: 1, stdout: "", stderr: `unexpand: invalid tab size: '${t6.slice(7)}'
` };
          e5.tabStops = a7, n23++;
        } else if (t6 === "-a" || t6 === "--all") e5.allBlanks = true, n23++;
        else if (t6 === "--") {
          l8.push(...s9.slice(n23 + 1));
          break;
        } else {
          if (t6.startsWith("-") && t6 !== "-") return r3("unexpand", t6);
          l8.push(t6), n23++;
        }
      }
      let o9 = "";
      if (l8.length === 0) {
        let t6 = i10.stdin ?? "";
        o9 = C8(t6, e5);
      } else for (let t6 of l8) {
        let a7 = i10.fs.resolvePath(i10.cwd, t6), u10 = await i10.fs.readFile(a7);
        if (u10 === null) return { exitCode: 1, stdout: o9, stderr: `unexpand: ${t6}: No such file or directory
` };
        o9 += C8(u10, e5);
      }
      return { exitCode: 0, stdout: o9, stderr: "" };
    } };
    F9 = { name: "unexpand", flags: [{ flag: "-t", type: "value", valueHint: "number" }, { flag: "-a", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/unexpand-RGTMIGZM.js
var unexpand_RGTMIGZM_exports = {};
__export(unexpand_RGTMIGZM_exports, {
  flagsForFuzzing: () => F9,
  unexpand: () => w8
});
var init_unexpand_RGTMIGZM = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/unexpand-RGTMIGZM.js"() {
    init_chunk_PYSFUGCK();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VYOJP4TV.js
function p8(n23) {
  return n23 >= 32 && n23 <= 126 || n23 === 9;
}
function d8(n23, s9) {
  if (s9 === null) return "";
  switch (s9) {
    case "o":
      return `${n23.toString(8).padStart(7, " ")} `;
    case "x":
      return `${n23.toString(16).padStart(7, " ")} `;
    case "d":
      return `${n23.toString(10).padStart(7, " ")} `;
    default:
      return s9;
  }
}
function g11(n23, s9) {
  let o9 = [], r8 = "", i10 = 0, l8 = typeof n23 == "string" ? new TextEncoder().encode(n23) : n23;
  for (let e5 = 0; e5 < l8.length; e5++) {
    let t6 = l8[e5];
    if (p8(t6)) r8.length === 0 && (i10 = e5), r8 += String.fromCharCode(t6);
    else {
      if (r8.length >= s9.minLength) {
        let a7 = d8(i10, s9.offsetFormat);
        o9.push(`${a7}${r8}`);
      }
      r8 = "";
    }
  }
  if (r8.length >= s9.minLength) {
    let e5 = d8(i10, s9.offsetFormat);
    o9.push(`${e5}${r8}`);
  }
  return o9;
}
var m11, b13, N6;
var init_chunk_VYOJP4TV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VYOJP4TV.js"() {
    init_chunk_74CEPOFO();
    m11 = { name: "strings", summary: "print the sequences of printable characters in files", usage: "strings [OPTION]... [FILE]...", description: "For each FILE, print the printable character sequences that are at least MIN characters long. If no FILE is specified, standard input is read.", options: ["-n MIN       Print sequences of at least MIN characters (default: 4)", "-t FORMAT    Print offset before each string (o=octal, x=hex, d=decimal)", "-a           Scan the entire file (default behavior)", "-e ENCODING  Select character encoding (s=7-bit, S=8-bit)"], examples: ["strings file.bin          # Extract strings (min 4 chars)", "strings -n 8 file.bin     # Extract strings (min 8 chars)", "strings -t x file.bin     # Show hex offset", "echo 'hello' | strings    # Read from stdin"] };
    b13 = { name: "strings", execute: async (n23, s9) => {
      if (o2(n23)) return s(m11);
      let o9 = { minLength: 4, offsetFormat: null }, r8 = [], i10 = 0;
      for (; i10 < n23.length; ) {
        let e5 = n23[i10];
        if (e5 === "-n" && i10 + 1 < n23.length) {
          let t6 = Number.parseInt(n23[i10 + 1], 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${n23[i10 + 1]}'
` };
          o9.minLength = t6, i10 += 2;
        } else if (e5.match(/^-n\d+$/)) {
          let t6 = Number.parseInt(e5.slice(2), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${e5.slice(2)}'
` };
          o9.minLength = t6, i10++;
        } else if (e5.match(/^-\d+$/)) {
          let t6 = Number.parseInt(e5.slice(1), 10);
          if (Number.isNaN(t6) || t6 < 1) return { exitCode: 1, stdout: "", stderr: `strings: invalid minimum string length: '${e5.slice(1)}'
` };
          o9.minLength = t6, i10++;
        } else if (e5 === "-t" && i10 + 1 < n23.length) {
          let t6 = n23[i10 + 1];
          if (t6 !== "o" && t6 !== "x" && t6 !== "d") return { exitCode: 1, stdout: "", stderr: `strings: invalid radix: '${t6}'
` };
          o9.offsetFormat = t6, i10 += 2;
        } else if (e5.startsWith("-t") && e5.length === 3) {
          let t6 = e5[2];
          if (t6 !== "o" && t6 !== "x" && t6 !== "d") return { exitCode: 1, stdout: "", stderr: `strings: invalid radix: '${t6}'
` };
          o9.offsetFormat = t6, i10++;
        } else if (e5 === "-a" || e5 === "--all" || e5 === "-") e5 === "-" && r8.push(e5), i10++;
        else if (e5 === "-e" && i10 + 1 < n23.length) {
          let t6 = n23[i10 + 1];
          if (t6 !== "s" && t6 !== "S") return { exitCode: 1, stdout: "", stderr: `strings: invalid encoding: '${t6}'
` };
          i10 += 2;
        } else if (e5.startsWith("-e") && e5.length === 3) {
          let t6 = e5[2];
          if (t6 !== "s" && t6 !== "S") return { exitCode: 1, stdout: "", stderr: `strings: invalid encoding: '${t6}'
` };
          i10++;
        } else if (e5 === "--") {
          r8.push(...n23.slice(i10 + 1));
          break;
        } else {
          if (e5.startsWith("-") && e5 !== "-") return r3("strings", e5);
          r8.push(e5), i10++;
        }
      }
      let l8 = "";
      if (r8.length === 0) {
        let e5 = s9.stdin ?? "", t6 = g11(e5, o9);
        l8 = t6.length > 0 ? `${t6.join(`
`)}
` : "";
      } else for (let e5 of r8) {
        let t6;
        if (e5 === "-") t6 = s9.stdin ?? "";
        else {
          let h16 = s9.fs.resolvePath(s9.cwd, e5);
          if (t6 = await s9.fs.readFile(h16), t6 === null) return { exitCode: 1, stdout: l8, stderr: `strings: ${e5}: No such file or directory
` };
        }
        let a7 = g11(t6, o9);
        a7.length > 0 && (l8 += `${a7.join(`
`)}
`);
      }
      return { exitCode: 0, stdout: l8, stderr: "" };
    } };
    N6 = { name: "strings", flags: [{ flag: "-n", type: "value", valueHint: "number" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-a", type: "boolean" }, { flag: "-e", type: "value", valueHint: "string" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/strings-7PLOGTPD.js
var strings_7PLOGTPD_exports = {};
__export(strings_7PLOGTPD_exports, {
  flagsForFuzzing: () => N6,
  strings: () => b13
});
var init_strings_7PLOGTPD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/strings-7PLOGTPD.js"() {
    init_chunk_VYOJP4TV();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-KTGH7NTP.js
function p9(s9) {
  let l8 = s9.match(/^(\d+)([KMGTPEZY]?)([B]?)$/i);
  if (!l8) return null;
  let e5 = Number.parseInt(l8[1], 10);
  if (Number.isNaN(e5) || e5 < 1) return null;
  let o9 = (l8[2] || "").toUpperCase(), u10 = (/* @__PURE__ */ new Map([["", 1], ["K", 1024], ["M", 1024 * 1024], ["G", 1024 * 1024 * 1024], ["T", 1024 * 1024 * 1024 * 1024], ["P", 1024 * 1024 * 1024 * 1024 * 1024]])).get(o9);
  return u10 === void 0 ? null : e5 * u10;
}
function k7(s9, l8, e5) {
  if (l8) return s9.toString().padStart(e5, "0");
  let o9 = "abcdefghijklmnopqrstuvwxyz", t6 = "", u10 = s9;
  for (let r8 = 0; r8 < e5; r8++) t6 = o9[u10 % 26] + t6, u10 = Math.floor(u10 / 26);
  return t6;
}
function y10(s9, l8) {
  let e5 = s9.split(`
`), o9 = s9.endsWith(`
`) && e5[e5.length - 1] === "";
  o9 && e5.pop();
  let t6 = [];
  for (let u10 = 0; u10 < e5.length; u10 += l8) {
    let r8 = e5.slice(u10, u10 + l8), c14 = u10 + l8 >= e5.length && !o9 ? r8.join(`
`) : `${r8.join(`
`)}
`;
    t6.push({ content: c14, hasContent: true });
  }
  return t6;
}
function g12(s9, l8) {
  let o9 = new TextEncoder().encode(s9), t6 = new TextDecoder(), u10 = [];
  for (let r8 = 0; r8 < o9.length; r8 += l8) {
    let f11 = o9.slice(r8, r8 + l8);
    u10.push({ content: t6.decode(f11), hasContent: f11.length > 0 });
  }
  return u10;
}
function C9(s9, l8) {
  let o9 = new TextEncoder().encode(s9), t6 = new TextDecoder(), u10 = [], r8 = Math.ceil(o9.length / l8);
  for (let f11 = 0; f11 < l8; f11++) {
    let c14 = f11 * r8, i10 = Math.min(c14 + r8, o9.length), n23 = o9.slice(c14, i10);
    u10.push({ content: t6.decode(n23), hasContent: n23.length > 0 });
  }
  return u10;
}
var N7, S6, I10;
var init_chunk_KTGH7NTP = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-KTGH7NTP.js"() {
    init_chunk_74CEPOFO();
    N7 = { name: "split", summary: "split a file into pieces", usage: "split [OPTION]... [FILE [PREFIX]]", description: "Output pieces of FILE to PREFIXaa, PREFIXab, ...; default size is 1000 lines, and default PREFIX is 'x'.", options: ["-l N         Put N lines per output file", "-b SIZE      Put SIZE bytes per output file (K, M, G suffixes)", "-n CHUNKS    Split into CHUNKS equal-sized files", "-d           Use numeric suffixes (00, 01, ...) instead of alphabetic", "-a LENGTH    Use suffixes of length LENGTH (default: 2)", "--additional-suffix=SUFFIX  Append SUFFIX to file names"], examples: ["split -l 100 file.txt        # Split into 100-line chunks", "split -b 1M file.bin         # Split into 1MB chunks", "split -n 5 file.txt          # Split into 5 equal parts", "split -d file.txt part_      # part_00, part_01, ...", "split -a 3 -d file.txt x     # x000, x001, ..."] };
    S6 = { name: "split", execute: async (s9, l8) => {
      if (o2(s9)) return s(N7);
      let e5 = { mode: "lines", lines: 1e3, bytes: 0, chunks: 0, useNumericSuffix: false, suffixLength: 2, additionalSuffix: "" }, o9 = [], t6 = 0;
      for (; t6 < s9.length; ) {
        let i10 = s9[t6];
        if (i10 === "-l" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of lines: '${s9[t6 + 1]}'
` };
          e5.mode = "lines", e5.lines = n23, t6 += 2;
        } else if (i10.match(/^-l\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of lines: '${i10.slice(2)}'
` };
          e5.mode = "lines", e5.lines = n23, t6++;
        } else if (i10 === "-b" && t6 + 1 < s9.length) {
          let n23 = p9(s9[t6 + 1]);
          if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: invalid number of bytes: '${s9[t6 + 1]}'
` };
          e5.mode = "bytes", e5.bytes = n23, t6 += 2;
        } else if (i10.match(/^-b.+$/)) {
          let n23 = p9(i10.slice(2));
          if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: invalid number of bytes: '${i10.slice(2)}'
` };
          e5.mode = "bytes", e5.bytes = n23, t6++;
        } else if (i10 === "-n" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of chunks: '${s9[t6 + 1]}'
` };
          e5.mode = "chunks", e5.chunks = n23, t6 += 2;
        } else if (i10.match(/^-n\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid number of chunks: '${i10.slice(2)}'
` };
          e5.mode = "chunks", e5.chunks = n23, t6++;
        } else if (i10 === "-a" && t6 + 1 < s9.length) {
          let n23 = Number.parseInt(s9[t6 + 1], 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid suffix length: '${s9[t6 + 1]}'
` };
          e5.suffixLength = n23, t6 += 2;
        } else if (i10.match(/^-a\d+$/)) {
          let n23 = Number.parseInt(i10.slice(2), 10);
          if (Number.isNaN(n23) || n23 < 1) return { exitCode: 1, stdout: "", stderr: `split: invalid suffix length: '${i10.slice(2)}'
` };
          e5.suffixLength = n23, t6++;
        } else if (i10 === "-d" || i10 === "--numeric-suffixes") e5.useNumericSuffix = true, t6++;
        else if (i10.startsWith("--additional-suffix=")) e5.additionalSuffix = i10.slice(20), t6++;
        else if (i10 === "--additional-suffix" && t6 + 1 < s9.length) e5.additionalSuffix = s9[t6 + 1], t6 += 2;
        else if (i10 === "--") {
          o9.push(...s9.slice(t6 + 1));
          break;
        } else {
          if (i10.startsWith("-") && i10 !== "-") return r3("split", i10);
          o9.push(i10), t6++;
        }
      }
      let u10 = "-", r8 = "x";
      o9.length >= 1 && (u10 = o9[0]), o9.length >= 2 && (r8 = o9[1]);
      let f11;
      if (u10 === "-") f11 = l8.stdin ?? "";
      else {
        let i10 = l8.fs.resolvePath(l8.cwd, u10), n23 = await l8.fs.readFile(i10);
        if (n23 === null) return { exitCode: 1, stdout: "", stderr: `split: ${u10}: No such file or directory
` };
        f11 = n23;
      }
      if (f11 === "") return { exitCode: 0, stdout: "", stderr: "" };
      let c14;
      switch (e5.mode) {
        case "lines":
          c14 = y10(f11, e5.lines);
          break;
        case "bytes":
          c14 = g12(f11, e5.bytes);
          break;
        case "chunks":
          c14 = C9(f11, e5.chunks);
          break;
        default:
          return e5.mode;
      }
      for (let i10 = 0; i10 < c14.length; i10++) {
        let n23 = c14[i10];
        if (!n23.hasContent) continue;
        let m24 = k7(i10, e5.useNumericSuffix, e5.suffixLength), b25 = `${r8}${m24}${e5.additionalSuffix}`, x22 = l8.fs.resolvePath(l8.cwd, b25);
        await l8.fs.writeFile(x22, n23.content);
      }
      return { exitCode: 0, stdout: "", stderr: "" };
    } };
    I10 = { name: "split", flags: [{ flag: "-l", type: "value", valueHint: "number" }, { flag: "-b", type: "value", valueHint: "string" }, { flag: "-n", type: "value", valueHint: "number" }, { flag: "-d", type: "boolean" }, { flag: "-a", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/split-EZOC5IIZ.js
var split_EZOC5IIZ_exports = {};
__export(split_EZOC5IIZ_exports, {
  flagsForFuzzing: () => I10,
  split: () => S6
});
var init_split_EZOC5IIZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/split-EZOC5IIZ.js"() {
    init_chunk_KTGH7NTP();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-LWEGUNWT.js
function C10(t6, e5, l8) {
  return e5 ? l8 ? t6.split(e5) : t6.split(e5).filter((n23) => n23.length > 0) : l8 ? t6.split(/[ \t]/) : t6.split(/[ \t]+/).filter((n23) => n23.length > 0);
}
function I11(t6) {
  let e5 = [];
  for (let l8 of t6) for (let n23 = 0; n23 < l8.length; n23++) {
    let o9 = l8[n23].length;
    (e5[n23] === void 0 || o9 > e5[n23]) && (e5[n23] = o9);
  }
  return e5;
}
function W7(t6, e5) {
  if (t6.length === 0) return "";
  let l8 = I11(t6), n23 = [];
  for (let o9 of t6) {
    let c14 = [];
    for (let s9 = 0; s9 < o9.length; s9++) s9 === o9.length - 1 ? c14.push(o9[s9]) : c14.push(o9[s9].padEnd(l8[s9]));
    n23.push(c14.join(e5));
  }
  return n23.join(`
`);
}
function j5(t6, e5, l8) {
  if (t6.length === 0) return "";
  let n23 = Math.max(...t6.map((a7) => a7.length)), o9 = l8.length, c14 = n23 + o9, s9 = Math.max(1, Math.floor((e5 + o9) / c14)), p17 = Math.ceil(t6.length / s9), d16 = [];
  for (let a7 = 0; a7 < p17; a7++) {
    let i10 = [];
    for (let r8 = 0; r8 < s9; r8++) {
      let m24 = r8 * p17 + a7;
      m24 < t6.length && (r8 === s9 - 1 || (r8 + 1) * p17 + a7 >= t6.length ? i10.push(t6[m24]) : i10.push(t6[m24].padEnd(n23)));
    }
    d16.push(i10.join(l8));
  }
  return d16.join(`
`);
}
var v11, H8, M6, P8;
var init_chunk_LWEGUNWT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-LWEGUNWT.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    v11 = { name: "column", summary: "columnate lists", usage: "column [OPTION]... [FILE]...", description: "Format input into multiple columns. By default, fills rows first. Use -t to create a table based on whitespace-delimited input.", options: ["-t           Create a table (determine columns from input)", "-s SEP       Input field delimiter (default: whitespace)", "-o SEP       Output field delimiter (default: two spaces)", "-c WIDTH     Output width for fill mode (default: 80)", "-n           Don't merge multiple adjacent delimiters"], examples: ["ls | column              # Fill columns with ls output", "cat data | column -t     # Format as table", "column -t -s ',' file    # Format CSV as table", "column -c 40 file        # Fill 40-char wide columns"] };
    H8 = { table: { short: "t", long: "table", type: "boolean" }, separator: { short: "s", type: "string" }, outputSep: { short: "o", type: "string" }, width: { short: "c", type: "number", default: 80 }, noMerge: { short: "n", type: "boolean" } };
    M6 = { name: "column", execute: async (t6, e5) => {
      if (o2(t6)) return s(v11);
      let l8 = x3("column", t6, H8);
      if (!l8.ok) return l8.error;
      let { table: n23, separator: o9, outputSep: c14, width: s9, noMerge: p17 } = l8.result.flags, d16 = l8.result.positional, a7 = c14 ?? "  ", i10;
      if (d16.length === 0) i10 = e5.stdin ?? "";
      else {
        let u10 = [];
        for (let f11 of d16) if (f11 === "-") u10.push(e5.stdin ?? "");
        else {
          let w19 = e5.fs.resolvePath(e5.cwd, f11), y18 = await e5.fs.readFile(w19);
          if (y18 === null) return { exitCode: 1, stdout: "", stderr: `column: ${f11}: No such file or directory
` };
          u10.push(y18);
        }
        i10 = u10.join("");
      }
      if (i10 === "" || i10.trim() === "") return { exitCode: 0, stdout: "", stderr: "" };
      let r8 = i10.split(`
`);
      i10.endsWith(`
`) && r8[r8.length - 1] === "" && r8.pop();
      let g18 = r8.filter((u10) => u10.trim().length > 0), h16;
      if (n23) {
        let u10 = g18.map((f11) => C10(f11, o9, p17));
        h16 = W7(u10, a7);
      } else {
        let u10 = [];
        for (let f11 of g18) {
          let w19 = C10(f11, o9, p17);
          u10.push(...w19);
        }
        h16 = j5(u10, s9, a7);
      }
      return h16.length > 0 && (h16 += `
`), { exitCode: 0, stdout: h16, stderr: "" };
    } };
    P8 = { name: "column", flags: [{ flag: "-t", type: "boolean" }, { flag: "-s", type: "value", valueHint: "delimiter" }, { flag: "-o", type: "value", valueHint: "string" }, { flag: "-c", type: "value", valueHint: "number" }, { flag: "-n", type: "boolean" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/column-WLPMMSTS.js
var column_WLPMMSTS_exports = {};
__export(column_WLPMMSTS_exports, {
  column: () => M6,
  flagsForFuzzing: () => P8
});
var init_column_WLPMMSTS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/column-WLPMMSTS.js"() {
    init_chunk_LWEGUNWT();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A7ICOL4V.js
function N8(i10, s9) {
  return s9 ? i10.split(s9) : i10.split(/[ \t]+/).filter((n23) => n23.length > 0);
}
function F10(i10, s9, n23, f11) {
  let e5 = N8(i10, s9), r8 = e5[n23 - 1] ?? "";
  return f11 && (r8 = r8.toLowerCase()), { fields: e5, joinKey: r8, original: i10 };
}
function m12(i10, s9, n23) {
  let f11 = n23.separator ?? " ";
  if (n23.outputFormat) {
    let o9 = [];
    for (let { file: c14, field: p17 } of n23.outputFormat) {
      let a7 = c14 === 1 ? i10 : s9;
      a7 && p17 === 0 ? o9.push(a7.joinKey) : a7 && a7.fields[p17 - 1] !== void 0 ? o9.push(a7.fields[p17 - 1]) : o9.push(n23.emptyString);
    }
    return o9.join(f11);
  }
  let e5 = [], r8 = i10?.joinKey ?? s9?.joinKey ?? "";
  if (e5.push(r8), i10) for (let o9 = 0; o9 < i10.fields.length; o9++) o9 !== n23.field1 - 1 && e5.push(i10.fields[o9]);
  if (s9) for (let o9 = 0; o9 < s9.fields.length; o9++) o9 !== n23.field2 - 1 && e5.push(s9.fields[o9]);
  return e5.join(f11);
}
function I12(i10) {
  let s9 = i10.split(","), n23 = [];
  for (let f11 of s9) {
    let e5 = f11.trim().match(/^(\d+)\.(\d+)$/);
    if (!e5) return null;
    let r8 = Number.parseInt(e5[1], 10), o9 = Number.parseInt(e5[2], 10);
    if (r8 !== 1 && r8 !== 2) return null;
    n23.push({ file: r8, field: o9 });
  }
  return n23;
}
var v12, w9, U7;
var init_chunk_A7ICOL4V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A7ICOL4V.js"() {
    init_chunk_74CEPOFO();
    v12 = { name: "join", summary: "join lines of two files on a common field", usage: "join [OPTION]... FILE1 FILE2", description: "For each pair of input lines with identical join fields, write a line to standard output. The default join field is the first, delimited by blanks.", options: ["-1 FIELD     Join on this FIELD of file 1 (default: 1)", "-2 FIELD     Join on this FIELD of file 2 (default: 1)", "-t CHAR      Use CHAR as input and output field separator", "-a FILENUM   Also print unpairable lines from file FILENUM (1 or 2)", "-v FILENUM   Like -a but only output unpairable lines", "-e STRING    Replace missing fields with STRING", "-o FORMAT    Output format (comma-separated list of FILENUM.FIELD)", "-i           Ignore case when comparing fields"], examples: ["join file1 file2               # Join on first field", "join -1 2 -2 1 file1 file2     # Join file1 col 2 with file2 col 1", "join -t ',' file1.csv file2.csv  # Join CSV files", "join -a 1 file1 file2          # Left outer join"] };
    w9 = { name: "join", execute: async (i10, s9) => {
      if (o2(i10)) return s(v12);
      let n23 = { field1: 1, field2: 1, separator: null, printUnpairable: /* @__PURE__ */ new Set(), onlyUnpairable: /* @__PURE__ */ new Set(), emptyString: "", outputFormat: null, ignoreCase: false }, f11 = [], e5 = 0;
      for (; e5 < i10.length; ) {
        let t6 = i10[e5];
        if (t6 === "-1" && e5 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e5 + 1], 10);
          if (Number.isNaN(l8) || l8 < 1) return { exitCode: 1, stdout: "", stderr: `join: invalid field number: '${i10[e5 + 1]}'
` };
          n23.field1 = l8, e5 += 2;
        } else if (t6 === "-2" && e5 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e5 + 1], 10);
          if (Number.isNaN(l8) || l8 < 1) return { exitCode: 1, stdout: "", stderr: `join: invalid field number: '${i10[e5 + 1]}'
` };
          n23.field2 = l8, e5 += 2;
        } else if ((t6 === "-t" || t6 === "--field-separator") && e5 + 1 < i10.length) n23.separator = i10[e5 + 1], e5 += 2;
        else if (t6.startsWith("-t") && t6.length > 2) n23.separator = t6.slice(2), e5++;
        else if (t6 === "-a" && e5 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e5 + 1], 10);
          if (l8 !== 1 && l8 !== 2) return { exitCode: 1, stdout: "", stderr: `join: invalid file number: '${i10[e5 + 1]}'
` };
          n23.printUnpairable.add(l8), e5 += 2;
        } else if (t6.match(/^-a[12]$/)) n23.printUnpairable.add(Number.parseInt(t6[2], 10)), e5++;
        else if (t6 === "-v" && e5 + 1 < i10.length) {
          let l8 = Number.parseInt(i10[e5 + 1], 10);
          if (l8 !== 1 && l8 !== 2) return { exitCode: 1, stdout: "", stderr: `join: invalid file number: '${i10[e5 + 1]}'
` };
          n23.onlyUnpairable.add(l8), e5 += 2;
        } else if (t6.match(/^-v[12]$/)) n23.onlyUnpairable.add(Number.parseInt(t6[2], 10)), e5++;
        else if (t6 === "-e" && e5 + 1 < i10.length) n23.emptyString = i10[e5 + 1], e5 += 2;
        else if (t6 === "-o" && e5 + 1 < i10.length) {
          let l8 = I12(i10[e5 + 1]);
          if (!l8) return { exitCode: 1, stdout: "", stderr: `join: invalid field spec: '${i10[e5 + 1]}'
` };
          n23.outputFormat = l8, e5 += 2;
        } else if (t6 === "-i" || t6 === "--ignore-case") n23.ignoreCase = true, e5++;
        else if (t6 === "--") {
          f11.push(...i10.slice(e5 + 1));
          break;
        } else {
          if (t6.startsWith("-") && t6 !== "-") return r3("join", t6);
          f11.push(t6), e5++;
        }
      }
      if (f11.length !== 2) return { exitCode: 1, stdout: "", stderr: f11.length < 2 ? `join: missing file operand
` : `join: extra operand
` };
      let r8 = [];
      for (let t6 of f11) if (t6 === "-") r8.push(s9.stdin ?? "");
      else {
        let l8 = s9.fs.resolvePath(s9.cwd, t6), u10 = await s9.fs.readFile(l8);
        if (u10 === null) return { exitCode: 1, stdout: "", stderr: `join: ${t6}: No such file or directory
` };
        r8.push(u10);
      }
      let o9 = (t6, l8) => {
        let u10 = t6.split(`
`);
        return t6.endsWith(`
`) && u10[u10.length - 1] === "" && u10.pop(), u10.filter((h16) => h16.length > 0).map((h16) => F10(h16, n23.separator, l8, n23.ignoreCase));
      }, c14 = o9(r8[0], n23.field1), p17 = o9(r8[1], n23.field2), a7 = /* @__PURE__ */ new Map();
      for (let t6 of p17) {
        let l8 = a7.get(t6.joinKey);
        l8 ? l8.push(t6) : a7.set(t6.joinKey, [t6]);
      }
      let d16 = [], b25 = /* @__PURE__ */ new Set();
      for (let t6 of c14) {
        let l8 = a7.get(t6.joinKey);
        if (l8 && l8.length > 0) {
          if (b25.add(t6.joinKey), n23.onlyUnpairable.size === 0) for (let u10 of l8) d16.push(m12(t6, u10, n23));
        } else (n23.printUnpairable.has(1) || n23.onlyUnpairable.has(1)) && d16.push(m12(t6, null, n23));
      }
      if (n23.printUnpairable.has(2) || n23.onlyUnpairable.has(2)) for (let t6 of p17) b25.has(t6.joinKey) || d16.push(m12(null, t6, n23));
      return { exitCode: 0, stdout: d16.length > 0 ? `${d16.join(`
`)}
` : "", stderr: "" };
    } };
    U7 = { name: "join", flags: [{ flag: "-1", type: "value", valueHint: "number" }, { flag: "-2", type: "value", valueHint: "number" }, { flag: "-t", type: "value", valueHint: "delimiter" }, { flag: "-a", type: "value", valueHint: "number" }, { flag: "-v", type: "value", valueHint: "number" }, { flag: "-e", type: "value", valueHint: "string" }, { flag: "-o", type: "value", valueHint: "format" }, { flag: "-i", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/join-GG2LDHE5.js
var join_GG2LDHE5_exports = {};
__export(join_GG2LDHE5_exports, {
  flagsForFuzzing: () => U7,
  join: () => w9
});
var init_join_GG2LDHE5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/join-GG2LDHE5.js"() {
    init_chunk_A7ICOL4V();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-55VFSPNA.js
var u3, m13, y11, w10;
var init_chunk_55VFSPNA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-55VFSPNA.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    u3 = { name: "tee", summary: "read from stdin and write to stdout and files", usage: "tee [OPTION]... [FILE]...", options: ["-a, --append     append to the given FILEs, do not overwrite", "    --help       display this help and exit"] };
    m13 = { append: { short: "a", long: "append", type: "boolean" } };
    y11 = { name: "tee", async execute(n23, e5) {
      if (o2(n23)) return s(u3);
      let t6 = x3("tee", n23, m13);
      if (!t6.ok) return t6.error;
      let { append: f11 } = t6.result.flags, c14 = t6.result.positional, o9 = e5.stdin, r8 = "", a7 = 0;
      for (let i10 of c14) try {
        let s9 = e5.fs.resolvePath(e5.cwd, i10);
        f11 ? await e5.fs.appendFile(s9, o9) : await e5.fs.writeFile(s9, o9);
      } catch {
        r8 += `tee: ${i10}: No such file or directory
`, a7 = 1;
      }
      return { stdout: o9, stderr: r8, exitCode: a7 };
    } };
    w10 = { name: "tee", flags: [{ flag: "-a", type: "boolean" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tee-O7VXZDCO.js
var tee_O7VXZDCO_exports = {};
__export(tee_O7VXZDCO_exports, {
  flagsForFuzzing: () => w10,
  teeCommand: () => y11
});
var init_tee_O7VXZDCO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tee-O7VXZDCO.js"() {
    init_chunk_55VFSPNA();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-YYB54I7F.js
function N9(e5, t6) {
  switch (e5.type) {
    case "name": {
      let n23 = e5.pattern, r8 = n23.match(/^\*(\.[a-zA-Z0-9]+)$/);
      if (r8) {
        let s9 = r8[1], o9 = t6.name;
        if (e5.ignoreCase) {
          if (!o9.toLowerCase().endsWith(s9.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!o9.endsWith(s9)) return { matches: false, pruned: false, printed: false };
        return { matches: true, pruned: false, printed: false };
      }
      return { matches: h6(t6.name, n23, e5.ignoreCase), pruned: false, printed: false };
    }
    case "path": {
      let n23 = e5.pattern, r8 = t6.relativePath, s9 = n23.split("/");
      for (let i10 = 0; i10 < s9.length - 1; i10++) {
        let a7 = s9[i10];
        if (a7 && a7 !== "." && a7 !== ".." && !a7.includes("*") && !a7.includes("?") && !a7.includes("[")) {
          let c14 = `/${a7}/`;
          if (e5.ignoreCase) {
            if (!r8.toLowerCase().includes(c14.toLowerCase())) return { matches: false, pruned: false, printed: false };
          } else if (!r8.includes(c14)) return { matches: false, pruned: false, printed: false };
        }
      }
      let o9 = n23.match(/\*(\.[a-zA-Z0-9]+)$/);
      if (o9) {
        let i10 = o9[1];
        if (e5.ignoreCase) {
          if (!r8.toLowerCase().endsWith(i10.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!r8.endsWith(i10)) return { matches: false, pruned: false, printed: false };
      }
      return { matches: h6(r8, n23, e5.ignoreCase), pruned: false, printed: false };
    }
    case "regex":
      try {
        let n23 = e5.ignoreCase ? "i" : "";
        return { matches: b1(e5.pattern, n23).test(t6.relativePath), pruned: false, printed: false };
      } catch {
        return { matches: false, pruned: false, printed: false };
      }
    case "type":
      return e5.fileType === "f" ? { matches: t6.isFile, pruned: false, printed: false } : e5.fileType === "d" ? { matches: t6.isDirectory, pruned: false, printed: false } : { matches: false, pruned: false, printed: false };
    case "empty":
      return { matches: t6.isEmpty, pruned: false, printed: false };
    case "mtime": {
      let r8 = (Date.now() - t6.mtime) / (1e3 * 60 * 60 * 24), s9;
      return e5.comparison === "more" ? s9 = r8 > e5.days : e5.comparison === "less" ? s9 = r8 < e5.days : s9 = Math.floor(r8) === e5.days, { matches: s9, pruned: false, printed: false };
    }
    case "newer": {
      let n23 = t6.newerRefTimes.get(e5.refPath);
      return n23 === void 0 ? { matches: false, pruned: false, printed: false } : { matches: t6.mtime > n23, pruned: false, printed: false };
    }
    case "size": {
      let n23 = e5.value;
      switch (e5.unit) {
        case "c":
          n23 = e5.value;
          break;
        case "k":
          n23 = e5.value * 1024;
          break;
        case "M":
          n23 = e5.value * 1024 * 1024;
          break;
        case "G":
          n23 = e5.value * 1024 * 1024 * 1024;
          break;
        case "b":
          n23 = e5.value * 512;
          break;
      }
      let r8;
      return e5.comparison === "more" ? r8 = t6.size > n23 : e5.comparison === "less" ? r8 = t6.size < n23 : e5.unit === "b" ? r8 = Math.ceil(t6.size / 512) === e5.value : r8 = t6.size === n23, { matches: r8, pruned: false, printed: false };
    }
    case "perm": {
      let n23 = t6.mode & 511, r8 = e5.mode & 511, s9;
      return e5.matchType === "exact" ? s9 = n23 === r8 : e5.matchType === "all" ? s9 = (n23 & r8) === r8 : s9 = (n23 & r8) !== 0, { matches: s9, pruned: false, printed: false };
    }
    case "prune":
      return { matches: true, pruned: true, printed: false };
    case "print":
      return { matches: true, pruned: false, printed: true };
    case "not": {
      let n23 = N9(e5.expr, t6);
      return { matches: !n23.matches, pruned: n23.pruned, printed: false };
    }
    case "and": {
      let n23 = N9(e5.left, t6);
      if (!n23.matches) return { matches: false, pruned: n23.pruned, printed: false };
      let r8 = N9(e5.right, t6);
      return { matches: r8.matches, pruned: n23.pruned || r8.pruned, printed: n23.printed || r8.printed };
    }
    case "or": {
      let n23 = N9(e5.left, t6);
      if (n23.matches) return n23;
      let r8 = N9(e5.right, t6);
      return { matches: r8.matches, pruned: n23.pruned || r8.pruned, printed: r8.printed };
    }
  }
}
function Y7(e5) {
  if (!e5) return false;
  switch (e5.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return false;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return true;
    case "not":
      return Y7(e5.expr);
    case "and":
    case "or":
      return Y7(e5.left) || Y7(e5.right);
  }
}
function _5(e5) {
  if (!e5) return false;
  switch (e5.type) {
    case "empty":
      return true;
    case "not":
      return _5(e5.expr);
    case "and":
    case "or":
      return _5(e5.left) || _5(e5.right);
    default:
      return false;
  }
}
function pe5(e5) {
  let t6 = { terminalDirName: null, requiredExtension: null };
  if (!e5) return t6;
  let n23 = be2(e5);
  if (ve3(e5) && n23.length === 1) {
    let o9 = n23[0].split("/").filter((i10) => i10.length > 0);
    if (o9.length >= 2) for (let i10 = o9.length - 2; i10 >= 0; i10--) {
      let a7 = o9[i10];
      if (!a7.includes("*") && !a7.includes("?") && !a7.includes("[") && a7 !== "." && a7 !== "..") {
        let c14 = o9[i10 + 1];
        if (c14 && (c14.includes("*") || c14.includes("?"))) {
          t6.terminalDirName = a7;
          let l8 = c14.match(/^\*(\.[a-zA-Z0-9]+)$/);
          l8 && (t6.requiredExtension = l8[1]);
        }
        break;
      }
    }
  }
  return t6;
}
function be2(e5) {
  let t6 = [], n23 = (r8) => {
    r8.type === "path" ? t6.push(r8.pattern) : r8.type === "not" ? n23(r8.expr) : (r8.type === "and" || r8.type === "or") && (n23(r8.left), n23(r8.right));
  };
  return n23(e5), t6;
}
function ve3(e5) {
  let t6 = (n23) => n23.type === "type" && n23.fileType === "f" ? true : n23.type === "not" ? t6(n23.expr) : n23.type === "and" || n23.type === "or" ? t6(n23.left) || t6(n23.right) : false;
  return t6(e5);
}
function fe6(e5) {
  let t6 = [], n23 = (r8) => {
    r8 && (r8.type === "newer" ? t6.push(r8.refPath) : r8.type === "not" ? n23(r8.expr) : (r8.type === "and" || r8.type === "or") && (n23(r8.left), n23(r8.right)));
  };
  return n23(e5), t6;
}
function V7(e5) {
  if (!e5) return true;
  switch (e5.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return true;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return false;
    case "not":
      return V7(e5.expr);
    case "and":
    case "or":
      return V7(e5.left) && V7(e5.right);
  }
}
function H9(e5, t6, n23, r8, s9) {
  switch (e5.type) {
    case "name": {
      let o9 = e5.pattern, i10 = o9.match(/^\*(\.[a-zA-Z0-9]+)$/);
      if (i10) {
        let a7 = i10[1];
        if (e5.ignoreCase) {
          if (!t6.toLowerCase().endsWith(a7.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!t6.endsWith(a7)) return { matches: false, pruned: false, printed: false };
        return { matches: true, pruned: false, printed: false };
      }
      return { matches: h6(t6, o9, e5.ignoreCase), pruned: false, printed: false };
    }
    case "path": {
      let o9 = e5.pattern, i10 = o9.split("/");
      for (let c14 = 0; c14 < i10.length - 1; c14++) {
        let l8 = i10[c14];
        if (l8 && l8 !== "." && l8 !== ".." && !l8.includes("*") && !l8.includes("?") && !l8.includes("[")) {
          let d16 = `/${l8}/`;
          if (e5.ignoreCase) {
            if (!n23.toLowerCase().includes(d16.toLowerCase())) return { matches: false, pruned: false, printed: false };
          } else if (!n23.includes(d16)) return { matches: false, pruned: false, printed: false };
        }
      }
      let a7 = o9.match(/\*(\.[a-zA-Z0-9]+)$/);
      if (a7) {
        let c14 = a7[1];
        if (e5.ignoreCase) {
          if (!n23.toLowerCase().endsWith(c14.toLowerCase())) return { matches: false, pruned: false, printed: false };
        } else if (!n23.endsWith(c14)) return { matches: false, pruned: false, printed: false };
      }
      return { matches: h6(n23, o9, e5.ignoreCase), pruned: false, printed: false };
    }
    case "regex":
      try {
        let o9 = e5.ignoreCase ? "i" : "";
        return { matches: b1(e5.pattern, o9).test(n23), pruned: false, printed: false };
      } catch {
        return { matches: false, pruned: false, printed: false };
      }
    case "type":
      return e5.fileType === "f" ? { matches: r8, pruned: false, printed: false } : e5.fileType === "d" ? { matches: s9, pruned: false, printed: false } : { matches: false, pruned: false, printed: false };
    case "prune":
      return { matches: true, pruned: true, printed: false };
    case "print":
      return { matches: true, pruned: false, printed: true };
    case "not": {
      let o9 = H9(e5.expr, t6, n23, r8, s9);
      return { matches: !o9.matches, pruned: o9.pruned, printed: false };
    }
    case "and": {
      let o9 = H9(e5.left, t6, n23, r8, s9);
      if (!o9.matches) return { matches: false, pruned: o9.pruned, printed: false };
      let i10 = H9(e5.right, t6, n23, r8, s9);
      return { matches: i10.matches, pruned: o9.pruned || i10.pruned, printed: o9.printed || i10.printed };
    }
    case "or": {
      let o9 = H9(e5.left, t6, n23, r8, s9);
      if (o9.matches) return o9;
      let i10 = H9(e5.right, t6, n23, r8, s9);
      return { matches: i10.matches, pruned: o9.pruned || i10.pruned, printed: i10.printed };
    }
    default:
      return { matches: false, pruned: false, printed: false };
  }
}
function J7(e5) {
  if (!e5) return false;
  switch (e5.type) {
    case "prune":
      return true;
    case "not":
      return J7(e5.expr);
    case "and":
    case "or":
      return J7(e5.left) || J7(e5.right);
    default:
      return false;
  }
}
function z5(e5) {
  switch (e5.type) {
    case "name":
    case "path":
    case "regex":
    case "type":
    case "prune":
    case "print":
      return true;
    case "empty":
    case "mtime":
    case "newer":
    case "size":
    case "perm":
      return false;
    case "not":
      return z5(e5.expr);
    case "and":
    case "or":
      return z5(e5.left) && z5(e5.right);
  }
}
function ue5(e5, t6) {
  if (!e5 || !t6.isDirectory) return { shouldPrune: false };
  if (!z5(e5)) return ne5(e5, t6);
  let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
  return { shouldPrune: N9(e5, n23).pruned };
}
function ne5(e5, t6) {
  switch (e5.type) {
    case "or": {
      if (z5(e5.left)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        if (N9(e5.left, n23).pruned) return { shouldPrune: true };
      }
      return ne5(e5.right, t6);
    }
    case "and": {
      if (z5(e5.left) && z5(e5.right)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        return { shouldPrune: N9(e5, n23).pruned };
      }
      if (z5(e5.left)) {
        let n23 = { name: t6.name, relativePath: t6.relativePath, isFile: t6.isFile, isDirectory: t6.isDirectory, isEmpty: false, mtime: 0, size: 0, mode: 0, newerRefTimes: /* @__PURE__ */ new Map() };
        return N9(e5.left, n23).matches ? ne5(e5.right, t6) : { shouldPrune: false };
      }
      return { shouldPrune: false };
    }
    case "not":
      return { shouldPrune: false };
    default:
      return { shouldPrune: false };
  }
}
function he5(e5, t6) {
  let n23 = [], r8 = [], s9 = t6;
  for (; s9 < e5.length; ) {
    let i10 = e5[s9];
    if (i10 === "(" || i10 === "\\(") {
      n23.push({ type: "lparen" }), s9++;
      continue;
    }
    if (i10 === ")" || i10 === "\\)") {
      n23.push({ type: "rparen" }), s9++;
      continue;
    }
    if (i10 === "-name" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "name", pattern: e5[++s9] } });
    else if (i10 === "-iname" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "name", pattern: e5[++s9], ignoreCase: true } });
    else if (i10 === "-path" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "path", pattern: e5[++s9] } });
    else if (i10 === "-ipath" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "path", pattern: e5[++s9], ignoreCase: true } });
    else if (i10 === "-regex" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "regex", pattern: e5[++s9] } });
    else if (i10 === "-iregex" && s9 + 1 < e5.length) n23.push({ type: "expr", expr: { type: "regex", pattern: e5[++s9], ignoreCase: true } });
    else if (i10 === "-type" && s9 + 1 < e5.length) {
      let a7 = e5[++s9];
      if (a7 === "f" || a7 === "d") n23.push({ type: "expr", expr: { type: "type", fileType: a7 } });
      else return { expr: null, pathIndex: s9, error: `find: Unknown argument to -type: ${a7}
`, actions: [] };
    } else if (i10 === "-empty") n23.push({ type: "expr", expr: { type: "empty" } });
    else if (i10 === "-mtime" && s9 + 1 < e5.length) {
      let a7 = e5[++s9], c14 = "exact", l8 = a7;
      a7.startsWith("+") ? (c14 = "more", l8 = a7.slice(1)) : a7.startsWith("-") && (c14 = "less", l8 = a7.slice(1));
      let d16 = parseInt(l8, 10);
      Number.isNaN(d16) || n23.push({ type: "expr", expr: { type: "mtime", days: d16, comparison: c14 } });
    } else if (i10 === "-newer" && s9 + 1 < e5.length) {
      let a7 = e5[++s9];
      n23.push({ type: "expr", expr: { type: "newer", refPath: a7 } });
    } else if (i10 === "-size" && s9 + 1 < e5.length) {
      let a7 = e5[++s9], c14 = "exact", l8 = a7;
      a7.startsWith("+") ? (c14 = "more", l8 = a7.slice(1)) : a7.startsWith("-") && (c14 = "less", l8 = a7.slice(1));
      let d16 = l8.match(/^(\d+)([ckMGb])?$/);
      if (d16) {
        let B12 = parseInt(d16[1], 10), I17 = d16[2] || "b";
        n23.push({ type: "expr", expr: { type: "size", value: B12, unit: I17, comparison: c14 } });
      }
    } else if (i10 === "-perm" && s9 + 1 < e5.length) {
      let a7 = e5[++s9], c14 = "exact", l8 = a7;
      a7.startsWith("-") ? (c14 = "all", l8 = a7.slice(1)) : a7.startsWith("/") && (c14 = "any", l8 = a7.slice(1));
      let d16 = parseInt(l8, 8);
      Number.isNaN(d16) || n23.push({ type: "expr", expr: { type: "perm", mode: d16, matchType: c14 } });
    } else if (i10 === "-prune") n23.push({ type: "expr", expr: { type: "prune" } });
    else if (i10 === "-not" || i10 === "!") n23.push({ type: "not" });
    else if (i10 === "-o" || i10 === "-or") n23.push({ type: "op", op: "or" });
    else if (i10 === "-a" || i10 === "-and") n23.push({ type: "op", op: "and" });
    else if (i10 === "-maxdepth" || i10 === "-mindepth") s9++;
    else if (i10 !== "-depth") if (i10 === "-exec") {
      let a7 = [];
      for (s9++; s9 < e5.length && e5[s9] !== ";" && e5[s9] !== "+"; ) a7.push(e5[s9]), s9++;
      if (s9 >= e5.length) return { expr: null, pathIndex: s9, error: "find: missing argument to `-exec'\n", actions: [] };
      let c14 = e5[s9] === "+";
      r8.push({ type: "exec", command: a7, batchMode: c14 });
    } else if (i10 === "-print") n23.push({ type: "expr", expr: { type: "print" } }), r8.push({ type: "print" });
    else if (i10 === "-print0") r8.push({ type: "print0" });
    else if (i10 === "-printf" && s9 + 1 < e5.length) {
      let a7 = e5[++s9];
      r8.push({ type: "printf", format: a7 });
    } else if (i10 === "-delete") r8.push({ type: "delete" });
    else {
      if (i10.startsWith("-")) return { expr: null, pathIndex: s9, error: `find: unknown predicate '${i10}'
`, actions: [] };
      if (n23.length === 0) {
        s9++;
        continue;
      }
      break;
    }
    s9++;
  }
  if (n23.length === 0) return { expr: null, pathIndex: s9, actions: r8 };
  let o9 = Ee2(n23);
  return o9.error ? { expr: null, pathIndex: s9, error: o9.error, actions: r8 } : { expr: o9.expr, pathIndex: s9, actions: r8 };
}
function Ee2(e5) {
  let t6 = 0;
  function n23() {
    let a7 = r8();
    if (!a7) return null;
    for (; t6 < e5.length; ) {
      let c14 = e5[t6];
      if (c14.type === "op" && c14.op === "or") {
        t6++;
        let l8 = r8();
        if (!l8) return a7;
        a7 = { type: "or", left: a7, right: l8 };
      } else break;
    }
    return a7;
  }
  function r8() {
    let a7 = s9();
    if (!a7) return null;
    for (; t6 < e5.length; ) {
      let c14 = e5[t6];
      if (c14.type === "op" && c14.op === "and") {
        t6++;
        let l8 = s9();
        if (!l8) return a7;
        a7 = { type: "and", left: a7, right: l8 };
      } else if (c14.type === "expr" || c14.type === "not" || c14.type === "lparen") {
        let l8 = s9();
        if (!l8) return a7;
        a7 = { type: "and", left: a7, right: l8 };
      } else break;
    }
    return a7;
  }
  function s9() {
    if (t6 < e5.length && e5[t6].type === "not") {
      t6++;
      let a7 = s9();
      return a7 ? { type: "not", expr: a7 } : null;
    }
    return o9();
  }
  function o9() {
    if (t6 >= e5.length) return null;
    let a7 = e5[t6];
    if (a7.type === "lparen") {
      t6++;
      let c14 = n23();
      return t6 < e5.length && e5[t6].type === "rparen" && t6++, c14;
    }
    return a7.type === "expr" ? (t6++, a7.expr) : (a7.type === "rparen", null);
  }
  return { expr: n23() };
}
function Me2() {
  return { readdirCalls: 0, readdirTime: 0, statCalls: 0, statTime: 0, evalCalls: 0, evalTime: 0, nodeCount: 0, batchCount: 0, batchTime: 0, earlyPrunes: 0 };
}
function xe3(e5, t6, n23) {
  e5({ category: "find", name: "summary", durationMs: n23, details: { readdirCalls: t6.readdirCalls, readdirTimeMs: t6.readdirTime, statCalls: t6.statCalls, statTimeMs: t6.statTime, evalCalls: t6.evalCalls, evalTimeMs: t6.evalTime, nodeCount: t6.nodeCount, batchCount: t6.batchCount, batchTimeMs: t6.batchTime, earlyPrunes: t6.earlyPrunes, otherTimeMs: n23 - t6.readdirTime - t6.statTime - t6.evalTime - t6.batchTime } });
}
function $e2(e5, t6) {
  let n23 = r4(e5), r8 = "", s9 = 0;
  for (; s9 < n23.length; ) if (n23[s9] === "%" && s9 + 1 < n23.length) {
    if (s9++, n23[s9] === "%") {
      r8 += "%", s9++;
      continue;
    }
    let [o9, i10, a7] = h3(n23, s9);
    if (s9 += a7, s9 >= n23.length) {
      r8 += "%";
      break;
    }
    let c14 = n23[s9], l8;
    switch (c14) {
      case "f":
        l8 = t6.name, s9++;
        break;
      case "h": {
        let d16 = t6.path.lastIndexOf("/");
        l8 = d16 > 0 ? t6.path.slice(0, d16) : ".", s9++;
        break;
      }
      case "p":
        l8 = t6.path, s9++;
        break;
      case "P": {
        let d16 = t6.startingPoint;
        t6.path === d16 ? l8 = "" : t6.path.startsWith(`${d16}/`) ? l8 = t6.path.slice(d16.length + 1) : d16 === "." && t6.path.startsWith("./") ? l8 = t6.path.slice(2) : l8 = t6.path, s9++;
        break;
      }
      case "s":
        l8 = String(t6.size), s9++;
        break;
      case "d":
        l8 = String(t6.depth), s9++;
        break;
      case "m":
        l8 = (t6.mode & 511).toString(8), s9++;
        break;
      case "M":
        l8 = Re4(t6.mode, t6.isDirectory), s9++;
        break;
      case "t": {
        let d16 = new Date(t6.mtime);
        l8 = ke2(d16), s9++;
        break;
      }
      case "T": {
        if (s9 + 1 < n23.length) {
          let d16 = n23[s9 + 1], B12 = new Date(t6.mtime);
          l8 = Ne3(B12, d16), s9 += 2;
        } else l8 = "%T", s9++;
        break;
      }
      default:
        r8 += `%${o9 !== 0 || i10 !== -1 ? `${o9}.${i10}` : ""}${c14}`, s9++;
        continue;
    }
    r8 += i2(l8, o9, i10);
  } else r8 += n23[s9], s9++;
  return r8;
}
function Re4(e5, t6) {
  let n23 = e5 & 511, r8 = t6 ? "d" : "-";
  return r8 += n23 & 256 ? "r" : "-", r8 += n23 & 128 ? "w" : "-", r8 += n23 & 64 ? "x" : "-", r8 += n23 & 32 ? "r" : "-", r8 += n23 & 16 ? "w" : "-", r8 += n23 & 8 ? "x" : "-", r8 += n23 & 4 ? "r" : "-", r8 += n23 & 2 ? "w" : "-", r8 += n23 & 1 ? "x" : "-", r8;
}
function ke2(e5) {
  let t6 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], n23 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], r8 = t6[e5.getDay()], s9 = n23[e5.getMonth()], o9 = String(e5.getDate()).padStart(2, " "), i10 = String(e5.getHours()).padStart(2, "0"), a7 = String(e5.getMinutes()).padStart(2, "0"), c14 = String(e5.getSeconds()).padStart(2, "0"), l8 = e5.getFullYear();
  return `${r8} ${s9} ${o9} ${i10}:${a7}:${c14} ${l8}`;
}
function Ne3(e5, t6) {
  switch (t6) {
    case "@":
      return String(e5.getTime() / 1e3);
    case "Y":
      return String(e5.getFullYear());
    case "m":
      return String(e5.getMonth() + 1).padStart(2, "0");
    case "d":
      return String(e5.getDate()).padStart(2, "0");
    case "H":
      return String(e5.getHours()).padStart(2, "0");
    case "M":
      return String(e5.getMinutes()).padStart(2, "0");
    case "S":
      return String(e5.getSeconds()).padStart(2, "0");
    case "T":
      return `${String(e5.getHours()).padStart(2, "0")}:${String(e5.getMinutes()).padStart(2, "0")}:${String(e5.getSeconds()).padStart(2, "0")}`;
    case "F":
      return `${e5.getFullYear()}-${String(e5.getMonth() + 1).padStart(2, "0")}-${String(e5.getDate()).padStart(2, "0")}`;
    default:
      return `%T${t6}`;
  }
}
var de5, Fe3, Ie3, je3, Ze3;
var init_chunk_YYB54I7F = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-YYB54I7F.js"() {
    init_chunk_IJXFPKNC();
    init_chunk_YNYSPYQ5();
    init_chunk_EEXR5ZDP();
    init_chunk_74CEPOFO();
    de5 = 500;
    Fe3 = { name: "find", summary: "search for files in a directory hierarchy", usage: "find [path...] [expression]", options: ["-name PATTERN    file name matches shell pattern PATTERN", "-iname PATTERN   like -name but case insensitive", "-path PATTERN    file path matches shell pattern PATTERN", "-ipath PATTERN   like -path but case insensitive", "-regex PATTERN   file path matches regular expression PATTERN", "-iregex PATTERN  like -regex but case insensitive", "-type TYPE       file is of type: f (regular file), d (directory)", "-empty           file is empty or directory is empty", "-mtime N         file's data was modified N*24 hours ago", "-newer FILE      file was modified more recently than FILE", "-size N[ckMGb]   file uses N units of space (c=bytes, k=KB, M=MB, G=GB, b=512B blocks)", "-perm MODE       file's permission bits are exactly MODE (octal)", "-perm -MODE      all permission bits MODE are set", "-perm /MODE      any permission bits MODE are set", "-maxdepth LEVELS descend at most LEVELS directories", "-mindepth LEVELS do not apply tests at levels less than LEVELS", "-depth           process directory contents before directory itself", "-prune           do not descend into this directory", "-not, !          negate the following expression", "-a, -and         logical AND (default)", "-o, -or          logical OR", "-exec CMD {} ;   execute CMD on each file ({} is replaced by filename)", "-exec CMD {} +   execute CMD with multiple files at once", "-print           print the full file name (default action)", "-print0          print the full file name followed by a null character", "-printf FORMAT   print FORMAT with directives: %f %h %p %P %s %d %m %M %t", "-delete          delete found files/directories", "    --help       display this help and exit"] };
    Ie3 = /* @__PURE__ */ new Set(["-name", "-iname", "-path", "-ipath", "-regex", "-iregex", "-type", "-maxdepth", "-mindepth", "-mtime", "-newer", "-size", "-perm"]);
    je3 = { name: "find", async execute(e5, t6) {
      if (o2(e5)) return s(Fe3);
      let n23 = [], r8 = null, s9 = null, o9 = false, i10 = false;
      for (let p17 = 0; p17 < e5.length; p17++) {
        let f11 = e5[p17];
        if (f11 === "-maxdepth" && p17 + 1 < e5.length) i10 = true, r8 = parseInt(e5[++p17], 10);
        else if (f11 === "-mindepth" && p17 + 1 < e5.length) i10 = true, s9 = parseInt(e5[++p17], 10);
        else if (f11 === "-depth") i10 = true, o9 = true;
        else if (f11 === "-exec") for (i10 = true, p17++; p17 < e5.length && e5[p17] !== ";" && e5[p17] !== "+"; ) p17++;
        else !f11.startsWith("-") && f11 !== ";" && f11 !== "+" && f11 !== "(" && f11 !== ")" && f11 !== "\\(" && f11 !== "\\)" && f11 !== "!" ? i10 || n23.push(f11) : Ie3.has(f11) ? (i10 = true, p17++) : (f11.startsWith("-") || f11 === "(" || f11 === "\\(" || f11 === "!") && (i10 = true);
      }
      n23.length === 0 && n23.push(".");
      let { expr: a7, error: c14, actions: l8 } = he5(e5, 0);
      if (c14) return { stdout: "", stderr: c14, exitCode: 1 };
      let d16 = l8.some((p17) => p17.type === "print"), B12 = l8.length === 0, I17 = [], me5 = l8.some((p17) => p17.type === "printf"), se7 = [], q15 = "", G8 = 0, ye7 = fe6(a7), U13 = /* @__PURE__ */ new Map();
      for (let p17 of ye7) {
        let f11 = t6.fs.resolvePath(t6.cwd, p17);
        try {
          let h16 = await t6.fs.stat(f11);
          U13.set(p17, h16.mtime?.getTime() ?? Date.now());
        } catch {
        }
      }
      let ge8 = l8.some((p17) => {
        if (p17.type !== "printf") return false;
        let f11 = p17.format.replace(/%%/g, "");
        return /%[-+]?[0-9]*\.?[0-9]*(s|m|M|t|T)/.test(f11);
      }), we6 = Y7(a7) || ge8, De6 = _5(a7), K9 = pe5(a7), re5 = J7(a7), Te5 = V7(a7), Ce4 = typeof t6.fs.readdirWithFileTypes == "function";
      for (let p17 of n23) {
        let W14 = function(u10) {
          let R13 = s9 === null || u10.depth >= s9, P19 = false;
          if (R13 && a7 !== null) {
            let S16 = Date.now(), y18;
            if (Te5) y18 = H9(a7, u10.name, u10.relativePath, u10.isFile, u10.isDirectory);
            else {
              let m24 = { name: u10.name, relativePath: u10.relativePath, isFile: u10.isFile, isDirectory: u10.isDirectory, isEmpty: u10.isEmpty, mtime: u10.stat?.mtime?.getTime() ?? Date.now(), size: u10.stat?.size ?? 0, mode: u10.stat?.mode ?? 420, newerRefTimes: U13 };
              y18 = N9(a7, m24);
            }
            R13 = y18.matches, P19 = d16 ? y18.printed : R13, h16.evalCalls++, h16.evalTime += Date.now() - S16;
          } else R13 && (P19 = true);
          return P19 ? { print: true, printfData: me5 ? { path: u10.relativePath, name: u10.name, size: u10.stat?.size ?? 0, mtime: u10.stat?.mtime?.getTime() ?? Date.now(), mode: u10.stat?.mode ?? 420, isDirectory: u10.isDirectory, depth: u10.depth, startingPoint: p17 } : null } : { print: false, printfData: null };
        };
        var We5 = W14;
        p17.length > 1 && p17.endsWith("/") && (p17 = p17.slice(0, -1));
        let f11 = t6.fs.resolvePath(t6.cwd, p17);
        try {
          await t6.fs.stat(f11);
        } catch {
          q15 += `find: ${p17}: No such file or directory
`, G8 = 1;
          continue;
        }
        let h16 = Me2(), $17 = Date.now();
        async function b25(u10) {
          let { path: v20, depth: R13, typeInfo: P19 } = u10;
          if (h16.nodeCount++, r8 !== null && R13 > r8) return null;
          let E12, S16, y18;
          if (P19 && !we6) E12 = P19.isFile, S16 = P19.isDirectory;
          else {
            try {
              let L18 = Date.now();
              y18 = await t6.fs.stat(v20), h16.statCalls++, h16.statTime += Date.now() - L18;
            } catch {
              return null;
            }
            if (!y18) return null;
            E12 = y18.isFile, S16 = y18.isDirectory;
          }
          let m24;
          v20 === f11 ? m24 = p17.split("/").pop() || p17 : m24 = v20.split("/").pop() || "";
          let g18 = v20 === f11 ? p17 : p17 === "." ? `./${v20.slice(f11 === "/" ? f11.length : f11.length + 1)}` : p17 + v20.slice(f11.length), T10 = [], C19 = null, w19 = null, D15 = false;
          S16 && re5 && !o9 && (D15 = ue5(a7, { name: m24, relativePath: g18, isFile: E12, isDirectory: S16 }).shouldPrune, D15 && h16.earlyPrunes++);
          let x22 = r8 !== null && R13 >= r8, F20 = K9.terminalDirName !== null && m24 === K9.terminalDirName, j11 = !x22 && !F20 && !D15;
          if (S16 && ((j11 || De6 || F20) && !D15)) {
            let L18 = Date.now();
            if (Ce4 && t6.fs.readdirWithFileTypes) {
              if (C19 = await t6.fs.readdirWithFileTypes(v20), w19 = C19.map((M14) => M14.name), h16.readdirCalls++, h16.readdirTime += Date.now() - L18, j11) T10 = C19.map((M14, k15) => ({ path: v20 === "/" ? `/${M14.name}` : `${v20}/${M14.name}`, depth: R13 + 1, typeInfo: { isFile: M14.isFile, isDirectory: M14.isDirectory }, resultIndex: k15 }));
              else if (F20) {
                let M14 = K9.requiredExtension;
                T10 = C19.filter((k15) => k15.isFile && (!M14 || k15.name.endsWith(M14))).map((k15, Se6) => ({ path: v20 === "/" ? `/${k15.name}` : `${v20}/${k15.name}`, depth: R13 + 1, typeInfo: { isFile: k15.isFile, isDirectory: k15.isDirectory }, resultIndex: Se6 }));
              }
            } else w19 = await t6.fs.readdir(v20), h16.readdirCalls++, h16.readdirTime += Date.now() - L18, j11 && (T10 = w19.map((M14, k15) => ({ path: v20 === "/" ? `/${M14}` : `${v20}/${M14}`, depth: R13 + 1, resultIndex: k15 })));
          }
          let Q13 = E12 ? (y18?.size ?? 0) === 0 : w19 !== null && w19.length === 0, O16 = D15;
          if (!o9 && a7 !== null && !D15 && re5) {
            let L18 = Date.now(), M14 = { name: m24, relativePath: g18, isFile: E12, isDirectory: S16, isEmpty: Q13, mtime: y18?.mtime?.getTime() ?? Date.now(), size: y18?.size ?? 0, mode: y18?.mode ?? 420, newerRefTimes: U13 };
            O16 = N9(a7, M14).pruned, h16.evalCalls++, h16.evalTime += Date.now() - L18;
          }
          return { relativePath: g18, name: m24, isFile: E12, isDirectory: S16, isEmpty: Q13, stat: y18, depth: R13, children: O16 ? [] : T10, pruned: O16 };
        }
        async function Pe6() {
          let u10 = { paths: [], printfData: [] };
          if (o9) {
            let y18 = function(m24) {
              let g18 = { paths: [], printfData: [] }, T10 = P19[m24];
              if (!T10) return g18;
              for (let D15 of T10.childIndices) {
                let x22 = y18(D15);
                g18.paths.push(...x22.paths), g18.printfData.push(...x22.printfData);
              }
              let { print: C19, printfData: w19 } = W14(T10.node);
              return C19 && (g18.paths.push(T10.node.relativePath), w19 && g18.printfData.push(w19)), g18;
            };
            var v20 = y18;
            let P19 = [], E12 = [{ item: { path: f11, depth: 0, resultIndex: 0 }, parentIndex: -1, childOrderInParent: 0 }], S16 = /* @__PURE__ */ new Map();
            for (; E12.length > 0; ) {
              let m24 = Date.now(), g18 = E12.splice(0, de5), T10 = await Promise.all(g18.map((C19) => b25(C19.item)));
              h16.batchCount++, h16.batchTime += Date.now() - m24;
              for (let C19 = 0; C19 < g18.length; C19++) {
                let w19 = T10[C19], D15 = g18[C19];
                if (!w19) continue;
                let x22 = P19.length;
                if (D15.parentIndex >= 0) {
                  let F20 = S16.get(D15.parentIndex) || [];
                  F20.push(x22), S16.set(D15.parentIndex, F20);
                }
                P19.push({ node: w19, parentIndex: D15.parentIndex, childIndices: [] });
                for (let F20 = 0; F20 < w19.children.length; F20++) E12.push({ item: w19.children[F20], parentIndex: x22, childOrderInParent: F20 });
              }
            }
            for (let [m24, g18] of S16) m24 >= 0 && m24 < P19.length && (P19[m24].childIndices = g18);
            if (P19.length > 0) {
              let m24 = y18(0);
              u10.paths.push(...m24.paths), u10.printfData.push(...m24.printfData);
            }
          } else {
            let m24 = function(g18) {
              let T10 = P19.get(g18);
              T10 && (u10.paths.push(T10.path), T10.printfData && u10.printfData.push(T10.printfData));
              let C19 = y18.get(g18);
              if (C19) for (let w19 of C19) m24(w19);
            };
            var R13 = m24;
            let P19 = /* @__PURE__ */ new Map(), E12 = 0, S16 = [{ item: { path: f11, depth: 0, resultIndex: 0 }, orderIndex: E12++ }], y18 = /* @__PURE__ */ new Map();
            for (; S16.length > 0; ) {
              let g18 = Date.now(), T10 = S16.splice(0, de5), C19 = await Promise.all(T10.map(async ({ item: w19, orderIndex: D15 }) => {
                let x22 = await b25(w19);
                return x22 ? { node: x22, orderIndex: D15 } : null;
              }));
              h16.batchCount++, h16.batchTime += Date.now() - g18;
              for (let w19 of C19) {
                if (!w19) continue;
                let { node: D15, orderIndex: x22 } = w19, { print: F20, printfData: j11 } = W14(D15);
                if (F20 && P19.set(x22, { path: D15.relativePath, printfData: j11 }), D15.children.length > 0) {
                  let ee7 = [];
                  for (let Q13 of D15.children) {
                    let O16 = E12++;
                    ee7.push(O16), S16.push({ item: Q13, orderIndex: O16 });
                  }
                  y18.set(x22, ee7);
                }
              }
            }
            m24(0);
          }
          return u10;
        }
        let X10 = await Pe6();
        if (I17.push(...X10.paths), se7.push(...X10.printfData), t6.trace) {
          let u10 = Date.now() - $17;
          xe3(t6.trace, h16, u10), t6.trace({ category: "find", name: "searchPath", durationMs: u10, details: { path: p17, resultsFound: X10.paths.length } });
        }
      }
      let A13 = "";
      if (l8.length > 0) for (let p17 of l8) switch (p17.type) {
        case "print":
          A13 += I17.length > 0 ? `${I17.join(`
`)}
` : "";
          break;
        case "print0":
          A13 += I17.length > 0 ? `${I17.join("\0")}\0` : "";
          break;
        case "delete": {
          let f11 = [...I17].sort((h16, $17) => $17.length - h16.length);
          for (let h16 of f11) {
            let $17 = t6.fs.resolvePath(t6.cwd, h16);
            try {
              await t6.fs.rm($17, { recursive: false });
            } catch (b25) {
              let W14 = b25 instanceof Error ? b25.message : String(b25);
              q15 += `find: cannot delete '${h16}': ${W14}
`, G8 = 1;
            }
          }
          break;
        }
        case "printf":
          for (let f11 of se7) A13 += $e2(p17.format, f11);
          break;
        case "exec":
          if (!t6.exec) return { stdout: "", stderr: `find: -exec not supported in this context
`, exitCode: 1 };
          if (p17.batchMode) {
            let f11 = [];
            for (let b25 of p17.command) b25 === "{}" ? f11.push(...I17) : f11.push(b25);
            let h16 = f11.map((b25) => `"${b25}"`).join(" "), $17 = await t6.exec(h16, { cwd: t6.cwd });
            A13 += $17.stdout, q15 += $17.stderr, $17.exitCode !== 0 && (G8 = $17.exitCode);
          } else for (let f11 of I17) {
            let $17 = p17.command.map((W14) => W14 === "{}" ? f11 : W14).map((W14) => `"${W14}"`).join(" "), b25 = await t6.exec($17, { cwd: t6.cwd });
            A13 += b25.stdout, q15 += b25.stderr, b25.exitCode !== 0 && (G8 = b25.exitCode);
          }
          break;
      }
      else B12 && (A13 = I17.length > 0 ? `${I17.join(`
`)}
` : "");
      return { stdout: A13, stderr: q15, exitCode: G8 };
    } };
    Ze3 = { name: "find", flags: [{ flag: "-name", type: "value", valueHint: "pattern" }, { flag: "-iname", type: "value", valueHint: "pattern" }, { flag: "-type", type: "value", valueHint: "string" }, { flag: "-maxdepth", type: "value", valueHint: "number" }, { flag: "-mindepth", type: "value", valueHint: "number" }, { flag: "-empty", type: "boolean" }, { flag: "-print", type: "boolean" }, { flag: "-print0", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/find-74OP3M7S.js
var find_74OP3M7S_exports = {};
__export(find_74OP3M7S_exports, {
  findCommand: () => je3,
  flagsForFuzzing: () => Ze3
});
var init_find_74OP3M7S = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/find-74OP3M7S.js"() {
    init_chunk_YYB54I7F();
    init_chunk_IJXFPKNC();
    init_chunk_YNYSPYQ5();
    init_chunk_EEXR5ZDP();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-ALLTKNUZ.js
var p10, c6, h10;
var init_chunk_ALLTKNUZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-ALLTKNUZ.js"() {
    init_chunk_74CEPOFO();
    p10 = { name: "basename", summary: "strip directory and suffix from filenames", usage: `basename NAME [SUFFIX]
basename OPTION... NAME...`, options: ["-a, --multiple   support multiple arguments", "-s, --suffix=SUFFIX  remove a trailing SUFFIX", "    --help       display this help and exit"] };
    c6 = { name: "basename", async execute(n23, u10) {
      if (o2(n23)) return s(p10);
      let l8 = false, s9 = "", a7 = [];
      for (let t6 = 0; t6 < n23.length; t6++) {
        let e5 = n23[t6];
        e5 === "-a" || e5 === "--multiple" ? l8 = true : e5 === "-s" && t6 + 1 < n23.length ? (s9 = n23[++t6], l8 = true) : e5.startsWith("--suffix=") ? (s9 = e5.slice(9), l8 = true) : e5.startsWith("-") || a7.push(e5);
      }
      if (a7.length === 0) return { stdout: "", stderr: `basename: missing operand
`, exitCode: 1 };
      !l8 && a7.length >= 2 && (s9 = a7.pop() ?? "");
      let o9 = [];
      for (let t6 of a7) {
        let e5 = t6.replace(/\/+$/, ""), i10 = e5.split("/").pop() || e5;
        s9 && i10.endsWith(s9) && (i10 = i10.slice(0, -s9.length)), o9.push(i10);
      }
      return { stdout: `${o9.join(`
`)}
`, stderr: "", exitCode: 0 };
    } };
    h10 = { name: "basename", flags: [{ flag: "-a", type: "boolean" }, { flag: "-s", type: "value", valueHint: "string" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/basename-AA2KJYZQ.js
var basename_AA2KJYZQ_exports = {};
__export(basename_AA2KJYZQ_exports, {
  basenameCommand: () => c6,
  flagsForFuzzing: () => h10
});
var init_basename_AA2KJYZQ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/basename-AA2KJYZQ.js"() {
    init_chunk_ALLTKNUZ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-4Q4SM6WR.js
var m14, p11, c7;
var init_chunk_4Q4SM6WR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-4Q4SM6WR.js"() {
    init_chunk_74CEPOFO();
    m14 = { name: "dirname", summary: "strip last component from file name", usage: "dirname [OPTION] NAME...", options: ["    --help       display this help and exit"] };
    p11 = { name: "dirname", async execute(t6, l8) {
      if (o2(t6)) return s(m14);
      let r8 = t6.filter((n23) => !n23.startsWith("-"));
      if (r8.length === 0) return { stdout: "", stderr: `dirname: missing operand
`, exitCode: 1 };
      let e5 = [];
      for (let n23 of r8) {
        let a7 = n23.replace(/\/+$/, ""), s9 = a7.lastIndexOf("/");
        s9 === -1 ? e5.push(".") : s9 === 0 ? e5.push("/") : e5.push(a7.slice(0, s9));
      }
      return { stdout: `${e5.join(`
`)}
`, stderr: "", exitCode: 0 };
    } };
    c7 = { name: "dirname", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/dirname-LEMTZZFS.js
var dirname_LEMTZZFS_exports = {};
__export(dirname_LEMTZZFS_exports, {
  dirnameCommand: () => p11,
  flagsForFuzzing: () => c7
});
var init_dirname_LEMTZZFS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/dirname-LEMTZZFS.js"() {
    init_chunk_4Q4SM6WR();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XVDPCNWR.js
async function T4(i10, o9, s9, f11, d16) {
  let e5 = { output: "", stderr: "", dirCount: 0, fileCount: 0 }, l8 = i10.fs.resolvePath(i10.cwd, o9);
  try {
    if (!(await i10.fs.stat(l8)).isDirectory) return e5.output = `${o9}
`, e5.fileCount = 1, e5;
  } catch {
    return e5.stderr = `tree: ${o9}: No such file or directory
`, e5;
  }
  if (e5.output = `${o9}
`, s9.maxDepth !== null && d16 >= s9.maxDepth) return e5;
  try {
    let a7 = [];
    if (i10.fs.readdirWithFileTypes) a7 = (await i10.fs.readdirWithFileTypes(l8)).map((r8) => ({ name: r8.name, isDirectory: r8.isDirectory }));
    else {
      let t6 = await i10.fs.readdir(l8);
      for (let r8 = 0; r8 < t6.length; r8 += 100) {
        let m24 = t6.slice(r8, r8 + 100), u10 = await Promise.all(m24.map(async (c14) => {
          let y18 = l8 === "/" ? `/${c14}` : `${l8}/${c14}`;
          try {
            let h16 = await i10.fs.stat(y18);
            return { name: c14, isDirectory: h16.isDirectory };
          } catch {
            return null;
          }
        }));
        a7.push(...u10.filter((c14) => c14 !== null));
      }
    }
    let n23 = a7.filter((t6) => !(!s9.showHidden && t6.name.startsWith(".") || s9.directoriesOnly && !t6.isDirectory));
    n23.sort((t6, r8) => t6.name.localeCompare(r8.name));
    for (let t6 = 0; t6 < n23.length; t6++) {
      let r8 = n23[t6], m24 = l8 === "/" ? `/${r8.name}` : `${l8}/${r8.name}`, u10 = t6 === n23.length - 1, c14 = u10 ? "`-- " : "|-- ", y18 = f11 + (u10 ? "    " : "|   ");
      if (r8.isDirectory) {
        e5.dirCount++;
        let h16 = s9.fullPath ? m24 : r8.name;
        if (e5.output += `${f11 + c14 + h16}
`, s9.maxDepth === null || d16 + 1 < s9.maxDepth) {
          let C19 = await w11(i10, m24, s9, y18, d16 + 1);
          e5.output += C19.output, e5.dirCount += C19.dirCount, e5.fileCount += C19.fileCount;
        }
      } else {
        e5.fileCount++;
        let h16 = s9.fullPath ? m24 : r8.name;
        e5.output += `${f11 + c14 + h16}
`;
      }
    }
  } catch {
    e5.stderr = `tree: ${o9}: Permission denied
`;
  }
  return e5;
}
async function w11(i10, o9, s9, f11, d16) {
  let e5 = { output: "", stderr: "", dirCount: 0, fileCount: 0 };
  if (s9.maxDepth !== null && d16 >= s9.maxDepth) return e5;
  try {
    let l8 = [];
    if (i10.fs.readdirWithFileTypes) l8 = (await i10.fs.readdirWithFileTypes(o9)).map((t6) => ({ name: t6.name, isDirectory: t6.isDirectory }));
    else {
      let n23 = await i10.fs.readdir(o9);
      for (let t6 = 0; t6 < n23.length; t6 += 100) {
        let r8 = n23.slice(t6, t6 + 100), m24 = await Promise.all(r8.map(async (u10) => {
          let c14 = o9 === "/" ? `/${u10}` : `${o9}/${u10}`;
          try {
            let y18 = await i10.fs.stat(c14);
            return { name: u10, isDirectory: y18.isDirectory };
          } catch {
            return null;
          }
        }));
        l8.push(...m24.filter((u10) => u10 !== null));
      }
    }
    let a7 = l8.filter((n23) => !(!s9.showHidden && n23.name.startsWith(".") || s9.directoriesOnly && !n23.isDirectory));
    a7.sort((n23, t6) => n23.name.localeCompare(t6.name));
    for (let n23 = 0; n23 < a7.length; n23++) {
      let t6 = a7[n23], r8 = o9 === "/" ? `/${t6.name}` : `${o9}/${t6.name}`, m24 = n23 === a7.length - 1, u10 = m24 ? "`-- " : "|-- ", c14 = f11 + (m24 ? "    " : "|   ");
      if (t6.isDirectory) {
        e5.dirCount++;
        let y18 = s9.fullPath ? r8 : t6.name;
        e5.output += `${f11 + u10 + y18}
`;
        let h16 = await w11(i10, r8, s9, c14, d16 + 1);
        e5.output += h16.output, e5.dirCount += h16.dirCount, e5.fileCount += h16.fileCount;
      } else {
        e5.fileCount++;
        let y18 = s9.fullPath ? r8 : t6.name;
        e5.output += `${f11 + u10 + y18}
`;
      }
    }
  } catch {
  }
  return e5;
}
var P9, b14, O9, L9;
var init_chunk_XVDPCNWR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XVDPCNWR.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    P9 = { name: "tree", summary: "list contents of directories in a tree-like format", usage: "tree [OPTION]... [DIRECTORY]...", options: ["-a          include hidden files", "-d          list directories only", "-L LEVEL    limit depth of directory tree", "-f          print full path prefix for each file", "    --help  display this help and exit"] };
    b14 = { showHidden: { short: "a", type: "boolean" }, directoriesOnly: { short: "d", type: "boolean" }, fullPath: { short: "f", type: "boolean" }, maxDepth: { short: "L", type: "number" } };
    O9 = { name: "tree", async execute(i10, o9) {
      if (o2(i10)) return s(P9);
      let s9 = x3("tree", i10, b14);
      if (!s9.ok) return s9.error;
      let f11 = { showHidden: s9.result.flags.showHidden, directoriesOnly: s9.result.flags.directoriesOnly, maxDepth: s9.result.flags.maxDepth ?? null, fullPath: s9.result.flags.fullPath }, d16 = s9.result.positional;
      d16.length === 0 && d16.push(".");
      let e5 = "", l8 = "", a7 = 0, n23 = 0;
      for (let t6 of d16) {
        let r8 = await T4(o9, t6, f11, "", 0);
        e5 += r8.output, l8 += r8.stderr, a7 += r8.dirCount, n23 += r8.fileCount;
      }
      return e5 += `
${a7} director${a7 === 1 ? "y" : "ies"}`, f11.directoriesOnly || (e5 += `, ${n23} file${n23 === 1 ? "" : "s"}`), e5 += `
`, { stdout: e5, stderr: l8, exitCode: l8 ? 1 : 0 };
    } };
    L9 = { name: "tree", flags: [{ flag: "-a", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-L", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tree-LYXBS7DC.js
var tree_LYXBS7DC_exports = {};
__export(tree_LYXBS7DC_exports, {
  flagsForFuzzing: () => L9,
  treeCommand: () => O9
});
var init_tree_LYXBS7DC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tree-LYXBS7DC.js"() {
    init_chunk_XVDPCNWR();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-K3PAWJ7V.js
async function w12(a7, s9, n23, r8, c14) {
  let i10 = { output: "", totalSize: 0, stderr: "" };
  try {
    let m24 = await a7.fs.stat(s9);
    if (!m24.isDirectory) return i10.totalSize = m24.size, (r8.allFiles || c14 === 0) && (i10.output = D8(m24.size, r8.humanReadable) + "	" + n23 + `
`), i10;
    let p17 = 0, l8 = [];
    if (a7.fs.readdirWithFileTypes) {
      let t6 = await a7.fs.readdirWithFileTypes(s9), o9 = t6.filter((e5) => e5.isFile), f11 = t6.filter((e5) => e5.isDirectory);
      for (let e5 = 0; e5 < o9.length; e5 += 100) {
        let u10 = o9.slice(e5, e5 + 100), y18 = await Promise.all(u10.map(async (d16) => {
          let T10 = s9 === "/" ? `/${d16.name}` : `${s9}/${d16.name}`;
          try {
            let S16 = await a7.fs.stat(T10);
            return { name: d16.name, isDirectory: false, size: S16.size };
          } catch {
            return { name: d16.name, isDirectory: false, size: 0 };
          }
        }));
        l8.push(...y18);
      }
      l8.push(...f11.map((e5) => ({ name: e5.name, isDirectory: true })));
    } else {
      let t6 = await a7.fs.readdir(s9);
      for (let o9 = 0; o9 < t6.length; o9 += 100) {
        let f11 = t6.slice(o9, o9 + 100), e5 = await Promise.all(f11.map(async (u10) => {
          let y18 = s9 === "/" ? `/${u10}` : `${s9}/${u10}`;
          try {
            let d16 = await a7.fs.stat(y18);
            return { name: u10, isDirectory: d16.isDirectory, size: d16.isDirectory ? void 0 : d16.size };
          } catch {
            return { name: u10, isDirectory: false, size: 0 };
          }
        }));
        l8.push(...e5);
      }
    }
    l8.sort((t6, o9) => t6.name.localeCompare(o9.name));
    let z10 = l8.filter((t6) => !t6.isDirectory);
    for (let t6 of z10) {
      let o9 = t6.size ?? 0;
      if (p17 += o9, r8.allFiles && !r8.summarize) {
        let f11 = n23 === "." ? t6.name : `${n23}/${t6.name}`;
        i10.output += D8(o9, r8.humanReadable) + "	" + f11 + `
`;
      }
    }
    let h16 = l8.filter((t6) => t6.isDirectory);
    for (let t6 = 0; t6 < h16.length; t6 += 100) {
      let o9 = h16.slice(t6, t6 + 100), f11 = await Promise.all(o9.map(async (e5) => {
        let u10 = s9 === "/" ? `/${e5.name}` : `${s9}/${e5.name}`, y18 = n23 === "." ? e5.name : `${n23}/${e5.name}`;
        return { name: e5.name, result: await w12(a7, u10, y18, r8, c14 + 1) };
      }));
      f11.sort((e5, u10) => e5.name.localeCompare(u10.name));
      for (let { result: e5 } of f11) p17 += e5.totalSize, r8.summarize || (r8.maxDepth === null || c14 + 1 <= r8.maxDepth) && (i10.output += e5.output);
    }
    i10.totalSize = p17, (r8.summarize || r8.maxDepth === null || c14 <= r8.maxDepth) && (i10.output += `${D8(p17, r8.humanReadable)}	${n23}
`);
  } catch {
    i10.stderr = `du: cannot read directory '${n23}': Permission denied
`;
  }
  return i10;
}
function D8(a7, s9) {
  return s9 ? a7 < 1024 ? `${a7}` : a7 < 1024 * 1024 ? `${(a7 / 1024).toFixed(1)}K` : a7 < 1024 * 1024 * 1024 ? `${(a7 / (1024 * 1024)).toFixed(1)}M` : `${(a7 / (1024 * 1024 * 1024)).toFixed(1)}G` : String(Math.ceil(a7 / 1024) || 1);
}
var x13, R3, H10, v13;
var init_chunk_K3PAWJ7V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-K3PAWJ7V.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    x13 = { name: "du", summary: "estimate file space usage", usage: "du [OPTION]... [FILE]...", options: ["-a          write counts for all files, not just directories", "-h          print sizes in human readable format", "-s          display only a total for each argument", "-c          produce a grand total", "--max-depth=N  print total for directory only if N or fewer levels deep", "    --help  display this help and exit"] };
    R3 = { allFiles: { short: "a", type: "boolean" }, humanReadable: { short: "h", type: "boolean" }, summarize: { short: "s", type: "boolean" }, grandTotal: { short: "c", type: "boolean" }, maxDepth: { long: "max-depth", type: "number" } };
    H10 = { name: "du", async execute(a7, s9) {
      if (o2(a7)) return s(x13);
      let n23 = x3("du", a7, R3);
      if (!n23.ok) return n23.error;
      let r8 = { allFiles: n23.result.flags.allFiles, humanReadable: n23.result.flags.humanReadable, summarize: n23.result.flags.summarize, grandTotal: n23.result.flags.grandTotal, maxDepth: n23.result.flags.maxDepth ?? null }, c14 = n23.result.positional;
      c14.length === 0 && c14.push(".");
      let i10 = "", m24 = "", p17 = 0;
      for (let l8 of c14) {
        let z10 = s9.fs.resolvePath(s9.cwd, l8);
        try {
          await s9.fs.stat(z10);
          let h16 = await w12(s9, z10, l8, r8, 0);
          i10 += h16.output, p17 += h16.totalSize, m24 += h16.stderr;
        } catch {
          m24 += `du: cannot access '${l8}': No such file or directory
`;
        }
      }
      return r8.grandTotal && c14.length > 0 && (i10 += `${D8(p17, r8.humanReadable)}	total
`), { stdout: i10, stderr: m24, exitCode: m24 ? 1 : 0 };
    } };
    v13 = { name: "du", flags: [{ flag: "-a", type: "boolean" }, { flag: "-h", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "--max-depth", type: "value", valueHint: "number" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/du-DM4QX4XA.js
var du_DM4QX4XA_exports = {};
__export(du_DM4QX4XA_exports, {
  duCommand: () => H10,
  flagsForFuzzing: () => v13
});
var init_du_DM4QX4XA = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/du-DM4QX4XA.js"() {
    init_chunk_K3PAWJ7V();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-OGDTSM2Q.js
var $9, C11, w13, E6, O10, j6;
var init_chunk_OGDTSM2Q = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-OGDTSM2Q.js"() {
    init_chunk_74CEPOFO();
    $9 = { name: "env", summary: "run a program in a modified environment", usage: "env [OPTION]... [NAME=VALUE]... [COMMAND [ARG]...]", options: ["-i, --ignore-environment  start with an empty environment", "-u NAME, --unset=NAME     remove NAME from the environment", "    --help                display this help and exit"] };
    C11 = { name: "env", async execute(o9, l8) {
      if (o2(o9)) return s($9);
      let c14 = false, i10 = [], a7 = /* @__PURE__ */ new Map(), t6 = -1;
      for (let n23 = 0; n23 < o9.length; n23++) {
        let e5 = o9[n23];
        if (e5 === "-i" || e5 === "--ignore-environment") c14 = true;
        else if (e5 === "-u" && n23 + 1 < o9.length) i10.push(o9[++n23]);
        else if (e5.startsWith("-u")) i10.push(e5.slice(2));
        else if (e5.startsWith("--unset=")) i10.push(e5.slice(8));
        else {
          if (e5.startsWith("--") && e5 !== "--") return r3("env", e5);
          if (e5.startsWith("-") && e5 !== "-") {
            for (let r8 of e5.slice(1)) if (r8 !== "i" && r8 !== "u") return r3("env", `-${r8}`);
            e5.includes("i") && (c14 = true);
          } else if (e5.includes("=") && t6 === -1) {
            let r8 = e5.indexOf("="), y18 = e5.slice(0, r8), A13 = e5.slice(r8 + 1);
            a7.set(y18, A13);
          } else {
            t6 = n23;
            break;
          }
        }
      }
      let s9;
      if (c14) s9 = new Map(a7);
      else {
        s9 = new Map(l8.env);
        for (let n23 of i10) s9.delete(n23);
        for (let [n23, e5] of a7) s9.set(n23, e5);
      }
      if (t6 === -1) {
        let n23 = [];
        for (let [e5, r8] of s9) n23.push(`${e5}=${r8}`);
        return { stdout: n23.join(`
`) + (n23.length > 0 ? `
` : ""), stderr: "", exitCode: 0 };
      }
      if (!l8.exec) return { stdout: "", stderr: `env: command execution not supported in this context
`, exitCode: 1 };
      let u10 = o9.slice(t6), h16 = u10[0], g18 = u10.slice(1).map((n23) => /[\s"'\\$`!*?[\]{}|&;<>()]/.test(n23) ? `'${n23.replace(/'/g, "'\\''")}'` : n23), d16 = ["command", h16, ...g18].join(" "), v20 = Object.entries(a7).map(([n23, e5]) => `${n23}="${e5}"`).join(" "), x22 = v20 ? `${v20} ${d16}` : d16;
      return l8.exec(x22, { cwd: l8.cwd });
    } };
    w13 = { name: "printenv", summary: "print all or part of environment", usage: "printenv [OPTION]... [VARIABLE]...", options: ["    --help       display this help and exit"] };
    E6 = { name: "printenv", async execute(o9, l8) {
      if (o2(o9)) return s(w13);
      let c14 = o9.filter((t6) => !t6.startsWith("-"));
      if (c14.length === 0) {
        let t6 = [];
        for (let [s9, u10] of l8.env) t6.push(`${s9}=${u10}`);
        return { stdout: t6.join(`
`) + (t6.length > 0 ? `
` : ""), stderr: "", exitCode: 0 };
      }
      let i10 = [], a7 = 0;
      for (let t6 of c14) {
        let s9 = l8.env.get(t6);
        s9 !== void 0 ? i10.push(s9) : a7 = 1;
      }
      return { stdout: i10.join(`
`) + (i10.length > 0 ? `
` : ""), stderr: "", exitCode: a7 };
    } };
    O10 = { name: "env", flags: [{ flag: "-i", type: "boolean" }, { flag: "-u", type: "value", valueHint: "string" }] };
    j6 = { name: "printenv", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/env-S547XMN7.js
var env_S547XMN7_exports = {};
__export(env_S547XMN7_exports, {
  envCommand: () => C11,
  flagsForFuzzing: () => O10,
  printenvCommand: () => E6,
  printenvFlagsForFuzzing: () => j6
});
var init_env_S547XMN7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/env-S547XMN7.js"() {
    init_chunk_OGDTSM2Q();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VOBGTVA6.js
var d9, o4, m15, c8, p12, h11;
var init_chunk_VOBGTVA6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VOBGTVA6.js"() {
    init_chunk_74CEPOFO();
    d9 = { name: "alias", summary: "define or display aliases", usage: "alias [name[=value] ...]", options: ["    --help display this help and exit"] };
    o4 = "BASH_ALIAS_";
    m15 = { name: "alias", async execute(e5, a7) {
      if (o2(e5)) return s(d9);
      if (e5.length === 0) {
        let s9 = "";
        for (let [i10, t6] of a7.env) if (i10.startsWith(o4)) {
          let n23 = i10.slice(o4.length);
          s9 += `alias ${n23}='${t6}'
`;
        }
        return { stdout: s9, stderr: "", exitCode: 0 };
      }
      let l8 = e5[0] === "--" ? e5.slice(1) : e5;
      for (let s9 of l8) {
        let i10 = s9.indexOf("=");
        if (i10 === -1) {
          let t6 = o4 + s9;
          return a7.env.get(t6) ? { stdout: `alias ${s9}='${a7.env.get(t6)}'
`, stderr: "", exitCode: 0 } : { stdout: "", stderr: `alias: ${s9}: not found
`, exitCode: 1 };
        } else {
          let t6 = s9.slice(0, i10), n23 = s9.slice(i10 + 1);
          (n23.startsWith("'") && n23.endsWith("'") || n23.startsWith('"') && n23.endsWith('"')) && (n23 = n23.slice(1, -1)), a7.env.set(o4 + t6, n23);
        }
      }
      return { stdout: "", stderr: "", exitCode: 0 };
    } };
    c8 = { name: "unalias", async execute(e5, a7) {
      if (o2(e5)) return s({ name: "unalias", summary: "remove alias definitions", usage: "unalias name [name ...]", options: ["-a      remove all aliases", "    --help display this help and exit"] });
      if (e5.length === 0) return { stdout: "", stderr: `unalias: usage: unalias [-a] name [name ...]
`, exitCode: 1 };
      if (e5[0] === "-a") {
        for (let t6 of a7.env.keys()) t6.startsWith(o4) && a7.env.delete(t6);
        return { stdout: "", stderr: "", exitCode: 0 };
      }
      let l8 = e5[0] === "--" ? e5.slice(1) : e5, s9 = false, i10 = "";
      for (let t6 of l8) {
        let n23 = o4 + t6;
        a7.env.get(n23) ? a7.env.delete(n23) : (i10 += `unalias: ${t6}: not found
`, s9 = true);
      }
      return { stdout: "", stderr: i10, exitCode: s9 ? 1 : 0 };
    } };
    p12 = { name: "alias", flags: [] };
    h11 = { name: "unalias", flags: [{ flag: "-a", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/alias-JE7RI5QX.js
var alias_JE7RI5QX_exports = {};
__export(alias_JE7RI5QX_exports, {
  aliasCommand: () => m15,
  flagsForFuzzing: () => p12,
  unaliasCommand: () => c8,
  unaliasFlagsForFuzzing: () => h11
});
var init_alias_JE7RI5QX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/alias-JE7RI5QX.js"() {
    init_chunk_VOBGTVA6();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NCNPKYJZ.js
var p13, h12, m16, u4;
var init_chunk_NCNPKYJZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NCNPKYJZ.js"() {
    init_chunk_74CEPOFO();
    p13 = { name: "history", summary: "display command history", usage: "history [n]", options: ["-c      clear the history list", "    --help display this help and exit"] };
    h12 = "BASH_HISTORY";
    m16 = { name: "history", async execute(e5, s9) {
      if (o2(e5)) return s(p13);
      let a7 = s9.env.get(h12) || "[]", t6;
      try {
        t6 = JSON.parse(a7);
      } catch {
        t6 = [];
      }
      if (e5[0] === "-c") return s9.env.set(h12, "[]"), { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6.length;
      e5[0] && /^\d+$/.test(e5[0]) && (n23 = Math.min(parseInt(e5[0], 10), t6.length));
      let c14 = t6.length - n23, r8 = "";
      for (let o9 = c14; o9 < t6.length; o9++) {
        let y18 = (o9 + 1).toString().padStart(5, " ");
        r8 += `${y18}  ${t6[o9]}
`;
      }
      return { stdout: r8, stderr: "", exitCode: 0 };
    } };
    u4 = { name: "history", flags: [{ flag: "-c", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/history-J4QRNGRO.js
var history_J4QRNGRO_exports = {};
__export(history_J4QRNGRO_exports, {
  flagsForFuzzing: () => u4,
  historyCommand: () => m16
});
var init_history_J4QRNGRO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/history-J4QRNGRO.js"() {
    init_chunk_NCNPKYJZ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SXR3EI72.js
var $10, N10, P10;
var init_chunk_SXR3EI72 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SXR3EI72.js"() {
    init_chunk_74CEPOFO();
    $10 = { name: "xargs", summary: "build and execute command lines from standard input", usage: "xargs [OPTION]... [COMMAND [INITIAL-ARGS]]", options: ["-I REPLACE   replace occurrences of REPLACE with input", "-d DELIM     use DELIM as input delimiter (e.g., -d '\\n' for newline)", "-n NUM       use at most NUM arguments per command line", "-P NUM       run at most NUM processes at a time", "-0, --null   items are separated by null, not whitespace", "-t, --verbose  print commands before executing", "-r, --no-run-if-empty  do not run command if input is empty", "    --help   display this help and exit"] };
    N10 = { name: "xargs", async execute(l8, i10) {
      if (o2(l8)) return s($10);
      let m24 = null, g18 = null, c14 = null, o9 = null, h16 = false, x22 = false, y18 = false, s9 = 0;
      for (let e5 = 0; e5 < l8.length; e5++) {
        let t6 = l8[e5];
        if (t6 === "-I" && e5 + 1 < l8.length) m24 = l8[++e5], s9 = e5 + 1;
        else if (t6 === "-d" && e5 + 1 < l8.length) g18 = l8[++e5].replace(/\\n/g, `
`).replace(/\\t/g, "	").replace(/\\r/g, "\r").replace(/\\0/g, "\0").replace(/\\\\/g, "\\"), s9 = e5 + 1;
        else if (t6 === "-n" && e5 + 1 < l8.length) c14 = parseInt(l8[++e5], 10), s9 = e5 + 1;
        else if (t6 === "-P" && e5 + 1 < l8.length) o9 = parseInt(l8[++e5], 10), s9 = e5 + 1;
        else if (t6 === "-0" || t6 === "--null") h16 = true, s9 = e5 + 1;
        else if (t6 === "-t" || t6 === "--verbose") x22 = true, s9 = e5 + 1;
        else if (t6 === "-r" || t6 === "--no-run-if-empty") y18 = true, s9 = e5 + 1;
        else {
          if (t6.startsWith("--")) return r3("xargs", t6);
          if (t6.startsWith("-") && t6.length > 1) {
            for (let n23 of t6.slice(1)) if (!"0tr".includes(n23)) return r3("xargs", `-${n23}`);
            t6.includes("0") && (h16 = true), t6.includes("t") && (x22 = true), t6.includes("r") && (y18 = true), s9 = e5 + 1;
          } else if (!t6.startsWith("-")) {
            s9 = e5;
            break;
          }
        }
      }
      let a7 = l8.slice(s9);
      a7.length === 0 && a7.push("echo");
      let r8;
      if (h16 ? r8 = i10.stdin.split("\0").filter((e5) => e5.length > 0) : g18 !== null ? r8 = i10.stdin.replace(/\n$/, "").split(g18).filter((t6) => t6.length > 0) : r8 = i10.stdin.split(/\s+/).map((e5) => e5.trim()).filter((e5) => e5.length > 0), r8.length === 0) return y18 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 };
      let d16 = "", u10 = "", f11 = 0, v20 = (e5) => /[\s"'\\$`!*?[\]{}();&|<>#]/.test(e5) ? `"${e5.replace(/([\\"`$])/g, "\\$1")}"` : e5, C19 = async (e5) => {
        let t6 = e5.map(v20).join(" ");
        return x22 && (u10 += `${t6}
`), i10.exec ? i10.exec(t6, { cwd: i10.cwd }) : { stdout: `${t6}
`, stderr: "", exitCode: 0 };
      }, w19 = async (e5) => {
        if (o9 !== null && o9 > 1) for (let t6 = 0; t6 < e5.length; t6 += o9) {
          let n23 = e5.slice(t6, t6 + o9), M14 = await Promise.all(n23.map(C19));
          for (let p17 of M14) d16 += p17.stdout, u10 += p17.stderr, p17.exitCode !== 0 && (f11 = p17.exitCode);
        }
        else for (let t6 of e5) {
          let n23 = await C19(t6);
          d16 += n23.stdout, u10 += n23.stderr, n23.exitCode !== 0 && (f11 = n23.exitCode);
        }
      };
      if (m24 !== null) {
        let e5 = r8.map((t6) => a7.map((n23) => n23.replaceAll(m24, t6)));
        await w19(e5);
      } else if (c14 !== null) {
        let e5 = [];
        for (let t6 = 0; t6 < r8.length; t6 += c14) {
          let n23 = r8.slice(t6, t6 + c14);
          e5.push([...a7, ...n23]);
        }
        await w19(e5);
      } else {
        let e5 = [...a7, ...r8], t6 = await C19(e5);
        d16 += t6.stdout, u10 += t6.stderr, f11 = t6.exitCode;
      }
      return { stdout: d16, stderr: u10, exitCode: f11 };
    } };
    P10 = { name: "xargs", flags: [{ flag: "-I", type: "value", valueHint: "string" }, { flag: "-d", type: "value", valueHint: "delimiter" }, { flag: "-n", type: "value", valueHint: "number" }, { flag: "-0", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-r", type: "boolean" }], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xargs-OGI2NN6J.js
var xargs_OGI2NN6J_exports = {};
__export(xargs_OGI2NN6J_exports, {
  flagsForFuzzing: () => P10,
  xargsCommand: () => N10
});
var init_xargs_OGI2NN6J = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xargs-OGI2NN6J.js"() {
    init_chunk_SXR3EI72();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-R6QSAL5T.js
var e3, t, s2, r7;
var init_chunk_R6QSAL5T = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-R6QSAL5T.js"() {
    e3 = { name: "true", async execute() {
      return { stdout: "", stderr: "", exitCode: 0 };
    } };
    t = { name: "false", async execute() {
      return { stdout: "", stderr: "", exitCode: 1 };
    } };
    s2 = { name: "true", flags: [] };
    r7 = { name: "false", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/true-WHJNXCHG.js
var true_WHJNXCHG_exports = {};
__export(true_WHJNXCHG_exports, {
  falseCommand: () => t,
  falseFlagsForFuzzing: () => r7,
  flagsForFuzzing: () => s2,
  trueCommand: () => e3
});
var init_true_WHJNXCHG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/true-WHJNXCHG.js"() {
    init_chunk_R6QSAL5T();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-LL3S3NLB.js
var t2, s3, o5;
var init_chunk_LL3S3NLB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-LL3S3NLB.js"() {
    init_chunk_74CEPOFO();
    t2 = { name: "clear", summary: "clear the terminal screen", usage: "clear [OPTIONS]", options: ["    --help display this help and exit"] };
    s3 = { name: "clear", async execute(r8, c14) {
      return o2(r8) ? s(t2) : { stdout: "\x1B[2J\x1B[H", stderr: "", exitCode: 0 };
    } };
    o5 = { name: "clear", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/clear-5CZ5X4YR.js
var clear_5CZ5X4YR_exports = {};
__export(clear_5CZ5X4YR_exports, {
  clearCommand: () => s3,
  flagsForFuzzing: () => o5
});
var init_clear_5CZ5X4YR = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/clear-5CZ5X4YR.js"() {
    init_chunk_LL3S3NLB();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JP44OYZS.js
async function i3(t6, e5, n23, o9) {
  if (!o9.exec) return { stdout: "", stderr: `bash: internal error: exec function not available
`, exitCode: 1 };
  let r8 = c2(o9.exportedEnv || {}, { 0: e5, "#": String(n23.length), "@": n23.join(" "), "*": n23.join(" ") });
  n23.forEach((a7, m24) => {
    r8[String(m24 + 1)] = a7;
  });
  let s9 = t6;
  if (s9.startsWith("#!")) {
    let a7 = s9.indexOf(`
`);
    a7 !== -1 && (s9 = s9.slice(a7 + 1));
  }
  return await o9.exec(s9, { env: r8, cwd: o9.cwd, stdin: o9.stdin });
}
var d10, y12, C12, b15, P11;
var init_chunk_JP44OYZS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JP44OYZS.js"() {
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    d10 = { name: "bash", summary: "execute shell commands or scripts", usage: "bash [OPTIONS] [SCRIPT_FILE] [ARGUMENTS...]", options: ["-c COMMAND  execute COMMAND string", "    --help  display this help and exit"], notes: ["Without -c, reads and executes commands from SCRIPT_FILE.", "Arguments are passed as $1, $2, etc. to the script.", '$0 is set to the script name (or "bash" with -c).'] };
    y12 = { name: "bash", async execute(t6, e5) {
      if (o2(t6)) return s(d10);
      if (t6[0] === "-c" && t6.length >= 2) {
        let r8 = t6[1], s9 = t6[2] || "bash", c14 = t6.slice(3);
        return i3(r8, s9, c14, e5);
      }
      if (t6.length === 0) return e5.stdin?.trim() ? i3(e5.stdin, "bash", [], e5) : { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6[0], o9 = t6.slice(1);
      try {
        let r8 = e5.fs.resolvePath(e5.cwd, n23), s9 = await e5.fs.readFile(r8);
        return i3(s9, n23, o9, e5);
      } catch {
        return { stdout: "", stderr: `bash: ${n23}: No such file or directory
`, exitCode: 127 };
      }
    } };
    C12 = { name: "sh", async execute(t6, e5) {
      if (o2(t6)) return s({ ...d10, name: "sh", summary: "execute shell commands or scripts (POSIX shell)" });
      if (t6[0] === "-c" && t6.length >= 2) {
        let r8 = t6[1], s9 = t6[2] || "sh", c14 = t6.slice(3);
        return i3(r8, s9, c14, e5);
      }
      if (t6.length === 0) return e5.stdin?.trim() ? i3(e5.stdin, "sh", [], e5) : { stdout: "", stderr: "", exitCode: 0 };
      let n23 = t6[0], o9 = t6.slice(1);
      try {
        let r8 = e5.fs.resolvePath(e5.cwd, n23), s9 = await e5.fs.readFile(r8);
        return i3(s9, n23, o9, e5);
      } catch {
        return { stdout: "", stderr: `sh: ${n23}: No such file or directory
`, exitCode: 127 };
      }
    } };
    b15 = { name: "bash", flags: [{ flag: "-c", type: "value", valueHint: "string" }], stdinType: "text" };
    P11 = { name: "sh", flags: [{ flag: "-c", type: "value", valueHint: "string" }], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/bash-DYXMG247.js
var bash_DYXMG247_exports = {};
__export(bash_DYXMG247_exports, {
  bashCommand: () => y12,
  flagsForFuzzing: () => b15,
  shCommand: () => C12,
  shFlagsForFuzzing: () => P11
});
var init_bash_DYXMG247 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/bash-DYXMG247.js"() {
    init_chunk_JP44OYZS();
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-7MKBHGLS.js
function o6(e5) {
  return !n19.has(e5);
}
function u5(e5, t6, r8) {
  o6(t6) && (e5[t6] = r8);
}
function c9(e5, t6) {
  return Object.hasOwn(e5, t6);
}
function s4(e5) {
  return Object.assign(/* @__PURE__ */ Object.create(null), e5);
}
function i4(...e5) {
  return Object.assign(/* @__PURE__ */ Object.create(null), ...e5);
}
var n19, f8;
var init_chunk_7MKBHGLS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-7MKBHGLS.js"() {
    n19 = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
    f8 = /* @__PURE__ */ new Set([...n19, "__defineGetter__", "__defineSetter__", "__lookupGetter__", "__lookupSetter__", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-FRDGR5VK.js
function W8(t6, r8, e5, n23, p17, i10, u10, c14, s9, f11) {
  switch (r8) {
    case "sort":
      return Array.isArray(t6) ? [[...t6].sort(u10)] : [null];
    case "sort_by":
      return !Array.isArray(t6) || e5.length === 0 ? [null] : [[...t6].sort((h16, y18) => {
        let a7 = p17(h16, e5[0], n23)[0], l8 = p17(y18, e5[0], n23)[0];
        return u10(a7, l8);
      })];
    case "bsearch": {
      if (!Array.isArray(t6)) {
        let h16 = t6 === null ? "null" : typeof t6 == "object" ? "object" : typeof t6;
        throw new Error(`${h16} (${JSON.stringify(t6)}) cannot be searched from`);
      }
      return e5.length === 0 ? [null] : p17(t6, e5[0], n23).map((h16) => {
        let y18 = 0, a7 = t6.length;
        for (; y18 < a7; ) {
          let l8 = y18 + a7 >>> 1;
          u10(t6[l8], h16) < 0 ? y18 = l8 + 1 : a7 = l8;
        }
        return y18 < t6.length && u10(t6[y18], h16) === 0 ? y18 : -y18 - 1;
      });
    }
    case "unique_by": {
      if (!Array.isArray(t6) || e5.length === 0) return [null];
      let o9 = /* @__PURE__ */ new Map();
      for (let y18 of t6) {
        let a7 = p17(y18, e5[0], n23)[0], l8 = JSON.stringify(a7);
        o9.has(l8) || o9.set(l8, { item: y18, key: a7 });
      }
      let h16 = [...o9.values()];
      return h16.sort((y18, a7) => u10(y18.key, a7.key)), [h16.map((y18) => y18.item)];
    }
    case "group_by": {
      if (!Array.isArray(t6) || e5.length === 0) return [null];
      let o9 = /* @__PURE__ */ new Map();
      for (let h16 of t6) {
        let y18 = JSON.stringify(p17(h16, e5[0], n23)[0]);
        o9.has(y18) || o9.set(y18, []), o9.get(y18)?.push(h16);
      }
      return [[...o9.values()]];
    }
    case "max":
      return Array.isArray(t6) && t6.length > 0 ? [t6.reduce((o9, h16) => u10(o9, h16) > 0 ? o9 : h16)] : [null];
    case "max_by":
      return !Array.isArray(t6) || t6.length === 0 || e5.length === 0 ? [null] : [t6.reduce((o9, h16) => {
        let y18 = p17(o9, e5[0], n23)[0], a7 = p17(h16, e5[0], n23)[0];
        return u10(y18, a7) > 0 ? o9 : h16;
      })];
    case "min":
      return Array.isArray(t6) && t6.length > 0 ? [t6.reduce((o9, h16) => u10(o9, h16) < 0 ? o9 : h16)] : [null];
    case "min_by":
      return !Array.isArray(t6) || t6.length === 0 || e5.length === 0 ? [null] : [t6.reduce((o9, h16) => {
        let y18 = p17(o9, e5[0], n23)[0], a7 = p17(h16, e5[0], n23)[0];
        return u10(y18, a7) < 0 ? o9 : h16;
      })];
    case "add": {
      let o9 = (h16) => {
        let y18 = h16.filter((a7) => a7 !== null);
        return y18.length === 0 ? null : y18.every((a7) => typeof a7 == "number") ? y18.reduce((a7, l8) => a7 + l8, 0) : y18.every((a7) => typeof a7 == "string") ? y18.join("") : y18.every((a7) => Array.isArray(a7)) ? y18.flat() : y18.every((a7) => a7 && typeof a7 == "object" && !Array.isArray(a7)) ? c2(...y18) : null;
      };
      if (e5.length >= 1) {
        let h16 = p17(t6, e5[0], n23);
        return [o9(h16)];
      }
      return Array.isArray(t6) ? [o9(t6)] : [null];
    }
    case "any": {
      if (e5.length >= 2) {
        try {
          let o9 = i10(t6, e5[0], n23);
          for (let h16 of o9) if (p17(h16, e5[1], n23).some(c14)) return [true];
        } catch (o9) {
          if (o9 instanceof f11) throw o9;
        }
        return [false];
      }
      return e5.length === 1 ? Array.isArray(t6) ? [t6.some((o9) => c14(p17(o9, e5[0], n23)[0]))] : [false] : Array.isArray(t6) ? [t6.some(c14)] : [false];
    }
    case "all": {
      if (e5.length >= 2) {
        try {
          let o9 = i10(t6, e5[0], n23);
          for (let h16 of o9) if (!p17(h16, e5[1], n23).some(c14)) return [false];
        } catch (o9) {
          if (o9 instanceof f11) throw o9;
        }
        return [true];
      }
      return e5.length === 1 ? Array.isArray(t6) ? [t6.every((o9) => c14(p17(o9, e5[0], n23)[0]))] : [true] : Array.isArray(t6) ? [t6.every(c14)] : [true];
    }
    case "select":
      return e5.length === 0 ? [t6] : p17(t6, e5[0], n23).some(c14) ? [t6] : [];
    case "map":
      return e5.length === 0 || !Array.isArray(t6) ? [null] : [t6.flatMap((h16) => p17(h16, e5[0], n23))];
    case "map_values": {
      if (e5.length === 0) return [null];
      if (Array.isArray(t6)) return [t6.flatMap((o9) => p17(o9, e5[0], n23))];
      if (t6 && typeof t6 == "object") {
        let o9 = /* @__PURE__ */ Object.create(null);
        for (let [h16, y18] of Object.entries(t6)) {
          if (!o6(h16)) continue;
          let a7 = p17(y18, e5[0], n23);
          a7.length > 0 && u5(o9, h16, a7[0]);
        }
        return [o9];
      }
      return [null];
    }
    case "has": {
      if (e5.length === 0) return [false];
      let h16 = p17(t6, e5[0], n23)[0];
      return Array.isArray(t6) && typeof h16 == "number" ? [h16 >= 0 && h16 < t6.length] : t6 && typeof t6 == "object" && typeof h16 == "string" ? [c9(t6, h16)] : [false];
    }
    case "in": {
      if (e5.length === 0) return [false];
      let h16 = p17(t6, e5[0], n23)[0];
      return Array.isArray(h16) && typeof t6 == "number" ? [t6 >= 0 && t6 < h16.length] : h16 && typeof h16 == "object" && typeof t6 == "string" ? [c9(h16, t6)] : [false];
    }
    case "contains": {
      if (e5.length === 0) return [false];
      let o9 = p17(t6, e5[0], n23);
      return [s9(t6, o9[0])];
    }
    case "inside": {
      if (e5.length === 0) return [false];
      let o9 = p17(t6, e5[0], n23);
      return [s9(o9[0], t6)];
    }
    default:
      return null;
  }
}
function Q8(t6, r8, e5, n23, p17, i10, u10, c14) {
  switch (r8) {
    case "first":
      if (e5.length > 0) try {
        let s9 = i10(t6, e5[0], n23);
        return s9.length > 0 ? [s9[0]] : [];
      } catch (s9) {
        if (s9 instanceof c14) throw s9;
        return [];
      }
      return Array.isArray(t6) && t6.length > 0 ? [t6[0]] : [null];
    case "last":
      if (e5.length > 0) {
        let s9 = p17(t6, e5[0], n23);
        return s9.length > 0 ? [s9[s9.length - 1]] : [];
      }
      return Array.isArray(t6) && t6.length > 0 ? [t6[t6.length - 1]] : [null];
    case "nth": {
      if (e5.length < 1) return [null];
      let s9 = p17(t6, e5[0], n23);
      if (e5.length > 1) {
        for (let o9 of s9) if (o9 < 0) throw new Error("nth doesn't support negative indices");
        let f11;
        try {
          f11 = i10(t6, e5[1], n23);
        } catch (o9) {
          if (o9 instanceof c14) throw o9;
          f11 = [];
        }
        return s9.flatMap((o9) => {
          let h16 = o9;
          return h16 < f11.length ? [f11[h16]] : [];
        });
      }
      return Array.isArray(t6) ? s9.flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("nth doesn't support negative indices");
        return o9 < t6.length ? [t6[o9]] : [null];
      }) : [null];
    }
    case "range": {
      if (e5.length === 0) return [];
      let s9 = p17(t6, e5[0], n23);
      if (e5.length === 1) {
        let y18 = [];
        for (let a7 of s9) {
          let l8 = a7;
          for (let m24 = 0; m24 < l8; m24++) y18.push(m24);
        }
        return y18;
      }
      let f11 = p17(t6, e5[1], n23);
      if (e5.length === 2) {
        let y18 = [];
        for (let a7 of s9) for (let l8 of f11) {
          let m24 = a7, A13 = l8;
          for (let E12 = m24; E12 < A13; E12++) y18.push(E12);
        }
        return y18;
      }
      let o9 = p17(t6, e5[2], n23), h16 = [];
      for (let y18 of s9) for (let a7 of f11) for (let l8 of o9) {
        let m24 = y18, A13 = a7, E12 = l8;
        if (E12 !== 0) if (E12 > 0) for (let w19 = m24; w19 < A13; w19 += E12) h16.push(w19);
        else for (let w19 = m24; w19 > A13; w19 += E12) h16.push(w19);
      }
      return h16;
    }
    case "limit":
      return e5.length < 2 ? [] : p17(t6, e5[0], n23).flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("limit doesn't support negative count");
        if (o9 === 0) return [];
        let h16;
        try {
          h16 = i10(t6, e5[1], n23);
        } catch (y18) {
          if (y18 instanceof c14) throw y18;
          h16 = [];
        }
        return h16.slice(0, o9);
      });
    case "isempty": {
      if (e5.length < 1) return [true];
      try {
        return [i10(t6, e5[0], n23).length === 0];
      } catch (s9) {
        if (s9 instanceof c14) throw s9;
        return [true];
      }
    }
    case "isvalid": {
      if (e5.length < 1) return [true];
      try {
        return [p17(t6, e5[0], n23).length > 0];
      } catch (s9) {
        if (s9 instanceof c14) throw s9;
        return [false];
      }
    }
    case "skip":
      return e5.length < 2 ? [] : p17(t6, e5[0], n23).flatMap((f11) => {
        let o9 = f11;
        if (o9 < 0) throw new Error("skip doesn't support negative count");
        return p17(t6, e5[1], n23).slice(o9);
      });
    case "until": {
      if (e5.length < 2) return [t6];
      let s9 = t6, f11 = n23.limits.maxIterations;
      for (let o9 = 0; o9 < f11; o9++) {
        if (p17(s9, e5[0], n23).some(u10)) return [s9];
        let y18 = p17(s9, e5[1], n23);
        if (y18.length === 0) return [s9];
        s9 = y18[0];
      }
      throw new c14(`jq until: too many iterations (${f11}), increase executionLimits.maxJqIterations`, "iterations");
    }
    case "while": {
      if (e5.length < 2) return [t6];
      let s9 = [], f11 = t6, o9 = n23.limits.maxIterations;
      for (let h16 = 0; h16 < o9 && p17(f11, e5[0], n23).some(u10); h16++) {
        s9.push(f11);
        let a7 = p17(f11, e5[1], n23);
        if (a7.length === 0) break;
        f11 = a7[0];
      }
      if (s9.length >= o9) throw new c14(`jq while: too many iterations (${o9}), increase executionLimits.maxJqIterations`, "iterations");
      return s9;
    }
    case "repeat": {
      if (e5.length === 0) return [t6];
      let s9 = [], f11 = t6, o9 = n23.limits.maxIterations;
      for (let h16 = 0; h16 < o9; h16++) {
        s9.push(f11);
        let y18 = p17(f11, e5[0], n23);
        if (y18.length === 0) break;
        f11 = y18[0];
      }
      if (s9.length >= o9) throw new c14(`jq repeat: too many iterations (${o9}), increase executionLimits.maxJqIterations`, "iterations");
      return s9;
    }
    default:
      return null;
  }
}
function Z7(t6, r8, e5, n23, p17) {
  switch (r8) {
    case "now":
      return [Date.now() / 1e3];
    case "gmtime": {
      if (typeof t6 != "number") return [null];
      let i10 = new Date(t6 * 1e3), u10 = i10.getUTCFullYear(), c14 = i10.getUTCMonth(), s9 = i10.getUTCDate(), f11 = i10.getUTCHours(), o9 = i10.getUTCMinutes(), h16 = i10.getUTCSeconds(), y18 = i10.getUTCDay(), a7 = Date.UTC(u10, 0, 1), l8 = Math.floor((i10.getTime() - a7) / (1440 * 60 * 1e3));
      return [[u10, c14, s9, f11, o9, h16, y18, l8]];
    }
    case "mktime": {
      if (!Array.isArray(t6)) throw new Error("mktime requires parsed datetime inputs");
      let [i10, u10, c14, s9 = 0, f11 = 0, o9 = 0] = t6;
      if (typeof i10 != "number" || typeof u10 != "number") throw new Error("mktime requires parsed datetime inputs");
      let h16 = Date.UTC(i10, u10, c14 ?? 1, s9 ?? 0, f11 ?? 0, o9 ?? 0);
      return [Math.floor(h16 / 1e3)];
    }
    case "strftime": {
      if (e5.length === 0) return [null];
      let u10 = p17(t6, e5[0], n23)[0];
      if (typeof u10 != "string") throw new Error("strftime/1 requires a string format");
      let c14;
      if (typeof t6 == "number") c14 = new Date(t6 * 1e3);
      else if (Array.isArray(t6)) {
        let [y18, a7, l8, m24 = 0, A13 = 0, E12 = 0] = t6;
        if (typeof y18 != "number" || typeof a7 != "number") throw new Error("strftime/1 requires parsed datetime inputs");
        c14 = new Date(Date.UTC(y18, a7, l8 ?? 1, m24 ?? 0, A13 ?? 0, E12 ?? 0));
      } else throw new Error("strftime/1 requires parsed datetime inputs");
      let s9 = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], f11 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], o9 = (y18, a7 = 2) => String(y18).padStart(a7, "0");
      return [u10.replace(/%Y/g, String(c14.getUTCFullYear())).replace(/%m/g, o9(c14.getUTCMonth() + 1)).replace(/%d/g, o9(c14.getUTCDate())).replace(/%H/g, o9(c14.getUTCHours())).replace(/%M/g, o9(c14.getUTCMinutes())).replace(/%S/g, o9(c14.getUTCSeconds())).replace(/%A/g, s9[c14.getUTCDay()]).replace(/%B/g, f11[c14.getUTCMonth()]).replace(/%Z/g, "UTC").replace(/%%/g, "%")];
    }
    case "strptime": {
      if (e5.length === 0) return [null];
      if (typeof t6 != "string") throw new Error("strptime/1 requires a string input");
      let u10 = p17(t6, e5[0], n23)[0];
      if (typeof u10 != "string") throw new Error("strptime/1 requires a string format");
      if (u10 === "%Y-%m-%dT%H:%M:%SZ") {
        let s9 = t6.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z$/);
        if (s9) {
          let [, f11, o9, h16, y18, a7, l8] = s9.map(Number), m24 = new Date(Date.UTC(f11, o9 - 1, h16, y18, a7, l8)), A13 = m24.getUTCDay(), E12 = Date.UTC(f11, 0, 1), w19 = Math.floor((m24.getTime() - E12) / (1440 * 60 * 1e3));
          return [[f11, o9 - 1, h16, y18, a7, l8, A13, w19]];
        }
      }
      let c14 = new Date(t6);
      if (!Number.isNaN(c14.getTime())) {
        let s9 = c14.getUTCFullYear(), f11 = c14.getUTCMonth(), o9 = c14.getUTCDate(), h16 = c14.getUTCHours(), y18 = c14.getUTCMinutes(), a7 = c14.getUTCSeconds(), l8 = c14.getUTCDay(), m24 = Date.UTC(s9, 0, 1), A13 = Math.floor((c14.getTime() - m24) / (1440 * 60 * 1e3));
        return [[s9, f11, o9, h16, y18, a7, l8, A13]];
      }
      throw new Error(`Cannot parse date: ${t6}`);
    }
    case "fromdate": {
      if (typeof t6 != "string") throw new Error("fromdate requires a string input");
      let i10 = new Date(t6);
      if (Number.isNaN(i10.getTime())) throw new Error(`date "${t6}" does not match format "%Y-%m-%dT%H:%M:%SZ"`);
      return [Math.floor(i10.getTime() / 1e3)];
    }
    case "todate": {
      if (typeof t6 != "number") throw new Error("todate requires a number input");
      return [new Date(t6 * 1e3).toISOString().replace(/\.\d{3}Z$/, "Z")];
    }
    default:
      return null;
  }
}
function N11(t6) {
  return t6 !== false && t6 !== null;
}
function R4(t6, r8) {
  return JSON.stringify(t6) === JSON.stringify(r8);
}
function D9(t6, r8) {
  return typeof t6 == "number" && typeof r8 == "number" ? t6 - r8 : typeof t6 == "string" && typeof r8 == "string" ? t6.localeCompare(r8) : 0;
}
function z6(t6, r8) {
  let e5 = s4(t6);
  for (let n23 of Object.keys(r8)) o6(n23) && (c9(e5, n23) && e5[n23] && typeof e5[n23] == "object" && !Array.isArray(e5[n23]) && r8[n23] && typeof r8[n23] == "object" && !Array.isArray(r8[n23]) ? u5(e5, n23, z6(e5[n23], r8[n23])) : u5(e5, n23, r8[n23]));
  return e5;
}
function M7(t6, r8 = 3e3) {
  let e5 = 0, n23 = t6;
  for (; e5 < r8; ) if (Array.isArray(n23)) {
    if (n23.length === 0) return e5 + 1;
    n23 = n23[0], e5++;
  } else if (n23 !== null && typeof n23 == "object") {
    let p17 = Object.keys(n23);
    if (p17.length === 0) return e5 + 1;
    n23 = n23[p17[0]], e5++;
  } else return e5;
  return e5;
}
function L10(t6, r8) {
  let e5 = (i10) => i10 === null ? 0 : typeof i10 == "boolean" ? 1 : typeof i10 == "number" ? 2 : typeof i10 == "string" ? 3 : Array.isArray(i10) ? 4 : typeof i10 == "object" ? 5 : 6, n23 = e5(t6), p17 = e5(r8);
  if (n23 !== p17) return n23 - p17;
  if (typeof t6 == "number" && typeof r8 == "number") return t6 - r8;
  if (typeof t6 == "string" && typeof r8 == "string") return t6.localeCompare(r8);
  if (typeof t6 == "boolean" && typeof r8 == "boolean") return (t6 ? 1 : 0) - (r8 ? 1 : 0);
  if (Array.isArray(t6) && Array.isArray(r8)) {
    for (let i10 = 0; i10 < Math.min(t6.length, r8.length); i10++) {
      let u10 = L10(t6[i10], r8[i10]);
      if (u10 !== 0) return u10;
    }
    return t6.length - r8.length;
  }
  if (t6 && r8 && typeof t6 == "object" && typeof r8 == "object") {
    let i10 = t6, u10 = r8, c14 = Object.keys(i10).sort(), s9 = Object.keys(u10).sort();
    for (let f11 = 0; f11 < Math.min(c14.length, s9.length); f11++) {
      let o9 = c14[f11].localeCompare(s9[f11]);
      if (o9 !== 0) return o9;
    }
    if (c14.length !== s9.length) return c14.length - s9.length;
    for (let f11 of c14) {
      let o9 = L10(i10[f11], u10[f11]);
      if (o9 !== 0) return o9;
    }
  }
  return 0;
}
function _6(t6, r8) {
  if (R4(t6, r8)) return true;
  if (typeof t6 == "string" && typeof r8 == "string") return t6.includes(r8);
  if (Array.isArray(t6) && Array.isArray(r8)) return r8.every((e5) => t6.some((n23) => _6(n23, e5)));
  if (t6 && r8 && typeof t6 == "object" && typeof r8 == "object" && !Array.isArray(t6) && !Array.isArray(r8)) {
    let e5 = t6, n23 = r8;
    return Object.keys(n23).every((p17) => c9(e5, p17) && _6(e5[p17], n23[p17]));
  }
  return false;
}
function v14(t6, r8, e5) {
  switch (r8) {
    case "@base64":
      return typeof t6 == "string" ? typeof Buffer < "u" ? [Buffer.from(t6, "utf-8").toString("base64")] : [btoa(t6)] : [null];
    case "@base64d":
      return typeof t6 == "string" ? typeof Buffer < "u" ? [Buffer.from(t6, "base64").toString("utf-8")] : [atob(t6)] : [null];
    case "@uri":
      return typeof t6 == "string" ? [encodeURIComponent(t6).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A")] : [null];
    case "@urid":
      return typeof t6 == "string" ? [decodeURIComponent(t6)] : [null];
    case "@csv":
      return Array.isArray(t6) ? [t6.map((p17) => {
        if (p17 === null) return "";
        if (typeof p17 == "boolean") return p17 ? "true" : "false";
        if (typeof p17 == "number") return String(p17);
        let i10 = String(p17);
        return i10.includes(",") || i10.includes('"') || i10.includes(`
`) || i10.includes("\r") ? `"${i10.replace(/"/g, '""')}"` : i10;
      }).join(",")] : [null];
    case "@tsv":
      return Array.isArray(t6) ? [t6.map((n23) => String(n23 ?? "").replace(/\t/g, "\\t").replace(/\n/g, "\\n")).join("	")] : [null];
    case "@json": {
      let n23 = e5 ?? Et2;
      return M7(t6, n23 + 1) > n23 ? [null] : [JSON.stringify(t6)];
    }
    case "@html":
      return typeof t6 == "string" ? [t6.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;")] : [null];
    case "@sh":
      return typeof t6 == "string" ? [`'${t6.replace(/'/g, "'\\''")}'`] : [null];
    case "@text":
      return typeof t6 == "string" ? [t6] : t6 == null ? [""] : [String(t6)];
    default:
      return null;
  }
}
function tt3(t6, r8, e5, n23, p17, i10) {
  switch (r8) {
    case "index":
      return e5.length === 0 ? [null] : p17(t6, e5[0], n23).map((c14) => {
        if (typeof t6 == "string" && typeof c14 == "string") {
          if (c14 === "" && t6 === "") return null;
          let s9 = t6.indexOf(c14);
          return s9 >= 0 ? s9 : null;
        }
        if (Array.isArray(t6)) {
          if (Array.isArray(c14)) {
            for (let f11 = 0; f11 <= t6.length - c14.length; f11++) {
              let o9 = true;
              for (let h16 = 0; h16 < c14.length; h16++) if (!i10(t6[f11 + h16], c14[h16])) {
                o9 = false;
                break;
              }
              if (o9) return f11;
            }
            return null;
          }
          let s9 = t6.findIndex((f11) => i10(f11, c14));
          return s9 >= 0 ? s9 : null;
        }
        return null;
      });
    case "rindex":
      return e5.length === 0 ? [null] : p17(t6, e5[0], n23).map((c14) => {
        if (typeof t6 == "string" && typeof c14 == "string") {
          let s9 = t6.lastIndexOf(c14);
          return s9 >= 0 ? s9 : null;
        }
        if (Array.isArray(t6)) {
          if (Array.isArray(c14)) {
            for (let s9 = t6.length - c14.length; s9 >= 0; s9--) {
              let f11 = true;
              for (let o9 = 0; o9 < c14.length; o9++) if (!i10(t6[s9 + o9], c14[o9])) {
                f11 = false;
                break;
              }
              if (f11) return s9;
            }
            return null;
          }
          for (let s9 = t6.length - 1; s9 >= 0; s9--) if (i10(t6[s9], c14)) return s9;
          return null;
        }
        return null;
      });
    case "indices":
      return e5.length === 0 ? [[]] : p17(t6, e5[0], n23).map((c14) => {
        let s9 = [];
        if (typeof t6 == "string" && typeof c14 == "string") {
          let f11 = t6.indexOf(c14);
          for (; f11 !== -1; ) s9.push(f11), f11 = t6.indexOf(c14, f11 + 1);
        } else if (Array.isArray(t6)) if (Array.isArray(c14)) {
          let f11 = c14.length;
          if (f11 === 0) for (let o9 = 0; o9 <= t6.length; o9++) s9.push(o9);
          else for (let o9 = 0; o9 <= t6.length - f11; o9++) {
            let h16 = true;
            for (let y18 = 0; y18 < f11; y18++) if (!i10(t6[o9 + y18], c14[y18])) {
              h16 = false;
              break;
            }
            h16 && s9.push(o9);
          }
        } else for (let f11 = 0; f11 < t6.length; f11++) i10(t6[f11], c14) && s9.push(f11);
        return s9;
      });
    default:
      return null;
  }
}
function et3(t6, r8, e5, n23, p17) {
  switch (r8) {
    case "fabs":
    case "abs":
      return typeof t6 == "number" ? [Math.abs(t6)] : typeof t6 == "string" ? [t6] : [null];
    case "exp10":
      return typeof t6 == "number" ? [10 ** t6] : [null];
    case "exp2":
      return typeof t6 == "number" ? [2 ** t6] : [null];
    case "pow": {
      if (e5.length < 2) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = p17(t6, e5[1], n23), c14 = i10[0], s9 = u10[0];
      return typeof c14 != "number" || typeof s9 != "number" ? [null] : [c14 ** s9];
    }
    case "atan2": {
      if (e5.length < 2) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = p17(t6, e5[1], n23), c14 = i10[0], s9 = u10[0];
      return typeof c14 != "number" || typeof s9 != "number" ? [null] : [Math.atan2(c14, s9)];
    }
    case "hypot": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [Math.hypot(t6, i10)];
    }
    case "fma": {
      if (typeof t6 != "number" || e5.length < 2) return [null];
      let i10 = p17(t6, e5[0], n23)[0], u10 = p17(t6, e5[1], n23)[0];
      return [t6 * i10 + u10];
    }
    case "copysign": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [Math.sign(i10) * Math.abs(t6)];
    }
    case "drem":
    case "remainder": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [t6 - Math.round(t6 / i10) * i10];
    }
    case "fdim": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [Math.max(0, t6 - i10)];
    }
    case "fmax": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [Math.max(t6, i10)];
    }
    case "fmin": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [Math.min(t6, i10)];
    }
    case "ldexp": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [t6 * 2 ** i10];
    }
    case "scalbn":
    case "scalbln": {
      if (typeof t6 != "number" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23)[0];
      return [t6 * 2 ** i10];
    }
    case "nearbyint":
      return typeof t6 == "number" ? [Math.round(t6)] : [null];
    case "logb":
      return typeof t6 == "number" ? [Math.floor(Math.log2(Math.abs(t6)))] : [null];
    case "significand":
      if (typeof t6 == "number") {
        let i10 = Math.floor(Math.log2(Math.abs(t6)));
        return [t6 / 2 ** i10];
      }
      return [null];
    case "frexp":
      if (typeof t6 == "number") {
        if (t6 === 0) return [[0, 0]];
        let i10 = Math.floor(Math.log2(Math.abs(t6))) + 1;
        return [[t6 / 2 ** i10, i10]];
      }
      return [null];
    case "modf":
      if (typeof t6 == "number") {
        let i10 = Math.trunc(t6);
        return [[t6 - i10, i10]];
      }
      return [null];
    default:
      return null;
  }
}
function rt3(t6, r8, e5, n23, p17, i10, u10, c14) {
  switch (r8) {
    case "recurse": {
      if (e5.length === 0) {
        let a7 = [], l8 = (m24) => {
          if (a7.push(m24), Array.isArray(m24)) for (let A13 of m24) l8(A13);
          else if (m24 && typeof m24 == "object") for (let A13 of Object.keys(m24)) l8(m24[A13]);
        };
        return l8(t6), a7;
      }
      let s9 = [], f11 = e5.length >= 2 ? e5[1] : null, o9 = 1e4, h16 = 0, y18 = (a7) => {
        if (h16++ > o9 || f11 && !p17(a7, f11, n23).some(i10)) return;
        s9.push(a7);
        let l8 = p17(a7, e5[0], n23);
        for (let m24 of l8) m24 != null && y18(m24);
      };
      return y18(t6), s9;
    }
    case "recurse_down":
      return c14(t6, "recurse", e5, n23);
    case "walk": {
      if (e5.length === 0) return [t6];
      let s9 = /* @__PURE__ */ new WeakSet(), f11 = (o9) => {
        if (o9 && typeof o9 == "object") {
          if (s9.has(o9)) return o9;
          s9.add(o9);
        }
        let h16;
        if (Array.isArray(o9)) h16 = o9.map(f11);
        else if (o9 && typeof o9 == "object") {
          let a7 = /* @__PURE__ */ Object.create(null);
          for (let [l8, m24] of Object.entries(o9)) o6(l8) && u5(a7, l8, f11(m24));
          h16 = a7;
        } else h16 = o9;
        return p17(h16, e5[0], n23)[0];
      };
      return [f11(t6)];
    }
    case "transpose": {
      if (!Array.isArray(t6)) return [null];
      if (t6.length === 0) return [[]];
      let s9 = Math.max(...t6.map((o9) => Array.isArray(o9) ? o9.length : 0)), f11 = [];
      for (let o9 = 0; o9 < s9; o9++) f11.push(t6.map((h16) => Array.isArray(h16) ? h16[o9] : null));
      return [f11];
    }
    case "combinations": {
      if (e5.length > 0) {
        let h16 = p17(t6, e5[0], n23)[0];
        if (!Array.isArray(t6) || h16 < 0) return [];
        if (h16 === 0) return [[]];
        let y18 = [], a7 = (l8, m24) => {
          if (m24 === h16) {
            y18.push([...l8]);
            return;
          }
          for (let A13 of t6) l8.push(A13), a7(l8, m24 + 1), l8.pop();
        };
        return a7([], 0), y18;
      }
      if (!Array.isArray(t6)) return [];
      if (t6.length === 0) return [[]];
      for (let o9 of t6) if (!Array.isArray(o9)) return [];
      let s9 = [], f11 = (o9, h16) => {
        if (o9 === t6.length) {
          s9.push([...h16]);
          return;
        }
        let y18 = t6[o9];
        for (let a7 of y18) h16.push(a7), f11(o9 + 1, h16), h16.pop();
      };
      return f11(0, []), s9;
    }
    case "parent": {
      if (n23.root === void 0 || n23.currentPath === void 0) return [];
      let s9 = n23.currentPath;
      if (s9.length === 0) return [];
      let f11 = e5.length > 0 ? p17(t6, e5[0], n23)[0] : 1;
      if (f11 >= 0) {
        if (f11 > s9.length) return [];
        let o9 = s9.slice(0, s9.length - f11);
        return [u10(n23.root, o9)];
      } else {
        let o9 = -f11 - 1;
        if (o9 >= s9.length) return [t6];
        let h16 = s9.slice(0, o9);
        return [u10(n23.root, h16)];
      }
    }
    case "parents": {
      if (n23.root === void 0 || n23.currentPath === void 0) return [[]];
      let s9 = n23.currentPath, f11 = [];
      for (let o9 = s9.length - 1; o9 >= 0; o9--) f11.push(u10(n23.root, s9.slice(0, o9)));
      return [f11];
    }
    case "root":
      return n23.root !== void 0 ? [n23.root] : [];
    default:
      return null;
  }
}
function nt3(t6, r8, e5, n23, p17) {
  switch (r8) {
    case "keys":
      return Array.isArray(t6) ? [t6.map((i10, u10) => u10)] : t6 && typeof t6 == "object" ? [Object.keys(t6).sort()] : [null];
    case "keys_unsorted":
      return Array.isArray(t6) ? [t6.map((i10, u10) => u10)] : t6 && typeof t6 == "object" ? [Object.keys(t6)] : [null];
    case "length":
      return typeof t6 == "string" ? [t6.length] : Array.isArray(t6) ? [t6.length] : t6 && typeof t6 == "object" ? [Object.keys(t6).length] : t6 === null ? [0] : typeof t6 == "number" ? [Math.abs(t6)] : [null];
    case "utf8bytelength": {
      if (typeof t6 == "string") return [new TextEncoder().encode(t6).length];
      let i10 = t6 === null ? "null" : Array.isArray(t6) ? "array" : typeof t6, u10 = i10 === "array" || i10 === "object" ? JSON.stringify(t6) : String(t6);
      throw new Error(`${i10} (${u10}) only strings have UTF-8 byte length`);
    }
    case "to_entries":
      return t6 && typeof t6 == "object" && !Array.isArray(t6) ? [Object.entries(t6).map(([i10, u10]) => ({ key: i10, value: u10 }))] : [null];
    case "from_entries":
      if (Array.isArray(t6)) {
        let i10 = /* @__PURE__ */ Object.create(null);
        for (let u10 of t6) if (u10 && typeof u10 == "object") {
          let c14 = u10, s9 = c14.key ?? c14.Key ?? c14.name ?? c14.Name ?? c14.k, f11 = c14.value ?? c14.Value ?? c14.v;
          if (s9 !== void 0) {
            let o9 = String(s9);
            o6(o9) && u5(i10, o9, f11);
          }
        }
        return [i10];
      }
      return [null];
    case "with_entries": {
      if (e5.length === 0) return [t6];
      if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
        let u10 = Object.entries(t6).map(([s9, f11]) => ({ key: s9, value: f11 })).flatMap((s9) => p17(s9, e5[0], n23)), c14 = /* @__PURE__ */ Object.create(null);
        for (let s9 of u10) if (s9 && typeof s9 == "object") {
          let f11 = s9, o9 = f11.key ?? f11.name ?? f11.k, h16 = f11.value ?? f11.v;
          if (o9 !== void 0) {
            let y18 = String(o9);
            o6(y18) && u5(c14, y18, h16);
          }
        }
        return [c14];
      }
      return [null];
    }
    case "reverse":
      return Array.isArray(t6) ? [[...t6].reverse()] : typeof t6 == "string" ? [t6.split("").reverse().join("")] : [null];
    case "flatten":
      return Array.isArray(t6) ? (e5.length > 0 ? p17(t6, e5[0], n23) : [Number.POSITIVE_INFINITY]).map((u10) => {
        let c14 = u10;
        if (c14 < 0) throw new Error("flatten depth must not be negative");
        return t6.flat(c14);
      }) : [null];
    case "unique":
      if (Array.isArray(t6)) {
        let i10 = /* @__PURE__ */ new Set(), u10 = [];
        for (let c14 of t6) {
          let s9 = JSON.stringify(c14);
          i10.has(s9) || (i10.add(s9), u10.push(c14));
        }
        return [u10];
      }
      return [null];
    case "tojson":
    case "tojsonstream": {
      let i10 = n23.limits.maxDepth ?? wt2;
      return M7(t6, i10 + 1) > i10 ? [null] : [JSON.stringify(t6)];
    }
    case "fromjson": {
      if (typeof t6 == "string") {
        let i10 = t6.trim().toLowerCase();
        if (i10 === "nan") return [Number.NaN];
        if (i10 === "inf" || i10 === "infinity") return [Number.POSITIVE_INFINITY];
        if (i10 === "-inf" || i10 === "-infinity") return [Number.NEGATIVE_INFINITY];
        try {
          return [JSON.parse(t6)];
        } catch {
          throw new Error(`Invalid JSON: ${t6}`);
        }
      }
      return [t6];
    }
    case "tostring":
      return typeof t6 == "string" ? [t6] : [JSON.stringify(t6)];
    case "tonumber":
      if (typeof t6 == "number") return [t6];
      if (typeof t6 == "string") {
        let i10 = Number(t6);
        if (Number.isNaN(i10)) throw new Error(`${JSON.stringify(t6)} cannot be parsed as a number`);
        return [i10];
      }
      throw new Error(`${typeof t6} cannot be parsed as a number`);
    case "toboolean": {
      if (typeof t6 == "boolean") return [t6];
      if (typeof t6 == "string") {
        if (t6 === "true") return [true];
        if (t6 === "false") return [false];
        throw new Error(`string (${JSON.stringify(t6)}) cannot be parsed as a boolean`);
      }
      let i10 = t6 === null ? "null" : Array.isArray(t6) ? "array" : typeof t6, u10 = i10 === "array" || i10 === "object" ? JSON.stringify(t6) : String(t6);
      throw new Error(`${i10} (${u10}) cannot be parsed as a boolean`);
    }
    case "tostream": {
      let i10 = [], u10 = (c14, s9) => {
        if (c14 === null || typeof c14 != "object") i10.push([s9, c14]);
        else if (Array.isArray(c14)) if (c14.length === 0) i10.push([s9, []]);
        else for (let f11 = 0; f11 < c14.length; f11++) u10(c14[f11], [...s9, f11]);
        else {
          let f11 = Object.keys(c14);
          if (f11.length === 0) i10.push([s9, /* @__PURE__ */ Object.create(null)]);
          else for (let o9 of f11) u10(c14[o9], [...s9, o9]);
        }
      };
      return u10(t6, []), i10.push([[]]), i10;
    }
    case "fromstream": {
      if (e5.length === 0) return [t6];
      let i10 = p17(t6, e5[0], n23), u10 = null;
      for (let c14 of i10) {
        if (!Array.isArray(c14) || c14.length === 1 && Array.isArray(c14[0]) && c14[0].length === 0 || c14.length !== 2) continue;
        let [s9, f11] = c14;
        if (!Array.isArray(s9)) continue;
        if (s9.length === 0) {
          u10 = f11;
          continue;
        }
        u10 === null && (u10 = typeof s9[0] == "number" ? [] : {});
        let o9 = u10;
        for (let y18 = 0; y18 < s9.length - 1; y18++) {
          let a7 = s9[y18], l8 = s9[y18 + 1];
          if (Array.isArray(o9) && typeof a7 == "number") {
            for (; o9.length <= a7; ) o9.push(null);
            o9[a7] === null && (o9[a7] = typeof l8 == "number" ? [] : {}), o9 = o9[a7];
          } else if (o9 && typeof o9 == "object" && !Array.isArray(o9)) {
            let m24 = String(a7);
            if (!o6(m24)) continue;
            let A13 = o9;
            (A13[m24] === null || A13[m24] === void 0) && u5(A13, m24, typeof l8 == "number" ? [] : {}), o9 = A13[m24];
          }
        }
        let h16 = s9[s9.length - 1];
        if (Array.isArray(o9) && typeof h16 == "number") {
          for (; o9.length <= h16; ) o9.push(null);
          o9[h16] = f11;
        } else if (o9 && typeof o9 == "object" && !Array.isArray(o9)) {
          let y18 = String(h16);
          o6(y18) && u5(o9, y18, f11);
        }
      }
      return [u10];
    }
    case "truncate_stream": {
      let i10 = typeof t6 == "number" ? Math.floor(t6) : 0;
      if (e5.length === 0) return [];
      let u10 = [], c14 = p17(t6, e5[0], n23);
      for (let s9 of c14) if (Array.isArray(s9)) {
        if (s9.length === 1 && Array.isArray(s9[0])) {
          let f11 = s9[0];
          f11.length > i10 && u10.push([f11.slice(i10)]);
          continue;
        }
        if (s9.length === 2 && Array.isArray(s9[0])) {
          let f11 = s9[0], o9 = s9[1];
          f11.length > i10 && u10.push([f11.slice(i10), o9]);
        }
      }
      return u10;
    }
    default:
      return null;
  }
}
function st3(t6, r8, e5, n23, p17, i10, u10, c14, s9, f11) {
  switch (r8) {
    case "getpath": {
      if (e5.length === 0) return [null];
      let o9 = p17(t6, e5[0], n23), h16 = [];
      for (let y18 of o9) {
        let a7 = y18, l8 = t6;
        for (let m24 of a7) {
          if (l8 == null) {
            l8 = null;
            break;
          }
          if (Array.isArray(l8) && typeof m24 == "number") l8 = l8[m24];
          else if (typeof l8 == "object" && typeof m24 == "string") {
            let A13 = l8;
            if (!Object.hasOwn(A13, m24)) {
              l8 = null;
              break;
            }
            l8 = A13[m24];
          } else {
            l8 = null;
            break;
          }
        }
        h16.push(l8);
      }
      return h16;
    }
    case "setpath": {
      if (e5.length < 2) return [null];
      let h16 = p17(t6, e5[0], n23)[0], a7 = p17(t6, e5[1], n23)[0];
      return [u10(t6, h16, a7)];
    }
    case "delpaths": {
      if (e5.length === 0) return [t6];
      let h16 = p17(t6, e5[0], n23)[0], y18 = t6;
      for (let a7 of h16.sort((l8, m24) => m24.length - l8.length)) y18 = c14(y18, a7);
      return [y18];
    }
    case "path": {
      if (e5.length === 0) return [[]];
      let o9 = [];
      return f11(t6, e5[0], n23, [], o9), o9;
    }
    case "del":
      return e5.length === 0 ? [t6] : [s9(t6, e5[0], n23)];
    case "pick": {
      if (e5.length === 0) return [null];
      let o9 = [];
      for (let y18 of e5) f11(t6, y18, n23, [], o9);
      let h16 = null;
      for (let y18 of o9) {
        for (let l8 of y18) if (typeof l8 == "number" && l8 < 0) throw new Error("Out of bounds negative array index");
        let a7 = t6;
        for (let l8 of y18) {
          if (a7 == null) break;
          if (Array.isArray(a7) && typeof l8 == "number") a7 = a7[l8];
          else if (typeof a7 == "object" && typeof l8 == "string") {
            let m24 = a7;
            if (!Object.hasOwn(m24, l8)) {
              a7 = null;
              break;
            }
            a7 = m24[l8];
          } else {
            a7 = null;
            break;
          }
        }
        h16 = u10(h16, y18, a7);
      }
      return [h16];
    }
    case "paths": {
      let o9 = [], h16 = (y18, a7) => {
        if (y18 && typeof y18 == "object") if (Array.isArray(y18)) for (let l8 = 0; l8 < y18.length; l8++) o9.push([...a7, l8]), h16(y18[l8], [...a7, l8]);
        else for (let l8 of Object.keys(y18)) o9.push([...a7, l8]), h16(y18[l8], [...a7, l8]);
      };
      return h16(t6, []), e5.length > 0 ? o9.filter((y18) => {
        let a7 = t6;
        for (let m24 of y18) if (Array.isArray(a7) && typeof m24 == "number") a7 = a7[m24];
        else if (a7 && typeof a7 == "object" && typeof m24 == "string") {
          let A13 = a7;
          if (!Object.hasOwn(A13, m24)) return false;
          a7 = A13[m24];
        } else return false;
        return p17(a7, e5[0], n23).some(i10);
      }) : o9;
    }
    case "leaf_paths": {
      let o9 = [], h16 = (y18, a7) => {
        if (y18 === null || typeof y18 != "object") o9.push(a7);
        else if (Array.isArray(y18)) for (let l8 = 0; l8 < y18.length; l8++) h16(y18[l8], [...a7, l8]);
        else for (let l8 of Object.keys(y18)) h16(y18[l8], [...a7, l8]);
      };
      return h16(t6, []), o9;
    }
    default:
      return null;
  }
}
function it3(t6, r8, e5, n23, p17, i10) {
  switch (r8) {
    case "IN": {
      if (e5.length === 0) return [false];
      if (e5.length === 1) {
        let f11 = p17(t6, e5[0], n23);
        for (let o9 of f11) if (i10(t6, o9)) return [true];
        return [false];
      }
      let u10 = p17(t6, e5[0], n23), c14 = p17(t6, e5[1], n23), s9 = new Set(c14.map((f11) => JSON.stringify(f11)));
      for (let f11 of u10) if (s9.has(JSON.stringify(f11))) return [true];
      return [false];
    }
    case "INDEX": {
      if (e5.length === 0) return [{}];
      if (e5.length === 1) {
        let s9 = p17(t6, e5[0], n23), f11 = /* @__PURE__ */ Object.create(null);
        for (let o9 of s9) {
          let h16 = String(o9);
          o6(h16) && u5(f11, h16, o9);
        }
        return [f11];
      }
      if (e5.length === 2) {
        let s9 = p17(t6, e5[0], n23), f11 = /* @__PURE__ */ Object.create(null);
        for (let o9 of s9) {
          let h16 = p17(o9, e5[1], n23);
          if (h16.length > 0) {
            let y18 = String(h16[0]);
            o6(y18) && u5(f11, y18, o9);
          }
        }
        return [f11];
      }
      let u10 = p17(t6, e5[0], n23), c14 = /* @__PURE__ */ Object.create(null);
      for (let s9 of u10) {
        let f11 = p17(s9, e5[1], n23), o9 = p17(s9, e5[2], n23);
        if (f11.length > 0 && o9.length > 0) {
          let h16 = String(f11[0]);
          o6(h16) && u5(c14, h16, o9[0]);
        }
      }
      return [c14];
    }
    case "JOIN": {
      if (e5.length < 2) return [null];
      let u10 = p17(t6, e5[0], n23)[0];
      if (!u10 || typeof u10 != "object" || Array.isArray(u10)) return [null];
      let c14 = u10;
      if (!Array.isArray(t6)) return [null];
      let s9 = [];
      for (let f11 of t6) {
        let o9 = p17(f11, e5[1], n23), h16 = o9.length > 0 ? String(o9[0]) : "", y18 = c9(c14, h16) ? c14[h16] : null;
        s9.push([f11, y18]);
      }
      return [s9];
    }
    default:
      return null;
  }
}
function ot3(t6, r8, e5, n23, p17) {
  switch (r8) {
    case "join": {
      if (!Array.isArray(t6)) return [null];
      let i10 = e5.length > 0 ? p17(t6, e5[0], n23) : [""];
      for (let u10 of t6) if (Array.isArray(u10) || u10 !== null && typeof u10 == "object") throw new Error("cannot join: contains arrays or objects");
      return i10.map((u10) => t6.map((c14) => c14 === null ? "" : typeof c14 == "string" ? c14 : String(c14)).join(String(u10)));
    }
    case "split": {
      if (typeof t6 != "string" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      return [t6.split(u10)];
    }
    case "splits": {
      if (typeof t6 != "string" || e5.length === 0) return [];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      try {
        let c14 = e5.length > 1 ? String(p17(t6, e5[1], n23)[0]) : "g";
        return b1(u10, c14.includes("g") ? c14 : `${c14}g`).split(t6);
      } catch {
        return [];
      }
    }
    case "scan": {
      if (typeof t6 != "string" || e5.length === 0) return [];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      try {
        let c14 = e5.length > 1 ? String(p17(t6, e5[1], n23)[0]) : "";
        return [...b1(u10, c14.includes("g") ? c14 : `${c14}g`).matchAll(t6)].map((o9) => o9.length > 1 ? o9.slice(1) : o9[0]);
      } catch {
        return [];
      }
    }
    case "test": {
      if (typeof t6 != "string" || e5.length === 0) return [false];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      try {
        let c14 = e5.length > 1 ? String(p17(t6, e5[1], n23)[0]) : "";
        return [b1(u10, c14).test(t6)];
      } catch {
        return [false];
      }
    }
    case "match": {
      if (typeof t6 != "string" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      try {
        let c14 = e5.length > 1 ? String(p17(t6, e5[1], n23)[0]) : "", f11 = b1(u10, `${c14}d`).exec(t6);
        if (!f11) return [];
        let o9 = f11.indices;
        return [{ offset: f11.index, length: f11[0].length, string: f11[0], captures: f11.slice(1).map((h16, y18) => ({ offset: o9?.[y18 + 1]?.[0] ?? null, length: h16?.length ?? 0, string: h16 ?? "", name: null })) }];
      } catch {
        return [null];
      }
    }
    case "capture": {
      if (typeof t6 != "string" || e5.length === 0) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      try {
        let c14 = e5.length > 1 ? String(p17(t6, e5[1], n23)[0]) : "", f11 = b1(u10, c14).match(t6);
        return !f11 || !f11.groups ? [{}] : [f11.groups];
      } catch {
        return [null];
      }
    }
    case "sub": {
      if (typeof t6 != "string" || e5.length < 2) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = p17(t6, e5[1], n23), c14 = String(i10[0]), s9 = String(u10[0]);
      try {
        let f11 = e5.length > 2 ? String(p17(t6, e5[2], n23)[0]) : "";
        return [b1(c14, f11).replace(t6, s9)];
      } catch {
        return [t6];
      }
    }
    case "gsub": {
      if (typeof t6 != "string" || e5.length < 2) return [null];
      let i10 = p17(t6, e5[0], n23), u10 = p17(t6, e5[1], n23), c14 = String(i10[0]), s9 = String(u10[0]);
      try {
        let f11 = e5.length > 2 ? String(p17(t6, e5[2], n23)[0]) : "g", o9 = f11.includes("g") ? f11 : `${f11}g`;
        return [b1(c14, o9).replace(t6, s9)];
      } catch {
        return [t6];
      }
    }
    case "ascii_downcase":
      return typeof t6 == "string" ? [t6.replace(/[A-Z]/g, (i10) => String.fromCharCode(i10.charCodeAt(0) + 32))] : [null];
    case "ascii_upcase":
      return typeof t6 == "string" ? [t6.replace(/[a-z]/g, (i10) => String.fromCharCode(i10.charCodeAt(0) - 32))] : [null];
    case "ltrimstr": {
      if (typeof t6 != "string" || e5.length === 0) return [t6];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      return [t6.startsWith(u10) ? t6.slice(u10.length) : t6];
    }
    case "rtrimstr": {
      if (typeof t6 != "string" || e5.length === 0) return [t6];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      return u10 === "" ? [t6] : [t6.endsWith(u10) ? t6.slice(0, -u10.length) : t6];
    }
    case "trimstr": {
      if (typeof t6 != "string" || e5.length === 0) return [t6];
      let i10 = p17(t6, e5[0], n23), u10 = String(i10[0]);
      if (u10 === "") return [t6];
      let c14 = t6;
      return c14.startsWith(u10) && (c14 = c14.slice(u10.length)), c14.endsWith(u10) && (c14 = c14.slice(0, -u10.length)), [c14];
    }
    case "trim":
      if (typeof t6 == "string") return [t6.trim()];
      throw new Error("trim input must be a string");
    case "ltrim":
      if (typeof t6 == "string") return [t6.trimStart()];
      throw new Error("trim input must be a string");
    case "rtrim":
      if (typeof t6 == "string") return [t6.trimEnd()];
      throw new Error("trim input must be a string");
    case "startswith": {
      if (typeof t6 != "string" || e5.length === 0) return [false];
      let i10 = p17(t6, e5[0], n23);
      return [t6.startsWith(String(i10[0]))];
    }
    case "endswith": {
      if (typeof t6 != "string" || e5.length === 0) return [false];
      let i10 = p17(t6, e5[0], n23);
      return [t6.endsWith(String(i10[0]))];
    }
    case "ascii":
      return typeof t6 == "string" && t6.length > 0 ? [t6.charCodeAt(0)] : [null];
    case "explode":
      return typeof t6 == "string" ? [Array.from(t6).map((i10) => i10.codePointAt(0))] : [null];
    case "implode":
      if (!Array.isArray(t6)) throw new Error("implode input must be an array");
      return [t6.map((c14) => {
        if (typeof c14 == "string") throw new Error(`string (${JSON.stringify(c14)}) can't be imploded, unicode codepoint needs to be numeric`);
        if (typeof c14 != "number" || Number.isNaN(c14)) throw new Error("number (null) can't be imploded, unicode codepoint needs to be numeric");
        let s9 = Math.trunc(c14);
        return s9 < 0 || s9 > 1114111 || s9 >= 55296 && s9 <= 57343 ? String.fromCodePoint(65533) : String.fromCodePoint(s9);
      }).join("")];
    default:
      return null;
  }
}
function ft2(t6, r8) {
  switch (r8) {
    case "type":
      return t6 === null ? ["null"] : Array.isArray(t6) ? ["array"] : typeof t6 == "boolean" ? ["boolean"] : typeof t6 == "number" ? ["number"] : typeof t6 == "string" ? ["string"] : typeof t6 == "object" ? ["object"] : ["null"];
    case "infinite":
      return [Number.POSITIVE_INFINITY];
    case "nan":
      return [Number.NaN];
    case "isinfinite":
      return [typeof t6 == "number" && !Number.isFinite(t6)];
    case "isnan":
      return [typeof t6 == "number" && Number.isNaN(t6)];
    case "isnormal":
      return [typeof t6 == "number" && Number.isFinite(t6) && t6 !== 0];
    case "isfinite":
      return [typeof t6 == "number" && Number.isFinite(t6)];
    case "numbers":
      return typeof t6 == "number" ? [t6] : [];
    case "strings":
      return typeof t6 == "string" ? [t6] : [];
    case "booleans":
      return typeof t6 == "boolean" ? [t6] : [];
    case "nulls":
      return t6 === null ? [t6] : [];
    case "arrays":
      return Array.isArray(t6) ? [t6] : [];
    case "objects":
      return t6 && typeof t6 == "object" && !Array.isArray(t6) ? [t6] : [];
    case "iterables":
      return Array.isArray(t6) || t6 && typeof t6 == "object" && !Array.isArray(t6) ? [t6] : [];
    case "scalars":
      return !Array.isArray(t6) && !(t6 && typeof t6 == "object") ? [t6] : [];
    case "values":
      return t6 === null ? [] : [t6];
    case "not":
      return t6 === false || t6 === null ? [true] : [false];
    case "null":
      return [null];
    case "true":
      return [true];
    case "false":
      return [false];
    case "empty":
      return [];
    default:
      return null;
  }
}
function $11(t6, r8, e5) {
  if (r8.length === 0) return e5;
  let [n23, ...p17] = r8;
  if (typeof n23 == "number") {
    if (t6 && typeof t6 == "object" && !Array.isArray(t6)) throw new Error("Cannot index object with number");
    if (n23 > 536870911) throw new Error("Array index too large");
    if (n23 < 0) throw new Error("Out of bounds negative array index");
    let s9 = Array.isArray(t6) ? [...t6] : [];
    for (; s9.length <= n23; ) s9.push(null);
    return s9[n23] = $11(s9[n23], p17, e5), s9;
  }
  if (Array.isArray(t6)) throw new Error("Cannot index array with string");
  if (!o6(n23)) return t6 ?? /* @__PURE__ */ Object.create(null);
  let i10 = t6 && typeof t6 == "object" && !Array.isArray(t6) ? s4(t6) : /* @__PURE__ */ Object.create(null), u10 = Object.hasOwn(i10, n23) ? i10[n23] : void 0;
  return u5(i10, n23, $11(u10, p17, e5)), i10;
}
function F11(t6, r8) {
  if (r8.length === 0) return null;
  if (r8.length === 1) {
    let p17 = r8[0];
    if (Array.isArray(t6) && typeof p17 == "number") {
      let i10 = [...t6];
      return i10.splice(p17, 1), i10;
    }
    if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
      let i10 = String(p17);
      if (!o6(i10)) return t6;
      let u10 = s4(t6);
      return delete u10[i10], u10;
    }
    return t6;
  }
  let [e5, ...n23] = r8;
  if (Array.isArray(t6) && typeof e5 == "number") {
    let p17 = [...t6];
    return p17[e5] = F11(p17[e5], n23), p17;
  }
  if (t6 && typeof t6 == "object" && !Array.isArray(t6)) {
    let p17 = String(e5);
    if (!o6(p17)) return t6;
    let i10 = s4(t6);
    return Object.hasOwn(i10, p17) && u5(i10, p17, F11(i10[p17], n23)), i10;
  }
  return t6;
}
function Ot3(t6) {
  return { vars: /* @__PURE__ */ new Map(), limits: { maxIterations: t6?.limits?.maxIterations ?? kt2, maxDepth: t6?.limits?.maxDepth ?? lt2 }, env: t6?.env, coverage: t6?.coverage };
}
function J8(t6, r8, e5) {
  let n23 = new Map(t6.vars);
  return n23.set(r8, e5), { vars: n23, limits: t6.limits, env: t6.env, root: t6.root, currentPath: t6.currentPath, funcs: t6.funcs, labels: t6.labels, coverage: t6.coverage };
}
function B6(t6, r8, e5) {
  switch (r8.type) {
    case "var":
      return J8(t6, r8.name, e5);
    case "array": {
      if (!Array.isArray(e5)) return null;
      let n23 = t6;
      for (let p17 = 0; p17 < r8.elements.length; p17++) {
        let i10 = r8.elements[p17], u10 = p17 < e5.length ? e5[p17] : null, c14 = B6(n23, i10, u10);
        if (c14 === null) return null;
        n23 = c14;
      }
      return n23;
    }
    case "object": {
      if (e5 === null || typeof e5 != "object" || Array.isArray(e5)) return null;
      let n23 = e5, p17 = t6;
      for (let i10 of r8.fields) {
        let u10;
        if (typeof i10.key == "string") u10 = i10.key;
        else {
          let f11 = d11(e5, i10.key, t6);
          if (f11.length === 0) return null;
          u10 = String(f11[0]);
        }
        let c14 = c9(n23, u10) ? n23[u10] : null;
        i10.keyVar && (p17 = J8(p17, i10.keyVar, c14));
        let s9 = B6(p17, i10.pattern, c14);
        if (s9 === null) return null;
        p17 = s9;
      }
      return p17;
    }
  }
}
function St2(t6, r8) {
  let e5 = t6;
  for (let n23 of r8) if (e5 && typeof e5 == "object") if (Array.isArray(e5)) if (typeof n23 == "number") e5 = e5[n23];
  else return;
  else {
    let p17 = e5;
    if (typeof n23 == "string" && Object.hasOwn(p17, n23)) e5 = p17[n23];
    else return;
  }
  else return;
  return e5;
}
function T5(t6) {
  if (t6.type === "Identity") return [];
  if (t6.type === "Field") {
    let r8 = t6.base ? T5(t6.base) : [];
    return r8 === null ? null : [...r8, t6.name];
  }
  if (t6.type === "Index" && t6.index.type === "Literal") {
    let r8 = t6.base ? T5(t6.base) : [];
    if (r8 === null) return null;
    let e5 = t6.index.value;
    return typeof e5 == "number" || typeof e5 == "string" ? [...r8, e5] : null;
  }
  if (t6.type === "Pipe") {
    let r8 = T5(t6.left);
    return r8 === null ? null : ct2(r8, t6.right);
  }
  if (t6.type === "Call") {
    if (t6.name === "parent" || t6.name === "root") return null;
    if (t6.name === "first" && t6.args.length === 0) return [0];
    if (t6.name === "last" && t6.args.length === 0) return [-1];
  }
  return null;
}
function ct2(t6, r8) {
  if (r8.type === "Call") {
    if (r8.name === "parent") {
      let e5 = 1;
      if (r8.args.length > 0 && r8.args[0].type === "Literal") {
        let n23 = r8.args[0].value;
        typeof n23 == "number" && (e5 = n23);
      }
      if (e5 >= 0) return t6.slice(0, Math.max(0, t6.length - e5));
      {
        let n23 = -e5 - 1;
        return t6.slice(0, Math.min(n23, t6.length));
      }
    }
    if (r8.name === "root") return [];
  }
  if (r8.type === "Field") {
    let e5 = T5(r8);
    if (e5 !== null) return [...t6, ...e5];
  }
  if (r8.type === "Index" && r8.index.type === "Literal") {
    let e5 = T5(r8);
    if (e5 !== null) return [...t6, ...e5];
  }
  if (r8.type === "Pipe") {
    let e5 = ct2(t6, r8.left);
    return e5 === null ? null : ct2(e5, r8.right);
  }
  return r8.type === "Identity" ? t6 : null;
}
function yt2(t6, r8, e5) {
  if (r8.type === "Comma") {
    let n23 = [];
    try {
      n23.push(...d11(t6, r8.left, e5));
    } catch (p17) {
      if (p17 instanceof b2) throw p17;
      if (n23.length > 0) return n23;
      throw new Error("evaluation failed");
    }
    try {
      n23.push(...d11(t6, r8.right, e5));
    } catch (p17) {
      if (p17 instanceof b2) throw p17;
      return n23;
    }
    return n23;
  }
  return d11(t6, r8, e5);
}
function d11(t6, r8, e5) {
  let n23 = e5 && "vars" in e5 ? e5 : Ot3(e5);
  switch (n23.root === void 0 && (n23 = { ...n23, root: t6, currentPath: [] }), n23.coverage?.hit(`jq:node:${r8.type}`), r8.type) {
    case "Identity":
      return [t6];
    case "Field":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => {
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let c14 = i10;
          if (!Object.hasOwn(c14, r8.name)) return [null];
          let s9 = c14[r8.name];
          return [s9 === void 0 ? null : s9];
        }
        if (i10 === null) return [null];
        let u10 = Array.isArray(i10) ? "array" : typeof i10;
        throw new Error(`Cannot index ${u10} with string "${r8.name}"`);
      });
    case "Index":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => d11(i10, r8.index, n23).flatMap((c14) => {
        if (typeof c14 == "number" && Array.isArray(i10)) {
          if (Number.isNaN(c14)) return [null];
          let s9 = Math.trunc(c14), f11 = s9 < 0 ? i10.length + s9 : s9;
          return f11 >= 0 && f11 < i10.length ? [i10[f11]] : [null];
        }
        if (typeof c14 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let s9 = i10;
          return Object.hasOwn(s9, c14) ? [s9[c14]] : [null];
        }
        return [null];
      }));
    case "Slice":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => {
        if (i10 === null) return [null];
        if (!Array.isArray(i10) && typeof i10 != "string") throw new Error(`Cannot slice ${typeof i10} (${JSON.stringify(i10)})`);
        let u10 = i10.length, c14 = r8.start ? d11(t6, r8.start, n23) : [0], s9 = r8.end ? d11(t6, r8.end, n23) : [u10];
        return c14.flatMap((f11) => s9.map((o9) => {
          let h16 = f11, y18 = o9, a7 = Number.isNaN(h16) ? 0 : Number.isInteger(h16) ? h16 : Math.floor(h16), l8 = Number.isNaN(y18) ? u10 : Number.isInteger(y18) ? y18 : Math.ceil(y18), m24 = at3(a7, u10), A13 = at3(l8, u10);
          return Array.isArray(i10), i10.slice(m24, A13);
        }));
      });
    case "Iterate":
      return (r8.base ? d11(t6, r8.base, n23) : [t6]).flatMap((i10) => Array.isArray(i10) ? i10 : i10 && typeof i10 == "object" ? Object.values(i10) : []);
    case "Pipe": {
      let p17 = d11(t6, r8.left, n23), i10 = T5(r8.left), u10 = [];
      for (let c14 of p17) try {
        if (i10 !== null) {
          let s9 = { ...n23, currentPath: [...n23.currentPath ?? [], ...i10] };
          u10.push(...d11(c14, r8.right, s9));
        } else u10.push(...d11(c14, r8.right, n23));
      } catch (s9) {
        throw s9 instanceof I13 ? s9.withPrependedResults(u10) : s9;
      }
      return u10;
    }
    case "Comma": {
      let p17 = d11(t6, r8.left, n23), i10 = d11(t6, r8.right, n23);
      return [...p17, ...i10];
    }
    case "Literal":
      return [r8.value];
    case "Array":
      return r8.elements ? [d11(t6, r8.elements, n23)] : [[]];
    case "Object": {
      let p17 = [/* @__PURE__ */ Object.create(null)];
      for (let i10 of r8.entries) {
        let u10 = typeof i10.key == "string" ? [i10.key] : d11(t6, i10.key, n23), c14 = d11(t6, i10.value, n23), s9 = [];
        for (let f11 of p17) for (let o9 of u10) {
          if (typeof o9 != "string") {
            let h16 = o9 === null ? "null" : Array.isArray(o9) ? "array" : typeof o9;
            throw new Error(`Cannot use ${h16} (${JSON.stringify(o9)}) as object key`);
          }
          if (!o6(o9)) {
            for (let h16 of c14) s9.push(s4(f11));
            continue;
          }
          for (let h16 of c14) {
            let y18 = s4(f11);
            u5(y18, o9, h16), s9.push(y18);
          }
        }
        p17.length = 0, p17.push(...s9);
      }
      return p17;
    }
    case "Paren":
      return d11(t6, r8.expr, n23);
    case "BinaryOp":
      return jt2(t6, r8.op, r8.left, r8.right, n23);
    case "UnaryOp":
      return d11(t6, r8.operand, n23).map((i10) => {
        if (r8.op === "-") {
          if (typeof i10 == "number") return -i10;
          if (typeof i10 == "string") {
            let u10 = (c14) => c14.length > 5 ? `"${c14.slice(0, 3)}...` : JSON.stringify(c14);
            throw new Error(`string (${u10(i10)}) cannot be negated`);
          }
          return null;
        }
        return r8.op === "not" ? !N11(i10) : null;
      });
    case "Cond":
      return d11(t6, r8.cond, n23).flatMap((i10) => {
        if (N11(i10)) return d11(t6, r8.then, n23);
        for (let u10 of r8.elifs) if (d11(t6, u10.cond, n23).some(N11)) return d11(t6, u10.then, n23);
        return r8.else ? d11(t6, r8.else, n23) : [t6];
      });
    case "Try":
      try {
        return d11(t6, r8.body, n23);
      } catch (p17) {
        if (r8.catch) {
          let i10 = p17 instanceof V8 ? p17.value : p17 instanceof Error ? p17.message : String(p17);
          return d11(i10, r8.catch, n23);
        }
        return [];
      }
    case "Call":
      return mt2(t6, r8.name, r8.args, n23);
    case "VarBind":
      return d11(t6, r8.value, n23).flatMap((i10) => {
        let u10 = null, c14 = [];
        r8.pattern ? c14.push(r8.pattern) : r8.name && c14.push({ type: "var", name: r8.name }), r8.alternatives && c14.push(...r8.alternatives);
        for (let s9 of c14) if (u10 = B6(n23, s9, i10), u10 !== null) break;
        return u10 === null ? [] : d11(t6, r8.body, u10);
      });
    case "VarRef": {
      if (r8.name === "$ENV") return [n23.env ? r(n23.env) : /* @__PURE__ */ Object.create(null)];
      let p17 = n23.vars.get(r8.name);
      return p17 !== void 0 ? [p17] : [null];
    }
    case "Recurse": {
      let p17 = [], i10 = /* @__PURE__ */ new WeakSet(), u10 = (c14) => {
        if (c14 && typeof c14 == "object") {
          if (i10.has(c14)) return;
          i10.add(c14);
        }
        if (p17.push(c14), Array.isArray(c14)) for (let s9 of c14) u10(s9);
        else if (c14 && typeof c14 == "object") for (let s9 of Object.keys(c14)) u10(c14[s9]);
      };
      return u10(t6), p17;
    }
    case "Optional":
      try {
        return d11(t6, r8.expr, n23);
      } catch {
        return [];
      }
    case "StringInterp":
      return [r8.parts.map((i10) => typeof i10 == "string" ? i10 : d11(t6, i10, n23).map((c14) => typeof c14 == "string" ? c14 : JSON.stringify(c14)).join("")).join("")];
    case "UpdateOp":
      return [Tt3(t6, r8.path, r8.op, r8.value, n23)];
    case "Reduce": {
      let p17 = d11(t6, r8.expr, n23), i10 = d11(t6, r8.init, n23)[0], u10 = n23.limits.maxDepth ?? lt2;
      for (let c14 of p17) {
        let s9;
        if (r8.pattern) {
          if (s9 = B6(n23, r8.pattern, c14), s9 === null) continue;
        } else s9 = J8(n23, r8.varName, c14);
        if (i10 = d11(i10, r8.update, s9)[0], M7(i10, u10 + 1) > u10) return [null];
      }
      return [i10];
    }
    case "Foreach": {
      let p17 = d11(t6, r8.expr, n23), i10 = d11(t6, r8.init, n23)[0], u10 = [];
      for (let c14 of p17) try {
        let s9;
        if (r8.pattern) {
          if (s9 = B6(n23, r8.pattern, c14), s9 === null) continue;
        } else s9 = J8(n23, r8.varName, c14);
        if (i10 = d11(i10, r8.update, s9)[0], r8.extract) {
          let f11 = d11(i10, r8.extract, s9);
          u10.push(...f11);
        } else u10.push(i10);
      } catch (s9) {
        throw s9 instanceof I13 ? s9.withPrependedResults(u10) : s9;
      }
      return u10;
    }
    case "Label":
      try {
        return d11(t6, r8.body, { ...n23, labels: /* @__PURE__ */ new Set([...n23.labels ?? [], r8.name]) });
      } catch (p17) {
        if (p17 instanceof I13 && p17.label === r8.name) return p17.partialResults;
        throw p17;
      }
    case "Break":
      throw new I13(r8.name);
    case "Def": {
      let p17 = new Map(n23.funcs ?? []), i10 = `${r8.name}/${r8.params.length}`;
      p17.set(i10, { params: r8.params, body: r8.funcBody, closure: new Map(n23.funcs ?? []) });
      let u10 = { ...n23, funcs: p17 };
      return d11(t6, r8.body, u10);
    }
    default: {
      let p17 = r8;
      throw new Error(`Unknown AST node type: ${p17.type}`);
    }
  }
}
function at3(t6, r8) {
  return t6 < 0 ? Math.max(0, r8 + t6) : Math.min(t6, r8);
}
function Tt3(t6, r8, e5, n23, p17) {
  function i10(s9, f11) {
    switch (e5) {
      case "=":
        return f11;
      case "|=":
        return d11(s9, n23, p17)[0] ?? null;
      case "+=":
        return typeof s9 == "number" && typeof f11 == "number" || typeof s9 == "string" && typeof f11 == "string" ? s9 + f11 : Array.isArray(s9) && Array.isArray(f11) ? [...s9, ...f11] : s9 && f11 && typeof s9 == "object" && typeof f11 == "object" ? i4(s9, f11) : f11;
      case "-=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 - f11 : s9;
      case "*=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 * f11 : s9;
      case "/=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 / f11 : s9;
      case "%=":
        return typeof s9 == "number" && typeof f11 == "number" ? s9 % f11 : s9;
      case "//=":
        return s9 === null || s9 === false ? f11 : s9;
      default:
        return f11;
    }
  }
  function u10(s9, f11, o9) {
    switch (f11.type) {
      case "Identity":
        return o9(s9);
      case "Field": {
        if (!o6(f11.name)) return s9;
        if (f11.base) return u10(s9, f11.base, (h16) => {
          if (h16 && typeof h16 == "object" && !Array.isArray(h16)) {
            let y18 = s4(h16), a7 = Object.hasOwn(y18, f11.name) ? y18[f11.name] : void 0;
            return u5(y18, f11.name, o9(a7)), y18;
          }
          return h16;
        });
        if (s9 && typeof s9 == "object" && !Array.isArray(s9)) {
          let h16 = s4(s9), y18 = Object.hasOwn(h16, f11.name) ? h16[f11.name] : void 0;
          return u5(h16, f11.name, o9(y18)), h16;
        }
        return s9;
      }
      case "Index": {
        let y18 = d11(t6, f11.index, p17)[0];
        if (typeof y18 == "number" && Number.isNaN(y18)) throw new Error("Cannot set array element at NaN index");
        if (typeof y18 == "number" && !Number.isInteger(y18) && (y18 = Math.trunc(y18)), f11.base) return u10(s9, f11.base, (a7) => {
          if (typeof y18 == "number" && Array.isArray(a7)) {
            let l8 = [...a7], m24 = y18 < 0 ? l8.length + y18 : y18;
            if (m24 >= 0) {
              for (; l8.length <= m24; ) l8.push(null);
              l8[m24] = o9(l8[m24]);
            }
            return l8;
          }
          if (typeof y18 == "string" && a7 && typeof a7 == "object" && !Array.isArray(a7)) {
            if (!o6(y18)) return a7;
            let l8 = s4(a7), m24 = Object.hasOwn(l8, y18) ? l8[y18] : void 0;
            return u5(l8, y18, o9(m24)), l8;
          }
          return a7;
        });
        if (typeof y18 == "number") {
          if (y18 > 536870911) throw new Error("Array index too large");
          if (y18 < 0 && (!s9 || !Array.isArray(s9))) throw new Error("Out of bounds negative array index");
          if (Array.isArray(s9)) {
            let l8 = [...s9], m24 = y18 < 0 ? l8.length + y18 : y18;
            if (m24 >= 0) {
              for (; l8.length <= m24; ) l8.push(null);
              l8[m24] = o9(l8[m24]);
            }
            return l8;
          }
          if (s9 == null) {
            let l8 = [];
            for (; l8.length <= y18; ) l8.push(null);
            return l8[y18] = o9(null), l8;
          }
          return s9;
        }
        if (typeof y18 == "string" && s9 && typeof s9 == "object" && !Array.isArray(s9)) {
          if (!o6(y18)) return s9;
          let a7 = s4(s9), l8 = Object.hasOwn(a7, y18) ? a7[y18] : void 0;
          return u5(a7, y18, o9(l8)), a7;
        }
        return s9;
      }
      case "Iterate": {
        let h16 = (y18) => {
          if (Array.isArray(y18)) return y18.map((a7) => o9(a7));
          if (y18 && typeof y18 == "object") {
            let a7 = /* @__PURE__ */ Object.create(null);
            for (let [l8, m24] of Object.entries(y18)) o6(l8) && u5(a7, l8, o9(m24));
            return a7;
          }
          return y18;
        };
        return f11.base ? u10(s9, f11.base, h16) : h16(s9);
      }
      case "Pipe": {
        let h16 = u10(s9, f11.left, (y18) => y18);
        return u10(h16, f11.right, o9);
      }
      default:
        return o9(s9);
    }
  }
  return u10(t6, r8, (s9) => {
    if (e5 === "|=") return i10(s9, s9);
    let f11 = d11(t6, n23, p17);
    return i10(s9, f11[0] ?? null);
  });
}
function Ct3(t6, r8, e5) {
  function n23(i10, u10, c14) {
    switch (u10.type) {
      case "Identity":
        return c14;
      case "Field": {
        if (!o6(u10.name)) return i10;
        if (u10.base) {
          let s9 = d11(i10, u10.base, e5)[0], f11 = n23(s9, { type: "Field", name: u10.name }, c14);
          return n23(i10, u10.base, f11);
        }
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          let s9 = s4(i10);
          return u5(s9, u10.name, c14), s9;
        }
        return i10;
      }
      case "Index": {
        if (u10.base) {
          let o9 = d11(i10, u10.base, e5)[0], h16 = n23(o9, { type: "Index", index: u10.index }, c14);
          return n23(i10, u10.base, h16);
        }
        let f11 = d11(t6, u10.index, e5)[0];
        if (typeof f11 == "number" && Array.isArray(i10)) {
          let o9 = [...i10], h16 = f11 < 0 ? o9.length + f11 : f11;
          return h16 >= 0 && h16 < o9.length && (o9[h16] = c14), o9;
        }
        if (typeof f11 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(f11)) return i10;
          let o9 = s4(i10);
          return u5(o9, f11, c14), o9;
        }
        return i10;
      }
      default:
        return i10;
    }
  }
  function p17(i10, u10) {
    switch (u10.type) {
      case "Identity":
        return null;
      case "Field": {
        if (!o6(u10.name)) return i10;
        if (u10.base) {
          let s9 = d11(i10, u10.base, e5)[0];
          if (s9 == null) return i10;
          let f11 = p17(s9, { type: "Field", name: u10.name });
          return n23(i10, u10.base, f11);
        }
        if (i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(u10.name)) return i10;
          let s9 = s4(i10);
          return delete s9[u10.name], s9;
        }
        return i10;
      }
      case "Index": {
        if (u10.base) {
          let o9 = d11(i10, u10.base, e5)[0];
          if (o9 == null) return i10;
          let h16 = p17(o9, { type: "Index", index: u10.index });
          return n23(i10, u10.base, h16);
        }
        let f11 = d11(t6, u10.index, e5)[0];
        if (typeof f11 == "number" && Array.isArray(i10)) {
          let o9 = [...i10], h16 = f11 < 0 ? o9.length + f11 : f11;
          return h16 >= 0 && h16 < o9.length && o9.splice(h16, 1), o9;
        }
        if (typeof f11 == "string" && i10 && typeof i10 == "object" && !Array.isArray(i10)) {
          if (!o6(f11)) return i10;
          let o9 = s4(i10);
          return delete o9[f11], o9;
        }
        return i10;
      }
      case "Iterate":
        return Array.isArray(i10) ? [] : i10 && typeof i10 == "object" ? /* @__PURE__ */ Object.create(null) : i10;
      case "Pipe": {
        let o9 = function(a7, l8, m24) {
          switch (l8.type) {
            case "Identity":
              return m24;
            case "Field": {
              if (!o6(l8.name)) return a7;
              if (a7 && typeof a7 == "object" && !Array.isArray(a7)) {
                let A13 = s4(a7);
                return u5(A13, l8.name, m24), A13;
              }
              return a7;
            }
            case "Index": {
              let E12 = d11(t6, l8.index, e5)[0];
              if (typeof E12 == "number" && Array.isArray(a7)) {
                let w19 = [...a7], x22 = E12 < 0 ? w19.length + E12 : E12;
                return x22 >= 0 && x22 < w19.length && (w19[x22] = m24), w19;
              }
              if (typeof E12 == "string" && a7 && typeof a7 == "object" && !Array.isArray(a7)) {
                if (!o6(E12)) return a7;
                let w19 = s4(a7);
                return u5(w19, E12, m24), w19;
              }
              return a7;
            }
            case "Pipe": {
              let A13 = d11(a7, l8.left, e5)[0], E12 = o9(A13, l8.right, m24);
              return o9(a7, l8.left, E12);
            }
            default:
              return a7;
          }
        };
        var c14 = o9;
        let s9 = u10.left, f11 = u10.right, h16 = d11(i10, s9, e5)[0];
        if (h16 == null) return i10;
        let y18 = p17(h16, f11);
        return o9(i10, s9, y18);
      }
      default:
        return i10;
    }
  }
  return p17(t6, r8);
}
function jt2(t6, r8, e5, n23, p17) {
  if (r8 === "and") return d11(t6, e5, p17).flatMap((s9) => N11(s9) ? d11(t6, n23, p17).map((o9) => N11(o9)) : [false]);
  if (r8 === "or") return d11(t6, e5, p17).flatMap((s9) => N11(s9) ? [true] : d11(t6, n23, p17).map((o9) => N11(o9)));
  if (r8 === "//") {
    let s9 = d11(t6, e5, p17).filter((f11) => f11 != null && f11 !== false);
    return s9.length > 0 ? s9 : d11(t6, n23, p17);
  }
  let i10 = d11(t6, e5, p17), u10 = d11(t6, n23, p17);
  return i10.flatMap((c14) => u10.map((s9) => {
    switch (r8) {
      case "+":
        return c14 === null ? s9 : s9 === null ? c14 : typeof c14 == "number" && typeof s9 == "number" || typeof c14 == "string" && typeof s9 == "string" ? c14 + s9 : Array.isArray(c14) && Array.isArray(s9) ? [...c14, ...s9] : c14 && s9 && typeof c14 == "object" && typeof s9 == "object" && !Array.isArray(c14) && !Array.isArray(s9) ? i4(c14, s9) : null;
      case "-":
        if (typeof c14 == "number" && typeof s9 == "number") return c14 - s9;
        if (Array.isArray(c14) && Array.isArray(s9)) {
          let f11 = new Set(s9.map((o9) => JSON.stringify(o9)));
          return c14.filter((o9) => !f11.has(JSON.stringify(o9)));
        }
        if (typeof c14 == "string" && typeof s9 == "string") {
          let f11 = (o9) => o9.length > 10 ? `"${o9.slice(0, 10)}...` : JSON.stringify(o9);
          throw new Error(`string (${f11(c14)}) and string (${f11(s9)}) cannot be subtracted`);
        }
        return null;
      case "*":
        return typeof c14 == "number" && typeof s9 == "number" ? c14 * s9 : typeof c14 == "string" && typeof s9 == "number" ? c14.repeat(s9) : c14 && s9 && typeof c14 == "object" && typeof s9 == "object" && !Array.isArray(c14) && !Array.isArray(s9) ? z6(c14, s9) : null;
      case "/":
        if (typeof c14 == "number" && typeof s9 == "number") {
          if (s9 === 0) throw new Error(`number (${c14}) and number (${s9}) cannot be divided because the divisor is zero`);
          return c14 / s9;
        }
        return typeof c14 == "string" && typeof s9 == "string" ? c14.split(s9) : null;
      case "%":
        if (typeof c14 == "number" && typeof s9 == "number") {
          if (s9 === 0) throw new Error(`number (${c14}) and number (${s9}) cannot be divided (remainder) because the divisor is zero`);
          return !Number.isFinite(c14) && !Number.isNaN(c14) ? !Number.isFinite(s9) && !Number.isNaN(s9) && c14 < 0 && s9 > 0 ? -1 : 0 : c14 % s9;
        }
        return null;
      case "==":
        return R4(c14, s9);
      case "!=":
        return !R4(c14, s9);
      case "<":
        return D9(c14, s9) < 0;
      case "<=":
        return D9(c14, s9) <= 0;
      case ">":
        return D9(c14, s9) > 0;
      case ">=":
        return D9(c14, s9) >= 0;
      default:
        return null;
    }
  }));
}
function mt2(t6, r8, e5, n23) {
  let p17 = Nt2.get(r8);
  if (p17) return typeof t6 == "number" ? [p17(t6)] : [null];
  let i10 = et3(t6, r8, e5, n23, d11);
  if (i10 !== null) return i10;
  let u10 = ot3(t6, r8, e5, n23, d11);
  if (u10 !== null) return u10;
  let c14 = Z7(t6, r8, e5, n23, d11);
  if (c14 !== null) return c14;
  let s9 = v14(t6, r8, n23.limits.maxDepth);
  if (s9 !== null) return s9;
  let f11 = ft2(t6, r8);
  if (f11 !== null) return f11;
  let o9 = nt3(t6, r8, e5, n23, d11);
  if (o9 !== null) return o9;
  let h16 = W8(t6, r8, e5, n23, d11, yt2, L10, N11, _6, b2);
  if (h16 !== null) return h16;
  let y18 = st3(t6, r8, e5, n23, d11, N11, $11, F11, Ct3, K8);
  if (y18 !== null) return y18;
  let a7 = tt3(t6, r8, e5, n23, d11, R4);
  if (a7 !== null) return a7;
  let l8 = Q8(t6, r8, e5, n23, d11, yt2, N11, b2);
  if (l8 !== null) return l8;
  let m24 = rt3(t6, r8, e5, n23, d11, N11, St2, mt2);
  if (m24 !== null) return m24;
  let A13 = it3(t6, r8, e5, n23, d11, R4);
  if (A13 !== null) return A13;
  switch (r8) {
    case "builtins":
      return [["add/0", "all/0", "all/1", "all/2", "any/0", "any/1", "any/2", "arrays/0", "ascii/0", "ascii_downcase/0", "ascii_upcase/0", "booleans/0", "bsearch/1", "builtins/0", "combinations/0", "combinations/1", "contains/1", "debug/0", "del/1", "delpaths/1", "empty/0", "env/0", "error/0", "error/1", "explode/0", "first/0", "first/1", "flatten/0", "flatten/1", "floor/0", "from_entries/0", "fromdate/0", "fromjson/0", "getpath/1", "gmtime/0", "group_by/1", "gsub/2", "gsub/3", "has/1", "implode/0", "IN/1", "IN/2", "INDEX/1", "INDEX/2", "index/1", "indices/1", "infinite/0", "inside/1", "isempty/1", "isnan/0", "isnormal/0", "isvalid/1", "iterables/0", "join/1", "keys/0", "keys_unsorted/0", "last/0", "last/1", "length/0", "limit/2", "ltrimstr/1", "map/1", "map_values/1", "match/1", "match/2", "max/0", "max_by/1", "min/0", "min_by/1", "mktime/0", "modulemeta/1", "nan/0", "not/0", "nth/1", "nth/2", "null/0", "nulls/0", "numbers/0", "objects/0", "path/1", "paths/0", "paths/1", "pick/1", "range/1", "range/2", "range/3", "recurse/0", "recurse/1", "recurse_down/0", "repeat/1", "reverse/0", "rindex/1", "rtrimstr/1", "scalars/0", "scan/1", "scan/2", "select/1", "setpath/2", "skip/2", "sort/0", "sort_by/1", "split/1", "splits/1", "splits/2", "sqrt/0", "startswith/1", "strftime/1", "strings/0", "strptime/1", "sub/2", "sub/3", "test/1", "test/2", "to_entries/0", "toboolean/0", "todate/0", "tojson/0", "tostream/0", "fromstream/1", "truncate_stream/1", "tonumber/0", "tostring/0", "transpose/0", "trim/0", "ltrim/0", "rtrim/0", "type/0", "unique/0", "unique_by/1", "until/2", "utf8bytelength/0", "values/0", "walk/1", "while/2", "with_entries/1"]];
    case "error": {
      let E12 = e5.length > 0 ? d11(t6, e5[0], n23)[0] : t6;
      throw new V8(E12);
    }
    case "env":
      return [n23.env ? r(n23.env) : /* @__PURE__ */ Object.create(null)];
    case "debug":
      return [t6];
    case "input_line_number":
      return [1];
    default: {
      let E12 = `${r8}/${e5.length}`, w19 = n23.funcs?.get(E12);
      if (w19) {
        let x22 = w19.closure ?? n23.funcs ?? /* @__PURE__ */ new Map(), Y10 = new Map(x22);
        Y10.set(E12, w19);
        for (let U13 = 0; U13 < w19.params.length; U13++) {
          let gt2 = w19.params[U13], ut5 = e5[U13];
          if (ut5) {
            let C19 = d11(t6, ut5, n23), j11;
            if (C19.length === 0) j11 = { type: "Call", name: "empty", args: [] };
            else if (C19.length === 1) j11 = { type: "Literal", value: C19[0] };
            else {
              j11 = { type: "Literal", value: C19[C19.length - 1] };
              for (let q15 = C19.length - 2; q15 >= 0; q15--) j11 = { type: "Comma", left: { type: "Literal", value: C19[q15] }, right: j11 };
            }
            Y10.set(`${gt2}/0`, { params: [], body: j11 });
          }
        }
        let bt3 = { ...n23, funcs: Y10 };
        return d11(t6, w19.body, bt3);
      }
      throw new Error(`Unknown function: ${r8}`);
    }
  }
}
function K8(t6, r8, e5, n23, p17) {
  if (r8.type === "Comma") {
    let c14 = r8;
    K8(t6, c14.left, e5, n23, p17), K8(t6, c14.right, e5, n23, p17);
    return;
  }
  let i10 = T5(r8);
  if (i10 !== null) {
    p17.push([...n23, ...i10]);
    return;
  }
  if (r8.type === "Iterate") {
    if (Array.isArray(t6)) for (let c14 = 0; c14 < t6.length; c14++) p17.push([...n23, c14]);
    else if (t6 && typeof t6 == "object") for (let c14 of Object.keys(t6)) p17.push([...n23, c14]);
    return;
  }
  if (r8.type === "Recurse") {
    let c14 = (s9, f11) => {
      if (p17.push([...n23, ...f11]), s9 && typeof s9 == "object") if (Array.isArray(s9)) for (let o9 = 0; o9 < s9.length; o9++) c14(s9[o9], [...f11, o9]);
      else for (let o9 of Object.keys(s9)) c14(s9[o9], [...f11, o9]);
    };
    c14(t6, []);
    return;
  }
  if (r8.type === "Pipe") {
    let c14 = T5(r8.left);
    if (c14 !== null) {
      let s9 = d11(t6, r8.left, e5);
      for (let f11 of s9) K8(f11, r8.right, e5, [...n23, ...c14], p17);
      return;
    }
  }
  d11(t6, r8, e5).length > 0 && p17.push(n23);
}
function At2(t6) {
  let r8 = [], e5 = 0, n23 = (f11 = 0) => t6[e5 + f11], p17 = () => t6[e5++], i10 = () => e5 >= t6.length, u10 = (f11) => f11 >= "0" && f11 <= "9", c14 = (f11) => f11 >= "a" && f11 <= "z" || f11 >= "A" && f11 <= "Z" || f11 === "_", s9 = (f11) => c14(f11) || u10(f11);
  for (; !i10(); ) {
    let f11 = e5, o9 = p17();
    if (!(o9 === " " || o9 === "	" || o9 === `
` || o9 === "\r")) {
      if (o9 === "#") {
        for (; !i10() && n23() !== `
`; ) p17();
        continue;
      }
      if (o9 === "." && n23() === ".") {
        p17(), r8.push({ type: "DOTDOT", pos: f11 });
        continue;
      }
      if (o9 === "=" && n23() === "=") {
        p17(), r8.push({ type: "EQ", pos: f11 });
        continue;
      }
      if (o9 === "!" && n23() === "=") {
        p17(), r8.push({ type: "NE", pos: f11 });
        continue;
      }
      if (o9 === "<" && n23() === "=") {
        p17(), r8.push({ type: "LE", pos: f11 });
        continue;
      }
      if (o9 === ">" && n23() === "=") {
        p17(), r8.push({ type: "GE", pos: f11 });
        continue;
      }
      if (o9 === "/" && n23() === "/") {
        p17(), n23() === "=" ? (p17(), r8.push({ type: "UPDATE_ALT", pos: f11 })) : r8.push({ type: "ALT", pos: f11 });
        continue;
      }
      if (o9 === "+" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_ADD", pos: f11 });
        continue;
      }
      if (o9 === "-" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_SUB", pos: f11 });
        continue;
      }
      if (o9 === "*" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_MUL", pos: f11 });
        continue;
      }
      if (o9 === "/" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_DIV", pos: f11 });
        continue;
      }
      if (o9 === "%" && n23() === "=") {
        p17(), r8.push({ type: "UPDATE_MOD", pos: f11 });
        continue;
      }
      if (o9 === "=" && n23() !== "=") {
        r8.push({ type: "ASSIGN", pos: f11 });
        continue;
      }
      if (o9 === ".") {
        r8.push({ type: "DOT", pos: f11 });
        continue;
      }
      if (o9 === "|") {
        n23() === "=" ? (p17(), r8.push({ type: "UPDATE_PIPE", pos: f11 })) : r8.push({ type: "PIPE", pos: f11 });
        continue;
      }
      if (o9 === ",") {
        r8.push({ type: "COMMA", pos: f11 });
        continue;
      }
      if (o9 === ":") {
        r8.push({ type: "COLON", pos: f11 });
        continue;
      }
      if (o9 === ";") {
        r8.push({ type: "SEMICOLON", pos: f11 });
        continue;
      }
      if (o9 === "(") {
        r8.push({ type: "LPAREN", pos: f11 });
        continue;
      }
      if (o9 === ")") {
        r8.push({ type: "RPAREN", pos: f11 });
        continue;
      }
      if (o9 === "[") {
        r8.push({ type: "LBRACKET", pos: f11 });
        continue;
      }
      if (o9 === "]") {
        r8.push({ type: "RBRACKET", pos: f11 });
        continue;
      }
      if (o9 === "{") {
        r8.push({ type: "LBRACE", pos: f11 });
        continue;
      }
      if (o9 === "}") {
        r8.push({ type: "RBRACE", pos: f11 });
        continue;
      }
      if (o9 === "?") {
        r8.push({ type: "QUESTION", pos: f11 });
        continue;
      }
      if (o9 === "+") {
        r8.push({ type: "PLUS", pos: f11 });
        continue;
      }
      if (o9 === "-") {
        r8.push({ type: "MINUS", pos: f11 });
        continue;
      }
      if (o9 === "*") {
        r8.push({ type: "STAR", pos: f11 });
        continue;
      }
      if (o9 === "/") {
        r8.push({ type: "SLASH", pos: f11 });
        continue;
      }
      if (o9 === "%") {
        r8.push({ type: "PERCENT", pos: f11 });
        continue;
      }
      if (o9 === "<") {
        r8.push({ type: "LT", pos: f11 });
        continue;
      }
      if (o9 === ">") {
        r8.push({ type: "GT", pos: f11 });
        continue;
      }
      if (u10(o9)) {
        let h16 = o9;
        for (; !i10() && (u10(n23()) || n23() === "." || n23() === "e" || n23() === "E"); ) (n23() === "e" || n23() === "E") && (t6[e5 + 1] === "+" || t6[e5 + 1] === "-") && (h16 += p17()), h16 += p17();
        r8.push({ type: "NUMBER", value: Number(h16), pos: f11 });
        continue;
      }
      if (o9 === '"') {
        let h16 = "";
        for (; !i10() && n23() !== '"'; ) if (n23() === "\\") {
          if (p17(), i10()) break;
          let y18 = p17();
          switch (y18) {
            case "n":
              h16 += `
`;
              break;
            case "r":
              h16 += "\r";
              break;
            case "t":
              h16 += "	";
              break;
            case "\\":
              h16 += "\\";
              break;
            case '"':
              h16 += '"';
              break;
            case "(":
              h16 += "\\(";
              break;
            default:
              h16 += y18;
          }
        } else h16 += p17();
        i10() || p17(), r8.push({ type: "STRING", value: h16, pos: f11 });
        continue;
      }
      if (c14(o9) || o9 === "$" || o9 === "@") {
        let h16 = o9;
        for (; !i10() && s9(n23()); ) h16 += p17();
        let y18 = dt2.get(h16);
        y18 ? r8.push({ type: y18, value: h16, pos: f11 }) : r8.push({ type: "IDENT", value: h16, pos: f11 });
        continue;
      }
      throw new Error(`Unexpected character '${o9}' at position ${f11}`);
    }
  }
  return r8.push({ type: "EOF", pos: e5 }), r8;
}
function ge4(t6) {
  let r8 = At2(t6);
  return new pt2(r8).parse();
}
var Et2, wt2, I13, V8, kt2, lt2, Nt2, dt2, H11, pt2;
var init_chunk_FRDGR5VK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-FRDGR5VK.js"() {
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    Et2 = 2e3;
    wt2 = 2e3;
    I13 = class t3 extends Error {
      label;
      partialResults;
      constructor(r8, e5 = []) {
        super(`break ${r8}`), this.label = r8, this.partialResults = e5, this.name = "BreakError";
      }
      withPrependedResults(r8) {
        return new t3(this.label, [...r8, ...this.partialResults]);
      }
    };
    V8 = class extends Error {
      value;
      constructor(r8) {
        super(typeof r8 == "string" ? r8 : JSON.stringify(r8)), this.value = r8, this.name = "JqError";
      }
    };
    kt2 = 1e4;
    lt2 = 2e3;
    Nt2 = /* @__PURE__ */ new Map([["floor", Math.floor], ["ceil", Math.ceil], ["round", Math.round], ["sqrt", Math.sqrt], ["log", Math.log], ["log10", Math.log10], ["log2", Math.log2], ["exp", Math.exp], ["sin", Math.sin], ["cos", Math.cos], ["tan", Math.tan], ["asin", Math.asin], ["acos", Math.acos], ["atan", Math.atan], ["sinh", Math.sinh], ["cosh", Math.cosh], ["tanh", Math.tanh], ["asinh", Math.asinh], ["acosh", Math.acosh], ["atanh", Math.atanh], ["cbrt", Math.cbrt], ["expm1", Math.expm1], ["log1p", Math.log1p], ["trunc", Math.trunc]]);
    dt2 = /* @__PURE__ */ new Map([["and", "AND"], ["or", "OR"], ["not", "NOT"], ["if", "IF"], ["then", "THEN"], ["elif", "ELIF"], ["else", "ELSE"], ["end", "END"], ["as", "AS"], ["try", "TRY"], ["catch", "CATCH"], ["true", "TRUE"], ["false", "FALSE"], ["null", "NULL"], ["reduce", "REDUCE"], ["foreach", "FOREACH"], ["label", "LABEL"], ["break", "BREAK"], ["def", "DEF"]]);
    H11 = new Set(dt2.values());
    pt2 = class t4 {
      tokens;
      pos = 0;
      constructor(r8) {
        this.tokens = r8;
      }
      peek(r8 = 0) {
        return this.tokens[this.pos + r8] ?? { type: "EOF", pos: -1 };
      }
      advance() {
        return this.tokens[this.pos++];
      }
      check(r8) {
        return this.peek().type === r8;
      }
      match(...r8) {
        for (let e5 of r8) if (this.check(e5)) return this.advance();
        return null;
      }
      expect(r8, e5) {
        if (!this.check(r8)) throw new Error(`${e5} at position ${this.peek().pos}, got ${this.peek().type}`);
        return this.advance();
      }
      isFieldNameAfterDot(r8 = 0) {
        let e5 = this.peek(r8), n23 = this.peek(r8 + 1);
        return n23.type === "STRING" ? true : n23.type === "IDENT" || H11.has(n23.type) ? n23.pos === e5.pos + 1 : false;
      }
      isIdentLike() {
        let r8 = this.peek().type;
        return r8 === "IDENT" || H11.has(r8);
      }
      consumeFieldNameAfterDot(r8) {
        let e5 = this.peek();
        return e5.type === "STRING" ? this.advance().value : (e5.type === "IDENT" || H11.has(e5.type)) && e5.pos === r8.pos + 1 ? this.advance().value : null;
      }
      parse() {
        let r8 = this.parseExpr();
        if (!this.check("EOF")) throw new Error(`Unexpected token ${this.peek().type} at position ${this.peek().pos}`);
        return r8;
      }
      parseExpr() {
        return this.parsePipe();
      }
      parsePattern() {
        if (this.match("LBRACKET")) {
          let n23 = [];
          if (!this.check("RBRACKET")) for (n23.push(this.parsePattern()); this.match("COMMA") && !this.check("RBRACKET"); ) n23.push(this.parsePattern());
          return this.expect("RBRACKET", "Expected ']' after array pattern"), { type: "array", elements: n23 };
        }
        if (this.match("LBRACE")) {
          let n23 = [];
          if (!this.check("RBRACE")) for (n23.push(this.parsePatternField()); this.match("COMMA") && !this.check("RBRACE"); ) n23.push(this.parsePatternField());
          return this.expect("RBRACE", "Expected '}' after object pattern"), { type: "object", fields: n23 };
        }
        let r8 = this.expect("IDENT", "Expected variable name in pattern"), e5 = r8.value;
        if (!e5.startsWith("$")) throw new Error(`Variable name must start with $ at position ${r8.pos}`);
        return { type: "var", name: e5 };
      }
      parsePatternField() {
        if (this.match("LPAREN")) {
          let e5 = this.parseExpr();
          this.expect("RPAREN", "Expected ')' after computed key"), this.expect("COLON", "Expected ':' after computed key");
          let n23 = this.parsePattern();
          return { key: e5, pattern: n23 };
        }
        let r8 = this.peek();
        if (r8.type === "IDENT" || H11.has(r8.type)) {
          let e5 = r8.value;
          if (e5.startsWith("$")) {
            if (this.advance(), this.match("COLON")) {
              let n23 = this.parsePattern();
              return { key: e5.slice(1), pattern: n23, keyVar: e5 };
            }
            return { key: e5.slice(1), pattern: { type: "var", name: e5 } };
          }
          if (this.advance(), this.match("COLON")) {
            let n23 = this.parsePattern();
            return { key: e5, pattern: n23 };
          }
          return { key: e5, pattern: { type: "var", name: `$${e5}` } };
        }
        throw new Error(`Expected field name in object pattern at position ${r8.pos}`);
      }
      parsePipe() {
        let r8 = this.parseComma();
        for (; this.match("PIPE"); ) {
          let e5 = this.parseComma();
          r8 = { type: "Pipe", left: r8, right: e5 };
        }
        return r8;
      }
      parseComma() {
        let r8 = this.parseVarBind();
        for (; this.match("COMMA"); ) {
          let e5 = this.parseVarBind();
          r8 = { type: "Comma", left: r8, right: e5 };
        }
        return r8;
      }
      parseVarBind() {
        let r8 = this.parseUpdate();
        if (this.match("AS")) {
          let e5 = this.parsePattern(), n23 = [];
          for (; this.check("QUESTION") && this.peekAhead(1)?.type === "ALT"; ) this.advance(), this.advance(), n23.push(this.parsePattern());
          this.expect("PIPE", "Expected '|' after variable binding");
          let p17 = this.parseExpr();
          return e5.type === "var" && n23.length === 0 ? { type: "VarBind", name: e5.name, value: r8, body: p17 } : { type: "VarBind", name: e5.type === "var" ? e5.name : "", value: r8, body: p17, pattern: e5.type !== "var" ? e5 : void 0, alternatives: n23.length > 0 ? n23 : void 0 };
        }
        return r8;
      }
      peekAhead(r8) {
        let e5 = this.pos + r8;
        return e5 < this.tokens.length ? this.tokens[e5] : void 0;
      }
      parseUpdate() {
        let r8 = this.parseAlt(), e5 = /* @__PURE__ */ new Map([["ASSIGN", "="], ["UPDATE_ADD", "+="], ["UPDATE_SUB", "-="], ["UPDATE_MUL", "*="], ["UPDATE_DIV", "/="], ["UPDATE_MOD", "%="], ["UPDATE_ALT", "//="], ["UPDATE_PIPE", "|="]]), n23 = this.match("ASSIGN", "UPDATE_ADD", "UPDATE_SUB", "UPDATE_MUL", "UPDATE_DIV", "UPDATE_MOD", "UPDATE_ALT", "UPDATE_PIPE");
        if (n23) {
          let p17 = this.parseVarBind(), i10 = e5.get(n23.type);
          if (i10) return { type: "UpdateOp", op: i10, path: r8, value: p17 };
        }
        return r8;
      }
      parseAlt() {
        let r8 = this.parseOr();
        for (; this.match("ALT"); ) {
          let e5 = this.parseOr();
          r8 = { type: "BinaryOp", op: "//", left: r8, right: e5 };
        }
        return r8;
      }
      parseOr() {
        let r8 = this.parseAnd();
        for (; this.match("OR"); ) {
          let e5 = this.parseAnd();
          r8 = { type: "BinaryOp", op: "or", left: r8, right: e5 };
        }
        return r8;
      }
      parseAnd() {
        let r8 = this.parseNot();
        for (; this.match("AND"); ) {
          let e5 = this.parseNot();
          r8 = { type: "BinaryOp", op: "and", left: r8, right: e5 };
        }
        return r8;
      }
      parseNot() {
        return this.parseComparison();
      }
      parseComparison() {
        let r8 = this.parseAddSub(), e5 = /* @__PURE__ */ new Map([["EQ", "=="], ["NE", "!="], ["LT", "<"], ["LE", "<="], ["GT", ">"], ["GE", ">="]]), n23 = this.match("EQ", "NE", "LT", "LE", "GT", "GE");
        if (n23) {
          let p17 = e5.get(n23.type);
          if (p17) {
            let i10 = this.parseAddSub();
            r8 = { type: "BinaryOp", op: p17, left: r8, right: i10 };
          }
        }
        return r8;
      }
      parseAddSub() {
        let r8 = this.parseMulDiv();
        for (; ; ) if (this.match("PLUS")) {
          let e5 = this.parseMulDiv();
          r8 = { type: "BinaryOp", op: "+", left: r8, right: e5 };
        } else if (this.match("MINUS")) {
          let e5 = this.parseMulDiv();
          r8 = { type: "BinaryOp", op: "-", left: r8, right: e5 };
        } else break;
        return r8;
      }
      parseMulDiv() {
        let r8 = this.parseUnary();
        for (; ; ) if (this.match("STAR")) {
          let e5 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "*", left: r8, right: e5 };
        } else if (this.match("SLASH")) {
          let e5 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "/", left: r8, right: e5 };
        } else if (this.match("PERCENT")) {
          let e5 = this.parseUnary();
          r8 = { type: "BinaryOp", op: "%", left: r8, right: e5 };
        } else break;
        return r8;
      }
      parseUnary() {
        return this.match("MINUS") ? { type: "UnaryOp", op: "-", operand: this.parseUnary() } : this.parsePostfix();
      }
      parsePostfix() {
        let r8 = this.parsePrimary();
        for (; ; ) if (this.match("QUESTION")) r8 = { type: "Optional", expr: r8 };
        else if (this.check("DOT") && this.isFieldNameAfterDot()) this.advance(), r8 = { type: "Field", name: this.advance().value, base: r8 };
        else if (this.check("LBRACKET")) if (this.advance(), this.match("RBRACKET")) r8 = { type: "Iterate", base: r8 };
        else if (this.check("COLON")) {
          this.advance();
          let e5 = this.check("RBRACKET") ? void 0 : this.parseExpr();
          this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Slice", end: e5, base: r8 };
        } else {
          let e5 = this.parseExpr();
          if (this.match("COLON")) {
            let n23 = this.check("RBRACKET") ? void 0 : this.parseExpr();
            this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Slice", start: e5, end: n23, base: r8 };
          } else this.expect("RBRACKET", "Expected ']'"), r8 = { type: "Index", index: e5, base: r8 };
        }
        else break;
        return r8;
      }
      parsePrimary() {
        if (this.match("DOTDOT")) return { type: "Recurse" };
        if (this.check("DOT")) {
          let r8 = this.advance();
          if (this.check("LBRACKET")) {
            if (this.advance(), this.match("RBRACKET")) return { type: "Iterate" };
            if (this.check("COLON")) {
              this.advance();
              let p17 = this.check("RBRACKET") ? void 0 : this.parseExpr();
              return this.expect("RBRACKET", "Expected ']'"), { type: "Slice", end: p17 };
            }
            let n23 = this.parseExpr();
            if (this.match("COLON")) {
              let p17 = this.check("RBRACKET") ? void 0 : this.parseExpr();
              return this.expect("RBRACKET", "Expected ']'"), { type: "Slice", start: n23, end: p17 };
            }
            return this.expect("RBRACKET", "Expected ']'"), { type: "Index", index: n23 };
          }
          let e5 = this.consumeFieldNameAfterDot(r8);
          return e5 !== null ? { type: "Field", name: e5 } : { type: "Identity" };
        }
        if (this.match("TRUE")) return { type: "Literal", value: true };
        if (this.match("FALSE")) return { type: "Literal", value: false };
        if (this.match("NULL")) return { type: "Literal", value: null };
        if (this.check("NUMBER")) return { type: "Literal", value: this.advance().value };
        if (this.check("STRING")) {
          let e5 = this.advance().value;
          return e5.includes("\\(") ? this.parseStringInterpolation(e5) : { type: "Literal", value: e5 };
        }
        if (this.match("LBRACKET")) {
          if (this.match("RBRACKET")) return { type: "Array" };
          let r8 = this.parseExpr();
          return this.expect("RBRACKET", "Expected ']'"), { type: "Array", elements: r8 };
        }
        if (this.match("LBRACE")) return this.parseObjectConstruction();
        if (this.match("LPAREN")) {
          let r8 = this.parseExpr();
          return this.expect("RPAREN", "Expected ')'"), { type: "Paren", expr: r8 };
        }
        if (this.match("IF")) return this.parseIf();
        if (this.match("TRY")) {
          let r8 = this.parsePostfix(), e5;
          return this.match("CATCH") && (e5 = this.parsePostfix()), { type: "Try", body: r8, catch: e5 };
        }
        if (this.match("REDUCE")) {
          let r8 = this.parseAddSub();
          this.expect("AS", "Expected 'as' after reduce expression");
          let e5 = this.parsePattern();
          this.expect("LPAREN", "Expected '(' after variable");
          let n23 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after init expression");
          let p17 = this.parseExpr();
          this.expect("RPAREN", "Expected ')' after update expression");
          let i10 = e5.type === "var" ? e5.name : "";
          return { type: "Reduce", expr: r8, varName: i10, init: n23, update: p17, pattern: e5.type !== "var" ? e5 : void 0 };
        }
        if (this.match("FOREACH")) {
          let r8 = this.parseAddSub();
          this.expect("AS", "Expected 'as' after foreach expression");
          let e5 = this.parsePattern();
          this.expect("LPAREN", "Expected '(' after variable");
          let n23 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after init expression");
          let p17 = this.parseExpr(), i10;
          this.match("SEMICOLON") && (i10 = this.parseExpr()), this.expect("RPAREN", "Expected ')' after expressions");
          let u10 = e5.type === "var" ? e5.name : "";
          return { type: "Foreach", expr: r8, varName: u10, init: n23, update: p17, extract: i10, pattern: e5.type !== "var" ? e5 : void 0 };
        }
        if (this.match("LABEL")) {
          let r8 = this.expect("IDENT", "Expected label name (e.g., $out)"), e5 = r8.value;
          if (!e5.startsWith("$")) throw new Error(`Label name must start with $ at position ${r8.pos}`);
          this.expect("PIPE", "Expected '|' after label name");
          let n23 = this.parseExpr();
          return { type: "Label", name: e5, body: n23 };
        }
        if (this.match("BREAK")) {
          let r8 = this.expect("IDENT", "Expected label name to break to"), e5 = r8.value;
          if (!e5.startsWith("$")) throw new Error(`Break label must start with $ at position ${r8.pos}`);
          return { type: "Break", name: e5 };
        }
        if (this.match("DEF")) {
          let e5 = this.expect("IDENT", "Expected function name after def").value, n23 = [];
          if (this.match("LPAREN")) {
            if (!this.check("RPAREN")) {
              let u10 = this.expect("IDENT", "Expected parameter name");
              for (n23.push(u10.value); this.match("SEMICOLON"); ) {
                let c14 = this.expect("IDENT", "Expected parameter name");
                n23.push(c14.value);
              }
            }
            this.expect("RPAREN", "Expected ')' after parameters");
          }
          this.expect("COLON", "Expected ':' after function name");
          let p17 = this.parseExpr();
          this.expect("SEMICOLON", "Expected ';' after function body");
          let i10 = this.parseExpr();
          return { type: "Def", name: e5, params: n23, funcBody: p17, body: i10 };
        }
        if (this.match("NOT")) return { type: "Call", name: "not", args: [] };
        if (this.check("IDENT")) {
          let e5 = this.advance().value;
          if (e5.startsWith("$")) return { type: "VarRef", name: e5 };
          if (this.match("LPAREN")) {
            let n23 = [];
            if (!this.check("RPAREN")) for (n23.push(this.parseExpr()); this.match("SEMICOLON"); ) n23.push(this.parseExpr());
            return this.expect("RPAREN", "Expected ')'"), { type: "Call", name: e5, args: n23 };
          }
          return { type: "Call", name: e5, args: [] };
        }
        throw new Error(`Unexpected token ${this.peek().type} at position ${this.peek().pos}`);
      }
      parseObjectConstruction() {
        let r8 = [];
        if (!this.check("RBRACE")) do {
          let e5, n23;
          if (this.match("LPAREN")) e5 = this.parseExpr(), this.expect("RPAREN", "Expected ')'"), this.expect("COLON", "Expected ':'"), n23 = this.parseObjectValue();
          else if (this.isIdentLike()) {
            let p17 = this.advance().value;
            this.match("COLON") ? (e5 = p17, n23 = this.parseObjectValue()) : (e5 = p17, n23 = { type: "Field", name: p17 });
          } else if (this.check("STRING")) e5 = this.advance().value, this.expect("COLON", "Expected ':'"), n23 = this.parseObjectValue();
          else throw new Error(`Expected object key at position ${this.peek().pos}`);
          r8.push({ key: e5, value: n23 });
        } while (this.match("COMMA"));
        return this.expect("RBRACE", "Expected '}'"), { type: "Object", entries: r8 };
      }
      parseObjectValue() {
        let r8 = this.parseVarBind();
        for (; this.match("PIPE"); ) {
          let e5 = this.parseVarBind();
          r8 = { type: "Pipe", left: r8, right: e5 };
        }
        return r8;
      }
      parseIf() {
        let r8 = this.parseExpr();
        this.expect("THEN", "Expected 'then'");
        let e5 = this.parseExpr(), n23 = [];
        for (; this.match("ELIF"); ) {
          let i10 = this.parseExpr();
          this.expect("THEN", "Expected 'then' after elif");
          let u10 = this.parseExpr();
          n23.push({ cond: i10, then: u10 });
        }
        let p17;
        return this.match("ELSE") && (p17 = this.parseExpr()), this.expect("END", "Expected 'end'"), { type: "Cond", cond: r8, then: e5, elifs: n23, else: p17 };
      }
      parseStringInterpolation(r8) {
        let e5 = [], n23 = "", p17 = 0;
        for (; p17 < r8.length; ) if (r8[p17] === "\\" && r8[p17 + 1] === "(") {
          n23 && (e5.push(n23), n23 = ""), p17 += 2;
          let i10 = 1, u10 = "";
          for (; p17 < r8.length && i10 > 0; ) r8[p17] === "(" ? i10++ : r8[p17] === ")" && i10--, i10 > 0 && (u10 += r8[p17]), p17++;
          let c14 = At2(u10), s9 = new t4(c14);
          e5.push(s9.parse());
        } else n23 += r8[p17], p17++;
        return n23 && e5.push(n23), { type: "StringInterp", parts: e5 };
      }
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-2OCD45J4.js
function I14(s9) {
  let r8 = [], t6 = 0, i10 = s9.length;
  for (; t6 < i10; ) {
    for (; t6 < i10 && /\s/.test(s9[t6]); ) t6++;
    if (t6 >= i10) break;
    let u10 = t6, n23 = s9[t6];
    if (n23 === "{" || n23 === "[") {
      let o9 = n23, l8 = n23 === "{" ? "}" : "]", c14 = 1, p17 = false, d16 = false;
      for (t6++; t6 < i10 && c14 > 0; ) {
        let h16 = s9[t6];
        d16 ? d16 = false : h16 === "\\" ? d16 = true : h16 === '"' ? p17 = !p17 : p17 || (h16 === o9 ? c14++ : h16 === l8 && c14--), t6++;
      }
      if (c14 !== 0) throw new Error(`Unexpected end of JSON input at position ${t6} (unclosed ${o9})`);
      r8.push(JSON.parse(s9.slice(u10, t6)));
    } else if (n23 === '"') {
      let o9 = false;
      for (t6++; t6 < i10; ) {
        let l8 = s9[t6];
        if (o9) o9 = false;
        else if (l8 === "\\") o9 = true;
        else if (l8 === '"') {
          t6++;
          break;
        }
        t6++;
      }
      r8.push(JSON.parse(s9.slice(u10, t6)));
    } else if (n23 === "-" || n23 >= "0" && n23 <= "9") {
      for (; t6 < i10 && /[\d.eE+-]/.test(s9[t6]); ) t6++;
      r8.push(JSON.parse(s9.slice(u10, t6)));
    } else if (s9.slice(t6, t6 + 4) === "true") r8.push(true), t6 += 4;
    else if (s9.slice(t6, t6 + 5) === "false") r8.push(false), t6 += 5;
    else if (s9.slice(t6, t6 + 4) === "null") r8.push(null), t6 += 4;
    else {
      let o9 = s9.slice(t6, t6 + 10);
      throw new Error(`Invalid JSON at position ${u10}: unexpected '${o9.split(/\s/)[0]}'`);
    }
  }
  return r8;
}
function j7(s9, r8, t6, i10, u10, n23 = 0) {
  if (s9 === null || s9 === void 0) return "null";
  if (typeof s9 == "boolean") return String(s9);
  if (typeof s9 == "number") return Number.isFinite(s9) ? String(s9) : "null";
  if (typeof s9 == "string") return t6 ? s9 : JSON.stringify(s9);
  let o9 = u10 ? "	" : "  ";
  if (Array.isArray(s9)) return s9.length === 0 ? "[]" : r8 ? `[${s9.map((c14) => j7(c14, true, false, i10, u10)).join(",")}]` : `[
${s9.map((c14) => o9.repeat(n23 + 1) + j7(c14, false, false, i10, u10, n23 + 1)).join(`,
`)}
${o9.repeat(n23)}]`;
  if (typeof s9 == "object") {
    let l8 = Object.keys(s9);
    return i10 && (l8 = l8.sort()), l8.length === 0 ? "{}" : r8 ? `{${l8.map((p17) => `${JSON.stringify(p17)}:${j7(s9[p17], true, false, i10, u10)}`).join(",")}}` : `{
${l8.map((p17) => {
      let d16 = j7(s9[p17], false, false, i10, u10, n23 + 1);
      return `${o9.repeat(n23 + 1)}${JSON.stringify(p17)}: ${d16}`;
    }).join(`,
`)}
${o9.repeat(n23)}}`;
  }
  return String(s9);
}
var A5, P12, U8;
var init_chunk_2OCD45J4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-2OCD45J4.js"() {
    init_chunk_FRDGR5VK();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    A5 = { name: "jq", summary: "command-line JSON processor", usage: "jq [OPTIONS] FILTER [FILE]", options: ["-r, --raw-output  output strings without quotes", "-c, --compact     compact output (no pretty printing)", "-e, --exit-status set exit status based on output", "-s, --slurp       read entire input into array", "-n, --null-input  don't read any input", "-j, --join-output don't print newlines after each output", "-a, --ascii       force ASCII output", "-S, --sort-keys   sort object keys", "-C, --color       colorize output (ignored)", "-M, --monochrome  monochrome output (ignored)", "    --tab         use tabs for indentation", "    --help        display this help and exit"] };
    P12 = { name: "jq", async execute(s9, r8) {
      if (o2(s9)) return s(A5);
      let t6 = false, i10 = false, u10 = false, n23 = false, o9 = false, l8 = false, c14 = false, p17 = false, d16 = ".", h16 = false, g18 = [];
      for (let a7 = 0; a7 < s9.length; a7++) {
        let e5 = s9[a7];
        if (e5 === "-r" || e5 === "--raw-output") t6 = true;
        else if (e5 === "-c" || e5 === "--compact-output") i10 = true;
        else if (e5 === "-e" || e5 === "--exit-status") u10 = true;
        else if (e5 === "-s" || e5 === "--slurp") n23 = true;
        else if (e5 === "-n" || e5 === "--null-input") o9 = true;
        else if (e5 === "-j" || e5 === "--join-output") l8 = true;
        else if (!(e5 === "-a" || e5 === "--ascii")) {
          if (e5 === "-S" || e5 === "--sort-keys") c14 = true;
          else if (!(e5 === "-C" || e5 === "--color")) {
            if (!(e5 === "-M" || e5 === "--monochrome")) if (e5 === "--tab") p17 = true;
            else if (e5 === "-") g18.push("-");
            else {
              if (e5.startsWith("--")) return r3("jq", e5);
              if (e5.startsWith("-")) {
                for (let f11 of e5.slice(1)) if (f11 === "r") t6 = true;
                else if (f11 === "c") i10 = true;
                else if (f11 === "e") u10 = true;
                else if (f11 === "s") n23 = true;
                else if (f11 === "n") o9 = true;
                else if (f11 === "j") l8 = true;
                else if (f11 !== "a") {
                  if (f11 === "S") c14 = true;
                  else if (f11 !== "C") {
                    if (f11 !== "M") return r3("jq", `-${f11}`);
                  }
                }
              } else h16 ? g18.push(e5) : (d16 = e5, h16 = true);
            }
          }
        }
      }
      let y18 = [];
      if (!o9) if (g18.length === 0 || g18.length === 1 && g18[0] === "-") y18.push({ source: "stdin", content: r8.stdin });
      else {
        let a7 = await y2(r8, g18, { cmdName: "jq", stopOnError: true });
        if (a7.exitCode !== 0) return { stdout: "", stderr: a7.stderr, exitCode: 2 };
        y18 = a7.files.map((e5) => ({ source: e5.filename || "stdin", content: e5.content }));
      }
      try {
        let a7 = ge4(d16), e5 = [], f11 = { limits: r8.limits ? { maxIterations: r8.limits.maxJqIterations } : void 0, env: r8.env, coverage: r8.coverage };
        if (o9) e5 = d11(null, a7, f11);
        else if (n23) {
          let m24 = [];
          for (let { content: w19 } of y18) {
            let b25 = w19.trim();
            b25 && m24.push(...I14(b25));
          }
          e5 = d11(m24, a7, f11);
        } else for (let { content: m24 } of y18) {
          let w19 = m24.trim();
          if (!w19) continue;
          let b25 = I14(w19);
          for (let z10 of b25) e5.push(...d11(z10, a7, f11));
        }
        let k15 = e5.map((m24) => j7(m24, i10, t6, c14, p17)), F20 = l8 ? "" : `
`, S16 = k15.join(F20), $17 = r8.limits?.maxStringLength;
        if ($17 !== void 0 && $17 > 0 && S16.length > $17) throw new b2(`jq: output size limit exceeded (${$17} bytes)`, "string_length");
        let L18 = u10 && (e5.length === 0 || e5.every((m24) => m24 == null || m24 === false)) ? 1 : 0;
        return { stdout: S16 ? l8 ? S16 : `${S16}
` : "", stderr: "", exitCode: L18 };
      } catch (a7) {
        if (a7 instanceof b2) return { stdout: "", stderr: `jq: ${a7.message}
`, exitCode: b2.EXIT_CODE };
        let e5 = a7.message;
        return e5.includes("Unknown function") ? { stdout: "", stderr: `jq: error: ${e5}
`, exitCode: 3 } : { stdout: "", stderr: `jq: parse error: ${e5}
`, exitCode: 5 };
      }
    } };
    U8 = { name: "jq", flags: [{ flag: "-r", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-e", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-j", type: "boolean" }, { flag: "-S", type: "boolean" }, { flag: "--tab", type: "boolean" }], stdinType: "json", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/jq-OJYNICKX.js
var jq_OJYNICKX_exports = {};
__export(jq_OJYNICKX_exports, {
  flagsForFuzzing: () => U8,
  jqCommand: () => P12
});
var init_jq_OJYNICKX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/jq-OJYNICKX.js"() {
    init_chunk_2OCD45J4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-IBFD7QQD.js
async function p14(r8, o9, n23) {
  if (o9.length === 0 || o9.length === 1 && o9[0] === "-") return { ok: true, data: Uint8Array.from(r8.stdin, (e5) => e5.charCodeAt(0)) };
  let d16 = [];
  for (let e5 of o9) {
    if (e5 === "-") {
      d16.push(Uint8Array.from(r8.stdin, (t6) => t6.charCodeAt(0)));
      continue;
    }
    try {
      let t6 = r8.fs.resolvePath(r8.cwd, e5), s9 = await r8.fs.readFileBuffer(t6);
      d16.push(s9);
    } catch {
      return { ok: false, error: { stdout: "", stderr: `${n23}: ${e5}: No such file or directory
`, exitCode: 1 } };
    }
  }
  let f11 = d16.reduce((e5, t6) => e5 + t6.length, 0), u10 = new Uint8Array(f11), a7 = 0;
  for (let e5 of d16) u10.set(e5, a7), a7 += e5.length;
  return { ok: true, data: u10 };
}
var b16, m17, A6, F12;
var init_chunk_IBFD7QQD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-IBFD7QQD.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    b16 = { name: "base64", summary: "base64 encode/decode data and print to standard output", usage: "base64 [OPTION]... [FILE]", options: ["-d, --decode    decode data", "-w, --wrap=COLS wrap encoded lines after COLS character (default 76, 0 to disable)", "    --help      display this help and exit"] };
    m17 = { decode: { short: "d", long: "decode", type: "boolean" }, wrap: { short: "w", long: "wrap", type: "number", default: 76 } };
    A6 = { name: "base64", async execute(r8, o9) {
      if (o2(r8)) return s(b16);
      let n23 = x3("base64", r8, m17);
      if (!n23.ok) return n23.error;
      let d16 = n23.result.flags.decode, f11 = n23.result.flags.wrap, u10 = n23.result.positional;
      try {
        if (d16) {
          let t6 = await p14(o9, u10, "base64");
          if (!t6.ok) return t6.error;
          if (typeof Buffer < "u") {
            let g18 = Buffer.from(t6.data).toString("utf8").replace(/\s/g, "");
            return { stdout: Buffer.from(g18, "base64").toString("latin1"), stderr: "", exitCode: 0 };
          }
          let h16 = String.fromCharCode(...t6.data).replace(/\s/g, "");
          return { stdout: atob(h16), stderr: "", exitCode: 0 };
        }
        let a7 = await p14(o9, u10, "base64");
        if (!a7.ok) return a7.error;
        let e5;
        if (typeof Buffer < "u" ? e5 = Buffer.from(a7.data).toString("base64") : e5 = btoa(String.fromCharCode(...a7.data)), f11 > 0) {
          let t6 = [];
          for (let s9 = 0; s9 < e5.length; s9 += f11) t6.push(e5.slice(s9, s9 + f11));
          e5 = t6.join(`
`) + (e5.length > 0 ? `
` : "");
        }
        return { stdout: e5, stderr: "", exitCode: 0 };
      } catch {
        return { stdout: "", stderr: `base64: invalid input
`, exitCode: 1 };
      }
    } };
    F12 = { name: "base64", flags: [{ flag: "-d", type: "boolean" }, { flag: "-w", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/base64-A3SGWC34.js
var base64_A3SGWC34_exports = {};
__export(base64_A3SGWC34_exports, {
  base64Command: () => A6,
  flagsForFuzzing: () => F12
});
var init_base64_A3SGWC34 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/base64-A3SGWC34.js"() {
    init_chunk_IBFD7QQD();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/diff/base.js
var Diff;
var init_base = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/diff/base.js"() {
    Diff = class {
      diff(oldStr, newStr, options = {}) {
        let callback;
        if (typeof options === "function") {
          callback = options;
          options = {};
        } else if ("callback" in options) {
          callback = options.callback;
        }
        const oldString = this.castInput(oldStr, options);
        const newString = this.castInput(newStr, options);
        const oldTokens = this.removeEmpty(this.tokenize(oldString, options));
        const newTokens = this.removeEmpty(this.tokenize(newString, options));
        return this.diffWithOptionsObj(oldTokens, newTokens, options, callback);
      }
      diffWithOptionsObj(oldTokens, newTokens, options, callback) {
        var _a2;
        const done = (value) => {
          value = this.postProcess(value, options);
          if (callback) {
            setTimeout(function() {
              callback(value);
            }, 0);
            return void 0;
          } else {
            return value;
          }
        };
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let editLength = 1;
        let maxEditLength = newLen + oldLen;
        if (options.maxEditLength != null) {
          maxEditLength = Math.min(maxEditLength, options.maxEditLength);
        }
        const maxExecutionTime = (_a2 = options.timeout) !== null && _a2 !== void 0 ? _a2 : Infinity;
        const abortAfterTimestamp = Date.now() + maxExecutionTime;
        const bestPath = [{ oldPos: -1, lastComponent: void 0 }];
        let newPos = this.extractCommon(bestPath[0], newTokens, oldTokens, 0, options);
        if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) {
          return done(this.buildValues(bestPath[0].lastComponent, newTokens, oldTokens));
        }
        let minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity;
        const execEditLength = () => {
          for (let diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2) {
            let basePath;
            const removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
            if (removePath) {
              bestPath[diagonalPath - 1] = void 0;
            }
            let canAdd = false;
            if (addPath) {
              const addPathNewPos = addPath.oldPos - diagonalPath;
              canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
            }
            const canRemove = removePath && removePath.oldPos + 1 < oldLen;
            if (!canAdd && !canRemove) {
              bestPath[diagonalPath] = void 0;
              continue;
            }
            if (!canRemove || canAdd && removePath.oldPos < addPath.oldPos) {
              basePath = this.addToPath(addPath, true, false, 0, options);
            } else {
              basePath = this.addToPath(removePath, false, true, 1, options);
            }
            newPos = this.extractCommon(basePath, newTokens, oldTokens, diagonalPath, options);
            if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) {
              return done(this.buildValues(basePath.lastComponent, newTokens, oldTokens)) || true;
            } else {
              bestPath[diagonalPath] = basePath;
              if (basePath.oldPos + 1 >= oldLen) {
                maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
              }
              if (newPos + 1 >= newLen) {
                minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
              }
            }
          }
          editLength++;
        };
        if (callback) {
          (function exec() {
            setTimeout(function() {
              if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) {
                return callback(void 0);
              }
              if (!execEditLength()) {
                exec();
              }
            }, 0);
          })();
        } else {
          while (editLength <= maxEditLength && Date.now() <= abortAfterTimestamp) {
            const ret = execEditLength();
            if (ret) {
              return ret;
            }
          }
        }
      }
      addToPath(path2, added, removed, oldPosInc, options) {
        const last = path2.lastComponent;
        if (last && !options.oneChangePerToken && last.added === added && last.removed === removed) {
          return {
            oldPos: path2.oldPos + oldPosInc,
            lastComponent: { count: last.count + 1, added, removed, previousComponent: last.previousComponent }
          };
        } else {
          return {
            oldPos: path2.oldPos + oldPosInc,
            lastComponent: { count: 1, added, removed, previousComponent: last }
          };
        }
      }
      extractCommon(basePath, newTokens, oldTokens, diagonalPath, options) {
        const newLen = newTokens.length, oldLen = oldTokens.length;
        let oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
        while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(oldTokens[oldPos + 1], newTokens[newPos + 1], options)) {
          newPos++;
          oldPos++;
          commonCount++;
          if (options.oneChangePerToken) {
            basePath.lastComponent = { count: 1, previousComponent: basePath.lastComponent, added: false, removed: false };
          }
        }
        if (commonCount && !options.oneChangePerToken) {
          basePath.lastComponent = { count: commonCount, previousComponent: basePath.lastComponent, added: false, removed: false };
        }
        basePath.oldPos = oldPos;
        return newPos;
      }
      equals(left, right, options) {
        if (options.comparator) {
          return options.comparator(left, right);
        } else {
          return left === right || !!options.ignoreCase && left.toLowerCase() === right.toLowerCase();
        }
      }
      removeEmpty(array) {
        const ret = [];
        for (let i10 = 0; i10 < array.length; i10++) {
          if (array[i10]) {
            ret.push(array[i10]);
          }
        }
        return ret;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      castInput(value, options) {
        return value;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      tokenize(value, options) {
        return Array.from(value);
      }
      join(chars) {
        return chars.join("");
      }
      postProcess(changeObjects, options) {
        return changeObjects;
      }
      get useLongestToken() {
        return false;
      }
      buildValues(lastComponent, newTokens, oldTokens) {
        const components = [];
        let nextComponent;
        while (lastComponent) {
          components.push(lastComponent);
          nextComponent = lastComponent.previousComponent;
          delete lastComponent.previousComponent;
          lastComponent = nextComponent;
        }
        components.reverse();
        const componentLen = components.length;
        let componentPos = 0, newPos = 0, oldPos = 0;
        for (; componentPos < componentLen; componentPos++) {
          const component = components[componentPos];
          if (!component.removed) {
            if (!component.added && this.useLongestToken) {
              let value = newTokens.slice(newPos, newPos + component.count);
              value = value.map(function(value2, i10) {
                const oldValue = oldTokens[oldPos + i10];
                return oldValue.length > value2.length ? oldValue : value2;
              });
              component.value = this.join(value);
            } else {
              component.value = this.join(newTokens.slice(newPos, newPos + component.count));
            }
            newPos += component.count;
            if (!component.added) {
              oldPos += component.count;
            }
          } else {
            component.value = this.join(oldTokens.slice(oldPos, oldPos + component.count));
            oldPos += component.count;
          }
        }
        return components;
      }
    };
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/diff/line.js
function diffLines(oldStr, newStr, options) {
  return lineDiff.diff(oldStr, newStr, options);
}
function tokenize(value, options) {
  if (options.stripTrailingCr) {
    value = value.replace(/\r\n/g, "\n");
  }
  const retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/);
  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
    linesAndNewlines.pop();
  }
  for (let i10 = 0; i10 < linesAndNewlines.length; i10++) {
    const line = linesAndNewlines[i10];
    if (i10 % 2 && !options.newlineIsToken) {
      retLines[retLines.length - 1] += line;
    } else {
      retLines.push(line);
    }
  }
  return retLines;
}
var LineDiff, lineDiff;
var init_line = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/diff/line.js"() {
    init_base();
    LineDiff = class extends Diff {
      constructor() {
        super(...arguments);
        this.tokenize = tokenize;
      }
      equals(left, right, options) {
        if (options.ignoreWhitespace) {
          if (!options.newlineIsToken || !left.includes("\n")) {
            left = left.trim();
          }
          if (!options.newlineIsToken || !right.includes("\n")) {
            right = right.trim();
          }
        } else if (options.ignoreNewlineAtEof && !options.newlineIsToken) {
          if (left.endsWith("\n")) {
            left = left.slice(0, -1);
          }
          if (right.endsWith("\n")) {
            right = right.slice(0, -1);
          }
        }
        return super.equals(left, right, options);
      }
    };
    lineDiff = new LineDiff();
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/patch/create.js
function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
  let optionsObj;
  if (!options) {
    optionsObj = {};
  } else if (typeof options === "function") {
    optionsObj = { callback: options };
  } else {
    optionsObj = options;
  }
  if (typeof optionsObj.context === "undefined") {
    optionsObj.context = 4;
  }
  const context = optionsObj.context;
  if (optionsObj.newlineIsToken) {
    throw new Error("newlineIsToken may not be used with patch-generation functions, only with diffing functions");
  }
  if (!optionsObj.callback) {
    return diffLinesResultToPatch(diffLines(oldStr, newStr, optionsObj));
  } else {
    const { callback } = optionsObj;
    diffLines(oldStr, newStr, Object.assign(Object.assign({}, optionsObj), { callback: (diff) => {
      const patch = diffLinesResultToPatch(diff);
      callback(patch);
    } }));
  }
  function diffLinesResultToPatch(diff) {
    if (!diff) {
      return;
    }
    diff.push({ value: "", lines: [] });
    function contextLines(lines) {
      return lines.map(function(entry) {
        return " " + entry;
      });
    }
    const hunks = [];
    let oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
    for (let i10 = 0; i10 < diff.length; i10++) {
      const current = diff[i10], lines = current.lines || splitLines(current.value);
      current.lines = lines;
      if (current.added || current.removed) {
        if (!oldRangeStart) {
          const prev = diff[i10 - 1];
          oldRangeStart = oldLine;
          newRangeStart = newLine;
          if (prev) {
            curRange = context > 0 ? contextLines(prev.lines.slice(-context)) : [];
            oldRangeStart -= curRange.length;
            newRangeStart -= curRange.length;
          }
        }
        for (const line of lines) {
          curRange.push((current.added ? "+" : "-") + line);
        }
        if (current.added) {
          newLine += lines.length;
        } else {
          oldLine += lines.length;
        }
      } else {
        if (oldRangeStart) {
          if (lines.length <= context * 2 && i10 < diff.length - 2) {
            for (const line of contextLines(lines)) {
              curRange.push(line);
            }
          } else {
            const contextSize = Math.min(lines.length, context);
            for (const line of contextLines(lines.slice(0, contextSize))) {
              curRange.push(line);
            }
            const hunk = {
              oldStart: oldRangeStart,
              oldLines: oldLine - oldRangeStart + contextSize,
              newStart: newRangeStart,
              newLines: newLine - newRangeStart + contextSize,
              lines: curRange
            };
            hunks.push(hunk);
            oldRangeStart = 0;
            newRangeStart = 0;
            curRange = [];
          }
        }
        oldLine += lines.length;
        newLine += lines.length;
      }
    }
    for (const hunk of hunks) {
      for (let i10 = 0; i10 < hunk.lines.length; i10++) {
        if (hunk.lines[i10].endsWith("\n")) {
          hunk.lines[i10] = hunk.lines[i10].slice(0, -1);
        } else {
          hunk.lines.splice(i10 + 1, 0, "\\ No newline at end of file");
          i10++;
        }
      }
    }
    return {
      oldFileName,
      newFileName,
      oldHeader,
      newHeader,
      hunks
    };
  }
}
function formatPatch(patch, headerOptions) {
  if (!headerOptions) {
    headerOptions = INCLUDE_HEADERS;
  }
  if (Array.isArray(patch)) {
    if (patch.length > 1 && !headerOptions.includeFileHeaders) {
      throw new Error("Cannot omit file headers on a multi-file patch. (The result would be unparseable; how would a tool trying to apply the patch know which changes are to which file?)");
    }
    return patch.map((p17) => formatPatch(p17, headerOptions)).join("\n");
  }
  const ret = [];
  if (headerOptions.includeIndex && patch.oldFileName == patch.newFileName) {
    ret.push("Index: " + patch.oldFileName);
  }
  if (headerOptions.includeUnderline) {
    ret.push("===================================================================");
  }
  if (headerOptions.includeFileHeaders) {
    ret.push("--- " + patch.oldFileName + (typeof patch.oldHeader === "undefined" ? "" : "	" + patch.oldHeader));
    ret.push("+++ " + patch.newFileName + (typeof patch.newHeader === "undefined" ? "" : "	" + patch.newHeader));
  }
  for (let i10 = 0; i10 < patch.hunks.length; i10++) {
    const hunk = patch.hunks[i10];
    if (hunk.oldLines === 0) {
      hunk.oldStart -= 1;
    }
    if (hunk.newLines === 0) {
      hunk.newStart -= 1;
    }
    ret.push("@@ -" + hunk.oldStart + "," + hunk.oldLines + " +" + hunk.newStart + "," + hunk.newLines + " @@");
    for (const line of hunk.lines) {
      ret.push(line);
    }
  }
  return ret.join("\n") + "\n";
}
function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
  if (typeof options === "function") {
    options = { callback: options };
  }
  if (!(options === null || options === void 0 ? void 0 : options.callback)) {
    const patchObj = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
    if (!patchObj) {
      return;
    }
    return formatPatch(patchObj, options === null || options === void 0 ? void 0 : options.headerOptions);
  } else {
    const { callback } = options;
    structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, Object.assign(Object.assign({}, options), { callback: (patchObj) => {
      if (!patchObj) {
        callback(void 0);
      } else {
        callback(formatPatch(patchObj, options.headerOptions));
      }
    } }));
  }
}
function splitLines(text) {
  const hasTrailingNl = text.endsWith("\n");
  const result = text.split("\n").map((line) => line + "\n");
  if (hasTrailingNl) {
    result.pop();
  } else {
    result.push(result.pop().slice(0, -1));
  }
  return result;
}
var INCLUDE_HEADERS;
var init_create = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/patch/create.js"() {
    init_line();
    INCLUDE_HEADERS = {
      includeIndex: true,
      includeUnderline: true,
      includeFileHeaders: true
    };
  }
});

// ../../node_modules/just-bash/node_modules/diff/libesm/index.js
var init_libesm = __esm({
  "../../node_modules/just-bash/node_modules/diff/libesm/index.js"() {
    init_create();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-TLSUDHID.js
var y13, b17, $12, x14;
var init_chunk_TLSUDHID = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-TLSUDHID.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_libesm();
    y13 = { name: "diff", summary: "compare files line by line", usage: "diff [OPTION]... FILE1 FILE2", options: ["-u, --unified     output unified diff format (default)", "-q, --brief       report only whether files differ", "-s, --report-identical-files  report when files are the same", "-i, --ignore-case  ignore case differences", "    --help        display this help and exit"] };
    b17 = { unified: { short: "u", long: "unified", type: "boolean" }, brief: { short: "q", long: "brief", type: "boolean" }, reportSame: { short: "s", long: "report-identical-files", type: "boolean" }, ignoreCase: { short: "i", long: "ignore-case", type: "boolean" } };
    $12 = { name: "diff", async execute(a7, e5) {
      if (o2(a7)) return s(y13);
      let t6 = x3("diff", a7, b17);
      if (!t6.ok) return t6.error;
      let g18 = t6.result.flags.brief, h16 = t6.result.flags.reportSame, m24 = t6.result.flags.ignoreCase, d16 = t6.result.positional;
      if (t6.result.flags.unified, d16.length < 2) return { stdout: "", stderr: `diff: missing operand
`, exitCode: 2 };
      let i10, s9, [r8, o9] = d16;
      try {
        i10 = r8 === "-" ? e5.stdin : await e5.fs.readFile(e5.fs.resolvePath(e5.cwd, r8));
      } catch {
        return { stdout: "", stderr: `diff: ${r8}: No such file or directory
`, exitCode: 2 };
      }
      try {
        s9 = o9 === "-" ? e5.stdin : await e5.fs.readFile(e5.fs.resolvePath(e5.cwd, o9));
      } catch {
        return { stdout: "", stderr: `diff: ${o9}: No such file or directory
`, exitCode: 2 };
      }
      let f11 = i10, n23 = s9;
      return m24 && (f11 = f11.toLowerCase(), n23 = n23.toLowerCase()), f11 === n23 ? h16 ? { stdout: `Files ${r8} and ${o9} are identical
`, stderr: "", exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 } : g18 ? { stdout: `Files ${r8} and ${o9} differ
`, stderr: "", exitCode: 1 } : { stdout: createTwoFilesPatch(r8, o9, i10, s9, "", "", { context: 3 }), stderr: "", exitCode: 1 };
    } };
    x14 = { name: "diff", flags: [{ flag: "-u", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-i", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/diff-HJF2MPDN.js
var diff_HJF2MPDN_exports = {};
__export(diff_HJF2MPDN_exports, {
  diffCommand: () => $12,
  flagsForFuzzing: () => x14
});
var init_diff_HJF2MPDN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/diff-HJF2MPDN.js"() {
    init_chunk_TLSUDHID();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-D7MEQ3VN.js
function s5(a7, i10 = 2) {
  return String(a7).padStart(i10, "0");
}
function b18(a7, i10, n23) {
  let t6 = { Y: a7.getUTCFullYear(), m: a7.getUTCMonth(), D: a7.getUTCDate(), H: a7.getUTCHours(), M: a7.getUTCMinutes(), S: a7.getUTCSeconds(), w: a7.getUTCDay() }, e5 = "", l8 = 0;
  for (; l8 < i10.length; ) {
    if (i10[l8] === "%" && l8 + 1 < i10.length) {
      let o9 = i10[++l8];
      switch (o9) {
        case "%":
          e5 += "%";
          break;
        case "a":
          e5 += T6[t6.w];
          break;
        case "b":
        case "h":
          e5 += S7[t6.m];
          break;
        case "d":
          e5 += s5(t6.D);
          break;
        case "e":
          e5 += String(t6.D).padStart(2, " ");
          break;
        case "F":
          e5 += `${t6.Y}-${s5(t6.m + 1)}-${s5(t6.D)}`;
          break;
        case "H":
          e5 += s5(t6.H);
          break;
        case "I":
          e5 += s5(t6.H % 12 || 12);
          break;
        case "m":
          e5 += s5(t6.m + 1);
          break;
        case "M":
          e5 += s5(t6.M);
          break;
        case "n":
          e5 += `
`;
          break;
        case "p":
          e5 += t6.H < 12 ? "AM" : "PM";
          break;
        case "P":
          e5 += t6.H < 12 ? "am" : "pm";
          break;
        case "R":
          e5 += `${s5(t6.H)}:${s5(t6.M)}`;
          break;
        case "s":
          e5 += Math.floor(a7.getTime() / 1e3);
          break;
        case "S":
          e5 += s5(t6.S);
          break;
        case "t":
          e5 += "	";
          break;
        case "T":
          e5 += `${s5(t6.H)}:${s5(t6.M)}:${s5(t6.S)}`;
          break;
        case "u":
          e5 += t6.w || 7;
          break;
        case "w":
          e5 += t6.w;
          break;
        case "y":
          e5 += s5(t6.Y % 100);
          break;
        case "Y":
          e5 += t6.Y;
          break;
        case "z":
          e5 += "+0000";
          break;
        case "Z":
          e5 += "UTC";
          break;
        default:
          e5 += `%${o9}`;
      }
    } else e5 += i10[l8];
    l8++;
  }
  return e5;
}
function h13(a7) {
  let i10 = new Date(a7);
  if (!Number.isNaN(i10.getTime())) return i10;
  if (/^\d+$/.test(a7)) return new Date(Number.parseInt(a7, 10) * 1e3);
  let n23 = a7.toLowerCase();
  return n23 === "now" || n23 === "today" ? /* @__PURE__ */ new Date() : n23 === "yesterday" ? new Date(Date.now() - 864e5) : n23 === "tomorrow" ? new Date(Date.now() + 864e5) : null;
}
var g13, T6, S7, M8, D10;
var init_chunk_D7MEQ3VN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-D7MEQ3VN.js"() {
    init_chunk_74CEPOFO();
    g13 = { name: "date", summary: "display the current time in the given FORMAT", usage: "date [OPTION]... [+FORMAT]", options: ["-d, --date=STRING   display time described by STRING", "-u, --utc           print Coordinated Universal Time (UTC)", "-I, --iso-8601      output date/time in ISO 8601 format", "-R, --rfc-email     output RFC 5322 date format", "    --help          display this help and exit"] };
    T6 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    S7 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    M8 = { name: "date", async execute(a7, i10) {
      if (o2(a7)) return s(g13);
      let n23 = false, t6 = null, e5 = null, l8 = false, o9 = false;
      for (let f11 = 0; f11 < a7.length; f11++) {
        let r8 = a7[f11];
        if (r8 === "-u" || r8 === "--utc") n23 = true;
        else if (r8 === "-d" || r8 === "--date") t6 = a7[++f11] ?? "";
        else if (r8.startsWith("--date=")) t6 = r8.slice(7);
        else if (r8 === "-I" || r8 === "--iso-8601") l8 = true;
        else if (r8 === "-R" || r8 === "--rfc-email") o9 = true;
        else if (r8.startsWith("+")) e5 = r8.slice(1);
        else {
          if (r8.startsWith("--")) return r3("date", r8);
          if (r8.startsWith("-")) for (let d16 of r8.slice(1)) if (d16 === "u") n23 = true;
          else if (d16 === "I") l8 = true;
          else if (d16 === "R") o9 = true;
          else return r3("date", `-${d16}`);
        }
      }
      let u10 = t6 !== null ? h13(t6) : /* @__PURE__ */ new Date();
      if (!u10) return { stdout: "", stderr: `date: invalid date '${t6}'
`, exitCode: 1 };
      let c14;
      return e5 ? c14 = b18(u10, e5, n23) : l8 ? c14 = b18(u10, "%Y-%m-%dT%H:%M:%S%z", n23) : o9 ? c14 = b18(u10, "%a, %d %b %Y %H:%M:%S %z", n23) : c14 = b18(u10, "%a %b %e %H:%M:%S %Z %Y", n23), { stdout: `${c14}
`, stderr: "", exitCode: 0 };
    } };
    D10 = { name: "date", flags: [{ flag: "-d", type: "value", valueHint: "string" }, { flag: "-u", type: "boolean" }, { flag: "-I", type: "boolean" }, { flag: "-R", type: "boolean" }] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/date-DD7FVA2V.js
var date_DD7FVA2V_exports = {};
__export(date_DD7FVA2V_exports, {
  dateCommand: () => M8,
  flagsForFuzzing: () => D10
});
var init_date_DD7FVA2V = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/date-DD7FVA2V.js"() {
    init_chunk_D7MEQ3VN();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-WMLBQOWO.js
function i5(t6) {
  let s9 = t6.match(/^(\d+\.?\d*)(s|m|h|d)?$/);
  if (!s9) return null;
  let e5 = parseFloat(s9[1]);
  switch (s9[2] || "s") {
    case "s":
      return e5 * 1e3;
    case "m":
      return e5 * 60 * 1e3;
    case "h":
      return e5 * 60 * 60 * 1e3;
    case "d":
      return e5 * 24 * 60 * 60 * 1e3;
    default:
      return null;
  }
}
var l4, d12, m18;
var init_chunk_WMLBQOWO = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-WMLBQOWO.js"() {
    init_chunk_74CEPOFO();
    l4 = { name: "sleep", summary: "delay for a specified amount of time", usage: "sleep NUMBER[SUFFIX]", description: `Pause for NUMBER seconds. SUFFIX may be:
  s - seconds (default)
  m - minutes
  h - hours
  d - days

NUMBER may be a decimal number.`, options: ["    --help display this help and exit"] };
    d12 = { name: "sleep", async execute(t6, s9) {
      if (o2(t6)) return s(l4);
      if (t6.length === 0) return { stdout: "", stderr: `sleep: missing operand
`, exitCode: 1 };
      let e5 = 0;
      for (let n23 of t6) {
        let r8 = i5(n23);
        if (r8 === null) return { stdout: "", stderr: `sleep: invalid time interval '${n23}'
`, exitCode: 1 };
        e5 += r8;
      }
      return s9.sleep ? await s9.sleep(e5) : await new Promise((n23) => setTimeout(n23, e5)), { stdout: "", stderr: "", exitCode: 0 };
    } };
    m18 = { name: "sleep", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sleep-JHK4I472.js
var sleep_JHK4I472_exports = {};
__export(sleep_JHK4I472_exports, {
  flagsForFuzzing: () => m18,
  sleepCommand: () => d12
});
var init_sleep_JHK4I472 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sleep-JHK4I472.js"() {
    init_chunk_WMLBQOWO();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XNL7YAHW.js
function A7(r8) {
  let i10 = r8.match(/^(\d+\.?\d*)(s|m|h|d)?$/);
  if (!i10) return null;
  let n23 = parseFloat(i10[1]);
  switch (i10[2] || "s") {
    case "s":
      return n23 * 1e3;
    case "m":
      return n23 * 60 * 1e3;
    case "h":
      return n23 * 60 * 60 * 1e3;
    case "d":
      return n23 * 24 * 60 * 60 * 1e3;
    default:
      return null;
  }
}
var x15, v15, k8;
var init_chunk_XNL7YAHW = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XNL7YAHW.js"() {
    init_chunk_74CEPOFO();
    x15 = { name: "timeout", summary: "run a command with a time limit", usage: "timeout [OPTION] DURATION COMMAND [ARG]...", description: `Start COMMAND, and kill it if still running after DURATION.

DURATION is a number with optional suffix:
  s - seconds (default)
  m - minutes
  h - hours
  d - days`, options: ["-k, --kill-after=DURATION  send KILL signal after DURATION if still running", "-s, --signal=SIGNAL        specify signal to send (default: TERM)", "    --preserve-status      exit with same status as COMMAND, even on timeout", "    --foreground           run command in foreground", "    --help                 display this help and exit"] };
    v15 = { name: "timeout", async execute(r8, i10) {
      if (o2(r8)) return s(x15);
      let n23 = false, s9 = 0;
      for (let e5 = 0; e5 < r8.length; e5++) {
        let t6 = r8[e5];
        if (t6 === "--preserve-status") n23 = true, s9 = e5 + 1;
        else if (t6 === "--foreground") s9 = e5 + 1;
        else if (t6 === "-k" || t6 === "--kill-after") e5++, s9 = e5 + 1;
        else if (t6.startsWith("--kill-after=")) s9 = e5 + 1;
        else if (t6 === "-s" || t6 === "--signal") e5++, s9 = e5 + 1;
        else if (t6.startsWith("--signal=")) s9 = e5 + 1;
        else {
          if (t6.startsWith("--") && t6 !== "--") return r3("timeout", t6);
          if (t6.startsWith("-") && t6.length > 1 && t6 !== "--") if (t6.startsWith("-k")) s9 = e5 + 1;
          else if (t6.startsWith("-s")) s9 = e5 + 1;
          else return r3("timeout", t6);
          else {
            s9 = e5;
            break;
          }
        }
      }
      let o9 = r8.slice(s9);
      if (o9.length === 0) return { stdout: "", stderr: `timeout: missing operand
`, exitCode: 1 };
      let u10 = o9[0], l8 = A7(u10);
      if (l8 === null) return { stdout: "", stderr: `timeout: invalid time interval '${u10}'
`, exitCode: 1 };
      let m24 = o9.slice(1);
      if (m24.length === 0) return { stdout: "", stderr: `timeout: missing operand
`, exitCode: 1 };
      if (!i10.exec) return { stdout: "", stderr: `timeout: exec not available
`, exitCode: 1 };
      let g18 = m24.map((e5) => e5.includes(" ") || e5.includes("	") ? `'${e5.replace(/'/g, "'\\''")}'` : e5).join(" "), p17 = new Promise((e5) => {
        setTimeout(() => e5({ timedOut: true }), l8);
      }), h16 = i10.exec(g18, { cwd: i10.cwd }).then((e5) => ({ timedOut: false, result: e5 })), d16 = await Promise.race([p17, h16]);
      return d16.timedOut ? { stdout: "", stderr: "", exitCode: 124 } : d16.result;
    } };
    k8 = { name: "timeout", flags: [{ flag: "-k", type: "value", valueHint: "string" }, { flag: "-s", type: "value", valueHint: "string" }, { flag: "--preserve-status", type: "boolean" }, { flag: "--foreground", type: "boolean" }], needsArgs: true, minArgs: 2 };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/timeout-5UJUQXOE.js
var timeout_5UJUQXOE_exports = {};
__export(timeout_5UJUQXOE_exports, {
  flagsForFuzzing: () => k8,
  timeoutCommand: () => v15
});
var init_timeout_5UJUQXOE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/timeout-5UJUQXOE.js"() {
    init_chunk_XNL7YAHW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-CSBFBYLD.js
function w14(i10) {
  let r8 = Math.floor(i10 / 3600), a7 = Math.floor(i10 % 3600 / 60), o9 = i10 % 60;
  return r8 > 0 ? `${r8}:${a7.toString().padStart(2, "0")}:${o9.toFixed(2).padStart(5, "0")}` : `${a7}:${o9.toFixed(2).padStart(5, "0")}`;
}
var C13, F13;
var init_chunk_CSBFBYLD = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-CSBFBYLD.js"() {
    init_chunk_OJDRYQWQ();
    C13 = { name: "time", async execute(i10, r8) {
      let a7 = "%e %M", o9 = null, d16 = false, m24 = false, t6 = 0;
      for (; t6 < i10.length; ) {
        let e5 = i10[t6];
        if (e5 === "-f" || e5 === "--format") {
          if (t6++, t6 >= i10.length) return { stdout: "", stderr: `time: missing argument to '-f'
`, exitCode: 1 };
          a7 = i10[t6], t6++;
        } else if (e5 === "-o" || e5 === "--output") {
          if (t6++, t6 >= i10.length) return { stdout: "", stderr: `time: missing argument to '-o'
`, exitCode: 1 };
          o9 = i10[t6], t6++;
        } else if (e5 === "-a" || e5 === "--append") d16 = true, t6++;
        else if (e5 === "-v" || e5 === "--verbose") a7 = `Command being timed: %C
Elapsed (wall clock) time: %e seconds
Maximum resident set size (kbytes): %M`, t6++;
        else if (e5 === "-p" || e5 === "--portability") m24 = true, t6++;
        else if (e5 === "--") {
          t6++;
          break;
        } else if (e5.startsWith("-")) t6++;
        else break;
      }
      let f11 = i10.slice(t6);
      if (f11.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
      let p17 = performance.now(), u10 = f11.join(" "), s9;
      try {
        if (!r8.exec) return { stdout: "", stderr: `time: exec not available
`, exitCode: 1 };
        s9 = await r8.exec(u10, { env: r(r8.env), cwd: r8.cwd });
      } catch (e5) {
        s9 = { stdout: "", stderr: `time: ${e5.message}
`, exitCode: 127 };
      }
      let l8 = (performance.now() - p17) / 1e3, n23;
      if (m24 ? n23 = `real ${l8.toFixed(2)}
user 0.00
sys 0.00
` : (n23 = a7.replace(/%e/g, l8.toFixed(2)).replace(/%E/g, w14(l8)).replace(/%M/g, "0").replace(/%S/g, "0.00").replace(/%U/g, "0.00").replace(/%P/g, "0%").replace(/%C/g, u10), n23.endsWith(`
`) || (n23 += `
`)), o9) try {
        let e5 = r8.fs.resolvePath(r8.cwd, o9);
        if (d16 && await r8.fs.exists(e5)) {
          let g18 = await r8.fs.readFile(e5);
          await r8.fs.writeFile(e5, g18 + n23);
        } else await r8.fs.writeFile(e5, n23);
      } catch (e5) {
        return { stdout: s9.stdout, stderr: s9.stderr + `time: cannot write to '${o9}': ${e5.message}
`, exitCode: s9.exitCode };
      }
      else s9 = { ...s9, stderr: s9.stderr + n23 };
      return s9;
    } };
    F13 = { name: "time", flags: [{ flag: "-p", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/time-BPT76IHZ.js
var time_BPT76IHZ_exports = {};
__export(time_BPT76IHZ_exports, {
  flagsForFuzzing: () => F13,
  timeCommand: () => C13
});
var init_time_BPT76IHZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/time-BPT76IHZ.js"() {
    init_chunk_CSBFBYLD();
    init_chunk_OJDRYQWQ();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-A7A2DBEE.js
var F14, b19;
var init_chunk_A7A2DBEE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-A7A2DBEE.js"() {
    F14 = { name: "seq", async execute(r8) {
      let d16 = `
`, f11 = false, s9 = [], t6 = 0;
      for (; t6 < r8.length; ) {
        let e5 = r8[t6];
        if (e5 === "-s" && t6 + 1 < r8.length) {
          d16 = r8[t6 + 1], t6 += 2;
          continue;
        }
        if (e5 === "-w") {
          f11 = true, t6++;
          continue;
        }
        if (e5 === "--") {
          t6++;
          break;
        }
        if (e5.startsWith("-") && e5 !== "-") {
          if (e5.startsWith("-s") && e5.length > 2) {
            d16 = e5.slice(2), t6++;
            continue;
          }
          if ((e5 === "-ws" || e5 === "-sw") && (f11 = true, t6 + 1 < r8.length)) {
            d16 = r8[t6 + 1], t6 += 2;
            continue;
          }
        }
        s9.push(e5), t6++;
      }
      for (; t6 < r8.length; ) s9.push(r8[t6]), t6++;
      if (s9.length === 0) return { stdout: "", stderr: `seq: missing operand
`, exitCode: 1 };
      let l8 = 1, o9 = 1, a7;
      if (s9.length === 1 ? a7 = parseFloat(s9[0]) : s9.length === 2 ? (l8 = parseFloat(s9[0]), a7 = parseFloat(s9[1])) : (l8 = parseFloat(s9[0]), o9 = parseFloat(s9[1]), a7 = parseFloat(s9[2])), Number.isNaN(l8) || Number.isNaN(o9) || Number.isNaN(a7)) return { stdout: "", stderr: `seq: invalid floating point argument: '${s9.find((n23) => Number.isNaN(parseFloat(n23)))}'
`, exitCode: 1 };
      if (o9 === 0) return { stdout: "", stderr: `seq: invalid Zero increment value: '0'
`, exitCode: 1 };
      let i10 = [], h16 = (e5) => {
        let n23 = String(e5), u10 = n23.indexOf(".");
        return u10 === -1 ? 0 : n23.length - u10 - 1;
      }, c14 = Math.max(h16(l8), h16(o9), h16(a7)), p17 = 1e5, g18 = 0;
      if (o9 > 0) for (let e5 = l8; e5 <= a7 + 1e-10 && !(g18++ > p17); e5 += o9) i10.push(c14 > 0 ? e5.toFixed(c14) : String(Math.round(e5)));
      else for (let e5 = l8; e5 >= a7 - 1e-10 && !(g18++ > p17); e5 += o9) i10.push(c14 > 0 ? e5.toFixed(c14) : String(Math.round(e5)));
      if (f11 && i10.length > 0) {
        let e5 = Math.max(...i10.map((n23) => n23.replace("-", "").length));
        for (let n23 = 0; n23 < i10.length; n23++) {
          let u10 = i10[n23].startsWith("-"), x22 = (u10 ? i10[n23].slice(1) : i10[n23]).padStart(e5, "0");
          i10[n23] = u10 ? `-${x22}` : x22;
        }
      }
      let m24 = i10.join(d16);
      return { stdout: m24 ? `${m24}
` : "", stderr: "", exitCode: 0 };
    } };
    b19 = { name: "seq", flags: [{ flag: "-s", type: "value", valueHint: "string" }, { flag: "-w", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/seq-RN5ZUASB.js
var seq_RN5ZUASB_exports = {};
__export(seq_RN5ZUASB_exports, {
  flagsForFuzzing: () => b19,
  seqCommand: () => F14
});
var init_seq_RN5ZUASB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/seq-RN5ZUASB.js"() {
    init_chunk_A7A2DBEE();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-U7QI5ZS5.js
function d13(s9) {
  if (s9.length === 1) return s9[0];
  let r8 = 0;
  function l8() {
    let e5 = h16();
    for (; r8 < s9.length && s9[r8] === "|"; ) {
      r8++;
      let t6 = h16();
      if (e5 !== "0" && e5 !== "") return e5;
      e5 = t6;
    }
    return e5;
  }
  function h16() {
    let e5 = m24();
    for (; r8 < s9.length && s9[r8] === "&"; ) {
      r8++;
      let t6 = m24();
      (e5 === "0" || e5 === "" || t6 === "0" || t6 === "") && (e5 = "0");
    }
    return e5;
  }
  function m24() {
    let e5 = p17();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (["=", "!=", "<", ">", "<=", ">="].includes(t6)) {
        r8++;
        let o9 = p17(), n23 = parseInt(e5, 10), i10 = parseInt(o9, 10), f11 = !Number.isNaN(n23) && !Number.isNaN(i10), c14;
        t6 === "=" ? c14 = f11 ? n23 === i10 : e5 === o9 : t6 === "!=" ? c14 = f11 ? n23 !== i10 : e5 !== o9 : t6 === "<" ? c14 = f11 ? n23 < i10 : e5 < o9 : t6 === ">" ? c14 = f11 ? n23 > i10 : e5 > o9 : t6 === "<=" ? c14 = f11 ? n23 <= i10 : e5 <= o9 : c14 = f11 ? n23 >= i10 : e5 >= o9, e5 = c14 ? "1" : "0";
      } else break;
    }
    return e5;
  }
  function p17() {
    let e5 = g18();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (t6 === "+" || t6 === "-") {
        r8++;
        let o9 = g18(), n23 = parseInt(e5, 10), i10 = parseInt(o9, 10);
        if (Number.isNaN(n23) || Number.isNaN(i10)) throw new Error("non-integer argument");
        e5 = String(t6 === "+" ? n23 + i10 : n23 - i10);
      } else break;
    }
    return e5;
  }
  function g18() {
    let e5 = N14();
    for (; r8 < s9.length; ) {
      let t6 = s9[r8];
      if (t6 === "*" || t6 === "/" || t6 === "%") {
        r8++;
        let o9 = N14(), n23 = parseInt(e5, 10), i10 = parseInt(o9, 10);
        if (Number.isNaN(n23) || Number.isNaN(i10)) throw new Error("non-integer argument");
        if ((t6 === "/" || t6 === "%") && i10 === 0) throw new Error("division by zero");
        t6 === "*" ? e5 = String(n23 * i10) : t6 === "/" ? e5 = String(Math.trunc(n23 / i10)) : e5 = String(n23 % i10);
      } else break;
    }
    return e5;
  }
  function N14() {
    let e5 = u10();
    for (; r8 < s9.length && s9[r8] === ":"; ) {
      r8++;
      let t6 = u10(), n23 = b1(`^${t6}`).match(e5);
      n23 ? e5 = n23[1] !== void 0 ? n23[1] : String(n23[0].length) : e5 = "0";
    }
    return e5;
  }
  function u10() {
    if (r8 >= s9.length) throw new Error("syntax error");
    let e5 = s9[r8];
    if (e5 === "match") {
      r8++;
      let t6 = u10(), o9 = u10(), i10 = b1(o9).match(t6);
      return i10 ? i10[1] !== void 0 ? i10[1] : String(i10[0].length) : "0";
    }
    if (e5 === "substr") {
      r8++;
      let t6 = u10(), o9 = parseInt(u10(), 10), n23 = parseInt(u10(), 10);
      if (Number.isNaN(o9) || Number.isNaN(n23)) throw new Error("non-integer argument");
      return t6.substring(o9 - 1, o9 - 1 + n23);
    }
    if (e5 === "index") {
      r8++;
      let t6 = u10(), o9 = u10();
      for (let n23 = 0; n23 < t6.length; n23++) if (o9.includes(t6[n23])) return String(n23 + 1);
      return "0";
    }
    if (e5 === "length") {
      r8++;
      let t6 = u10();
      return String(t6.length);
    }
    if (e5 === "(") {
      r8++;
      let t6 = l8();
      if (r8 >= s9.length || s9[r8] !== ")") throw new Error("syntax error");
      return r8++, t6;
    }
    return r8++, e5;
  }
  return l8();
}
var w15, b20;
var init_chunk_U7QI5ZS5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-U7QI5ZS5.js"() {
    init_chunk_YNYSPYQ5();
    w15 = { name: "expr", async execute(s9, r8) {
      if (s9.length === 0) return { stdout: "", stderr: `expr: missing operand
`, exitCode: 2 };
      try {
        let l8 = d13(s9), h16 = l8 === "0" || l8 === "" ? 1 : 0;
        return { stdout: `${l8}
`, stderr: "", exitCode: h16 };
      } catch (l8) {
        return { stdout: "", stderr: `expr: ${l8.message}
`, exitCode: 2 };
      }
    } };
    b20 = { name: "expr", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/expr-3572LAOT.js
var expr_3572LAOT_exports = {};
__export(expr_3572LAOT_exports, {
  exprCommand: () => w15,
  flagsForFuzzing: () => b20
});
var init_expr_3572LAOT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/expr-3572LAOT.js"() {
    init_chunk_U7QI5ZS5();
    init_chunk_YNYSPYQ5();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-EIZGF4BS.js
function L11(n23) {
  function h16(r8, u10) {
    return r8 << u10 | r8 >>> 32 - u10;
  }
  let g18 = new Uint32Array([3614090360, 3905402710, 606105819, 3250441966, 4118548399, 1200080426, 2821735955, 4249261313, 1770035416, 2336552879, 4294925233, 2304563134, 1804603682, 4254626195, 2792965006, 1236535329, 4129170786, 3225465664, 643717713, 3921069994, 3593408605, 38016083, 3634488961, 3889429448, 568446438, 3275163606, 4107603335, 1163531501, 2850285829, 4243563512, 1735328473, 2368359562, 4294588738, 2272392833, 1839030562, 4259657740, 2763975236, 1272893353, 4139469664, 3200236656, 681279174, 3936430074, 3572445317, 76029189, 3654602809, 3873151461, 530742520, 3299628645, 4096336452, 1126891415, 2878612391, 4237533241, 1700485571, 2399980690, 4293915773, 2240044497, 1873313359, 4264355552, 2734768916, 1309151649, 4149444226, 3174756917, 718787259, 3951481745]), A13 = [7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21], b25 = n23.length * 8, o9 = (n23.length % 64 < 56 ? 56 : 120) - n23.length % 64, s9 = new Uint8Array(n23.length + o9 + 8);
  s9.set(n23), s9[n23.length] = 128;
  let d16 = new DataView(s9.buffer);
  d16.setUint32(s9.length - 8, b25 >>> 0, true), d16.setUint32(s9.length - 4, Math.floor(b25 / 4294967296), true);
  let w19 = 1732584193, l8 = 4023233417, p17 = 2562383102, e5 = 271733878;
  for (let r8 = 0; r8 < s9.length; r8 += 64) {
    let u10 = new Uint32Array(16);
    for (let t6 = 0; t6 < 16; t6++) u10[t6] = d16.getUint32(r8 + t6 * 4, true);
    let U13 = w19, a7 = l8, x22 = p17, c14 = e5;
    for (let t6 = 0; t6 < 64; t6++) {
      let i10, $17;
      t6 < 16 ? (i10 = a7 & x22 | ~a7 & c14, $17 = t6) : t6 < 32 ? (i10 = c14 & a7 | ~c14 & x22, $17 = (5 * t6 + 1) % 16) : t6 < 48 ? (i10 = a7 ^ x22 ^ c14, $17 = (3 * t6 + 5) % 16) : (i10 = x22 ^ (a7 | ~c14), $17 = 7 * t6 % 16), i10 = i10 + U13 + g18[t6] + u10[$17] >>> 0, U13 = c14, c14 = x22, x22 = a7, a7 = a7 + h16(i10, A13[t6]) >>> 0;
    }
    w19 = w19 + U13 >>> 0, l8 = l8 + a7 >>> 0, p17 = p17 + x22 >>> 0, e5 = e5 + c14 >>> 0;
  }
  let f11 = new Uint8Array(16);
  return new DataView(f11.buffer).setUint32(0, w19, true), new DataView(f11.buffer).setUint32(4, l8, true), new DataView(f11.buffer).setUint32(8, p17, true), new DataView(f11.buffer).setUint32(12, e5, true), Array.from(f11).map((r8) => r8.toString(16).padStart(2, "0")).join("");
}
async function C14(n23, h16) {
  if (n23 === "md5") return L11(h16);
  let g18 = F15.get(n23);
  if (!g18) throw new Error(`Unknown algorithm: ${n23}`);
  let A13 = await globalThis.crypto.subtle.digest(g18, new Uint8Array(h16).buffer);
  return Array.from(new Uint8Array(A13)).map((b25) => b25.toString(16).padStart(2, "0")).join("");
}
function S8(n23, h16, g18) {
  let A13 = { name: n23, summary: g18, usage: `${n23} [OPTION]... [FILE]...`, options: ["-c, --check    read checksums from FILEs and check them", "    --help     display this help and exit"] };
  return { name: n23, async execute(b25, o9) {
    if (o2(b25)) return s(A13);
    let s9 = false, d16 = [];
    for (let e5 of b25) if (e5 === "-c" || e5 === "--check") s9 = true;
    else if (!(e5 === "-b" || e5 === "-t" || e5 === "--binary" || e5 === "--text")) {
      if (e5.startsWith("-") && e5 !== "-") return r3(n23, e5);
      d16.push(e5);
    }
    d16.length === 0 && d16.push("-");
    let w19 = async (e5) => {
      if (e5 === "-") return Uint8Array.from(o9.stdin, (f11) => f11.charCodeAt(0));
      try {
        return await o9.fs.readFileBuffer(o9.fs.resolvePath(o9.cwd, e5));
      } catch {
        return null;
      }
    };
    if (s9) {
      let e5 = 0, f11 = "";
      for (let r8 of d16) {
        let u10 = r8 === "-" ? o9.stdin : await o9.fs.readFile(o9.fs.resolvePath(o9.cwd, r8)).catch(() => null);
        if (u10 === null) return { stdout: "", stderr: `${n23}: ${r8}: No such file or directory
`, exitCode: 1 };
        for (let U13 of u10.split(`
`)) {
          let a7 = U13.match(/^([a-fA-F0-9]+)\s+[* ]?(.+)$/);
          if (!a7) continue;
          let [, x22, c14] = a7, t6 = await w19(c14);
          if (t6 === null) {
            f11 += `${c14}: FAILED open or read
`, e5++;
            continue;
          }
          let i10 = await C14(h16, t6) === x22.toLowerCase();
          f11 += `${c14}: ${i10 ? "OK" : "FAILED"}
`, i10 || e5++;
        }
      }
      return e5 > 0 && (f11 += `${n23}: WARNING: ${e5} computed checksum${e5 > 1 ? "s" : ""} did NOT match
`), { stdout: f11, stderr: "", exitCode: e5 > 0 ? 1 : 0 };
    }
    let l8 = "", p17 = 0;
    for (let e5 of d16) {
      let f11 = await w19(e5);
      if (f11 === null) {
        l8 += `${n23}: ${e5}: No such file or directory
`, p17 = 1;
        continue;
      }
      l8 += `${await C14(h16, f11)}  ${e5}
`;
    }
    return { stdout: l8, stderr: "", exitCode: p17 };
  } };
}
var F15;
var init_chunk_EIZGF4BS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-EIZGF4BS.js"() {
    init_chunk_74CEPOFO();
    F15 = /* @__PURE__ */ new Map([["sha1", "SHA-1"], ["sha256", "SHA-256"]]);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-APT7OOP2.js
var s6, o7;
var init_chunk_APT7OOP2 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-APT7OOP2.js"() {
    init_chunk_EIZGF4BS();
    s6 = S8("md5sum", "md5", "compute MD5 message digest");
    o7 = { name: "md5sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/md5sum-INMIK4DX.js
var md5sum_INMIK4DX_exports = {};
__export(md5sum_INMIK4DX_exports, {
  flagsForFuzzing: () => o7,
  md5sumCommand: () => s6
});
var init_md5sum_INMIK4DX = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/md5sum-INMIK4DX.js"() {
    init_chunk_APT7OOP2();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XKQRETAK.js
var a2, m19;
var init_chunk_XKQRETAK = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XKQRETAK.js"() {
    init_chunk_EIZGF4BS();
    a2 = S8("sha1sum", "sha1", "compute SHA1 message digest");
    m19 = { name: "sha1sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sha1sum-VJPNLNU6.js
var sha1sum_VJPNLNU6_exports = {};
__export(sha1sum_VJPNLNU6_exports, {
  flagsForFuzzing: () => m19,
  sha1sumCommand: () => a2
});
var init_sha1sum_VJPNLNU6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sha1sum-VJPNLNU6.js"() {
    init_chunk_XKQRETAK();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-5V6VZH6T.js
var a3, m20;
var init_chunk_5V6VZH6T = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-5V6VZH6T.js"() {
    init_chunk_EIZGF4BS();
    a3 = S8("sha256sum", "sha256", "compute SHA256 message digest");
    m20 = { name: "sha256sum", flags: [{ flag: "-c", type: "boolean" }], needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sha256sum-PI32XWXY.js
var sha256sum_PI32XWXY_exports = {};
__export(sha256sum_PI32XWXY_exports, {
  flagsForFuzzing: () => m20,
  sha256sumCommand: () => a3
});
var init_sha256sum_PI32XWXY = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sha256sum-PI32XWXY.js"() {
    init_chunk_5V6VZH6T();
    init_chunk_EIZGF4BS();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:fs/promises
var open;
var init_promises = __esm({
  "stub-node:node:fs/promises"() {
    open = () => {
    };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js
function oe4(i10) {
  try {
    let e5 = i10.getReader({ mode: "byob" });
    return e5 instanceof ReadableStreamDefaultReader ? new L12(e5) : new _7(e5);
  } catch (e5) {
    if (e5 instanceof TypeError) return new L12(i10.getReader());
    throw e5;
  }
}
function se4(i10, e5) {
  let t6 = oe4(i10), r8 = e5 ?? {}, n23 = r8.onClose;
  return r8.onClose = async () => {
    if (await t6.close(), n23) return n23();
  }, new X6(t6, r8);
}
function ve4(i10, e5) {
  return new Z8(i10, e5);
}
function Se2(i10, e5) {
  return new Q9(i10, e5);
}
function Ee3(i10, e5 = "utf-8") {
  switch (e5.toLowerCase()) {
    case "utf-8":
    case "utf8":
      return typeof globalThis.TextDecoder < "u" ? new globalThis.TextDecoder("utf-8").decode(i10) : lt3(i10);
    case "utf-16le":
      return ut2(i10);
    case "ascii":
      return xt2(i10);
    case "latin1":
    case "iso-8859-1":
      return dt3(i10);
    case "windows-1252":
      return ht2(i10);
    default:
      throw new RangeError(`Encoding '${e5}' not supported`);
  }
}
function lt3(i10) {
  let e5 = "", t6 = 0;
  for (; t6 < i10.length; ) {
    let r8 = i10[t6++];
    if (r8 < 128) e5 += String.fromCharCode(r8);
    else if (r8 < 224) {
      let n23 = i10[t6++] & 63;
      e5 += String.fromCharCode((r8 & 31) << 6 | n23);
    } else if (r8 < 240) {
      let n23 = i10[t6++] & 63, o9 = i10[t6++] & 63;
      e5 += String.fromCharCode((r8 & 15) << 12 | n23 << 6 | o9);
    } else {
      let n23 = i10[t6++] & 63, o9 = i10[t6++] & 63, s9 = i10[t6++] & 63, c14 = (r8 & 7) << 18 | n23 << 12 | o9 << 6 | s9;
      c14 -= 65536, e5 += String.fromCharCode(55296 + (c14 >> 10 & 1023), 56320 + (c14 & 1023));
    }
  }
  return e5;
}
function ut2(i10) {
  let e5 = "";
  for (let t6 = 0; t6 < i10.length; t6 += 2) e5 += String.fromCharCode(i10[t6] | i10[t6 + 1] << 8);
  return e5;
}
function xt2(i10) {
  return String.fromCharCode(...i10.map((e5) => e5 & 127));
}
function dt3(i10) {
  return String.fromCharCode(...i10);
}
function ht2(i10) {
  let e5 = "";
  for (let t6 of i10) t6 >= 128 && t6 <= 159 && ce4[t6] ? e5 += ce4[t6] : e5 += String.fromCharCode(t6);
  return e5;
}
function y14(i10) {
  return new DataView(i10.buffer, i10.byteOffset);
}
function Xe3(i10) {
  let e5 = new Uint8Array(h14.len);
  return h14.put(e5, 0, i10), e5;
}
function _t2(i10, e5) {
  let t6 = i10.length, r8 = e5.length;
  if (r8 > t6) return -1;
  for (let n23 = 0; n23 <= t6 - r8; n23++) {
    let o9 = true;
    for (let s9 = 0; s9 < r8; s9++) if (i10[n23 + s9] !== e5[s9]) {
      o9 = false;
      break;
    }
    if (o9) return n23;
  }
  return -1;
}
function $t2(i10) {
  let e5 = i10.reduce((n23, o9) => n23 + o9.length, 0), t6 = new Uint8Array(e5), r8 = 0;
  for (let n23 of i10) t6.set(n23, r8), r8 += n23.length;
  return t6;
}
function de6(i10) {
  let { byteLength: e5 } = i10;
  if (e5 === 6) return i10.getUint16(0) * 2 ** 32 + i10.getUint32(2);
  if (e5 === 5) return i10.getUint8(0) * 2 ** 32 + i10.getUint32(1);
  if (e5 === 4) return i10.getUint32(0);
  if (e5 === 3) return i10.getUint8(0) * 2 ** 16 + i10.getUint16(1);
  if (e5 === 2) return i10.getUint16(0);
  if (e5 === 1) return i10.getUint8(0);
}
function Ze4(i10, e5) {
  if (e5 === "utf-16le") {
    let t6 = [];
    for (let r8 = 0; r8 < i10.length; r8++) {
      let n23 = i10.charCodeAt(r8);
      t6.push(n23 & 255, n23 >> 8 & 255);
    }
    return t6;
  }
  if (e5 === "utf-16be") {
    let t6 = [];
    for (let r8 = 0; r8 < i10.length; r8++) {
      let n23 = i10.charCodeAt(r8);
      t6.push(n23 >> 8 & 255, n23 & 255);
    }
    return t6;
  }
  return [...i10].map((t6) => t6.charCodeAt(0));
}
function Qe3(i10, e5 = 0) {
  let t6 = Number.parseInt(new b21(6).get(i10, 148).replace(/\0.*$/, "").trim(), 8);
  if (Number.isNaN(t6)) return false;
  let r8 = 256;
  for (let n23 = e5; n23 < e5 + 148; n23++) r8 += i10[n23];
  for (let n23 = e5 + 156; n23 < e5 + 512; n23++) r8 += i10[n23];
  return t6 === r8;
}
async function ke3(i10, e5) {
  return new we2(e5).fromBuffer(i10);
}
function ge5(i10) {
  switch (i10 = i10.toLowerCase(), i10) {
    case "application/epub+zip":
      return { ext: "epub", mime: i10 };
    case "application/vnd.oasis.opendocument.text":
      return { ext: "odt", mime: i10 };
    case "application/vnd.oasis.opendocument.text-template":
      return { ext: "ott", mime: i10 };
    case "application/vnd.oasis.opendocument.spreadsheet":
      return { ext: "ods", mime: i10 };
    case "application/vnd.oasis.opendocument.spreadsheet-template":
      return { ext: "ots", mime: i10 };
    case "application/vnd.oasis.opendocument.presentation":
      return { ext: "odp", mime: i10 };
    case "application/vnd.oasis.opendocument.presentation-template":
      return { ext: "otp", mime: i10 };
    case "application/vnd.oasis.opendocument.graphics":
      return { ext: "odg", mime: i10 };
    case "application/vnd.oasis.opendocument.graphics-template":
      return { ext: "otg", mime: i10 };
    case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
      return { ext: "ppsx", mime: i10 };
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return { ext: "xlsx", mime: i10 };
    case "application/vnd.ms-excel.sheet.macroenabled":
      return { ext: "xlsm", mime: "application/vnd.ms-excel.sheet.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
      return { ext: "xltx", mime: i10 };
    case "application/vnd.ms-excel.template.macroenabled":
      return { ext: "xltm", mime: "application/vnd.ms-excel.template.macroenabled.12" };
    case "application/vnd.ms-powerpoint.slideshow.macroenabled":
      return { ext: "ppsm", mime: "application/vnd.ms-powerpoint.slideshow.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return { ext: "docx", mime: i10 };
    case "application/vnd.ms-word.document.macroenabled":
      return { ext: "docm", mime: "application/vnd.ms-word.document.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      return { ext: "dotx", mime: i10 };
    case "application/vnd.ms-word.template.macroenabledtemplate":
      return { ext: "dotm", mime: "application/vnd.ms-word.template.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.presentationml.template":
      return { ext: "potx", mime: i10 };
    case "application/vnd.ms-powerpoint.template.macroenabled":
      return { ext: "potm", mime: "application/vnd.ms-powerpoint.template.macroenabled.12" };
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return { ext: "pptx", mime: i10 };
    case "application/vnd.ms-powerpoint.presentation.macroenabled":
      return { ext: "pptm", mime: "application/vnd.ms-powerpoint.presentation.macroenabled.12" };
    case "application/vnd.ms-visio.drawing":
      return { ext: "vsdx", mime: "application/vnd.visio" };
    case "application/vnd.ms-package.3dmanufacturing-3dmodel+xml":
      return { ext: "3mf", mime: "model/3mf" };
    default:
  }
}
function A8(i10, e5, t6) {
  t6 = { offset: 0, ...t6 };
  for (let [r8, n23] of e5.entries()) if (t6.mask) {
    if (n23 !== (t6.mask[r8] & i10[r8 + t6.offset])) return false;
  } else if (n23 !== i10[r8 + t6.offset]) return false;
  return true;
}
function Jt2(i10, e5) {
  let t6 = Gt2.get(i10);
  if (t6) return t6;
  let [r8, n23] = e5.split("/"), o9 = n23?.split("+")[0]?.replace(/-/g, " ") || i10;
  switch (r8) {
    case "image":
      return `${o9.toUpperCase()} image data`;
    case "audio":
      return `${o9.toUpperCase()} audio`;
    case "video":
      return `${o9.toUpperCase()} video`;
    case "font":
      return `${o9} font`;
    case "model":
      return `${o9} 3D model`;
    case "application":
      return n23?.includes("zip") || n23?.includes("compressed") ? `${o9} archive data` : n23?.includes("executable") ? `${o9} executable` : `${i10.toUpperCase()} data`;
    default:
      return `${i10.toUpperCase()} data`;
  }
}
function Xt2(i10) {
  let e5 = i10.split("/").pop() || i10;
  if (e5.startsWith(".") && !e5.includes(".", 1)) return e5;
  let t6 = e5.lastIndexOf(".");
  return t6 === -1 || t6 === 0 ? "" : e5.slice(t6).toLowerCase();
}
function Zt2(i10, e5) {
  if (i10.startsWith("#!")) {
    let m24 = i10.split(`
`)[0];
    return m24.includes("python") ? { description: "Python script, ASCII text executable", mime: "text/x-python" } : m24.includes("node") || m24.includes("bun") || m24.includes("deno") ? { description: "JavaScript script, ASCII text executable", mime: "text/javascript" } : m24.includes("bash") ? { description: "Bourne-Again shell script, ASCII text executable", mime: "text/x-shellscript" } : m24.includes("sh") ? { description: "POSIX shell script, ASCII text executable", mime: "text/x-shellscript" } : m24.includes("ruby") ? { description: "Ruby script, ASCII text executable", mime: "text/x-ruby" } : m24.includes("perl") ? { description: "Perl script, ASCII text executable", mime: "text/x-perl" } : { description: "script, ASCII text executable", mime: "text/plain" };
  }
  let t6 = i10.trimStart();
  if (t6.startsWith("<?xml")) return { description: "XML document", mime: "application/xml" };
  if (t6.startsWith("<!DOCTYPE html") || t6.toLowerCase().startsWith("<html")) return { description: "HTML document", mime: "text/html" };
  let r8 = i10.includes(`\r
`), n23 = i10.includes("\r") && !r8, o9 = "";
  r8 ? o9 = ", with CRLF line terminators" : n23 && (o9 = ", with CR line terminators");
  let s9 = Xt2(e5), c14 = s9 ? qt2.get(s9) : void 0;
  if (c14) return c14.mime.startsWith("text/") && o9 ? { description: `${c14.description}${o9}`, mime: c14.mime } : c14;
  let p17 = false;
  for (let m24 = 0; m24 < Math.min(i10.length, 8192); m24++) if (i10.charCodeAt(m24) > 127) {
    p17 = true;
    break;
  }
  return p17 ? { description: `UTF-8 Unicode text${o9}`, mime: "text/plain; charset=utf-8" } : { description: `ASCII text${o9}`, mime: "text/plain" };
}
async function Qt2(i10, e5) {
  if (e5.length === 0) return { description: "empty", mime: "inode/x-empty" };
  let t6 = await ke3(e5);
  if (t6) return { description: Jt2(t6.ext, t6.mime), mime: t6.mime };
  let r8 = new TextDecoder("utf-8", { fatal: false }).decode(e5);
  return Zt2(r8, i10);
}
var Te2, ze3, fe7, Le3, je4, _e2, He3, We2, nt4, x16, D11, M9, J9, _7, L12, S9, st4, X6, Z8, Q9, $13, ft3, Ae3, ce4, mt3, Be2, d14, R5, h14, Ie4, Oe2, De3, b21, Je3, U9, ue6, Ve2, qe2, Ge3, E7, xe4, Nt3, ie3, H12, W9, ur, xr2, dr, Ye3, Ke3, et4, he6, we2, Ht2, Wt2, Vt, qt2, Gt2, Dr2, Mr2;
var init_chunk_CR5AFCPT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js"() {
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    init_promises();
    Te2 = o((ae8) => {
      ae8.read = function(i10, e5, t6, r8, n23) {
        var o9, s9, c14 = n23 * 8 - r8 - 1, p17 = (1 << c14) - 1, m24 = p17 >> 1, a7 = -7, f11 = t6 ? n23 - 1 : 0, l8 = t6 ? -1 : 1, u10 = i10[e5 + f11];
        for (f11 += l8, o9 = u10 & (1 << -a7) - 1, u10 >>= -a7, a7 += c14; a7 > 0; o9 = o9 * 256 + i10[e5 + f11], f11 += l8, a7 -= 8) ;
        for (s9 = o9 & (1 << -a7) - 1, o9 >>= -a7, a7 += r8; a7 > 0; s9 = s9 * 256 + i10[e5 + f11], f11 += l8, a7 -= 8) ;
        if (o9 === 0) o9 = 1 - m24;
        else {
          if (o9 === p17) return s9 ? NaN : (u10 ? -1 : 1) * (1 / 0);
          s9 = s9 + Math.pow(2, r8), o9 = o9 - m24;
        }
        return (u10 ? -1 : 1) * s9 * Math.pow(2, o9 - r8);
      };
      ae8.write = function(i10, e5, t6, r8, n23, o9) {
        var s9, c14, p17, m24 = o9 * 8 - n23 - 1, a7 = (1 << m24) - 1, f11 = a7 >> 1, l8 = n23 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, u10 = r8 ? 0 : o9 - 1, T10 = r8 ? 1 : -1, k15 = e5 < 0 || e5 === 0 && 1 / e5 < 0 ? 1 : 0;
        for (e5 = Math.abs(e5), isNaN(e5) || e5 === 1 / 0 ? (c14 = isNaN(e5) ? 1 : 0, s9 = a7) : (s9 = Math.floor(Math.log(e5) / Math.LN2), e5 * (p17 = Math.pow(2, -s9)) < 1 && (s9--, p17 *= 2), s9 + f11 >= 1 ? e5 += l8 / p17 : e5 += l8 * Math.pow(2, 1 - f11), e5 * p17 >= 2 && (s9++, p17 /= 2), s9 + f11 >= a7 ? (c14 = 0, s9 = a7) : s9 + f11 >= 1 ? (c14 = (e5 * p17 - 1) * Math.pow(2, n23), s9 = s9 + f11) : (c14 = e5 * Math.pow(2, f11 - 1) * Math.pow(2, n23), s9 = 0)); n23 >= 8; i10[t6 + u10] = c14 & 255, u10 += T10, c14 /= 256, n23 -= 8) ;
        for (s9 = s9 << n23 | c14, m24 += n23; m24 > 0; i10[t6 + u10] = s9 & 255, u10 += T10, s9 /= 256, m24 -= 8) ;
        i10[t6 + u10 - T10] |= k15 * 128;
      };
    });
    ze3 = o((Ki, Me6) => {
      var j11 = 1e3, P19 = j11 * 60, N14 = P19 * 60, z10 = N14 * 24, wt4 = z10 * 7, kt4 = z10 * 365.25;
      Me6.exports = function(i10, e5) {
        e5 = e5 || {};
        var t6 = typeof i10;
        if (t6 === "string" && i10.length > 0) return yt4(i10);
        if (t6 === "number" && isFinite(i10)) return e5.long ? Ct5(i10) : bt3(i10);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(i10));
      };
      function yt4(i10) {
        if (i10 = String(i10), !(i10.length > 100)) {
          var e5 = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(i10);
          if (e5) {
            var t6 = parseFloat(e5[1]), r8 = (e5[2] || "ms").toLowerCase();
            switch (r8) {
              case "years":
              case "year":
              case "yrs":
              case "yr":
              case "y":
                return t6 * kt4;
              case "weeks":
              case "week":
              case "w":
                return t6 * wt4;
              case "days":
              case "day":
              case "d":
                return t6 * z10;
              case "hours":
              case "hour":
              case "hrs":
              case "hr":
              case "h":
                return t6 * N14;
              case "minutes":
              case "minute":
              case "mins":
              case "min":
              case "m":
                return t6 * P19;
              case "seconds":
              case "second":
              case "secs":
              case "sec":
              case "s":
                return t6 * j11;
              case "milliseconds":
              case "millisecond":
              case "msecs":
              case "msec":
              case "ms":
                return t6;
              default:
                return;
            }
          }
        }
      }
      function bt3(i10) {
        var e5 = Math.abs(i10);
        return e5 >= z10 ? Math.round(i10 / z10) + "d" : e5 >= N14 ? Math.round(i10 / N14) + "h" : e5 >= P19 ? Math.round(i10 / P19) + "m" : e5 >= j11 ? Math.round(i10 / j11) + "s" : i10 + "ms";
      }
      function Ct5(i10) {
        var e5 = Math.abs(i10);
        return e5 >= z10 ? Y10(i10, e5, z10, "day") : e5 >= N14 ? Y10(i10, e5, N14, "hour") : e5 >= P19 ? Y10(i10, e5, P19, "minute") : e5 >= j11 ? Y10(i10, e5, j11, "second") : i10 + " ms";
      }
      function Y10(i10, e5, t6, r8) {
        var n23 = e5 >= t6 * 1.5;
        return Math.round(i10 / t6) + " " + r8 + (n23 ? "s" : "");
      }
    });
    fe7 = o((er, Ue5) => {
      function Ft3(i10) {
        t6.debug = t6, t6.default = t6, t6.coerce = p17, t6.disable = s9, t6.enable = n23, t6.enabled = c14, t6.humanize = ze3(), t6.destroy = m24, Object.keys(i10).forEach((a7) => {
          t6[a7] = i10[a7];
        }), t6.names = [], t6.skips = [], t6.formatters = {};
        function e5(a7) {
          let f11 = 0;
          for (let l8 = 0; l8 < a7.length; l8++) f11 = (f11 << 5) - f11 + a7.charCodeAt(l8), f11 |= 0;
          return t6.colors[Math.abs(f11) % t6.colors.length];
        }
        t6.selectColor = e5;
        function t6(a7) {
          let f11, l8 = null, u10, T10;
          function k15(...F20) {
            if (!k15.enabled) return;
            let O16 = k15, V13 = Number(/* @__PURE__ */ new Date()), tt7 = V13 - (f11 || V13);
            O16.diff = tt7, O16.prev = f11, O16.curr = V13, f11 = V13, F20[0] = t6.coerce(F20[0]), typeof F20[0] != "string" && F20.unshift("%O");
            let q15 = 0;
            F20[0] = F20[0].replace(/%([a-zA-Z%])/g, (re5, it6) => {
              if (re5 === "%%") return "%";
              q15++;
              let ye7 = t6.formatters[it6];
              if (typeof ye7 == "function") {
                let rt6 = F20[q15];
                re5 = ye7.call(O16, rt6), F20.splice(q15, 1), q15--;
              }
              return re5;
            }), t6.formatArgs.call(O16, F20), (O16.log || t6.log).apply(O16, F20);
          }
          return k15.namespace = a7, k15.useColors = t6.useColors(), k15.color = t6.selectColor(a7), k15.extend = r8, k15.destroy = t6.destroy, Object.defineProperty(k15, "enabled", { enumerable: true, configurable: false, get: () => l8 !== null ? l8 : (u10 !== t6.namespaces && (u10 = t6.namespaces, T10 = t6.enabled(a7)), T10), set: (F20) => {
            l8 = F20;
          } }), typeof t6.init == "function" && t6.init(k15), k15;
        }
        function r8(a7, f11) {
          let l8 = t6(this.namespace + (typeof f11 > "u" ? ":" : f11) + a7);
          return l8.log = this.log, l8;
        }
        function n23(a7) {
          t6.save(a7), t6.namespaces = a7, t6.names = [], t6.skips = [];
          let f11 = (typeof a7 == "string" ? a7 : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
          for (let l8 of f11) l8[0] === "-" ? t6.skips.push(l8.slice(1)) : t6.names.push(l8);
        }
        function o9(a7, f11) {
          let l8 = 0, u10 = 0, T10 = -1, k15 = 0;
          for (; l8 < a7.length; ) if (u10 < f11.length && (f11[u10] === a7[l8] || f11[u10] === "*")) f11[u10] === "*" ? (T10 = u10, k15 = l8, u10++) : (l8++, u10++);
          else if (T10 !== -1) u10 = T10 + 1, k15++, l8 = k15;
          else return false;
          for (; u10 < f11.length && f11[u10] === "*"; ) u10++;
          return u10 === f11.length;
        }
        function s9() {
          let a7 = [...t6.names, ...t6.skips.map((f11) => "-" + f11)].join(",");
          return t6.enable(""), a7;
        }
        function c14(a7) {
          for (let f11 of t6.skips) if (o9(a7, f11)) return false;
          for (let f11 of t6.names) if (o9(a7, f11)) return true;
          return false;
        }
        function p17(a7) {
          return a7 instanceof Error ? a7.stack || a7.message : a7;
        }
        function m24() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        return t6.enable(t6.load()), t6;
      }
      Ue5.exports = Ft3;
    });
    Le3 = o((C19, K9) => {
      C19.formatArgs = St5;
      C19.save = Tt6;
      C19.load = Et4;
      C19.useColors = vt4;
      C19.storage = At4();
      C19.destroy = /* @__PURE__ */ (() => {
        let i10 = false;
        return () => {
          i10 || (i10 = true, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
        };
      })();
      C19.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
      function vt4() {
        if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
        if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
        let i10;
        return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (i10 = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(i10[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      function St5(i10) {
        if (i10[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + i10[0] + (this.useColors ? "%c " : " ") + "+" + K9.exports.humanize(this.diff), !this.useColors) return;
        let e5 = "color: " + this.color;
        i10.splice(1, 0, e5, "color: inherit");
        let t6 = 0, r8 = 0;
        i10[0].replace(/%[a-zA-Z%]/g, (n23) => {
          n23 !== "%%" && (t6++, n23 === "%c" && (r8 = t6));
        }), i10.splice(r8, 0, e5);
      }
      C19.log = console.debug || console.log || (() => {
      });
      function Tt6(i10) {
        try {
          i10 ? C19.storage.setItem("debug", i10) : C19.storage.removeItem("debug");
        } catch {
        }
      }
      function Et4() {
        let i10;
        try {
          i10 = C19.storage.getItem("debug") || C19.storage.getItem("DEBUG");
        } catch {
        }
        return !i10 && typeof process < "u" && "env" in process && (i10 = process.env.DEBUG), i10;
      }
      function At4() {
        try {
          return localStorage;
        } catch {
        }
      }
      K9.exports = fe7()(C19);
      var { formatters: Bt2 } = K9.exports;
      Bt2.j = function(i10) {
        try {
          return JSON.stringify(i10);
        } catch (e5) {
          return "[UnexpectedJSONParseError]: " + e5.message;
        }
      };
    });
    je4 = o((tr, Re7) => {
      "use strict";
      Re7.exports = (i10, e5 = process.argv) => {
        let t6 = i10.startsWith("-") ? "" : i10.length === 1 ? "-" : "--", r8 = e5.indexOf(t6 + i10), n23 = e5.indexOf("--");
        return r8 !== -1 && (n23 === -1 || r8 < n23);
      };
    });
    _e2 = o((ir, Ne6) => {
      "use strict";
      var It3 = m3("os"), Pe6 = m3("tty"), v20 = je4(), { env: g18 } = process, I17;
      v20("no-color") || v20("no-colors") || v20("color=false") || v20("color=never") ? I17 = 0 : (v20("color") || v20("colors") || v20("color=true") || v20("color=always")) && (I17 = 1);
      "FORCE_COLOR" in g18 && (g18.FORCE_COLOR === "true" ? I17 = 1 : g18.FORCE_COLOR === "false" ? I17 = 0 : I17 = g18.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(g18.FORCE_COLOR, 10), 3));
      function pe8(i10) {
        return i10 === 0 ? false : { level: i10, hasBasic: true, has256: i10 >= 2, has16m: i10 >= 3 };
      }
      function me5(i10, e5) {
        if (I17 === 0) return 0;
        if (v20("color=16m") || v20("color=full") || v20("color=truecolor")) return 3;
        if (v20("color=256")) return 2;
        if (i10 && !e5 && I17 === void 0) return 0;
        let t6 = I17 || 0;
        if (g18.TERM === "dumb") return t6;
        if (process.platform === "win32") {
          let r8 = It3.release().split(".");
          return Number(r8[0]) >= 10 && Number(r8[2]) >= 10586 ? Number(r8[2]) >= 14931 ? 3 : 2 : 1;
        }
        if ("CI" in g18) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI", "GITHUB_ACTIONS", "BUILDKITE"].some((r8) => r8 in g18) || g18.CI_NAME === "codeship" ? 1 : t6;
        if ("TEAMCITY_VERSION" in g18) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(g18.TEAMCITY_VERSION) ? 1 : 0;
        if (g18.COLORTERM === "truecolor") return 3;
        if ("TERM_PROGRAM" in g18) {
          let r8 = parseInt((g18.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
          switch (g18.TERM_PROGRAM) {
            case "iTerm.app":
              return r8 >= 3 ? 3 : 2;
            case "Apple_Terminal":
              return 2;
          }
        }
        return /-256(color)?$/i.test(g18.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(g18.TERM) || "COLORTERM" in g18 ? 1 : t6;
      }
      function Ot5(i10) {
        let e5 = me5(i10, i10 && i10.isTTY);
        return pe8(e5);
      }
      Ne6.exports = { supportsColor: Ot5, stdout: pe8(me5(true, Pe6.isatty(1))), stderr: pe8(me5(true, Pe6.isatty(2))) };
    });
    He3 = o((w19, te9) => {
      var Dt2 = m3("tty"), ee7 = m3("util");
      w19.init = Pt3;
      w19.log = Lt5;
      w19.formatArgs = zt3;
      w19.save = Rt2;
      w19.load = jt3;
      w19.useColors = Mt3;
      w19.destroy = ee7.deprecate(() => {
      }, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
      w19.colors = [6, 2, 3, 4, 5, 1];
      try {
        let i10 = _e2();
        i10 && (i10.stderr || i10).level >= 2 && (w19.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
      } catch {
      }
      w19.inspectOpts = Object.keys(process.env).filter((i10) => /^debug_/i.test(i10)).reduce((i10, e5) => {
        let t6 = e5.substring(6).toLowerCase().replace(/_([a-z])/g, (n23, o9) => o9.toUpperCase()), r8 = process.env[e5];
        return /^(yes|on|true|enabled)$/i.test(r8) ? r8 = true : /^(no|off|false|disabled)$/i.test(r8) ? r8 = false : r8 === "null" ? r8 = null : r8 = Number(r8), i10[t6] = r8, i10;
      }, {});
      function Mt3() {
        return "colors" in w19.inspectOpts ? !!w19.inspectOpts.colors : Dt2.isatty(process.stderr.fd);
      }
      function zt3(i10) {
        let { namespace: e5, useColors: t6 } = this;
        if (t6) {
          let r8 = this.color, n23 = "\x1B[3" + (r8 < 8 ? r8 : "8;5;" + r8), o9 = `  ${n23};1m${e5} \x1B[0m`;
          i10[0] = o9 + i10[0].split(`
`).join(`
` + o9), i10.push(n23 + "m+" + te9.exports.humanize(this.diff) + "\x1B[0m");
        } else i10[0] = Ut3() + e5 + " " + i10[0];
      }
      function Ut3() {
        return w19.inspectOpts.hideDate ? "" : (/* @__PURE__ */ new Date()).toISOString() + " ";
      }
      function Lt5(...i10) {
        return process.stderr.write(ee7.formatWithOptions(w19.inspectOpts, ...i10) + `
`);
      }
      function Rt2(i10) {
        i10 ? process.env.DEBUG = i10 : delete process.env.DEBUG;
      }
      function jt3() {
        return process.env.DEBUG;
      }
      function Pt3(i10) {
        i10.inspectOpts = {};
        let e5 = Object.keys(w19.inspectOpts);
        for (let t6 = 0; t6 < e5.length; t6++) i10.inspectOpts[e5[t6]] = w19.inspectOpts[e5[t6]];
      }
      te9.exports = fe7()(w19);
      var { formatters: $e6 } = te9.exports;
      $e6.o = function(i10) {
        return this.inspectOpts.colors = this.useColors, ee7.inspect(i10, this.inspectOpts).split(`
`).map((e5) => e5.trim()).join(" ");
      };
      $e6.O = function(i10) {
        return this.inspectOpts.colors = this.useColors, ee7.inspect(i10, this.inspectOpts);
      };
    });
    We2 = o((rr, le8) => {
      typeof process > "u" || process.type === "renderer" || process.browser === true || process.__nwjs ? le8.exports = Le3() : le8.exports = He3();
    });
    nt4 = "End-Of-Stream";
    x16 = class extends Error {
      constructor() {
        super(nt4), this.name = "EndOfStreamError";
      }
    };
    D11 = class extends Error {
      constructor(e5 = "The operation was aborted") {
        super(e5), this.name = "AbortError";
      }
    };
    M9 = class {
      constructor() {
        this.endOfStream = false, this.interrupted = false, this.peekQueue = [];
      }
      async peek(e5, t6 = false) {
        let r8 = await this.read(e5, t6);
        return this.peekQueue.push(e5.subarray(0, r8)), r8;
      }
      async read(e5, t6 = false) {
        if (e5.length === 0) return 0;
        let r8 = this.readFromPeekBuffer(e5);
        if (this.endOfStream || (r8 += await this.readRemainderFromStream(e5.subarray(r8), t6)), r8 === 0 && !t6) throw new x16();
        return r8;
      }
      readFromPeekBuffer(e5) {
        let t6 = e5.length, r8 = 0;
        for (; this.peekQueue.length > 0 && t6 > 0; ) {
          let n23 = this.peekQueue.pop();
          if (!n23) throw new Error("peekData should be defined");
          let o9 = Math.min(n23.length, t6);
          e5.set(n23.subarray(0, o9), r8), r8 += o9, t6 -= o9, o9 < n23.length && this.peekQueue.push(n23.subarray(o9));
        }
        return r8;
      }
      async readRemainderFromStream(e5, t6) {
        let r8 = 0;
        for (; r8 < e5.length && !this.endOfStream; ) {
          if (this.interrupted) throw new D11();
          let n23 = await this.readFromStream(e5.subarray(r8), t6);
          if (n23 === 0) break;
          r8 += n23;
        }
        if (!t6 && r8 < e5.length) throw new x16();
        return r8;
      }
    };
    J9 = class extends M9 {
      constructor(e5) {
        super(), this.reader = e5;
      }
      async abort() {
        return this.close();
      }
      async close() {
        this.reader.releaseLock();
      }
    };
    _7 = class extends J9 {
      async readFromStream(e5, t6) {
        if (e5.length === 0) return 0;
        let r8 = await this.reader.read(new Uint8Array(e5.length), { min: t6 ? void 0 : e5.length });
        return r8.done && (this.endOfStream = r8.done), r8.value ? (e5.set(r8.value), r8.value.length) : 0;
      }
    };
    L12 = class extends M9 {
      constructor(e5) {
        super(), this.reader = e5, this.buffer = null;
      }
      writeChunk(e5, t6) {
        let r8 = Math.min(t6.length, e5.length);
        return e5.set(t6.subarray(0, r8)), r8 < t6.length ? this.buffer = t6.subarray(r8) : this.buffer = null, r8;
      }
      async readFromStream(e5, t6) {
        if (e5.length === 0) return 0;
        let r8 = 0;
        for (this.buffer && (r8 += this.writeChunk(e5, this.buffer)); r8 < e5.length && !this.endOfStream; ) {
          let n23 = await this.reader.read();
          if (n23.done) {
            this.endOfStream = true;
            break;
          }
          n23.value && (r8 += this.writeChunk(e5.subarray(r8), n23.value));
        }
        if (!t6 && r8 === 0 && this.endOfStream) throw new x16();
        return r8;
      }
      abort() {
        return this.interrupted = true, this.reader.cancel();
      }
      async close() {
        await this.abort(), this.reader.releaseLock();
      }
    };
    S9 = class {
      constructor(e5) {
        this.numBuffer = new Uint8Array(8), this.position = 0, this.onClose = e5?.onClose, e5?.abortSignal && e5.abortSignal.addEventListener("abort", () => {
          this.abort();
        });
      }
      async readToken(e5, t6 = this.position) {
        let r8 = new Uint8Array(e5.len);
        if (await this.readBuffer(r8, { position: t6 }) < e5.len) throw new x16();
        return e5.get(r8, 0);
      }
      async peekToken(e5, t6 = this.position) {
        let r8 = new Uint8Array(e5.len);
        if (await this.peekBuffer(r8, { position: t6 }) < e5.len) throw new x16();
        return e5.get(r8, 0);
      }
      async readNumber(e5) {
        if (await this.readBuffer(this.numBuffer, { length: e5.len }) < e5.len) throw new x16();
        return e5.get(this.numBuffer, 0);
      }
      async peekNumber(e5) {
        if (await this.peekBuffer(this.numBuffer, { length: e5.len }) < e5.len) throw new x16();
        return e5.get(this.numBuffer, 0);
      }
      async ignore(e5) {
        if (this.fileInfo.size !== void 0) {
          let t6 = this.fileInfo.size - this.position;
          if (e5 > t6) return this.position += t6, t6;
        }
        return this.position += e5, e5;
      }
      async close() {
        await this.abort(), await this.onClose?.();
      }
      normalizeOptions(e5, t6) {
        if (!this.supportsRandomAccess() && t6 && t6.position !== void 0 && t6.position < this.position) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
        return { mayBeLess: false, offset: 0, length: e5.length, position: this.position, ...t6 };
      }
      abort() {
        return Promise.resolve();
      }
    };
    st4 = 256e3;
    X6 = class extends S9 {
      constructor(e5, t6) {
        super(t6), this.streamReader = e5, this.fileInfo = t6?.fileInfo ?? {};
      }
      async readBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6), n23 = r8.position - this.position;
        if (n23 > 0) return await this.ignore(n23), this.readBuffer(e5, t6);
        if (n23 < 0) throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
        if (r8.length === 0) return 0;
        let o9 = await this.streamReader.read(e5.subarray(0, r8.length), r8.mayBeLess);
        if (this.position += o9, (!t6 || !t6.mayBeLess) && o9 < r8.length) throw new x16();
        return o9;
      }
      async peekBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6), n23 = 0;
        if (r8.position) {
          let o9 = r8.position - this.position;
          if (o9 > 0) {
            let s9 = new Uint8Array(r8.length + o9);
            return n23 = await this.peekBuffer(s9, { mayBeLess: r8.mayBeLess }), e5.set(s9.subarray(o9)), n23 - o9;
          }
          if (o9 < 0) throw new Error("Cannot peek from a negative offset in a stream");
        }
        if (r8.length > 0) {
          try {
            n23 = await this.streamReader.peek(e5.subarray(0, r8.length), r8.mayBeLess);
          } catch (o9) {
            if (t6?.mayBeLess && o9 instanceof x16) return 0;
            throw o9;
          }
          if (!r8.mayBeLess && n23 < r8.length) throw new x16();
        }
        return n23;
      }
      async ignore(e5) {
        let t6 = Math.min(st4, e5), r8 = new Uint8Array(t6), n23 = 0;
        for (; n23 < e5; ) {
          let o9 = e5 - n23, s9 = await this.readBuffer(r8, { length: Math.min(t6, o9) });
          if (s9 < 0) return s9;
          n23 += s9;
        }
        return n23;
      }
      abort() {
        return this.streamReader.abort();
      }
      async close() {
        return this.streamReader.close();
      }
      supportsRandomAccess() {
        return false;
      }
    };
    Z8 = class extends S9 {
      constructor(e5, t6) {
        super(t6), this.uint8Array = e5, this.fileInfo = { ...t6?.fileInfo ?? {}, size: e5.length };
      }
      async readBuffer(e5, t6) {
        t6?.position && (this.position = t6.position);
        let r8 = await this.peekBuffer(e5, t6);
        return this.position += r8, r8;
      }
      async peekBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6), n23 = Math.min(this.uint8Array.length - r8.position, r8.length);
        if (!r8.mayBeLess && n23 < r8.length) throw new x16();
        return e5.set(this.uint8Array.subarray(r8.position, r8.position + n23)), n23;
      }
      close() {
        return super.close();
      }
      supportsRandomAccess() {
        return true;
      }
      setPosition(e5) {
        this.position = e5;
      }
    };
    Q9 = class extends S9 {
      constructor(e5, t6) {
        super(t6), this.blob = e5, this.fileInfo = { ...t6?.fileInfo ?? {}, size: e5.size, mimeType: e5.type };
      }
      async readBuffer(e5, t6) {
        t6?.position && (this.position = t6.position);
        let r8 = await this.peekBuffer(e5, t6);
        return this.position += r8, r8;
      }
      async peekBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6), n23 = Math.min(this.blob.size - r8.position, r8.length);
        if (!r8.mayBeLess && n23 < r8.length) throw new x16();
        let o9 = await this.blob.slice(r8.position, r8.position + n23).arrayBuffer();
        return e5.set(new Uint8Array(o9)), n23;
      }
      close() {
        return super.close();
      }
      supportsRandomAccess() {
        return true;
      }
      setPosition(e5) {
        this.position = e5;
      }
    };
    $13 = class i6 extends S9 {
      static async fromFile(e5) {
        let t6 = await open(e5, "r"), r8 = await t6.stat();
        return new i6(t6, { fileInfo: { path: e5, size: r8.size } });
      }
      constructor(e5, t6) {
        super(t6), this.fileHandle = e5, this.fileInfo = t6.fileInfo;
      }
      async readBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6);
        if (this.position = r8.position, r8.length === 0) return 0;
        let n23 = await this.fileHandle.read(e5, 0, r8.length, r8.position);
        if (this.position += n23.bytesRead, n23.bytesRead < r8.length && (!t6 || !t6.mayBeLess)) throw new x16();
        return n23.bytesRead;
      }
      async peekBuffer(e5, t6) {
        let r8 = this.normalizeOptions(e5, t6), n23 = await this.fileHandle.read(e5, 0, r8.length, r8.position);
        if (!r8.mayBeLess && n23.bytesRead < r8.length) throw new x16();
        return n23.bytesRead;
      }
      async close() {
        return await this.fileHandle.close(), super.close();
      }
      setPosition(e5) {
        this.position = e5;
      }
      supportsRandomAccess() {
        return true;
      }
    };
    ft3 = $13.fromFile;
    Ae3 = q2(Te2(), 1);
    ce4 = { 128: "\u20AC", 130: "\u201A", 131: "\u0192", 132: "\u201E", 133: "\u2026", 134: "\u2020", 135: "\u2021", 136: "\u02C6", 137: "\u2030", 138: "\u0160", 139: "\u2039", 140: "\u0152", 142: "\u017D", 145: "\u2018", 146: "\u2019", 147: "\u201C", 148: "\u201D", 149: "\u2022", 150: "\u2013", 151: "\u2014", 152: "\u02DC", 153: "\u2122", 154: "\u0161", 155: "\u203A", 156: "\u0153", 158: "\u017E", 159: "\u0178" };
    mt3 = {};
    for (let [i10, e5] of Object.entries(ce4)) mt3[e5] = Number.parseInt(i10);
    Be2 = { len: 1, get(i10, e5) {
      return y14(i10).getUint8(e5);
    }, put(i10, e5, t6) {
      return y14(i10).setUint8(e5, t6), e5 + 1;
    } };
    d14 = { len: 2, get(i10, e5) {
      return y14(i10).getUint16(e5, true);
    }, put(i10, e5, t6) {
      return y14(i10).setUint16(e5, t6, true), e5 + 2;
    } };
    R5 = { len: 2, get(i10, e5) {
      return y14(i10).getUint16(e5);
    }, put(i10, e5, t6) {
      return y14(i10).setUint16(e5, t6), e5 + 2;
    } };
    h14 = { len: 4, get(i10, e5) {
      return y14(i10).getUint32(e5, true);
    }, put(i10, e5, t6) {
      return y14(i10).setUint32(e5, t6, true), e5 + 4;
    } };
    Ie4 = { len: 4, get(i10, e5) {
      return y14(i10).getUint32(e5);
    }, put(i10, e5, t6) {
      return y14(i10).setUint32(e5, t6), e5 + 4;
    } };
    Oe2 = { len: 4, get(i10, e5) {
      return y14(i10).getInt32(e5);
    }, put(i10, e5, t6) {
      return y14(i10).setInt32(e5, t6), e5 + 4;
    } };
    De3 = { len: 8, get(i10, e5) {
      return y14(i10).getBigUint64(e5, true);
    }, put(i10, e5, t6) {
      return y14(i10).setBigUint64(e5, t6, true), e5 + 8;
    } };
    b21 = class {
      constructor(e5, t6) {
        this.len = e5, this.encoding = t6;
      }
      get(e5, t6 = 0) {
        let r8 = e5.subarray(t6, t6 + this.len);
        return Ee3(r8, this.encoding);
      }
    };
    Je3 = q2(We2(), 1);
    U9 = { LocalFileHeader: 67324752, DataDescriptor: 134695760, CentralFileHeader: 33639248, EndOfCentralDirectory: 101010256 };
    ue6 = { get(i10) {
      return { signature: h14.get(i10, 0), compressedSize: h14.get(i10, 8), uncompressedSize: h14.get(i10, 12) };
    }, len: 16 };
    Ve2 = { get(i10) {
      let e5 = d14.get(i10, 6);
      return { signature: h14.get(i10, 0), minVersion: d14.get(i10, 4), dataDescriptor: !!(e5 & 8), compressedMethod: d14.get(i10, 8), compressedSize: h14.get(i10, 18), uncompressedSize: h14.get(i10, 22), filenameLength: d14.get(i10, 26), extraFieldLength: d14.get(i10, 28), filename: null };
    }, len: 30 };
    qe2 = { get(i10) {
      return { signature: h14.get(i10, 0), nrOfThisDisk: d14.get(i10, 4), nrOfThisDiskWithTheStart: d14.get(i10, 6), nrOfEntriesOnThisDisk: d14.get(i10, 8), nrOfEntriesOfSize: d14.get(i10, 10), sizeOfCd: h14.get(i10, 12), offsetOfStartOfCd: h14.get(i10, 16), zipFileCommentLength: d14.get(i10, 20) };
    }, len: 22 };
    Ge3 = { get(i10) {
      let e5 = d14.get(i10, 8);
      return { signature: h14.get(i10, 0), minVersion: d14.get(i10, 6), dataDescriptor: !!(e5 & 8), compressedMethod: d14.get(i10, 10), compressedSize: h14.get(i10, 20), uncompressedSize: h14.get(i10, 24), filenameLength: d14.get(i10, 28), extraFieldLength: d14.get(i10, 30), fileCommentLength: d14.get(i10, 32), relativeOffsetOfLocalHeader: h14.get(i10, 42), filename: null };
    }, len: 46 };
    E7 = (0, Je3.default)("tokenizer:inflate");
    xe4 = 256 * 1024;
    Nt3 = Xe3(U9.DataDescriptor);
    ie3 = Xe3(U9.EndOfCentralDirectory);
    H12 = class i7 {
      constructor(e5) {
        this.tokenizer = e5, this.syncBuffer = new Uint8Array(xe4);
      }
      async isZip() {
        return await this.peekSignature() === U9.LocalFileHeader;
      }
      peekSignature() {
        return this.tokenizer.peekToken(h14);
      }
      async findEndOfCentralDirectoryLocator() {
        let e5 = this.tokenizer, t6 = Math.min(16 * 1024, e5.fileInfo.size), r8 = this.syncBuffer.subarray(0, t6);
        await this.tokenizer.readBuffer(r8, { position: e5.fileInfo.size - t6 });
        for (let n23 = r8.length - 4; n23 >= 0; n23--) if (r8[n23] === ie3[0] && r8[n23 + 1] === ie3[1] && r8[n23 + 2] === ie3[2] && r8[n23 + 3] === ie3[3]) return e5.fileInfo.size - t6 + n23;
        return -1;
      }
      async readCentralDirectory() {
        if (!this.tokenizer.supportsRandomAccess()) {
          E7("Cannot reading central-directory without random-read support");
          return;
        }
        E7("Reading central-directory...");
        let e5 = this.tokenizer.position, t6 = await this.findEndOfCentralDirectoryLocator();
        if (t6 > 0) {
          E7("Central-directory 32-bit signature found");
          let r8 = await this.tokenizer.readToken(qe2, t6), n23 = [];
          this.tokenizer.setPosition(r8.offsetOfStartOfCd);
          for (let o9 = 0; o9 < r8.nrOfEntriesOfSize; ++o9) {
            let s9 = await this.tokenizer.readToken(Ge3);
            if (s9.signature !== U9.CentralFileHeader) throw new Error("Expected Central-File-Header signature");
            s9.filename = await this.tokenizer.readToken(new b21(s9.filenameLength, "utf-8")), await this.tokenizer.ignore(s9.extraFieldLength), await this.tokenizer.ignore(s9.fileCommentLength), n23.push(s9), E7(`Add central-directory file-entry: n=${o9 + 1}/${n23.length}: filename=${n23[o9].filename}`);
          }
          return this.tokenizer.setPosition(e5), n23;
        }
        this.tokenizer.setPosition(e5);
      }
      async unzip(e5) {
        let t6 = await this.readCentralDirectory();
        if (t6) return this.iterateOverCentralDirectory(t6, e5);
        let r8 = false;
        do {
          let n23 = await this.readLocalFileHeader();
          if (!n23) break;
          let o9 = e5(n23);
          r8 = !!o9.stop;
          let s9;
          if (await this.tokenizer.ignore(n23.extraFieldLength), n23.dataDescriptor && n23.compressedSize === 0) {
            let c14 = [], p17 = xe4;
            E7("Compressed-file-size unknown, scanning for next data-descriptor-signature....");
            let m24 = -1;
            for (; m24 < 0 && p17 === xe4; ) {
              p17 = await this.tokenizer.peekBuffer(this.syncBuffer, { mayBeLess: true }), m24 = _t2(this.syncBuffer.subarray(0, p17), Nt3);
              let a7 = m24 >= 0 ? m24 : p17;
              if (o9.handler) {
                let f11 = new Uint8Array(a7);
                await this.tokenizer.readBuffer(f11), c14.push(f11);
              } else await this.tokenizer.ignore(a7);
            }
            E7(`Found data-descriptor-signature at pos=${this.tokenizer.position}`), o9.handler && await this.inflate(n23, $t2(c14), o9.handler);
          } else o9.handler ? (E7(`Reading compressed-file-data: ${n23.compressedSize} bytes`), s9 = new Uint8Array(n23.compressedSize), await this.tokenizer.readBuffer(s9), await this.inflate(n23, s9, o9.handler)) : (E7(`Ignoring compressed-file-data: ${n23.compressedSize} bytes`), await this.tokenizer.ignore(n23.compressedSize));
          if (E7(`Reading data-descriptor at pos=${this.tokenizer.position}`), n23.dataDescriptor && (await this.tokenizer.readToken(ue6)).signature !== 134695760) throw new Error(`Expected data-descriptor-signature at position ${this.tokenizer.position - ue6.len}`);
        } while (!r8);
      }
      async iterateOverCentralDirectory(e5, t6) {
        for (let r8 of e5) {
          let n23 = t6(r8);
          if (n23.handler) {
            this.tokenizer.setPosition(r8.relativeOffsetOfLocalHeader);
            let o9 = await this.readLocalFileHeader();
            if (o9) {
              await this.tokenizer.ignore(o9.extraFieldLength);
              let s9 = new Uint8Array(r8.compressedSize);
              await this.tokenizer.readBuffer(s9), await this.inflate(o9, s9, n23.handler);
            }
          }
          if (n23.stop) break;
        }
      }
      async inflate(e5, t6, r8) {
        if (e5.compressedMethod === 0) return r8(t6);
        if (e5.compressedMethod !== 8) throw new Error(`Unsupported ZIP compression method: ${e5.compressedMethod}`);
        E7(`Decompress filename=${e5.filename}, compressed-size=${t6.length}`);
        let n23 = await i7.decompressDeflateRaw(t6);
        return r8(n23);
      }
      static async decompressDeflateRaw(e5) {
        let t6 = new ReadableStream({ start(o9) {
          o9.enqueue(e5), o9.close();
        } }), r8 = new DecompressionStream("deflate-raw"), n23 = t6.pipeThrough(r8);
        try {
          let s9 = await new Response(n23).arrayBuffer();
          return new Uint8Array(s9);
        } catch (o9) {
          let s9 = o9 instanceof Error ? `Failed to deflate ZIP entry: ${o9.message}` : "Unknown decompression error in ZIP entry";
          throw new TypeError(s9);
        }
      }
      async readLocalFileHeader() {
        let e5 = await this.tokenizer.peekToken(h14);
        if (e5 === U9.LocalFileHeader) {
          let t6 = await this.tokenizer.readToken(Ve2);
          return t6.filename = await this.tokenizer.readToken(new b21(t6.filenameLength, "utf-8")), t6;
        }
        if (e5 === U9.CentralFileHeader) return false;
        throw e5 === 3759263696 ? new Error("Encrypted ZIP") : new Error("Unexpected signature");
      }
    };
    W9 = class {
      constructor(e5) {
        this.tokenizer = e5;
      }
      inflate() {
        let e5 = this.tokenizer;
        return new ReadableStream({ async pull(t6) {
          let r8 = new Uint8Array(1024), n23 = await e5.readBuffer(r8, { mayBeLess: true });
          if (n23 === 0) {
            t6.close();
            return;
          }
          t6.enqueue(r8.subarray(0, n23));
        } }).pipeThrough(new DecompressionStream("gzip"));
      }
    };
    ur = { utf8: new globalThis.TextDecoder("utf8") };
    xr2 = new globalThis.TextEncoder();
    dr = Array.from({ length: 256 }, (i10, e5) => e5.toString(16).padStart(2, "0"));
    Ye3 = { get: (i10, e5) => i10[e5 + 3] & 127 | i10[e5 + 2] << 7 | i10[e5 + 1] << 14 | i10[e5] << 21, len: 4 };
    Ke3 = ["jpg", "png", "apng", "gif", "webp", "flif", "xcf", "cr2", "cr3", "orf", "arw", "dng", "nef", "rw2", "raf", "tif", "bmp", "icns", "jxr", "psd", "indd", "zip", "tar", "rar", "gz", "bz2", "7z", "dmg", "mp4", "mid", "mkv", "webm", "mov", "avi", "mpg", "mp2", "mp3", "m4a", "oga", "ogg", "ogv", "opus", "flac", "wav", "spx", "amr", "pdf", "epub", "elf", "macho", "exe", "swf", "rtf", "wasm", "woff", "woff2", "eot", "ttf", "otf", "ttc", "ico", "flv", "ps", "xz", "sqlite", "nes", "crx", "xpi", "cab", "deb", "ar", "rpm", "Z", "lz", "cfb", "mxf", "mts", "blend", "bpg", "docx", "pptx", "xlsx", "3gp", "3g2", "j2c", "jp2", "jpm", "jpx", "mj2", "aif", "qcp", "odt", "ods", "odp", "xml", "mobi", "heic", "cur", "ktx", "ape", "wv", "dcm", "ics", "glb", "pcap", "dsf", "lnk", "alias", "voc", "ac3", "m4v", "m4p", "m4b", "f4v", "f4p", "f4b", "f4a", "mie", "asf", "ogm", "ogx", "mpc", "arrow", "shp", "aac", "mp1", "it", "s3m", "xm", "skp", "avif", "eps", "lzh", "pgp", "asar", "stl", "chm", "3mf", "zst", "jxl", "vcf", "jls", "pst", "dwg", "parquet", "class", "arj", "cpio", "ace", "avro", "icc", "fbx", "vsdx", "vtt", "apk", "drc", "lz4", "potx", "xltx", "dotx", "xltm", "ott", "ots", "otp", "odg", "otg", "xlsm", "docm", "dotm", "potm", "pptm", "jar", "jmp", "rm", "sav", "ppsm", "ppsx", "tar.gz", "reg", "dat"];
    et4 = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/flif", "image/x-xcf", "image/x-canon-cr2", "image/x-canon-cr3", "image/tiff", "image/bmp", "image/vnd.ms-photo", "image/vnd.adobe.photoshop", "application/x-indesign", "application/epub+zip", "application/x-xpinstall", "application/vnd.ms-powerpoint.slideshow.macroenabled.12", "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.spreadsheet", "application/vnd.oasis.opendocument.presentation", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.presentationml.slideshow", "application/zip", "application/x-tar", "application/x-rar-compressed", "application/gzip", "application/x-bzip2", "application/x-7z-compressed", "application/x-apple-diskimage", "application/vnd.apache.arrow.file", "video/mp4", "audio/midi", "video/matroska", "video/webm", "video/quicktime", "video/vnd.avi", "audio/wav", "audio/qcelp", "audio/x-ms-asf", "video/x-ms-asf", "application/vnd.ms-asf", "video/mpeg", "video/3gpp", "audio/mpeg", "audio/mp4", "video/ogg", "audio/ogg", "audio/ogg; codecs=opus", "application/ogg", "audio/flac", "audio/ape", "audio/wavpack", "audio/amr", "application/pdf", "application/x-elf", "application/x-mach-binary", "application/x-msdownload", "application/x-shockwave-flash", "application/rtf", "application/wasm", "font/woff", "font/woff2", "application/vnd.ms-fontobject", "font/ttf", "font/otf", "font/collection", "image/x-icon", "video/x-flv", "application/postscript", "application/eps", "application/x-xz", "application/x-sqlite3", "application/x-nintendo-nes-rom", "application/x-google-chrome-extension", "application/vnd.ms-cab-compressed", "application/x-deb", "application/x-unix-archive", "application/x-rpm", "application/x-compress", "application/x-lzip", "application/x-cfb", "application/x-mie", "application/mxf", "video/mp2t", "application/x-blender", "image/bpg", "image/j2c", "image/jp2", "image/jpx", "image/jpm", "image/mj2", "audio/aiff", "application/xml", "application/x-mobipocket-ebook", "image/heif", "image/heif-sequence", "image/heic", "image/heic-sequence", "image/icns", "image/ktx", "application/dicom", "audio/x-musepack", "text/calendar", "text/vcard", "text/vtt", "model/gltf-binary", "application/vnd.tcpdump.pcap", "audio/x-dsf", "application/x.ms.shortcut", "application/x.apple.alias", "audio/x-voc", "audio/vnd.dolby.dd-raw", "audio/x-m4a", "image/apng", "image/x-olympus-orf", "image/x-sony-arw", "image/x-adobe-dng", "image/x-nikon-nef", "image/x-panasonic-rw2", "image/x-fujifilm-raf", "video/x-m4v", "video/3gpp2", "application/x-esri-shape", "audio/aac", "audio/x-it", "audio/x-s3m", "audio/x-xm", "video/MP1S", "video/MP2P", "application/vnd.sketchup.skp", "image/avif", "application/x-lzh-compressed", "application/pgp-encrypted", "application/x-asar", "model/stl", "application/vnd.ms-htmlhelp", "model/3mf", "image/jxl", "application/zstd", "image/jls", "application/vnd.ms-outlook", "image/vnd.dwg", "application/vnd.apache.parquet", "application/java-vm", "application/x-arj", "application/x-cpio", "application/x-ace-compressed", "application/avro", "application/vnd.iccprofile", "application/x.autodesk.fbx", "application/vnd.visio", "application/vnd.android.package-archive", "application/vnd.google.draco", "application/x-lz4", "application/vnd.openxmlformats-officedocument.presentationml.template", "application/vnd.openxmlformats-officedocument.spreadsheetml.template", "application/vnd.openxmlformats-officedocument.wordprocessingml.template", "application/vnd.ms-excel.template.macroenabled.12", "application/vnd.oasis.opendocument.text-template", "application/vnd.oasis.opendocument.spreadsheet-template", "application/vnd.oasis.opendocument.presentation-template", "application/vnd.oasis.opendocument.graphics", "application/vnd.oasis.opendocument.graphics-template", "application/vnd.ms-excel.sheet.macroenabled.12", "application/vnd.ms-word.document.macroenabled.12", "application/vnd.ms-word.template.macroenabled.12", "application/vnd.ms-powerpoint.template.macroenabled.12", "application/vnd.ms-powerpoint.presentation.macroenabled.12", "application/java-archive", "application/vnd.rn-realmedia", "application/x-spss-sav", "application/x-ms-regedit", "application/x-ft-windows-registry-hive", "application/x-jmp-data"];
    he6 = 4100;
    we2 = class {
      constructor(e5) {
        this.options = { mpegOffsetTolerance: 0, ...e5 }, this.detectors = [...e5?.customDetectors ?? [], { id: "core", detect: this.detectConfident }, { id: "core.imprecise", detect: this.detectImprecise }], this.tokenizerOptions = { abortSignal: e5?.signal };
      }
      async fromTokenizer(e5) {
        let t6 = e5.position;
        for (let r8 of this.detectors) {
          let n23 = await r8.detect(e5);
          if (n23) return n23;
          if (t6 !== e5.position) return;
        }
      }
      async fromBuffer(e5) {
        if (!(e5 instanceof Uint8Array || e5 instanceof ArrayBuffer)) throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`ArrayBuffer\`, got \`${typeof e5}\``);
        let t6 = e5 instanceof Uint8Array ? e5 : new Uint8Array(e5);
        if (t6?.length > 1) return this.fromTokenizer(ve4(t6, this.tokenizerOptions));
      }
      async fromBlob(e5) {
        let t6 = Se2(e5, this.tokenizerOptions);
        try {
          return await this.fromTokenizer(t6);
        } finally {
          await t6.close();
        }
      }
      async fromStream(e5) {
        let t6 = se4(e5, this.tokenizerOptions);
        try {
          return await this.fromTokenizer(t6);
        } finally {
          await t6.close();
        }
      }
      async toDetectionStream(e5, t6) {
        let { sampleSize: r8 = he6 } = t6, n23, o9, s9 = e5.getReader({ mode: "byob" });
        try {
          let { value: m24, done: a7 } = await s9.read(new Uint8Array(r8));
          if (o9 = m24, !a7 && m24) try {
            n23 = await this.fromBuffer(m24.subarray(0, r8));
          } catch (f11) {
            if (!(f11 instanceof x16)) throw f11;
            n23 = void 0;
          }
          o9 = m24;
        } finally {
          s9.releaseLock();
        }
        let c14 = new TransformStream({ async start(m24) {
          m24.enqueue(o9);
        }, transform(m24, a7) {
          a7.enqueue(m24);
        } }), p17 = e5.pipeThrough(c14);
        return p17.fileType = n23, p17;
      }
      check(e5, t6) {
        return A8(this.buffer, e5, t6);
      }
      checkString(e5, t6) {
        return this.check(Ze4(e5, t6?.encoding), t6);
      }
      detectConfident = async (e5) => {
        if (this.buffer = new Uint8Array(he6), e5.fileInfo.size === void 0 && (e5.fileInfo.size = Number.MAX_SAFE_INTEGER), this.tokenizer = e5, await e5.peekBuffer(this.buffer, { length: 32, mayBeLess: true }), this.check([66, 77])) return { ext: "bmp", mime: "image/bmp" };
        if (this.check([11, 119])) return { ext: "ac3", mime: "audio/vnd.dolby.dd-raw" };
        if (this.check([120, 1])) return { ext: "dmg", mime: "application/x-apple-diskimage" };
        if (this.check([77, 90])) return { ext: "exe", mime: "application/x-msdownload" };
        if (this.check([37, 33])) return await e5.peekBuffer(this.buffer, { length: 24, mayBeLess: true }), this.checkString("PS-Adobe-", { offset: 2 }) && this.checkString(" EPSF-", { offset: 14 }) ? { ext: "eps", mime: "application/eps" } : { ext: "ps", mime: "application/postscript" };
        if (this.check([31, 160]) || this.check([31, 157])) return { ext: "Z", mime: "application/x-compress" };
        if (this.check([199, 113])) return { ext: "cpio", mime: "application/x-cpio" };
        if (this.check([96, 234])) return { ext: "arj", mime: "application/x-arj" };
        if (this.check([239, 187, 191])) return this.tokenizer.ignore(3), this.detectConfident(e5);
        if (this.check([71, 73, 70])) return { ext: "gif", mime: "image/gif" };
        if (this.check([73, 73, 188])) return { ext: "jxr", mime: "image/vnd.ms-photo" };
        if (this.check([31, 139, 8])) {
          let r8 = new W9(e5).inflate(), n23 = true;
          try {
            let o9;
            try {
              o9 = await this.fromStream(r8);
            } catch {
              n23 = false;
            }
            if (o9 && o9.ext === "tar") return { ext: "tar.gz", mime: "application/gzip" };
          } finally {
            n23 && await r8.cancel();
          }
          return { ext: "gz", mime: "application/gzip" };
        }
        if (this.check([66, 90, 104])) return { ext: "bz2", mime: "application/x-bzip2" };
        if (this.checkString("ID3")) {
          await e5.ignore(6);
          let t6 = await e5.readToken(Ye3);
          return e5.position + t6 > e5.fileInfo.size ? { ext: "mp3", mime: "audio/mpeg" } : (await e5.ignore(t6), this.fromTokenizer(e5));
        }
        if (this.checkString("MP+")) return { ext: "mpc", mime: "audio/x-musepack" };
        if ((this.buffer[0] === 67 || this.buffer[0] === 70) && this.check([87, 83], { offset: 1 })) return { ext: "swf", mime: "application/x-shockwave-flash" };
        if (this.check([255, 216, 255])) return this.check([247], { offset: 3 }) ? { ext: "jls", mime: "image/jls" } : { ext: "jpg", mime: "image/jpeg" };
        if (this.check([79, 98, 106, 1])) return { ext: "avro", mime: "application/avro" };
        if (this.checkString("FLIF")) return { ext: "flif", mime: "image/flif" };
        if (this.checkString("8BPS")) return { ext: "psd", mime: "image/vnd.adobe.photoshop" };
        if (this.checkString("MPCK")) return { ext: "mpc", mime: "audio/x-musepack" };
        if (this.checkString("FORM")) return { ext: "aif", mime: "audio/aiff" };
        if (this.checkString("icns", { offset: 0 })) return { ext: "icns", mime: "image/icns" };
        if (this.check([80, 75, 3, 4])) {
          let t6;
          return await new H12(e5).unzip((r8) => {
            switch (r8.filename) {
              case "META-INF/mozilla.rsa":
                return t6 = { ext: "xpi", mime: "application/x-xpinstall" }, { stop: true };
              case "META-INF/MANIFEST.MF":
                return t6 = { ext: "jar", mime: "application/java-archive" }, { stop: true };
              case "mimetype":
                return { async handler(n23) {
                  let o9 = new TextDecoder("utf-8").decode(n23).trim();
                  t6 = ge5(o9);
                }, stop: true };
              case "[Content_Types].xml":
                return { async handler(n23) {
                  let o9 = new TextDecoder("utf-8").decode(n23), s9 = o9.indexOf('.main+xml"');
                  if (s9 === -1) {
                    let c14 = "application/vnd.ms-package.3dmanufacturing-3dmodel+xml";
                    o9.includes(`ContentType="${c14}"`) && (t6 = ge5(c14));
                  } else {
                    o9 = o9.slice(0, Math.max(0, s9));
                    let c14 = o9.lastIndexOf('"'), p17 = o9.slice(Math.max(0, c14 + 1));
                    t6 = ge5(p17);
                  }
                }, stop: true };
              default:
                return /classes\d*\.dex/.test(r8.filename) ? (t6 = { ext: "apk", mime: "application/vnd.android.package-archive" }, { stop: true }) : {};
            }
          }).catch((r8) => {
            if (!(r8 instanceof x16)) throw r8;
          }), t6 ?? { ext: "zip", mime: "application/zip" };
        }
        if (this.checkString("OggS")) {
          await e5.ignore(28);
          let t6 = new Uint8Array(8);
          return await e5.readBuffer(t6), A8(t6, [79, 112, 117, 115, 72, 101, 97, 100]) ? { ext: "opus", mime: "audio/ogg; codecs=opus" } : A8(t6, [128, 116, 104, 101, 111, 114, 97]) ? { ext: "ogv", mime: "video/ogg" } : A8(t6, [1, 118, 105, 100, 101, 111, 0]) ? { ext: "ogm", mime: "video/ogg" } : A8(t6, [127, 70, 76, 65, 67]) ? { ext: "oga", mime: "audio/ogg" } : A8(t6, [83, 112, 101, 101, 120, 32, 32]) ? { ext: "spx", mime: "audio/ogg" } : A8(t6, [1, 118, 111, 114, 98, 105, 115]) ? { ext: "ogg", mime: "audio/ogg" } : { ext: "ogx", mime: "application/ogg" };
        }
        if (this.check([80, 75]) && (this.buffer[2] === 3 || this.buffer[2] === 5 || this.buffer[2] === 7) && (this.buffer[3] === 4 || this.buffer[3] === 6 || this.buffer[3] === 8)) return { ext: "zip", mime: "application/zip" };
        if (this.checkString("MThd")) return { ext: "mid", mime: "audio/midi" };
        if (this.checkString("wOFF") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return { ext: "woff", mime: "font/woff" };
        if (this.checkString("wOF2") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) return { ext: "woff2", mime: "font/woff2" };
        if (this.check([212, 195, 178, 161]) || this.check([161, 178, 195, 212])) return { ext: "pcap", mime: "application/vnd.tcpdump.pcap" };
        if (this.checkString("DSD ")) return { ext: "dsf", mime: "audio/x-dsf" };
        if (this.checkString("LZIP")) return { ext: "lz", mime: "application/x-lzip" };
        if (this.checkString("fLaC")) return { ext: "flac", mime: "audio/flac" };
        if (this.check([66, 80, 71, 251])) return { ext: "bpg", mime: "image/bpg" };
        if (this.checkString("wvpk")) return { ext: "wv", mime: "audio/wavpack" };
        if (this.checkString("%PDF")) return { ext: "pdf", mime: "application/pdf" };
        if (this.check([0, 97, 115, 109])) return { ext: "wasm", mime: "application/wasm" };
        if (this.check([73, 73])) {
          let t6 = await this.readTiffHeader(false);
          if (t6) return t6;
        }
        if (this.check([77, 77])) {
          let t6 = await this.readTiffHeader(true);
          if (t6) return t6;
        }
        if (this.checkString("MAC ")) return { ext: "ape", mime: "audio/ape" };
        if (this.check([26, 69, 223, 163])) {
          async function t6() {
            let c14 = await e5.peekNumber(Be2), p17 = 128, m24 = 0;
            for (; (c14 & p17) === 0 && p17 !== 0; ) ++m24, p17 >>= 1;
            let a7 = new Uint8Array(m24 + 1);
            return await e5.readBuffer(a7), a7;
          }
          async function r8() {
            let c14 = await t6(), p17 = await t6();
            p17[0] ^= 128 >> p17.length - 1;
            let m24 = Math.min(6, p17.length), a7 = new DataView(c14.buffer), f11 = new DataView(p17.buffer, p17.length - m24, m24);
            return { id: de6(a7), len: de6(f11) };
          }
          async function n23(c14) {
            for (; c14 > 0; ) {
              let p17 = await r8();
              if (p17.id === 17026) return (await e5.readToken(new b21(p17.len))).replaceAll(/\00.*$/g, "");
              await e5.ignore(p17.len), --c14;
            }
          }
          let o9 = await r8();
          switch (await n23(o9.len)) {
            case "webm":
              return { ext: "webm", mime: "video/webm" };
            case "matroska":
              return { ext: "mkv", mime: "video/matroska" };
            default:
              return;
          }
        }
        if (this.checkString("SQLi")) return { ext: "sqlite", mime: "application/x-sqlite3" };
        if (this.check([78, 69, 83, 26])) return { ext: "nes", mime: "application/x-nintendo-nes-rom" };
        if (this.checkString("Cr24")) return { ext: "crx", mime: "application/x-google-chrome-extension" };
        if (this.checkString("MSCF") || this.checkString("ISc(")) return { ext: "cab", mime: "application/vnd.ms-cab-compressed" };
        if (this.check([237, 171, 238, 219])) return { ext: "rpm", mime: "application/x-rpm" };
        if (this.check([197, 208, 211, 198])) return { ext: "eps", mime: "application/eps" };
        if (this.check([40, 181, 47, 253])) return { ext: "zst", mime: "application/zstd" };
        if (this.check([127, 69, 76, 70])) return { ext: "elf", mime: "application/x-elf" };
        if (this.check([33, 66, 68, 78])) return { ext: "pst", mime: "application/vnd.ms-outlook" };
        if (this.checkString("PAR1") || this.checkString("PARE")) return { ext: "parquet", mime: "application/vnd.apache.parquet" };
        if (this.checkString("ttcf")) return { ext: "ttc", mime: "font/collection" };
        if (this.check([207, 250, 237, 254])) return { ext: "macho", mime: "application/x-mach-binary" };
        if (this.check([4, 34, 77, 24])) return { ext: "lz4", mime: "application/x-lz4" };
        if (this.checkString("regf")) return { ext: "dat", mime: "application/x-ft-windows-registry-hive" };
        if (this.checkString("$FL2") || this.checkString("$FL3")) return { ext: "sav", mime: "application/x-spss-sav" };
        if (this.check([79, 84, 84, 79, 0])) return { ext: "otf", mime: "font/otf" };
        if (this.checkString("#!AMR")) return { ext: "amr", mime: "audio/amr" };
        if (this.checkString("{\\rtf")) return { ext: "rtf", mime: "application/rtf" };
        if (this.check([70, 76, 86, 1])) return { ext: "flv", mime: "video/x-flv" };
        if (this.checkString("IMPM")) return { ext: "it", mime: "audio/x-it" };
        if (this.checkString("-lh0-", { offset: 2 }) || this.checkString("-lh1-", { offset: 2 }) || this.checkString("-lh2-", { offset: 2 }) || this.checkString("-lh3-", { offset: 2 }) || this.checkString("-lh4-", { offset: 2 }) || this.checkString("-lh5-", { offset: 2 }) || this.checkString("-lh6-", { offset: 2 }) || this.checkString("-lh7-", { offset: 2 }) || this.checkString("-lzs-", { offset: 2 }) || this.checkString("-lz4-", { offset: 2 }) || this.checkString("-lz5-", { offset: 2 }) || this.checkString("-lhd-", { offset: 2 })) return { ext: "lzh", mime: "application/x-lzh-compressed" };
        if (this.check([0, 0, 1, 186])) {
          if (this.check([33], { offset: 4, mask: [241] })) return { ext: "mpg", mime: "video/MP1S" };
          if (this.check([68], { offset: 4, mask: [196] })) return { ext: "mpg", mime: "video/MP2P" };
        }
        if (this.checkString("ITSF")) return { ext: "chm", mime: "application/vnd.ms-htmlhelp" };
        if (this.check([202, 254, 186, 190])) return { ext: "class", mime: "application/java-vm" };
        if (this.checkString(".RMF")) return { ext: "rm", mime: "application/vnd.rn-realmedia" };
        if (this.checkString("DRACO")) return { ext: "drc", mime: "application/vnd.google.draco" };
        if (this.check([253, 55, 122, 88, 90, 0])) return { ext: "xz", mime: "application/x-xz" };
        if (this.checkString("<?xml ")) return { ext: "xml", mime: "application/xml" };
        if (this.check([55, 122, 188, 175, 39, 28])) return { ext: "7z", mime: "application/x-7z-compressed" };
        if (this.check([82, 97, 114, 33, 26, 7]) && (this.buffer[6] === 0 || this.buffer[6] === 1)) return { ext: "rar", mime: "application/x-rar-compressed" };
        if (this.checkString("solid ")) return { ext: "stl", mime: "model/stl" };
        if (this.checkString("AC")) {
          let t6 = new b21(4, "latin1").get(this.buffer, 2);
          if (t6.match("^d*") && t6 >= 1e3 && t6 <= 1050) return { ext: "dwg", mime: "image/vnd.dwg" };
        }
        if (this.checkString("070707")) return { ext: "cpio", mime: "application/x-cpio" };
        if (this.checkString("BLENDER")) return { ext: "blend", mime: "application/x-blender" };
        if (this.checkString("!<arch>")) return await e5.ignore(8), await e5.readToken(new b21(13, "ascii")) === "debian-binary" ? { ext: "deb", mime: "application/x-deb" } : { ext: "ar", mime: "application/x-unix-archive" };
        if (this.checkString("WEBVTT") && [`
`, "\r", "	", " ", "\0"].some((t6) => this.checkString(t6, { offset: 6 }))) return { ext: "vtt", mime: "text/vtt" };
        if (this.check([137, 80, 78, 71, 13, 10, 26, 10])) {
          await e5.ignore(8);
          async function t6() {
            return { length: await e5.readToken(Oe2), type: await e5.readToken(new b21(4, "latin1")) };
          }
          do {
            let r8 = await t6();
            if (r8.length < 0) return;
            switch (r8.type) {
              case "IDAT":
                return { ext: "png", mime: "image/png" };
              case "acTL":
                return { ext: "apng", mime: "image/apng" };
              default:
                await e5.ignore(r8.length + 4);
            }
          } while (e5.position + 8 < e5.fileInfo.size);
          return { ext: "png", mime: "image/png" };
        }
        if (this.check([65, 82, 82, 79, 87, 49, 0, 0])) return { ext: "arrow", mime: "application/vnd.apache.arrow.file" };
        if (this.check([103, 108, 84, 70, 2, 0, 0, 0])) return { ext: "glb", mime: "model/gltf-binary" };
        if (this.check([102, 114, 101, 101], { offset: 4 }) || this.check([109, 100, 97, 116], { offset: 4 }) || this.check([109, 111, 111, 118], { offset: 4 }) || this.check([119, 105, 100, 101], { offset: 4 })) return { ext: "mov", mime: "video/quicktime" };
        if (this.check([73, 73, 82, 79, 8, 0, 0, 0, 24])) return { ext: "orf", mime: "image/x-olympus-orf" };
        if (this.checkString("gimp xcf ")) return { ext: "xcf", mime: "image/x-xcf" };
        if (this.checkString("ftyp", { offset: 4 }) && (this.buffer[8] & 96) !== 0) {
          let t6 = new b21(4, "latin1").get(this.buffer, 8).replace("\0", " ").trim();
          switch (t6) {
            case "avif":
            case "avis":
              return { ext: "avif", mime: "image/avif" };
            case "mif1":
              return { ext: "heic", mime: "image/heif" };
            case "msf1":
              return { ext: "heic", mime: "image/heif-sequence" };
            case "heic":
            case "heix":
              return { ext: "heic", mime: "image/heic" };
            case "hevc":
            case "hevx":
              return { ext: "heic", mime: "image/heic-sequence" };
            case "qt":
              return { ext: "mov", mime: "video/quicktime" };
            case "M4V":
            case "M4VH":
            case "M4VP":
              return { ext: "m4v", mime: "video/x-m4v" };
            case "M4P":
              return { ext: "m4p", mime: "video/mp4" };
            case "M4B":
              return { ext: "m4b", mime: "audio/mp4" };
            case "M4A":
              return { ext: "m4a", mime: "audio/x-m4a" };
            case "F4V":
              return { ext: "f4v", mime: "video/mp4" };
            case "F4P":
              return { ext: "f4p", mime: "video/mp4" };
            case "F4A":
              return { ext: "f4a", mime: "audio/mp4" };
            case "F4B":
              return { ext: "f4b", mime: "audio/mp4" };
            case "crx":
              return { ext: "cr3", mime: "image/x-canon-cr3" };
            default:
              return t6.startsWith("3g") ? t6.startsWith("3g2") ? { ext: "3g2", mime: "video/3gpp2" } : { ext: "3gp", mime: "video/3gpp" } : { ext: "mp4", mime: "video/mp4" };
          }
        }
        if (this.checkString(`REGEDIT4\r
`)) return { ext: "reg", mime: "application/x-ms-regedit" };
        if (this.check([82, 73, 70, 70])) {
          if (this.checkString("WEBP", { offset: 8 })) return { ext: "webp", mime: "image/webp" };
          if (this.check([65, 86, 73], { offset: 8 })) return { ext: "avi", mime: "video/vnd.avi" };
          if (this.check([87, 65, 86, 69], { offset: 8 })) return { ext: "wav", mime: "audio/wav" };
          if (this.check([81, 76, 67, 77], { offset: 8 })) return { ext: "qcp", mime: "audio/qcelp" };
        }
        if (this.check([73, 73, 85, 0, 24, 0, 0, 0, 136, 231, 116, 216])) return { ext: "rw2", mime: "image/x-panasonic-rw2" };
        if (this.check([48, 38, 178, 117, 142, 102, 207, 17, 166, 217])) {
          async function t6() {
            let r8 = new Uint8Array(16);
            return await e5.readBuffer(r8), { id: r8, size: Number(await e5.readToken(De3)) };
          }
          for (await e5.ignore(30); e5.position + 24 < e5.fileInfo.size; ) {
            let r8 = await t6(), n23 = r8.size - 24;
            if (A8(r8.id, [145, 7, 220, 183, 183, 169, 207, 17, 142, 230, 0, 192, 12, 32, 83, 101])) {
              let o9 = new Uint8Array(16);
              if (n23 -= await e5.readBuffer(o9), A8(o9, [64, 158, 105, 248, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "audio/x-ms-asf" };
              if (A8(o9, [192, 239, 25, 188, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) return { ext: "asf", mime: "video/x-ms-asf" };
              break;
            }
            await e5.ignore(n23);
          }
          return { ext: "asf", mime: "application/vnd.ms-asf" };
        }
        if (this.check([171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10])) return { ext: "ktx", mime: "image/ktx" };
        if ((this.check([126, 16, 4]) || this.check([126, 24, 4])) && this.check([48, 77, 73, 69], { offset: 4 })) return { ext: "mie", mime: "application/x-mie" };
        if (this.check([39, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], { offset: 2 })) return { ext: "shp", mime: "application/x-esri-shape" };
        if (this.check([255, 79, 255, 81])) return { ext: "j2c", mime: "image/j2c" };
        if (this.check([0, 0, 0, 12, 106, 80, 32, 32, 13, 10, 135, 10])) switch (await e5.ignore(20), await e5.readToken(new b21(4, "ascii"))) {
          case "jp2 ":
            return { ext: "jp2", mime: "image/jp2" };
          case "jpx ":
            return { ext: "jpx", mime: "image/jpx" };
          case "jpm ":
            return { ext: "jpm", mime: "image/jpm" };
          case "mjp2":
            return { ext: "mj2", mime: "image/mj2" };
          default:
            return;
        }
        if (this.check([255, 10]) || this.check([0, 0, 0, 12, 74, 88, 76, 32, 13, 10, 135, 10])) return { ext: "jxl", mime: "image/jxl" };
        if (this.check([254, 255])) return this.checkString("<?xml ", { offset: 2, encoding: "utf-16be" }) ? { ext: "xml", mime: "application/xml" } : void 0;
        if (this.check([208, 207, 17, 224, 161, 177, 26, 225])) return { ext: "cfb", mime: "application/x-cfb" };
        if (await e5.peekBuffer(this.buffer, { length: Math.min(256, e5.fileInfo.size), mayBeLess: true }), this.check([97, 99, 115, 112], { offset: 36 })) return { ext: "icc", mime: "application/vnd.iccprofile" };
        if (this.checkString("**ACE", { offset: 7 }) && this.checkString("**", { offset: 12 })) return { ext: "ace", mime: "application/x-ace-compressed" };
        if (this.checkString("BEGIN:")) {
          if (this.checkString("VCARD", { offset: 6 })) return { ext: "vcf", mime: "text/vcard" };
          if (this.checkString("VCALENDAR", { offset: 6 })) return { ext: "ics", mime: "text/calendar" };
        }
        if (this.checkString("FUJIFILMCCD-RAW")) return { ext: "raf", mime: "image/x-fujifilm-raf" };
        if (this.checkString("Extended Module:")) return { ext: "xm", mime: "audio/x-xm" };
        if (this.checkString("Creative Voice File")) return { ext: "voc", mime: "audio/x-voc" };
        if (this.check([4, 0, 0, 0]) && this.buffer.length >= 16) {
          let t6 = new DataView(this.buffer.buffer).getUint32(12, true);
          if (t6 > 12 && this.buffer.length >= t6 + 16) try {
            let r8 = new TextDecoder().decode(this.buffer.subarray(16, t6 + 16));
            if (JSON.parse(r8).files) return { ext: "asar", mime: "application/x-asar" };
          } catch {
          }
        }
        if (this.check([6, 14, 43, 52, 2, 5, 1, 1, 13, 1, 2, 1, 1, 2])) return { ext: "mxf", mime: "application/mxf" };
        if (this.checkString("SCRM", { offset: 44 })) return { ext: "s3m", mime: "audio/x-s3m" };
        if (this.check([71]) && this.check([71], { offset: 188 })) return { ext: "mts", mime: "video/mp2t" };
        if (this.check([71], { offset: 4 }) && this.check([71], { offset: 196 })) return { ext: "mts", mime: "video/mp2t" };
        if (this.check([66, 79, 79, 75, 77, 79, 66, 73], { offset: 60 })) return { ext: "mobi", mime: "application/x-mobipocket-ebook" };
        if (this.check([68, 73, 67, 77], { offset: 128 })) return { ext: "dcm", mime: "application/dicom" };
        if (this.check([76, 0, 0, 0, 1, 20, 2, 0, 0, 0, 0, 0, 192, 0, 0, 0, 0, 0, 0, 70])) return { ext: "lnk", mime: "application/x.ms.shortcut" };
        if (this.check([98, 111, 111, 107, 0, 0, 0, 0, 109, 97, 114, 107, 0, 0, 0, 0])) return { ext: "alias", mime: "application/x.apple.alias" };
        if (this.checkString("Kaydara FBX Binary  \0")) return { ext: "fbx", mime: "application/x.autodesk.fbx" };
        if (this.check([76, 80], { offset: 34 }) && (this.check([0, 0, 1], { offset: 8 }) || this.check([1, 0, 2], { offset: 8 }) || this.check([2, 0, 2], { offset: 8 }))) return { ext: "eot", mime: "application/vnd.ms-fontobject" };
        if (this.check([6, 6, 237, 245, 216, 29, 70, 229, 189, 49, 239, 231, 254, 116, 183, 29])) return { ext: "indd", mime: "application/x-indesign" };
        if (this.check([255, 255, 0, 0, 7, 0, 0, 0, 4, 0, 0, 0, 1, 0, 1, 0]) || this.check([0, 0, 255, 255, 0, 0, 0, 7, 0, 0, 0, 4, 0, 1, 0, 1])) return { ext: "jmp", mime: "application/x-jmp-data" };
        if (await e5.peekBuffer(this.buffer, { length: Math.min(512, e5.fileInfo.size), mayBeLess: true }), this.checkString("ustar", { offset: 257 }) && (this.checkString("\0", { offset: 262 }) || this.checkString(" ", { offset: 262 })) || this.check([0, 0, 0, 0, 0, 0], { offset: 257 }) && Qe3(this.buffer)) return { ext: "tar", mime: "application/x-tar" };
        if (this.check([255, 254])) {
          let t6 = "utf-16le";
          return this.checkString("<?xml ", { offset: 2, encoding: t6 }) ? { ext: "xml", mime: "application/xml" } : this.check([255, 14], { offset: 2 }) && this.checkString("SketchUp Model", { offset: 4, encoding: t6 }) ? { ext: "skp", mime: "application/vnd.sketchup.skp" } : this.checkString(`Windows Registry Editor Version 5.00\r
`, { offset: 2, encoding: t6 }) ? { ext: "reg", mime: "application/x-ms-regedit" } : void 0;
        }
        if (this.checkString("-----BEGIN PGP MESSAGE-----")) return { ext: "pgp", mime: "application/pgp-encrypted" };
      };
      detectImprecise = async (e5) => {
        if (this.buffer = new Uint8Array(he6), await e5.peekBuffer(this.buffer, { length: Math.min(8, e5.fileInfo.size), mayBeLess: true }), this.check([0, 0, 1, 186]) || this.check([0, 0, 1, 179])) return { ext: "mpg", mime: "video/mpeg" };
        if (this.check([0, 1, 0, 0, 0])) return { ext: "ttf", mime: "font/ttf" };
        if (this.check([0, 0, 1, 0])) return { ext: "ico", mime: "image/x-icon" };
        if (this.check([0, 0, 2, 0])) return { ext: "cur", mime: "image/x-icon" };
        if (await e5.peekBuffer(this.buffer, { length: Math.min(2 + this.options.mpegOffsetTolerance, e5.fileInfo.size), mayBeLess: true }), this.buffer.length >= 2 + this.options.mpegOffsetTolerance) for (let t6 = 0; t6 <= this.options.mpegOffsetTolerance; ++t6) {
          let r8 = this.scanMpeg(t6);
          if (r8) return r8;
        }
      };
      async readTiffTag(e5) {
        let t6 = await this.tokenizer.readToken(e5 ? R5 : d14);
        switch (this.tokenizer.ignore(10), t6) {
          case 50341:
            return { ext: "arw", mime: "image/x-sony-arw" };
          case 50706:
            return { ext: "dng", mime: "image/x-adobe-dng" };
          default:
        }
      }
      async readTiffIFD(e5) {
        let t6 = await this.tokenizer.readToken(e5 ? R5 : d14);
        for (let r8 = 0; r8 < t6; ++r8) {
          let n23 = await this.readTiffTag(e5);
          if (n23) return n23;
        }
      }
      async readTiffHeader(e5) {
        let t6 = (e5 ? R5 : d14).get(this.buffer, 2), r8 = (e5 ? Ie4 : h14).get(this.buffer, 4);
        if (t6 === 42) {
          if (r8 >= 6) {
            if (this.checkString("CR", { offset: 8 })) return { ext: "cr2", mime: "image/x-canon-cr2" };
            if (r8 >= 8) {
              let o9 = (e5 ? R5 : d14).get(this.buffer, 8), s9 = (e5 ? R5 : d14).get(this.buffer, 10);
              if (o9 === 28 && s9 === 254 || o9 === 31 && s9 === 11) return { ext: "nef", mime: "image/x-nikon-nef" };
            }
          }
          return await this.tokenizer.ignore(r8), await this.readTiffIFD(e5) ?? { ext: "tif", mime: "image/tiff" };
        }
        if (t6 === 43) return { ext: "tif", mime: "image/tiff" };
      }
      scanMpeg(e5) {
        if (this.check([255, 224], { offset: e5, mask: [255, 224] })) {
          if (this.check([16], { offset: e5 + 1, mask: [22] })) return this.check([8], { offset: e5 + 1, mask: [8] }) ? { ext: "aac", mime: "audio/aac" } : { ext: "aac", mime: "audio/aac" };
          if (this.check([2], { offset: e5 + 1, mask: [6] })) return { ext: "mp3", mime: "audio/mpeg" };
          if (this.check([4], { offset: e5 + 1, mask: [6] })) return { ext: "mp2", mime: "audio/mpeg" };
          if (this.check([6], { offset: e5 + 1, mask: [6] })) return { ext: "mp1", mime: "audio/mpeg" };
        }
      }
    };
    Ht2 = new Set(Ke3);
    Wt2 = new Set(et4);
    Vt = { name: "file", summary: "determine file type", usage: "file [OPTION]... FILE...", options: ["-b, --brief          do not prepend filenames to output", "-i, --mime           output MIME type strings", "-L, --dereference    follow symlinks", "    --help           display this help and exit"] };
    qt2 = /* @__PURE__ */ new Map([[".js", { description: "JavaScript source", mime: "text/javascript" }], [".mjs", { description: "JavaScript module", mime: "text/javascript" }], [".cjs", { description: "CommonJS module", mime: "text/javascript" }], [".ts", { description: "TypeScript source", mime: "text/typescript" }], [".tsx", { description: "TypeScript JSX source", mime: "text/typescript" }], [".jsx", { description: "JavaScript JSX source", mime: "text/javascript" }], [".py", { description: "Python script", mime: "text/x-python" }], [".rb", { description: "Ruby script", mime: "text/x-ruby" }], [".go", { description: "Go source", mime: "text/x-go" }], [".rs", { description: "Rust source", mime: "text/x-rust" }], [".c", { description: "C source", mime: "text/x-c" }], [".h", { description: "C header", mime: "text/x-c" }], [".cpp", { description: "C++ source", mime: "text/x-c++" }], [".hpp", { description: "C++ header", mime: "text/x-c++" }], [".java", { description: "Java source", mime: "text/x-java" }], [".sh", { description: "Bourne-Again shell script", mime: "text/x-shellscript" }], [".bash", { description: "Bourne-Again shell script", mime: "text/x-shellscript" }], [".zsh", { description: "Zsh shell script", mime: "text/x-shellscript" }], [".json", { description: "JSON data", mime: "application/json" }], [".yaml", { description: "YAML data", mime: "text/yaml" }], [".yml", { description: "YAML data", mime: "text/yaml" }], [".xml", { description: "XML document", mime: "application/xml" }], [".csv", { description: "CSV text", mime: "text/csv" }], [".toml", { description: "TOML data", mime: "text/toml" }], [".html", { description: "HTML document", mime: "text/html" }], [".htm", { description: "HTML document", mime: "text/html" }], [".css", { description: "CSS stylesheet", mime: "text/css" }], [".svg", { description: "SVG image", mime: "image/svg+xml" }], [".md", { description: "Markdown document", mime: "text/markdown" }], [".markdown", { description: "Markdown document", mime: "text/markdown" }], [".txt", { description: "ASCII text", mime: "text/plain" }], [".rst", { description: "reStructuredText", mime: "text/x-rst" }], [".env", { description: "ASCII text", mime: "text/plain" }], [".gitignore", { description: "ASCII text", mime: "text/plain" }], [".dockerignore", { description: "ASCII text", mime: "text/plain" }]]);
    Gt2 = /* @__PURE__ */ new Map([["jpg", "JPEG image data"], ["jpeg", "JPEG image data"], ["png", "PNG image data"], ["gif", "GIF image data"], ["webp", "WebP image data"], ["bmp", "PC bitmap"], ["ico", "MS Windows icon resource"], ["tif", "TIFF image data"], ["tiff", "TIFF image data"], ["psd", "Adobe Photoshop Document"], ["avif", "AVIF image"], ["heic", "HEIC image"], ["heif", "HEIF image"], ["jxl", "JPEG XL image"], ["icns", "Mac OS X icon"], ["svg", "SVG Scalable Vector Graphics image"], ["pdf", "PDF document"], ["epub", "EPUB document"], ["mobi", "Mobipocket E-book"], ["djvu", "DjVu document"], ["zip", "Zip archive data"], ["gz", "gzip compressed data"], ["gzip", "gzip compressed data"], ["bz2", "bzip2 compressed data"], ["xz", "XZ compressed data"], ["tar", "POSIX tar archive"], ["rar", "RAR archive data"], ["7z", "7-zip archive data"], ["lz", "lzip compressed data"], ["lzma", "LZMA compressed data"], ["zst", "Zstandard compressed data"], ["cab", "Microsoft Cabinet archive"], ["ar", "Unix ar archive"], ["rpm", "RPM package"], ["deb", "Debian binary package"], ["apk", "Android Package"], ["dmg", "Apple disk image"], ["iso", "ISO 9660 CD-ROM filesystem data"], ["vhd", "Microsoft Virtual Hard Disk"], ["vhdx", "Microsoft Virtual Hard Disk (new format)"], ["qcow2", "QEMU QCOW Image"], ["mp3", "Audio file with ID3"], ["m4a", "MPEG-4 audio"], ["aac", "AAC audio"], ["wav", "RIFF (little-endian) data, WAVE audio"], ["flac", "FLAC audio bitstream data"], ["ogg", "Ogg data"], ["oga", "Ogg audio"], ["opus", "Ogg Opus audio"], ["aiff", "AIFF audio"], ["wma", "Windows Media Audio"], ["amr", "AMR audio"], ["mid", "MIDI audio"], ["midi", "MIDI audio"], ["ape", "Monkey's Audio"], ["mp4", "ISO Media, MPEG-4"], ["m4v", "MPEG-4 video"], ["webm", "WebM"], ["avi", "RIFF (little-endian) data, AVI"], ["mov", "ISO Media, Apple QuickTime movie"], ["mkv", "Matroska data"], ["wmv", "Windows Media Video"], ["flv", "Flash Video"], ["3gp", "3GPP multimedia"], ["3g2", "3GPP2 multimedia"], ["ogv", "Ogg video"], ["mts", "MPEG transport stream"], ["m2ts", "MPEG transport stream"], ["ts", "MPEG transport stream"], ["mpg", "MPEG video"], ["mpeg", "MPEG video"], ["exe", "PE32 executable"], ["dll", "PE32 DLL"], ["elf", "ELF executable"], ["mach", "Mach-O executable"], ["wasm", "WebAssembly (wasm) binary module"], ["dex", "Android Dalvik executable"], ["class", "Java class file"], ["swf", "Adobe Flash"], ["doc", "Microsoft Word Document"], ["docx", "Microsoft Word 2007+ Document"], ["xls", "Microsoft Excel Spreadsheet"], ["xlsx", "Microsoft Excel 2007+ Spreadsheet"], ["ppt", "Microsoft PowerPoint Presentation"], ["pptx", "Microsoft PowerPoint 2007+ Presentation"], ["odt", "OpenDocument Text"], ["ods", "OpenDocument Spreadsheet"], ["odp", "OpenDocument Presentation"], ["ttf", "TrueType Font"], ["otf", "OpenType Font"], ["woff", "Web Open Font Format"], ["woff2", "Web Open Font Format 2"], ["eot", "Embedded OpenType font"], ["stl", "Stereolithography CAD"], ["obj", "Wavefront 3D Object"], ["gltf", "GL Transmission Format"], ["glb", "GL Transmission Format (binary)"], ["sqlite", "SQLite 3.x database"], ["mdb", "Microsoft Access Database"], ["xml", "XML document"], ["json", "JSON data"], ["macho", "Mach-O binary"], ["ics", "iCalendar data"], ["vcf", "vCard data"], ["msi", "Microsoft Installer"], ["ps", "PostScript"], ["ai", "Adobe Illustrator"], ["indd", "Adobe InDesign"], ["sketch", "Sketch design file"], ["fig", "Figma design file"], ["xd", "Adobe XD"], ["blend", "Blender"], ["fbx", "Autodesk FBX"], ["lnk", "MS Windows shortcut"], ["alias", "Mac OS alias"], ["torrent", "BitTorrent file"], ["pcap", "pcap capture file"], ["arrow", "Apache Arrow"], ["parquet", "Apache Parquet"]]);
    Dr2 = { name: "file", async execute(i10, e5) {
      if (o2(i10)) return s(Vt);
      let t6 = false, r8 = false, n23 = [];
      for (let c14 of i10) if (c14.startsWith("--")) {
        if (c14 === "--brief") t6 = true;
        else if (c14 === "--mime" || c14 === "--mime-type") r8 = true;
        else if (c14 !== "--dereference") return r3("file", c14);
      } else if (c14.startsWith("-") && c14 !== "-") {
        for (let p17 of c14.slice(1)) if (p17 === "b") t6 = true;
        else if (p17 === "i") r8 = true;
        else if (p17 !== "L") return r3("file", `-${p17}`);
      } else n23.push(c14);
      if (n23.length === 0) return { stdout: "", stderr: `Usage: file [-bLi] FILE...
`, exitCode: 1 };
      let o9 = "", s9 = 0;
      for (let c14 of n23) try {
        let p17 = e5.fs.resolvePath(e5.cwd, c14);
        if ((await e5.fs.stat(p17)).isDirectory) {
          let u10 = r8 ? "inode/directory" : "directory";
          o9 += t6 ? `${u10}
` : `${c14}: ${u10}
`;
          continue;
        }
        let a7 = await e5.fs.readFileBuffer(p17), f11 = await Qt2(c14, a7), l8 = r8 ? f11.mime : f11.description;
        o9 += t6 ? `${l8}
` : `${c14}: ${l8}
`;
      } catch {
        o9 += t6 ? `cannot open
` : `${c14}: cannot open (No such file or directory)
`, s9 = 1;
      }
      return { stdout: o9, stderr: "", exitCode: s9 };
    } };
    Mr2 = { name: "file", flags: [{ flag: "-b", type: "boolean" }, { flag: "-i", type: "boolean" }, { flag: "-L", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/file-ZIGAJ4YS.js
var file_ZIGAJ4YS_exports = {};
__export(file_ZIGAJ4YS_exports, {
  fileCommand: () => Dr2,
  flagsForFuzzing: () => Mr2
});
var init_file_ZIGAJ4YS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/file-ZIGAJ4YS.js"() {
    init_chunk_CR5AFCPT();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/turndown/lib/turndown.browser.es.js
function extend(destination) {
  for (var i10 = 1; i10 < arguments.length; i10++) {
    var source = arguments[i10];
    for (var key in source) {
      if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
  }
  return destination;
}
function repeat(character, count) {
  return Array(count + 1).join(character);
}
function trimLeadingNewlines(string) {
  return string.replace(/^\n*/, "");
}
function trimTrailingNewlines(string) {
  var indexEnd = string.length;
  while (indexEnd > 0 && string[indexEnd - 1] === "\n") indexEnd--;
  return string.substring(0, indexEnd);
}
function trimNewlines(string) {
  return trimTrailingNewlines(trimLeadingNewlines(string));
}
function isBlock(node) {
  return is(node, blockElements);
}
function isVoid(node) {
  return is(node, voidElements);
}
function hasVoid(node) {
  return has(node, voidElements);
}
function isMeaningfulWhenBlank(node) {
  return is(node, meaningfulWhenBlankElements);
}
function hasMeaningfulWhenBlank(node) {
  return has(node, meaningfulWhenBlankElements);
}
function is(node, tagNames) {
  return tagNames.indexOf(node.nodeName) >= 0;
}
function has(node, tagNames) {
  return node.getElementsByTagName && tagNames.some(function(tagName) {
    return node.getElementsByTagName(tagName).length;
  });
}
function cleanAttribute(attribute) {
  return attribute ? attribute.replace(/(\n+\s*)+/g, "\n") : "";
}
function Rules(options) {
  this.options = options;
  this._keep = [];
  this._remove = [];
  this.blankRule = {
    replacement: options.blankReplacement
  };
  this.keepReplacement = options.keepReplacement;
  this.defaultRule = {
    replacement: options.defaultReplacement
  };
  this.array = [];
  for (var key in options.rules) this.array.push(options.rules[key]);
}
function findRule(rules2, node, options) {
  for (var i10 = 0; i10 < rules2.length; i10++) {
    var rule = rules2[i10];
    if (filterValue(rule, node, options)) return rule;
  }
  return void 0;
}
function filterValue(rule, node, options) {
  var filter2 = rule.filter;
  if (typeof filter2 === "string") {
    if (filter2 === node.nodeName.toLowerCase()) return true;
  } else if (Array.isArray(filter2)) {
    if (filter2.indexOf(node.nodeName.toLowerCase()) > -1) return true;
  } else if (typeof filter2 === "function") {
    if (filter2.call(rule, node, options)) return true;
  } else {
    throw new TypeError("`filter` needs to be a string, array, or function");
  }
}
function collapseWhitespace(options) {
  var element = options.element;
  var isBlock2 = options.isBlock;
  var isVoid2 = options.isVoid;
  var isPre = options.isPre || function(node2) {
    return node2.nodeName === "PRE";
  };
  if (!element.firstChild || isPre(element)) return;
  var prevText = null;
  var keepLeadingWs = false;
  var prev = null;
  var node = next(prev, element, isPre);
  while (node !== element) {
    if (node.nodeType === 3 || node.nodeType === 4) {
      var text = node.data.replace(/[ \r\n\t]+/g, " ");
      if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === " ") {
        text = text.substr(1);
      }
      if (!text) {
        node = remove(node);
        continue;
      }
      node.data = text;
      prevText = node;
    } else if (node.nodeType === 1) {
      if (isBlock2(node) || node.nodeName === "BR") {
        if (prevText) {
          prevText.data = prevText.data.replace(/ $/, "");
        }
        prevText = null;
        keepLeadingWs = false;
      } else if (isVoid2(node) || isPre(node)) {
        prevText = null;
        keepLeadingWs = true;
      } else if (prevText) {
        keepLeadingWs = false;
      }
    } else {
      node = remove(node);
      continue;
    }
    var nextNode = next(prev, node, isPre);
    prev = node;
    node = nextNode;
  }
  if (prevText) {
    prevText.data = prevText.data.replace(/ $/, "");
    if (!prevText.data) {
      remove(prevText);
    }
  }
}
function remove(node) {
  var next2 = node.nextSibling || node.parentNode;
  node.parentNode.removeChild(node);
  return next2;
}
function next(prev, current, isPre) {
  if (prev && prev.parentNode === current || isPre(current)) {
    return current.nextSibling || current.parentNode;
  }
  return current.firstChild || current.nextSibling || current.parentNode;
}
function canParseHTMLNatively() {
  var Parser = root.DOMParser;
  var canParse = false;
  try {
    if (new Parser().parseFromString("", "text/html")) {
      canParse = true;
    }
  } catch (e5) {
  }
  return canParse;
}
function createHTMLParser() {
  var Parser = function() {
  };
  {
    if (shouldUseActiveX()) {
      Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject("htmlfile");
        doc.designMode = "on";
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
      };
    } else {
      Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument("");
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
      };
    }
  }
  return Parser;
}
function shouldUseActiveX() {
  var useActiveX = false;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch (e5) {
    if (root.ActiveXObject) useActiveX = true;
  }
  return useActiveX;
}
function RootNode(input, options) {
  var root2;
  if (typeof input === "string") {
    var doc = htmlParser().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + input + "</x-turndown>",
      "text/html"
    );
    root2 = doc.getElementById("turndown-root");
  } else {
    root2 = input.cloneNode(true);
  }
  collapseWhitespace({
    element: root2,
    isBlock,
    isVoid,
    isPre: options.preformattedCode ? isPreOrCode : null
  });
  return root2;
}
function htmlParser() {
  _htmlParser = _htmlParser || new HTMLParser();
  return _htmlParser;
}
function isPreOrCode(node) {
  return node.nodeName === "PRE" || node.nodeName === "CODE";
}
function Node(node, options) {
  node.isBlock = isBlock(node);
  node.isCode = node.nodeName === "CODE" || node.parentNode.isCode;
  node.isBlank = isBlank(node);
  node.flankingWhitespace = flankingWhitespace(node, options);
  return node;
}
function isBlank(node) {
  return !isVoid(node) && !isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !hasVoid(node) && !hasMeaningfulWhenBlank(node);
}
function flankingWhitespace(node, options) {
  if (node.isBlock || options.preformattedCode && node.isCode) {
    return { leading: "", trailing: "" };
  }
  var edges = edgeWhitespace(node.textContent);
  if (edges.leadingAscii && isFlankedByWhitespace("left", node, options)) {
    edges.leading = edges.leadingNonAscii;
  }
  if (edges.trailingAscii && isFlankedByWhitespace("right", node, options)) {
    edges.trailing = edges.trailingNonAscii;
  }
  return { leading: edges.leading, trailing: edges.trailing };
}
function edgeWhitespace(string) {
  var m24 = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: m24[1],
    // whole string for whitespace-only strings
    leadingAscii: m24[2],
    leadingNonAscii: m24[3],
    trailing: m24[4],
    // empty for whitespace-only strings
    trailingNonAscii: m24[5],
    trailingAscii: m24[6]
  };
}
function isFlankedByWhitespace(side, node, options) {
  var sibling;
  var regExp;
  var isFlanked;
  if (side === "left") {
    sibling = node.previousSibling;
    regExp = / $/;
  } else {
    sibling = node.nextSibling;
    regExp = /^ /;
  }
  if (sibling) {
    if (sibling.nodeType === 3) {
      isFlanked = regExp.test(sibling.nodeValue);
    } else if (options.preformattedCode && sibling.nodeName === "CODE") {
      isFlanked = false;
    } else if (sibling.nodeType === 1 && !isBlock(sibling)) {
      isFlanked = regExp.test(sibling.textContent);
    }
  }
  return isFlanked;
}
function TurndownService(options) {
  if (!(this instanceof TurndownService)) return new TurndownService(options);
  var defaults2 = {
    rules,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: false,
    blankReplacement: function(content, node) {
      return node.isBlock ? "\n\n" : "";
    },
    keepReplacement: function(content, node) {
      return node.isBlock ? "\n\n" + node.outerHTML + "\n\n" : node.outerHTML;
    },
    defaultReplacement: function(content, node) {
      return node.isBlock ? "\n\n" + content + "\n\n" : content;
    }
  };
  this.options = extend({}, defaults2, options);
  this.rules = new Rules(this.options);
}
function process2(parentNode) {
  var self2 = this;
  return reduce.call(parentNode.childNodes, function(output, node) {
    node = new Node(node, self2.options);
    var replacement = "";
    if (node.nodeType === 3) {
      replacement = node.isCode ? node.nodeValue : self2.escape(node.nodeValue);
    } else if (node.nodeType === 1) {
      replacement = replacementForNode.call(self2, node);
    }
    return join2(output, replacement);
  }, "");
}
function postProcess(output) {
  var self2 = this;
  this.rules.forEach(function(rule) {
    if (typeof rule.append === "function") {
      output = join2(output, rule.append(self2.options));
    }
  });
  return output.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function replacementForNode(node) {
  var rule = this.rules.forNode(node);
  var content = process2.call(this, node);
  var whitespace = node.flankingWhitespace;
  if (whitespace.leading || whitespace.trailing) content = content.trim();
  return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
function join2(output, replacement) {
  var s12 = trimTrailingNewlines(output);
  var s22 = trimLeadingNewlines(replacement);
  var nls = Math.max(output.length - s12.length, replacement.length - s22.length);
  var separator = "\n\n".substring(0, nls);
  return s12 + separator + s22;
}
function canConvert(input) {
  return input != null && (typeof input === "string" || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}
var blockElements, voidElements, meaningfulWhenBlankElements, rules, root, HTMLParser, _htmlParser, reduce, escapes, turndown_browser_es_default;
var init_turndown_browser_es = __esm({
  "../../node_modules/turndown/lib/turndown.browser.es.js"() {
    blockElements = [
      "ADDRESS",
      "ARTICLE",
      "ASIDE",
      "AUDIO",
      "BLOCKQUOTE",
      "BODY",
      "CANVAS",
      "CENTER",
      "DD",
      "DIR",
      "DIV",
      "DL",
      "DT",
      "FIELDSET",
      "FIGCAPTION",
      "FIGURE",
      "FOOTER",
      "FORM",
      "FRAMESET",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "HEADER",
      "HGROUP",
      "HR",
      "HTML",
      "ISINDEX",
      "LI",
      "MAIN",
      "MENU",
      "NAV",
      "NOFRAMES",
      "NOSCRIPT",
      "OL",
      "OUTPUT",
      "P",
      "PRE",
      "SECTION",
      "TABLE",
      "TBODY",
      "TD",
      "TFOOT",
      "TH",
      "THEAD",
      "TR",
      "UL"
    ];
    voidElements = [
      "AREA",
      "BASE",
      "BR",
      "COL",
      "COMMAND",
      "EMBED",
      "HR",
      "IMG",
      "INPUT",
      "KEYGEN",
      "LINK",
      "META",
      "PARAM",
      "SOURCE",
      "TRACK",
      "WBR"
    ];
    meaningfulWhenBlankElements = [
      "A",
      "TABLE",
      "THEAD",
      "TBODY",
      "TFOOT",
      "TH",
      "TD",
      "IFRAME",
      "SCRIPT",
      "AUDIO",
      "VIDEO"
    ];
    rules = {};
    rules.paragraph = {
      filter: "p",
      replacement: function(content) {
        return "\n\n" + content + "\n\n";
      }
    };
    rules.lineBreak = {
      filter: "br",
      replacement: function(content, node, options) {
        return options.br + "\n";
      }
    };
    rules.heading = {
      filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
      replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === "setext" && hLevel < 3) {
          var underline = repeat(hLevel === 1 ? "=" : "-", content.length);
          return "\n\n" + content + "\n" + underline + "\n\n";
        } else {
          return "\n\n" + repeat("#", hLevel) + " " + content + "\n\n";
        }
      }
    };
    rules.blockquote = {
      filter: "blockquote",
      replacement: function(content) {
        content = trimNewlines(content).replace(/^/gm, "> ");
        return "\n\n" + content + "\n\n";
      }
    };
    rules.list = {
      filter: ["ul", "ol"],
      replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === "LI" && parent.lastElementChild === node) {
          return "\n" + content;
        } else {
          return "\n\n" + content + "\n\n";
        }
      }
    };
    rules.listItem = {
      filter: "li",
      replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + "   ";
        var parent = node.parentNode;
        if (parent.nodeName === "OL") {
          var start = parent.getAttribute("start");
          var index = Array.prototype.indexOf.call(parent.children, node);
          prefix = (start ? Number(start) + index : index + 1) + ".  ";
        }
        var isParagraph = /\n$/.test(content);
        content = trimNewlines(content) + (isParagraph ? "\n" : "");
        content = content.replace(/\n/gm, "\n" + " ".repeat(prefix.length));
        return prefix + content + (node.nextSibling ? "\n" : "");
      }
    };
    rules.indentedCodeBlock = {
      filter: function(node, options) {
        return options.codeBlockStyle === "indented" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
      },
      replacement: function(content, node, options) {
        return "\n\n    " + node.firstChild.textContent.replace(/\n/g, "\n    ") + "\n\n";
      }
    };
    rules.fencedCodeBlock = {
      filter: function(node, options) {
        return options.codeBlockStyle === "fenced" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
      },
      replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute("class") || "";
        var language = (className.match(/language-(\S+)/) || [null, ""])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp("^" + fenceChar + "{3,}", "gm");
        var match2;
        while (match2 = fenceInCodeRegex.exec(code)) {
          if (match2[0].length >= fenceSize) {
            fenceSize = match2[0].length + 1;
          }
        }
        var fence = repeat(fenceChar, fenceSize);
        return "\n\n" + fence + language + "\n" + code.replace(/\n$/, "") + "\n" + fence + "\n\n";
      }
    };
    rules.horizontalRule = {
      filter: "hr",
      replacement: function(content, node, options) {
        return "\n\n" + options.hr + "\n\n";
      }
    };
    rules.inlineLink = {
      filter: function(node, options) {
        return options.linkStyle === "inlined" && node.nodeName === "A" && node.getAttribute("href");
      },
      replacement: function(content, node) {
        var href = node.getAttribute("href");
        if (href) href = href.replace(/([()])/g, "\\$1");
        var title = cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title.replace(/"/g, '\\"') + '"';
        return "[" + content + "](" + href + title + ")";
      }
    };
    rules.referenceLink = {
      filter: function(node, options) {
        return options.linkStyle === "referenced" && node.nodeName === "A" && node.getAttribute("href");
      },
      replacement: function(content, node, options) {
        var href = node.getAttribute("href");
        var title = cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title + '"';
        var replacement;
        var reference;
        switch (options.linkReferenceStyle) {
          case "collapsed":
            replacement = "[" + content + "][]";
            reference = "[" + content + "]: " + href + title;
            break;
          case "shortcut":
            replacement = "[" + content + "]";
            reference = "[" + content + "]: " + href + title;
            break;
          default:
            var id = this.references.length + 1;
            replacement = "[" + content + "][" + id + "]";
            reference = "[" + id + "]: " + href + title;
        }
        this.references.push(reference);
        return replacement;
      },
      references: [],
      append: function(options) {
        var references = "";
        if (this.references.length) {
          references = "\n\n" + this.references.join("\n") + "\n\n";
          this.references = [];
        }
        return references;
      }
    };
    rules.emphasis = {
      filter: ["em", "i"],
      replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.emDelimiter + content + options.emDelimiter;
      }
    };
    rules.strong = {
      filter: ["strong", "b"],
      replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.strongDelimiter + content + options.strongDelimiter;
      }
    };
    rules.code = {
      filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === "PRE" && !hasSiblings;
        return node.nodeName === "CODE" && !isCodeBlock;
      },
      replacement: function(content) {
        if (!content) return "";
        content = content.replace(/\r?\n|\r/g, " ");
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? " " : "";
        var delimiter = "`";
        var matches = content.match(/`+/gm) || [];
        while (matches.indexOf(delimiter) !== -1) delimiter = delimiter + "`";
        return delimiter + extraSpace + content + extraSpace + delimiter;
      }
    };
    rules.image = {
      filter: "img",
      replacement: function(content, node) {
        var alt = cleanAttribute(node.getAttribute("alt"));
        var src = node.getAttribute("src") || "";
        var title = cleanAttribute(node.getAttribute("title"));
        var titlePart = title ? ' "' + title + '"' : "";
        return src ? "![" + alt + "](" + src + titlePart + ")" : "";
      }
    };
    Rules.prototype = {
      add: function(key, rule) {
        this.array.unshift(rule);
      },
      keep: function(filter2) {
        this._keep.unshift({
          filter: filter2,
          replacement: this.keepReplacement
        });
      },
      remove: function(filter2) {
        this._remove.unshift({
          filter: filter2,
          replacement: function() {
            return "";
          }
        });
      },
      forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = findRule(this.array, node, this.options)) return rule;
        if (rule = findRule(this._keep, node, this.options)) return rule;
        if (rule = findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
      },
      forEach: function(fn2) {
        for (var i10 = 0; i10 < this.array.length; i10++) fn2(this.array[i10], i10);
      }
    };
    root = typeof window !== "undefined" ? window : {};
    HTMLParser = canParseHTMLNatively() ? root.DOMParser : createHTMLParser();
    reduce = Array.prototype.reduce;
    escapes = [
      [/\\/g, "\\\\"],
      [/\*/g, "\\*"],
      [/^-/g, "\\-"],
      [/^\+ /g, "\\+ "],
      [/^(=+)/g, "\\$1"],
      [/^(#{1,6}) /g, "\\$1 "],
      [/`/g, "\\`"],
      [/^~~~/g, "\\~~~"],
      [/\[/g, "\\["],
      [/\]/g, "\\]"],
      [/^>/g, "\\>"],
      [/_/g, "\\_"],
      [/^(\d+)\. /g, "$1\\. "]
    ];
    TurndownService.prototype = {
      /**
       * The entry point for converting a string or DOM node to Markdown
       * @public
       * @param {String|HTMLElement} input The string or DOM node to convert
       * @returns A Markdown representation of the input
       * @type String
       */
      turndown: function(input) {
        if (!canConvert(input)) {
          throw new TypeError(
            input + " is not a string, or an element/document/fragment node."
          );
        }
        if (input === "") return "";
        var output = process2.call(this, new RootNode(input, this.options));
        return postProcess.call(this, output);
      },
      /**
       * Add one or more plugins
       * @public
       * @param {Function|Array} plugin The plugin or array of plugins to add
       * @returns The Turndown instance for chaining
       * @type Object
       */
      use: function(plugin) {
        if (Array.isArray(plugin)) {
          for (var i10 = 0; i10 < plugin.length; i10++) this.use(plugin[i10]);
        } else if (typeof plugin === "function") {
          plugin(this);
        } else {
          throw new TypeError("plugin must be a Function or an Array of Functions");
        }
        return this;
      },
      /**
       * Adds a rule
       * @public
       * @param {String} key The unique key of the rule
       * @param {Object} rule The rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
      },
      /**
       * Keep a node (as HTML) that matches the filter
       * @public
       * @param {String|Array|Function} filter The unique key of the rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      keep: function(filter2) {
        this.rules.keep(filter2);
        return this;
      },
      /**
       * Remove a node that matches the filter
       * @public
       * @param {String|Array|Function} filter The unique key of the rule
       * @returns The Turndown instance for chaining
       * @type Object
       */
      remove: function(filter2) {
        this.rules.remove(filter2);
        return this;
      },
      /**
       * Escapes Markdown syntax
       * @public
       * @param {String} string The string to escape
       * @returns A string with Markdown syntax escaped
       * @type String
       */
      escape: function(string) {
        return escapes.reduce(function(accumulator, escape2) {
          return accumulator.replace(escape2[0], escape2[1]);
        }, string);
      }
    };
    turndown_browser_es_default = TurndownService;
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-MDLLFABN.js
var p15, g14, x17;
var init_chunk_MDLLFABN = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-MDLLFABN.js"() {
    init_chunk_74CEPOFO();
    init_turndown_browser_es();
    p15 = { name: "html-to-markdown", summary: "convert HTML to Markdown (BashEnv extension)", usage: "html-to-markdown [OPTION]... [FILE]", description: ["Convert HTML content to Markdown format using the turndown library.", "This is a non-standard BashEnv extension command, not available in regular bash.", "", "Read HTML from FILE or standard input and output Markdown to standard output.", "Commonly used with curl to convert web pages:", "  curl -s https://example.com | html-to-markdown", "", "Supported HTML elements:", "  - Headings (h1-h6) \u2192 # Markdown headings", "  - Paragraphs (p) \u2192 Plain text with blank lines", "  - Links (a) \u2192 [text](url)", "  - Images (img) \u2192 ![alt](src)", "  - Bold/Strong \u2192 **text**", "  - Italic/Em \u2192 _text_", "  - Code (code, pre) \u2192 `inline` or fenced blocks", "  - Lists (ul, ol, li) \u2192 - or 1. items", "  - Blockquotes \u2192 > quoted text", "  - Horizontal rules (hr) \u2192 ---"], options: ["-b, --bullet=CHAR     bullet character for unordered lists (-, +, or *)", "-c, --code=FENCE      fence style for code blocks (``` or ~~~)", "-r, --hr=STRING       string for horizontal rules (default: ---)", "    --heading-style=STYLE", "                      heading style: 'atx' for # headings (default),", "                      'setext' for underlined headings (h1/h2 only)", "    --help            display this help and exit"], examples: ["echo '<h1>Hello</h1><p>World</p>' | html-to-markdown", "html-to-markdown page.html", "curl -s https://example.com | html-to-markdown > page.md"] };
    g14 = { name: "html-to-markdown", async execute(r8, n23) {
      if (o2(r8)) return s(p15);
      let s9 = "-", a7 = "```", i10 = "---", m24 = "atx", o9 = [];
      for (let e5 = 0; e5 < r8.length; e5++) {
        let t6 = r8[e5];
        if (t6 === "-b" || t6 === "--bullet") s9 = r8[++e5] ?? "-";
        else if (t6.startsWith("--bullet=")) s9 = t6.slice(9);
        else if (t6 === "-c" || t6 === "--code") a7 = r8[++e5] ?? "```";
        else if (t6.startsWith("--code=")) a7 = t6.slice(7);
        else if (t6 === "-r" || t6 === "--hr") i10 = r8[++e5] ?? "---";
        else if (t6.startsWith("--hr=")) i10 = t6.slice(5);
        else if (t6.startsWith("--heading-style=")) {
          let d16 = t6.slice(16);
          (d16 === "setext" || d16 === "atx") && (m24 = d16);
        } else if (t6 === "-") o9.push("-");
        else {
          if (t6.startsWith("--")) return r3("html-to-markdown", t6);
          if (t6.startsWith("-")) return r3("html-to-markdown", t6);
          o9.push(t6);
        }
      }
      let l8;
      if (o9.length === 0 || o9.length === 1 && o9[0] === "-") l8 = n23.stdin;
      else try {
        let e5 = n23.fs.resolvePath(n23.cwd, o9[0]);
        l8 = await n23.fs.readFile(e5);
      } catch {
        return { stdout: "", stderr: `html-to-markdown: ${o9[0]}: No such file or directory
`, exitCode: 1 };
      }
      if (!l8.trim()) return { stdout: "", stderr: "", exitCode: 0 };
      try {
        let e5 = new turndown_browser_es_default({ bulletListMarker: s9, codeBlockStyle: "fenced", fence: a7, hr: i10, headingStyle: m24 });
        return e5.remove(["script", "style", "footer"]), { stdout: `${e5.turndown(l8).trim()}
`, stderr: "", exitCode: 0 };
      } catch (e5) {
        return { stdout: "", stderr: `html-to-markdown: conversion error: ${e5.message}
`, exitCode: 1 };
      }
    } };
    x17 = { name: "html-to-markdown", flags: [], stdinType: "text" };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/html-to-markdown-TFCECAGV.js
var html_to_markdown_TFCECAGV_exports = {};
__export(html_to_markdown_TFCECAGV_exports, {
  flagsForFuzzing: () => x17,
  htmlToMarkdownCommand: () => g14
});
var init_html_to_markdown_TFCECAGV = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/html-to-markdown-TFCECAGV.js"() {
    init_chunk_MDLLFABN();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-ZKLK6C7H.js
function l5(n23) {
  let e5 = [], t6 = new Set(n23);
  e5.push(`Available commands:
`);
  let s9 = [];
  for (let [a7, r8] of c10) {
    let o9 = r8.filter((i10) => t6.has(i10));
    if (o9.length > 0) {
      e5.push(`  ${a7}:`), e5.push(`    ${o9.join(", ")}
`);
      for (let i10 of o9) t6.delete(i10);
    }
  }
  for (let a7 of t6) s9.push(a7);
  return s9.length > 0 && (e5.push("  Other:"), e5.push(`    ${s9.sort().join(", ")}
`)), e5.push("Use '<command> --help' for details on a specific command."), `${e5.join(`
`)}
`;
}
var c10, d15, m21;
var init_chunk_ZKLK6C7H = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-ZKLK6C7H.js"() {
    c10 = /* @__PURE__ */ new Map([["File operations", ["ls", "cat", "head", "tail", "wc", "touch", "mkdir", "rm", "cp", "mv", "ln", "chmod", "stat", "readlink"]], ["Text processing", ["grep", "sed", "awk", "sort", "uniq", "cut", "tr", "tee", "diff"]], ["Search", ["find"]], ["Navigation & paths", ["pwd", "basename", "dirname", "tree", "du"]], ["Environment & shell", ["echo", "printf", "env", "printenv", "export", "alias", "unalias", "history", "clear", "true", "false", "bash", "sh"]], ["Data processing", ["xargs", "jq", "base64", "date"]], ["Network", ["curl", "html-to-markdown"]]]);
    d15 = { name: "help", async execute(n23, e5) {
      if (n23.includes("--help") || n23.includes("-h")) return { stdout: `help - display available commands

Usage: help [command]

Options:
  -h, --help    Show this help message

If a command name is provided, shows help for that command.
Otherwise, lists all available commands.
`, stderr: "", exitCode: 0 };
      if (n23.length > 0 && e5.exec) {
        let s9 = n23[0];
        return e5.exec(`${s9} --help`, { cwd: e5.cwd });
      }
      let t6 = e5.getRegisteredCommands?.() ?? [];
      return { stdout: l5(t6), stderr: "", exitCode: 0 };
    } };
    m21 = { name: "help", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/help-T2NGLTSG.js
var help_T2NGLTSG_exports = {};
__export(help_T2NGLTSG_exports, {
  flagsForFuzzing: () => m21,
  helpCommand: () => d15
});
var init_help_T2NGLTSG = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/help-T2NGLTSG.js"() {
    init_chunk_ZKLK6C7H();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-UYGR3CFC.js
var g15, w16, A9, F16;
var init_chunk_UYGR3CFC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-UYGR3CFC.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    g15 = { name: "which", summary: "locate a command", usage: "which [-as] program ...", options: ["-a         List all instances of executables found", "-s         No output, just return 0 if found, 1 if not", "--help     display this help and exit"] };
    w16 = { showAll: { short: "a", type: "boolean" }, silent: { short: "s", type: "boolean" } };
    A9 = { name: "which", async execute(e5, s9) {
      if (o2(e5)) return s(g15);
      let t6 = x3("which", e5, w16);
      if (!t6.ok) return t6.error;
      let c14 = t6.result.flags.showAll, p17 = t6.result.flags.silent, o9 = t6.result.positional;
      if (o9.length === 0) return { stdout: "", stderr: "", exitCode: 1 };
      let d16 = (s9.env.get("PATH") || "/usr/bin:/bin").split(":"), n23 = "", a7 = true;
      for (let m24 of o9) {
        let l8 = false;
        for (let r8 of d16) {
          if (!r8) continue;
          let i10 = `${r8}/${m24}`;
          if (await s9.fs.exists(i10) && (l8 = true, p17 || (n23 += `${i10}
`), !c14)) break;
        }
        l8 || (a7 = false);
      }
      return { stdout: n23, stderr: "", exitCode: a7 ? 0 : 1 };
    } };
    F16 = { name: "which", flags: [{ flag: "-a", type: "boolean" }, { flag: "-s", type: "boolean" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/which-NCIYTMAT.js
var which_NCIYTMAT_exports = {};
__export(which_NCIYTMAT_exports, {
  flagsForFuzzing: () => F16,
  whichCommand: () => A9
});
var init_which_NCIYTMAT = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/which-NCIYTMAT.js"() {
    init_chunk_UYGR3CFC();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-NQOQ2Q77.js
async function c11(t6, s9) {
  if (t6.length > 0 && t6[0] !== "-") {
    let i10 = t6[0].startsWith("/") ? t6[0] : `${s9.cwd}/${t6[0]}`;
    try {
      let n23 = (await s9.fs.readFile(i10)).split(`
`);
      n23[n23.length - 1] === "" && n23.pop();
      let r8 = n23.reverse();
      return { stdout: r8.length > 0 ? `${r8.join(`
`)}
` : "", stderr: "", exitCode: 0 };
    } catch {
      return { stdout: "", stderr: `tac: ${t6[0]}: No such file or directory
`, exitCode: 1 };
    }
  }
  let e5 = s9.stdin.split(`
`);
  e5[e5.length - 1] === "" && e5.pop();
  let o9 = e5.reverse();
  return { stdout: o9.length > 0 ? `${o9.join(`
`)}
` : "", stderr: "", exitCode: 0 };
}
var l6, u6;
var init_chunk_NQOQ2Q77 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-NQOQ2Q77.js"() {
    l6 = { name: "tac", execute: c11 };
    u6 = { name: "tac", flags: [], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tac-T7YAU2Y6.js
var tac_T7YAU2Y6_exports = {};
__export(tac_T7YAU2Y6_exports, {
  flagsForFuzzing: () => u6,
  tac: () => l6
});
var init_tac_T7YAU2Y6 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tac-T7YAU2Y6.js"() {
    init_chunk_NQOQ2Q77();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-4HHKTUW3.js
async function t5(e5, n23) {
  return { stdout: `localhost
`, stderr: "", exitCode: 0 };
}
var o8, s7;
var init_chunk_4HHKTUW3 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-4HHKTUW3.js"() {
    o8 = { name: "hostname", execute: t5 };
    s7 = { name: "hostname", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/hostname-BK6HG2DE.js
var hostname_BK6HG2DE_exports = {};
__export(hostname_BK6HG2DE_exports, {
  flagsForFuzzing: () => s7,
  hostname: () => o8
});
var init_hostname_BK6HG2DE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/hostname-BK6HG2DE.js"() {
    init_chunk_4HHKTUW3();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HJQJAYMS.js
async function e4(t6, o9) {
  return { stdout: `user
`, stderr: "", exitCode: 0 };
}
var a4, n20;
var init_chunk_HJQJAYMS = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HJQJAYMS.js"() {
    a4 = { name: "whoami", execute: e4 };
    n20 = { name: "whoami", flags: [] };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/whoami-DGKU3D2X.js
var whoami_DGKU3D2X_exports = {};
__export(whoami_DGKU3D2X_exports, {
  flagsForFuzzing: () => n20,
  whoami: () => a4
});
var init_whoami_DGKU3D2X = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/whoami-DGKU3D2X.js"() {
    init_chunk_HJQJAYMS();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-PP6PSHAB.js
async function x18(a7, u10) {
  let o9 = "octal", n23 = [], i10 = [];
  for (let t6 = 0; t6 < a7.length; t6++) {
    let e5 = a7[t6];
    if (e5 === "-c") n23.push("char");
    else if (e5 === "-An" || e5 === "-A" && a7[t6 + 1] === "n") o9 = "none", e5 === "-A" && t6++;
    else if (e5 === "-t" && a7[t6 + 1]) {
      let r8 = a7[++t6];
      r8 === "x1" ? n23.push("hex") : r8 === "c" ? n23.push("char") : r8.startsWith("o") && n23.push("octal");
    } else (!e5.startsWith("-") || e5 === "-") && i10.push(e5);
  }
  n23.length === 0 && n23.push("octal");
  let c14 = u10.stdin;
  if (i10.length > 0 && i10[0] !== "-") {
    let t6 = i10[0].startsWith("/") ? i10[0] : `${u10.cwd}/${i10[0]}`;
    try {
      c14 = await u10.fs.readFile(t6);
    } catch {
      return { stdout: "", stderr: `od: ${i10[0]}: No such file or directory
`, exitCode: 1 };
    }
  }
  let d16 = n23.includes("char");
  function m24(t6) {
    return t6 === 0 ? "  \\0" : t6 === 7 ? "  \\a" : t6 === 8 ? "  \\b" : t6 === 9 ? "  \\t" : t6 === 10 ? "  \\n" : t6 === 11 ? "  \\v" : t6 === 12 ? "  \\f" : t6 === 13 ? "  \\r" : t6 >= 32 && t6 < 127 ? `   ${String.fromCharCode(t6)}` : ` ${t6.toString(8).padStart(3, "0")}`;
  }
  function y18(t6) {
    return d16 ? `  ${t6.toString(16).padStart(2, "0")}` : ` ${t6.toString(16).padStart(2, "0")}`;
  }
  function S16(t6) {
    return ` ${t6.toString(8).padStart(3, "0")}`;
  }
  let s9 = [];
  for (let t6 of c14) s9.push(t6.charCodeAt(0));
  let p17 = 16, f11 = [];
  for (let t6 = 0; t6 < s9.length; t6 += p17) {
    let e5 = s9.slice(t6, t6 + p17);
    for (let r8 = 0; r8 < n23.length; r8++) {
      let g18 = n23[r8], l8;
      g18 === "char" ? l8 = e5.map(m24) : g18 === "hex" ? l8 = e5.map(y18) : l8 = e5.map(S16);
      let h16 = "";
      r8 === 0 && o9 !== "none" ? h16 = `${t6.toString(8).padStart(7, "0")} ` : (r8 > 0 || o9 === "none") && (h16 = o9 === "none" ? "" : "        "), f11.push(h16 + l8.join(""));
    }
  }
  return o9 !== "none" && s9.length > 0 && f11.push(s9.length.toString(8).padStart(7, "0")), { stdout: f11.length > 0 ? `${f11.join(`
`)}
` : "", stderr: "", exitCode: 0 };
}
var $14, v16;
var init_chunk_PP6PSHAB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-PP6PSHAB.js"() {
    $14 = { name: "od", execute: x18 };
    v16 = { name: "od", flags: [{ flag: "-c", type: "boolean" }, { flag: "-A", type: "value", valueHint: "string" }, { flag: "-t", type: "value", valueHint: "string" }, { flag: "-N", type: "value", valueHint: "number" }], stdinType: "text", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/od-VJEF2UR5.js
var od_VJEF2UR5_exports = {};
__export(od_VJEF2UR5_exports, {
  flagsForFuzzing: () => v16,
  od: () => $14
});
var init_od_VJEF2UR5 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/od-VJEF2UR5.js"() {
    init_chunk_PP6PSHAB();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-DZ33S2U7.js
function F17(e5) {
  return e5.best ? constants.Z_BEST_COMPRESSION : e5.level8 ? 8 : e5.level7 ? 7 : e5.level6 ? 6 : e5.level5 ? 5 : e5.level4 ? 4 : e5.level3 ? 3 : e5.level2 ? 2 : e5.fast ? constants.Z_BEST_SPEED : constants.Z_DEFAULT_COMPRESSION;
}
function S10(e5) {
  if (e5.length < 10) return { originalName: null, mtime: null, headerSize: 0 };
  if (e5[0] !== 31 || e5[1] !== 139) return { originalName: null, mtime: null, headerSize: 0 };
  let t6 = e5[3], o9 = e5[4] | e5[5] << 8 | e5[6] << 16 | e5[7] << 24, r8 = 10;
  if (t6 & 4) {
    if (r8 + 2 > e5.length) return { originalName: null, mtime: null, headerSize: 0 };
    let n23 = e5[r8] | e5[r8 + 1] << 8;
    r8 += 2 + n23;
  }
  let s9 = null;
  if (t6 & 8) {
    let n23 = r8;
    for (; r8 < e5.length && e5[r8] !== 0; ) r8++;
    r8 < e5.length && (s9 = new TextDecoder().decode(e5.slice(n23, r8)), r8++);
  }
  if (t6 & 16) {
    for (; r8 < e5.length && e5[r8] !== 0; ) r8++;
    r8++;
  }
  return t6 & 2 && (r8 += 2), { originalName: s9, mtime: o9 > 0 ? new Date(o9 * 1e3) : null, headerSize: r8 };
}
function D12(e5) {
  if (e5.length < 4) return 0;
  let t6 = e5.length;
  return e5[t6 - 4] | e5[t6 - 3] << 8 | e5[t6 - 2] << 16 | e5[t6 - 1] << 24;
}
function m22(e5) {
  return e5.length >= 2 && e5[0] === 31 && e5[1] === 139;
}
async function E8(e5, t6, o9, r8, s9, n23) {
  let l8 = o9.suffix, f11, p17, a7;
  if (t6 === "-" || t6 === "") if (a7 = Uint8Array.from(e5.stdin, (u10) => u10.charCodeAt(0)), s9) {
    if (!m22(a7)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: stdin: not in gzip format
`, exitCode: 1 };
    try {
      let u10 = gunzipSync(a7);
      return { stdout: String.fromCharCode(...u10), stderr: "", exitCode: 0 };
    } catch (u10) {
      let i10 = u10 instanceof Error ? u10.message : "unknown error";
      return { stdout: "", stderr: `${r8}: stdin: ${i10}
`, exitCode: 1 };
    }
  } else {
    let u10 = F17(o9), i10 = gzipSync(a7, { level: u10 });
    return { stdout: String.fromCharCode(...i10), stderr: "", exitCode: 0 };
  }
  f11 = e5.fs.resolvePath(e5.cwd, t6);
  try {
    if ((await e5.fs.stat(f11)).isDirectory) return o9.recursive ? await k9(e5, f11, o9, r8, s9, n23) : o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: is a directory -- ignored
`, exitCode: 1 };
  } catch {
    return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  try {
    a7 = await e5.fs.readFileBuffer(f11);
  } catch {
    return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  if (s9) {
    if (!t6.endsWith(l8)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: unknown suffix -- ignored
`, exitCode: 1 };
    if (!m22(a7)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
    let u10;
    try {
      u10 = gunzipSync(a7);
    } catch (i10) {
      let c14 = i10 instanceof Error ? i10.message : "unknown error";
      return { stdout: "", stderr: `${r8}: ${t6}: ${c14}
`, exitCode: 1 };
    }
    if (n23) return { stdout: String.fromCharCode(...u10), stderr: "", exitCode: 0 };
    if (o9.name) {
      let i10 = S10(a7);
      i10.originalName ? p17 = e5.fs.resolvePath(e5.cwd, i10.originalName) : p17 = f11.slice(0, -l8.length);
    } else p17 = f11.slice(0, -l8.length);
    if (!o9.force) try {
      return await e5.fs.stat(p17), { stdout: "", stderr: `${r8}: ${p17} already exists; not overwritten
`, exitCode: 1 };
    } catch {
    }
    if (await e5.fs.writeFile(p17, u10), !o9.keep && !n23 && await e5.fs.rm(f11), o9.verbose) {
      let i10 = a7.length > 0 ? ((1 - a7.length / u10.length) * 100).toFixed(1) : "0.0";
      return { stdout: "", stderr: `${t6}:	${i10}% -- replaced with ${p17.split("/").pop()}
`, exitCode: 0 };
    }
    return { stdout: "", stderr: "", exitCode: 0 };
  } else {
    if (t6.endsWith(l8)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6} already has ${l8} suffix -- unchanged
`, exitCode: 1 };
    let u10 = F17(o9), i10;
    try {
      i10 = gzipSync(a7, { level: u10 });
    } catch (c14) {
      let d16 = c14 instanceof Error ? c14.message : "unknown error";
      return { stdout: "", stderr: `${r8}: ${t6}: ${d16}
`, exitCode: 1 };
    }
    if (n23) return { stdout: String.fromCharCode(...i10), stderr: "", exitCode: 0 };
    if (p17 = f11 + l8, !o9.force) try {
      return await e5.fs.stat(p17), { stdout: "", stderr: `${r8}: ${p17} already exists; not overwritten
`, exitCode: 1 };
    } catch {
    }
    if (await e5.fs.writeFile(p17, i10), !o9.keep && !n23 && await e5.fs.rm(f11), o9.verbose) {
      let c14 = a7.length > 0 ? ((1 - i10.length / a7.length) * 100).toFixed(1) : "0.0";
      return { stdout: "", stderr: `${t6}:	${c14}% -- replaced with ${p17.split("/").pop()}
`, exitCode: 0 };
    }
    return { stdout: "", stderr: "", exitCode: 0 };
  }
}
async function k9(e5, t6, o9, r8, s9, n23) {
  let l8 = await e5.fs.readdir(t6), f11 = "", p17 = "", a7 = 0;
  for (let u10 of l8) {
    let i10 = e5.fs.resolvePath(t6, u10), c14 = await e5.fs.stat(i10);
    if (c14.isDirectory) {
      let d16 = await k9(e5, i10, o9, r8, s9, n23);
      f11 += d16.stdout, p17 += d16.stderr, d16.exitCode !== 0 && (a7 = d16.exitCode);
    } else if (c14.isFile) {
      let d16 = o9.suffix;
      if (s9 && !u10.endsWith(d16) || !s9 && u10.endsWith(d16)) continue;
      let y18 = i10.startsWith(`${e5.cwd}/`) ? i10.slice(e5.cwd.length + 1) : i10, h16 = await E8(e5, y18, o9, r8, s9, n23);
      f11 += h16.stdout, p17 += h16.stderr, h16.exitCode !== 0 && (a7 = h16.exitCode);
    }
  }
  return { stdout: f11, stderr: p17, exitCode: a7 };
}
async function O11(e5, t6, o9, r8) {
  let s9;
  if (t6 === "-" || t6 === "") s9 = Uint8Array.from(e5.stdin, (i10) => i10.charCodeAt(0));
  else {
    let i10 = e5.fs.resolvePath(e5.cwd, t6);
    try {
      s9 = await e5.fs.readFileBuffer(i10);
    } catch {
      return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
    }
  }
  if (!m22(s9)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
  let n23 = s9.length, l8 = D12(s9), f11 = l8 > 0 ? ((1 - n23 / l8) * 100).toFixed(1) : "0.0", a7 = S10(s9).originalName || (t6 === "-" ? "" : t6.replace(/\.gz$/, ""));
  return { stdout: `${n23.toString().padStart(10)} ${l8.toString().padStart(10)} ${f11.padStart(5)}% ${a7}
`, stderr: "", exitCode: 0 };
}
async function U10(e5, t6, o9, r8) {
  let s9;
  if (t6 === "-" || t6 === "") s9 = Uint8Array.from(e5.stdin, (n23) => n23.charCodeAt(0));
  else {
    let n23 = e5.fs.resolvePath(e5.cwd, t6);
    try {
      s9 = await e5.fs.readFileBuffer(n23);
    } catch {
      return { stdout: "", stderr: `${r8}: ${t6}: No such file or directory
`, exitCode: 1 };
    }
  }
  if (!m22(s9)) return o9.quiet ? { stdout: "", stderr: "", exitCode: 1 } : { stdout: "", stderr: `${r8}: ${t6}: not in gzip format
`, exitCode: 1 };
  try {
    return gunzipSync(s9), o9.verbose ? { stdout: "", stderr: `${t6}:	OK
`, exitCode: 0 } : { stdout: "", stderr: "", exitCode: 0 };
  } catch (n23) {
    let l8 = n23 instanceof Error ? n23.message : "invalid";
    return { stdout: "", stderr: `${r8}: ${t6}: ${l8}
`, exitCode: 1 };
  }
}
async function x19(e5, t6, o9) {
  let r8 = o9 === "zcat" ? P13 : o9 === "gunzip" ? I15 : q10;
  if (o2(e5)) return s(r8);
  let s9 = x3(o9, e5, L13);
  if (!s9.ok) return s9.error.stderr.includes("unrecognized option"), s9.error;
  let n23 = s9.result.flags, l8 = s9.result.positional, f11 = o9 === "gunzip" || o9 === "zcat" || n23.decompress || n23.uncompress, p17 = o9 === "zcat" || n23.stdout || n23.toStdout;
  if (n23.list) {
    l8.length === 0 && (l8 = ["-"]);
    let c14 = `  compressed uncompressed  ratio uncompressed_name
`, d16 = "", y18 = 0;
    for (let h16 of l8) {
      let g18 = await O11(t6, h16, n23, o9);
      c14 += g18.stdout, d16 += g18.stderr, g18.exitCode !== 0 && (y18 = g18.exitCode);
    }
    return { stdout: c14, stderr: d16, exitCode: y18 };
  }
  if (n23.test) {
    l8.length === 0 && (l8 = ["-"]);
    let c14 = "", d16 = "", y18 = 0;
    for (let h16 of l8) {
      let g18 = await U10(t6, h16, n23, o9);
      c14 += g18.stdout, d16 += g18.stderr, g18.exitCode !== 0 && (y18 = g18.exitCode);
    }
    return { stdout: c14, stderr: d16, exitCode: y18 };
  }
  l8.length === 0 && (l8 = ["-"]);
  let a7 = "", u10 = "", i10 = 0;
  for (let c14 of l8) {
    let d16 = await E8(t6, c14, n23, o9, f11, p17);
    a7 += d16.stdout, u10 += d16.stderr, d16.exitCode !== 0 && (i10 = d16.exitCode);
  }
  return { stdout: a7, stderr: u10, exitCode: i10 };
}
var q10, I15, P13, L13, _8, H13, B7, G5, Z9, M10;
var init_chunk_DZ33S2U7 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-DZ33S2U7.js"() {
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_node_zlib();
    q10 = { name: "gzip", summary: "compress or expand files", usage: "gzip [OPTION]... [FILE]...", description: `Compress FILEs (by default, in-place).

When no FILE is given, or when FILE is -, read from standard input.

With -d, decompress instead.`, options: ["-c, --stdout      write to standard output, keep original files", "-d, --decompress  decompress", "-f, --force       force overwrite of output file", "-k, --keep        keep (don't delete) input files", "-l, --list        list compressed file contents", "-n, --no-name     do not save or restore the original name and timestamp", "-N, --name        save or restore the original file name and timestamp", "-q, --quiet       suppress all warnings", "-r, --recursive   operate recursively on directories", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "-1, --fast        compress faster", "-9, --best        compress better", "    --help        display this help and exit"] };
    I15 = { name: "gunzip", summary: "decompress files", usage: "gunzip [OPTION]... [FILE]...", description: `Decompress FILEs (by default, in-place).

When no FILE is given, or when FILE is -, read from standard input.`, options: ["-c, --stdout      write to standard output, keep original files", "-f, --force       force overwrite of output file", "-k, --keep        keep (don't delete) input files", "-l, --list        list compressed file contents", "-n, --no-name     do not restore the original name and timestamp", "-N, --name        restore the original file name and timestamp", "-q, --quiet       suppress all warnings", "-r, --recursive   operate recursively on directories", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "    --help        display this help and exit"] };
    P13 = { name: "zcat", summary: "decompress files to stdout", usage: "zcat [OPTION]... [FILE]...", description: `Decompress FILEs to standard output.

When no FILE is given, or when FILE is -, read from standard input.`, options: ["-f, --force       force; read compressed data even from a terminal", "-l, --list        list compressed file contents", "-q, --quiet       suppress all warnings", "-S, --suffix=SUF  use suffix SUF on compressed files (default: .gz)", "-t, --test        test compressed file integrity", "-v, --verbose     verbose mode", "    --help        display this help and exit"] };
    L13 = { stdout: { short: "c", long: "stdout", type: "boolean" }, toStdout: { long: "to-stdout", type: "boolean" }, decompress: { short: "d", long: "decompress", type: "boolean" }, uncompress: { long: "uncompress", type: "boolean" }, force: { short: "f", long: "force", type: "boolean" }, keep: { short: "k", long: "keep", type: "boolean" }, list: { short: "l", long: "list", type: "boolean" }, noName: { short: "n", long: "no-name", type: "boolean" }, name: { short: "N", long: "name", type: "boolean" }, quiet: { short: "q", long: "quiet", type: "boolean" }, recursive: { short: "r", long: "recursive", type: "boolean" }, suffix: { short: "S", long: "suffix", type: "string", default: ".gz" }, test: { short: "t", long: "test", type: "boolean" }, verbose: { short: "v", long: "verbose", type: "boolean" }, fast: { short: "1", long: "fast", type: "boolean" }, level2: { short: "2", type: "boolean" }, level3: { short: "3", type: "boolean" }, level4: { short: "4", type: "boolean" }, level5: { short: "5", type: "boolean" }, level6: { short: "6", type: "boolean" }, level7: { short: "7", type: "boolean" }, level8: { short: "8", type: "boolean" }, best: { short: "9", long: "best", type: "boolean" } };
    _8 = { name: "gzip", async execute(e5, t6) {
      return x19(e5, t6, "gzip");
    } };
    H13 = { name: "gunzip", async execute(e5, t6) {
      return x19(e5, t6, "gunzip");
    } };
    B7 = { name: "zcat", async execute(e5, t6) {
      return x19(e5, t6, "zcat");
    } };
    G5 = { name: "gzip", flags: [{ flag: "-c", type: "boolean" }, { flag: "-d", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-k", type: "boolean" }, { flag: "-l", type: "boolean" }, { flag: "-n", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-r", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-1", type: "boolean" }, { flag: "-9", type: "boolean" }], stdinType: "binary", needsFiles: true };
    Z9 = { name: "gunzip", flags: [{ flag: "-c", type: "boolean" }, { flag: "-f", type: "boolean" }, { flag: "-k", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "binary", needsFiles: true };
    M10 = { name: "zcat", flags: [{ flag: "-f", type: "boolean" }, { flag: "-q", type: "boolean" }, { flag: "-v", type: "boolean" }], stdinType: "binary", needsFiles: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/gzip-UTSGNF5Z.js
var gzip_UTSGNF5Z_exports = {};
__export(gzip_UTSGNF5Z_exports, {
  flagsForFuzzing: () => G5,
  gunzipCommand: () => H13,
  gunzipFlagsForFuzzing: () => Z9,
  gzipCommand: () => _8,
  zcatCommand: () => B7,
  zcatFlagsForFuzzing: () => M10
});
var init_gzip_UTSGNF5Z = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/gzip-UTSGNF5Z.js"() {
    init_chunk_DZ33S2U7();
    init_chunk_HWKDQ44K();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub:compressjs
var compressjs_default;
var init_compressjs = __esm({
  "stub:compressjs"() {
    compressjs_default = {};
  }
});

// stub:node-liblzma
var node_liblzma_exports = {};
__export(node_liblzma_exports, {
  default: () => node_liblzma_default
});
var node_liblzma_default;
var init_node_liblzma = __esm({
  "stub:node-liblzma"() {
    node_liblzma_default = {};
  }
});

// stub:@mongodb-js/zstd
var zstd_exports = {};
__export(zstd_exports, {
  default: () => zstd_default
});
var zstd_default;
var init_zstd = __esm({
  "stub:@mongodb-js/zstd"() {
    zstd_default = {};
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-VZWXH2PZ.js
function T7(e5, t6, i10, r8) {
  r8 && U11.encodeInto(r8, e5.subarray(t6, t6 + i10));
}
function F18(e5, t6, i10, r8) {
  if (r8 === void 0) return;
  let n23 = r8.toString(8).padStart(i10 - 1, "0");
  U11.encodeInto(n23, e5.subarray(t6, t6 + i10 - 1));
}
function A10(e5, t6, i10) {
  let r8 = e5.indexOf(0, t6), n23 = r8 === -1 || r8 > t6 + i10 ? t6 + i10 : r8;
  return le5.decode(e5.subarray(t6, n23));
}
function W10(e5, t6, i10) {
  let r8 = 0, n23 = t6 + i10;
  for (let s9 = t6; s9 < n23; s9++) {
    let o9 = e5[s9];
    if (o9 === 0) break;
    o9 !== 32 && (r8 = r8 * 8 + (o9 - 48));
  }
  return r8;
}
function k10(e5, t6, i10) {
  if (e5[t6] & 128) {
    let r8 = 0;
    r8 = e5[t6] & 127;
    for (let n23 = 1; n23 < i10; n23++) r8 = r8 * 256 + e5[t6 + n23];
    if (!Number.isSafeInteger(r8)) throw new Error("TAR number too large");
    return r8;
  }
  return W10(e5, t6, i10);
}
async function ue7(e5) {
  if (e5 == null) return b22;
  if (e5 instanceof Uint8Array) return e5;
  if (typeof e5 == "string") return U11.encode(e5);
  if (e5 instanceof ArrayBuffer) return new Uint8Array(e5);
  if (e5 instanceof Blob) return new Uint8Array(await e5.arrayBuffer());
  throw new TypeError("Unsupported content type for entry body.");
}
function fe8(e5, t6) {
  let { strip: i10, filter: r8, map: n23 } = t6;
  if (!i10 && !r8 && !n23) return e5;
  let s9 = { ...e5 };
  if (i10 && i10 > 0) {
    let a7 = s9.name.split("/").filter(Boolean);
    if (i10 >= a7.length) return null;
    let c14 = a7.slice(i10).join("/");
    if (s9.name = s9.type === M11 && !c14.endsWith("/") ? `${c14}/` : c14, s9.linkname?.startsWith("/")) {
      let l8 = s9.linkname.split("/").filter(Boolean);
      s9.linkname = i10 >= l8.length ? "/" : `/${l8.slice(i10).join("/")}`;
    }
  }
  if (r8?.(s9) === false) return null;
  let o9 = n23 ? n23(s9) : s9;
  return o9 && (!o9.name || !o9.name.trim() || o9.name === "." || o9.name === "/") ? null : o9;
}
function Be3(e5) {
  let t6 = W10(e5, 148, 8), i10 = 0;
  for (let r8 = 0; r8 < e5.length; r8++) r8 >= 148 && r8 < 156 ? i10 += G6 : i10 += e5[r8];
  return t6 === i10;
}
function De4(e5) {
  e5.fill(G6, 148, 156);
  let t6 = 0;
  for (let i10 of e5) t6 += i10;
  for (let i10 = 153; i10 >= 148; i10--) e5[i10] = (t6 & 7) + Ze5, t6 >>= 3;
  e5[154] = 0, e5[155] = G6;
}
function Ne4(e5) {
  let t6 = {};
  e5.name.length > 100 && de7(e5.name) === null && (t6.path = e5.name), e5.linkname && e5.linkname.length > 100 && (t6.linkpath = e5.linkname), e5.uname && e5.uname.length > 32 && (t6.uname = e5.uname), e5.gname && e5.gname.length > 32 && (t6.gname = e5.gname), e5.uid != null && e5.uid > 2097151 && (t6.uid = String(e5.uid)), e5.gid != null && e5.gid > 2097151 && (t6.gid = String(e5.gid)), e5.size != null && e5.size > 8589934591 && (t6.size = String(e5.size)), e5.pax && Object.assign(t6, e5.pax);
  let i10 = Object.entries(t6);
  if (i10.length === 0) return null;
  let r8 = U11.encode(i10.map(([n23, s9]) => {
    let o9 = `${n23}=${s9}
`, a7 = U11.encode(o9).length + 1, c14 = a7 + String(a7).length;
    return c14 = a7 + String(c14).length, `${c14} ${o9}`;
  }).join(""));
  return { paxHeader: me3({ name: le5.decode(U11.encode(`PaxHeader/${e5.name}`).slice(0, 100)), size: r8.length, type: "pax-header", mode: 420, mtime: e5.mtime, uname: e5.uname, gname: e5.gname, uid: e5.uid, gid: e5.gid }), paxBody: r8 };
}
function de7(e5) {
  if (e5.length <= 100) return null;
  let t6 = e5.length - 100 - 1, i10 = e5.lastIndexOf("/", 155);
  return i10 > 0 && i10 >= t6 ? { prefix: e5.slice(0, i10), name: e5.slice(i10 + 1) } : null;
}
function me3(e5) {
  let t6 = new Uint8Array(512), i10 = z7(e5) ? 0 : e5.size ?? 0, r8 = e5.name, n23 = "";
  if (!e5.pax?.path) {
    let s9 = de7(r8);
    s9 && (r8 = s9.name, n23 = s9.prefix);
  }
  return T7(t6, 0, 100, r8), F18(t6, 100, 8, e5.mode ?? (e5.type === M11 ? 493 : 420)), F18(t6, 108, 8, e5.uid ?? 0), F18(t6, 116, 8, e5.gid ?? 0), F18(t6, 124, 12, i10), F18(t6, 136, 12, Math.floor((e5.mtime?.getTime() ?? Date.now()) / 1e3)), T7(t6, 156, 1, be3[e5.type ?? H14]), T7(t6, 157, 100, e5.linkname), T7(t6, 257, 6, "ustar\0"), T7(t6, 263, 2, "00"), T7(t6, 265, 32, e5.uname), T7(t6, 297, 32, e5.gname), T7(t6, 345, 155, n23), De4(t6), t6;
}
function Le4(e5, t6) {
  if (t6 && !Be3(e5)) throw new Error("Invalid tar header checksum.");
  let i10 = A10(e5, 156, 1), r8 = { name: A10(e5, 0, 100), mode: W10(e5, 100, 8), uid: k10(e5, 108, 8), gid: k10(e5, 116, 8), size: k10(e5, 124, 12), mtime: new Date(k10(e5, 136, 12) * 1e3), type: Me3[i10] || H14, linkname: A10(e5, 157, 100) }, n23 = A10(e5, 257, 6);
  return n23.trim() === "ustar" && (r8.uname = A10(e5, 265, 32), r8.gname = A10(e5, 297, 32)), n23 === "ustar" && (r8.prefix = A10(e5, 345, 155)), r8;
}
function Pe3(e5) {
  let t6 = new TextDecoder("utf-8"), i10 = {}, r8 = {}, n23 = 0;
  for (; n23 < e5.length; ) {
    let s9 = e5.indexOf(32, n23);
    if (s9 === -1) break;
    let o9 = parseInt(t6.decode(e5.subarray(n23, s9)), 10);
    if (Number.isNaN(o9) || o9 === 0) break;
    let a7 = n23 + o9, [c14, l8] = t6.decode(e5.subarray(s9 + 1, a7 - 1)).split("=", 2);
    if (c14 && l8 !== void 0) {
      r8[c14] = l8;
      let d16 = Ke4[c14];
      if (d16) {
        let [u10, g18] = d16, p17 = g18(l8);
        (typeof p17 == "string" || !Number.isNaN(p17)) && (i10[u10] = p17);
      }
    }
    n23 = a7;
  }
  return Object.keys(r8).length > 0 && (i10.pax = r8), i10;
}
function se5(e5, t6) {
  t6.name !== void 0 && (e5.name = t6.name), t6.linkname !== void 0 && (e5.linkname = t6.linkname), t6.size !== void 0 && (e5.size = t6.size), t6.mtime !== void 0 && (e5.mtime = new Date(t6.mtime * 1e3)), t6.uid !== void 0 && (e5.uid = t6.uid), t6.gid !== void 0 && (e5.gid = t6.gid), t6.uname !== void 0 && (e5.uname = t6.uname), t6.gname !== void 0 && (e5.gname = t6.gname), t6.pax && (e5.pax = Object.assign({}, e5.pax ?? {}, t6.pax));
}
function Ge4(e5) {
  switch (e5) {
    case "pax-global-header":
    case "pax-header":
      return Pe3;
    case "gnu-long-name":
      return (t6) => ({ name: A10(t6, 0, t6.length) });
    case "gnu-long-link-name":
      return (t6) => ({ linkname: A10(t6, 0, t6.length) });
    default:
      return;
  }
}
function He4(e5) {
  let t6 = me3(e5), i10 = Ne4(e5);
  if (!i10) return [t6];
  let r8 = -i10.paxBody.length & 511, n23 = r8 > 0 ? [$e3.subarray(0, r8)] : [];
  return [i10.paxHeader, i10.paxBody, ...n23, t6];
}
function pe6(e5, t6, i10) {
  let r8 = null, n23 = 0, s9 = false;
  return { add(o9) {
    if (s9) {
      let a7 = new Error("No new tar entries after finalize.");
      throw t6(a7), a7;
    }
    if (r8 !== null) {
      let a7 = new Error("Previous entry must be completed before adding a new one");
      throw t6(a7), a7;
    }
    try {
      let a7 = z7(o9) ? 0 : o9.size ?? 0, c14 = He4({ ...o9, size: a7 });
      for (let l8 of c14) e5(l8);
      r8 = { ...o9, size: a7 }, n23 = 0;
    } catch (a7) {
      t6(a7);
    }
  }, write(o9) {
    if (!r8) {
      let c14 = new Error("No active tar entry.");
      throw t6(c14), c14;
    }
    if (s9) {
      let c14 = new Error("Cannot write data after finalize.");
      throw t6(c14), c14;
    }
    let a7 = n23 + o9.length;
    if (a7 > r8.size) {
      let c14 = new Error(`"${r8.name}" exceeds given size of ${r8.size} bytes.`);
      throw t6(c14), c14;
    }
    try {
      n23 = a7, e5(o9);
    } catch (c14) {
      t6(c14);
    }
  }, endEntry() {
    if (!r8) {
      let o9 = new Error("No active entry to end.");
      throw t6(o9), o9;
    }
    if (s9) {
      let o9 = new Error("Cannot end entry after finalize.");
      throw t6(o9), o9;
    }
    try {
      if (n23 !== r8.size) {
        let a7 = new Error(`Size mismatch for "${r8.name}".`);
        throw t6(a7), a7;
      }
      let o9 = -r8.size & 511;
      o9 > 0 && e5(new Uint8Array(o9)), r8 = null, n23 = 0;
    } catch (o9) {
      throw t6(o9), o9;
    }
  }, finalize() {
    if (s9) {
      let o9 = new Error("Archive has already been finalized");
      throw t6(o9), o9;
    }
    if (r8 !== null) {
      let o9 = new Error("Cannot finalize while an entry is still active");
      throw t6(o9), o9;
    }
    try {
      e5(We3), s9 = true, i10 && i10();
    } catch (o9) {
      t6(o9);
    }
  } };
}
function Xe4() {
  let e5 = new Array(R6), t6 = e5.length - 1, i10 = 0, r8 = 0, n23 = 0, s9 = (a7) => {
    let c14 = e5[i10];
    a7 === c14.length ? (e5[i10] = b22, i10 = i10 + 1 & t6) : e5[i10] = c14.subarray(a7), n23 -= a7, n23 === 0 && e5.length > R6 && (e5 = new Array(R6), t6 = R6 - 1, i10 = 0, r8 = 0);
  };
  function o9(a7, c14) {
    if (c14) {
      let p17 = 0, f11 = Math.min(a7, n23);
      for (; f11 > 0; ) {
        let h16 = e5[i10], m24 = Math.min(f11, h16.length), S16 = m24 === h16.length ? h16 : h16.subarray(0, m24);
        if (s9(m24), f11 -= m24, p17 += m24, !c14(S16)) break;
      }
      return p17;
    }
    if (n23 < a7) return null;
    if (a7 === 0) return b22;
    let l8 = e5[i10];
    if (l8.length >= a7) {
      let p17 = l8.length === a7 ? l8 : l8.subarray(0, a7);
      return s9(a7), p17;
    }
    let d16 = new Uint8Array(a7), u10 = 0, g18 = a7;
    for (; g18 > 0; ) {
      let p17 = e5[i10], f11 = Math.min(g18, p17.length);
      d16.set(f11 === p17.length ? p17 : p17.subarray(0, f11), u10), u10 += f11, g18 -= f11, s9(f11);
    }
    return d16;
  }
  return { push: (a7) => {
    if (a7.length === 0) return;
    let c14 = r8 + 1 & t6;
    if (c14 === i10) {
      let l8 = e5.length, d16 = l8 * 2, u10 = new Array(d16), g18 = r8 - i10 + l8 & l8 - 1;
      if (i10 < r8) for (let p17 = 0; p17 < g18; p17++) u10[p17] = e5[i10 + p17];
      else if (g18 > 0) {
        let p17 = l8 - i10;
        for (let f11 = 0; f11 < p17; f11++) u10[f11] = e5[i10 + f11];
        for (let f11 = 0; f11 < r8; f11++) u10[p17 + f11] = e5[f11];
      }
      e5 = u10, t6 = d16 - 1, i10 = 0, r8 = g18, c14 = r8 + 1 & t6;
    }
    e5[r8] = a7, r8 = c14, n23 += a7.length;
  }, available: () => n23, peek: (a7) => {
    if (n23 < a7) return null;
    if (a7 === 0) return b22;
    let c14 = e5[i10];
    if (c14.length >= a7) return c14.length === a7 ? c14 : c14.subarray(0, a7);
    let l8 = new Uint8Array(a7), d16 = 0, u10 = i10;
    for (; d16 < a7; ) {
      let g18 = e5[u10], p17 = Math.min(a7 - d16, g18.length);
      p17 === g18.length ? l8.set(g18, d16) : l8.set(g18.subarray(0, p17), d16), d16 += p17, u10 = u10 + 1 & t6;
    }
    return l8;
  }, discard: (a7) => {
    if (a7 > n23) throw new Error("Too many bytes consumed");
    if (a7 === 0) return;
    let c14 = a7;
    for (; c14 > 0; ) {
      let l8 = e5[i10], d16 = Math.min(c14, l8.length);
      s9(d16), c14 -= d16;
    }
  }, pull: o9 };
}
function he7(e5 = {}) {
  let t6 = e5.strict ?? false, { available: i10, peek: r8, push: n23, discard: s9, pull: o9 } = Xe4(), a7 = P14, c14 = false, l8 = false, d16 = false, u10 = null, g18 = {}, p17 = {}, f11 = { isEntryActive: () => a7 === v17, isBodyComplete: () => !u10 || u10.remaining === 0, write(h16) {
    if (c14) throw new Error("Archive already ended.");
    n23(h16);
  }, end() {
    c14 = true;
  }, readHeader() {
    if (a7 !== P14) throw new Error("Cannot read header while an entry is active");
    if (!l8) for (; !l8; ) {
      if (i10() < 512) {
        if (c14) {
          if (i10() > 0 && t6) throw O12;
          l8 = true;
          return;
        }
        return null;
      }
      let h16 = r8(512);
      if (ae6(h16)) {
        if (i10() < 512 * 2) {
          if (c14) {
            if (t6) throw O12;
            l8 = true;
            return;
          }
          return null;
        }
        if (ae6(r8(512 * 2).subarray(512))) {
          s9(512 * 2), l8 = true, d16 = true;
          return;
        }
        if (t6) throw new Error("Invalid tar header.");
        s9(512);
        continue;
      }
      let m24;
      try {
        m24 = Le4(h16, t6);
      } catch (w19) {
        if (t6) throw w19;
        s9(512);
        continue;
      }
      let S16 = Ge4(m24.type);
      if (S16) {
        let w19 = m24.size + 511 & -512;
        if (i10() < 512 + w19) {
          if (c14 && t6) throw O12;
          return null;
        }
        s9(512);
        let I17 = S16(o9(w19).subarray(0, m24.size)), Oe5 = m24.type === "pax-global-header" ? g18 : p17;
        for (let re5 in I17) Oe5[re5] = I17[re5];
        continue;
      }
      s9(512);
      let E12 = m24;
      return m24.prefix && (E12.name = `${m24.prefix}/${E12.name}`), se5(E12, g18), se5(E12, p17), p17 = {}, u10 = { header: E12, remaining: E12.size, padding: -E12.size & 511 }, a7 = v17, E12;
    }
  }, streamBody(h16) {
    if (a7 !== v17 || !u10 || u10.remaining === 0) return 0;
    let m24 = Math.min(u10.remaining, i10());
    if (m24 === 0) return 0;
    let S16 = o9(m24, h16);
    return u10.remaining -= S16, S16;
  }, skipPadding() {
    if (a7 !== v17 || !u10) return true;
    if (u10.remaining > 0) throw new Error("Body not fully consumed");
    return i10() < u10.padding ? false : (s9(u10.padding), u10 = null, a7 = P14, true);
  }, skipEntry() {
    if (a7 !== v17 || !u10) return true;
    let h16 = Math.min(u10.remaining, i10());
    return h16 > 0 && (s9(h16), u10.remaining -= h16), u10.remaining > 0 ? false : f11.skipPadding();
  }, validateEOF() {
    if (t6) {
      if (!d16) throw O12;
      if (i10() > 0 && o9(i10()).some((h16) => h16 !== 0)) throw new Error("Invalid EOF.");
    }
  } };
  return f11;
}
function ae6(e5) {
  if (e5.byteOffset % 8 === 0) {
    let t6 = new BigUint64Array(e5.buffer, e5.byteOffset, e5.length / 8);
    for (let i10 = 0; i10 < t6.length; i10++) if (t6[i10] !== 0n) return false;
    return true;
  }
  for (let t6 = 0; t6 < e5.length; t6++) if (e5[t6] !== 0) return false;
  return true;
}
function Se3() {
  return new CompressionStream("gzip");
}
function Ee4() {
  return new DecompressionStream("gzip");
}
function je5() {
  let e5, t6;
  return { readable: new ReadableStream({ start(i10) {
    e5 = i10, t6 = pe6(i10.enqueue.bind(i10), i10.error.bind(i10), i10.close.bind(i10));
  } }), controller: { add(i10) {
    let r8 = z7(i10), n23 = { ...i10 };
    return r8 && (n23.size = 0), t6.add(n23), r8 && t6.endEntry(), new WritableStream({ write(s9) {
      t6.write(s9);
    }, close() {
      r8 || t6.endEntry();
    }, abort(s9) {
      e5.error(s9);
    } });
  }, finalize() {
    t6.finalize();
  }, error(i10) {
    e5.error(i10);
  } } };
}
async function we3(e5) {
  let t6 = [], i10 = e5.getReader(), r8 = 0;
  try {
    for (; ; ) {
      let { done: o9, value: a7 } = await i10.read();
      if (o9) break;
      t6.push(a7), r8 += a7.length;
    }
    let n23 = new Uint8Array(r8), s9 = 0;
    for (let o9 of t6) n23.set(o9, s9), s9 += o9.length;
    return n23;
  } finally {
    i10.releaseLock();
  }
}
function qe3(e5 = {}) {
  let t6 = he7(e5), i10 = null, r8 = false, n23 = (s9) => {
    if (!r8) {
      r8 = true;
      try {
        for (; ; ) if (t6.isEntryActive()) {
          if (i10) {
            if (t6.streamBody((o9) => (i10.enqueue(o9), true)) === 0 && !t6.isBodyComplete()) break;
          } else if (!t6.skipEntry()) break;
          if (t6.isBodyComplete()) {
            try {
              i10?.close();
            } catch {
            }
            if (i10 = null, !t6.skipPadding()) break;
          }
        } else {
          let o9 = t6.readHeader();
          if (o9 == null) break;
          s9.enqueue({ header: o9, body: new ReadableStream({ start(a7) {
            o9.size === 0 ? a7.close() : i10 = a7;
          }, pull: () => n23(s9), cancel() {
            i10 = null, n23(s9);
          } }) });
        }
      } catch (o9) {
        try {
          i10?.error(o9);
        } catch {
        }
        throw i10 = null, o9;
      } finally {
        r8 = false;
      }
    }
  };
  return new TransformStream({ transform(s9, o9) {
    try {
      t6.write(s9), n23(o9);
    } catch (a7) {
      try {
        i10?.error(a7);
      } catch {
      }
      throw a7;
    }
  }, flush(s9) {
    try {
      if (t6.end(), n23(s9), t6.validateEOF(), t6.isEntryActive() && !t6.isBodyComplete()) try {
        i10?.close();
      } catch {
      }
    } catch (o9) {
      try {
        i10?.error(o9);
      } catch {
      }
      throw o9;
    }
  } }, void 0, { highWaterMark: 1 });
}
async function ye4(e5) {
  let { readable: t6, controller: i10 } = je5();
  return await (async () => {
    for (let r8 of e5) {
      let n23 = i10.add(r8.header), s9 = "body" in r8 ? r8.body : r8.data;
      if (!s9) {
        await n23.close();
        continue;
      }
      if (s9 instanceof ReadableStream) await s9.pipeTo(n23);
      else if (s9 instanceof Blob) await s9.stream().pipeTo(n23);
      else try {
        let o9 = await ue7(s9);
        if (o9.length > 0) {
          let a7 = n23.getWriter();
          await a7.write(o9), await a7.close();
        } else await n23.close();
      } catch {
        throw new TypeError(`Unsupported content type for entry "${r8.header.name}".`);
      }
    }
  })().then(() => i10.finalize()).catch((r8) => i10.error(r8)), new Uint8Array(await we3(t6));
}
async function Ae4(e5, t6 = {}) {
  let i10 = e5 instanceof ReadableStream ? e5 : new ReadableStream({ start(s9) {
    s9.enqueue(e5 instanceof Uint8Array ? e5 : new Uint8Array(e5)), s9.close();
  } }), r8 = [], n23 = i10.pipeThrough(qe3(t6));
  for await (let s9 of n23) {
    let o9;
    try {
      o9 = fe8(s9.header, t6);
    } catch (a7) {
      throw await s9.body.cancel(), a7;
    }
    if (o9 === null) {
      await ge6(s9.body);
      continue;
    }
    z7(o9) ? (await ge6(s9.body), r8.push({ header: o9 })) : r8.push({ header: o9, data: await we3(s9.body) });
  }
  return r8;
}
async function Ce2() {
  if ($15) return $15;
  if (Z10) throw Z10;
  try {
    return $15 = await Promise.resolve().then(() => (init_node_liblzma(), node_liblzma_exports)), $15;
  } catch {
    throw Z10 = new Error("xz compression requires node-liblzma which failed to load. Install liblzma-dev (apt) or xz (brew) and reinstall dependencies."), Z10;
  }
}
async function xe5() {
  if (B8) return B8;
  if (D13) throw D13;
  try {
    return B8 = await Promise.resolve().then(() => (init_zstd(), zstd_exports)), B8;
  } catch {
    throw D13 = new Error("zstd compression requires @mongodb-js/zstd which is not installed. Install it with: npm install @mongodb-js/zstd"), D13;
  }
}
function Ye4(e5) {
  let t6 = "file";
  e5.isDirectory ? t6 = "directory" : e5.isSymlink && (t6 = "symlink");
  let i10 = e5.name;
  e5.isDirectory && !i10.endsWith("/") && (i10 += "/");
  let r8;
  e5.content !== void 0 && (typeof e5.content == "string" ? r8 = new TextEncoder().encode(e5.content) : r8 = e5.content);
  let n23 = e5.isDirectory || e5.isSymlink ? 0 : r8?.length ?? 0;
  return { header: { name: i10, mode: e5.mode ?? (e5.isDirectory ? 493 : 420), uid: e5.uid ?? 0, gid: e5.gid ?? 0, size: n23, mtime: e5.mtime ?? /* @__PURE__ */ new Date(), type: t6, linkname: e5.linkTarget ?? "", uname: "user", gname: "user" }, body: r8 };
}
async function C15(e5) {
  let t6 = e5.map(Ye4);
  return ye4(t6);
}
async function Ue3(e5) {
  let t6 = await C15(e5), n23 = new ReadableStream({ start(l8) {
    l8.enqueue(t6), l8.close();
  } }).pipeThrough(Se3()).getReader(), s9 = [];
  for (; ; ) {
    let { done: l8, value: d16 } = await n23.read();
    if (l8) break;
    s9.push(d16);
  }
  let o9 = s9.reduce((l8, d16) => l8 + d16.length, 0), a7 = new Uint8Array(o9), c14 = 0;
  for (let l8 of s9) a7.set(l8, c14), c14 += l8.length;
  return a7;
}
async function _9(e5) {
  if (e5.length > y15) return { entries: [], error: `Archive too large (max ${y15} bytes)` };
  try {
    let t6 = await Ae4(e5), i10 = [];
    for (let r8 of t6) {
      if (i10.length >= _e3) return { entries: i10, error: `Too many entries (max ${_e3})` };
      let n23 = "file";
      switch (r8.header.type) {
        case "directory":
          n23 = "directory";
          break;
        case "symlink":
          n23 = "symlink";
          break;
        case "link":
          n23 = "hardlink";
          break;
        case "file":
          n23 = "file";
          break;
        default:
          n23 = "other";
      }
      i10.push({ name: r8.header.name, mode: r8.header.mode ?? 420, uid: r8.header.uid ?? 0, gid: r8.header.gid ?? 0, size: r8.header.size, mtime: r8.header.mtime ?? /* @__PURE__ */ new Date(), type: n23, linkTarget: r8.header.linkname || void 0, content: r8.data ?? new Uint8Array(0) });
    }
    return { entries: i10 };
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
async function X7(e5) {
  if (e5.length > y15) return { entries: [], error: `Archive too large (max ${y15} bytes)` };
  try {
    let r8 = new ReadableStream({ start(c14) {
      c14.enqueue(e5), c14.close();
    } }).pipeThrough(Ee4()).getReader(), n23 = [];
    for (; ; ) {
      let { done: c14, value: l8 } = await r8.read();
      if (c14) break;
      n23.push(l8);
    }
    let s9 = n23.reduce((c14, l8) => c14 + l8.length, 0), o9 = new Uint8Array(s9), a7 = 0;
    for (let c14 of n23) o9.set(c14, a7), a7 += c14.length;
    return _9(o9);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: `Decompression failed: ${i10}` };
  }
}
function j8(e5) {
  return e5.length >= 2 && e5[0] === 31 && e5[1] === 139;
}
function q11(e5) {
  return e5.length >= 3 && e5[0] === 66 && e5[1] === 90 && e5[2] === 104;
}
function Y8(e5) {
  return e5.length >= 6 && e5[0] === 253 && e5[1] === 55 && e5[2] === 122 && e5[3] === 88 && e5[4] === 90 && e5[5] === 0;
}
async function Ve3(e5) {
  let i10 = compressjs_default.Bzip2.decompressFile(Array.from(e5));
  return new Uint8Array(i10);
}
async function Je4(e5) {
  let t6 = compressjs_default.Bzip2, i10 = [];
  return t6.compressFile(Array.from(e5), i10, 9), new Uint8Array(i10);
}
async function Qe4(e5) {
  let i10 = (await Ce2()).unxzSync(Buffer.from(e5));
  return new Uint8Array(i10);
}
async function et5(e5) {
  let i10 = (await Ce2()).xzSync(Buffer.from(e5));
  return new Uint8Array(i10);
}
async function Ie5(e5) {
  let t6 = await C15(e5);
  return Je4(t6);
}
async function Fe4(e5) {
  let t6 = await C15(e5);
  return et5(t6);
}
async function V9(e5) {
  if (e5.length > y15) return { entries: [], error: `Archive too large (max ${y15} bytes)` };
  try {
    let t6 = await Ve3(e5);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
async function J10(e5) {
  if (e5.length > y15) return { entries: [], error: `Archive too large (max ${y15} bytes)` };
  try {
    let t6 = await Qe4(e5);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
function Q10(e5) {
  return e5.length >= 4 && e5[0] === 40 && e5[1] === 181 && e5[2] === 47 && e5[3] === 253;
}
async function tt4(e5) {
  let i10 = await (await xe5()).compress(Buffer.from(e5), 3);
  return new Uint8Array(i10);
}
async function rt4(e5) {
  let i10 = await (await xe5()).decompress(Buffer.from(e5));
  return new Uint8Array(i10);
}
async function ve5(e5) {
  let t6 = await C15(e5);
  return tt4(t6);
}
async function ee5(e5) {
  if (e5.length > y15) return { entries: [], error: `Archive too large (max ${y15} bytes)` };
  try {
    let t6 = await rt4(e5);
    return _9(t6);
  } catch (t6) {
    let i10 = t6 instanceof Error ? t6.message : "Unknown error";
    return { entries: [], error: i10 };
  }
}
function ze4(e5) {
  let t6 = { create: false, append: false, update: false, extract: false, list: false, file: "", autoCompress: false, gzip: false, bzip2: false, xz: false, zstd: false, verbose: false, toStdout: false, keepOldFiles: false, touch: false, directory: "", preserve: false, strip: 0, exclude: [], filesFrom: "", excludeFrom: "", wildcards: false }, i10 = [], r8 = 0;
  for (; r8 < e5.length; ) {
    let n23 = e5[r8];
    if (n23.startsWith("-") && !n23.startsWith("--") && n23.length > 2) {
      if (/^-\d+$/.test(n23)) {
        i10.push(n23), r8++;
        continue;
      }
      for (let s9 = 1; s9 < n23.length; s9++) {
        let o9 = n23[s9];
        switch (o9) {
          case "c":
            t6.create = true;
            break;
          case "r":
            t6.append = true;
            break;
          case "u":
            t6.update = true;
            break;
          case "x":
            t6.extract = true;
            break;
          case "t":
            t6.list = true;
            break;
          case "a":
            t6.autoCompress = true;
            break;
          case "z":
            t6.gzip = true;
            break;
          case "j":
            t6.bzip2 = true;
            break;
          case "J":
            t6.xz = true;
            break;
          case "v":
            t6.verbose = true;
            break;
          case "O":
            t6.toStdout = true;
            break;
          case "k":
            t6.keepOldFiles = true;
            break;
          case "m":
            t6.touch = true;
            break;
          case "p":
            t6.preserve = true;
            break;
          case "f":
            if (s9 < n23.length - 1) t6.file = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'f'
`, exitCode: 2 } };
              t6.file = e5[r8];
            }
            break;
          case "C":
            if (s9 < n23.length - 1) t6.directory = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'C'
`, exitCode: 2 } };
              t6.directory = e5[r8];
            }
            break;
          case "T":
            if (s9 < n23.length - 1) t6.filesFrom = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'T'
`, exitCode: 2 } };
              t6.filesFrom = e5[r8];
            }
            break;
          case "X":
            if (s9 < n23.length - 1) t6.excludeFrom = n23.substring(s9 + 1), s9 = n23.length;
            else {
              if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'X'
`, exitCode: 2 } };
              t6.excludeFrom = e5[r8];
            }
            break;
          default:
            return { ok: false, error: r3("tar", `-${o9}`) };
        }
      }
      r8++;
      continue;
    }
    if (n23 === "-c" || n23 === "--create") t6.create = true;
    else if (n23 === "-r" || n23 === "--append") t6.append = true;
    else if (n23 === "-u" || n23 === "--update") t6.update = true;
    else if (n23 === "-x" || n23 === "--extract" || n23 === "--get") t6.extract = true;
    else if (n23 === "-t" || n23 === "--list") t6.list = true;
    else if (n23 === "-a" || n23 === "--auto-compress") t6.autoCompress = true;
    else if (n23 === "-z" || n23 === "--gzip" || n23 === "--gunzip") t6.gzip = true;
    else if (n23 === "-j" || n23 === "--bzip2") t6.bzip2 = true;
    else if (n23 === "-J" || n23 === "--xz") t6.xz = true;
    else if (n23 === "--zstd") t6.zstd = true;
    else if (n23 === "-v" || n23 === "--verbose") t6.verbose = true;
    else if (n23 === "-O" || n23 === "--to-stdout") t6.toStdout = true;
    else if (n23 === "-k" || n23 === "--keep-old-files") t6.keepOldFiles = true;
    else if (n23 === "-m" || n23 === "--touch") t6.touch = true;
    else if (n23 === "--wildcards") t6.wildcards = true;
    else if (n23 === "-p" || n23 === "--preserve" || n23 === "--preserve-permissions") t6.preserve = true;
    else if (n23 === "-f" || n23 === "--file") {
      if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'f'
`, exitCode: 2 } };
      t6.file = e5[r8];
    } else if (n23.startsWith("--file=")) t6.file = n23.substring(7);
    else if (n23 === "-C" || n23 === "--directory") {
      if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'C'
`, exitCode: 2 } };
      t6.directory = e5[r8];
    } else if (n23.startsWith("--directory=")) t6.directory = n23.substring(12);
    else if (n23.startsWith("--strip-components=") || n23.startsWith("--strip=")) {
      let s9 = n23.includes("--strip-components=") ? n23.substring(19) : n23.substring(8), o9 = parseInt(s9, 10);
      if (Number.isNaN(o9) || o9 < 0) return { ok: false, error: { stdout: "", stderr: `tar: invalid number for --strip: '${s9}'
`, exitCode: 2 } };
      t6.strip = o9;
    } else if (n23.startsWith("--exclude=")) t6.exclude.push(n23.substring(10));
    else if (n23 === "--exclude") {
      if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option '--exclude' requires an argument
`, exitCode: 2 } };
      t6.exclude.push(e5[r8]);
    } else if (n23 === "-T" || n23 === "--files-from") {
      if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'T'
`, exitCode: 2 } };
      t6.filesFrom = e5[r8];
    } else if (n23.startsWith("--files-from=")) t6.filesFrom = n23.substring(13);
    else if (n23 === "-X" || n23 === "--exclude-from") {
      if (r8++, r8 >= e5.length) return { ok: false, error: { stdout: "", stderr: `tar: option requires an argument -- 'X'
`, exitCode: 2 } };
      t6.excludeFrom = e5[r8];
    } else if (n23.startsWith("--exclude-from=")) t6.excludeFrom = n23.substring(15);
    else if (n23 === "--") {
      i10.push(...e5.slice(r8 + 1));
      break;
    } else {
      if (n23.startsWith("-")) return { ok: false, error: r3("tar", n23) };
      i10.push(n23);
    }
    r8++;
  }
  return { ok: true, options: t6, files: i10 };
}
function te6(e5, t6) {
  let i10 = e5.includes("/") ? e5.substring(e5.lastIndexOf("/") + 1) : e5;
  for (let r8 of t6) {
    let n23 = r8.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*\*/g, "<<<GLOBSTAR>>>").replace(/\*/g, "[^/]*").replace(/<<<GLOBSTAR>>>/g, ".*").replace(/\?/g, ".");
    if (b1(`^${n23}$`).test(e5) || b1(`^${n23}/`).test(e5) || !r8.includes("/") && b1(`^${n23}$`).test(i10)) return true;
  }
  return false;
}
function N12(e5, t6) {
  let i10 = t6.replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*\*/g, "<<<GLOBSTAR>>>").replace(/\*/g, "[^/]*").replace(/<<<GLOBSTAR>>>/g, ".*").replace(/\?/g, "."), r8 = e5.includes("/") ? e5.substring(e5.lastIndexOf("/") + 1) : e5;
  return b1(`^${i10}$`).test(e5) || b1(`^${i10}$`).test(r8);
}
function Re5(e5, t6) {
  if (t6 <= 0) return e5;
  let i10 = e5.split("/").filter((r8) => r8 !== "");
  return i10.length <= t6 ? "" : i10.slice(t6).join("/");
}
function it4(e5, t6) {
  let i10 = t6 ? "d" : "-", r8 = [e5 & 256 ? "r" : "-", e5 & 128 ? "w" : "-", e5 & 64 ? "x" : "-", e5 & 32 ? "r" : "-", e5 & 16 ? "w" : "-", e5 & 8 ? "x" : "-", e5 & 4 ? "r" : "-", e5 & 2 ? "w" : "-", e5 & 1 ? "x" : "-"].join("");
  return i10 + r8;
}
function st5(e5) {
  let i10 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][e5.getMonth()], r8 = e5.getDate().toString().padStart(2, " "), n23 = e5.getHours().toString().padStart(2, "0"), s9 = e5.getMinutes().toString().padStart(2, "0");
  return `${i10} ${r8} ${n23}:${s9}`;
}
async function L14(e5, t6, i10, r8) {
  let n23 = [], s9 = [], o9 = e5.fs.resolvePath(t6, i10);
  try {
    let a7 = await e5.fs.stat(o9);
    if (te6(i10, r8)) return { entries: n23, errors: s9 };
    if (a7.isDirectory) {
      n23.push({ name: i10, isDirectory: true, mode: a7.mode, mtime: a7.mtime });
      let c14 = await e5.fs.readdir(o9);
      for (let l8 = 0; l8 < c14.length; l8 += ke4) {
        let d16 = c14.slice(l8, l8 + ke4), u10 = await Promise.all(d16.map((g18) => L14(e5, t6, i10 ? `${i10}/${g18}` : g18, r8)));
        for (let g18 of u10) n23.push(...g18.entries), s9.push(...g18.errors);
      }
    } else if (a7.isFile) {
      let c14 = await e5.fs.readFileBuffer(o9);
      n23.push({ name: i10, content: c14, mode: a7.mode, mtime: a7.mtime });
    } else if (a7.isSymbolicLink) {
      let c14 = await e5.fs.readlink(o9);
      n23.push({ name: i10, isSymlink: true, linkTarget: c14, mode: a7.mode, mtime: a7.mtime });
    }
  } catch (a7) {
    let c14 = a7 instanceof Error ? a7.message : "unknown error";
    s9.push(`tar: ${i10}: ${c14}`);
  }
  return { entries: n23, errors: s9 };
}
async function at4(e5, t6, i10) {
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to create an empty archive
`, exitCode: 2 };
  let r8 = t6.directory ? e5.fs.resolvePath(e5.cwd, t6.directory) : e5.cwd, n23 = [], s9 = [], o9 = "";
  for (let d16 of i10) {
    let { entries: u10, errors: g18 } = await L14(e5, r8, d16, t6.exclude);
    if (n23.push(...u10), s9.push(...g18), t6.verbose) for (let p17 of u10) o9 += `${p17.name}${p17.isDirectory ? "/" : ""}
`;
  }
  if (n23.length === 0 && s9.length > 0) return { stdout: "", stderr: `${s9.join(`
`)}
`, exitCode: 2 };
  let a7;
  try {
    t6.gzip ? a7 = await Ue3(n23) : t6.bzip2 ? a7 = await Ie5(n23) : t6.xz ? a7 = await Fe4(n23) : t6.zstd ? a7 = await ve5(n23) : a7 = await C15(n23);
  } catch (d16) {
    return { stdout: "", stderr: `tar: error creating archive: ${d16 instanceof Error ? d16.message : "unknown error"}
`, exitCode: 2 };
  }
  let c14 = "";
  if (t6.file && t6.file !== "-") {
    let d16 = e5.fs.resolvePath(e5.cwd, t6.file);
    try {
      await e5.fs.writeFile(d16, a7);
    } catch (u10) {
      let g18 = u10 instanceof Error ? u10.message : "unknown error";
      return { stdout: "", stderr: `tar: ${t6.file}: ${g18}
`, exitCode: 2 };
    }
  } else c14 = String.fromCharCode(...a7);
  let l8 = o9;
  return s9.length > 0 && (l8 += `${s9.join(`
`)}
`), { stdout: c14, stderr: l8, exitCode: s9.length > 0 ? 2 : 0 };
}
async function ot4(e5, t6, i10) {
  if (!t6.file || t6.file === "-") return { stdout: "", stderr: `tar: Cannot append to stdin/stdout
`, exitCode: 2 };
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to append nothing to archive
`, exitCode: 2 };
  let r8 = e5.fs.resolvePath(e5.cwd, t6.file), n23;
  try {
    n23 = await e5.fs.readFileBuffer(r8);
  } catch {
    return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
  }
  let s9 = await _9(n23);
  if (s9.error) return { stdout: "", stderr: `tar: ${s9.error}
`, exitCode: 2 };
  let o9 = s9.entries.map((f11) => ({ name: f11.name, content: f11.content, mode: f11.mode, mtime: f11.mtime, isDirectory: f11.type === "directory", isSymlink: f11.type === "symlink", linkTarget: f11.linkTarget, uid: f11.uid, gid: f11.gid })), a7 = t6.directory ? e5.fs.resolvePath(e5.cwd, t6.directory) : e5.cwd, c14 = [], l8 = [], d16 = "";
  for (let f11 of i10) {
    let { entries: h16, errors: m24 } = await L14(e5, a7, f11, t6.exclude);
    if (c14.push(...h16), l8.push(...m24), t6.verbose) for (let S16 of h16) d16 += `${S16.name}${S16.isDirectory ? "/" : ""}
`;
  }
  let u10 = [...o9, ...c14], g18;
  try {
    g18 = await C15(u10);
  } catch (f11) {
    return { stdout: "", stderr: `tar: error creating archive: ${f11 instanceof Error ? f11.message : "unknown error"}
`, exitCode: 2 };
  }
  try {
    await e5.fs.writeFile(r8, g18);
  } catch (f11) {
    let h16 = f11 instanceof Error ? f11.message : "unknown error";
    return { stdout: "", stderr: `tar: ${t6.file}: ${h16}
`, exitCode: 2 };
  }
  let p17 = d16;
  return l8.length > 0 && (p17 += `${l8.join(`
`)}
`), { stdout: "", stderr: p17, exitCode: l8.length > 0 ? 2 : 0 };
}
async function ct3(e5, t6, i10) {
  if (!t6.file || t6.file === "-") return { stdout: "", stderr: `tar: Cannot update stdin/stdout
`, exitCode: 2 };
  if (i10.length === 0) return { stdout: "", stderr: `tar: Cowardly refusing to update with nothing
`, exitCode: 2 };
  let r8 = e5.fs.resolvePath(e5.cwd, t6.file), n23;
  try {
    n23 = await e5.fs.readFileBuffer(r8);
  } catch {
    return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
  }
  let s9 = await _9(n23);
  if (s9.error) return { stdout: "", stderr: `tar: ${s9.error}
`, exitCode: 2 };
  let o9 = /* @__PURE__ */ new Map();
  for (let m24 of s9.entries) o9.set(m24.name, m24.mtime);
  let a7 = t6.directory ? e5.fs.resolvePath(e5.cwd, t6.directory) : e5.cwd, c14 = [], l8 = [], d16 = "";
  for (let m24 of i10) {
    let { entries: S16, errors: E12 } = await L14(e5, a7, m24, t6.exclude);
    l8.push(...E12);
    for (let w19 of S16) {
      let I17 = o9.get(w19.name);
      (!I17 || w19.mtime && w19.mtime.getTime() > I17.getTime()) && (c14.push(w19), t6.verbose && (d16 += `${w19.name}${w19.isDirectory ? "/" : ""}
`));
    }
  }
  if (c14.length === 0) {
    let m24 = "";
    return l8.length > 0 && (m24 = `${l8.join(`
`)}
`), { stdout: "", stderr: m24, exitCode: l8.length > 0 ? 2 : 0 };
  }
  let u10 = new Set(c14.map((m24) => m24.name)), p17 = [...s9.entries.filter((m24) => !u10.has(m24.name)).map((m24) => ({ name: m24.name, content: m24.content, mode: m24.mode, mtime: m24.mtime, isDirectory: m24.type === "directory", isSymlink: m24.type === "symlink", linkTarget: m24.linkTarget, uid: m24.uid, gid: m24.gid })), ...c14], f11;
  try {
    f11 = await C15(p17);
  } catch (m24) {
    return { stdout: "", stderr: `tar: error creating archive: ${m24 instanceof Error ? m24.message : "unknown error"}
`, exitCode: 2 };
  }
  try {
    await e5.fs.writeFile(r8, f11);
  } catch (m24) {
    let S16 = m24 instanceof Error ? m24.message : "unknown error";
    return { stdout: "", stderr: `tar: ${t6.file}: ${S16}
`, exitCode: 2 };
  }
  let h16 = d16;
  return l8.length > 0 && (h16 += `${l8.join(`
`)}
`), { stdout: "", stderr: h16, exitCode: l8.length > 0 ? 2 : 0 };
}
async function lt4(e5, t6, i10) {
  let r8;
  if (t6.file && t6.file !== "-") {
    let f11 = e5.fs.resolvePath(e5.cwd, t6.file);
    try {
      r8 = await e5.fs.readFileBuffer(f11);
    } catch {
      return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
    }
  } else r8 = Uint8Array.from(e5.stdin, (f11) => f11.charCodeAt(0));
  let n23, s9 = t6.gzip || j8(r8), o9 = t6.bzip2 || q11(r8), a7 = t6.xz || Y8(r8), c14 = t6.zstd || Q10(r8);
  if (s9 ? n23 = await X7(r8) : o9 ? n23 = await V9(r8) : a7 ? n23 = await J10(r8) : c14 ? n23 = await ee5(r8) : n23 = await _9(r8), n23.error) return { stdout: "", stderr: `tar: ${n23.error}
`, exitCode: 2 };
  let l8 = t6.directory ? e5.fs.resolvePath(e5.cwd, t6.directory) : e5.cwd, d16 = "", u10 = "", g18 = [];
  if (t6.directory && !t6.toStdout) try {
    await e5.fs.mkdir(l8, { recursive: true });
  } catch {
  }
  for (let f11 of n23.entries) {
    let h16 = Re5(f11.name, t6.strip);
    if (!h16) continue;
    let m24 = h16.endsWith("/") ? h16.slice(0, -1) : h16;
    if (i10.length > 0) {
      let E12;
      if (t6.wildcards ? E12 = i10.some((w19) => N12(h16, w19) || N12(m24, w19) || h16.startsWith(`${w19}/`)) : E12 = i10.some((w19) => h16 === w19 || h16.startsWith(`${w19}/`) || m24 === w19), !E12) continue;
    }
    if (te6(h16, t6.exclude)) continue;
    let S16 = e5.fs.resolvePath(l8, h16);
    try {
      if (f11.type === "directory") {
        if (t6.toStdout) continue;
        await e5.fs.mkdir(S16, { recursive: true }), t6.verbose && (d16 += `${h16}
`);
      } else if (f11.type === "file") {
        if (t6.toStdout) {
          u10 += new TextDecoder().decode(f11.content), t6.verbose && (d16 += `${h16}
`);
          continue;
        }
        if (t6.keepOldFiles) try {
          await e5.fs.stat(S16), t6.verbose && (d16 += `${h16}: not overwritten, file exists
`);
          continue;
        } catch {
        }
        let E12 = S16.substring(0, S16.lastIndexOf("/"));
        if (E12) try {
          await e5.fs.mkdir(E12, { recursive: true });
        } catch {
        }
        if (await e5.fs.writeFile(S16, f11.content), t6.preserve && f11.mode) try {
          await e5.fs.chmod(S16, f11.mode);
        } catch {
        }
        t6.verbose && (d16 += `${h16}
`);
      } else if (f11.type === "symlink" && f11.linkTarget) {
        if (t6.toStdout) continue;
        if (t6.keepOldFiles) try {
          await e5.fs.stat(S16), t6.verbose && (d16 += `${h16}: not overwritten, file exists
`);
          continue;
        } catch {
        }
        let E12 = S16.substring(0, S16.lastIndexOf("/"));
        if (E12) try {
          await e5.fs.mkdir(E12, { recursive: true });
        } catch {
        }
        try {
          await e5.fs.symlink(f11.linkTarget, S16);
        } catch {
        }
        t6.verbose && (d16 += `${h16}
`);
      }
    } catch (E12) {
      let w19 = E12 instanceof Error ? E12.message : "unknown error";
      g18.push(`tar: ${h16}: ${w19}`);
    }
  }
  let p17 = d16;
  return g18.length > 0 && (p17 += `${g18.join(`
`)}
`), { stdout: u10, stderr: p17, exitCode: g18.length > 0 ? 2 : 0 };
}
async function ut3(e5, t6, i10) {
  let r8;
  if (t6.file && t6.file !== "-") {
    let d16 = e5.fs.resolvePath(e5.cwd, t6.file);
    try {
      r8 = await e5.fs.readFileBuffer(d16);
    } catch {
      return { stdout: "", stderr: `tar: ${t6.file}: Cannot open: No such file or directory
`, exitCode: 2 };
    }
  } else r8 = Uint8Array.from(e5.stdin, (d16) => d16.charCodeAt(0));
  let n23, s9 = t6.gzip || j8(r8), o9 = t6.bzip2 || q11(r8), a7 = t6.xz || Y8(r8), c14 = t6.zstd || Q10(r8);
  if (s9 ? n23 = await X7(r8) : o9 ? n23 = await V9(r8) : a7 ? n23 = await J10(r8) : c14 ? n23 = await ee5(r8) : n23 = await _9(r8), n23.error) return { stdout: "", stderr: `tar: ${n23.error}
`, exitCode: 2 };
  let l8 = "";
  for (let d16 of n23.entries) {
    let u10 = Re5(d16.name, t6.strip);
    if (!u10) continue;
    let g18 = u10.endsWith("/") ? u10.slice(0, -1) : u10;
    if (i10.length > 0) {
      let p17;
      if (t6.wildcards ? p17 = i10.some((f11) => N12(u10, f11) || N12(g18, f11) || u10.startsWith(`${f11}/`)) : p17 = i10.some((f11) => u10 === f11 || u10.startsWith(`${f11}/`) || g18 === f11), !p17) continue;
    }
    if (!te6(u10, t6.exclude)) if (t6.verbose) {
      let p17 = d16.type === "directory", f11 = it4(d16.mode, p17), h16 = `${d16.uid}/${d16.gid}`, m24 = d16.size.toString().padStart(8, " "), S16 = st5(d16.mtime), E12 = `${f11} ${h16.padEnd(10)} ${m24} ${S16} ${u10}`;
      d16.type === "symlink" && d16.linkTarget && (E12 += ` -> ${d16.linkTarget}`), l8 += `${E12}
`;
    } else l8 += `${u10}
`;
  }
  return { stdout: l8, stderr: "", exitCode: 0 };
}
var H14, oe5, ce5, M11, be3, Me3, $e3, b22, U11, le5, z7, G6, Ze5, Ke4, We3, R6, P14, v17, O12, ge6, $15, Z10, B8, D13, y15, _e3, ke4, nt5, Tt4, Ct4;
var init_chunk_VZWXH2PZ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-VZWXH2PZ.js"() {
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_compressjs();
    H14 = "file";
    oe5 = "link";
    ce5 = "symlink";
    M11 = "directory";
    be3 = { file: "0", link: "1", symlink: "2", "character-device": "3", "block-device": "4", directory: "5", fifo: "6", "pax-header": "x", "pax-global-header": "g", "gnu-long-name": "L", "gnu-long-link-name": "K" };
    Me3 = { 0: H14, 1: oe5, 2: ce5, 3: "character-device", 4: "block-device", 5: M11, 6: "fifo", x: "pax-header", g: "pax-global-header", L: "gnu-long-name", K: "gnu-long-link-name" };
    $e3 = new Uint8Array(512);
    b22 = new Uint8Array(0);
    U11 = new TextEncoder();
    le5 = new TextDecoder();
    z7 = (e5) => e5.type === M11 || e5.type === ce5 || e5.type === oe5;
    G6 = 32;
    Ze5 = 48;
    Ke4 = { path: ["name", (e5) => e5], linkpath: ["linkname", (e5) => e5], size: ["size", (e5) => parseInt(e5, 10)], mtime: ["mtime", parseFloat], uid: ["uid", (e5) => parseInt(e5, 10)], gid: ["gid", (e5) => parseInt(e5, 10)], uname: ["uname", (e5) => e5], gname: ["gname", (e5) => e5] };
    We3 = new Uint8Array(512 * 2);
    R6 = 256;
    P14 = 0;
    v17 = 1;
    O12 = new Error("Tar archive is truncated.");
    ge6 = (e5) => e5.pipeTo(new WritableStream());
    $15 = null;
    Z10 = null;
    B8 = null;
    D13 = null;
    y15 = 100 * 1024 * 1024;
    _e3 = 1e4;
    ke4 = 100;
    nt5 = { name: "tar", summary: "manipulate tape archives", usage: "tar [options] [file...]", description: ["Create, extract, or list contents of tar archives.", "", "One of -c, -r, -u, -x, or -t is required to specify the operation."], options: ["-c, --create           create a new archive", "-r, --append           append files to the end of an archive", "-u, --update           only append files newer than copy in archive", "-x, --extract          extract files from an archive", "-t, --list             list contents of an archive", "-f, --file=ARCHIVE     use archive file ARCHIVE", "-a, --auto-compress    use archive suffix to determine compression", "-z, --gzip             filter archive through gzip", "-j, --bzip2            filter archive through bzip2", "-J, --xz               filter archive through xz", "--zstd                 filter archive through zstd", "-v, --verbose          verbosely list files processed", "-O, --to-stdout        extract files to standard output", "-k, --keep-old-files   don't replace existing files when extracting", "-m, --touch            don't extract file modified time", "-C, --directory=DIR    change to directory DIR before performing operations", "-p, --preserve         preserve permissions", "-T, --files-from=FILE  read files to extract/create from FILE", "-X, --exclude-from=FILE read exclude patterns from FILE", "--strip=N              strip N leading path components on extraction", "--exclude=PATTERN      exclude files matching PATTERN", "--wildcards            use wildcards for pattern matching", "    --help             display this help and exit"], examples: ["tar -cvf archive.tar file1 file2     Create archive from files", "tar -czvf archive.tar.gz dir/        Create gzip-compressed archive", "tar -cjvf archive.tar.bz2 dir/       Create bzip2-compressed archive", "tar -rf archive.tar newfile.txt      Append file to archive", "tar -uf archive.tar dir/             Update archive with newer files", "tar -xvf archive.tar                 Extract archive", "tar -xvf archive.tar -C /tmp         Extract to /tmp", "tar -tvf archive.tar                 List archive contents", "tar -xzf archive.tar.gz              Extract gzip archive", "tar -xf archive.tar file1.txt        Extract specific file", "tar -xOf archive.tar file.txt        Extract file to stdout", "tar -xf archive.tar --wildcards '*.txt'  Extract matching files"] };
    Tt4 = { name: "tar", async execute(e5, t6) {
      if (o2(e5)) return s(nt5);
      let i10 = ze4(e5);
      if (!i10.ok) return i10.error;
      let { options: r8, files: n23 } = i10, s9 = [r8.create, r8.append, r8.update, r8.extract, r8.list].filter(Boolean).length;
      if (s9 === 0) return { stdout: "", stderr: `tar: You must specify one of -c, -r, -u, -x, or -t
`, exitCode: 2 };
      if (s9 > 1) return { stdout: "", stderr: `tar: You may not specify more than one of -c, -r, -u, -x, or -t
`, exitCode: 2 };
      if (r8.autoCompress && r8.file && r8.create) {
        let c14 = r8.file.toLowerCase();
        c14.endsWith(".tar.gz") || c14.endsWith(".tgz") ? r8.gzip = true : c14.endsWith(".tar.bz2") || c14.endsWith(".tbz2") ? r8.bzip2 = true : c14.endsWith(".tar.xz") || c14.endsWith(".txz") ? r8.xz = true : (c14.endsWith(".tar.zst") || c14.endsWith(".tzst")) && (r8.zstd = true);
      }
      let o9 = [r8.gzip, r8.bzip2, r8.xz, r8.zstd].filter(Boolean).length;
      if (o9 > 1) return { stdout: "", stderr: `tar: You may not specify more than one compression option
`, exitCode: 2 };
      if ((r8.append || r8.update) && o9 > 0) return { stdout: "", stderr: `tar: Cannot append/update compressed archives - decompress first
`, exitCode: 2 };
      let a7 = n23;
      if (r8.filesFrom) {
        let c14 = t6.fs.resolvePath(t6.cwd, r8.filesFrom);
        try {
          let d16 = (await t6.fs.readFile(c14)).split(`
`).map((u10) => u10.trim()).filter((u10) => u10.length > 0 && !u10.startsWith("#"));
          a7 = [...n23, ...d16];
        } catch {
          return { stdout: "", stderr: `tar: ${r8.filesFrom}: Cannot open: No such file or directory
`, exitCode: 2 };
        }
      }
      if (r8.excludeFrom) {
        let c14 = t6.fs.resolvePath(t6.cwd, r8.excludeFrom);
        try {
          let d16 = (await t6.fs.readFile(c14)).split(`
`).map((u10) => u10.trim()).filter((u10) => u10.length > 0 && !u10.startsWith("#"));
          r8.exclude.push(...d16);
        } catch {
          return { stdout: "", stderr: `tar: ${r8.excludeFrom}: Cannot open: No such file or directory
`, exitCode: 2 };
        }
      }
      return r8.create ? at4(t6, r8, a7) : r8.append ? ot4(t6, r8, a7) : r8.update ? ct3(t6, r8, a7) : r8.extract ? lt4(t6, r8, a7) : ut3(t6, r8, a7);
    } };
    Ct4 = { name: "tar", flags: [{ flag: "-c", type: "boolean" }, { flag: "-x", type: "boolean" }, { flag: "-t", type: "boolean" }, { flag: "-f", type: "value", valueHint: "path" }, { flag: "-z", type: "boolean" }, { flag: "-j", type: "boolean" }, { flag: "-v", type: "boolean" }, { flag: "-C", type: "value", valueHint: "path" }, { flag: "--strip-components", type: "value", valueHint: "number" }, { flag: "--exclude", type: "value", valueHint: "pattern" }], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/tar-K7K7BL55.js
var tar_K7K7BL55_exports = {};
__export(tar_K7K7BL55_exports, {
  flagsForFuzzing: () => Ct4,
  tarCommand: () => Tt4
});
var init_tar_K7K7BL55 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/tar-K7K7BL55.js"() {
    init_chunk_VZWXH2PZ();
    init_chunk_YNYSPYQ5();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js
var xe6;
var init_chunk_SYMJJMQ4 = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js"() {
    init_chunk_DXB73IDG();
    xe6 = o((de9, pe8) => {
      (function(oe8, R13) {
        typeof define == "function" && define.amd ? define([], R13) : typeof pe8 == "object" && typeof de9 < "u" ? pe8.exports = R13() : oe8.Papa = R13();
      })(de9, function oe8() {
        "use strict";
        var R13 = /* @__PURE__ */ function() {
          return typeof self < "u" ? self : typeof window < "u" ? window : typeof R13 < "u" ? R13 : {};
        }();
        function _e6() {
          var e5 = R13.URL || R13.webkitURL || null, t6 = oe8.toString();
          return l8.BLOB_URL || (l8.BLOB_URL = e5.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", t6, ")();"], { type: "text/javascript" })));
        }
        var Y10 = !R13.document && !!R13.postMessage, ue9 = R13.IS_PAPA_WORKER || false, ae8 = {}, ge8 = 0, l8 = {};
        if (l8.parse = Ce4, l8.unparse = Re7, l8.RECORD_SEP = "", l8.UNIT_SEP = "", l8.BYTE_ORDER_MARK = "\uFEFF", l8.BAD_DELIMITERS = ["\r", `
`, '"', l8.BYTE_ORDER_MARK], l8.WORKERS_SUPPORTED = !Y10 && !!R13.Worker, l8.NODE_STREAM_INPUT = 1, l8.LocalChunkSize = 1024 * 1024 * 10, l8.RemoteChunkSize = 1024 * 1024 * 5, l8.DefaultDelimiter = ",", l8.Parser = fe10, l8.ParserHandle = ce9, l8.NetworkStreamer = G8, l8.FileStreamer = ee7, l8.StringStreamer = Z12, l8.ReadableStreamStreamer = te9, typeof PAPA_BROWSER_CONTEXT > "u" && (l8.DuplexStreamStreamer = re5), R13.jQuery) {
          var V13 = R13.jQuery;
          V13.fn.parse = function(e5) {
            var t6 = e5.config || {}, r8 = [];
            return this.each(function(h16) {
              var i10 = V13(this).prop("tagName").toUpperCase() === "INPUT" && V13(this).attr("type").toLowerCase() === "file" && R13.FileReader;
              if (!i10 || !this.files || this.files.length === 0) return true;
              for (var y18 = 0; y18 < this.files.length; y18++) r8.push({ file: this.files[y18], inputElem: this, instanceConfig: V13.extend({}, t6) });
            }), s9(), this;
            function s9() {
              if (r8.length === 0) {
                g18(e5.complete) && e5.complete();
                return;
              }
              var h16 = r8[0];
              if (g18(e5.before)) {
                var i10 = e5.before(h16.file, h16.inputElem);
                if (typeof i10 == "object") if (i10.action === "abort") {
                  n23("AbortError", h16.file, h16.inputElem, i10.reason);
                  return;
                } else if (i10.action === "skip") {
                  p17();
                  return;
                } else typeof i10.config == "object" && (h16.instanceConfig = V13.extend(h16.instanceConfig, i10.config));
                else if (i10 === "skip") {
                  p17();
                  return;
                }
              }
              var y18 = h16.instanceConfig.complete;
              h16.instanceConfig.complete = function(E12) {
                g18(y18) && y18(E12, h16.file, h16.inputElem), p17();
              }, l8.parse(h16.file, h16.instanceConfig);
            }
            function n23(h16, i10, y18, E12) {
              g18(e5.error) && e5.error({ name: h16 }, i10, y18, E12);
            }
            function p17() {
              r8.splice(0, 1), s9();
            }
          };
        }
        ue9 && (R13.onmessage = Se6);
        function Ce4(e5, t6) {
          t6 = t6 || {};
          var r8 = t6.dynamicTyping || false;
          if (g18(r8) && (t6.dynamicTypingFunction = r8, r8 = {}), t6.dynamicTyping = r8, t6.transform = g18(t6.transform) ? t6.transform : false, t6.worker && l8.WORKERS_SUPPORTED) {
            var s9 = Ee6();
            s9.userStep = t6.step, s9.userChunk = t6.chunk, s9.userComplete = t6.complete, s9.userError = t6.error, t6.step = g18(t6.step), t6.chunk = g18(t6.chunk), t6.complete = g18(t6.complete), t6.error = g18(t6.error), delete t6.worker, s9.postMessage({ input: e5, config: t6, workerId: s9.id });
            return;
          }
          var n23 = null;
          if (e5 === l8.NODE_STREAM_INPUT && typeof PAPA_BROWSER_CONTEXT > "u") return n23 = new re5(t6), n23.getStream();
          return typeof e5 == "string" ? (e5 = p17(e5), t6.download ? n23 = new G8(t6) : n23 = new Z12(t6)) : e5.readable === true && g18(e5.read) && g18(e5.on) ? n23 = new te9(t6) : (R13.File && e5 instanceof File || e5 instanceof Object) && (n23 = new ee7(t6)), n23.stream(e5);
          function p17(h16) {
            return h16.charCodeAt(0) === 65279 ? h16.slice(1) : h16;
          }
        }
        function Re7(e5, t6) {
          var r8 = false, s9 = true, n23 = ",", p17 = `\r
`, h16 = '"', i10 = h16 + h16, y18 = false, E12 = null, O16 = false;
          L18();
          var d16 = new RegExp(se7(h16), "g");
          if (typeof e5 == "string" && (e5 = JSON.parse(e5)), Array.isArray(e5)) {
            if (!e5.length || Array.isArray(e5[0])) return u10(null, e5, y18);
            if (typeof e5[0] == "object") return u10(E12 || Object.keys(e5[0]), e5, y18);
          } else if (typeof e5 == "object") return typeof e5.data == "string" && (e5.data = JSON.parse(e5.data)), Array.isArray(e5.data) && (e5.fields || (e5.fields = e5.meta && e5.meta.fields || E12), e5.fields || (e5.fields = Array.isArray(e5.data[0]) ? e5.fields : typeof e5.data[0] == "object" ? Object.keys(e5.data[0]) : []), !Array.isArray(e5.data[0]) && typeof e5.data[0] != "object" && (e5.data = [e5.data])), u10(e5.fields || [], e5.data || [], y18);
          throw new Error("Unable to serialize unrecognized input");
          function L18() {
            if (typeof t6 == "object") {
              if (typeof t6.delimiter == "string" && !l8.BAD_DELIMITERS.filter(function(v20) {
                return t6.delimiter.indexOf(v20) !== -1;
              }).length && (n23 = t6.delimiter), (typeof t6.quotes == "boolean" || typeof t6.quotes == "function" || Array.isArray(t6.quotes)) && (r8 = t6.quotes), (typeof t6.skipEmptyLines == "boolean" || typeof t6.skipEmptyLines == "string") && (y18 = t6.skipEmptyLines), typeof t6.newline == "string" && (p17 = t6.newline), typeof t6.quoteChar == "string" && (h16 = t6.quoteChar), typeof t6.header == "boolean" && (s9 = t6.header), Array.isArray(t6.columns)) {
                if (t6.columns.length === 0) throw new Error("Option columns is empty");
                E12 = t6.columns;
              }
              t6.escapeChar !== void 0 && (i10 = t6.escapeChar + h16), t6.escapeFormulae instanceof RegExp ? O16 = t6.escapeFormulae : typeof t6.escapeFormulae == "boolean" && t6.escapeFormulae && (O16 = /^[=+\-@\t\r].*$/);
            }
          }
          function u10(v20, k15, S16) {
            var w19 = "";
            typeof v20 == "string" && (v20 = JSON.parse(v20)), typeof k15 == "string" && (k15 = JSON.parse(k15));
            var M14 = Array.isArray(v20) && v20.length > 0, T10 = !Array.isArray(k15[0]);
            if (M14 && s9) {
              for (var q15 = 0; q15 < v20.length; q15++) q15 > 0 && (w19 += n23), w19 += c14(v20[q15], q15);
              k15.length > 0 && (w19 += p17);
            }
            for (var _14 = 0; _14 < k15.length; _14++) {
              var j11 = M14 ? v20.length : k15[_14].length, W14 = false, o9 = M14 ? Object.keys(k15[_14]).length === 0 : k15[_14].length === 0;
              if (S16 && !M14 && (W14 = S16 === "greedy" ? k15[_14].join("").trim() === "" : k15[_14].length === 1 && k15[_14][0].length === 0), S16 === "greedy" && M14) {
                for (var f11 = [], m24 = 0; m24 < j11; m24++) {
                  var b25 = T10 ? v20[m24] : m24;
                  f11.push(k15[_14][b25]);
                }
                W14 = f11.join("").trim() === "";
              }
              if (!W14) {
                for (var a7 = 0; a7 < j11; a7++) {
                  a7 > 0 && !o9 && (w19 += n23);
                  var C19 = M14 && T10 ? v20[a7] : a7;
                  w19 += c14(k15[_14][C19], a7);
                }
                _14 < k15.length - 1 && (!S16 || j11 > 0 && !o9) && (w19 += p17);
              }
            }
            return w19;
          }
          function c14(v20, k15) {
            if (typeof v20 > "u" || v20 === null) return "";
            if (v20.constructor === Date) return JSON.stringify(v20).slice(1, 25);
            var S16 = false;
            O16 && typeof v20 == "string" && O16.test(v20) && (v20 = "'" + v20, S16 = true);
            var w19 = v20.toString().replace(d16, i10);
            return S16 = S16 || r8 === true || typeof r8 == "function" && r8(v20, k15) || Array.isArray(r8) && r8[k15] || Q13(w19, l8.BAD_DELIMITERS) || w19.indexOf(n23) > -1 || w19.charAt(0) === " " || w19.charAt(w19.length - 1) === " ", S16 ? h16 + w19 + h16 : w19;
          }
          function Q13(v20, k15) {
            for (var S16 = 0; S16 < k15.length; S16++) if (v20.indexOf(k15[S16]) > -1) return true;
            return false;
          }
        }
        function z10(e5) {
          this._handle = null, this._finished = false, this._completed = false, this._halted = false, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = true, this._completeResults = { data: [], errors: [], meta: {} }, t6.call(this, e5), this.parseChunk = function(r8, s9) {
            let n23 = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && n23 > 0) {
              let O16 = this._config.newline;
              if (!O16) {
                let L18 = this._config.quoteChar || '"';
                O16 = this._handle.guessLineEndings(r8, L18);
              }
              r8 = [...r8.split(O16).slice(n23)].join(O16);
            }
            if (this.isFirstChunk && g18(this._config.beforeFirstChunk)) {
              var p17 = this._config.beforeFirstChunk(r8);
              p17 !== void 0 && (r8 = p17);
            }
            this.isFirstChunk = false, this._halted = false;
            var h16 = this._partialLine + r8;
            this._partialLine = "";
            var i10 = this._handle.parse(h16, this._baseIndex, !this._finished);
            if (this._handle.paused() || this._handle.aborted()) {
              this._halted = true;
              return;
            }
            var y18 = i10.meta.cursor;
            this._finished || (this._partialLine = h16.substring(y18 - this._baseIndex), this._baseIndex = y18), i10 && i10.data && (this._rowCount += i10.data.length);
            var E12 = this._finished || this._config.preview && this._rowCount >= this._config.preview;
            if (ue9) R13.postMessage({ results: i10, workerId: l8.WORKER_ID, finished: E12 });
            else if (g18(this._config.chunk) && !s9) {
              if (this._config.chunk(i10, this._handle), this._handle.paused() || this._handle.aborted()) {
                this._halted = true;
                return;
              }
              i10 = void 0, this._completeResults = void 0;
            }
            return !this._config.step && !this._config.chunk && (this._completeResults.data = this._completeResults.data.concat(i10.data), this._completeResults.errors = this._completeResults.errors.concat(i10.errors), this._completeResults.meta = i10.meta), !this._completed && E12 && g18(this._config.complete) && (!i10 || !i10.meta.aborted) && (this._config.complete(this._completeResults, this._input), this._completed = true), !E12 && (!i10 || !i10.meta.paused) && this._nextChunk(), i10;
          }, this._sendError = function(r8) {
            g18(this._config.error) ? this._config.error(r8) : ue9 && this._config.error && R13.postMessage({ workerId: l8.WORKER_ID, error: r8, finished: false });
          };
          function t6(r8) {
            var s9 = he10(r8);
            s9.chunkSize = parseInt(s9.chunkSize), !r8.step && !r8.chunk && (s9.chunkSize = null), this._handle = new ce9(s9), this._handle.streamer = this, this._config = s9;
          }
        }
        function G8(e5) {
          e5 = e5 || {}, e5.chunkSize || (e5.chunkSize = l8.RemoteChunkSize), z10.call(this, e5);
          var t6;
          Y10 ? this._nextChunk = function() {
            this._readChunk(), this._chunkLoaded();
          } : this._nextChunk = function() {
            this._readChunk();
          }, this.stream = function(s9) {
            this._input = s9, this._nextChunk();
          }, this._readChunk = function() {
            if (this._finished) {
              this._chunkLoaded();
              return;
            }
            if (t6 = new XMLHttpRequest(), this._config.withCredentials && (t6.withCredentials = this._config.withCredentials), Y10 || (t6.onload = F20(this._chunkLoaded, this), t6.onerror = F20(this._chunkError, this)), t6.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !Y10), this._config.downloadRequestHeaders) {
              var s9 = this._config.downloadRequestHeaders;
              for (var n23 in s9) t6.setRequestHeader(n23, s9[n23]);
            }
            if (this._config.chunkSize) {
              var p17 = this._start + this._config.chunkSize - 1;
              t6.setRequestHeader("Range", "bytes=" + this._start + "-" + p17);
            }
            try {
              t6.send(this._config.downloadRequestBody);
            } catch (h16) {
              this._chunkError(h16.message);
            }
            Y10 && t6.status === 0 && this._chunkError();
          }, this._chunkLoaded = function() {
            if (t6.readyState === 4) {
              if (t6.status < 200 || t6.status >= 400) {
                this._chunkError();
                return;
              }
              this._start += this._config.chunkSize ? this._config.chunkSize : t6.responseText.length, this._finished = !this._config.chunkSize || this._start >= r8(t6), this.parseChunk(t6.responseText);
            }
          }, this._chunkError = function(s9) {
            var n23 = t6.statusText || s9;
            this._sendError(new Error(n23));
          };
          function r8(s9) {
            var n23 = s9.getResponseHeader("Content-Range");
            return n23 === null ? -1 : parseInt(n23.substring(n23.lastIndexOf("/") + 1));
          }
        }
        G8.prototype = Object.create(z10.prototype), G8.prototype.constructor = G8;
        function ee7(e5) {
          e5 = e5 || {}, e5.chunkSize || (e5.chunkSize = l8.LocalChunkSize), z10.call(this, e5);
          var t6, r8, s9 = typeof FileReader < "u";
          this.stream = function(n23) {
            this._input = n23, r8 = n23.slice || n23.webkitSlice || n23.mozSlice, s9 ? (t6 = new FileReader(), t6.onload = F20(this._chunkLoaded, this), t6.onerror = F20(this._chunkError, this)) : t6 = new FileReaderSync(), this._nextChunk();
          }, this._nextChunk = function() {
            !this._finished && (!this._config.preview || this._rowCount < this._config.preview) && this._readChunk();
          }, this._readChunk = function() {
            var n23 = this._input;
            if (this._config.chunkSize) {
              var p17 = Math.min(this._start + this._config.chunkSize, this._input.size);
              n23 = r8.call(n23, this._start, p17);
            }
            var h16 = t6.readAsText(n23, this._config.encoding);
            s9 || this._chunkLoaded({ target: { result: h16 } });
          }, this._chunkLoaded = function(n23) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(n23.target.result);
          }, this._chunkError = function() {
            this._sendError(t6.error);
          };
        }
        ee7.prototype = Object.create(z10.prototype), ee7.prototype.constructor = ee7;
        function Z12(e5) {
          e5 = e5 || {}, z10.call(this, e5);
          var t6;
          this.stream = function(r8) {
            return t6 = r8, this._nextChunk();
          }, this._nextChunk = function() {
            if (!this._finished) {
              var r8 = this._config.chunkSize, s9;
              return r8 ? (s9 = t6.substring(0, r8), t6 = t6.substring(r8)) : (s9 = t6, t6 = ""), this._finished = !t6, this.parseChunk(s9);
            }
          };
        }
        Z12.prototype = Object.create(Z12.prototype), Z12.prototype.constructor = Z12;
        function te9(e5) {
          e5 = e5 || {}, z10.call(this, e5);
          var t6 = [], r8 = true, s9 = false;
          this.pause = function() {
            z10.prototype.pause.apply(this, arguments), this._input.pause();
          }, this.resume = function() {
            z10.prototype.resume.apply(this, arguments), this._input.resume();
          }, this.stream = function(n23) {
            this._input = n23, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
          }, this._checkIsFinished = function() {
            s9 && t6.length === 1 && (this._finished = true);
          }, this._nextChunk = function() {
            this._checkIsFinished(), t6.length ? this.parseChunk(t6.shift()) : r8 = true;
          }, this._streamData = F20(function(n23) {
            try {
              t6.push(typeof n23 == "string" ? n23 : n23.toString(this._config.encoding)), r8 && (r8 = false, this._checkIsFinished(), this.parseChunk(t6.shift()));
            } catch (p17) {
              this._streamError(p17);
            }
          }, this), this._streamError = F20(function(n23) {
            this._streamCleanUp(), this._sendError(n23);
          }, this), this._streamEnd = F20(function() {
            this._streamCleanUp(), s9 = true, this._streamData("");
          }, this), this._streamCleanUp = F20(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
          }, this);
        }
        te9.prototype = Object.create(z10.prototype), te9.prototype.constructor = te9;
        function re5(e5) {
          var t6 = m3("stream").Duplex, r8 = he10(e5), s9 = true, n23 = false, p17 = [], h16 = null;
          this._onCsvData = function(i10) {
            var y18 = i10.data;
            !h16.push(y18) && !this._handle.paused() && this._handle.pause();
          }, this._onCsvComplete = function() {
            h16.push(null);
          }, r8.step = F20(this._onCsvData, this), r8.complete = F20(this._onCsvComplete, this), z10.call(this, r8), this._nextChunk = function() {
            n23 && p17.length === 1 && (this._finished = true), p17.length ? p17.shift()() : s9 = true;
          }, this._addToParseQueue = function(i10, y18) {
            p17.push(F20(function() {
              if (this.parseChunk(typeof i10 == "string" ? i10 : i10.toString(r8.encoding)), g18(y18)) return y18();
            }, this)), s9 && (s9 = false, this._nextChunk());
          }, this._onRead = function() {
            this._handle.paused() && this._handle.resume();
          }, this._onWrite = function(i10, y18, E12) {
            this._addToParseQueue(i10, E12);
          }, this._onWriteComplete = function() {
            n23 = true, this._addToParseQueue("");
          }, this.getStream = function() {
            return h16;
          }, h16 = new t6({ readableObjectMode: true, decodeStrings: false, read: F20(this._onRead, this), write: F20(this._onWrite, this) }), h16.once("finish", F20(this._onWriteComplete, this));
        }
        typeof PAPA_BROWSER_CONTEXT > "u" && (re5.prototype = Object.create(z10.prototype), re5.prototype.constructor = re5);
        function ce9(e5) {
          var t6 = Math.pow(2, 53), r8 = -t6, s9 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, n23 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, p17 = this, h16 = 0, i10 = 0, y18, E12, O16 = false, d16 = false, L18, u10 = [], c14 = { data: [], errors: [], meta: {} };
          if (g18(e5.step)) {
            var Q13 = e5.step;
            e5.step = function(o9) {
              if (c14 = o9, w19()) S16();
              else {
                if (S16(), c14.data.length === 0) return;
                h16 += o9.data.length, e5.preview && h16 > e5.preview ? E12.abort() : (c14.data = c14.data[0], Q13(c14, p17));
              }
            };
          }
          this.parse = function(o9, f11, m24) {
            var b25 = e5.quoteChar || '"';
            if (e5.newline || (e5.newline = this.guessLineEndings(o9, b25)), L18 = false, e5.delimiter) g18(e5.delimiter) && (e5.delimiter = e5.delimiter(o9), c14.meta.delimiter = e5.delimiter);
            else {
              var a7 = j11(o9, e5.newline, e5.skipEmptyLines, e5.comments, e5.delimitersToGuess);
              a7.successful ? e5.delimiter = a7.bestDelimiter : (L18 = true, e5.delimiter = l8.DefaultDelimiter), c14.meta.delimiter = e5.delimiter;
            }
            var C19 = he10(e5);
            return e5.preview && e5.header && C19.preview++, y18 = o9, E12 = new fe10(C19), c14 = E12.parse(y18, f11, m24), S16(), O16 ? { meta: { paused: true } } : c14 || { meta: { paused: false } };
          }, this.paused = function() {
            return O16;
          }, this.pause = function() {
            O16 = true, E12.abort(), y18 = g18(e5.chunk) ? "" : y18.substring(E12.getCharIndex());
          }, this.resume = function() {
            p17.streamer._halted ? (O16 = false, p17.streamer.parseChunk(y18, true)) : setTimeout(p17.resume, 3);
          }, this.aborted = function() {
            return d16;
          }, this.abort = function() {
            d16 = true, E12.abort(), c14.meta.aborted = true, g18(e5.complete) && e5.complete(c14), y18 = "";
          }, this.guessLineEndings = function(o9, f11) {
            o9 = o9.substring(0, 1024 * 1024);
            var m24 = new RegExp(se7(f11) + "([^]*?)" + se7(f11), "gm");
            o9 = o9.replace(m24, "");
            var b25 = o9.split("\r"), a7 = o9.split(`
`), C19 = a7.length > 1 && a7[0].length < b25[0].length;
            if (b25.length === 1 || C19) return `
`;
            for (var A13 = 0, x22 = 0; x22 < b25.length; x22++) b25[x22][0] === `
` && A13++;
            return A13 >= b25.length / 2 ? `\r
` : "\r";
          };
          function v20(o9) {
            return e5.skipEmptyLines === "greedy" ? o9.join("").trim() === "" : o9.length === 1 && o9[0].length === 0;
          }
          function k15(o9) {
            if (s9.test(o9)) {
              var f11 = parseFloat(o9);
              if (f11 > r8 && f11 < t6) return true;
            }
            return false;
          }
          function S16() {
            return c14 && L18 && (W14("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + l8.DefaultDelimiter + "'"), L18 = false), e5.skipEmptyLines && (c14.data = c14.data.filter(function(o9) {
              return !v20(o9);
            })), w19() && M14(), _14();
          }
          function w19() {
            return e5.header && u10.length === 0;
          }
          function M14() {
            if (!c14) return;
            function o9(m24, b25) {
              g18(e5.transformHeader) && (m24 = e5.transformHeader(m24, b25)), u10.push(m24);
            }
            if (Array.isArray(c14.data[0])) {
              for (var f11 = 0; w19() && f11 < c14.data.length; f11++) c14.data[f11].forEach(o9);
              c14.data.splice(0, 1);
            } else c14.data.forEach(o9);
          }
          function T10(o9) {
            return e5.dynamicTypingFunction && e5.dynamicTyping[o9] === void 0 && (e5.dynamicTyping[o9] = e5.dynamicTypingFunction(o9)), (e5.dynamicTyping[o9] || e5.dynamicTyping) === true;
          }
          function q15(o9, f11) {
            return T10(o9) ? f11 === "true" || f11 === "TRUE" ? true : f11 === "false" || f11 === "FALSE" ? false : k15(f11) ? parseFloat(f11) : n23.test(f11) ? new Date(f11) : f11 === "" ? null : f11 : f11;
          }
          function _14() {
            if (!c14 || !e5.header && !e5.dynamicTyping && !e5.transform) return c14;
            function o9(m24, b25) {
              var a7 = e5.header ? {} : [], C19;
              for (C19 = 0; C19 < m24.length; C19++) {
                var A13 = C19, x22 = m24[C19];
                e5.header && (A13 = C19 >= u10.length ? "__parsed_extra" : u10[C19]), e5.transform && (x22 = e5.transform(x22, A13)), x22 = q15(A13, x22), A13 === "__parsed_extra" ? (a7[A13] = a7[A13] || [], a7[A13].push(x22)) : a7[A13] = x22;
              }
              return e5.header && (C19 > u10.length ? W14("FieldMismatch", "TooManyFields", "Too many fields: expected " + u10.length + " fields but parsed " + C19, i10 + b25) : C19 < u10.length && W14("FieldMismatch", "TooFewFields", "Too few fields: expected " + u10.length + " fields but parsed " + C19, i10 + b25)), a7;
            }
            var f11 = 1;
            return !c14.data.length || Array.isArray(c14.data[0]) ? (c14.data = c14.data.map(o9), f11 = c14.data.length) : c14.data = o9(c14.data, 0), e5.header && c14.meta && (c14.meta.fields = u10), i10 += f11, c14;
          }
          function j11(o9, f11, m24, b25, a7) {
            var C19, A13, x22, J13;
            a7 = a7 || [",", "	", "|", ";", l8.RECORD_SEP, l8.UNIT_SEP];
            for (var N14 = 0; N14 < a7.length; N14++) {
              var ie7 = a7[N14], X10 = 0, K9 = 0, I17 = 0;
              x22 = void 0;
              for (var H16 = new fe10({ comments: b25, delimiter: ie7, newline: f11, preview: 10 }).parse(o9), D15 = 0; D15 < H16.data.length; D15++) {
                if (m24 && v20(H16.data[D15])) {
                  I17++;
                  continue;
                }
                var P19 = H16.data[D15].length;
                if (K9 += P19, typeof x22 > "u") {
                  x22 = P19;
                  continue;
                } else P19 > 0 && (X10 += Math.abs(P19 - x22), x22 = P19);
              }
              H16.data.length > 0 && (K9 /= H16.data.length - I17), (typeof A13 > "u" || X10 <= A13) && (typeof J13 > "u" || K9 > J13) && K9 > 1.99 && (A13 = X10, C19 = ie7, J13 = K9);
            }
            return e5.delimiter = C19, { successful: !!C19, bestDelimiter: C19 };
          }
          function W14(o9, f11, m24, b25) {
            var a7 = { type: o9, code: f11, message: m24 };
            b25 !== void 0 && (a7.row = b25), c14.errors.push(a7);
          }
        }
        function se7(e5) {
          return e5.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        function fe10(e5) {
          e5 = e5 || {};
          var t6 = e5.delimiter, r8 = e5.newline, s9 = e5.comments, n23 = e5.step, p17 = e5.preview, h16 = e5.fastMode, i10, y18 = null, E12 = false;
          e5.quoteChar === void 0 || e5.quoteChar === null ? i10 = '"' : i10 = e5.quoteChar;
          var O16 = i10;
          if (e5.escapeChar !== void 0 && (O16 = e5.escapeChar), (typeof t6 != "string" || l8.BAD_DELIMITERS.indexOf(t6) > -1) && (t6 = ","), s9 === t6) throw new Error("Comment character same as delimiter");
          s9 === true ? s9 = "#" : (typeof s9 != "string" || l8.BAD_DELIMITERS.indexOf(s9) > -1) && (s9 = false), r8 !== `
` && r8 !== "\r" && r8 !== `\r
` && (r8 = `
`);
          var d16 = 0, L18 = false;
          this.parse = function(u10, c14, Q13) {
            if (typeof u10 != "string") throw new Error("Input must be a string");
            var v20 = u10.length, k15 = t6.length, S16 = r8.length, w19 = s9.length, M14 = g18(n23);
            d16 = 0;
            var T10 = [], q15 = [], _14 = [], j11 = 0;
            if (!u10) return I17();
            if (h16 || h16 !== false && u10.indexOf(i10) === -1) {
              for (var W14 = u10.split(r8), o9 = 0; o9 < W14.length; o9++) {
                if (_14 = W14[o9], d16 += _14.length, o9 !== W14.length - 1) d16 += r8.length;
                else if (Q13) return I17();
                if (!(s9 && _14.substring(0, w19) === s9)) {
                  if (M14) {
                    if (T10 = [], N14(_14.split(t6)), H16(), L18) return I17();
                  } else N14(_14.split(t6));
                  if (p17 && o9 >= p17) return T10 = T10.slice(0, p17), I17(true);
                }
              }
              return I17();
            }
            for (var f11 = u10.indexOf(t6, d16), m24 = u10.indexOf(r8, d16), b25 = new RegExp(se7(O16) + se7(i10), "g"), a7 = u10.indexOf(i10, d16); ; ) {
              if (u10[d16] === i10) {
                for (a7 = d16, d16++; ; ) {
                  if (a7 = u10.indexOf(i10, a7 + 1), a7 === -1) return Q13 || q15.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: T10.length, index: d16 }), X10();
                  if (a7 === v20 - 1) {
                    var C19 = u10.substring(d16, a7).replace(b25, i10);
                    return X10(C19);
                  }
                  if (i10 === O16 && u10[a7 + 1] === O16) {
                    a7++;
                    continue;
                  }
                  if (!(i10 !== O16 && a7 !== 0 && u10[a7 - 1] === O16)) {
                    f11 !== -1 && f11 < a7 + 1 && (f11 = u10.indexOf(t6, a7 + 1)), m24 !== -1 && m24 < a7 + 1 && (m24 = u10.indexOf(r8, a7 + 1));
                    var A13 = m24 === -1 ? f11 : Math.min(f11, m24), x22 = ie7(A13);
                    if (u10.substr(a7 + 1 + x22, k15) === t6) {
                      _14.push(u10.substring(d16, a7).replace(b25, i10)), d16 = a7 + 1 + x22 + k15, u10[a7 + 1 + x22 + k15] !== i10 && (a7 = u10.indexOf(i10, d16)), f11 = u10.indexOf(t6, d16), m24 = u10.indexOf(r8, d16);
                      break;
                    }
                    var J13 = ie7(m24);
                    if (u10.substring(a7 + 1 + J13, a7 + 1 + J13 + S16) === r8) {
                      if (_14.push(u10.substring(d16, a7).replace(b25, i10)), K9(a7 + 1 + J13 + S16), f11 = u10.indexOf(t6, d16), a7 = u10.indexOf(i10, d16), M14 && (H16(), L18)) return I17();
                      if (p17 && T10.length >= p17) return I17(true);
                      break;
                    }
                    q15.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: T10.length, index: d16 }), a7++;
                  }
                }
                continue;
              }
              if (s9 && _14.length === 0 && u10.substring(d16, d16 + w19) === s9) {
                if (m24 === -1) return I17();
                d16 = m24 + S16, m24 = u10.indexOf(r8, d16), f11 = u10.indexOf(t6, d16);
                continue;
              }
              if (f11 !== -1 && (f11 < m24 || m24 === -1)) {
                _14.push(u10.substring(d16, f11)), d16 = f11 + k15, f11 = u10.indexOf(t6, d16);
                continue;
              }
              if (m24 !== -1) {
                if (_14.push(u10.substring(d16, m24)), K9(m24 + S16), M14 && (H16(), L18)) return I17();
                if (p17 && T10.length >= p17) return I17(true);
                continue;
              }
              break;
            }
            return X10();
            function N14(D15) {
              T10.push(D15), j11 = d16;
            }
            function ie7(D15) {
              var P19 = 0;
              if (D15 !== -1) {
                var B12 = u10.substring(a7 + 1, D15);
                B12 && B12.trim() === "" && (P19 = B12.length);
              }
              return P19;
            }
            function X10(D15) {
              return Q13 || (typeof D15 > "u" && (D15 = u10.substring(d16)), _14.push(D15), d16 = v20, N14(_14), M14 && H16()), I17();
            }
            function K9(D15) {
              d16 = D15, N14(_14), _14 = [], m24 = u10.indexOf(r8, d16);
            }
            function I17(D15) {
              if (e5.header && !c14 && T10.length && !E12) {
                let P19 = T10[0], B12 = /* @__PURE__ */ Object.create(null), le8 = new Set(P19), ve7 = false;
                for (let $17 = 0; $17 < P19.length; $17++) {
                  let U13 = P19[$17];
                  if (g18(e5.transformHeader) && (U13 = e5.transformHeader(U13, $17)), !B12[U13]) B12[U13] = 1, P19[$17] = U13;
                  else {
                    let ne8, ke6 = B12[U13];
                    do
                      ne8 = `${U13}_${ke6}`, ke6++;
                    while (le8.has(ne8));
                    le8.add(ne8), P19[$17] = ne8, B12[U13]++, ve7 = true, y18 === null && (y18 = {}), y18[ne8] = U13;
                  }
                  le8.add(U13);
                }
                ve7 && console.warn("Duplicate headers found and renamed."), E12 = true;
              }
              return { data: T10, errors: q15, meta: { delimiter: t6, linebreak: r8, aborted: L18, truncated: !!D15, cursor: j11 + (c14 || 0), renamedHeaders: y18 } };
            }
            function H16() {
              n23(I17()), T10 = [], q15 = [];
            }
          }, this.abort = function() {
            L18 = true;
          }, this.getCharIndex = function() {
            return d16;
          };
        }
        function Ee6() {
          if (!l8.WORKERS_SUPPORTED) return false;
          var e5 = _e6(), t6 = new R13.Worker(e5);
          return t6.onmessage = be6, t6.id = ge8++, ae8[t6.id] = t6, t6;
        }
        function be6(e5) {
          var t6 = e5.data, r8 = ae8[t6.workerId], s9 = false;
          if (t6.error) r8.userError(t6.error, t6.file);
          else if (t6.results && t6.results.data) {
            var n23 = function() {
              s9 = true, me5(t6.workerId, { data: [], errors: [], meta: { aborted: true } });
            }, p17 = { abort: n23, pause: ye7, resume: ye7 };
            if (g18(r8.userStep)) {
              for (var h16 = 0; h16 < t6.results.data.length && (r8.userStep({ data: t6.results.data[h16], errors: t6.results.errors, meta: t6.results.meta }, p17), !s9); h16++) ;
              delete t6.results;
            } else g18(r8.userChunk) && (r8.userChunk(t6.results, p17, t6.file), delete t6.results);
          }
          t6.finished && !s9 && me5(t6.workerId, t6.results);
        }
        function me5(e5, t6) {
          var r8 = ae8[e5];
          g18(r8.userComplete) && r8.userComplete(t6), r8.terminate(), delete ae8[e5];
        }
        function ye7() {
          throw new Error("Not implemented.");
        }
        function Se6(e5) {
          var t6 = e5.data;
          if (typeof l8.WORKER_ID > "u" && t6 && (l8.WORKER_ID = t6.workerId), typeof t6.input == "string") R13.postMessage({ workerId: l8.WORKER_ID, results: l8.parse(t6.input, t6.config), finished: true });
          else if (R13.File && t6.input instanceof File || t6.input instanceof Object) {
            var r8 = l8.parse(t6.input, t6.config);
            r8 && R13.postMessage({ workerId: l8.WORKER_ID, results: r8, finished: true });
          }
        }
        function he10(e5) {
          if (typeof e5 != "object" || e5 === null) return e5;
          var t6 = Array.isArray(e5) ? [] : {};
          for (var r8 in e5) t6[r8] = he10(e5[r8]);
          return t6;
        }
        function F20(e5, t6) {
          return function() {
            e5.apply(t6, arguments);
          };
        }
        function g18(e5) {
          return typeof e5 == "function";
        }
        return l8;
      });
    });
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js
function wt3(s9, e5) {
  let t6 = [], n23 = e5.exec(s9);
  for (; n23; ) {
    let i10 = [];
    i10.startIndex = e5.lastIndex - n23[0].length;
    let r8 = n23.length;
    for (let o9 = 0; o9 < r8; o9++) i10.push(n23[o9]);
    t6.push(i10), n23 = e5.exec(s9);
  }
  return t6;
}
function Ii(s9) {
  return typeof s9 < "u";
}
function Mi(s9, e5) {
  e5 = Object.assign({}, Qa, e5);
  let t6 = [], n23 = false, i10 = false;
  s9[0] === "\uFEFF" && (s9 = s9.substr(1));
  for (let r8 = 0; r8 < s9.length; r8++) if (s9[r8] === "<" && s9[r8 + 1] === "?") {
    if (r8 += 2, r8 = Ci(s9, r8), r8.err) return r8;
  } else if (s9[r8] === "<") {
    let o9 = r8;
    if (r8++, s9[r8] === "!") {
      r8 = Li(s9, r8);
      continue;
    } else {
      let a7 = false;
      s9[r8] === "/" && (a7 = true, r8++);
      let l8 = "";
      for (; r8 < s9.length && s9[r8] !== ">" && s9[r8] !== " " && s9[r8] !== "	" && s9[r8] !== `
` && s9[r8] !== "\r"; r8++) l8 += s9[r8];
      if (l8 = l8.trim(), l8[l8.length - 1] === "/" && (l8 = l8.substring(0, l8.length - 1), r8--), !nl(l8)) {
        let f11;
        return l8.trim().length === 0 ? f11 = "Invalid space after '<'." : f11 = "Tag '" + l8 + "' is an invalid name.", q12("InvalidTag", f11, _10(s9, r8));
      }
      let c14 = za(s9, r8);
      if (c14 === false) return q12("InvalidAttr", "Attributes for '" + l8 + "' have open quote.", _10(s9, r8));
      let u10 = c14.value;
      if (r8 = c14.index, u10[u10.length - 1] === "/") {
        let f11 = r8 - u10.length;
        u10 = u10.substring(0, u10.length - 1);
        let d16 = Pi(u10, e5);
        if (d16 === true) n23 = true;
        else return q12(d16.err.code, d16.err.msg, _10(s9, f11 + d16.err.line));
      } else if (a7) if (c14.tagClosed) {
        if (u10.trim().length > 0) return q12("InvalidTag", "Closing tag '" + l8 + "' can't have attributes or invalid starting.", _10(s9, o9));
        if (t6.length === 0) return q12("InvalidTag", "Closing tag '" + l8 + "' has not been opened.", _10(s9, o9));
        {
          let f11 = t6.pop();
          if (l8 !== f11.tagName) {
            let d16 = _10(s9, f11.tagStartPos);
            return q12("InvalidTag", "Expected closing tag '" + f11.tagName + "' (opened in line " + d16.line + ", col " + d16.col + ") instead of closing tag '" + l8 + "'.", _10(s9, o9));
          }
          t6.length == 0 && (i10 = true);
        }
      } else return q12("InvalidTag", "Closing tag '" + l8 + "' doesn't have proper closing.", _10(s9, r8));
      else {
        let f11 = Pi(u10, e5);
        if (f11 !== true) return q12(f11.err.code, f11.err.msg, _10(s9, r8 - u10.length + f11.err.line));
        if (i10 === true) return q12("InvalidXml", "Multiple possible root nodes found.", _10(s9, r8));
        e5.unpairedTags.indexOf(l8) !== -1 || t6.push({ tagName: l8, tagStartPos: o9 }), n23 = true;
      }
      for (r8++; r8 < s9.length; r8++) if (s9[r8] === "<") if (s9[r8 + 1] === "!") {
        r8++, r8 = Li(s9, r8);
        continue;
      } else if (s9[r8 + 1] === "?") {
        if (r8 = Ci(s9, ++r8), r8.err) return r8;
      } else break;
      else if (s9[r8] === "&") {
        let f11 = tl(s9, r8);
        if (f11 == -1) return q12("InvalidChar", "char '&' is not expected.", _10(s9, r8));
        r8 = f11;
      } else if (i10 === true && !qi(s9[r8])) return q12("InvalidXml", "Extra text at the end", _10(s9, r8));
      s9[r8] === "<" && r8--;
    }
  } else {
    if (qi(s9[r8])) continue;
    return q12("InvalidChar", "char '" + s9[r8] + "' is not expected.", _10(s9, r8));
  }
  if (n23) {
    if (t6.length == 1) return q12("InvalidTag", "Unclosed tag '" + t6[0].tagName + "'.", _10(s9, t6[0].tagStartPos));
    if (t6.length > 0) return q12("InvalidXml", "Invalid '" + JSON.stringify(t6.map((r8) => r8.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else return q12("InvalidXml", "Start tag expected.", 1);
  return true;
}
function qi(s9) {
  return s9 === " " || s9 === "	" || s9 === `
` || s9 === "\r";
}
function Ci(s9, e5) {
  let t6 = e5;
  for (; e5 < s9.length; e5++) if (s9[e5] == "?" || s9[e5] == " ") {
    let n23 = s9.substr(t6, e5 - t6);
    if (e5 > 5 && n23 === "xml") return q12("InvalidXml", "XML declaration allowed only at the start of the document.", _10(s9, e5));
    if (s9[e5] == "?" && s9[e5 + 1] == ">") {
      e5++;
      break;
    } else continue;
  }
  return e5;
}
function Li(s9, e5) {
  if (s9.length > e5 + 5 && s9[e5 + 1] === "-" && s9[e5 + 2] === "-") {
    for (e5 += 3; e5 < s9.length; e5++) if (s9[e5] === "-" && s9[e5 + 1] === "-" && s9[e5 + 2] === ">") {
      e5 += 2;
      break;
    }
  } else if (s9.length > e5 + 8 && s9[e5 + 1] === "D" && s9[e5 + 2] === "O" && s9[e5 + 3] === "C" && s9[e5 + 4] === "T" && s9[e5 + 5] === "Y" && s9[e5 + 6] === "P" && s9[e5 + 7] === "E") {
    let t6 = 1;
    for (e5 += 8; e5 < s9.length; e5++) if (s9[e5] === "<") t6++;
    else if (s9[e5] === ">" && (t6--, t6 === 0)) break;
  } else if (s9.length > e5 + 9 && s9[e5 + 1] === "[" && s9[e5 + 2] === "C" && s9[e5 + 3] === "D" && s9[e5 + 4] === "A" && s9[e5 + 5] === "T" && s9[e5 + 6] === "A" && s9[e5 + 7] === "[") {
    for (e5 += 8; e5 < s9.length; e5++) if (s9[e5] === "]" && s9[e5 + 1] === "]" && s9[e5 + 2] === ">") {
      e5 += 2;
      break;
    }
  }
  return e5;
}
function za(s9, e5) {
  let t6 = "", n23 = "", i10 = false;
  for (; e5 < s9.length; e5++) {
    if (s9[e5] === Ha || s9[e5] === Da) n23 === "" ? n23 = s9[e5] : n23 !== s9[e5] || (n23 = "");
    else if (s9[e5] === ">" && n23 === "") {
      i10 = true;
      break;
    }
    t6 += s9[e5];
  }
  return n23 !== "" ? false : { value: t6, index: e5, tagClosed: i10 };
}
function Pi(s9, e5) {
  let t6 = wt3(s9, Za), n23 = {};
  for (let i10 = 0; i10 < t6.length; i10++) {
    if (t6[i10][1].length === 0) return q12("InvalidAttr", "Attribute '" + t6[i10][2] + "' has no space in starting.", Pe4(t6[i10]));
    if (t6[i10][3] !== void 0 && t6[i10][4] === void 0) return q12("InvalidAttr", "Attribute '" + t6[i10][2] + "' is without value.", Pe4(t6[i10]));
    if (t6[i10][3] === void 0 && !e5.allowBooleanAttributes) return q12("InvalidAttr", "boolean attribute '" + t6[i10][2] + "' is not allowed.", Pe4(t6[i10]));
    let r8 = t6[i10][2];
    if (!sl(r8)) return q12("InvalidAttr", "Attribute '" + r8 + "' is an invalid name.", Pe4(t6[i10]));
    if (!n23.hasOwnProperty(r8)) n23[r8] = 1;
    else return q12("InvalidAttr", "Attribute '" + r8 + "' is repeated.", Pe4(t6[i10]));
  }
  return true;
}
function el(s9, e5) {
  let t6 = /\d/;
  for (s9[e5] === "x" && (e5++, t6 = /[\da-fA-F]/); e5 < s9.length; e5++) {
    if (s9[e5] === ";") return e5;
    if (!s9[e5].match(t6)) break;
  }
  return -1;
}
function tl(s9, e5) {
  if (e5++, s9[e5] === ";") return -1;
  if (s9[e5] === "#") return e5++, el(s9, e5);
  let t6 = 0;
  for (; e5 < s9.length; e5++, t6++) if (!(s9[e5].match(/\w/) && t6 < 20)) {
    if (s9[e5] === ";") break;
    return -1;
  }
  return e5;
}
function q12(s9, e5, t6) {
  return { err: { code: s9, msg: e5, line: t6.line || t6, col: t6.col } };
}
function sl(s9) {
  return ye5(s9);
}
function nl(s9) {
  return ye5(s9);
}
function _10(s9, e5) {
  let t6 = s9.substring(0, e5).split(/\r?\n/);
  return { line: t6.length, col: t6[t6.length - 1].length + 1 };
}
function Pe4(s9) {
  return s9.startIndex + s9[1].length;
}
function le6(s9, e5, t6) {
  for (let n23 = 0; n23 < e5.length; n23++) if (e5[n23] !== s9[t6 + n23 + 1]) return false;
  return true;
}
function Me4(s9) {
  if (ye5(s9)) return s9;
  throw new Error(`Invalid entity name ${s9}`);
}
function Os(s9, e5 = {}) {
  if (e5 = Object.assign({}, al, e5), !s9 || typeof s9 != "string") return s9;
  let t6 = s9.trim();
  if (e5.skipLike !== void 0 && e5.skipLike.test(t6)) return s9;
  if (s9 === "0") return 0;
  if (e5.hex && rl.test(t6)) return ul(t6, 16);
  if (t6.includes("e") || t6.includes("E")) return cl(s9, t6, e5);
  {
    let n23 = ol.exec(t6);
    if (n23) {
      let i10 = n23[1] || "", r8 = n23[2], o9 = fl(n23[3]), a7 = i10 ? s9[r8.length + 1] === "." : s9[r8.length] === ".";
      if (!e5.leadingZeros && (r8.length > 1 || r8.length === 1 && !a7)) return s9;
      {
        let l8 = Number(t6), c14 = String(l8);
        if (l8 === 0) return l8;
        if (c14.search(/[eE]/) !== -1) return e5.eNotation ? l8 : s9;
        if (t6.indexOf(".") !== -1) return c14 === "0" || c14 === o9 || c14 === `${i10}${o9}` ? l8 : s9;
        let u10 = r8 ? o9 : t6;
        return r8 ? u10 === c14 || i10 + u10 === c14 ? l8 : s9 : u10 === c14 || u10 === i10 + c14 ? l8 : s9;
      }
    } else return s9;
  }
}
function cl(s9, e5, t6) {
  if (!t6.eNotation) return s9;
  let n23 = e5.match(ll);
  if (n23) {
    let i10 = n23[1] || "", r8 = n23[3].indexOf("e") === -1 ? "E" : "e", o9 = n23[2], a7 = i10 ? s9[o9.length + 1] === r8 : s9[o9.length] === r8;
    return o9.length > 1 && a7 ? s9 : o9.length === 1 && (n23[3].startsWith(`.${r8}`) || n23[3][0] === r8) ? Number(e5) : t6.leadingZeros && !a7 ? (e5 = (n23[1] || "") + n23[3], Number(e5)) : s9;
  } else return s9;
}
function fl(s9) {
  return s9 && s9.indexOf(".") !== -1 && (s9 = s9.replace(/0+$/, ""), s9 === "." ? s9 = "0" : s9[0] === "." ? s9 = "0" + s9 : s9[s9.length - 1] === "." && (s9 = s9.substring(0, s9.length - 1))), s9;
}
function ul(s9, e5) {
  if (parseInt) return parseInt(s9, e5);
  if (Number.parseInt) return Number.parseInt(s9, e5);
  if (window && window.parseInt) return window.parseInt(s9, e5);
  throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
function _e4(s9) {
  return typeof s9 == "function" ? s9 : Array.isArray(s9) ? (e5) => {
    for (let t6 of s9) if (typeof t6 == "string" && e5 === t6 || t6 instanceof RegExp && t6.test(e5)) return true;
  } : () => false;
}
function dl(s9) {
  let e5 = Object.keys(s9);
  for (let t6 = 0; t6 < e5.length; t6++) {
    let n23 = e5[t6];
    this.lastEntities[n23] = { regex: new RegExp("&" + n23 + ";", "g"), val: s9[n23] };
  }
}
function hl(s9, e5, t6, n23, i10, r8, o9) {
  if (s9 !== void 0 && (this.options.trimValues && !n23 && (s9 = s9.trim()), s9.length > 0)) {
    o9 || (s9 = this.replaceEntitiesValue(s9));
    let a7 = this.options.tagValueProcessor(e5, s9, t6, i10, r8);
    return a7 == null ? s9 : typeof a7 != typeof s9 || a7 !== s9 ? a7 : this.options.trimValues ? Is(s9, this.options.parseTagValue, this.options.numberParseOptions) : s9.trim() === s9 ? Is(s9, this.options.parseTagValue, this.options.numberParseOptions) : s9;
  }
}
function pl(s9) {
  if (this.options.removeNSPrefix) {
    let e5 = s9.split(":"), t6 = s9.charAt(0) === "/" ? "/" : "";
    if (e5[0] === "xmlns") return "";
    e5.length === 2 && (s9 = t6 + e5[1]);
  }
  return s9;
}
function gl(s9, e5) {
  if (this.options.ignoreAttributes !== true && typeof s9 == "string") {
    let t6 = wt3(s9, ml), n23 = t6.length, i10 = {};
    for (let r8 = 0; r8 < n23; r8++) {
      let o9 = this.resolveNameSpace(t6[r8][1]);
      if (this.ignoreAttributesFn(o9, e5)) continue;
      let a7 = t6[r8][4], l8 = this.options.attributeNamePrefix + o9;
      if (o9.length) if (this.options.transformAttributeName && (l8 = this.options.transformAttributeName(l8)), l8 === "__proto__" && (l8 = "#__proto__"), a7 !== void 0) {
        this.options.trimValues && (a7 = a7.trim()), a7 = this.replaceEntitiesValue(a7);
        let c14 = this.options.attributeValueProcessor(o9, a7, e5);
        c14 == null ? i10[l8] = a7 : typeof c14 != typeof a7 || c14 !== a7 ? i10[l8] = c14 : i10[l8] = Is(a7, this.options.parseAttributeValue, this.options.numberParseOptions);
      } else this.options.allowBooleanAttributes && (i10[l8] = true);
    }
    if (!Object.keys(i10).length) return;
    if (this.options.attributesGroupName) {
      let r8 = {};
      return r8[this.options.attributesGroupName] = i10, r8;
    }
    return i10;
  }
}
function bl(s9, e5, t6, n23) {
  this.options.captureMetaData || (n23 = void 0);
  let i10 = this.options.updateTag(e5.tagname, t6, e5[":@"]);
  i10 === false || (typeof i10 == "string" && (e5.tagname = i10), s9.addChild(e5, n23));
}
function Sl(s9, e5, t6, n23) {
  return s9 && (n23 === void 0 && (n23 = e5.child.length === 0), s9 = this.parseTextData(s9, e5.tagname, t6, false, e5[":@"] ? Object.keys(e5[":@"]).length !== 0 : false, n23), s9 !== void 0 && s9 !== "" && e5.add(this.options.textNodeName, s9), s9 = ""), s9;
}
function Nl(s9, e5, t6, n23) {
  return !!(e5 && e5.has(n23) || s9 && s9.has(t6));
}
function El(s9, e5, t6 = ">") {
  let n23, i10 = "";
  for (let r8 = e5; r8 < s9.length; r8++) {
    let o9 = s9[r8];
    if (n23) o9 === n23 && (n23 = "");
    else if (o9 === '"' || o9 === "'") n23 = o9;
    else if (o9 === t6[0]) if (t6[1]) {
      if (s9[r8 + 1] === t6[1]) return { data: i10, index: r8 };
    } else return { data: i10, index: r8 };
    else o9 === "	" && (o9 = " ");
    i10 += o9;
  }
}
function ce6(s9, e5, t6, n23) {
  let i10 = s9.indexOf(e5, t6);
  if (i10 === -1) throw new Error(n23);
  return i10 + e5.length - 1;
}
function ks(s9, e5, t6, n23 = ">") {
  let i10 = El(s9, e5 + 1, n23);
  if (!i10) return;
  let r8 = i10.data, o9 = i10.index, a7 = r8.search(/\s/), l8 = r8, c14 = true;
  a7 !== -1 && (l8 = r8.substring(0, a7), r8 = r8.substring(a7 + 1).trimStart());
  let u10 = l8;
  if (t6) {
    let f11 = l8.indexOf(":");
    f11 !== -1 && (l8 = l8.substr(f11 + 1), c14 = l8 !== i10.data.substr(f11 + 1));
  }
  return { tagName: l8, tagExp: r8, closeIndex: o9, attrExpPresent: c14, rawTagName: u10 };
}
function vl(s9, e5, t6) {
  let n23 = t6, i10 = 1;
  for (; t6 < s9.length; t6++) if (s9[t6] === "<") if (s9[t6 + 1] === "/") {
    let r8 = ce6(s9, ">", t6, `${e5} is not closed`);
    if (s9.substring(t6 + 2, r8).trim() === e5 && (i10--, i10 === 0)) return { tagContent: s9.substring(n23, t6), i: r8 };
    t6 = r8;
  } else if (s9[t6 + 1] === "?") t6 = ce6(s9, "?>", t6 + 1, "StopNode is not closed.");
  else if (s9.substr(t6 + 1, 3) === "!--") t6 = ce6(s9, "-->", t6 + 3, "StopNode is not closed.");
  else if (s9.substr(t6 + 1, 2) === "![") t6 = ce6(s9, "]]>", t6, "StopNode is not closed.") - 2;
  else {
    let r8 = ks(s9, t6, ">");
    r8 && ((r8 && r8.tagName) === e5 && r8.tagExp[r8.tagExp.length - 1] !== "/" && i10++, t6 = r8.closeIndex);
  }
}
function Is(s9, e5, t6) {
  if (e5 && typeof s9 == "string") {
    let n23 = s9.trim();
    return n23 === "true" ? true : n23 === "false" ? false : Os(s9, t6);
  } else return Ii(s9) ? s9 : "";
}
function Cs(s9, e5) {
  return _i(s9, e5);
}
function _i(s9, e5, t6) {
  let n23, i10 = {};
  for (let r8 = 0; r8 < s9.length; r8++) {
    let o9 = s9[r8], a7 = Al(o9), l8 = "";
    if (t6 === void 0 ? l8 = a7 : l8 = t6 + "." + a7, a7 === e5.textNodeName) n23 === void 0 ? n23 = o9[a7] : n23 += "" + o9[a7];
    else {
      if (a7 === void 0) continue;
      if (o9[a7]) {
        let c14 = _i(o9[a7], e5, l8), u10 = Ol(c14, e5);
        o9[qs] !== void 0 && (c14[qs] = o9[qs]), o9[":@"] ? Tl(c14, o9[":@"], l8, e5) : Object.keys(c14).length === 1 && c14[e5.textNodeName] !== void 0 && !e5.alwaysCreateTextNode ? c14 = c14[e5.textNodeName] : Object.keys(c14).length === 0 && (e5.alwaysCreateTextNode ? c14[e5.textNodeName] = "" : c14 = ""), i10[a7] !== void 0 && i10.hasOwnProperty(a7) ? (Array.isArray(i10[a7]) || (i10[a7] = [i10[a7]]), i10[a7].push(c14)) : e5.isArray(a7, l8, u10) ? i10[a7] = [c14] : i10[a7] = c14;
      }
    }
  }
  return typeof n23 == "string" ? n23.length > 0 && (i10[e5.textNodeName] = n23) : n23 !== void 0 && (i10[e5.textNodeName] = n23), i10;
}
function Al(s9) {
  let e5 = Object.keys(s9);
  for (let t6 = 0; t6 < e5.length; t6++) {
    let n23 = e5[t6];
    if (n23 !== ":@") return n23;
  }
}
function Tl(s9, e5, t6, n23) {
  if (e5) {
    let i10 = Object.keys(e5), r8 = i10.length;
    for (let o9 = 0; o9 < r8; o9++) {
      let a7 = i10[o9];
      n23.isArray(a7, t6 + "." + a7, true, true) ? s9[a7] = [e5[a7]] : s9[a7] = e5[a7];
    }
  }
}
function Ol(s9, e5) {
  let { textNodeName: t6 } = e5, n23 = Object.keys(s9).length;
  return !!(n23 === 0 || n23 === 1 && (s9[t6] || typeof s9[t6] == "boolean" || s9[t6] === 0));
}
function Ls(s9, e5) {
  let t6 = "";
  return e5.format && e5.indentBy.length > 0 && (t6 = `
`), Bi(s9, e5, "", t6);
}
function Bi(s9, e5, t6, n23) {
  let i10 = "", r8 = false;
  for (let o9 = 0; o9 < s9.length; o9++) {
    let a7 = s9[o9], l8 = kl(a7);
    if (l8 === void 0) continue;
    let c14 = "";
    if (t6.length === 0 ? c14 = l8 : c14 = `${t6}.${l8}`, l8 === e5.textNodeName) {
      let g18 = a7[l8];
      Il(c14, e5) || (g18 = e5.tagValueProcessor(l8, g18), g18 = Fi(g18, e5)), r8 && (i10 += n23), i10 += g18, r8 = false;
      continue;
    } else if (l8 === e5.cdataPropName) {
      r8 && (i10 += n23), i10 += `<![CDATA[${a7[l8][0][e5.textNodeName]}]]>`, r8 = false;
      continue;
    } else if (l8 === e5.commentPropName) {
      i10 += n23 + `<!--${a7[l8][0][e5.textNodeName]}-->`, r8 = true;
      continue;
    } else if (l8[0] === "?") {
      let g18 = xi(a7[":@"], e5), h16 = l8 === "?xml" ? "" : n23, m24 = a7[l8][0][e5.textNodeName];
      m24 = m24.length !== 0 ? " " + m24 : "", i10 += h16 + `<${l8}${m24}${g18}?>`, r8 = true;
      continue;
    }
    let u10 = n23;
    u10 !== "" && (u10 += e5.indentBy);
    let f11 = xi(a7[":@"], e5), d16 = n23 + `<${l8}${f11}`, p17 = Bi(a7[l8], e5, c14, u10);
    e5.unpairedTags.indexOf(l8) !== -1 ? e5.suppressUnpairedNode ? i10 += d16 + ">" : i10 += d16 + "/>" : (!p17 || p17.length === 0) && e5.suppressEmptyNode ? i10 += d16 + "/>" : p17 && p17.endsWith(">") ? i10 += d16 + `>${p17}${n23}</${l8}>` : (i10 += d16 + ">", p17 && n23 !== "" && (p17.includes("/>") || p17.includes("</")) ? i10 += n23 + e5.indentBy + p17 + n23 : i10 += p17, i10 += `</${l8}>`), r8 = true;
  }
  return i10;
}
function kl(s9) {
  let e5 = Object.keys(s9);
  for (let t6 = 0; t6 < e5.length; t6++) {
    let n23 = e5[t6];
    if (s9.hasOwnProperty(n23) && n23 !== ":@") return n23;
  }
}
function xi(s9, e5) {
  let t6 = "";
  if (s9 && !e5.ignoreAttributes) for (let n23 in s9) {
    if (!s9.hasOwnProperty(n23)) continue;
    let i10 = e5.attributeValueProcessor(n23, s9[n23]);
    i10 = Fi(i10, e5), i10 === true && e5.suppressBooleanAttributes ? t6 += ` ${n23.substr(e5.attributeNamePrefix.length)}` : t6 += ` ${n23.substr(e5.attributeNamePrefix.length)}="${i10}"`;
  }
  return t6;
}
function Il(s9, e5) {
  s9 = s9.substr(0, s9.length - e5.textNodeName.length - 1);
  let t6 = s9.substr(s9.lastIndexOf(".") + 1);
  for (let n23 in e5.stopNodes) if (e5.stopNodes[n23] === s9 || e5.stopNodes[n23] === "*." + t6) return true;
  return false;
}
function Fi(s9, e5) {
  if (s9 && s9.length > 0 && e5.processEntities) for (let t6 = 0; t6 < e5.entities.length; t6++) {
    let n23 = e5.entities[t6];
    s9 = s9.replace(n23.regex, n23.val);
  }
  return s9;
}
function R7(s9) {
  this.options = Object.assign({}, ql, s9), this.options.ignoreAttributes === true || this.options.attributesGroupName ? this.isAttribute = function() {
    return false;
  } : (this.ignoreAttributesFn = _e4(this.options.ignoreAttributes), this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = Pl), this.processTextOrObjNode = Cl, this.options.format ? (this.indentate = Ll, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
function Cl(s9, e5, t6, n23) {
  let i10 = this.j2x(s9, t6 + 1, n23.concat(e5));
  return s9[this.options.textNodeName] !== void 0 && Object.keys(s9).length === 1 ? this.buildTextValNode(s9[this.options.textNodeName], e5, i10.attrStr, t6) : this.buildObjectNode(i10.val, e5, i10.attrStr, t6);
}
function Ll(s9) {
  return this.options.indentBy.repeat(s9);
}
function Pl(s9) {
  return s9.startsWith(this.options.attributeNamePrefix) && s9 !== this.options.textNodeName ? s9.substr(this.attrPrefixLen) : false;
}
function Ml(s9, e5) {
  let t6 = s9.slice(0, e5).split(/\r\n|\n|\r/g);
  return [t6.length, t6.pop().length + 1];
}
function $l(s9, e5, t6) {
  let n23 = s9.split(/\r\n|\n|\r/g), i10 = "", r8 = (Math.log10(e5 + 1) | 0) + 1;
  for (let o9 = e5 - 1; o9 <= e5 + 1; o9++) {
    let a7 = n23[o9 - 1];
    a7 && (i10 += o9.toString().padEnd(r8, " "), i10 += ":  ", i10 += a7, i10 += `
`, o9 === e5 && (i10 += " ".repeat(r8 + t6 + 2), i10 += `^
`));
  }
  return i10;
}
function _l(s9, e5) {
  let t6 = 0;
  for (; s9[e5 - ++t6] === "\\"; ) ;
  return --t6 && t6 % 2;
}
function Et3(s9, e5 = 0, t6 = s9.length) {
  let n23 = s9.indexOf(`
`, e5);
  return s9[n23 - 1] === "\r" && n23--, n23 <= t6 ? n23 : -1;
}
function we4(s9, e5) {
  for (let t6 = e5; t6 < s9.length; t6++) {
    let n23 = s9[t6];
    if (n23 === `
`) return t6;
    if (n23 === "\r" && s9[t6 + 1] === `
`) return t6 + 1;
    if (n23 < " " && n23 !== "	" || n23 === "\x7F") throw new T8("control characters are not allowed in comments", { toml: s9, ptr: e5 });
  }
  return s9.length;
}
function B9(s9, e5, t6, n23) {
  let i10;
  for (; (i10 = s9[e5]) === " " || i10 === "	" || !t6 && (i10 === `
` || i10 === "\r" && s9[e5 + 1] === `
`); ) e5++;
  return n23 || i10 !== "#" ? e5 : B9(s9, we4(s9, e5), t6);
}
function Ui(s9, e5, t6, n23, i10 = false) {
  if (!n23) return e5 = Et3(s9, e5), e5 < 0 ? s9.length : e5;
  for (let r8 = e5; r8 < s9.length; r8++) {
    let o9 = s9[r8];
    if (o9 === "#") r8 = Et3(s9, r8);
    else {
      if (o9 === t6) return r8 + 1;
      if (o9 === n23 || i10 && (o9 === `
` || o9 === "\r" && s9[r8 + 1] === `
`)) return r8;
    }
  }
  throw new T8("cannot find end of structure", { toml: s9, ptr: e5 });
}
function vt3(s9, e5) {
  let t6 = s9[e5], n23 = t6 === s9[e5 + 1] && s9[e5 + 1] === s9[e5 + 2] ? s9.slice(e5, e5 + 3) : t6;
  e5 += n23.length - 1;
  do
    e5 = s9.indexOf(n23, ++e5);
  while (e5 > -1 && t6 !== "'" && _l(s9, e5));
  return e5 > -1 && (e5 += n23.length, n23.length > 1 && (s9[e5] === t6 && e5++, s9[e5] === t6 && e5++)), e5;
}
function At3(s9, e5 = 0, t6 = s9.length) {
  let n23 = s9[e5] === "'", i10 = s9[e5++] === s9[e5] && s9[e5] === s9[e5 + 1];
  i10 && (t6 -= 2, s9[e5 += 2] === "\r" && e5++, s9[e5] === `
` && e5++);
  let r8 = 0, o9, a7 = "", l8 = e5;
  for (; e5 < t6 - 1; ) {
    let c14 = s9[e5++];
    if (c14 === `
` || c14 === "\r" && s9[e5] === `
`) {
      if (!i10) throw new T8("newlines are not allowed in strings", { toml: s9, ptr: e5 - 1 });
    } else if (c14 < " " && c14 !== "	" || c14 === "\x7F") throw new T8("control characters are not allowed in strings", { toml: s9, ptr: e5 - 1 });
    if (o9) {
      if (o9 = false, c14 === "x" || c14 === "u" || c14 === "U") {
        let u10 = s9.slice(e5, e5 += c14 === "x" ? 2 : c14 === "u" ? 4 : 8);
        if (!Vl.test(u10)) throw new T8("invalid unicode escape", { toml: s9, ptr: r8 });
        try {
          a7 += String.fromCodePoint(parseInt(u10, 16));
        } catch {
          throw new T8("invalid unicode escape", { toml: s9, ptr: r8 });
        }
      } else if (i10 && (c14 === `
` || c14 === " " || c14 === "	" || c14 === "\r")) {
        if (e5 = B9(s9, e5 - 1, true), s9[e5] !== `
` && s9[e5] !== "\r") throw new T8("invalid escape: only line-ending whitespace may be escaped", { toml: s9, ptr: r8 });
        e5 = B9(s9, e5);
      } else if (c14 in Ji) a7 += Ji[c14];
      else throw new T8("unrecognized escape sequence", { toml: s9, ptr: r8 });
      l8 = e5;
    } else !n23 && c14 === "\\" && (r8 = e5 - 1, o9 = true, a7 += s9.slice(l8, r8));
  }
  return a7 + s9.slice(l8, t6 - 1);
}
function Wi(s9, e5, t6, n23) {
  if (s9 === "true") return true;
  if (s9 === "false") return false;
  if (s9 === "-inf") return -1 / 0;
  if (s9 === "inf" || s9 === "+inf") return 1 / 0;
  if (s9 === "nan" || s9 === "+nan" || s9 === "-nan") return NaN;
  if (s9 === "-0") return n23 ? 0n : 0;
  let i10 = Bl.test(s9);
  if (i10 || Fl.test(s9)) {
    if (jl.test(s9)) throw new T8("leading zeroes are not allowed", { toml: e5, ptr: t6 });
    s9 = s9.replace(/_/g, "");
    let o9 = +s9;
    if (isNaN(o9)) throw new T8("invalid number", { toml: e5, ptr: t6 });
    if (i10) {
      if ((i10 = !Number.isSafeInteger(o9)) && !n23) throw new T8("integer value cannot be represented losslessly", { toml: e5, ptr: t6 });
      (i10 || n23 === true) && (o9 = BigInt(s9));
    }
    return o9;
  }
  let r8 = new Be4(s9);
  if (!r8.isValid()) throw new T8("invalid value", { toml: e5, ptr: t6 });
  return r8;
}
function Kl(s9, e5, t6) {
  let n23 = s9.slice(e5, t6), i10 = n23.indexOf("#");
  return i10 > -1 && (we4(s9, i10), n23 = n23.slice(0, i10)), [n23.trimEnd(), i10];
}
function Fe5(s9, e5, t6, n23, i10) {
  if (n23 === 0) throw new T8("document contains excessively nested structures. aborting.", { toml: s9, ptr: e5 });
  let r8 = s9[e5];
  if (r8 === "[" || r8 === "{") {
    let [l8, c14] = r8 === "[" ? Xi(s9, e5, n23, i10) : Gi(s9, e5, n23, i10);
    if (t6) {
      if (c14 = B9(s9, c14), s9[c14] === ",") c14++;
      else if (s9[c14] !== t6) throw new T8("expected comma or end of structure", { toml: s9, ptr: c14 });
    }
    return [l8, c14];
  }
  let o9;
  if (r8 === '"' || r8 === "'") {
    o9 = vt3(s9, e5);
    let l8 = At3(s9, e5, o9);
    if (t6) {
      if (o9 = B9(s9, o9), s9[o9] && s9[o9] !== "," && s9[o9] !== t6 && s9[o9] !== `
` && s9[o9] !== "\r") throw new T8("unexpected character encountered", { toml: s9, ptr: o9 });
      o9 += +(s9[o9] === ",");
    }
    return [l8, o9];
  }
  o9 = Ui(s9, e5, ",", t6);
  let a7 = Kl(s9, e5, o9 - +(s9[o9 - 1] === ","));
  if (!a7[0]) throw new T8("incomplete key-value declaration: no value specified", { toml: s9, ptr: e5 });
  return t6 && a7[1] > -1 && (o9 = B9(s9, e5 + a7[1]), o9 += +(s9[o9] === ",")), [Wi(a7[0], s9, e5, i10), o9];
}
function Tt5(s9, e5, t6 = "=") {
  let n23 = e5 - 1, i10 = [], r8 = s9.indexOf(t6, e5);
  if (r8 < 0) throw new T8("incomplete key-value: cannot find end of key", { toml: s9, ptr: e5 });
  do {
    let o9 = s9[e5 = ++n23];
    if (o9 !== " " && o9 !== "	") if (o9 === '"' || o9 === "'") {
      if (o9 === s9[e5 + 1] && o9 === s9[e5 + 2]) throw new T8("multiline strings are not allowed in keys", { toml: s9, ptr: e5 });
      let a7 = vt3(s9, e5);
      if (a7 < 0) throw new T8("unfinished string encountered", { toml: s9, ptr: e5 });
      n23 = s9.indexOf(".", a7);
      let l8 = s9.slice(a7, n23 < 0 || n23 > r8 ? r8 : n23), c14 = Et3(l8);
      if (c14 > -1) throw new T8("newlines are not allowed in keys", { toml: s9, ptr: e5 + n23 + c14 });
      if (l8.trimStart()) throw new T8("found extra tokens after the string part", { toml: s9, ptr: a7 });
      if (r8 < a7 && (r8 = s9.indexOf(t6, a7), r8 < 0)) throw new T8("incomplete key-value: cannot find end of key", { toml: s9, ptr: e5 });
      i10.push(At3(s9, e5, a7));
    } else {
      n23 = s9.indexOf(".", e5);
      let a7 = s9.slice(e5, n23 < 0 || n23 > r8 ? r8 : n23);
      if (!Rl.test(a7)) throw new T8("only letter, numbers, dashes and underscores are allowed in keys", { toml: s9, ptr: e5 });
      i10.push(a7.trimEnd());
    }
  } while (n23 + 1 && n23 < r8);
  return [i10, B9(s9, r8 + 1, true, true)];
}
function Gi(s9, e5, t6, n23) {
  let i10 = {}, r8 = /* @__PURE__ */ new Set(), o9;
  for (e5++; (o9 = s9[e5++]) !== "}" && o9; ) {
    if (o9 === ",") throw new T8("expected value, found comma", { toml: s9, ptr: e5 - 1 });
    if (o9 === "#") e5 = we4(s9, e5);
    else if (o9 !== " " && o9 !== "	" && o9 !== `
` && o9 !== "\r") {
      let a7, l8 = i10, c14 = false, [u10, f11] = Tt5(s9, e5 - 1);
      for (let g18 = 0; g18 < u10.length; g18++) {
        if (g18 && (l8 = c14 ? l8[a7] : l8[a7] = {}), a7 = u10[g18], (c14 = Object.hasOwn(l8, a7)) && (typeof l8[a7] != "object" || r8.has(l8[a7]))) throw new T8("trying to redefine an already defined value", { toml: s9, ptr: e5 });
        !c14 && a7 === "__proto__" && Object.defineProperty(l8, a7, { enumerable: true, configurable: true, writable: true });
      }
      if (c14) throw new T8("trying to redefine an already defined value", { toml: s9, ptr: e5 });
      let [d16, p17] = Fe5(s9, f11, "}", t6 - 1, n23);
      r8.add(d16), l8[a7] = d16, e5 = p17;
    }
  }
  if (!o9) throw new T8("unfinished table encountered", { toml: s9, ptr: e5 });
  return [i10, e5];
}
function Xi(s9, e5, t6, n23) {
  let i10 = [], r8;
  for (e5++; (r8 = s9[e5++]) !== "]" && r8; ) {
    if (r8 === ",") throw new T8("expected value, found comma", { toml: s9, ptr: e5 - 1 });
    if (r8 === "#") e5 = we4(s9, e5);
    else if (r8 !== " " && r8 !== "	" && r8 !== `
` && r8 !== "\r") {
      let o9 = Fe5(s9, e5 - 1, "]", t6 - 1, n23);
      i10.push(o9[0]), e5 = o9[1];
    }
  }
  if (!r8) throw new T8("unfinished array encountered", { toml: s9, ptr: e5 });
  return [i10, e5];
}
function Qi(s9, e5, t6, n23) {
  let i10 = e5, r8 = t6, o9, a7 = false, l8;
  for (let c14 = 0; c14 < s9.length; c14++) {
    if (c14) {
      if (i10 = a7 ? i10[o9] : i10[o9] = {}, r8 = (l8 = r8[o9]).c, n23 === 0 && (l8.t === 1 || l8.t === 2)) return null;
      if (l8.t === 2) {
        let u10 = i10.length - 1;
        i10 = i10[u10], r8 = r8[u10].c;
      }
    }
    if (o9 = s9[c14], (a7 = Object.hasOwn(i10, o9)) && r8[o9]?.t === 0 && r8[o9]?.d) return null;
    a7 || (o9 === "__proto__" && (Object.defineProperty(i10, o9, { enumerable: true, configurable: true, writable: true }), Object.defineProperty(r8, o9, { enumerable: true, configurable: true, writable: true })), r8[o9] = { t: c14 < s9.length - 1 && n23 === 2 ? 3 : n23, d: false, i: 0, c: {} });
  }
  if (l8 = r8[o9], l8.t !== n23 && !(n23 === 1 && l8.t === 3) || (n23 === 2 && (l8.d || (l8.d = true, i10[o9] = []), i10[o9].push(i10 = {}), l8.c[l8.i++] = l8 = { t: 1, d: false, i: 0, c: {} }), l8.d)) return null;
  if (l8.d = true, n23 === 1) i10 = a7 ? i10[o9] : i10[o9] = {};
  else if (n23 === 0 && a7) return null;
  return [o9, i10, l8.c];
}
function Ot4(s9, { maxDepth: e5 = 1e3, integersAsBigInt: t6 } = {}) {
  let n23 = {}, i10 = {}, r8 = n23, o9 = i10;
  for (let a7 = B9(s9, 0); a7 < s9.length; ) {
    if (s9[a7] === "[") {
      let l8 = s9[++a7] === "[", c14 = Tt5(s9, a7 += +l8, "]");
      if (l8) {
        if (s9[c14[1] - 1] !== "]") throw new T8("expected end of table declaration", { toml: s9, ptr: c14[1] - 1 });
        c14[1]++;
      }
      let u10 = Qi(c14[0], n23, i10, l8 ? 2 : 1);
      if (!u10) throw new T8("trying to redefine an already defined table or value", { toml: s9, ptr: a7 });
      o9 = u10[2], r8 = u10[1], a7 = c14[1];
    } else {
      let l8 = Tt5(s9, a7), c14 = Qi(l8[0], r8, o9, 0);
      if (!c14) throw new T8("trying to redefine an already defined table or value", { toml: s9, ptr: a7 });
      let u10 = Fe5(s9, l8[1], void 0, e5, t6);
      c14[1][c14[0]] = u10[0], a7 = u10[1];
    }
    if (a7 = B9(s9, a7, true), s9[a7] && s9[a7] !== `
` && s9[a7] !== "\r") throw new T8("each key-value declaration must be followed by an end-of-line", { toml: s9, ptr: a7 });
    a7 = B9(s9, a7);
  }
  return n23;
}
function je6(s9) {
  let e5 = typeof s9;
  if (e5 === "object") {
    if (Array.isArray(s9)) return "array";
    if (s9 instanceof Date) return "date";
  }
  return e5;
}
function Yl(s9) {
  for (let e5 = 0; e5 < s9.length; e5++) if (je6(s9[e5]) !== "object") return false;
  return s9.length != 0;
}
function $s(s9) {
  return JSON.stringify(s9).replace(/\x7f/g, "\\u007f");
}
function _s(s9, e5, t6, n23) {
  if (t6 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  if (e5 === "number") return isNaN(s9) ? "nan" : s9 === 1 / 0 ? "inf" : s9 === -1 / 0 ? "-inf" : n23 && Number.isInteger(s9) ? s9.toFixed(1) : s9.toString();
  if (e5 === "bigint" || e5 === "boolean") return s9.toString();
  if (e5 === "string") return $s(s9);
  if (e5 === "date") {
    if (isNaN(s9.getTime())) throw new TypeError("cannot serialize invalid date");
    return s9.toISOString();
  }
  if (e5 === "object") return Ul(s9, t6, n23);
  if (e5 === "array") return Jl(s9, t6, n23);
}
function Ul(s9, e5, t6) {
  let n23 = Object.keys(s9);
  if (n23.length === 0) return "{}";
  let i10 = "{ ";
  for (let r8 = 0; r8 < n23.length; r8++) {
    let o9 = n23[r8];
    r8 && (i10 += ", "), i10 += Hi.test(o9) ? o9 : $s(o9), i10 += " = ", i10 += _s(s9[o9], je6(s9[o9]), e5 - 1, t6);
  }
  return i10 + " }";
}
function Jl(s9, e5, t6) {
  if (s9.length === 0) return "[]";
  let n23 = "[ ";
  for (let i10 = 0; i10 < s9.length; i10++) {
    if (i10 && (n23 += ", "), s9[i10] === null || s9[i10] === void 0) throw new TypeError("arrays cannot contain null or undefined values");
    n23 += _s(s9[i10], je6(s9[i10]), e5 - 1, t6);
  }
  return n23 + " ]";
}
function Wl(s9, e5, t6, n23) {
  if (t6 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  let i10 = "";
  for (let r8 = 0; r8 < s9.length; r8++) i10 += `${i10 && `
`}[[${e5}]]
`, i10 += xs(0, s9[r8], e5, t6, n23);
  return i10;
}
function xs(s9, e5, t6, n23, i10) {
  if (n23 === 0) throw new Error("Could not stringify the object: maximum object depth exceeded");
  let r8 = "", o9 = "", a7 = Object.keys(e5);
  for (let l8 = 0; l8 < a7.length; l8++) {
    let c14 = a7[l8];
    if (e5[c14] !== null && e5[c14] !== void 0) {
      let u10 = je6(e5[c14]);
      if (u10 === "symbol" || u10 === "function") throw new TypeError(`cannot serialize values of type '${u10}'`);
      let f11 = Hi.test(c14) ? c14 : $s(c14);
      if (u10 === "array" && Yl(e5[c14])) o9 += (o9 && `
`) + Wl(e5[c14], t6 ? `${t6}.${f11}` : f11, n23 - 1, i10);
      else if (u10 === "object") {
        let d16 = t6 ? `${t6}.${f11}` : f11;
        o9 += (o9 && `
`) + xs(d16, e5[c14], d16, n23 - 1, i10);
      } else r8 += f11, r8 += " = ", r8 += _s(e5[c14], u10, n23, i10), r8 += `
`;
    }
  }
  return s9 && (r8 || !o9) && (r8 = r8 ? `[${s9}]
${r8}` : `[${s9}]`), r8 && o9 ? `${r8}
${o9}` : r8 || o9;
}
function Bs(s9, { maxDepth: e5 = 1e3, numbersAsFloat: t6 = false } = {}) {
  if (je6(s9) !== "object") throw new TypeError("stringify can only be called with an object");
  let n23 = xs(0, s9, "", e5, t6);
  return n23[n23.length - 1] !== `
` ? n23 + `
` : n23;
}
function Si(s9) {
  return typeof s9 == "string" && Eh.includes(s9);
}
function Ni(s9) {
  return typeof s9 == "string" && vh.includes(s9);
}
function Ah(s9) {
  let e5 = s9.lastIndexOf("."), t6 = Math.max(s9.lastIndexOf("/"), s9.lastIndexOf("\\"));
  return e5 <= t6 + 1 ? "" : s9.slice(e5);
}
function Ka(s9) {
  switch (Ah(s9).toLowerCase()) {
    case ".yaml":
    case ".yml":
      return "yaml";
    case ".json":
      return "json";
    case ".xml":
      return "xml";
    case ".ini":
      return "ini";
    case ".csv":
    case ".tsv":
      return "csv";
    case ".toml":
      return "toml";
    default:
      return null;
  }
}
function Th(s9, e5, t6) {
  return wi.default.parse(s9, { delimiter: e5 || void 0, header: t6, dynamicTyping: true, skipEmptyLines: true }).data;
}
function Oh(s9, e5) {
  return Array.isArray(s9) || (s9 = [s9]), wi.default.unparse(s9, { delimiter: e5 || "," });
}
function Ei(s9, e5) {
  let t6 = s9.trim();
  if (!t6) return null;
  switch (e5.inputFormat) {
    case "yaml":
      return yt3.default.parse(t6);
    case "json":
      return JSON.parse(t6);
    case "xml":
      return new be4({ ignoreAttributes: false, attributeNamePrefix: e5.xmlAttributePrefix, textNodeName: e5.xmlContentName, parseAttributeValue: false, parseTagValue: false, trimValues: true, tagValueProcessor: (i10, r8) => r8 === "" ? null : r8 }).parse(t6);
    case "ini":
      return vs.parse(t6);
    case "csv":
      return Th(t6, e5.csvDelimiter, e5.csvHeader);
    case "toml":
      return Ot4(t6);
    default: {
      let n23 = e5.inputFormat;
      throw new Error(`Invalid input format: ${n23}`);
    }
  }
}
function Ra(s9) {
  return yt3.default.parseAllDocuments(s9).map((t6) => t6.toJSON());
}
function Ya(s9) {
  let e5 = s9.trimStart();
  if (e5.startsWith("---")) {
    let t6 = e5.slice(3).match(/\n---(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e5.slice(3, t6.index + 3), i10 = e5.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: yt3.default.parse(n23), content: i10 };
    }
  }
  if (e5.startsWith("+++")) {
    let t6 = e5.slice(3).match(/\n\+\+\+(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e5.slice(3, t6.index + 3), i10 = e5.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: Ot4(n23), content: i10 };
    }
  }
  if (e5.startsWith("{{{")) {
    let t6 = e5.slice(3).match(/\n}}}(\n|$)/);
    if (t6 && t6.index !== void 0) {
      let n23 = e5.slice(3, t6.index + 3), i10 = e5.slice(t6.index + 3 + t6[0].length);
      return { frontMatter: JSON.parse(n23), content: i10 };
    }
  }
  return null;
}
function Ua(s9, e5) {
  if (s9 === void 0) return "";
  switch (e5.outputFormat) {
    case "yaml":
      return yt3.default.stringify(s9, { indent: e5.indent }).trimEnd();
    case "json":
      return e5.raw && typeof s9 == "string" ? s9 : e5.compact ? JSON.stringify(s9) : JSON.stringify(s9, null, e5.indent);
    case "xml":
      return new R7({ ignoreAttributes: false, attributeNamePrefix: e5.xmlAttributePrefix, textNodeName: e5.xmlContentName, format: e5.prettyPrint || !e5.compact, indentBy: " ".repeat(e5.indent) }).build(s9);
    case "ini":
      return !s9 || typeof s9 != "object" || Array.isArray(s9) ? "" : vs.stringify(s9);
    case "csv":
      return Oh(s9, e5.csvDelimiter);
    case "toml":
      return !s9 || typeof s9 != "object" || Array.isArray(s9) ? "" : Bs(s9);
    default:
      throw new Error(`Unknown output format: ${e5.outputFormat}`);
  }
}
function Ih(s9) {
  let e5 = { ...Va, exitStatus: false, slurp: false, nullInput: false, joinOutput: false, inplace: false, frontMatter: false }, t6 = false, n23 = ".", i10 = false, r8 = [];
  for (let o9 = 0; o9 < s9.length; o9++) {
    let a7 = s9[o9];
    if (a7.startsWith("--input-format=")) {
      let l8 = a7.slice(15);
      if (!Si(l8)) return r3("yq", `--input-format=${l8}`);
      e5.inputFormat = l8, t6 = true;
    } else if (a7.startsWith("--output-format=")) {
      let l8 = a7.slice(16);
      if (!Ni(l8)) return r3("yq", `--output-format=${l8}`);
      e5.outputFormat = l8;
    } else if (a7.startsWith("--indent=")) e5.indent = Number.parseInt(a7.slice(9), 10);
    else if (a7.startsWith("--xml-attribute-prefix=")) e5.xmlAttributePrefix = a7.slice(23);
    else if (a7.startsWith("--xml-content-name=")) e5.xmlContentName = a7.slice(19);
    else if (a7.startsWith("--csv-delimiter=")) e5.csvDelimiter = a7.slice(16);
    else if (a7 === "--csv-header") e5.csvHeader = true;
    else if (a7 === "--no-csv-header") e5.csvHeader = false;
    else if (a7 === "-p" || a7 === "--input-format") {
      let l8 = s9[++o9];
      if (!Si(l8)) return r3("yq", `${a7} ${l8}`);
      e5.inputFormat = l8, t6 = true;
    } else if (a7 === "-o" || a7 === "--output-format") {
      let l8 = s9[++o9];
      if (!Ni(l8)) return r3("yq", `${a7} ${l8}`);
      e5.outputFormat = l8;
    } else if (a7 === "-I" || a7 === "--indent") e5.indent = Number.parseInt(s9[++o9], 10);
    else if (a7 === "-r" || a7 === "--raw-output") e5.raw = true;
    else if (a7 === "-c" || a7 === "--compact") e5.compact = true;
    else if (a7 === "-e" || a7 === "--exit-status") e5.exitStatus = true;
    else if (a7 === "-s" || a7 === "--slurp") e5.slurp = true;
    else if (a7 === "-n" || a7 === "--null-input") e5.nullInput = true;
    else if (a7 === "-j" || a7 === "--join-output") e5.joinOutput = true;
    else if (a7 === "-i" || a7 === "--inplace") e5.inplace = true;
    else if (a7 === "-f" || a7 === "--front-matter") e5.frontMatter = true;
    else if (a7 === "-P" || a7 === "--prettyPrint") e5.prettyPrint = true;
    else if (a7 === "-") r8.push("-");
    else {
      if (a7.startsWith("--")) return r3("yq", a7);
      if (a7.startsWith("-")) for (let l8 of a7.slice(1)) if (l8 === "r") e5.raw = true;
      else if (l8 === "c") e5.compact = true;
      else if (l8 === "e") e5.exitStatus = true;
      else if (l8 === "s") e5.slurp = true;
      else if (l8 === "n") e5.nullInput = true;
      else if (l8 === "j") e5.joinOutput = true;
      else if (l8 === "i") e5.inplace = true;
      else if (l8 === "f") e5.frontMatter = true;
      else if (l8 === "P") e5.prettyPrint = true;
      else return r3("yq", `-${l8}`);
      else i10 ? r8.push(a7) : (n23 = a7, i10 = true);
    }
  }
  return { options: e5, filter: n23, files: r8, inputFormatExplicit: t6 };
}
var Yi, O13, Ve4, Ks, Lt3, Rs, D14, Pt2, Ue4, C16, Je5, _t3, We4, Sr, Qe5, He5, Tr2, en2, Ut2, nn2, te7, on2, ne6, Ae5, ie4, Te3, et6, zt2, fn, Oe3, dn, pn, Hr2, Zr2, bn2, rs, En, co, fo, ho, kn, qn, bo, Io, Bn, Lo, at5, ft4, ut4, ms, Jn, Wn, Yo, Jo, qe4, Ho, zo, Dn, Zn, ia, oa, ca, da, ni, ba, Sa, Aa, ws, hi2, mi, yi, Ba, ja, ki, Wa, Ga, Xa, ye5, Qa, Ha, Da, Za, il, $i, St3, V10, $e4, x20, rl, ol, al, ll, xe7, ml, yl, wl, qs, be4, ql, vs, wi, T8, xl, Be4, Bl, Fl, jl, Vl, Ji, Rl, Hi, yt3, Eh, vh, Va, kh, ig, rg;
var init_chunk_XMDVFEVC = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js"() {
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    Yi = o((rp, Ri) => {
      var { hasOwnProperty: Ps } = Object.prototype, Ms = (s9, e5 = {}) => {
        typeof e5 == "string" && (e5 = { section: e5 }), e5.align = e5.align === true, e5.newline = e5.newline === true, e5.sort = e5.sort === true, e5.whitespace = e5.whitespace === true || e5.align === true, e5.platform = e5.platform || typeof process < "u" && process.platform, e5.bracketedArray = e5.bracketedArray !== false;
        let t6 = e5.platform === "win32" ? `\r
` : `
`, n23 = e5.whitespace ? " = " : "=", i10 = [], r8 = e5.sort ? Object.keys(s9).sort() : Object.keys(s9), o9 = 0;
        e5.align && (o9 = G8(r8.filter((c14) => s9[c14] === null || Array.isArray(s9[c14]) || typeof s9[c14] != "object").map((c14) => Array.isArray(s9[c14]) ? `${c14}[]` : c14).concat([""]).reduce((c14, u10) => G8(c14).length >= G8(u10).length ? c14 : u10)).length);
        let a7 = "", l8 = e5.bracketedArray ? "[]" : "";
        for (let c14 of r8) {
          let u10 = s9[c14];
          if (u10 && Array.isArray(u10)) for (let f11 of u10) a7 += G8(`${c14}${l8}`).padEnd(o9, " ") + n23 + G8(f11) + t6;
          else u10 && typeof u10 == "object" ? i10.push(c14) : a7 += G8(c14).padEnd(o9, " ") + n23 + G8(u10) + t6;
        }
        e5.section && a7.length && (a7 = "[" + G8(e5.section) + "]" + (e5.newline ? t6 + t6 : t6) + a7);
        for (let c14 of i10) {
          let u10 = Vi2(c14, ".").join("\\."), f11 = (e5.section ? e5.section + "." : "") + u10, d16 = Ms(s9[c14], { ...e5, section: f11 });
          a7.length && d16.length && (a7 += t6), a7 += d16;
        }
        return a7;
      };
      function Vi2(s9, e5) {
        var t6 = 0, n23 = 0, i10 = 0, r8 = [];
        do
          if (i10 = s9.indexOf(e5, t6), i10 !== -1) {
            if (t6 = i10 + e5.length, i10 > 0 && s9[i10 - 1] === "\\") continue;
            r8.push(s9.slice(n23, i10)), n23 = i10 + e5.length;
          }
        while (i10 !== -1);
        return r8.push(s9.slice(n23)), r8;
      }
      var ji = (s9, e5 = {}) => {
        e5.bracketedArray = e5.bracketedArray !== false;
        let t6 = /* @__PURE__ */ Object.create(null), n23 = t6, i10 = null, r8 = /^\[([^\]]*)\]\s*$|^([^=]+)(=(.*))?$/i, o9 = s9.split(/[\r\n]+/g), a7 = {};
        for (let c14 of o9) {
          if (!c14 || c14.match(/^\s*[;#]/) || c14.match(/^\s*$/)) continue;
          let u10 = c14.match(r8);
          if (!u10) continue;
          if (u10[1] !== void 0) {
            if (i10 = Nt4(u10[1]), i10 === "__proto__") {
              n23 = /* @__PURE__ */ Object.create(null);
              continue;
            }
            n23 = t6[i10] = t6[i10] || /* @__PURE__ */ Object.create(null);
            continue;
          }
          let f11 = Nt4(u10[2]), d16;
          e5.bracketedArray ? d16 = f11.length > 2 && f11.slice(-2) === "[]" : (a7[f11] = (a7?.[f11] || 0) + 1, d16 = a7[f11] > 1);
          let p17 = d16 && f11.endsWith("[]") ? f11.slice(0, -2) : f11;
          if (p17 === "__proto__") continue;
          let g18 = u10[3] ? Nt4(u10[4]) : true, h16 = g18 === "true" || g18 === "false" || g18 === "null" ? JSON.parse(g18) : g18;
          d16 && (Ps.call(n23, p17) ? Array.isArray(n23[p17]) || (n23[p17] = [n23[p17]]) : n23[p17] = []), Array.isArray(n23[p17]) ? n23[p17].push(h16) : n23[p17] = h16;
        }
        let l8 = [];
        for (let c14 of Object.keys(t6)) {
          if (!Ps.call(t6, c14) || typeof t6[c14] != "object" || Array.isArray(t6[c14])) continue;
          let u10 = Vi2(c14, ".");
          n23 = t6;
          let f11 = u10.pop(), d16 = f11.replace(/\\\./g, ".");
          for (let p17 of u10) p17 !== "__proto__" && ((!Ps.call(n23, p17) || typeof n23[p17] != "object") && (n23[p17] = /* @__PURE__ */ Object.create(null)), n23 = n23[p17]);
          n23 === t6 && d16 === f11 || (n23[d16] = t6[c14], l8.push(c14));
        }
        for (let c14 of l8) delete t6[c14];
        return t6;
      }, Ki = (s9) => s9.startsWith('"') && s9.endsWith('"') || s9.startsWith("'") && s9.endsWith("'"), G8 = (s9) => typeof s9 != "string" || s9.match(/[=\r\n]/) || s9.match(/^\[/) || s9.length > 1 && Ki(s9) || s9 !== s9.trim() ? JSON.stringify(s9) : s9.split(";").join("\\;").split("#").join("\\#"), Nt4 = (s9) => {
        if (s9 = (s9 || "").trim(), Ki(s9)) {
          s9.charAt(0) === "'" && (s9 = s9.slice(1, -1));
          try {
            s9 = JSON.parse(s9);
          } catch {
          }
        } else {
          let e5 = false, t6 = "";
          for (let n23 = 0, i10 = s9.length; n23 < i10; n23++) {
            let r8 = s9.charAt(n23);
            if (e5) "\\;#".indexOf(r8) !== -1 ? t6 += r8 : t6 += "\\" + r8, e5 = false;
            else {
              if (";#".indexOf(r8) !== -1) break;
              r8 === "\\" ? e5 = true : t6 += r8;
            }
          }
          return e5 && (t6 += "\\"), t6.trim();
        }
        return s9;
      };
      Ri.exports = { parse: ji, decode: ji, stringify: Ms, encode: Ms, safe: G8, unsafe: Nt4 };
    });
    O13 = o(($17) => {
      "use strict";
      var Fs = Symbol.for("yaml.alias"), Di2 = Symbol.for("yaml.document"), kt4 = Symbol.for("yaml.map"), zi = Symbol.for("yaml.pair"), js = Symbol.for("yaml.scalar"), It3 = Symbol.for("yaml.seq"), X10 = Symbol.for("yaml.node.type"), Xl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === Fs, Ql = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === Di2, Hl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === kt4, Dl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === zi, Zi = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === js, zl = (s9) => !!s9 && typeof s9 == "object" && s9[X10] === It3;
      function er(s9) {
        if (s9 && typeof s9 == "object") switch (s9[X10]) {
          case kt4:
          case It3:
            return true;
        }
        return false;
      }
      function Zl(s9) {
        if (s9 && typeof s9 == "object") switch (s9[X10]) {
          case Fs:
          case kt4:
          case js:
          case It3:
            return true;
        }
        return false;
      }
      var ec = (s9) => (Zi(s9) || er(s9)) && !!s9.anchor;
      $17.ALIAS = Fs;
      $17.DOC = Di2;
      $17.MAP = kt4;
      $17.NODE_TYPE = X10;
      $17.PAIR = zi;
      $17.SCALAR = js;
      $17.SEQ = It3;
      $17.hasAnchor = ec;
      $17.isAlias = Xl;
      $17.isCollection = er;
      $17.isDocument = Ql;
      $17.isMap = Hl;
      $17.isNode = Zl;
      $17.isPair = Dl;
      $17.isScalar = Zi;
      $17.isSeq = zl;
    });
    Ve4 = o((Vs) => {
      "use strict";
      var M14 = O13(), F20 = Symbol("break visit"), tr = Symbol("skip children"), J13 = Symbol("remove node");
      function qt3(s9, e5) {
        let t6 = sr(e5);
        M14.isDocument(s9) ? Se6(null, s9.contents, t6, Object.freeze([s9])) === J13 && (s9.contents = null) : Se6(null, s9, t6, Object.freeze([]));
      }
      qt3.BREAK = F20;
      qt3.SKIP = tr;
      qt3.REMOVE = J13;
      function Se6(s9, e5, t6, n23) {
        let i10 = nr(s9, e5, t6, n23);
        if (M14.isNode(i10) || M14.isPair(i10)) return ir(s9, n23, i10), Se6(s9, i10, t6, n23);
        if (typeof i10 != "symbol") {
          if (M14.isCollection(e5)) {
            n23 = Object.freeze(n23.concat(e5));
            for (let r8 = 0; r8 < e5.items.length; ++r8) {
              let o9 = Se6(r8, e5.items[r8], t6, n23);
              if (typeof o9 == "number") r8 = o9 - 1;
              else {
                if (o9 === F20) return F20;
                o9 === J13 && (e5.items.splice(r8, 1), r8 -= 1);
              }
            }
          } else if (M14.isPair(e5)) {
            n23 = Object.freeze(n23.concat(e5));
            let r8 = Se6("key", e5.key, t6, n23);
            if (r8 === F20) return F20;
            r8 === J13 && (e5.key = null);
            let o9 = Se6("value", e5.value, t6, n23);
            if (o9 === F20) return F20;
            o9 === J13 && (e5.value = null);
          }
        }
        return i10;
      }
      async function Ct5(s9, e5) {
        let t6 = sr(e5);
        M14.isDocument(s9) ? await Ne6(null, s9.contents, t6, Object.freeze([s9])) === J13 && (s9.contents = null) : await Ne6(null, s9, t6, Object.freeze([]));
      }
      Ct5.BREAK = F20;
      Ct5.SKIP = tr;
      Ct5.REMOVE = J13;
      async function Ne6(s9, e5, t6, n23) {
        let i10 = await nr(s9, e5, t6, n23);
        if (M14.isNode(i10) || M14.isPair(i10)) return ir(s9, n23, i10), Ne6(s9, i10, t6, n23);
        if (typeof i10 != "symbol") {
          if (M14.isCollection(e5)) {
            n23 = Object.freeze(n23.concat(e5));
            for (let r8 = 0; r8 < e5.items.length; ++r8) {
              let o9 = await Ne6(r8, e5.items[r8], t6, n23);
              if (typeof o9 == "number") r8 = o9 - 1;
              else {
                if (o9 === F20) return F20;
                o9 === J13 && (e5.items.splice(r8, 1), r8 -= 1);
              }
            }
          } else if (M14.isPair(e5)) {
            n23 = Object.freeze(n23.concat(e5));
            let r8 = await Ne6("key", e5.key, t6, n23);
            if (r8 === F20) return F20;
            r8 === J13 && (e5.key = null);
            let o9 = await Ne6("value", e5.value, t6, n23);
            if (o9 === F20) return F20;
            o9 === J13 && (e5.value = null);
          }
        }
        return i10;
      }
      function sr(s9) {
        return typeof s9 == "object" && (s9.Collection || s9.Node || s9.Value) ? Object.assign({ Alias: s9.Node, Map: s9.Node, Scalar: s9.Node, Seq: s9.Node }, s9.Value && { Map: s9.Value, Scalar: s9.Value, Seq: s9.Value }, s9.Collection && { Map: s9.Collection, Seq: s9.Collection }, s9) : s9;
      }
      function nr(s9, e5, t6, n23) {
        if (typeof t6 == "function") return t6(s9, e5, n23);
        if (M14.isMap(e5)) return t6.Map?.(s9, e5, n23);
        if (M14.isSeq(e5)) return t6.Seq?.(s9, e5, n23);
        if (M14.isPair(e5)) return t6.Pair?.(s9, e5, n23);
        if (M14.isScalar(e5)) return t6.Scalar?.(s9, e5, n23);
        if (M14.isAlias(e5)) return t6.Alias?.(s9, e5, n23);
      }
      function ir(s9, e5, t6) {
        let n23 = e5[e5.length - 1];
        if (M14.isCollection(n23)) n23.items[s9] = t6;
        else if (M14.isPair(n23)) s9 === "key" ? n23.key = t6 : n23.value = t6;
        else if (M14.isDocument(n23)) n23.contents = t6;
        else {
          let i10 = M14.isAlias(n23) ? "alias" : "scalar";
          throw new Error(`Cannot replace node with ${i10} parent`);
        }
      }
      Vs.visit = qt3;
      Vs.visitAsync = Ct5;
    });
    Ks = o((or) => {
      "use strict";
      var rr = O13(), tc = Ve4(), sc = { "!": "%21", ",": "%2C", "[": "%5B", "]": "%5D", "{": "%7B", "}": "%7D" }, nc = (s9) => s9.replace(/[!,[\]{}]/g, (e5) => sc[e5]), Ke6 = class s9 {
        constructor(e5, t6) {
          this.docStart = null, this.docEnd = false, this.yaml = Object.assign({}, s9.defaultYaml, e5), this.tags = Object.assign({}, s9.defaultTags, t6);
        }
        clone() {
          let e5 = new s9(this.yaml, this.tags);
          return e5.docStart = this.docStart, e5;
        }
        atDocument() {
          let e5 = new s9(this.yaml, this.tags);
          switch (this.yaml.version) {
            case "1.1":
              this.atNextDocument = true;
              break;
            case "1.2":
              this.atNextDocument = false, this.yaml = { explicit: s9.defaultYaml.explicit, version: "1.2" }, this.tags = Object.assign({}, s9.defaultTags);
              break;
          }
          return e5;
        }
        add(e5, t6) {
          this.atNextDocument && (this.yaml = { explicit: s9.defaultYaml.explicit, version: "1.1" }, this.tags = Object.assign({}, s9.defaultTags), this.atNextDocument = false);
          let n23 = e5.trim().split(/[ \t]+/), i10 = n23.shift();
          switch (i10) {
            case "%TAG": {
              if (n23.length !== 2 && (t6(0, "%TAG directive should contain exactly two parts"), n23.length < 2)) return false;
              let [r8, o9] = n23;
              return this.tags[r8] = o9, true;
            }
            case "%YAML": {
              if (this.yaml.explicit = true, n23.length !== 1) return t6(0, "%YAML directive should contain exactly one part"), false;
              let [r8] = n23;
              if (r8 === "1.1" || r8 === "1.2") return this.yaml.version = r8, true;
              {
                let o9 = /^\d+\.\d+$/.test(r8);
                return t6(6, `Unsupported YAML version ${r8}`, o9), false;
              }
            }
            default:
              return t6(0, `Unknown directive ${i10}`, true), false;
          }
        }
        tagName(e5, t6) {
          if (e5 === "!") return "!";
          if (e5[0] !== "!") return t6(`Not a valid tag: ${e5}`), null;
          if (e5[1] === "<") {
            let o9 = e5.slice(2, -1);
            return o9 === "!" || o9 === "!!" ? (t6(`Verbatim tags aren't resolved, so ${e5} is invalid.`), null) : (e5[e5.length - 1] !== ">" && t6("Verbatim tags must end with a >"), o9);
          }
          let [, n23, i10] = e5.match(/^(.*!)([^!]*)$/s);
          i10 || t6(`The ${e5} tag has no suffix`);
          let r8 = this.tags[n23];
          if (r8) try {
            return r8 + decodeURIComponent(i10);
          } catch (o9) {
            return t6(String(o9)), null;
          }
          return n23 === "!" ? e5 : (t6(`Could not resolve tag: ${e5}`), null);
        }
        tagString(e5) {
          for (let [t6, n23] of Object.entries(this.tags)) if (e5.startsWith(n23)) return t6 + nc(e5.substring(n23.length));
          return e5[0] === "!" ? e5 : `!<${e5}>`;
        }
        toString(e5) {
          let t6 = this.yaml.explicit ? [`%YAML ${this.yaml.version || "1.2"}`] : [], n23 = Object.entries(this.tags), i10;
          if (e5 && n23.length > 0 && rr.isNode(e5.contents)) {
            let r8 = {};
            tc.visit(e5.contents, (o9, a7) => {
              rr.isNode(a7) && a7.tag && (r8[a7.tag] = true);
            }), i10 = Object.keys(r8);
          } else i10 = [];
          for (let [r8, o9] of n23) r8 === "!!" && o9 === "tag:yaml.org,2002:" || (!e5 || i10.some((a7) => a7.startsWith(o9))) && t6.push(`%TAG ${r8} ${o9}`);
          return t6.join(`
`);
        }
      };
      Ke6.defaultYaml = { explicit: false, version: "1.2" };
      Ke6.defaultTags = { "!!": "tag:yaml.org,2002:" };
      or.Directives = Ke6;
    });
    Lt3 = o((Re7) => {
      "use strict";
      var ar = O13(), ic = Ve4();
      function rc(s9) {
        if (/[\x00-\x19\s,[\]{}]/.test(s9)) {
          let t6 = `Anchor must not contain whitespace or control characters: ${JSON.stringify(s9)}`;
          throw new Error(t6);
        }
        return true;
      }
      function lr(s9) {
        let e5 = /* @__PURE__ */ new Set();
        return ic.visit(s9, { Value(t6, n23) {
          n23.anchor && e5.add(n23.anchor);
        } }), e5;
      }
      function cr(s9, e5) {
        for (let t6 = 1; ; ++t6) {
          let n23 = `${s9}${t6}`;
          if (!e5.has(n23)) return n23;
        }
      }
      function oc(s9, e5) {
        let t6 = [], n23 = /* @__PURE__ */ new Map(), i10 = null;
        return { onAnchor: (r8) => {
          t6.push(r8), i10 ?? (i10 = lr(s9));
          let o9 = cr(e5, i10);
          return i10.add(o9), o9;
        }, setAnchors: () => {
          for (let r8 of t6) {
            let o9 = n23.get(r8);
            if (typeof o9 == "object" && o9.anchor && (ar.isScalar(o9.node) || ar.isCollection(o9.node))) o9.node.anchor = o9.anchor;
            else {
              let a7 = new Error("Failed to resolve repeated object (this should not happen)");
              throw a7.source = r8, a7;
            }
          }
        }, sourceObjects: n23 };
      }
      Re7.anchorIsValid = rc;
      Re7.anchorNames = lr;
      Re7.createNodeAnchors = oc;
      Re7.findNewAnchor = cr;
    });
    Rs = o((fr) => {
      "use strict";
      function Ye6(s9, e5, t6, n23) {
        if (n23 && typeof n23 == "object") if (Array.isArray(n23)) for (let i10 = 0, r8 = n23.length; i10 < r8; ++i10) {
          let o9 = n23[i10], a7 = Ye6(s9, n23, String(i10), o9);
          a7 === void 0 ? delete n23[i10] : a7 !== o9 && (n23[i10] = a7);
        }
        else if (n23 instanceof Map) for (let i10 of Array.from(n23.keys())) {
          let r8 = n23.get(i10), o9 = Ye6(s9, n23, i10, r8);
          o9 === void 0 ? n23.delete(i10) : o9 !== r8 && n23.set(i10, o9);
        }
        else if (n23 instanceof Set) for (let i10 of Array.from(n23)) {
          let r8 = Ye6(s9, n23, i10, i10);
          r8 === void 0 ? n23.delete(i10) : r8 !== i10 && (n23.delete(i10), n23.add(r8));
        }
        else for (let [i10, r8] of Object.entries(n23)) {
          let o9 = Ye6(s9, n23, i10, r8);
          o9 === void 0 ? delete n23[i10] : o9 !== r8 && (n23[i10] = o9);
        }
        return s9.call(e5, t6, n23);
      }
      fr.applyReviver = Ye6;
    });
    D14 = o((dr2) => {
      "use strict";
      var ac = O13();
      function ur2(s9, e5, t6) {
        if (Array.isArray(s9)) return s9.map((n23, i10) => ur2(n23, String(i10), t6));
        if (s9 && typeof s9.toJSON == "function") {
          if (!t6 || !ac.hasAnchor(s9)) return s9.toJSON(e5, t6);
          let n23 = { aliasCount: 0, count: 1, res: void 0 };
          t6.anchors.set(s9, n23), t6.onCreate = (r8) => {
            n23.res = r8, delete t6.onCreate;
          };
          let i10 = s9.toJSON(e5, t6);
          return t6.onCreate && t6.onCreate(i10), i10;
        }
        return typeof s9 == "bigint" && !t6?.keep ? Number(s9) : s9;
      }
      dr2.toJS = ur2;
    });
    Pt2 = o((pr) => {
      "use strict";
      var lc = Rs(), hr = O13(), cc = D14(), Ys = class {
        constructor(e5) {
          Object.defineProperty(this, hr.NODE_TYPE, { value: e5 });
        }
        clone() {
          let e5 = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
          return this.range && (e5.range = this.range.slice()), e5;
        }
        toJS(e5, { mapAsMap: t6, maxAliasCount: n23, onAnchor: i10, reviver: r8 } = {}) {
          if (!hr.isDocument(e5)) throw new TypeError("A document argument is required");
          let o9 = { anchors: /* @__PURE__ */ new Map(), doc: e5, keep: true, mapAsMap: t6 === true, mapKeyWarned: false, maxAliasCount: typeof n23 == "number" ? n23 : 100 }, a7 = cc.toJS(this, "", o9);
          if (typeof i10 == "function") for (let { count: l8, res: c14 } of o9.anchors.values()) i10(c14, l8);
          return typeof r8 == "function" ? lc.applyReviver(r8, { "": a7 }, "", a7) : a7;
        }
      };
      pr.NodeBase = Ys;
    });
    Ue4 = o((mr) => {
      "use strict";
      var fc = Lt3(), uc = Ve4(), Ee6 = O13(), dc = Pt2(), hc = D14(), Us = class extends dc.NodeBase {
        constructor(e5) {
          super(Ee6.ALIAS), this.source = e5, Object.defineProperty(this, "tag", { set() {
            throw new Error("Alias nodes cannot have tags");
          } });
        }
        resolve(e5, t6) {
          let n23;
          t6?.aliasResolveCache ? n23 = t6.aliasResolveCache : (n23 = [], uc.visit(e5, { Node: (r8, o9) => {
            (Ee6.isAlias(o9) || Ee6.hasAnchor(o9)) && n23.push(o9);
          } }), t6 && (t6.aliasResolveCache = n23));
          let i10;
          for (let r8 of n23) {
            if (r8 === this) break;
            r8.anchor === this.source && (i10 = r8);
          }
          return i10;
        }
        toJSON(e5, t6) {
          if (!t6) return { source: this.source };
          let { anchors: n23, doc: i10, maxAliasCount: r8 } = t6, o9 = this.resolve(i10, t6);
          if (!o9) {
            let l8 = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
            throw new ReferenceError(l8);
          }
          let a7 = n23.get(o9);
          if (a7 || (hc.toJS(o9, null, t6), a7 = n23.get(o9)), a7?.res === void 0) {
            let l8 = "This should not happen: Alias anchor was not resolved?";
            throw new ReferenceError(l8);
          }
          if (r8 >= 0 && (a7.count += 1, a7.aliasCount === 0 && (a7.aliasCount = Mt3(i10, o9, n23)), a7.count * a7.aliasCount > r8)) {
            let l8 = "Excessive alias count indicates a resource exhaustion attack";
            throw new ReferenceError(l8);
          }
          return a7.res;
        }
        toString(e5, t6, n23) {
          let i10 = `*${this.source}`;
          if (e5) {
            if (fc.anchorIsValid(this.source), e5.options.verifyAliasOrder && !e5.anchors.has(this.source)) {
              let r8 = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
              throw new Error(r8);
            }
            if (e5.implicitKey) return `${i10} `;
          }
          return i10;
        }
      };
      function Mt3(s9, e5, t6) {
        if (Ee6.isAlias(e5)) {
          let n23 = e5.resolve(s9), i10 = t6 && n23 && t6.get(n23);
          return i10 ? i10.count * i10.aliasCount : 0;
        } else if (Ee6.isCollection(e5)) {
          let n23 = 0;
          for (let i10 of e5.items) {
            let r8 = Mt3(s9, i10, t6);
            r8 > n23 && (n23 = r8);
          }
          return n23;
        } else if (Ee6.isPair(e5)) {
          let n23 = Mt3(s9, e5.key, t6), i10 = Mt3(s9, e5.value, t6);
          return Math.max(n23, i10);
        }
        return 1;
      }
      mr.Alias = Us;
    });
    C16 = o((Js) => {
      "use strict";
      var pc = O13(), mc = Pt2(), gc = D14(), yc = (s9) => !s9 || typeof s9 != "function" && typeof s9 != "object", z10 = class extends mc.NodeBase {
        constructor(e5) {
          super(pc.SCALAR), this.value = e5;
        }
        toJSON(e5, t6) {
          return t6?.keep ? this.value : gc.toJS(this.value, e5, t6);
        }
        toString() {
          return String(this.value);
        }
      };
      z10.BLOCK_FOLDED = "BLOCK_FOLDED";
      z10.BLOCK_LITERAL = "BLOCK_LITERAL";
      z10.PLAIN = "PLAIN";
      z10.QUOTE_DOUBLE = "QUOTE_DOUBLE";
      z10.QUOTE_SINGLE = "QUOTE_SINGLE";
      Js.Scalar = z10;
      Js.isScalarValue = yc;
    });
    Je5 = o((yr) => {
      "use strict";
      var bc = Ue4(), fe10 = O13(), gr = C16(), wc = "tag:yaml.org,2002:";
      function Sc(s9, e5, t6) {
        if (e5) {
          let n23 = t6.filter((r8) => r8.tag === e5), i10 = n23.find((r8) => !r8.format) ?? n23[0];
          if (!i10) throw new Error(`Tag ${e5} not found`);
          return i10;
        }
        return t6.find((n23) => n23.identify?.(s9) && !n23.format);
      }
      function Nc(s9, e5, t6) {
        if (fe10.isDocument(s9) && (s9 = s9.contents), fe10.isNode(s9)) return s9;
        if (fe10.isPair(s9)) {
          let f11 = t6.schema[fe10.MAP].createNode?.(t6.schema, null, t6);
          return f11.items.push(s9), f11;
        }
        (s9 instanceof String || s9 instanceof Number || s9 instanceof Boolean || typeof BigInt < "u" && s9 instanceof BigInt) && (s9 = s9.valueOf());
        let { aliasDuplicateObjects: n23, onAnchor: i10, onTagObj: r8, schema: o9, sourceObjects: a7 } = t6, l8;
        if (n23 && s9 && typeof s9 == "object") {
          if (l8 = a7.get(s9), l8) return l8.anchor ?? (l8.anchor = i10(s9)), new bc.Alias(l8.anchor);
          l8 = { anchor: null, node: null }, a7.set(s9, l8);
        }
        e5?.startsWith("!!") && (e5 = wc + e5.slice(2));
        let c14 = Sc(s9, e5, o9.tags);
        if (!c14) {
          if (s9 && typeof s9.toJSON == "function" && (s9 = s9.toJSON()), !s9 || typeof s9 != "object") {
            let f11 = new gr.Scalar(s9);
            return l8 && (l8.node = f11), f11;
          }
          c14 = s9 instanceof Map ? o9[fe10.MAP] : Symbol.iterator in Object(s9) ? o9[fe10.SEQ] : o9[fe10.MAP];
        }
        r8 && (r8(c14), delete t6.onTagObj);
        let u10 = c14?.createNode ? c14.createNode(t6.schema, s9, t6) : typeof c14?.nodeClass?.from == "function" ? c14.nodeClass.from(t6.schema, s9, t6) : new gr.Scalar(s9);
        return e5 ? u10.tag = e5 : c14.default || (u10.tag = c14.tag), l8 && (l8.node = u10), u10;
      }
      yr.createNode = Nc;
    });
    _t3 = o(($t3) => {
      "use strict";
      var Ec = Je5(), W14 = O13(), vc = Pt2();
      function Ws(s9, e5, t6) {
        let n23 = t6;
        for (let i10 = e5.length - 1; i10 >= 0; --i10) {
          let r8 = e5[i10];
          if (typeof r8 == "number" && Number.isInteger(r8) && r8 >= 0) {
            let o9 = [];
            o9[r8] = n23, n23 = o9;
          } else n23 = /* @__PURE__ */ new Map([[r8, n23]]);
        }
        return Ec.createNode(n23, void 0, { aliasDuplicateObjects: false, keepUndefined: false, onAnchor: () => {
          throw new Error("This should not happen, please report a bug.");
        }, schema: s9, sourceObjects: /* @__PURE__ */ new Map() });
      }
      var br = (s9) => s9 == null || typeof s9 == "object" && !!s9[Symbol.iterator]().next().done, Gs = class extends vc.NodeBase {
        constructor(e5, t6) {
          super(e5), Object.defineProperty(this, "schema", { value: t6, configurable: true, enumerable: false, writable: true });
        }
        clone(e5) {
          let t6 = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
          return e5 && (t6.schema = e5), t6.items = t6.items.map((n23) => W14.isNode(n23) || W14.isPair(n23) ? n23.clone(e5) : n23), this.range && (t6.range = this.range.slice()), t6;
        }
        addIn(e5, t6) {
          if (br(e5)) this.add(t6);
          else {
            let [n23, ...i10] = e5, r8 = this.get(n23, true);
            if (W14.isCollection(r8)) r8.addIn(i10, t6);
            else if (r8 === void 0 && this.schema) this.set(n23, Ws(this.schema, i10, t6));
            else throw new Error(`Expected YAML collection at ${n23}. Remaining path: ${i10}`);
          }
        }
        deleteIn(e5) {
          let [t6, ...n23] = e5;
          if (n23.length === 0) return this.delete(t6);
          let i10 = this.get(t6, true);
          if (W14.isCollection(i10)) return i10.deleteIn(n23);
          throw new Error(`Expected YAML collection at ${t6}. Remaining path: ${n23}`);
        }
        getIn(e5, t6) {
          let [n23, ...i10] = e5, r8 = this.get(n23, true);
          return i10.length === 0 ? !t6 && W14.isScalar(r8) ? r8.value : r8 : W14.isCollection(r8) ? r8.getIn(i10, t6) : void 0;
        }
        hasAllNullValues(e5) {
          return this.items.every((t6) => {
            if (!W14.isPair(t6)) return false;
            let n23 = t6.value;
            return n23 == null || e5 && W14.isScalar(n23) && n23.value == null && !n23.commentBefore && !n23.comment && !n23.tag;
          });
        }
        hasIn(e5) {
          let [t6, ...n23] = e5;
          if (n23.length === 0) return this.has(t6);
          let i10 = this.get(t6, true);
          return W14.isCollection(i10) ? i10.hasIn(n23) : false;
        }
        setIn(e5, t6) {
          let [n23, ...i10] = e5;
          if (i10.length === 0) this.set(n23, t6);
          else {
            let r8 = this.get(n23, true);
            if (W14.isCollection(r8)) r8.setIn(i10, t6);
            else if (r8 === void 0 && this.schema) this.set(n23, Ws(this.schema, i10, t6));
            else throw new Error(`Expected YAML collection at ${n23}. Remaining path: ${i10}`);
          }
        }
      };
      $t3.Collection = Gs;
      $t3.collectionFromPath = Ws;
      $t3.isEmptyPath = br;
    });
    We4 = o((xt3) => {
      "use strict";
      var Ac = (s9) => s9.replace(/^(?!$)(?: $)?/gm, "#");
      function Xs(s9, e5) {
        return /^\n+$/.test(s9) ? s9.substring(1) : e5 ? s9.replace(/^(?! *$)/gm, e5) : s9;
      }
      var Tc = (s9, e5, t6) => s9.endsWith(`
`) ? Xs(t6, e5) : t6.includes(`
`) ? `
` + Xs(t6, e5) : (s9.endsWith(" ") ? "" : " ") + t6;
      xt3.indentComment = Xs;
      xt3.lineComment = Tc;
      xt3.stringifyComment = Ac;
    });
    Sr = o((Ge6) => {
      "use strict";
      var Oc = "flow", Qs = "block", Bt2 = "quoted";
      function kc(s9, e5, t6 = "flow", { indentAtStart: n23, lineWidth: i10 = 80, minContentWidth: r8 = 20, onFold: o9, onOverflow: a7 } = {}) {
        if (!i10 || i10 < 0) return s9;
        i10 < r8 && (r8 = 0);
        let l8 = Math.max(1 + r8, 1 + i10 - e5.length);
        if (s9.length <= l8) return s9;
        let c14 = [], u10 = {}, f11 = i10 - e5.length;
        typeof n23 == "number" && (n23 > i10 - Math.max(2, r8) ? c14.push(0) : f11 = i10 - n23);
        let d16, p17, g18 = false, h16 = -1, m24 = -1, y18 = -1;
        t6 === Qs && (h16 = wr2(s9, h16, e5.length), h16 !== -1 && (f11 = h16 + l8));
        for (let N14; N14 = s9[h16 += 1]; ) {
          if (t6 === Bt2 && N14 === "\\") {
            switch (m24 = h16, s9[h16 + 1]) {
              case "x":
                h16 += 3;
                break;
              case "u":
                h16 += 5;
                break;
              case "U":
                h16 += 9;
                break;
              default:
                h16 += 1;
            }
            y18 = h16;
          }
          if (N14 === `
`) t6 === Qs && (h16 = wr2(s9, h16, e5.length)), f11 = h16 + e5.length + l8, d16 = void 0;
          else {
            if (N14 === " " && p17 && p17 !== " " && p17 !== `
` && p17 !== "	") {
              let E12 = s9[h16 + 1];
              E12 && E12 !== " " && E12 !== `
` && E12 !== "	" && (d16 = h16);
            }
            if (h16 >= f11) if (d16) c14.push(d16), f11 = d16 + l8, d16 = void 0;
            else if (t6 === Bt2) {
              for (; p17 === " " || p17 === "	"; ) p17 = N14, N14 = s9[h16 += 1], g18 = true;
              let E12 = h16 > y18 + 1 ? h16 - 2 : m24 - 1;
              if (u10[E12]) return s9;
              c14.push(E12), u10[E12] = true, f11 = E12 + l8, d16 = void 0;
            } else g18 = true;
          }
          p17 = N14;
        }
        if (g18 && a7 && a7(), c14.length === 0) return s9;
        o9 && o9();
        let S16 = s9.slice(0, c14[0]);
        for (let N14 = 0; N14 < c14.length; ++N14) {
          let E12 = c14[N14], v20 = c14[N14 + 1] || s9.length;
          E12 === 0 ? S16 = `
${e5}${s9.slice(0, v20)}` : (t6 === Bt2 && u10[E12] && (S16 += `${s9[E12]}\\`), S16 += `
${e5}${s9.slice(E12 + 1, v20)}`);
        }
        return S16;
      }
      function wr2(s9, e5, t6) {
        let n23 = e5, i10 = e5 + 1, r8 = s9[i10];
        for (; r8 === " " || r8 === "	"; ) if (e5 < i10 + t6) r8 = s9[++e5];
        else {
          do
            r8 = s9[++e5];
          while (r8 && r8 !== `
`);
          n23 = e5, i10 = e5 + 1, r8 = s9[i10];
        }
        return n23;
      }
      Ge6.FOLD_BLOCK = Qs;
      Ge6.FOLD_FLOW = Oc;
      Ge6.FOLD_QUOTED = Bt2;
      Ge6.foldFlowLines = kc;
    });
    Qe5 = o((Nr2) => {
      "use strict";
      var Y10 = C16(), Z12 = Sr(), jt3 = (s9, e5) => ({ indentAtStart: e5 ? s9.indent.length : s9.indentAtStart, lineWidth: s9.options.lineWidth, minContentWidth: s9.options.minContentWidth }), Vt2 = (s9) => /^(%|---|\.\.\.)/m.test(s9);
      function Ic(s9, e5, t6) {
        if (!e5 || e5 < 0) return false;
        let n23 = e5 - t6, i10 = s9.length;
        if (i10 <= n23) return false;
        for (let r8 = 0, o9 = 0; r8 < i10; ++r8) if (s9[r8] === `
`) {
          if (r8 - o9 > n23) return true;
          if (o9 = r8 + 1, i10 - o9 <= n23) return false;
        }
        return true;
      }
      function Xe6(s9, e5) {
        let t6 = JSON.stringify(s9);
        if (e5.options.doubleQuotedAsJSON) return t6;
        let { implicitKey: n23 } = e5, i10 = e5.options.doubleQuotedMinMultiLineLength, r8 = e5.indent || (Vt2(s9) ? "  " : ""), o9 = "", a7 = 0;
        for (let l8 = 0, c14 = t6[l8]; c14; c14 = t6[++l8]) if (c14 === " " && t6[l8 + 1] === "\\" && t6[l8 + 2] === "n" && (o9 += t6.slice(a7, l8) + "\\ ", l8 += 1, a7 = l8, c14 = "\\"), c14 === "\\") switch (t6[l8 + 1]) {
          case "u":
            {
              o9 += t6.slice(a7, l8);
              let u10 = t6.substr(l8 + 2, 4);
              switch (u10) {
                case "0000":
                  o9 += "\\0";
                  break;
                case "0007":
                  o9 += "\\a";
                  break;
                case "000b":
                  o9 += "\\v";
                  break;
                case "001b":
                  o9 += "\\e";
                  break;
                case "0085":
                  o9 += "\\N";
                  break;
                case "00a0":
                  o9 += "\\_";
                  break;
                case "2028":
                  o9 += "\\L";
                  break;
                case "2029":
                  o9 += "\\P";
                  break;
                default:
                  u10.substr(0, 2) === "00" ? o9 += "\\x" + u10.substr(2) : o9 += t6.substr(l8, 6);
              }
              l8 += 5, a7 = l8 + 1;
            }
            break;
          case "n":
            if (n23 || t6[l8 + 2] === '"' || t6.length < i10) l8 += 1;
            else {
              for (o9 += t6.slice(a7, l8) + `

`; t6[l8 + 2] === "\\" && t6[l8 + 3] === "n" && t6[l8 + 4] !== '"'; ) o9 += `
`, l8 += 2;
              o9 += r8, t6[l8 + 2] === " " && (o9 += "\\"), l8 += 1, a7 = l8 + 1;
            }
            break;
          default:
            l8 += 1;
        }
        return o9 = a7 ? o9 + t6.slice(a7) : t6, n23 ? o9 : Z12.foldFlowLines(o9, r8, Z12.FOLD_QUOTED, jt3(e5, false));
      }
      function Hs(s9, e5) {
        if (e5.options.singleQuote === false || e5.implicitKey && s9.includes(`
`) || /[ \t]\n|\n[ \t]/.test(s9)) return Xe6(s9, e5);
        let t6 = e5.indent || (Vt2(s9) ? "  " : ""), n23 = "'" + s9.replace(/'/g, "''").replace(/\n+/g, `$&
${t6}`) + "'";
        return e5.implicitKey ? n23 : Z12.foldFlowLines(n23, t6, Z12.FOLD_FLOW, jt3(e5, false));
      }
      function ve7(s9, e5) {
        let { singleQuote: t6 } = e5.options, n23;
        if (t6 === false) n23 = Xe6;
        else {
          let i10 = s9.includes('"'), r8 = s9.includes("'");
          i10 && !r8 ? n23 = Hs : r8 && !i10 ? n23 = Xe6 : n23 = t6 ? Hs : Xe6;
        }
        return n23(s9, e5);
      }
      var Ds;
      try {
        Ds = new RegExp(`(^|(?<!
))
+(?!
|$)`, "g");
      } catch {
        Ds = /\n+(?!\n|$)/g;
      }
      function Ft3({ comment: s9, type: e5, value: t6 }, n23, i10, r8) {
        let { blockQuote: o9, commentString: a7, lineWidth: l8 } = n23.options;
        if (!o9 || /\n[\t ]+$/.test(t6)) return ve7(t6, n23);
        let c14 = n23.indent || (n23.forceBlockIndent || Vt2(t6) ? "  " : ""), u10 = o9 === "literal" ? true : o9 === "folded" || e5 === Y10.Scalar.BLOCK_FOLDED ? false : e5 === Y10.Scalar.BLOCK_LITERAL ? true : !Ic(t6, l8, c14.length);
        if (!t6) return u10 ? `|
` : `>
`;
        let f11, d16;
        for (d16 = t6.length; d16 > 0; --d16) {
          let v20 = t6[d16 - 1];
          if (v20 !== `
` && v20 !== "	" && v20 !== " ") break;
        }
        let p17 = t6.substring(d16), g18 = p17.indexOf(`
`);
        g18 === -1 ? f11 = "-" : t6 === p17 || g18 !== p17.length - 1 ? (f11 = "+", r8 && r8()) : f11 = "", p17 && (t6 = t6.slice(0, -p17.length), p17[p17.length - 1] === `
` && (p17 = p17.slice(0, -1)), p17 = p17.replace(Ds, `$&${c14}`));
        let h16 = false, m24, y18 = -1;
        for (m24 = 0; m24 < t6.length; ++m24) {
          let v20 = t6[m24];
          if (v20 === " ") h16 = true;
          else if (v20 === `
`) y18 = m24;
          else break;
        }
        let S16 = t6.substring(0, y18 < m24 ? y18 + 1 : m24);
        S16 && (t6 = t6.substring(S16.length), S16 = S16.replace(/\n+/g, `$&${c14}`));
        let E12 = (h16 ? c14 ? "2" : "1" : "") + f11;
        if (s9 && (E12 += " " + a7(s9.replace(/ ?[\r\n]+/g, " ")), i10 && i10()), !u10) {
          let v20 = t6.replace(/\n+/g, `
$&`).replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, "$1$2").replace(/\n+/g, `$&${c14}`), A13 = false, I17 = jt3(n23, true);
          o9 !== "folded" && e5 !== Y10.Scalar.BLOCK_FOLDED && (I17.onOverflow = () => {
            A13 = true;
          });
          let w19 = Z12.foldFlowLines(`${S16}${v20}${p17}`, c14, Z12.FOLD_BLOCK, I17);
          if (!A13) return `>${E12}
${c14}${w19}`;
        }
        return t6 = t6.replace(/\n+/g, `$&${c14}`), `|${E12}
${c14}${S16}${t6}${p17}`;
      }
      function qc(s9, e5, t6, n23) {
        let { type: i10, value: r8 } = s9, { actualString: o9, implicitKey: a7, indent: l8, indentStep: c14, inFlow: u10 } = e5;
        if (a7 && r8.includes(`
`) || u10 && /[[\]{},]/.test(r8)) return ve7(r8, e5);
        if (/^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(r8)) return a7 || u10 || !r8.includes(`
`) ? ve7(r8, e5) : Ft3(s9, e5, t6, n23);
        if (!a7 && !u10 && i10 !== Y10.Scalar.PLAIN && r8.includes(`
`)) return Ft3(s9, e5, t6, n23);
        if (Vt2(r8)) {
          if (l8 === "") return e5.forceBlockIndent = true, Ft3(s9, e5, t6, n23);
          if (a7 && l8 === c14) return ve7(r8, e5);
        }
        let f11 = r8.replace(/\n+/g, `$&
${l8}`);
        if (o9) {
          let d16 = (h16) => h16.default && h16.tag !== "tag:yaml.org,2002:str" && h16.test?.test(f11), { compat: p17, tags: g18 } = e5.doc.schema;
          if (g18.some(d16) || p17?.some(d16)) return ve7(r8, e5);
        }
        return a7 ? f11 : Z12.foldFlowLines(f11, l8, Z12.FOLD_FLOW, jt3(e5, false));
      }
      function Cc(s9, e5, t6, n23) {
        let { implicitKey: i10, inFlow: r8 } = e5, o9 = typeof s9.value == "string" ? s9 : Object.assign({}, s9, { value: String(s9.value) }), { type: a7 } = s9;
        a7 !== Y10.Scalar.QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f\u{D800}-\u{DFFF}]/u.test(o9.value) && (a7 = Y10.Scalar.QUOTE_DOUBLE);
        let l8 = (u10) => {
          switch (u10) {
            case Y10.Scalar.BLOCK_FOLDED:
            case Y10.Scalar.BLOCK_LITERAL:
              return i10 || r8 ? ve7(o9.value, e5) : Ft3(o9, e5, t6, n23);
            case Y10.Scalar.QUOTE_DOUBLE:
              return Xe6(o9.value, e5);
            case Y10.Scalar.QUOTE_SINGLE:
              return Hs(o9.value, e5);
            case Y10.Scalar.PLAIN:
              return qc(o9, e5, t6, n23);
            default:
              return null;
          }
        }, c14 = l8(a7);
        if (c14 === null) {
          let { defaultKeyType: u10, defaultStringType: f11 } = e5.options, d16 = i10 && u10 || f11;
          if (c14 = l8(d16), c14 === null) throw new Error(`Unsupported default string type ${d16}`);
        }
        return c14;
      }
      Nr2.stringifyString = Cc;
    });
    He5 = o((zs) => {
      "use strict";
      var Lc = Lt3(), ee7 = O13(), Pc = We4(), Mc = Qe5();
      function $c(s9, e5) {
        let t6 = Object.assign({ blockQuote: true, commentString: Pc.stringifyComment, defaultKeyType: null, defaultStringType: "PLAIN", directives: null, doubleQuotedAsJSON: false, doubleQuotedMinMultiLineLength: 40, falseStr: "false", flowCollectionPadding: true, indentSeq: true, lineWidth: 80, minContentWidth: 20, nullStr: "null", simpleKeys: false, singleQuote: null, trueStr: "true", verifyAliasOrder: true }, s9.schema.toStringOptions, e5), n23;
        switch (t6.collectionStyle) {
          case "block":
            n23 = false;
            break;
          case "flow":
            n23 = true;
            break;
          default:
            n23 = null;
        }
        return { anchors: /* @__PURE__ */ new Set(), doc: s9, flowCollectionPadding: t6.flowCollectionPadding ? " " : "", indent: "", indentStep: typeof t6.indent == "number" ? " ".repeat(t6.indent) : "  ", inFlow: n23, options: t6 };
      }
      function _c(s9, e5) {
        if (e5.tag) {
          let i10 = s9.filter((r8) => r8.tag === e5.tag);
          if (i10.length > 0) return i10.find((r8) => r8.format === e5.format) ?? i10[0];
        }
        let t6, n23;
        if (ee7.isScalar(e5)) {
          n23 = e5.value;
          let i10 = s9.filter((r8) => r8.identify?.(n23));
          if (i10.length > 1) {
            let r8 = i10.filter((o9) => o9.test);
            r8.length > 0 && (i10 = r8);
          }
          t6 = i10.find((r8) => r8.format === e5.format) ?? i10.find((r8) => !r8.format);
        } else n23 = e5, t6 = s9.find((i10) => i10.nodeClass && n23 instanceof i10.nodeClass);
        if (!t6) {
          let i10 = n23?.constructor?.name ?? (n23 === null ? "null" : typeof n23);
          throw new Error(`Tag not resolved for ${i10} value`);
        }
        return t6;
      }
      function xc(s9, e5, { anchors: t6, doc: n23 }) {
        if (!n23.directives) return "";
        let i10 = [], r8 = (ee7.isScalar(s9) || ee7.isCollection(s9)) && s9.anchor;
        r8 && Lc.anchorIsValid(r8) && (t6.add(r8), i10.push(`&${r8}`));
        let o9 = s9.tag ?? (e5.default ? null : e5.tag);
        return o9 && i10.push(n23.directives.tagString(o9)), i10.join(" ");
      }
      function Bc(s9, e5, t6, n23) {
        if (ee7.isPair(s9)) return s9.toString(e5, t6, n23);
        if (ee7.isAlias(s9)) {
          if (e5.doc.directives) return s9.toString(e5);
          if (e5.resolvedAliases?.has(s9)) throw new TypeError("Cannot stringify circular structure without alias nodes");
          e5.resolvedAliases ? e5.resolvedAliases.add(s9) : e5.resolvedAliases = /* @__PURE__ */ new Set([s9]), s9 = s9.resolve(e5.doc);
        }
        let i10, r8 = ee7.isNode(s9) ? s9 : e5.doc.createNode(s9, { onTagObj: (l8) => i10 = l8 });
        i10 ?? (i10 = _c(e5.doc.schema.tags, r8));
        let o9 = xc(r8, i10, e5);
        o9.length > 0 && (e5.indentAtStart = (e5.indentAtStart ?? 0) + o9.length + 1);
        let a7 = typeof i10.stringify == "function" ? i10.stringify(r8, e5, t6, n23) : ee7.isScalar(r8) ? Mc.stringifyString(r8, e5, t6, n23) : r8.toString(e5, t6, n23);
        return o9 ? ee7.isScalar(r8) || a7[0] === "{" || a7[0] === "[" ? `${o9} ${a7}` : `${o9}
${e5.indent}${a7}` : a7;
      }
      zs.createStringifyContext = $c;
      zs.stringify = Bc;
    });
    Tr2 = o((Ar) => {
      "use strict";
      var Q13 = O13(), Er = C16(), vr3 = He5(), De6 = We4();
      function Fc({ key: s9, value: e5 }, t6, n23, i10) {
        let { allNullValues: r8, doc: o9, indent: a7, indentStep: l8, options: { commentString: c14, indentSeq: u10, simpleKeys: f11 } } = t6, d16 = Q13.isNode(s9) && s9.comment || null;
        if (f11) {
          if (d16) throw new Error("With simple keys, key nodes cannot have comments");
          if (Q13.isCollection(s9) || !Q13.isNode(s9) && typeof s9 == "object") {
            let I17 = "With simple keys, collection cannot be used as a key value";
            throw new Error(I17);
          }
        }
        let p17 = !f11 && (!s9 || d16 && e5 == null && !t6.inFlow || Q13.isCollection(s9) || (Q13.isScalar(s9) ? s9.type === Er.Scalar.BLOCK_FOLDED || s9.type === Er.Scalar.BLOCK_LITERAL : typeof s9 == "object"));
        t6 = Object.assign({}, t6, { allNullValues: false, implicitKey: !p17 && (f11 || !r8), indent: a7 + l8 });
        let g18 = false, h16 = false, m24 = vr3.stringify(s9, t6, () => g18 = true, () => h16 = true);
        if (!p17 && !t6.inFlow && m24.length > 1024) {
          if (f11) throw new Error("With simple keys, single line scalar must not span more than 1024 characters");
          p17 = true;
        }
        if (t6.inFlow) {
          if (r8 || e5 == null) return g18 && n23 && n23(), m24 === "" ? "?" : p17 ? `? ${m24}` : m24;
        } else if (r8 && !f11 || e5 == null && p17) return m24 = `? ${m24}`, d16 && !g18 ? m24 += De6.lineComment(m24, t6.indent, c14(d16)) : h16 && i10 && i10(), m24;
        g18 && (d16 = null), p17 ? (d16 && (m24 += De6.lineComment(m24, t6.indent, c14(d16))), m24 = `? ${m24}
${a7}:`) : (m24 = `${m24}:`, d16 && (m24 += De6.lineComment(m24, t6.indent, c14(d16))));
        let y18, S16, N14;
        Q13.isNode(e5) ? (y18 = !!e5.spaceBefore, S16 = e5.commentBefore, N14 = e5.comment) : (y18 = false, S16 = null, N14 = null, e5 && typeof e5 == "object" && (e5 = o9.createNode(e5))), t6.implicitKey = false, !p17 && !d16 && Q13.isScalar(e5) && (t6.indentAtStart = m24.length + 1), h16 = false, !u10 && l8.length >= 2 && !t6.inFlow && !p17 && Q13.isSeq(e5) && !e5.flow && !e5.tag && !e5.anchor && (t6.indent = t6.indent.substring(2));
        let E12 = false, v20 = vr3.stringify(e5, t6, () => E12 = true, () => h16 = true), A13 = " ";
        if (d16 || y18 || S16) {
          if (A13 = y18 ? `
` : "", S16) {
            let I17 = c14(S16);
            A13 += `
${De6.indentComment(I17, t6.indent)}`;
          }
          v20 === "" && !t6.inFlow ? A13 === `
` && N14 && (A13 = `

`) : A13 += `
${t6.indent}`;
        } else if (!p17 && Q13.isCollection(e5)) {
          let I17 = v20[0], w19 = v20.indexOf(`
`), L18 = w19 !== -1, H16 = t6.inFlow ?? e5.flow ?? e5.items.length === 0;
          if (L18 || !H16) {
            let ge8 = false;
            if (L18 && (I17 === "&" || I17 === "!")) {
              let P19 = v20.indexOf(" ");
              I17 === "&" && P19 !== -1 && P19 < w19 && v20[P19 + 1] === "!" && (P19 = v20.indexOf(" ", P19 + 1)), (P19 === -1 || w19 < P19) && (ge8 = true);
            }
            ge8 || (A13 = `
${t6.indent}`);
          }
        } else (v20 === "" || v20[0] === `
`) && (A13 = "");
        return m24 += A13 + v20, t6.inFlow ? E12 && n23 && n23() : N14 && !E12 ? m24 += De6.lineComment(m24, t6.indent, c14(N14)) : h16 && i10 && i10(), m24;
      }
      Ar.stringifyPair = Fc;
    });
    en2 = o((Zs) => {
      "use strict";
      var Or2 = m3("process");
      function jc(s9, ...e5) {
        s9 === "debug" && console.log(...e5);
      }
      function Vc(s9, e5) {
        (s9 === "debug" || s9 === "warn") && (typeof Or2.emitWarning == "function" ? Or2.emitWarning(e5) : console.warn(e5));
      }
      Zs.debug = jc;
      Zs.warn = Vc;
    });
    Ut2 = o((Yt2) => {
      "use strict";
      var ze6 = O13(), kr2 = C16(), Kt2 = "<<", Rt2 = { identify: (s9) => s9 === Kt2 || typeof s9 == "symbol" && s9.description === Kt2, default: "key", tag: "tag:yaml.org,2002:merge", test: /^<<$/, resolve: () => Object.assign(new kr2.Scalar(Symbol(Kt2)), { addToJSMap: Ir2 }), stringify: () => Kt2 }, Kc = (s9, e5) => (Rt2.identify(e5) || ze6.isScalar(e5) && (!e5.type || e5.type === kr2.Scalar.PLAIN) && Rt2.identify(e5.value)) && s9?.doc.schema.tags.some((t6) => t6.tag === Rt2.tag && t6.default);
      function Ir2(s9, e5, t6) {
        if (t6 = s9 && ze6.isAlias(t6) ? t6.resolve(s9.doc) : t6, ze6.isSeq(t6)) for (let n23 of t6.items) tn(s9, e5, n23);
        else if (Array.isArray(t6)) for (let n23 of t6) tn(s9, e5, n23);
        else tn(s9, e5, t6);
      }
      function tn(s9, e5, t6) {
        let n23 = s9 && ze6.isAlias(t6) ? t6.resolve(s9.doc) : t6;
        if (!ze6.isMap(n23)) throw new Error("Merge sources must be maps or map aliases");
        let i10 = n23.toJSON(null, s9, Map);
        for (let [r8, o9] of i10) e5 instanceof Map ? e5.has(r8) || e5.set(r8, o9) : e5 instanceof Set ? e5.add(r8) : Object.prototype.hasOwnProperty.call(e5, r8) || Object.defineProperty(e5, r8, { value: o9, writable: true, enumerable: true, configurable: true });
        return e5;
      }
      Yt2.addMergeToJSMap = Ir2;
      Yt2.isMergeKey = Kc;
      Yt2.merge = Rt2;
    });
    nn2 = o((Lr2) => {
      "use strict";
      var Rc = en2(), qr2 = Ut2(), Yc = He5(), Cr2 = O13(), sn2 = D14();
      function Uc(s9, e5, { key: t6, value: n23 }) {
        if (Cr2.isNode(t6) && t6.addToJSMap) t6.addToJSMap(s9, e5, n23);
        else if (qr2.isMergeKey(s9, t6)) qr2.addMergeToJSMap(s9, e5, n23);
        else {
          let i10 = sn2.toJS(t6, "", s9);
          if (e5 instanceof Map) e5.set(i10, sn2.toJS(n23, i10, s9));
          else if (e5 instanceof Set) e5.add(i10);
          else {
            let r8 = Jc(t6, i10, s9), o9 = sn2.toJS(n23, r8, s9);
            r8 in e5 ? Object.defineProperty(e5, r8, { value: o9, writable: true, enumerable: true, configurable: true }) : e5[r8] = o9;
          }
        }
        return e5;
      }
      function Jc(s9, e5, t6) {
        if (e5 === null) return "";
        if (typeof e5 != "object") return String(e5);
        if (Cr2.isNode(s9) && t6?.doc) {
          let n23 = Yc.createStringifyContext(t6.doc, {});
          n23.anchors = /* @__PURE__ */ new Set();
          for (let r8 of t6.anchors.keys()) n23.anchors.add(r8.anchor);
          n23.inFlow = true, n23.inStringifyKey = true;
          let i10 = s9.toString(n23);
          if (!t6.mapKeyWarned) {
            let r8 = JSON.stringify(i10);
            r8.length > 40 && (r8 = r8.substring(0, 36) + '..."'), Rc.warn(t6.doc.options.logLevel, `Keys with collection values will be stringified due to JS Object restrictions: ${r8}. Set mapAsMap: true to use object keys.`), t6.mapKeyWarned = true;
          }
          return i10;
        }
        return JSON.stringify(e5);
      }
      Lr2.addPairToJSMap = Uc;
    });
    te7 = o((rn2) => {
      "use strict";
      var Pr2 = Je5(), Wc = Tr2(), Gc = nn2(), Jt3 = O13();
      function Xc(s9, e5, t6) {
        let n23 = Pr2.createNode(s9, void 0, t6), i10 = Pr2.createNode(e5, void 0, t6);
        return new Wt3(n23, i10);
      }
      var Wt3 = class s9 {
        constructor(e5, t6 = null) {
          Object.defineProperty(this, Jt3.NODE_TYPE, { value: Jt3.PAIR }), this.key = e5, this.value = t6;
        }
        clone(e5) {
          let { key: t6, value: n23 } = this;
          return Jt3.isNode(t6) && (t6 = t6.clone(e5)), Jt3.isNode(n23) && (n23 = n23.clone(e5)), new s9(t6, n23);
        }
        toJSON(e5, t6) {
          let n23 = t6?.mapAsMap ? /* @__PURE__ */ new Map() : {};
          return Gc.addPairToJSMap(t6, n23, this);
        }
        toString(e5, t6, n23) {
          return e5?.doc ? Wc.stringifyPair(this, e5, t6, n23) : JSON.stringify(this);
        }
      };
      rn2.Pair = Wt3;
      rn2.createPair = Xc;
    });
    on2 = o(($r2) => {
      "use strict";
      var ue9 = O13(), Mr3 = He5(), Gt3 = We4();
      function Qc(s9, e5, t6) {
        return (e5.inFlow ?? s9.flow ? Dc : Hc)(s9, e5, t6);
      }
      function Hc({ comment: s9, items: e5 }, t6, { blockItemPrefix: n23, flowChars: i10, itemIndent: r8, onChompKeep: o9, onComment: a7 }) {
        let { indent: l8, options: { commentString: c14 } } = t6, u10 = Object.assign({}, t6, { indent: r8, type: null }), f11 = false, d16 = [];
        for (let g18 = 0; g18 < e5.length; ++g18) {
          let h16 = e5[g18], m24 = null;
          if (ue9.isNode(h16)) !f11 && h16.spaceBefore && d16.push(""), Xt3(t6, d16, h16.commentBefore, f11), h16.comment && (m24 = h16.comment);
          else if (ue9.isPair(h16)) {
            let S16 = ue9.isNode(h16.key) ? h16.key : null;
            S16 && (!f11 && S16.spaceBefore && d16.push(""), Xt3(t6, d16, S16.commentBefore, f11));
          }
          f11 = false;
          let y18 = Mr3.stringify(h16, u10, () => m24 = null, () => f11 = true);
          m24 && (y18 += Gt3.lineComment(y18, r8, c14(m24))), f11 && m24 && (f11 = false), d16.push(n23 + y18);
        }
        let p17;
        if (d16.length === 0) p17 = i10.start + i10.end;
        else {
          p17 = d16[0];
          for (let g18 = 1; g18 < d16.length; ++g18) {
            let h16 = d16[g18];
            p17 += h16 ? `
${l8}${h16}` : `
`;
          }
        }
        return s9 ? (p17 += `
` + Gt3.indentComment(c14(s9), l8), a7 && a7()) : f11 && o9 && o9(), p17;
      }
      function Dc({ items: s9 }, e5, { flowChars: t6, itemIndent: n23 }) {
        let { indent: i10, indentStep: r8, flowCollectionPadding: o9, options: { commentString: a7 } } = e5;
        n23 += r8;
        let l8 = Object.assign({}, e5, { indent: n23, inFlow: true, type: null }), c14 = false, u10 = 0, f11 = [];
        for (let g18 = 0; g18 < s9.length; ++g18) {
          let h16 = s9[g18], m24 = null;
          if (ue9.isNode(h16)) h16.spaceBefore && f11.push(""), Xt3(e5, f11, h16.commentBefore, false), h16.comment && (m24 = h16.comment);
          else if (ue9.isPair(h16)) {
            let S16 = ue9.isNode(h16.key) ? h16.key : null;
            S16 && (S16.spaceBefore && f11.push(""), Xt3(e5, f11, S16.commentBefore, false), S16.comment && (c14 = true));
            let N14 = ue9.isNode(h16.value) ? h16.value : null;
            N14 ? (N14.comment && (m24 = N14.comment), N14.commentBefore && (c14 = true)) : h16.value == null && S16?.comment && (m24 = S16.comment);
          }
          m24 && (c14 = true);
          let y18 = Mr3.stringify(h16, l8, () => m24 = null);
          g18 < s9.length - 1 && (y18 += ","), m24 && (y18 += Gt3.lineComment(y18, n23, a7(m24))), !c14 && (f11.length > u10 || y18.includes(`
`)) && (c14 = true), f11.push(y18), u10 = f11.length;
        }
        let { start: d16, end: p17 } = t6;
        if (f11.length === 0) return d16 + p17;
        if (!c14) {
          let g18 = f11.reduce((h16, m24) => h16 + m24.length + 2, 2);
          c14 = e5.options.lineWidth > 0 && g18 > e5.options.lineWidth;
        }
        if (c14) {
          let g18 = d16;
          for (let h16 of f11) g18 += h16 ? `
${r8}${i10}${h16}` : `
`;
          return `${g18}
${i10}${p17}`;
        } else return `${d16}${o9}${f11.join(" ")}${o9}${p17}`;
      }
      function Xt3({ indent: s9, options: { commentString: e5 } }, t6, n23, i10) {
        if (n23 && i10 && (n23 = n23.replace(/^\n+/, "")), n23) {
          let r8 = Gt3.indentComment(e5(n23), s9);
          t6.push(r8.trimStart());
        }
      }
      $r2.stringifyCollection = Qc;
    });
    ne6 = o((ln2) => {
      "use strict";
      var zc = on2(), Zc = nn2(), ef = _t3(), se7 = O13(), Qt3 = te7(), tf = C16();
      function Ze6(s9, e5) {
        let t6 = se7.isScalar(e5) ? e5.value : e5;
        for (let n23 of s9) if (se7.isPair(n23) && (n23.key === e5 || n23.key === t6 || se7.isScalar(n23.key) && n23.key.value === t6)) return n23;
      }
      var an2 = class extends ef.Collection {
        static get tagName() {
          return "tag:yaml.org,2002:map";
        }
        constructor(e5) {
          super(se7.MAP, e5), this.items = [];
        }
        static from(e5, t6, n23) {
          let { keepUndefined: i10, replacer: r8 } = n23, o9 = new this(e5), a7 = (l8, c14) => {
            if (typeof r8 == "function") c14 = r8.call(t6, l8, c14);
            else if (Array.isArray(r8) && !r8.includes(l8)) return;
            (c14 !== void 0 || i10) && o9.items.push(Qt3.createPair(l8, c14, n23));
          };
          if (t6 instanceof Map) for (let [l8, c14] of t6) a7(l8, c14);
          else if (t6 && typeof t6 == "object") for (let l8 of Object.keys(t6)) a7(l8, t6[l8]);
          return typeof e5.sortMapEntries == "function" && o9.items.sort(e5.sortMapEntries), o9;
        }
        add(e5, t6) {
          let n23;
          se7.isPair(e5) ? n23 = e5 : !e5 || typeof e5 != "object" || !("key" in e5) ? n23 = new Qt3.Pair(e5, e5?.value) : n23 = new Qt3.Pair(e5.key, e5.value);
          let i10 = Ze6(this.items, n23.key), r8 = this.schema?.sortMapEntries;
          if (i10) {
            if (!t6) throw new Error(`Key ${n23.key} already set`);
            se7.isScalar(i10.value) && tf.isScalarValue(n23.value) ? i10.value.value = n23.value : i10.value = n23.value;
          } else if (r8) {
            let o9 = this.items.findIndex((a7) => r8(n23, a7) < 0);
            o9 === -1 ? this.items.push(n23) : this.items.splice(o9, 0, n23);
          } else this.items.push(n23);
        }
        delete(e5) {
          let t6 = Ze6(this.items, e5);
          return t6 ? this.items.splice(this.items.indexOf(t6), 1).length > 0 : false;
        }
        get(e5, t6) {
          let i10 = Ze6(this.items, e5)?.value;
          return (!t6 && se7.isScalar(i10) ? i10.value : i10) ?? void 0;
        }
        has(e5) {
          return !!Ze6(this.items, e5);
        }
        set(e5, t6) {
          this.add(new Qt3.Pair(e5, t6), true);
        }
        toJSON(e5, t6, n23) {
          let i10 = n23 ? new n23() : t6?.mapAsMap ? /* @__PURE__ */ new Map() : {};
          t6?.onCreate && t6.onCreate(i10);
          for (let r8 of this.items) Zc.addPairToJSMap(t6, i10, r8);
          return i10;
        }
        toString(e5, t6, n23) {
          if (!e5) return JSON.stringify(this);
          for (let i10 of this.items) if (!se7.isPair(i10)) throw new Error(`Map items must all be pairs; found ${JSON.stringify(i10)} instead`);
          return !e5.allNullValues && this.hasAllNullValues(false) && (e5 = Object.assign({}, e5, { allNullValues: true })), zc.stringifyCollection(this, e5, { blockItemPrefix: "", flowChars: { start: "{", end: "}" }, itemIndent: e5.indent || "", onChompKeep: n23, onComment: t6 });
        }
      };
      ln2.YAMLMap = an2;
      ln2.findPair = Ze6;
    });
    Ae5 = o((xr3) => {
      "use strict";
      var sf = O13(), _r2 = ne6(), nf = { collection: "map", default: true, nodeClass: _r2.YAMLMap, tag: "tag:yaml.org,2002:map", resolve(s9, e5) {
        return sf.isMap(s9) || e5("Expected a mapping for this tag"), s9;
      }, createNode: (s9, e5, t6) => _r2.YAMLMap.from(s9, e5, t6) };
      xr3.map = nf;
    });
    ie4 = o((Br2) => {
      "use strict";
      var rf = Je5(), of = on2(), af = _t3(), Dt2 = O13(), lf = C16(), cf = D14(), cn3 = class extends af.Collection {
        static get tagName() {
          return "tag:yaml.org,2002:seq";
        }
        constructor(e5) {
          super(Dt2.SEQ, e5), this.items = [];
        }
        add(e5) {
          this.items.push(e5);
        }
        delete(e5) {
          let t6 = Ht3(e5);
          return typeof t6 != "number" ? false : this.items.splice(t6, 1).length > 0;
        }
        get(e5, t6) {
          let n23 = Ht3(e5);
          if (typeof n23 != "number") return;
          let i10 = this.items[n23];
          return !t6 && Dt2.isScalar(i10) ? i10.value : i10;
        }
        has(e5) {
          let t6 = Ht3(e5);
          return typeof t6 == "number" && t6 < this.items.length;
        }
        set(e5, t6) {
          let n23 = Ht3(e5);
          if (typeof n23 != "number") throw new Error(`Expected a valid index, not ${e5}.`);
          let i10 = this.items[n23];
          Dt2.isScalar(i10) && lf.isScalarValue(t6) ? i10.value = t6 : this.items[n23] = t6;
        }
        toJSON(e5, t6) {
          let n23 = [];
          t6?.onCreate && t6.onCreate(n23);
          let i10 = 0;
          for (let r8 of this.items) n23.push(cf.toJS(r8, String(i10++), t6));
          return n23;
        }
        toString(e5, t6, n23) {
          return e5 ? of.stringifyCollection(this, e5, { blockItemPrefix: "- ", flowChars: { start: "[", end: "]" }, itemIndent: (e5.indent || "") + "  ", onChompKeep: n23, onComment: t6 }) : JSON.stringify(this);
        }
        static from(e5, t6, n23) {
          let { replacer: i10 } = n23, r8 = new this(e5);
          if (t6 && Symbol.iterator in Object(t6)) {
            let o9 = 0;
            for (let a7 of t6) {
              if (typeof i10 == "function") {
                let l8 = t6 instanceof Set ? a7 : String(o9++);
                a7 = i10.call(t6, l8, a7);
              }
              r8.items.push(rf.createNode(a7, void 0, n23));
            }
          }
          return r8;
        }
      };
      function Ht3(s9) {
        let e5 = Dt2.isScalar(s9) ? s9.value : s9;
        return e5 && typeof e5 == "string" && (e5 = Number(e5)), typeof e5 == "number" && Number.isInteger(e5) && e5 >= 0 ? e5 : null;
      }
      Br2.YAMLSeq = cn3;
    });
    Te3 = o((jr2) => {
      "use strict";
      var ff = O13(), Fr2 = ie4(), uf = { collection: "seq", default: true, nodeClass: Fr2.YAMLSeq, tag: "tag:yaml.org,2002:seq", resolve(s9, e5) {
        return ff.isSeq(s9) || e5("Expected a sequence for this tag"), s9;
      }, createNode: (s9, e5, t6) => Fr2.YAMLSeq.from(s9, e5, t6) };
      jr2.seq = uf;
    });
    et6 = o((Vr) => {
      "use strict";
      var df = Qe5(), hf = { identify: (s9) => typeof s9 == "string", default: true, tag: "tag:yaml.org,2002:str", resolve: (s9) => s9, stringify(s9, e5, t6, n23) {
        return e5 = Object.assign({ actualString: true }, e5), df.stringifyString(s9, e5, t6, n23);
      } };
      Vr.string = hf;
    });
    zt2 = o((Yr) => {
      "use strict";
      var Kr = C16(), Rr2 = { identify: (s9) => s9 == null, createNode: () => new Kr.Scalar(null), default: true, tag: "tag:yaml.org,2002:null", test: /^(?:~|[Nn]ull|NULL)?$/, resolve: () => new Kr.Scalar(null), stringify: ({ source: s9 }, e5) => typeof s9 == "string" && Rr2.test.test(s9) ? s9 : e5.options.nullStr };
      Yr.nullTag = Rr2;
    });
    fn = o((Jr) => {
      "use strict";
      var pf = C16(), Ur2 = { identify: (s9) => typeof s9 == "boolean", default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/, resolve: (s9) => new pf.Scalar(s9[0] === "t" || s9[0] === "T"), stringify({ source: s9, value: e5 }, t6) {
        if (s9 && Ur2.test.test(s9)) {
          let n23 = s9[0] === "t" || s9[0] === "T";
          if (e5 === n23) return s9;
        }
        return e5 ? t6.options.trueStr : t6.options.falseStr;
      } };
      Jr.boolTag = Ur2;
    });
    Oe3 = o((Wr) => {
      "use strict";
      function mf({ format: s9, minFractionDigits: e5, tag: t6, value: n23 }) {
        if (typeof n23 == "bigint") return String(n23);
        let i10 = typeof n23 == "number" ? n23 : Number(n23);
        if (!isFinite(i10)) return isNaN(i10) ? ".nan" : i10 < 0 ? "-.inf" : ".inf";
        let r8 = Object.is(n23, -0) ? "-0" : JSON.stringify(n23);
        if (!s9 && e5 && (!t6 || t6 === "tag:yaml.org,2002:float") && /^\d/.test(r8)) {
          let o9 = r8.indexOf(".");
          o9 < 0 && (o9 = r8.length, r8 += ".");
          let a7 = e5 - (r8.length - o9 - 1);
          for (; a7-- > 0; ) r8 += "0";
        }
        return r8;
      }
      Wr.stringifyNumber = mf;
    });
    dn = o((Zt3) => {
      "use strict";
      var gf = C16(), un2 = Oe3(), yf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^(?:[-+]?\.(?:inf|Inf|INF)|\.nan|\.NaN|\.NAN)$/, resolve: (s9) => s9.slice(-3).toLowerCase() === "nan" ? NaN : s9[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, stringify: un2.stringifyNumber }, bf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "EXP", test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/, resolve: (s9) => parseFloat(s9), stringify(s9) {
        let e5 = Number(s9.value);
        return isFinite(e5) ? e5.toExponential() : un2.stringifyNumber(s9);
      } }, wf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^[-+]?(?:\.[0-9]+|[0-9]+\.[0-9]*)$/, resolve(s9) {
        let e5 = new gf.Scalar(parseFloat(s9)), t6 = s9.indexOf(".");
        return t6 !== -1 && s9[s9.length - 1] === "0" && (e5.minFractionDigits = s9.length - t6 - 1), e5;
      }, stringify: un2.stringifyNumber };
      Zt3.float = wf;
      Zt3.floatExp = bf;
      Zt3.floatNaN = yf;
    });
    pn = o((ts) => {
      "use strict";
      var Gr = Oe3(), es = (s9) => typeof s9 == "bigint" || Number.isInteger(s9), hn = (s9, e5, t6, { intAsBigInt: n23 }) => n23 ? BigInt(s9) : parseInt(s9.substring(e5), t6);
      function Xr(s9, e5, t6) {
        let { value: n23 } = s9;
        return es(n23) && n23 >= 0 ? t6 + n23.toString(e5) : Gr.stringifyNumber(s9);
      }
      var Sf = { identify: (s9) => es(s9) && s9 >= 0, default: true, tag: "tag:yaml.org,2002:int", format: "OCT", test: /^0o[0-7]+$/, resolve: (s9, e5, t6) => hn(s9, 2, 8, t6), stringify: (s9) => Xr(s9, 8, "0o") }, Nf = { identify: es, default: true, tag: "tag:yaml.org,2002:int", test: /^[-+]?[0-9]+$/, resolve: (s9, e5, t6) => hn(s9, 0, 10, t6), stringify: Gr.stringifyNumber }, Ef = { identify: (s9) => es(s9) && s9 >= 0, default: true, tag: "tag:yaml.org,2002:int", format: "HEX", test: /^0x[0-9a-fA-F]+$/, resolve: (s9, e5, t6) => hn(s9, 2, 16, t6), stringify: (s9) => Xr(s9, 16, "0x") };
      ts.int = Nf;
      ts.intHex = Ef;
      ts.intOct = Sf;
    });
    Hr2 = o((Qr2) => {
      "use strict";
      var vf = Ae5(), Af = zt2(), Tf = Te3(), Of = et6(), kf = fn(), mn = dn(), gn2 = pn(), If = [vf.map, Tf.seq, Of.string, Af.nullTag, kf.boolTag, gn2.intOct, gn2.int, gn2.intHex, mn.floatNaN, mn.floatExp, mn.float];
      Qr2.schema = If;
    });
    Zr2 = o((zr2) => {
      "use strict";
      var qf = C16(), Cf = Ae5(), Lf = Te3();
      function Dr3(s9) {
        return typeof s9 == "bigint" || Number.isInteger(s9);
      }
      var ss = ({ value: s9 }) => JSON.stringify(s9), Pf = [{ identify: (s9) => typeof s9 == "string", default: true, tag: "tag:yaml.org,2002:str", resolve: (s9) => s9, stringify: ss }, { identify: (s9) => s9 == null, createNode: () => new qf.Scalar(null), default: true, tag: "tag:yaml.org,2002:null", test: /^null$/, resolve: () => null, stringify: ss }, { identify: (s9) => typeof s9 == "boolean", default: true, tag: "tag:yaml.org,2002:bool", test: /^true$|^false$/, resolve: (s9) => s9 === "true", stringify: ss }, { identify: Dr3, default: true, tag: "tag:yaml.org,2002:int", test: /^-?(?:0|[1-9][0-9]*)$/, resolve: (s9, e5, { intAsBigInt: t6 }) => t6 ? BigInt(s9) : parseInt(s9, 10), stringify: ({ value: s9 }) => Dr3(s9) ? s9.toString() : JSON.stringify(s9) }, { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/, resolve: (s9) => parseFloat(s9), stringify: ss }], Mf = { default: true, tag: "", test: /^/, resolve(s9, e5) {
        return e5(`Unresolved plain scalar ${JSON.stringify(s9)}`), s9;
      } }, $f = [Cf.map, Lf.seq].concat(Pf, Mf);
      zr2.schema = $f;
    });
    bn2 = o((eo) => {
      "use strict";
      var tt7 = m3("buffer"), yn = C16(), _f = Qe5(), xf = { identify: (s9) => s9 instanceof Uint8Array, default: false, tag: "tag:yaml.org,2002:binary", resolve(s9, e5) {
        if (typeof tt7.Buffer == "function") return tt7.Buffer.from(s9, "base64");
        if (typeof atob == "function") {
          let t6 = atob(s9.replace(/[\n\r]/g, "")), n23 = new Uint8Array(t6.length);
          for (let i10 = 0; i10 < t6.length; ++i10) n23[i10] = t6.charCodeAt(i10);
          return n23;
        } else return e5("This environment does not support reading binary tags; either Buffer or atob is required"), s9;
      }, stringify({ comment: s9, type: e5, value: t6 }, n23, i10, r8) {
        if (!t6) return "";
        let o9 = t6, a7;
        if (typeof tt7.Buffer == "function") a7 = o9 instanceof tt7.Buffer ? o9.toString("base64") : tt7.Buffer.from(o9.buffer).toString("base64");
        else if (typeof btoa == "function") {
          let l8 = "";
          for (let c14 = 0; c14 < o9.length; ++c14) l8 += String.fromCharCode(o9[c14]);
          a7 = btoa(l8);
        } else throw new Error("This environment does not support writing binary tags; either Buffer or btoa is required");
        if (e5 ?? (e5 = yn.Scalar.BLOCK_LITERAL), e5 !== yn.Scalar.QUOTE_DOUBLE) {
          let l8 = Math.max(n23.options.lineWidth - n23.indent.length, n23.options.minContentWidth), c14 = Math.ceil(a7.length / l8), u10 = new Array(c14);
          for (let f11 = 0, d16 = 0; f11 < c14; ++f11, d16 += l8) u10[f11] = a7.substr(d16, l8);
          a7 = u10.join(e5 === yn.Scalar.BLOCK_LITERAL ? `
` : " ");
        }
        return _f.stringifyString({ comment: s9, type: e5, value: a7 }, n23, i10, r8);
      } };
      eo.binary = xf;
    });
    rs = o((is2) => {
      "use strict";
      var ns = O13(), wn = te7(), Bf = C16(), Ff = ie4();
      function to(s9, e5) {
        if (ns.isSeq(s9)) for (let t6 = 0; t6 < s9.items.length; ++t6) {
          let n23 = s9.items[t6];
          if (!ns.isPair(n23)) {
            if (ns.isMap(n23)) {
              n23.items.length > 1 && e5("Each pair must have its own sequence indicator");
              let i10 = n23.items[0] || new wn.Pair(new Bf.Scalar(null));
              if (n23.commentBefore && (i10.key.commentBefore = i10.key.commentBefore ? `${n23.commentBefore}
${i10.key.commentBefore}` : n23.commentBefore), n23.comment) {
                let r8 = i10.value ?? i10.key;
                r8.comment = r8.comment ? `${n23.comment}
${r8.comment}` : n23.comment;
              }
              n23 = i10;
            }
            s9.items[t6] = ns.isPair(n23) ? n23 : new wn.Pair(n23);
          }
        }
        else e5("Expected a sequence for this tag");
        return s9;
      }
      function so(s9, e5, t6) {
        let { replacer: n23 } = t6, i10 = new Ff.YAMLSeq(s9);
        i10.tag = "tag:yaml.org,2002:pairs";
        let r8 = 0;
        if (e5 && Symbol.iterator in Object(e5)) for (let o9 of e5) {
          typeof n23 == "function" && (o9 = n23.call(e5, String(r8++), o9));
          let a7, l8;
          if (Array.isArray(o9)) if (o9.length === 2) a7 = o9[0], l8 = o9[1];
          else throw new TypeError(`Expected [key, value] tuple: ${o9}`);
          else if (o9 && o9 instanceof Object) {
            let c14 = Object.keys(o9);
            if (c14.length === 1) a7 = c14[0], l8 = o9[a7];
            else throw new TypeError(`Expected tuple with one key, not ${c14.length} keys`);
          } else a7 = o9;
          i10.items.push(wn.createPair(a7, l8, t6));
        }
        return i10;
      }
      var jf = { collection: "seq", default: false, tag: "tag:yaml.org,2002:pairs", resolve: to, createNode: so };
      is2.createPairs = so;
      is2.pairs = jf;
      is2.resolvePairs = to;
    });
    En = o((Nn) => {
      "use strict";
      var no = O13(), Sn = D14(), st7 = ne6(), Vf = ie4(), io = rs(), de9 = class s9 extends Vf.YAMLSeq {
        constructor() {
          super(), this.add = st7.YAMLMap.prototype.add.bind(this), this.delete = st7.YAMLMap.prototype.delete.bind(this), this.get = st7.YAMLMap.prototype.get.bind(this), this.has = st7.YAMLMap.prototype.has.bind(this), this.set = st7.YAMLMap.prototype.set.bind(this), this.tag = s9.tag;
        }
        toJSON(e5, t6) {
          if (!t6) return super.toJSON(e5);
          let n23 = /* @__PURE__ */ new Map();
          t6?.onCreate && t6.onCreate(n23);
          for (let i10 of this.items) {
            let r8, o9;
            if (no.isPair(i10) ? (r8 = Sn.toJS(i10.key, "", t6), o9 = Sn.toJS(i10.value, r8, t6)) : r8 = Sn.toJS(i10, "", t6), n23.has(r8)) throw new Error("Ordered maps must not include duplicate keys");
            n23.set(r8, o9);
          }
          return n23;
        }
        static from(e5, t6, n23) {
          let i10 = io.createPairs(e5, t6, n23), r8 = new this();
          return r8.items = i10.items, r8;
        }
      };
      de9.tag = "tag:yaml.org,2002:omap";
      var Kf = { collection: "seq", identify: (s9) => s9 instanceof Map, nodeClass: de9, default: false, tag: "tag:yaml.org,2002:omap", resolve(s9, e5) {
        let t6 = io.resolvePairs(s9, e5), n23 = [];
        for (let { key: i10 } of t6.items) no.isScalar(i10) && (n23.includes(i10.value) ? e5(`Ordered maps must not include duplicate keys: ${i10.value}`) : n23.push(i10.value));
        return Object.assign(new de9(), t6);
      }, createNode: (s9, e5, t6) => de9.from(s9, e5, t6) };
      Nn.YAMLOMap = de9;
      Nn.omap = Kf;
    });
    co = o((vn) => {
      "use strict";
      var ro = C16();
      function oo({ value: s9, source: e5 }, t6) {
        return e5 && (s9 ? ao : lo).test.test(e5) ? e5 : s9 ? t6.options.trueStr : t6.options.falseStr;
      }
      var ao = { identify: (s9) => s9 === true, default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/, resolve: () => new ro.Scalar(true), stringify: oo }, lo = { identify: (s9) => s9 === false, default: true, tag: "tag:yaml.org,2002:bool", test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/, resolve: () => new ro.Scalar(false), stringify: oo };
      vn.falseTag = lo;
      vn.trueTag = ao;
    });
    fo = o((os2) => {
      "use strict";
      var Rf = C16(), An = Oe3(), Yf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^(?:[-+]?\.(?:inf|Inf|INF)|\.nan|\.NaN|\.NAN)$/, resolve: (s9) => s9.slice(-3).toLowerCase() === "nan" ? NaN : s9[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, stringify: An.stringifyNumber }, Uf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "EXP", test: /^[-+]?(?:[0-9][0-9_]*)?(?:\.[0-9_]*)?[eE][-+]?[0-9]+$/, resolve: (s9) => parseFloat(s9.replace(/_/g, "")), stringify(s9) {
        let e5 = Number(s9.value);
        return isFinite(e5) ? e5.toExponential() : An.stringifyNumber(s9);
      } }, Jf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", test: /^[-+]?(?:[0-9][0-9_]*)?\.[0-9_]*$/, resolve(s9) {
        let e5 = new Rf.Scalar(parseFloat(s9.replace(/_/g, ""))), t6 = s9.indexOf(".");
        if (t6 !== -1) {
          let n23 = s9.substring(t6 + 1).replace(/_/g, "");
          n23[n23.length - 1] === "0" && (e5.minFractionDigits = n23.length);
        }
        return e5;
      }, stringify: An.stringifyNumber };
      os2.float = Jf;
      os2.floatExp = Uf;
      os2.floatNaN = Yf;
    });
    ho = o((it6) => {
      "use strict";
      var uo = Oe3(), nt7 = (s9) => typeof s9 == "bigint" || Number.isInteger(s9);
      function as(s9, e5, t6, { intAsBigInt: n23 }) {
        let i10 = s9[0];
        if ((i10 === "-" || i10 === "+") && (e5 += 1), s9 = s9.substring(e5).replace(/_/g, ""), n23) {
          switch (t6) {
            case 2:
              s9 = `0b${s9}`;
              break;
            case 8:
              s9 = `0o${s9}`;
              break;
            case 16:
              s9 = `0x${s9}`;
              break;
          }
          let o9 = BigInt(s9);
          return i10 === "-" ? BigInt(-1) * o9 : o9;
        }
        let r8 = parseInt(s9, t6);
        return i10 === "-" ? -1 * r8 : r8;
      }
      function Tn(s9, e5, t6) {
        let { value: n23 } = s9;
        if (nt7(n23)) {
          let i10 = n23.toString(e5);
          return n23 < 0 ? "-" + t6 + i10.substr(1) : t6 + i10;
        }
        return uo.stringifyNumber(s9);
      }
      var Wf = { identify: nt7, default: true, tag: "tag:yaml.org,2002:int", format: "BIN", test: /^[-+]?0b[0-1_]+$/, resolve: (s9, e5, t6) => as(s9, 2, 2, t6), stringify: (s9) => Tn(s9, 2, "0b") }, Gf = { identify: nt7, default: true, tag: "tag:yaml.org,2002:int", format: "OCT", test: /^[-+]?0[0-7_]+$/, resolve: (s9, e5, t6) => as(s9, 1, 8, t6), stringify: (s9) => Tn(s9, 8, "0") }, Xf = { identify: nt7, default: true, tag: "tag:yaml.org,2002:int", test: /^[-+]?[0-9][0-9_]*$/, resolve: (s9, e5, t6) => as(s9, 0, 10, t6), stringify: uo.stringifyNumber }, Qf = { identify: nt7, default: true, tag: "tag:yaml.org,2002:int", format: "HEX", test: /^[-+]?0x[0-9a-fA-F_]+$/, resolve: (s9, e5, t6) => as(s9, 2, 16, t6), stringify: (s9) => Tn(s9, 16, "0x") };
      it6.int = Xf;
      it6.intBin = Wf;
      it6.intHex = Qf;
      it6.intOct = Gf;
    });
    kn = o((On2) => {
      "use strict";
      var fs = O13(), ls = te7(), cs = ne6(), he10 = class s9 extends cs.YAMLMap {
        constructor(e5) {
          super(e5), this.tag = s9.tag;
        }
        add(e5) {
          let t6;
          fs.isPair(e5) ? t6 = e5 : e5 && typeof e5 == "object" && "key" in e5 && "value" in e5 && e5.value === null ? t6 = new ls.Pair(e5.key, null) : t6 = new ls.Pair(e5, null), cs.findPair(this.items, t6.key) || this.items.push(t6);
        }
        get(e5, t6) {
          let n23 = cs.findPair(this.items, e5);
          return !t6 && fs.isPair(n23) ? fs.isScalar(n23.key) ? n23.key.value : n23.key : n23;
        }
        set(e5, t6) {
          if (typeof t6 != "boolean") throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof t6}`);
          let n23 = cs.findPair(this.items, e5);
          n23 && !t6 ? this.items.splice(this.items.indexOf(n23), 1) : !n23 && t6 && this.items.push(new ls.Pair(e5));
        }
        toJSON(e5, t6) {
          return super.toJSON(e5, t6, Set);
        }
        toString(e5, t6, n23) {
          if (!e5) return JSON.stringify(this);
          if (this.hasAllNullValues(true)) return super.toString(Object.assign({}, e5, { allNullValues: true }), t6, n23);
          throw new Error("Set items must all have null values");
        }
        static from(e5, t6, n23) {
          let { replacer: i10 } = n23, r8 = new this(e5);
          if (t6 && Symbol.iterator in Object(t6)) for (let o9 of t6) typeof i10 == "function" && (o9 = i10.call(t6, o9, o9)), r8.items.push(ls.createPair(o9, null, n23));
          return r8;
        }
      };
      he10.tag = "tag:yaml.org,2002:set";
      var Hf = { collection: "map", identify: (s9) => s9 instanceof Set, nodeClass: he10, default: false, tag: "tag:yaml.org,2002:set", createNode: (s9, e5, t6) => he10.from(s9, e5, t6), resolve(s9, e5) {
        if (fs.isMap(s9)) {
          if (s9.hasAllNullValues(true)) return Object.assign(new he10(), s9);
          e5("Set items must all have null values");
        } else e5("Expected a mapping for this tag");
        return s9;
      } };
      On2.YAMLSet = he10;
      On2.set = Hf;
    });
    qn = o((us) => {
      "use strict";
      var Df = Oe3();
      function In(s9, e5) {
        let t6 = s9[0], n23 = t6 === "-" || t6 === "+" ? s9.substring(1) : s9, i10 = (o9) => e5 ? BigInt(o9) : Number(o9), r8 = n23.replace(/_/g, "").split(":").reduce((o9, a7) => o9 * i10(60) + i10(a7), i10(0));
        return t6 === "-" ? i10(-1) * r8 : r8;
      }
      function po(s9) {
        let { value: e5 } = s9, t6 = (o9) => o9;
        if (typeof e5 == "bigint") t6 = (o9) => BigInt(o9);
        else if (isNaN(e5) || !isFinite(e5)) return Df.stringifyNumber(s9);
        let n23 = "";
        e5 < 0 && (n23 = "-", e5 *= t6(-1));
        let i10 = t6(60), r8 = [e5 % i10];
        return e5 < 60 ? r8.unshift(0) : (e5 = (e5 - r8[0]) / i10, r8.unshift(e5 % i10), e5 >= 60 && (e5 = (e5 - r8[0]) / i10, r8.unshift(e5))), n23 + r8.map((o9) => String(o9).padStart(2, "0")).join(":").replace(/000000\d*$/, "");
      }
      var zf = { identify: (s9) => typeof s9 == "bigint" || Number.isInteger(s9), default: true, tag: "tag:yaml.org,2002:int", format: "TIME", test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+$/, resolve: (s9, e5, { intAsBigInt: t6 }) => In(s9, t6), stringify: po }, Zf = { identify: (s9) => typeof s9 == "number", default: true, tag: "tag:yaml.org,2002:float", format: "TIME", test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*$/, resolve: (s9) => In(s9, false), stringify: po }, mo = { identify: (s9) => s9 instanceof Date, default: true, tag: "tag:yaml.org,2002:timestamp", test: RegExp("^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?$"), resolve(s9) {
        let e5 = s9.match(mo.test);
        if (!e5) throw new Error("!!timestamp expects a date, starting with yyyy-mm-dd");
        let [, t6, n23, i10, r8, o9, a7] = e5.map(Number), l8 = e5[7] ? Number((e5[7] + "00").substr(1, 3)) : 0, c14 = Date.UTC(t6, n23 - 1, i10, r8 || 0, o9 || 0, a7 || 0, l8), u10 = e5[8];
        if (u10 && u10 !== "Z") {
          let f11 = In(u10, false);
          Math.abs(f11) < 30 && (f11 *= 60), c14 -= 6e4 * f11;
        }
        return new Date(c14);
      }, stringify: ({ value: s9 }) => s9?.toISOString().replace(/(T00:00:00)?\.000Z$/, "") ?? "" };
      us.floatTime = Zf;
      us.intTime = zf;
      us.timestamp = mo;
    });
    bo = o((yo) => {
      "use strict";
      var eu = Ae5(), tu = zt2(), su = Te3(), nu = et6(), iu = bn2(), go = co(), Cn2 = fo(), ds = ho(), ru = Ut2(), ou = En(), au = rs(), lu = kn(), Ln = qn(), cu = [eu.map, su.seq, nu.string, tu.nullTag, go.trueTag, go.falseTag, ds.intBin, ds.intOct, ds.int, ds.intHex, Cn2.floatNaN, Cn2.floatExp, Cn2.float, iu.binary, ru.merge, ou.omap, au.pairs, lu.set, Ln.intTime, Ln.floatTime, Ln.timestamp];
      yo.schema = cu;
    });
    Io = o(($n) => {
      "use strict";
      var Eo = Ae5(), fu = zt2(), vo = Te3(), uu = et6(), du = fn(), Pn = dn(), Mn = pn(), hu = Hr2(), pu = Zr2(), Ao = bn2(), rt6 = Ut2(), To = En(), Oo = rs(), wo = bo(), ko = kn(), hs = qn(), So = /* @__PURE__ */ new Map([["core", hu.schema], ["failsafe", [Eo.map, vo.seq, uu.string]], ["json", pu.schema], ["yaml11", wo.schema], ["yaml-1.1", wo.schema]]), No = { binary: Ao.binary, bool: du.boolTag, float: Pn.float, floatExp: Pn.floatExp, floatNaN: Pn.floatNaN, floatTime: hs.floatTime, int: Mn.int, intHex: Mn.intHex, intOct: Mn.intOct, intTime: hs.intTime, map: Eo.map, merge: rt6.merge, null: fu.nullTag, omap: To.omap, pairs: Oo.pairs, seq: vo.seq, set: ko.set, timestamp: hs.timestamp }, mu = { "tag:yaml.org,2002:binary": Ao.binary, "tag:yaml.org,2002:merge": rt6.merge, "tag:yaml.org,2002:omap": To.omap, "tag:yaml.org,2002:pairs": Oo.pairs, "tag:yaml.org,2002:set": ko.set, "tag:yaml.org,2002:timestamp": hs.timestamp };
      function gu(s9, e5, t6) {
        let n23 = So.get(e5);
        if (n23 && !s9) return t6 && !n23.includes(rt6.merge) ? n23.concat(rt6.merge) : n23.slice();
        let i10 = n23;
        if (!i10) if (Array.isArray(s9)) i10 = [];
        else {
          let r8 = Array.from(So.keys()).filter((o9) => o9 !== "yaml11").map((o9) => JSON.stringify(o9)).join(", ");
          throw new Error(`Unknown schema "${e5}"; use one of ${r8} or define customTags array`);
        }
        if (Array.isArray(s9)) for (let r8 of s9) i10 = i10.concat(r8);
        else typeof s9 == "function" && (i10 = s9(i10.slice()));
        return t6 && (i10 = i10.concat(rt6.merge)), i10.reduce((r8, o9) => {
          let a7 = typeof o9 == "string" ? No[o9] : o9;
          if (!a7) {
            let l8 = JSON.stringify(o9), c14 = Object.keys(No).map((u10) => JSON.stringify(u10)).join(", ");
            throw new Error(`Unknown custom tag ${l8}; use one of ${c14}`);
          }
          return r8.includes(a7) || r8.push(a7), r8;
        }, []);
      }
      $n.coreKnownTags = mu;
      $n.getTags = gu;
    });
    Bn = o((qo) => {
      "use strict";
      var _n2 = O13(), yu = Ae5(), bu = Te3(), wu = et6(), ps = Io(), Su = (s9, e5) => s9.key < e5.key ? -1 : s9.key > e5.key ? 1 : 0, xn = class s9 {
        constructor({ compat: e5, customTags: t6, merge: n23, resolveKnownTags: i10, schema: r8, sortMapEntries: o9, toStringDefaults: a7 }) {
          this.compat = Array.isArray(e5) ? ps.getTags(e5, "compat") : e5 ? ps.getTags(null, e5) : null, this.name = typeof r8 == "string" && r8 || "core", this.knownTags = i10 ? ps.coreKnownTags : {}, this.tags = ps.getTags(t6, this.name, n23), this.toStringOptions = a7 ?? null, Object.defineProperty(this, _n2.MAP, { value: yu.map }), Object.defineProperty(this, _n2.SCALAR, { value: wu.string }), Object.defineProperty(this, _n2.SEQ, { value: bu.seq }), this.sortMapEntries = typeof o9 == "function" ? o9 : o9 === true ? Su : null;
        }
        clone() {
          let e5 = Object.create(s9.prototype, Object.getOwnPropertyDescriptors(this));
          return e5.tags = this.tags.slice(), e5;
        }
      };
      qo.Schema = xn;
    });
    Lo = o((Co) => {
      "use strict";
      var Nu = O13(), Fn = He5(), ot6 = We4();
      function Eu(s9, e5) {
        let t6 = [], n23 = e5.directives === true;
        if (e5.directives !== false && s9.directives) {
          let l8 = s9.directives.toString(s9);
          l8 ? (t6.push(l8), n23 = true) : s9.directives.docStart && (n23 = true);
        }
        n23 && t6.push("---");
        let i10 = Fn.createStringifyContext(s9, e5), { commentString: r8 } = i10.options;
        if (s9.commentBefore) {
          t6.length !== 1 && t6.unshift("");
          let l8 = r8(s9.commentBefore);
          t6.unshift(ot6.indentComment(l8, ""));
        }
        let o9 = false, a7 = null;
        if (s9.contents) {
          if (Nu.isNode(s9.contents)) {
            if (s9.contents.spaceBefore && n23 && t6.push(""), s9.contents.commentBefore) {
              let u10 = r8(s9.contents.commentBefore);
              t6.push(ot6.indentComment(u10, ""));
            }
            i10.forceBlockIndent = !!s9.comment, a7 = s9.contents.comment;
          }
          let l8 = a7 ? void 0 : () => o9 = true, c14 = Fn.stringify(s9.contents, i10, () => a7 = null, l8);
          a7 && (c14 += ot6.lineComment(c14, "", r8(a7))), (c14[0] === "|" || c14[0] === ">") && t6[t6.length - 1] === "---" ? t6[t6.length - 1] = `--- ${c14}` : t6.push(c14);
        } else t6.push(Fn.stringify(s9.contents, i10));
        if (s9.directives?.docEnd) if (s9.comment) {
          let l8 = r8(s9.comment);
          l8.includes(`
`) ? (t6.push("..."), t6.push(ot6.indentComment(l8, ""))) : t6.push(`... ${l8}`);
        } else t6.push("...");
        else {
          let l8 = s9.comment;
          l8 && o9 && (l8 = l8.replace(/^\n+/, "")), l8 && ((!o9 || a7) && t6[t6.length - 1] !== "" && t6.push(""), t6.push(ot6.indentComment(r8(l8), "")));
        }
        return t6.join(`
`) + `
`;
      }
      Co.stringifyDocument = Eu;
    });
    at5 = o((Po) => {
      "use strict";
      var vu = Ue4(), ke6 = _t3(), K9 = O13(), Au = te7(), Tu = D14(), Ou = Bn(), ku = Lo(), jn = Lt3(), Iu = Rs(), qu = Je5(), Vn = Ks(), Kn = class s9 {
        constructor(e5, t6, n23) {
          this.commentBefore = null, this.comment = null, this.errors = [], this.warnings = [], Object.defineProperty(this, K9.NODE_TYPE, { value: K9.DOC });
          let i10 = null;
          typeof t6 == "function" || Array.isArray(t6) ? i10 = t6 : n23 === void 0 && t6 && (n23 = t6, t6 = void 0);
          let r8 = Object.assign({ intAsBigInt: false, keepSourceTokens: false, logLevel: "warn", prettyErrors: true, strict: true, stringKeys: false, uniqueKeys: true, version: "1.2" }, n23);
          this.options = r8;
          let { version: o9 } = r8;
          n23?._directives ? (this.directives = n23._directives.atDocument(), this.directives.yaml.explicit && (o9 = this.directives.yaml.version)) : this.directives = new Vn.Directives({ version: o9 }), this.setSchema(o9, n23), this.contents = e5 === void 0 ? null : this.createNode(e5, i10, n23);
        }
        clone() {
          let e5 = Object.create(s9.prototype, { [K9.NODE_TYPE]: { value: K9.DOC } });
          return e5.commentBefore = this.commentBefore, e5.comment = this.comment, e5.errors = this.errors.slice(), e5.warnings = this.warnings.slice(), e5.options = Object.assign({}, this.options), this.directives && (e5.directives = this.directives.clone()), e5.schema = this.schema.clone(), e5.contents = K9.isNode(this.contents) ? this.contents.clone(e5.schema) : this.contents, this.range && (e5.range = this.range.slice()), e5;
        }
        add(e5) {
          Ie7(this.contents) && this.contents.add(e5);
        }
        addIn(e5, t6) {
          Ie7(this.contents) && this.contents.addIn(e5, t6);
        }
        createAlias(e5, t6) {
          if (!e5.anchor) {
            let n23 = jn.anchorNames(this);
            e5.anchor = !t6 || n23.has(t6) ? jn.findNewAnchor(t6 || "a", n23) : t6;
          }
          return new vu.Alias(e5.anchor);
        }
        createNode(e5, t6, n23) {
          let i10;
          if (typeof t6 == "function") e5 = t6.call({ "": e5 }, "", e5), i10 = t6;
          else if (Array.isArray(t6)) {
            let m24 = (S16) => typeof S16 == "number" || S16 instanceof String || S16 instanceof Number, y18 = t6.filter(m24).map(String);
            y18.length > 0 && (t6 = t6.concat(y18)), i10 = t6;
          } else n23 === void 0 && t6 && (n23 = t6, t6 = void 0);
          let { aliasDuplicateObjects: r8, anchorPrefix: o9, flow: a7, keepUndefined: l8, onTagObj: c14, tag: u10 } = n23 ?? {}, { onAnchor: f11, setAnchors: d16, sourceObjects: p17 } = jn.createNodeAnchors(this, o9 || "a"), g18 = { aliasDuplicateObjects: r8 ?? true, keepUndefined: l8 ?? false, onAnchor: f11, onTagObj: c14, replacer: i10, schema: this.schema, sourceObjects: p17 }, h16 = qu.createNode(e5, u10, g18);
          return a7 && K9.isCollection(h16) && (h16.flow = true), d16(), h16;
        }
        createPair(e5, t6, n23 = {}) {
          let i10 = this.createNode(e5, null, n23), r8 = this.createNode(t6, null, n23);
          return new Au.Pair(i10, r8);
        }
        delete(e5) {
          return Ie7(this.contents) ? this.contents.delete(e5) : false;
        }
        deleteIn(e5) {
          return ke6.isEmptyPath(e5) ? this.contents == null ? false : (this.contents = null, true) : Ie7(this.contents) ? this.contents.deleteIn(e5) : false;
        }
        get(e5, t6) {
          return K9.isCollection(this.contents) ? this.contents.get(e5, t6) : void 0;
        }
        getIn(e5, t6) {
          return ke6.isEmptyPath(e5) ? !t6 && K9.isScalar(this.contents) ? this.contents.value : this.contents : K9.isCollection(this.contents) ? this.contents.getIn(e5, t6) : void 0;
        }
        has(e5) {
          return K9.isCollection(this.contents) ? this.contents.has(e5) : false;
        }
        hasIn(e5) {
          return ke6.isEmptyPath(e5) ? this.contents !== void 0 : K9.isCollection(this.contents) ? this.contents.hasIn(e5) : false;
        }
        set(e5, t6) {
          this.contents == null ? this.contents = ke6.collectionFromPath(this.schema, [e5], t6) : Ie7(this.contents) && this.contents.set(e5, t6);
        }
        setIn(e5, t6) {
          ke6.isEmptyPath(e5) ? this.contents = t6 : this.contents == null ? this.contents = ke6.collectionFromPath(this.schema, Array.from(e5), t6) : Ie7(this.contents) && this.contents.setIn(e5, t6);
        }
        setSchema(e5, t6 = {}) {
          typeof e5 == "number" && (e5 = String(e5));
          let n23;
          switch (e5) {
            case "1.1":
              this.directives ? this.directives.yaml.version = "1.1" : this.directives = new Vn.Directives({ version: "1.1" }), n23 = { resolveKnownTags: false, schema: "yaml-1.1" };
              break;
            case "1.2":
            case "next":
              this.directives ? this.directives.yaml.version = e5 : this.directives = new Vn.Directives({ version: e5 }), n23 = { resolveKnownTags: true, schema: "core" };
              break;
            case null:
              this.directives && delete this.directives, n23 = null;
              break;
            default: {
              let i10 = JSON.stringify(e5);
              throw new Error(`Expected '1.1', '1.2' or null as first argument, but found: ${i10}`);
            }
          }
          if (t6.schema instanceof Object) this.schema = t6.schema;
          else if (n23) this.schema = new Ou.Schema(Object.assign(n23, t6));
          else throw new Error("With a null YAML version, the { schema: Schema } option is required");
        }
        toJS({ json: e5, jsonArg: t6, mapAsMap: n23, maxAliasCount: i10, onAnchor: r8, reviver: o9 } = {}) {
          let a7 = { anchors: /* @__PURE__ */ new Map(), doc: this, keep: !e5, mapAsMap: n23 === true, mapKeyWarned: false, maxAliasCount: typeof i10 == "number" ? i10 : 100 }, l8 = Tu.toJS(this.contents, t6 ?? "", a7);
          if (typeof r8 == "function") for (let { count: c14, res: u10 } of a7.anchors.values()) r8(u10, c14);
          return typeof o9 == "function" ? Iu.applyReviver(o9, { "": l8 }, "", l8) : l8;
        }
        toJSON(e5, t6) {
          return this.toJS({ json: true, jsonArg: e5, mapAsMap: false, onAnchor: t6 });
        }
        toString(e5 = {}) {
          if (this.errors.length > 0) throw new Error("Document with errors cannot be stringified");
          if ("indent" in e5 && (!Number.isInteger(e5.indent) || Number(e5.indent) <= 0)) {
            let t6 = JSON.stringify(e5.indent);
            throw new Error(`"indent" option must be a positive integer, not ${t6}`);
          }
          return ku.stringifyDocument(this, e5);
        }
      };
      function Ie7(s9) {
        if (K9.isCollection(s9)) return true;
        throw new Error("Expected a YAML collection as document contents");
      }
      Po.Document = Kn;
    });
    ft4 = o((ct5) => {
      "use strict";
      var lt6 = class extends Error {
        constructor(e5, t6, n23, i10) {
          super(), this.name = e5, this.code = n23, this.message = i10, this.pos = t6;
        }
      }, Rn = class extends lt6 {
        constructor(e5, t6, n23) {
          super("YAMLParseError", e5, t6, n23);
        }
      }, Yn = class extends lt6 {
        constructor(e5, t6, n23) {
          super("YAMLWarning", e5, t6, n23);
        }
      }, Cu = (s9, e5) => (t6) => {
        if (t6.pos[0] === -1) return;
        t6.linePos = t6.pos.map((a7) => e5.linePos(a7));
        let { line: n23, col: i10 } = t6.linePos[0];
        t6.message += ` at line ${n23}, column ${i10}`;
        let r8 = i10 - 1, o9 = s9.substring(e5.lineStarts[n23 - 1], e5.lineStarts[n23]).replace(/[\n\r]+$/, "");
        if (r8 >= 60 && o9.length > 80) {
          let a7 = Math.min(r8 - 39, o9.length - 79);
          o9 = "\u2026" + o9.substring(a7), r8 -= a7 - 1;
        }
        if (o9.length > 80 && (o9 = o9.substring(0, 79) + "\u2026"), n23 > 1 && /^ *$/.test(o9.substring(0, r8))) {
          let a7 = s9.substring(e5.lineStarts[n23 - 2], e5.lineStarts[n23 - 1]);
          a7.length > 80 && (a7 = a7.substring(0, 79) + `\u2026
`), o9 = a7 + o9;
        }
        if (/[^ ]/.test(o9)) {
          let a7 = 1, l8 = t6.linePos[1];
          l8?.line === n23 && l8.col > i10 && (a7 = Math.max(1, Math.min(l8.col - i10, 80 - r8)));
          let c14 = " ".repeat(r8) + "^".repeat(a7);
          t6.message += `:

${o9}
${c14}
`;
        }
      };
      ct5.YAMLError = lt6;
      ct5.YAMLParseError = Rn;
      ct5.YAMLWarning = Yn;
      ct5.prettifyError = Cu;
    });
    ut4 = o((Mo) => {
      "use strict";
      function Lu(s9, { flow: e5, indicator: t6, next: n23, offset: i10, onError: r8, parentIndent: o9, startOnNewline: a7 }) {
        let l8 = false, c14 = a7, u10 = a7, f11 = "", d16 = "", p17 = false, g18 = false, h16 = null, m24 = null, y18 = null, S16 = null, N14 = null, E12 = null, v20 = null;
        for (let w19 of s9) switch (g18 && (w19.type !== "space" && w19.type !== "newline" && w19.type !== "comma" && r8(w19.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), g18 = false), h16 && (c14 && w19.type !== "comment" && w19.type !== "newline" && r8(h16, "TAB_AS_INDENT", "Tabs are not allowed as indentation"), h16 = null), w19.type) {
          case "space":
            !e5 && (t6 !== "doc-start" || n23?.type !== "flow-collection") && w19.source.includes("	") && (h16 = w19), u10 = true;
            break;
          case "comment": {
            u10 || r8(w19, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
            let L18 = w19.source.substring(1) || " ";
            f11 ? f11 += d16 + L18 : f11 = L18, d16 = "", c14 = false;
            break;
          }
          case "newline":
            c14 ? f11 ? f11 += w19.source : (!E12 || t6 !== "seq-item-ind") && (l8 = true) : d16 += w19.source, c14 = true, p17 = true, (m24 || y18) && (S16 = w19), u10 = true;
            break;
          case "anchor":
            m24 && r8(w19, "MULTIPLE_ANCHORS", "A node can have at most one anchor"), w19.source.endsWith(":") && r8(w19.offset + w19.source.length - 1, "BAD_ALIAS", "Anchor ending in : is ambiguous", true), m24 = w19, v20 ?? (v20 = w19.offset), c14 = false, u10 = false, g18 = true;
            break;
          case "tag": {
            y18 && r8(w19, "MULTIPLE_TAGS", "A node can have at most one tag"), y18 = w19, v20 ?? (v20 = w19.offset), c14 = false, u10 = false, g18 = true;
            break;
          }
          case t6:
            (m24 || y18) && r8(w19, "BAD_PROP_ORDER", `Anchors and tags must be after the ${w19.source} indicator`), E12 && r8(w19, "UNEXPECTED_TOKEN", `Unexpected ${w19.source} in ${e5 ?? "collection"}`), E12 = w19, c14 = t6 === "seq-item-ind" || t6 === "explicit-key-ind", u10 = false;
            break;
          case "comma":
            if (e5) {
              N14 && r8(w19, "UNEXPECTED_TOKEN", `Unexpected , in ${e5}`), N14 = w19, c14 = false, u10 = false;
              break;
            }
          default:
            r8(w19, "UNEXPECTED_TOKEN", `Unexpected ${w19.type} token`), c14 = false, u10 = false;
        }
        let A13 = s9[s9.length - 1], I17 = A13 ? A13.offset + A13.source.length : i10;
        return g18 && n23 && n23.type !== "space" && n23.type !== "newline" && n23.type !== "comma" && (n23.type !== "scalar" || n23.source !== "") && r8(n23.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), h16 && (c14 && h16.indent <= o9 || n23?.type === "block-map" || n23?.type === "block-seq") && r8(h16, "TAB_AS_INDENT", "Tabs are not allowed as indentation"), { comma: N14, found: E12, spaceBefore: l8, comment: f11, hasNewline: p17, anchor: m24, tag: y18, newlineAfterProp: S16, end: I17, start: v20 ?? I17 };
      }
      Mo.resolveProps = Lu;
    });
    ms = o(($o) => {
      "use strict";
      function Un(s9) {
        if (!s9) return null;
        switch (s9.type) {
          case "alias":
          case "scalar":
          case "double-quoted-scalar":
          case "single-quoted-scalar":
            if (s9.source.includes(`
`)) return true;
            if (s9.end) {
              for (let e5 of s9.end) if (e5.type === "newline") return true;
            }
            return false;
          case "flow-collection":
            for (let e5 of s9.items) {
              for (let t6 of e5.start) if (t6.type === "newline") return true;
              if (e5.sep) {
                for (let t6 of e5.sep) if (t6.type === "newline") return true;
              }
              if (Un(e5.key) || Un(e5.value)) return true;
            }
            return false;
          default:
            return true;
        }
      }
      $o.containsNewline = Un;
    });
    Jn = o((_o) => {
      "use strict";
      var Pu = ms();
      function Mu(s9, e5, t6) {
        if (e5?.type === "flow-collection") {
          let n23 = e5.end[0];
          n23.indent === s9 && (n23.source === "]" || n23.source === "}") && Pu.containsNewline(e5) && t6(n23, "BAD_INDENT", "Flow end indicator should be more indented than parent", true);
        }
      }
      _o.flowIndentCheck = Mu;
    });
    Wn = o((Bo) => {
      "use strict";
      var xo = O13();
      function $u(s9, e5, t6) {
        let { uniqueKeys: n23 } = s9.options;
        if (n23 === false) return false;
        let i10 = typeof n23 == "function" ? n23 : (r8, o9) => r8 === o9 || xo.isScalar(r8) && xo.isScalar(o9) && r8.value === o9.value;
        return e5.some((r8) => i10(r8.key, t6));
      }
      Bo.mapIncludes = $u;
    });
    Yo = o((Ro) => {
      "use strict";
      var Fo = te7(), _u = ne6(), jo = ut4(), xu = ms(), Vo = Jn(), Bu = Wn(), Ko = "All mapping items must start at the same column";
      function Fu({ composeNode: s9, composeEmptyNode: e5 }, t6, n23, i10, r8) {
        let o9 = r8?.nodeClass ?? _u.YAMLMap, a7 = new o9(t6.schema);
        t6.atRoot && (t6.atRoot = false);
        let l8 = n23.offset, c14 = null;
        for (let u10 of n23.items) {
          let { start: f11, key: d16, sep: p17, value: g18 } = u10, h16 = jo.resolveProps(f11, { indicator: "explicit-key-ind", next: d16 ?? p17?.[0], offset: l8, onError: i10, parentIndent: n23.indent, startOnNewline: true }), m24 = !h16.found;
          if (m24) {
            if (d16 && (d16.type === "block-seq" ? i10(l8, "BLOCK_AS_IMPLICIT_KEY", "A block sequence may not be used as an implicit map key") : "indent" in d16 && d16.indent !== n23.indent && i10(l8, "BAD_INDENT", Ko)), !h16.anchor && !h16.tag && !p17) {
              c14 = h16.end, h16.comment && (a7.comment ? a7.comment += `
` + h16.comment : a7.comment = h16.comment);
              continue;
            }
            (h16.newlineAfterProp || xu.containsNewline(d16)) && i10(d16 ?? f11[f11.length - 1], "MULTILINE_IMPLICIT_KEY", "Implicit keys need to be on a single line");
          } else h16.found?.indent !== n23.indent && i10(l8, "BAD_INDENT", Ko);
          t6.atKey = true;
          let y18 = h16.end, S16 = d16 ? s9(t6, d16, h16, i10) : e5(t6, y18, f11, null, h16, i10);
          t6.schema.compat && Vo.flowIndentCheck(n23.indent, d16, i10), t6.atKey = false, Bu.mapIncludes(t6, a7.items, S16) && i10(y18, "DUPLICATE_KEY", "Map keys must be unique");
          let N14 = jo.resolveProps(p17 ?? [], { indicator: "map-value-ind", next: g18, offset: S16.range[2], onError: i10, parentIndent: n23.indent, startOnNewline: !d16 || d16.type === "block-scalar" });
          if (l8 = N14.end, N14.found) {
            m24 && (g18?.type === "block-map" && !N14.hasNewline && i10(l8, "BLOCK_AS_IMPLICIT_KEY", "Nested mappings are not allowed in compact mappings"), t6.options.strict && h16.start < N14.found.offset - 1024 && i10(S16.range, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit block mapping key"));
            let E12 = g18 ? s9(t6, g18, N14, i10) : e5(t6, l8, p17, null, N14, i10);
            t6.schema.compat && Vo.flowIndentCheck(n23.indent, g18, i10), l8 = E12.range[2];
            let v20 = new Fo.Pair(S16, E12);
            t6.options.keepSourceTokens && (v20.srcToken = u10), a7.items.push(v20);
          } else {
            m24 && i10(S16.range, "MISSING_CHAR", "Implicit map keys need to be followed by map values"), N14.comment && (S16.comment ? S16.comment += `
` + N14.comment : S16.comment = N14.comment);
            let E12 = new Fo.Pair(S16);
            t6.options.keepSourceTokens && (E12.srcToken = u10), a7.items.push(E12);
          }
        }
        return c14 && c14 < l8 && i10(c14, "IMPOSSIBLE", "Map comment with trailing content"), a7.range = [n23.offset, l8, c14 ?? l8], a7;
      }
      Ro.resolveBlockMap = Fu;
    });
    Jo = o((Uo) => {
      "use strict";
      var ju = ie4(), Vu = ut4(), Ku = Jn();
      function Ru({ composeNode: s9, composeEmptyNode: e5 }, t6, n23, i10, r8) {
        let o9 = r8?.nodeClass ?? ju.YAMLSeq, a7 = new o9(t6.schema);
        t6.atRoot && (t6.atRoot = false), t6.atKey && (t6.atKey = false);
        let l8 = n23.offset, c14 = null;
        for (let { start: u10, value: f11 } of n23.items) {
          let d16 = Vu.resolveProps(u10, { indicator: "seq-item-ind", next: f11, offset: l8, onError: i10, parentIndent: n23.indent, startOnNewline: true });
          if (!d16.found) if (d16.anchor || d16.tag || f11) f11?.type === "block-seq" ? i10(d16.end, "BAD_INDENT", "All sequence items must start at the same column") : i10(l8, "MISSING_CHAR", "Sequence item without - indicator");
          else {
            c14 = d16.end, d16.comment && (a7.comment = d16.comment);
            continue;
          }
          let p17 = f11 ? s9(t6, f11, d16, i10) : e5(t6, d16.end, u10, null, d16, i10);
          t6.schema.compat && Ku.flowIndentCheck(n23.indent, f11, i10), l8 = p17.range[2], a7.items.push(p17);
        }
        return a7.range = [n23.offset, l8, c14 ?? l8], a7;
      }
      Uo.resolveBlockSeq = Ru;
    });
    qe4 = o((Wo) => {
      "use strict";
      function Yu(s9, e5, t6, n23) {
        let i10 = "";
        if (s9) {
          let r8 = false, o9 = "";
          for (let a7 of s9) {
            let { source: l8, type: c14 } = a7;
            switch (c14) {
              case "space":
                r8 = true;
                break;
              case "comment": {
                t6 && !r8 && n23(a7, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
                let u10 = l8.substring(1) || " ";
                i10 ? i10 += o9 + u10 : i10 = u10, o9 = "";
                break;
              }
              case "newline":
                i10 && (o9 += l8), r8 = true;
                break;
              default:
                n23(a7, "UNEXPECTED_TOKEN", `Unexpected ${c14} at node end`);
            }
            e5 += l8.length;
          }
        }
        return { comment: i10, offset: e5 };
      }
      Wo.resolveEnd = Yu;
    });
    Ho = o((Qo) => {
      "use strict";
      var Uu = O13(), Ju = te7(), Go = ne6(), Wu = ie4(), Gu = qe4(), Xo = ut4(), Xu = ms(), Qu = Wn(), Gn = "Block collections are not allowed within flow collections", Xn = (s9) => s9 && (s9.type === "block-map" || s9.type === "block-seq");
      function Hu({ composeNode: s9, composeEmptyNode: e5 }, t6, n23, i10, r8) {
        let o9 = n23.start.source === "{", a7 = o9 ? "flow map" : "flow sequence", l8 = r8?.nodeClass ?? (o9 ? Go.YAMLMap : Wu.YAMLSeq), c14 = new l8(t6.schema);
        c14.flow = true;
        let u10 = t6.atRoot;
        u10 && (t6.atRoot = false), t6.atKey && (t6.atKey = false);
        let f11 = n23.offset + n23.start.source.length;
        for (let m24 = 0; m24 < n23.items.length; ++m24) {
          let y18 = n23.items[m24], { start: S16, key: N14, sep: E12, value: v20 } = y18, A13 = Xo.resolveProps(S16, { flow: a7, indicator: "explicit-key-ind", next: N14 ?? E12?.[0], offset: f11, onError: i10, parentIndent: n23.indent, startOnNewline: false });
          if (!A13.found) {
            if (!A13.anchor && !A13.tag && !E12 && !v20) {
              m24 === 0 && A13.comma ? i10(A13.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${a7}`) : m24 < n23.items.length - 1 && i10(A13.start, "UNEXPECTED_TOKEN", `Unexpected empty item in ${a7}`), A13.comment && (c14.comment ? c14.comment += `
` + A13.comment : c14.comment = A13.comment), f11 = A13.end;
              continue;
            }
            !o9 && t6.options.strict && Xu.containsNewline(N14) && i10(N14, "MULTILINE_IMPLICIT_KEY", "Implicit keys of flow sequence pairs need to be on a single line");
          }
          if (m24 === 0) A13.comma && i10(A13.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${a7}`);
          else if (A13.comma || i10(A13.start, "MISSING_CHAR", `Missing , between ${a7} items`), A13.comment) {
            let I17 = "";
            e: for (let w19 of S16) switch (w19.type) {
              case "comma":
              case "space":
                break;
              case "comment":
                I17 = w19.source.substring(1);
                break e;
              default:
                break e;
            }
            if (I17) {
              let w19 = c14.items[c14.items.length - 1];
              Uu.isPair(w19) && (w19 = w19.value ?? w19.key), w19.comment ? w19.comment += `
` + I17 : w19.comment = I17, A13.comment = A13.comment.substring(I17.length + 1);
            }
          }
          if (!o9 && !E12 && !A13.found) {
            let I17 = v20 ? s9(t6, v20, A13, i10) : e5(t6, A13.end, E12, null, A13, i10);
            c14.items.push(I17), f11 = I17.range[2], Xn(v20) && i10(I17.range, "BLOCK_IN_FLOW", Gn);
          } else {
            t6.atKey = true;
            let I17 = A13.end, w19 = N14 ? s9(t6, N14, A13, i10) : e5(t6, I17, S16, null, A13, i10);
            Xn(N14) && i10(w19.range, "BLOCK_IN_FLOW", Gn), t6.atKey = false;
            let L18 = Xo.resolveProps(E12 ?? [], { flow: a7, indicator: "map-value-ind", next: v20, offset: w19.range[2], onError: i10, parentIndent: n23.indent, startOnNewline: false });
            if (L18.found) {
              if (!o9 && !A13.found && t6.options.strict) {
                if (E12) for (let P19 of E12) {
                  if (P19 === L18.found) break;
                  if (P19.type === "newline") {
                    i10(P19, "MULTILINE_IMPLICIT_KEY", "Implicit keys of flow sequence pairs need to be on a single line");
                    break;
                  }
                }
                A13.start < L18.found.offset - 1024 && i10(L18.found, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit flow sequence key");
              }
            } else v20 && ("source" in v20 && v20.source?.[0] === ":" ? i10(v20, "MISSING_CHAR", `Missing space after : in ${a7}`) : i10(L18.start, "MISSING_CHAR", `Missing , or : between ${a7} items`));
            let H16 = v20 ? s9(t6, v20, L18, i10) : L18.found ? e5(t6, L18.end, E12, null, L18, i10) : null;
            H16 ? Xn(v20) && i10(H16.range, "BLOCK_IN_FLOW", Gn) : L18.comment && (w19.comment ? w19.comment += `
` + L18.comment : w19.comment = L18.comment);
            let ge8 = new Ju.Pair(w19, H16);
            if (t6.options.keepSourceTokens && (ge8.srcToken = y18), o9) {
              let P19 = c14;
              Qu.mapIncludes(t6, P19.items, w19) && i10(I17, "DUPLICATE_KEY", "Map keys must be unique"), P19.items.push(ge8);
            } else {
              let P19 = new Go.YAMLMap(t6.schema);
              P19.flow = true, P19.items.push(ge8);
              let vi2 = (H16 ?? w19).range;
              P19.range = [w19.range[0], vi2[1], vi2[2]], c14.items.push(P19);
            }
            f11 = H16 ? H16.range[2] : L18.end;
          }
        }
        let d16 = o9 ? "}" : "]", [p17, ...g18] = n23.end, h16 = f11;
        if (p17?.source === d16) h16 = p17.offset + p17.source.length;
        else {
          let m24 = a7[0].toUpperCase() + a7.substring(1), y18 = u10 ? `${m24} must end with a ${d16}` : `${m24} in block collection must be sufficiently indented and end with a ${d16}`;
          i10(f11, u10 ? "MISSING_CHAR" : "BAD_INDENT", y18), p17 && p17.source.length !== 1 && g18.unshift(p17);
        }
        if (g18.length > 0) {
          let m24 = Gu.resolveEnd(g18, h16, t6.options.strict, i10);
          m24.comment && (c14.comment ? c14.comment += `
` + m24.comment : c14.comment = m24.comment), c14.range = [n23.offset, h16, m24.offset];
        } else c14.range = [n23.offset, h16, h16];
        return c14;
      }
      Qo.resolveFlowCollection = Hu;
    });
    zo = o((Do) => {
      "use strict";
      var Du = O13(), zu = C16(), Zu = ne6(), ed = ie4(), td = Yo(), sd = Jo(), nd = Ho();
      function Qn(s9, e5, t6, n23, i10, r8) {
        let o9 = t6.type === "block-map" ? td.resolveBlockMap(s9, e5, t6, n23, r8) : t6.type === "block-seq" ? sd.resolveBlockSeq(s9, e5, t6, n23, r8) : nd.resolveFlowCollection(s9, e5, t6, n23, r8), a7 = o9.constructor;
        return i10 === "!" || i10 === a7.tagName ? (o9.tag = a7.tagName, o9) : (i10 && (o9.tag = i10), o9);
      }
      function id(s9, e5, t6, n23, i10) {
        let r8 = n23.tag, o9 = r8 ? e5.directives.tagName(r8.source, (d16) => i10(r8, "TAG_RESOLVE_FAILED", d16)) : null;
        if (t6.type === "block-seq") {
          let { anchor: d16, newlineAfterProp: p17 } = n23, g18 = d16 && r8 ? d16.offset > r8.offset ? d16 : r8 : d16 ?? r8;
          g18 && (!p17 || p17.offset < g18.offset) && i10(g18, "MISSING_CHAR", "Missing newline after block sequence props");
        }
        let a7 = t6.type === "block-map" ? "map" : t6.type === "block-seq" ? "seq" : t6.start.source === "{" ? "map" : "seq";
        if (!r8 || !o9 || o9 === "!" || o9 === Zu.YAMLMap.tagName && a7 === "map" || o9 === ed.YAMLSeq.tagName && a7 === "seq") return Qn(s9, e5, t6, i10, o9);
        let l8 = e5.schema.tags.find((d16) => d16.tag === o9 && d16.collection === a7);
        if (!l8) {
          let d16 = e5.schema.knownTags[o9];
          if (d16?.collection === a7) e5.schema.tags.push(Object.assign({}, d16, { default: false })), l8 = d16;
          else return d16 ? i10(r8, "BAD_COLLECTION_TYPE", `${d16.tag} used for ${a7} collection, but expects ${d16.collection ?? "scalar"}`, true) : i10(r8, "TAG_RESOLVE_FAILED", `Unresolved tag: ${o9}`, true), Qn(s9, e5, t6, i10, o9);
        }
        let c14 = Qn(s9, e5, t6, i10, o9, l8), u10 = l8.resolve?.(c14, (d16) => i10(r8, "TAG_RESOLVE_FAILED", d16), e5.options) ?? c14, f11 = Du.isNode(u10) ? u10 : new zu.Scalar(u10);
        return f11.range = c14.range, f11.tag = o9, l8?.format && (f11.format = l8.format), f11;
      }
      Do.composeCollection = id;
    });
    Dn = o((Zo) => {
      "use strict";
      var Hn = C16();
      function rd(s9, e5, t6) {
        let n23 = e5.offset, i10 = od(e5, s9.options.strict, t6);
        if (!i10) return { value: "", type: null, comment: "", range: [n23, n23, n23] };
        let r8 = i10.mode === ">" ? Hn.Scalar.BLOCK_FOLDED : Hn.Scalar.BLOCK_LITERAL, o9 = e5.source ? ad(e5.source) : [], a7 = o9.length;
        for (let h16 = o9.length - 1; h16 >= 0; --h16) {
          let m24 = o9[h16][1];
          if (m24 === "" || m24 === "\r") a7 = h16;
          else break;
        }
        if (a7 === 0) {
          let h16 = i10.chomp === "+" && o9.length > 0 ? `
`.repeat(Math.max(1, o9.length - 1)) : "", m24 = n23 + i10.length;
          return e5.source && (m24 += e5.source.length), { value: h16, type: r8, comment: i10.comment, range: [n23, m24, m24] };
        }
        let l8 = e5.indent + i10.indent, c14 = e5.offset + i10.length, u10 = 0;
        for (let h16 = 0; h16 < a7; ++h16) {
          let [m24, y18] = o9[h16];
          if (y18 === "" || y18 === "\r") i10.indent === 0 && m24.length > l8 && (l8 = m24.length);
          else {
            m24.length < l8 && t6(c14 + m24.length, "MISSING_CHAR", "Block scalars with more-indented leading empty lines must use an explicit indentation indicator"), i10.indent === 0 && (l8 = m24.length), u10 = h16, l8 === 0 && !s9.atRoot && t6(c14, "BAD_INDENT", "Block scalar values in collections must be indented");
            break;
          }
          c14 += m24.length + y18.length + 1;
        }
        for (let h16 = o9.length - 1; h16 >= a7; --h16) o9[h16][0].length > l8 && (a7 = h16 + 1);
        let f11 = "", d16 = "", p17 = false;
        for (let h16 = 0; h16 < u10; ++h16) f11 += o9[h16][0].slice(l8) + `
`;
        for (let h16 = u10; h16 < a7; ++h16) {
          let [m24, y18] = o9[h16];
          c14 += m24.length + y18.length + 1;
          let S16 = y18[y18.length - 1] === "\r";
          if (S16 && (y18 = y18.slice(0, -1)), y18 && m24.length < l8) {
            let E12 = `Block scalar lines must not be less indented than their ${i10.indent ? "explicit indentation indicator" : "first line"}`;
            t6(c14 - y18.length - (S16 ? 2 : 1), "BAD_INDENT", E12), m24 = "";
          }
          r8 === Hn.Scalar.BLOCK_LITERAL ? (f11 += d16 + m24.slice(l8) + y18, d16 = `
`) : m24.length > l8 || y18[0] === "	" ? (d16 === " " ? d16 = `
` : !p17 && d16 === `
` && (d16 = `

`), f11 += d16 + m24.slice(l8) + y18, d16 = `
`, p17 = true) : y18 === "" ? d16 === `
` ? f11 += `
` : d16 = `
` : (f11 += d16 + y18, d16 = " ", p17 = false);
        }
        switch (i10.chomp) {
          case "-":
            break;
          case "+":
            for (let h16 = a7; h16 < o9.length; ++h16) f11 += `
` + o9[h16][0].slice(l8);
            f11[f11.length - 1] !== `
` && (f11 += `
`);
            break;
          default:
            f11 += `
`;
        }
        let g18 = n23 + i10.length + e5.source.length;
        return { value: f11, type: r8, comment: i10.comment, range: [n23, g18, g18] };
      }
      function od({ offset: s9, props: e5 }, t6, n23) {
        if (e5[0].type !== "block-scalar-header") return n23(e5[0], "IMPOSSIBLE", "Block scalar header not found"), null;
        let { source: i10 } = e5[0], r8 = i10[0], o9 = 0, a7 = "", l8 = -1;
        for (let d16 = 1; d16 < i10.length; ++d16) {
          let p17 = i10[d16];
          if (!a7 && (p17 === "-" || p17 === "+")) a7 = p17;
          else {
            let g18 = Number(p17);
            !o9 && g18 ? o9 = g18 : l8 === -1 && (l8 = s9 + d16);
          }
        }
        l8 !== -1 && n23(l8, "UNEXPECTED_TOKEN", `Block scalar header includes extra characters: ${i10}`);
        let c14 = false, u10 = "", f11 = i10.length;
        for (let d16 = 1; d16 < e5.length; ++d16) {
          let p17 = e5[d16];
          switch (p17.type) {
            case "space":
              c14 = true;
            case "newline":
              f11 += p17.source.length;
              break;
            case "comment":
              t6 && !c14 && n23(p17, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters"), f11 += p17.source.length, u10 = p17.source.substring(1);
              break;
            case "error":
              n23(p17, "UNEXPECTED_TOKEN", p17.message), f11 += p17.source.length;
              break;
            default: {
              let g18 = `Unexpected token in block scalar header: ${p17.type}`;
              n23(p17, "UNEXPECTED_TOKEN", g18);
              let h16 = p17.source;
              h16 && typeof h16 == "string" && (f11 += h16.length);
            }
          }
        }
        return { mode: r8, indent: o9, chomp: a7, comment: u10, length: f11 };
      }
      function ad(s9) {
        let e5 = s9.split(/\n( *)/), t6 = e5[0], n23 = t6.match(/^( *)/), r8 = [n23?.[1] ? [n23[1], t6.slice(n23[1].length)] : ["", t6]];
        for (let o9 = 1; o9 < e5.length; o9 += 2) r8.push([e5[o9], e5[o9 + 1]]);
        return r8;
      }
      Zo.resolveBlockScalar = rd;
    });
    Zn = o((ta) => {
      "use strict";
      var zn = C16(), ld = qe4();
      function cd(s9, e5, t6) {
        let { offset: n23, type: i10, source: r8, end: o9 } = s9, a7, l8, c14 = (d16, p17, g18) => t6(n23 + d16, p17, g18);
        switch (i10) {
          case "scalar":
            a7 = zn.Scalar.PLAIN, l8 = fd(r8, c14);
            break;
          case "single-quoted-scalar":
            a7 = zn.Scalar.QUOTE_SINGLE, l8 = ud(r8, c14);
            break;
          case "double-quoted-scalar":
            a7 = zn.Scalar.QUOTE_DOUBLE, l8 = dd(r8, c14);
            break;
          default:
            return t6(s9, "UNEXPECTED_TOKEN", `Expected a flow scalar value, but found: ${i10}`), { value: "", type: null, comment: "", range: [n23, n23 + r8.length, n23 + r8.length] };
        }
        let u10 = n23 + r8.length, f11 = ld.resolveEnd(o9, u10, e5, t6);
        return { value: l8, type: a7, comment: f11.comment, range: [n23, u10, f11.offset] };
      }
      function fd(s9, e5) {
        let t6 = "";
        switch (s9[0]) {
          case "	":
            t6 = "a tab character";
            break;
          case ",":
            t6 = "flow indicator character ,";
            break;
          case "%":
            t6 = "directive indicator character %";
            break;
          case "|":
          case ">": {
            t6 = `block scalar indicator ${s9[0]}`;
            break;
          }
          case "@":
          case "`": {
            t6 = `reserved character ${s9[0]}`;
            break;
          }
        }
        return t6 && e5(0, "BAD_SCALAR_START", `Plain value cannot start with ${t6}`), ea(s9);
      }
      function ud(s9, e5) {
        return (s9[s9.length - 1] !== "'" || s9.length === 1) && e5(s9.length, "MISSING_CHAR", "Missing closing 'quote"), ea(s9.slice(1, -1)).replace(/''/g, "'");
      }
      function ea(s9) {
        let e5, t6;
        try {
          e5 = new RegExp(`(.*?)(?<![ 	])[ 	]*\r?
`, "sy"), t6 = new RegExp(`[ 	]*(.*?)(?:(?<![ 	])[ 	]*)?\r?
`, "sy");
        } catch {
          e5 = /(.*?)[ \t]*\r?\n/sy, t6 = /[ \t]*(.*?)[ \t]*\r?\n/sy;
        }
        let n23 = e5.exec(s9);
        if (!n23) return s9;
        let i10 = n23[1], r8 = " ", o9 = e5.lastIndex;
        for (t6.lastIndex = o9; n23 = t6.exec(s9); ) n23[1] === "" ? r8 === `
` ? i10 += r8 : r8 = `
` : (i10 += r8 + n23[1], r8 = " "), o9 = t6.lastIndex;
        let a7 = /[ \t]*(.*)/sy;
        return a7.lastIndex = o9, n23 = a7.exec(s9), i10 + r8 + (n23?.[1] ?? "");
      }
      function dd(s9, e5) {
        let t6 = "";
        for (let n23 = 1; n23 < s9.length - 1; ++n23) {
          let i10 = s9[n23];
          if (!(i10 === "\r" && s9[n23 + 1] === `
`)) if (i10 === `
`) {
            let { fold: r8, offset: o9 } = hd(s9, n23);
            t6 += r8, n23 = o9;
          } else if (i10 === "\\") {
            let r8 = s9[++n23], o9 = pd[r8];
            if (o9) t6 += o9;
            else if (r8 === `
`) for (r8 = s9[n23 + 1]; r8 === " " || r8 === "	"; ) r8 = s9[++n23 + 1];
            else if (r8 === "\r" && s9[n23 + 1] === `
`) for (r8 = s9[++n23 + 1]; r8 === " " || r8 === "	"; ) r8 = s9[++n23 + 1];
            else if (r8 === "x" || r8 === "u" || r8 === "U") {
              let a7 = { x: 2, u: 4, U: 8 }[r8];
              t6 += md(s9, n23 + 1, a7, e5), n23 += a7;
            } else {
              let a7 = s9.substr(n23 - 1, 2);
              e5(n23 - 1, "BAD_DQ_ESCAPE", `Invalid escape sequence ${a7}`), t6 += a7;
            }
          } else if (i10 === " " || i10 === "	") {
            let r8 = n23, o9 = s9[n23 + 1];
            for (; o9 === " " || o9 === "	"; ) o9 = s9[++n23 + 1];
            o9 !== `
` && !(o9 === "\r" && s9[n23 + 2] === `
`) && (t6 += n23 > r8 ? s9.slice(r8, n23 + 1) : i10);
          } else t6 += i10;
        }
        return (s9[s9.length - 1] !== '"' || s9.length === 1) && e5(s9.length, "MISSING_CHAR", 'Missing closing "quote'), t6;
      }
      function hd(s9, e5) {
        let t6 = "", n23 = s9[e5 + 1];
        for (; (n23 === " " || n23 === "	" || n23 === `
` || n23 === "\r") && !(n23 === "\r" && s9[e5 + 2] !== `
`); ) n23 === `
` && (t6 += `
`), e5 += 1, n23 = s9[e5 + 1];
        return t6 || (t6 = " "), { fold: t6, offset: e5 };
      }
      var pd = { 0: "\0", a: "\x07", b: "\b", e: "\x1B", f: "\f", n: `
`, r: "\r", t: "	", v: "\v", N: "\x85", _: "\xA0", L: "\u2028", P: "\u2029", " ": " ", '"': '"', "/": "/", "\\": "\\", "	": "	" };
      function md(s9, e5, t6, n23) {
        let i10 = s9.substr(e5, t6), o9 = i10.length === t6 && /^[0-9a-fA-F]+$/.test(i10) ? parseInt(i10, 16) : NaN;
        if (isNaN(o9)) {
          let a7 = s9.substr(e5 - 2, t6 + 2);
          return n23(e5 - 2, "BAD_DQ_ESCAPE", `Invalid escape sequence ${a7}`), a7;
        }
        return String.fromCodePoint(o9);
      }
      ta.resolveFlowScalar = cd;
    });
    ia = o((na) => {
      "use strict";
      var pe8 = O13(), sa = C16(), gd = Dn(), yd = Zn();
      function bd(s9, e5, t6, n23) {
        let { value: i10, type: r8, comment: o9, range: a7 } = e5.type === "block-scalar" ? gd.resolveBlockScalar(s9, e5, n23) : yd.resolveFlowScalar(e5, s9.options.strict, n23), l8 = t6 ? s9.directives.tagName(t6.source, (f11) => n23(t6, "TAG_RESOLVE_FAILED", f11)) : null, c14;
        s9.options.stringKeys && s9.atKey ? c14 = s9.schema[pe8.SCALAR] : l8 ? c14 = wd(s9.schema, i10, l8, t6, n23) : e5.type === "scalar" ? c14 = Sd(s9, i10, e5, n23) : c14 = s9.schema[pe8.SCALAR];
        let u10;
        try {
          let f11 = c14.resolve(i10, (d16) => n23(t6 ?? e5, "TAG_RESOLVE_FAILED", d16), s9.options);
          u10 = pe8.isScalar(f11) ? f11 : new sa.Scalar(f11);
        } catch (f11) {
          let d16 = f11 instanceof Error ? f11.message : String(f11);
          n23(t6 ?? e5, "TAG_RESOLVE_FAILED", d16), u10 = new sa.Scalar(i10);
        }
        return u10.range = a7, u10.source = i10, r8 && (u10.type = r8), l8 && (u10.tag = l8), c14.format && (u10.format = c14.format), o9 && (u10.comment = o9), u10;
      }
      function wd(s9, e5, t6, n23, i10) {
        if (t6 === "!") return s9[pe8.SCALAR];
        let r8 = [];
        for (let a7 of s9.tags) if (!a7.collection && a7.tag === t6) if (a7.default && a7.test) r8.push(a7);
        else return a7;
        for (let a7 of r8) if (a7.test?.test(e5)) return a7;
        let o9 = s9.knownTags[t6];
        return o9 && !o9.collection ? (s9.tags.push(Object.assign({}, o9, { default: false, test: void 0 })), o9) : (i10(n23, "TAG_RESOLVE_FAILED", `Unresolved tag: ${t6}`, t6 !== "tag:yaml.org,2002:str"), s9[pe8.SCALAR]);
      }
      function Sd({ atKey: s9, directives: e5, schema: t6 }, n23, i10, r8) {
        let o9 = t6.tags.find((a7) => (a7.default === true || s9 && a7.default === "key") && a7.test?.test(n23)) || t6[pe8.SCALAR];
        if (t6.compat) {
          let a7 = t6.compat.find((l8) => l8.default && l8.test?.test(n23)) ?? t6[pe8.SCALAR];
          if (o9.tag !== a7.tag) {
            let l8 = e5.tagString(o9.tag), c14 = e5.tagString(a7.tag), u10 = `Value may be parsed as either ${l8} or ${c14}`;
            r8(i10, "TAG_RESOLVE_FAILED", u10, true);
          }
        }
        return o9;
      }
      na.composeScalar = bd;
    });
    oa = o((ra) => {
      "use strict";
      function Nd(s9, e5, t6) {
        if (e5) {
          t6 ?? (t6 = e5.length);
          for (let n23 = t6 - 1; n23 >= 0; --n23) {
            let i10 = e5[n23];
            switch (i10.type) {
              case "space":
              case "comment":
              case "newline":
                s9 -= i10.source.length;
                continue;
            }
            for (i10 = e5[++n23]; i10?.type === "space"; ) s9 += i10.source.length, i10 = e5[++n23];
            break;
          }
        }
        return s9;
      }
      ra.emptyScalarPosition = Nd;
    });
    ca = o((ti) => {
      "use strict";
      var Ed = Ue4(), vd = O13(), Ad = zo(), aa = ia(), Td = qe4(), Od = oa(), kd = { composeNode: la, composeEmptyNode: ei };
      function la(s9, e5, t6, n23) {
        let i10 = s9.atKey, { spaceBefore: r8, comment: o9, anchor: a7, tag: l8 } = t6, c14, u10 = true;
        switch (e5.type) {
          case "alias":
            c14 = Id(s9, e5, n23), (a7 || l8) && n23(e5, "ALIAS_PROPS", "An alias node must not specify any properties");
            break;
          case "scalar":
          case "single-quoted-scalar":
          case "double-quoted-scalar":
          case "block-scalar":
            c14 = aa.composeScalar(s9, e5, l8, n23), a7 && (c14.anchor = a7.source.substring(1));
            break;
          case "block-map":
          case "block-seq":
          case "flow-collection":
            c14 = Ad.composeCollection(kd, s9, e5, t6, n23), a7 && (c14.anchor = a7.source.substring(1));
            break;
          default: {
            let f11 = e5.type === "error" ? e5.message : `Unsupported token (type: ${e5.type})`;
            n23(e5, "UNEXPECTED_TOKEN", f11), c14 = ei(s9, e5.offset, void 0, null, t6, n23), u10 = false;
          }
        }
        return a7 && c14.anchor === "" && n23(a7, "BAD_ALIAS", "Anchor cannot be an empty string"), i10 && s9.options.stringKeys && (!vd.isScalar(c14) || typeof c14.value != "string" || c14.tag && c14.tag !== "tag:yaml.org,2002:str") && n23(l8 ?? e5, "NON_STRING_KEY", "With stringKeys, all keys must be strings"), r8 && (c14.spaceBefore = true), o9 && (e5.type === "scalar" && e5.source === "" ? c14.comment = o9 : c14.commentBefore = o9), s9.options.keepSourceTokens && u10 && (c14.srcToken = e5), c14;
      }
      function ei(s9, e5, t6, n23, { spaceBefore: i10, comment: r8, anchor: o9, tag: a7, end: l8 }, c14) {
        let u10 = { type: "scalar", offset: Od.emptyScalarPosition(e5, t6, n23), indent: -1, source: "" }, f11 = aa.composeScalar(s9, u10, a7, c14);
        return o9 && (f11.anchor = o9.source.substring(1), f11.anchor === "" && c14(o9, "BAD_ALIAS", "Anchor cannot be an empty string")), i10 && (f11.spaceBefore = true), r8 && (f11.comment = r8, f11.range[2] = l8), f11;
      }
      function Id({ options: s9 }, { offset: e5, source: t6, end: n23 }, i10) {
        let r8 = new Ed.Alias(t6.substring(1));
        r8.source === "" && i10(e5, "BAD_ALIAS", "Alias cannot be an empty string"), r8.source.endsWith(":") && i10(e5 + t6.length - 1, "BAD_ALIAS", "Alias ending in : is ambiguous", true);
        let o9 = e5 + t6.length, a7 = Td.resolveEnd(n23, o9, s9.strict, i10);
        return r8.range = [e5, o9, a7.offset], a7.comment && (r8.comment = a7.comment), r8;
      }
      ti.composeEmptyNode = ei;
      ti.composeNode = la;
    });
    da = o((ua) => {
      "use strict";
      var qd = at5(), fa2 = ca(), Cd = qe4(), Ld = ut4();
      function Pd(s9, e5, { offset: t6, start: n23, value: i10, end: r8 }, o9) {
        let a7 = Object.assign({ _directives: e5 }, s9), l8 = new qd.Document(void 0, a7), c14 = { atKey: false, atRoot: true, directives: l8.directives, options: l8.options, schema: l8.schema }, u10 = Ld.resolveProps(n23, { indicator: "doc-start", next: i10 ?? r8?.[0], offset: t6, onError: o9, parentIndent: 0, startOnNewline: true });
        u10.found && (l8.directives.docStart = true, i10 && (i10.type === "block-map" || i10.type === "block-seq") && !u10.hasNewline && o9(u10.end, "MISSING_CHAR", "Block collection cannot start on same line with directives-end marker")), l8.contents = i10 ? fa2.composeNode(c14, i10, u10, o9) : fa2.composeEmptyNode(c14, u10.end, n23, null, u10, o9);
        let f11 = l8.contents.range[2], d16 = Cd.resolveEnd(r8, f11, false, o9);
        return d16.comment && (l8.comment = d16.comment), l8.range = [t6, f11, d16.offset], l8;
      }
      ua.composeDoc = Pd;
    });
    ni = o((ma) => {
      "use strict";
      var Md = m3("process"), $d = Ks(), _d = at5(), dt5 = ft4(), ha2 = O13(), xd = da(), Bd = qe4();
      function ht3(s9) {
        if (typeof s9 == "number") return [s9, s9 + 1];
        if (Array.isArray(s9)) return s9.length === 2 ? s9 : [s9[0], s9[1]];
        let { offset: e5, source: t6 } = s9;
        return [e5, e5 + (typeof t6 == "string" ? t6.length : 1)];
      }
      function pa2(s9) {
        let e5 = "", t6 = false, n23 = false;
        for (let i10 = 0; i10 < s9.length; ++i10) {
          let r8 = s9[i10];
          switch (r8[0]) {
            case "#":
              e5 += (e5 === "" ? "" : n23 ? `

` : `
`) + (r8.substring(1) || " "), t6 = true, n23 = false;
              break;
            case "%":
              s9[i10 + 1]?.[0] !== "#" && (i10 += 1), t6 = false;
              break;
            default:
              t6 || (n23 = true), t6 = false;
          }
        }
        return { comment: e5, afterEmptyLine: n23 };
      }
      var si = class {
        constructor(e5 = {}) {
          this.doc = null, this.atDirectives = false, this.prelude = [], this.errors = [], this.warnings = [], this.onError = (t6, n23, i10, r8) => {
            let o9 = ht3(t6);
            r8 ? this.warnings.push(new dt5.YAMLWarning(o9, n23, i10)) : this.errors.push(new dt5.YAMLParseError(o9, n23, i10));
          }, this.directives = new $d.Directives({ version: e5.version || "1.2" }), this.options = e5;
        }
        decorate(e5, t6) {
          let { comment: n23, afterEmptyLine: i10 } = pa2(this.prelude);
          if (n23) {
            let r8 = e5.contents;
            if (t6) e5.comment = e5.comment ? `${e5.comment}
${n23}` : n23;
            else if (i10 || e5.directives.docStart || !r8) e5.commentBefore = n23;
            else if (ha2.isCollection(r8) && !r8.flow && r8.items.length > 0) {
              let o9 = r8.items[0];
              ha2.isPair(o9) && (o9 = o9.key);
              let a7 = o9.commentBefore;
              o9.commentBefore = a7 ? `${n23}
${a7}` : n23;
            } else {
              let o9 = r8.commentBefore;
              r8.commentBefore = o9 ? `${n23}
${o9}` : n23;
            }
          }
          t6 ? (Array.prototype.push.apply(e5.errors, this.errors), Array.prototype.push.apply(e5.warnings, this.warnings)) : (e5.errors = this.errors, e5.warnings = this.warnings), this.prelude = [], this.errors = [], this.warnings = [];
        }
        streamInfo() {
          return { comment: pa2(this.prelude).comment, directives: this.directives, errors: this.errors, warnings: this.warnings };
        }
        *compose(e5, t6 = false, n23 = -1) {
          for (let i10 of e5) yield* this.next(i10);
          yield* this.end(t6, n23);
        }
        *next(e5) {
          switch (Md.env.LOG_STREAM && console.dir(e5, { depth: null }), e5.type) {
            case "directive":
              this.directives.add(e5.source, (t6, n23, i10) => {
                let r8 = ht3(e5);
                r8[0] += t6, this.onError(r8, "BAD_DIRECTIVE", n23, i10);
              }), this.prelude.push(e5.source), this.atDirectives = true;
              break;
            case "document": {
              let t6 = xd.composeDoc(this.options, this.directives, e5, this.onError);
              this.atDirectives && !t6.directives.docStart && this.onError(e5, "MISSING_CHAR", "Missing directives-end/doc-start indicator line"), this.decorate(t6, false), this.doc && (yield this.doc), this.doc = t6, this.atDirectives = false;
              break;
            }
            case "byte-order-mark":
            case "space":
              break;
            case "comment":
            case "newline":
              this.prelude.push(e5.source);
              break;
            case "error": {
              let t6 = e5.source ? `${e5.message}: ${JSON.stringify(e5.source)}` : e5.message, n23 = new dt5.YAMLParseError(ht3(e5), "UNEXPECTED_TOKEN", t6);
              this.atDirectives || !this.doc ? this.errors.push(n23) : this.doc.errors.push(n23);
              break;
            }
            case "doc-end": {
              if (!this.doc) {
                let n23 = "Unexpected doc-end without preceding document";
                this.errors.push(new dt5.YAMLParseError(ht3(e5), "UNEXPECTED_TOKEN", n23));
                break;
              }
              this.doc.directives.docEnd = true;
              let t6 = Bd.resolveEnd(e5.end, e5.offset + e5.source.length, this.doc.options.strict, this.onError);
              if (this.decorate(this.doc, true), t6.comment) {
                let n23 = this.doc.comment;
                this.doc.comment = n23 ? `${n23}
${t6.comment}` : t6.comment;
              }
              this.doc.range[2] = t6.offset;
              break;
            }
            default:
              this.errors.push(new dt5.YAMLParseError(ht3(e5), "UNEXPECTED_TOKEN", `Unsupported token ${e5.type}`));
          }
        }
        *end(e5 = false, t6 = -1) {
          if (this.doc) this.decorate(this.doc, true), yield this.doc, this.doc = null;
          else if (e5) {
            let n23 = Object.assign({ _directives: this.directives }, this.options), i10 = new _d.Document(void 0, n23);
            this.atDirectives && this.onError(t6, "MISSING_CHAR", "Missing directives-end indicator line"), i10.range = [0, t6, t6], this.decorate(i10, false), yield i10;
          }
        }
      };
      ma.Composer = si;
    });
    ba = o((gs) => {
      "use strict";
      var Fd = Dn(), jd = Zn(), Vd = ft4(), ga = Qe5();
      function Kd(s9, e5 = true, t6) {
        if (s9) {
          let n23 = (i10, r8, o9) => {
            let a7 = typeof i10 == "number" ? i10 : Array.isArray(i10) ? i10[0] : i10.offset;
            if (t6) t6(a7, r8, o9);
            else throw new Vd.YAMLParseError([a7, a7 + 1], r8, o9);
          };
          switch (s9.type) {
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return jd.resolveFlowScalar(s9, e5, n23);
            case "block-scalar":
              return Fd.resolveBlockScalar({ options: { strict: e5 } }, s9, n23);
          }
        }
        return null;
      }
      function Rd(s9, e5) {
        let { implicitKey: t6 = false, indent: n23, inFlow: i10 = false, offset: r8 = -1, type: o9 = "PLAIN" } = e5, a7 = ga.stringifyString({ type: o9, value: s9 }, { implicitKey: t6, indent: n23 > 0 ? " ".repeat(n23) : "", inFlow: i10, options: { blockQuote: true, lineWidth: -1 } }), l8 = e5.end ?? [{ type: "newline", offset: -1, indent: n23, source: `
` }];
        switch (a7[0]) {
          case "|":
          case ">": {
            let c14 = a7.indexOf(`
`), u10 = a7.substring(0, c14), f11 = a7.substring(c14 + 1) + `
`, d16 = [{ type: "block-scalar-header", offset: r8, indent: n23, source: u10 }];
            return ya(d16, l8) || d16.push({ type: "newline", offset: -1, indent: n23, source: `
` }), { type: "block-scalar", offset: r8, indent: n23, props: d16, source: f11 };
          }
          case '"':
            return { type: "double-quoted-scalar", offset: r8, indent: n23, source: a7, end: l8 };
          case "'":
            return { type: "single-quoted-scalar", offset: r8, indent: n23, source: a7, end: l8 };
          default:
            return { type: "scalar", offset: r8, indent: n23, source: a7, end: l8 };
        }
      }
      function Yd(s9, e5, t6 = {}) {
        let { afterKey: n23 = false, implicitKey: i10 = false, inFlow: r8 = false, type: o9 } = t6, a7 = "indent" in s9 ? s9.indent : null;
        if (n23 && typeof a7 == "number" && (a7 += 2), !o9) switch (s9.type) {
          case "single-quoted-scalar":
            o9 = "QUOTE_SINGLE";
            break;
          case "double-quoted-scalar":
            o9 = "QUOTE_DOUBLE";
            break;
          case "block-scalar": {
            let c14 = s9.props[0];
            if (c14.type !== "block-scalar-header") throw new Error("Invalid block scalar header");
            o9 = c14.source[0] === ">" ? "BLOCK_FOLDED" : "BLOCK_LITERAL";
            break;
          }
          default:
            o9 = "PLAIN";
        }
        let l8 = ga.stringifyString({ type: o9, value: e5 }, { implicitKey: i10 || a7 === null, indent: a7 !== null && a7 > 0 ? " ".repeat(a7) : "", inFlow: r8, options: { blockQuote: true, lineWidth: -1 } });
        switch (l8[0]) {
          case "|":
          case ">":
            Ud(s9, l8);
            break;
          case '"':
            ii(s9, l8, "double-quoted-scalar");
            break;
          case "'":
            ii(s9, l8, "single-quoted-scalar");
            break;
          default:
            ii(s9, l8, "scalar");
        }
      }
      function Ud(s9, e5) {
        let t6 = e5.indexOf(`
`), n23 = e5.substring(0, t6), i10 = e5.substring(t6 + 1) + `
`;
        if (s9.type === "block-scalar") {
          let r8 = s9.props[0];
          if (r8.type !== "block-scalar-header") throw new Error("Invalid block scalar header");
          r8.source = n23, s9.source = i10;
        } else {
          let { offset: r8 } = s9, o9 = "indent" in s9 ? s9.indent : -1, a7 = [{ type: "block-scalar-header", offset: r8, indent: o9, source: n23 }];
          ya(a7, "end" in s9 ? s9.end : void 0) || a7.push({ type: "newline", offset: -1, indent: o9, source: `
` });
          for (let l8 of Object.keys(s9)) l8 !== "type" && l8 !== "offset" && delete s9[l8];
          Object.assign(s9, { type: "block-scalar", indent: o9, props: a7, source: i10 });
        }
      }
      function ya(s9, e5) {
        if (e5) for (let t6 of e5) switch (t6.type) {
          case "space":
          case "comment":
            s9.push(t6);
            break;
          case "newline":
            return s9.push(t6), true;
        }
        return false;
      }
      function ii(s9, e5, t6) {
        switch (s9.type) {
          case "scalar":
          case "double-quoted-scalar":
          case "single-quoted-scalar":
            s9.type = t6, s9.source = e5;
            break;
          case "block-scalar": {
            let n23 = s9.props.slice(1), i10 = e5.length;
            s9.props[0].type === "block-scalar-header" && (i10 -= s9.props[0].source.length);
            for (let r8 of n23) r8.offset += i10;
            delete s9.props, Object.assign(s9, { type: t6, source: e5, end: n23 });
            break;
          }
          case "block-map":
          case "block-seq": {
            let i10 = { type: "newline", offset: s9.offset + e5.length, indent: s9.indent, source: `
` };
            delete s9.items, Object.assign(s9, { type: t6, source: e5, end: [i10] });
            break;
          }
          default: {
            let n23 = "indent" in s9 ? s9.indent : -1, i10 = "end" in s9 && Array.isArray(s9.end) ? s9.end.filter((r8) => r8.type === "space" || r8.type === "comment" || r8.type === "newline") : [];
            for (let r8 of Object.keys(s9)) r8 !== "type" && r8 !== "offset" && delete s9[r8];
            Object.assign(s9, { type: t6, indent: n23, source: e5, end: i10 });
          }
        }
      }
      gs.createScalarToken = Rd;
      gs.resolveAsScalar = Kd;
      gs.setScalarValue = Yd;
    });
    Sa = o((wa) => {
      "use strict";
      var Jd = (s9) => "type" in s9 ? bs(s9) : ys(s9);
      function bs(s9) {
        switch (s9.type) {
          case "block-scalar": {
            let e5 = "";
            for (let t6 of s9.props) e5 += bs(t6);
            return e5 + s9.source;
          }
          case "block-map":
          case "block-seq": {
            let e5 = "";
            for (let t6 of s9.items) e5 += ys(t6);
            return e5;
          }
          case "flow-collection": {
            let e5 = s9.start.source;
            for (let t6 of s9.items) e5 += ys(t6);
            for (let t6 of s9.end) e5 += t6.source;
            return e5;
          }
          case "document": {
            let e5 = ys(s9);
            if (s9.end) for (let t6 of s9.end) e5 += t6.source;
            return e5;
          }
          default: {
            let e5 = s9.source;
            if ("end" in s9 && s9.end) for (let t6 of s9.end) e5 += t6.source;
            return e5;
          }
        }
      }
      function ys({ start: s9, key: e5, sep: t6, value: n23 }) {
        let i10 = "";
        for (let r8 of s9) i10 += r8.source;
        if (e5 && (i10 += bs(e5)), t6) for (let r8 of t6) i10 += r8.source;
        return n23 && (i10 += bs(n23)), i10;
      }
      wa.stringify = Jd;
    });
    Aa = o((va) => {
      "use strict";
      var ri = Symbol("break visit"), Wd = Symbol("skip children"), Na = Symbol("remove item");
      function me5(s9, e5) {
        "type" in s9 && s9.type === "document" && (s9 = { start: s9.start, value: s9.value }), Ea(Object.freeze([]), s9, e5);
      }
      me5.BREAK = ri;
      me5.SKIP = Wd;
      me5.REMOVE = Na;
      me5.itemAtPath = (s9, e5) => {
        let t6 = s9;
        for (let [n23, i10] of e5) {
          let r8 = t6?.[n23];
          if (r8 && "items" in r8) t6 = r8.items[i10];
          else return;
        }
        return t6;
      };
      me5.parentCollection = (s9, e5) => {
        let t6 = me5.itemAtPath(s9, e5.slice(0, -1)), n23 = e5[e5.length - 1][0], i10 = t6?.[n23];
        if (i10 && "items" in i10) return i10;
        throw new Error("Parent collection not found");
      };
      function Ea(s9, e5, t6) {
        let n23 = t6(e5, s9);
        if (typeof n23 == "symbol") return n23;
        for (let i10 of ["key", "value"]) {
          let r8 = e5[i10];
          if (r8 && "items" in r8) {
            for (let o9 = 0; o9 < r8.items.length; ++o9) {
              let a7 = Ea(Object.freeze(s9.concat([[i10, o9]])), r8.items[o9], t6);
              if (typeof a7 == "number") o9 = a7 - 1;
              else {
                if (a7 === ri) return ri;
                a7 === Na && (r8.items.splice(o9, 1), o9 -= 1);
              }
            }
            typeof n23 == "function" && i10 === "key" && (n23 = n23(e5, s9));
          }
        }
        return typeof n23 == "function" ? n23(e5, s9) : n23;
      }
      va.visit = me5;
    });
    ws = o((j11) => {
      "use strict";
      var oi = ba(), Gd = Sa(), Xd = Aa(), ai = "\uFEFF", li = "", ci = "", fi = "", Qd = (s9) => !!s9 && "items" in s9, Hd = (s9) => !!s9 && (s9.type === "scalar" || s9.type === "single-quoted-scalar" || s9.type === "double-quoted-scalar" || s9.type === "block-scalar");
      function Dd(s9) {
        switch (s9) {
          case ai:
            return "<BOM>";
          case li:
            return "<DOC>";
          case ci:
            return "<FLOW_END>";
          case fi:
            return "<SCALAR>";
          default:
            return JSON.stringify(s9);
        }
      }
      function zd(s9) {
        switch (s9) {
          case ai:
            return "byte-order-mark";
          case li:
            return "doc-mode";
          case ci:
            return "flow-error-end";
          case fi:
            return "scalar";
          case "---":
            return "doc-start";
          case "...":
            return "doc-end";
          case "":
          case `
`:
          case `\r
`:
            return "newline";
          case "-":
            return "seq-item-ind";
          case "?":
            return "explicit-key-ind";
          case ":":
            return "map-value-ind";
          case "{":
            return "flow-map-start";
          case "}":
            return "flow-map-end";
          case "[":
            return "flow-seq-start";
          case "]":
            return "flow-seq-end";
          case ",":
            return "comma";
        }
        switch (s9[0]) {
          case " ":
          case "	":
            return "space";
          case "#":
            return "comment";
          case "%":
            return "directive-line";
          case "*":
            return "alias";
          case "&":
            return "anchor";
          case "!":
            return "tag";
          case "'":
            return "single-quoted-scalar";
          case '"':
            return "double-quoted-scalar";
          case "|":
          case ">":
            return "block-scalar-header";
        }
        return null;
      }
      j11.createScalarToken = oi.createScalarToken;
      j11.resolveAsScalar = oi.resolveAsScalar;
      j11.setScalarValue = oi.setScalarValue;
      j11.stringify = Gd.stringify;
      j11.visit = Xd.visit;
      j11.BOM = ai;
      j11.DOCUMENT = li;
      j11.FLOW_END = ci;
      j11.SCALAR = fi;
      j11.isCollection = Qd;
      j11.isScalar = Hd;
      j11.prettyToken = Dd;
      j11.tokenType = zd;
    });
    hi2 = o((Oa) => {
      "use strict";
      var pt3 = ws();
      function U13(s9) {
        switch (s9) {
          case void 0:
          case " ":
          case `
`:
          case "\r":
          case "	":
            return true;
          default:
            return false;
        }
      }
      var Ta = new Set("0123456789ABCDEFabcdef"), Zd = new Set("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-#;/?:@&=+$_.!~*'()"), Ss = new Set(",[]{}"), eh = new Set(` ,[]{}
\r	`), ui = (s9) => !s9 || eh.has(s9), di = class {
        constructor() {
          this.atEnd = false, this.blockScalarIndent = -1, this.blockScalarKeep = false, this.buffer = "", this.flowKey = false, this.flowLevel = 0, this.indentNext = 0, this.indentValue = 0, this.lineEndPos = null, this.next = null, this.pos = 0;
        }
        *lex(e5, t6 = false) {
          if (e5) {
            if (typeof e5 != "string") throw TypeError("source is not a string");
            this.buffer = this.buffer ? this.buffer + e5 : e5, this.lineEndPos = null;
          }
          this.atEnd = !t6;
          let n23 = this.next ?? "stream";
          for (; n23 && (t6 || this.hasChars(1)); ) n23 = yield* this.parseNext(n23);
        }
        atLineEnd() {
          let e5 = this.pos, t6 = this.buffer[e5];
          for (; t6 === " " || t6 === "	"; ) t6 = this.buffer[++e5];
          return !t6 || t6 === "#" || t6 === `
` ? true : t6 === "\r" ? this.buffer[e5 + 1] === `
` : false;
        }
        charAt(e5) {
          return this.buffer[this.pos + e5];
        }
        continueScalar(e5) {
          let t6 = this.buffer[e5];
          if (this.indentNext > 0) {
            let n23 = 0;
            for (; t6 === " "; ) t6 = this.buffer[++n23 + e5];
            if (t6 === "\r") {
              let i10 = this.buffer[n23 + e5 + 1];
              if (i10 === `
` || !i10 && !this.atEnd) return e5 + n23 + 1;
            }
            return t6 === `
` || n23 >= this.indentNext || !t6 && !this.atEnd ? e5 + n23 : -1;
          }
          if (t6 === "-" || t6 === ".") {
            let n23 = this.buffer.substr(e5, 3);
            if ((n23 === "---" || n23 === "...") && U13(this.buffer[e5 + 3])) return -1;
          }
          return e5;
        }
        getLine() {
          let e5 = this.lineEndPos;
          return (typeof e5 != "number" || e5 !== -1 && e5 < this.pos) && (e5 = this.buffer.indexOf(`
`, this.pos), this.lineEndPos = e5), e5 === -1 ? this.atEnd ? this.buffer.substring(this.pos) : null : (this.buffer[e5 - 1] === "\r" && (e5 -= 1), this.buffer.substring(this.pos, e5));
        }
        hasChars(e5) {
          return this.pos + e5 <= this.buffer.length;
        }
        setNext(e5) {
          return this.buffer = this.buffer.substring(this.pos), this.pos = 0, this.lineEndPos = null, this.next = e5, null;
        }
        peek(e5) {
          return this.buffer.substr(this.pos, e5);
        }
        *parseNext(e5) {
          switch (e5) {
            case "stream":
              return yield* this.parseStream();
            case "line-start":
              return yield* this.parseLineStart();
            case "block-start":
              return yield* this.parseBlockStart();
            case "doc":
              return yield* this.parseDocument();
            case "flow":
              return yield* this.parseFlowCollection();
            case "quoted-scalar":
              return yield* this.parseQuotedScalar();
            case "block-scalar":
              return yield* this.parseBlockScalar();
            case "plain-scalar":
              return yield* this.parsePlainScalar();
          }
        }
        *parseStream() {
          let e5 = this.getLine();
          if (e5 === null) return this.setNext("stream");
          if (e5[0] === pt3.BOM && (yield* this.pushCount(1), e5 = e5.substring(1)), e5[0] === "%") {
            let t6 = e5.length, n23 = e5.indexOf("#");
            for (; n23 !== -1; ) {
              let r8 = e5[n23 - 1];
              if (r8 === " " || r8 === "	") {
                t6 = n23 - 1;
                break;
              } else n23 = e5.indexOf("#", n23 + 1);
            }
            for (; ; ) {
              let r8 = e5[t6 - 1];
              if (r8 === " " || r8 === "	") t6 -= 1;
              else break;
            }
            let i10 = (yield* this.pushCount(t6)) + (yield* this.pushSpaces(true));
            return yield* this.pushCount(e5.length - i10), this.pushNewline(), "stream";
          }
          if (this.atLineEnd()) {
            let t6 = yield* this.pushSpaces(true);
            return yield* this.pushCount(e5.length - t6), yield* this.pushNewline(), "stream";
          }
          return yield pt3.DOCUMENT, yield* this.parseLineStart();
        }
        *parseLineStart() {
          let e5 = this.charAt(0);
          if (!e5 && !this.atEnd) return this.setNext("line-start");
          if (e5 === "-" || e5 === ".") {
            if (!this.atEnd && !this.hasChars(4)) return this.setNext("line-start");
            let t6 = this.peek(3);
            if ((t6 === "---" || t6 === "...") && U13(this.charAt(3))) return yield* this.pushCount(3), this.indentValue = 0, this.indentNext = 0, t6 === "---" ? "doc" : "stream";
          }
          return this.indentValue = yield* this.pushSpaces(false), this.indentNext > this.indentValue && !U13(this.charAt(1)) && (this.indentNext = this.indentValue), yield* this.parseBlockStart();
        }
        *parseBlockStart() {
          let [e5, t6] = this.peek(2);
          if (!t6 && !this.atEnd) return this.setNext("block-start");
          if ((e5 === "-" || e5 === "?" || e5 === ":") && U13(t6)) {
            let n23 = (yield* this.pushCount(1)) + (yield* this.pushSpaces(true));
            return this.indentNext = this.indentValue + 1, this.indentValue += n23, yield* this.parseBlockStart();
          }
          return "doc";
        }
        *parseDocument() {
          yield* this.pushSpaces(true);
          let e5 = this.getLine();
          if (e5 === null) return this.setNext("doc");
          let t6 = yield* this.pushIndicators();
          switch (e5[t6]) {
            case "#":
              yield* this.pushCount(e5.length - t6);
            case void 0:
              return yield* this.pushNewline(), yield* this.parseLineStart();
            case "{":
            case "[":
              return yield* this.pushCount(1), this.flowKey = false, this.flowLevel = 1, "flow";
            case "}":
            case "]":
              return yield* this.pushCount(1), "doc";
            case "*":
              return yield* this.pushUntil(ui), "doc";
            case '"':
            case "'":
              return yield* this.parseQuotedScalar();
            case "|":
            case ">":
              return t6 += yield* this.parseBlockScalarHeader(), t6 += yield* this.pushSpaces(true), yield* this.pushCount(e5.length - t6), yield* this.pushNewline(), yield* this.parseBlockScalar();
            default:
              return yield* this.parsePlainScalar();
          }
        }
        *parseFlowCollection() {
          let e5, t6, n23 = -1;
          do
            e5 = yield* this.pushNewline(), e5 > 0 ? (t6 = yield* this.pushSpaces(false), this.indentValue = n23 = t6) : t6 = 0, t6 += yield* this.pushSpaces(true);
          while (e5 + t6 > 0);
          let i10 = this.getLine();
          if (i10 === null) return this.setNext("flow");
          if ((n23 !== -1 && n23 < this.indentNext && i10[0] !== "#" || n23 === 0 && (i10.startsWith("---") || i10.startsWith("...")) && U13(i10[3])) && !(n23 === this.indentNext - 1 && this.flowLevel === 1 && (i10[0] === "]" || i10[0] === "}"))) return this.flowLevel = 0, yield pt3.FLOW_END, yield* this.parseLineStart();
          let r8 = 0;
          for (; i10[r8] === ","; ) r8 += yield* this.pushCount(1), r8 += yield* this.pushSpaces(true), this.flowKey = false;
          switch (r8 += yield* this.pushIndicators(), i10[r8]) {
            case void 0:
              return "flow";
            case "#":
              return yield* this.pushCount(i10.length - r8), "flow";
            case "{":
            case "[":
              return yield* this.pushCount(1), this.flowKey = false, this.flowLevel += 1, "flow";
            case "}":
            case "]":
              return yield* this.pushCount(1), this.flowKey = true, this.flowLevel -= 1, this.flowLevel ? "flow" : "doc";
            case "*":
              return yield* this.pushUntil(ui), "flow";
            case '"':
            case "'":
              return this.flowKey = true, yield* this.parseQuotedScalar();
            case ":": {
              let o9 = this.charAt(1);
              if (this.flowKey || U13(o9) || o9 === ",") return this.flowKey = false, yield* this.pushCount(1), yield* this.pushSpaces(true), "flow";
            }
            default:
              return this.flowKey = false, yield* this.parsePlainScalar();
          }
        }
        *parseQuotedScalar() {
          let e5 = this.charAt(0), t6 = this.buffer.indexOf(e5, this.pos + 1);
          if (e5 === "'") for (; t6 !== -1 && this.buffer[t6 + 1] === "'"; ) t6 = this.buffer.indexOf("'", t6 + 2);
          else for (; t6 !== -1; ) {
            let r8 = 0;
            for (; this.buffer[t6 - 1 - r8] === "\\"; ) r8 += 1;
            if (r8 % 2 === 0) break;
            t6 = this.buffer.indexOf('"', t6 + 1);
          }
          let n23 = this.buffer.substring(0, t6), i10 = n23.indexOf(`
`, this.pos);
          if (i10 !== -1) {
            for (; i10 !== -1; ) {
              let r8 = this.continueScalar(i10 + 1);
              if (r8 === -1) break;
              i10 = n23.indexOf(`
`, r8);
            }
            i10 !== -1 && (t6 = i10 - (n23[i10 - 1] === "\r" ? 2 : 1));
          }
          if (t6 === -1) {
            if (!this.atEnd) return this.setNext("quoted-scalar");
            t6 = this.buffer.length;
          }
          return yield* this.pushToIndex(t6 + 1, false), this.flowLevel ? "flow" : "doc";
        }
        *parseBlockScalarHeader() {
          this.blockScalarIndent = -1, this.blockScalarKeep = false;
          let e5 = this.pos;
          for (; ; ) {
            let t6 = this.buffer[++e5];
            if (t6 === "+") this.blockScalarKeep = true;
            else if (t6 > "0" && t6 <= "9") this.blockScalarIndent = Number(t6) - 1;
            else if (t6 !== "-") break;
          }
          return yield* this.pushUntil((t6) => U13(t6) || t6 === "#");
        }
        *parseBlockScalar() {
          let e5 = this.pos - 1, t6 = 0, n23;
          e: for (let r8 = this.pos; n23 = this.buffer[r8]; ++r8) switch (n23) {
            case " ":
              t6 += 1;
              break;
            case `
`:
              e5 = r8, t6 = 0;
              break;
            case "\r": {
              let o9 = this.buffer[r8 + 1];
              if (!o9 && !this.atEnd) return this.setNext("block-scalar");
              if (o9 === `
`) break;
            }
            default:
              break e;
          }
          if (!n23 && !this.atEnd) return this.setNext("block-scalar");
          if (t6 >= this.indentNext) {
            this.blockScalarIndent === -1 ? this.indentNext = t6 : this.indentNext = this.blockScalarIndent + (this.indentNext === 0 ? 1 : this.indentNext);
            do {
              let r8 = this.continueScalar(e5 + 1);
              if (r8 === -1) break;
              e5 = this.buffer.indexOf(`
`, r8);
            } while (e5 !== -1);
            if (e5 === -1) {
              if (!this.atEnd) return this.setNext("block-scalar");
              e5 = this.buffer.length;
            }
          }
          let i10 = e5 + 1;
          for (n23 = this.buffer[i10]; n23 === " "; ) n23 = this.buffer[++i10];
          if (n23 === "	") {
            for (; n23 === "	" || n23 === " " || n23 === "\r" || n23 === `
`; ) n23 = this.buffer[++i10];
            e5 = i10 - 1;
          } else if (!this.blockScalarKeep) do {
            let r8 = e5 - 1, o9 = this.buffer[r8];
            o9 === "\r" && (o9 = this.buffer[--r8]);
            let a7 = r8;
            for (; o9 === " "; ) o9 = this.buffer[--r8];
            if (o9 === `
` && r8 >= this.pos && r8 + 1 + t6 > a7) e5 = r8;
            else break;
          } while (true);
          return yield pt3.SCALAR, yield* this.pushToIndex(e5 + 1, true), yield* this.parseLineStart();
        }
        *parsePlainScalar() {
          let e5 = this.flowLevel > 0, t6 = this.pos - 1, n23 = this.pos - 1, i10;
          for (; i10 = this.buffer[++n23]; ) if (i10 === ":") {
            let r8 = this.buffer[n23 + 1];
            if (U13(r8) || e5 && Ss.has(r8)) break;
            t6 = n23;
          } else if (U13(i10)) {
            let r8 = this.buffer[n23 + 1];
            if (i10 === "\r" && (r8 === `
` ? (n23 += 1, i10 = `
`, r8 = this.buffer[n23 + 1]) : t6 = n23), r8 === "#" || e5 && Ss.has(r8)) break;
            if (i10 === `
`) {
              let o9 = this.continueScalar(n23 + 1);
              if (o9 === -1) break;
              n23 = Math.max(n23, o9 - 2);
            }
          } else {
            if (e5 && Ss.has(i10)) break;
            t6 = n23;
          }
          return !i10 && !this.atEnd ? this.setNext("plain-scalar") : (yield pt3.SCALAR, yield* this.pushToIndex(t6 + 1, true), e5 ? "flow" : "doc");
        }
        *pushCount(e5) {
          return e5 > 0 ? (yield this.buffer.substr(this.pos, e5), this.pos += e5, e5) : 0;
        }
        *pushToIndex(e5, t6) {
          let n23 = this.buffer.slice(this.pos, e5);
          return n23 ? (yield n23, this.pos += n23.length, n23.length) : (t6 && (yield ""), 0);
        }
        *pushIndicators() {
          switch (this.charAt(0)) {
            case "!":
              return (yield* this.pushTag()) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case "&":
              return (yield* this.pushUntil(ui)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            case "-":
            case "?":
            case ":": {
              let e5 = this.flowLevel > 0, t6 = this.charAt(1);
              if (U13(t6) || e5 && Ss.has(t6)) return e5 ? this.flowKey && (this.flowKey = false) : this.indentNext = this.indentValue + 1, (yield* this.pushCount(1)) + (yield* this.pushSpaces(true)) + (yield* this.pushIndicators());
            }
          }
          return 0;
        }
        *pushTag() {
          if (this.charAt(1) === "<") {
            let e5 = this.pos + 2, t6 = this.buffer[e5];
            for (; !U13(t6) && t6 !== ">"; ) t6 = this.buffer[++e5];
            return yield* this.pushToIndex(t6 === ">" ? e5 + 1 : e5, false);
          } else {
            let e5 = this.pos + 1, t6 = this.buffer[e5];
            for (; t6; ) if (Zd.has(t6)) t6 = this.buffer[++e5];
            else if (t6 === "%" && Ta.has(this.buffer[e5 + 1]) && Ta.has(this.buffer[e5 + 2])) t6 = this.buffer[e5 += 3];
            else break;
            return yield* this.pushToIndex(e5, false);
          }
        }
        *pushNewline() {
          let e5 = this.buffer[this.pos];
          return e5 === `
` ? yield* this.pushCount(1) : e5 === "\r" && this.charAt(1) === `
` ? yield* this.pushCount(2) : 0;
        }
        *pushSpaces(e5) {
          let t6 = this.pos - 1, n23;
          do
            n23 = this.buffer[++t6];
          while (n23 === " " || e5 && n23 === "	");
          let i10 = t6 - this.pos;
          return i10 > 0 && (yield this.buffer.substr(this.pos, i10), this.pos = t6), i10;
        }
        *pushUntil(e5) {
          let t6 = this.pos, n23 = this.buffer[t6];
          for (; !e5(n23); ) n23 = this.buffer[++t6];
          return yield* this.pushToIndex(t6, false);
        }
      };
      Oa.Lexer = di;
    });
    mi = o((ka) => {
      "use strict";
      var pi = class {
        constructor() {
          this.lineStarts = [], this.addNewLine = (e5) => this.lineStarts.push(e5), this.linePos = (e5) => {
            let t6 = 0, n23 = this.lineStarts.length;
            for (; t6 < n23; ) {
              let r8 = t6 + n23 >> 1;
              this.lineStarts[r8] < e5 ? t6 = r8 + 1 : n23 = r8;
            }
            if (this.lineStarts[t6] === e5) return { line: t6 + 1, col: 1 };
            if (t6 === 0) return { line: 0, col: e5 };
            let i10 = this.lineStarts[t6 - 1];
            return { line: t6, col: e5 - i10 + 1 };
          };
        }
      };
      ka.LineCounter = pi;
    });
    yi = o((Pa) => {
      "use strict";
      var th = m3("process"), Ia = ws(), sh = hi2();
      function re5(s9, e5) {
        for (let t6 = 0; t6 < s9.length; ++t6) if (s9[t6].type === e5) return true;
        return false;
      }
      function qa(s9) {
        for (let e5 = 0; e5 < s9.length; ++e5) switch (s9[e5].type) {
          case "space":
          case "comment":
          case "newline":
            break;
          default:
            return e5;
        }
        return -1;
      }
      function La(s9) {
        switch (s9?.type) {
          case "alias":
          case "scalar":
          case "single-quoted-scalar":
          case "double-quoted-scalar":
          case "flow-collection":
            return true;
          default:
            return false;
        }
      }
      function Ns(s9) {
        switch (s9.type) {
          case "document":
            return s9.start;
          case "block-map": {
            let e5 = s9.items[s9.items.length - 1];
            return e5.sep ?? e5.start;
          }
          case "block-seq":
            return s9.items[s9.items.length - 1].start;
          default:
            return [];
        }
      }
      function Ce4(s9) {
        if (s9.length === 0) return [];
        let e5 = s9.length;
        e: for (; --e5 >= 0; ) switch (s9[e5].type) {
          case "doc-start":
          case "explicit-key-ind":
          case "map-value-ind":
          case "seq-item-ind":
          case "newline":
            break e;
        }
        for (; s9[++e5]?.type === "space"; ) ;
        return s9.splice(e5, s9.length);
      }
      function Ca(s9) {
        if (s9.start.type === "flow-seq-start") for (let e5 of s9.items) e5.sep && !e5.value && !re5(e5.start, "explicit-key-ind") && !re5(e5.sep, "map-value-ind") && (e5.key && (e5.value = e5.key), delete e5.key, La(e5.value) ? e5.value.end ? Array.prototype.push.apply(e5.value.end, e5.sep) : e5.value.end = e5.sep : Array.prototype.push.apply(e5.start, e5.sep), delete e5.sep);
      }
      var gi = class {
        constructor(e5) {
          this.atNewLine = true, this.atScalar = false, this.indent = 0, this.offset = 0, this.onKeyLine = false, this.stack = [], this.source = "", this.type = "", this.lexer = new sh.Lexer(), this.onNewLine = e5;
        }
        *parse(e5, t6 = false) {
          this.onNewLine && this.offset === 0 && this.onNewLine(0);
          for (let n23 of this.lexer.lex(e5, t6)) yield* this.next(n23);
          t6 || (yield* this.end());
        }
        *next(e5) {
          if (this.source = e5, th.env.LOG_TOKENS && console.log("|", Ia.prettyToken(e5)), this.atScalar) {
            this.atScalar = false, yield* this.step(), this.offset += e5.length;
            return;
          }
          let t6 = Ia.tokenType(e5);
          if (t6) if (t6 === "scalar") this.atNewLine = false, this.atScalar = true, this.type = "scalar";
          else {
            switch (this.type = t6, yield* this.step(), t6) {
              case "newline":
                this.atNewLine = true, this.indent = 0, this.onNewLine && this.onNewLine(this.offset + e5.length);
                break;
              case "space":
                this.atNewLine && e5[0] === " " && (this.indent += e5.length);
                break;
              case "explicit-key-ind":
              case "map-value-ind":
              case "seq-item-ind":
                this.atNewLine && (this.indent += e5.length);
                break;
              case "doc-mode":
              case "flow-error-end":
                return;
              default:
                this.atNewLine = false;
            }
            this.offset += e5.length;
          }
          else {
            let n23 = `Not a YAML token: ${e5}`;
            yield* this.pop({ type: "error", offset: this.offset, message: n23, source: e5 }), this.offset += e5.length;
          }
        }
        *end() {
          for (; this.stack.length > 0; ) yield* this.pop();
        }
        get sourceToken() {
          return { type: this.type, offset: this.offset, indent: this.indent, source: this.source };
        }
        *step() {
          let e5 = this.peek(1);
          if (this.type === "doc-end" && e5?.type !== "doc-end") {
            for (; this.stack.length > 0; ) yield* this.pop();
            this.stack.push({ type: "doc-end", offset: this.offset, source: this.source });
            return;
          }
          if (!e5) return yield* this.stream();
          switch (e5.type) {
            case "document":
              return yield* this.document(e5);
            case "alias":
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return yield* this.scalar(e5);
            case "block-scalar":
              return yield* this.blockScalar(e5);
            case "block-map":
              return yield* this.blockMap(e5);
            case "block-seq":
              return yield* this.blockSequence(e5);
            case "flow-collection":
              return yield* this.flowCollection(e5);
            case "doc-end":
              return yield* this.documentEnd(e5);
          }
          yield* this.pop();
        }
        peek(e5) {
          return this.stack[this.stack.length - e5];
        }
        *pop(e5) {
          let t6 = e5 ?? this.stack.pop();
          if (!t6) yield { type: "error", offset: this.offset, source: "", message: "Tried to pop an empty stack" };
          else if (this.stack.length === 0) yield t6;
          else {
            let n23 = this.peek(1);
            switch (t6.type === "block-scalar" ? t6.indent = "indent" in n23 ? n23.indent : 0 : t6.type === "flow-collection" && n23.type === "document" && (t6.indent = 0), t6.type === "flow-collection" && Ca(t6), n23.type) {
              case "document":
                n23.value = t6;
                break;
              case "block-scalar":
                n23.props.push(t6);
                break;
              case "block-map": {
                let i10 = n23.items[n23.items.length - 1];
                if (i10.value) {
                  n23.items.push({ start: [], key: t6, sep: [] }), this.onKeyLine = true;
                  return;
                } else if (i10.sep) i10.value = t6;
                else {
                  Object.assign(i10, { key: t6, sep: [] }), this.onKeyLine = !i10.explicitKey;
                  return;
                }
                break;
              }
              case "block-seq": {
                let i10 = n23.items[n23.items.length - 1];
                i10.value ? n23.items.push({ start: [], value: t6 }) : i10.value = t6;
                break;
              }
              case "flow-collection": {
                let i10 = n23.items[n23.items.length - 1];
                !i10 || i10.value ? n23.items.push({ start: [], key: t6, sep: [] }) : i10.sep ? i10.value = t6 : Object.assign(i10, { key: t6, sep: [] });
                return;
              }
              default:
                yield* this.pop(), yield* this.pop(t6);
            }
            if ((n23.type === "document" || n23.type === "block-map" || n23.type === "block-seq") && (t6.type === "block-map" || t6.type === "block-seq")) {
              let i10 = t6.items[t6.items.length - 1];
              i10 && !i10.sep && !i10.value && i10.start.length > 0 && qa(i10.start) === -1 && (t6.indent === 0 || i10.start.every((r8) => r8.type !== "comment" || r8.indent < t6.indent)) && (n23.type === "document" ? n23.end = i10.start : n23.items.push({ start: i10.start }), t6.items.splice(-1, 1));
            }
          }
        }
        *stream() {
          switch (this.type) {
            case "directive-line":
              yield { type: "directive", offset: this.offset, source: this.source };
              return;
            case "byte-order-mark":
            case "space":
            case "comment":
            case "newline":
              yield this.sourceToken;
              return;
            case "doc-mode":
            case "doc-start": {
              let e5 = { type: "document", offset: this.offset, start: [] };
              this.type === "doc-start" && e5.start.push(this.sourceToken), this.stack.push(e5);
              return;
            }
          }
          yield { type: "error", offset: this.offset, message: `Unexpected ${this.type} token in YAML stream`, source: this.source };
        }
        *document(e5) {
          if (e5.value) return yield* this.lineEnd(e5);
          switch (this.type) {
            case "doc-start": {
              qa(e5.start) !== -1 ? (yield* this.pop(), yield* this.step()) : e5.start.push(this.sourceToken);
              return;
            }
            case "anchor":
            case "tag":
            case "space":
            case "comment":
            case "newline":
              e5.start.push(this.sourceToken);
              return;
          }
          let t6 = this.startBlockValue(e5);
          t6 ? this.stack.push(t6) : yield { type: "error", offset: this.offset, message: `Unexpected ${this.type} token in YAML document`, source: this.source };
        }
        *scalar(e5) {
          if (this.type === "map-value-ind") {
            let t6 = Ns(this.peek(2)), n23 = Ce4(t6), i10;
            e5.end ? (i10 = e5.end, i10.push(this.sourceToken), delete e5.end) : i10 = [this.sourceToken];
            let r8 = { type: "block-map", offset: e5.offset, indent: e5.indent, items: [{ start: n23, key: e5, sep: i10 }] };
            this.onKeyLine = true, this.stack[this.stack.length - 1] = r8;
          } else yield* this.lineEnd(e5);
        }
        *blockScalar(e5) {
          switch (this.type) {
            case "space":
            case "comment":
            case "newline":
              e5.props.push(this.sourceToken);
              return;
            case "scalar":
              if (e5.source = this.source, this.atNewLine = true, this.indent = 0, this.onNewLine) {
                let t6 = this.source.indexOf(`
`) + 1;
                for (; t6 !== 0; ) this.onNewLine(this.offset + t6), t6 = this.source.indexOf(`
`, t6) + 1;
              }
              yield* this.pop();
              break;
            default:
              yield* this.pop(), yield* this.step();
          }
        }
        *blockMap(e5) {
          let t6 = e5.items[e5.items.length - 1];
          switch (this.type) {
            case "newline":
              if (this.onKeyLine = false, t6.value) {
                let n23 = "end" in t6.value ? t6.value.end : void 0;
                (Array.isArray(n23) ? n23[n23.length - 1] : void 0)?.type === "comment" ? n23?.push(this.sourceToken) : e5.items.push({ start: [this.sourceToken] });
              } else t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
              return;
            case "space":
            case "comment":
              if (t6.value) e5.items.push({ start: [this.sourceToken] });
              else if (t6.sep) t6.sep.push(this.sourceToken);
              else {
                if (this.atIndentedComment(t6.start, e5.indent)) {
                  let i10 = e5.items[e5.items.length - 2]?.value?.end;
                  if (Array.isArray(i10)) {
                    Array.prototype.push.apply(i10, t6.start), i10.push(this.sourceToken), e5.items.pop();
                    return;
                  }
                }
                t6.start.push(this.sourceToken);
              }
              return;
          }
          if (this.indent >= e5.indent) {
            let n23 = !this.onKeyLine && this.indent === e5.indent, i10 = n23 && (t6.sep || t6.explicitKey) && this.type !== "seq-item-ind", r8 = [];
            if (i10 && t6.sep && !t6.value) {
              let o9 = [];
              for (let a7 = 0; a7 < t6.sep.length; ++a7) {
                let l8 = t6.sep[a7];
                switch (l8.type) {
                  case "newline":
                    o9.push(a7);
                    break;
                  case "space":
                    break;
                  case "comment":
                    l8.indent > e5.indent && (o9.length = 0);
                    break;
                  default:
                    o9.length = 0;
                }
              }
              o9.length >= 2 && (r8 = t6.sep.splice(o9[1]));
            }
            switch (this.type) {
              case "anchor":
              case "tag":
                i10 || t6.value ? (r8.push(this.sourceToken), e5.items.push({ start: r8 }), this.onKeyLine = true) : t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
                return;
              case "explicit-key-ind":
                !t6.sep && !t6.explicitKey ? (t6.start.push(this.sourceToken), t6.explicitKey = true) : i10 || t6.value ? (r8.push(this.sourceToken), e5.items.push({ start: r8, explicitKey: true })) : this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: [this.sourceToken], explicitKey: true }] }), this.onKeyLine = true;
                return;
              case "map-value-ind":
                if (t6.explicitKey) if (t6.sep) if (t6.value) e5.items.push({ start: [], key: null, sep: [this.sourceToken] });
                else if (re5(t6.sep, "map-value-ind")) this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: r8, key: null, sep: [this.sourceToken] }] });
                else if (La(t6.key) && !re5(t6.sep, "newline")) {
                  let o9 = Ce4(t6.start), a7 = t6.key, l8 = t6.sep;
                  l8.push(this.sourceToken), delete t6.key, delete t6.sep, this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: o9, key: a7, sep: l8 }] });
                } else r8.length > 0 ? t6.sep = t6.sep.concat(r8, this.sourceToken) : t6.sep.push(this.sourceToken);
                else if (re5(t6.start, "newline")) Object.assign(t6, { key: null, sep: [this.sourceToken] });
                else {
                  let o9 = Ce4(t6.start);
                  this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: o9, key: null, sep: [this.sourceToken] }] });
                }
                else t6.sep ? t6.value || i10 ? e5.items.push({ start: r8, key: null, sep: [this.sourceToken] }) : re5(t6.sep, "map-value-ind") ? this.stack.push({ type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: [], key: null, sep: [this.sourceToken] }] }) : t6.sep.push(this.sourceToken) : Object.assign(t6, { key: null, sep: [this.sourceToken] });
                this.onKeyLine = true;
                return;
              case "alias":
              case "scalar":
              case "single-quoted-scalar":
              case "double-quoted-scalar": {
                let o9 = this.flowScalar(this.type);
                i10 || t6.value ? (e5.items.push({ start: r8, key: o9, sep: [] }), this.onKeyLine = true) : t6.sep ? this.stack.push(o9) : (Object.assign(t6, { key: o9, sep: [] }), this.onKeyLine = true);
                return;
              }
              default: {
                let o9 = this.startBlockValue(e5);
                if (o9) {
                  if (o9.type === "block-seq") {
                    if (!t6.explicitKey && t6.sep && !re5(t6.sep, "newline")) {
                      yield* this.pop({ type: "error", offset: this.offset, message: "Unexpected block-seq-ind on same line with key", source: this.source });
                      return;
                    }
                  } else n23 && e5.items.push({ start: r8 });
                  this.stack.push(o9);
                  return;
                }
              }
            }
          }
          yield* this.pop(), yield* this.step();
        }
        *blockSequence(e5) {
          let t6 = e5.items[e5.items.length - 1];
          switch (this.type) {
            case "newline":
              if (t6.value) {
                let n23 = "end" in t6.value ? t6.value.end : void 0;
                (Array.isArray(n23) ? n23[n23.length - 1] : void 0)?.type === "comment" ? n23?.push(this.sourceToken) : e5.items.push({ start: [this.sourceToken] });
              } else t6.start.push(this.sourceToken);
              return;
            case "space":
            case "comment":
              if (t6.value) e5.items.push({ start: [this.sourceToken] });
              else {
                if (this.atIndentedComment(t6.start, e5.indent)) {
                  let i10 = e5.items[e5.items.length - 2]?.value?.end;
                  if (Array.isArray(i10)) {
                    Array.prototype.push.apply(i10, t6.start), i10.push(this.sourceToken), e5.items.pop();
                    return;
                  }
                }
                t6.start.push(this.sourceToken);
              }
              return;
            case "anchor":
            case "tag":
              if (t6.value || this.indent <= e5.indent) break;
              t6.start.push(this.sourceToken);
              return;
            case "seq-item-ind":
              if (this.indent !== e5.indent) break;
              t6.value || re5(t6.start, "seq-item-ind") ? e5.items.push({ start: [this.sourceToken] }) : t6.start.push(this.sourceToken);
              return;
          }
          if (this.indent > e5.indent) {
            let n23 = this.startBlockValue(e5);
            if (n23) {
              this.stack.push(n23);
              return;
            }
          }
          yield* this.pop(), yield* this.step();
        }
        *flowCollection(e5) {
          let t6 = e5.items[e5.items.length - 1];
          if (this.type === "flow-error-end") {
            let n23;
            do
              yield* this.pop(), n23 = this.peek(1);
            while (n23?.type === "flow-collection");
          } else if (e5.end.length === 0) {
            switch (this.type) {
              case "comma":
              case "explicit-key-ind":
                !t6 || t6.sep ? e5.items.push({ start: [this.sourceToken] }) : t6.start.push(this.sourceToken);
                return;
              case "map-value-ind":
                !t6 || t6.value ? e5.items.push({ start: [], key: null, sep: [this.sourceToken] }) : t6.sep ? t6.sep.push(this.sourceToken) : Object.assign(t6, { key: null, sep: [this.sourceToken] });
                return;
              case "space":
              case "comment":
              case "newline":
              case "anchor":
              case "tag":
                !t6 || t6.value ? e5.items.push({ start: [this.sourceToken] }) : t6.sep ? t6.sep.push(this.sourceToken) : t6.start.push(this.sourceToken);
                return;
              case "alias":
              case "scalar":
              case "single-quoted-scalar":
              case "double-quoted-scalar": {
                let i10 = this.flowScalar(this.type);
                !t6 || t6.value ? e5.items.push({ start: [], key: i10, sep: [] }) : t6.sep ? this.stack.push(i10) : Object.assign(t6, { key: i10, sep: [] });
                return;
              }
              case "flow-map-end":
              case "flow-seq-end":
                e5.end.push(this.sourceToken);
                return;
            }
            let n23 = this.startBlockValue(e5);
            n23 ? this.stack.push(n23) : (yield* this.pop(), yield* this.step());
          } else {
            let n23 = this.peek(2);
            if (n23.type === "block-map" && (this.type === "map-value-ind" && n23.indent === e5.indent || this.type === "newline" && !n23.items[n23.items.length - 1].sep)) yield* this.pop(), yield* this.step();
            else if (this.type === "map-value-ind" && n23.type !== "flow-collection") {
              let i10 = Ns(n23), r8 = Ce4(i10);
              Ca(e5);
              let o9 = e5.end.splice(1, e5.end.length);
              o9.push(this.sourceToken);
              let a7 = { type: "block-map", offset: e5.offset, indent: e5.indent, items: [{ start: r8, key: e5, sep: o9 }] };
              this.onKeyLine = true, this.stack[this.stack.length - 1] = a7;
            } else yield* this.lineEnd(e5);
          }
        }
        flowScalar(e5) {
          if (this.onNewLine) {
            let t6 = this.source.indexOf(`
`) + 1;
            for (; t6 !== 0; ) this.onNewLine(this.offset + t6), t6 = this.source.indexOf(`
`, t6) + 1;
          }
          return { type: e5, offset: this.offset, indent: this.indent, source: this.source };
        }
        startBlockValue(e5) {
          switch (this.type) {
            case "alias":
            case "scalar":
            case "single-quoted-scalar":
            case "double-quoted-scalar":
              return this.flowScalar(this.type);
            case "block-scalar-header":
              return { type: "block-scalar", offset: this.offset, indent: this.indent, props: [this.sourceToken], source: "" };
            case "flow-map-start":
            case "flow-seq-start":
              return { type: "flow-collection", offset: this.offset, indent: this.indent, start: this.sourceToken, items: [], end: [] };
            case "seq-item-ind":
              return { type: "block-seq", offset: this.offset, indent: this.indent, items: [{ start: [this.sourceToken] }] };
            case "explicit-key-ind": {
              this.onKeyLine = true;
              let t6 = Ns(e5), n23 = Ce4(t6);
              return n23.push(this.sourceToken), { type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: n23, explicitKey: true }] };
            }
            case "map-value-ind": {
              this.onKeyLine = true;
              let t6 = Ns(e5), n23 = Ce4(t6);
              return { type: "block-map", offset: this.offset, indent: this.indent, items: [{ start: n23, key: null, sep: [this.sourceToken] }] };
            }
          }
          return null;
        }
        atIndentedComment(e5, t6) {
          return this.type !== "comment" || this.indent <= t6 ? false : e5.every((n23) => n23.type === "newline" || n23.type === "space");
        }
        *documentEnd(e5) {
          this.type !== "doc-mode" && (e5.end ? e5.end.push(this.sourceToken) : e5.end = [this.sourceToken], this.type === "newline" && (yield* this.pop()));
        }
        *lineEnd(e5) {
          switch (this.type) {
            case "comma":
            case "doc-start":
            case "doc-end":
            case "flow-seq-end":
            case "flow-map-end":
            case "map-value-ind":
              yield* this.pop(), yield* this.step();
              break;
            case "newline":
              this.onKeyLine = false;
            default:
              e5.end ? e5.end.push(this.sourceToken) : e5.end = [this.sourceToken], this.type === "newline" && (yield* this.pop());
          }
        }
      };
      Pa.Parser = gi;
    });
    Ba = o((gt2) => {
      "use strict";
      var Ma = ni(), nh = at5(), mt5 = ft4(), ih = en2(), rh = O13(), oh = mi(), $a = yi();
      function _a2(s9) {
        let e5 = s9.prettyErrors !== false;
        return { lineCounter: s9.lineCounter || e5 && new oh.LineCounter() || null, prettyErrors: e5 };
      }
      function ah(s9, e5 = {}) {
        let { lineCounter: t6, prettyErrors: n23 } = _a2(e5), i10 = new $a.Parser(t6?.addNewLine), r8 = new Ma.Composer(e5), o9 = Array.from(r8.compose(i10.parse(s9)));
        if (n23 && t6) for (let a7 of o9) a7.errors.forEach(mt5.prettifyError(s9, t6)), a7.warnings.forEach(mt5.prettifyError(s9, t6));
        return o9.length > 0 ? o9 : Object.assign([], { empty: true }, r8.streamInfo());
      }
      function xa(s9, e5 = {}) {
        let { lineCounter: t6, prettyErrors: n23 } = _a2(e5), i10 = new $a.Parser(t6?.addNewLine), r8 = new Ma.Composer(e5), o9 = null;
        for (let a7 of r8.compose(i10.parse(s9), true, s9.length)) if (!o9) o9 = a7;
        else if (o9.options.logLevel !== "silent") {
          o9.errors.push(new mt5.YAMLParseError(a7.range.slice(0, 2), "MULTIPLE_DOCS", "Source contains multiple documents; please use YAML.parseAllDocuments()"));
          break;
        }
        return n23 && t6 && (o9.errors.forEach(mt5.prettifyError(s9, t6)), o9.warnings.forEach(mt5.prettifyError(s9, t6))), o9;
      }
      function lh(s9, e5, t6) {
        let n23;
        typeof e5 == "function" ? n23 = e5 : t6 === void 0 && e5 && typeof e5 == "object" && (t6 = e5);
        let i10 = xa(s9, t6);
        if (!i10) return null;
        if (i10.warnings.forEach((r8) => ih.warn(i10.options.logLevel, r8)), i10.errors.length > 0) {
          if (i10.options.logLevel !== "silent") throw i10.errors[0];
          i10.errors = [];
        }
        return i10.toJS(Object.assign({ reviver: n23 }, t6));
      }
      function ch(s9, e5, t6) {
        let n23 = null;
        if (typeof e5 == "function" || Array.isArray(e5) ? n23 = e5 : t6 === void 0 && e5 && (t6 = e5), typeof t6 == "string" && (t6 = t6.length), typeof t6 == "number") {
          let i10 = Math.round(t6);
          t6 = i10 < 1 ? void 0 : i10 > 8 ? { indent: 8 } : { indent: i10 };
        }
        if (s9 === void 0) {
          let { keepUndefined: i10 } = t6 ?? e5 ?? {};
          if (!i10) return;
        }
        return rh.isDocument(s9) && !n23 ? s9.toString(t6) : new nh.Document(s9, n23, t6).toString(t6);
      }
      gt2.parse = lh;
      gt2.parseAllDocuments = ah;
      gt2.parseDocument = xa;
      gt2.stringify = ch;
    });
    ja = o((k15) => {
      "use strict";
      var fh = ni(), uh = at5(), dh = Bn(), bi = ft4(), hh = Ue4(), oe8 = O13(), ph = te7(), mh = C16(), gh = ne6(), yh = ie4(), bh = ws(), wh = hi2(), Sh = mi(), Nh = yi(), Es = Ba(), Fa = Ve4();
      k15.Composer = fh.Composer;
      k15.Document = uh.Document;
      k15.Schema = dh.Schema;
      k15.YAMLError = bi.YAMLError;
      k15.YAMLParseError = bi.YAMLParseError;
      k15.YAMLWarning = bi.YAMLWarning;
      k15.Alias = hh.Alias;
      k15.isAlias = oe8.isAlias;
      k15.isCollection = oe8.isCollection;
      k15.isDocument = oe8.isDocument;
      k15.isMap = oe8.isMap;
      k15.isNode = oe8.isNode;
      k15.isPair = oe8.isPair;
      k15.isScalar = oe8.isScalar;
      k15.isSeq = oe8.isSeq;
      k15.Pair = ph.Pair;
      k15.Scalar = mh.Scalar;
      k15.YAMLMap = gh.YAMLMap;
      k15.YAMLSeq = yh.YAMLSeq;
      k15.CST = bh;
      k15.Lexer = wh.Lexer;
      k15.LineCounter = Sh.LineCounter;
      k15.Parser = Nh.Parser;
      k15.parse = Es.parse;
      k15.parseAllDocuments = Es.parseAllDocuments;
      k15.parseDocument = Es.parseDocument;
      k15.stringify = Es.stringify;
      k15.visit = Fa.visit;
      k15.visitAsync = Fa.visitAsync;
    });
    ki = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    Wa = ki + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    Ga = "[" + ki + "][" + Wa + "]*";
    Xa = new RegExp("^" + Ga + "$");
    ye5 = function(s9) {
      let e5 = Xa.exec(s9);
      return !(e5 === null || typeof e5 > "u");
    };
    Qa = { allowBooleanAttributes: false, unpairedTags: [] };
    Ha = '"';
    Da = "'";
    Za = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
    il = { preserveOrder: false, attributeNamePrefix: "@_", attributesGroupName: false, textNodeName: "#text", ignoreAttributes: true, removeNSPrefix: false, allowBooleanAttributes: false, parseTagValue: true, parseAttributeValue: false, trimValues: true, cdataPropName: false, numberParseOptions: { hex: true, leadingZeros: true, eNotation: true }, tagValueProcessor: function(s9, e5) {
      return e5;
    }, attributeValueProcessor: function(s9, e5) {
      return e5;
    }, stopNodes: [], alwaysCreateTextNode: false, isArray: () => false, commentPropName: false, unpairedTags: [], processEntities: true, htmlEntities: false, ignoreDeclaration: false, ignorePiTags: false, transformTagName: false, transformAttributeName: false, updateTag: function(s9, e5, t6) {
      return s9;
    }, captureMetaData: false };
    $i = function(s9) {
      return Object.assign({}, il, s9);
    };
    typeof Symbol != "function" ? St3 = "@@xmlMetadata" : St3 = Symbol("XML Node Metadata");
    V10 = class {
      constructor(e5) {
        this.tagname = e5, this.child = [], this[":@"] = {};
      }
      add(e5, t6) {
        e5 === "__proto__" && (e5 = "#__proto__"), this.child.push({ [e5]: t6 });
      }
      addChild(e5, t6) {
        e5.tagname === "__proto__" && (e5.tagname = "#__proto__"), e5[":@"] && Object.keys(e5[":@"]).length > 0 ? this.child.push({ [e5.tagname]: e5.child, ":@": e5[":@"] }) : this.child.push({ [e5.tagname]: e5.child }), t6 !== void 0 && (this.child[this.child.length - 1][St3] = { startIndex: t6 });
      }
      static getMetaDataSymbol() {
        return St3;
      }
    };
    $e4 = class {
      constructor(e5) {
        this.suppressValidationErr = !e5;
      }
      readDocType(e5, t6) {
        let n23 = {};
        if (e5[t6 + 3] === "O" && e5[t6 + 4] === "C" && e5[t6 + 5] === "T" && e5[t6 + 6] === "Y" && e5[t6 + 7] === "P" && e5[t6 + 8] === "E") {
          t6 = t6 + 9;
          let i10 = 1, r8 = false, o9 = false, a7 = "";
          for (; t6 < e5.length; t6++) if (e5[t6] === "<" && !o9) {
            if (r8 && le6(e5, "!ENTITY", t6)) {
              t6 += 7;
              let l8, c14;
              [l8, c14, t6] = this.readEntityExp(e5, t6 + 1, this.suppressValidationErr), c14.indexOf("&") === -1 && (n23[l8] = { regx: RegExp(`&${l8};`, "g"), val: c14 });
            } else if (r8 && le6(e5, "!ELEMENT", t6)) {
              t6 += 8;
              let { index: l8 } = this.readElementExp(e5, t6 + 1);
              t6 = l8;
            } else if (r8 && le6(e5, "!ATTLIST", t6)) t6 += 8;
            else if (r8 && le6(e5, "!NOTATION", t6)) {
              t6 += 9;
              let { index: l8 } = this.readNotationExp(e5, t6 + 1, this.suppressValidationErr);
              t6 = l8;
            } else if (le6(e5, "!--", t6)) o9 = true;
            else throw new Error("Invalid DOCTYPE");
            i10++, a7 = "";
          } else if (e5[t6] === ">") {
            if (o9 ? e5[t6 - 1] === "-" && e5[t6 - 2] === "-" && (o9 = false, i10--) : i10--, i10 === 0) break;
          } else e5[t6] === "[" ? r8 = true : a7 += e5[t6];
          if (i10 !== 0) throw new Error("Unclosed DOCTYPE");
        } else throw new Error("Invalid Tag instead of DOCTYPE");
        return { entities: n23, i: t6 };
      }
      readEntityExp(e5, t6) {
        t6 = x20(e5, t6);
        let n23 = "";
        for (; t6 < e5.length && !/\s/.test(e5[t6]) && e5[t6] !== '"' && e5[t6] !== "'"; ) n23 += e5[t6], t6++;
        if (Me4(n23), t6 = x20(e5, t6), !this.suppressValidationErr) {
          if (e5.substring(t6, t6 + 6).toUpperCase() === "SYSTEM") throw new Error("External entities are not supported");
          if (e5[t6] === "%") throw new Error("Parameter entities are not supported");
        }
        let i10 = "";
        return [t6, i10] = this.readIdentifierVal(e5, t6, "entity"), t6--, [n23, i10, t6];
      }
      readNotationExp(e5, t6) {
        t6 = x20(e5, t6);
        let n23 = "";
        for (; t6 < e5.length && !/\s/.test(e5[t6]); ) n23 += e5[t6], t6++;
        !this.suppressValidationErr && Me4(n23), t6 = x20(e5, t6);
        let i10 = e5.substring(t6, t6 + 6).toUpperCase();
        if (!this.suppressValidationErr && i10 !== "SYSTEM" && i10 !== "PUBLIC") throw new Error(`Expected SYSTEM or PUBLIC, found "${i10}"`);
        t6 += i10.length, t6 = x20(e5, t6);
        let r8 = null, o9 = null;
        if (i10 === "PUBLIC") [t6, r8] = this.readIdentifierVal(e5, t6, "publicIdentifier"), t6 = x20(e5, t6), (e5[t6] === '"' || e5[t6] === "'") && ([t6, o9] = this.readIdentifierVal(e5, t6, "systemIdentifier"));
        else if (i10 === "SYSTEM" && ([t6, o9] = this.readIdentifierVal(e5, t6, "systemIdentifier"), !this.suppressValidationErr && !o9)) throw new Error("Missing mandatory system identifier for SYSTEM notation");
        return { notationName: n23, publicIdentifier: r8, systemIdentifier: o9, index: --t6 };
      }
      readIdentifierVal(e5, t6, n23) {
        let i10 = "", r8 = e5[t6];
        if (r8 !== '"' && r8 !== "'") throw new Error(`Expected quoted string, found "${r8}"`);
        for (t6++; t6 < e5.length && e5[t6] !== r8; ) i10 += e5[t6], t6++;
        if (e5[t6] !== r8) throw new Error(`Unterminated ${n23} value`);
        return t6++, [t6, i10];
      }
      readElementExp(e5, t6) {
        t6 = x20(e5, t6);
        let n23 = "";
        for (; t6 < e5.length && !/\s/.test(e5[t6]); ) n23 += e5[t6], t6++;
        if (!this.suppressValidationErr && !ye5(n23)) throw new Error(`Invalid element name: "${n23}"`);
        t6 = x20(e5, t6);
        let i10 = "";
        if (e5[t6] === "E" && le6(e5, "MPTY", t6)) t6 += 4;
        else if (e5[t6] === "A" && le6(e5, "NY", t6)) t6 += 2;
        else if (e5[t6] === "(") {
          for (t6++; t6 < e5.length && e5[t6] !== ")"; ) i10 += e5[t6], t6++;
          if (e5[t6] !== ")") throw new Error("Unterminated content model");
        } else if (!this.suppressValidationErr) throw new Error(`Invalid Element Expression, found "${e5[t6]}"`);
        return { elementName: n23, contentModel: i10.trim(), index: t6 };
      }
      readAttlistExp(e5, t6) {
        t6 = x20(e5, t6);
        let n23 = "";
        for (; t6 < e5.length && !/\s/.test(e5[t6]); ) n23 += e5[t6], t6++;
        Me4(n23), t6 = x20(e5, t6);
        let i10 = "";
        for (; t6 < e5.length && !/\s/.test(e5[t6]); ) i10 += e5[t6], t6++;
        if (!Me4(i10)) throw new Error(`Invalid attribute name: "${i10}"`);
        t6 = x20(e5, t6);
        let r8 = "";
        if (e5.substring(t6, t6 + 8).toUpperCase() === "NOTATION") {
          if (r8 = "NOTATION", t6 += 8, t6 = x20(e5, t6), e5[t6] !== "(") throw new Error(`Expected '(', found "${e5[t6]}"`);
          t6++;
          let a7 = [];
          for (; t6 < e5.length && e5[t6] !== ")"; ) {
            let l8 = "";
            for (; t6 < e5.length && e5[t6] !== "|" && e5[t6] !== ")"; ) l8 += e5[t6], t6++;
            if (l8 = l8.trim(), !Me4(l8)) throw new Error(`Invalid notation name: "${l8}"`);
            a7.push(l8), e5[t6] === "|" && (t6++, t6 = x20(e5, t6));
          }
          if (e5[t6] !== ")") throw new Error("Unterminated list of notations");
          t6++, r8 += " (" + a7.join("|") + ")";
        } else {
          for (; t6 < e5.length && !/\s/.test(e5[t6]); ) r8 += e5[t6], t6++;
          let a7 = ["CDATA", "ID", "IDREF", "IDREFS", "ENTITY", "ENTITIES", "NMTOKEN", "NMTOKENS"];
          if (!this.suppressValidationErr && !a7.includes(r8.toUpperCase())) throw new Error(`Invalid attribute type: "${r8}"`);
        }
        t6 = x20(e5, t6);
        let o9 = "";
        return e5.substring(t6, t6 + 8).toUpperCase() === "#REQUIRED" ? (o9 = "#REQUIRED", t6 += 8) : e5.substring(t6, t6 + 7).toUpperCase() === "#IMPLIED" ? (o9 = "#IMPLIED", t6 += 7) : [t6, o9] = this.readIdentifierVal(e5, t6, "ATTLIST"), { elementName: n23, attributeName: i10, attributeType: r8, defaultValue: o9, index: t6 };
      }
    };
    x20 = (s9, e5) => {
      for (; e5 < s9.length && /\s/.test(s9[e5]); ) e5++;
      return e5;
    };
    rl = /^[-+]?0x[a-fA-F0-9]+$/;
    ol = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
    al = { hex: true, leadingZeros: true, decimalPoint: ".", eNotation: true };
    ll = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
    xe7 = class {
      constructor(e5) {
        if (this.options = e5, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = { apos: { regex: /&(apos|#39|#x27);/g, val: "'" }, gt: { regex: /&(gt|#62|#x3E);/g, val: ">" }, lt: { regex: /&(lt|#60|#x3C);/g, val: "<" }, quot: { regex: /&(quot|#34|#x22);/g, val: '"' } }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = { space: { regex: /&(nbsp|#160);/g, val: " " }, cent: { regex: /&(cent|#162);/g, val: "\xA2" }, pound: { regex: /&(pound|#163);/g, val: "\xA3" }, yen: { regex: /&(yen|#165);/g, val: "\xA5" }, euro: { regex: /&(euro|#8364);/g, val: "\u20AC" }, copyright: { regex: /&(copy|#169);/g, val: "\xA9" }, reg: { regex: /&(reg|#174);/g, val: "\xAE" }, inr: { regex: /&(inr|#8377);/g, val: "\u20B9" }, num_dec: { regex: /&#([0-9]{1,7});/g, val: (t6, n23) => String.fromCodePoint(Number.parseInt(n23, 10)) }, num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (t6, n23) => String.fromCodePoint(Number.parseInt(n23, 16)) } }, this.addExternalEntities = dl, this.parseXml = yl, this.parseTextData = hl, this.resolveNameSpace = pl, this.buildAttributesMap = gl, this.isItStopNode = Nl, this.replaceEntitiesValue = wl, this.readStopNodeData = vl, this.saveTextToParentTag = Sl, this.addChild = bl, this.ignoreAttributesFn = _e4(this.options.ignoreAttributes), this.options.stopNodes && this.options.stopNodes.length > 0) {
          this.stopNodesExact = /* @__PURE__ */ new Set(), this.stopNodesWildcard = /* @__PURE__ */ new Set();
          for (let t6 = 0; t6 < this.options.stopNodes.length; t6++) {
            let n23 = this.options.stopNodes[t6];
            typeof n23 == "string" && (n23.startsWith("*.") ? this.stopNodesWildcard.add(n23.substring(2)) : this.stopNodesExact.add(n23));
          }
        }
      }
    };
    ml = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
    yl = function(s9) {
      s9 = s9.replace(/\r\n?/g, `
`);
      let e5 = new V10("!xml"), t6 = e5, n23 = "", i10 = "", r8 = new $e4(this.options.processEntities);
      for (let o9 = 0; o9 < s9.length; o9++) if (s9[o9] === "<") if (s9[o9 + 1] === "/") {
        let l8 = ce6(s9, ">", o9, "Closing Tag is not closed."), c14 = s9.substring(o9 + 2, l8).trim();
        if (this.options.removeNSPrefix) {
          let d16 = c14.indexOf(":");
          d16 !== -1 && (c14 = c14.substr(d16 + 1));
        }
        this.options.transformTagName && (c14 = this.options.transformTagName(c14)), t6 && (n23 = this.saveTextToParentTag(n23, t6, i10));
        let u10 = i10.substring(i10.lastIndexOf(".") + 1);
        if (c14 && this.options.unpairedTags.indexOf(c14) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${c14}>`);
        let f11 = 0;
        u10 && this.options.unpairedTags.indexOf(u10) !== -1 ? (f11 = i10.lastIndexOf(".", i10.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : f11 = i10.lastIndexOf("."), i10 = i10.substring(0, f11), t6 = this.tagsNodeStack.pop(), n23 = "", o9 = l8;
      } else if (s9[o9 + 1] === "?") {
        let l8 = ks(s9, o9, false, "?>");
        if (!l8) throw new Error("Pi Tag is not closed.");
        if (n23 = this.saveTextToParentTag(n23, t6, i10), !(this.options.ignoreDeclaration && l8.tagName === "?xml" || this.options.ignorePiTags)) {
          let c14 = new V10(l8.tagName);
          c14.add(this.options.textNodeName, ""), l8.tagName !== l8.tagExp && l8.attrExpPresent && (c14[":@"] = this.buildAttributesMap(l8.tagExp, i10)), this.addChild(t6, c14, i10, o9);
        }
        o9 = l8.closeIndex + 1;
      } else if (s9.substr(o9 + 1, 3) === "!--") {
        let l8 = ce6(s9, "-->", o9 + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          let c14 = s9.substring(o9 + 4, l8 - 2);
          n23 = this.saveTextToParentTag(n23, t6, i10), t6.add(this.options.commentPropName, [{ [this.options.textNodeName]: c14 }]);
        }
        o9 = l8;
      } else if (s9.substr(o9 + 1, 2) === "!D") {
        let l8 = r8.readDocType(s9, o9);
        this.docTypeEntities = l8.entities, o9 = l8.i;
      } else if (s9.substr(o9 + 1, 2) === "![") {
        let l8 = ce6(s9, "]]>", o9, "CDATA is not closed.") - 2, c14 = s9.substring(o9 + 9, l8);
        n23 = this.saveTextToParentTag(n23, t6, i10);
        let u10 = this.parseTextData(c14, t6.tagname, i10, true, false, true, true);
        u10 == null && (u10 = ""), this.options.cdataPropName ? t6.add(this.options.cdataPropName, [{ [this.options.textNodeName]: c14 }]) : t6.add(this.options.textNodeName, u10), o9 = l8 + 2;
      } else {
        let l8 = ks(s9, o9, this.options.removeNSPrefix), c14 = l8.tagName, u10 = l8.rawTagName, f11 = l8.tagExp, d16 = l8.attrExpPresent, p17 = l8.closeIndex;
        if (this.options.transformTagName) {
          let m24 = this.options.transformTagName(c14);
          f11 === c14 && (f11 = m24), c14 = m24;
        }
        t6 && n23 && t6.tagname !== "!xml" && (n23 = this.saveTextToParentTag(n23, t6, i10, false));
        let g18 = t6;
        g18 && this.options.unpairedTags.indexOf(g18.tagname) !== -1 && (t6 = this.tagsNodeStack.pop(), i10 = i10.substring(0, i10.lastIndexOf("."))), c14 !== e5.tagname && (i10 += i10 ? "." + c14 : c14);
        let h16 = o9;
        if (this.isItStopNode(this.stopNodesExact, this.stopNodesWildcard, i10, c14)) {
          let m24 = "";
          if (f11.length > 0 && f11.lastIndexOf("/") === f11.length - 1) c14[c14.length - 1] === "/" ? (c14 = c14.substr(0, c14.length - 1), i10 = i10.substr(0, i10.length - 1), f11 = c14) : f11 = f11.substr(0, f11.length - 1), o9 = l8.closeIndex;
          else if (this.options.unpairedTags.indexOf(c14) !== -1) o9 = l8.closeIndex;
          else {
            let S16 = this.readStopNodeData(s9, u10, p17 + 1);
            if (!S16) throw new Error(`Unexpected end of ${u10}`);
            o9 = S16.i, m24 = S16.tagContent;
          }
          let y18 = new V10(c14);
          c14 !== f11 && d16 && (y18[":@"] = this.buildAttributesMap(f11, i10)), m24 && (m24 = this.parseTextData(m24, c14, i10, true, d16, true, true)), i10 = i10.substr(0, i10.lastIndexOf(".")), y18.add(this.options.textNodeName, m24), this.addChild(t6, y18, i10, h16);
        } else {
          if (f11.length > 0 && f11.lastIndexOf("/") === f11.length - 1) {
            if (c14[c14.length - 1] === "/" ? (c14 = c14.substr(0, c14.length - 1), i10 = i10.substr(0, i10.length - 1), f11 = c14) : f11 = f11.substr(0, f11.length - 1), this.options.transformTagName) {
              let y18 = this.options.transformTagName(c14);
              f11 === c14 && (f11 = y18), c14 = y18;
            }
            let m24 = new V10(c14);
            c14 !== f11 && d16 && (m24[":@"] = this.buildAttributesMap(f11, i10)), this.addChild(t6, m24, i10, h16), i10 = i10.substr(0, i10.lastIndexOf("."));
          } else {
            let m24 = new V10(c14);
            this.tagsNodeStack.push(t6), c14 !== f11 && d16 && (m24[":@"] = this.buildAttributesMap(f11, i10)), this.addChild(t6, m24, i10, h16), t6 = m24;
          }
          n23 = "", o9 = p17;
        }
      }
      else n23 += s9[o9];
      return e5.child;
    };
    wl = function(s9) {
      if (this.options.processEntities) {
        for (let e5 in this.docTypeEntities) {
          let t6 = this.docTypeEntities[e5];
          s9 = s9.replace(t6.regx, t6.val);
        }
        for (let e5 in this.lastEntities) {
          let t6 = this.lastEntities[e5];
          s9 = s9.replace(t6.regex, t6.val);
        }
        if (this.options.htmlEntities) for (let e5 in this.htmlEntities) {
          let t6 = this.htmlEntities[e5];
          s9 = s9.replace(t6.regex, t6.val);
        }
        s9 = s9.replace(this.ampEntity.regex, this.ampEntity.val);
      }
      return s9;
    };
    qs = V10.getMetaDataSymbol();
    be4 = class {
      constructor(e5) {
        this.externalEntities = {}, this.options = $i(e5);
      }
      parse(e5, t6) {
        if (typeof e5 != "string" && e5.toString) e5 = e5.toString();
        else if (typeof e5 != "string") throw new Error("XML data is accepted in String or Bytes[] form.");
        if (t6) {
          t6 === true && (t6 = {});
          let r8 = Mi(e5, t6);
          if (r8 !== true) throw Error(`${r8.err.msg}:${r8.err.line}:${r8.err.col}`);
        }
        let n23 = new xe7(this.options);
        n23.addExternalEntities(this.externalEntities);
        let i10 = n23.parseXml(e5);
        return this.options.preserveOrder || i10 === void 0 ? i10 : Cs(i10, this.options);
      }
      addEntity(e5, t6) {
        if (t6.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        if (e5.indexOf("&") !== -1 || e5.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        if (t6 === "&") throw new Error("An entity with value '&' is not permitted");
        this.externalEntities[e5] = t6;
      }
      static getMetaDataSymbol() {
        return V10.getMetaDataSymbol();
      }
    };
    ql = { attributeNamePrefix: "@_", attributesGroupName: false, textNodeName: "#text", ignoreAttributes: true, cdataPropName: false, format: false, indentBy: "  ", suppressEmptyNode: false, suppressUnpairedNode: true, suppressBooleanAttributes: true, tagValueProcessor: function(s9, e5) {
      return e5;
    }, attributeValueProcessor: function(s9, e5) {
      return e5;
    }, preserveOrder: false, commentPropName: false, unpairedTags: [], entities: [{ regex: new RegExp("&", "g"), val: "&amp;" }, { regex: new RegExp(">", "g"), val: "&gt;" }, { regex: new RegExp("<", "g"), val: "&lt;" }, { regex: new RegExp("'", "g"), val: "&apos;" }, { regex: new RegExp('"', "g"), val: "&quot;" }], processEntities: true, stopNodes: [], oneListGroup: false };
    R7.prototype.build = function(s9) {
      return this.options.preserveOrder ? Ls(s9, this.options) : (Array.isArray(s9) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (s9 = { [this.options.arrayNodeName]: s9 }), this.j2x(s9, 0, []).val);
    };
    R7.prototype.j2x = function(s9, e5, t6) {
      let n23 = "", i10 = "", r8 = t6.join(".");
      for (let o9 in s9) if (Object.prototype.hasOwnProperty.call(s9, o9)) if (typeof s9[o9] > "u") this.isAttribute(o9) && (i10 += "");
      else if (s9[o9] === null) this.isAttribute(o9) || o9 === this.options.cdataPropName ? i10 += "" : o9[0] === "?" ? i10 += this.indentate(e5) + "<" + o9 + "?" + this.tagEndChar : i10 += this.indentate(e5) + "<" + o9 + "/" + this.tagEndChar;
      else if (s9[o9] instanceof Date) i10 += this.buildTextValNode(s9[o9], o9, "", e5);
      else if (typeof s9[o9] != "object") {
        let a7 = this.isAttribute(o9);
        if (a7 && !this.ignoreAttributesFn(a7, r8)) n23 += this.buildAttrPairStr(a7, "" + s9[o9]);
        else if (!a7) if (o9 === this.options.textNodeName) {
          let l8 = this.options.tagValueProcessor(o9, "" + s9[o9]);
          i10 += this.replaceEntitiesValue(l8);
        } else i10 += this.buildTextValNode(s9[o9], o9, "", e5);
      } else if (Array.isArray(s9[o9])) {
        let a7 = s9[o9].length, l8 = "", c14 = "";
        for (let u10 = 0; u10 < a7; u10++) {
          let f11 = s9[o9][u10];
          if (!(typeof f11 > "u")) if (f11 === null) o9[0] === "?" ? i10 += this.indentate(e5) + "<" + o9 + "?" + this.tagEndChar : i10 += this.indentate(e5) + "<" + o9 + "/" + this.tagEndChar;
          else if (typeof f11 == "object") if (this.options.oneListGroup) {
            let d16 = this.j2x(f11, e5 + 1, t6.concat(o9));
            l8 += d16.val, this.options.attributesGroupName && f11.hasOwnProperty(this.options.attributesGroupName) && (c14 += d16.attrStr);
          } else l8 += this.processTextOrObjNode(f11, o9, e5, t6);
          else if (this.options.oneListGroup) {
            let d16 = this.options.tagValueProcessor(o9, f11);
            d16 = this.replaceEntitiesValue(d16), l8 += d16;
          } else l8 += this.buildTextValNode(f11, o9, "", e5);
        }
        this.options.oneListGroup && (l8 = this.buildObjectNode(l8, o9, c14, e5)), i10 += l8;
      } else if (this.options.attributesGroupName && o9 === this.options.attributesGroupName) {
        let a7 = Object.keys(s9[o9]), l8 = a7.length;
        for (let c14 = 0; c14 < l8; c14++) n23 += this.buildAttrPairStr(a7[c14], "" + s9[o9][a7[c14]]);
      } else i10 += this.processTextOrObjNode(s9[o9], o9, e5, t6);
      return { attrStr: n23, val: i10 };
    };
    R7.prototype.buildAttrPairStr = function(s9, e5) {
      return e5 = this.options.attributeValueProcessor(s9, "" + e5), e5 = this.replaceEntitiesValue(e5), this.options.suppressBooleanAttributes && e5 === "true" ? " " + s9 : " " + s9 + '="' + e5 + '"';
    };
    R7.prototype.buildObjectNode = function(s9, e5, t6, n23) {
      if (s9 === "") return e5[0] === "?" ? this.indentate(n23) + "<" + e5 + t6 + "?" + this.tagEndChar : this.indentate(n23) + "<" + e5 + t6 + this.closeTag(e5) + this.tagEndChar;
      {
        let i10 = "</" + e5 + this.tagEndChar, r8 = "";
        return e5[0] === "?" && (r8 = "?", i10 = ""), (t6 || t6 === "") && s9.indexOf("<") === -1 ? this.indentate(n23) + "<" + e5 + t6 + r8 + ">" + s9 + i10 : this.options.commentPropName !== false && e5 === this.options.commentPropName && r8.length === 0 ? this.indentate(n23) + `<!--${s9}-->` + this.newLine : this.indentate(n23) + "<" + e5 + t6 + r8 + this.tagEndChar + s9 + this.indentate(n23) + i10;
      }
    };
    R7.prototype.closeTag = function(s9) {
      let e5 = "";
      return this.options.unpairedTags.indexOf(s9) !== -1 ? this.options.suppressUnpairedNode || (e5 = "/") : this.options.suppressEmptyNode ? e5 = "/" : e5 = `></${s9}`, e5;
    };
    R7.prototype.buildTextValNode = function(s9, e5, t6, n23) {
      if (this.options.cdataPropName !== false && e5 === this.options.cdataPropName) return this.indentate(n23) + `<![CDATA[${s9}]]>` + this.newLine;
      if (this.options.commentPropName !== false && e5 === this.options.commentPropName) return this.indentate(n23) + `<!--${s9}-->` + this.newLine;
      if (e5[0] === "?") return this.indentate(n23) + "<" + e5 + t6 + "?" + this.tagEndChar;
      {
        let i10 = this.options.tagValueProcessor(e5, s9);
        return i10 = this.replaceEntitiesValue(i10), i10 === "" ? this.indentate(n23) + "<" + e5 + t6 + this.closeTag(e5) + this.tagEndChar : this.indentate(n23) + "<" + e5 + t6 + ">" + i10 + "</" + e5 + this.tagEndChar;
      }
    };
    R7.prototype.replaceEntitiesValue = function(s9) {
      if (s9 && s9.length > 0 && this.options.processEntities) for (let e5 = 0; e5 < this.options.entities.length; e5++) {
        let t6 = this.options.entities[e5];
        s9 = s9.replace(t6.regex, t6.val);
      }
      return s9;
    };
    vs = q2(Yi(), 1);
    wi = q2(xe6(), 1);
    T8 = class extends Error {
      line;
      column;
      codeblock;
      constructor(e5, t6) {
        let [n23, i10] = Ml(t6.toml, t6.ptr), r8 = $l(t6.toml, n23, i10);
        super(`Invalid TOML document: ${e5}

${r8}`, t6), this.line = n23, this.column = i10, this.codeblock = r8;
      }
    };
    xl = /^(\d{4}-\d{2}-\d{2})?[T ]?(?:(\d{2}):\d{2}(?::\d{2}(?:\.\d+)?)?)?(Z|[-+]\d{2}:\d{2})?$/i;
    Be4 = class s8 extends Date {
      #t = false;
      #s = false;
      #e = null;
      constructor(e5) {
        let t6 = true, n23 = true, i10 = "Z";
        if (typeof e5 == "string") {
          let r8 = e5.match(xl);
          r8 ? (r8[1] || (t6 = false, e5 = `0000-01-01T${e5}`), n23 = !!r8[2], n23 && e5[10] === " " && (e5 = e5.replace(" ", "T")), r8[2] && +r8[2] > 23 ? e5 = "" : (i10 = r8[3] || null, e5 = e5.toUpperCase(), !i10 && n23 && (e5 += "Z"))) : e5 = "";
        }
        super(e5), isNaN(this.getTime()) || (this.#t = t6, this.#s = n23, this.#e = i10);
      }
      isDateTime() {
        return this.#t && this.#s;
      }
      isLocal() {
        return !this.#t || !this.#s || !this.#e;
      }
      isDate() {
        return this.#t && !this.#s;
      }
      isTime() {
        return this.#s && !this.#t;
      }
      isValid() {
        return this.#t || this.#s;
      }
      toISOString() {
        let e5 = super.toISOString();
        if (this.isDate()) return e5.slice(0, 10);
        if (this.isTime()) return e5.slice(11, 23);
        if (this.#e === null) return e5.slice(0, -1);
        if (this.#e === "Z") return e5;
        let t6 = +this.#e.slice(1, 3) * 60 + +this.#e.slice(4, 6);
        return t6 = this.#e[0] === "-" ? t6 : -t6, new Date(this.getTime() - t6 * 6e4).toISOString().slice(0, -1) + this.#e;
      }
      static wrapAsOffsetDateTime(e5, t6 = "Z") {
        let n23 = new s8(e5);
        return n23.#e = t6, n23;
      }
      static wrapAsLocalDateTime(e5) {
        let t6 = new s8(e5);
        return t6.#e = null, t6;
      }
      static wrapAsLocalDate(e5) {
        let t6 = new s8(e5);
        return t6.#s = false, t6.#e = null, t6;
      }
      static wrapAsLocalTime(e5) {
        let t6 = new s8(e5);
        return t6.#t = false, t6.#e = null, t6;
      }
    };
    Bl = /^((0x[0-9a-fA-F](_?[0-9a-fA-F])*)|(([+-]|0[ob])?\d(_?\d)*))$/;
    Fl = /^[+-]?\d(_?\d)*(\.\d(_?\d)*)?([eE][+-]?\d(_?\d)*)?$/;
    jl = /^[+-]?0[0-9_]/;
    Vl = /^[0-9a-f]{2,8}$/i;
    Ji = { b: "\b", t: "	", n: `
`, f: "\f", r: "\r", e: "\x1B", '"': '"', "\\": "\\" };
    Rl = /^[a-zA-Z0-9-_]+[ \t]*$/;
    Hi = /^[a-z0-9-_]+$/i;
    yt3 = q2(ja(), 1);
    Eh = ["yaml", "xml", "json", "ini", "csv", "toml"];
    vh = ["yaml", "json", "xml", "ini", "csv", "toml"];
    Va = { inputFormat: "yaml", outputFormat: "yaml", raw: false, compact: false, prettyPrint: false, indent: 2, xmlAttributePrefix: "+@", xmlContentName: "+content", csvDelimiter: "", csvHeader: true };
    kh = { name: "yq", summary: "command-line YAML/XML/INI/CSV/TOML processor", usage: "yq [OPTIONS] [FILTER] [FILE]", description: `yq uses jq-style expressions to query and transform data in various formats.
Supports YAML, JSON, XML, INI, CSV, and TOML with automatic format conversion.

EXAMPLES:
  # Extract a value from YAML
  yq '.name' config.yaml
  yq '.users[0].email' data.yaml

  # Filter arrays
  yq '.items[] | select(.active == true)' data.yaml
  yq '[.users[] | select(.age > 30)]' users.yaml

  # Transform data
  yq '.users | map({name, email})' data.yaml
  yq '.items | sort_by(.price) | reverse' products.yaml

  # Modify file in-place
  yq -i '.version = "2.0"' config.yaml

  # Read JSON, output YAML
  yq -p json '.' config.json

  # Read YAML, output JSON
  yq -o json '.' config.yaml
  yq -o json -c '.' config.yaml  # compact JSON

  # Parse TOML config files
  yq '.package.name' Cargo.toml
  yq -o json '.' pyproject.toml

  # Parse XML (attributes use +@ prefix, text uses +content)
  yq -p xml '.root.items.item[].name' data.xml
  yq -p xml '.root.user["+@id"]' data.xml  # XML attributes

  # Parse INI config files
  yq -p ini '.database.host' config.ini
  yq -p ini '.server' config.ini -o json

  # Parse CSV/TSV (auto-detects delimiter)
  yq -p csv '.[0].name' data.csv
  yq '.[0].name' data.tsv              # auto-detected as CSV
  yq -p csv '[.[] | select(.category == "A")]' data.csv

  # Extract front-matter from markdown/content files
  yq --front-matter '.title' post.md

  # Convert between formats
  yq -p json -o csv '.users' data.json   # JSON to CSV
  yq -p csv -o yaml '.' data.csv         # CSV to YAML
  yq -p ini -o json '.' config.ini       # INI to JSON
  yq -p xml -o json '.' data.xml         # XML to JSON
  yq -o toml '.' config.yaml             # YAML to TOML

  # Common jq functions work in yq:
  yq 'keys' data.yaml                    # get object keys
  yq 'length' data.yaml                  # array/string length
  yq '.items | first' data.yaml          # first element
  yq '.items | last' data.yaml           # last element
  yq '.nums | add' data.yaml             # sum numbers
  yq '.nums | min' data.yaml             # minimum
  yq '.nums | max' data.yaml             # maximum
  yq '.items | unique' data.yaml         # unique values
  yq '.items | group_by(.type)' data.yaml`, options: ["-p, --input-format=FMT   input format: yaml (default), xml, json, ini, csv, toml", "-o, --output-format=FMT  output format: yaml (default), json, xml, ini, csv, toml", "-i, --inplace            modify file in-place", "-r, --raw-output         output strings without quotes (json only)", "-c, --compact            compact output (json only)", "-e, --exit-status        set exit status based on output", "-s, --slurp              read entire input into array", "-n, --null-input         don't read any input", "-j, --join-output        don't print newlines after each output", "-f, --front-matter       extract and process front-matter only", "-P, --prettyPrint        pretty print output", "-I, --indent=N           set indent level (default: 2)", "    --xml-attribute-prefix=STR  XML attribute prefix (default: +@)", "    --xml-content-name=STR  XML text content name (default: +content)", "    --csv-delimiter=CHAR CSV delimiter (default: auto-detect)", "    --csv-header         CSV has header row (default: true)", "    --help               display this help and exit"] };
    ig = { name: "yq", async execute(s9, e5) {
      if (o2(s9)) return s(kh);
      let t6 = Ih(s9);
      if ("exitCode" in t6) return t6;
      let { options: n23, filter: i10, files: r8, inputFormatExplicit: o9 } = t6;
      if (!o9 && r8.length > 0 && r8[0] !== "-") {
        let c14 = Ka(r8[0]);
        c14 && (n23.inputFormat = c14);
      }
      if (n23.inplace && (r8.length === 0 || r8[0] === "-")) return { stdout: "", stderr: `yq: -i/--inplace requires a file argument
`, exitCode: 1 };
      let a7, l8;
      if (n23.nullInput) a7 = "";
      else if (r8.length === 0 || r8.length === 1 && r8[0] === "-") a7 = e5.stdin;
      else try {
        l8 = e5.fs.resolvePath(e5.cwd, r8[0]), a7 = await e5.fs.readFile(l8);
      } catch {
        return { stdout: "", stderr: `yq: ${r8[0]}: No such file or directory
`, exitCode: 2 };
      }
      try {
        let c14 = ge4(i10), u10, f11 = { limits: e5.limits ? { maxIterations: e5.limits.maxJqIterations } : void 0, env: e5.env, coverage: e5.coverage };
        if (n23.nullInput) u10 = d11(null, c14, f11);
        else if (n23.frontMatter) {
          let y18 = Ya(a7);
          if (!y18) return { stdout: "", stderr: `yq: no front-matter found
`, exitCode: 1 };
          u10 = d11(y18.frontMatter, c14, f11);
        } else if (n23.slurp) {
          let y18;
          n23.inputFormat === "yaml" ? y18 = Ra(a7) : y18 = [Ei(a7, n23)], u10 = d11(y18, c14, f11);
        } else {
          let y18 = Ei(a7, n23);
          u10 = d11(y18, c14, f11);
        }
        let d16 = u10.map((y18) => Ua(y18, n23)), p17 = n23.joinOutput ? "" : `
`, g18 = d16.filter((y18) => y18 !== "").join(p17), h16 = g18 ? n23.joinOutput ? g18 : `${g18}
` : "";
        if (n23.inplace && l8) return await e5.fs.writeFile(l8, h16), { stdout: "", stderr: "", exitCode: 0 };
        let m24 = n23.exitStatus && (u10.length === 0 || u10.every((y18) => y18 == null || y18 === false)) ? 1 : 0;
        return { stdout: h16, stderr: "", exitCode: m24 };
      } catch (c14) {
        if (c14 instanceof b2) return { stdout: "", stderr: `yq: ${c14.message}
`, exitCode: b2.EXIT_CODE };
        let u10 = c14.message;
        return u10.includes("Unknown function") ? { stdout: "", stderr: `yq: error: ${u10}
`, exitCode: 3 } : { stdout: "", stderr: `yq: parse error: ${u10}
`, exitCode: 5 };
      }
    } };
    rg = { name: "yq", flags: [{ flag: "-r", type: "boolean" }, { flag: "-c", type: "boolean" }, { flag: "-s", type: "boolean" }, { flag: "-i", type: "value", valueHint: "string" }, { flag: "-o", type: "value", valueHint: "string" }], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/yq-FD5F3WOJ.js
var yq_FD5F3WOJ_exports = {};
__export(yq_FD5F3WOJ_exports, {
  flagsForFuzzing: () => rg,
  yqCommand: () => ig
});
var init_yq_FD5F3WOJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/yq-FD5F3WOJ.js"() {
    init_chunk_XMDVFEVC();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-F55TLFGB.js
function j9() {
  return /* @__PURE__ */ Object.create(null);
}
function S11(e5, o9, r8) {
  e5[o9] = r8;
}
function C17(e5) {
  let o9 = j9();
  for (let r8 of Object.keys(e5)) {
    let s9 = e5[r8];
    (typeof s9 == "string" || typeof s9 == "number" || typeof s9 == "boolean" || s9 === null) && (o9[r8] = s9);
  }
  return o9;
}
function b23(e5) {
  let o9 = w17.default.parse(e5.trim(), { header: true, dynamicTyping: true, skipEmptyLines: true }), r8 = o9.data.map((s9) => C17(s9));
  return { headers: o9.meta.fields || [], data: r8 };
}
function R8(e5, o9) {
  return o9.length === 0 ? `${e5.join(",")}
` : `${w17.default.unparse(o9, { columns: e5 }).replace(/\r\n/g, `
`)}
`;
}
async function g16(e5, o9) {
  let r8 = e5.find((p17) => !p17.startsWith("-")), s9;
  if (!r8 || r8 === "-") s9 = o9.stdin;
  else try {
    let p17 = o9.fs.resolvePath(o9.cwd, r8);
    s9 = await o9.fs.readFile(p17);
  } catch {
    return { headers: [], data: [], error: { stdout: "", stderr: `xan: ${r8}: No such file or directory
`, exitCode: 1 } };
  }
  let { headers: i10, data: f11 } = b23(s9);
  return { headers: i10, data: f11 };
}
async function W11(e5, o9) {
  let r8 = 0, s9 = [], i10 = [];
  for (let t6 = 0; t6 < e5.length; t6++) {
    let n23 = e5[t6];
    (n23 === "-l" || n23 === "--limit") && t6 + 1 < e5.length ? r8 = Number.parseInt(e5[++t6], 10) : (n23 === "-s" || n23 === "--select") && t6 + 1 < e5.length ? s9 = e5[++t6].split(",") : n23.startsWith("-") || i10.push(n23);
  }
  let { headers: f11, data: p17, error: d16 } = await g16(i10, o9);
  if (d16) return d16;
  let c14 = s9.length > 0 ? s9.filter((t6) => f11.includes(t6)) : f11, l8 = r8 > 0 ? p17.slice(0, r8) : p17, h16 = Math.max(...c14.map((t6) => t6.length)), a7 = [], $17 = "\u2500".repeat(80);
  for (let t6 = 0; t6 < l8.length; t6++) {
    let n23 = l8[t6];
    a7.push(`Row n\xB0${t6}`), a7.push($17);
    for (let u10 of c14) {
      let m24 = n23[u10], y18 = m24 == null ? "" : String(m24);
      a7.push(`${u10.padEnd(h16)} ${y18}`);
    }
    t6 < l8.length - 1 && a7.push("");
  }
  return { stdout: `${a7.join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function k11(e5, o9) {
  let r8 = 0, s9 = [];
  for (let t6 = 0; t6 < e5.length; t6++) {
    let n23 = e5[t6];
    n23 === "-n" && t6 + 1 < e5.length ? r8 = Number.parseInt(e5[++t6], 10) : n23.startsWith("-") || s9.push(n23);
  }
  let { headers: i10, data: f11, error: p17 } = await g16(s9, o9);
  if (p17) return p17;
  let d16 = r8 > 0 ? f11.slice(0, r8) : f11, c14 = i10.map((t6) => t6.length);
  for (let t6 of d16) for (let n23 = 0; n23 < i10.length; n23++) {
    let u10 = String(t6[i10[n23]] ?? "");
    c14[n23] = Math.max(c14[n23], u10.length);
  }
  let l8 = [], h16 = "\u2500", a7 = "\u2502";
  l8.push(`\u250C${c14.map((t6) => h16.repeat(t6 + 2)).join("\u252C")}\u2510`);
  let $17 = i10.map((t6, n23) => ` ${t6.padEnd(c14[n23])} `).join(a7);
  l8.push(`${a7}${$17}${a7}`), l8.push(`\u251C${c14.map((t6) => h16.repeat(t6 + 2)).join("\u253C")}\u2524`);
  for (let t6 of d16) {
    let n23 = i10.map((u10, m24) => ` ${String(t6[u10] ?? "").padEnd(c14[m24])} `).join(a7);
    l8.push(`${a7}${n23}${a7}`);
  }
  return l8.push(`\u2514${c14.map((t6) => h16.repeat(t6 + 2)).join("\u2534")}\u2518`), { stdout: `${l8.join(`
`)}
`, stderr: "", exitCode: 0 };
}
var w17;
var init_chunk_F55TLFGB = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-F55TLFGB.js"() {
    init_chunk_SYMJJMQ4();
    init_chunk_DXB73IDG();
    w17 = q2(xe6(), 1);
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xan-view-ECQUO7AJ.js
var xan_view_ECQUO7AJ_exports = {};
__export(xan_view_ECQUO7AJ_exports, {
  cmdFlatten: () => W11,
  cmdView: () => k11
});
var init_xan_view_ECQUO7AJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xan-view-ECQUO7AJ.js"() {
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-JI3KJ32H.js
function V11(e5) {
  let n23 = [], s9 = new q13(e5).tokenize(), r8 = 0, o9 = () => s9[r8] || { type: "eof", value: "", pos: 0 }, i10 = () => s9[r8++];
  for (; o9().type !== "eof"; ) {
    if (o9().type === "," && n23.length > 0) {
      i10();
      continue;
    }
    let h16 = [], u10 = 0, p17 = r8;
    for (; o9().type !== "eof"; ) {
      let a7 = o9();
      if ((a7.type === "," || a7.type === "as") && u10 === 0) break;
      (a7.type === "(" || a7.type === "[" || a7.type === "{") && u10++, (a7.type === ")" || a7.type === "]" || a7.type === "}") && u10--, h16.push(i10());
    }
    h16.push({ type: "eof", value: "", pos: 0 });
    let f11 = new J11(h16).parse(), c14;
    if (o9().type === "as") if (i10(), o9().type === "(") {
      i10();
      let a7 = [];
      for (; o9().type !== ")" && o9().type !== "eof"; ) (o9().type === "ident" || o9().type === "string") && (a7.push(o9().value), i10()), o9().type === "," && i10();
      o9().type === ")" && i10(), c14 = a7;
    } else if (o9().type === "ident" || o9().type === "string") c14 = o9().value, i10();
    else throw new Error(`Expected name after 'as', got ${o9().type}`);
    else c14 = e5.slice(s9[p17].pos, s9[r8 - 1]?.pos || e5.length).trim(), f11.type === "identifier" && (c14 = f11.name);
    n23.push({ expr: f11, name: c14 });
  }
  return n23;
}
function _11(e5) {
  let t6 = new q13(e5).tokenize();
  return new J11(t6).parse();
}
function E9(e5, n23) {
  return n23.length === 0 ? k12(e5, []) : n23.length === 1 ? { type: "Pipe", left: n23[0], right: k12(e5, []) } : { type: "Pipe", left: n23[0], right: k12(e5, n23.slice(1)) };
}
function S12(e5, n23, t6) {
  return { type: "BinaryOp", op: e5, left: n23, right: t6 };
}
function k12(e5, n23) {
  return { type: "Call", name: e5, args: n23 };
}
function Je6(e5, n23, t6) {
  let s9 = { type: "Cond", cond: e5, elifs: [], else: t6 || { type: "Literal", value: null } };
  return s9[tt5] = n23, s9;
}
function P15(e5) {
  return { type: "Pipe", left: e5, right: { type: "Call", name: "tostring", args: [] } };
}
function O14(e5, n23 = true) {
  switch (e5.type) {
    case "int":
    case "float":
      return { type: "Literal", value: e5.value };
    case "string":
      return { type: "Literal", value: e5.value };
    case "bool":
      return { type: "Literal", value: e5.value };
    case "null":
      return { type: "Literal", value: null };
    case "underscore":
      return { type: "Index", base: { type: "Identity" }, index: { type: "Literal", value: "_" } };
    case "identifier":
      return n23 ? { type: "Field", name: e5.name } : { type: "VarRef", name: e5.name };
    case "lambdaBinding":
      return { type: "VarRef", name: e5.name };
    case "func": {
      let t6 = e5.args.map((r8) => O14(r8.expr, n23)), s9 = Object.hasOwn(B10, e5.name) ? B10[e5.name] : void 0;
      return typeof s9 == "function" ? s9(t6) : k12(typeof s9 == "string" ? s9 : e5.name, t6);
    }
    case "list":
      return e5.elements.length === 0 ? { type: "Array" } : { type: "Array", elements: e5.elements.reduce((t6, s9, r8) => {
        let o9 = O14(s9, n23);
        return r8 === 0 ? o9 : { type: "Comma", left: t6, right: o9 };
      }, null) };
    case "map":
      return { type: "Object", entries: e5.entries.map((t6) => ({ key: t6.key, value: O14(t6.value, n23) })) };
    case "regex":
      return { type: "Literal", value: e5.pattern };
    case "slice":
      return { type: "Slice", start: e5.start ? O14(e5.start, n23) : void 0, end: e5.end ? O14(e5.end, n23) : void 0 };
    case "lambda":
      return O14(e5.body, n23);
    case "pipeline":
      return { type: "Identity" };
    default:
      throw new Error(`Unknown moonblade expression type: ${e5.type}`);
  }
}
function Q11(e5) {
  let n23 = [], t6 = 0;
  for (; t6 < e5.length; ) {
    for (; t6 < e5.length && (e5[t6] === " " || e5[t6] === ","); ) t6++;
    if (t6 >= e5.length) break;
    let s9 = t6;
    for (; t6 < e5.length && /\w/.test(e5[t6]); ) t6++;
    let r8 = e5.slice(s9, t6);
    for (; t6 < e5.length && e5[t6] === " "; ) t6++;
    if (e5[t6] !== "(") break;
    t6++;
    let o9 = 1, i10 = t6;
    for (; t6 < e5.length && o9 > 0; ) e5[t6] === "(" ? o9++ : e5[t6] === ")" && o9--, o9 > 0 && t6++;
    let h16 = e5.slice(i10, t6).trim();
    for (t6++; t6 < e5.length && e5[t6] === " "; ) t6++;
    let u10 = "";
    if (e5.slice(t6, t6 + 3).toLowerCase() === "as ") {
      for (t6 += 3; t6 < e5.length && e5[t6] === " "; ) t6++;
      let p17 = t6;
      for (; t6 < e5.length && /\w/.test(e5[t6]); ) t6++;
      u10 = e5.slice(p17, t6);
    }
    u10 || (u10 = h16 ? `${r8}(${h16})` : `${r8}()`), n23.push({ func: r8, expr: h16, alias: u10 });
  }
  return n23;
}
function ze5(e5) {
  return /^\w+$/.test(e5);
}
function Z11(e5, n23, t6) {
  let s9 = O14(_11(n23)), r8 = d11(e5, s9, t6);
  return r8.length > 0 ? r8[0] : null;
}
function ee6(e5, n23, t6 = {}) {
  let { func: s9, expr: r8 } = n23;
  if (s9 === "count" && !r8) return e5.length;
  let o9;
  switch (ze5(r8) ? o9 = e5.map((i10) => i10[r8]).filter((i10) => i10 != null) : o9 = e5.map((i10) => Z11(i10, r8, t6)).filter((i10) => i10 != null), s9) {
    case "count":
      return ze5(r8) ? o9.length : o9.filter((i10) => !!i10).length;
    case "sum":
      return o9.map((h16) => typeof h16 == "number" ? h16 : Number.parseFloat(String(h16))).reduce((h16, u10) => h16 + u10, 0);
    case "mean":
    case "avg": {
      let i10 = o9.map((h16) => typeof h16 == "number" ? h16 : Number.parseFloat(String(h16)));
      return i10.length > 0 ? i10.reduce((h16, u10) => h16 + u10, 0) / i10.length : 0;
    }
    case "min": {
      let i10 = o9.map((h16) => typeof h16 == "number" ? h16 : Number.parseFloat(String(h16)));
      return i10.length > 0 ? Math.min(...i10) : null;
    }
    case "max": {
      let i10 = o9.map((h16) => typeof h16 == "number" ? h16 : Number.parseFloat(String(h16)));
      return i10.length > 0 ? Math.max(...i10) : null;
    }
    case "first":
      return o9.length > 0 ? o9[0] : null;
    case "last":
      return o9.length > 0 ? o9[o9.length - 1] : null;
    case "median": {
      let i10 = o9.map((u10) => typeof u10 == "number" ? u10 : Number.parseFloat(String(u10))).filter((u10) => !Number.isNaN(u10)).sort((u10, p17) => u10 - p17);
      if (i10.length === 0) return null;
      let h16 = Math.floor(i10.length / 2);
      return i10.length % 2 === 0 ? (i10[h16 - 1] + i10[h16]) / 2 : i10[h16];
    }
    case "mode": {
      let i10 = /* @__PURE__ */ new Map();
      for (let p17 of o9) {
        let l8 = String(p17);
        i10.set(l8, (i10.get(l8) || 0) + 1);
      }
      let h16 = 0, u10 = null;
      for (let [p17, l8] of i10) l8 > h16 && (h16 = l8, u10 = p17);
      return u10;
    }
    case "cardinality":
      return new Set(o9.map((h16) => String(h16))).size;
    case "values":
      return o9.map((i10) => String(i10)).join("|");
    case "distinct_values":
      return [...new Set(o9.map((h16) => String(h16)))].sort().join("|");
    case "all": {
      if (e5.length === 0) return true;
      for (let i10 of e5) if (!Z11(i10, r8, t6)) return false;
      return true;
    }
    case "any": {
      for (let i10 of e5) if (Z11(i10, r8, t6)) return true;
      return false;
    }
    default:
      return null;
  }
}
function Ke5(e5, n23, t6 = {}) {
  let s9 = j9();
  for (let r8 of n23) S11(s9, r8.alias, ee6(e5, r8, t6));
  return s9;
}
async function te8(e5, n23) {
  let t6 = "", s9 = [];
  for (let l8 of e5) l8.startsWith("-") || (t6 ? s9.push(l8) : t6 = l8);
  if (!t6) return { stdout: "", stderr: `xan agg: no aggregation expression
`, exitCode: 1 };
  let { data: r8, error: o9 } = await g16(s9, n23);
  if (o9) return o9;
  let i10 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, h16 = Q11(t6), u10 = h16.map((l8) => l8.alias), p17 = Ke5(r8, h16, i10);
  return { stdout: R8(u10, [p17]), stderr: "", exitCode: 0 };
}
async function ne7(e5, n23) {
  let t6 = "", s9 = "", r8 = [];
  for (let d16 = 0; d16 < e5.length; d16++) {
    let m24 = e5[d16];
    m24 === "--sorted" || m24.startsWith("-") || (t6 ? s9 ? r8.push(m24) : s9 = m24 : t6 = m24);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan groupby: usage: xan groupby COLS EXPR [FILE]
`, exitCode: 1 };
  let { data: o9, error: i10 } = await g16(r8, n23);
  if (i10) return i10;
  let h16 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, u10 = t6.split(","), p17 = Q11(s9), l8 = [], f11 = /* @__PURE__ */ new Map();
  for (let d16 of o9) {
    let m24 = u10.map((g18) => String(d16[g18])).join("\0");
    f11.has(m24) || (f11.set(m24, []), l8.push(m24)), f11.get(m24)?.push(d16);
  }
  let c14 = [...u10, ...p17.map((d16) => d16.alias)], a7 = [];
  for (let d16 of l8) {
    let m24 = f11.get(d16);
    if (!m24) continue;
    let g18 = j9();
    for (let y18 of u10) S11(g18, y18, m24[0][y18]);
    for (let y18 of p17) S11(g18, y18.alias, ee6(m24, y18, h16));
    a7.push(g18);
  }
  return { stdout: R8(c14, a7), stderr: "", exitCode: 0 };
}
async function se6(e5, n23) {
  let t6 = [], s9 = "", r8 = 10, o9 = false, i10 = [];
  for (let a7 = 0; a7 < e5.length; a7++) {
    let d16 = e5[a7];
    (d16 === "-s" || d16 === "--select") && a7 + 1 < e5.length ? t6 = e5[++a7].split(",") : (d16 === "-g" || d16 === "--groupby") && a7 + 1 < e5.length ? s9 = e5[++a7] : (d16 === "-l" || d16 === "--limit") && a7 + 1 < e5.length ? r8 = Number.parseInt(e5[++a7], 10) : d16 === "--no-extra" ? o9 = true : d16 === "-A" || d16 === "--all" ? r8 = 0 : d16.startsWith("-") || i10.push(d16);
  }
  let { headers: h16, data: u10, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  let l8 = t6.length > 0 ? t6 : h16.filter((a7) => a7 !== s9);
  s9 && t6.length === 0 && (l8 = h16.filter((a7) => a7 !== s9));
  let f11 = [], c14 = s9 ? ["field", s9, "value", "count"] : ["field", "value", "count"];
  if (s9) {
    let a7 = /* @__PURE__ */ new Map();
    for (let d16 of u10) {
      let m24 = String(d16[s9] ?? "");
      a7.has(m24) || a7.set(m24, []), a7.get(m24)?.push(d16);
    }
    for (let d16 of l8) for (let [m24, g18] of a7) {
      let y18 = /* @__PURE__ */ new Map();
      for (let I17 of g18) {
        let N14 = I17[d16], C19 = N14 === "" || N14 === null || N14 === void 0 ? "" : String(N14);
        y18.set(C19, (y18.get(C19) || 0) + 1);
      }
      let x22 = [...y18.entries()].sort((I17, N14) => N14[1] !== I17[1] ? N14[1] - I17[1] : I17[0].localeCompare(N14[0]));
      o9 && (x22 = x22.filter(([I17]) => I17 !== "")), r8 > 0 && (x22 = x22.slice(0, r8));
      for (let [I17, N14] of x22) f11.push({ field: d16, [s9]: m24, value: I17 === "" ? "<empty>" : I17, count: N14 });
    }
  } else for (let a7 of l8) {
    let d16 = /* @__PURE__ */ new Map();
    for (let g18 of u10) {
      let y18 = g18[a7], x22 = y18 === "" || y18 === null || y18 === void 0 ? "" : String(y18);
      d16.set(x22, (d16.get(x22) || 0) + 1);
    }
    let m24 = [...d16.entries()].sort((g18, y18) => y18[1] !== g18[1] ? y18[1] - g18[1] : g18[0].localeCompare(y18[0]));
    o9 && (m24 = m24.filter(([g18]) => g18 !== "")), r8 > 0 && (m24 = m24.slice(0, r8));
    for (let [g18, y18] of m24) f11.push({ field: a7, value: g18 === "" ? "<empty>" : g18, count: y18 });
  }
  return { stdout: R8(c14, f11), stderr: "", exitCode: 0 };
}
async function re4(e5, n23) {
  let t6 = [], s9 = [];
  for (let l8 = 0; l8 < e5.length; l8++) {
    let f11 = e5[l8];
    f11 === "-s" && l8 + 1 < e5.length ? t6 = e5[++l8].split(",") : f11.startsWith("-") || s9.push(f11);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = t6.length > 0 ? t6 : r8, u10 = ["field", "type", "count", "min", "max", "mean"], p17 = [];
  for (let l8 of h16) {
    let f11 = o9.map((d16) => d16[l8]).filter((d16) => d16 != null), c14 = f11.map((d16) => typeof d16 == "number" ? d16 : Number.parseFloat(String(d16))).filter((d16) => !Number.isNaN(d16)), a7 = c14.length === f11.length && c14.length > 0;
    p17.push({ field: l8, type: a7 ? "Number" : "String", count: f11.length, min: a7 ? Math.min(...c14) : "", max: a7 ? Math.max(...c14) : "", mean: a7 ? Math.round(c14.reduce((d16, m24) => d16 + m24, 0) / c14.length * 1e10) / 1e10 : "" });
  }
  return { stdout: R8(u10, p17), stderr: "", exitCode: 0 };
}
function Ge5(e5) {
  let n23 = _11(e5);
  return O14(n23);
}
function nt6(e5) {
  let t6 = e5.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*");
  return b1(`^${t6}$`);
}
function z8(e5, n23) {
  let t6 = [], s9 = /* @__PURE__ */ new Set();
  for (let r8 of e5.split(",")) {
    let o9 = r8.trim();
    if (o9.startsWith("!")) {
      let p17 = o9.slice(1), l8 = z8(p17, n23);
      for (let f11 of l8) s9.add(f11);
      continue;
    }
    if (o9 === "*") {
      for (let p17 of n23) t6.includes(p17) || t6.push(p17);
      continue;
    }
    if (o9.includes("*")) {
      let p17 = nt6(o9);
      for (let l8 of n23) p17.test(l8) && !t6.includes(l8) && t6.push(l8);
      continue;
    }
    let i10 = o9.match(/^([^:]*):([^:]*)$/);
    if (i10 && (i10[1] || i10[2])) {
      let p17 = i10[1], l8 = i10[2], f11 = p17 ? n23.indexOf(p17) : 0, c14 = l8 ? n23.indexOf(l8) : n23.length - 1;
      if (f11 !== -1 && c14 !== -1) {
        let a7 = f11 <= c14 ? 1 : -1;
        for (let d16 = f11; a7 > 0 ? d16 <= c14 : d16 >= c14; d16 += a7) t6.includes(n23[d16]) || t6.push(n23[d16]);
      }
      continue;
    }
    let h16 = o9.match(/^(\d+)-(\d+)$/);
    if (h16) {
      let p17 = Number.parseInt(h16[1], 10), l8 = Number.parseInt(h16[2], 10);
      for (let f11 = p17; f11 <= l8 && f11 < n23.length; f11++) t6.push(n23[f11]);
      continue;
    }
    let u10 = Number.parseInt(o9, 10);
    if (!Number.isNaN(u10) && u10 >= 0 && u10 < n23.length) {
      t6.push(n23[u10]);
      continue;
    }
    n23.includes(o9) && t6.push(o9);
  }
  return s9.size > 0 ? t6.filter((r8) => !s9.has(r8)) : t6;
}
async function oe6(e5, n23) {
  let t6 = "", s9 = [];
  for (let p17 of e5) p17.startsWith("-") || (t6 ? s9.push(p17) : t6 = p17);
  if (!t6) return { stdout: "", stderr: `xan select: no columns specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = z8(t6, r8), u10 = o9.map((p17) => {
    let l8 = j9();
    for (let f11 of h16) S11(l8, f11, p17[f11]);
    return l8;
  });
  return { stdout: R8(h16, u10), stderr: "", exitCode: 0 };
}
async function ie5(e5, n23) {
  let t6 = "", s9 = [];
  for (let l8 of e5) l8.startsWith("-") || (t6 ? s9.push(l8) : t6 = l8);
  if (!t6) return { stdout: "", stderr: `xan drop: no columns specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = new Set(z8(t6, r8)), u10 = r8.filter((l8) => !h16.has(l8)), p17 = o9.map((l8) => {
    let f11 = j9();
    for (let c14 of u10) S11(f11, c14, l8[c14]);
    return f11;
  });
  return { stdout: R8(u10, p17), stderr: "", exitCode: 0 };
}
async function ae7(e5, n23) {
  let t6 = "", s9 = "", r8 = [];
  for (let l8 = 0; l8 < e5.length; l8++) {
    let f11 = e5[l8];
    f11 === "-s" && l8 + 1 < e5.length ? s9 = e5[++l8] : f11.startsWith("-") || (t6 ? r8.push(f11) : t6 = f11);
  }
  if (!t6) return { stdout: "", stderr: `xan rename: no new name(s) specified
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h16 } = await g16(r8, n23);
  if (h16) return h16;
  let u10;
  if (s9) {
    let l8 = s9.split(","), f11 = t6.split(","), c14 = /* @__PURE__ */ new Map();
    for (let a7 = 0; a7 < l8.length && a7 < f11.length; a7++) c14.set(l8[a7], f11[a7]);
    u10 = o9.map((a7) => c14.get(a7) || a7);
  } else {
    let l8 = t6.split(",");
    u10 = o9.map((f11, c14) => c14 < l8.length ? l8[c14] : f11);
  }
  let p17 = i10.map((l8) => {
    let f11 = j9();
    for (let c14 = 0; c14 < o9.length; c14++) S11(f11, u10[c14], l8[o9[c14]]);
    return f11;
  });
  return { stdout: R8(u10, p17), stderr: "", exitCode: 0 };
}
async function le7(e5, n23) {
  let t6 = "index", s9 = [];
  for (let p17 = 0; p17 < e5.length; p17++) e5[p17] === "-c" && p17 + 1 < e5.length ? t6 = e5[++p17] : s9.push(e5[p17]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = [t6, ...r8], u10 = o9.map((p17, l8) => {
    let f11 = j9();
    S11(f11, t6, l8);
    for (let c14 of r8) S11(f11, c14, p17[c14]);
    return f11;
  });
  return { stdout: R8(h16, u10), stderr: "", exitCode: 0 };
}
async function ue8(e5, n23) {
  let t6 = e5.includes("-j") || e5.includes("--just-names"), { headers: s9, error: r8 } = await g16(e5.filter((i10) => i10 !== "-j" && i10 !== "--just-names"), n23);
  return r8 || { stdout: t6 ? `${s9.map((i10) => i10).join(`
`)}
` : `${s9.map((i10, h16) => `${h16}   ${i10}`).join(`
`)}
`, stderr: "", exitCode: 0 };
}
async function ce7(e5, n23) {
  let { data: t6, error: s9 } = await g16(e5, n23);
  return s9 || { stdout: `${t6.length}
`, stderr: "", exitCode: 0 };
}
async function pe7(e5, n23) {
  let t6 = 10, s9 = [];
  for (let u10 = 0; u10 < e5.length; u10++) (e5[u10] === "-l" || e5[u10] === "-n") && u10 + 1 < e5.length ? t6 = Number.parseInt(e5[++u10], 10) : s9.push(e5[u10]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = o9.slice(0, t6);
  return { stdout: R8(r8, h16), stderr: "", exitCode: 0 };
}
async function fe9(e5, n23) {
  let t6 = 10, s9 = [];
  for (let u10 = 0; u10 < e5.length; u10++) (e5[u10] === "-l" || e5[u10] === "-n") && u10 + 1 < e5.length ? t6 = Number.parseInt(e5[++u10], 10) : s9.push(e5[u10]);
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = o9.slice(-t6);
  return { stdout: R8(r8, h16), stderr: "", exitCode: 0 };
}
async function de8(e5, n23) {
  let t6, s9, r8, o9 = [];
  for (let c14 = 0; c14 < e5.length; c14++) {
    let a7 = e5[c14];
    (a7 === "-s" || a7 === "--start") && c14 + 1 < e5.length ? t6 = Number.parseInt(e5[++c14], 10) : (a7 === "-e" || a7 === "--end") && c14 + 1 < e5.length ? s9 = Number.parseInt(e5[++c14], 10) : (a7 === "-l" || a7 === "--len") && c14 + 1 < e5.length ? r8 = Number.parseInt(e5[++c14], 10) : a7.startsWith("-") || o9.push(a7);
  }
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  let p17 = t6 ?? 0, l8;
  r8 !== void 0 ? l8 = p17 + r8 : s9 !== void 0 ? l8 = s9 : l8 = h16.length;
  let f11 = h16.slice(p17, l8);
  return { stdout: R8(i10, f11), stderr: "", exitCode: 0 };
}
async function he8(e5, n23) {
  let { headers: t6, data: s9, error: r8 } = await g16(e5, n23);
  if (r8) return r8;
  let o9 = [...s9].reverse();
  return { stdout: R8(t6, o9), stderr: "", exitCode: 0 };
}
async function ge7(e5, n23) {
  let t6 = e5.filter((p17) => !p17.startsWith("-")), { headers: s9, data: r8, error: o9 } = await g16(t6, n23);
  if (o9) return o9;
  if (r8.length === 0) {
    let p17 = ["column"], l8 = s9.map((f11) => ({ column: f11 }));
    return { stdout: R8(p17, l8), stderr: "", exitCode: 0 };
  }
  let i10 = s9[0], h16 = [i10, ...r8.map((p17, l8) => String(p17[i10] ?? `row_${l8}`))], u10 = [];
  for (let p17 = 1; p17 < s9.length; p17++) {
    let l8 = s9[p17], f11 = j9();
    S11(f11, i10, l8);
    for (let c14 = 0; c14 < r8.length; c14++) S11(f11, h16[c14 + 1], r8[c14][l8]);
    u10.push(f11);
  }
  return { stdout: R8(h16, u10), stderr: "", exitCode: 0 };
}
async function ye6(e5, n23) {
  let t6 = null, s9 = [];
  for (let l8 = 0; l8 < e5.length; l8++) {
    let f11 = e5[l8];
    f11 === "--seed" && l8 + 1 < e5.length ? t6 = Number.parseInt(e5[++l8], 10) : f11.startsWith("-") || s9.push(f11);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = t6 !== null ? t6 : Date.now(), u10 = () => (h16 = h16 * 1103515245 + 12345 & 2147483647, h16 / 2147483647), p17 = [...o9];
  for (let l8 = p17.length - 1; l8 > 0; l8--) {
    let f11 = Math.floor(u10() * (l8 + 1));
    [p17[l8], p17[f11]] = [p17[f11], p17[l8]];
  }
  return { stdout: R8(r8, p17), stderr: "", exitCode: 0 };
}
async function xe8(e5, n23) {
  let t6 = null, s9 = "", r8 = [];
  for (let a7 = 0; a7 < e5.length; a7++) {
    let d16 = e5[a7];
    (d16 === "-l" || d16 === "--length") && a7 + 1 < e5.length ? t6 = Number.parseInt(e5[++a7], 10) : (d16 === "-d" || d16 === "--default") && a7 + 1 < e5.length ? s9 = e5[++a7] : d16.startsWith("-") || r8.push(d16);
  }
  let o9 = r8[0], i10;
  if (!o9 || o9 === "-") i10 = n23.stdin;
  else try {
    let a7 = n23.fs.resolvePath(n23.cwd, o9);
    i10 = await n23.fs.readFile(a7);
  } catch {
    return { stdout: "", stderr: `xan fixlengths: ${o9}: No such file or directory
`, exitCode: 1 };
  }
  let u10 = me4.default.parse(i10.trim(), { header: false, skipEmptyLines: true }).data;
  if (u10.length === 0) return { stdout: "", stderr: "", exitCode: 0 };
  let p17 = Math.max(...u10.map((a7) => a7.length)), l8 = t6 ?? p17, f11 = u10.map((a7) => a7.length === l8 ? a7 : a7.length < l8 ? [...a7, ...Array(l8 - a7.length).fill(s9)] : a7.slice(0, l8));
  return { stdout: `${me4.default.unparse(f11).replace(/\r\n/g, `
`)}
`, stderr: "", exitCode: 0 };
}
async function we5(e5, n23) {
  let t6 = null, s9 = null, r8 = ".", o9 = [];
  for (let c14 = 0; c14 < e5.length; c14++) {
    let a7 = e5[c14];
    (a7 === "-c" || a7 === "--chunks") && c14 + 1 < e5.length ? t6 = Number.parseInt(e5[++c14], 10) : (a7 === "-S" || a7 === "--size") && c14 + 1 < e5.length ? s9 = Number.parseInt(e5[++c14], 10) : (a7 === "-o" || a7 === "--output") && c14 + 1 < e5.length ? r8 = e5[++c14] : a7.startsWith("-") || o9.push(a7);
  }
  if (!t6 && !s9) return { stdout: "", stderr: `xan split: must specify -c or -S
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  let p17 = [];
  if (t6) {
    let c14 = Math.ceil(h16.length / t6);
    for (let a7 = 0; a7 < t6; a7++) p17.push(h16.slice(a7 * c14, (a7 + 1) * c14));
  } else if (s9) for (let c14 = 0; c14 < h16.length; c14 += s9) p17.push(h16.slice(c14, c14 + s9));
  let l8 = p17.filter((c14) => c14.length > 0), f11 = o9[0]?.replace(/\.csv$/, "") || "part";
  try {
    let c14 = n23.fs.resolvePath(n23.cwd, r8);
    for (let a7 = 0; a7 < l8.length; a7++) {
      let d16 = `${f11}_${String(a7 + 1).padStart(3, "0")}.csv`, m24 = n23.fs.resolvePath(c14, d16);
      await n23.fs.writeFile(m24, R8(i10, l8[a7]));
    }
    return { stdout: `Split into ${l8.length} parts
`, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: `${l8.map((a7, d16) => `Part ${d16 + 1}: ${a7.length} rows`).join(`
`)}
`, stderr: "", exitCode: 0 };
  }
}
async function ve6(e5, n23) {
  let t6 = "", s9 = ".", r8 = [];
  for (let p17 = 0; p17 < e5.length; p17++) {
    let l8 = e5[p17];
    (l8 === "-o" || l8 === "--output") && p17 + 1 < e5.length ? s9 = e5[++p17] : l8.startsWith("-") || (t6 ? r8.push(l8) : t6 = l8);
  }
  if (!t6) return { stdout: "", stderr: `xan partition: usage: xan partition COLUMN [FILE]
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h16 } = await g16(r8, n23);
  if (h16) return h16;
  if (!o9.includes(t6)) return { stdout: "", stderr: `xan partition: column '${t6}' not found
`, exitCode: 1 };
  let u10 = /* @__PURE__ */ new Map();
  for (let p17 of i10) {
    let l8 = String(p17[t6] ?? "");
    u10.has(l8) || u10.set(l8, []), u10.get(l8)?.push(p17);
  }
  try {
    let p17 = n23.fs.resolvePath(n23.cwd, s9);
    for (let [l8, f11] of u10) {
      let a7 = `${l8.replace(/[^a-zA-Z0-9_-]/g, "_") || "empty"}.csv`, d16 = n23.fs.resolvePath(p17, a7);
      await n23.fs.writeFile(d16, R8(o9, f11));
    }
    return { stdout: `Partitioned into ${u10.size} files by '${t6}'
`, stderr: "", exitCode: 0 };
  } catch {
    return { stdout: `${Array.from(u10.entries()).map(([l8, f11]) => `${l8}: ${f11.length} rows`).join(`
`)}
`, stderr: "", exitCode: 0 };
  }
}
async function Ce3(e5, n23) {
  if (e5.length === 0) return { stdout: "", stderr: `xan to: usage: xan to <format> [FILE]
`, exitCode: 1 };
  let t6 = e5[0], s9 = e5.slice(1);
  return t6 === "json" ? st6(s9, n23) : { stdout: "", stderr: `xan to: unsupported format '${t6}'
`, exitCode: 1 };
}
async function st6(e5, n23) {
  let t6 = e5.filter((i10) => !i10.startsWith("-")), { data: s9, error: r8 } = await g16(t6, n23);
  return r8 || { stdout: `${JSON.stringify(s9, null, 2)}
`, stderr: "", exitCode: 0 };
}
async function be5(e5, n23) {
  let t6 = "", s9 = [];
  for (let r8 = 0; r8 < e5.length; r8++) {
    let o9 = e5[r8];
    (o9 === "-f" || o9 === "--format") && r8 + 1 < e5.length ? t6 = e5[++r8] : o9.startsWith("-") || s9.push(o9);
  }
  return t6 ? t6 === "json" ? rt5(s9, n23) : { stdout: "", stderr: `xan from: unsupported format '${t6}'
`, exitCode: 1 } : { stdout: "", stderr: `xan from: usage: xan from -f <format> [FILE]
`, exitCode: 1 };
}
async function rt5(e5, n23) {
  let t6 = e5[0], s9;
  if (!t6 || t6 === "-") s9 = n23.stdin;
  else try {
    let r8 = n23.fs.resolvePath(n23.cwd, t6);
    s9 = await n23.fs.readFile(r8);
  } catch {
    return { stdout: "", stderr: `xan from: ${t6}: No such file or directory
`, exitCode: 1 };
  }
  try {
    let r8 = JSON.parse(s9.trim());
    if (!Array.isArray(r8)) return { stdout: "", stderr: `xan from: JSON input must be an array
`, exitCode: 1 };
    if (r8.length === 0) return { stdout: `
`, stderr: "", exitCode: 0 };
    if (Array.isArray(r8[0])) {
      let [i10, ...h16] = r8, u10 = h16.map((p17) => {
        let l8 = j9();
        for (let f11 = 0; f11 < i10.length; f11++) S11(l8, i10[f11], p17[f11]);
        return l8;
      });
      return { stdout: R8(i10, u10), stderr: "", exitCode: 0 };
    }
    let o9 = Object.keys(r8[0]).sort();
    return { stdout: R8(o9, r8), stderr: "", exitCode: 0 };
  } catch {
    return { stdout: "", stderr: `xan from: invalid JSON input
`, exitCode: 1 };
  }
}
async function Se4(e5, n23) {
  let t6 = false, s9 = 0, r8 = "", o9 = [];
  for (let c14 = 0; c14 < e5.length; c14++) {
    let a7 = e5[c14];
    if (a7 === "-v" || a7 === "--invert") t6 = true;
    else if ((a7 === "-l" || a7 === "--limit") && c14 + 1 < e5.length) s9 = Number.parseInt(e5[++c14], 10);
    else {
      if (a7 === "--help") return s({ name: "xan filter", summary: "Filter rows by expression", usage: "xan filter [OPTIONS] EXPR [FILE]", description: "Filter CSV rows using moonblade expressions.", options: ["-v, --invert    invert match", "-l, --limit N   limit output to N rows", "    --help      display help"] });
      a7.startsWith("-") || (r8 ? o9.push(a7) : r8 = a7);
    }
  }
  if (!r8) return { stdout: "", stderr: `xan filter: no expression specified
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  let p17 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, l8 = Ge5(r8), f11 = [];
  for (let c14 of h16) {
    if (s9 > 0 && f11.length >= s9) break;
    let a7 = d11(c14, l8, p17), d16 = a7.length > 0 && a7.some((m24) => !!m24);
    (t6 ? !d16 : d16) && f11.push(c14);
  }
  return { stdout: R8(i10, f11), stderr: "", exitCode: 0 };
}
async function Ie6(e5, n23) {
  let t6 = "", s9 = false, r8 = false, o9 = [];
  for (let l8 = 0; l8 < e5.length; l8++) {
    let f11 = e5[l8];
    f11 === "-N" || f11 === "--numeric" ? s9 = true : f11 === "-R" || f11 === "-r" || f11 === "--reverse" ? r8 = true : f11 === "-s" && l8 + 1 < e5.length ? t6 = e5[++l8] : f11.startsWith("-") || o9.push(f11);
  }
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  !t6 && i10.length > 0 && (t6 = i10[0]);
  let p17 = [...h16].sort((l8, f11) => {
    let c14 = l8[t6], a7 = f11[t6], d16;
    if (s9) {
      let m24 = typeof c14 == "number" ? c14 : Number.parseFloat(String(c14)), g18 = typeof a7 == "number" ? a7 : Number.parseFloat(String(a7));
      d16 = m24 - g18;
    } else d16 = String(c14).localeCompare(String(a7));
    return r8 ? -d16 : d16;
  });
  return { stdout: R8(i10, p17), stderr: "", exitCode: 0 };
}
async function ke5(e5, n23) {
  let t6 = "", s9 = [];
  for (let p17 = 0; p17 < e5.length; p17++) {
    let l8 = e5[p17];
    l8 === "-s" && p17 + 1 < e5.length ? t6 = e5[++p17] : l8.startsWith("-") || s9.push(l8);
  }
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let h16 = /* @__PURE__ */ new Set(), u10 = o9.filter((p17) => {
    let l8 = t6 ? String(p17[t6]) : JSON.stringify(p17);
    return h16.has(l8) ? false : (h16.add(l8), true);
  });
  return { stdout: R8(r8, u10), stderr: "", exitCode: 0 };
}
async function Ne5(e5, n23) {
  let t6 = 10, s9 = "", r8 = false, o9 = [];
  for (let f11 = 0; f11 < e5.length; f11++) {
    let c14 = e5[f11];
    (c14 === "-l" || c14 === "-n") && f11 + 1 < e5.length ? t6 = Number.parseInt(e5[++f11], 10) : c14 === "-R" || c14 === "-r" || c14 === "--reverse" ? r8 = true : c14.startsWith("-") || (s9 ? o9.push(c14) : s9 = c14);
  }
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  !s9 && i10.length > 0 && (s9 = i10[0]);
  let l8 = [...h16].sort((f11, c14) => {
    let a7 = f11[s9], d16 = c14[s9], m24 = typeof a7 == "number" ? a7 : Number.parseFloat(String(a7)), g18 = typeof d16 == "number" ? d16 : Number.parseFloat(String(d16));
    return r8 ? m24 - g18 : g18 - m24;
  }).slice(0, t6);
  return { stdout: R8(i10, l8), stderr: "", exitCode: 0 };
}
async function Ee5(e5, n23) {
  let t6 = "", s9 = false, r8 = false, o9 = [];
  for (let d16 = 0; d16 < e5.length; d16++) {
    let m24 = e5[d16];
    m24 === "-O" || m24 === "--overwrite" ? s9 = true : m24 === "--filter" ? r8 = true : m24.startsWith("-") || (t6 ? o9.push(m24) : t6 = m24);
  }
  if (!t6) return { stdout: "", stderr: `xan map: no expression specified
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  let l8 = V11(t6).map(({ expr: d16, name: m24 }) => ({ alias: typeof m24 == "string" ? m24 : m24[0], ast: O14(d16) })), f11 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, c14;
  if (s9) {
    c14 = [...i10];
    for (let d16 of l8) i10.includes(d16.alias) || c14.push(d16.alias);
  } else c14 = [...i10, ...l8.map((d16) => d16.alias)];
  let a7 = [];
  for (let d16 = 0; d16 < h16.length; d16++) {
    let m24 = h16[d16], g18 = C17(m24), y18 = false, x22 = Object.assign(s4(m24), { _row_index: d16 });
    for (let I17 of l8) {
      let N14 = d11(x22, I17.ast, f11), C19 = N14.length > 0 ? N14[0] : null;
      if (r8 && C19 == null) {
        y18 = true;
        break;
      }
      S11(g18, I17.alias, C19);
    }
    y18 || a7.push(g18);
  }
  return { stdout: R8(c14, a7), stderr: "", exitCode: 0 };
}
async function Ae6(e5, n23) {
  let t6 = "", s9 = "", r8 = "", o9 = [];
  for (let m24 = 0; m24 < e5.length; m24++) {
    let g18 = e5[m24];
    (g18 === "-r" || g18 === "--rename") && m24 + 1 < e5.length ? r8 = e5[++m24] : g18.startsWith("-") || (t6 ? s9 ? o9.push(g18) : s9 = g18 : t6 = g18);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan transform: usage: xan transform COLUMN EXPR [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  let p17 = t6.split(",").map((m24) => m24.trim()), l8 = r8 ? r8.split(",").map((m24) => m24.trim()) : [];
  for (let m24 of p17) if (!i10.includes(m24)) return { stdout: "", stderr: `xan transform: column '${m24}' not found
`, exitCode: 1 };
  let f11 = O14(V11(s9)[0]?.expr || (U12(), r2(He6)).parseMoonblade(s9)), c14 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, a7 = i10.map((m24) => {
    let g18 = p17.indexOf(m24);
    return g18 !== -1 && l8[g18] ? l8[g18] : m24;
  }), d16 = [];
  for (let m24 of h16) {
    let g18 = C17(m24);
    for (let y18 = 0; y18 < p17.length; y18++) {
      let x22 = p17[y18], I17 = Object.assign(s4(m24), { _: m24[x22] }), N14 = d11(I17, f11, c14), C19 = N14.length > 0 ? N14[0] : null, A13 = l8[y18] || x22;
      A13 !== x22 && delete g18[x22], S11(g18, A13, C19);
    }
    d16.push(g18);
  }
  return { stdout: R8(a7, d16), stderr: "", exitCode: 0 };
}
async function Fe6(e5, n23) {
  let t6 = "", s9 = "|", r8 = false, o9 = "", i10 = [];
  for (let a7 = 0; a7 < e5.length; a7++) {
    let d16 = e5[a7];
    (d16 === "-s" || d16 === "--separator") && a7 + 1 < e5.length ? s9 = e5[++a7] : d16 === "--drop-empty" ? r8 = true : (d16 === "-r" || d16 === "--rename") && a7 + 1 < e5.length ? o9 = e5[++a7] : d16.startsWith("-") || (t6 ? i10.push(d16) : t6 = d16);
  }
  if (!t6) return { stdout: "", stderr: `xan explode: usage: xan explode COLUMN [FILE]
`, exitCode: 1 };
  let { headers: h16, data: u10, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  if (!h16.includes(t6)) return { stdout: "", stderr: `xan explode: column '${t6}' not found
`, exitCode: 1 };
  let l8 = o9 ? h16.map((a7) => a7 === t6 ? o9 : a7) : h16, f11 = o9 || t6, c14 = [];
  for (let a7 of u10) {
    let d16 = a7[t6], m24 = d16 == null ? "" : String(d16);
    if (m24 === "") {
      if (!r8) {
        let g18 = C17(a7);
        o9 && (delete g18[t6], S11(g18, f11, "")), c14.push(g18);
      }
    } else {
      let g18 = m24.split(s9);
      for (let y18 of g18) {
        let x22 = C17(a7);
        o9 && delete x22[t6], S11(x22, f11, y18), c14.push(x22);
      }
    }
  }
  return { stdout: R8(l8, c14), stderr: "", exitCode: 0 };
}
async function Oe4(e5, n23) {
  let t6 = "", s9 = "|", r8 = "", o9 = [];
  for (let g18 = 0; g18 < e5.length; g18++) {
    let y18 = e5[g18];
    (y18 === "-s" || y18 === "--sep") && g18 + 1 < e5.length ? s9 = e5[++g18] : (y18 === "-r" || y18 === "--rename") && g18 + 1 < e5.length ? r8 = e5[++g18] : y18.startsWith("-") || (t6 ? o9.push(y18) : t6 = y18);
  }
  if (!t6) return { stdout: "", stderr: `xan implode: usage: xan implode COLUMN [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  if (!i10.includes(t6)) return { stdout: "", stderr: `xan implode: column '${t6}' not found
`, exitCode: 1 };
  let p17 = i10.filter((g18) => g18 !== t6), l8 = r8 ? i10.map((g18) => g18 === t6 ? r8 : g18) : i10, f11 = r8 || t6, c14 = [], a7 = null, d16 = [], m24 = null;
  for (let g18 of h16) {
    let y18 = p17.map((N14) => String(g18[N14] ?? "")).join("\0"), x22 = g18[t6], I17 = x22 == null ? "" : String(x22);
    if (y18 !== a7) {
      if (m24 !== null) {
        let N14 = C17(m24);
        r8 && delete N14[t6], S11(N14, f11, d16.join(s9)), c14.push(N14);
      }
      a7 = y18, d16 = [I17], m24 = g18;
    } else d16.push(I17);
  }
  if (m24 !== null) {
    let g18 = C17(m24);
    r8 && delete g18[t6], S11(g18, f11, d16.join(s9)), c14.push(g18);
  }
  return { stdout: R8(l8, c14), stderr: "", exitCode: 0 };
}
async function Le5(e5, n23) {
  let t6 = "", s9 = "", r8 = "", o9 = "", i10 = "inner", h16 = "", u10 = 0;
  for (let C19 = 0; C19 < e5.length; C19++) {
    let A13 = e5[C19];
    A13 === "--left" ? i10 = "left" : A13 === "--right" ? i10 = "right" : A13 === "--full" ? i10 = "full" : (A13 === "-D" || A13 === "--default") && C19 + 1 < e5.length ? h16 = e5[++C19] : A13.startsWith("-") || (u10++, u10 === 1 ? t6 = A13 : u10 === 2 ? s9 = A13 : u10 === 3 ? r8 = A13 : u10 === 4 && (o9 = A13));
  }
  if (!t6 || !s9 || !r8 || !o9) return { stdout: "", stderr: `xan join: usage: xan join KEY1 FILE1 KEY2 FILE2 [OPTIONS]
`, exitCode: 1 };
  let p17 = await g16([s9], n23);
  if (p17.error) return p17.error;
  let l8 = await g16([o9], n23);
  if (l8.error) return l8.error;
  let { headers: f11, data: c14 } = p17, { headers: a7, data: d16 } = l8;
  if (!f11.includes(t6)) return { stdout: "", stderr: `xan join: column '${t6}' not found in first file
`, exitCode: 1 };
  if (!a7.includes(r8)) return { stdout: "", stderr: `xan join: column '${r8}' not found in second file
`, exitCode: 1 };
  let m24 = /* @__PURE__ */ new Map();
  for (let C19 of d16) {
    let A13 = String(C19[r8] ?? "");
    m24.has(A13) || m24.set(A13, []), m24.get(A13)?.push(C19);
  }
  let g18 = new Set(f11), y18 = a7.filter((C19) => !g18.has(C19)), x22 = [...f11, ...y18], I17 = [], N14 = /* @__PURE__ */ new Set();
  for (let C19 of c14) {
    let A13 = String(C19[t6] ?? ""), j11 = m24.get(A13);
    if (j11 && j11.length > 0) {
      N14.add(A13);
      for (let L18 of j11) {
        let T10 = j9();
        for (let W14 of f11) S11(T10, W14, C19[W14]);
        for (let W14 of y18) S11(T10, W14, L18[W14]);
        I17.push(T10);
      }
    } else if (i10 === "left" || i10 === "full") {
      let L18 = j9();
      for (let T10 of f11) S11(L18, T10, C19[T10]);
      for (let T10 of y18) S11(L18, T10, h16);
      I17.push(L18);
    }
  }
  if (i10 === "right" || i10 === "full") for (let C19 of d16) {
    let A13 = String(C19[r8] ?? "");
    if (!N14.has(A13)) {
      let j11 = j9();
      for (let L18 of f11) S11(j11, L18, a7.includes(L18) ? C19[L18] : h16);
      for (let L18 of y18) S11(j11, L18, C19[L18]);
      I17.push(j11);
    }
  }
  return { stdout: R8(x22, I17), stderr: "", exitCode: 0 };
}
async function Pe5(e5, n23) {
  let t6 = "", s9 = "", r8 = [], o9 = [];
  for (let y18 = 0; y18 < e5.length; y18++) {
    let x22 = e5[y18];
    (x22 === "-g" || x22 === "--groupby") && y18 + 1 < e5.length ? r8 = e5[++y18].split(",").map((I17) => I17.trim()) : x22.startsWith("-") || (t6 ? s9 ? o9.push(x22) : s9 = x22 : t6 = x22);
  }
  if (!t6 || !s9) return { stdout: "", stderr: `xan pivot: usage: xan pivot COLUMN AGG_EXPR [OPTIONS] [FILE]
`, exitCode: 1 };
  let { headers: i10, data: h16, error: u10 } = await g16(o9, n23);
  if (u10) return u10;
  if (!i10.includes(t6)) return { stdout: "", stderr: `xan pivot: column '${t6}' not found
`, exitCode: 1 };
  let p17 = s9.match(/^(\w+)\((\w+)\)$/);
  if (!p17) return { stdout: "", stderr: `xan pivot: invalid aggregation expression '${s9}'
`, exitCode: 1 };
  let [, l8, f11] = p17;
  r8.length === 0 && (r8 = i10.filter((y18) => y18 !== t6 && y18 !== f11));
  let c14 = [];
  for (let y18 of h16) {
    let x22 = String(y18[t6] ?? "");
    c14.includes(x22) || c14.push(x22);
  }
  let a7 = /* @__PURE__ */ new Map(), d16 = [];
  for (let y18 of h16) {
    let x22 = r8.map((A13) => String(y18[A13] ?? "")).join("\0"), I17 = String(y18[t6] ?? ""), N14 = y18[f11];
    a7.has(x22) || (a7.set(x22, /* @__PURE__ */ new Map()), d16.push(x22));
    let C19 = a7.get(x22);
    C19 && (C19.has(I17) || C19.set(I17, []), C19.get(I17)?.push(N14));
  }
  let m24 = [...r8, ...c14], g18 = [];
  for (let y18 of d16) {
    let x22 = y18.split("\0"), I17 = a7.get(y18);
    if (!I17) continue;
    let N14 = j9();
    for (let C19 = 0; C19 < r8.length; C19++) S11(N14, r8[C19], x22[C19]);
    for (let C19 of c14) {
      let A13 = I17.get(C19) || [];
      S11(N14, C19, ot5(l8, A13));
    }
    g18.push(N14);
  }
  return { stdout: R8(m24, g18), stderr: "", exitCode: 0 };
}
function ot5(e5, n23) {
  let t6 = n23.filter((s9) => s9 != null).map((s9) => typeof s9 == "number" ? s9 : Number.parseFloat(String(s9))).filter((s9) => !Number.isNaN(s9));
  switch (e5) {
    case "count":
      return n23.length;
    case "sum":
      return t6.reduce((s9, r8) => s9 + r8, 0);
    case "mean":
    case "avg":
      return t6.length > 0 ? t6.reduce((s9, r8) => s9 + r8, 0) / t6.length : null;
    case "min":
      return t6.length > 0 ? Math.min(...t6) : null;
    case "max":
      return t6.length > 0 ? Math.max(...t6) : null;
    case "first":
      return n23.length > 0 ? String(n23[0] ?? "") : null;
    case "last":
      return n23.length > 0 ? String(n23[n23.length - 1] ?? "") : null;
    default:
      return null;
  }
}
async function Re6(e5, n23) {
  let t6 = "", s9 = [];
  for (let h16 = 0; h16 < e5.length; h16++) {
    let u10 = e5[h16];
    (u10 === "-s" || u10 === "--sort") && h16 + 1 < e5.length ? t6 = e5[++h16] : u10.startsWith("-") || s9.push(u10);
  }
  if (s9.length < 2) return { stdout: "", stderr: `xan merge: usage: xan merge [OPTIONS] FILE1 FILE2 ...
`, exitCode: 1 };
  let r8 = [], o9 = null;
  for (let h16 of s9) {
    let u10 = await g16([h16], n23);
    if (u10.error) return u10.error;
    if (o9 === null) o9 = u10.headers;
    else if (JSON.stringify(o9) !== JSON.stringify(u10.headers)) return { stdout: "", stderr: `xan merge: all files must have the same headers
`, exitCode: 1 };
    r8.push({ headers: u10.headers, data: u10.data });
  }
  if (!o9) return { stdout: "", stderr: "", exitCode: 0 };
  let i10 = [];
  for (let { data: h16 } of r8) i10 = i10.concat(h16);
  if (t6) {
    if (!o9.includes(t6)) return { stdout: "", stderr: `xan merge: column '${t6}' not found
`, exitCode: 1 };
    i10.sort((h16, u10) => {
      let p17 = h16[t6], l8 = u10[t6], f11 = typeof p17 == "number" ? p17 : Number.parseFloat(String(p17)), c14 = typeof l8 == "number" ? l8 : Number.parseFloat(String(l8));
      return !Number.isNaN(f11) && !Number.isNaN(c14) ? f11 - c14 : String(p17 ?? "").localeCompare(String(l8 ?? ""));
    });
  }
  return { stdout: R8(o9, i10), stderr: "", exitCode: 0 };
}
async function Me5(e5, n23) {
  let t6 = e5.filter((u10) => !u10.startsWith("-")), { headers: s9, data: r8, error: o9 } = await g16(t6, n23);
  return o9 || (r8.length === 0 ? { stdout: "", stderr: "", exitCode: 0 } : { stdout: r8.map((u10) => s9.map((p17) => u10[p17])).map((u10) => u10.map((p17) => it5(p17)).join(",")).join(`
`) + `
`, stderr: "", exitCode: 0 });
}
function it5(e5) {
  if (e5 == null) return "";
  let n23 = String(e5);
  return n23.includes(",") || n23.includes('"') || n23.includes(`
`) ? `"${n23.replace(/"/g, '""')}"` : n23;
}
async function $e5(e5, n23) {
  let t6 = null, s9 = null, r8 = [];
  for (let c14 = 0; c14 < e5.length; c14++) {
    let a7 = e5[c14];
    if (a7 === "--seed" && c14 + 1 < e5.length) s9 = Number.parseInt(e5[++c14], 10);
    else if (!a7.startsWith("-")) {
      let d16 = Number.parseInt(a7, 10);
      t6 === null && !Number.isNaN(d16) && d16 > 0 ? t6 = d16 : r8.push(a7);
    }
  }
  if (t6 === null) return { stdout: "", stderr: `xan sample: usage: xan sample <sample-size> [FILE]
`, exitCode: 1 };
  let { headers: o9, data: i10, error: h16 } = await g16(r8, n23);
  if (h16) return h16;
  if (i10.length <= t6) return { stdout: R8(o9, i10), stderr: "", exitCode: 0 };
  let u10 = s9 !== null ? s9 : Date.now(), p17 = () => (u10 = u10 * 1103515245 + 12345 & 2147483647, u10 / 2147483647), l8 = i10.map((c14, a7) => a7);
  for (let c14 = l8.length - 1; c14 > 0; c14--) {
    let a7 = Math.floor(p17() * (c14 + 1));
    [l8[c14], l8[a7]] = [l8[a7], l8[c14]];
  }
  let f11 = l8.slice(0, t6).sort((c14, a7) => c14 - a7).map((c14) => i10[c14]);
  return { stdout: R8(o9, f11), stderr: "", exitCode: 0 };
}
async function Te4(e5, n23) {
  let t6 = false, s9 = [];
  for (let u10 = 0; u10 < e5.length; u10++) {
    let p17 = e5[u10];
    p17 === "-p" || p17 === "--pad" ? t6 = true : p17.startsWith("-") || s9.push(p17);
  }
  if (s9.length === 0) return { stdout: "", stderr: `xan cat: no files specified
`, exitCode: 1 };
  let r8 = await y2(n23, s9, { cmdName: "xan cat", stopOnError: true });
  if (r8.exitCode !== 0) return { stdout: "", stderr: r8.stderr, exitCode: r8.exitCode };
  let o9 = [], i10 = [];
  for (let { content: u10 } of r8.files) {
    let { headers: p17, data: l8 } = b23(u10);
    o9.push({ headers: p17, data: l8 });
    for (let f11 of p17) i10.includes(f11) || i10.push(f11);
  }
  if (!t6) {
    let u10 = JSON.stringify(o9[0].headers);
    for (let p17 = 1; p17 < o9.length; p17++) if (JSON.stringify(o9[p17].headers) !== u10) return { stdout: "", stderr: `xan cat: headers do not match (use -p to pad)
`, exitCode: 1 };
    i10 = o9[0].headers;
  }
  let h16 = [];
  for (let { headers: u10, data: p17 } of o9) for (let l8 of p17) {
    let f11 = j9();
    for (let c14 of i10) S11(f11, c14, u10.includes(c14) ? l8[c14] : "");
    h16.push(f11);
  }
  return { stdout: R8(i10, h16), stderr: "", exitCode: 0 };
}
async function je7(e5, n23) {
  let t6 = "", s9 = [], r8 = false, o9 = false, i10 = [];
  for (let a7 = 0; a7 < e5.length; a7++) {
    let d16 = e5[a7];
    (d16 === "-s" || d16 === "--select") && a7 + 1 < e5.length ? s9 = e5[++a7].split(",") : d16 === "-v" || d16 === "--invert" ? r8 = true : d16 === "-i" || d16 === "--ignore-case" ? o9 = true : d16 === "-r" || d16 === "--regex" || d16.startsWith("-") || (t6 ? i10.push(d16) : t6 = d16);
  }
  if (!t6) return { stdout: "", stderr: `xan search: no pattern specified
`, exitCode: 1 };
  let { headers: h16, data: u10, error: p17 } = await g16(i10, n23);
  if (p17) return p17;
  let l8 = s9.length > 0 ? s9 : h16, f11;
  try {
    f11 = b1(t6, o9 ? "i" : "");
  } catch {
    return { stdout: "", stderr: `xan search: invalid regex pattern '${t6}'
`, exitCode: 1 };
  }
  let c14 = u10.filter((a7) => {
    let d16 = l8.some((m24) => {
      let g18 = a7[m24];
      return g18 != null && f11.test(String(g18));
    });
    return r8 ? !d16 : d16;
  });
  return { stdout: R8(h16, c14), stderr: "", exitCode: 0 };
}
async function De5(e5, n23) {
  let t6 = "", s9 = [];
  for (let c14 of e5) c14.startsWith("-") || (t6 ? s9.push(c14) : t6 = c14);
  if (!t6) return { stdout: "", stderr: `xan flatmap: no expression specified
`, exitCode: 1 };
  let { headers: r8, data: o9, error: i10 } = await g16(s9, n23);
  if (i10) return i10;
  let u10 = V11(t6).map(({ expr: c14, name: a7 }) => ({ alias: typeof a7 == "string" ? a7 : a7[0], ast: O14(c14) })), p17 = { limits: n23.limits ? { maxIterations: n23.limits.maxJqIterations } : void 0 }, l8 = [...r8, ...u10.map((c14) => c14.alias)], f11 = [];
  for (let c14 of o9) {
    let a7 = [], d16 = 1;
    for (let m24 of u10) {
      let g18 = d11(c14, m24.ast, p17), y18 = g18.length > 0 && Array.isArray(g18[0]) ? g18[0] : g18;
      a7.push(y18), d16 = Math.max(d16, y18.length);
    }
    for (let m24 = 0; m24 < d16; m24++) {
      let g18 = C17(c14);
      for (let y18 = 0; y18 < u10.length; y18++) {
        let x22 = a7[y18][m24] ?? null;
        S11(g18, u10[y18].alias, x22);
      }
      f11.push(g18);
    }
  }
  return { stdout: R8(l8, f11), stderr: "", exitCode: 0 };
}
async function Ve5(e5, n23) {
  let { cmdView: t6 } = await Promise.resolve().then(() => (init_xan_view_ECQUO7AJ(), xan_view_ECQUO7AJ_exports));
  return t6(e5, n23);
}
var q13, _e5, He6, R9, J11, U12, B10, tt5, me4, Ye5, at6, Xe5, lt5, cn2, pn2;
var init_chunk_JI3KJ32H = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-JI3KJ32H.js"() {
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    _e5 = n17(() => {
      "use strict";
      q13 = class {
        input;
        pos = 0;
        tokens = [];
        constructor(n23) {
          this.input = n23;
        }
        tokenize() {
          for (; this.pos < this.input.length && (this.skipWhitespace(), !(this.pos >= this.input.length)); ) {
            let n23 = this.nextToken();
            n23 && this.tokens.push(n23);
          }
          return this.tokens.push({ type: "eof", value: "", pos: this.pos }), this.tokens;
        }
        skipWhitespace() {
          for (; this.pos < this.input.length; ) {
            let n23 = this.input[this.pos];
            if (n23 === " " || n23 === "	" || n23 === `
` || n23 === "\r") this.pos++;
            else if (n23 === "#") for (; this.pos < this.input.length && this.input[this.pos] !== `
`; ) this.pos++;
            else break;
          }
        }
        nextToken() {
          let n23 = this.pos, t6 = this.input[this.pos];
          if (t6 >= "0" && t6 <= "9") return this.readNumber();
          if (t6 === '"' || t6 === "'" || t6 === "`") return this.readString(t6);
          if (t6 === "b" && this.pos + 1 < this.input.length) {
            let o9 = this.input[this.pos + 1];
            if (o9 === '"' || o9 === "'" || o9 === "`") return this.pos++, this.readString(o9);
          }
          if (t6 === "/") {
            let o9 = this.tokens[this.tokens.length - 1];
            return o9 && (o9.type === "int" || o9.type === "float" || o9.type === "string" || o9.type === "ident" || o9.type === ")" || o9.type === "]") ? this.input[this.pos + 1] === "/" ? (this.pos += 2, { type: "//", value: "//", pos: n23 }) : (this.pos++, { type: "/", value: "/", pos: n23 }) : this.readRegex();
          }
          if (this.match("not in")) return { type: "not in", value: "not in", pos: n23 };
          if (this.match("=>")) return { type: "=>", value: "=>", pos: n23 };
          if (this.match("**")) return { type: "**", value: "**", pos: n23 };
          if (this.match("++")) return { type: "++", value: "++", pos: n23 };
          if (this.match("//")) return { type: "//", value: "//", pos: n23 };
          if (this.match("==")) return { type: "==", value: "==", pos: n23 };
          if (this.match("!=")) return { type: "!=", value: "!=", pos: n23 };
          if (this.match("<=")) return { type: "<=", value: "<=", pos: n23 };
          if (this.match(">=")) return { type: ">=", value: ">=", pos: n23 };
          if (this.match("&&")) return { type: "&&", value: "&&", pos: n23 };
          if (this.match("||")) return { type: "||", value: "||", pos: n23 };
          let r8 = (/* @__PURE__ */ new Map([["(", "("], [")", ")"], ["[", "["], ["]", "]"], ["{", "{"], ["}", "}"], [",", ","], [":", ":"], [";", ";"], ["+", "+"], ["-", "-"], ["*", "*"], ["%", "%"], ["<", "<"], [">", ">"], ["!", "!"], [".", "."], ["|", "|"], ["=", "="]])).get(t6);
          if (r8 !== void 0) return this.pos++, { type: r8, value: t6, pos: n23 };
          if (this.isIdentStart(t6)) return this.readIdentifier();
          throw new Error(`Unexpected character '${t6}' at position ${this.pos}`);
        }
        match(n23) {
          if (this.input.slice(this.pos, this.pos + n23.length) === n23) {
            if (/^[a-zA-Z]/.test(n23)) {
              let t6 = this.input[this.pos + n23.length];
              if (t6 && this.isIdentChar(t6)) return false;
            }
            return this.pos += n23.length, true;
          }
          return false;
        }
        isIdentStart(n23) {
          return n23 >= "a" && n23 <= "z" || n23 >= "A" && n23 <= "Z" || n23 === "_";
        }
        isIdentChar(n23) {
          return this.isIdentStart(n23) || n23 >= "0" && n23 <= "9";
        }
        readNumber() {
          let n23 = this.pos, t6 = false, s9 = false;
          for (; this.pos < this.input.length; ) {
            let o9 = this.input[this.pos];
            if (o9 >= "0" && o9 <= "9") this.pos++;
            else if (o9 === "_") this.pos++;
            else if (o9 === "." && !t6 && !s9) t6 = true, this.pos++;
            else if ((o9 === "e" || o9 === "E") && !s9) s9 = true, t6 = true, this.pos++, this.pos < this.input.length && (this.input[this.pos] === "+" || this.input[this.pos] === "-") && this.pos++;
            else break;
          }
          let r8 = this.input.slice(n23, this.pos).replace(/_/g, "");
          return { type: t6 ? "float" : "int", value: r8, pos: n23 };
        }
        readString(n23) {
          let t6 = this.pos;
          this.pos++;
          let s9 = "";
          for (; this.pos < this.input.length; ) {
            let r8 = this.input[this.pos];
            if (r8 === n23) return this.pos++, { type: "string", value: s9, pos: t6 };
            if (r8 === "\\") {
              if (this.pos++, this.pos < this.input.length) {
                let o9 = this.input[this.pos];
                switch (o9) {
                  case "n":
                    s9 += `
`;
                    break;
                  case "r":
                    s9 += "\r";
                    break;
                  case "t":
                    s9 += "	";
                    break;
                  case "\\":
                    s9 += "\\";
                    break;
                  case '"':
                    s9 += '"';
                    break;
                  case "'":
                    s9 += "'";
                    break;
                  case "`":
                    s9 += "`";
                    break;
                  case "0":
                    s9 += "\0";
                    break;
                  default:
                    s9 += o9;
                }
                this.pos++;
              }
            } else s9 += r8, this.pos++;
          }
          throw new Error(`Unterminated string starting at position ${t6}`);
        }
        readRegex() {
          let n23 = this.pos;
          this.pos++;
          let t6 = "", s9 = "";
          for (; this.pos < this.input.length; ) {
            let r8 = this.input[this.pos];
            if (r8 === "/") {
              for (this.pos++; this.pos < this.input.length && this.input[this.pos] === "i"; ) s9 += this.input[this.pos], this.pos++;
              return { type: "regex", value: t6 + (s9 ? `/${s9}` : ""), pos: n23 };
            }
            r8 === "\\" ? (t6 += r8, this.pos++, this.pos < this.input.length && (t6 += this.input[this.pos], this.pos++)) : (t6 += r8, this.pos++);
          }
          throw new Error(`Unterminated regex starting at position ${n23}`);
        }
        readIdentifier() {
          let n23 = this.pos;
          for (; this.pos < this.input.length && this.isIdentChar(this.input[this.pos]); ) this.pos++;
          let t6 = false;
          this.pos < this.input.length && this.input[this.pos] === "?" && (t6 = true, this.pos++);
          let s9 = this.input.slice(n23, t6 ? this.pos - 1 : this.pos);
          t6 && (s9 += "?");
          let r8 = /* @__PURE__ */ new Map([["true", "true"], ["false", "false"], ["null", "null"], ["and", "and"], ["or", "or"], ["eq", "eq"], ["ne", "ne"], ["lt", "lt"], ["le", "le"], ["gt", "gt"], ["ge", "ge"], ["in", "in"], ["as", "as"], ["_", "_"]]), o9 = s9.replace(/\?$/, ""), i10 = r8.get(o9);
          return i10 !== void 0 && !t6 ? { type: i10, value: o9, pos: n23 } : { type: "ident", value: s9, pos: n23 };
        }
      };
    });
    He6 = {};
    p3(He6, { parseMoonblade: () => _11, parseNamedExpressions: () => V11 });
    U12 = n17(() => {
      "use strict";
      _e5();
      R9 = { PIPE: 1, OR: 2, AND: 3, EQUALITY: 4, COMPARISON: 5, ADDITIVE: 6, MULTIPLICATIVE: 7, POWER: 8, UNARY: 9, POSTFIX: 10 }, J11 = class {
        pos = 0;
        tokens;
        constructor(n23) {
          this.tokens = n23;
        }
        parse() {
          let n23 = this.parseExpr(0);
          if (this.peek().type !== "eof") throw new Error(`Unexpected token: ${this.peek().value}`);
          return n23;
        }
        parseExpr(n23) {
          let t6 = this.parsePrefix();
          for (; ; ) {
            let s9 = this.peek(), r8 = this.getInfixPrec(s9.type);
            if (r8 < n23) break;
            t6 = this.parseInfix(t6, r8);
          }
          return t6;
        }
        parsePrefix() {
          let n23 = this.peek();
          switch (n23.type) {
            case "int":
              return this.advance(), { type: "int", value: Number.parseInt(n23.value, 10) };
            case "float":
              return this.advance(), { type: "float", value: Number.parseFloat(n23.value) };
            case "string":
              return this.advance(), { type: "string", value: n23.value };
            case "regex": {
              this.advance();
              let t6 = n23.value.split("/"), s9 = t6.length > 1 ? t6[t6.length - 1] : "";
              return { type: "regex", pattern: t6.slice(0, -1).join("/") || n23.value, caseInsensitive: s9.includes("i") };
            }
            case "true":
              return this.advance(), { type: "bool", value: true };
            case "false":
              return this.advance(), { type: "bool", value: false };
            case "null":
              return this.advance(), { type: "null" };
            case "_":
              return this.advance(), { type: "underscore" };
            case "ident": {
              let t6 = n23.value, s9 = t6.endsWith("?"), r8 = s9 ? t6.slice(0, -1) : t6;
              if (this.advance(), this.peek().type === "(") return this.parseFunctionCall(r8);
              if (this.peek().type === "=>") {
                this.advance();
                let o9 = this.parseExpr(0);
                return this.bindLambdaArgs({ type: "lambda", params: [r8], body: o9 }, [r8]);
              }
              return { type: "identifier", name: r8, unsure: s9 };
            }
            case "(": {
              this.advance();
              let t6 = [];
              if (this.peek().type === ")") {
                if (this.advance(), this.peek().type === "=>") {
                  this.advance();
                  let r8 = this.parseExpr(0);
                  return { type: "lambda", params: [], body: r8 };
                }
                throw new Error("Empty parentheses not allowed");
              }
              if (this.peek().type === "ident") {
                let r8 = this.peek().value;
                if (this.advance(), this.peek().type === "," || this.peek().type === ")") {
                  for (t6.push(r8); this.peek().type === "," && (this.advance(), this.peek().type === "ident"); ) t6.push(this.peek().value), this.advance();
                  if (this.peek().type === ")" && (this.advance(), this.peek().type === "=>")) {
                    this.advance();
                    let o9 = this.parseExpr(0);
                    return this.bindLambdaArgs({ type: "lambda", params: t6, body: o9 }, t6);
                  }
                  this.pos -= t6.length * 2, t6.length > 1 && (this.pos = this.pos);
                }
                this.pos--;
              }
              let s9 = this.parseExpr(0);
              return this.expect(")"), this.peek().type, s9;
            }
            case "[":
              return this.parseList();
            case "{":
              return this.parseMap();
            case "-": {
              this.advance();
              let t6 = this.parseExpr(R9.UNARY);
              return t6.type === "int" ? { type: "int", value: -t6.value } : t6.type === "float" ? { type: "float", value: -t6.value } : { type: "func", name: "neg", args: [{ expr: t6 }] };
            }
            case "!":
              return this.advance(), { type: "func", name: "not", args: [{ expr: this.parseExpr(R9.UNARY) }] };
            default:
              throw new Error(`Unexpected token: ${n23.type} (${n23.value})`);
          }
        }
        parseFunctionCall(n23) {
          this.expect("(");
          let t6 = [];
          if (this.peek().type !== ")") do {
            t6.length > 0 && this.peek().type === "," && this.advance();
            let s9;
            if (this.peek().type === "ident") {
              let o9 = this.peek().value, i10 = this.pos + 1;
              i10 < this.tokens.length && this.tokens[i10].type === "=" && (s9 = o9, this.advance(), this.advance());
            }
            let r8 = this.parseExpr(0);
            t6.push({ name: s9, expr: r8 });
          } while (this.peek().type === ",");
          return this.expect(")"), { type: "func", name: n23.toLowerCase(), args: t6 };
        }
        parseList() {
          this.expect("[");
          let n23 = [];
          if (this.peek().type !== "]") do
            n23.length > 0 && this.peek().type === "," && this.advance(), n23.push(this.parseExpr(0));
          while (this.peek().type === ",");
          return this.expect("]"), { type: "list", elements: n23 };
        }
        parseMap() {
          this.expect("{");
          let n23 = [];
          if (this.peek().type !== "}") do {
            n23.length > 0 && this.peek().type === "," && this.advance();
            let t6;
            if (this.peek().type === "ident") t6 = this.peek().value, this.advance();
            else if (this.peek().type === "string") t6 = this.peek().value, this.advance();
            else throw new Error(`Expected map key, got ${this.peek().type}`);
            this.expect(":");
            let s9 = this.parseExpr(0);
            n23.push({ key: t6, value: s9 });
          } while (this.peek().type === ",");
          return this.expect("}"), { type: "map", entries: n23 };
        }
        parseInfix(n23, t6) {
          let s9 = this.peek(), o9 = (/* @__PURE__ */ new Map([["+", "add"], ["-", "sub"], ["*", "mul"], ["/", "div"], ["//", "idiv"], ["%", "mod"], ["**", "pow"], ["++", "concat"], ["==", "=="], ["!=", "!="], ["<", "<"], ["<=", "<="], [">", ">"], [">=", ">="], ["eq", "eq"], ["ne", "ne"], ["lt", "lt"], ["le", "le"], ["gt", "gt"], ["ge", "ge"], ["&&", "and"], ["and", "and"], ["||", "or"], ["or", "or"]])).get(s9.type);
          if (o9 !== void 0) {
            this.advance();
            let i10 = this.parseExpr(t6 + (this.isRightAssoc(s9.type) ? 0 : 1));
            return { type: "func", name: o9, args: [{ expr: n23 }, { expr: i10 }] };
          }
          if (s9.type === "|") {
            this.advance();
            let i10 = this.parseExpr(t6);
            return this.handlePipe(n23, i10);
          }
          if (s9.type === ".") return this.advance(), this.handleDot(n23);
          if (s9.type === "[") return this.advance(), this.handleIndexing(n23);
          if (s9.type === "in") return this.advance(), { type: "func", name: "contains", args: [{ expr: this.parseExpr(t6 + 1) }, { expr: n23 }] };
          if (s9.type === "not in") return this.advance(), { type: "func", name: "not", args: [{ expr: { type: "func", name: "contains", args: [{ expr: this.parseExpr(t6 + 1) }, { expr: n23 }] } }] };
          throw new Error(`Unexpected infix token: ${s9.type}`);
        }
        handlePipe(n23, t6) {
          if (t6.type === "identifier") return { type: "func", name: t6.name, args: [{ expr: n23 }] };
          if (t6.type === "func") {
            let s9 = this.countUnderscores(t6);
            return s9 === 0 ? t6 : s9 === 1 ? this.fillUnderscore(t6, n23) : { type: "pipeline", exprs: [n23, t6] };
          }
          return this.countUnderscores(t6) === 1 ? this.fillUnderscore(t6, n23) : t6;
        }
        handleDot(n23) {
          let t6 = this.peek();
          if (t6.type === "ident") {
            let s9 = t6.value;
            if (this.advance(), this.peek().type === "(") {
              let r8 = this.parseFunctionCall(s9);
              return r8.type === "func" && r8.args.unshift({ expr: n23 }), r8;
            }
            return { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "string", value: s9 } }] };
          }
          if (t6.type === "int") {
            let s9 = Number.parseInt(t6.value, 10);
            return this.advance(), { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "int", value: s9 } }] };
          }
          if (t6.type === "string") {
            let s9 = t6.value;
            return this.advance(), { type: "func", name: "get", args: [{ expr: n23 }, { expr: { type: "string", value: s9 } }] };
          }
          throw new Error(`Expected identifier, number, or string after dot, got ${t6.type}`);
        }
        handleIndexing(n23) {
          if (this.peek().type === ":") {
            if (this.advance(), this.peek().type === "]") return this.advance(), { type: "func", name: "slice", args: [{ expr: n23 }] };
            let s9 = this.parseExpr(0);
            return this.expect("]"), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: { type: "int", value: 0 } }, { expr: s9 }] };
          }
          let t6 = this.parseExpr(0);
          if (this.peek().type === ":") {
            if (this.advance(), this.peek().type === "]") return this.advance(), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: t6 }] };
            let s9 = this.parseExpr(0);
            return this.expect("]"), { type: "func", name: "slice", args: [{ expr: n23 }, { expr: t6 }, { expr: s9 }] };
          }
          return this.expect("]"), { type: "func", name: "get", args: [{ expr: n23 }, { expr: t6 }] };
        }
        countUnderscores(n23) {
          return n23.type === "underscore" ? 1 : n23.type === "func" ? n23.args.reduce((t6, s9) => t6 + this.countUnderscores(s9.expr), 0) : n23.type === "list" ? n23.elements.reduce((t6, s9) => t6 + this.countUnderscores(s9), 0) : n23.type === "map" ? n23.entries.reduce((t6, s9) => t6 + this.countUnderscores(s9.value), 0) : 0;
        }
        fillUnderscore(n23, t6) {
          return n23.type === "underscore" ? t6 : n23.type === "func" ? { ...n23, args: n23.args.map((s9) => ({ ...s9, expr: this.fillUnderscore(s9.expr, t6) })) } : n23.type === "list" ? { ...n23, elements: n23.elements.map((s9) => this.fillUnderscore(s9, t6)) } : n23.type === "map" ? { ...n23, entries: n23.entries.map((s9) => ({ ...s9, value: this.fillUnderscore(s9.value, t6) })) } : n23;
        }
        bindLambdaArgs(n23, t6) {
          return { ...n23, body: this.bindLambdaArgsInExpr(n23.body, t6) };
        }
        bindLambdaArgsInExpr(n23, t6) {
          return n23.type === "identifier" && t6.includes(n23.name) ? { type: "lambdaBinding", name: n23.name } : n23.type === "func" ? { ...n23, args: n23.args.map((s9) => ({ ...s9, expr: this.bindLambdaArgsInExpr(s9.expr, t6) })) } : n23.type === "list" ? { ...n23, elements: n23.elements.map((s9) => this.bindLambdaArgsInExpr(s9, t6)) } : n23.type === "map" ? { ...n23, entries: n23.entries.map((s9) => ({ ...s9, value: this.bindLambdaArgsInExpr(s9.value, t6) })) } : n23;
        }
        getInfixPrec(n23) {
          switch (n23) {
            case "|":
              return R9.PIPE;
            case "||":
            case "or":
              return R9.OR;
            case "&&":
            case "and":
              return R9.AND;
            case "==":
            case "!=":
            case "eq":
            case "ne":
              return R9.EQUALITY;
            case "<":
            case "<=":
            case ">":
            case ">=":
            case "lt":
            case "le":
            case "gt":
            case "ge":
            case "in":
            case "not in":
              return R9.COMPARISON;
            case "+":
            case "-":
            case "++":
              return R9.ADDITIVE;
            case "*":
            case "/":
            case "//":
            case "%":
              return R9.MULTIPLICATIVE;
            case "**":
              return R9.POWER;
            case ".":
            case "[":
              return R9.POSTFIX;
            default:
              return -1;
          }
        }
        isRightAssoc(n23) {
          return n23 === "**";
        }
        peek() {
          return this.tokens[this.pos] || { type: "eof", value: "", pos: 0 };
        }
        advance() {
          return this.tokens[this.pos++];
        }
        expect(n23) {
          let t6 = this.peek();
          if (t6.type !== n23) throw new Error(`Expected ${n23}, got ${t6.type}`);
          return this.advance();
        }
      };
    });
    U12();
    B10 = { add: (e5) => S12("+", e5[0], e5[1]), sub: (e5) => S12("-", e5[0], e5[1]), mul: (e5) => S12("*", e5[0], e5[1]), div: (e5) => S12("/", e5[0], e5[1]), mod: (e5) => S12("%", e5[0], e5[1]), idiv: (e5) => k12("floor", [S12("/", e5[0], e5[1])]), pow: (e5) => E9("pow", e5), neg: (e5) => ({ type: "UnaryOp", op: "-", operand: e5[0] }), "==": (e5) => S12("==", e5[0], e5[1]), "!=": (e5) => S12("!=", e5[0], e5[1]), "<": (e5) => S12("<", e5[0], e5[1]), "<=": (e5) => S12("<=", e5[0], e5[1]), ">": (e5) => S12(">", e5[0], e5[1]), ">=": (e5) => S12(">=", e5[0], e5[1]), eq: (e5) => S12("==", P15(e5[0]), P15(e5[1])), ne: (e5) => S12("!=", P15(e5[0]), P15(e5[1])), lt: (e5) => S12("<", P15(e5[0]), P15(e5[1])), le: (e5) => S12("<=", P15(e5[0]), P15(e5[1])), gt: (e5) => S12(">", P15(e5[0]), P15(e5[1])), ge: (e5) => S12(">=", P15(e5[0]), P15(e5[1])), and: (e5) => S12("and", e5[0], e5[1]), or: (e5) => S12("or", e5[0], e5[1]), not: (e5) => ({ type: "UnaryOp", op: "not", operand: e5[0] }), len: (e5) => E9("length", e5), length: (e5) => E9("length", e5), upper: (e5) => E9("ascii_upcase", e5), lower: (e5) => E9("ascii_downcase", e5), trim: (e5) => E9("trim", e5), ltrim: (e5) => e5.length === 0 ? k12("ltrimstr", [{ type: "Literal", value: " " }]) : { type: "Pipe", left: e5[0], right: k12("ltrimstr", [{ type: "Literal", value: " " }]) }, rtrim: (e5) => e5.length === 0 ? k12("rtrimstr", [{ type: "Literal", value: " " }]) : { type: "Pipe", left: e5[0], right: k12("rtrimstr", [{ type: "Literal", value: " " }]) }, split: (e5) => E9("split", e5), join: (e5) => e5.length === 1 ? k12("join", [{ type: "Literal", value: "" }]) : E9("join", e5), concat: (e5) => S12("+", e5[0], e5[1]), startswith: (e5) => E9("startswith", e5), endswith: (e5) => E9("endswith", e5), contains: (e5) => E9("contains", e5), replace: (e5) => E9("gsub", e5), substr: (e5) => e5.length === 2 ? { type: "Slice", base: e5[0], start: e5[1] } : { type: "Slice", base: e5[0], start: e5[1], end: S12("+", e5[1], e5[2]) }, abs: (e5) => E9("fabs", e5), floor: (e5) => E9("floor", e5), ceil: (e5) => E9("ceil", e5), round: (e5) => E9("round", e5), sqrt: (e5) => E9("sqrt", e5), log: (e5) => E9("log", e5), log10: (e5) => E9("log10", e5), log2: (e5) => E9("log2", e5), exp: (e5) => E9("exp", e5), sin: (e5) => E9("sin", e5), cos: (e5) => E9("cos", e5), tan: (e5) => E9("tan", e5), asin: (e5) => E9("asin", e5), acos: (e5) => E9("acos", e5), atan: (e5) => E9("atan", e5), min: (e5) => E9("min", e5), max: (e5) => E9("max", e5), first: (e5) => e5.length === 0 ? { type: "Index", index: { type: "Literal", value: 0 } } : { type: "Index", index: { type: "Literal", value: 0 }, base: e5[0] }, last: (e5) => e5.length === 0 ? { type: "Index", index: { type: "Literal", value: -1 } } : { type: "Index", index: { type: "Literal", value: -1 }, base: e5[0] }, get: (e5) => e5.length === 1 ? { type: "Index", index: e5[0] } : { type: "Index", index: e5[1], base: e5[0] }, slice: (e5) => e5.length === 1 ? { type: "Slice", base: e5[0] } : e5.length === 2 ? { type: "Slice", base: e5[0], start: e5[1] } : { type: "Slice", base: e5[0], start: e5[1], end: e5[2] }, keys: "keys", values: "values", entries: (e5) => k12("to_entries", e5), from_entries: "from_entries", reverse: "reverse", sort: "sort", sort_by: "sort_by", group_by: "group_by", unique: "unique", unique_by: "unique_by", flatten: "flatten", map: (e5) => ({ type: "Pipe", left: e5[0], right: { type: "Array", elements: e5[1] } }), select: (e5) => k12("select", e5), empty: () => k12("empty", []), count: () => k12("length", []), sum: (e5) => e5.length === 0 ? k12("add", []) : { type: "Pipe", left: { type: "Array", elements: e5[0] }, right: k12("add", []) }, mean: (e5) => e5.length === 0 ? { type: "Pipe", left: { type: "Identity" }, right: S12("/", k12("add", []), k12("length", [])) } : { type: "Pipe", left: { type: "Array", elements: e5[0] }, right: S12("/", k12("add", []), k12("length", [])) }, avg: (e5) => e5.length === 0 ? { type: "Pipe", left: { type: "Identity" }, right: S12("/", k12("add", []), k12("length", [])) } : { type: "Pipe", left: { type: "Array", elements: e5[0] }, right: S12("/", k12("add", []), k12("length", [])) }, type: "type", isnull: (e5) => e5.length === 0 ? S12("==", { type: "Identity" }, { type: "Literal", value: null }) : S12("==", e5[0], { type: "Literal", value: null }), isempty: (e5) => e5.length === 0 ? S12("==", { type: "Identity" }, { type: "Literal", value: "" }) : S12("==", e5[0], { type: "Literal", value: "" }), tonumber: (e5) => e5.length === 0 ? k12("tonumber", []) : k12("tonumber", e5), tostring: (e5) => e5.length === 0 ? k12("tostring", []) : k12("tostring", e5), if: (e5) => Je6(e5[0], e5[1], e5[2]), coalesce: (e5) => {
      if (e5.length === 0) return { type: "Literal", value: null };
      if (e5.length === 1) return e5[0];
      let [n23, ...t6] = e5, s9 = S12("and", S12("!=", n23, { type: "Literal", value: null }), S12("!=", n23, { type: "Literal", value: "" }));
      return Je6(s9, n23, t6.length === 1 ? t6[0] : B10.coalesce(t6));
    }, index: () => ({ type: "Field", name: "_row_index" }), now: () => k12("now", []), fmt: (e5) => k12("tostring", e5), format: (e5) => k12("tostring", e5) };
    tt5 = "then";
    U12();
    me4 = q2(xe6(), 1);
    U12();
    U12();
    Ye5 = /* @__PURE__ */ new Set(["fuzzy-join", "glob", "hist", "input", "parallel", "plot", "progress", "range", "scrape", "tokenize", "union-find"]);
    at6 = /* @__PURE__ */ new Set(["agg", "behead", "cat", "count", "dedup", "drop", "enum", "explode", "f", "filter", "fixlengths", "flatmap", "flatten", "fmt", "frequency", "freq", "from", "groupby", "head", "headers", "implode", "join", "map", "merge", "partition", "pivot", "rename", "reverse", "sample", "search", "select", "shuffle", "slice", "sort", "split", "stats", "tail", "to", "top", "transform", "transpose", "view", ...Ye5]);
    Xe5 = { name: "xan", summary: "CSV toolkit for data manipulation", usage: "xan <COMMAND> [OPTIONS] [FILE]", description: `xan is a collection of commands for working with CSV data.
It provides a simple, ergonomic interface for common data operations.

COMMANDS:
  Core:
    headers    Show column names
    count      Count rows
    head       Show first N rows
    tail       Show last N rows
    slice      Extract row range
    reverse    Reverse row order
    behead     Remove header row
    sample     Random sample of rows

  Column operations:
    select     Select columns (supports glob, ranges, negation)
    drop       Drop columns
    rename     Rename columns
    enum       Add row index column

  Row operations:
    filter     Filter rows by expression
    search     Filter rows by regex match
    sort       Sort rows
    dedup      Remove duplicates
    top        Get top N by column

  Transformations:
    map        Add computed columns
    transform  Modify existing columns
    explode    Split column into multiple rows
    implode    Combine rows, join column values
    flatmap    Map returning multiple rows
    pivot      Reshape rows into columns
    transpose  Swap rows and columns

  Aggregation:
    agg        Aggregate values
    groupby    Group and aggregate
    frequency  Count value occurrences
    stats      Show column statistics

  Multi-file:
    cat        Concatenate CSV files
    join       Join two CSV files on key
    merge      Merge sorted CSV files
    split      Split into multiple files
    partition  Split by column value

  Data conversion:
    to         Convert CSV to other formats (json)
    from       Convert other formats to CSV (json)
    shuffle    Randomly reorder rows
    fixlengths Fix ragged CSV files

  Output:
    view       Pretty print as table
    flatten    Display records vertically (alias: f)
    fmt        Format output

EXAMPLES:
  xan headers data.csv
  xan count data.csv
  xan head -n 5 data.csv
  xan select name,email data.csv
  xan select 'vec_*' data.csv          # glob pattern
  xan select 'a:c' data.csv            # column range
  xan filter 'age > 30' data.csv
  xan search -r '^foo' data.csv
  xan sort -N price data.csv
  xan agg 'sum(amount) as total' data.csv
  xan groupby region 'count() as n' data.csv
  xan explode tags data.csv
  xan join id file1.csv id file2.csv
  xan pivot year 'sum(sales)' data.csv`, options: ["    --help    display this help and exit"] };
    lt5 = { headers: { name: "xan headers", summary: "Show column names", usage: "xan headers [OPTIONS] [FILE]", description: "Display column names from a CSV file.", options: ["-j, --just-names    show names only (no index)"] }, count: { name: "xan count", summary: "Count rows", usage: "xan count [FILE]", description: "Count the number of data rows (excluding header).", options: [] }, filter: { name: "xan filter", summary: "Filter rows by expression", usage: "xan filter [OPTIONS] EXPR [FILE]", description: "Filter CSV rows using moonblade expressions.", options: ["-v, --invert    invert match", "-l, --limit N   limit output rows"] }, search: { name: "xan search", summary: "Filter rows by regex", usage: "xan search [OPTIONS] PATTERN [FILE]", description: "Filter CSV rows by regex match on columns.", options: ["-s, --select COLS   search only these columns", "-v, --invert        invert match", "-i, --ignore-case   case insensitive"] }, select: { name: "xan select", summary: "Select columns", usage: "xan select COLS [FILE]", description: "Select columns by name, index, glob, or range.", options: ["Supports: col names, indices (0,1), ranges (a:c), globs (vec_*), negation (!col)"] }, explode: { name: "xan explode", summary: "Split column into rows", usage: "xan explode COLUMN [OPTIONS] [FILE]", description: "Split delimited column values into multiple rows.", options: ["-s, --separator SEP  separator (default: |)", "--drop-empty         drop empty values", "-r, --rename NAME    rename column"] }, implode: { name: "xan implode", summary: "Combine rows", usage: "xan implode COLUMN [OPTIONS] [FILE]", description: "Combine consecutive rows, joining column values.", options: ["-s, --sep SEP        separator (default: |)", "-r, --rename NAME    rename column"] }, join: { name: "xan join", summary: "Join CSV files", usage: "xan join KEY1 FILE1 KEY2 FILE2 [OPTIONS]", description: "Join two CSV files on key columns.", options: ["--left               left outer join", "--right              right outer join", "--full               full outer join", "-D, --default VAL    default for missing"] }, pivot: { name: "xan pivot", summary: "Reshape to columns", usage: "xan pivot COLUMN AGG_EXPR [OPTIONS] [FILE]", description: "Turn row values into columns.", options: ["-g, --groupby COLS   group by columns"] } };
    cn2 = { name: "xan", async execute(e5, n23) {
      if (e5.length === 0 || o2(e5)) return s(Xe5);
      let t6 = e5[0], s9 = e5.slice(1);
      if (o2(s9)) {
        let r8 = lt5[t6];
        return r8 ? s(r8) : s(Xe5);
      }
      if (Ye5.has(t6)) return { stdout: "", stderr: `xan ${t6}: not yet implemented
`, exitCode: 1 };
      switch (t6) {
        case "headers":
          return ue8(s9, n23);
        case "count":
          return ce7(s9, n23);
        case "head":
          return pe7(s9, n23);
        case "tail":
          return fe9(s9, n23);
        case "slice":
          return de8(s9, n23);
        case "reverse":
          return he8(s9, n23);
        case "behead":
          return Me5(s9, n23);
        case "sample":
          return $e5(s9, n23);
        case "select":
          return oe6(s9, n23);
        case "drop":
          return ie5(s9, n23);
        case "rename":
          return ae7(s9, n23);
        case "enum":
          return le7(s9, n23);
        case "filter":
          return Se4(s9, n23);
        case "search":
          return je7(s9, n23);
        case "sort":
          return Ie6(s9, n23);
        case "dedup":
          return ke5(s9, n23);
        case "top":
          return Ne5(s9, n23);
        case "map":
          return Ee5(s9, n23);
        case "transform":
          return Ae6(s9, n23);
        case "explode":
          return Fe6(s9, n23);
        case "implode":
          return Oe4(s9, n23);
        case "flatmap":
          return De5(s9, n23);
        case "pivot":
          return Pe5(s9, n23);
        case "agg":
          return te8(s9, n23);
        case "groupby":
          return ne7(s9, n23);
        case "frequency":
        case "freq":
          return se6(s9, n23);
        case "stats":
          return re4(s9, n23);
        case "cat":
          return Te4(s9, n23);
        case "join":
          return Le5(s9, n23);
        case "merge":
          return Re6(s9, n23);
        case "split":
          return we5(s9, n23);
        case "partition":
          return ve6(s9, n23);
        case "to":
          return Ce3(s9, n23);
        case "from":
          return be5(s9, n23);
        case "transpose":
          return ge7(s9, n23);
        case "shuffle":
          return ye6(s9, n23);
        case "fixlengths":
          return xe8(s9, n23);
        case "view":
          return k11(s9, n23);
        case "flatten":
        case "f":
          return W11(s9, n23);
        case "fmt":
          return Ve5(s9, n23);
        default:
          return at6.has(t6) ? { stdout: "", stderr: `xan ${t6}: not yet implemented
`, exitCode: 1 } : { stdout: "", stderr: `xan: unknown command '${t6}'
Run 'xan --help' for usage.
`, exitCode: 1 };
      }
    } };
    pn2 = { name: "xan", flags: [], stdinType: "text", needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/xan-Z6KVJKEE.js
var xan_Z6KVJKEE_exports = {};
__export(xan_Z6KVJKEE_exports, {
  flagsForFuzzing: () => pn2,
  xanCommand: () => cn2
});
var init_xan_Z6KVJKEE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/xan-Z6KVJKEE.js"() {
    init_chunk_JI3KJ32H();
    init_chunk_F55TLFGB();
    init_chunk_SYMJJMQ4();
    init_chunk_FRDGR5VK();
    init_chunk_7MKBHGLS();
    init_chunk_OJDRYQWQ();
    init_chunk_YNYSPYQ5();
    init_chunk_7L36YK2X();
    init_chunk_PSW6BMXW();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// stub-node:node:url
var fileURLToPath;
var init_node_url = __esm({
  "stub-node:node:url"() {
    fileURLToPath = (u10) => u10;
  }
});

// stub-node:node:worker_threads
var Worker;
var init_node_worker_threads = __esm({
  "stub-node:node:worker_threads"() {
    Worker = class {
      constructor() {
      }
    };
  }
});

// stub:sql.js
var sql_default;
var init_sql = __esm({
  "stub:sql.js"() {
    sql_default = {};
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/chunk-HDZ4QEVJ.js
function q14(e5, r8, n23) {
  switch (n23.mode) {
    case "list":
      return y16(e5, r8, n23);
    case "csv":
      return L15(e5, r8, n23);
    case "json":
      return V12(e5, r8);
    case "line":
      return O15(e5, r8, n23);
    case "column":
      return A11(e5, r8, n23);
    case "table":
      return N13(e5, r8, n23);
    case "markdown":
      return P16(e5, r8, n23);
    case "tabs":
      return I16(e5, r8, n23);
    case "box":
      return M12(e5, r8, n23);
    case "quote":
      return R10(e5, r8, n23);
    case "html":
      return F19(e5, r8, n23);
    case "ascii":
      return Q12(e5, r8, n23);
  }
}
function u7(e5, r8) {
  return e5 == null ? r8 : e5 instanceof Uint8Array || Buffer.isBuffer(e5) ? Buffer.from(e5).toString("utf8") : typeof e5 == "number" && !Number.isInteger(e5) ? e5.toPrecision(17).replace(/\.?0+$/, "") : String(e5);
}
function y16(e5, r8, n23) {
  let t6 = [];
  n23.header && e5.length > 0 && t6.push(e5.join(n23.separator));
  for (let l8 of r8) t6.push(l8.map((i10) => u7(i10, n23.nullValue)).join(n23.separator));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function L15(e5, r8, n23) {
  let t6 = [];
  n23.header && e5.length > 0 && t6.push(e5.map(j10).join(","));
  for (let l8 of r8) t6.push(l8.map((i10) => j10(u7(i10, n23.nullValue))).join(","));
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function j10(e5) {
  return e5.includes(",") || e5.includes('"') || e5.includes("'") || e5.includes(`
`) ? `"${e5.replace(/"/g, '""')}"` : e5;
}
function E10(e5) {
  return e5.toPrecision(17).replace(/\.?0+$/, "");
}
function k13(e5) {
  return e5 === null ? "null" : typeof e5 == "number" ? Number.isInteger(e5) ? String(e5) : E10(e5) : JSON.stringify(e5);
}
function V12(e5, r8) {
  return r8.length === 0 ? "" : `[${r8.map((t6) => `{${e5.map((i10, s9) => `${JSON.stringify(i10)}:${k13(t6[s9])}`).join(",")}}`).join(`,
`)}]
`;
}
function O15(e5, r8, n23) {
  if (e5.length === 0 || r8.length === 0) return "";
  let t6 = Math.max(5, ...e5.map((i10) => i10.length)), l8 = [];
  for (let i10 of r8) for (let s9 = 0; s9 < e5.length; s9++) {
    let o9 = e5[s9].padStart(t6);
    l8.push(`${o9} = ${u7(i10[s9], n23.nullValue)}`);
  }
  return `${l8.join(`
`)}
`;
}
function A11(e5, r8, n23) {
  if (e5.length === 0) return "";
  let t6 = e5.map((i10) => i10.length);
  for (let i10 of r8) for (let s9 = 0; s9 < i10.length; s9++) {
    let o9 = u7(i10[s9], n23.nullValue).length;
    o9 > t6[s9] && (t6[s9] = o9);
  }
  let l8 = [];
  n23.header && (l8.push(e5.map((i10, s9) => i10.padEnd(t6[s9])).join("  ")), l8.push(t6.map((i10) => "-".repeat(i10)).join("  ")));
  for (let i10 of r8) l8.push(i10.map((s9, o9) => u7(s9, n23.nullValue).padEnd(t6[o9])).join("  "));
  return l8.length > 0 ? `${l8.join(`
`)}
` : "";
}
function N13(e5, r8, n23) {
  if (e5.length === 0) return "";
  let t6 = e5.map((s9) => s9.length);
  for (let s9 of r8) for (let o9 = 0; o9 < s9.length; o9++) {
    let f11 = u7(s9[o9], n23.nullValue).length;
    f11 > t6[o9] && (t6[o9] = f11);
  }
  let l8 = [], i10 = `+${t6.map((s9) => "-".repeat(s9 + 2)).join("+")}+`;
  l8.push(i10), n23.header && (l8.push(`| ${e5.map((s9, o9) => s9.padEnd(t6[o9])).join(" | ")} |`), l8.push(i10));
  for (let s9 of r8) l8.push(`| ${s9.map((o9, f11) => u7(o9, n23.nullValue).padEnd(t6[f11])).join(" | ")} |`);
  return l8.push(i10), `${l8.join(`
`)}
`;
}
function P16(e5, r8, n23) {
  if (e5.length === 0) return "";
  let t6 = [];
  n23.header && (t6.push(`| ${e5.join(" | ")} |`), t6.push(`|${e5.map(() => "---").join("|")}|`));
  for (let l8 of r8) t6.push(`| ${l8.map((i10) => u7(i10, n23.nullValue)).join(" | ")} |`);
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function I16(e5, r8, n23) {
  let t6 = [];
  n23.header && e5.length > 0 && t6.push(e5.join("	"));
  for (let l8 of r8) t6.push(l8.map((i10) => u7(i10, n23.nullValue)).join("	"));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function M12(e5, r8, n23) {
  if (e5.length === 0) return "";
  let t6 = e5.map((i10) => i10.length);
  for (let i10 of r8) for (let s9 = 0; s9 < i10.length; s9++) {
    let o9 = u7(i10[s9], n23.nullValue).length;
    o9 > t6[s9] && (t6[s9] = o9);
  }
  let l8 = [];
  l8.push(`\u250C${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u252C")}\u2510`), l8.push(`\u2502 ${e5.map((i10, s9) => i10.padEnd(t6[s9])).join(" \u2502 ")} \u2502`), l8.push(`\u251C${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u253C")}\u2524`);
  for (let i10 of r8) l8.push(`\u2502 ${i10.map((s9, o9) => u7(s9, n23.nullValue).padEnd(t6[o9])).join(" \u2502 ")} \u2502`);
  return l8.push(`\u2514${t6.map((i10) => "\u2500".repeat(i10 + 2)).join("\u2534")}\u2518`), `${l8.join(`
`)}
`;
}
function R10(e5, r8, n23) {
  let t6 = [];
  n23.header && e5.length > 0 && t6.push(e5.map((l8) => `'${l8}'`).join(","));
  for (let l8 of r8) t6.push(l8.map((i10) => i10 == null ? "NULL" : typeof i10 == "number" ? Number.isInteger(i10) ? String(i10) : E10(i10) : `'${String(i10)}'`).join(","));
  return t6.length > 0 ? `${t6.join(n23.newline)}${n23.newline}` : "";
}
function F19(e5, r8, n23) {
  let t6 = [];
  n23.header && e5.length > 0 && (t6.push(`<TR>${e5.map((l8) => `<TH>${S13(l8)}</TH>`).join("")}`), t6.push("</TR>"));
  for (let l8 of r8) t6.push(`<TR>${l8.map((i10) => `<TD>${S13(u7(i10, n23.nullValue))}</TD>`).join("")}`), t6.push("</TR>");
  return t6.length > 0 ? `${t6.join(`
`)}
` : "";
}
function S13(e5) {
  return e5.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function Q12(e5, r8, n23) {
  let i10 = [];
  n23.header && e5.length > 0 && i10.push(e5.join(""));
  for (let s9 of r8) i10.push(s9.map((o9) => u7(o9, n23.nullValue)).join(""));
  return i10.length > 0 ? i10.join("") + "" : "";
}
function _12(e5) {
  let r8 = { mode: "list", header: false, separator: "|", newline: `
`, nullValue: "", readonly: false, bail: false, echo: false, cmd: null }, n23 = null, t6 = null, l8 = false, i10 = false;
  for (let s9 = 0; s9 < e5.length; s9++) {
    let o9 = e5[s9];
    if (i10) {
      n23 === null ? n23 = o9 : t6 === null && (t6 = o9);
      continue;
    }
    if (o9 === "--") i10 = true;
    else if (o9 === "-version") l8 = true;
    else if (o9 === "-list") r8.mode = "list";
    else if (o9 === "-csv") r8.mode = "csv";
    else if (o9 === "-json") r8.mode = "json";
    else if (o9 === "-line") r8.mode = "line";
    else if (o9 === "-column") r8.mode = "column";
    else if (o9 === "-table") r8.mode = "table";
    else if (o9 === "-markdown") r8.mode = "markdown";
    else if (o9 === "-tabs") r8.mode = "tabs";
    else if (o9 === "-box") r8.mode = "box";
    else if (o9 === "-quote") r8.mode = "quote";
    else if (o9 === "-html") r8.mode = "html";
    else if (o9 === "-ascii") r8.mode = "ascii";
    else if (o9 === "-header") r8.header = true;
    else if (o9 === "-noheader") r8.header = false;
    else if (o9 === "-readonly") r8.readonly = true;
    else if (o9 === "-bail") r8.bail = true;
    else if (o9 === "-echo") r8.echo = true;
    else if (o9 === "-separator") {
      if (s9 + 1 >= e5.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -separator
`, exitCode: 1 };
      r8.separator = e5[++s9];
    } else if (o9 === "-newline") {
      if (s9 + 1 >= e5.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -newline
`, exitCode: 1 };
      r8.newline = e5[++s9];
    } else if (o9 === "-nullvalue") {
      if (s9 + 1 >= e5.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -nullvalue
`, exitCode: 1 };
      r8.nullValue = e5[++s9];
    } else if (o9 === "-cmd") {
      if (s9 + 1 >= e5.length) return { stdout: "", stderr: `sqlite3: Error: missing argument to -cmd
`, exitCode: 1 };
      r8.cmd = e5[++s9];
    } else {
      if (o9.startsWith("-")) return { stdout: "", stderr: `sqlite3: Error: unknown option: ${o9.startsWith("--") ? o9.slice(1) : o9}
Use -help for a list of options.
`, exitCode: 1 };
      n23 === null ? n23 = o9 : t6 === null && (t6 = o9);
    }
  }
  return { options: r8, database: n23, sql: t6, showVersion: l8 };
}
async function z9() {
  let e5 = await sql_default(), r8 = new e5.Database();
  try {
    let n23 = r8.exec("SELECT sqlite_version()");
    return n23.length > 0 && n23[0].values.length > 0 ? String(n23[0].values[0][0]) : "unknown";
  } finally {
    r8.close();
  }
}
function X8() {
  let e5 = dirname(fileURLToPath(import.meta.url)), r8 = join(e5, "../../commands/sqlite3/worker.js");
  if (existsSync(r8)) return r8;
  let n23 = join(e5, "worker.js");
  if (existsSync(n23)) return n23;
  let t6 = join(e5, "../../../dist/commands/sqlite3/worker.js");
  if (existsSync(t6)) return t6;
  throw new Error("sqlite3 worker not found. Run 'pnpm build' to compile the worker.");
}
async function Y9(e5, r8) {
  try {
    let n23 = X8();
    return await new Promise((t6, l8) => {
      let i10 = new Worker(n23, { workerData: e5 }), s9 = setTimeout(() => {
        i10.terminate(), t6({ success: false, error: `Query timeout: execution exceeded ${r8}ms limit` });
      }, r8);
      i10.on("message", (o9) => {
        clearTimeout(s9), t6(o9);
      }), i10.on("error", (o9) => {
        clearTimeout(s9), l8(o9);
      }), i10.on("exit", (o9) => {
        clearTimeout(s9), o9 !== 0 && t6({ success: false, error: `Worker exited with code ${o9}` });
      });
    });
  } catch (n23) {
    throw new Error(`sqlite3 worker failed to load: ${n23.message}`);
  }
}
var J12, W12, oe7, ie6;
var init_chunk_HDZ4QEVJ = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/chunk-HDZ4QEVJ.js"() {
    init_chunk_74CEPOFO();
    init_node_fs();
    init_node_path();
    init_node_url();
    init_node_worker_threads();
    init_sql();
    J12 = 5e3;
    W12 = { name: "sqlite3", summary: "SQLite database CLI", usage: "sqlite3 [OPTIONS] DATABASE [SQL]", options: ["-list           output in list mode (default)", "-csv            output in CSV mode", "-json           output in JSON mode", "-line           output in line mode", "-column         output in column mode", "-table          output as ASCII table", "-markdown       output as markdown table", "-tabs           output in tab-separated mode", "-box            output in Unicode box mode", "-quote          output in SQL quote mode", "-html           output as HTML table", "-ascii          output in ASCII mode (control chars)", "-header         show column headers", "-noheader       hide column headers", "-separator SEP  field separator for list mode (default: |)", "-newline SEP    row separator (default: \\n)", "-nullvalue TEXT text for NULL values (default: empty)", "-readonly       open database read-only (no writeback)", "-bail           stop on first error", "-echo           print SQL before execution", "-cmd COMMAND    run SQL command before main SQL", "-version        show SQLite version", "--              end of options", "--help          show this help"], examples: ['sqlite3 :memory: "CREATE TABLE t(x); INSERT INTO t VALUES(1); SELECT * FROM t"', 'sqlite3 -json data.db "SELECT * FROM users"', 'sqlite3 -csv -header data.db "SELECT id, name FROM products"', 'sqlite3 -box data.db "SELECT * FROM users"'] };
    oe7 = { name: "sqlite3", async execute(e5, r8) {
      if (o2(e5) || e5.includes("-help")) return s(W12);
      let n23 = _12(e5);
      if ("exitCode" in n23) return n23;
      let { options: t6, database: l8, sql: i10, showVersion: s9 } = n23;
      if (s9) return { stdout: `${await z9()}
`, stderr: "", exitCode: 0 };
      if (!l8) return { stdout: "", stderr: `sqlite3: missing database argument
`, exitCode: 1 };
      let o9 = i10 || r8.stdin.trim();
      if (t6.cmd && (o9 = t6.cmd + (o9 ? `; ${o9}` : "")), !o9) return { stdout: "", stderr: `sqlite3: no SQL provided
`, exitCode: 1 };
      let f11 = l8 === ":memory:", m24 = "", g18 = null;
      try {
        f11 || (m24 = r8.fs.resolvePath(r8.cwd, l8), await r8.fs.exists(m24) && (g18 = await r8.fs.readFileBuffer(m24)));
      } catch (a7) {
        return { stdout: "", stderr: `sqlite3: unable to open database "${l8}": ${a7.message}
`, exitCode: 1 };
      }
      let x22 = r8.limits?.maxSqliteTimeoutMs ?? J12, T10 = { dbBuffer: g18, sql: o9, options: { bail: t6.bail, echo: t6.echo } }, d16;
      try {
        d16 = await Y9(T10, x22);
      } catch (a7) {
        return { stdout: "", stderr: `sqlite3: worker error: ${a7.message}
`, exitCode: 1 };
      }
      if (!d16.success) return { stdout: "", stderr: `sqlite3: ${d16.error}
`, exitCode: 1 };
      let C19 = { mode: t6.mode, header: t6.header, separator: t6.separator, newline: t6.newline, nullValue: t6.nullValue }, c14 = "";
      t6.echo && (c14 += `${o9}
`);
      let w19 = false;
      for (let a7 of d16.results) if (a7.type === "error") {
        if (t6.bail) return { stdout: c14, stderr: `Error: ${a7.error}
`, exitCode: 1 };
        c14 += `Error: ${a7.error}
`, w19 = true;
      } else a7.columns && a7.rows && (a7.rows.length > 0 || t6.header) && (c14 += q14(a7.columns, a7.rows, C19));
      if (d16.hasModifications && !t6.readonly && !f11 && m24 && d16.dbBuffer) try {
        await r8.fs.writeFile(m24, d16.dbBuffer);
      } catch (a7) {
        return { stdout: c14, stderr: `sqlite3: failed to write database: ${a7.message}
`, exitCode: 1 };
      }
      return { stdout: c14, stderr: "", exitCode: w19 && t6.bail ? 1 : 0 };
    } };
    ie6 = { name: "sqlite3", flags: [], needsArgs: true };
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/sqlite3-Z2IGWYCE.js
var sqlite3_Z2IGWYCE_exports = {};
__export(sqlite3_Z2IGWYCE_exports, {
  flagsForFuzzing: () => ie6,
  sqlite3Command: () => oe7
});
var init_sqlite3_Z2IGWYCE = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/sqlite3-Z2IGWYCE.js"() {
    init_chunk_HDZ4QEVJ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
  }
});

// ../../node_modules/just-bash/dist/bundle/chunks/python3-W2D6SNQF.js
var python3_W2D6SNQF_exports = {};
__export(python3_W2D6SNQF_exports, {
  python3Command: () => G7,
  pythonCommand: () => tt6
});
function _13() {
  return new SharedArrayBuffer(p16.TOTAL);
}
function b24(r8) {
  let t6 = { code: null, module: null, scriptFile: null, showVersion: false, scriptArgs: [] };
  if (r8.length === 0) return t6;
  let e5 = r8.findIndex((s9) => !s9.startsWith("-") || s9 === "-" || s9 === "--");
  for (let s9 = 0; s9 < (e5 === -1 ? r8.length : e5); s9++) {
    let o9 = r8[s9];
    if (o9 === "-c") return s9 + 1 >= r8.length ? { stdout: "", stderr: `python3: option requires an argument -- 'c'
`, exitCode: 2 } : (t6.code = r8[s9 + 1], t6.scriptArgs = r8.slice(s9 + 2), t6);
    if (o9 === "-m") return s9 + 1 >= r8.length ? { stdout: "", stderr: `python3: option requires an argument -- 'm'
`, exitCode: 2 } : (t6.module = r8[s9 + 1], t6.scriptArgs = r8.slice(s9 + 2), t6);
    if (o9 === "--version" || o9 === "-V") return t6.showVersion = true, t6;
    if (o9.startsWith("-") && o9 !== "-") return { stdout: "", stderr: `python3: unrecognized option '${o9}'
`, exitCode: 2 };
  }
  if (e5 !== -1) {
    let s9 = r8[e5];
    s9 === "--" ? e5 + 1 < r8.length && (t6.scriptFile = r8[e5 + 1], t6.scriptArgs = r8.slice(e5 + 2)) : (t6.scriptFile = s9, t6.scriptArgs = r8.slice(e5 + 1));
  }
  return t6;
}
function P17() {
  if (E11 || S14.length === 0) return;
  let r8 = S14.shift();
  if (!r8) return;
  E11 = r8, v18().postMessage(E11.input);
}
function v18() {
  return g17 && (clearTimeout(g17), g17 = null), l7 || (l7 = new Worker(B11), l7.on("message", (r8) => {
    E11 && (E11.resolve(r8), E11 = null), S14.length > 0 ? P17() : H15();
  }), l7.on("error", (r8) => {
    E11 && (E11.resolve({ success: false, error: r8.message }), E11 = null);
    for (let t6 of S14) t6.resolve({ success: false, error: "Worker crashed" });
    S14.length = 0, l7 = null;
  }), l7.on("exit", () => {
    l7 = null;
  }), l7);
}
function H15() {
  g17 = setTimeout(() => {
    l7 && !E11 && S14.length === 0 && (l7.terminate(), l7 = null);
  }, 5e3);
}
async function W13(r8, t6, e5, s9 = []) {
  let o9 = _13(), a7 = new A12(o9, t6.fs, t6.cwd, t6.fetch), d16 = t6.limits?.maxPythonTimeoutMs ?? M13, y18 = { sharedBuffer: o9, pythonCode: r8, cwd: t6.cwd, env: r(t6.env), args: s9, scriptPath: e5 }, I17 = new Promise((T10) => {
    let U13 = setTimeout(() => {
      T10({ success: false, error: `Execution timeout: exceeded ${d16}ms limit` });
    }, d16), x22 = (L18) => {
      clearTimeout(U13), T10(L18);
    };
    S14.push({ input: y18, resolve: x22 }), P17();
  }), [m24, F20] = await Promise.all([a7.run(d16), I17.catch((T10) => ({ success: false, error: T10.message }))]);
  return !F20.success && F20.error ? { stdout: m24.stdout, stderr: `${m24.stderr}python3: ${F20.error}
`, exitCode: m24.exitCode || 1 } : m24;
}
var h15, n21, u8, i8, p16, R11, c12, w18, A12, M13, k14, l7, g17, S14, E11, B11, G7, tt6;
var init_python3_W2D6SNQF = __esm({
  "../../node_modules/just-bash/dist/bundle/chunks/python3-W2D6SNQF.js"() {
    init_chunk_YYAPW4OA();
    init_chunk_OJDRYQWQ();
    init_chunk_74CEPOFO();
    init_chunk_DXB73IDG();
    init_node_url();
    init_node_worker_threads();
    h15 = { NOOP: 0, READ_FILE: 1, WRITE_FILE: 2, STAT: 3, READDIR: 4, MKDIR: 5, RM: 6, EXISTS: 7, APPEND_FILE: 8, SYMLINK: 9, READLINK: 10, LSTAT: 11, CHMOD: 12, REALPATH: 13, WRITE_STDOUT: 100, WRITE_STDERR: 101, EXIT: 102, HTTP_REQUEST: 200 };
    n21 = { PENDING: 0, READY: 1, SUCCESS: 2, ERROR: 3 };
    u8 = { NONE: 0, NOT_FOUND: 1, IS_DIRECTORY: 2, NOT_DIRECTORY: 3, EXISTS: 4, PERMISSION_DENIED: 5, INVALID_PATH: 6, IO_ERROR: 7, TIMEOUT: 8, NETWORK_ERROR: 9, NETWORK_NOT_CONFIGURED: 10 };
    i8 = { OP_CODE: 0, STATUS: 4, PATH_LENGTH: 8, DATA_LENGTH: 12, RESULT_LENGTH: 16, ERROR_CODE: 20, FLAGS: 24, MODE: 28, PATH_BUFFER: 32, DATA_BUFFER: 4128 };
    p16 = { CONTROL_REGION: 32, PATH_BUFFER: 4096, DATA_BUFFER: 1048576, TOTAL: 1052704 };
    R11 = { NONE: 0, RECURSIVE: 1, FORCE: 2, MKDIR_RECURSIVE: 1 };
    c12 = { IS_FILE: 0, IS_DIRECTORY: 1, IS_SYMLINK: 2, MODE: 4, SIZE: 8, MTIME: 16, TOTAL: 24 };
    w18 = class {
      int32View;
      uint8View;
      dataView;
      constructor(t6) {
        this.int32View = new Int32Array(t6), this.uint8View = new Uint8Array(t6), this.dataView = new DataView(t6);
      }
      getOpCode() {
        return Atomics.load(this.int32View, i8.OP_CODE / 4);
      }
      setOpCode(t6) {
        Atomics.store(this.int32View, i8.OP_CODE / 4, t6);
      }
      getStatus() {
        return Atomics.load(this.int32View, i8.STATUS / 4);
      }
      setStatus(t6) {
        Atomics.store(this.int32View, i8.STATUS / 4, t6);
      }
      getPathLength() {
        return Atomics.load(this.int32View, i8.PATH_LENGTH / 4);
      }
      setPathLength(t6) {
        Atomics.store(this.int32View, i8.PATH_LENGTH / 4, t6);
      }
      getDataLength() {
        return Atomics.load(this.int32View, i8.DATA_LENGTH / 4);
      }
      setDataLength(t6) {
        Atomics.store(this.int32View, i8.DATA_LENGTH / 4, t6);
      }
      getResultLength() {
        return Atomics.load(this.int32View, i8.RESULT_LENGTH / 4);
      }
      setResultLength(t6) {
        Atomics.store(this.int32View, i8.RESULT_LENGTH / 4, t6);
      }
      getErrorCode() {
        return Atomics.load(this.int32View, i8.ERROR_CODE / 4);
      }
      setErrorCode(t6) {
        Atomics.store(this.int32View, i8.ERROR_CODE / 4, t6);
      }
      getFlags() {
        return Atomics.load(this.int32View, i8.FLAGS / 4);
      }
      setFlags(t6) {
        Atomics.store(this.int32View, i8.FLAGS / 4, t6);
      }
      getMode() {
        return Atomics.load(this.int32View, i8.MODE / 4);
      }
      setMode(t6) {
        Atomics.store(this.int32View, i8.MODE / 4, t6);
      }
      getPath() {
        let t6 = this.getPathLength(), e5 = this.uint8View.slice(i8.PATH_BUFFER, i8.PATH_BUFFER + t6);
        return new TextDecoder().decode(e5);
      }
      setPath(t6) {
        let e5 = new TextEncoder().encode(t6);
        if (e5.length > p16.PATH_BUFFER) throw new Error(`Path too long: ${e5.length} > ${p16.PATH_BUFFER}`);
        this.uint8View.set(e5, i8.PATH_BUFFER), this.setPathLength(e5.length);
      }
      getData() {
        let t6 = this.getDataLength();
        return this.uint8View.slice(i8.DATA_BUFFER, i8.DATA_BUFFER + t6);
      }
      setData(t6) {
        if (t6.length > p16.DATA_BUFFER) throw new Error(`Data too large: ${t6.length} > ${p16.DATA_BUFFER}`);
        this.uint8View.set(t6, i8.DATA_BUFFER), this.setDataLength(t6.length);
      }
      getDataAsString() {
        let t6 = this.getData();
        return new TextDecoder().decode(t6);
      }
      setDataFromString(t6) {
        let e5 = new TextEncoder().encode(t6);
        this.setData(e5);
      }
      getResult() {
        let t6 = this.getResultLength();
        return this.uint8View.slice(i8.DATA_BUFFER, i8.DATA_BUFFER + t6);
      }
      setResult(t6) {
        if (t6.length > p16.DATA_BUFFER) throw new Error(`Result too large: ${t6.length} > ${p16.DATA_BUFFER}`);
        this.uint8View.set(t6, i8.DATA_BUFFER), this.setResultLength(t6.length);
      }
      getResultAsString() {
        let t6 = this.getResult();
        return new TextDecoder().decode(t6);
      }
      setResultFromString(t6) {
        let e5 = new TextEncoder().encode(t6);
        this.setResult(e5);
      }
      encodeStat(t6) {
        this.uint8View[i8.DATA_BUFFER + c12.IS_FILE] = t6.isFile ? 1 : 0, this.uint8View[i8.DATA_BUFFER + c12.IS_DIRECTORY] = t6.isDirectory ? 1 : 0, this.uint8View[i8.DATA_BUFFER + c12.IS_SYMLINK] = t6.isSymbolicLink ? 1 : 0, this.dataView.setInt32(i8.DATA_BUFFER + c12.MODE, t6.mode, true);
        let e5 = Math.min(t6.size, Number.MAX_SAFE_INTEGER);
        this.dataView.setFloat64(i8.DATA_BUFFER + c12.SIZE, e5, true), this.dataView.setFloat64(i8.DATA_BUFFER + c12.MTIME, t6.mtime.getTime(), true), this.setResultLength(c12.TOTAL);
      }
      decodeStat() {
        return { isFile: this.uint8View[i8.DATA_BUFFER + c12.IS_FILE] === 1, isDirectory: this.uint8View[i8.DATA_BUFFER + c12.IS_DIRECTORY] === 1, isSymbolicLink: this.uint8View[i8.DATA_BUFFER + c12.IS_SYMLINK] === 1, mode: this.dataView.getInt32(i8.DATA_BUFFER + c12.MODE, true), size: this.dataView.getFloat64(i8.DATA_BUFFER + c12.SIZE, true), mtime: new Date(this.dataView.getFloat64(i8.DATA_BUFFER + c12.MTIME, true)) };
      }
      waitForReady(t6) {
        return Atomics.wait(this.int32View, i8.STATUS / 4, n21.PENDING, t6);
      }
      waitForReadyAsync(t6) {
        return Atomics.waitAsync(this.int32View, i8.STATUS / 4, n21.PENDING, t6);
      }
      async waitUntilReady(t6) {
        let e5 = Date.now();
        for (; ; ) {
          let s9 = this.getStatus();
          if (s9 === n21.READY) return true;
          let o9 = Date.now() - e5;
          if (o9 >= t6) return false;
          let a7 = t6 - o9, d16 = Atomics.waitAsync(this.int32View, i8.STATUS / 4, s9, a7);
          if (d16.async && await d16.value === "timed-out") return false;
        }
      }
      waitForResult(t6) {
        return Atomics.wait(this.int32View, i8.STATUS / 4, n21.READY, t6);
      }
      notify() {
        return Atomics.notify(this.int32View, i8.STATUS / 4);
      }
      reset() {
        this.setOpCode(h15.NOOP), this.setStatus(n21.PENDING), this.setPathLength(0), this.setDataLength(0), this.setResultLength(0), this.setErrorCode(u8.NONE), this.setFlags(R11.NONE), this.setMode(0);
      }
    };
    A12 = class {
      fs;
      cwd;
      secureFetch;
      protocol;
      running = false;
      output = { stdout: "", stderr: "", exitCode: 0 };
      constructor(t6, e5, s9, o9 = void 0) {
        this.fs = e5, this.cwd = s9, this.secureFetch = o9, this.protocol = new w18(t6);
      }
      async run(t6) {
        this.running = true;
        let e5 = Date.now();
        for (; this.running; ) {
          let s9 = Date.now() - e5;
          if (s9 >= t6) {
            this.output.stderr += `
python3: execution timeout exceeded
`, this.output.exitCode = 124;
            break;
          }
          let o9 = t6 - s9;
          if (!await this.protocol.waitUntilReady(o9)) {
            this.output.stderr += `
python3: execution timeout exceeded
`, this.output.exitCode = 124;
            break;
          }
          let d16 = this.protocol.getOpCode();
          await this.handleOperation(d16), this.protocol.notify();
        }
        return this.output;
      }
      stop() {
        this.running = false;
      }
      async handleOperation(t6) {
        try {
          switch (t6) {
            case h15.READ_FILE:
              await this.handleReadFile();
              break;
            case h15.WRITE_FILE:
              await this.handleWriteFile();
              break;
            case h15.STAT:
              await this.handleStat();
              break;
            case h15.LSTAT:
              await this.handleLstat();
              break;
            case h15.READDIR:
              await this.handleReaddir();
              break;
            case h15.MKDIR:
              await this.handleMkdir();
              break;
            case h15.RM:
              await this.handleRm();
              break;
            case h15.EXISTS:
              await this.handleExists();
              break;
            case h15.APPEND_FILE:
              await this.handleAppendFile();
              break;
            case h15.SYMLINK:
              await this.handleSymlink();
              break;
            case h15.READLINK:
              await this.handleReadlink();
              break;
            case h15.CHMOD:
              await this.handleChmod();
              break;
            case h15.REALPATH:
              await this.handleRealpath();
              break;
            case h15.WRITE_STDOUT:
              this.handleWriteStdout();
              break;
            case h15.WRITE_STDERR:
              this.handleWriteStderr();
              break;
            case h15.EXIT:
              this.handleExit();
              break;
            case h15.HTTP_REQUEST:
              await this.handleHttpRequest();
              break;
            default:
              this.protocol.setErrorCode(u8.IO_ERROR), this.protocol.setStatus(n21.ERROR);
          }
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      resolvePath(t6) {
        return t6.startsWith("/mnt/host/") ? t6.slice(9) : t6.startsWith("/mnt/host") ? t6.slice(9) || "/" : this.fs.resolvePath(this.cwd, t6);
      }
      async handleReadFile() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.readFileBuffer(t6);
          this.protocol.setResult(e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleWriteFile() {
        let t6 = this.resolvePath(this.protocol.getPath()), e5 = this.protocol.getData();
        try {
          await this.fs.writeFile(t6, e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleStat() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.stat(t6);
          this.protocol.encodeStat(e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleLstat() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.lstat(t6);
          this.protocol.encodeStat(e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleReaddir() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.readdir(t6);
          this.protocol.setResultFromString(JSON.stringify(e5)), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleMkdir() {
        let t6 = this.resolvePath(this.protocol.getPath()), s9 = (this.protocol.getFlags() & R11.MKDIR_RECURSIVE) !== 0;
        try {
          await this.fs.mkdir(t6, { recursive: s9 }), this.protocol.setStatus(n21.SUCCESS);
        } catch (o9) {
          this.setErrorFromException(o9);
        }
      }
      async handleRm() {
        let t6 = this.resolvePath(this.protocol.getPath()), e5 = this.protocol.getFlags(), s9 = (e5 & R11.RECURSIVE) !== 0, o9 = (e5 & R11.FORCE) !== 0;
        try {
          await this.fs.rm(t6, { recursive: s9, force: o9 }), this.protocol.setStatus(n21.SUCCESS);
        } catch (a7) {
          this.setErrorFromException(a7);
        }
      }
      async handleExists() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.exists(t6);
          this.protocol.setResult(new Uint8Array([e5 ? 1 : 0])), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleAppendFile() {
        let t6 = this.resolvePath(this.protocol.getPath()), e5 = this.protocol.getData();
        try {
          await this.fs.appendFile(t6, e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleSymlink() {
        let t6 = this.protocol.getPath(), e5 = this.protocol.getDataAsString(), s9 = this.resolvePath(t6);
        try {
          await this.fs.symlink(e5, s9), this.protocol.setStatus(n21.SUCCESS);
        } catch (o9) {
          this.setErrorFromException(o9);
        }
      }
      async handleReadlink() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.readlink(t6);
          this.protocol.setResultFromString(e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      async handleChmod() {
        let t6 = this.resolvePath(this.protocol.getPath()), e5 = this.protocol.getMode();
        try {
          await this.fs.chmod(t6, e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (s9) {
          this.setErrorFromException(s9);
        }
      }
      async handleRealpath() {
        let t6 = this.resolvePath(this.protocol.getPath());
        try {
          let e5 = await this.fs.realpath(t6);
          this.protocol.setResultFromString(e5), this.protocol.setStatus(n21.SUCCESS);
        } catch (e5) {
          this.setErrorFromException(e5);
        }
      }
      handleWriteStdout() {
        let t6 = this.protocol.getDataAsString();
        this.output.stdout += t6, this.protocol.setStatus(n21.SUCCESS);
      }
      handleWriteStderr() {
        let t6 = this.protocol.getDataAsString();
        this.output.stderr += t6, this.protocol.setStatus(n21.SUCCESS);
      }
      handleExit() {
        let t6 = this.protocol.getFlags();
        this.output.exitCode = t6, this.protocol.setStatus(n21.SUCCESS), this.running = false;
      }
      async handleHttpRequest() {
        if (!this.secureFetch) {
          this.protocol.setErrorCode(u8.NETWORK_NOT_CONFIGURED), this.protocol.setResultFromString("Network access not configured. Enable network in Bash options."), this.protocol.setStatus(n21.ERROR);
          return;
        }
        let t6 = this.protocol.getPath(), e5 = this.protocol.getDataAsString();
        try {
          let s9 = e5 ? JSON.parse(e5) : {}, o9 = await this.secureFetch(t6, { method: s9.method, headers: s9.headers, body: s9.body }), a7 = JSON.stringify({ status: o9.status, statusText: o9.statusText, headers: o9.headers, body: o9.body, url: o9.url });
          this.protocol.setResultFromString(a7), this.protocol.setStatus(n21.SUCCESS);
        } catch (s9) {
          let o9 = d3(s9 instanceof Error ? s9.message : String(s9));
          this.protocol.setErrorCode(u8.NETWORK_ERROR), this.protocol.setResultFromString(o9), this.protocol.setStatus(n21.ERROR);
        }
      }
      setErrorFromException(t6) {
        let e5 = t6 instanceof Error ? t6.message : String(t6), s9 = d3(e5), o9 = u8.IO_ERROR, a7 = e5.toLowerCase();
        a7.includes("no such file") || a7.includes("not found") || a7.includes("enoent") ? o9 = u8.NOT_FOUND : a7.includes("is a directory") || a7.includes("eisdir") ? o9 = u8.IS_DIRECTORY : a7.includes("not a directory") || a7.includes("enotdir") ? o9 = u8.NOT_DIRECTORY : a7.includes("already exists") || a7.includes("eexist") ? o9 = u8.EXISTS : (a7.includes("permission") || a7.includes("eperm") || a7.includes("eacces")) && (o9 = u8.PERMISSION_DENIED), this.protocol.setErrorCode(o9), this.protocol.setResultFromString(s9), this.protocol.setStatus(n21.ERROR);
      }
    };
    M13 = 3e4;
    k14 = { name: "python3", summary: "Execute Python code via Pyodide", usage: "python3 [OPTIONS] [-c CODE | -m MODULE | FILE] [ARGS...]", description: ["Execute Python code using Pyodide (Python compiled to WebAssembly).", "", "This command runs Python in a sandboxed environment with access to", "the virtual filesystem. Only Pyodide-bundled packages are available."], options: ["-c CODE     Execute CODE as Python script", "-m MODULE   Run library module as a script", "--version   Show Python version", "--help      Show this help"], examples: ['python3 -c "print(1 + 2)"', 'python3 -c "import sys; print(sys.version)"', "python3 script.py", "python3 script.py arg1 arg2", `echo 'print("hello")' | python3`], notes: ["Pyodide runs in WebAssembly, so execution may be slower than native Python.", "Only packages bundled with Pyodide are available (no pip install).", "First execution loads Pyodide (~30MB), subsequent calls are faster.", "Maximum execution time is 30 seconds by default."] };
    l7 = null;
    g17 = null;
    S14 = [];
    E11 = null;
    B11 = fileURLToPath(new URL("./worker.js", import.meta.url));
    G7 = { name: "python3", async execute(r8, t6) {
      if (o2(r8)) return s(k14);
      let e5 = b24(r8);
      if ("exitCode" in e5) return e5;
      if (e5.showVersion) return { stdout: `Python 3.12.1 (Pyodide)
`, stderr: "", exitCode: 0 };
      let s9, o9;
      if (e5.code !== null) s9 = e5.code, o9 = "-c";
      else if (e5.module !== null) s9 = `import runpy; runpy.run_module('${e5.module}', run_name='__main__')`, o9 = e5.module;
      else if (e5.scriptFile !== null) {
        let a7 = t6.fs.resolvePath(t6.cwd, e5.scriptFile);
        if (!await t6.fs.exists(a7)) return { stdout: "", stderr: `python3: can't open file '${e5.scriptFile}': [Errno 2] No such file or directory
`, exitCode: 2 };
        try {
          s9 = await t6.fs.readFile(a7), o9 = e5.scriptFile;
        } catch (d16) {
          return { stdout: "", stderr: `python3: can't open file '${e5.scriptFile}': ${d16.message}
`, exitCode: 2 };
        }
      } else if (t6.stdin.trim()) s9 = t6.stdin, o9 = "<stdin>";
      else return { stdout: "", stderr: `python3: no input provided (use -c CODE, -m MODULE, or provide a script file)
`, exitCode: 2 };
      return W13(s9, t6, o9, e5.scriptArgs);
    } };
    tt6 = { name: "python", async execute(r8, t6) {
      return G7.execute(r8, t6);
    } };
  }
});

// stub-node:node:module
var node_module_exports = {};
__export(node_module_exports, {
  createRequire: () => createRequire,
  default: () => node_module_default
});
function createRequire() {
  return () => {
  };
}
var node_module_default;
var init_node_module = __esm({
  "stub-node:node:module"() {
    node_module_default = { createRequire };
  }
});

// ../../node_modules/just-bash/dist/bundle/index.js
init_chunk_V4CDPGZH();
init_chunk_YYAPW4OA();
init_chunk_OJDRYQWQ();
init_chunk_YNYSPYQ5();
init_chunk_PSW6BMXW();
init_chunk_44UOCSGV();
init_chunk_DXB73IDG();
init_node_fs();
init_node_path();
init_node_fs();
init_node_path();
var He7 = [{ name: "echo", load: async () => (await Promise.resolve().then(() => (init_echo_O45JWWI2(), echo_O45JWWI2_exports))).echoCommand }, { name: "cat", load: async () => (await Promise.resolve().then(() => (init_cat_C2OBLGHA(), cat_C2OBLGHA_exports))).catCommand }, { name: "printf", load: async () => (await Promise.resolve().then(() => (init_printf_KGN6BDCY(), printf_KGN6BDCY_exports))).printfCommand }, { name: "ls", load: async () => (await Promise.resolve().then(() => (init_ls_OTONBH2E(), ls_OTONBH2E_exports))).lsCommand }, { name: "mkdir", load: async () => (await Promise.resolve().then(() => (init_mkdir_QWGXDWUS(), mkdir_QWGXDWUS_exports))).mkdirCommand }, { name: "rmdir", load: async () => (await Promise.resolve().then(() => (init_rmdir_XTQXT7RK(), rmdir_XTQXT7RK_exports))).rmdirCommand }, { name: "touch", load: async () => (await Promise.resolve().then(() => (init_touch_DX2IJOQ4(), touch_DX2IJOQ4_exports))).touchCommand }, { name: "rm", load: async () => (await Promise.resolve().then(() => (init_rm_KPTLPKPH(), rm_KPTLPKPH_exports))).rmCommand }, { name: "cp", load: async () => (await Promise.resolve().then(() => (init_cp_XOYR4ABJ(), cp_XOYR4ABJ_exports))).cpCommand }, { name: "mv", load: async () => (await Promise.resolve().then(() => (init_mv_Z6MORUFL(), mv_Z6MORUFL_exports))).mvCommand }, { name: "ln", load: async () => (await Promise.resolve().then(() => (init_ln_YAIFIHCT(), ln_YAIFIHCT_exports))).lnCommand }, { name: "chmod", load: async () => (await Promise.resolve().then(() => (init_chmod_MIKE3OIT(), chmod_MIKE3OIT_exports))).chmodCommand }, { name: "pwd", load: async () => (await Promise.resolve().then(() => (init_pwd_D4OZ7N27(), pwd_D4OZ7N27_exports))).pwdCommand }, { name: "readlink", load: async () => (await Promise.resolve().then(() => (init_readlink_IEQO24KU(), readlink_IEQO24KU_exports))).readlinkCommand }, { name: "head", load: async () => (await Promise.resolve().then(() => (init_head_HT2B6D2J(), head_HT2B6D2J_exports))).headCommand }, { name: "tail", load: async () => (await Promise.resolve().then(() => (init_tail_S5ULNTJU(), tail_S5ULNTJU_exports))).tailCommand }, { name: "wc", load: async () => (await Promise.resolve().then(() => (init_wc_TQB3VNOX(), wc_TQB3VNOX_exports))).wcCommand }, { name: "stat", load: async () => (await Promise.resolve().then(() => (init_stat_74KBZFAX(), stat_74KBZFAX_exports))).statCommand }, { name: "grep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).grepCommand }, { name: "fgrep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).fgrepCommand }, { name: "egrep", load: async () => (await Promise.resolve().then(() => (init_grep_BPEMMINR(), grep_BPEMMINR_exports))).egrepCommand }, { name: "rg", load: async () => (await Promise.resolve().then(() => (init_rg_ORQK4GVH(), rg_ORQK4GVH_exports))).rgCommand }, { name: "sed", load: async () => (await Promise.resolve().then(() => (init_sed_7HX4RAZG(), sed_7HX4RAZG_exports))).sedCommand }, { name: "awk", load: async () => (await Promise.resolve().then(() => (init_awk2_BDPR2JPZ(), awk2_BDPR2JPZ_exports))).awkCommand2 }, { name: "sort", load: async () => (await Promise.resolve().then(() => (init_sort_T7TNLWXL(), sort_T7TNLWXL_exports))).sortCommand }, { name: "uniq", load: async () => (await Promise.resolve().then(() => (init_uniq_ZXE4O5XB(), uniq_ZXE4O5XB_exports))).uniqCommand }, { name: "comm", load: async () => (await Promise.resolve().then(() => (init_comm_5SLSESQG(), comm_5SLSESQG_exports))).commCommand }, { name: "cut", load: async () => (await Promise.resolve().then(() => (init_cut_LO6YYY5P(), cut_LO6YYY5P_exports))).cutCommand }, { name: "paste", load: async () => (await Promise.resolve().then(() => (init_paste_7N6AFSDS(), paste_7N6AFSDS_exports))).pasteCommand }, { name: "tr", load: async () => (await Promise.resolve().then(() => (init_tr_RYO2EDCA(), tr_RYO2EDCA_exports))).trCommand }, { name: "rev", load: async () => (await Promise.resolve().then(() => (init_rev_XOSYPP45(), rev_XOSYPP45_exports))).rev }, { name: "nl", load: async () => (await Promise.resolve().then(() => (init_nl_U5YJDM32(), nl_U5YJDM32_exports))).nl }, { name: "fold", load: async () => (await Promise.resolve().then(() => (init_fold_LDSORVYE(), fold_LDSORVYE_exports))).fold }, { name: "expand", load: async () => (await Promise.resolve().then(() => (init_expand_DTNXU4LQ(), expand_DTNXU4LQ_exports))).expand }, { name: "unexpand", load: async () => (await Promise.resolve().then(() => (init_unexpand_RGTMIGZM(), unexpand_RGTMIGZM_exports))).unexpand }, { name: "strings", load: async () => (await Promise.resolve().then(() => (init_strings_7PLOGTPD(), strings_7PLOGTPD_exports))).strings }, { name: "split", load: async () => (await Promise.resolve().then(() => (init_split_EZOC5IIZ(), split_EZOC5IIZ_exports))).split }, { name: "column", load: async () => (await Promise.resolve().then(() => (init_column_WLPMMSTS(), column_WLPMMSTS_exports))).column }, { name: "join", load: async () => (await Promise.resolve().then(() => (init_join_GG2LDHE5(), join_GG2LDHE5_exports))).join }, { name: "tee", load: async () => (await Promise.resolve().then(() => (init_tee_O7VXZDCO(), tee_O7VXZDCO_exports))).teeCommand }, { name: "find", load: async () => (await Promise.resolve().then(() => (init_find_74OP3M7S(), find_74OP3M7S_exports))).findCommand }, { name: "basename", load: async () => (await Promise.resolve().then(() => (init_basename_AA2KJYZQ(), basename_AA2KJYZQ_exports))).basenameCommand }, { name: "dirname", load: async () => (await Promise.resolve().then(() => (init_dirname_LEMTZZFS(), dirname_LEMTZZFS_exports))).dirnameCommand }, { name: "tree", load: async () => (await Promise.resolve().then(() => (init_tree_LYXBS7DC(), tree_LYXBS7DC_exports))).treeCommand }, { name: "du", load: async () => (await Promise.resolve().then(() => (init_du_DM4QX4XA(), du_DM4QX4XA_exports))).duCommand }, { name: "env", load: async () => (await Promise.resolve().then(() => (init_env_S547XMN7(), env_S547XMN7_exports))).envCommand }, { name: "printenv", load: async () => (await Promise.resolve().then(() => (init_env_S547XMN7(), env_S547XMN7_exports))).printenvCommand }, { name: "alias", load: async () => (await Promise.resolve().then(() => (init_alias_JE7RI5QX(), alias_JE7RI5QX_exports))).aliasCommand }, { name: "unalias", load: async () => (await Promise.resolve().then(() => (init_alias_JE7RI5QX(), alias_JE7RI5QX_exports))).unaliasCommand }, { name: "history", load: async () => (await Promise.resolve().then(() => (init_history_J4QRNGRO(), history_J4QRNGRO_exports))).historyCommand }, { name: "xargs", load: async () => (await Promise.resolve().then(() => (init_xargs_OGI2NN6J(), xargs_OGI2NN6J_exports))).xargsCommand }, { name: "true", load: async () => (await Promise.resolve().then(() => (init_true_WHJNXCHG(), true_WHJNXCHG_exports))).trueCommand }, { name: "false", load: async () => (await Promise.resolve().then(() => (init_true_WHJNXCHG(), true_WHJNXCHG_exports))).falseCommand }, { name: "clear", load: async () => (await Promise.resolve().then(() => (init_clear_5CZ5X4YR(), clear_5CZ5X4YR_exports))).clearCommand }, { name: "bash", load: async () => (await Promise.resolve().then(() => (init_bash_DYXMG247(), bash_DYXMG247_exports))).bashCommand }, { name: "sh", load: async () => (await Promise.resolve().then(() => (init_bash_DYXMG247(), bash_DYXMG247_exports))).shCommand }, { name: "jq", load: async () => (await Promise.resolve().then(() => (init_jq_OJYNICKX(), jq_OJYNICKX_exports))).jqCommand }, { name: "base64", load: async () => (await Promise.resolve().then(() => (init_base64_A3SGWC34(), base64_A3SGWC34_exports))).base64Command }, { name: "diff", load: async () => (await Promise.resolve().then(() => (init_diff_HJF2MPDN(), diff_HJF2MPDN_exports))).diffCommand }, { name: "date", load: async () => (await Promise.resolve().then(() => (init_date_DD7FVA2V(), date_DD7FVA2V_exports))).dateCommand }, { name: "sleep", load: async () => (await Promise.resolve().then(() => (init_sleep_JHK4I472(), sleep_JHK4I472_exports))).sleepCommand }, { name: "timeout", load: async () => (await Promise.resolve().then(() => (init_timeout_5UJUQXOE(), timeout_5UJUQXOE_exports))).timeoutCommand }, { name: "time", load: async () => (await Promise.resolve().then(() => (init_time_BPT76IHZ(), time_BPT76IHZ_exports))).timeCommand }, { name: "seq", load: async () => (await Promise.resolve().then(() => (init_seq_RN5ZUASB(), seq_RN5ZUASB_exports))).seqCommand }, { name: "expr", load: async () => (await Promise.resolve().then(() => (init_expr_3572LAOT(), expr_3572LAOT_exports))).exprCommand }, { name: "md5sum", load: async () => (await Promise.resolve().then(() => (init_md5sum_INMIK4DX(), md5sum_INMIK4DX_exports))).md5sumCommand }, { name: "sha1sum", load: async () => (await Promise.resolve().then(() => (init_sha1sum_VJPNLNU6(), sha1sum_VJPNLNU6_exports))).sha1sumCommand }, { name: "sha256sum", load: async () => (await Promise.resolve().then(() => (init_sha256sum_PI32XWXY(), sha256sum_PI32XWXY_exports))).sha256sumCommand }, { name: "file", load: async () => (await Promise.resolve().then(() => (init_file_ZIGAJ4YS(), file_ZIGAJ4YS_exports))).fileCommand }, { name: "html-to-markdown", load: async () => (await Promise.resolve().then(() => (init_html_to_markdown_TFCECAGV(), html_to_markdown_TFCECAGV_exports))).htmlToMarkdownCommand }, { name: "help", load: async () => (await Promise.resolve().then(() => (init_help_T2NGLTSG(), help_T2NGLTSG_exports))).helpCommand }, { name: "which", load: async () => (await Promise.resolve().then(() => (init_which_NCIYTMAT(), which_NCIYTMAT_exports))).whichCommand }, { name: "tac", load: async () => (await Promise.resolve().then(() => (init_tac_T7YAU2Y6(), tac_T7YAU2Y6_exports))).tac }, { name: "hostname", load: async () => (await Promise.resolve().then(() => (init_hostname_BK6HG2DE(), hostname_BK6HG2DE_exports))).hostname }, { name: "whoami", load: async () => (await Promise.resolve().then(() => (init_whoami_DGKU3D2X(), whoami_DGKU3D2X_exports))).whoami }, { name: "od", load: async () => (await Promise.resolve().then(() => (init_od_VJEF2UR5(), od_VJEF2UR5_exports))).od }, { name: "gzip", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).gzipCommand }, { name: "gunzip", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).gunzipCommand }, { name: "zcat", load: async () => (await Promise.resolve().then(() => (init_gzip_UTSGNF5Z(), gzip_UTSGNF5Z_exports))).zcatCommand }];
(typeof __BROWSER__ > "u" || !__BROWSER__) && (He7.push({ name: "tar", load: async () => (await Promise.resolve().then(() => (init_tar_K7K7BL55(), tar_K7K7BL55_exports))).tarCommand }), He7.push({ name: "yq", load: async () => (await Promise.resolve().then(() => (init_yq_FD5F3WOJ(), yq_FD5F3WOJ_exports))).yqCommand }), He7.push({ name: "xan", load: async () => (await Promise.resolve().then(() => (init_xan_Z6KVJKEE(), xan_Z6KVJKEE_exports))).xanCommand }), He7.push({ name: "sqlite3", load: async () => (await Promise.resolve().then(() => (init_sqlite3_Z2IGWYCE(), sqlite3_Z2IGWYCE_exports))).sqlite3Command }));
var Lt4 = [];
(typeof __BROWSER__ > "u" || !__BROWSER__) && (Lt4.push({ name: "python3", load: async () => (await Promise.resolve().then(() => (init_python3_W2D6SNQF(), python3_W2D6SNQF_exports))).python3Command }), Lt4.push({ name: "python", load: async () => (await Promise.resolve().then(() => (init_python3_W2D6SNQF(), python3_W2D6SNQF_exports))).pythonCommand }));
var xi2 = new TextEncoder();
var Ni2 = new TextDecoder();
var Je7 = new TextEncoder();
var L17 = Object.freeze({ stdout: "", stderr: "", exitCode: 0 });
var _n = /* @__PURE__ */ new Map([[":", [": [arguments]", `Null command.
    No effect; the command does nothing.
    Exit Status:
    Always succeeds.`]], [".", [". filename [arguments]", `Execute commands from a file in the current shell.
    Read and execute commands from FILENAME in the current shell.
    The entries in $PATH are used to find the directory containing FILENAME.
    Exit Status:
    Returns the status of the last command executed in FILENAME.`]], ["[", ["[ arg... ]", `Evaluate conditional expression.
    This is a synonym for the "test" builtin, but the last argument must
    be a literal \`]', to match the opening \`['.`]], ["alias", ["alias [-p] [name[=value] ... ]", `Define or display aliases.
    Without arguments, \`alias' prints the list of aliases in the reusable
    form \`alias NAME=VALUE' on standard output.
    Exit Status:
    alias returns true unless a NAME is supplied for which no alias has been
    defined.`]], ["bg", ["bg [job_spec ...]", `Move jobs to the background.
    Place the jobs identified by each JOB_SPEC in the background, as if they
    had been started with \`&'.`]], ["break", ["break [n]", `Exit for, while, or until loops.
    Exit a FOR, WHILE or UNTIL loop.  If N is specified, break N enclosing
    loops.
    Exit Status:
    The exit status is 0 unless N is not greater than or equal to 1.`]], ["builtin", ["builtin [shell-builtin [arg ...]]", `Execute shell builtins.
    Execute SHELL-BUILTIN with arguments ARGs without performing command
    lookup.  This is useful when you wish to reimplement a shell builtin
    as a shell function, but need to execute the builtin within the function.
    Exit Status:
    Returns the exit status of SHELL-BUILTIN, or false if SHELL-BUILTIN is
    not a shell builtin.`]], ["caller", ["caller [expr]", `Return the context of the current subroutine call.
    Without EXPR, returns "$line $filename".  With EXPR, returns
    "$line $subroutine $filename"; this extra information can be used to
    provide a stack trace.
    Exit Status:
    Returns 0 unless the shell is not executing a subroutine call or
    EXPR is invalid.`]], ["cd", ["cd [-L|-P] [dir]", `Change the shell working directory.
    Change the current directory to DIR.  The default DIR is the value of the
    HOME shell variable.

    The variable CDPATH defines the search path for the directory containing
    DIR.  Alternative directory names in CDPATH are separated by a colon (:).
    A null directory name is the same as the current directory.  If DIR begins
    with a slash (/), then CDPATH is not used.

    If the directory is not found, and the shell option \`cdable_vars' is set,
    the word is assumed to be a variable name.  If that variable has a value,
    its value is used for DIR.

    Options:
      -L	force symbolic links to be followed
      -P	use the physical directory structure without following symbolic
    	links

    The default is to follow symbolic links, as if \`-L' were specified.

    Exit Status:
    Returns 0 if the directory is changed; non-zero otherwise.`]], ["command", ["command [-pVv] command [arg ...]", `Execute a simple command or display information about commands.
    Runs COMMAND with ARGS suppressing shell function lookup, or display
    information about the specified COMMANDs.

    Options:
      -p	use a default value for PATH that is guaranteed to find all of
    	the standard utilities
      -v	print a description of COMMAND similar to the \`type' builtin
      -V	print a more verbose description of each COMMAND

    Exit Status:
    Returns exit status of COMMAND, or failure if COMMAND is not found.`]], ["compgen", ["compgen [-abcdefgjksuv] [-o option] [-A action] [-G globpat] [-W wordlist]  [-F function] [-C command] [-X filterpat] [-P prefix] [-S suffix] [word]", `Display possible completions depending on the options.
    Intended to be used from within a shell function generating possible
    completions.  If the optional WORD argument is supplied, matches against
    WORD are generated.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["complete", ["complete [-abcdefgjksuv] [-pr] [-DEI] [-o option] [-A action] [-G globpat] [-W wordlist]  [-F function] [-C command] [-X filterpat] [-P prefix] [-S suffix] [name ...]", `Specify how arguments are to be completed.
    For each NAME, specify how arguments are to be completed.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["continue", ["continue [n]", `Resume for, while, or until loops.
    Resumes the next iteration of the enclosing FOR, WHILE or UNTIL loop.
    If N is specified, resumes the Nth enclosing loop.
    Exit Status:
    The exit status is 0 unless N is not greater than or equal to 1.`]], ["declare", ["declare [-aAfFgilnrtux] [-p] [name[=value] ...]", `Set variable values and attributes.
    Declare variables and give them attributes.  If no NAMEs are given,
    display the attributes and values of all variables.

    Options:
      -a	to make NAMEs indexed arrays (if supported)
      -A	to make NAMEs associative arrays (if supported)
      -i	to make NAMEs have the \`integer' attribute
      -l	to convert the value of each NAME to lower case on assignment
      -n	make NAME a reference to the variable named by its value
      -r	to make NAMEs readonly
      -t	to make NAMEs have the \`trace' attribute
      -u	to convert the value of each NAME to upper case on assignment
      -x	to make NAMEs export

    Exit Status:
    Returns success unless an invalid option is supplied or a variable
    assignment error occurs.`]], ["dirs", ["dirs [-clpv] [+N] [-N]", `Display directory stack.
    Display the list of currently remembered directories.  Directories
    find their way onto the list with the \`pushd' command; you can get
    back up through the list with the \`popd' command.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["disown", ["disown [-h] [-ar] [jobspec ...]", `Remove jobs from current shell.
    Without any JOBSPECs, remove the current job.`]], ["echo", ["echo [-neE] [arg ...]", `Write arguments to the standard output.
    Display the ARGs, separated by a single space character and followed by a
    newline, on the standard output.

    Options:
      -n	do not append a newline
      -e	enable interpretation of the following backslash escapes
      -E	explicitly suppress interpretation of backslash escapes

    Exit Status:
    Returns success unless a write error occurs.`]], ["enable", ["enable [-a] [-dnps] [-f filename] [name ...]", `Enable and disable shell builtins.
    Enables and disables builtin shell commands.
    Exit Status:
    Returns success unless NAME is not a shell builtin or an error occurs.`]], ["eval", ["eval [arg ...]", `Execute arguments as a shell command.
    Combine ARGs into a single string, use the result as input to the shell,
    and execute the resulting commands.
    Exit Status:
    Returns exit status of command or success if command is null.`]], ["exec", ["exec [-cl] [-a name] [command [arguments ...]] [redirection ...]", `Replace the shell with the given command.
    Execute COMMAND, replacing this shell with the specified program.
    ARGUMENTS become the arguments to COMMAND.  If COMMAND is not specified,
    any redirections take effect in the current shell.
    Exit Status:
    Returns success unless COMMAND is not found or a redirection error occurs.`]], ["exit", ["exit [n]", `Exit the shell.
    Exits the shell with a status of N.  If N is omitted, the exit status
    is that of the last command executed.`]], ["export", ["export [-fn] [name[=value] ...] or export -p", `Set export attribute for shell variables.
    Marks each NAME for automatic export to the environment of subsequently
    executed commands.  If VALUE is supplied, assign VALUE before exporting.

    Options:
      -f	refer to shell functions
      -n	remove the export property from each NAME
      -p	display a list of all exported variables and functions

    Exit Status:
    Returns success unless an invalid option is given or NAME is invalid.`]], ["false", ["false", `Return an unsuccessful result.
    Exit Status:
    Always fails.`]], ["fc", ["fc [-e ename] [-lnr] [first] [last] or fc -s [pat=rep] [command]", `Display or execute commands from the history list.
    Exit Status:
    Returns success or status of executed command.`]], ["fg", ["fg [job_spec]", `Move job to the foreground.
    Place the job identified by JOB_SPEC in the foreground, making it the
    current job.`]], ["getopts", ["getopts optstring name [arg]", `Parse option arguments.
    Getopts is used by shell procedures to parse positional parameters
    as options.

    OPTSTRING contains the option letters to be recognized; if a letter
    is followed by a colon, the option is expected to have an argument,
    which should be separated from it by white space.
    Exit Status:
    Returns success if an option is found; fails if the end of options is
    encountered or an error occurs.`]], ["hash", ["hash [-lr] [-p pathname] [-dt] [name ...]", `Remember or display program locations.
    Determine and remember the full pathname of each command NAME.
    Exit Status:
    Returns success unless NAME is not found or an invalid option is given.`]], ["help", ["help [-s] [pattern ...]", `Display information about builtin commands.
    Displays brief summaries of builtin commands.  If PATTERN is
    specified, gives detailed help on all commands matching PATTERN,
    otherwise the list of help topics is printed.

    Options:
      -s	output only a short usage synopsis for each topic matching
    	PATTERN

    Exit Status:
    Returns success unless PATTERN is not found.`]], ["history", ["history [-c] [-d offset] [n] or history -anrw [filename] or history -ps arg [arg...]", `Display or manipulate the history list.
    Display the history list with line numbers, prefixing each modified
    entry with a \`*'.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["jobs", ["jobs [-lnprs] [jobspec ...] or jobs -x command [args]", `Display status of jobs.
    Lists the active jobs.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["kill", ["kill [-s sigspec | -n signum | -sigspec] pid | jobspec ... or kill -l [sigspec]", `Send a signal to a job.
    Send the processes identified by PID or JOBSPEC the signal named by
    SIGSPEC or SIGNUM.
    Exit Status:
    Returns success unless an invalid option is given or an error occurs.`]], ["let", ["let arg [arg ...]", `Evaluate arithmetic expressions.
    Evaluate each ARG as an arithmetic expression.  Evaluation is done in
    fixed-width integers with no check for overflow, though division by 0
    is trapped and flagged as an error.
    Exit Status:
    If the last ARG evaluates to 0, let returns 1; 0 is returned otherwise.`]], ["local", ["local [option] name[=value] ...", `Define local variables.
    Create a local variable called NAME, and give it VALUE.  OPTION can
    be any option accepted by \`declare'.

    Local can only be used within a function; it makes the variable NAME
    have a visible scope restricted to that function and its children.
    Exit Status:
    Returns success unless an invalid option is supplied, a variable
    assignment error occurs, or the shell is not executing a function.`]], ["logout", ["logout [n]", `Exit a login shell.
    Exits a login shell with exit status N.  Returns an error if not executed
    in a login shell.`]], ["mapfile", ["mapfile [-d delim] [-n count] [-O origin] [-s count] [-t] [-u fd] [-C callback] [-c quantum] [array]", `Read lines from the standard input into an indexed array variable.
    Read lines from the standard input into the indexed array variable ARRAY,
    or from file descriptor FD if the -u option is supplied.

    Options:
      -d delim	Use DELIM to terminate lines, instead of newline
      -n count	Copy at most COUNT lines
      -O origin	Begin assigning to ARRAY at index ORIGIN
      -s count	Discard the first COUNT lines read
      -t	Remove a trailing DELIM from each line read (default newline)
      -u fd	Read lines from file descriptor FD instead of standard input

    Exit Status:
    Returns success unless an invalid option is given or ARRAY is readonly.`]], ["popd", ["popd [-n] [+N | -N]", `Remove directories from stack.
    Removes entries from the directory stack.
    Exit Status:
    Returns success unless an invalid argument is supplied or the directory
    change fails.`]], ["printf", ["printf [-v var] format [arguments]", `Formats and prints ARGUMENTS under control of the FORMAT.

    Options:
      -v var	assign the output to shell variable VAR rather than
    		display it on the standard output

    FORMAT is a character string which contains three types of objects: plain
    characters, which are simply copied to standard output; character escape
    sequences, which are converted and copied to the standard output; and
    format specifications, each of which causes printing of the next successive
    argument.
    Exit Status:
    Returns success unless an invalid option is given or a write or assignment
    error occurs.`]], ["pushd", ["pushd [-n] [+N | -N | dir]", `Add directories to stack.
    Adds a directory to the top of the directory stack, or rotates
    the stack, making the new top of the stack the current working
    directory.
    Exit Status:
    Returns success unless an invalid argument is supplied or the directory
    change fails.`]], ["pwd", ["pwd [-LP]", `Print the name of the current working directory.

    Options:
      -L	print the value of $PWD if it names the current working
    	directory
      -P	print the physical directory, without any symbolic links

    By default, \`pwd' behaves as if \`-L' were specified.
    Exit Status:
    Returns 0 unless an invalid option is given or the current directory
    cannot be read.`]], ["read", ["read [-ers] [-a array] [-d delim] [-i text] [-n nchars] [-N nchars] [-p prompt] [-t timeout] [-u fd] [name ...]", `Read a line from the standard input and split it into fields.
    Reads a single line from the standard input, or from file descriptor FD
    if the -u option is supplied.  The line is split into fields as with word
    splitting, and the first word is assigned to the first NAME, the second
    word to the second NAME, and so on, with any leftover words assigned to
    the last NAME.
    Exit Status:
    The return code is zero, unless end-of-file is encountered, read times out,
    or an invalid file descriptor is supplied as the argument to -u.`]], ["readarray", ["readarray [-d delim] [-n count] [-O origin] [-s count] [-t] [-u fd] [-C callback] [-c quantum] [array]", "Read lines from a file into an array variable.\n    A synonym for `mapfile'."]], ["readonly", ["readonly [-aAf] [name[=value] ...] or readonly -p", `Mark shell variables as unchangeable.
    Mark each NAME as read-only; the values of these NAMEs may not be
    changed by subsequent assignment.
    Exit Status:
    Returns success unless an invalid option is given or NAME is invalid.`]], ["return", ["return [n]", `Return from a shell function.
    Causes a function or sourced script to exit with the return value
    specified by N.  If N is omitted, the return status is that of the
    last command executed within the function or script.
    Exit Status:
    Returns N, or failure if the shell is not executing a function or script.`]], ["set", ["set [-abefhkmnptuvxBCHP] [-o option-name] [--] [arg ...]", `Set or unset values of shell options and positional parameters.
    Change the value of shell attributes and positional parameters, or
    display the names and values of shell variables.

    Options:
      -e  Exit immediately if a command exits with a non-zero status.
      -u  Treat unset variables as an error when substituting.
      -x  Print commands and their arguments as they are executed.
      -o option-name
          Set the variable corresponding to option-name

    Exit Status:
    Returns success unless an invalid option is given.`]], ["shift", ["shift [n]", `Shift positional parameters.
    Rename the positional parameters $N+1,$N+2 ... to $1,$2 ...  If N is
    not given, it is assumed to be 1.
    Exit Status:
    Returns success unless N is negative or greater than $#.`]], ["shopt", ["shopt [-pqsu] [-o] [optname ...]", `Set and unset shell options.
    Change the setting of each shell option OPTNAME.  Without any option
    arguments, list each supplied OPTNAME, or all shell options if no
    OPTNAMEs are given, with an indication of whether or not each is set.

    Options:
      -o	restrict OPTNAMEs to those defined for use with \`set -o'
      -p	print each shell option with an indication of its status
      -q	suppress output
      -s	enable (set) each OPTNAME
      -u	disable (unset) each OPTNAME

    Exit Status:
    Returns success if OPTNAME is enabled; fails if an invalid option is
    given or OPTNAME is disabled.`]], ["source", ["source filename [arguments]", `Execute commands from a file in the current shell.
    Read and execute commands from FILENAME in the current shell.
    The entries in $PATH are used to find the directory containing FILENAME.
    Exit Status:
    Returns the status of the last command executed in FILENAME.`]], ["suspend", ["suspend [-f]", `Suspend shell execution.
    Suspend the execution of this shell until it receives a SIGCONT signal.`]], ["test", ["test [expr]", `Evaluate conditional expression.
    Exits with a status of 0 (true) or 1 (false) depending on
    the evaluation of EXPR.  Expressions may be unary or binary.
    Exit Status:
    Returns success if EXPR evaluates to true; fails if EXPR evaluates to
    false or an invalid argument is given.`]], ["times", ["times", `Display process times.
    Prints the accumulated user and system times for the shell and all of its
    child processes.
    Exit Status:
    Always succeeds.`]], ["trap", ["trap [-lp] [[arg] signal_spec ...]", `Trap signals and other events.
    Defines and activates handlers to be run when the shell receives signals
    or other conditions.
    Exit Status:
    Returns success unless a SIGSPEC is invalid or an invalid option is given.`]], ["true", ["true", `Return a successful result.
    Exit Status:
    Always succeeds.`]], ["type", ["type [-afptP] name [name ...]", `Display information about command type.
    For each NAME, indicate how it would be interpreted if used as a
    command name.

    Options:
      -a	display all locations containing an executable named NAME
      -f	suppress shell function lookup
      -P	force a PATH search for each NAME, even if it is an alias,
    	builtin, or function, and returns the name of the disk file
    	that would be executed
      -p	returns either the name of the disk file that would be executed,
    	or nothing if \`type -t NAME' would not return \`file'
      -t	output a single word which is one of \`alias', \`keyword',
    	\`function', \`builtin', \`file' or \`', if NAME is an alias,
    	shell reserved word, shell function, shell builtin, disk file,
    	or not found, respectively

    Exit Status:
    Returns success if all of the NAMEs are found; fails if any are not found.`]], ["typeset", ["typeset [-aAfFgilnrtux] [-p] name[=value] ...", "Set variable values and attributes.\n    A synonym for `declare'."]], ["ulimit", ["ulimit [-SHabcdefiklmnpqrstuvxPT] [limit]", `Modify shell resource limits.
    Provides control over the resources available to the shell and processes
    it creates, on systems that allow such control.
    Exit Status:
    Returns success unless an invalid option is supplied or an error occurs.`]], ["umask", ["umask [-p] [-S] [mode]", `Display or set file mode mask.
    Sets the user file-creation mask to MODE.  If MODE is omitted, prints
    the current value of the mask.
    Exit Status:
    Returns success unless MODE is invalid or an invalid option is given.`]], ["unalias", ["unalias [-a] name [name ...]", `Remove each NAME from the list of defined aliases.
    Exit Status:
    Returns success unless a NAME is not an existing alias.`]], ["unset", ["unset [-f] [-v] [-n] [name ...]", `Unset values and attributes of shell variables and functions.
    For each NAME, remove the corresponding variable or function.

    Options:
      -f	treat each NAME as a shell function
      -v	treat each NAME as a shell variable
      -n	treat each NAME as a name reference and unset the variable itself
    	rather than the variable it references

    Without options, unset first tries to unset a variable, and if that fails,
    tries to unset a function.
    Exit Status:
    Returns success unless an invalid option is given or a NAME is read-only.`]], ["wait", ["wait [-fn] [id ...]", `Wait for job completion and return exit status.
    Waits for each process identified by an ID, which may be a process ID or a
    job specification, and reports its termination status.
    Exit Status:
    Returns the status of the last ID; fails if ID is invalid or an invalid
    option is given.`]]]);
var Cn = [..._n.keys()].sort();
var ct4 = typeof __BROWSER__ < "u" && __BROWSER__;
var vr2 = null;
if (!ct4) try {
  let { createRequire: e5 } = await Promise.resolve().then(() => (init_node_module(), node_module_exports));
  vr2 = e5(import.meta.url)("node:async_hooks").AsyncLocalStorage;
} catch (e5) {
  console.warn("[DefenseInDepthBox] WARNING: AsyncLocalStorage not available, defense-in-depth security layer is DISABLED. This means script execution will NOT be protected by runtime security patches. Reason:", e5 instanceof Error ? e5.message : e5);
}
var ce8 = !ct4 && vr2 ? new vr2() : null;
export {
  hi as parse
};
/*! Bundled license information:

just-bash/dist/bundle/chunks/chunk-YNYSPYQ5.js:
  (*! Bundled license information:
  
  re2js/build/index.esm.js:
    (*!
     * re2js
     * RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
     *
     * @version v1.2.1
     * @author Alexey Vasiliev
     * @homepage https://github.com/le0pard/re2js#readme
     * @repository github:le0pard/re2js
     * @license MIT
     *)
  *)

just-bash/dist/bundle/chunks/chunk-CR5AFCPT.js:
  (*! Bundled license information:
  
  ieee754/index.js:
    (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)
  *)

just-bash/dist/bundle/chunks/chunk-SYMJJMQ4.js:
  (*! Bundled license information:
  
  papaparse/papaparse.js:
    (* @license
    Papa Parse
    v5.5.3
    https://github.com/mholt/PapaParse
    License: MIT
    *)
  *)

just-bash/dist/bundle/chunks/chunk-XMDVFEVC.js:
  (*! Bundled license information:
  
  smol-toml/dist/error.js:
  smol-toml/dist/util.js:
  smol-toml/dist/date.js:
  smol-toml/dist/primitive.js:
  smol-toml/dist/extract.js:
  smol-toml/dist/struct.js:
  smol-toml/dist/parse.js:
  smol-toml/dist/stringify.js:
  smol-toml/dist/index.js:
    (*!
     * Copyright (c) Squirrel Chat et al., All rights reserved.
     * SPDX-License-Identifier: BSD-3-Clause
     *
     * Redistribution and use in source and binary forms, with or without
     * modification, are permitted provided that the following conditions are met:
     *
     * 1. Redistributions of source code must retain the above copyright notice, this
     *    list of conditions and the following disclaimer.
     * 2. Redistributions in binary form must reproduce the above copyright notice,
     *    this list of conditions and the following disclaimer in the
     *    documentation and/or other materials provided with the distribution.
     * 3. Neither the name of the copyright holder nor the names of its contributors
     *    may be used to endorse or promote products derived from this software without
     *    specific prior written permission.
     *
     * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
     * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
     * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
     * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
     * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
     * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
     * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
     *)
  *)
*/
